export const airporte = [
     {
      "fs": "ANC",
      "iata": "ANC",
      "icao": "PANC",
      "faa": "PANC",
      "name": "Ted Stevens Anchorage International Airport",
      "city": "Anchorage",
      "cityCode": "ANC",
      "stateCode": "AK",
      "postalCode": "99519-6960",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ101",
      "localTime": "2022-11-09T03:41:39.662",
      "utcOffsetHours": -9,
      "latitude": 61.174444,
      "longitude": -149.996389,
      "elevationFeet": 144,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANC?codeType=fs"
     },
     {
      "fs": "ATL",
      "iata": "ATL",
      "icao": "KATL",
      "faa": "ATL",
      "name": "Hartsfield-Jackson Atlanta International Airport",
      "street1": "6000 N Terminal Parkway",
      "street2": "",
      "city": "Atlanta",
      "cityCode": "ATL",
      "stateCode": "GA",
      "postalCode": "30320",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ044",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 33.640067,
      "longitude": -84.44403,
      "elevationFeet": 1026,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATL?codeType=fs"
     },
     {
      "fs": "BOS",
      "iata": "BOS",
      "icao": "KBOS",
      "faa": "BOS",
      "name": "Logan International Airport",
      "street1": "One Harborside Drive",
      "street2": "",
      "city": "Boston",
      "cityCode": "BOS",
      "stateCode": "MA",
      "postalCode": "02128-2909",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ015",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 42.36646,
      "longitude": -71.020176,
      "elevationFeet": 19,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BOS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BOS?codeType=fs"
     },
     {
      "fs": "BWI",
      "iata": "BWI",
      "icao": "KBWI",
      "faa": "BWI",
      "name": "Baltimore/Wash International Thurgood Marshall Airport",
      "city": "Baltimore",
      "cityCode": "BWI",
      "stateCode": "MD",
      "postalCode": "21240",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MDZ014",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 39.179526,
      "longitude": -76.668941,
      "elevationFeet": 146,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWI?codeType=fs"
     },
     {
      "fs": "CLE",
      "iata": "CLE",
      "icao": "KCLE",
      "faa": "CLE",
      "name": "Cleveland Hopkins International Airport",
      "street1": "5300 Riverside Drive",
      "city": "Cleveland",
      "cityCode": "CLE",
      "stateCode": "OH",
      "postalCode": "44135-3193",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ011",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 41.410856,
      "longitude": -81.83821,
      "elevationFeet": 791,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLE?codeType=fs"
     },
     {
      "fs": "CLT",
      "iata": "CLT",
      "icao": "KCLT",
      "faa": "CLT",
      "name": "Charlotte Douglas International Airport",
      "street1": "5501 Josh Birmingham Parkway",
      "city": "Charlotte",
      "cityCode": "CLT",
      "stateCode": "NC",
      "postalCode": "28204",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ071",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 35.219167,
      "longitude": -80.935833,
      "elevationFeet": 748,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLT?codeType=fs"
     },
     {
      "fs": "CVG",
      "iata": "CVG",
      "icao": "KCVG",
      "faa": "CVG",
      "name": "Cincinnati/Northern Kentucky Airport",
      "city": "Cincinnati",
      "cityCode": "CVG",
      "stateCode": "OH",
      "postalCode": "41048",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ077",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 39.0555,
      "longitude": -84.66145,
      "elevationFeet": 897,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CVG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CVG?codeType=fs"
     },
     {
      "fs": "DAL",
      "iata": "DAL",
      "icao": "KDAL",
      "faa": "DAL",
      "name": "Dallas Love Field",
      "street1": "8008 Cedar Springs Road",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "postalCode": "75235",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ119",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 32.843909,
      "longitude": -96.850002,
      "elevationFeet": 487,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DAL?codeType=fs"
     },
     {
      "fs": "DCA",
      "iata": "DCA",
      "icao": "KDCA",
      "faa": "DCA",
      "name": "Ronald Reagan National Airport",
      "street1": "1 Aviation Circle",
      "street2": "",
      "city": "Washington",
      "cityCode": "WAS",
      "stateCode": "DC",
      "postalCode": "20001-6000",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "DCZ001",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 38.853434,
      "longitude": -77.043457,
      "elevationFeet": 15,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DCA?codeType=fs"
     },
     {
      "fs": "DEN",
      "iata": "DEN",
      "icao": "KDEN",
      "faa": "DEN",
      "name": "Denver International Airport",
      "street1": "8500 Pena Boulevard",
      "city": "Denver",
      "cityCode": "DEN",
      "stateCode": "CO",
      "postalCode": "80249-6340",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ040",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 39.851382,
      "longitude": -104.673098,
      "elevationFeet": 5389,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DEN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DEN?codeType=fs"
     },
     {
      "fs": "DFW",
      "iata": "DFW",
      "icao": "KDFW",
      "faa": "DFW",
      "name": "Dallas/Fort Worth International Airport",
      "street1": "International Pkwy",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "postalCode": "75261",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ119",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 32.897462,
      "longitude": -97.036128,
      "elevationFeet": 603,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DFW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DFW?codeType=fs"
     },
     {
      "fs": "DTW",
      "iata": "DTW",
      "icao": "KDTW",
      "faa": "DTW",
      "name": "Detroit Metropolitan Wayne County Airport",
      "street1": "1 Detroit Metro Airport",
      "street2": "Smith Building, Mezzanie Level",
      "city": "Detroit",
      "cityCode": "DTT",
      "stateCode": "MI",
      "postalCode": "48242",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ076",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 42.207808,
      "longitude": -83.356048,
      "elevationFeet": 640,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DTW?codeType=fs"
     },
     {
      "fs": "EWR",
      "iata": "EWR",
      "icao": "KEWR",
      "faa": "EWR",
      "name": "Newark Liberty International Airport",
      "street1": "Building 1, Conrad Road",
      "street2": "",
      "city": "Newark",
      "cityCode": "EWR",
      "stateCode": "NJ",
      "postalCode": "07114",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NJZ006",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.689071,
      "longitude": -74.178753,
      "elevationFeet": 18,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EWR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EWR?codeType=fs"
     },
     {
      "fs": "FLL",
      "iata": "FLL",
      "icao": "KFLL",
      "faa": "FLL",
      "name": "Fort Lauderdale-Hollywood International Airport",
      "street1": "320 Terminal Drive",
      "city": "Fort Lauderdale",
      "cityCode": "FLL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ072",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 26.071492,
      "longitude": -80.144908,
      "elevationFeet": 9,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLL?codeType=fs"
     },
     {
      "fs": "HNL",
      "iata": "HNL",
      "icao": "PHNL",
      "faa": "PHNL",
      "name": "Daniel K. Inouye International Airport",
      "street1": "300 Rodgers Blvd., #12",
      "city": "Honolulu",
      "cityCode": "HNL",
      "stateCode": "HI",
      "postalCode": "96819",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ002",
      "localTime": "2022-11-09T02:41:39.662",
      "utcOffsetHours": -10,
      "latitude": 21.325833,
      "longitude": -157.921667,
      "elevationFeet": 13,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNL?codeType=fs"
     },
     {
      "fs": "HOU",
      "iata": "HOU",
      "icao": "KHOU",
      "faa": "HOU",
      "name": "William P. Hobby Airport",
      "street1": "7800 Airport Boulevard",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "postalCode": "77061",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ213",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 29.654513,
      "longitude": -95.277018,
      "elevationFeet": 46,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HOU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HOU?codeType=fs"
     },
     {
      "fs": "IAD",
      "iata": "IAD",
      "icao": "KIAD",
      "faa": "IAD",
      "name": "Washington Dulles International Airport",
      "street1": "1 Saarinen Circle",
      "city": "Dulles",
      "cityCode": "WAS",
      "stateCode": "VA",
      "postalCode": "20166",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "DCZ001",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 38.95315,
      "longitude": -77.447735,
      "elevationFeet": 313,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IAD?codeType=fs"
     },
     {
      "fs": "IAH",
      "iata": "IAH",
      "icao": "KIAH",
      "faa": "IAH",
      "name": "George Bush Intercontinental Airport",
      "street1": "16930 JFK Boulevard",
      "street2": "",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "postalCode": "77032",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ213",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 29.983333,
      "longitude": -95.34,
      "elevationFeet": 97,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IAH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IAH?codeType=fs"
     },
     {
      "fs": "IND",
      "iata": "IND",
      "icao": "KIND",
      "faa": "IND",
      "name": "Indianapolis International Airport",
      "street1": "7800 Col. H. Weir Cook Memorial Drive",
      "city": "Indianapolis",
      "cityCode": "IND",
      "stateCode": "IN",
      "postalCode": "46241",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "INZ047",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 39.71627,
      "longitude": -86.292991,
      "elevationFeet": 773,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IND?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IND?codeType=fs"
     },
     {
      "fs": "JFK",
      "iata": "JFK",
      "icao": "KJFK",
      "faa": "JFK",
      "name": "John F. Kennedy International Airport",
      "street1": "JFK Airport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "postalCode": "11430",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ178",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.642335,
      "longitude": -73.78817,
      "elevationFeet": 13,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JFK?codeType=fs"
     },
     {
      "fs": "LAS",
      "iata": "LAS",
      "icao": "KLAS",
      "faa": "LAS",
      "name": "Harry Reid International Airport",
      "street1": "5757 Wayne Newton Boulevard",
      "city": "Las Vegas",
      "cityCode": "LAS",
      "stateCode": "NV",
      "postalCode": "89119",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "NVZ020",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 36.081,
      "longitude": -115.147599,
      "elevationFeet": 2095,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAS?codeType=fs"
     },
     {
      "fs": "LAX",
      "iata": "LAX",
      "icao": "KLAX",
      "faa": "LAX",
      "name": "Los Angeles International Airport",
      "street1": "One World Way",
      "street2": "",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "postalCode": "90045-5803",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ041",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 33.943399,
      "longitude": -118.408279,
      "elevationFeet": 126,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAX?codeType=fs"
     },
     {
      "fs": "LGA",
      "iata": "LGA",
      "icao": "KLGA",
      "faa": "LGA",
      "name": "LaGuardia Airport",
      "street1": "Hangar 7 Center",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "postalCode": "11371",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ176",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.774252,
      "longitude": -73.871617,
      "elevationFeet": 22,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LGA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LGA?codeType=fs"
     },
     {
      "fs": "MCO",
      "iata": "MCO",
      "icao": "KMCO",
      "faa": "MCO",
      "name": "Orlando International Airport",
      "street1": "One Airport Boulevard",
      "street2": "",
      "city": "Orlando",
      "cityCode": "ORL",
      "stateCode": "FL",
      "postalCode": "32827-4399",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ045",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 28.432177,
      "longitude": -81.308301,
      "elevationFeet": 96,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCO?codeType=fs"
     },
     {
      "fs": "MDW",
      "iata": "MDW",
      "icao": "KMDW",
      "faa": "MDW",
      "name": "Chicago Midway International Airport",
      "street1": "5700 South Cicero",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "postalCode": "60638",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ014",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 41.788136,
      "longitude": -87.740871,
      "elevationFeet": 620,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDW?codeType=fs"
     },
     {
      "fs": "MEM",
      "iata": "MEM",
      "icao": "KMEM",
      "faa": "MEM",
      "name": "Memphis International Airport",
      "street1": "2491 Winchester Road, Suite 113",
      "city": "Memphis",
      "cityCode": "MEM",
      "stateCode": "TN",
      "postalCode": "38116",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TNZ088",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 35.044579,
      "longitude": -89.982258,
      "elevationFeet": 292,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MEM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MEM?codeType=fs"
     },
     {
      "fs": "MIA",
      "iata": "MIA",
      "icao": "KMIA",
      "faa": "MIA",
      "name": "Miami International Airport",
      "street1": "4200 N.W. 21 Street",
      "street2": "",
      "city": "Miami",
      "cityCode": "MIA",
      "stateCode": "FL",
      "postalCode": "33122",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ074",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 25.796,
      "longitude": -80.278234,
      "elevationFeet": 8,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIA?codeType=fs"
     },
     {
      "fs": "MSP",
      "iata": "MSP",
      "icao": "KMSP",
      "faa": "MSP",
      "name": "Minneapolis-St. Paul International Airport",
      "street1": "6040 28th Avenue South",
      "city": "Minneapolis",
      "cityCode": "MSP",
      "stateCode": "MN",
      "postalCode": "55450",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ060",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 44.883016,
      "longitude": -93.210922,
      "elevationFeet": 841,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSP?codeType=fs"
     },
     {
      "fs": "OAK",
      "iata": "OAK",
      "icao": "KOAK",
      "faa": "OAK",
      "name": "Metropolitan Oakland International Airport",
      "street1": "1 Airport Drive",
      "city": "Oakland",
      "cityCode": "OAK",
      "stateCode": "CA",
      "postalCode": "94621",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ508",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 37.71188,
      "longitude": -122.212011,
      "elevationFeet": 6,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OAK?codeType=fs"
     },
     {
      "fs": "ORD",
      "iata": "ORD",
      "icao": "KORD",
      "faa": "ORD",
      "name": "O'Hare International Airport",
      "street1": "10000 West O'Hare",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "postalCode": "60666",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ014",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 41.976912,
      "longitude": -87.904876,
      "elevationFeet": 668,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORD?codeType=fs"
     },
     {
      "fs": "PDX",
      "iata": "PDX",
      "icao": "KPDX",
      "faa": "PDX",
      "name": "Portland International Airport",
      "street1": "7000 NE Airport Way",
      "city": "Portland",
      "cityCode": "PDX",
      "stateCode": "OR",
      "postalCode": "97218",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ006",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 45.588995,
      "longitude": -122.592901,
      "elevationFeet": 30,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PDX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PDX?codeType=fs"
     },
     {
      "fs": "PHL",
      "iata": "PHL",
      "icao": "KPHL",
      "faa": "PHL",
      "name": "Philadelphia International Airport",
      "street1": "Industrial Highway and Island Road",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "postalCode": "19153",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ071",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 39.876413,
      "longitude": -75.243305,
      "elevationFeet": 10,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHL?codeType=fs"
     },
     {
      "fs": "PHX",
      "iata": "PHX",
      "icao": "KPHX",
      "faa": "PHX",
      "name": "Phoenix Sky Harbor International Airport",
      "street1": "3400 Sky Harbor Boulevard",
      "city": "Phoenix",
      "cityCode": "PHX",
      "stateCode": "AZ",
      "postalCode": "85034",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ023",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 33.435036,
      "longitude": -112.000164,
      "elevationFeet": 1135,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHX?codeType=fs"
     },
     {
      "fs": "SAN",
      "iata": "SAN",
      "icao": "KSAN",
      "faa": "SAN",
      "name": "San Diego International Airport",
      "street1": "Airport Drive",
      "street2": "",
      "city": "San Diego",
      "cityCode": "SAN",
      "stateCode": "CA",
      "postalCode": "92101",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ043",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 32.731938,
      "longitude": -117.197312,
      "elevationFeet": 14,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAN?codeType=fs"
     },
     {
      "fs": "SDF",
      "iata": "SDF",
      "icao": "KSDF",
      "faa": "SDF",
      "name": "Louisville International Airport-Standiford Field",
      "street1": "600 Terminal Drive",
      "city": "Louisville",
      "cityCode": "SDF",
      "stateCode": "KY",
      "postalCode": "40209",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "KYZ030",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 38.174397,
      "longitude": -85.73599,
      "elevationFeet": 474,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SDF?codeType=fs"
     },
     {
      "fs": "SEA",
      "iata": "SEA",
      "icao": "KSEA",
      "faa": "SEA",
      "name": "Seattle-Tacoma International Airport",
      "city": "Seattle",
      "cityCode": "SEA",
      "stateCode": "WA",
      "postalCode": "98158",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 47.443839,
      "longitude": -122.301732,
      "elevationFeet": 429,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SEA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SEA?codeType=fs"
     },
     {
      "fs": "SFO",
      "iata": "SFO",
      "icao": "KSFO",
      "faa": "SFO",
      "name": "San Francisco International Airport",
      "city": "San Francisco",
      "cityCode": "SFO",
      "stateCode": "CA",
      "postalCode": "94128",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ508",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 37.615215,
      "longitude": -122.389881,
      "elevationFeet": 11,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SFO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SFO?codeType=fs"
     },
     {
      "fs": "SLC",
      "iata": "SLC",
      "icao": "KSLC",
      "faa": "SLC",
      "name": "Salt Lake City International Airport",
      "street1": "776 North Terminal Drive",
      "street2": "",
      "city": "Salt Lake City",
      "cityCode": "SLC",
      "stateCode": "UT",
      "postalCode": "84116",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "UTZ003",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 40.785645,
      "longitude": -111.980673,
      "elevationFeet": 4227,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLC?codeType=fs"
     },
     {
      "fs": "STL",
      "iata": "STL",
      "icao": "KSTL",
      "faa": "STL",
      "name": "Lambert-St. Louis International Airport",
      "street1": "10701 Lambert International Blvd.",
      "city": "Saint Louis",
      "cityCode": "STL",
      "stateCode": "MO",
      "postalCode": "63145",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ063",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 38.748707,
      "longitude": -90.379002,
      "elevationFeet": 536,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STL?codeType=fs"
     },
     {
      "fs": "TPA",
      "iata": "TPA",
      "icao": "KTPA",
      "faa": "TPA",
      "name": "Tampa International Airport",
      "street1": "5507 West Spruce Street",
      "city": "Tampa",
      "cityCode": "TPA",
      "stateCode": "FL",
      "postalCode": "33607",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ251",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 27.979869,
      "longitude": -82.535415,
      "elevationFeet": 26,
      "classification": 1,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TPA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TPA?codeType=fs"
     },
     {
      "fs": "ABQ",
      "iata": "ABQ",
      "icao": "KABQ",
      "faa": "ABQ",
      "name": "Albuquerque International Sunport",
      "street1": "2200 Sunport Blvd. SE",
      "city": "Albuquerque",
      "cityCode": "ABQ",
      "stateCode": "NM",
      "postalCode": "87106",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ519",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 35.049625,
      "longitude": -106.617193,
      "elevationFeet": 5355,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ABQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ABQ?codeType=fs"
     },
     {
      "fs": "ALB",
      "iata": "ALB",
      "icao": "KALB",
      "faa": "ALB",
      "name": "Albany International Airport",
      "street1": "737 Albany-Shaker Road",
      "street2": "",
      "city": "Albany",
      "cityCode": "ALB",
      "stateCode": "NY",
      "postalCode": "12211",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ052",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 42.745279,
      "longitude": -73.809556,
      "elevationFeet": 285,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALB?codeType=fs"
     },
     {
      "fs": "AUS",
      "iata": "AUS",
      "icao": "KAUS",
      "faa": "AUS",
      "name": "Austin-Bergstrom International Airport",
      "street1": "3600 Presidential Blvd",
      "street2": "",
      "city": "Austin",
      "cityCode": "AUS",
      "stateCode": "TX",
      "postalCode": "78719",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ192",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 30.202545,
      "longitude": -97.667064,
      "elevationFeet": 541,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUS?codeType=fs"
     },
     {
      "fs": "BDL",
      "iata": "BDL",
      "icao": "KBDL",
      "faa": "BDL",
      "name": "Bradley International Airport",
      "street1": "Schoephoester Road",
      "street2": "",
      "city": "Hartford",
      "cityCode": "HFD",
      "stateCode": "CT",
      "postalCode": "06096",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "CTZ002",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 41.92953,
      "longitude": -72.684701,
      "elevationFeet": 173,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDL?codeType=fs"
     },
     {
      "fs": "BNA",
      "iata": "BNA",
      "icao": "KBNA",
      "faa": "BNA",
      "name": "Nashville International Airport",
      "street1": "One Terminal Drive, Suite 501",
      "city": "Nashville",
      "cityCode": "BNA",
      "stateCode": "TN",
      "postalCode": "37214-4114",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TNZ027",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 36.13174,
      "longitude": -86.668945,
      "elevationFeet": 599,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNA?codeType=fs"
     },
     {
      "fs": "BUF",
      "iata": "BUF",
      "icao": "KBUF",
      "faa": "BUF",
      "name": "Buffalo Niagara International Airport",
      "street1": "Genesee Street",
      "street2": "",
      "city": "Buffalo",
      "cityCode": "BUF",
      "stateCode": "NY",
      "postalCode": "14225",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ010",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 42.933828,
      "longitude": -78.731804,
      "elevationFeet": 724,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BUF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BUF?codeType=fs"
     },
     {
      "fs": "JAX",
      "iata": "JAX",
      "icao": "KJAX",
      "faa": "JAX",
      "name": "Jacksonville International Airport",
      "street1": "2400 Yankee Clipper Drive",
      "city": "Jacksonville",
      "cityCode": "JAX",
      "stateCode": "FL",
      "postalCode": "32218",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ025",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 30.491254,
      "longitude": -81.683053,
      "elevationFeet": 19,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JAX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JAX?codeType=fs"
     },
     {
      "fs": "MCI",
      "iata": "MCI",
      "icao": "KMCI",
      "faa": "MCI",
      "name": "Kansas City International Airport",
      "street1": "601 Brasilia Avenue",
      "city": "Kansas City",
      "cityCode": "MKC",
      "stateCode": "MO",
      "postalCode": "64153",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ028",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 39.293807,
      "longitude": -94.719925,
      "elevationFeet": 1026,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCI?codeType=fs"
     },
     {
      "fs": "MKE",
      "iata": "MKE",
      "icao": "KMKE",
      "faa": "MKE",
      "name": "General Mitchell International Airport",
      "street1": "5300 S. Howell Avenue",
      "city": "Milwaukee",
      "cityCode": "MKE",
      "stateCode": "WI",
      "postalCode": "53207",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ066",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 42.948095,
      "longitude": -87.902668,
      "elevationFeet": 670,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKE?codeType=fs"
     },
     {
      "fs": "OGG",
      "iata": "OGG",
      "icao": "PHOG",
      "faa": "PHOG",
      "name": "Kahului Airport",
      "street1": "",
      "street2": "",
      "city": "Kahului",
      "cityCode": "OGG",
      "stateCode": "HI",
      "postalCode": "96732",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ003",
      "localTime": "2022-11-09T02:41:39.662",
      "utcOffsetHours": -10,
      "latitude": 20.892883,
      "longitude": -156.438629,
      "elevationFeet": 54,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OGG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OGG?codeType=fs"
     },
     {
      "fs": "OKC",
      "iata": "OKC",
      "icao": "KOKC",
      "faa": "OKC",
      "name": "Will Rogers World Airport",
      "street1": "7100 Terminal Drive",
      "city": "Oklahoma City",
      "cityCode": "OKC",
      "stateCode": "OK",
      "postalCode": "73159-0937",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "OKZ025",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 35.395629,
      "longitude": -97.59609,
      "elevationFeet": 1295,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OKC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OKC?codeType=fs"
     },
     {
      "fs": "OMA",
      "iata": "OMA",
      "icao": "KOMA",
      "faa": "OMA",
      "name": "Eppley Airfield",
      "street1": "",
      "street2": "",
      "city": "Omaha",
      "cityCode": "OMA",
      "stateCode": "NE",
      "postalCode": "68110",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ052",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 41.29957,
      "longitude": -95.899717,
      "elevationFeet": 984,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OMA?codeType=fs"
     },
     {
      "fs": "PIT",
      "iata": "PIT",
      "icao": "KPIT",
      "faa": "PIT",
      "name": "Pittsburgh International Airport",
      "street1": "1000 Airport Boulevard",
      "street2": "",
      "city": "Pittsburgh",
      "cityCode": "PIT",
      "stateCode": "PA",
      "postalCode": "15231-0370",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ021",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.49585,
      "longitude": -80.25657,
      "elevationFeet": 1204,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIT?codeType=fs"
     },
     {
      "fs": "RDU",
      "iata": "RDU",
      "icao": "KRDU",
      "faa": "RDU",
      "name": "Raleigh-Durham International Airport",
      "city": "Raleigh/Durham",
      "cityCode": "RDU",
      "stateCode": "NC",
      "postalCode": "27623",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ041",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 35.873592,
      "longitude": -78.790862,
      "elevationFeet": 435,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDU?codeType=fs"
     },
     {
      "fs": "SAT",
      "iata": "SAT",
      "icao": "KSAT",
      "faa": "SAT",
      "name": "San Antonio International Airport",
      "street1": "9800 Airport Boulevard",
      "street2": "",
      "city": "San Antonio",
      "cityCode": "SAT",
      "stateCode": "TX",
      "postalCode": "78216",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ205",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 29.524937,
      "longitude": -98.472643,
      "elevationFeet": 809,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAT?codeType=fs"
     },
     {
      "fs": "SJC",
      "iata": "SJC",
      "icao": "KSJC",
      "faa": "SJC",
      "name": "Norman Y. Mineta San Jose International Airport",
      "street1": "1701 Airport Boulevard, Suite B-1130",
      "city": "San Jose",
      "cityCode": "SJC",
      "stateCode": "CA",
      "postalCode": "95110",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ513",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 37.366736,
      "longitude": -121.926375,
      "elevationFeet": 58,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SJC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SJC?codeType=fs"
     },
     {
      "fs": "SMF",
      "iata": "SMF",
      "icao": "KSMF",
      "faa": "SMF",
      "name": "Sacramento International Airport",
      "street1": "6900 Airport Boulevard",
      "street2": "",
      "city": "Sacramento",
      "cityCode": "SAC",
      "stateCode": "CA",
      "postalCode": "95837",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ017",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 38.692283,
      "longitude": -121.593695,
      "elevationFeet": 28,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMF?codeType=fs"
     },
     {
      "fs": "SNA",
      "iata": "SNA",
      "icao": "KSNA",
      "faa": "SNA",
      "name": "John Wayne Airport",
      "street1": "18601 Airport Way",
      "street2": "",
      "city": "Santa Ana",
      "cityCode": "SNA",
      "stateCode": "CA",
      "postalCode": "92707",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ042",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 33.680201,
      "longitude": -117.860538,
      "elevationFeet": 54,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SNA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SNA?codeType=fs"
     },
     {
      "fs": "SYR",
      "iata": "SYR",
      "icao": "KSYR",
      "faa": "SYR",
      "name": "Hancock International Airport",
      "street1": "City Hall",
      "street2": "",
      "city": "Syracuse",
      "cityCode": "SYR",
      "stateCode": "NY",
      "postalCode": "13212",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ018",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 43.113984,
      "longitude": -76.112231,
      "elevationFeet": 421,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYR?codeType=fs"
     },
     {
      "fs": "TUL",
      "iata": "TUL",
      "icao": "KTUL",
      "faa": "TUL",
      "name": "Tulsa International Airport",
      "street1": "7777 E. Apache",
      "street2": "",
      "city": "Tulsa",
      "cityCode": "TUL",
      "stateCode": "OK",
      "postalCode": "74115",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "OKZ060",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 36.189809,
      "longitude": -95.890102,
      "elevationFeet": 677,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TUL?codeType=fs"
     },
     {
      "fs": "ACK",
      "iata": "ACK",
      "icao": "KACK",
      "faa": "ACK",
      "name": "Nantucket Memorial Airport",
      "street1": "30 Macy Lane",
      "street2": "",
      "city": "Nantucket",
      "cityCode": "ACK",
      "stateCode": "MA",
      "postalCode": "02554",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ024",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 41.256667,
      "longitude": -70.059722,
      "elevationFeet": 48,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ACK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ACK?codeType=fs"
     },
     {
      "fs": "BET",
      "iata": "BET",
      "icao": "PABE",
      "faa": "PABE",
      "name": "Bethel Airport",
      "street1": "",
      "street2": "",
      "city": "Bethel",
      "cityCode": "BET",
      "stateCode": "AK",
      "postalCode": "99559",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.662",
      "utcOffsetHours": -9,
      "latitude": 60.784444,
      "longitude": -161.831389,
      "elevationFeet": 123,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BET?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BET?codeType=fs"
     },
     {
      "fs": "BFI",
      "iata": "BFI",
      "icao": "KBFI",
      "faa": "BFI",
      "name": "Boeing Field International Airport",
      "city": "Seattle",
      "cityCode": "SEA",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 47.530204,
      "longitude": -122.302253,
      "elevationFeet": 17,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFI?codeType=fs"
     },
     {
      "fs": "BHM",
      "iata": "BHM",
      "icao": "KBHM",
      "faa": "BHM",
      "name": "Birmingham-Shuttlesworth International Airport",
      "street1": "5900 Airport Highway",
      "city": "Birmingham",
      "cityCode": "BHM",
      "stateCode": "AL",
      "postalCode": "35212",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ024",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 33.560834,
      "longitude": -86.752189,
      "elevationFeet": 644,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BHM?codeType=fs"
     },
     {
      "fs": "BUR",
      "iata": "BUR",
      "icao": "KBUR",
      "faa": "BUR",
      "name": "Bob Hope Airport",
      "street1": "2627 Hollywood Way",
      "street2": "",
      "city": "Burbank",
      "cityCode": "BUR",
      "stateCode": "CA",
      "postalCode": "91505",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ041",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 34.196188,
      "longitude": -118.354113,
      "elevationFeet": 775,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BUR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BUR?codeType=fs"
     },
     {
      "fs": "CHS",
      "iata": "CHS",
      "icao": "KCHS",
      "faa": "CHS",
      "name": "Charleston International Airport",
      "city": "Charleston",
      "cityCode": "CHS",
      "stateCode": "SC",
      "postalCode": "29404",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "SCZ050",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 32.884355,
      "longitude": -80.037157,
      "elevationFeet": 46,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHS?codeType=fs"
     },
     {
      "fs": "CMH",
      "iata": "CMH",
      "icao": "KCMH",
      "faa": "CMH",
      "name": "John Glenn Columbus International Airport",
      "street1": "4600 International Gateway",
      "city": "Columbus",
      "cityCode": "CMH",
      "stateCode": "OH",
      "postalCode": "43219",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ055",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 39.998181,
      "longitude": -82.884966,
      "elevationFeet": 815,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CMH?codeType=fs"
     },
     {
      "fs": "DSM",
      "iata": "DSM",
      "icao": "KDSM",
      "faa": "DSM",
      "name": "Des Moines International Airport",
      "street1": "5800 Fleur Drive, Suite 201",
      "city": "Des Moines",
      "cityCode": "DSM",
      "stateCode": "IA",
      "postalCode": "50321-2854",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ060",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 41.532434,
      "longitude": -93.648087,
      "elevationFeet": 957,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DSM?codeType=fs"
     },
     {
      "fs": "GEG",
      "iata": "GEG",
      "icao": "KGEG",
      "faa": "GEG",
      "name": "Spokane International Airport",
      "street1": "9000 West Airport Drive",
      "street2": "",
      "city": "Spokane",
      "cityCode": "GEG",
      "stateCode": "WA",
      "postalCode": "99224",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ036",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 47.625147,
      "longitude": -117.537638,
      "elevationFeet": 2372,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GEG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GEG?codeType=fs"
     },
     {
      "fs": "HYA",
      "iata": "HYA",
      "icao": "KHYA",
      "faa": "HYA",
      "name": "Barnstable Municipal Airport",
      "street1": "480 Barnstable Road",
      "city": "Hyannis",
      "cityCode": "HYA",
      "stateCode": "MA",
      "postalCode": "02601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ022",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 41.665833,
      "longitude": -70.280556,
      "elevationFeet": 55,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HYA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HYA?codeType=fs"
     },
     {
      "fs": "MSY",
      "iata": "MSY",
      "icao": "KMSY",
      "faa": "MSY",
      "name": "Louis Armstrong New Orleans International Airport",
      "street1": "900 Airline Highway",
      "city": "New Orleans",
      "cityCode": "MSY",
      "stateCode": "LA",
      "postalCode": "70062",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ061",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 29.984564,
      "longitude": -90.256391,
      "elevationFeet": 4,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSY?codeType=fs"
     },
     {
      "fs": "ONT",
      "iata": "ONT",
      "icao": "KONT",
      "faa": "ONT",
      "name": "Ontario International Airport",
      "street1": "2900 E. Airport Drive",
      "city": "Ontario",
      "cityCode": "ONT",
      "stateCode": "CA",
      "postalCode": "91761",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ048",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 34.056001,
      "longitude": -117.601193,
      "elevationFeet": 922,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONT?codeType=fs"
     },
     {
      "fs": "ORF",
      "iata": "ORF",
      "icao": "KORF",
      "faa": "ORF",
      "name": "Norfolk International Airport",
      "street1": "2200 Norview Ave.",
      "street2": "",
      "city": "Norfolk",
      "cityCode": "ORF",
      "stateCode": "VA",
      "postalCode": "23518-5897",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ095",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 36.898583,
      "longitude": -76.206295,
      "elevationFeet": 26,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORF?codeType=fs"
     },
     {
      "fs": "PBI",
      "iata": "PBI",
      "icao": "KPBI",
      "faa": "PBI",
      "name": "Palm Beach International Airport",
      "street1": "Building 846, Palm Beach International",
      "city": "West Palm Beach",
      "cityCode": "PBI",
      "stateCode": "FL",
      "postalCode": "33406",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ068",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 26.683164,
      "longitude": -80.095589,
      "elevationFeet": 12,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PBI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PBI?codeType=fs"
     },
     {
      "fs": "PVD",
      "iata": "PVD",
      "icao": "KPVD",
      "faa": "PVD",
      "name": "Theodore Francis Green Memorial State Airport",
      "street1": "2000 Airport Road",
      "city": "Providence",
      "cityCode": "PVD",
      "stateCode": "RI",
      "postalCode": "02888",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "RIZ002",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 41.726312,
      "longitude": -71.436317,
      "elevationFeet": 55,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVD?codeType=fs"
     },
     {
      "fs": "RIC",
      "iata": "RIC",
      "icao": "KRIC",
      "faa": "RIC",
      "name": "Richmond International Airport (Byrd Field)",
      "street1": "1 Richard E. Byrd Terminal Drive",
      "street2": "",
      "city": "Richmond",
      "cityCode": "RIC",
      "stateCode": "VA",
      "postalCode": "23250-2400",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ071",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 37.506111,
      "longitude": -77.3225,
      "elevationFeet": 167,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIC?codeType=fs"
     },
     {
      "fs": "ROC",
      "iata": "ROC",
      "icao": "KROC",
      "faa": "ROC",
      "name": "Greater Rochester International Airport",
      "street1": "1200 Brooks Avenue",
      "street2": "",
      "city": "Rochester",
      "cityCode": "ROC",
      "stateCode": "NY",
      "postalCode": "14624",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ003",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 43.127974,
      "longitude": -77.665427,
      "elevationFeet": 560,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ROC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ROC?codeType=fs"
     },
     {
      "fs": "RSW",
      "iata": "RSW",
      "icao": "KRSW",
      "faa": "RSW",
      "name": "Southwest Florida International Airport",
      "street1": "11000 Terminal Access Road",
      "city": "Fort Myers",
      "cityCode": "FMY",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ065",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 26.527887,
      "longitude": -81.755263,
      "elevationFeet": 30,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSW?codeType=fs"
     },
     {
      "fs": "SUS",
      "iata": "SUS",
      "icao": "KSUS",
      "faa": "SUS",
      "name": "Spirit of St. Louis Airport",
      "city": "Saint Louis",
      "cityCode": "STL",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 38.663008,
      "longitude": -90.65646,
      "elevationFeet": 472,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUS?codeType=fs"
     },
     {
      "fs": "TEB",
      "iata": "TEB",
      "icao": "KTEB",
      "faa": "TEB",
      "name": "Teterboro Airport",
      "city": "Teterboro",
      "cityCode": "TEB",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NJZ003",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.849722,
      "longitude": -74.062222,
      "elevationFeet": 9,
      "classification": 2,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TEB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TEB?codeType=fs"
     },
     {
      "fs": "COS",
      "iata": "COS",
      "icao": "KCOS",
      "faa": "COS",
      "name": "Colorado Springs Municipal Airport",
      "street1": "7770 Milton E. Proby Parkway",
      "city": "Colorado Springs",
      "cityCode": "COS",
      "stateCode": "CO",
      "postalCode": "80916",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ071",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 38.805778,
      "longitude": -104.700747,
      "elevationFeet": 6119,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COS?codeType=fs"
     },
     {
      "fs": "FAI",
      "iata": "FAI",
      "icao": "PAFA",
      "faa": "PAFA",
      "name": "Fairbanks International Airport",
      "street1": "University Ave.",
      "city": "Fairbanks",
      "cityCode": "FAI",
      "stateCode": "AK",
      "postalCode": "99709-4658",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ222",
      "localTime": "2022-11-09T03:41:39.662",
      "utcOffsetHours": -9,
      "latitude": 64.818214,
      "longitude": -147.866805,
      "elevationFeet": 434,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAI?codeType=fs"
     },
     {
      "fs": "FSD",
      "iata": "FSD",
      "icao": "KFSD",
      "faa": "FSD",
      "name": "Joe Foss Field",
      "street1": "2801 Jaycee Lane",
      "city": "Sioux Falls",
      "cityCode": "FSD",
      "stateCode": "SD",
      "postalCode": "57104",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "SDZ062",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 43.58201,
      "longitude": -96.741849,
      "elevationFeet": 1423,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FSD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FSD?codeType=fs"
     },
     {
      "fs": "GRB",
      "iata": "GRB",
      "icao": "KGRB",
      "faa": "GRB",
      "name": "Austin Straubel International Airport",
      "street1": "2077 Airport Drive",
      "city": "Green Bay",
      "cityCode": "GRB",
      "stateCode": "WI",
      "postalCode": "54313-5596",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ039",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 44.492848,
      "longitude": -88.121896,
      "elevationFeet": 695,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRB?codeType=fs"
     },
     {
      "fs": "ICT",
      "iata": "ICT",
      "icao": "KICT",
      "faa": "ICT",
      "name": "Wichita Dwight D. Eisenhower National Airport",
      "street1": "2173 Air Cargo Road",
      "city": "Wichita",
      "cityCode": "ICT",
      "stateCode": "KS",
      "postalCode": "67277-0130",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ083",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 37.653044,
      "longitude": -97.428957,
      "elevationFeet": 1332,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ICT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ICT?codeType=fs"
     },
     {
      "fs": "KOA",
      "iata": "KOA",
      "icao": "PHKO",
      "faa": "PHKO",
      "name": "Kona International Airport at Keahole",
      "city": "Kailua-Kona",
      "cityCode": "KOA",
      "stateCode": "HI",
      "postalCode": "96734",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ002",
      "localTime": "2022-11-09T02:41:39.662",
      "utcOffsetHours": -10,
      "latitude": 19.736174,
      "longitude": -156.041077,
      "elevationFeet": 47,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOA?codeType=fs"
     },
     {
      "fs": "LEX",
      "iata": "LEX",
      "icao": "KLEX",
      "faa": "LEX",
      "name": "Blue Grass Airport",
      "street1": "4000 Terminal Drive, Suite 206",
      "street2": "",
      "city": "Lexington",
      "cityCode": "LEX",
      "stateCode": "KY",
      "postalCode": "40510",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "KYZ041",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 38.037622,
      "longitude": -84.597921,
      "elevationFeet": 979,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LEX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LEX?codeType=fs"
     },
     {
      "fs": "LIT",
      "iata": "LIT",
      "icao": "KLIT",
      "faa": "LIT",
      "name": "Bill and Hillary Clinton National Airport",
      "street1": "No. 1 Airport Drive",
      "city": "Little Rock",
      "cityCode": "LIT",
      "stateCode": "AR",
      "postalCode": "72202-4402",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ044",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 34.727431,
      "longitude": -92.221374,
      "elevationFeet": 262,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIT?codeType=fs"
     },
     {
      "fs": "RST",
      "iata": "RST",
      "icao": "KRST",
      "faa": "RST",
      "name": "Rochester International Airport",
      "street1": "7600 Helgerson Drive Southwest",
      "city": "Rochester",
      "cityCode": "RST",
      "stateCode": "MN",
      "postalCode": "55902",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ087",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 43.910793,
      "longitude": -92.489768,
      "elevationFeet": 1317,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RST?codeType=fs"
     },
     {
      "fs": "TUS",
      "iata": "TUS",
      "icao": "KTUS",
      "faa": "TUS",
      "name": "Tucson International Airport",
      "street1": "7005 South Plumer Ave.",
      "street2": "",
      "city": "Tucson",
      "cityCode": "TUS",
      "stateCode": "AZ",
      "postalCode": "85706",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ033",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 32.120688,
      "longitude": -110.937369,
      "elevationFeet": 2643,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TUS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TUS?codeType=fs"
     },
     {
      "fs": "ABE",
      "iata": "ABE",
      "icao": "KABE",
      "faa": "ABE",
      "name": "Lehigh Valley International Airport",
      "street1": "3311 Airport Road",
      "street2": "",
      "city": "Allentown",
      "cityCode": "ABE",
      "stateCode": "PA",
      "postalCode": "18109",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ062",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.651573,
      "longitude": -75.434366,
      "elevationFeet": 394,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ABE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ABE?codeType=fs"
     },
     {
      "fs": "ADQ",
      "iata": "ADQ",
      "icao": "PADQ",
      "faa": "PADQ",
      "name": "Kodiak Benny Benson State Airport",
      "street1": "2410 Mill Bay Road",
      "city": "Kodiak",
      "cityCode": "ADQ",
      "stateCode": "AK",
      "postalCode": "99615",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ171",
      "localTime": "2022-11-09T03:41:39.662",
      "utcOffsetHours": -9,
      "latitude": 57.753887,
      "longitude": -152.514408,
      "elevationFeet": 64,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADQ?codeType=fs"
     },
     {
      "fs": "ADS",
      "iata": "ADS",
      "icao": "KADS",
      "faa": "ADS",
      "name": "Addison Airport",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 32.966626,
      "longitude": -96.842922,
      "elevationFeet": 626,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADS?codeType=fs"
     },
     {
      "fs": "AFW",
      "iata": "AFW",
      "icao": "KAFW",
      "faa": "AFW",
      "name": "Fort Worth Alliance Airport",
      "street1": "2221 Alliance Boulevard",
      "city": "Fort Worth",
      "cityCode": "FTW",
      "stateCode": "TX",
      "postalCode": "76177",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ118",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 32.985651,
      "longitude": -97.315295,
      "elevationFeet": 687,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AFW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AFW?codeType=fs"
     },
     {
      "fs": "AMA",
      "iata": "AMA",
      "icao": "KAMA",
      "faa": "AMA",
      "name": "Rick Husband Amarillo International Airport",
      "street1": "10801 Airport Boulevard",
      "city": "Amarillo",
      "cityCode": "AMA",
      "stateCode": "TX",
      "postalCode": "79111",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ012",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 35.218274,
      "longitude": -101.705134,
      "elevationFeet": 3605,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AMA?codeType=fs"
     },
     {
      "fs": "APA",
      "iata": "APA",
      "icao": "KAPA",
      "faa": "APA",
      "name": "Centennial Airport",
      "city": "Denver",
      "cityCode": "DEN",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ040",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 39.572123,
      "longitude": -104.848713,
      "elevationFeet": 5831,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APA?codeType=fs"
     },
     {
      "fs": "AVL",
      "iata": "AVL",
      "icao": "KAVL",
      "faa": "AVL",
      "name": "Asheville Regional Airport",
      "street1": "61 Terminal Drive",
      "city": "Asheville",
      "cityCode": "AVL",
      "stateCode": "NC",
      "postalCode": "28732",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 35.43508,
      "longitude": -82.537314,
      "elevationFeet": 2165,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AVL?codeType=fs"
     },
     {
      "fs": "BIL",
      "iata": "BIL",
      "icao": "KBIL",
      "faa": "BIL",
      "name": "Billings Logan International Airport",
      "street1": "1901 Terminal Circle, Room 216",
      "city": "Billings",
      "cityCode": "BIL",
      "stateCode": "MT",
      "postalCode": "59105",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ035",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 45.803419,
      "longitude": -108.537229,
      "elevationFeet": 3649,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIL?codeType=fs"
     },
     {
      "fs": "BKL",
      "iata": "BKL",
      "icao": "KBKL",
      "faa": "BKL",
      "name": "Burke Lakefront Airport",
      "city": "Cleveland",
      "cityCode": "CLE",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ011",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 41.516944,
      "longitude": -81.683333,
      "elevationFeet": 583,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKL?codeType=fs"
     },
     {
      "fs": "BOI",
      "iata": "BOI",
      "icao": "KBOI",
      "faa": "BOI",
      "name": "Boise Air Terminal (Gowen Field)",
      "street1": "3201 Airport Way",
      "city": "Boise",
      "cityCode": "BOI",
      "stateCode": "ID",
      "postalCode": "83705",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "IDZ014",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 43.569263,
      "longitude": -116.221934,
      "elevationFeet": 2868,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BOI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BOI?codeType=fs"
     },
     {
      "fs": "BTR",
      "iata": "BTR",
      "icao": "KBTR",
      "faa": "BTR",
      "name": "Baton Rouge Metropolitan Airport",
      "street1": "9430 Jackie Cochran Drive",
      "city": "Baton Rouge",
      "cityCode": "BTR",
      "stateCode": "LA",
      "postalCode": "70807",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ048",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 30.532537,
      "longitude": -91.156907,
      "elevationFeet": 70,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTR?codeType=fs"
     },
     {
      "fs": "BTV",
      "iata": "BTV",
      "icao": "KBTV",
      "faa": "BTV",
      "name": "Burlington International Airport",
      "street1": "1200 Airport Drive, Number 1",
      "street2": "",
      "city": "Burlington",
      "cityCode": "BTV",
      "stateCode": "VT",
      "postalCode": "05403",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VTZ005",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 44.469014,
      "longitude": -73.155277,
      "elevationFeet": 335,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTV?codeType=fs"
     },
     {
      "fs": "CAE",
      "iata": "CAE",
      "icao": "KCAE",
      "faa": "CAE",
      "name": "Columbia Metropolitan Airport",
      "street1": "125-A Summer Lake",
      "city": "Columbia",
      "cityCode": "CAE",
      "stateCode": "SC",
      "postalCode": "29170",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "SCZ027",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 33.938804,
      "longitude": -81.119497,
      "elevationFeet": 219,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CAE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CAE?codeType=fs"
     },
     {
      "fs": "CAK",
      "iata": "CAK",
      "icao": "KCAK",
      "faa": "CAK",
      "name": "Akron-Canton Airport",
      "street1": "5400 Lauby Road NW - Box 9",
      "city": "Akron",
      "cityCode": "CAK",
      "stateCode": "OH",
      "postalCode": "44720",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ032",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 40.914962,
      "longitude": -81.435831,
      "elevationFeet": 1228,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CAK?codeType=fs"
     },
     {
      "fs": "CHA",
      "iata": "CHA",
      "icao": "KCHA",
      "faa": "CHA",
      "name": "Chattanooga Airport",
      "city": "Chattanooga",
      "cityCode": "CHA",
      "stateCode": "TN",
      "postalCode": "37422",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "TNZ099",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 35.036925,
      "longitude": -85.197784,
      "elevationFeet": 682,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHA?codeType=fs"
     },
     {
      "fs": "CHO",
      "iata": "CHO",
      "icao": "KCHO",
      "faa": "CHO",
      "name": "Charlottesville Albemarle Airport",
      "street1": "100 Bowen Loop",
      "city": "Charlottesville",
      "cityCode": "CHO",
      "stateCode": "VA",
      "postalCode": "22911",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ037",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 38.139415,
      "longitude": -78.449279,
      "elevationFeet": 639,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHO?codeType=fs"
     },
     {
      "fs": "CID",
      "iata": "CID",
      "icao": "KCID",
      "faa": "CID",
      "name": "The Eastern Iowa Airport",
      "street1": "2515 Wright Brothers Boulevard",
      "city": "Cedar Rapids",
      "cityCode": "CID",
      "stateCode": "IA",
      "postalCode": "52404",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ052",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 41.889423,
      "longitude": -91.700305,
      "elevationFeet": 864,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CID?codeType=fs"
     },
     {
      "fs": "CRP",
      "iata": "CRP",
      "icao": "KCRP",
      "faa": "CRP",
      "name": "Corpus Christi International Airport",
      "street1": "1000 International Drive",
      "street2": "",
      "city": "Corpus Christi",
      "cityCode": "CRP",
      "stateCode": "TX",
      "postalCode": "78406-1801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ243",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 27.774813,
      "longitude": -97.502489,
      "elevationFeet": 43,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRP?codeType=fs"
     },
     {
      "fs": "CRW",
      "iata": "CRW",
      "icao": "KCRW",
      "faa": "CRW",
      "name": "Yeager Airport",
      "street1": "100 Airport Road, Suite 175",
      "street2": "",
      "city": "Charleston",
      "cityCode": "CRW",
      "stateCode": "WV",
      "postalCode": "25311",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ015",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 38.370342,
      "longitude": -81.596504,
      "elevationFeet": 982,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRW?codeType=fs"
     },
     {
      "fs": "DAY",
      "iata": "DAY",
      "icao": "KDAY",
      "faa": "DAY",
      "name": "James M. Cox Dayton International Airport",
      "street1": "Terminal Building",
      "city": "Dayton",
      "cityCode": "DAY",
      "stateCode": "OH",
      "postalCode": "45377",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ061",
      "localTime": "2022-11-09T07:41:39.662",
      "utcOffsetHours": -5,
      "latitude": 39.898007,
      "longitude": -84.220767,
      "elevationFeet": 1009,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DAY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DAY?codeType=fs"
     },
     {
      "fs": "DPA",
      "iata": "DPA",
      "icao": "KDPA",
      "faa": "DPA",
      "name": "DuPage Airport",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 41.906831,
      "longitude": -88.253748,
      "elevationFeet": 758,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DPA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DPA?codeType=fs"
     },
     {
      "fs": "ECP",
      "iata": "ECP",
      "icao": "KECP",
      "faa": "",
      "name": "Northwest Florida Beaches International Airport",
      "city": "Panama City",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.662",
      "utcOffsetHours": -6,
      "latitude": 30.355819,
      "longitude": -85.798847,
      "elevationFeet": 63,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ECP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ECP?codeType=fs"
     },
     {
      "fs": "ELP",
      "iata": "ELP",
      "icao": "KELP",
      "faa": "ELP",
      "name": "El Paso International Airport",
      "street1": "6701 Convair Dr.",
      "city": "El Paso",
      "cityCode": "ELP",
      "stateCode": "TX",
      "postalCode": "79925",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "TXZ055",
      "localTime": "2022-11-09T05:41:39.662",
      "utcOffsetHours": -7,
      "latitude": 31.798949,
      "longitude": -106.396003,
      "elevationFeet": 3958,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELP?codeType=fs"
     },
     {
      "fs": "ENA",
      "iata": "ENA",
      "icao": "PAEN",
      "faa": "PAEN",
      "name": "Kenai Municipal Airport",
      "street1": "305 North Willow, Suite 200",
      "city": "Kenai",
      "cityCode": "ENA",
      "stateCode": "AK",
      "postalCode": "99611",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ121",
      "localTime": "2022-11-09T03:41:39.662",
      "utcOffsetHours": -9,
      "latitude": 60.565207,
      "longitude": -151.246448,
      "elevationFeet": 97,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ENA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ENA?codeType=fs"
     },
     {
      "fs": "EUG",
      "iata": "EUG",
      "icao": "KEUG",
      "faa": "EUG",
      "name": "Mahlon Sweet Field",
      "street1": "28801 Douglas Dr",
      "city": "Eugene",
      "cityCode": "EUG",
      "stateCode": "OR",
      "postalCode": "97402",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ008",
      "localTime": "2022-11-09T04:41:39.662",
      "utcOffsetHours": -8,
      "latitude": 44.124591,
      "longitude": -123.211974,
      "elevationFeet": 361,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EUG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EUG?codeType=fs"
     },
     {
      "fs": "EYW",
      "iata": "EYW",
      "icao": "KEYW",
      "faa": "EYW",
      "name": "Key West International Airport",
      "street1": "3491 South Roosevelt Boulevard",
      "street2": "",
      "city": "Key West",
      "cityCode": "EYW",
      "stateCode": "FL",
      "postalCode": "33040-5260",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 24.553574,
      "longitude": -81.75501,
      "elevationFeet": 3,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EYW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EYW?codeType=fs"
     },
     {
      "fs": "FAR",
      "iata": "FAR",
      "icao": "KFAR",
      "faa": "FAR",
      "name": "Hector International Airport",
      "city": "Fargo",
      "cityCode": "FAR",
      "stateCode": "ND",
      "postalCode": "58102",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ039",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 46.919529,
      "longitude": -96.825508,
      "elevationFeet": 900,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAR?codeType=fs"
     },
     {
      "fs": "FAT",
      "iata": "FAT",
      "icao": "KFAT",
      "faa": "FAT",
      "name": "Fresno Yosemite International Airport",
      "street1": "5175 E. Clinton Way",
      "city": "Fresno",
      "cityCode": "FAT",
      "stateCode": "CA",
      "postalCode": "93727",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ090",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 36.769624,
      "longitude": -119.720236,
      "elevationFeet": 336,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAT?codeType=fs"
     },
     {
      "fs": "FTY",
      "iata": "FTY",
      "icao": "KFTY",
      "faa": "FTY",
      "name": "Fulton County Airport",
      "city": "Atlanta",
      "cityCode": "ATL",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.777196,
      "longitude": -84.521143,
      "elevationFeet": 821,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FTY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FTY?codeType=fs"
     },
     {
      "fs": "FWA",
      "iata": "FWA",
      "icao": "KFWA",
      "faa": "FWA",
      "name": "Fort Wayne International Airport",
      "city": "Fort Wayne",
      "cityCode": "FWA",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "INZ018",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.98666,
      "longitude": -85.187715,
      "elevationFeet": 815,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FWA?codeType=fs"
     },
     {
      "fs": "GFK",
      "iata": "GFK",
      "icao": "KGFK",
      "faa": "GFK",
      "name": "Grand Forks International Airport",
      "street1": "2787 Airport Drive",
      "city": "Grand Forks",
      "cityCode": "GFK",
      "stateCode": "ND",
      "postalCode": "58203",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ027",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 47.949786,
      "longitude": -97.177132,
      "elevationFeet": 845,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GFK?codeType=fs"
     },
     {
      "fs": "GJT",
      "iata": "GJT",
      "icao": "KGJT",
      "faa": "GJT",
      "name": "Grand Junction Regional Airport",
      "street1": "2828 Walker Field Road, Suite 211",
      "street2": "",
      "city": "Grand Junction",
      "cityCode": "GJT",
      "stateCode": "CO",
      "postalCode": "81506",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ006",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 39.122666,
      "longitude": -108.528333,
      "elevationFeet": 4858,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GJT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GJT?codeType=fs"
     },
     {
      "fs": "GRR",
      "iata": "GRR",
      "icao": "KGRR",
      "faa": "GRR",
      "name": "Gerald R. Ford International Airport",
      "street1": "5500 44th Street Southeast",
      "city": "Grand Rapids",
      "cityCode": "GRR",
      "stateCode": "MI",
      "postalCode": "49512",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ057",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.885009,
      "longitude": -85.529738,
      "elevationFeet": 793,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRR?codeType=fs"
     },
     {
      "fs": "GSO",
      "iata": "GSO",
      "icao": "KGSO",
      "faa": "GSO",
      "name": "Piedmont Triad International Airport",
      "street1": "International Airport",
      "city": "Greensboro/High Point",
      "cityCode": "GSO",
      "stateCode": "NC",
      "postalCode": "27425-5408",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ022",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 36.105324,
      "longitude": -79.937304,
      "elevationFeet": 926,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GSO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GSO?codeType=fs"
     },
     {
      "fs": "GSP",
      "iata": "GSP",
      "icao": "KGSP",
      "faa": "GSP",
      "name": "Greenville-Spartanburg International Airport",
      "street1": "2000 GPS Drive, Suite 1",
      "city": "Greenville",
      "cityCode": "GSP",
      "stateCode": "SC",
      "postalCode": "29651-9202",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "SCZ006",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 34.890569,
      "longitude": -82.217053,
      "elevationFeet": 964,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GSP?codeType=fs"
     },
     {
      "fs": "HPN",
      "iata": "HPN",
      "icao": "KHPN",
      "faa": "HPN",
      "name": "Westchester County Airport",
      "street1": "240 Airport Road, Suite 202",
      "city": "Westchester County",
      "cityCode": "HPN",
      "stateCode": "NY",
      "postalCode": "10604",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ070",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.068674,
      "longitude": -73.703889,
      "elevationFeet": 439,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HPN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HPN?codeType=fs"
     },
     {
      "fs": "HSV",
      "iata": "HSV",
      "icao": "KHSV",
      "faa": "HSV",
      "name": "Huntsville International Airport - Carl T. Jones Field",
      "street1": "1000 Glenn Hearn Blvd, Box 20008",
      "city": "Huntsville",
      "cityCode": "HSV",
      "stateCode": "AL",
      "postalCode": "35824",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ006",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 34.64857,
      "longitude": -86.774838,
      "elevationFeet": 629,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HSV?codeType=fs"
     },
     {
      "fs": "ILM",
      "iata": "ILM",
      "icao": "KILM",
      "faa": "ILM",
      "name": "Wilmington International Airport",
      "street1": "1740 Airport Boulevard",
      "city": "Wilmington",
      "cityCode": "ILM",
      "stateCode": "NC",
      "postalCode": "28405",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ101",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 34.267052,
      "longitude": -77.910627,
      "elevationFeet": 41,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ILM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ILM?codeType=fs"
     },
     {
      "fs": "ISP",
      "iata": "ISP",
      "icao": "KISP",
      "faa": "ISP",
      "name": "Long Island MacArthur Airport",
      "street1": "100 Arrivals Avenue",
      "city": "Islip",
      "cityCode": "ISP",
      "stateCode": "NY",
      "postalCode": "11779",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ080",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.789314,
      "longitude": -73.097546,
      "elevationFeet": 79,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISP?codeType=fs"
     },
     {
      "fs": "ITO",
      "iata": "ITO",
      "icao": "PHTO",
      "faa": "PHTO",
      "name": "Hilo International Airport",
      "street1": "",
      "street2": "",
      "city": "Hilo",
      "cityCode": "ITO",
      "stateCode": "HI",
      "postalCode": "96720",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ004",
      "localTime": "2022-11-09T02:41:39.663",
      "utcOffsetHours": -10,
      "latitude": 19.714565,
      "longitude": -155.039628,
      "elevationFeet": 38,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ITO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ITO?codeType=fs"
     },
     {
      "fs": "JAN",
      "iata": "JAN",
      "icao": "KJAN",
      "faa": "JAN",
      "name": "Jackson-Evers International Airport",
      "street1": "100 International Drive, Suite 300",
      "city": "Jackson",
      "cityCode": "JAN",
      "stateCode": "MS",
      "postalCode": "39296-8109",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ048",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 32.309896,
      "longitude": -90.074955,
      "elevationFeet": 346,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JAN?codeType=fs"
     },
     {
      "fs": "JNU",
      "iata": "JNU",
      "icao": "PAJN",
      "faa": "PAJN",
      "name": "Juneau International Airport",
      "street1": "155 South Seward Street",
      "city": "Juneau",
      "cityCode": "JNU",
      "stateCode": "AK",
      "postalCode": "99801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ025",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 58.359323,
      "longitude": -134.583395,
      "elevationFeet": 19,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JNU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JNU?codeType=fs"
     },
     {
      "fs": "KTN",
      "iata": "KTN",
      "icao": "PAKT",
      "faa": "PAKT",
      "name": "Ketchikan International Airport",
      "street1": "1000 Airport Terminal Building",
      "street2": "",
      "city": "Ketchikan",
      "cityCode": "KTN",
      "stateCode": "AK",
      "postalCode": "99901",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ027",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 55.35655,
      "longitude": -131.708694,
      "elevationFeet": 88,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTN?codeType=fs"
     },
     {
      "fs": "LAN",
      "iata": "LAN",
      "icao": "KLAN",
      "faa": "LAN",
      "name": "Lansing Capital Region International Airport",
      "street1": "4100 Capital City Blvd.",
      "city": "Lansing",
      "cityCode": "LAN",
      "stateCode": "MI",
      "postalCode": "48906",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ067",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.778689,
      "longitude": -84.587348,
      "elevationFeet": 850,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAN?codeType=fs"
     },
     {
      "fs": "LBB",
      "iata": "LBB",
      "icao": "KLBB",
      "faa": "LBB",
      "name": "Lubbock Preston Smith International Airport",
      "street1": "5401 N. Martin Luther King Blvd.",
      "city": "Lubbock",
      "cityCode": "LBB",
      "stateCode": "TX",
      "postalCode": "79403",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ035",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 33.656221,
      "longitude": -101.8223,
      "elevationFeet": 3282,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LBB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LBB?codeType=fs"
     },
     {
      "fs": "LCK",
      "iata": "LCK",
      "icao": "KLCK",
      "faa": "LCK",
      "name": "Rickenbacker International Airport",
      "city": "Columbus",
      "cityCode": "CMH",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ055",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.817957,
      "longitude": -82.935508,
      "elevationFeet": 744,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LCK?codeType=fs"
     },
     {
      "fs": "LGB",
      "iata": "LGB",
      "icao": "KLGB",
      "faa": "LGB",
      "name": "Long Beach Airport",
      "street1": "4100 Donald Douglas Drive",
      "city": "Long Beach",
      "cityCode": "LGB",
      "stateCode": "CA",
      "postalCode": "90808-1798",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ041",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.818194,
      "longitude": -118.144494,
      "elevationFeet": 58,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LGB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LGB?codeType=fs"
     },
     {
      "fs": "LIH",
      "iata": "LIH",
      "icao": "PHLI",
      "faa": "PHLI",
      "name": "Lihue Airport",
      "street1": "3901 Mokulele Lap, Box 6",
      "city": "Kauai Island",
      "cityCode": "LIH",
      "stateCode": "HI",
      "postalCode": "96766",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ001",
      "localTime": "2022-11-09T02:41:39.663",
      "utcOffsetHours": -10,
      "latitude": 21.978204,
      "longitude": -159.349445,
      "elevationFeet": 153,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIH?codeType=fs"
     },
     {
      "fs": "LWM",
      "iata": "LWM",
      "icao": "KLWM",
      "faa": "LWM",
      "name": "Lawrence Municipal Airport",
      "city": "Lawrence",
      "cityCode": "LWM",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.7175,
      "longitude": -71.1225,
      "elevationFeet": 148,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWM?codeType=fs"
     },
     {
      "fs": "MAF",
      "iata": "MAF",
      "icao": "KMAF",
      "faa": "MAF",
      "name": "Midland International Airport",
      "city": "Midland",
      "cityCode": "MAF",
      "stateCode": "TX",
      "postalCode": "79711",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ062",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 31.937145,
      "longitude": -102.208167,
      "elevationFeet": 2871,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MAF?codeType=fs"
     },
     {
      "fs": "MDT",
      "iata": "MDT",
      "icao": "KMDT",
      "faa": "MDT",
      "name": "Harrisburg International Airport",
      "street1": "One Terminal Drive",
      "street2": "",
      "city": "Middletown",
      "cityCode": "HAR",
      "stateCode": "PA",
      "postalCode": "17057",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ057",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.196008,
      "longitude": -76.756057,
      "elevationFeet": 310,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDT?codeType=fs"
     },
     {
      "fs": "MFR",
      "iata": "MFR",
      "icao": "KMFR",
      "faa": "MFR",
      "name": "Rogue Valley International-Medford Airport",
      "street1": "1000 Terminal Spur Rd.",
      "city": "Medford",
      "cityCode": "MFR",
      "stateCode": "OR",
      "postalCode": "97504",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ026",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 42.369025,
      "longitude": -122.87312,
      "elevationFeet": 1335,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MFR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MFR?codeType=fs"
     },
     {
      "fs": "MHT",
      "iata": "MHT",
      "icao": "KMHT",
      "faa": "MHT",
      "name": "Manchester Boston Regional Airport",
      "street1": "One Airport Road",
      "city": "Manchester",
      "cityCode": "MHT",
      "stateCode": "NH",
      "postalCode": "03103",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NHZ012",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.927862,
      "longitude": -71.438439,
      "elevationFeet": 242,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHT?codeType=fs"
     },
     {
      "fs": "MKC",
      "iata": "MKC",
      "icao": "KMKC",
      "faa": "MKC",
      "name": "Charles B. Wheeler Downtown Airport",
      "city": "Kansas City",
      "cityCode": "MKC",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ028",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 39.124167,
      "longitude": -94.591944,
      "elevationFeet": 759,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKC?codeType=fs"
     },
     {
      "fs": "MKK",
      "iata": "MKK",
      "icao": "PHMK",
      "faa": "PHMK",
      "name": "Molokai Airport",
      "city": "Hoolehua",
      "cityCode": "MKK",
      "stateCode": "HI",
      "postalCode": "96729",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ005",
      "localTime": "2022-11-09T02:41:39.663",
      "utcOffsetHours": -10,
      "latitude": 21.155184,
      "longitude": -157.092927,
      "elevationFeet": 454,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKK?codeType=fs"
     },
     {
      "fs": "MLI",
      "iata": "MLI",
      "icao": "KMLI",
      "faa": "MLI",
      "name": "Quad City International Airport",
      "street1": "2200 69th Ave.",
      "city": "Moline",
      "cityCode": "MLI",
      "stateCode": "IL",
      "postalCode": "61265",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ015",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 41.453897,
      "longitude": -90.506111,
      "elevationFeet": 590,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLI?codeType=fs"
     },
     {
      "fs": "MOB",
      "iata": "MOB",
      "icao": "KMOB",
      "faa": "MOB",
      "name": "Mobile Regional Airport",
      "street1": "8400 Airport Blvd.",
      "city": "Mobile",
      "cityCode": "MOB",
      "stateCode": "AL",
      "postalCode": "36608-0004",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ063",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.681085,
      "longitude": -88.244753,
      "elevationFeet": 219,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOB?codeType=fs"
     },
     {
      "fs": "MRY",
      "iata": "MRY",
      "icao": "KMRY",
      "faa": "MRY",
      "name": "Monterey Regional Airport",
      "street1": "200 Fred Kane Drive, Suite 200",
      "city": "Monterey",
      "cityCode": "MRY",
      "stateCode": "CA",
      "postalCode": "93940",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 36.587294,
      "longitude": -121.850813,
      "elevationFeet": 181,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRY?codeType=fs"
     },
     {
      "fs": "MSN",
      "iata": "MSN",
      "icao": "KMSN",
      "faa": "MSN",
      "name": "Dane County Regional Airport",
      "street1": "4000 International Lane",
      "street2": "",
      "city": "Madison",
      "cityCode": "MSN",
      "stateCode": "WI",
      "postalCode": "53704-3120",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ063",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 43.136377,
      "longitude": -89.346497,
      "elevationFeet": 887,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSN?codeType=fs"
     },
     {
      "fs": "MVY",
      "iata": "MVY",
      "icao": "KMVY",
      "faa": "MVY",
      "name": "Martha's Vineyard Airport",
      "street1": "RFD 850",
      "street2": "",
      "city": "Martha's Vineyard",
      "cityCode": "MVY",
      "stateCode": "MA",
      "postalCode": "02568",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ023",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.389335,
      "longitude": -70.61182,
      "elevationFeet": 68,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVY?codeType=fs"
     },
     {
      "fs": "MYR",
      "iata": "MYR",
      "icao": "KMYR",
      "faa": "MYR",
      "name": "Myrtle Beach International Airport",
      "street1": "1100 Jetport Road",
      "street2": "",
      "city": "Myrtle Beach",
      "cityCode": "MYR",
      "stateCode": "SC",
      "postalCode": "29577",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "SCZ034",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.682676,
      "longitude": -78.922944,
      "elevationFeet": 25,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYR?codeType=fs"
     },
     {
      "fs": "OME",
      "iata": "OME",
      "icao": "PAOM",
      "faa": "PAOM",
      "name": "Nome Airport",
      "city": "Nome",
      "cityCode": "OME",
      "stateCode": "AK",
      "postalCode": "99762",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ211",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 64.510601,
      "longitude": -165.431055,
      "elevationFeet": 37,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OME?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OME?codeType=fs"
     },
     {
      "fs": "ORL",
      "iata": "ORL",
      "icao": "KORL",
      "faa": "ORL",
      "name": "Orlando Executive Airport",
      "city": "Orlando",
      "cityCode": "ORL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ045",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 28.544167,
      "longitude": -81.335556,
      "elevationFeet": 113,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORL?codeType=fs"
     },
     {
      "fs": "OTZ",
      "iata": "OTZ",
      "icao": "PAOT",
      "faa": "PAOT",
      "name": "Ralph Wien Memorial Airport",
      "city": "Kotzebue",
      "cityCode": "OTZ",
      "stateCode": "AK",
      "postalCode": "99752",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ209",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 66.890613,
      "longitude": -162.602699,
      "elevationFeet": 11,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTZ?codeType=fs"
     },
     {
      "fs": "PDK",
      "iata": "PDK",
      "icao": "KPDK",
      "faa": "PDK",
      "name": "DeKalb Peachtree Airport",
      "city": "Atlanta",
      "cityCode": "ATL",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.875556,
      "longitude": -84.301944,
      "elevationFeet": 991,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PDK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PDK?codeType=fs"
     },
     {
      "fs": "PIA",
      "iata": "PIA",
      "icao": "KPIA",
      "faa": "PIA",
      "name": "Peoria International Airport",
      "street1": "6100 W. Everett McKinley Dirksen Parkway",
      "city": "Peoria",
      "cityCode": "PIA",
      "stateCode": "IL",
      "postalCode": "61607",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ029",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 40.666432,
      "longitude": -89.690117,
      "elevationFeet": 660,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIA?codeType=fs"
     },
     {
      "fs": "PNS",
      "iata": "PNS",
      "icao": "KPNS",
      "faa": "PNS",
      "name": "Pensacola International Airport",
      "street1": "2430 Airport Boulevard",
      "city": "Pensacola",
      "cityCode": "PNS",
      "stateCode": "FL",
      "postalCode": "32504",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "FLZ002",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.475942,
      "longitude": -87.194157,
      "elevationFeet": 121,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNS?codeType=fs"
     },
     {
      "fs": "PSP",
      "iata": "PSP",
      "icao": "KPSP",
      "faa": "PSP",
      "name": "Palm Springs International Airport",
      "street1": "3400 East Tahquitz-Canyon Way",
      "city": "Palm Springs",
      "cityCode": "PSP",
      "stateCode": "CA",
      "postalCode": "92262",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ061",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.822976,
      "longitude": -116.508444,
      "elevationFeet": 474,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSP?codeType=fs"
     },
     {
      "fs": "PWM",
      "iata": "PWM",
      "icao": "KPWM",
      "faa": "PWM",
      "name": "Portland International Jetport",
      "street1": "1001 Westbrook Street",
      "street2": "",
      "city": "Portland",
      "cityCode": "PWM",
      "stateCode": "ME",
      "postalCode": "04102",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ024",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 43.647492,
      "longitude": -70.310307,
      "elevationFeet": 74,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PWM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PWM?codeType=fs"
     },
     {
      "fs": "RDM",
      "iata": "RDM",
      "icao": "KRDM",
      "faa": "RDM",
      "name": "Roberts Field",
      "city": "Redmond",
      "cityCode": "RDM",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ043",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 44.254112,
      "longitude": -121.150106,
      "elevationFeet": 3071,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDM?codeType=fs"
     },
     {
      "fs": "RNO",
      "iata": "RNO",
      "icao": "KRNO",
      "faa": "RNO",
      "name": "Reno/Tahoe International Airport",
      "street1": "2001 East Plumb Lane",
      "city": "Reno",
      "cityCode": "RNO",
      "stateCode": "NV",
      "postalCode": "89502",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "NVZ003",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 39.505782,
      "longitude": -119.775698,
      "elevationFeet": 4412,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RNO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RNO?codeType=fs"
     },
     {
      "fs": "ROA",
      "iata": "ROA",
      "icao": "KROA",
      "faa": "ROA",
      "name": "Roanoke-Blacksburg Regional Airport",
      "street1": "5202 Aviation Drive, N.W.",
      "city": "Roanoke",
      "cityCode": "ROA",
      "stateCode": "VA",
      "postalCode": "24012-1148",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ022",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 37.320509,
      "longitude": -79.970384,
      "elevationFeet": 1176,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ROA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ROA?codeType=fs"
     },
     {
      "fs": "SAV",
      "iata": "SAV",
      "icao": "KSAV",
      "faa": "SAV",
      "name": "Savannah/Hilton Head Airport",
      "street1": "400 Airways Avenue",
      "street2": "",
      "city": "Savannah",
      "cityCode": "SAV",
      "stateCode": "GA",
      "postalCode": "31408",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ118",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 32.1358,
      "longitude": -81.210588,
      "elevationFeet": 50,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAV?codeType=fs"
     },
     {
      "fs": "SBA",
      "iata": "SBA",
      "icao": "KSBA",
      "faa": "SBA",
      "name": "Santa Barbara Municipal Airport",
      "street1": "500 Fowler Rd.",
      "city": "Santa Barbara",
      "cityCode": "SBA",
      "stateCode": "CA",
      "postalCode": "93117",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ039",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 34.432833,
      "longitude": -119.836476,
      "elevationFeet": 10,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBA?codeType=fs"
     },
     {
      "fs": "SBN",
      "iata": "SBN",
      "icao": "KSBN",
      "faa": "SBN",
      "name": "South Bend Regional",
      "street1": "4477 Progress Dr",
      "city": "South Bend",
      "cityCode": "SBN",
      "stateCode": "IN",
      "postalCode": "46628-5594",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "INZ004",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.700555,
      "longitude": -86.313345,
      "elevationFeet": 799,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBN?codeType=fs"
     },
     {
      "fs": "SGF",
      "iata": "SGF",
      "icao": "KSGF",
      "faa": "SGF",
      "name": "Springfield-Branson National Airport",
      "street1": "2300 N Airport Blvd",
      "city": "Springfield",
      "cityCode": "SGF",
      "stateCode": "MO",
      "postalCode": "65802",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ090",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 37.238707,
      "longitude": -93.396929,
      "elevationFeet": 1267,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGF?codeType=fs"
     },
     {
      "fs": "SHV",
      "iata": "SHV",
      "icao": "KSHV",
      "faa": "SHV",
      "name": "Shreveport Regional Airport",
      "street1": "5103 Hollywood Avenue, Suite 300",
      "street2": "",
      "city": "Shreveport",
      "cityCode": "SHV",
      "stateCode": "LA",
      "postalCode": "71109",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ001",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 32.454707,
      "longitude": -93.828383,
      "elevationFeet": 258,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHV?codeType=fs"
     },
     {
      "fs": "STP",
      "iata": "STP",
      "icao": "KSTP",
      "faa": "STP",
      "name": "St. Paul Downtown Airport",
      "city": "Saint Paul",
      "cityCode": "STP",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ070",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 44.934502,
      "longitude": -93.059998,
      "elevationFeet": 702,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STP?codeType=fs"
     },
     {
      "fs": "TLH",
      "iata": "TLH",
      "icao": "KTLH",
      "faa": "TLH",
      "name": "Tallahassee International Airport",
      "street1": "3300 Capitol Circle Southwest",
      "city": "Tallahassee",
      "cityCode": "TLH",
      "stateCode": "FL",
      "postalCode": "32310",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ017",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 30.395783,
      "longitude": -84.34444,
      "elevationFeet": 81,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TLH?codeType=fs"
     },
     {
      "fs": "TYS",
      "iata": "TYS",
      "icao": "KTYS",
      "faa": "TYS",
      "name": "McGhee Tyson Airport",
      "street1": "2055 Alcoa Highway",
      "city": "Knoxville",
      "cityCode": "TYS",
      "stateCode": "TN",
      "postalCode": "37701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "TNZ071",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 35.80565,
      "longitude": -83.989729,
      "elevationFeet": 981,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TYS?codeType=fs"
     },
     {
      "fs": "XNA",
      "iata": "XNA",
      "icao": "KXNA",
      "faa": "XNA",
      "name": "Northwest Arkansas Regional Airport",
      "street1": "1 Airport Blvd.",
      "city": "Bentonville",
      "cityCode": "FYV",
      "stateCode": "AR",
      "postalCode": "72712",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ010",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 36.275259,
      "longitude": -94.297109,
      "elevationFeet": 1287,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XNA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XNA?codeType=fs"
     },
     {
      "fs": "YIP",
      "iata": "YIP",
      "icao": "KYIP",
      "faa": "YIP",
      "name": "Willow Run Airport",
      "city": "Detroit",
      "cityCode": "DTT",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.233333,
      "longitude": -83.533333,
      "elevationFeet": 716,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/YIP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/YIP?codeType=fs"
     },
     {
      "fs": "YUM",
      "iata": "YUM",
      "icao": "KNYL",
      "faa": "NYL",
      "name": "Yuma International Airport",
      "city": "Yuma",
      "cityCode": "YUM",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ025",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 32.668605,
      "longitude": -114.599263,
      "elevationFeet": 216,
      "classification": 3,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/YUM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/YUM?codeType=fs"
     },
     {
      "fs": "0M9",
      "iata": "DQO",
      "icao": "",
      "faa": "0M9",
      "name": "Delhi Municipal",
      "city": "Delhi",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 32.507,
      "longitude": -91.637306,
      "elevationFeet": 91,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M9?codeType=fs"
     },
     {
      "fs": "0N4",
      "iata": "",
      "icao": "",
      "faa": "0N4",
      "name": "Chandelle Estates Airport",
      "city": "Dover",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.205079,
      "longitude": -75.483301,
      "elevationFeet": 21,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0N4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0N4?codeType=fs"
     },
     {
      "fs": "1A5",
      "iata": "",
      "icao": "",
      "faa": "1A5",
      "name": "Macon Co",
      "city": "Franklin",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 35.275944,
      "longitude": -83.440444,
      "elevationFeet": 2020,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A5?codeType=fs"
     },
     {
      "fs": "1G0",
      "iata": "",
      "icao": "",
      "faa": "1G0",
      "name": "Wood Co",
      "city": "Bowling Green",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.46,
      "longitude": -83.751389,
      "elevationFeet": 673,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G0?codeType=fs"
     },
     {
      "fs": "1G4",
      "iata": "GCW",
      "icao": "",
      "faa": "1G4",
      "name": "Grand Canyon West Airport",
      "city": "Peach Springs",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 35.988802,
      "longitude": -113.815671,
      "elevationFeet": 4775,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G4?codeType=fs"
     },
     {
      "fs": "1O5",
      "iata": "ROF",
      "icao": "",
      "faa": "1O5",
      "name": "Rohrer Field",
      "city": "Montague",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 41.730496,
      "longitude": -122.544845,
      "elevationFeet": 2520,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O5?codeType=fs"
     },
     {
      "fs": "1Z1",
      "iata": "GCT",
      "icao": "",
      "faa": "1Z1",
      "name": "Bar Ten Ranch Airport",
      "city": "Grand Canyon",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 36.258369,
      "longitude": -113.231092,
      "elevationFeet": 3988,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Z1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Z1?codeType=fs"
     },
     {
      "fs": "27K",
      "iata": "",
      "icao": "",
      "faa": "27K",
      "name": "Georgetown-Scott County Regional Airport",
      "city": "Georgetown",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 38.234173,
      "longitude": -84.432938,
      "elevationFeet": 943,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27K?codeType=fs"
     },
     {
      "fs": "33N",
      "iata": "",
      "icao": "",
      "faa": "33N",
      "name": "Delaware Airpark",
      "city": "Dover-Cheswold",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.218231,
      "longitude": -75.595525,
      "elevationFeet": 47,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33N?codeType=fs"
     },
     {
      "fs": "36U",
      "iata": "",
      "icao": "",
      "faa": "36U",
      "name": "Heber City Mun-Mcdonald",
      "city": "Heber",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 40.618056,
      "longitude": -111.538056,
      "elevationFeet": 5637,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/36U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/36U?codeType=fs"
     },
     {
      "fs": "38S",
      "iata": "",
      "icao": "",
      "faa": "38S",
      "name": "Deer Lodge-City-Co",
      "city": "Deer Lodge",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 46.438167,
      "longitude": -112.769833,
      "elevationFeet": 4689,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38S?codeType=fs"
     },
     {
      "fs": "3A1",
      "iata": "",
      "icao": "KCMD",
      "faa": "CMD",
      "name": "Cullman Regional-Folsom Field",
      "city": "Cullman",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 34.268694,
      "longitude": -86.858028,
      "elevationFeet": 952,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A1?codeType=fs"
     },
     {
      "fs": "3J7",
      "iata": "",
      "icao": "",
      "faa": "3J7",
      "name": "Greene County Regional Airport",
      "city": "Greensboro",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.597227,
      "longitude": -83.139233,
      "elevationFeet": 683,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3J7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3J7?codeType=fs"
     },
     {
      "fs": "3S8",
      "iata": "GTP",
      "icao": "",
      "faa": "3S8",
      "name": "Grants Pass Airport",
      "city": "Grants Pass",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 42.509257,
      "longitude": -123.388694,
      "elevationFeet": 1105,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S8?codeType=fs"
     },
     {
      "fs": "4A7",
      "iata": "",
      "icao": "",
      "faa": "4A7",
      "name": "Henry County Airport - Tara Field",
      "city": "Hampton",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.389381,
      "longitude": -84.330755,
      "elevationFeet": 842,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A7?codeType=fs"
     },
     {
      "fs": "4I3",
      "iata": "",
      "icao": "",
      "faa": "4I3",
      "name": "Knox County Airport",
      "city": "Mt Vernon",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.329379,
      "longitude": -82.521501,
      "elevationFeet": 1183,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4I3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4I3?codeType=fs"
     },
     {
      "fs": "4R4",
      "iata": "",
      "icao": "KCQF",
      "faa": "CQF",
      "name": "H. L. Sonny Callahan Airport",
      "city": "Fairhope",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.466524,
      "longitude": -87.877186,
      "elevationFeet": 84,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R4?codeType=fs"
     },
     {
      "fs": "5S8",
      "iata": "",
      "icao": "",
      "faa": "5S8",
      "name": "St. Michael",
      "city": "St. Michael",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 63.5505,
      "longitude": -162.203694,
      "elevationFeet": 93,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S8?codeType=fs"
     },
     {
      "fs": "5T6",
      "iata": "",
      "icao": "",
      "faa": "5T6",
      "name": "Dona Ana Co At Santa Teresa",
      "city": "Santa Teresa",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 32.009861,
      "longitude": -106.748139,
      "elevationFeet": 4112,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5T6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5T6?codeType=fs"
     },
     {
      "fs": "5T9",
      "iata": "",
      "icao": "",
      "faa": "5T9",
      "name": "Maverick County Memorial International Airport",
      "city": "Eagle Pass",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 28.859717,
      "longitude": -100.516368,
      "elevationFeet": 887,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5T9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5T9?codeType=fs"
     },
     {
      "fs": "6S5",
      "iata": "",
      "icao": "",
      "faa": "6S5",
      "name": "Ravalli Co",
      "city": "Hamilton",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 46.264944,
      "longitude": -114.205417,
      "elevationFeet": 3642,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S5?codeType=fs"
     },
     {
      "fs": "7S0",
      "iata": "",
      "icao": "",
      "faa": "7S0",
      "name": "Ronan",
      "city": "Ronan",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 47.607694,
      "longitude": -114.217778,
      "elevationFeet": 3089,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S0?codeType=fs"
     },
     {
      "fs": "8A0",
      "iata": "",
      "icao": "",
      "faa": "8A0",
      "name": "The Albertville Mun-Brumlik",
      "city": "Albertville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 34.341222,
      "longitude": -86.307556,
      "elevationFeet": 1032,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8A0?codeType=fs"
     },
     {
      "fs": "ABI",
      "iata": "ABI",
      "icao": "KABI",
      "faa": "ABI",
      "name": "Abilene Regional Airport",
      "city": "Abilene",
      "cityCode": "ABI",
      "stateCode": "TX",
      "postalCode": "79604",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ127",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 32.412843,
      "longitude": -99.680052,
      "elevationFeet": 1791,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ABI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ABI?codeType=fs"
     },
     {
      "fs": "ABL",
      "iata": "ABL",
      "icao": "PAFM",
      "faa": "PAFM",
      "name": "Ambler Airport",
      "city": "Ambler",
      "cityCode": "ABL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ217",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 67.0875,
      "longitude": -157.845833,
      "elevationFeet": 289,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ABL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ABL?codeType=fs"
     },
     {
      "fs": "ABR",
      "iata": "ABR",
      "icao": "KABR",
      "faa": "ABR",
      "name": "Aberdeen Regional Airport",
      "street1": "4400 E. Hwy 12",
      "city": "Aberdeen",
      "cityCode": "ABR",
      "stateCode": "SD",
      "postalCode": "57401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "SDZ006",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 45.44906,
      "longitude": -98.421829,
      "elevationFeet": 1301,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ABR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ABR?codeType=fs"
     },
     {
      "fs": "ABY",
      "iata": "ABY",
      "icao": "KABY",
      "faa": "ABY",
      "name": "Southwest Georgia Regional Airport",
      "street1": "3905 Newton Road",
      "city": "Albany",
      "cityCode": "ABY",
      "stateCode": "GA",
      "postalCode": "31701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ125",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 31.532222,
      "longitude": -84.196111,
      "elevationFeet": 197,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ABY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ABY?codeType=fs"
     },
     {
      "fs": "ACB",
      "iata": "ACB",
      "icao": "KACB",
      "faa": "ACB",
      "name": "Antrim County Airport",
      "city": "Bellaire",
      "cityCode": "ACB",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 44.983333,
      "longitude": -85.216667,
      "elevationFeet": 623,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ACB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ACB?codeType=fs"
     },
     {
      "fs": "ACT",
      "iata": "ACT",
      "icao": "KACT",
      "faa": "ACT",
      "name": "Waco Municipal Airport",
      "street1": "Route 10",
      "street2": "",
      "city": "Waco",
      "cityCode": "ACT",
      "stateCode": "TX",
      "postalCode": "76708",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ159",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 31.609132,
      "longitude": -97.223217,
      "elevationFeet": 516,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ACT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ACT?codeType=fs"
     },
     {
      "fs": "ACV",
      "iata": "ACV",
      "icao": "KACV",
      "faa": "ACV",
      "name": "Arcata-Eureka Airport",
      "street1": "3561 Boeing Ave",
      "city": "Arcata",
      "cityCode": "ACV",
      "stateCode": "CA",
      "postalCode": "95519",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ001",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 40.970912,
      "longitude": -124.106929,
      "elevationFeet": 218,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ACV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ACV?codeType=fs"
     },
     {
      "fs": "ACY",
      "iata": "ACY",
      "icao": "KACY",
      "faa": "ACY",
      "name": "Atlantic City International Airport",
      "street1": "101 Atlantic City International Airport",
      "city": "Atlantic City",
      "cityCode": "AIY",
      "stateCode": "NJ",
      "postalCode": "08234",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NJZ022",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.450701,
      "longitude": -74.572233,
      "elevationFeet": 75,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ACY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ACY?codeType=fs"
     },
     {
      "fs": "ADK",
      "iata": "ADK",
      "icao": "PADK",
      "faa": "PADK",
      "name": "Adak Island Naval Station",
      "city": "Adak Island",
      "cityCode": "ADK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Adak",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.663",
      "utcOffsetHours": -10,
      "latitude": 51.882778,
      "longitude": -176.644722,
      "elevationFeet": 18,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADK?codeType=fs"
     },
     {
      "fs": "ADM",
      "iata": "ADM",
      "icao": "KADM",
      "faa": "ADM",
      "name": "Ardmore Municipal Airport",
      "city": "Ardmore",
      "cityCode": "ADM",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 34.303056,
      "longitude": -97.019444,
      "elevationFeet": 762,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADM?codeType=fs"
     },
     {
      "fs": "ADW",
      "iata": "ADW",
      "icao": "KADW",
      "faa": "ADW",
      "name": "Andrews Air Force Base",
      "city": "Camp Springs",
      "cityCode": "ADW",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 38.816667,
      "longitude": -76.866667,
      "elevationFeet": 280,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADW?codeType=fs"
     },
     {
      "fs": "AET",
      "iata": "AET",
      "icao": "",
      "faa": "6A8",
      "name": "Allakaket Airport",
      "city": "Allakaket",
      "cityCode": "AET",
      "stateCode": "AK",
      "postalCode": "99720",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ219",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 66.553651,
      "longitude": -152.610527,
      "elevationFeet": 419,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AET?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AET?codeType=fs"
     },
     {
      "fs": "AEX",
      "iata": "AEX",
      "icao": "KAEX",
      "faa": "AEX",
      "name": "Alexandria International Airport",
      "street1": "1611 Arnold Drive",
      "city": "Alexandria",
      "cityCode": "AEX",
      "stateCode": "LA",
      "postalCode": "71303-5636",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ028",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 31.322573,
      "longitude": -92.542568,
      "elevationFeet": 89,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AEX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AEX?codeType=fs"
     },
     {
      "fs": "AGC",
      "iata": "AGC",
      "icao": "KAGC",
      "faa": "AGC",
      "name": "Allegheny County Airport",
      "city": "Pittsburgh",
      "cityCode": "PIT",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ021",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.354722,
      "longitude": -79.93,
      "elevationFeet": 1252,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AGC?codeType=fs"
     },
     {
      "fs": "AGN",
      "iata": "AGN",
      "icao": "",
      "faa": "",
      "name": "Angoon Seaplane Base",
      "city": "Angoon",
      "cityCode": "AGN",
      "stateCode": "AK",
      "postalCode": "99820",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ025",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 57.496784,
      "longitude": -134.568858,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AGN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AGN?codeType=fs"
     },
     {
      "fs": "AGS",
      "iata": "AGS",
      "icao": "KAGS",
      "faa": "AGS",
      "name": "Augusta Regional Airport",
      "street1": "1501 Aviation Way",
      "city": "Augusta",
      "cityCode": "AGS",
      "stateCode": "GA",
      "postalCode": "30906",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ065",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.373666,
      "longitude": -81.973438,
      "elevationFeet": 145,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AGS?codeType=fs"
     },
     {
      "fs": "AHN",
      "iata": "AHN",
      "icao": "KAHN",
      "faa": "AHN",
      "name": "Athens-Ben Epps Airport",
      "street1": "1010 Ben Epps Drive",
      "city": "Athens",
      "cityCode": "AHN",
      "stateCode": "GA",
      "postalCode": "30605",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ036",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.951951,
      "longitude": -83.324725,
      "elevationFeet": 808,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AHN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AHN?codeType=fs"
     },
     {
      "fs": "AIA",
      "iata": "AIA",
      "icao": "KAIA",
      "faa": "AIA",
      "name": "Alliance Airport",
      "city": "Alliance",
      "cityCode": "AIA",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NEZ003",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 42.051667,
      "longitude": -102.806667,
      "elevationFeet": 3931,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIA?codeType=fs"
     },
     {
      "fs": "AIK",
      "iata": "AIK",
      "icao": "KAIK",
      "faa": "AIK",
      "name": "Aiken Municipal Airport",
      "city": "Aiken",
      "cityCode": "AIK",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.649014,
      "longitude": -81.684066,
      "elevationFeet": 509,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIK?codeType=fs"
     },
     {
      "fs": "AIN",
      "iata": "AIN",
      "icao": "PAWT",
      "faa": "PAWI",
      "name": "Wainwright Airport",
      "city": "Wainwright",
      "cityCode": "AIN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ201",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 70.633333,
      "longitude": -160.033333,
      "elevationFeet": 41,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIN?codeType=fs"
     },
     {
      "fs": "AIZ",
      "iata": "AIZ",
      "icao": "KAIZ",
      "faa": "AIZ",
      "name": "Lee C Fine Memorial Airport",
      "city": "Kaiser/Lake Ozark",
      "cityCode": "AIZ",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 38.098333,
      "longitude": -92.547222,
      "elevationFeet": 869,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIZ?codeType=fs"
     },
     {
      "fs": "AKB",
      "iata": "AKB",
      "icao": "",
      "faa": "AKA",
      "name": "Atka Airport",
      "city": "Atka",
      "cityCode": "AKB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Adak",
      "weatherZone": "AKZ191",
      "localTime": "2022-11-09T02:41:39.663",
      "utcOffsetHours": -10,
      "latitude": 52.217222,
      "longitude": -174.200833,
      "elevationFeet": 56,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKB?codeType=fs"
     },
     {
      "fs": "AKC",
      "iata": "AKC",
      "icao": "KAKR",
      "faa": "",
      "name": "Akron Fulton International Airport",
      "city": "Akron",
      "cityCode": "CAK",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.035899,
      "longitude": -81.468098,
      "elevationFeet": 1042,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKC?codeType=fs"
     },
     {
      "fs": "AKI",
      "iata": "AKI",
      "icao": "",
      "faa": "AKI",
      "name": "Akiak Airport",
      "city": "Akiak",
      "cityCode": "AKI",
      "stateCode": "AK",
      "postalCode": "99552",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 60.905556,
      "longitude": -161.223333,
      "elevationFeet": 22,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKI?codeType=fs"
     },
     {
      "fs": "AKK",
      "iata": "AKK",
      "icao": "",
      "faa": "AKK",
      "name": "Akhiok Sea Plane Base",
      "city": "Akhiok",
      "cityCode": "AKK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 56.944444,
      "longitude": -154.166667,
      "elevationFeet": 44,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKK?codeType=fs"
     },
     {
      "fs": "AKN",
      "iata": "AKN",
      "icao": "PAKN",
      "faa": "PAKN",
      "name": "King Salmon Airport",
      "city": "King Salmon",
      "cityCode": "AKN",
      "stateCode": "AK",
      "postalCode": "99613",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 58.682741,
      "longitude": -156.669016,
      "elevationFeet": 57,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKN?codeType=fs"
     },
     {
      "fs": "AKP",
      "iata": "AKP",
      "icao": "PAKP",
      "faa": "PAKP",
      "name": "Anaktuvuk Airport",
      "city": "Anaktuvuk",
      "cityCode": "AKP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ206",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 68.1375,
      "longitude": -151.74,
      "elevationFeet": 2107,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKP?codeType=fs"
     },
     {
      "fs": "ALE",
      "iata": "ALE",
      "icao": "",
      "faa": "E38",
      "name": "Alpine-Casparis Municipal Airport",
      "city": "Alpine",
      "cityCode": "ALE",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.3871,
      "longitude": -103.680778,
      "elevationFeet": 4466,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALE?codeType=fs"
     },
     {
      "fs": "ALI",
      "iata": "ALI",
      "icao": "KALI",
      "faa": "ALI",
      "name": "Alice International Airport",
      "city": "Alice",
      "cityCode": "ALI",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 27.7409,
      "longitude": -98.026901,
      "elevationFeet": 173,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALI?codeType=fs"
     },
     {
      "fs": "ALM",
      "iata": "ALM",
      "icao": "KALM",
      "faa": "ALM",
      "name": "Alamogordo Municipal Airport",
      "city": "Alamogordo",
      "cityCode": "ALM",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ024",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 32.845833,
      "longitude": -105.985278,
      "elevationFeet": 4200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALM?codeType=fs"
     },
     {
      "fs": "ALN",
      "iata": "ALN",
      "icao": "KALN",
      "faa": "ALN",
      "name": "St. Louis Regional Airport",
      "city": "Alton",
      "cityCode": "ALN",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 38.891667,
      "longitude": -90.048333,
      "elevationFeet": 544,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALN?codeType=fs"
     },
     {
      "fs": "ALO",
      "iata": "ALO",
      "icao": "KALO",
      "faa": "ALO",
      "name": "Waterloo Airport",
      "street1": "2790 Airport Boulevard",
      "street2": "",
      "city": "Waterloo",
      "cityCode": "ALO",
      "stateCode": "IA",
      "postalCode": "50704",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ039",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 42.556111,
      "longitude": -92.399722,
      "elevationFeet": 873,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALO?codeType=fs"
     },
     {
      "fs": "ALS",
      "iata": "ALS",
      "icao": "KALS",
      "faa": "ALS",
      "name": "Alamosa Municipal Airport",
      "street1": "",
      "street2": "",
      "city": "Alamosa",
      "cityCode": "ALS",
      "stateCode": "CO",
      "postalCode": "81101",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ063",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 37.436667,
      "longitude": -105.866667,
      "elevationFeet": 7539,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALS?codeType=fs"
     },
     {
      "fs": "ALW",
      "iata": "ALW",
      "icao": "KALW",
      "faa": "ALW",
      "name": "Walla Walla Airport",
      "city": "Walla Walla",
      "cityCode": "ALW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ029",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 46.094722,
      "longitude": -118.291111,
      "elevationFeet": 1205,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALW?codeType=fs"
     },
     {
      "fs": "ALZ",
      "iata": "ALZ",
      "icao": "",
      "faa": "",
      "name": "Alitak Sea Plane Base",
      "city": "Alitak",
      "cityCode": "ALZ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 56.897686,
      "longitude": -154.248486,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALZ?codeType=fs"
     },
     {
      "fs": "AMK",
      "iata": "AMK",
      "icao": "",
      "faa": "00C",
      "name": "Animas Air Park",
      "city": "Durango",
      "cityCode": "DRO",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 37.203201,
      "longitude": -107.869003,
      "elevationFeet": 6658,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AMK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AMK?codeType=fs"
     },
     {
      "fs": "ANB",
      "iata": "ANB",
      "icao": "KANB",
      "faa": "ANB",
      "name": "Anniston Regional Airport",
      "city": "Anniston",
      "cityCode": "ANB",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 33.588193,
      "longitude": -85.8581,
      "elevationFeet": 595,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANB?codeType=fs"
     },
     {
      "fs": "AND",
      "iata": "AND",
      "icao": "KAND",
      "faa": "AND",
      "name": "Anderson Airport",
      "city": "Anderson",
      "cityCode": "AND",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 34.493611,
      "longitude": -82.71,
      "elevationFeet": 782,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AND?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AND?codeType=fs"
     },
     {
      "fs": "ANI",
      "iata": "ANI",
      "icao": "PANI",
      "faa": "PANI",
      "name": "Aniak Airport",
      "city": "Aniak",
      "cityCode": "ANI",
      "stateCode": "AK",
      "postalCode": "99557",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 61.574399,
      "longitude": -159.536971,
      "elevationFeet": 88,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANI?codeType=fs"
     },
     {
      "fs": "ANV",
      "iata": "ANV",
      "icao": "PANV",
      "faa": "PANV",
      "name": "Anvik Airport",
      "city": "Anvik",
      "cityCode": "ANV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ215",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 62.647778,
      "longitude": -160.188889,
      "elevationFeet": 309,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANV?codeType=fs"
     },
     {
      "fs": "AOO",
      "iata": "AOO",
      "icao": "KAOO",
      "faa": "AOO",
      "name": "Altoona Airport",
      "street1": "2 Airport Drive",
      "street2": "",
      "city": "Altoona",
      "cityCode": "AOO",
      "stateCode": "PA",
      "postalCode": "16662",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ025",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.297222,
      "longitude": -78.32,
      "elevationFeet": 1504,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AOO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AOO?codeType=fs"
     },
     {
      "fs": "AOS",
      "iata": "AOS",
      "icao": "",
      "faa": "",
      "name": "Amook Bay Seaplane Base",
      "city": "Amook",
      "cityCode": "AOS",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 57.470987,
      "longitude": -153.815706,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AOS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AOS?codeType=fs"
     },
     {
      "fs": "APC",
      "iata": "APC",
      "icao": "KAPC",
      "faa": "APC",
      "name": "Napa County Airport",
      "city": "Napa",
      "cityCode": "APC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 38.212222,
      "longitude": -122.28,
      "elevationFeet": 33,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APC?codeType=fs"
     },
     {
      "fs": "APF",
      "iata": "APF",
      "icao": "KAPF",
      "faa": "APF",
      "name": "Naples Municipal Airport",
      "street1": "160 Aviation Drive North",
      "city": "Naples",
      "cityCode": "APF",
      "stateCode": "FL",
      "postalCode": "34104-3568",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ069",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 26.152778,
      "longitude": -81.775278,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APF?codeType=fs"
     },
     {
      "fs": "APN",
      "iata": "APN",
      "icao": "KAPN",
      "faa": "APN",
      "name": "Alpena County Regional Airport",
      "street1": "Airport Road, Route 6",
      "street2": "",
      "city": "Alpena",
      "cityCode": "APN",
      "stateCode": "MI",
      "postalCode": "49707",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ024",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 45.081667,
      "longitude": -83.555833,
      "elevationFeet": 689,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APN?codeType=fs"
     },
     {
      "fs": "ARA",
      "iata": "ARA",
      "icao": "KARA",
      "faa": "ARA",
      "name": "Acadiana Regional Airport",
      "city": "New Iberia",
      "cityCode": "ARA",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.037778,
      "longitude": -91.883889,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ARA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ARA?codeType=fs"
     },
     {
      "fs": "ARB",
      "iata": "ARB",
      "icao": "KARB",
      "faa": "ARB",
      "name": "Ann Arbor Municipal Airport",
      "city": "Ann Arbor",
      "cityCode": "ARB",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.224912,
      "longitude": -83.74559,
      "elevationFeet": 834,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ARB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ARB?codeType=fs"
     },
     {
      "fs": "ARC",
      "iata": "ARC",
      "icao": "PARC",
      "faa": "PARC",
      "name": "Arctic Village Airport",
      "city": "Arctic Village",
      "cityCode": "ARC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ218",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 68.1375,
      "longitude": -145.524444,
      "elevationFeet": 2086,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ARC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ARC?codeType=fs"
     },
     {
      "fs": "ART",
      "iata": "ART",
      "icao": "KART",
      "faa": "ART",
      "name": "Watertown Airport",
      "city": "Watertown",
      "cityCode": "ART",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ007",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 43.990833,
      "longitude": -76.021389,
      "elevationFeet": 325,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ART?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ART?codeType=fs"
     },
     {
      "fs": "ARV",
      "iata": "ARV",
      "icao": "KARV",
      "faa": "ARV",
      "name": "Noble F. Lee Airport",
      "city": "Minocqua",
      "cityCode": "ARV",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 45.924167,
      "longitude": -89.732222,
      "elevationFeet": 1630,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ARV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ARV?codeType=fs"
     },
     {
      "fs": "ASE",
      "iata": "ASE",
      "icao": "KASE",
      "faa": "ASE",
      "name": "Aspen Airport",
      "street1": "233 East Airport Road",
      "city": "Aspen",
      "cityCode": "ASE",
      "stateCode": "CO",
      "postalCode": "81611",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ010",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 39.219685,
      "longitude": -106.864688,
      "elevationFeet": 7820,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASE?codeType=fs"
     },
     {
      "fs": "ASH",
      "iata": "ASH",
      "icao": "KASH",
      "faa": "ASH",
      "name": "Boire Field",
      "city": "Nashua",
      "cityCode": "ASH",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.7817,
      "longitude": -71.514801,
      "elevationFeet": 188,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASH?codeType=fs"
     },
     {
      "fs": "ASN",
      "iata": "ASN",
      "icao": "KASN",
      "faa": "ASN",
      "name": "Talladega Municipal Airport",
      "city": "Talladega",
      "cityCode": "ASN",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 33.571351,
      "longitude": -86.05219,
      "elevationFeet": 504,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASN?codeType=fs"
     },
     {
      "fs": "AST",
      "iata": "AST",
      "icao": "KAST",
      "faa": "AST",
      "name": "Astoria Regional Airport",
      "city": "Astoria",
      "cityCode": "AST",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 46.159722,
      "longitude": -123.88,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AST?codeType=fs"
     },
     {
      "fs": "ATK",
      "iata": "ATK",
      "icao": "PATQ",
      "faa": "ATK",
      "name": "Atqasuk Airport",
      "city": "Atqasuk",
      "cityCode": "ATK",
      "stateCode": "AK",
      "postalCode": "99791",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ201",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 70.5,
      "longitude": -157.333333,
      "elevationFeet": 96,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATK?codeType=fs"
     },
     {
      "fs": "ATT",
      "iata": "ATT",
      "icao": "",
      "faa": "4A2",
      "name": "Atmautluak Airport",
      "city": "Atmautluak",
      "cityCode": "ATT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 60.866594,
      "longitude": -162.273678,
      "elevationFeet": 17,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATT?codeType=fs"
     },
     {
      "fs": "ATW",
      "iata": "ATW",
      "icao": "KATW",
      "faa": "ATW",
      "name": "Appleton International Airport",
      "street1": "West 6390, Challenger Drive, Suite 201",
      "city": "Appleton",
      "cityCode": "ATW",
      "stateCode": "WI",
      "postalCode": "54915",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 44.26011,
      "longitude": -88.509943,
      "elevationFeet": 918,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATW?codeType=fs"
     },
     {
      "fs": "ATY",
      "iata": "ATY",
      "icao": "KATY",
      "faa": "ATY",
      "name": "Watertown Airport",
      "street1": "",
      "street2": "",
      "city": "Watertown",
      "cityCode": "ATY",
      "stateCode": "SD",
      "postalCode": "57201",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "SDZ020",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 44.908889,
      "longitude": -97.154167,
      "elevationFeet": 1748,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATY?codeType=fs"
     },
     {
      "fs": "AUG",
      "iata": "AUG",
      "icao": "KAUG",
      "faa": "AUG",
      "name": "Augusta Airport",
      "city": "Augusta",
      "cityCode": "AUG",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ021",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 44.318056,
      "longitude": -69.796667,
      "elevationFeet": 352,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUG?codeType=fs"
     },
     {
      "fs": "AUK",
      "iata": "AUK",
      "icao": "",
      "faa": "AUK",
      "name": "Alakanuk Airport",
      "city": "Alakanuk",
      "cityCode": "AUK",
      "stateCode": "AK",
      "postalCode": "99554",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 62.689167,
      "longitude": -164.610833,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUK?codeType=fs"
     },
     {
      "fs": "AUO",
      "iata": "AUO",
      "icao": "KAUO",
      "faa": "AUO",
      "name": "Auburn University Regional Airport",
      "city": "Auburn",
      "cityCode": "AUO",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 32.615046,
      "longitude": -85.433875,
      "elevationFeet": 752,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUO?codeType=fs"
     },
     {
      "fs": "AUZ",
      "iata": "AUZ",
      "icao": "KARR",
      "faa": "ARR",
      "name": "Aurora Municipal Airport",
      "city": "Aurora",
      "cityCode": "AUZ",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 41.770365,
      "longitude": -88.471194,
      "elevationFeet": 701,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUZ?codeType=fs"
     },
     {
      "fs": "AVP",
      "iata": "AVP",
      "icao": "KAVP",
      "faa": "AVP",
      "name": "Wilkes-Barre/Scranton International Airport",
      "street1": "100 Terminal Road",
      "city": "Wilkes-Barre",
      "cityCode": "AVP",
      "stateCode": "PA",
      "postalCode": "18641",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ047",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.336698,
      "longitude": -75.730643,
      "elevationFeet": 962,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AVP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AVP?codeType=fs"
     },
     {
      "fs": "AVW",
      "iata": "AVW",
      "icao": "KAVQ",
      "faa": "AVQ",
      "name": "Marana Regional Airport",
      "city": "Tucson",
      "cityCode": "TUS",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 32.407605,
      "longitude": -111.215615,
      "elevationFeet": 2028,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AVW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AVW?codeType=fs"
     },
     {
      "fs": "AVX",
      "iata": "AVX",
      "icao": "KAVX",
      "faa": "AVX",
      "name": "Catalina Airport",
      "city": "Avalon",
      "cityCode": "AVX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.4049,
      "longitude": -118.416,
      "elevationFeet": 1587,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AVX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AVX?codeType=fs"
     },
     {
      "fs": "AWM",
      "iata": "AWM",
      "icao": "KAWM",
      "faa": "AWM",
      "name": "West Memphis Municipal Airport",
      "city": "West Memphis",
      "cityCode": "AWM",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 35.137882,
      "longitude": -90.231974,
      "elevationFeet": 213,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AWM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AWM?codeType=fs"
     },
     {
      "fs": "AXN",
      "iata": "AXN",
      "icao": "KAXN",
      "faa": "AXN",
      "name": "Chandler Field",
      "city": "Alexandria",
      "cityCode": "AXN",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 45.867222,
      "longitude": -95.394167,
      "elevationFeet": 1424,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AXN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AXN?codeType=fs"
     },
     {
      "fs": "AXX",
      "iata": "AXX",
      "icao": "KAXX",
      "faa": "AXX",
      "name": "Angel Fire Airport",
      "city": "Angel Fire",
      "cityCode": "AXX",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 36.419646,
      "longitude": -105.290381,
      "elevationFeet": 8376,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AXX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AXX?codeType=fs"
     },
     {
      "fs": "AZA",
      "iata": "AZA",
      "icao": "KIWA",
      "faa": "IWA",
      "name": "Phoenix-Mesa Gateway Airport",
      "street1": "6033 S. Sossaman Rd.",
      "city": "Mesa",
      "cityCode": "PHX",
      "stateCode": "AZ",
      "postalCode": "85212",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 33.307778,
      "longitude": -111.655556,
      "elevationFeet": 1382,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AZA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AZA?codeType=fs"
     },
     {
      "fs": "AZO",
      "iata": "AZO",
      "icao": "KAZO",
      "faa": "AZO",
      "name": "Kalamazoo/Battle Creek International Airport",
      "street1": "5235 Portage Road",
      "city": "Kalamazoo",
      "cityCode": "AZO",
      "stateCode": "MI",
      "postalCode": "49002",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.239962,
      "longitude": -85.556553,
      "elevationFeet": 874,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AZO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AZO?codeType=fs"
     },
     {
      "fs": "BAD",
      "iata": "BAD",
      "icao": "KBAD",
      "faa": "BAD",
      "name": "Barksdale Air Force Base",
      "city": "Shreveport",
      "cityCode": "SHV",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 32.5,
      "longitude": -93.666667,
      "elevationFeet": 166,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BAD?codeType=fs"
     },
     {
      "fs": "BAF",
      "iata": "BAF",
      "icao": "KBAF",
      "faa": "BAF",
      "name": "Westfield-Barnes Regional Airport",
      "city": "Springfield",
      "cityCode": "BAF",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.157954,
      "longitude": -72.715624,
      "elevationFeet": 259,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BAF?codeType=fs"
     },
     {
      "fs": "BBW",
      "iata": "BBW",
      "icao": "KBBW",
      "faa": "BBW",
      "name": "Broken Bow Municipal Airport",
      "city": "Broken Bow",
      "cityCode": "BBW",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 41.431867,
      "longitude": -99.638354,
      "elevationFeet": 2526,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BBW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BBW?codeType=fs"
     },
     {
      "fs": "BBX",
      "iata": "BBX",
      "icao": "KLOM",
      "faa": "LOM",
      "name": "Wings Field",
      "city": "Blue Bell",
      "cityCode": "BBX",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.136667,
      "longitude": -75.2675,
      "elevationFeet": 288,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BBX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BBX?codeType=fs"
     },
     {
      "fs": "BCT",
      "iata": "BCT",
      "icao": "KBCT",
      "faa": "BCT",
      "name": "Boca Raton Airport",
      "city": "Boca Raton",
      "cityCode": "BCT",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 26.379022,
      "longitude": -80.107981,
      "elevationFeet": 9,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BCT?codeType=fs"
     },
     {
      "fs": "BDR",
      "iata": "BDR",
      "icao": "KBDR",
      "faa": "BDR",
      "name": "Igor I. Sikorsky Memorial Airport",
      "street1": "1000 Great Meadow Road",
      "street2": "",
      "city": "Bridgeport",
      "cityCode": "BDR",
      "stateCode": "CT",
      "postalCode": "06497",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "CTZ009",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.164167,
      "longitude": -73.124444,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDR?codeType=fs"
     },
     {
      "fs": "BED",
      "iata": "BED",
      "icao": "KBED",
      "faa": "BED",
      "name": "Laurence G. Hanscom Field",
      "city": "Bedford/Hanscom",
      "cityCode": "BED",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ005",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.470833,
      "longitude": -71.29,
      "elevationFeet": 133,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BED?codeType=fs"
     },
     {
      "fs": "BEH",
      "iata": "BEH",
      "icao": "KBEH",
      "faa": "BEH",
      "name": "Southwest Michigan Regional Airport",
      "city": "Benton Harbor",
      "cityCode": "BEH",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.127778,
      "longitude": -86.428333,
      "elevationFeet": 643,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BEH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BEH?codeType=fs"
     },
     {
      "fs": "BFD",
      "iata": "BFD",
      "icao": "KBFD",
      "faa": "BFD",
      "name": "Bradford Airport",
      "street1": "Star Route",
      "street2": "",
      "city": "Bradford",
      "cityCode": "BFD",
      "stateCode": "PA",
      "postalCode": "16738",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ005",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.802222,
      "longitude": -78.639444,
      "elevationFeet": 2143,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFD?codeType=fs"
     },
     {
      "fs": "BFF",
      "iata": "BFF",
      "icao": "KBFF",
      "faa": "BFF",
      "name": "Western Nebraska Regional Airport",
      "city": "Scottsbluff",
      "cityCode": "BFF",
      "stateCode": "NE",
      "postalCode": "69341-0690",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NEZ019",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 41.873989,
      "longitude": -103.595968,
      "elevationFeet": 3956,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFF?codeType=fs"
     },
     {
      "fs": "BFL",
      "iata": "BFL",
      "icao": "KBFL",
      "faa": "BFL",
      "name": "Meadows Field Airport",
      "street1": "3701 Wings Way",
      "city": "Bakersfield",
      "cityCode": "BFL",
      "stateCode": "CA",
      "postalCode": "93308",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ095",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 35.437466,
      "longitude": -119.055263,
      "elevationFeet": 507,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFL?codeType=fs"
     },
     {
      "fs": "BFM",
      "iata": "BFM",
      "icao": "KBFM",
      "faa": "BFM",
      "name": "Mobile Downtown Airport",
      "city": "Mobile",
      "cityCode": "MOB",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ063",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.636651,
      "longitude": -88.075247,
      "elevationFeet": 23,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFM?codeType=fs"
     },
     {
      "fs": "BFT",
      "iata": "BFT",
      "icao": "KARW",
      "faa": "ARW",
      "name": "Beaufort County Airport",
      "city": "Beaufort",
      "cityCode": "BFT",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 32.410833,
      "longitude": -80.635,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFT?codeType=fs"
     },
     {
      "fs": "BGM",
      "iata": "BGM",
      "icao": "KBGM",
      "faa": "BGM",
      "name": "Greater Binghamton Airport",
      "street1": "2534 Airport Road",
      "city": "Binghamton",
      "cityCode": "BGM",
      "stateCode": "NY",
      "postalCode": "13790",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ056",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.208533,
      "longitude": -75.982944,
      "elevationFeet": 1636,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGM?codeType=fs"
     },
     {
      "fs": "BGR",
      "iata": "BGR",
      "icao": "KBGR",
      "faa": "BGR",
      "name": "Bangor International Airport",
      "street1": "287 Godfry Boulevard",
      "city": "Bangor",
      "cityCode": "BGR",
      "stateCode": "ME",
      "postalCode": "04401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ015",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 44.808699,
      "longitude": -68.817799,
      "elevationFeet": 192,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGR?codeType=fs"
     },
     {
      "fs": "BGT",
      "iata": "BGT",
      "icao": "",
      "faa": "E51",
      "name": "Bagdad Airport",
      "city": "Bagdad",
      "cityCode": "BGT",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 34.59398,
      "longitude": -113.168702,
      "elevationFeet": 4197,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGT?codeType=fs"
     },
     {
      "fs": "BHB",
      "iata": "BHB",
      "icao": "KBHB",
      "faa": "BHB",
      "name": "Bar Harbor Airport",
      "street1": "",
      "street2": "",
      "city": "Bar Harbor",
      "cityCode": "BHB",
      "stateCode": "ME",
      "postalCode": "04605",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ029",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 44.448889,
      "longitude": -68.361667,
      "elevationFeet": 83,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BHB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BHB?codeType=fs"
     },
     {
      "fs": "BIC",
      "icao": "",
      "faa": "",
      "name": "Big Creek Airport",
      "city": "Big Creek",
      "cityCode": "BIC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 58.3,
      "longitude": -157.516667,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIC?codeType=fs"
     },
     {
      "fs": "BID",
      "iata": "BID",
      "icao": "KBID",
      "faa": "BID",
      "name": "Block Island Airport",
      "city": "Block Island",
      "cityCode": "BID",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "RIZ006",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.169432,
      "longitude": -71.579613,
      "elevationFeet": 109,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BID?codeType=fs"
     },
     {
      "fs": "BIE",
      "iata": "BIE",
      "icao": "KBIE",
      "faa": "BIE",
      "name": "Beatrice Municipal Airport",
      "city": "Beatrice",
      "cityCode": "BIE",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 40.3,
      "longitude": -96.75,
      "elevationFeet": 1324,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIE?codeType=fs"
     },
     {
      "fs": "BIF",
      "iata": "BIF",
      "icao": "KBIF",
      "faa": "BIF",
      "name": "Biggs Army Air Field",
      "city": "El Paso",
      "cityCode": "ELP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 31.854273,
      "longitude": -106.375514,
      "elevationFeet": 3936,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIF?codeType=fs"
     },
     {
      "fs": "BIH",
      "iata": "BIH",
      "icao": "KBIH",
      "faa": "BIH",
      "name": "Eastern Sierra Regional Airport",
      "city": "Bishop",
      "cityCode": "BIH",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 37.373333,
      "longitude": -118.365,
      "elevationFeet": 4120,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIH?codeType=fs"
     },
     {
      "fs": "BIS",
      "iata": "BIS",
      "icao": "KBIS",
      "faa": "BIS",
      "name": "Bismarck Airport",
      "street1": "2301 University Drive Bldg 17",
      "street2": "",
      "city": "Bismarck",
      "cityCode": "BIS",
      "stateCode": "ND",
      "postalCode": "58504",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ035",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 46.77448,
      "longitude": -100.758211,
      "elevationFeet": 1661,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIS?codeType=fs"
     },
     {
      "fs": "BJC",
      "iata": "BJC",
      "icao": "KBJC",
      "faa": "BJC",
      "name": "Rocky Mountain Metropolitan Airport",
      "city": "Broomfield",
      "cityCode": "BJC",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 39.910441,
      "longitude": -105.117236,
      "elevationFeet": 5631,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BJC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BJC?codeType=fs"
     },
     {
      "fs": "BJI",
      "iata": "BJI",
      "icao": "KBJI",
      "faa": "BJI",
      "name": "Bemidji Airport",
      "street1": "",
      "street2": "",
      "city": "Bemidji",
      "cityCode": "BJI",
      "stateCode": "MN",
      "postalCode": "56601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ017",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 47.509722,
      "longitude": -94.934722,
      "elevationFeet": 1390,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BJI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BJI?codeType=fs"
     },
     {
      "fs": "BKC",
      "iata": "BKC",
      "icao": "PABL",
      "faa": "BVK",
      "name": "Buckland Airport",
      "city": "Buckland",
      "cityCode": "BKC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ210",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 65.978889,
      "longitude": -161.126667,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKC?codeType=fs"
     },
     {
      "fs": "BKE",
      "iata": "BKE",
      "icao": "KBKE",
      "faa": "BKE",
      "name": "Baker Airport",
      "city": "Baker",
      "cityCode": "BKE",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 44.838333,
      "longitude": -117.81,
      "elevationFeet": 3373,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKE?codeType=fs"
     },
     {
      "fs": "BKG",
      "iata": "BKG",
      "icao": "KBBG",
      "faa": "BBG",
      "name": "Branson Airport",
      "street1": "4000 Branson Airport Boulevard",
      "city": "Hollister",
      "stateCode": "MO",
      "postalCode": "65672",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ104",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 36.532082,
      "longitude": -93.200544,
      "elevationFeet": 1255,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKG?codeType=fs"
     },
     {
      "fs": "BKW",
      "iata": "BKW",
      "icao": "KBKW",
      "faa": "BKW",
      "name": "Raleigh County Memorial Airport",
      "city": "Beckley",
      "cityCode": "BKW",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ035",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 37.781944,
      "longitude": -81.124167,
      "elevationFeet": 2504,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKW?codeType=fs"
     },
     {
      "fs": "BLD",
      "iata": "BLD",
      "icao": "",
      "faa": "61B",
      "name": "Boulder City Municipal Airport",
      "city": "Boulder City",
      "cityCode": "BLD",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 35.946778,
      "longitude": -114.856374,
      "elevationFeet": 2150,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLD?codeType=fs"
     },
     {
      "fs": "BLH",
      "iata": "BLH",
      "icao": "KBLH",
      "faa": "BLH",
      "name": "Blythe Airport",
      "city": "Blythe",
      "cityCode": "BLH",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.620833,
      "longitude": -114.718889,
      "elevationFeet": 397,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLH?codeType=fs"
     },
     {
      "fs": "BLI",
      "iata": "BLI",
      "icao": "KBLI",
      "faa": "BLI",
      "name": "Bellingham International Airport",
      "street1": "4255 Mitchell Way",
      "city": "Bellingham",
      "cityCode": "BLI",
      "stateCode": "WA",
      "postalCode": "98226",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 48.795733,
      "longitude": -122.532672,
      "elevationFeet": 170,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLI?codeType=fs"
     },
     {
      "fs": "BLM",
      "iata": "BLM",
      "icao": "KBLM",
      "faa": "BLM",
      "name": "Monmouth Executive Airport",
      "city": "Belmar",
      "cityCode": "BLM",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.184548,
      "longitude": -74.122223,
      "elevationFeet": 154,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLM?codeType=fs"
     },
     {
      "fs": "BLV",
      "iata": "BLV",
      "icao": "KBLV",
      "faa": "BLV",
      "name": "MidAmerica St. Louis Airport / Scott AFB",
      "city": "Belleville",
      "cityCode": "BLV",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 38.547326,
      "longitude": -89.815909,
      "elevationFeet": 453,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLV?codeType=fs"
     },
     {
      "fs": "BMG",
      "iata": "BMG",
      "icao": "KBMG",
      "faa": "BMG",
      "name": "Monroe County Airport",
      "city": "Bloomington",
      "cityCode": "BMG",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.14,
      "longitude": -86.614722,
      "elevationFeet": 846,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BMG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BMG?codeType=fs"
     },
     {
      "fs": "BMI",
      "iata": "BMI",
      "icao": "KBMI",
      "faa": "BMI",
      "name": "Central Illinois Regional Airport",
      "street1": "3201 Cira Dr",
      "city": "Bloomington",
      "cityCode": "BMI",
      "stateCode": "IL",
      "postalCode": "61704",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ038",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 40.48401,
      "longitude": -88.914834,
      "elevationFeet": 871,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BMI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BMI?codeType=fs"
     },
     {
      "fs": "BMT",
      "iata": "BMT",
      "icao": "KBMT",
      "faa": "BMT",
      "name": "Beaumont Municipal Airport",
      "city": "Beaumont",
      "cityCode": "BPT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.0707,
      "longitude": -94.215797,
      "elevationFeet": 30,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BMT?codeType=fs"
     },
     {
      "fs": "BNO",
      "iata": "BNO",
      "icao": "KBNO",
      "faa": "BNO",
      "name": "Burns Municipal Airport",
      "city": "Burns",
      "cityCode": "BNO",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 43.590557,
      "longitude": -118.955192,
      "elevationFeet": 4150,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNO?codeType=fs"
     },
     {
      "fs": "BPT",
      "iata": "BPT",
      "icao": "KBPT",
      "faa": "BPT",
      "name": "Jefferson County Airport",
      "street1": "",
      "street2": "",
      "city": "Beaumont",
      "cityCode": "BPT",
      "stateCode": "TX",
      "postalCode": "77704-3827",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ215",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 29.950833,
      "longitude": -94.02,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BPT?codeType=fs"
     },
     {
      "fs": "BQK",
      "iata": "BQK",
      "icao": "KBQK",
      "faa": "BQK",
      "name": "Glynco Jetport",
      "city": "Brunswick",
      "cityCode": "SSI",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ154",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 31.166667,
      "longitude": -81.483333,
      "elevationFeet": 26,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BQK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BQK?codeType=fs"
     },
     {
      "fs": "BRD",
      "iata": "BRD",
      "icao": "KBRD",
      "faa": "BRD",
      "name": "Crow Wing County Airport",
      "street1": "2375 Airport Road Northeast",
      "street2": "",
      "city": "Brainerd",
      "cityCode": "BRD",
      "stateCode": "MN",
      "postalCode": "56401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ034",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 46.397222,
      "longitude": -94.1375,
      "elevationFeet": 1226,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BRD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BRD?codeType=fs"
     },
     {
      "fs": "BRL",
      "iata": "BRL",
      "icao": "KBRL",
      "faa": "BRL",
      "name": "Burlington Airport",
      "street1": "2501 Summer Street",
      "street2": "",
      "city": "Burlington",
      "cityCode": "BRL",
      "stateCode": "IA",
      "postalCode": "52601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ089",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 40.786111,
      "longitude": -91.123333,
      "elevationFeet": 698,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BRL?codeType=fs"
     },
     {
      "fs": "BRO",
      "iata": "BRO",
      "icao": "KBRO",
      "faa": "BRO",
      "name": "South Padre Island International Airport",
      "street1": "700 South Minnesota Avenue",
      "street2": "",
      "city": "Brownsville",
      "cityCode": "BRO",
      "stateCode": "TX",
      "postalCode": "78521-5721",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ255",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 25.908889,
      "longitude": -97.423333,
      "elevationFeet": 22,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BRO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BRO?codeType=fs"
     },
     {
      "fs": "BRW",
      "iata": "BRW",
      "icao": "PABR",
      "faa": "PABR",
      "name": "Wiley Post-Will Rogers Memorial Airport",
      "city": "Barrow",
      "cityCode": "BRW",
      "stateCode": "AK",
      "postalCode": "99723",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ202",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 71.287223,
      "longitude": -156.770252,
      "elevationFeet": 13,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BRW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BRW?codeType=fs"
     },
     {
      "fs": "BSZ",
      "iata": "BSZ",
      "icao": "",
      "faa": "",
      "name": "Bartletts Airport",
      "city": "Bartletts",
      "cityCode": "BSZ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 58.233611,
      "longitude": -157.350278,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BSZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BSZ?codeType=fs"
     },
     {
      "fs": "BTI",
      "iata": "BTI",
      "icao": "PABA",
      "faa": "PABA",
      "name": "Barter Island Airport",
      "city": "Barter Island",
      "cityCode": "BTI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 70.134722,
      "longitude": -143.578333,
      "elevationFeet": 5,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTI?codeType=fs"
     },
     {
      "fs": "BTL",
      "iata": "BTL",
      "icao": "KBTL",
      "faa": "BTL",
      "name": "WK Kellogg Regional Airport",
      "city": "Battle Creek",
      "cityCode": "BTL",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ073",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.305036,
      "longitude": -85.252674,
      "elevationFeet": 928,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTL?codeType=fs"
     },
     {
      "fs": "BTM",
      "iata": "BTM",
      "icao": "KBTM",
      "faa": "BTM",
      "name": "Butte Airport",
      "street1": "101 Airport Road",
      "street2": "",
      "city": "Butte",
      "cityCode": "BTM",
      "stateCode": "MT",
      "postalCode": "59701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ007",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 45.951111,
      "longitude": -112.493889,
      "elevationFeet": 5545,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTM?codeType=fs"
     },
     {
      "fs": "BTT",
      "iata": "BTT",
      "icao": "PABT",
      "faa": "PABT",
      "name": "Bettles Airport",
      "city": "Bettles",
      "cityCode": "BTT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ219",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 66.915278,
      "longitude": -151.526389,
      "elevationFeet": 643,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTT?codeType=fs"
     },
     {
      "fs": "BUB",
      "iata": "BUB",
      "icao": "KBUB",
      "faa": "BUB",
      "name": "Cram Field",
      "city": "Burwell",
      "cityCode": "BUB",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 41.775599,
      "longitude": -99.147158,
      "elevationFeet": 2182,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BUB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BUB?codeType=fs"
     },
     {
      "fs": "BVO",
      "iata": "BVO",
      "icao": "KBVO",
      "faa": "BVO",
      "name": "Bartlesville Municipal Airport",
      "city": "Bartlesville",
      "cityCode": "BVO",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 36.7625,
      "longitude": -96.010833,
      "elevationFeet": 713,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BVO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BVO?codeType=fs"
     },
     {
      "fs": "BVY",
      "iata": "BVY",
      "icao": "KBVY",
      "faa": "BVY",
      "name": "Beverly Municipal Airport",
      "city": "Beverly",
      "cityCode": "BVY",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.585167,
      "longitude": -70.915335,
      "elevationFeet": 96,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BVY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BVY?codeType=fs"
     },
     {
      "fs": "BWD",
      "iata": "BWD",
      "icao": "KBWD",
      "faa": "BWD",
      "name": "Brownwood Regional Airport",
      "city": "Brownwood",
      "cityCode": "BWD",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ140",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 31.794722,
      "longitude": -98.956667,
      "elevationFeet": 1387,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWD?codeType=fs"
     },
     {
      "fs": "BWG",
      "iata": "BWG",
      "icao": "KBWG",
      "faa": "BWG",
      "name": "Warren County Airport",
      "city": "Bowling Green",
      "cityCode": "BWG",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 36.962222,
      "longitude": -86.422222,
      "elevationFeet": 547,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWG?codeType=fs"
     },
     {
      "fs": "BYI",
      "iata": "BYI",
      "icao": "KBYI",
      "faa": "BYI",
      "name": "Burley Municipal Airport",
      "city": "Burley",
      "cityCode": "BYI",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 42.541389,
      "longitude": -113.774167,
      "elevationFeet": 4150,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BYI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BYI?codeType=fs"
     },
     {
      "fs": "BZN",
      "iata": "BZN",
      "icao": "KBZN",
      "faa": "BZN",
      "name": "Bozeman Yellowstone International Airport",
      "street1": "850 Gallatin Field Rd",
      "city": "Belgrade",
      "cityCode": "BZN",
      "stateCode": "MT",
      "postalCode": "59714",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ055",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 45.777687,
      "longitude": -111.160334,
      "elevationFeet": 4474,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BZN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BZN?codeType=fs"
     },
     {
      "fs": "C29",
      "iata": "",
      "icao": "",
      "faa": "C29",
      "name": "Middleton Municipal Airport",
      "city": "Middleton",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 43.112736,
      "longitude": -89.532238,
      "elevationFeet": 924,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C29?codeType=fs"
     },
     {
      "fs": "CAD",
      "iata": "CAD",
      "icao": "KCAD",
      "faa": "CAD",
      "name": "Wexford County Airport",
      "city": "Cadillac",
      "cityCode": "CAD",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 44.275833,
      "longitude": -85.422222,
      "elevationFeet": 1307,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CAD?codeType=fs"
     },
     {
      "fs": "CAO",
      "iata": "CAO",
      "icao": "KCAO",
      "faa": "CAO",
      "name": "Clayton Municipal Airpark",
      "city": "Clayton",
      "cityCode": "CAO",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 36.446061,
      "longitude": -103.153654,
      "elevationFeet": 4974,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CAO?codeType=fs"
     },
     {
      "fs": "CBE",
      "iata": "CBE",
      "icao": "KCBE",
      "faa": "CBE",
      "name": "Wiley Ford Airport",
      "street1": "Route 1",
      "street2": "",
      "city": "Cumberland",
      "cityCode": "CBE",
      "stateCode": "MD",
      "postalCode": "26767",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ049",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.614444,
      "longitude": -78.766111,
      "elevationFeet": 775,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CBE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CBE?codeType=fs"
     },
     {
      "fs": "CBK",
      "iata": "CBK",
      "icao": "KCBK",
      "faa": "CBK",
      "name": "Colby Municipal Airport",
      "city": "Colby",
      "cityCode": "CBK",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 39.426141,
      "longitude": -101.050303,
      "elevationFeet": 3170,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CBK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CBK?codeType=fs"
     },
     {
      "fs": "CCB",
      "iata": "CCB",
      "icao": "KCCB",
      "faa": "CCB",
      "name": "Cable Airport",
      "city": "Upland",
      "cityCode": "CCB",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 34.111563,
      "longitude": -117.687638,
      "elevationFeet": 1413,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CCB?codeType=fs"
     },
     {
      "fs": "CCR",
      "iata": "CCR",
      "icao": "KCCR",
      "faa": "CCR",
      "name": "Buchanan Field",
      "city": "Concord",
      "cityCode": "CCR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 37.988889,
      "longitude": -122.055556,
      "elevationFeet": 23,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CCR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CCR?codeType=fs"
     },
     {
      "fs": "CDB",
      "iata": "CDB",
      "icao": "PACD",
      "faa": "PACD",
      "name": "Cold Bay Airport",
      "city": "Cold Bay",
      "cityCode": "CDB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ181",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 55.198716,
      "longitude": -162.721354,
      "elevationFeet": 98,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDB?codeType=fs"
     },
     {
      "fs": "CDC",
      "iata": "CDC",
      "icao": "KCDC",
      "faa": "CDC",
      "name": "Cedar City Airport",
      "street1": "2281 West, Kittyhawk Airport",
      "street2": "",
      "city": "Cedar City",
      "cityCode": "CDC",
      "stateCode": "UT",
      "postalCode": "84720",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "UTZ016",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 37.7025,
      "longitude": -113.096111,
      "elevationFeet": 5626,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDC?codeType=fs"
     },
     {
      "fs": "CDR",
      "iata": "CDR",
      "icao": "KCDR",
      "faa": "CDR",
      "name": "Chadron Airport",
      "street1": "",
      "street2": "",
      "city": "Chadron",
      "cityCode": "CDR",
      "stateCode": "NE",
      "postalCode": "69337",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NEZ002",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 42.835,
      "longitude": -103.097778,
      "elevationFeet": 3297,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDR?codeType=fs"
     },
     {
      "fs": "CDV",
      "iata": "CDV",
      "icao": "PACV",
      "faa": "PACV",
      "name": "Mudhole Smith Airport",
      "city": "Cordova",
      "cityCode": "CDV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ135",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 60.493056,
      "longitude": -145.47,
      "elevationFeet": 42,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDV?codeType=fs"
     },
     {
      "fs": "CDW",
      "iata": "CDW",
      "icao": "KCDW",
      "faa": "CDW",
      "name": "Essex County Airport",
      "city": "Caldwell",
      "cityCode": "CDW",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 40.875005,
      "longitude": -74.28021,
      "elevationFeet": 171,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDW?codeType=fs"
     },
     {
      "fs": "CEC",
      "iata": "CEC",
      "icao": "KCEC",
      "faa": "CEC",
      "name": "Del Norte County Regional Airport",
      "street1": "700, 5th Street",
      "city": "Crescent City",
      "cityCode": "CEC",
      "stateCode": "CA",
      "postalCode": "95531",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ001",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 41.78,
      "longitude": -124.235833,
      "elevationFeet": 57,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEC?codeType=fs"
     },
     {
      "fs": "CEF",
      "iata": "CEF",
      "icao": "KCEF",
      "faa": "CEF",
      "name": "Westover Metropolitan Airport",
      "city": "Springfield",
      "cityCode": "SFY",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.183377,
      "longitude": -72.553834,
      "elevationFeet": 245,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEF?codeType=fs"
     },
     {
      "fs": "CEM",
      "iata": "CEM",
      "icao": "",
      "faa": "CEM",
      "name": "Central Airport",
      "city": "Central",
      "cityCode": "CEM",
      "stateCode": "AK",
      "postalCode": "99730",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 65.574722,
      "longitude": -144.781944,
      "elevationFeet": 932,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEM?codeType=fs"
     },
     {
      "fs": "CEU",
      "iata": "CEU",
      "icao": "KCEU",
      "faa": "CEU",
      "name": "Oconee County Regional Airport",
      "city": "Clemson",
      "cityCode": "CEU",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 34.671263,
      "longitude": -82.885251,
      "elevationFeet": 896,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEU?codeType=fs"
     },
     {
      "fs": "CEW",
      "iata": "CEW",
      "icao": "KCEW",
      "faa": "CEW",
      "name": "Bob Sikes Airport",
      "city": "Crestview",
      "cityCode": "CEW",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 30.777433,
      "longitude": -86.523401,
      "elevationFeet": 164,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEW?codeType=fs"
     },
     {
      "fs": "CEZ",
      "iata": "CEZ",
      "icao": "KCEZ",
      "faa": "CEZ",
      "name": "Montezuma County Airport",
      "city": "Cortez",
      "cityCode": "CEZ",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ021",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 37.302778,
      "longitude": -108.627222,
      "elevationFeet": 5918,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEZ?codeType=fs"
     },
     {
      "fs": "CFA",
      "iata": "CFA",
      "icao": "",
      "faa": "",
      "name": "Coffee Point Airport",
      "city": "Coffee Point",
      "cityCode": "CFA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 58.216667,
      "longitude": -157.5,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CFA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CFA?codeType=fs"
     },
     {
      "fs": "CGA",
      "iata": "CGA",
      "icao": "",
      "faa": "",
      "name": "Craig Seaplane Base",
      "city": "Craig",
      "cityCode": "CGA",
      "stateCode": "AK",
      "postalCode": "99921",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ028",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 55.478383,
      "longitude": -133.146166,
      "elevationFeet": 6,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGA?codeType=fs"
     },
     {
      "fs": "CGF",
      "iata": "CGF",
      "icao": "KCGF",
      "faa": "CGF",
      "name": "Cuyahoga County Airport",
      "city": "Cleveland",
      "cityCode": "CLE",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.565181,
      "longitude": -81.488049,
      "elevationFeet": 862,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGF?codeType=fs"
     },
     {
      "fs": "CGI",
      "iata": "CGI",
      "icao": "KCGI",
      "faa": "CGI",
      "name": "Cape Girardeau Airport",
      "street1": "401 Independence",
      "street2": "",
      "city": "Cape Girardeau",
      "cityCode": "CGI",
      "stateCode": "MO",
      "postalCode": "63702",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ087",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 37.223611,
      "longitude": -89.571667,
      "elevationFeet": 342,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGI?codeType=fs"
     },
     {
      "fs": "CHU",
      "iata": "CHU",
      "icao": "",
      "faa": "9A3",
      "name": "Chuathbaluk Airport",
      "city": "Chuathbaluk",
      "cityCode": "CHU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 61.583436,
      "longitude": -159.238821,
      "elevationFeet": 1179,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHU?codeType=fs"
     },
     {
      "fs": "CIC",
      "iata": "CIC",
      "icao": "KCIC",
      "faa": "CIC",
      "name": "Chico Municipal Airport",
      "city": "Chico",
      "cityCode": "CIC",
      "stateCode": "CA",
      "postalCode": "95973",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ066",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 39.798178,
      "longitude": -121.856046,
      "elevationFeet": 238,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIC?codeType=fs"
     },
     {
      "fs": "CIK",
      "iata": "CIK",
      "icao": "",
      "faa": "CIK",
      "name": "Chalkyitsik Airport",
      "city": "Chalkyitsik",
      "cityCode": "CIK",
      "stateCode": "AK",
      "postalCode": "99788",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 66.648056,
      "longitude": -143.729167,
      "elevationFeet": 560,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIK?codeType=fs"
     },
     {
      "fs": "CIR",
      "iata": "CIR",
      "icao": "KCIR",
      "faa": "CIR",
      "name": "Cairo Airport",
      "city": "Cairo",
      "cityCode": "CIR",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 37.064499,
      "longitude": -89.219597,
      "elevationFeet": 315,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIR?codeType=fs"
     },
     {
      "fs": "CIU",
      "iata": "CIU",
      "icao": "KCIU",
      "faa": "CIU",
      "name": "Chippewa County Airport",
      "street1": "119 Airport Drive",
      "city": "Sault Ste. Marie",
      "cityCode": "SSM",
      "stateCode": "MI",
      "postalCode": "49788",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ008",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 46.250598,
      "longitude": -84.473192,
      "elevationFeet": 799,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIU?codeType=fs"
     },
     {
      "fs": "CKB",
      "iata": "CKB",
      "icao": "KCKB",
      "faa": "CKB",
      "name": "Benedum Airport",
      "street1": "2000 Aviation Way",
      "street2": "",
      "city": "Clarksburg",
      "cityCode": "CKB",
      "stateCode": "WV",
      "postalCode": "26330",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ031",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.295556,
      "longitude": -80.229444,
      "elevationFeet": 1217,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKB?codeType=fs"
     },
     {
      "fs": "CKD",
      "iata": "CKD",
      "icao": "",
      "faa": "CJX",
      "name": "Crooked Creek Airport",
      "city": "Crooked Creek",
      "cityCode": "CKD",
      "stateCode": "AK",
      "postalCode": "99575",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 61.870833,
      "longitude": -158.100833,
      "elevationFeet": 128,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKD?codeType=fs"
     },
     {
      "fs": "CKX",
      "iata": "CKX",
      "icao": "",
      "faa": "CKX",
      "name": "Chicken Airport",
      "city": "Chicken",
      "cityCode": "CKX",
      "stateCode": "AK",
      "postalCode": "99732",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ224",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 64.067778,
      "longitude": -141.949167,
      "elevationFeet": 1640,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKX?codeType=fs"
     },
     {
      "fs": "CLD",
      "iata": "CLD",
      "icao": "KCRQ",
      "faa": "CRQ",
      "name": "McClellan-Palomar Airport",
      "street1": "2192 Palomar Airport Road",
      "city": "Carlsbad",
      "cityCode": "SAN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ043",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.127288,
      "longitude": -117.278883,
      "elevationFeet": 318,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLD?codeType=fs"
     },
     {
      "fs": "CLK",
      "iata": "CLK",
      "icao": "KCLK",
      "faa": "CLK",
      "name": "Clinton Regional Airport",
      "city": "Clinton",
      "cityCode": "CSM",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 35.538056,
      "longitude": -98.9325,
      "elevationFeet": 1615,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLK?codeType=fs"
     },
     {
      "fs": "CLL",
      "iata": "CLL",
      "icao": "KCLL",
      "faa": "CLL",
      "name": "Easterwood Airport",
      "street1": "1, McKenzie Terminal Boulevard",
      "city": "College Station",
      "cityCode": "CLL",
      "stateCode": "TX",
      "postalCode": "77845",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ196",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.593842,
      "longitude": -96.366818,
      "elevationFeet": 321,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLL?codeType=fs"
     },
     {
      "fs": "CLM",
      "iata": "CLM",
      "icao": "KCLM",
      "faa": "CLM",
      "name": "William R. Fairchild International Airport",
      "city": "Port Angeles",
      "cityCode": "CLM",
      "stateCode": "WA",
      "postalCode": "98362",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 48.118658,
      "longitude": -123.497237,
      "elevationFeet": 291,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLM?codeType=fs"
     },
     {
      "fs": "CLP",
      "iata": "CLP",
      "icao": "",
      "faa": "CLP",
      "name": "Clarks Point Airport",
      "city": "Clarks Point",
      "cityCode": "CLP",
      "stateCode": "AK",
      "postalCode": "99569",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 58.836903,
      "longitude": -158.528192,
      "elevationFeet": 57,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLP?codeType=fs"
     },
     {
      "fs": "CLU",
      "iata": "CLU",
      "icao": "KBAK",
      "faa": "BAK",
      "name": "Columbus Municipal Airport",
      "city": "Columbus",
      "cityCode": "CLU",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.261918,
      "longitude": -85.896329,
      "elevationFeet": 654,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLU?codeType=fs"
     },
     {
      "fs": "CMI",
      "iata": "CMI",
      "icao": "KCMI",
      "faa": "CMI",
      "name": "University of Illinois Willard Airport",
      "street1": "One Airport Road",
      "city": "Champaign",
      "cityCode": "CMI",
      "stateCode": "IL",
      "postalCode": "61874",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ045",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 40.039167,
      "longitude": -88.278056,
      "elevationFeet": 746,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CMI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CMI?codeType=fs"
     },
     {
      "fs": "CMX",
      "iata": "CMX",
      "icao": "KCMX",
      "faa": "CMX",
      "name": "Houghton County Airport",
      "city": "Hancock",
      "cityCode": "CMX",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ003",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 47.167778,
      "longitude": -88.486389,
      "elevationFeet": 1095,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CMX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CMX?codeType=fs"
     },
     {
      "fs": "CNE",
      "iata": "CNE",
      "icao": "",
      "faa": "1V6",
      "name": "Canon City Airport",
      "city": "Canon City",
      "cityCode": "CNE",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 38.45,
      "longitude": -105.233333,
      "elevationFeet": 5439,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNE?codeType=fs"
     },
     {
      "fs": "CNM",
      "iata": "CNM",
      "icao": "KCNM",
      "faa": "CNM",
      "name": "Cavern City Air Terminal",
      "city": "Carlsbad",
      "cityCode": "CNM",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ028",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 32.337222,
      "longitude": -104.262778,
      "elevationFeet": 3295,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNM?codeType=fs"
     },
     {
      "fs": "CNO",
      "iata": "CNO",
      "icao": "KCNO",
      "faa": "CNO",
      "name": "Chino Airport",
      "city": "Chino",
      "cityCode": "CNO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.980833,
      "longitude": -117.639167,
      "elevationFeet": 652,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNO?codeType=fs"
     },
     {
      "fs": "CNW",
      "iata": "CNW",
      "icao": "KCNW",
      "faa": "CNW",
      "name": "TSTC Waco Airport",
      "city": "Waco",
      "cityCode": "ACT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 31.63759,
      "longitude": -97.073408,
      "elevationFeet": 465,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNW?codeType=fs"
     },
     {
      "fs": "CNY",
      "iata": "CNY",
      "icao": "KCNY",
      "faa": "CNY",
      "name": "Canyonlands Field",
      "city": "Moab",
      "cityCode": "CNY",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "UTZ027",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 38.759444,
      "longitude": -109.746111,
      "elevationFeet": 4553,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNY?codeType=fs"
     },
     {
      "fs": "COD",
      "iata": "COD",
      "icao": "KCOD",
      "faa": "COD",
      "name": "Yellowstone Regional Airport",
      "street1": "3001 Duggleby Drive",
      "street2": "",
      "city": "Cody",
      "cityCode": "COD",
      "stateCode": "WY",
      "postalCode": "82414",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ002",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 44.515833,
      "longitude": -109.0275,
      "elevationFeet": 5098,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COD?codeType=fs"
     },
     {
      "fs": "COE",
      "iata": "COE",
      "icao": "KCOE",
      "faa": "COE",
      "name": "Pappy Boyington Field",
      "city": "Coeur D'Alene",
      "cityCode": "COE",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 47.774279,
      "longitude": -116.819654,
      "elevationFeet": 2291,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COE?codeType=fs"
     },
     {
      "fs": "COF",
      "iata": "COF",
      "icao": "KCOF",
      "faa": "COF",
      "name": "Patrick Air Force Base",
      "city": "Cocoa",
      "cityCode": "COI",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 28.241516,
      "longitude": -80.609387,
      "elevationFeet": 5,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COF?codeType=fs"
     },
     {
      "fs": "CON",
      "iata": "CON",
      "icao": "KCON",
      "faa": "CON",
      "name": "Concord Municipal Airport",
      "street1": "71 Airport Road",
      "city": "Concord",
      "cityCode": "CON",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 43.20463,
      "longitude": -71.501789,
      "elevationFeet": 338,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CON?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CON?codeType=fs"
     },
     {
      "fs": "COU",
      "iata": "COU",
      "icao": "KCOU",
      "faa": "COU",
      "name": "Columbia Regional Airport",
      "street1": "Route 1",
      "street2": "",
      "city": "Columbia",
      "cityCode": "COU",
      "stateCode": "MO",
      "postalCode": "65201",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ041",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 38.813611,
      "longitude": -92.219167,
      "elevationFeet": 889,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COU?codeType=fs"
     },
     {
      "fs": "CPR",
      "iata": "CPR",
      "icao": "KCPR",
      "faa": "CPR",
      "name": "Casper/Natrona County International Airport",
      "street1": "8500 Airport Parkway",
      "city": "Casper",
      "cityCode": "CPR",
      "stateCode": "WY",
      "postalCode": "82602",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ015",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 42.908611,
      "longitude": -106.4625,
      "elevationFeet": 5348,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CPR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CPR?codeType=fs"
     },
     {
      "fs": "CPS",
      "iata": "CPS",
      "icao": "KCPS",
      "faa": "CPS",
      "name": "St. Louis Downtown Airport",
      "city": "Saint Louis",
      "cityCode": "STL",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ101",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 38.574974,
      "longitude": -90.155989,
      "elevationFeet": 412,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CPS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CPS?codeType=fs"
     },
     {
      "fs": "CRE",
      "iata": "CRE",
      "icao": "KCRE",
      "faa": "CRE",
      "name": "Grand Strand Airport",
      "city": "Myrtle Beach",
      "cityCode": "MYR",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.811389,
      "longitude": -78.724444,
      "elevationFeet": 32,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRE?codeType=fs"
     },
     {
      "fs": "CRG",
      "iata": "CRG",
      "icao": "KCRG",
      "faa": "CRG",
      "name": "Jacksonville Executive at Craig Airport",
      "city": "Jacksonville",
      "cityCode": "JAX",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ025",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 30.33631,
      "longitude": -81.511856,
      "elevationFeet": 39,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRG?codeType=fs"
     },
     {
      "fs": "CRX",
      "iata": "CRX",
      "icao": "KCRX",
      "faa": "CRX",
      "name": "Roscoe Turner Airport",
      "city": "Corinth",
      "cityCode": "CRX",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 34.915001,
      "longitude": -88.6035,
      "elevationFeet": 416,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRX?codeType=fs"
     },
     {
      "fs": "CSG",
      "iata": "CSG",
      "icao": "KCSG",
      "faa": "CSG",
      "name": "Columbus Airport",
      "street1": "3250 West Britt David Road",
      "city": "Columbus",
      "cityCode": "CSG",
      "stateCode": "GA",
      "postalCode": "31909",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ089",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 32.513333,
      "longitude": -84.941111,
      "elevationFeet": 397,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSG?codeType=fs"
     },
     {
      "fs": "CSV",
      "iata": "CSV",
      "icao": "KCSV",
      "faa": "CSV",
      "name": "Memorial-Whitson Field",
      "city": "Crossville",
      "cityCode": "CSV",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 35.951111,
      "longitude": -85.084722,
      "elevationFeet": 1881,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSV?codeType=fs"
     },
     {
      "fs": "CTB",
      "iata": "CTB",
      "icao": "KCTB",
      "faa": "CTB",
      "name": "Cut Bank Municipal Airport",
      "city": "Cut Bank",
      "cityCode": "CTB",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 48.608624,
      "longitude": -112.377903,
      "elevationFeet": 3854,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTB?codeType=fs"
     },
     {
      "fs": "CTH",
      "iata": "CTH",
      "icao": "KMQS",
      "faa": "MQS",
      "name": "Chester County  G. O. Carlson Airport",
      "city": "Coatesville",
      "cityCode": "CTH",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.979532,
      "longitude": -75.863395,
      "elevationFeet": 644,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTH?codeType=fs"
     },
     {
      "fs": "CTW",
      "iata": "CTW",
      "icao": "",
      "faa": "P52",
      "name": "Cottonwood Airport",
      "city": "Cottonwood",
      "cityCode": "CTW",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 34.73,
      "longitude": -112.035004,
      "elevationFeet": 3545,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTW?codeType=fs"
     },
     {
      "fs": "CTX",
      "iata": "CTX",
      "icao": "",
      "faa": "N03",
      "name": "Cortland County Airport",
      "city": "Cortland",
      "cityCode": "CTX",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.592602,
      "longitude": -76.214897,
      "elevationFeet": 1174,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTX?codeType=fs"
     },
     {
      "fs": "CVN",
      "iata": "CVN",
      "icao": "KCVN",
      "faa": "CVN",
      "name": "Clovis Municipal Airport",
      "city": "Clovis",
      "cityCode": "CVN",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ535",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 34.427222,
      "longitude": -103.078889,
      "elevationFeet": 4216,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CVN?codeType=fs"
     },
     {
      "fs": "CVO",
      "iata": "CVO",
      "icao": "KCVO",
      "faa": "CVO",
      "name": "Corvallis Municipal Airport",
      "city": "Corvallis",
      "cityCode": "CVO",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 44.501186,
      "longitude": -123.2857,
      "elevationFeet": 243,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CVO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CVO?codeType=fs"
     },
     {
      "fs": "CVR",
      "iata": "CVR",
      "icao": "",
      "faa": "",
      "name": "Hughes Airport",
      "city": "Culver City",
      "cityCode": "CVR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 33.975,
      "longitude": -118.417,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CVR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CVR?codeType=fs"
     },
     {
      "fs": "CVS",
      "iata": "CVS",
      "icao": "KCVS",
      "faa": "CVS",
      "name": "Cannon Air Force Base",
      "city": "Clovis",
      "cityCode": "CVN",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 34.383889,
      "longitude": -103.316667,
      "elevationFeet": 4295,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CVS?codeType=fs"
     },
     {
      "fs": "CWA",
      "iata": "CWA",
      "icao": "KCWA",
      "faa": "CWA",
      "name": "Central Wisconsin Airport",
      "street1": "",
      "street2": "",
      "city": "Wausau",
      "cityCode": "AUW",
      "stateCode": "WI",
      "postalCode": "54401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ030",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 44.784209,
      "longitude": -89.672437,
      "elevationFeet": 1277,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CWA?codeType=fs"
     },
     {
      "fs": "CXF",
      "iata": "CXF",
      "icao": "",
      "faa": "CXF",
      "name": "Coldfoot Airport",
      "city": "Coldfoot",
      "cityCode": "CXF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 67.253829,
      "longitude": -150.201896,
      "elevationFeet": 1016,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CXF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CXF?codeType=fs"
     },
     {
      "fs": "CXL",
      "iata": "CXL",
      "icao": "KCXL",
      "faa": "CXL",
      "name": "Calexico International Airport",
      "city": "Calexico",
      "cityCode": "CXL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 32.666667,
      "longitude": -115.516667,
      "elevationFeet": 4,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CXL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CXL?codeType=fs"
     },
     {
      "fs": "CXO",
      "iata": "CXO",
      "icao": "KCXO",
      "faa": "CXO",
      "name": "Lone Star Executive Airport",
      "city": "Conroe",
      "cityCode": "CXO",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.352968,
      "longitude": -95.416957,
      "elevationFeet": 239,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CXO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CXO?codeType=fs"
     },
     {
      "fs": "CYE",
      "iata": "CYE",
      "icao": "",
      "faa": "",
      "name": "Crystal Lake Airport",
      "city": "Crystal Lake",
      "cityCode": "CYE",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.210278,
      "longitude": -75.832222,
      "elevationFeet": 556,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CYE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CYE?codeType=fs"
     },
     {
      "fs": "CYF",
      "iata": "CYF",
      "icao": "PACK",
      "faa": "PACK",
      "name": "Chefornak Sea Plane Base",
      "city": "Chefornak",
      "cityCode": "CYF",
      "stateCode": "AK",
      "postalCode": "99561",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 60.216667,
      "longitude": -164.2,
      "elevationFeet": 40,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CYF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CYF?codeType=fs"
     },
     {
      "fs": "CYS",
      "iata": "CYS",
      "icao": "KCYS",
      "faa": "CYS",
      "name": "Cheyenne Regional Airport",
      "street1": "200 East 8th Avenue",
      "city": "Cheyenne",
      "cityCode": "CYS",
      "stateCode": "WY",
      "postalCode": "82003-2210",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 41.155833,
      "longitude": -104.816667,
      "elevationFeet": 6156,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CYS?codeType=fs"
     },
     {
      "fs": "D98",
      "iata": "",
      "icao": "",
      "faa": "D98",
      "name": "Romeo State",
      "city": "Romeo",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.920028,
      "longitude": -83.052639,
      "elevationFeet": 745,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D98?codeType=fs"
     },
     {
      "fs": "DAB",
      "iata": "DAB",
      "icao": "KDAB",
      "faa": "DAB",
      "name": "Daytona Beach International Airport",
      "street1": "700 Catalina Drive, Suite 300",
      "city": "Daytona Beach",
      "cityCode": "DAB",
      "stateCode": "FL",
      "postalCode": "32114",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ141",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 29.185192,
      "longitude": -81.060829,
      "elevationFeet": 34,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DAB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DAB?codeType=fs"
     },
     {
      "fs": "DAN",
      "iata": "DAN",
      "icao": "KDAN",
      "faa": "DAN",
      "name": "Danville Regional Airport",
      "city": "Danville",
      "cityCode": "DAN",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 36.572899,
      "longitude": -79.336098,
      "elevationFeet": 563,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DAN?codeType=fs"
     },
     {
      "fs": "DBQ",
      "iata": "DBQ",
      "icao": "KDBQ",
      "faa": "DBQ",
      "name": "Dubuque Municipal Airport",
      "street1": "11000 Airport Road",
      "street2": "",
      "city": "Dubuque",
      "cityCode": "DBQ",
      "stateCode": "IA",
      "postalCode": "52003",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ042",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 42.41,
      "longitude": -90.710833,
      "elevationFeet": 1076,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DBQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DBQ?codeType=fs"
     },
     {
      "fs": "DDC",
      "iata": "DDC",
      "icao": "KDDC",
      "faa": "DDC",
      "name": "Dodge City Regional Airport",
      "street1": "100 Airport Road",
      "city": "Dodge City",
      "cityCode": "DDC",
      "stateCode": "KS",
      "postalCode": "67801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ078",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 37.761667,
      "longitude": -99.965,
      "elevationFeet": 2594,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DDC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DDC?codeType=fs"
     },
     {
      "fs": "DEC",
      "iata": "DEC",
      "icao": "KDEC",
      "faa": "DEC",
      "name": "Decatur Airport",
      "street1": "910 S Airport Rd",
      "city": "Decatur",
      "cityCode": "DEC",
      "stateCode": "IL",
      "postalCode": "62521",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ053",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 39.834251,
      "longitude": -88.876529,
      "elevationFeet": 682,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DEC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DEC?codeType=fs"
     },
     {
      "fs": "DET",
      "iata": "DET",
      "icao": "KDET",
      "faa": "DET",
      "name": "Coleman A. Young Municipal Airport",
      "city": "Detroit",
      "cityCode": "DTT",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 42.409322,
      "longitude": -83.005101,
      "elevationFeet": 622,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DET?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DET?codeType=fs"
     },
     {
      "fs": "DHB",
      "iata": "DHB",
      "icao": "",
      "faa": "WA1",
      "name": "Deer Harbor Sea Plane Base",
      "city": "Orcas Island",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.663",
      "utcOffsetHours": -8,
      "latitude": 48.618395,
      "longitude": -123.005958,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DHB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DHB?codeType=fs"
     },
     {
      "fs": "DHN",
      "iata": "DHN",
      "icao": "KDHN",
      "faa": "DHN",
      "name": "Dothan Regional Airport",
      "street1": "800 Airport Drive, Suite 15",
      "city": "Dothan",
      "cityCode": "DHN",
      "stateCode": "AL",
      "postalCode": "36303",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ069",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 31.317943,
      "longitude": -85.450241,
      "elevationFeet": 401,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DHN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DHN?codeType=fs"
     },
     {
      "fs": "DIK",
      "iata": "DIK",
      "icao": "KDIK",
      "faa": "DIK",
      "name": "Dickinson Regional Airport",
      "street1": "11120 42nd St SW",
      "city": "Dickinson",
      "cityCode": "DIK",
      "stateCode": "ND",
      "postalCode": "58601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NDZ033",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 46.801471,
      "longitude": -102.793204,
      "elevationFeet": 2592,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DIK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DIK?codeType=fs"
     },
     {
      "fs": "DIO",
      "iata": "DIO",
      "icao": "",
      "faa": "",
      "name": "Diomede Heliport",
      "city": "Diomede Island",
      "cityCode": "DIO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ211",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 65.758436,
      "longitude": -168.953352,
      "elevationFeet": 2,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DIO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DIO?codeType=fs"
     },
     {
      "fs": "DJN",
      "iata": "DJN",
      "icao": "PABI",
      "faa": "D66",
      "name": "Delta Junction Airport",
      "city": "Delta Junction",
      "cityCode": "DJN",
      "stateCode": "AK",
      "postalCode": "99737",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ223",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 64.049829,
      "longitude": -145.725642,
      "elevationFeet": 1148,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DJN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DJN?codeType=fs"
     },
     {
      "fs": "DLF",
      "iata": "DLF",
      "icao": "KDLF",
      "faa": "DLF",
      "name": "Laughlin Air Force Base",
      "city": "Del Rio",
      "cityCode": "DRT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 29.359235,
      "longitude": -100.778668,
      "elevationFeet": 1078,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLF?codeType=fs"
     },
     {
      "fs": "DLG",
      "iata": "DLG",
      "icao": "PADL",
      "faa": "PADL",
      "name": "Dillingham Airport",
      "city": "Dillingham",
      "cityCode": "DLG",
      "stateCode": "AK",
      "postalCode": "99576",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 59.04264,
      "longitude": -158.511113,
      "elevationFeet": 86,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLG?codeType=fs"
     },
     {
      "fs": "DLH",
      "iata": "DLH",
      "icao": "KDLH",
      "faa": "DLH",
      "name": "Duluth International Airport",
      "street1": "4701 Grinden Drive",
      "city": "Duluth",
      "cityCode": "DLH",
      "stateCode": "MN",
      "postalCode": "55811",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ037",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 46.838975,
      "longitude": -92.180192,
      "elevationFeet": 1428,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLH?codeType=fs"
     },
     {
      "fs": "DLN",
      "iata": "DLN",
      "icao": "KDLN",
      "faa": "DLN",
      "name": "Dillon Airport",
      "city": "Dillon",
      "cityCode": "DLN",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 45.255402,
      "longitude": -112.553001,
      "elevationFeet": 5220,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLN?codeType=fs"
     },
     {
      "fs": "DMA",
      "iata": "DMA",
      "icao": "KDMA",
      "faa": "DMA",
      "name": "Davis Monthan Air Force Base",
      "city": "Tucson",
      "cityCode": "TUS",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 32.166667,
      "longitude": -110.883333,
      "elevationFeet": 2704,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DMA?codeType=fs"
     },
     {
      "fs": "DNL",
      "iata": "DNL",
      "icao": "KDNL",
      "faa": "DNL",
      "name": "Daniel Field",
      "city": "Augusta",
      "cityCode": "AGS",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 33.468096,
      "longitude": -82.039197,
      "elevationFeet": 414,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DNL?codeType=fs"
     },
     {
      "fs": "DNV",
      "iata": "DNV",
      "icao": "KDNV",
      "faa": "DNV",
      "name": "Vermilion Regional Airport",
      "city": "Danville",
      "cityCode": "DNV",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 40.197222,
      "longitude": -87.596944,
      "elevationFeet": 696,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DNV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DNV?codeType=fs"
     },
     {
      "fs": "DOV",
      "iata": "DOV",
      "icao": "KDOV",
      "faa": "DOV",
      "name": "Dover Air Force Base",
      "city": "Dover-Cheswold",
      "cityCode": "DOV",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 39.128611,
      "longitude": -75.464167,
      "elevationFeet": 30,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DOV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DOV?codeType=fs"
     },
     {
      "fs": "DRG",
      "iata": "DRG",
      "icao": "PADE",
      "faa": "DEE",
      "name": "Deering Airport",
      "city": "Deering",
      "cityCode": "DRG",
      "stateCode": "AK",
      "postalCode": "99736",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ210",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 66.071194,
      "longitude": -162.759886,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRG?codeType=fs"
     },
     {
      "fs": "DRO",
      "iata": "DRO",
      "icao": "KDRO",
      "faa": "DRO",
      "name": "Durango-La Plata County Airport",
      "street1": "1000 Airport Rd",
      "city": "Durango",
      "cityCode": "DRO",
      "stateCode": "CO",
      "postalCode": "81301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ022",
      "localTime": "2022-11-09T05:41:39.663",
      "utcOffsetHours": -7,
      "latitude": 37.15995,
      "longitude": -107.751075,
      "elevationFeet": 6685,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRO?codeType=fs"
     },
     {
      "fs": "DRT",
      "iata": "DRT",
      "icao": "KDRT",
      "faa": "DRT",
      "name": "Del Rio International Airport",
      "city": "Del Rio",
      "cityCode": "DRT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 29.374215,
      "longitude": -100.927142,
      "elevationFeet": 992,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRT?codeType=fs"
     },
     {
      "fs": "DSI",
      "iata": "DSI",
      "icao": "KDTS",
      "faa": "DTS",
      "name": "Destin-Fort Walton Beach Airport",
      "city": "Destin",
      "cityCode": "DSI",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 30.399591,
      "longitude": -86.470882,
      "elevationFeet": 18,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DSI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DSI?codeType=fs"
     },
     {
      "fs": "DTL",
      "iata": "DTL",
      "icao": "KDTL",
      "faa": "DTL",
      "name": "Wething Field",
      "city": "Detroit Lakes",
      "cityCode": "DTL",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.663",
      "utcOffsetHours": -6,
      "latitude": 46.826389,
      "longitude": -95.886111,
      "elevationFeet": 1396,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DTL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DTL?codeType=fs"
     },
     {
      "fs": "DUJ",
      "iata": "DUJ",
      "icao": "KDUJ",
      "faa": "DUJ",
      "name": "Jefferson County Airport",
      "street1": "",
      "street2": "",
      "city": "Dubois",
      "cityCode": "DUJ",
      "stateCode": "PA",
      "postalCode": "15801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ017",
      "localTime": "2022-11-09T07:41:39.663",
      "utcOffsetHours": -5,
      "latitude": 41.178333,
      "longitude": -78.898889,
      "elevationFeet": 1817,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DUJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DUJ?codeType=fs"
     },
     {
      "fs": "DUT",
      "iata": "DUT",
      "icao": "PADU",
      "faa": "PADU",
      "name": "Unalaska Airport",
      "city": "Dutch Harbor",
      "cityCode": "DUT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ185",
      "localTime": "2022-11-09T03:41:39.663",
      "utcOffsetHours": -9,
      "latitude": 53.894458,
      "longitude": -166.542238,
      "elevationFeet": 22,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DUT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DUT?codeType=fs"
     },
     {
      "fs": "DVL",
      "iata": "DVL",
      "icao": "KDVL",
      "faa": "DVL",
      "name": "Devils Lake Airport",
      "street1": "",
      "street2": "",
      "city": "Devils Lake",
      "cityCode": "DVL",
      "stateCode": "ND",
      "postalCode": "58301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ015",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 48.113056,
      "longitude": -98.9075,
      "elevationFeet": 1455,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DVL?codeType=fs"
     },
     {
      "fs": "DVN",
      "iata": "DVN",
      "icao": "KDVN",
      "faa": "DVN",
      "name": "Davenport Airport",
      "city": "Davenport",
      "cityCode": "DVN",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 41.610556,
      "longitude": -90.588611,
      "elevationFeet": 753,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DVN?codeType=fs"
     },
     {
      "fs": "DVT",
      "iata": "DVT",
      "icao": "KDVT",
      "faa": "DVT",
      "name": "Phoenix Deer Valley Airport",
      "city": "Phoenix",
      "cityCode": "PHX",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 33.688333,
      "longitude": -112.0825,
      "elevationFeet": 1462,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DVT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DVT?codeType=fs"
     },
     {
      "fs": "DWH",
      "iata": "DWH",
      "icao": "KDWH",
      "faa": "DWH",
      "name": "David Wayne Hooks Memorial Airport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.060468,
      "longitude": -95.550861,
      "elevationFeet": 149,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DWH?codeType=fs"
     },
     {
      "fs": "DXE",
      "iata": "DXE",
      "icao": "KMBO",
      "faa": "MBO",
      "name": "Bruce Campbell Field",
      "city": "Madison",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.44107,
      "longitude": -90.104127,
      "elevationFeet": 324,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DXE?codeType=fs"
     },
     {
      "fs": "DXR",
      "iata": "DXR",
      "icao": "KDXR",
      "faa": "DXR",
      "name": "Danbury Municipal Airport",
      "city": "Danbury",
      "cityCode": "DXR",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.371782,
      "longitude": -73.48999,
      "elevationFeet": 452,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DXR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DXR?codeType=fs"
     },
     {
      "fs": "DYS",
      "iata": "DYS",
      "icao": "KDYS",
      "faa": "DYS",
      "name": "Dyess Air Force Base",
      "city": "Abilene",
      "cityCode": "ABI",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.419703,
      "longitude": -99.848551,
      "elevationFeet": 1780,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DYS?codeType=fs"
     },
     {
      "fs": "E25",
      "iata": "",
      "icao": "",
      "faa": "E25",
      "name": "Wickenburg Municipal Airport",
      "city": "Wickenburg",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 33.966325,
      "longitude": -112.802227,
      "elevationFeet": 2368,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E25?codeType=fs"
     },
     {
      "fs": "EAA",
      "iata": "EAA",
      "icao": "PAEA",
      "faa": "PAEA",
      "name": "Eagle Airport",
      "city": "Eagle",
      "cityCode": "EAA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ224",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.776667,
      "longitude": -141.148611,
      "elevationFeet": 880,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EAA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EAA?codeType=fs"
     },
     {
      "fs": "EAR",
      "iata": "EAR",
      "icao": "KEAR",
      "faa": "EAR",
      "name": "Kearney Regional Airport",
      "street1": "5145 Airport Rd.",
      "city": "Kearney",
      "cityCode": "EAR",
      "stateCode": "NE",
      "postalCode": "68847",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ061",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 40.728458,
      "longitude": -99.008451,
      "elevationFeet": 2131,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EAR?codeType=fs"
     },
     {
      "fs": "EAT",
      "iata": "EAT",
      "icao": "KEAT",
      "faa": "EAT",
      "name": "Pangborn Field",
      "street1": "1 Pangborne Drive",
      "street2": "",
      "city": "Wenatchee",
      "cityCode": "EAT",
      "stateCode": "WA",
      "postalCode": "98807",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ041",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 47.399722,
      "longitude": -120.207778,
      "elevationFeet": 1249,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EAT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EAT?codeType=fs"
     },
     {
      "fs": "EAU",
      "iata": "EAU",
      "icao": "KEAU",
      "faa": "EAU",
      "name": "Eau Claire Airport",
      "street1": "3800 Starr Avenue",
      "street2": "",
      "city": "Eau Claire",
      "cityCode": "EAU",
      "stateCode": "WI",
      "postalCode": "54703",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ028",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 44.864444,
      "longitude": -91.487222,
      "elevationFeet": 907,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EAU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EAU?codeType=fs"
     },
     {
      "fs": "ECG",
      "iata": "ECG",
      "icao": "KECG",
      "faa": "ECG",
      "name": "Elizabeth City Airport",
      "city": "Elizabeth City",
      "cityCode": "ECG",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 36.259167,
      "longitude": -76.173056,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ECG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ECG?codeType=fs"
     },
     {
      "fs": "EDA",
      "iata": "EDA",
      "icao": "",
      "faa": "",
      "name": "Edna Bay Sea Plane Base",
      "city": "Edna Bay",
      "cityCode": "EDA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ027",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 55.949779,
      "longitude": -133.660707,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDA?codeType=fs"
     },
     {
      "fs": "EDC",
      "iata": "EDC",
      "icao": "KEDC",
      "faa": "",
      "name": "Austin Executive Airport",
      "city": "Austin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.3999,
      "longitude": -97.5735,
      "elevationFeet": 623,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDC?codeType=fs"
     },
     {
      "fs": "EDE",
      "iata": "EDE",
      "icao": "KEDE",
      "faa": "EDE",
      "name": "Northeastern Regional Airport",
      "city": "Edenton",
      "cityCode": "EDE",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 36.020711,
      "longitude": -76.568691,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDE?codeType=fs"
     },
     {
      "fs": "EDF",
      "iata": "EDF",
      "icao": "PAED",
      "faa": "PAED",
      "name": "Elmendorf Air Force Base",
      "city": "Anchorage",
      "cityCode": "ANC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 61.250403,
      "longitude": -149.802833,
      "elevationFeet": 181,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDF?codeType=fs"
     },
     {
      "fs": "EDW",
      "iata": "EDW",
      "icao": "KEDW",
      "faa": "EDW",
      "name": "Edwards Air Force Base",
      "city": "Edwards Air Force Base",
      "cityCode": "EDW",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 34.908862,
      "longitude": -117.881232,
      "elevationFeet": 2296,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDW?codeType=fs"
     },
     {
      "fs": "EEK",
      "iata": "EEK",
      "icao": "",
      "faa": "EEK",
      "name": "Eek Airport",
      "city": "Eek",
      "cityCode": "EEK",
      "stateCode": "AK",
      "postalCode": "99578",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 60.216667,
      "longitude": -162.016667,
      "elevationFeet": 40,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EEK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EEK?codeType=fs"
     },
     {
      "fs": "EFD",
      "iata": "EFD",
      "icao": "KEFD",
      "faa": "EFD",
      "name": "Ellington Field",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ213",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 29.609583,
      "longitude": -95.159708,
      "elevationFeet": 29,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EFD?codeType=fs"
     },
     {
      "fs": "EFK",
      "iata": "EFK",
      "icao": "KEFK",
      "faa": "EFK",
      "name": "Newport State Airport",
      "city": "Newport",
      "cityCode": "EFK",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 44.889444,
      "longitude": -72.23,
      "elevationFeet": 930,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EFK?codeType=fs"
     },
     {
      "fs": "EGE",
      "iata": "EGE",
      "icao": "KEGE",
      "faa": "EGE",
      "name": "Eagle County Airport",
      "street1": "",
      "street2": "",
      "city": "Vail",
      "cityCode": "EGE",
      "stateCode": "CO",
      "postalCode": "81631",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ008",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 39.639882,
      "longitude": -106.913471,
      "elevationFeet": 6535,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EGE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EGE?codeType=fs"
     },
     {
      "fs": "EGV",
      "iata": "EGV",
      "icao": "KEGV",
      "faa": "EGV",
      "name": "Eagle River Airport",
      "city": "Eagle River",
      "cityCode": "EGV",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 45.929167,
      "longitude": -89.265833,
      "elevationFeet": 1642,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EGV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EGV?codeType=fs"
     },
     {
      "fs": "EGX",
      "iata": "EGX",
      "icao": "PAII",
      "faa": "PAII",
      "name": "Egegik Airport",
      "city": "Egegik",
      "cityCode": "EGX",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.207778,
      "longitude": -157.370278,
      "elevationFeet": 84,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EGX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EGX?codeType=fs"
     },
     {
      "fs": "EIL",
      "iata": "EIL",
      "icao": "PAEI",
      "faa": "PAEI",
      "name": "Eielson Air Force Base",
      "city": "Fairbanks",
      "cityCode": "FAI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.667753,
      "longitude": -147.103194,
      "elevationFeet": 541,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EIL?codeType=fs"
     },
     {
      "fs": "EKA",
      "iata": "EKA",
      "icao": "KEKA",
      "faa": "EKA",
      "name": "Murray Field",
      "city": "Eureka",
      "cityCode": "EKA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 40.805,
      "longitude": -124.115,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EKA?codeType=fs"
     },
     {
      "fs": "EKN",
      "iata": "EKN",
      "icao": "KEKN",
      "faa": "EKN",
      "name": "Randolph County Airport",
      "city": "Elkins",
      "cityCode": "EKN",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.889444,
      "longitude": -79.857778,
      "elevationFeet": 1987,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EKN?codeType=fs"
     },
     {
      "fs": "EKO",
      "iata": "EKO",
      "icao": "KEKO",
      "faa": "EKO",
      "name": "Elko Airport",
      "street1": "1751 College Avenue",
      "street2": "",
      "city": "Elko",
      "cityCode": "EKO",
      "stateCode": "NV",
      "postalCode": "89801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "NVZ032",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 40.823889,
      "longitude": -115.789722,
      "elevationFeet": 5140,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EKO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EKO?codeType=fs"
     },
     {
      "fs": "EKS",
      "iata": "",
      "icao": "KEKS",
      "faa": "EKS",
      "name": "Big Sky Airport",
      "street1": "37 Airport Rd.",
      "city": "Ennis",
      "stateCode": "MT",
      "postalCode": "59729",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 45.267851,
      "longitude": -111.650341,
      "elevationFeet": 5337,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EKS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EKS?codeType=fs"
     },
     {
      "fs": "ELD",
      "iata": "ELD",
      "icao": "KELD",
      "faa": "ELD",
      "name": "South Arkansas Regional Airport",
      "city": "El Dorado",
      "cityCode": "ELD",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ073",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 33.217963,
      "longitude": -92.811188,
      "elevationFeet": 277,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELD?codeType=fs"
     },
     {
      "fs": "ELI",
      "iata": "ELI",
      "icao": "",
      "faa": "ELI",
      "name": "Elim Airport",
      "city": "Elim",
      "cityCode": "ELI",
      "stateCode": "AK",
      "postalCode": "99739",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.613611,
      "longitude": -162.270278,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELI?codeType=fs"
     },
     {
      "fs": "ELM",
      "iata": "ELM",
      "icao": "KELM",
      "faa": "ELM",
      "name": "Elmira Corning Regional Airport",
      "street1": "276 Sing Sing Rd #1",
      "city": "Elmira",
      "cityCode": "ELM",
      "stateCode": "NY",
      "postalCode": "14845",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ024",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.163042,
      "longitude": -76.89586,
      "elevationFeet": 955,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELM?codeType=fs"
     },
     {
      "fs": "ELV",
      "iata": "ELV",
      "icao": "",
      "faa": "",
      "name": "Elfin Cove Sea Plane Base",
      "city": "Elfin Cove",
      "cityCode": "ELV",
      "stateCode": "AK",
      "postalCode": "99825",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ025",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.195278,
      "longitude": -136.3475,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELV?codeType=fs"
     },
     {
      "fs": "ELY",
      "iata": "ELY",
      "icao": "KELY",
      "faa": "ELY",
      "name": "Yelland Field",
      "city": "Ely",
      "cityCode": "ELY",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "NVZ035",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 39.301944,
      "longitude": -114.841944,
      "elevationFeet": 6259,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELY?codeType=fs"
     },
     {
      "fs": "EMK",
      "iata": "EMK",
      "icao": "PAEM",
      "faa": "PAEM",
      "name": "Emmonak Airport",
      "city": "Emmonak",
      "cityCode": "EMK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 62.784856,
      "longitude": -164.490537,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EMK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EMK?codeType=fs"
     },
     {
      "fs": "EMT",
      "iata": "EMT",
      "icao": "KEMT",
      "faa": "EMT",
      "name": "El Monte Airport",
      "city": "El Monte",
      "cityCode": "EMT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 34.083333,
      "longitude": -118.033333,
      "elevationFeet": 296,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EMT?codeType=fs"
     },
     {
      "fs": "ENV",
      "iata": "ENV",
      "icao": "KENV",
      "faa": "ENV",
      "name": "Wendover Airport",
      "city": "Wendover",
      "cityCode": "ENV",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 40.733333,
      "longitude": -114.033333,
      "elevationFeet": 4235,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ENV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ENV?codeType=fs"
     },
     {
      "fs": "ENW",
      "iata": "ENW",
      "icao": "KENW",
      "faa": "ENW",
      "name": "Kenosha Regional Airport",
      "city": "Kenosha",
      "cityCode": "ENW",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 42.595699,
      "longitude": -87.927803,
      "elevationFeet": 721,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ENW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ENW?codeType=fs"
     },
     {
      "fs": "ERI",
      "iata": "ERI",
      "icao": "KERI",
      "faa": "ERI",
      "name": "Erie International Airport",
      "street1": "4411 W 12th St",
      "city": "Erie",
      "cityCode": "ERI",
      "stateCode": "PA",
      "postalCode": "16505",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ001",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.083142,
      "longitude": -80.18203,
      "elevationFeet": 733,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ERI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ERI?codeType=fs"
     },
     {
      "fs": "ERV",
      "iata": "ERV",
      "icao": "KERV",
      "faa": "ERV",
      "name": "Kerrville Airport",
      "city": "Kerrville",
      "cityCode": "ERV",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.05,
      "longitude": -99.133333,
      "elevationFeet": 1617,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ERV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ERV?codeType=fs"
     },
     {
      "fs": "ESC",
      "iata": "ESC",
      "icao": "KESC",
      "faa": "ESC",
      "name": "Delta County Airport",
      "street1": "3300 Airport Road",
      "street2": "",
      "city": "Escanaba",
      "cityCode": "ESC",
      "stateCode": "MI",
      "postalCode": "49829",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ013",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 45.720556,
      "longitude": -87.086667,
      "elevationFeet": 609,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESC?codeType=fs"
     },
     {
      "fs": "ESD",
      "iata": "ESD",
      "icao": "KORS",
      "faa": "ORS",
      "name": "Orcas Island Airport",
      "city": "Eastsound",
      "cityCode": "ESD",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 48.708333,
      "longitude": -122.9125,
      "elevationFeet": 31,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESD?codeType=fs"
     },
     {
      "fs": "ESN",
      "iata": "ESN",
      "icao": "KESN",
      "faa": "ESN",
      "name": "Newnam Field",
      "city": "Easton",
      "cityCode": "ESN",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.802778,
      "longitude": -76.067778,
      "elevationFeet": 72,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESN?codeType=fs"
     },
     {
      "fs": "EVM",
      "iata": "EVM",
      "icao": "KEVM",
      "faa": "EVM",
      "name": "Eveleth Airport",
      "city": "Eveleth",
      "cityCode": "EVM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 47.426389,
      "longitude": -92.495833,
      "elevationFeet": 1378,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EVM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EVM?codeType=fs"
     },
     {
      "fs": "EVV",
      "iata": "EVV",
      "icao": "KEVV",
      "faa": "EVV",
      "name": "Evansville Regional Airport",
      "street1": "7801 Bussing Drive",
      "city": "Evansville",
      "cityCode": "EVV",
      "stateCode": "IN",
      "postalCode": "47725",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "INZ086",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 38.046164,
      "longitude": -87.527965,
      "elevationFeet": 418,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EVV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EVV?codeType=fs"
     },
     {
      "fs": "EWB",
      "iata": "EWB",
      "icao": "KEWB",
      "faa": "EWB",
      "name": "New Bedford Airport",
      "city": "New Bedford",
      "cityCode": "EWB",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ020",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.676944,
      "longitude": -70.959167,
      "elevationFeet": 80,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EWB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EWB?codeType=fs"
     },
     {
      "fs": "EWD",
      "iata": "EWD",
      "icao": "",
      "faa": "",
      "name": "Wildman Lake Airport",
      "city": "Wildman Lake",
      "cityCode": "EWD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 56.456389,
      "longitude": -159.762222,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EWD?codeType=fs"
     },
     {
      "fs": "EWN",
      "iata": "EWN",
      "icao": "KEWN",
      "faa": "EWN",
      "name": "Coastal Carolina Regional Airport",
      "street1": "200 Terminal Drive",
      "street2": "",
      "city": "New Bern",
      "cityCode": "EWN",
      "stateCode": "NC",
      "postalCode": "28560",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ093",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 35.078344,
      "longitude": -77.034622,
      "elevationFeet": 18,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EWN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EWN?codeType=fs"
     },
     {
      "fs": "EXI",
      "iata": "EXI",
      "icao": "",
      "faa": "",
      "name": "Excursion Inlet Sea Plane Base",
      "city": "Excursion Inlet",
      "cityCode": "EXI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.420833,
      "longitude": -135.447222,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EXI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EXI?codeType=fs"
     },
     {
      "fs": "F05",
      "iata": "",
      "icao": "",
      "faa": "F05",
      "name": "Wilbarger Co",
      "city": "Vernon",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 34.306694,
      "longitude": -99.2875,
      "elevationFeet": 1265,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F05?codeType=fs"
     },
     {
      "fs": "FAY",
      "iata": "FAY",
      "icao": "KFAY",
      "faa": "FAY",
      "name": "Fayetteville Regional Airport",
      "city": "Fayetteville",
      "cityCode": "FAY",
      "stateCode": "NC",
      "postalCode": "28306",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ088",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 34.99132,
      "longitude": -78.887221,
      "elevationFeet": 189,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAY?codeType=fs"
     },
     {
      "fs": "FBS",
      "iata": "FBS",
      "icao": "",
      "faa": "",
      "name": "Friday Harbor SPB",
      "city": "Friday Harbor",
      "cityCode": "FRD",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 48.543611,
      "longitude": -123.006111,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FBS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FBS?codeType=fs"
     },
     {
      "fs": "FCA",
      "iata": "FCA",
      "icao": "KGPI",
      "faa": "GPI",
      "name": "Glacier Park International Airport",
      "street1": "4170 Highway 2 East",
      "street2": "",
      "city": "Kalispell",
      "cityCode": "FCA",
      "stateCode": "MT",
      "postalCode": "59901",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ003",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 48.307304,
      "longitude": -114.253152,
      "elevationFeet": 2972,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FCA?codeType=fs"
     },
     {
      "fs": "FCM",
      "iata": "FCM",
      "icao": "KFCM",
      "faa": "FCM",
      "name": "Flying Cloud Airport",
      "city": "Minneapolis",
      "cityCode": "MSP",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 44.827096,
      "longitude": -93.456769,
      "elevationFeet": 904,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FCM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FCM?codeType=fs"
     },
     {
      "fs": "FCT",
      "iata": "FCT",
      "icao": "KFCT",
      "faa": "FCT",
      "name": "Firing Center Army Air Field",
      "city": "Yakima",
      "cityCode": "YKM",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 46.6,
      "longitude": -120.516667,
      "elevationFeet": 1370,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FCT?codeType=fs"
     },
     {
      "fs": "FDK",
      "iata": "FDK",
      "icao": "KFDK",
      "faa": "FDK",
      "name": "Frederick Municipal Airport",
      "city": "Frederick",
      "cityCode": "FDK",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.416667,
      "longitude": -77.416667,
      "elevationFeet": 303,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FDK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FDK?codeType=fs"
     },
     {
      "fs": "FFM",
      "iata": "FFM",
      "icao": "KFFM",
      "faa": "FFM",
      "name": "Fergus Falls Municipal Airport",
      "city": "Fergus Falls",
      "cityCode": "FFM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 46.285618,
      "longitude": -96.151373,
      "elevationFeet": 1186,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FFM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FFM?codeType=fs"
     },
     {
      "fs": "FHU",
      "iata": "FHU",
      "icao": "KFHU",
      "faa": "FHU",
      "name": "Fort Huachuca/Sierra Vista Municipal Airport",
      "city": "Sierra Vista",
      "cityCode": "FHU",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 31.588889,
      "longitude": -110.343056,
      "elevationFeet": 4719,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FHU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FHU?codeType=fs"
     },
     {
      "fs": "FID",
      "iata": "FID",
      "icao": "",
      "faa": "0B8",
      "name": "Elizabeth Field",
      "city": "Fishers Island",
      "cityCode": "FID",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.254454,
      "longitude": -72.032786,
      "elevationFeet": 21,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FID?codeType=fs"
     },
     {
      "fs": "FKL",
      "iata": "FKL",
      "icao": "KFKL",
      "faa": "FKL",
      "name": "Venango Regional Airport",
      "street1": "1560 Airport Road",
      "city": "Franklin",
      "cityCode": "FKL",
      "stateCode": "PA",
      "postalCode": "16323",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ008",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.379167,
      "longitude": -79.859722,
      "elevationFeet": 1540,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FKL?codeType=fs"
     },
     {
      "fs": "FLD",
      "iata": "FLD",
      "icao": "KFLD",
      "faa": "FLD",
      "name": "Fond Du Lac County Airport",
      "city": "Fond Du Lac",
      "cityCode": "FLD",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 43.771198,
      "longitude": -88.488403,
      "elevationFeet": 809,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLD?codeType=fs"
     },
     {
      "fs": "FLG",
      "iata": "FLG",
      "icao": "KFLG",
      "faa": "FLG",
      "name": "Flagstaff Pulliam Airport",
      "street1": "6200 South Pulliam Drive 204",
      "city": "Flagstaff",
      "cityCode": "GCN",
      "stateCode": "AZ",
      "postalCode": "86001",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ015",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 35.137778,
      "longitude": -111.671667,
      "elevationFeet": 7014,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLG?codeType=fs"
     },
     {
      "fs": "FLO",
      "iata": "FLO",
      "icao": "KFLO",
      "faa": "FLO",
      "name": "Florence Airport",
      "street1": "2100 Terminal Drive",
      "street2": "",
      "city": "Florence",
      "cityCode": "FLO",
      "stateCode": "SC",
      "postalCode": "29501",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "SCZ032",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 34.188889,
      "longitude": -79.724444,
      "elevationFeet": 146,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLO?codeType=fs"
     },
     {
      "fs": "FMH",
      "iata": "FMH",
      "icao": "KFMH",
      "faa": "FMH",
      "name": "Otis Air Force Base",
      "city": "Falmouth",
      "cityCode": "FMH",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.666667,
      "longitude": -70.55,
      "elevationFeet": 131,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FMH?codeType=fs"
     },
     {
      "fs": "FMN",
      "iata": "FMN",
      "icao": "KFMN",
      "faa": "FMN",
      "name": "Four Corners Regional Airport",
      "street1": "1300 W Navajo St",
      "city": "Farmington",
      "cityCode": "FMN",
      "stateCode": "NM",
      "postalCode": "87401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 36.741111,
      "longitude": -108.229167,
      "elevationFeet": 5506,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FMN?codeType=fs"
     },
     {
      "fs": "FMY",
      "iata": "FMY",
      "icao": "KFMY",
      "faa": "FMY",
      "name": "Page Field",
      "city": "Fort Myers",
      "cityCode": "FMY",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ065",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 26.587888,
      "longitude": -81.860809,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FMY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FMY?codeType=fs"
     },
     {
      "fs": "FNL",
      "iata": "FNL",
      "icao": "KFNL",
      "faa": "FNL",
      "name": "Fort Collins/Loveland Municipal Airport",
      "city": "Fort Collins/Loveland",
      "cityCode": "FNL",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 40.448322,
      "longitude": -105.008459,
      "elevationFeet": 5011,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FNL?codeType=fs"
     },
     {
      "fs": "FNT",
      "iata": "FNT",
      "icao": "KFNT",
      "faa": "FNT",
      "name": "Bishop International Airport",
      "street1": "G-3425 West Bristol Road",
      "city": "Flint",
      "cityCode": "FNT",
      "stateCode": "MI",
      "postalCode": "48507-3110",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ061",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.973812,
      "longitude": -83.738904,
      "elevationFeet": 782,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FNT?codeType=fs"
     },
     {
      "fs": "FOD",
      "iata": "FOD",
      "icao": "KFOD",
      "faa": "FOD",
      "name": "Fort Dodge Airport",
      "city": "Fort Dodge",
      "cityCode": "FOD",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ035",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 42.5525,
      "longitude": -94.189722,
      "elevationFeet": 1157,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FOD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FOD?codeType=fs"
     },
     {
      "fs": "FOE",
      "iata": "FOE",
      "icao": "KFOE",
      "faa": "FOE",
      "name": "Forbes Field",
      "city": "Topeka",
      "cityCode": "TOP",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 38.9525,
      "longitude": -95.6625,
      "elevationFeet": 1078,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FOE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FOE?codeType=fs"
     },
     {
      "fs": "FOK",
      "iata": "FOK",
      "icao": "KFOK",
      "faa": "FOK",
      "name": "Francis S. Gabreski Airport",
      "city": "Westhampton Beach",
      "cityCode": "FOK",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.841888,
      "longitude": -72.631994,
      "elevationFeet": 55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FOK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FOK?codeType=fs"
     },
     {
      "fs": "FPR",
      "iata": "FPR",
      "icao": "KFPR",
      "faa": "FPR",
      "name": "Saint Lucie County Airport",
      "city": "Fort Pierce",
      "cityCode": "FPR",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ059",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 27.4951,
      "longitude": -80.368301,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FPR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FPR?codeType=fs"
     },
     {
      "fs": "FRD",
      "iata": "FRD",
      "icao": "KFHR",
      "faa": "FHR",
      "name": "Friday Harbor Airport",
      "city": "Friday Harbor",
      "cityCode": "FRD",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 48.524807,
      "longitude": -123.026499,
      "elevationFeet": 113,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRD?codeType=fs"
     },
     {
      "fs": "FRG",
      "iata": "FRG",
      "icao": "KFRG",
      "faa": "FRG",
      "name": "Republic Airport",
      "city": "Farmingdale",
      "cityCode": "FRG",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.728802,
      "longitude": -73.413399,
      "elevationFeet": 67,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRG?codeType=fs"
     },
     {
      "fs": "FRR",
      "iata": "FRR",
      "icao": "KFRR",
      "faa": "FRR",
      "name": "Front Royal-Warren County Airport",
      "city": "Front Royal",
      "cityCode": "FRR",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.918174,
      "longitude": -78.2541,
      "elevationFeet": 698,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRR?codeType=fs"
     },
     {
      "fs": "FRY",
      "iata": "FRY",
      "icao": "KIZG",
      "faa": "IZG",
      "name": "Eastern Slopes Regional Airport",
      "city": "Fryeburg",
      "cityCode": "FRY",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 43.992982,
      "longitude": -70.941378,
      "elevationFeet": 428,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRY?codeType=fs"
     },
     {
      "fs": "FSM",
      "iata": "FSM",
      "icao": "KFSM",
      "faa": "FSM",
      "name": "Fort Smith Regional Airport",
      "city": "Fort Smith",
      "cityCode": "FSM",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ029",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 35.34124,
      "longitude": -94.3589,
      "elevationFeet": 469,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FSM?codeType=fs"
     },
     {
      "fs": "FTW",
      "iata": "FTW",
      "icao": "KFTW",
      "faa": "FTW",
      "name": "Fort Worth Meacham International Airport",
      "city": "Fort Worth",
      "cityCode": "FTW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.816769,
      "longitude": -97.356687,
      "elevationFeet": 684,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FTW?codeType=fs"
     },
     {
      "fs": "FUL",
      "iata": "FUL",
      "icao": "KFUL",
      "faa": "FUL",
      "name": "Fullerton Municipal Airport",
      "city": "Fullerton",
      "cityCode": "FUL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 33.872626,
      "longitude": -117.974253,
      "elevationFeet": 93,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FUL?codeType=fs"
     },
     {
      "fs": "FWH",
      "iata": "FWH",
      "icao": "KNFW",
      "faa": "NFW",
      "name": "Fort Worth Naval Air Station Joint Reserve Base",
      "city": "Fort Worth",
      "cityCode": "FTW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.771494,
      "longitude": -97.427781,
      "elevationFeet": 610,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FWH?codeType=fs"
     },
     {
      "fs": "FXE",
      "iata": "FXE",
      "icao": "KFXE",
      "faa": "FXE",
      "name": "Fort Lauderdale Executive Airport",
      "city": "Fort Lauderdale",
      "cityCode": "FLL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ072",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 26.19659,
      "longitude": -80.171517,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FXE?codeType=fs"
     },
     {
      "fs": "FYU",
      "iata": "FYU",
      "icao": "PFYU",
      "faa": "PFYU",
      "name": "Fort Yukon Airport",
      "city": "Fort Yukon",
      "cityCode": "FYU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 66.567918,
      "longitude": -145.258136,
      "elevationFeet": 433,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FYU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FYU?codeType=fs"
     },
     {
      "fs": "FYV",
      "iata": "FYV",
      "icao": "KFYV",
      "faa": "FYV",
      "name": "Drake Field",
      "street1": "4500 South School Avenue, Suite F",
      "city": "Fayetteville",
      "cityCode": "FYV",
      "stateCode": "AR",
      "postalCode": "72701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ010",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 36.003611,
      "longitude": -94.17,
      "elevationFeet": 1251,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FYV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FYV?codeType=fs"
     },
     {
      "fs": "GAI",
      "iata": "GAI",
      "icao": "KGAI",
      "faa": "GAI",
      "name": "Montgomery County Airpark",
      "city": "Gaithersburg",
      "cityCode": "GAI",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.168301,
      "longitude": -77.166,
      "elevationFeet": 508,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAI?codeType=fs"
     },
     {
      "fs": "GAL",
      "iata": "GAL",
      "icao": "PAGA",
      "faa": "PAGA",
      "name": "Edward G. Pitka Sr. Airport",
      "city": "Galena",
      "cityCode": "GAL",
      "stateCode": "AK",
      "postalCode": "99741",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ216",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.73609,
      "longitude": -156.936112,
      "elevationFeet": 128,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAL?codeType=fs"
     },
     {
      "fs": "GAM",
      "iata": "GAM",
      "icao": "PAGM",
      "faa": "PAGM",
      "name": "Gambell Airport",
      "city": "Gambell",
      "cityCode": "GAM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ213",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 63.776596,
      "longitude": -171.713546,
      "elevationFeet": 27,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAM?codeType=fs"
     },
     {
      "fs": "GBD",
      "iata": "GBD",
      "icao": "KGBD",
      "faa": "GBD",
      "name": "Great Bend Airport",
      "street1": "",
      "street2": "",
      "city": "Great Bend",
      "cityCode": "GBD",
      "stateCode": "KS",
      "postalCode": "67530",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ047",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 38.347222,
      "longitude": -98.864167,
      "elevationFeet": 1887,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GBD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GBD?codeType=fs"
     },
     {
      "fs": "GCC",
      "iata": "GCC",
      "icao": "KGCC",
      "faa": "GCC",
      "name": "Campbell County Airport",
      "street1": "2000, Airport Road 28",
      "street2": "",
      "city": "Gillette",
      "cityCode": "GCC",
      "stateCode": "WY",
      "postalCode": "82716",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ054",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 44.346356,
      "longitude": -105.532684,
      "elevationFeet": 4363,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GCC?codeType=fs"
     },
     {
      "fs": "GCK",
      "iata": "GCK",
      "icao": "KGCK",
      "faa": "GCK",
      "name": "Garden City Municipal Airport",
      "street1": "2225 South Air Service Road 112",
      "street2": "",
      "city": "Garden City",
      "cityCode": "GCK",
      "stateCode": "KS",
      "postalCode": "67846",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ063",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 37.928611,
      "longitude": -100.729722,
      "elevationFeet": 2890,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GCK?codeType=fs"
     },
     {
      "fs": "GCN",
      "iata": "GCN",
      "icao": "KGCN",
      "faa": "GCN",
      "name": "Grand Canyon National Park Airport",
      "city": "Grand Canyon",
      "cityCode": "GCN",
      "stateCode": "AZ",
      "postalCode": "86023",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ007",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 35.951944,
      "longitude": -112.1475,
      "elevationFeet": 6606,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GCN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GCN?codeType=fs"
     },
     {
      "fs": "GDC",
      "iata": "GDC",
      "icao": "KGYH",
      "faa": "GYH",
      "name": "Donaldson Field",
      "city": "Greenville",
      "cityCode": "GSP",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 34.758311,
      "longitude": -82.376428,
      "elevationFeet": 939,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GDC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GDC?codeType=fs"
     },
     {
      "fs": "GDV",
      "iata": "GDV",
      "icao": "KGDV",
      "faa": "GDV",
      "name": "Dawson Community Airport",
      "city": "Glendive",
      "cityCode": "GDV",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ025",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 47.138889,
      "longitude": -104.806944,
      "elevationFeet": 2456,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GDV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GDV?codeType=fs"
     },
     {
      "fs": "GED",
      "iata": "GED",
      "icao": "KGED",
      "faa": "GED",
      "name": "Sussex County Airport",
      "city": "Georgetown",
      "cityCode": "GED",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.688333,
      "longitude": -75.3575,
      "elevationFeet": 50,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GED?codeType=fs"
     },
     {
      "fs": "GFL",
      "iata": "GFL",
      "icao": "KGFL",
      "faa": "GFL",
      "name": "Floyd Bennett Memorial Airport",
      "city": "Glens Falls",
      "cityCode": "GFL",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 43.341388,
      "longitude": -73.608812,
      "elevationFeet": 321,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GFL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GFL?codeType=fs"
     },
     {
      "fs": "GGE",
      "iata": "GGE",
      "icao": "KGGE",
      "faa": "GGE",
      "name": "Georgetown Airport",
      "city": "Georgetown",
      "cityCode": "GGE",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 33.383333,
      "longitude": -79.283333,
      "elevationFeet": 39,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GGE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GGE?codeType=fs"
     },
     {
      "fs": "GGG",
      "iata": "GGG",
      "icao": "KGGG",
      "faa": "GGG",
      "name": "Gregg County Airport",
      "street1": "",
      "street2": "",
      "city": "Longview",
      "cityCode": "GGG",
      "stateCode": "TX",
      "postalCode": "75603",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ137",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.386667,
      "longitude": -94.715278,
      "elevationFeet": 365,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GGG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GGG?codeType=fs"
     },
     {
      "fs": "GGW",
      "iata": "GGW",
      "icao": "KGGW",
      "faa": "GGW",
      "name": "Glasgow International Airport",
      "city": "Glasgow",
      "cityCode": "GGW",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ017",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 48.212778,
      "longitude": -106.615556,
      "elevationFeet": 2294,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GGW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GGW?codeType=fs"
     },
     {
      "fs": "GLD",
      "iata": "GLD",
      "icao": "KGLD",
      "faa": "GLD",
      "name": "Goodland Municipal Airport",
      "city": "Goodland",
      "cityCode": "GLD",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 39.370278,
      "longitude": -101.699444,
      "elevationFeet": 3656,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLD?codeType=fs"
     },
     {
      "fs": "GLH",
      "iata": "GLH",
      "icao": "KGLH",
      "faa": "GLH",
      "name": "Greenville Airport",
      "street1": "166 Fifth Ave. # 300",
      "street2": "",
      "city": "Greenville",
      "cityCode": "GLH",
      "stateCode": "MS",
      "postalCode": "38701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ034",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 33.484444,
      "longitude": -90.985,
      "elevationFeet": 131,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLH?codeType=fs"
     },
     {
      "fs": "GLR",
      "iata": "GLR",
      "icao": "KGLR",
      "faa": "GLR",
      "name": "Gaylord Regional Airport",
      "city": "Gaylord",
      "cityCode": "GLR",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 45.014539,
      "longitude": -84.701407,
      "elevationFeet": 1323,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLR?codeType=fs"
     },
     {
      "fs": "GLV",
      "iata": "GLV",
      "icao": "",
      "faa": "N93",
      "name": "Golovin Airport",
      "city": "Golovin",
      "cityCode": "GLV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ210",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.544167,
      "longitude": -163.0375,
      "elevationFeet": 69,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLV?codeType=fs"
     },
     {
      "fs": "GMU",
      "iata": "GMU",
      "icao": "KGMU",
      "faa": "GMU",
      "name": "Greenville Downtown Airport",
      "city": "Greenville",
      "cityCode": "GSP",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 34.85,
      "longitude": -82.383333,
      "elevationFeet": 1048,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GMU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GMU?codeType=fs"
     },
     {
      "fs": "GNU",
      "iata": "GNU",
      "icao": "",
      "faa": "GNU",
      "name": "Goodnews Bay Airport",
      "city": "Goodnews Bay",
      "cityCode": "GNU",
      "stateCode": "AK",
      "postalCode": "99589",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.1125,
      "longitude": -161.580556,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GNU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GNU?codeType=fs"
     },
     {
      "fs": "GNV",
      "iata": "GNV",
      "icao": "KGNV",
      "faa": "GNV",
      "name": "Gainesville Regional Airport",
      "street1": "3400 Northeast 39th Avenue",
      "street2": "",
      "city": "Gainesville",
      "cityCode": "GNV",
      "stateCode": "FL",
      "postalCode": "32609",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ036",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 29.686142,
      "longitude": -82.276797,
      "elevationFeet": 152,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GNV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GNV?codeType=fs"
     },
     {
      "fs": "GON",
      "iata": "GON",
      "icao": "KGON",
      "faa": "GON",
      "name": "Groton-New London Airport",
      "street1": "155 Tower Avenue",
      "city": "New London",
      "cityCode": "GON",
      "stateCode": "CT",
      "postalCode": "06340",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "CTZ012",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.328889,
      "longitude": -72.046389,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GON?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GON?codeType=fs"
     },
     {
      "fs": "GPT",
      "iata": "GPT",
      "icao": "KGPT",
      "faa": "GPT",
      "name": "Gulfport-Biloxi International Airport",
      "street1": "14035 Airport Road",
      "city": "Gulfport",
      "cityCode": "GPT",
      "stateCode": "MS",
      "postalCode": "39503",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ081",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.413284,
      "longitude": -89.072029,
      "elevationFeet": 28,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GPT?codeType=fs"
     },
     {
      "fs": "GPZ",
      "iata": "GPZ",
      "icao": "KGPZ",
      "faa": "GPZ",
      "name": "Grand Rapids - Itsaca County Airport",
      "street1": "1500, 7th Avenue Southeast",
      "city": "Grand Rapids",
      "cityCode": "GPZ",
      "stateCode": "MN",
      "postalCode": "55744",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ026",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 47.214444,
      "longitude": -93.511111,
      "elevationFeet": 1297,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GPZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GPZ?codeType=fs"
     },
     {
      "fs": "GRF",
      "iata": "GRF",
      "icao": "KGRF",
      "faa": "GRF",
      "name": "Gray Army Air Field",
      "city": "Tacoma",
      "cityCode": "TIW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 47.079226,
      "longitude": -122.58081,
      "elevationFeet": 298,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRF?codeType=fs"
     },
     {
      "fs": "GRI",
      "iata": "GRI",
      "icao": "KGRI",
      "faa": "GRI",
      "name": "Grand Island Airport",
      "street1": "3743 Sky Park Road",
      "street2": "",
      "city": "Grand Island",
      "cityCode": "GRI",
      "stateCode": "NE",
      "postalCode": "68801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ062",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 40.967222,
      "longitude": -98.306667,
      "elevationFeet": 1847,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRI?codeType=fs"
     },
     {
      "fs": "GRK",
      "iata": "GRK",
      "icao": "KGRK",
      "faa": "GRK",
      "name": "Robert Gray Army Airfield",
      "city": "Killeen",
      "cityCode": "ILE",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ158",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 31.061821,
      "longitude": -97.820914,
      "elevationFeet": 1015,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRK?codeType=fs"
     },
     {
      "fs": "GRN",
      "iata": "GRN",
      "icao": "KGRN",
      "faa": "GRN",
      "name": "Gordon Airport",
      "city": "Gordon",
      "cityCode": "GRN",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 42.802229,
      "longitude": -102.178694,
      "elevationFeet": 3549,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRN?codeType=fs"
     },
     {
      "fs": "GSH",
      "iata": "GSH",
      "icao": "KGSH",
      "faa": "GSH",
      "name": "Goshen Municipal Airport",
      "city": "Goshen",
      "cityCode": "GSH",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.526402,
      "longitude": -85.7929,
      "elevationFeet": 823,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GSH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GSH?codeType=fs"
     },
     {
      "fs": "GST",
      "iata": "GST",
      "icao": "PAGS",
      "faa": "PAGS",
      "name": "Gustavus Airport",
      "city": "Gustavus",
      "cityCode": "GST",
      "stateCode": "AK",
      "postalCode": "99826",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ021",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.423275,
      "longitude": -135.703687,
      "elevationFeet": 36,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GST?codeType=fs"
     },
     {
      "fs": "GTF",
      "iata": "GTF",
      "icao": "KGTF",
      "faa": "GTF",
      "name": "Great Falls International Airport",
      "street1": "2800 Terminal Drive",
      "city": "Great Falls",
      "cityCode": "GTF",
      "stateCode": "MT",
      "postalCode": "59404-5599",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ012",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 47.481889,
      "longitude": -111.35636,
      "elevationFeet": 3677,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GTF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GTF?codeType=fs"
     },
     {
      "fs": "GTR",
      "iata": "GTR",
      "icao": "KGTR",
      "faa": "GTR",
      "name": "Golden Triangle Regional Airport",
      "street1": "2080 Airport Road, Highway 82 West",
      "street2": "",
      "city": "Columbus",
      "cityCode": "UBS",
      "stateCode": "MS",
      "postalCode": "39701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ031",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 33.45,
      "longitude": -88.6,
      "elevationFeet": 264,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GTR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GTR?codeType=fs"
     },
     {
      "fs": "GUC",
      "iata": "GUC",
      "icao": "KGUC",
      "faa": "GUC",
      "name": "Gunnison Airport",
      "street1": "",
      "street2": "",
      "city": "Gunnison",
      "cityCode": "GUC",
      "stateCode": "CO",
      "postalCode": "81230",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ014",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 38.533889,
      "longitude": -106.938889,
      "elevationFeet": 7678,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GUC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GUC?codeType=fs"
     },
     {
      "fs": "GUF",
      "iata": "GUF",
      "icao": "KJKA",
      "faa": "JKA",
      "name": "Jack Edwards Airport",
      "city": "Gulf Shores",
      "cityCode": "GUF",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.28962,
      "longitude": -87.672884,
      "elevationFeet": 18,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GUF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GUF?codeType=fs"
     },
     {
      "fs": "GUP",
      "iata": "GUP",
      "icao": "KGUP",
      "faa": "GUP",
      "name": "Gallup Municipal Airport",
      "street1": "2111 West, Highway 66",
      "city": "Gallup",
      "cityCode": "GUP",
      "stateCode": "NM",
      "postalCode": "87305",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ505",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 35.511111,
      "longitude": -108.786667,
      "elevationFeet": 6472,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GUP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GUP?codeType=fs"
     },
     {
      "fs": "GUY",
      "iata": "GUY",
      "icao": "KGUY",
      "faa": "GUY",
      "name": "Guymon Municipal Airport",
      "city": "Guymon",
      "cityCode": "GUY",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 36.682778,
      "longitude": -101.507778,
      "elevationFeet": 3123,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GUY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GUY?codeType=fs"
     },
     {
      "fs": "GVT",
      "iata": "GVT",
      "icao": "KGVT",
      "faa": "GVT",
      "name": "Majors Field",
      "city": "Greenville",
      "cityCode": "GVT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 33.066667,
      "longitude": -96.061667,
      "elevationFeet": 535,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GVT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GVT?codeType=fs"
     },
     {
      "fs": "GXY",
      "iata": "GXY",
      "icao": "KGXY",
      "faa": "GXY",
      "name": "Greeley-Weld County Airport",
      "city": "Greeley",
      "cityCode": "GXY",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 40.427756,
      "longitude": -104.636865,
      "elevationFeet": 4649,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GXY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GXY?codeType=fs"
     },
     {
      "fs": "GYR",
      "iata": "GYR",
      "icao": "KGYR",
      "faa": "GYR",
      "name": "Phoenix Goodyear Airport",
      "city": "Goodyear",
      "cityCode": "GYR",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 33.426837,
      "longitude": -112.367078,
      "elevationFeet": 958,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GYR?codeType=fs"
     },
     {
      "fs": "GYY",
      "icao": "KGYY",
      "faa": "GYY",
      "name": "Gary/Chicago International Airport",
      "city": "Gary",
      "cityCode": "GYY",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 41.616667,
      "longitude": -87.416667,
      "elevationFeet": 592,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GYY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GYY?codeType=fs"
     },
     {
      "fs": "HAE",
      "iata": "HAE",
      "icao": "",
      "faa": "",
      "name": "Havasupai Airport",
      "city": "Havasupai",
      "cityCode": "HAE",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 36.230556,
      "longitude": -112.669444,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAE?codeType=fs"
     },
     {
      "fs": "HAO",
      "iata": "HAO",
      "icao": "KHAO",
      "faa": "HAO",
      "name": "Butler County Regional Airport",
      "city": "Hamilton",
      "cityCode": "HAO",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.363777,
      "longitude": -84.521987,
      "elevationFeet": 611,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAO?codeType=fs"
     },
     {
      "fs": "HAR",
      "iata": "HAR",
      "icao": "KCXY",
      "faa": "CXY",
      "name": "Harrisburg Capital City Airport",
      "city": "Harrisburg",
      "cityCode": "HAR",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.217089,
      "longitude": -76.851483,
      "elevationFeet": 339,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAR?codeType=fs"
     },
     {
      "fs": "HBG",
      "iata": "HBG",
      "icao": "KHBG",
      "faa": "HBG",
      "name": "Bobby L. Chain Municipal Airport",
      "city": "Hattiesburg",
      "cityCode": "HBG",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 31.316667,
      "longitude": -89.266667,
      "elevationFeet": 151,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HBG?codeType=fs"
     },
     {
      "fs": "HCA",
      "iata": "HCA",
      "icao": "",
      "faa": "",
      "name": "Howard County Airport",
      "city": "Big Spring",
      "cityCode": "HCA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.303611,
      "longitude": -101.433889,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HCA?codeType=fs"
     },
     {
      "fs": "HCC",
      "iata": "HCC",
      "icao": "",
      "faa": "1B1",
      "name": "Columbia County Airport",
      "city": "Hudson",
      "cityCode": "HCC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.293056,
      "longitude": -73.710556,
      "elevationFeet": 197,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HCC?codeType=fs"
     },
     {
      "fs": "HCR",
      "iata": "HCR",
      "icao": "PAHC",
      "faa": "HCA",
      "name": "Holy Cross Airport",
      "city": "Holy Cross",
      "cityCode": "HCR",
      "stateCode": "AK",
      "postalCode": "99602",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ215",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 62.190694,
      "longitude": -159.773472,
      "elevationFeet": 69,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HCR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HCR?codeType=fs"
     },
     {
      "fs": "HDN",
      "iata": "HDN",
      "icao": "KHDN",
      "faa": "HDN",
      "name": "Yampa Valley Airport",
      "street1": "11005 Routt County Road 51A",
      "street2": "",
      "city": "Hayden",
      "cityCode": "HDN",
      "stateCode": "CO",
      "postalCode": "81639",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ002",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 40.484808,
      "longitude": -107.220766,
      "elevationFeet": 6602,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HDN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HDN?codeType=fs"
     },
     {
      "fs": "HES",
      "iata": "HES",
      "icao": "KHRI",
      "faa": "HRI",
      "name": "State Airport",
      "city": "Hermiston",
      "cityCode": "HES",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 45.85,
      "longitude": -119.283333,
      "elevationFeet": 644,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HES?codeType=fs"
     },
     {
      "fs": "HFD",
      "iata": "HFD",
      "icao": "KHFD",
      "faa": "HFD",
      "name": "Brainard Airport",
      "city": "Hartford",
      "cityCode": "HFD",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "CTZ002",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.733056,
      "longitude": -72.65,
      "elevationFeet": 19,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HFD?codeType=fs"
     },
     {
      "fs": "HGR",
      "iata": "HGR",
      "icao": "KHGR",
      "faa": "HGR",
      "name": "Wash. County Regional Airport",
      "street1": "18434 Showalter Road",
      "street2": "",
      "city": "Hagerstown",
      "cityCode": "HGR",
      "stateCode": "MD",
      "postalCode": "21742",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MDZ003",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.707778,
      "longitude": -77.73,
      "elevationFeet": 703,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HGR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HGR?codeType=fs"
     },
     {
      "fs": "HHH",
      "iata": "HHH",
      "icao": "KHXD",
      "faa": "HXD",
      "name": "Hilton Head Airport",
      "street1": "120 Beach City Road",
      "city": "Hilton Head",
      "cityCode": "HHH",
      "stateCode": "SC",
      "postalCode": "29926",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "SCZ048",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 32.22263,
      "longitude": -80.697013,
      "elevationFeet": 59,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HHH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HHH?codeType=fs"
     },
     {
      "fs": "HHR",
      "iata": "HHR",
      "icao": "KHHR",
      "faa": "HHR",
      "name": "Hawthorne Municipal Airport",
      "city": "Hawthorne",
      "cityCode": "HHR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 33.922007,
      "longitude": -118.335229,
      "elevationFeet": 61,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HHR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HHR?codeType=fs"
     },
     {
      "fs": "HIB",
      "iata": "HIB",
      "icao": "KHIB",
      "faa": "HIB",
      "name": "Chisholm Airport",
      "street1": "11038 East Highway 37",
      "street2": "",
      "city": "Hibbing",
      "cityCode": "HIB",
      "stateCode": "MN",
      "postalCode": "55746",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ019",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 47.388611,
      "longitude": -92.838611,
      "elevationFeet": 1353,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HIB?codeType=fs"
     },
     {
      "fs": "HIE",
      "iata": "HIE",
      "icao": "KHIE",
      "faa": "HIE",
      "name": "Mount Washington Regional Airport",
      "city": "Whitefield",
      "cityCode": "HIE",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 44.365833,
      "longitude": -71.548611,
      "elevationFeet": 1074,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HIE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HIE?codeType=fs"
     },
     {
      "fs": "HII",
      "iata": "HII",
      "icao": "KHII",
      "faa": "HII",
      "name": "Lake Havasu City Municipal Airport",
      "street1": "5600 North Highway 95",
      "city": "Lake Havasu City",
      "cityCode": "HII",
      "stateCode": "AZ",
      "postalCode": "86404",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ002",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 34.569693,
      "longitude": -114.359729,
      "elevationFeet": 735,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HII?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HII?codeType=fs"
     },
     {
      "fs": "HIO",
      "iata": "HIO",
      "icao": "KHIO",
      "faa": "HIO",
      "name": "Portland Hillsboro Airport",
      "city": "Hillsboro",
      "cityCode": "HIO",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ006",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 45.516667,
      "longitude": -122.983333,
      "elevationFeet": 204,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HIO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HIO?codeType=fs"
     },
     {
      "fs": "HKB",
      "iata": "HKB",
      "icao": "",
      "faa": "",
      "name": "Healy Lake Airport",
      "city": "Healy Lake",
      "cityCode": "HKB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ223",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 63.866667,
      "longitude": -148.966667,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HKB?codeType=fs"
     },
     {
      "fs": "HKS",
      "iata": "HKS",
      "icao": "KHKS",
      "faa": "HKS",
      "name": "Hawkins Field",
      "city": "Jackson",
      "cityCode": "JAN",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.333676,
      "longitude": -90.222295,
      "elevationFeet": 313,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HKS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HKS?codeType=fs"
     },
     {
      "fs": "HLN",
      "iata": "HLN",
      "icao": "KHLN",
      "faa": "HLN",
      "name": "Helena Regional Airport",
      "street1": "2850 Mercer Loop",
      "city": "Helena",
      "cityCode": "HLN",
      "stateCode": "MT",
      "postalCode": "59601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ014",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 46.610518,
      "longitude": -111.990182,
      "elevationFeet": 3874,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLN?codeType=fs"
     },
     {
      "fs": "HNC",
      "iata": "HNC",
      "icao": "KHSE",
      "faa": "HSE",
      "name": "Hatteras Airport",
      "city": "Hatteras",
      "cityCode": "HNC",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 35.2328,
      "longitude": -75.617798,
      "elevationFeet": 17,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNC?codeType=fs"
     },
     {
      "fs": "HNH",
      "iata": "HNH",
      "icao": "PAOH",
      "faa": "PAOH",
      "name": "Hoonah Airport",
      "city": "Hoonah",
      "cityCode": "HNH",
      "stateCode": "AK",
      "postalCode": "99829",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ021",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.098569,
      "longitude": -135.411807,
      "elevationFeet": 30,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNH?codeType=fs"
     },
     {
      "fs": "HNM",
      "iata": "HNM",
      "icao": "PHHN",
      "faa": "PHHN",
      "name": "Hana Airport",
      "city": "Hana",
      "cityCode": "HNM",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ003",
      "localTime": "2022-11-09T02:41:39.664",
      "utcOffsetHours": -10,
      "latitude": 20.795833,
      "longitude": -156.018889,
      "elevationFeet": 78,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNM?codeType=fs"
     },
     {
      "fs": "HNS",
      "iata": "HNS",
      "icao": "PAHN",
      "faa": "",
      "name": "Haines Municipal Airport",
      "city": "Haines",
      "cityCode": "HNS",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ024",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.246197,
      "longitude": -135.529234,
      "elevationFeet": 31,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNS?codeType=fs"
     },
     {
      "fs": "HOB",
      "iata": "HOB",
      "icao": "KHOB",
      "faa": "HOB",
      "name": "Lea County Airport",
      "city": "Hobbs",
      "cityCode": "HOB",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ033",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 32.688611,
      "longitude": -103.216944,
      "elevationFeet": 3661,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HOB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HOB?codeType=fs"
     },
     {
      "fs": "HOM",
      "iata": "HOM",
      "icao": "PAHO",
      "faa": "PAHO",
      "name": "Homer Airport",
      "street1": "2336 Kachemak Drive",
      "street2": "",
      "city": "Homer",
      "cityCode": "HOM",
      "stateCode": "AK",
      "postalCode": "99603",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ121",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.643241,
      "longitude": -151.493161,
      "elevationFeet": 84,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HOM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HOM?codeType=fs"
     },
     {
      "fs": "HON",
      "iata": "HON",
      "icao": "KHON",
      "faa": "HON",
      "name": "Howes Airport",
      "street1": "",
      "street2": "",
      "city": "Huron",
      "cityCode": "HON",
      "stateCode": "SD",
      "postalCode": "57350",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "SDZ038",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 44.383611,
      "longitude": -98.226389,
      "elevationFeet": 1289,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HON?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HON?codeType=fs"
     },
     {
      "fs": "HOP",
      "iata": "HOP",
      "icao": "KHOP",
      "faa": "HOP",
      "name": "Campbell Army Airfield",
      "city": "Hopkinsville",
      "cityCode": "HOP",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 36.672079,
      "longitude": -87.488868,
      "elevationFeet": 562,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HOP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HOP?codeType=fs"
     },
     {
      "fs": "HOT",
      "iata": "HOT",
      "icao": "KHOT",
      "faa": "HOT",
      "name": "Memorial Field",
      "city": "Hot Springs",
      "cityCode": "HOT",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ042",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 34.478889,
      "longitude": -93.096111,
      "elevationFeet": 540,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HOT?codeType=fs"
     },
     {
      "fs": "HPB",
      "iata": "HPB",
      "icao": "PAHP",
      "faa": "PAHP",
      "name": "Hooper Bay Airport",
      "city": "Hooper Bay",
      "cityCode": "HPB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 61.525077,
      "longitude": -166.14586,
      "elevationFeet": 18,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HPB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HPB?codeType=fs"
     },
     {
      "fs": "HQM",
      "iata": "HQM",
      "icao": "KHQM",
      "faa": "HQM",
      "name": "Bowerman Airport",
      "city": "Hoquiam",
      "cityCode": "HQM",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 46.971111,
      "longitude": -123.935556,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HQM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HQM?codeType=fs"
     },
     {
      "fs": "HRL",
      "iata": "HRL",
      "icao": "KHRL",
      "faa": "HRL",
      "name": "Valley International Airport",
      "street1": "3002 Heritage Way",
      "city": "Harlingen",
      "cityCode": "HRL",
      "stateCode": "TX",
      "postalCode": "78550",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ255",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 26.223483,
      "longitude": -97.662253,
      "elevationFeet": 36,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HRL?codeType=fs"
     },
     {
      "fs": "HRO",
      "iata": "HRO",
      "icao": "KHRO",
      "faa": "HRO",
      "name": "Boone County Airport",
      "city": "Harrison",
      "cityCode": "HRO",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ003",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 36.264468,
      "longitude": -93.154259,
      "elevationFeet": 1347,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HRO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HRO?codeType=fs"
     },
     {
      "fs": "HSH",
      "iata": "HSH",
      "icao": "KHND",
      "faa": "HND",
      "name": "Henderson Executive Airport",
      "city": "Las Vegas",
      "cityCode": "LAS",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 35.973171,
      "longitude": -115.134188,
      "elevationFeet": 2442,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HSH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HSH?codeType=fs"
     },
     {
      "fs": "HSI",
      "iata": "HSI",
      "icao": "KHSI",
      "faa": "HSI",
      "name": "Hastings Airport",
      "city": "Hastings",
      "cityCode": "HSI",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 40.605556,
      "longitude": -98.426944,
      "elevationFeet": 1961,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HSI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HSI?codeType=fs"
     },
     {
      "fs": "HSL",
      "iata": "HSL",
      "icao": "PAHS",
      "faa": "PAHS",
      "name": "Huslia Airport",
      "city": "Huslia",
      "cityCode": "HSL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ216",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 65.7025,
      "longitude": -156.375,
      "elevationFeet": 180,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HSL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HSL?codeType=fs"
     },
     {
      "fs": "HSP",
      "iata": "HSP",
      "icao": "KHSP",
      "faa": "HSP",
      "name": "Ingalls Field",
      "city": "Hot Springs",
      "cityCode": "HSP",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 37.950556,
      "longitude": -79.833889,
      "elevationFeet": 3792,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HSP?codeType=fs"
     },
     {
      "fs": "HTO",
      "iata": "HTO",
      "icao": "KHTO",
      "faa": "HTO",
      "name": "East Hampton Airport",
      "city": "East Hampton",
      "cityCode": "HTO",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.959444,
      "longitude": -72.251667,
      "elevationFeet": 56,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HTO?codeType=fs"
     },
     {
      "fs": "HTS",
      "iata": "HTS",
      "icao": "KHTS",
      "faa": "HTS",
      "name": "Tri-State/Milton Airport",
      "street1": "1449 Airport Road",
      "street2": "",
      "city": "Huntington",
      "cityCode": "HTS",
      "stateCode": "WV",
      "postalCode": "25704",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ006",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.366944,
      "longitude": -82.556111,
      "elevationFeet": 828,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HTS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HTS?codeType=fs"
     },
     {
      "fs": "HUJ",
      "iata": "HUJ",
      "icao": "KHHW",
      "faa": "HHW",
      "name": "Hugo Airport",
      "city": "Hugo",
      "cityCode": "HUJ",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 34.016667,
      "longitude": -95.516667,
      "elevationFeet": 571,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUJ?codeType=fs"
     },
     {
      "fs": "HUM",
      "iata": "HUM",
      "icao": "KHUM",
      "faa": "HUM",
      "name": "Houma-Terrebonne Airport",
      "city": "Houma",
      "cityCode": "HUM",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 29.566944,
      "longitude": -90.660833,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUM?codeType=fs"
     },
     {
      "fs": "HUS",
      "iata": "HUS",
      "icao": "",
      "faa": "HUS",
      "name": "Hughes Municipal Airport",
      "city": "Hughes",
      "cityCode": "HUS",
      "stateCode": "AK",
      "postalCode": "99745",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ219",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 66.040556,
      "longitude": -154.263333,
      "elevationFeet": 289,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUS?codeType=fs"
     },
     {
      "fs": "HVN",
      "iata": "HVN",
      "icao": "KHVN",
      "faa": "HVN",
      "name": "New Haven Airport",
      "street1": "155 Burr Street",
      "street2": "",
      "city": "New Haven",
      "cityCode": "HVN",
      "stateCode": "CT",
      "postalCode": "06512",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "CTZ010",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.265278,
      "longitude": -72.888333,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HVN?codeType=fs"
     },
     {
      "fs": "HVR",
      "iata": "HVR",
      "icao": "KHVR",
      "faa": "HVR",
      "name": "Havre City County Airport",
      "city": "Havre",
      "cityCode": "HVR",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ011",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 48.544444,
      "longitude": -109.761111,
      "elevationFeet": 2590,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HVR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HVR?codeType=fs"
     },
     {
      "fs": "HWD",
      "iata": "HWD",
      "icao": "KHWD",
      "faa": "HWD",
      "name": "Hayward Executive Airport",
      "city": "Hayward",
      "cityCode": "HWD",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 37.659199,
      "longitude": -122.122002,
      "elevationFeet": 31,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HWD?codeType=fs"
     },
     {
      "fs": "HYG",
      "iata": "HYG",
      "icao": "",
      "faa": "",
      "name": "Hydaburg Sea Plane Base",
      "city": "Hydaburg",
      "cityCode": "HYG",
      "stateCode": "AK",
      "postalCode": "99922",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ028",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 55.205246,
      "longitude": -132.829184,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HYG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HYG?codeType=fs"
     },
     {
      "fs": "HYL",
      "iata": "HYL",
      "icao": "",
      "faa": "",
      "name": "Hollis Seaplane Base",
      "city": "Hollis",
      "cityCode": "HYL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ028",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 55.491016,
      "longitude": -132.622499,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HYL?codeType=fs"
     },
     {
      "fs": "HYR",
      "iata": "HYR",
      "icao": "KHYR",
      "faa": "HYR",
      "name": "Hayward Municipal Airport",
      "city": "Hayward",
      "cityCode": "HYR",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 46.024444,
      "longitude": -91.444444,
      "elevationFeet": 1214,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HYR?codeType=fs"
     },
     {
      "fs": "HYS",
      "iata": "HYS",
      "icao": "KHYS",
      "faa": "HYS",
      "name": "Hays Municipal Airport",
      "street1": "",
      "street2": "",
      "city": "Hays",
      "cityCode": "HYS",
      "stateCode": "KS",
      "postalCode": "67601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ031",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 38.846111,
      "longitude": -99.274167,
      "elevationFeet": 1998,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HYS?codeType=fs"
     },
     {
      "fs": "I39",
      "iata": "",
      "icao": "",
      "faa": "I39",
      "name": "Madison Airport",
      "city": "Richmond",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 37.629706,
      "longitude": -84.330551,
      "elevationFeet": 980,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I39?codeType=fs"
     },
     {
      "fs": "IAB",
      "iata": "IAB",
      "icao": "KIAB",
      "faa": "IAB",
      "name": "McConnell Air Force Base",
      "city": "Wichita",
      "cityCode": "ICT",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 37.681139,
      "longitude": -97.276167,
      "elevationFeet": 1371,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IAB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IAB?codeType=fs"
     },
     {
      "fs": "IAG",
      "iata": "IAG",
      "icao": "KIAG",
      "faa": "IAG",
      "name": "Niagara Falls International Airport",
      "city": "Niagara Falls",
      "cityCode": "IAG",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 43.1,
      "longitude": -78.95,
      "elevationFeet": 590,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IAG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IAG?codeType=fs"
     },
     {
      "fs": "IAN",
      "iata": "IAN",
      "icao": "PAIK",
      "faa": "IAN",
      "name": "Bob Baker Memorial Airport",
      "city": "Kiana",
      "cityCode": "IAN",
      "stateCode": "AK",
      "postalCode": "99749",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ217",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 66.974752,
      "longitude": -160.441212,
      "elevationFeet": 173,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IAN?codeType=fs"
     },
     {
      "fs": "IDA",
      "iata": "IDA",
      "icao": "KIDA",
      "faa": "IDA",
      "name": "Idaho Falls Regional Airport",
      "street1": "2140 North Skyline",
      "city": "Idaho Falls",
      "cityCode": "IDA",
      "stateCode": "ID",
      "postalCode": "83402",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "IDZ020",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 43.514854,
      "longitude": -112.06751,
      "elevationFeet": 4740,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IDA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IDA?codeType=fs"
     },
     {
      "fs": "IDI",
      "iata": "IDI",
      "icao": "KIDI",
      "faa": "IDI",
      "name": "Indiana County Airport",
      "city": "Indiana",
      "cityCode": "IDI",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.632198,
      "longitude": -79.105499,
      "elevationFeet": 1381,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IDI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IDI?codeType=fs"
     },
     {
      "fs": "IFP",
      "iata": "IFP",
      "icao": "KIFP",
      "faa": "IFP",
      "name": "Laughlin Bullhead International Airport",
      "street1": "600 Hwy. 95",
      "city": "Bullhead City",
      "cityCode": "IFP",
      "stateCode": "AZ",
      "postalCode": "86429",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ036",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 35.157684,
      "longitude": -114.557624,
      "elevationFeet": 675,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IFP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IFP?codeType=fs"
     },
     {
      "fs": "IGG",
      "iata": "IGG",
      "icao": "",
      "faa": "IGG",
      "name": "Igiugig Airport",
      "city": "Igiugig",
      "cityCode": "IGG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.316667,
      "longitude": -155.9,
      "elevationFeet": 110,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IGG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IGG?codeType=fs"
     },
     {
      "fs": "IGM",
      "iata": "IGM",
      "icao": "KIGM",
      "faa": "IGM",
      "name": "Kingman Airport",
      "street1": "7000 Flightline Drive",
      "street2": "",
      "city": "Kingman",
      "cityCode": "IGM",
      "stateCode": "AZ",
      "postalCode": "86401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ003",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 35.256667,
      "longitude": -113.94,
      "elevationFeet": 3449,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IGM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IGM?codeType=fs"
     },
     {
      "fs": "IKO",
      "iata": "IKO",
      "icao": "",
      "faa": "",
      "name": "Nikolski Air Station",
      "city": "Nikolski",
      "cityCode": "IKO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 52.941667,
      "longitude": -168.85,
      "elevationFeet": 61,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IKO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IKO?codeType=fs"
     },
     {
      "fs": "ILG",
      "iata": "ILG",
      "icao": "KILG",
      "faa": "ILG",
      "name": "New Castle Airport",
      "city": "Wilmington",
      "cityCode": "ILG",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "DEZ001",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.678333,
      "longitude": -75.6075,
      "elevationFeet": 79,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ILG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ILG?codeType=fs"
     },
     {
      "fs": "ILI",
      "iata": "ILI",
      "icao": "PAIL",
      "faa": "PAIL",
      "name": "Iliamna Airport",
      "city": "Iliamna",
      "cityCode": "ILI",
      "stateCode": "AK",
      "postalCode": "99606",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.755502,
      "longitude": -154.908568,
      "elevationFeet": 207,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ILI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ILI?codeType=fs"
     },
     {
      "fs": "ILN",
      "iata": "ILN",
      "icao": "KILN",
      "faa": "ILN",
      "name": "Wilmington Airpark",
      "city": "Wilmington",
      "cityCode": "ILN",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.433342,
      "longitude": -83.791092,
      "elevationFeet": 1062,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ILN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ILN?codeType=fs"
     },
     {
      "fs": "IMT",
      "iata": "IMT",
      "icao": "KIMT",
      "faa": "IMT",
      "name": "Ford Airport",
      "street1": "",
      "street2": "",
      "city": "Iron Mountain",
      "cityCode": "IMT",
      "stateCode": "MI",
      "postalCode": "49801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MIZ011",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 45.815556,
      "longitude": -88.114167,
      "elevationFeet": 1182,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IMT?codeType=fs"
     },
     {
      "fs": "INL",
      "iata": "INL",
      "icao": "KINL",
      "faa": "INL",
      "name": "Falls International Airport",
      "street1": "Airport Drive",
      "street2": "",
      "city": "International Falls",
      "cityCode": "INL",
      "stateCode": "MN",
      "postalCode": "56649-8955",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ010",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 48.563056,
      "longitude": -93.404167,
      "elevationFeet": 1185,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/INL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/INL?codeType=fs"
     },
     {
      "fs": "INT",
      "iata": "INT",
      "icao": "KINT",
      "faa": "INT",
      "name": "Smith-Reynolds Airport",
      "street1": "",
      "street2": "",
      "city": "Winston-Salem",
      "cityCode": "INT",
      "stateCode": "NC",
      "postalCode": "27115",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ021",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 36.135278,
      "longitude": -80.225556,
      "elevationFeet": 969,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/INT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/INT?codeType=fs"
     },
     {
      "fs": "IPL",
      "iata": "IPL",
      "icao": "KIPL",
      "faa": "IPL",
      "name": "Imperial County Airport",
      "city": "Imperial",
      "cityCode": "IPL",
      "stateCode": "CA",
      "postalCode": "92251",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ033",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 32.834832,
      "longitude": -115.574054,
      "elevationFeet": -55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IPL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IPL?codeType=fs"
     },
     {
      "fs": "IPT",
      "iata": "IPT",
      "icao": "KIPT",
      "faa": "IPT",
      "name": "Lycoming County Airport",
      "street1": "700 Airport Road",
      "street2": "",
      "city": "Williamsport",
      "cityCode": "IPT",
      "stateCode": "PA",
      "postalCode": "17754",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ041",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.242222,
      "longitude": -76.920556,
      "elevationFeet": 529,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IPT?codeType=fs"
     },
     {
      "fs": "IRC",
      "iata": "IRC",
      "icao": "SCIR",
      "faa": "PACR",
      "name": "Circle City Airport",
      "city": "Circle",
      "cityCode": "IRC",
      "stateCode": "AK",
      "postalCode": "99733",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 65.829167,
      "longitude": -144.063889,
      "elevationFeet": 610,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IRC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IRC?codeType=fs"
     },
     {
      "fs": "IRK",
      "iata": "IRK",
      "icao": "KIRK",
      "faa": "IRK",
      "name": "Kirksville Municipal Airport",
      "city": "Kirksville",
      "cityCode": "IRK",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ017",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 40.0925,
      "longitude": -92.543889,
      "elevationFeet": 966,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IRK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IRK?codeType=fs"
     },
     {
      "fs": "ISM",
      "iata": "ISM",
      "icao": "KISM",
      "faa": "ISM",
      "name": "Kissimmee Gateway Airport",
      "city": "Kissimmee",
      "cityCode": "ISM",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 28.29093,
      "longitude": -81.435014,
      "elevationFeet": 79,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISM?codeType=fs"
     },
     {
      "fs": "ISN",
      "iata": "ISN",
      "icao": "KISN",
      "faa": "ISN",
      "name": "Sloulin Field International Airport",
      "city": "Williston",
      "cityCode": "ISN",
      "stateCode": "ND",
      "postalCode": "58801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ009",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 48.175867,
      "longitude": -103.631886,
      "elevationFeet": 1982,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISN?codeType=fs"
     },
     {
      "fs": "ISO",
      "iata": "ISO",
      "icao": "KISO",
      "faa": "ISO",
      "name": "Kinston Regional Jetport",
      "street1": "2780 Jetport Road, Suite 1",
      "city": "Kinston",
      "cityCode": "ISO",
      "stateCode": "NC",
      "postalCode": "28504",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ091",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 35.326667,
      "longitude": -77.616667,
      "elevationFeet": 94,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISO?codeType=fs"
     },
     {
      "fs": "ISS",
      "iata": "ISS",
      "icao": "KIWI",
      "faa": "IWI",
      "name": "Wiscasset Airport",
      "city": "Wiscasset",
      "cityCode": "ISS",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ025",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 43.961399,
      "longitude": -69.712601,
      "elevationFeet": 59,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISS?codeType=fs"
     },
     {
      "fs": "ISW",
      "iata": "ISW",
      "icao": "KISW",
      "faa": "ISW",
      "name": "South Wood County Airport",
      "city": "Wisconsin Rapids",
      "cityCode": "ISW",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 44.360278,
      "longitude": -89.838889,
      "elevationFeet": 1021,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISW?codeType=fs"
     },
     {
      "fs": "ITH",
      "iata": "ITH",
      "icao": "KITH",
      "faa": "ITH",
      "name": "Ithaca Tompkins Regional Airport",
      "street1": "1 Culligan Dr",
      "city": "Ithaca",
      "cityCode": "ITH",
      "stateCode": "NY",
      "postalCode": "14850",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ025",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.490342,
      "longitude": -76.463593,
      "elevationFeet": 1099,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ITH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ITH?codeType=fs"
     },
     {
      "fs": "IWD",
      "iata": "IWD",
      "icao": "KIWD",
      "faa": "IWD",
      "name": "Gogebic County Airport",
      "street1": "Airport Road",
      "street2": "",
      "city": "Ironwood",
      "cityCode": "IWD",
      "stateCode": "MI",
      "postalCode": "49938",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MIZ009",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 46.525556,
      "longitude": -90.131667,
      "elevationFeet": 1230,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IWD?codeType=fs"
     },
     {
      "fs": "IYK",
      "iata": "IYK",
      "icao": "KIYK",
      "faa": "IYK",
      "name": "Kern County Airport",
      "street1": "1669 Airport Road",
      "street2": "",
      "city": "Inyokern",
      "cityCode": "IYK",
      "stateCode": "CA",
      "postalCode": "93527",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ098",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 35.656667,
      "longitude": -117.829167,
      "elevationFeet": 2455,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IYK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IYK?codeType=fs"
     },
     {
      "fs": "JAC",
      "iata": "JAC",
      "icao": "KJAC",
      "faa": "JAC",
      "name": "Jackson Hole Airport",
      "city": "Jackson",
      "cityCode": "JAC",
      "stateCode": "WY",
      "postalCode": "83001",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ007",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 43.602807,
      "longitude": -110.736131,
      "elevationFeet": 6447,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JAC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JAC?codeType=fs"
     },
     {
      "fs": "JBR",
      "iata": "JBR",
      "icao": "KJBR",
      "faa": "JBR",
      "name": "Jonesboro Airport",
      "city": "Jonesboro",
      "cityCode": "JBR",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ026",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 35.831711,
      "longitude": -90.646418,
      "elevationFeet": 254,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JBR?codeType=fs"
     },
     {
      "fs": "JEF",
      "iata": "JEF",
      "icao": "KJEF",
      "faa": "JEF",
      "name": "Jefferson City Memorial Airport",
      "city": "Jefferson City",
      "cityCode": "JEF",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 38.592222,
      "longitude": -92.156389,
      "elevationFeet": 549,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JEF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JEF?codeType=fs"
     },
     {
      "fs": "JGC",
      "iata": "JGC",
      "icao": "",
      "faa": "",
      "name": "Grand Canyon Heliport",
      "city": "Grand Canyon",
      "cityCode": "GCN",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 35.960973,
      "longitude": -112.131427,
      "elevationFeet": 6682,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JGC?codeType=fs"
     },
     {
      "fs": "JHM",
      "iata": "JHM",
      "icao": "PHJH",
      "faa": "JHM",
      "name": "Kapalua Airport",
      "city": "Kapalua",
      "cityCode": "JHM",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ003",
      "localTime": "2022-11-09T02:41:39.664",
      "utcOffsetHours": -10,
      "latitude": 20.962194,
      "longitude": -156.675692,
      "elevationFeet": 256,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JHM?codeType=fs"
     },
     {
      "fs": "JHW",
      "iata": "JHW",
      "icao": "KJHW",
      "faa": "JHW",
      "name": "Jamestown Airport",
      "street1": "",
      "street2": "",
      "city": "Jamestown",
      "cityCode": "JHW",
      "stateCode": "NY",
      "postalCode": "14733",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ019",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.150556,
      "longitude": -79.258056,
      "elevationFeet": 1724,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JHW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JHW?codeType=fs"
     },
     {
      "fs": "JLN",
      "iata": "JLN",
      "icao": "KJLN",
      "faa": "JLN",
      "name": "Joplin Airport",
      "street1": "",
      "street2": "",
      "city": "Joplin",
      "cityCode": "JLN",
      "stateCode": "MO",
      "postalCode": "64801",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MOZ088",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 37.149722,
      "longitude": -94.497778,
      "elevationFeet": 981,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JLN?codeType=fs"
     },
     {
      "fs": "JMS",
      "iata": "JMS",
      "icao": "KJMS",
      "faa": "JMS",
      "name": "Jamestown Airport",
      "street1": "",
      "street2": "",
      "city": "Jamestown",
      "cityCode": "JMS",
      "stateCode": "ND",
      "postalCode": "58401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ037",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 46.93,
      "longitude": -98.678333,
      "elevationFeet": 1498,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JMS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JMS?codeType=fs"
     },
     {
      "fs": "JRF",
      "iata": "JRF",
      "icao": "PHJR",
      "faa": "",
      "name": "Kalaeloa Airport",
      "city": "Kapolei",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.664",
      "utcOffsetHours": -10,
      "latitude": 21.310984,
      "longitude": -158.079899,
      "elevationFeet": 31,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JRF?codeType=fs"
     },
     {
      "fs": "JST",
      "iata": "JST",
      "icao": "KJST",
      "faa": "JST",
      "name": "Cambria County Airport",
      "street1": "479 Airport Road, Suite 1",
      "street2": "",
      "city": "Johnstown",
      "cityCode": "JST",
      "stateCode": "PA",
      "postalCode": "15904-9438",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ024",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.316667,
      "longitude": -78.834444,
      "elevationFeet": 2284,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JST?codeType=fs"
     },
     {
      "fs": "JVI",
      "iata": "JVI",
      "icao": "",
      "faa": "47N",
      "name": "Central Jersey Regional Airport",
      "city": "Manville",
      "cityCode": "JVI",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.52444,
      "longitude": -74.59833,
      "elevationFeet": 73,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JVI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JVI?codeType=fs"
     },
     {
      "fs": "JXN",
      "iata": "JXN",
      "icao": "KJXN",
      "faa": "JXN",
      "name": "Jackson County Airport",
      "city": "Jackson",
      "cityCode": "JXN",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.258889,
      "longitude": -84.461389,
      "elevationFeet": 1001,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JXN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JXN?codeType=fs"
     },
     {
      "fs": "KAAO",
      "iata": "",
      "icao": "KAAO",
      "faa": "AAO",
      "name": "Colonel James Jabara Airport",
      "city": "Wichita",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 37.746304,
      "longitude": -97.219844,
      "elevationFeet": 1406,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAAO?codeType=fs"
     },
     {
      "fs": "KAE",
      "iata": "KAE",
      "icao": "",
      "faa": "KAE",
      "name": "Kake Sea Plane Base",
      "city": "Kake",
      "cityCode": "KAE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ026",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 56.973971,
      "longitude": -133.947951,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAE?codeType=fs"
     },
     {
      "fs": "KAL",
      "iata": "KAL",
      "icao": "",
      "faa": "",
      "name": "Kaltag Airport",
      "city": "Kaltag",
      "cityCode": "KAL",
      "stateCode": "AK",
      "postalCode": "99748",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ216",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.321944,
      "longitude": -158.736111,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAL?codeType=fs"
     },
     {
      "fs": "KANE",
      "iata": "",
      "icao": "KANE",
      "faa": "ANE",
      "name": "Anoka Co-Blaine",
      "city": "Minneapolis",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 45.145,
      "longitude": -93.211401,
      "elevationFeet": 912,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KANE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KANE?codeType=fs"
     },
     {
      "fs": "KASW",
      "iata": "",
      "icao": "KASW",
      "faa": "ASW",
      "name": "Warsaw Municipal Airport",
      "city": "Warsaw",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 41.278801,
      "longitude": -85.845768,
      "elevationFeet": 841,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KASW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KASW?codeType=fs"
     },
     {
      "fs": "KBC",
      "iata": "KBC",
      "icao": "",
      "faa": "Z91",
      "name": "Birch Creek Airport",
      "city": "Birch Creek",
      "cityCode": "KBC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 66.27592,
      "longitude": -145.812969,
      "elevationFeet": 438,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBC?codeType=fs"
     },
     {
      "fs": "KBIV",
      "iata": "",
      "icao": "KBIV",
      "faa": "BIV",
      "name": "West Michigan Regional Airport",
      "city": "Holland",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 42.743565,
      "longitude": -86.107908,
      "elevationFeet": 671,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBIV?codeType=fs"
     },
     {
      "fs": "KBKV",
      "iata": "",
      "icao": "KBKV",
      "faa": "BKV",
      "name": "Brooksville-Tampa Bay Regional Airport",
      "city": "Brooksville",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 28.474971,
      "longitude": -82.456046,
      "elevationFeet": 66,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBKV?codeType=fs"
     },
     {
      "fs": "KBUY",
      "iata": "",
      "icao": "KBUY",
      "faa": "BUY",
      "name": "Burlington-Alamance Regional Airport",
      "city": "Burlington",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 36.048103,
      "longitude": -79.476039,
      "elevationFeet": 608,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBUY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBUY?codeType=fs"
     },
     {
      "fs": "KCC",
      "iata": "KCC",
      "icao": "",
      "faa": "",
      "name": "Coffman Cove Sea Plane Base",
      "city": "Coffman Cove",
      "cityCode": "KCC",
      "stateCode": "AK",
      "postalCode": "99918",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ026",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 56.014853,
      "longitude": -132.836937,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCC?codeType=fs"
     },
     {
      "fs": "KCCO",
      "iata": "",
      "icao": "KCCO",
      "faa": "CCO",
      "name": "Newnan-Coweta County Airport",
      "city": "Newnan",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 33.31103,
      "longitude": -84.768902,
      "elevationFeet": 947,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCCO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCCO?codeType=fs"
     },
     {
      "fs": "KCG",
      "iata": "KCG",
      "icao": "",
      "faa": "",
      "name": "Chignik Fisheries Airport",
      "city": "Chignik",
      "cityCode": "KCQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ171",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 56.310833,
      "longitude": -158.373611,
      "elevationFeet": 49,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCG?codeType=fs"
     },
     {
      "fs": "KCJR",
      "iata": "",
      "icao": "KCJR",
      "faa": "CJR",
      "name": "Culpeper Regional Airport",
      "city": "Culpeper",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.525911,
      "longitude": -77.859832,
      "elevationFeet": 300,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCJR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCJR?codeType=fs"
     },
     {
      "fs": "KCKI",
      "iata": "",
      "icao": "KCKI",
      "faa": "CKI",
      "name": "Williamsburg Co",
      "city": "Kingstree",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 33.722222,
      "longitude": -79.919722,
      "elevationFeet": 67,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCKI?codeType=fs"
     },
     {
      "fs": "KCL",
      "iata": "KCL",
      "icao": "",
      "faa": "",
      "name": "Chignik Lagoon Airport",
      "city": "Chignik",
      "cityCode": "KCQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ171",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 56.308333,
      "longitude": -158.531944,
      "elevationFeet": 108,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCL?codeType=fs"
     },
     {
      "fs": "KCMA",
      "iata": "",
      "icao": "KCMA",
      "faa": "CMA",
      "name": "Camarillo Airport",
      "city": "Camarillo",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 34.213128,
      "longitude": -119.085059,
      "elevationFeet": 72,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCMA?codeType=fs"
     },
     {
      "fs": "KCPK",
      "iata": "",
      "icao": "KCPK",
      "faa": "CPK",
      "name": "Chesapeake Regional Airport",
      "city": "Chesapeake",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 36.664538,
      "longitude": -76.324376,
      "elevationFeet": 16,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCPK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCPK?codeType=fs"
     },
     {
      "fs": "KCQ",
      "iata": "KCQ",
      "icao": "PAJC",
      "faa": "PAJC",
      "name": "Chignik Lake Airport",
      "city": "Chignik",
      "cityCode": "KCQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ171",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 56.261111,
      "longitude": -158.777778,
      "elevationFeet": 18,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCQ?codeType=fs"
     },
     {
      "fs": "KCVX",
      "iata": "",
      "icao": "KCVX",
      "faa": "CVX",
      "name": "Charlevoix Municipal",
      "city": "Charlevoix",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 45.347778,
      "longitude": -85.347778,
      "elevationFeet": 670,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCVX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCVX?codeType=fs"
     },
     {
      "fs": "KCWF",
      "iata": "CWF",
      "icao": "KCWF",
      "faa": "CWF",
      "name": "Chennault International Airport",
      "city": "Lake Charles",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.220827,
      "longitude": -93.153193,
      "elevationFeet": 13,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCWF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCWF?codeType=fs"
     },
     {
      "fs": "KDLL",
      "iata": "",
      "icao": "KDLL",
      "faa": "DLL",
      "name": "Baraboo-Wisconsin Dells Airport",
      "city": "Baraboo",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 43.519639,
      "longitude": -89.772488,
      "elevationFeet": 985,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDLL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDLL?codeType=fs"
     },
     {
      "fs": "KDLZ",
      "iata": "",
      "icao": "KDLZ",
      "faa": "DLZ",
      "name": "Delaware Municipal",
      "city": "Delaware",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 40.397028,
      "longitude": -83.248028,
      "elevationFeet": 945,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDLZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDLZ?codeType=fs"
     },
     {
      "fs": "KEB",
      "iata": "KEB",
      "icao": "",
      "faa": "",
      "name": "Nanwalek Airport",
      "city": "Nanwalek",
      "cityCode": "KEB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.352778,
      "longitude": -151.922222,
      "elevationFeet": 27,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEB?codeType=fs"
     },
     {
      "fs": "KEFT",
      "iata": "",
      "icao": "KEFT",
      "faa": "EFT",
      "name": "Monroe Municipal Airport",
      "city": "Monroe",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 42.618118,
      "longitude": -89.594506,
      "elevationFeet": 1071,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEFT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEFT?codeType=fs"
     },
     {
      "fs": "KEH",
      "iata": "KEH",
      "icao": "",
      "faa": "S60",
      "name": "Kenmore Air Harbor Airport",
      "city": "Kenmore Air Harbor",
      "cityCode": "KEH",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 47.755,
      "longitude": -122.258056,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEH?codeType=fs"
     },
     {
      "fs": "KEK",
      "iata": "KEK",
      "icao": "",
      "faa": "KEK",
      "name": "Ekwok Airport",
      "city": "Ekwok",
      "cityCode": "KEK",
      "stateCode": "AK",
      "postalCode": "99580",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.35323,
      "longitude": -157.476514,
      "elevationFeet": 131,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEK?codeType=fs"
     },
     {
      "fs": "KEVB",
      "iata": "",
      "icao": "KEVB",
      "faa": "EVB",
      "name": "New Smyrna Beach Municipal Airport",
      "city": "New Smyrna Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 29.055728,
      "longitude": -81.945622,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEVB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEVB?codeType=fs"
     },
     {
      "fs": "KFME",
      "iata": "FME",
      "icao": "KFME",
      "faa": "FME",
      "name": "Tipton Airport",
      "city": "Fort Meade",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.0854,
      "longitude": -76.759399,
      "elevationFeet": 134,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFME?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFME?codeType=fs"
     },
     {
      "fs": "KFP",
      "iata": "KFP",
      "icao": "",
      "faa": "",
      "name": "False Pass Airport",
      "city": "False Pass",
      "cityCode": "KFP",
      "stateCode": "AK",
      "postalCode": "99583",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ181",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 54.849167,
      "longitude": -163.409167,
      "elevationFeet": 20,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFP?codeType=fs"
     },
     {
      "fs": "KGK",
      "iata": "KGK",
      "icao": "PAJZ",
      "faa": "JZZ",
      "name": "Koliganek Airport",
      "city": "Koliganek",
      "cityCode": "KGK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.726739,
      "longitude": -157.267107,
      "elevationFeet": 261,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGK?codeType=fs"
     },
     {
      "fs": "KGKY",
      "iata": "",
      "icao": "KGKY",
      "faa": "GKY",
      "name": "Arlington Municipal Airport",
      "city": "Arlington",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 32.664102,
      "longitude": -97.093473,
      "elevationFeet": 625,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGKY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGKY?codeType=fs"
     },
     {
      "fs": "KGMJ",
      "iata": "",
      "icao": "KGMJ",
      "faa": "GMJ",
      "name": "Grove Municipal",
      "city": "Grove",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 36.652694,
      "longitude": -94.785667,
      "elevationFeet": 833,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGMJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGMJ?codeType=fs"
     },
     {
      "fs": "KGNB",
      "iata": "",
      "icao": "KGNB",
      "faa": "GNB",
      "name": "Granby-Grand Co",
      "city": "Granby",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.664",
      "utcOffsetHours": -7,
      "latitude": 40.166528,
      "longitude": -105.922361,
      "elevationFeet": 8203,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGNB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGNB?codeType=fs"
     },
     {
      "fs": "KGTB",
      "iata": "",
      "icao": "KGTB",
      "faa": "GTB",
      "name": "Wheeler-Sack Aaf",
      "city": "Ft Drum",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 44.066667,
      "longitude": -75.766667,
      "elevationFeet": 691,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGTB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGTB?codeType=fs"
     },
     {
      "fs": "KGTU",
      "iata": "",
      "icao": "KGTU",
      "faa": "GTU",
      "name": "Georgetown Municipal",
      "city": "Georgetown",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.678801,
      "longitude": -97.679398,
      "elevationFeet": 790,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGTU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGTU?codeType=fs"
     },
     {
      "fs": "KGX",
      "iata": "KGX",
      "icao": "",
      "faa": "",
      "name": "Grayling Airport",
      "city": "Grayling",
      "cityCode": "KGX",
      "stateCode": "AK",
      "postalCode": "99590",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 62.895278,
      "longitude": -160.0625,
      "elevationFeet": 99,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGX?codeType=fs"
     },
     {
      "fs": "KGZS",
      "iata": "",
      "icao": "KGZS",
      "faa": "GZS",
      "name": "Abernathy Field",
      "city": "Pulaski",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 35.15023,
      "longitude": -87.053963,
      "elevationFeet": 656,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGZS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGZS?codeType=fs"
     },
     {
      "fs": "KHBZ",
      "iata": "",
      "icao": "KHBZ",
      "faa": "HBZ",
      "name": "Heber Springs Municipal Airport",
      "city": "Heber Springs",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 35.512671,
      "longitude": -92.012238,
      "elevationFeet": 631,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHBZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHBZ?codeType=fs"
     },
     {
      "fs": "KHDC",
      "iata": "",
      "icao": "KHDC",
      "faa": "HDC",
      "name": "Hammond Northshore Regional Airport",
      "city": "Hammond",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.521473,
      "longitude": -90.417262,
      "elevationFeet": 41,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHDC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHDC?codeType=fs"
     },
     {
      "fs": "KHDO",
      "iata": "",
      "icao": "KHDO",
      "faa": "HDO",
      "name": "South Texas Regional Airport at Hondo",
      "city": "Hondo",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 29.356616,
      "longitude": -99.171302,
      "elevationFeet": 918,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHDO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHDO?codeType=fs"
     },
     {
      "fs": "KHEG",
      "iata": "",
      "icao": "KHEG",
      "faa": "HEG",
      "name": "Herlong Recreational Airport",
      "city": "Jacksonville",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 30.279015,
      "longitude": -81.807792,
      "elevationFeet": 85,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHEG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHEG?codeType=fs"
     },
     {
      "fs": "KHLX",
      "iata": "",
      "icao": "KHLX",
      "faa": "HLX",
      "name": "Twin Co",
      "city": "Galax-Hillsville",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 36.911167,
      "longitude": -80.885667,
      "elevationFeet": 2693,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHLX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHLX?codeType=fs"
     },
     {
      "fs": "KHRJ",
      "iata": "",
      "icao": "KHRJ",
      "faa": "HRJ",
      "name": "Harnett Regional Jetport",
      "city": "Erwin",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 35.379687,
      "longitude": -78.731726,
      "elevationFeet": 193,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHRJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHRJ?codeType=fs"
     },
     {
      "fs": "KHSA",
      "iata": "",
      "icao": "KHSA",
      "faa": "HSA",
      "name": "Stennis International Airport",
      "city": "Bay St. Louis",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 30.371622,
      "longitude": -89.454045,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHSA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHSA?codeType=fs"
     },
     {
      "fs": "KIC",
      "iata": "KIC",
      "icao": "KKIC",
      "faa": "KIC",
      "name": "Mesa Del Rey Airport",
      "city": "King City",
      "cityCode": "KIC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.664",
      "utcOffsetHours": -8,
      "latitude": 36.228001,
      "longitude": -121.122002,
      "elevationFeet": 371,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIC?codeType=fs"
     },
     {
      "fs": "KIXD",
      "iata": "JCI",
      "icao": "KIXD",
      "faa": "IXD",
      "name": "New Century Aircenter",
      "city": "Kansas City",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 38.833932,
      "longitude": -94.892235,
      "elevationFeet": 1072,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIXD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIXD?codeType=fs"
     },
     {
      "fs": "KJES",
      "iata": "",
      "icao": "KJES",
      "faa": "JES",
      "name": "Jesup-Wayne County Airport",
      "city": "Jesup",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 31.554795,
      "longitude": -81.88409,
      "elevationFeet": 88,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJES?codeType=fs"
     },
     {
      "fs": "KJQF",
      "iata": "USA",
      "icao": "KJQF",
      "faa": "JQF",
      "name": "Concord Regional Airport",
      "city": "Concord",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 35.385139,
      "longitude": -80.71119,
      "elevationFeet": 662,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJQF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJQF?codeType=fs"
     },
     {
      "fs": "KJVY",
      "iata": "",
      "icao": "KJVY",
      "faa": "JVY",
      "name": "Clark Regional Airport",
      "city": "Jeffersonville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 38.376616,
      "longitude": -85.73292,
      "elevationFeet": 469,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJVY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJVY?codeType=fs"
     },
     {
      "fs": "KJWN",
      "iata": "",
      "icao": "KJWN",
      "faa": "JWN",
      "name": "John C. Tune Airport",
      "city": "Nashville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.664",
      "utcOffsetHours": -6,
      "latitude": 36.183136,
      "longitude": -86.88271,
      "elevationFeet": 469,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJWN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJWN?codeType=fs"
     },
     {
      "fs": "KJYO",
      "iata": "",
      "icao": "KJYO",
      "faa": "JYO",
      "name": "Leesburg Executive Airport",
      "city": "Leesburg",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 39.07672,
      "longitude": -77.555951,
      "elevationFeet": 384,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJYO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJYO?codeType=fs"
     },
     {
      "fs": "KJZI",
      "iata": "",
      "icao": "KJZI",
      "faa": "JZI",
      "name": "Charleston Executive Airport",
      "city": "Charleston",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.664",
      "utcOffsetHours": -5,
      "latitude": 32.703474,
      "longitude": -80.007064,
      "elevationFeet": 17,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJZI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJZI?codeType=fs"
     },
     {
      "fs": "KKA",
      "iata": "KKA",
      "icao": "PAKK",
      "faa": "PAKK",
      "name": "Koyuk Airport",
      "city": "Koyuk",
      "cityCode": "KKA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ210",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 64.939444,
      "longitude": -161.15,
      "elevationFeet": 120,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKA?codeType=fs"
     },
     {
      "fs": "KKB",
      "iata": "KKB",
      "icao": "",
      "faa": "",
      "name": "Kitui Bay Sea Plane Base",
      "city": "Kitui Bay",
      "cityCode": "KKB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.191033,
      "longitude": -152.370949,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKB?codeType=fs"
     },
     {
      "fs": "KKH",
      "iata": "KKH",
      "icao": "PADY",
      "faa": "PADY",
      "name": "Kongiganak Airport",
      "city": "Kongiganak",
      "cityCode": "KKH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 59.966667,
      "longitude": -162.75,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKH?codeType=fs"
     },
     {
      "fs": "KKI",
      "iata": "KKI",
      "icao": "",
      "faa": "Z13",
      "name": "Akiachak Sea Plane Base",
      "city": "Akiachak",
      "cityCode": "KKI",
      "stateCode": "AK",
      "postalCode": "99551",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 60.906944,
      "longitude": -161.422222,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKI?codeType=fs"
     },
     {
      "fs": "KKL",
      "iata": "KKL",
      "icao": "",
      "faa": "",
      "name": "Karluk Lake Sea Plane Base",
      "city": "Karluk Lake",
      "cityCode": "KKL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 57.366896,
      "longitude": -154.027619,
      "elevationFeet": 376,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKL?codeType=fs"
     },
     {
      "fs": "KKU",
      "iata": "KKU",
      "icao": "",
      "faa": "",
      "name": "Ekuk Airport",
      "city": "Ekuk",
      "cityCode": "KKU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.664",
      "utcOffsetHours": -9,
      "latitude": 58.8125,
      "longitude": -158.560556,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKU?codeType=fs"
     },
     {
      "fs": "KLCQ",
      "iata": "LCQ",
      "icao": "KLCQ",
      "faa": "LCQ",
      "name": "Lake City Gateway Airport",
      "city": "Lake City",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 30.181882,
      "longitude": -82.57529,
      "elevationFeet": 194,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLCQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLCQ?codeType=fs"
     },
     {
      "fs": "KLG",
      "iata": "KLG",
      "icao": "",
      "faa": "",
      "name": "Kalskag Municipal Airport",
      "city": "Kalskag",
      "cityCode": "KLG",
      "stateCode": "AK",
      "postalCode": "99607",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 61.532582,
      "longitude": -160.346503,
      "elevationFeet": 55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLG?codeType=fs"
     },
     {
      "fs": "KLL",
      "iata": "KLL",
      "icao": "",
      "faa": "",
      "name": "Levelock Airport",
      "city": "Levelock",
      "cityCode": "KLL",
      "stateCode": "AK",
      "postalCode": "99625",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 59.118611,
      "longitude": -156.863333,
      "elevationFeet": 60,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLL?codeType=fs"
     },
     {
      "fs": "KLN",
      "iata": "KLN",
      "icao": "",
      "faa": "2A3",
      "name": "Larsen Sea Plane Base",
      "city": "Larsen Bay",
      "cityCode": "KLN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 57.533333,
      "longitude": -154,
      "elevationFeet": 77,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLN?codeType=fs"
     },
     {
      "fs": "KLW",
      "iata": "KLW",
      "icao": "PAKW",
      "faa": "AKW",
      "name": "Klawock Airport",
      "city": "Klawock",
      "cityCode": "KLW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ028",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 55.555,
      "longitude": -133.1,
      "elevationFeet": 80,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLW?codeType=fs"
     },
     {
      "fs": "KLXT",
      "iata": "",
      "icao": "KLXT",
      "faa": "LXT",
      "name": "Lee's Summit Municipal Airport",
      "city": "Lee's Summit",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.677",
      "utcOffsetHours": -6,
      "latitude": 38.959728,
      "longitude": -94.369918,
      "elevationFeet": 1006,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLXT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLXT?codeType=fs"
     },
     {
      "fs": "KLZU",
      "iata": "",
      "icao": "KLZU",
      "faa": "LZU",
      "name": "Gwinnett County Airport at Briscoe Field",
      "city": "Lawrenceville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 33.980997,
      "longitude": -83.964209,
      "elevationFeet": 1031,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLZU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLZU?codeType=fs"
     },
     {
      "fs": "KMMV",
      "iata": "",
      "icao": "KMMV",
      "faa": "MMV",
      "name": "Mc Minnville Municipal",
      "city": "Mc Minnville",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.677",
      "utcOffsetHours": -8,
      "latitude": 45.195135,
      "longitude": -123.140802,
      "elevationFeet": 163,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMMV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMMV?codeType=fs"
     },
     {
      "fs": "KMO",
      "iata": "KMO",
      "icao": "PAMB",
      "faa": "MBA",
      "name": "Manokotak Airport",
      "city": "Manokotak",
      "cityCode": "KMO",
      "stateCode": "AK",
      "postalCode": "99628",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 58.990197,
      "longitude": -159.05002,
      "elevationFeet": 43,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMO?codeType=fs"
     },
     {
      "fs": "KMQJ",
      "iata": "",
      "icao": "KMQJ",
      "faa": "MQJ",
      "name": "Mt Comfort Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 39.843867,
      "longitude": -85.895118,
      "elevationFeet": 855,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMQJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMQJ?codeType=fs"
     },
     {
      "fs": "KMRJ",
      "iata": "",
      "icao": "KMRJ",
      "faa": "MRJ",
      "name": "Iowa County Airport",
      "city": "Mineral Point",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.677",
      "utcOffsetHours": -6,
      "latitude": 42.886975,
      "longitude": -90.232345,
      "elevationFeet": 1129,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMRJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMRJ?codeType=fs"
     },
     {
      "fs": "KMTV",
      "iata": "",
      "icao": "KMTV",
      "faa": "MTV",
      "name": "Blue Ridge Airport",
      "city": "Martinsville",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 36.631759,
      "longitude": -80.018775,
      "elevationFeet": 923,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMTV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMTV?codeType=fs"
     },
     {
      "fs": "KMY",
      "iata": "KMY",
      "icao": "",
      "faa": "",
      "name": "Moser Bay Seaplane Base",
      "city": "Moser Bay",
      "cityCode": "KMY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 57.025847,
      "longitude": -154.144537,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMY?codeType=fs"
     },
     {
      "fs": "KNBC",
      "icao": "KNBC",
      "name": "Beaufort MCAS",
      "city": "Beaufort",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 32.477402,
      "longitude": -80.723198,
      "elevationFeet": 37,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNBC?codeType=fs"
     },
     {
      "fs": "KNK",
      "iata": "KNK",
      "icao": "",
      "faa": "",
      "name": "Kokhanok Airport",
      "city": "Kokhanok",
      "cityCode": "KNK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 59.43462,
      "longitude": -154.798172,
      "elevationFeet": 106,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNK?codeType=fs"
     },
     {
      "fs": "KNKT",
      "iata": "",
      "icao": "KNKT",
      "faa": "NKT",
      "name": "Marine Corps Air Station Cherry Point",
      "city": "Cherry Point",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 34.903999,
      "longitude": -76.881463,
      "elevationFeet": 26,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNKT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNKT?codeType=fs"
     },
     {
      "fs": "KNUI",
      "iata": "",
      "icao": "KNUI",
      "faa": "NUI",
      "name": "Webster Olf",
      "city": "St Inigoes",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 38.15125,
      "longitude": -76.580056,
      "elevationFeet": 21,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNUI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNUI?codeType=fs"
     },
     {
      "fs": "KNW",
      "iata": "KNW",
      "icao": "PANW",
      "faa": "KNW",
      "name": "New Stuyahok Airport",
      "city": "New Stuyahok",
      "cityCode": "KNW",
      "stateCode": "AK",
      "postalCode": "99636",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 59.456321,
      "longitude": -157.374302,
      "elevationFeet": 372,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNW?codeType=fs"
     },
     {
      "fs": "KODO",
      "iata": "",
      "icao": "KODO",
      "faa": "ODO",
      "name": "Odessa-Schlemeyer",
      "city": "Odessa",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.677",
      "utcOffsetHours": -6,
      "latitude": 31.919891,
      "longitude": -102.391269,
      "elevationFeet": 3004,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KODO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KODO?codeType=fs"
     },
     {
      "fs": "KOQU",
      "iata": "",
      "icao": "KOQU",
      "faa": "OQU",
      "name": "Quonset State",
      "city": "North Kingstown",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.677",
      "utcOffsetHours": -5,
      "latitude": 41.721528,
      "longitude": -71.521528,
      "elevationFeet": 19,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOQU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOQU?codeType=fs"
     },
     {
      "fs": "KOT",
      "iata": "KOT",
      "icao": "",
      "faa": "2A9",
      "name": "Kotlik Airport",
      "city": "Kotlik",
      "cityCode": "KOT",
      "stateCode": "AK",
      "postalCode": "99620",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 63.031014,
      "longitude": -163.532307,
      "elevationFeet": 3,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOT?codeType=fs"
     },
     {
      "fs": "KOY",
      "iata": "KOY",
      "icao": "",
      "faa": "",
      "name": "Olga Bay Sea Plane Base",
      "city": "Olga Bay",
      "cityCode": "KOY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 57.162222,
      "longitude": -154.2275,
      "elevationFeet": 1,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOY?codeType=fs"
     },
     {
      "fs": "KOZ",
      "iata": "KOZ",
      "icao": "",
      "faa": "4K5",
      "name": "Ouzinkie Sea Plane Base",
      "city": "Ouzinkie",
      "cityCode": "KOZ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.677",
      "utcOffsetHours": -9,
      "latitude": 57.916667,
      "longitude": -152.5,
      "elevationFeet": 55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOZ?codeType=fs"
     },
     {
      "fs": "KOZW",
      "iata": "",
      "icao": "KOZW",
      "faa": "OZW",
      "name": "Livingston Co",
      "city": "Howell",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.745083,
      "longitude": -83.99175,
      "elevationFeet": 961,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOZW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOZW?codeType=fs"
     },
     {
      "fs": "KPB",
      "iata": "KPB",
      "icao": "",
      "faa": "",
      "name": "Point Baker Sea Plane Base",
      "city": "Point Baker",
      "cityCode": "KPB",
      "stateCode": "AK",
      "postalCode": "99927",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ026",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.351927,
      "longitude": -133.622355,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPB?codeType=fs"
     },
     {
      "fs": "KPBG",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Plattsburgh International",
      "city": "Plattsburgh",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.659417,
      "longitude": -73.481278,
      "elevationFeet": 235,
      "classification": 4,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPBG?codeType=fs"
     },
     {
      "fs": "KPBX",
      "iata": "PVL",
      "icao": "KPBX",
      "faa": "PBX",
      "name": "Pike County Airport",
      "city": "Pikeville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 37.559214,
      "longitude": -82.564639,
      "elevationFeet": 1465,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPBX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPBX?codeType=fs"
     },
     {
      "fs": "KPC",
      "iata": "KPC",
      "icao": "PAPC",
      "faa": "",
      "name": "Port Clarence Coast Guard Station",
      "city": "Port Clarence",
      "cityCode": "KPC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 65.25745,
      "longitude": -166.857533,
      "elevationFeet": 11,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPC?codeType=fs"
     },
     {
      "fs": "KPD",
      "iata": "KPD",
      "icao": "",
      "faa": "",
      "name": "King Of Prussia Airport",
      "city": "King of Prussia",
      "cityCode": "KPD",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.083333,
      "longitude": -75.4,
      "elevationFeet": 188,
      "classification": 4,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPD?codeType=fs"
     },
     {
      "fs": "KPN",
      "iata": "KPN",
      "icao": "PAKI",
      "faa": "PAKI",
      "name": "Kipnuk Sea Plane Base",
      "city": "Kipnuk",
      "cityCode": "KPN",
      "stateCode": "AK",
      "postalCode": "99614",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.933333,
      "longitude": -164.05,
      "elevationFeet": 11,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPN?codeType=fs"
     },
     {
      "fs": "KPNA",
      "iata": "PWY",
      "icao": "KPNA",
      "faa": "PNA",
      "name": "Ralph Wenz Field",
      "city": "Pinedale",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 42.796127,
      "longitude": -109.805519,
      "elevationFeet": 7085,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPNA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPNA?codeType=fs"
     },
     {
      "fs": "KPR",
      "iata": "KPR",
      "icao": "",
      "faa": "",
      "name": "Port Williams Sea Plane Base",
      "city": "Port Williams",
      "cityCode": "KPR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 58.490353,
      "longitude": -152.583316,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPR?codeType=fs"
     },
     {
      "fs": "KPTD",
      "iata": "",
      "icao": "KPTD",
      "faa": "PTD",
      "name": "Potsdam Municipal",
      "city": "Potsdam",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.766694,
      "longitude": -75.084472,
      "elevationFeet": 474,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPTD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPTD?codeType=fs"
     },
     {
      "fs": "KPV",
      "iata": "KPV",
      "icao": "",
      "faa": "AK5",
      "name": "Perryville Airport",
      "city": "Perryville",
      "cityCode": "KPV",
      "stateCode": "AK",
      "postalCode": "99648",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ181",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.909003,
      "longitude": -159.159249,
      "elevationFeet": 11,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPV?codeType=fs"
     },
     {
      "fs": "KPWC",
      "iata": "",
      "icao": "KPWC",
      "faa": "PWC",
      "name": "Pine River Regional",
      "city": "Pine River",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 46.797889,
      "longitude": -94.517,
      "elevationFeet": 1295,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPWC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPWC?codeType=fs"
     },
     {
      "fs": "KPY",
      "iata": "KPY",
      "icao": "",
      "faa": "",
      "name": "Port Bailey Sea Plane Base",
      "city": "Port Bailey",
      "cityCode": "KPY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.930713,
      "longitude": -153.039917,
      "elevationFeet": 1,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPY?codeType=fs"
     },
     {
      "fs": "KQA",
      "iata": "KQA",
      "icao": "",
      "faa": "",
      "name": "Akutan Airport",
      "city": "Akutan",
      "cityCode": "KQA",
      "stateCode": "AK",
      "postalCode": "99553",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ185",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 54.133333,
      "longitude": -165.783333,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KQA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KQA?codeType=fs"
     },
     {
      "fs": "KRNM",
      "iata": "",
      "icao": "KRNM",
      "faa": "RNM",
      "name": "Ramona Airport",
      "city": "Ramona",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 33.039226,
      "longitude": -116.915104,
      "elevationFeet": 1390,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRNM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRNM?codeType=fs"
     },
     {
      "fs": "KRUE",
      "iata": "",
      "icao": "KRUE",
      "faa": "RUE",
      "name": "Russellville Regional Airport",
      "city": "Russellville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 35.259149,
      "longitude": -93.093285,
      "elevationFeet": 379,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRUE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRUE?codeType=fs"
     },
     {
      "fs": "KRXE",
      "iata": "RXE",
      "icao": "KRXE",
      "faa": "RXE",
      "name": "Rexburg-Madison County Airport",
      "city": "Rexburg",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 43.833825,
      "longitude": -111.80542,
      "elevationFeet": 4864,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRXE?codeType=fs"
     },
     {
      "fs": "KSBO",
      "iata": "",
      "icao": "KSBO",
      "faa": "SBO",
      "name": "Emanuel County Airport",
      "city": "Swainsboro",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 32.611743,
      "longitude": -82.371396,
      "elevationFeet": 325,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSBO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSBO?codeType=fs"
     },
     {
      "fs": "KSCX",
      "iata": "",
      "icao": "KSCX",
      "faa": "SCX",
      "name": "Scott Municipal",
      "city": "Oneida",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 36.506944,
      "longitude": -84.6075,
      "elevationFeet": 1545,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSCX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSCX?codeType=fs"
     },
     {
      "fs": "KSM",
      "iata": "KSM",
      "icao": "PASM",
      "faa": "PASM",
      "name": "Saint Mary's Airport",
      "city": "Saint Mary's",
      "cityCode": "KSM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 62.058667,
      "longitude": -163.294894,
      "elevationFeet": 311,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSM?codeType=fs"
     },
     {
      "fs": "KSNH",
      "iata": "",
      "icao": "KSNH",
      "faa": "SNH",
      "name": "Savannah Hardin County Airport",
      "city": "Savannah",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 35.169977,
      "longitude": -88.215612,
      "elevationFeet": 466,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSNH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSNH?codeType=fs"
     },
     {
      "fs": "KTB",
      "iata": "KTB",
      "icao": "",
      "faa": "",
      "name": "Thorne Bay Sea Plane Base",
      "city": "Thorne Bay",
      "cityCode": "KTB",
      "stateCode": "AK",
      "postalCode": "99919",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ027",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.688091,
      "longitude": -132.535025,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTB?codeType=fs"
     },
     {
      "fs": "KTKI",
      "iata": "",
      "icao": "KTKI",
      "faa": "TKI",
      "name": "McKinney National Airport",
      "city": "McKinney",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 33.177461,
      "longitude": -96.588871,
      "elevationFeet": 574,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTKI?codeType=fs"
     },
     {
      "fs": "KTS",
      "iata": "KTS",
      "icao": "",
      "faa": "",
      "name": "Brevig Mission Airport",
      "city": "Teller Mission",
      "cityCode": "KTS",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ213",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 65.329444,
      "longitude": -166.471667,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTS?codeType=fs"
     },
     {
      "fs": "KTTA",
      "iata": "",
      "icao": "KTTA",
      "faa": "TTA",
      "name": "Raleigh Exec Jetport at Sanford-Lee County",
      "city": "Sanford",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 35.583157,
      "longitude": -79.10078,
      "elevationFeet": 228,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTTA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTTA?codeType=fs"
     },
     {
      "fs": "KTYQ",
      "iata": "",
      "icao": "KTYQ",
      "faa": "TYQ",
      "name": "Indianapolis Executive Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.037179,
      "longitude": -86.252711,
      "elevationFeet": 919,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTYQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTYQ?codeType=fs"
     },
     {
      "fs": "KUAO",
      "iata": "",
      "icao": "KUAO",
      "faa": "UAO",
      "name": "Aurora State",
      "city": "Aurora",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 45.245767,
      "longitude": -122.770326,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUAO?codeType=fs"
     },
     {
      "fs": "KUK",
      "iata": "KUK",
      "icao": "",
      "faa": "Z09",
      "name": "Kasigluk Airport",
      "city": "Kasigluk",
      "cityCode": "KUK",
      "stateCode": "AK",
      "postalCode": "99609",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.876087,
      "longitude": -162.521245,
      "elevationFeet": 40,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUK?codeType=fs"
     },
     {
      "fs": "KUMP",
      "iata": "",
      "icao": "KUMP",
      "faa": "UMP",
      "name": "Indianapolis Metropolitan Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.934684,
      "longitude": -86.04598,
      "elevationFeet": 796,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUMP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUMP?codeType=fs"
     },
     {
      "fs": "KVC",
      "iata": "KVC",
      "icao": "",
      "faa": "",
      "name": "King Cove Airport",
      "city": "King Cove",
      "cityCode": "KVC",
      "stateCode": "AK",
      "postalCode": "99612",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ181",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.055,
      "longitude": -162.313333,
      "elevationFeet": 155,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVC?codeType=fs"
     },
     {
      "fs": "KVCB",
      "iata": "",
      "icao": "KVCB",
      "faa": "VCB",
      "name": "Nut Tree",
      "city": "Vacaville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.378211,
      "longitude": -121.961198,
      "elevationFeet": 114,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVCB?codeType=fs"
     },
     {
      "fs": "KVL",
      "iata": "KVL",
      "icao": "",
      "faa": "",
      "name": "Kivalina Airport",
      "city": "Kivalina",
      "cityCode": "KVL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ207",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 67.731667,
      "longitude": -164.547222,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVL?codeType=fs"
     },
     {
      "fs": "KVTA",
      "iata": "",
      "icao": "KVTA",
      "faa": "VTA",
      "name": "Newark Heath Airport",
      "city": "Newark",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.023839,
      "longitude": -82.46318,
      "elevationFeet": 876,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVTA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVTA?codeType=fs"
     },
     {
      "fs": "KWF",
      "iata": "KWF",
      "icao": "",
      "faa": "",
      "name": "Waterfall Sea Plane Base",
      "city": "Waterfall",
      "cityCode": "KWF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.295644,
      "longitude": -133.243742,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KWF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KWF?codeType=fs"
     },
     {
      "fs": "KWK",
      "iata": "KWK",
      "icao": "",
      "faa": "A85",
      "name": "Kwigillingok Airport",
      "city": "Kwigillingok",
      "cityCode": "KWK",
      "stateCode": "AK",
      "postalCode": "99622",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.833333,
      "longitude": -163.133333,
      "elevationFeet": 20,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KWK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KWK?codeType=fs"
     },
     {
      "fs": "KWN",
      "iata": "KWN",
      "icao": "PAQH",
      "faa": "AQH",
      "name": "Kwinhagak Airport",
      "city": "Quinhagak",
      "cityCode": "KWN",
      "stateCode": "AK",
      "postalCode": "99655",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.751235,
      "longitude": -161.840523,
      "elevationFeet": 26,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KWN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KWN?codeType=fs"
     },
     {
      "fs": "KWP",
      "iata": "KWP",
      "icao": "",
      "faa": "",
      "name": "West Point Village Sea Plane Base",
      "city": "West Point",
      "cityCode": "KWP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.770376,
      "longitude": -153.545131,
      "elevationFeet": 1,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KWP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KWP?codeType=fs"
     },
     {
      "fs": "KWT",
      "iata": "KWT",
      "icao": "",
      "faa": "",
      "name": "Kwethluk Airport",
      "city": "Kwethluk",
      "cityCode": "KWT",
      "stateCode": "AK",
      "postalCode": "99621",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.808889,
      "longitude": -161.4375,
      "elevationFeet": 28,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KWT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KWT?codeType=fs"
     },
     {
      "fs": "KXA",
      "iata": "KXA",
      "icao": "",
      "faa": "",
      "name": "Kasaan Sea Plane Base",
      "city": "Kasaan",
      "cityCode": "KXA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.537464,
      "longitude": -132.398326,
      "elevationFeet": 13,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KXA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KXA?codeType=fs"
     },
     {
      "fs": "KYK",
      "iata": "KYK",
      "icao": "PAKY",
      "faa": "PAKY",
      "name": "Karluk Airport",
      "city": "Karluk",
      "cityCode": "KYK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.566111,
      "longitude": -154.45,
      "elevationFeet": 137,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KYK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KYK?codeType=fs"
     },
     {
      "fs": "KYU",
      "iata": "KYU",
      "icao": "",
      "faa": "",
      "name": "Koyukuk Airport",
      "city": "Koyukuk",
      "cityCode": "KYU",
      "stateCode": "AK",
      "postalCode": "99754",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ216",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 64.878056,
      "longitude": -157.713056,
      "elevationFeet": 115,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KYU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KYU?codeType=fs"
     },
     {
      "fs": "KZB",
      "iata": "KZB",
      "icao": "",
      "faa": "",
      "name": "Zachar Bay Sea Plane Base",
      "city": "Zachar Bay",
      "cityCode": "KZB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.553398,
      "longitude": -153.747163,
      "elevationFeet": 5,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KZB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KZB?codeType=fs"
     },
     {
      "fs": "LAA",
      "iata": "LAA",
      "icao": "KLAA",
      "faa": "LAA",
      "name": "Lamar Municipal Airport",
      "city": "Lamar",
      "cityCode": "LAA",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 38.068611,
      "longitude": -102.690278,
      "elevationFeet": 3706,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAA?codeType=fs"
     },
     {
      "fs": "LAF",
      "iata": "LAF",
      "icao": "KLAF",
      "faa": "LAF",
      "name": "Purdue University Airport",
      "street1": "Terminal Building, Room 201",
      "city": "Lafayette",
      "cityCode": "LAF",
      "stateCode": "IN",
      "postalCode": "47906",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "INZ029",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.411944,
      "longitude": -86.933611,
      "elevationFeet": 606,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAF?codeType=fs"
     },
     {
      "fs": "LAL",
      "iata": "LAL",
      "icao": "KLAL",
      "faa": "LAL",
      "name": "Lakeland Municipal Airport",
      "city": "Lakeland",
      "cityCode": "LAL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 27.988889,
      "longitude": -82.014722,
      "elevationFeet": 142,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAL?codeType=fs"
     },
     {
      "fs": "LAM",
      "iata": "LAM",
      "icao": "KLAM",
      "faa": "LAM",
      "name": "Los Alamos Airport",
      "city": "Los Alamos",
      "cityCode": "LAM",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 35.880135,
      "longitude": -106.269054,
      "elevationFeet": 7133,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAM?codeType=fs"
     },
     {
      "fs": "LAR",
      "iata": "LAR",
      "icao": "KLAR",
      "faa": "LAR",
      "name": "General Brees Field",
      "street1": "555 General Brees Road",
      "street2": "",
      "city": "Laramie",
      "cityCode": "LAR",
      "stateCode": "WY",
      "postalCode": "82070",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ115",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 41.313611,
      "longitude": -105.673056,
      "elevationFeet": 7278,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAR?codeType=fs"
     },
     {
      "fs": "LAW",
      "iata": "LAW",
      "icao": "KLAW",
      "faa": "LAW",
      "name": "Lawton-Fort Sill Regional Airport",
      "street1": "3401 South 11th Street",
      "city": "Lawton",
      "cityCode": "LAW",
      "stateCode": "OK",
      "postalCode": "73502",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "OKZ038",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 34.569722,
      "longitude": -98.416111,
      "elevationFeet": 1110,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LAW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LAW?codeType=fs"
     },
     {
      "fs": "LBE",
      "iata": "LBE",
      "icao": "KLBE",
      "faa": "LBE",
      "name": "Westmoreland County Airport",
      "street1": "200 Pleasant Unity Road",
      "city": "Latrobe",
      "cityCode": "LBE",
      "stateCode": "PA",
      "postalCode": "15650-9549",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ030",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.272927,
      "longitude": -79.40855,
      "elevationFeet": 1146,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LBE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LBE?codeType=fs"
     },
     {
      "fs": "LBF",
      "iata": "LBF",
      "icao": "KLBF",
      "faa": "LBF",
      "name": "North Platte Regional Airport (Lee Bird Field)",
      "city": "North Platte",
      "cityCode": "LBF",
      "stateCode": "NE",
      "postalCode": "69101",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ059",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 41.126198,
      "longitude": -100.683984,
      "elevationFeet": 2766,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LBF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LBF?codeType=fs"
     },
     {
      "fs": "LBL",
      "iata": "LBL",
      "icao": "KLBL",
      "faa": "LBL",
      "name": "Mid-America Regional Airport",
      "city": "Liberal",
      "cityCode": "LBL",
      "stateCode": "KS",
      "postalCode": "67905-2199",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ086",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 37.044444,
      "longitude": -100.960556,
      "elevationFeet": 2883,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LBL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LBL?codeType=fs"
     },
     {
      "fs": "LBT",
      "iata": "LBT",
      "icao": "KLBT",
      "faa": "LBT",
      "name": "Lumberton Airport",
      "city": "Lumberton",
      "cityCode": "LBT",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 34.614039,
      "longitude": -79.06011,
      "elevationFeet": 126,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LBT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LBT?codeType=fs"
     },
     {
      "fs": "LCH",
      "iata": "LCH",
      "icao": "KLCH",
      "faa": "LCH",
      "name": "Lake Charles Regional Airport",
      "city": "Lake Charles",
      "cityCode": "LCH",
      "stateCode": "LA",
      "postalCode": "70607",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ041",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 30.123227,
      "longitude": -93.22105,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LCH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LCH?codeType=fs"
     },
     {
      "fs": "LCI",
      "iata": "LCI",
      "icao": "KLCI",
      "faa": "LCI",
      "name": "Laconia Municipal Airport",
      "city": "Laconia",
      "cityCode": "LCI",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.571389,
      "longitude": -71.421111,
      "elevationFeet": 545,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LCI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LCI?codeType=fs"
     },
     {
      "fs": "LDJ",
      "iata": "LDJ",
      "icao": "KLDJ",
      "faa": "LDJ",
      "name": "Linden Airport",
      "city": "Linden",
      "cityCode": "LDJ",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.616667,
      "longitude": -74.25,
      "elevationFeet": 23,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LDJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LDJ?codeType=fs"
     },
     {
      "fs": "LDM",
      "iata": "LDM",
      "icao": "KLDM",
      "faa": "LDM",
      "name": "Mason Co",
      "city": "Ludington",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.075333,
      "longitude": -86.479167,
      "elevationFeet": 645,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LDM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LDM?codeType=fs"
     },
     {
      "fs": "LEB",
      "iata": "LEB",
      "icao": "KLEB",
      "faa": "LEB",
      "name": "Lebanon Municipal Airport",
      "street1": "Airport Drive",
      "city": "Lebanon",
      "cityCode": "LEB",
      "stateCode": "NH",
      "postalCode": "03784",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NHZ005",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.629359,
      "longitude": -72.310007,
      "elevationFeet": 604,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LEB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LEB?codeType=fs"
     },
     {
      "fs": "LEE",
      "iata": "LEE",
      "icao": "KLEE",
      "faa": "LEE",
      "name": "Leesburg International Airport",
      "city": "Leesburg",
      "cityCode": "LEE",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 28.823099,
      "longitude": -81.808701,
      "elevationFeet": 70,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LEE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LEE?codeType=fs"
     },
     {
      "fs": "LEW",
      "iata": "LEW",
      "icao": "KLEW",
      "faa": "LEW",
      "name": "Auburn Lewiston Municipal Airport",
      "city": "Auburn",
      "cityCode": "LEW",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.0485,
      "longitude": -70.283501,
      "elevationFeet": 268,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LEW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LEW?codeType=fs"
     },
     {
      "fs": "LFI",
      "iata": "LFI",
      "icao": "KLFI",
      "faa": "LFI",
      "name": "Langley Air Force Base",
      "city": "Hampton",
      "cityCode": "PHF",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 37.078971,
      "longitude": -76.36109,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LFI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LFI?codeType=fs"
     },
     {
      "fs": "LFT",
      "iata": "LFT",
      "icao": "KLFT",
      "faa": "LFT",
      "name": "Lafayette Regional Airport",
      "street1": "200 Terminal Drive",
      "city": "Lafayette",
      "cityCode": "LFT",
      "stateCode": "LA",
      "postalCode": "70508",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ044",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 30.20851,
      "longitude": -91.99327,
      "elevationFeet": 42,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LFT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LFT?codeType=fs"
     },
     {
      "fs": "LGD",
      "iata": "LGD",
      "icao": "KLGD",
      "faa": "LGD",
      "name": "La Grande/Union County Airport",
      "city": "La Grande",
      "cityCode": "LGD",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 45.289722,
      "longitude": -118.005,
      "elevationFeet": 2717,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LGD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LGD?codeType=fs"
     },
     {
      "fs": "LGU",
      "iata": "LGU",
      "icao": "KLGU",
      "faa": "LGU",
      "name": "Cache Airport",
      "city": "Logan",
      "cityCode": "LGU",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 41.7875,
      "longitude": -111.855,
      "elevationFeet": 4454,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LGU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LGU?codeType=fs"
     },
     {
      "fs": "LKE",
      "iata": "LKE",
      "icao": "",
      "faa": "",
      "name": "Lake Union Sea Plane Base",
      "street1": "950 Westlake Avenue N.",
      "city": "Seattle",
      "cityCode": "SEA",
      "stateCode": "WA",
      "postalCode": "98109",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 47.628302,
      "longitude": -122.338988,
      "elevationFeet": 19,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LKE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LKE?codeType=fs"
     },
     {
      "fs": "LKP",
      "iata": "LKP",
      "icao": "KLKP",
      "faa": "LKP",
      "name": "Lake Placid Airport",
      "city": "Lake Placid",
      "cityCode": "LKP",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.2645,
      "longitude": -73.961899,
      "elevationFeet": 1745,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LKP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LKP?codeType=fs"
     },
     {
      "fs": "LKV",
      "iata": "LKV",
      "icao": "KLKV",
      "faa": "LKV",
      "name": "Lake County Airport",
      "city": "Lakeview",
      "cityCode": "LKV",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 42.166667,
      "longitude": -120.4,
      "elevationFeet": 4733,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LKV?codeType=fs"
     },
     {
      "fs": "LLX",
      "iata": "LLX",
      "icao": "",
      "faa": "6B8",
      "name": "Caledonia County Airport",
      "city": "Lyndonville",
      "cityCode": "LLX",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.569099,
      "longitude": -72.017998,
      "elevationFeet": 1167,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LLX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LLX?codeType=fs"
     },
     {
      "fs": "LMA",
      "iata": "LMA",
      "icao": "",
      "faa": "",
      "name": "Lake Minchumina Airport",
      "city": "Lake Minchumina",
      "cityCode": "LMA",
      "stateCode": "AK",
      "postalCode": "99757",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ221",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 63.883333,
      "longitude": -152.316667,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LMA?codeType=fs"
     },
     {
      "fs": "LMT",
      "iata": "LMT",
      "icao": "KLMT",
      "faa": "LMT",
      "name": "Crater Lake Klamath Regional Airport",
      "street1": "6775 Arnold Avenue",
      "city": "Klamath Falls",
      "cityCode": "LMT",
      "stateCode": "OR",
      "postalCode": "97603",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ029",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 42.163056,
      "longitude": -121.735833,
      "elevationFeet": 4095,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LMT?codeType=fs"
     },
     {
      "fs": "LNK",
      "iata": "LNK",
      "icao": "KLNK",
      "faa": "LNK",
      "name": "Lincoln Airport",
      "street1": "2400 West Adams Street",
      "city": "Lincoln",
      "cityCode": "LNK",
      "stateCode": "NE",
      "postalCode": "68524",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ066",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 40.846176,
      "longitude": -96.754707,
      "elevationFeet": 1219,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNK?codeType=fs"
     },
     {
      "fs": "LNR",
      "iata": "LNR",
      "icao": "KLNR",
      "faa": "LNR",
      "name": "Tri County Regional Airport",
      "city": "Lone Rock",
      "cityCode": "LNR",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 43.211908,
      "longitude": -90.182116,
      "elevationFeet": 717,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNR?codeType=fs"
     },
     {
      "fs": "LNS",
      "iata": "LNS",
      "icao": "KLNS",
      "faa": "LNS",
      "name": "Lancaster Airport",
      "street1": "500 Airport Road, Suite G",
      "street2": "",
      "city": "Lancaster",
      "cityCode": "LNS",
      "stateCode": "PA",
      "postalCode": "17543-9340",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ066",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.121111,
      "longitude": -76.299722,
      "elevationFeet": 403,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNS?codeType=fs"
     },
     {
      "fs": "LNY",
      "iata": "LNY",
      "icao": "PHNY",
      "faa": "PHNY",
      "name": "Lanai Airport",
      "street1": "1036 Lanai Ave.",
      "street2": "",
      "city": "Lanai",
      "cityCode": "LNY",
      "stateCode": "HI",
      "postalCode": "96763",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ006",
      "localTime": "2022-11-09T02:41:39.678",
      "utcOffsetHours": -10,
      "latitude": 20.790084,
      "longitude": -156.950481,
      "elevationFeet": 1308,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNY?codeType=fs"
     },
     {
      "fs": "LOL",
      "iata": "LOL",
      "icao": "KLOL",
      "faa": "LOL",
      "name": "Derby Field",
      "city": "Lovelock",
      "cityCode": "LOL",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 40.058333,
      "longitude": -118.566667,
      "elevationFeet": 3904,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOL?codeType=fs"
     },
     {
      "fs": "LOT",
      "iata": "LOT",
      "icao": "KLOT",
      "faa": "LOT",
      "name": "Lewis University Airport",
      "city": "Romeoville",
      "cityCode": "LOT",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 41.607476,
      "longitude": -88.09617,
      "elevationFeet": 664,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOT?codeType=fs"
     },
     {
      "fs": "LOU",
      "iata": "LOU",
      "icao": "KLOU",
      "faa": "LOU",
      "name": "Bowman Field",
      "city": "Louisville",
      "cityCode": "SDF",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 38.227275,
      "longitude": -85.656879,
      "elevationFeet": 524,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOU?codeType=fs"
     },
     {
      "fs": "LPS",
      "iata": "LPS",
      "icao": "",
      "faa": "S31",
      "name": "Lopez Island Airport",
      "city": "Lopez Island",
      "cityCode": "LPS",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 48.482778,
      "longitude": -122.935556,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LPS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LPS?codeType=fs"
     },
     {
      "fs": "LRD",
      "iata": "LRD",
      "icao": "KLRD",
      "faa": "LRD",
      "name": "Laredo International Airport",
      "street1": "5210 Bob Bullock Loop",
      "city": "Laredo",
      "cityCode": "LRD",
      "stateCode": "TX",
      "postalCode": "78041",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ239",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 27.543667,
      "longitude": -99.455122,
      "elevationFeet": 508,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LRD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LRD?codeType=fs"
     },
     {
      "fs": "LRU",
      "iata": "LRU",
      "icao": "KLRU",
      "faa": "LRU",
      "name": "Las Cruces Municipal Airport",
      "city": "Las Cruces",
      "cityCode": "LRU",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 32.290833,
      "longitude": -106.921667,
      "elevationFeet": 4456,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LRU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LRU?codeType=fs"
     },
     {
      "fs": "LSE",
      "iata": "LSE",
      "icao": "KLSE",
      "faa": "LSE",
      "name": "La Crosse Regional Airport",
      "street1": "2850 Airport Road",
      "city": "La Crosse",
      "cityCode": "LSE",
      "stateCode": "WI",
      "postalCode": "54601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ041",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 43.875245,
      "longitude": -91.264334,
      "elevationFeet": 654,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LSE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LSE?codeType=fs"
     },
     {
      "fs": "LSF",
      "iata": "LSF",
      "icao": "KLSF",
      "faa": "LSF",
      "name": "Lawson Army Air Field - Ft Benning",
      "city": "Columbus",
      "cityCode": "LSF",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 32.335278,
      "longitude": -84.990074,
      "elevationFeet": 224,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LSF?codeType=fs"
     },
     {
      "fs": "LSV",
      "iata": "LSV",
      "icao": "KLSV",
      "faa": "LSV",
      "name": "Nellis Air Force Base",
      "city": "Las Vegas",
      "cityCode": "LAS",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 36.23297,
      "longitude": -115.035953,
      "elevationFeet": 1840,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LSV?codeType=fs"
     },
     {
      "fs": "LUF",
      "iata": "LUF",
      "icao": "KLUF",
      "faa": "LUF",
      "name": "Luke Air Force Base",
      "city": "Phoenix",
      "cityCode": "PHX",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 33.536394,
      "longitude": -112.372838,
      "elevationFeet": 1067,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LUF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LUF?codeType=fs"
     },
     {
      "fs": "LUK",
      "iata": "LUK",
      "icao": "KLUK",
      "faa": "LUK",
      "name": "Cincinnati Municipal Airport -  Lunken Field",
      "city": "Cincinnati",
      "cityCode": "CVG",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ077",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.103297,
      "longitude": -84.418596,
      "elevationFeet": 472,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LUK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LUK?codeType=fs"
     },
     {
      "fs": "LUP",
      "iata": "LUP",
      "icao": "PHLU",
      "faa": "",
      "name": "Kalaupapa Airport",
      "city": "Kalaupapa",
      "cityCode": "LUP",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ005",
      "localTime": "2022-11-09T02:41:39.678",
      "utcOffsetHours": -10,
      "latitude": 21.211111,
      "longitude": -156.974444,
      "elevationFeet": 66,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LUP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LUP?codeType=fs"
     },
     {
      "fs": "LUR",
      "iata": "LUR",
      "icao": "PALU",
      "faa": "PALU",
      "name": "Cape Lisburne Airport",
      "city": "Cape Lisburne",
      "cityCode": "LUR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 68.875833,
      "longitude": -166.106944,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LUR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LUR?codeType=fs"
     },
     {
      "fs": "LVK",
      "iata": "LVK",
      "icao": "KLVK",
      "faa": "LVK",
      "name": "Livermore Municipal Airport",
      "city": "Livermore",
      "cityCode": "LVK",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.693889,
      "longitude": -121.817222,
      "elevationFeet": 397,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LVK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LVK?codeType=fs"
     },
     {
      "fs": "LVM",
      "iata": "LVM",
      "icao": "KLVM",
      "faa": "LVM",
      "name": "Mission Field",
      "city": "Livingston",
      "cityCode": "LVM",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 45.666667,
      "longitude": -110.566667,
      "elevationFeet": 4656,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LVM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LVM?codeType=fs"
     },
     {
      "fs": "LVS",
      "iata": "LVS",
      "icao": "KLVS",
      "faa": "LVS",
      "name": "Las Vegas Airport",
      "city": "Las Vegas",
      "cityCode": "LVS",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 35.6,
      "longitude": -105.216667,
      "elevationFeet": 6877,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LVS?codeType=fs"
     },
     {
      "fs": "LWB",
      "iata": "LWB",
      "icao": "KLWB",
      "faa": "LWB",
      "name": "Greenbrier Valley Airport",
      "street1": "",
      "street2": "",
      "city": "Lewisburg",
      "cityCode": "LWB",
      "stateCode": "WV",
      "postalCode": "24901",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ045",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 37.859722,
      "longitude": -80.398611,
      "elevationFeet": 2302,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWB?codeType=fs"
     },
     {
      "fs": "LWS",
      "iata": "LWS",
      "icao": "KLWS",
      "faa": "LWS",
      "name": "Lewiston-Nez Perce County Regional Airport",
      "city": "Lewiston",
      "cityCode": "LWS",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "IDZ026",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 46.374722,
      "longitude": -117.014444,
      "elevationFeet": 1438,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWS?codeType=fs"
     },
     {
      "fs": "LWT",
      "iata": "LWT",
      "icao": "KLWT",
      "faa": "LWT",
      "name": "Lewistown Municipal Airport",
      "city": "Lewistown",
      "cityCode": "LWT",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ051",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 47.051111,
      "longitude": -109.471111,
      "elevationFeet": 4167,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWT?codeType=fs"
     },
     {
      "fs": "LYH",
      "iata": "LYH",
      "icao": "KLYH",
      "faa": "LYH",
      "name": "Preston-Glenn Field",
      "street1": "4308 Wards Road, Suite 100",
      "street2": "",
      "city": "Lynchburg",
      "cityCode": "LYH",
      "stateCode": "VA",
      "postalCode": "24502",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ045",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 37.326944,
      "longitude": -79.201111,
      "elevationFeet": 938,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LYH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LYH?codeType=fs"
     },
     {
      "fs": "MAE",
      "iata": "MAE",
      "icao": "KMAE",
      "faa": "MAE",
      "name": "Madera Airport",
      "city": "Madera",
      "cityCode": "MAE",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 36.95,
      "longitude": -120.066667,
      "elevationFeet": 253,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MAE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MAE?codeType=fs"
     },
     {
      "fs": "MBG",
      "iata": "MBG",
      "icao": "KMBG",
      "faa": "MBG",
      "name": "Mobridge Municipal Airport",
      "city": "Mobridge",
      "cityCode": "MBG",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 45.544733,
      "longitude": -100.406877,
      "elevationFeet": 1693,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MBG?codeType=fs"
     },
     {
      "fs": "MBL",
      "iata": "MBL",
      "icao": "KMBL",
      "faa": "MBL",
      "name": "Blacker Airport",
      "street1": "2323 Airport Road",
      "street2": "",
      "city": "Manistee",
      "cityCode": "MBL",
      "stateCode": "MI",
      "postalCode": "49660",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ031",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.273889,
      "longitude": -86.253333,
      "elevationFeet": 621,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MBL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MBL?codeType=fs"
     },
     {
      "fs": "MBS",
      "iata": "MBS",
      "icao": "KMBS",
      "faa": "MBS",
      "name": "MBS International Airport",
      "street1": "8500 Garfield Road, Suite 101",
      "city": "Saginaw",
      "cityCode": "MBS",
      "stateCode": "MI",
      "postalCode": "48623",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ053",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.53339,
      "longitude": -84.090742,
      "elevationFeet": 668,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MBS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MBS?codeType=fs"
     },
     {
      "fs": "MCB",
      "iata": "MCB",
      "icao": "KMCB",
      "faa": "MCB",
      "name": "Pike County Airport",
      "city": "Mc Comb",
      "cityCode": "MCB",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 31.175556,
      "longitude": -90.469444,
      "elevationFeet": 413,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCB?codeType=fs"
     },
     {
      "fs": "MCC",
      "iata": "MCC",
      "icao": "KMCC",
      "faa": "MCC",
      "name": "McClellan Air Force Base",
      "city": "Sacramento",
      "cityCode": "SAC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.662617,
      "longitude": -121.398388,
      "elevationFeet": 74,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCC?codeType=fs"
     },
     {
      "fs": "MCD",
      "iata": "MCD",
      "icao": "KMCD",
      "faa": "MCD",
      "name": "Mackinac Island Airport",
      "city": "Mackinac Island",
      "cityCode": "MCD",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 45.864899,
      "longitude": -84.637299,
      "elevationFeet": 736,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCD?codeType=fs"
     },
     {
      "fs": "MCE",
      "iata": "MCE",
      "icao": "KMCE",
      "faa": "MCE",
      "name": "Merced Municipal Airport",
      "street1": "20 MacReady",
      "street2": "",
      "city": "Merced",
      "cityCode": "MCE",
      "stateCode": "CA",
      "postalCode": "95340",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ090",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.284722,
      "longitude": -120.512778,
      "elevationFeet": 156,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCE?codeType=fs"
     },
     {
      "fs": "MCF",
      "iata": "MCF",
      "icao": "KMCF",
      "faa": "MCF",
      "name": "MacDill Air Force Base",
      "city": "Tampa",
      "cityCode": "TPA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 27.848473,
      "longitude": -82.49993,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCF?codeType=fs"
     },
     {
      "fs": "MCG",
      "iata": "MCG",
      "icao": "PAMC",
      "faa": "PAMC",
      "name": "McGrath Airport",
      "city": "McGrath",
      "cityCode": "MCG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 62.950732,
      "longitude": -155.601923,
      "elevationFeet": 332,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCG?codeType=fs"
     },
     {
      "fs": "MCK",
      "iata": "MCK",
      "icao": "KMCK",
      "faa": "MCK",
      "name": "Mc Cook Airport",
      "street1": "",
      "street2": "",
      "city": "McCook",
      "cityCode": "MCK",
      "stateCode": "NE",
      "postalCode": "69001",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ081",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 40.206299,
      "longitude": -100.592003,
      "elevationFeet": 2583,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCK?codeType=fs"
     },
     {
      "fs": "MCN",
      "iata": "MCN",
      "icao": "KMCN",
      "faa": "MCN",
      "name": "Middle Georgia Regional Airport",
      "street1": "1000 Terminal Drive",
      "city": "Macon",
      "cityCode": "MCN",
      "stateCode": "GA",
      "postalCode": "31216",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ082",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 32.701987,
      "longitude": -83.648651,
      "elevationFeet": 354,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCN?codeType=fs"
     },
     {
      "fs": "MCW",
      "iata": "MCW",
      "icao": "KMCW",
      "faa": "MCW",
      "name": "Mason City Airport",
      "street1": "",
      "street2": "",
      "city": "Mason City",
      "cityCode": "MCW",
      "stateCode": "IA",
      "postalCode": "50401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ017",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 43.156944,
      "longitude": -93.329444,
      "elevationFeet": 1213,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCW?codeType=fs"
     },
     {
      "fs": "MDD",
      "iata": "MDD",
      "icao": "KMDD",
      "faa": "MDD",
      "name": "Midland Airpark",
      "city": "Midland",
      "cityCode": "MDD",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 32.033175,
      "longitude": -102.098865,
      "elevationFeet": 2797,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDD?codeType=fs"
     },
     {
      "fs": "MEI",
      "iata": "MEI",
      "icao": "KMEI",
      "faa": "MEI",
      "name": "Meridian Regional (Key Field) Airport",
      "street1": "2811 Airport Boulevard South",
      "street2": "",
      "city": "Meridian",
      "cityCode": "MEI",
      "stateCode": "MS",
      "postalCode": "39307",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ052",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 32.337222,
      "longitude": -88.749167,
      "elevationFeet": 297,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MEI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MEI?codeType=fs"
     },
     {
      "fs": "MEO",
      "iata": "MEO",
      "icao": "KMQI",
      "faa": "MQI",
      "name": "Dare County Regional Airport",
      "city": "Manteo",
      "cityCode": "MEO",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 35.919167,
      "longitude": -75.695278,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MEO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MEO?codeType=fs"
     },
     {
      "fs": "MFD",
      "iata": "MFD",
      "icao": "KMFD",
      "faa": "MFD",
      "name": "Lahm Municipal Airport",
      "city": "Mansfield",
      "cityCode": "MFD",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.82,
      "longitude": -82.512778,
      "elevationFeet": 1297,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MFD?codeType=fs"
     },
     {
      "fs": "MFE",
      "iata": "MFE",
      "icao": "KMFE",
      "faa": "MFE",
      "name": "McAllen International Airport",
      "street1": "2500 S Bicentenial Blvd",
      "city": "McAllen",
      "cityCode": "MFE",
      "stateCode": "TX",
      "postalCode": "78503",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ253",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 26.181295,
      "longitude": -98.239775,
      "elevationFeet": 107,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MFE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MFE?codeType=fs"
     },
     {
      "fs": "MGE",
      "iata": "MGE",
      "icao": "KMGE",
      "faa": "MGE",
      "name": "Dobbins Air Force Base",
      "city": "Marietta",
      "cityCode": "MGE",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 33.912954,
      "longitude": -84.510918,
      "elevationFeet": 1018,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGE?codeType=fs"
     },
     {
      "fs": "MGM",
      "iata": "MGM",
      "icao": "KMGM",
      "faa": "MGM",
      "name": "Montgomery Regional Airport-Dannelly Field",
      "street1": "4445 Selma Highway",
      "city": "Montgomery",
      "cityCode": "MGM",
      "stateCode": "AL",
      "postalCode": "36108",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ044",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 32.300596,
      "longitude": -86.393997,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGM?codeType=fs"
     },
     {
      "fs": "MGW",
      "iata": "MGW",
      "icao": "KMGW",
      "faa": "MGW",
      "name": "Morgantown Airport",
      "street1": "100 Hart Field Road",
      "street2": "",
      "city": "Morgantown",
      "cityCode": "MGW",
      "stateCode": "WV",
      "postalCode": "26505",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ022",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.642778,
      "longitude": -79.915833,
      "elevationFeet": 1248,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGW?codeType=fs"
     },
     {
      "fs": "MHE",
      "iata": "MHE",
      "icao": "KMHE",
      "faa": "MHE",
      "name": "Mitchell Municipal Airport",
      "city": "Mitchell",
      "cityCode": "MHE",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 43.775278,
      "longitude": -98.038056,
      "elevationFeet": 1304,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHE?codeType=fs"
     },
     {
      "fs": "MHK",
      "iata": "MHK",
      "icao": "KMHK",
      "faa": "MHK",
      "name": "Manhattan Municipal Airport",
      "street1": "1101 Poyntz Avenue",
      "street2": "",
      "city": "Manhattan",
      "cityCode": "MHK",
      "stateCode": "KS",
      "postalCode": "66502",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ022",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 39.142222,
      "longitude": -96.668889,
      "elevationFeet": 1056,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHK?codeType=fs"
     },
     {
      "fs": "MHM",
      "icao": "PAMH",
      "faa": "PAMH",
      "name": "Minchumina Intermediate Airport",
      "city": "Minchumina",
      "cityCode": "MHM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 63.869167,
      "longitude": -152.285833,
      "elevationFeet": 684,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHM?codeType=fs"
     },
     {
      "fs": "MHR",
      "iata": "MHR",
      "icao": "KMHR",
      "faa": "MHR",
      "name": "Mather Airport",
      "street1": "3745 Whitehead Street",
      "city": "Sacramento",
      "cityCode": "SAC",
      "stateCode": "CA",
      "postalCode": "95655",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ017",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.553902,
      "longitude": -121.297996,
      "elevationFeet": 86,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHR?codeType=fs"
     },
     {
      "fs": "MHV",
      "iata": "MHV",
      "icao": "KMHV",
      "faa": "MHV",
      "name": "Mojave Air and Space Port",
      "city": "Mojave",
      "cityCode": "MHV",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 35.057904,
      "longitude": -118.147815,
      "elevationFeet": 2743,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHV?codeType=fs"
     },
     {
      "fs": "MIB",
      "iata": "MIB",
      "icao": "KMIB",
      "faa": "MIB",
      "name": "Minot Air Force Base",
      "city": "Minot",
      "cityCode": "MOT",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 48.415781,
      "longitude": -101.35787,
      "elevationFeet": 1660,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIB?codeType=fs"
     },
     {
      "fs": "MIE",
      "iata": "MIE",
      "icao": "KMIE",
      "faa": "MIE",
      "name": "Delaware County Regional Airport",
      "city": "Muncie",
      "cityCode": "MIE",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.239722,
      "longitude": -85.394444,
      "elevationFeet": 937,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIE?codeType=fs"
     },
     {
      "fs": "MIQ",
      "iata": "MIQ",
      "icao": "KMLE",
      "faa": "MLE",
      "name": "Millard Airport",
      "city": "Omaha",
      "cityCode": "OMA",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 41.195123,
      "longitude": -96.112097,
      "elevationFeet": 1043,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIQ?codeType=fs"
     },
     {
      "fs": "MIV",
      "iata": "MIV",
      "icao": "KMIV",
      "faa": "MIV",
      "name": "Millville Municipal Airport",
      "city": "Millville",
      "cityCode": "MIV",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.364644,
      "longitude": -75.079292,
      "elevationFeet": 57,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIV?codeType=fs"
     },
     {
      "fs": "MJX",
      "iata": "MJX",
      "icao": "KMJX",
      "faa": "MJX",
      "name": "Robert J. Miller Air Park",
      "city": "Toms River",
      "cityCode": "MJX",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.928092,
      "longitude": -74.293055,
      "elevationFeet": 86,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MJX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MJX?codeType=fs"
     },
     {
      "fs": "MKG",
      "iata": "MKG",
      "icao": "KMKG",
      "faa": "MKG",
      "name": "Muskegon Airport",
      "street1": "99 Sinclair Drive",
      "street2": "",
      "city": "Muskegon",
      "cityCode": "MKG",
      "stateCode": "MI",
      "postalCode": "49441",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ050",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.170556,
      "longitude": -86.2375,
      "elevationFeet": 628,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKG?codeType=fs"
     },
     {
      "fs": "MKL",
      "iata": "MKL",
      "icao": "KMKL",
      "faa": "MKL",
      "name": "Mckellar-Sipes Regional Airport",
      "street1": "308 Grady Montgomery Drive",
      "city": "Jackson",
      "cityCode": "MKL",
      "stateCode": "TN",
      "postalCode": "38301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TNZ052",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 35.599778,
      "longitude": -88.915097,
      "elevationFeet": 418,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKL?codeType=fs"
     },
     {
      "fs": "MLB",
      "iata": "MLB",
      "icao": "KMLB",
      "faa": "MLB",
      "name": "Orlando Melbourne International Airport",
      "street1": "1 Air Terminal Parkway, Suite 220",
      "city": "Melbourne",
      "cityCode": "MLB",
      "stateCode": "FL",
      "postalCode": "32901-1888",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ047",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 28.1025,
      "longitude": -80.630278,
      "elevationFeet": 33,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLB?codeType=fs"
     },
     {
      "fs": "MLC",
      "iata": "MLC",
      "icao": "KMLC",
      "faa": "MLC",
      "name": "McAlester Regional Airport",
      "city": "McAlester",
      "cityCode": "MLC",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 34.880278,
      "longitude": -95.785,
      "elevationFeet": 770,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLC?codeType=fs"
     },
     {
      "fs": "MLL",
      "iata": "MLL",
      "icao": "PADM",
      "faa": "MDM",
      "name": "Marshall Don Hunter Sr. Airport",
      "city": "Marshall",
      "cityCode": "MLL",
      "stateCode": "AK",
      "postalCode": "99585",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 61.864187,
      "longitude": -162.026166,
      "elevationFeet": 70,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLL?codeType=fs"
     },
     {
      "fs": "MLS",
      "iata": "MLS",
      "icao": "KMLS",
      "faa": "MLS",
      "name": "Frank Wiley Field",
      "city": "Miles City",
      "cityCode": "MLS",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ032",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 46.428325,
      "longitude": -105.884503,
      "elevationFeet": 2625,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLS?codeType=fs"
     },
     {
      "fs": "MLT",
      "iata": "MLT",
      "icao": "KMLT",
      "faa": "MLT",
      "name": "Millinocket Municipal Airport",
      "city": "Millinocket",
      "cityCode": "MLT",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 45.6478,
      "longitude": -68.6856,
      "elevationFeet": 398,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLT?codeType=fs"
     },
     {
      "fs": "MLU",
      "iata": "MLU",
      "icao": "KMLU",
      "faa": "MLU",
      "name": "Monroe Regional Airport",
      "street1": "5400 Operations Road, Suite 201",
      "street2": "",
      "city": "Monroe",
      "cityCode": "MLU",
      "stateCode": "LA",
      "postalCode": "71203",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ014",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 32.511842,
      "longitude": -92.043659,
      "elevationFeet": 79,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLU?codeType=fs"
     },
     {
      "fs": "MLY",
      "iata": "MLY",
      "icao": "PAML",
      "faa": "PAML",
      "name": "Manley Hot Springs Airport",
      "city": "Manley Hot Springs",
      "cityCode": "MLY",
      "stateCode": "AK",
      "postalCode": "99756",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ221",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 64.996667,
      "longitude": -150.643056,
      "elevationFeet": 270,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLY?codeType=fs"
     },
     {
      "fs": "MMH",
      "iata": "MMH",
      "icao": "KMMH",
      "faa": "MMH",
      "name": "Mammoth Lakes Airport",
      "city": "Mammoth Lakes",
      "cityCode": "MMH",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.631111,
      "longitude": -118.851389,
      "elevationFeet": 7128,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMH?codeType=fs"
     },
     {
      "fs": "MML",
      "iata": "MML",
      "icao": "KMML",
      "faa": "MML",
      "name": "Southwest Minnesota Regional Airport",
      "city": "Marshall",
      "cityCode": "MML",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 44.447222,
      "longitude": -95.8175,
      "elevationFeet": 1180,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MML?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MML?codeType=fs"
     },
     {
      "fs": "MMN",
      "iata": "MMN",
      "icao": "",
      "faa": "6B6",
      "name": "Minute Man Airfield",
      "city": "Stow",
      "cityCode": "MMN",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.461967,
      "longitude": -71.51722,
      "elevationFeet": 265,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMN?codeType=fs"
     },
     {
      "fs": "MMU",
      "iata": "MMU",
      "icao": "KMMU",
      "faa": "MMU",
      "name": "Morristown Municipal Airport",
      "city": "Morristown",
      "cityCode": "MMU",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.795183,
      "longitude": -74.421112,
      "elevationFeet": 187,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMU?codeType=fs"
     },
     {
      "fs": "MNM",
      "iata": "MNM",
      "icao": "KMNM",
      "faa": "MNM",
      "name": "Menominee-Marinette Twin County Airport",
      "city": "Menominee",
      "cityCode": "MNM",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 45.121667,
      "longitude": -87.636111,
      "elevationFeet": 625,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MNM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MNM?codeType=fs"
     },
     {
      "fs": "MNT",
      "iata": "MNT",
      "icao": "",
      "faa": "51Z",
      "name": "Minto Airport",
      "city": "Minto",
      "cityCode": "MNT",
      "stateCode": "AK",
      "postalCode": "99758",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ221",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 64.895,
      "longitude": -149.170833,
      "elevationFeet": 460,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MNT?codeType=fs"
     },
     {
      "fs": "MNZ",
      "iata": "MNZ",
      "icao": "KHEF",
      "faa": "HEF",
      "name": "Manassas Regional Airport",
      "city": "Manassas",
      "cityCode": "MNZ",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 38.721944,
      "longitude": -77.518056,
      "elevationFeet": 179,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MNZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MNZ?codeType=fs"
     },
     {
      "fs": "MOD",
      "iata": "MOD",
      "icao": "KMOD",
      "faa": "MOD",
      "name": "Modesto Municipal Airport",
      "street1": "617 Airport Way",
      "street2": "",
      "city": "Modesto",
      "cityCode": "MOD",
      "stateCode": "CA",
      "postalCode": "95354",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ019",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.626944,
      "longitude": -120.955278,
      "elevationFeet": 97,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOD?codeType=fs"
     },
     {
      "fs": "MOP",
      "iata": "MOP",
      "icao": "KMOP",
      "faa": "MOP",
      "name": "Mount Pleasant Municipal Airport",
      "city": "Mount Pleasant",
      "cityCode": "MOP",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.620642,
      "longitude": -84.737792,
      "elevationFeet": 749,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOP?codeType=fs"
     },
     {
      "fs": "MOR",
      "iata": "MOR",
      "icao": "KMOR",
      "faa": "MOR",
      "name": "Moore-Murrell Airport",
      "city": "Morristown",
      "cityCode": "MOR",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 36.216667,
      "longitude": -83.3,
      "elevationFeet": 1313,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOR?codeType=fs"
     },
     {
      "fs": "MOT",
      "iata": "MOT",
      "icao": "KMOT",
      "faa": "MOT",
      "name": "Minot International Airport",
      "street1": "25 Airport Road",
      "city": "Minot",
      "cityCode": "MOT",
      "stateCode": "ND",
      "postalCode": "58703",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NDZ011",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 48.256328,
      "longitude": -101.291519,
      "elevationFeet": 1716,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOT?codeType=fs"
     },
     {
      "fs": "MOU",
      "iata": "MOU",
      "icao": "",
      "faa": "MOU",
      "name": "Mountain Village Airport",
      "city": "Mountain Village",
      "cityCode": "MOU",
      "stateCode": "AK",
      "postalCode": "99632",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 62.089444,
      "longitude": -163.716667,
      "elevationFeet": 335,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOU?codeType=fs"
     },
     {
      "fs": "MPB",
      "iata": "MPB",
      "icao": "",
      "faa": "",
      "name": "Miami Sea Plane Base",
      "city": "Miami",
      "cityCode": "MIA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 25.783182,
      "longitude": -80.176933,
      "elevationFeet": 2,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPB?codeType=fs"
     },
     {
      "fs": "MPV",
      "iata": "MPV",
      "icao": "KMPV",
      "faa": "MPV",
      "name": "Edward F. Knapp State Airport",
      "city": "Berlin",
      "cityCode": "MPV",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.202842,
      "longitude": -72.563806,
      "elevationFeet": 1132,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPV?codeType=fs"
     },
     {
      "fs": "MQT",
      "iata": "MQT",
      "icao": "KSAW",
      "faa": "SAW",
      "name": "Sawyer International Airport",
      "city": "Marquette",
      "cityCode": "MQT",
      "stateCode": "MI",
      "postalCode": "49841",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ005",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 46.353611,
      "longitude": -87.395278,
      "elevationFeet": 1221,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MQT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MQT?codeType=fs"
     },
     {
      "fs": "MQY",
      "iata": "MQY",
      "icao": "KMQY",
      "faa": "MQY",
      "name": "Smyrna Airport",
      "city": "Smyrna",
      "cityCode": "MQY",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 36.006745,
      "longitude": -86.510593,
      "elevationFeet": 518,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MQY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MQY?codeType=fs"
     },
     {
      "fs": "MRB",
      "iata": "MRB",
      "icao": "KMRB",
      "faa": "MRB",
      "name": "Eastern West Virginia Regional Airport",
      "city": "Martinsburg",
      "cityCode": "MRB",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.401667,
      "longitude": -77.985,
      "elevationFeet": 557,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRB?codeType=fs"
     },
     {
      "fs": "MRF",
      "iata": "MRF",
      "icao": "KMRF",
      "faa": "MRF",
      "name": "Marfa Municipal Airport",
      "city": "Marfa",
      "cityCode": "MRF",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 30.371099,
      "longitude": -104.017997,
      "elevationFeet": 4841,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRF?codeType=fs"
     },
     {
      "fs": "MRK",
      "iata": "MRK",
      "icao": "KMKY",
      "faa": "MKY",
      "name": "Marco Island Airport",
      "city": "Marco Island",
      "cityCode": "MRK",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 25.999664,
      "longitude": -81.674172,
      "elevationFeet": 1,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRK?codeType=fs"
     },
     {
      "fs": "MSC",
      "iata": "MSC",
      "icao": "KFFZ",
      "faa": "FFZ",
      "name": "Falcon Field",
      "city": "Mesa",
      "cityCode": "MSC",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 33.460689,
      "longitude": -111.728631,
      "elevationFeet": 1377,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSC?codeType=fs"
     },
     {
      "fs": "MSL",
      "iata": "MSL",
      "icao": "KMSL",
      "faa": "MSL",
      "name": "Northwest Alabama Regional Airport",
      "city": "Muscle Shoals",
      "cityCode": "MSL",
      "stateCode": "AL",
      "postalCode": "35661-2016",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ALZ002",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 34.748611,
      "longitude": -87.616111,
      "elevationFeet": 550,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSL?codeType=fs"
     },
     {
      "fs": "MSO",
      "iata": "MSO",
      "icao": "KMSO",
      "faa": "MSO",
      "name": "Missoula International Airport",
      "street1": "5225 Highway 10 West",
      "city": "Missoula",
      "cityCode": "MSO",
      "stateCode": "MT",
      "postalCode": "59802",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ043",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 46.918965,
      "longitude": -114.083216,
      "elevationFeet": 3205,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSO?codeType=fs"
     },
     {
      "fs": "MSS",
      "iata": "MSS",
      "icao": "KMSS",
      "faa": "MSS",
      "name": "Richards Field",
      "street1": "90 Aviation Road",
      "street2": "",
      "city": "Massena",
      "cityCode": "MSS",
      "stateCode": "NY",
      "postalCode": "13662",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ026",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.937778,
      "longitude": -74.846667,
      "elevationFeet": 215,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSS?codeType=fs"
     },
     {
      "fs": "MTC",
      "iata": "MTC",
      "icao": "KMTC",
      "faa": "MTC",
      "name": "Selfridge Air National Guard Base",
      "city": "Mount Clemens",
      "cityCode": "MTC",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.610445,
      "longitude": -82.836492,
      "elevationFeet": 580,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTC?codeType=fs"
     },
     {
      "fs": "MTH",
      "iata": "MTH",
      "icao": "KMTH",
      "faa": "MTH",
      "name": "The Florida Keys Marathon Airport",
      "street1": "9400 Overseas Highway, Suite 200",
      "city": "Marathon",
      "cityCode": "MTH",
      "stateCode": "FL",
      "postalCode": "33050",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 24.726206,
      "longitude": -81.050937,
      "elevationFeet": 4,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTH?codeType=fs"
     },
     {
      "fs": "MTJ",
      "iata": "MTJ",
      "icao": "KMTJ",
      "faa": "MTJ",
      "name": "Montrose Regional Airport",
      "street1": "2100 Airport Road",
      "city": "Montrose",
      "cityCode": "MTJ",
      "stateCode": "CO",
      "postalCode": "81401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ017",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 38.510287,
      "longitude": -107.896955,
      "elevationFeet": 5759,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTJ?codeType=fs"
     },
     {
      "fs": "MTM",
      "iata": "MTM",
      "icao": "",
      "faa": "",
      "name": "Metlakatla Sea Plane Base",
      "city": "Metlakatla",
      "cityCode": "MTM",
      "stateCode": "AK",
      "postalCode": "99926",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ027",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.131522,
      "longitude": -131.578047,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTM?codeType=fs"
     },
     {
      "fs": "MTN",
      "iata": "MTN",
      "icao": "KMTN",
      "faa": "MTN",
      "name": "Martin State Airport",
      "city": "Baltimore",
      "cityCode": "BWI",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.321667,
      "longitude": -76.411667,
      "elevationFeet": 22,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTN?codeType=fs"
     },
     {
      "fs": "MTP",
      "iata": "MTP",
      "icao": "KMTP",
      "faa": "MTP",
      "name": "Montauk Airport",
      "city": "Montauk Point",
      "cityCode": "MTP",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 41.074444,
      "longitude": -71.923611,
      "elevationFeet": 20,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTP?codeType=fs"
     },
     {
      "fs": "MUE",
      "iata": "MUE",
      "icao": "PHMU",
      "faa": "PHMU",
      "name": "Kamuela Airport",
      "city": "Kamuela",
      "cityCode": "MUE",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "HIZ007",
      "localTime": "2022-11-09T02:41:39.678",
      "utcOffsetHours": -10,
      "latitude": 20.002464,
      "longitude": -155.651457,
      "elevationFeet": 2747,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUE?codeType=fs"
     },
     {
      "fs": "MUO",
      "iata": "MUO",
      "icao": "KMUO",
      "faa": "MUO",
      "name": "Mountain Home Air Force Base",
      "city": "Mountain Home",
      "cityCode": "MUO",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 43.043598,
      "longitude": -115.872417,
      "elevationFeet": 2992,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUO?codeType=fs"
     },
     {
      "fs": "MVL",
      "iata": "MVL",
      "icao": "KMVL",
      "faa": "MVL",
      "name": "Morrisville-Stowe Airport",
      "city": "Stowe",
      "cityCode": "MVL",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.537403,
      "longitude": -72.615433,
      "elevationFeet": 732,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVL?codeType=fs"
     },
     {
      "fs": "MVN",
      "iata": "MVN",
      "icao": "KMVN",
      "faa": "MVN",
      "name": "Mount Vernon Airport",
      "city": "Mount Vernon",
      "cityCode": "MVN",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 38.323056,
      "longitude": -88.858611,
      "elevationFeet": 466,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVN?codeType=fs"
     },
     {
      "fs": "MVW",
      "iata": "MVW",
      "icao": "KBVS",
      "faa": "BVS",
      "name": "Skagit Regional Airport",
      "city": "Mount Vernon",
      "cityCode": "MVW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 48.472747,
      "longitude": -122.417975,
      "elevationFeet": 118,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVW?codeType=fs"
     },
     {
      "fs": "MWA",
      "iata": "MWA",
      "icao": "KMWA",
      "faa": "MWA",
      "name": "Veterans Airport of Southern Illinois",
      "street1": "Suite 100, Terminal Drive",
      "street2": "",
      "city": "Marion",
      "cityCode": "MWA",
      "stateCode": "IL",
      "postalCode": "62959",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ085",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 37.751944,
      "longitude": -89.016389,
      "elevationFeet": 472,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MWA?codeType=fs"
     },
     {
      "fs": "MWH",
      "iata": "MWH",
      "icao": "KMWH",
      "faa": "MWH",
      "name": "Grant County International Airport",
      "city": "Moses Lake",
      "cityCode": "MWH",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ034",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 47.205,
      "longitude": -119.315556,
      "elevationFeet": 1185,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MWH?codeType=fs"
     },
     {
      "fs": "MWO",
      "iata": "MWO",
      "icao": "KMWO",
      "faa": "MWO",
      "name": "Middletown Regional Airport",
      "city": "Middletown",
      "cityCode": "MWO",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.529251,
      "longitude": -84.394168,
      "elevationFeet": 643,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MWO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MWO?codeType=fs"
     },
     {
      "fs": "MYF",
      "iata": "MYF",
      "icao": "KMYF",
      "faa": "MYF",
      "name": "Montgomery Field",
      "city": "San Diego",
      "cityCode": "SAN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ043",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 32.815449,
      "longitude": -117.135633,
      "elevationFeet": 420,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYF?codeType=fs"
     },
     {
      "fs": "MYU",
      "iata": "MYU",
      "icao": "PAMY",
      "faa": "PAMY",
      "name": "Ellis Field",
      "city": "Mekoryuk",
      "cityCode": "MYU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.372778,
      "longitude": -166.268056,
      "elevationFeet": 48,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYU?codeType=fs"
     },
     {
      "fs": "MYV",
      "iata": "MYV",
      "icao": "KMYV",
      "faa": "MYV",
      "name": "Yuba County Airport",
      "city": "Marysville",
      "cityCode": "MYV",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 39.098056,
      "longitude": -121.569722,
      "elevationFeet": 62,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYV?codeType=fs"
     },
     {
      "fs": "MZJ",
      "iata": "MZJ",
      "icao": "KMZJ",
      "faa": "MZJ",
      "name": "Pinal Airpark",
      "city": "Marana",
      "cityCode": "MZJ",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 32.510705,
      "longitude": -111.322337,
      "elevationFeet": 1887,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MZJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MZJ?codeType=fs"
     },
     {
      "fs": "N14",
      "iata": "",
      "icao": "",
      "faa": "N14",
      "name": "Flying W Airport",
      "city": "Lumberton",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.934107,
      "longitude": -74.807253,
      "elevationFeet": 48,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N14?codeType=fs"
     },
     {
      "fs": "NCN",
      "iata": "NCN",
      "icao": "",
      "faa": "",
      "name": "New Chenega Airport",
      "city": "New Chenega",
      "cityCode": "NCN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.078308,
      "longitude": -147.997729,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NCN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NCN?codeType=fs"
     },
     {
      "fs": "NCO",
      "iata": "NCO",
      "icao": "",
      "faa": "",
      "name": "Quonset State Airport",
      "city": "North Kingstown",
      "cityCode": "NCO",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 41.59944,
      "longitude": -71.41667,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NCO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NCO?codeType=fs"
     },
     {
      "fs": "NEW",
      "iata": "NEW",
      "icao": "KNEW",
      "faa": "NEW",
      "name": "Lakefront Airport",
      "city": "New Orleans",
      "cityCode": "MSY",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "LAZ061",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 30.0424,
      "longitude": -90.028297,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NEW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NEW?codeType=fs"
     },
     {
      "fs": "NGU",
      "iata": "NGU",
      "icao": "KNGU",
      "faa": "NGU",
      "name": "Naval Station Norfolk",
      "city": "Norfolk",
      "cityCode": "ORF",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 36.940781,
      "longitude": -76.29248,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NGU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NGU?codeType=fs"
     },
     {
      "fs": "NHZ",
      "iata": "NHZ",
      "icao": "KNHZ",
      "faa": "NHZ",
      "name": "Brunswick Executive Airport",
      "city": "Brunswick",
      "cityCode": "NHZ",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.892289,
      "longitude": -69.937591,
      "elevationFeet": 65,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NHZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NHZ?codeType=fs"
     },
     {
      "fs": "NIB",
      "iata": "NIB",
      "icao": "",
      "faa": "5NI",
      "name": "Nikolai Airport",
      "city": "Nikolai",
      "cityCode": "NIB",
      "stateCode": "AK",
      "postalCode": "99691",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 63.016667,
      "longitude": -154.383333,
      "elevationFeet": 413,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NIB?codeType=fs"
     },
     {
      "fs": "NIP",
      "iata": "NIP",
      "icao": "KNIP",
      "faa": "NIP",
      "name": "NAS (Towers Field)",
      "city": "Jacksonville",
      "cityCode": "JAX",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 30.234314,
      "longitude": -81.675612,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NIP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NIP?codeType=fs"
     },
     {
      "fs": "NKI",
      "iata": "NKI",
      "icao": "",
      "faa": "",
      "name": "Naukiti Bay Sea Plane Base",
      "city": "Naukiti",
      "cityCode": "NKI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 55.849626,
      "longitude": -133.227872,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NKI?codeType=fs"
     },
     {
      "fs": "NKX",
      "iata": "NKX",
      "icao": "KNKX",
      "faa": "NKX",
      "name": "Marine Corps Air Station Miramar",
      "city": "San Diego",
      "cityCode": "SAN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 32.867945,
      "longitude": -117.134429,
      "elevationFeet": 460,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NKX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NKX?codeType=fs"
     },
     {
      "fs": "NLG",
      "iata": "NLG",
      "icao": "",
      "faa": "Z73",
      "name": "Nelson Lagoon Airport",
      "city": "Nelson Lagoon",
      "cityCode": "NLG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ181",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.001389,
      "longitude": -161.1525,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NLG?codeType=fs"
     },
     {
      "fs": "NME",
      "iata": "NME",
      "icao": "PAGT",
      "faa": "IGT",
      "name": "Nightmute Airport",
      "city": "Nightmute",
      "cityCode": "NME",
      "stateCode": "AK",
      "postalCode": "99690",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.471047,
      "longitude": -164.700838,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NME?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NME?codeType=fs"
     },
     {
      "fs": "NNL",
      "iata": "NNL",
      "icao": "",
      "faa": "5NN",
      "name": "Nondalton Airport",
      "city": "Nondalton",
      "cityCode": "NNL",
      "stateCode": "AK",
      "postalCode": "99640",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.978528,
      "longitude": -154.837769,
      "elevationFeet": 310,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NNL?codeType=fs"
     },
     {
      "fs": "NOT",
      "iata": "NOT",
      "icao": "KDVO",
      "faa": "DVO",
      "name": "Marin County Airport",
      "city": "Novato",
      "cityCode": "NOT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.143333,
      "longitude": -122.555833,
      "elevationFeet": 2,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NOT?codeType=fs"
     },
     {
      "fs": "NPA",
      "iata": "NPA",
      "icao": "KNPA",
      "faa": "NPA",
      "name": "Naval Air Station Pensacola",
      "city": "Pensacola",
      "cityCode": "PNS",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 30.353596,
      "longitude": -87.314051,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NPA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NPA?codeType=fs"
     },
     {
      "fs": "NPT",
      "iata": "NPT",
      "icao": "KUUU",
      "faa": "UUU",
      "name": "Newport State Airport",
      "city": "Newport",
      "cityCode": "NPT",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 41.532423,
      "longitude": -71.281362,
      "elevationFeet": 159,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NPT?codeType=fs"
     },
     {
      "fs": "NQX",
      "iata": "NQX",
      "icao": "KNQX",
      "faa": "NQX",
      "name": "Naval Air Station Key West",
      "city": "Key West",
      "cityCode": "EYW",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 24.576032,
      "longitude": -81.688479,
      "elevationFeet": 3,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NQX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NQX?codeType=fs"
     },
     {
      "fs": "NTD",
      "iata": "NTD",
      "icao": "KNTD",
      "faa": "NTD",
      "name": "Naval Base Ventura County",
      "city": "Oxnard",
      "cityCode": "NTD",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 34.119199,
      "longitude": -119.119432,
      "elevationFeet": 6,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NTD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NTD?codeType=fs"
     },
     {
      "fs": "NUI",
      "iata": "NUI",
      "icao": "PAQT",
      "faa": "PAQT",
      "name": "Nuiqsut Airport",
      "city": "Nuiqsut",
      "cityCode": "NUI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ203",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 70.209722,
      "longitude": -151.005556,
      "elevationFeet": 38,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NUI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NUI?codeType=fs"
     },
     {
      "fs": "NUL",
      "iata": "NUL",
      "icao": "",
      "faa": "NUL",
      "name": "Nulato Airport",
      "city": "Nulato",
      "cityCode": "NUL",
      "stateCode": "AK",
      "postalCode": "99765",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ216",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 64.727778,
      "longitude": -158.076667,
      "elevationFeet": 394,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NUL?codeType=fs"
     },
     {
      "fs": "NUP",
      "iata": "NUP",
      "icao": "",
      "faa": "16A",
      "name": "Nunapitchuk Airport",
      "city": "Nunapitchuk",
      "cityCode": "NUP",
      "stateCode": "AK",
      "postalCode": "99641",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.894444,
      "longitude": -162.466667,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NUP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NUP?codeType=fs"
     },
     {
      "fs": "NUQ",
      "iata": "NUQ",
      "icao": "KNUQ",
      "faa": "NUQ",
      "name": "Moffett Federal Field",
      "city": "Mountain View",
      "cityCode": "NUQ",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.413874,
      "longitude": -122.049245,
      "elevationFeet": 19,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NUQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NUQ?codeType=fs"
     },
     {
      "fs": "NZC",
      "iata": "VQQ",
      "icao": "KVQQ",
      "faa": "VQQ",
      "name": "Cecil Airport",
      "city": "Jacksonville",
      "cityCode": "JAX",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 30.220195,
      "longitude": -81.874156,
      "elevationFeet": 68,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NZC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NZC?codeType=fs"
     },
     {
      "fs": "NZY",
      "iata": "NZY",
      "icao": "KNZY",
      "faa": "NZY",
      "name": "North Island Naval Air Station",
      "city": "San Diego",
      "cityCode": "SAN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 32.700555,
      "longitude": -117.202708,
      "elevationFeet": 33,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NZY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NZY?codeType=fs"
     },
     {
      "fs": "O69",
      "iata": "",
      "icao": "",
      "faa": "O69",
      "name": "Petaluma Municipal Airport",
      "city": "Petaluma",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.257971,
      "longitude": -122.609822,
      "elevationFeet": 73,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O69?codeType=fs"
     },
     {
      "fs": "OAJ",
      "iata": "OAJ",
      "icao": "KOAJ",
      "faa": "OAJ",
      "name": "Albert J Ellis Airport",
      "street1": "264 State Road 1265",
      "city": "Richlands",
      "cityCode": "OAJ",
      "stateCode": "NC",
      "postalCode": "28574",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ098",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 34.830441,
      "longitude": -77.605834,
      "elevationFeet": 94,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OAJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OAJ?codeType=fs"
     },
     {
      "fs": "OBU",
      "iata": "OBU",
      "icao": "",
      "faa": "OBU",
      "name": "Kobuk/Wien Airport",
      "city": "Kobuk",
      "cityCode": "OBU",
      "stateCode": "AK",
      "postalCode": "99751",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ217",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 66.910556,
      "longitude": -156.883333,
      "elevationFeet": 145,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OBU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OBU?codeType=fs"
     },
     {
      "fs": "OCA",
      "iata": "OCA",
      "icao": "",
      "faa": "07FA",
      "name": "Ocean Reef Airport",
      "city": "Ocean Reef",
      "cityCode": "OCA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 25.325278,
      "longitude": -80.274722,
      "elevationFeet": 4,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCA?codeType=fs"
     },
     {
      "fs": "OCE",
      "iata": "OCE",
      "icao": "KOXB",
      "faa": "OXB",
      "name": "Ocean City Municipal Airport",
      "city": "Ocean City",
      "cityCode": "OCE",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 38.310398,
      "longitude": -75.124001,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCE?codeType=fs"
     },
     {
      "fs": "OCF",
      "iata": "OCF",
      "icao": "KOCF",
      "faa": "OCF",
      "name": "Ocala International Airport",
      "city": "Ocala",
      "cityCode": "OCF",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 29.174091,
      "longitude": -82.221597,
      "elevationFeet": 79,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCF?codeType=fs"
     },
     {
      "fs": "OCH",
      "iata": "OCH",
      "icao": "KOCH",
      "faa": "OCH",
      "name": "A.L. Mangham Jr. Regional Airport",
      "city": "Nacogdoches",
      "cityCode": "OCH",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 31.577999,
      "longitude": -94.709503,
      "elevationFeet": 343,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCH?codeType=fs"
     },
     {
      "fs": "OFF",
      "iata": "OFF",
      "icao": "KOFF",
      "faa": "OFF",
      "name": "Offutt Air Force Base",
      "city": "Omaha",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 41.118376,
      "longitude": -95.913037,
      "elevationFeet": 999,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OFF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OFF?codeType=fs"
     },
     {
      "fs": "OFK",
      "iata": "OFK",
      "icao": "KOFK",
      "faa": "OFK",
      "name": "Stefan Field",
      "street1": "Ranch Road 2",
      "street2": "",
      "city": "Norfolk",
      "cityCode": "OFK",
      "stateCode": "NE",
      "postalCode": "68701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "NEZ031",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 41.984167,
      "longitude": -97.434167,
      "elevationFeet": 1573,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OFK?codeType=fs"
     },
     {
      "fs": "OGD",
      "iata": "OGD",
      "icao": "KOGD",
      "faa": "OGD",
      "name": "Ogden Municipal Airport",
      "city": "Ogden",
      "cityCode": "OGD",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 41.196389,
      "longitude": -112.010833,
      "elevationFeet": 4470,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OGD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OGD?codeType=fs"
     },
     {
      "fs": "OGS",
      "iata": "OGS",
      "icao": "KOGS",
      "faa": "OGS",
      "name": "Ogdensburg Airport",
      "city": "Ogdensburg",
      "cityCode": "OGS",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ026",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.681667,
      "longitude": -75.465833,
      "elevationFeet": 297,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OGS?codeType=fs"
     },
     {
      "fs": "OJC",
      "iata": "OJC",
      "icao": "KOJC",
      "faa": "OJC",
      "name": "Johnson Executive Airport",
      "city": "Kansas City",
      "cityCode": "MKC",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 38.85,
      "longitude": -94.733333,
      "elevationFeet": 1096,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OJC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OJC?codeType=fs"
     },
     {
      "fs": "OKK",
      "iata": "OKK",
      "icao": "KOKK",
      "faa": "OKK",
      "name": "Kokomo Municipal Airport",
      "city": "Kokomo",
      "cityCode": "OKK",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.529722,
      "longitude": -86.058056,
      "elevationFeet": 830,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OKK?codeType=fs"
     },
     {
      "fs": "OLE",
      "iata": "OLE",
      "icao": "KOLE",
      "faa": "OLE",
      "name": "Cattaraugus County Airport",
      "city": "Olean",
      "cityCode": "OLE",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.241199,
      "longitude": -78.371399,
      "elevationFeet": 2131,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLE?codeType=fs"
     },
     {
      "fs": "OLF",
      "iata": "OLF",
      "icao": "KOLF",
      "faa": "OLF",
      "name": "Wolf Point International Airport",
      "city": "Wolf Point",
      "cityCode": "OLF",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ020",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 48.094722,
      "longitude": -105.566389,
      "elevationFeet": 1986,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLF?codeType=fs"
     },
     {
      "fs": "OLH",
      "iata": "OLH",
      "icao": "",
      "faa": "OLH",
      "name": "Old Harbor Sea Plane Base",
      "city": "Old Harbor",
      "cityCode": "OLH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.204167,
      "longitude": -153.3,
      "elevationFeet": 55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLH?codeType=fs"
     },
     {
      "fs": "OLM",
      "iata": "OLM",
      "icao": "KOLM",
      "faa": "OLM",
      "name": "Olympia Regional Airport",
      "city": "Olympia",
      "cityCode": "OLM",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 46.973611,
      "longitude": -122.903333,
      "elevationFeet": 206,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLM?codeType=fs"
     },
     {
      "fs": "OLS",
      "iata": "OLS",
      "icao": "KOLS",
      "faa": "OLS",
      "name": "Nogales International Airport",
      "city": "Nogales",
      "cityCode": "OLS",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 31.416667,
      "longitude": -110.85,
      "elevationFeet": 3884,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLS?codeType=fs"
     },
     {
      "fs": "OLV",
      "iata": "OLV",
      "icao": "KOLV",
      "faa": "OLV",
      "name": "Olive Branch Airport",
      "city": "Olive Branch",
      "cityCode": "OLV",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 34.978307,
      "longitude": -89.788449,
      "elevationFeet": 400,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLV?codeType=fs"
     },
     {
      "fs": "OMK",
      "iata": "OMK",
      "icao": "KOMK",
      "faa": "OMK",
      "name": "Omak Municipal Airport",
      "city": "Omak",
      "cityCode": "OMK",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 48.461576,
      "longitude": -119.517174,
      "elevationFeet": 1300,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OMK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OMK?codeType=fs"
     },
     {
      "fs": "ONL",
      "iata": "ONL",
      "icao": "KONL",
      "faa": "ONL",
      "name": "O'Neill Municipal Airport",
      "city": "O'Neill",
      "cityCode": "ONL",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 42.466414,
      "longitude": -98.686259,
      "elevationFeet": 2032,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONL?codeType=fs"
     },
     {
      "fs": "ONO",
      "iata": "ONO",
      "icao": "KONO",
      "faa": "ONO",
      "name": "Ontario Airport",
      "city": "Ontario",
      "cityCode": "ONO",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 44.022778,
      "longitude": -117.013889,
      "elevationFeet": 2193,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONO?codeType=fs"
     },
     {
      "fs": "ONP",
      "iata": "ONP",
      "icao": "KONP",
      "faa": "ONP",
      "name": "Newport Airport",
      "city": "Newport",
      "cityCode": "ONP",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 44.580399,
      "longitude": -124.057999,
      "elevationFeet": 160,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONP?codeType=fs"
     },
     {
      "fs": "OOK",
      "iata": "OOK",
      "icao": "",
      "faa": "OOK",
      "name": "Toksook Bay Airport",
      "city": "Toksook Bay",
      "cityCode": "OOK",
      "stateCode": "AK",
      "postalCode": "99637",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.531944,
      "longitude": -165.108333,
      "elevationFeet": 95,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OOK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OOK?codeType=fs"
     },
     {
      "fs": "OPF",
      "iata": "OPF",
      "icao": "KOPF",
      "faa": "OPF",
      "name": "Opa-locka Executive Airport",
      "city": "Miami",
      "cityCode": "MIA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ074",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 25.90856,
      "longitude": -80.274424,
      "elevationFeet": 6,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OPF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OPF?codeType=fs"
     },
     {
      "fs": "ORH",
      "iata": "ORH",
      "icao": "KORH",
      "faa": "ORH",
      "name": "Worcester Regional Airport",
      "street1": "375 Airport Drive",
      "city": "Worcester",
      "cityCode": "ORH",
      "stateCode": "MA",
      "postalCode": "01602",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ012",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.269167,
      "longitude": -71.874444,
      "elevationFeet": 1009,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORH?codeType=fs"
     },
     {
      "fs": "ORI",
      "iata": "ORI",
      "icao": "",
      "faa": "ORI",
      "name": "Port Lions Sea Plane Base",
      "city": "Port Lions",
      "cityCode": "ORI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.886111,
      "longitude": -152.843889,
      "elevationFeet": 52,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORI?codeType=fs"
     },
     {
      "fs": "ORV",
      "iata": "ORV",
      "icao": "PFNO",
      "faa": "D76",
      "name": "Robert (Bob) Curtis Memorial Airport",
      "city": "Noorvik",
      "cityCode": "ORV",
      "stateCode": "AK",
      "postalCode": "99763",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ208",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 66.817428,
      "longitude": -161.029281,
      "elevationFeet": 50,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORV?codeType=fs"
     },
     {
      "fs": "OSB",
      "iata": "OSB",
      "icao": "",
      "faa": "",
      "name": "Grand Glaize Airport",
      "city": "Osage Beach",
      "cityCode": "OSB",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 38.11437,
      "longitude": -92.68217,
      "elevationFeet": 875,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OSB?codeType=fs"
     },
     {
      "fs": "OSC",
      "iata": "OSC",
      "icao": "KOSC",
      "faa": "OSC",
      "name": "Wurtsmith Air Force Base",
      "city": "Oscoda",
      "cityCode": "OSC",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.453811,
      "longitude": -83.384978,
      "elevationFeet": 621,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OSC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OSC?codeType=fs"
     },
     {
      "fs": "OSH",
      "iata": "OSH",
      "icao": "KOSH",
      "faa": "OSH",
      "name": "Wittman Regional Airport",
      "street1": "525 West, 20th Street",
      "city": "Oshkosh",
      "cityCode": "OSH",
      "stateCode": "WI",
      "postalCode": "54901",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ048",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 43.983889,
      "longitude": -88.556944,
      "elevationFeet": 808,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OSH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OSH?codeType=fs"
     },
     {
      "fs": "OSU",
      "iata": "OSU",
      "icao": "KOSU",
      "faa": "OSU",
      "name": "Ohio State University Airport",
      "city": "Columbus",
      "cityCode": "CMH",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ055",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.075696,
      "longitude": -83.074769,
      "elevationFeet": 905,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OSU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OSU?codeType=fs"
     },
     {
      "fs": "OTH",
      "iata": "OTH",
      "icao": "KOTH",
      "faa": "OTH",
      "name": "Southwest Oregon Regional Airport",
      "city": "North Bend",
      "cityCode": "OTH",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ021",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 43.416235,
      "longitude": -124.245908,
      "elevationFeet": 17,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTH?codeType=fs"
     },
     {
      "fs": "OWB",
      "iata": "OWB",
      "icao": "KOWB",
      "faa": "OWB",
      "name": "Daviess County Airport",
      "street1": "",
      "street2": "",
      "city": "Owensboro",
      "cityCode": "OWB",
      "stateCode": "KY",
      "postalCode": "42301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KYZ019",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 37.740833,
      "longitude": -87.165833,
      "elevationFeet": 406,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OWB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OWB?codeType=fs"
     },
     {
      "fs": "OWD",
      "iata": "OWD",
      "icao": "KOWD",
      "faa": "OWD",
      "name": "Norwood Memorial Airport",
      "city": "Norwood",
      "cityCode": "OWD",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.192124,
      "longitude": -71.176789,
      "elevationFeet": 46,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OWD?codeType=fs"
     },
     {
      "fs": "OXC",
      "iata": "OXC",
      "icao": "KOXC",
      "faa": "OXC",
      "name": "Waterbury-Oxford Airport",
      "city": "Oxford",
      "cityCode": "OXC",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 41.479167,
      "longitude": -73.136389,
      "elevationFeet": 726,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OXC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OXC?codeType=fs"
     },
     {
      "fs": "OXR",
      "iata": "OXR",
      "icao": "KOXR",
      "faa": "OXR",
      "name": "Oxnard Airport",
      "street1": "555 Airport Way",
      "street2": "",
      "city": "Oxnard",
      "cityCode": "OXR",
      "stateCode": "CA",
      "postalCode": "93010",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ045",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 34.201111,
      "longitude": -119.206389,
      "elevationFeet": 43,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OXR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OXR?codeType=fs"
     },
     {
      "fs": "PAE",
      "iata": "PAE",
      "icao": "KPAE",
      "faa": "PAE",
      "name": "Snohomish County Airport",
      "city": "Everett",
      "cityCode": "PAE",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 47.909744,
      "longitude": -122.285618,
      "elevationFeet": 606,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAE?codeType=fs"
     },
     {
      "fs": "PAH",
      "iata": "PAH",
      "icao": "KPAH",
      "faa": "PAH",
      "name": "Barkley Regional Airport",
      "street1": "Fisher Rd. at U.S. 60",
      "street2": "",
      "city": "Paducah",
      "cityCode": "PAH",
      "stateCode": "KY",
      "postalCode": "42086",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KYZ005",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 37.061111,
      "longitude": -88.7725,
      "elevationFeet": 410,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAH?codeType=fs"
     },
     {
      "fs": "PAKU",
      "iata": "UUK",
      "icao": "PAKU",
      "faa": "PAKU",
      "name": "Ugnu-Kuparuk Airport",
      "city": "Ugnu Kuparuk",
      "cityCode": "UUK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 70.330819,
      "longitude": -149.597556,
      "elevationFeet": 75,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAKU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAKU?codeType=fs"
     },
     {
      "fs": "PAM",
      "iata": "PAM",
      "icao": "KPAM",
      "faa": "PAM",
      "name": "Tyndall Air Force Base",
      "city": "Panama City",
      "cityCode": "PFN",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 30.066928,
      "longitude": -85.575637,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAM?codeType=fs"
     },
     {
      "fs": "PAO",
      "iata": "PAO",
      "icao": "KPAO",
      "faa": "PAO",
      "name": "Palo Alto Airport of Santa Clara County",
      "city": "Palo Alto",
      "cityCode": "PAO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.460661,
      "longitude": -122.115247,
      "elevationFeet": 4,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAO?codeType=fs"
     },
     {
      "fs": "PAPB",
      "iata": "",
      "icao": "PAPB",
      "faa": "PAPB",
      "name": "St George",
      "city": "St George",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.67075,
      "longitude": -169.787361,
      "elevationFeet": 125,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAPB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAPB?codeType=fs"
     },
     {
      "fs": "PAQ",
      "iata": "PAQ",
      "icao": "PAAQ",
      "faa": "PAAQ",
      "name": "Palmer Municipal Airport",
      "city": "Palmer",
      "cityCode": "PAQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 61.601497,
      "longitude": -149.087667,
      "elevationFeet": 227,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAQ?codeType=fs"
     },
     {
      "fs": "PBG",
      "iata": "PBG",
      "icao": "KPBG",
      "faa": "PBG",
      "name": "Plattsburgh International Airport",
      "city": "Plattsburgh",
      "cityCode": "PLB",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.658745,
      "longitude": -73.465092,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PBG?codeType=fs"
     },
     {
      "fs": "PCE",
      "icao": "",
      "faa": "",
      "name": "Painter Creek Airport",
      "city": "Painter Creek",
      "cityCode": "PCE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.164167,
      "longitude": -157.433056,
      "elevationFeet": 0,
      "classification": 4,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PCE?codeType=fs"
     },
     {
      "fs": "PCT",
      "iata": "PCT",
      "icao": "",
      "faa": "39N",
      "name": "Princeton Airport",
      "city": "Princeton",
      "cityCode": "PCT",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.3992,
      "longitude": -74.658897,
      "elevationFeet": 126,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PCT?codeType=fs"
     },
     {
      "fs": "PDB",
      "iata": "PDB",
      "icao": "",
      "faa": "4K0",
      "name": "Pedro Bay Airport",
      "city": "Pedro Bay",
      "cityCode": "PDB",
      "stateCode": "AK",
      "postalCode": "99647",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.797036,
      "longitude": -154.130286,
      "elevationFeet": 64,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PDB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PDB?codeType=fs"
     },
     {
      "fs": "PDT",
      "iata": "PDT",
      "icao": "KPDT",
      "faa": "PDT",
      "name": "Eastern Oregon Regional Airport",
      "city": "Pendleton",
      "cityCode": "PDT",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 45.693009,
      "longitude": -118.843229,
      "elevationFeet": 1497,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PDT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PDT?codeType=fs"
     },
     {
      "fs": "PEC",
      "iata": "PEC",
      "icao": "",
      "faa": "",
      "name": "Pelican Sea Plane Base",
      "city": "Pelican",
      "cityCode": "PEC",
      "stateCode": "AK",
      "postalCode": "99832",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ025",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.959723,
      "longitude": -136.2302,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PEC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PEC?codeType=fs"
     },
     {
      "fs": "PEQ",
      "iata": "PEQ",
      "icao": "KPEQ",
      "faa": "PEQ",
      "name": "Pecos Municipal Airport",
      "city": "Pecos City",
      "cityCode": "PEQ",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 31.382401,
      "longitude": -103.511002,
      "elevationFeet": 2602,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PEQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PEQ?codeType=fs"
     },
     {
      "fs": "PGA",
      "iata": "PGA",
      "icao": "KPGA",
      "faa": "PGA",
      "name": "Page Airport",
      "street1": "",
      "street2": "",
      "city": "Page",
      "cityCode": "PGA",
      "stateCode": "AZ",
      "postalCode": "86040",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ005",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 36.926389,
      "longitude": -111.447222,
      "elevationFeet": 4313,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGA?codeType=fs"
     },
     {
      "fs": "PGD",
      "iata": "PGD",
      "icao": "KPGD",
      "faa": "PGD",
      "name": "Charlotte County Airport",
      "city": "Punta Gorda",
      "cityCode": "PGD",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 26.919167,
      "longitude": -81.991389,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGD?codeType=fs"
     },
     {
      "fs": "PGM",
      "iata": "PGM",
      "icao": "",
      "faa": "PGM",
      "name": "Port Graham Airport",
      "city": "Port Graham",
      "cityCode": "PGM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.35,
      "longitude": -151.833333,
      "elevationFeet": 93,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGM?codeType=fs"
     },
     {
      "fs": "PGV",
      "iata": "PGV",
      "icao": "KPGV",
      "faa": "PGV",
      "name": "Pitt-Greenville Airport",
      "street1": "",
      "street2": "",
      "city": "Greenville",
      "cityCode": "PGV",
      "stateCode": "NC",
      "postalCode": "27833",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NCZ044",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 35.633333,
      "longitude": -77.385278,
      "elevationFeet": 27,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGV?codeType=fs"
     },
     {
      "fs": "PHF",
      "iata": "PHF",
      "icao": "KPHF",
      "faa": "PHF",
      "name": "Newport News/Williamsburg International Airport",
      "street1": "900 Bland Boulevard",
      "city": "Newport News",
      "cityCode": "PHF",
      "stateCode": "VA",
      "postalCode": "23602",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ094",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 37.130328,
      "longitude": -76.502825,
      "elevationFeet": 43,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHF?codeType=fs"
     },
     {
      "fs": "PHNG",
      "iata": "NGF",
      "icao": "PHNG",
      "faa": "PHNG",
      "name": "Kaneohe Bay Marine Corps Air Station",
      "city": "Mokapu",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.678",
      "utcOffsetHours": -10,
      "latitude": 21.449229,
      "longitude": -157.769446,
      "elevationFeet": 4,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHNG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHNG?codeType=fs"
     },
     {
      "fs": "PHO",
      "iata": "PHO",
      "icao": "PAPO",
      "faa": "PAPO",
      "name": "Point Hope Airport",
      "city": "Point Hope",
      "cityCode": "PHO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ207",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 68.35,
      "longitude": -166.8,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHO?codeType=fs"
     },
     {
      "fs": "PIB",
      "iata": "PIB",
      "icao": "KPIB",
      "faa": "PIB",
      "name": "Hattiesburg-Laurel Regional Airport",
      "street1": "1002 Terminal Drive",
      "street2": "",
      "city": "Laurel",
      "cityCode": "LUL",
      "stateCode": "MS",
      "postalCode": "39459",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ066",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 31.4675,
      "longitude": -89.336667,
      "elevationFeet": 298,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIB?codeType=fs"
     },
     {
      "fs": "PIE",
      "iata": "PIE",
      "icao": "KPIE",
      "faa": "PIE",
      "name": "St. Petersburg-Clearwater International Airport",
      "street1": "Suite 221 - Terminal Building",
      "city": "Saint Petersburg",
      "cityCode": "PIE",
      "stateCode": "FL",
      "postalCode": "33762",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ050",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 27.912005,
      "longitude": -82.695109,
      "elevationFeet": 11,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIE?codeType=fs"
     },
     {
      "fs": "PIH",
      "iata": "PIH",
      "icao": "KPIH",
      "faa": "PIH",
      "name": "Pocatello Regional Airport",
      "street1": "I-86, Exit 56",
      "city": "Pocatello",
      "cityCode": "PIH",
      "stateCode": "ID",
      "postalCode": "83205-4169",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "IDZ023",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 42.909777,
      "longitude": -112.585879,
      "elevationFeet": 4452,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIH?codeType=fs"
     },
     {
      "fs": "PIP",
      "iata": "PIP",
      "icao": "",
      "faa": "PNP",
      "name": "Pilot Point Airport",
      "city": "Pilot Point",
      "cityCode": "PIP",
      "stateCode": "AK",
      "postalCode": "99649",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.563611,
      "longitude": -157.560833,
      "elevationFeet": 57,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIP?codeType=fs"
     },
     {
      "fs": "PIR",
      "iata": "PIR",
      "icao": "KPIR",
      "faa": "PIR",
      "name": "Pierre Regional Airport",
      "street1": "4001 Airport Road",
      "city": "Pierre",
      "cityCode": "PIR",
      "stateCode": "SD",
      "postalCode": "57501",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "SDZ035",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 44.380362,
      "longitude": -100.293192,
      "elevationFeet": 1742,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIR?codeType=fs"
     },
     {
      "fs": "PIZ",
      "iata": "PIZ",
      "icao": "PPIZ",
      "faa": "PPIZ",
      "name": "Dew Station Airport",
      "city": "Point Lay",
      "cityCode": "PIZ",
      "stateCode": "AK",
      "postalCode": "99759",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ201",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 69.75,
      "longitude": -163.166667,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIZ?codeType=fs"
     },
     {
      "fs": "PJB",
      "iata": "PJB",
      "icao": "KPAN",
      "faa": "PAN",
      "name": "Payson Airport",
      "city": "Payson",
      "cityCode": "PJB",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 34.256544,
      "longitude": -111.339588,
      "elevationFeet": 5137,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PJB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PJB?codeType=fs"
     },
     {
      "fs": "PKA",
      "iata": "PKA",
      "icao": "",
      "faa": "PKA",
      "name": "Napaskiak Sea Plane Base",
      "city": "Napaskiak",
      "cityCode": "PKA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.710833,
      "longitude": -161.758056,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PKA?codeType=fs"
     },
     {
      "fs": "PKB",
      "iata": "PKB",
      "icao": "KPKB",
      "faa": "PKB",
      "name": "Wood County Airport",
      "street1": "",
      "street2": "",
      "city": "Parkersburg",
      "cityCode": "PKB",
      "stateCode": "WV",
      "postalCode": "26101",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ009",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 39.345556,
      "longitude": -81.438889,
      "elevationFeet": 858,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PKB?codeType=fs"
     },
     {
      "fs": "PLN",
      "iata": "PLN",
      "icao": "KPLN",
      "faa": "PLN",
      "name": "Emmet County Airport",
      "street1": "U.S. 31 North",
      "street2": "",
      "city": "Pellston",
      "cityCode": "PLN",
      "stateCode": "MI",
      "postalCode": "49769",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ016",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 45.570833,
      "longitude": -84.792778,
      "elevationFeet": 720,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PLN?codeType=fs"
     },
     {
      "fs": "PMD",
      "iata": "PMD",
      "icao": "KPMD",
      "faa": "PMD",
      "name": "Palmdale Air Force 42 Base",
      "city": "Palmdale",
      "cityCode": "PMD",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 34.6275,
      "longitude": -118.083333,
      "elevationFeet": 2543,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PMD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PMD?codeType=fs"
     },
     {
      "fs": "PML",
      "iata": "PML",
      "icao": "",
      "faa": "",
      "name": "Port Moller Air Force Station",
      "city": "Port Moller",
      "cityCode": "PML",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.005556,
      "longitude": -160.558333,
      "elevationFeet": 9,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PML?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PML?codeType=fs"
     },
     {
      "fs": "PNC",
      "iata": "PNC",
      "icao": "KPNC",
      "faa": "PNC",
      "name": "Ponca City Regional Airport",
      "city": "Ponca City",
      "cityCode": "PNC",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "OKZ008",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 36.728056,
      "longitude": -97.099444,
      "elevationFeet": 1007,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNC?codeType=fs"
     },
     {
      "fs": "PNE",
      "iata": "PNE",
      "icao": "KPNE",
      "faa": "PNE",
      "name": "Northeast Philadelphia Airport",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.080278,
      "longitude": -75.0125,
      "elevationFeet": 121,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNE?codeType=fs"
     },
     {
      "fs": "POB",
      "iata": "POB",
      "icao": "KPOB",
      "faa": "POB",
      "name": "Pope Field",
      "city": "Fayetteville",
      "cityCode": "FAY",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 35.170833,
      "longitude": -79.014444,
      "elevationFeet": 201,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POB?codeType=fs"
     },
     {
      "fs": "POU",
      "iata": "POU",
      "icao": "KPOU",
      "faa": "POU",
      "name": "Dutchess County Airport",
      "city": "Poughkeepsie",
      "cityCode": "POU",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 41.628056,
      "longitude": -73.882778,
      "elevationFeet": 165,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POU?codeType=fs"
     },
     {
      "fs": "PPA",
      "iata": "PPA",
      "icao": "KPPA",
      "faa": "PPA",
      "name": "Perry Lefors Field",
      "city": "Pampa",
      "cityCode": "PPA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 35.533333,
      "longitude": -100.966667,
      "elevationFeet": 3244,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PPA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PPA?codeType=fs"
     },
     {
      "fs": "PPC",
      "iata": "PPC",
      "icao": "PAPR",
      "faa": "PAPR",
      "name": "Prospect Creek Airport",
      "city": "Prospect Creek",
      "cityCode": "PPC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 66.796667,
      "longitude": -150.7,
      "elevationFeet": 1099,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PPC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PPC?codeType=fs"
     },
     {
      "fs": "PPV",
      "iata": "PPV",
      "icao": "",
      "faa": "",
      "name": "Port Protection Sea Plane Base",
      "city": "Port Protection",
      "cityCode": "PPV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ027",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.328853,
      "longitude": -133.610296,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PPV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PPV?codeType=fs"
     },
     {
      "fs": "PQI",
      "iata": "PQI",
      "icao": "KPQI",
      "faa": "PQI",
      "name": "Presque Isle Municipal Airport",
      "street1": "650 Airport Drive, Suite 11",
      "street2": "",
      "city": "Presque Isle",
      "cityCode": "PQI",
      "stateCode": "ME",
      "postalCode": "04769",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ002",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 46.685,
      "longitude": -68.0475,
      "elevationFeet": 534,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PQI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PQI?codeType=fs"
     },
     {
      "fs": "PQS",
      "iata": "PQS",
      "icao": "",
      "faa": "0AK",
      "name": "Pilot Station Airport",
      "city": "Pilot Station",
      "cityCode": "PQS",
      "stateCode": "AK",
      "postalCode": "99650",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 61.934722,
      "longitude": -162.890556,
      "elevationFeet": 275,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PQS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PQS?codeType=fs"
     },
     {
      "fs": "PRB",
      "iata": "PRB",
      "icao": "KPRB",
      "faa": "PRB",
      "name": "Paso Robles Municipal Airport",
      "city": "Paso Robles",
      "cityCode": "PRB",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 35.670556,
      "longitude": -120.625833,
      "elevationFeet": 836,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRB?codeType=fs"
     },
     {
      "fs": "PRC",
      "iata": "PRC",
      "icao": "KPRC",
      "faa": "PRC",
      "name": "Ernest A. Love Field",
      "street1": "6546 Crystal Lane",
      "city": "Prescott",
      "cityCode": "PRC",
      "stateCode": "AZ",
      "postalCode": "86301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "AZZ008",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 34.65,
      "longitude": -112.424167,
      "elevationFeet": 5045,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRC?codeType=fs"
     },
     {
      "fs": "PSC",
      "iata": "PSC",
      "icao": "KPSC",
      "faa": "PSC",
      "name": "Tri-Cities Airport",
      "street1": "3601 N 20th Avenue",
      "city": "Pasco",
      "cityCode": "PSC",
      "stateCode": "WA",
      "postalCode": "99301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ028",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 46.259093,
      "longitude": -119.1152,
      "elevationFeet": 407,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSC?codeType=fs"
     },
     {
      "fs": "PSF",
      "iata": "PSF",
      "icao": "KPSF",
      "faa": "PSF",
      "name": "Pittsfield Municipal Airport",
      "city": "Pittsfield",
      "cityCode": "PSF",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.426667,
      "longitude": -73.291667,
      "elevationFeet": 1194,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSF?codeType=fs"
     },
     {
      "fs": "PSG",
      "iata": "PSG",
      "icao": "PAPG",
      "faa": "PAPG",
      "name": "Petersburg Municipal Airport",
      "street1": "",
      "street2": "",
      "city": "Petersburg",
      "cityCode": "PSG",
      "stateCode": "AK",
      "postalCode": "99833",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ026",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.804167,
      "longitude": -132.9425,
      "elevationFeet": 107,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSG?codeType=fs"
     },
     {
      "fs": "PSK",
      "iata": "PSK",
      "icao": "KPSK",
      "faa": "PSK",
      "name": "New River Valley Airport",
      "city": "Dublin",
      "cityCode": "PSK",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 37.137222,
      "longitude": -80.678611,
      "elevationFeet": 2105,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSK?codeType=fs"
     },
     {
      "fs": "PSM",
      "iata": "PSM",
      "icao": "KPSM",
      "faa": "PSM",
      "name": "Pease Air Force Base",
      "city": "Portsmouth",
      "cityCode": "PSM",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.0779,
      "longitude": -70.823303,
      "elevationFeet": 100,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSM?codeType=fs"
     },
     {
      "fs": "PSN",
      "iata": "PSN",
      "icao": "KPSN",
      "faa": "PSN",
      "name": "Palestine Municipal Airport",
      "city": "Palestine",
      "cityCode": "PSN",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 31.776972,
      "longitude": -95.706372,
      "elevationFeet": 414,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSN?codeType=fs"
     },
     {
      "fs": "PTA",
      "iata": "PTA",
      "icao": "",
      "faa": "",
      "name": "Port Alsworth Airport",
      "city": "Port Alsworth",
      "cityCode": "PTA",
      "stateCode": "AK",
      "postalCode": "99653",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 60.202767,
      "longitude": -154.318713,
      "elevationFeet": 287,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTA?codeType=fs"
     },
     {
      "fs": "PTH",
      "iata": "PTH",
      "icao": "PAPH",
      "faa": "PAPH",
      "name": "Port Heiden Airport",
      "city": "Port Heiden",
      "cityCode": "PTH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 56.956667,
      "longitude": -158.6375,
      "elevationFeet": 88,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTH?codeType=fs"
     },
     {
      "fs": "PTK",
      "iata": "PTK",
      "icao": "KPTK",
      "faa": "PTK",
      "name": "Oakland County International Airport",
      "city": "Pontiac",
      "cityCode": "PTK",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.665101,
      "longitude": -83.420035,
      "elevationFeet": 980,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTK?codeType=fs"
     },
     {
      "fs": "PTU",
      "iata": "PTU",
      "icao": "PAPM",
      "faa": "PAPM",
      "name": "Platinum Airport",
      "city": "Platinum",
      "cityCode": "PTU",
      "stateCode": "AK",
      "postalCode": "99651",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 59.011389,
      "longitude": -161.816944,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTU?codeType=fs"
     },
     {
      "fs": "PTW",
      "iata": "PTW",
      "icao": "KPTW",
      "faa": "PTW",
      "name": "Heritage Field",
      "city": "Pottstown",
      "cityCode": "PTW",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.260373,
      "longitude": -75.669518,
      "elevationFeet": 251,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTW?codeType=fs"
     },
     {
      "fs": "PUB",
      "iata": "PUB",
      "icao": "KPUB",
      "faa": "PUB",
      "name": "Pueblo Memorial Airport",
      "street1": "31201 Bryan Circle",
      "city": "Pueblo",
      "cityCode": "PUB",
      "stateCode": "CO",
      "postalCode": "81001",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ073",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 38.284206,
      "longitude": -104.495106,
      "elevationFeet": 4651,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PUB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PUB?codeType=fs"
     },
     {
      "fs": "PUC",
      "iata": "PUC",
      "icao": "KPUC",
      "faa": "PUC",
      "name": "Carbon County Regional Airport",
      "city": "Price",
      "cityCode": "PUC",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 39.609722,
      "longitude": -110.752778,
      "elevationFeet": 5848,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PUC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PUC?codeType=fs"
     },
     {
      "fs": "PUW",
      "iata": "PUW",
      "icao": "KPUW",
      "faa": "PUW",
      "name": "Pullman-Moscow Regional Airport",
      "city": "Pullman",
      "cityCode": "PUW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ033",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 46.744722,
      "longitude": -117.105,
      "elevationFeet": 2555,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PUW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PUW?codeType=fs"
     },
     {
      "fs": "PVC",
      "iata": "PVC",
      "icao": "KPVC",
      "faa": "PVC",
      "name": "Provincetown Airport",
      "city": "Provincetown",
      "cityCode": "PVC",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MAZ022",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 42.071944,
      "longitude": -70.221667,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVC?codeType=fs"
     },
     {
      "fs": "PVF",
      "iata": "PVF",
      "icao": "KPVF",
      "faa": "PVF",
      "name": "Placerville Airport",
      "city": "Placerville",
      "cityCode": "PVF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.72123,
      "longitude": -120.757327,
      "elevationFeet": 2584,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVF?codeType=fs"
     },
     {
      "fs": "PVU",
      "iata": "PVU",
      "icao": "KPVU",
      "faa": "PVU",
      "name": "Provo Airport",
      "city": "Provo",
      "cityCode": "PVU",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 40.218056,
      "longitude": -111.722222,
      "elevationFeet": 4497,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVU?codeType=fs"
     },
     {
      "fs": "PWA",
      "iata": "PWA",
      "icao": "KPWA",
      "faa": "PWA",
      "name": "Wiley Post Airport",
      "city": "Oklahoma City",
      "cityCode": "OKC",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "OKZ025",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 35.535143,
      "longitude": -97.646416,
      "elevationFeet": 1283,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PWA?codeType=fs"
     },
     {
      "fs": "PWK",
      "iata": "PWK",
      "icao": "KPWK",
      "faa": "PWK",
      "name": "Chicago Executive Airport",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 42.114167,
      "longitude": -87.901667,
      "elevationFeet": 647,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PWK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PWK?codeType=fs"
     },
     {
      "fs": "PWT",
      "iata": "PWT",
      "icao": "KPWT",
      "faa": "PWT",
      "name": "Bremerton National Airport",
      "city": "Bremerton",
      "cityCode": "PWT",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 47.485,
      "longitude": -122.763333,
      "elevationFeet": 439,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PWT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PWT?codeType=fs"
     },
     {
      "fs": "PYM",
      "iata": "PYM",
      "icao": "KPYM",
      "faa": "PYM",
      "name": "Plymouth Municipal Airport",
      "city": "Plymouth",
      "cityCode": "PYM",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 41.909,
      "longitude": -70.728798,
      "elevationFeet": 137,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PYM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PYM?codeType=fs"
     },
     {
      "fs": "RAP",
      "iata": "RAP",
      "icao": "KRAP",
      "faa": "RAP",
      "name": "Rapid City Regional Airport",
      "street1": "4550 Terminal Road, Suite 102",
      "city": "Rapid City",
      "cityCode": "RAP",
      "stateCode": "SD",
      "postalCode": "57703-8706",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "SDZ026",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 44.037581,
      "longitude": -103.061182,
      "elevationFeet": 3202,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RAP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RAP?codeType=fs"
     },
     {
      "fs": "RBD",
      "iata": "RBD",
      "icao": "KRBD",
      "faa": "RBD",
      "name": "Dallas Executive Airport",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 32.680833,
      "longitude": -96.868333,
      "elevationFeet": 660,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBD?codeType=fs"
     },
     {
      "fs": "RBG",
      "iata": "RBG",
      "icao": "KRBG",
      "faa": "RBG",
      "name": "Roseburg Regional Airport",
      "city": "Roseburg",
      "cityCode": "RBG",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 43.235436,
      "longitude": -123.357623,
      "elevationFeet": 501,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBG?codeType=fs"
     },
     {
      "fs": "RBH",
      "iata": "RBH",
      "icao": "",
      "faa": "",
      "name": "Brooks Lodge Airport",
      "city": "Brooks Lodge",
      "cityCode": "RBH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 58.55,
      "longitude": -155.8,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBH?codeType=fs"
     },
     {
      "fs": "RBK",
      "iata": "RBK",
      "icao": "",
      "faa": "F70",
      "name": "French Valley Airport",
      "city": "Murrieta",
      "cityCode": "RBK",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 33.5742,
      "longitude": -117.127998,
      "elevationFeet": 1336,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBK?codeType=fs"
     },
     {
      "fs": "RBL",
      "iata": "RBL",
      "icao": "KRBL",
      "faa": "RBL",
      "name": "Red Bluff Municipal Airport",
      "city": "Red Bluff",
      "cityCode": "RBL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 40.154998,
      "longitude": -122.252468,
      "elevationFeet": 344,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBL?codeType=fs"
     },
     {
      "fs": "RBW",
      "iata": "RBW",
      "icao": "KRBW",
      "faa": "RBW",
      "name": "Lowcountry Regional Airport",
      "city": "Walterboro",
      "cityCode": "RBW",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 32.92106,
      "longitude": -80.640584,
      "elevationFeet": 98,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBW?codeType=fs"
     },
     {
      "fs": "RBY",
      "iata": "RBY",
      "icao": "PARY",
      "faa": "PARY",
      "name": "Ruby Airport",
      "city": "Ruby",
      "cityCode": "RBY",
      "stateCode": "AK",
      "postalCode": "99768",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ216",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 64.73,
      "longitude": -155.460833,
      "elevationFeet": 654,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBY?codeType=fs"
     },
     {
      "fs": "RCA",
      "iata": "RCA",
      "icao": "KRCA",
      "faa": "RCA",
      "name": "Ellsworth Air Force Base",
      "city": "Rapid City",
      "cityCode": "RAP",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 44.145036,
      "longitude": -103.103563,
      "elevationFeet": 3219,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RCA?codeType=fs"
     },
     {
      "fs": "RCE",
      "iata": "RCE",
      "icao": "",
      "faa": "",
      "name": "Roche Harbor Sea Plane Base",
      "city": "Roche Harbor",
      "cityCode": "RCE",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 48.610877,
      "longitude": -123.157356,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RCE?codeType=fs"
     },
     {
      "fs": "RCP",
      "iata": "RCP",
      "icao": "",
      "faa": "",
      "name": "Cinder Park Airport",
      "city": "Cinder Park",
      "cityCode": "RCP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 57.083056,
      "longitude": -157.805556,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RCP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RCP?codeType=fs"
     },
     {
      "fs": "RDB",
      "iata": "RDB",
      "icao": "",
      "faa": "",
      "name": "Red Dog Airport",
      "city": "Red Dog",
      "cityCode": "RDB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 68.03222,
      "longitude": -162.89917,
      "elevationFeet": 972,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDB?codeType=fs"
     },
     {
      "fs": "RDD",
      "iata": "RDD",
      "icao": "KRDD",
      "faa": "RDD",
      "name": "Redding Municipal Airport",
      "street1": "6751 Woodrum Circle, Suite 200",
      "city": "Redding",
      "cityCode": "RDD",
      "stateCode": "CA",
      "postalCode": "96002",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ015",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 40.505769,
      "longitude": -122.299914,
      "elevationFeet": 502,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDD?codeType=fs"
     },
     {
      "fs": "RDG",
      "iata": "RDG",
      "icao": "KRDG",
      "faa": "RDG",
      "name": "Reading Regional Airport",
      "street1": "2501 Bernville Road",
      "city": "Reading",
      "cityCode": "RDG",
      "stateCode": "PA",
      "postalCode": "19605",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ060",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 40.378611,
      "longitude": -75.963889,
      "elevationFeet": 313,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDG?codeType=fs"
     },
     {
      "fs": "RDV",
      "iata": "RDV",
      "icao": "",
      "faa": "RDV",
      "name": "Red Devil Airport",
      "city": "Red Devil",
      "cityCode": "RDV",
      "stateCode": "AK",
      "postalCode": "99656",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 61.787222,
      "longitude": -157.346944,
      "elevationFeet": 210,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDV?codeType=fs"
     },
     {
      "fs": "RFD",
      "iata": "RFD",
      "icao": "KRFD",
      "faa": "RFD",
      "name": "Chicago Rockford International Airport",
      "street1": "2 Airport Cir",
      "city": "Rockford",
      "cityCode": "RFD",
      "stateCode": "IL",
      "postalCode": "61109",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ003",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 42.201748,
      "longitude": -89.095372,
      "elevationFeet": 732,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RFD?codeType=fs"
     },
     {
      "fs": "RHI",
      "iata": "RHI",
      "icao": "KRHI",
      "faa": "RHI",
      "name": "Oneida County Airport",
      "street1": "3375 Airport Road",
      "street2": "",
      "city": "Rhinelander",
      "cityCode": "RHI",
      "stateCode": "WI",
      "postalCode": "54501-9178",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "WIZ010",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 45.625707,
      "longitude": -89.462533,
      "elevationFeet": 1623,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RHI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RHI?codeType=fs"
     },
     {
      "fs": "RHV",
      "iata": "RHV",
      "icao": "KRHV",
      "faa": "RHV",
      "name": "Reid-Hillview Airport",
      "city": "San Jose",
      "cityCode": "SJC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.334155,
      "longitude": -121.818215,
      "elevationFeet": 129,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RHV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RHV?codeType=fs"
     },
     {
      "fs": "RIE",
      "iata": "RIE",
      "icao": "KRPD",
      "faa": "RPD",
      "name": "Rice Lake Regional Airport-Carl's Field",
      "city": "Rice Lake",
      "cityCode": "RIE",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 45.42054,
      "longitude": -91.773847,
      "elevationFeet": 1100,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIE?codeType=fs"
     },
     {
      "fs": "RIL",
      "iata": "RIL",
      "icao": "KRIL",
      "faa": "RIL",
      "name": "Garfield County Airport",
      "city": "Rifle",
      "cityCode": "RIL",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 39.526267,
      "longitude": -107.725484,
      "elevationFeet": 5520,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIL?codeType=fs"
     },
     {
      "fs": "RIV",
      "iata": "RIV",
      "icao": "KRIV",
      "faa": "RIV",
      "name": "March Air Reserve Base",
      "city": "Riverside",
      "cityCode": "RAL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 33.888479,
      "longitude": -117.258414,
      "elevationFeet": 1518,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIV?codeType=fs"
     },
     {
      "fs": "RIW",
      "iata": "RIW",
      "icao": "KRIW",
      "faa": "RIW",
      "name": "Riverton Airport",
      "street1": "4800 Airport Road",
      "street2": "",
      "city": "Riverton",
      "cityCode": "RIW",
      "stateCode": "WY",
      "postalCode": "82501",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ013",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 43.064444,
      "longitude": -108.456944,
      "elevationFeet": 5525,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIW?codeType=fs"
     },
     {
      "fs": "RKD",
      "iata": "RKD",
      "icao": "KRKD",
      "faa": "RKD",
      "name": "Knox County Regional Airport",
      "city": "Rockland",
      "cityCode": "RKD",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MEZ027",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 44.059167,
      "longitude": -69.098056,
      "elevationFeet": 55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKD?codeType=fs"
     },
     {
      "fs": "RKH",
      "iata": "RKH",
      "icao": "KUZA",
      "faa": "UZA",
      "name": "York County Airport-Bryant Field",
      "city": "Rock Hill",
      "cityCode": "RKH",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 34.987798,
      "longitude": -81.057196,
      "elevationFeet": 658,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKH?codeType=fs"
     },
     {
      "fs": "RKS",
      "iata": "RKS",
      "icao": "KRKS",
      "faa": "RKS",
      "name": "Rock Springs-Sweetwater County Airport",
      "city": "Rock Springs",
      "cityCode": "RKS",
      "stateCode": "WY",
      "postalCode": "82901",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ022",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 41.598034,
      "longitude": -109.072092,
      "elevationFeet": 6760,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKS?codeType=fs"
     },
     {
      "fs": "RLA",
      "iata": "RLA",
      "icao": "KVIH",
      "faa": "VIH",
      "name": "Rolla Downtown Airport",
      "city": "Rolla",
      "cityCode": "RLA",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 37.935903,
      "longitude": -91.813478,
      "elevationFeet": 975,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RLA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RLA?codeType=fs"
     },
     {
      "fs": "RLD",
      "iata": "RLD",
      "icao": "KRLD",
      "faa": "RLD",
      "name": "Richland Airport",
      "city": "Richland",
      "cityCode": "RLD",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 46.308333,
      "longitude": -119.305556,
      "elevationFeet": 391,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RLD?codeType=fs"
     },
     {
      "fs": "RME",
      "iata": "RME",
      "icao": "KRME",
      "faa": "RME",
      "name": "Griffiss International Airport",
      "city": "Rome",
      "cityCode": "RME",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.233799,
      "longitude": -75.406998,
      "elevationFeet": 485,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RME?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RME?codeType=fs"
     },
     {
      "fs": "RMG",
      "iata": "RMG",
      "icao": "KRMG",
      "faa": "RMG",
      "name": "Richard B Russell Airport",
      "city": "Rome",
      "cityCode": "RMG",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 34.351389,
      "longitude": -85.158611,
      "elevationFeet": 644,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RMG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RMG?codeType=fs"
     },
     {
      "fs": "RMP",
      "iata": "RMP",
      "icao": "",
      "faa": "RMP",
      "name": "Rampart Airport",
      "city": "Rampart",
      "cityCode": "RMP",
      "stateCode": "AK",
      "postalCode": "99767",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ221",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 65.508333,
      "longitude": -150.140278,
      "elevationFeet": 275,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RMP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RMP?codeType=fs"
     },
     {
      "fs": "RMY",
      "iata": "RMY",
      "icao": "",
      "faa": "",
      "name": "Mariposa-Yosemite Airport",
      "city": "Mariposa",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 37.51083,
      "longitude": -120.03944,
      "elevationFeet": 2234,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RMY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RMY?codeType=fs"
     },
     {
      "fs": "RND",
      "iata": "RND",
      "icao": "KRND",
      "faa": "RND",
      "name": "Randolph Air Force Base",
      "city": "San Antonio",
      "cityCode": "SAT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 29.529672,
      "longitude": -98.27889,
      "elevationFeet": 738,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RND?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RND?codeType=fs"
     },
     {
      "fs": "RNG",
      "iata": "RNG",
      "icao": "",
      "faa": "4V0",
      "name": "Rangely Airport",
      "city": "Rangely",
      "cityCode": "RNG",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 40.094722,
      "longitude": -108.760556,
      "elevationFeet": 5243,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RNG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RNG?codeType=fs"
     },
     {
      "fs": "RNT",
      "iata": "RNT",
      "icao": "KRNT",
      "faa": "RNT",
      "name": "Renton Municipal Airport",
      "city": "Renton",
      "cityCode": "RNT",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 47.493099,
      "longitude": -122.216003,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RNT?codeType=fs"
     },
     {
      "fs": "ROG",
      "iata": "ROG",
      "icao": "KROG",
      "faa": "ROG",
      "name": "Rogers Municipal Airport - Carter Field",
      "city": "Rogers",
      "cityCode": "ROG",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 36.372222,
      "longitude": -94.106667,
      "elevationFeet": 1353,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ROG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ROG?codeType=fs"
     },
     {
      "fs": "ROW",
      "iata": "ROW",
      "icao": "KROW",
      "faa": "ROW",
      "name": "Roswell International Air Center",
      "city": "Roswell",
      "cityCode": "ROW",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 33.305389,
      "longitude": -104.525744,
      "elevationFeet": 3671,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ROW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ROW?codeType=fs"
     },
     {
      "fs": "ROX",
      "iata": "ROX",
      "icao": "KROX",
      "faa": "ROX",
      "name": "Roseau Municipal Airport",
      "city": "Roseau",
      "cityCode": "ROX",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 48.853845,
      "longitude": -95.696899,
      "elevationFeet": 1058,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ROX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ROX?codeType=fs"
     },
     {
      "fs": "RSH",
      "iata": "RSH",
      "icao": "",
      "faa": "RSH",
      "name": "Russian Mission Airport",
      "city": "Russian Mission",
      "cityCode": "RSH",
      "stateCode": "AK",
      "postalCode": "99657",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ215",
      "localTime": "2022-11-09T03:41:39.678",
      "utcOffsetHours": -9,
      "latitude": 61.783056,
      "longitude": -161.319167,
      "elevationFeet": 50,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSH?codeType=fs"
     },
     {
      "fs": "RSJ",
      "iata": "RSJ",
      "icao": "",
      "faa": "W49",
      "name": "Rosario Sea Plane Base",
      "city": "Rosario",
      "cityCode": "RSJ",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 48.646262,
      "longitude": -122.870414,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSJ?codeType=fs"
     },
     {
      "fs": "RUT",
      "iata": "RUT",
      "icao": "KRUT",
      "faa": "RUT",
      "name": "Rutland Airport",
      "city": "Rutland",
      "cityCode": "RUT",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VTZ011",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 43.529444,
      "longitude": -72.948333,
      "elevationFeet": 787,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RUT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RUT?codeType=fs"
     },
     {
      "fs": "RVS",
      "iata": "RVS",
      "icao": "KRVS",
      "faa": "RVS",
      "name": "Richard Lloyd Jones Jr Airport",
      "city": "Tulsa",
      "cityCode": "TUL",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 36.038843,
      "longitude": -95.98448,
      "elevationFeet": 622,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RVS?codeType=fs"
     },
     {
      "fs": "RWI",
      "iata": "RWI",
      "icao": "KRWI",
      "faa": "RWI",
      "name": "Rocky Mount-Wilson Airport",
      "city": "Rocky Mount/Wilson",
      "cityCode": "RWI",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.678",
      "utcOffsetHours": -5,
      "latitude": 35.854444,
      "longitude": -77.890556,
      "elevationFeet": 159,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RWI?codeType=fs"
     },
     {
      "fs": "RWL",
      "iata": "RWL",
      "icao": "KRWL",
      "faa": "RWL",
      "name": "Rawlins Municipal Airport (Harvey Field)",
      "city": "Rawlins",
      "cityCode": "RWL",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 41.804444,
      "longitude": -107.201389,
      "elevationFeet": 6768,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RWL?codeType=fs"
     },
     {
      "fs": "S47",
      "iata": "OTK",
      "icao": "KTMK",
      "faa": "TMK",
      "name": "Tillamook Airport",
      "city": "Tillamook",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 45.417299,
      "longitude": -123.814525,
      "elevationFeet": 31,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S47?codeType=fs"
     },
     {
      "fs": "SAA",
      "iata": "SAA",
      "icao": "KSAA",
      "faa": "SAA",
      "name": "Shively Field",
      "city": "Saratoga",
      "cityCode": "SAA",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 41.444782,
      "longitude": -106.823933,
      "elevationFeet": 6923,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAA?codeType=fs"
     },
     {
      "fs": "SAC",
      "iata": "SAC",
      "icao": "KSAC",
      "faa": "SAC",
      "name": "Sacramento Executive Airport",
      "city": "Sacramento",
      "cityCode": "SAC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 38.513195,
      "longitude": -121.494136,
      "elevationFeet": 20,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAC?codeType=fs"
     },
     {
      "fs": "SAD",
      "iata": "SAD",
      "icao": "KSAD",
      "faa": "SAD",
      "name": "Safford Regional Airport",
      "city": "Safford",
      "cityCode": "SAD",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 32.853332,
      "longitude": -109.636769,
      "elevationFeet": 3170,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAD?codeType=fs"
     },
     {
      "fs": "SAF",
      "iata": "SAF",
      "icao": "KSAF",
      "faa": "SAF",
      "name": "Santa Fe Municipal Airport",
      "city": "Santa Fe",
      "cityCode": "SAF",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.678",
      "utcOffsetHours": -7,
      "latitude": 35.6175,
      "longitude": -106.088333,
      "elevationFeet": 6348,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAF?codeType=fs"
     },
     {
      "fs": "SBD",
      "iata": "SBD",
      "icao": "KSBD",
      "faa": "SBD",
      "name": "San Bernadino International Airport",
      "city": "San Bernardino",
      "cityCode": "SBT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 34.098476,
      "longitude": -117.242902,
      "elevationFeet": 1101,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBD?codeType=fs"
     },
     {
      "fs": "SBM",
      "iata": "SBM",
      "icao": "KSBM",
      "faa": "SBM",
      "name": "Sheboygan County Memorial Airport",
      "city": "Sheboygan",
      "cityCode": "SBM",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.678",
      "utcOffsetHours": -6,
      "latitude": 43.764751,
      "longitude": -87.850707,
      "elevationFeet": 741,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBM?codeType=fs"
     },
     {
      "fs": "SBP",
      "iata": "SBP",
      "icao": "KSBP",
      "faa": "SBP",
      "name": "San Luis Obispo County Regional Airport",
      "street1": "901 Airport Drive",
      "city": "San Luis Obispo",
      "cityCode": "CSL",
      "stateCode": "CA",
      "postalCode": "93401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ034",
      "localTime": "2022-11-09T04:41:39.678",
      "utcOffsetHours": -8,
      "latitude": 35.239113,
      "longitude": -120.640623,
      "elevationFeet": 209,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBP?codeType=fs"
     },
     {
      "fs": "SBS",
      "iata": "SBS",
      "icao": "KSBS",
      "faa": "SBS",
      "name": "Bob Adams Field",
      "city": "Steamboat Springs",
      "cityCode": "SBS",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 40.516366,
      "longitude": -106.866379,
      "elevationFeet": 6881,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBS?codeType=fs"
     },
     {
      "fs": "SBY",
      "iata": "SBY",
      "icao": "KSBY",
      "faa": "SBY",
      "name": "Wicomico Regional Airport",
      "street1": "5485 Airport Terminal Road Unit A",
      "city": "Salisbury-Ocean City",
      "cityCode": "SBY",
      "stateCode": "MD",
      "postalCode": "21804",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MDZ022",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 38.34312,
      "longitude": -75.517269,
      "elevationFeet": 52,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBY?codeType=fs"
     },
     {
      "fs": "SCC",
      "iata": "SCC",
      "icao": "PASC",
      "faa": "PASC",
      "name": "Prudhoe Bay/Deadhorse Airport",
      "city": "Prudhoe Bay/Deadhorse",
      "cityCode": "SCC",
      "stateCode": "AK",
      "postalCode": "99734",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ203",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 70.196561,
      "longitude": -148.464206,
      "elevationFeet": 61,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCC?codeType=fs"
     },
     {
      "fs": "SCE",
      "iata": "SCE",
      "icao": "KUNV",
      "faa": "UNV",
      "name": "University Park Airport",
      "city": "State College",
      "cityCode": "SCE",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "PAZ019",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.853721,
      "longitude": -77.848228,
      "elevationFeet": 1239,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCE?codeType=fs"
     },
     {
      "fs": "SCF",
      "iata": "SCF",
      "icao": "KSDL",
      "faa": "SDL",
      "name": "Scottsdale Airport",
      "city": "Phoenix",
      "cityCode": "PHX",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 33.621966,
      "longitude": -111.908681,
      "elevationFeet": 1471,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCF?codeType=fs"
     },
     {
      "fs": "SCH",
      "iata": "SCH",
      "icao": "KSCH",
      "faa": "SCH",
      "name": "Schenectady County Airport",
      "city": "Schenectady",
      "cityCode": "SCH",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.853488,
      "longitude": -73.92849,
      "elevationFeet": 335,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCH?codeType=fs"
     },
     {
      "fs": "SCK",
      "iata": "SCK",
      "icao": "KSCK",
      "faa": "SCK",
      "name": "Stockton Airport",
      "street1": "5000 South Airport Way, Room 202",
      "street2": "",
      "city": "Stockton",
      "cityCode": "SCK",
      "stateCode": "CA",
      "postalCode": "95206",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ018",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 37.894444,
      "longitude": -121.239167,
      "elevationFeet": 30,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCK?codeType=fs"
     },
     {
      "fs": "SCM",
      "iata": "SCM",
      "icao": "",
      "faa": "SCM",
      "name": "Scammon Bay Sea Plane Base",
      "city": "Scammon Bay",
      "cityCode": "SCM",
      "stateCode": "AK",
      "postalCode": "99662",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.846389,
      "longitude": -165.593889,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCM?codeType=fs"
     },
     {
      "fs": "SDM",
      "iata": "SDM",
      "icao": "KSDM",
      "faa": "SDM",
      "name": "Brown Field Municipal Airport",
      "city": "San Diego",
      "cityCode": "SAN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 32.572222,
      "longitude": -116.98,
      "elevationFeet": 526,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SDM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SDM?codeType=fs"
     },
     {
      "fs": "SDP",
      "iata": "SDP",
      "icao": "PASD",
      "faa": "PASD",
      "name": "Sand Point Municipal Airport",
      "city": "Sand Point",
      "cityCode": "SDP",
      "stateCode": "AK",
      "postalCode": "99661",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ181",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 55.316667,
      "longitude": -160.513889,
      "elevationFeet": 21,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SDP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SDP?codeType=fs"
     },
     {
      "fs": "SDX",
      "iata": "SDX",
      "icao": "KSEZ",
      "faa": "SEZ",
      "name": "Sedona Airport",
      "city": "Sedona",
      "cityCode": "SDX",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 34.848598,
      "longitude": -111.788002,
      "elevationFeet": 4790,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SDX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SDX?codeType=fs"
     },
     {
      "fs": "SDY",
      "iata": "SDY",
      "icao": "KSDY",
      "faa": "SDY",
      "name": "Richland Municipal Airport",
      "city": "Sidney",
      "cityCode": "SDY",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "MTZ024",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 47.706944,
      "longitude": -104.191944,
      "elevationFeet": 1984,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SDY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SDY?codeType=fs"
     },
     {
      "fs": "SEE",
      "iata": "SEE",
      "icao": "KSEE",
      "faa": "SEE",
      "name": "Gillespie Field",
      "city": "San Diego",
      "cityCode": "SAN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 32.826111,
      "longitude": -116.972222,
      "elevationFeet": 387,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SEE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SEE?codeType=fs"
     },
     {
      "fs": "SEG",
      "iata": "SEG",
      "icao": "KSEG",
      "faa": "SEG",
      "name": "Penn Valley Airport",
      "city": "Selinsgrove",
      "cityCode": "SEG",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.820599,
      "longitude": -76.863899,
      "elevationFeet": 444,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SEG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SEG?codeType=fs"
     },
     {
      "fs": "SFB",
      "iata": "SFB",
      "icao": "KSFB",
      "faa": "SFB",
      "name": "Orlando Sanford International Airport",
      "city": "Orlando",
      "cityCode": "ORL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ045",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 28.775118,
      "longitude": -81.243204,
      "elevationFeet": 55,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SFB?codeType=fs"
     },
     {
      "fs": "SFF",
      "iata": "SFF",
      "icao": "KSFF",
      "faa": "SFF",
      "name": "Felts Field",
      "city": "Spokane",
      "cityCode": "GEG",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 47.683148,
      "longitude": -117.322714,
      "elevationFeet": 1950,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SFF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SFF?codeType=fs"
     },
     {
      "fs": "SFM",
      "iata": "SFM",
      "icao": "KSFM",
      "faa": "SFM",
      "name": "Seacoast Regional Airport",
      "city": "Sanford",
      "cityCode": "SFM",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.393902,
      "longitude": -70.708,
      "elevationFeet": 227,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SFM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SFM?codeType=fs"
     },
     {
      "fs": "SFZ",
      "iata": "SFZ",
      "icao": "KSFZ",
      "faa": "SFZ",
      "name": "North Central State Airport",
      "city": "Pawtucket",
      "cityCode": "SFZ",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.920799,
      "longitude": -71.491402,
      "elevationFeet": 427,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SFZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SFZ?codeType=fs"
     },
     {
      "fs": "SGR",
      "iata": "SGR",
      "icao": "KSGR",
      "faa": "SGR",
      "name": "Sugar Land Municipal Airport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 29.611597,
      "longitude": -95.647824,
      "elevationFeet": 75,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGR?codeType=fs"
     },
     {
      "fs": "SGU",
      "iata": "SGU",
      "icao": "KSGU",
      "faa": "SGU",
      "name": "Saint George Municipal Airport",
      "city": "Saint George",
      "cityCode": "SGU",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "UTZ019",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 37.032628,
      "longitude": -113.510167,
      "elevationFeet": 2884,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGU?codeType=fs"
     },
     {
      "fs": "SGY",
      "iata": "SGY",
      "icao": "PAGY",
      "faa": "PAGY",
      "name": "Skagway Airport",
      "city": "Skagway",
      "cityCode": "SGY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ024",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 59.460556,
      "longitude": -135.315556,
      "elevationFeet": 44,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGY?codeType=fs"
     },
     {
      "fs": "SHD",
      "iata": "SHD",
      "icao": "KSHD",
      "faa": "SHD",
      "name": "Shenandoah Valley Airport",
      "street1": "77 Aviation Circle",
      "street2": "",
      "city": "Staunton",
      "cityCode": "SHD",
      "stateCode": "VA",
      "postalCode": "24486",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "VAZ025",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 38.263889,
      "longitude": -78.896667,
      "elevationFeet": 1201,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHD?codeType=fs"
     },
     {
      "fs": "SHG",
      "iata": "SHG",
      "icao": "",
      "faa": "SHG",
      "name": "Shungnak Airport",
      "city": "Shungnak",
      "cityCode": "SHG",
      "stateCode": "AK",
      "postalCode": "99773",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ217",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 66.889722,
      "longitude": -157.157778,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHG?codeType=fs"
     },
     {
      "fs": "SHH",
      "iata": "SHH",
      "icao": "PASH",
      "faa": "PASH",
      "name": "Shishmaref Airport",
      "city": "Shishmaref",
      "cityCode": "SHH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ207",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 66.256944,
      "longitude": -166.058333,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHH?codeType=fs"
     },
     {
      "fs": "SHR",
      "iata": "SHR",
      "icao": "KSHR",
      "faa": "SHR",
      "name": "Sheridan Airport",
      "street1": "Airport Terminal Building",
      "street2": "",
      "city": "Sheridan",
      "cityCode": "SHR",
      "stateCode": "WY",
      "postalCode": "82801-5896",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ099",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.774167,
      "longitude": -106.977222,
      "elevationFeet": 4024,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHR?codeType=fs"
     },
     {
      "fs": "SHX",
      "iata": "SHX",
      "icao": "",
      "faa": "SHX",
      "name": "Shageluk Airport",
      "city": "Shageluk",
      "cityCode": "SHX",
      "stateCode": "AK",
      "postalCode": "99665",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ215",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 62.695833,
      "longitude": -159.566667,
      "elevationFeet": 70,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHX?codeType=fs"
     },
     {
      "fs": "SIT",
      "iata": "SIT",
      "icao": "PASI",
      "faa": "PASI",
      "name": "Sitka Airport",
      "street1": "605 Airport Road",
      "street2": "",
      "city": "Sitka",
      "cityCode": "SIT",
      "stateCode": "AK",
      "postalCode": "99835",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ023",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 57.0471,
      "longitude": -135.362,
      "elevationFeet": 21,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SIT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SIT?codeType=fs"
     },
     {
      "fs": "SJT",
      "iata": "SJT",
      "icao": "KSJT",
      "faa": "SJT",
      "name": "San Angelo Regional Airport",
      "street1": "8618 Terminal Circle",
      "city": "San Angelo",
      "cityCode": "SJT",
      "stateCode": "TX",
      "postalCode": "76904",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ072",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.359722,
      "longitude": -100.494444,
      "elevationFeet": 1919,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SJT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SJT?codeType=fs"
     },
     {
      "fs": "SKA",
      "iata": "SKA",
      "icao": "KSKA",
      "faa": "SKA",
      "name": "Fairchild Air Force Base",
      "city": "Spokane",
      "cityCode": "GEG",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 47.615154,
      "longitude": -117.655561,
      "elevationFeet": 2442,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SKA?codeType=fs"
     },
     {
      "fs": "SKF",
      "iata": "SKF",
      "icao": "KSKF",
      "faa": "SKF",
      "name": "Kelly Field Annex",
      "city": "San Antonio",
      "cityCode": "SAT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 29.372971,
      "longitude": -98.570968,
      "elevationFeet": 671,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SKF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SKF?codeType=fs"
     },
     {
      "fs": "SKK",
      "iata": "SKK",
      "icao": "",
      "faa": "38A",
      "name": "Shaktoolik Airport",
      "city": "Shaktoolik",
      "cityCode": "SKK",
      "stateCode": "AK",
      "postalCode": "99771",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 64.324167,
      "longitude": -161.138889,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SKK?codeType=fs"
     },
     {
      "fs": "SLE",
      "iata": "SLE",
      "icao": "KSLE",
      "faa": "SLE",
      "name": "McNary Field",
      "city": "Salem",
      "cityCode": "SLE",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 44.909534,
      "longitude": -123.002496,
      "elevationFeet": 200,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLE?codeType=fs"
     },
     {
      "fs": "SLK",
      "iata": "SLK",
      "icao": "KSLK",
      "faa": "SLK",
      "name": "Adirondack Airport",
      "city": "Saranac Lake",
      "cityCode": "SLK",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ030",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.382778,
      "longitude": -74.206667,
      "elevationFeet": 1663,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLK?codeType=fs"
     },
     {
      "fs": "SLN",
      "iata": "SLN",
      "icao": "KSLN",
      "faa": "SLN",
      "name": "Salina Regional Airport",
      "city": "Salina",
      "cityCode": "SLN",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "KSZ049",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 38.790833,
      "longitude": -97.6525,
      "elevationFeet": 1273,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLN?codeType=fs"
     },
     {
      "fs": "SLQ",
      "iata": "SLQ",
      "icao": "PASL",
      "faa": "PASL",
      "name": "Sleetmute Airport",
      "city": "Sleetmute",
      "cityCode": "SLQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.705,
      "longitude": -157.166667,
      "elevationFeet": 178,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLQ?codeType=fs"
     },
     {
      "fs": "SLR",
      "iata": "SLR",
      "icao": "KSLR",
      "faa": "SLR",
      "name": "Sulphur Springs Airport",
      "city": "Sulphur Springs",
      "cityCode": "SLR",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.159655,
      "longitude": -95.618679,
      "elevationFeet": 478,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLR?codeType=fs"
     },
     {
      "fs": "SMK",
      "iata": "SMK",
      "icao": "",
      "faa": "",
      "name": "St. Michael Airport",
      "city": "Saint Michael",
      "cityCode": "SMK",
      "stateCode": "AK",
      "postalCode": "99659",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 63.484295,
      "longitude": -162.111813,
      "elevationFeet": 102,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMK?codeType=fs"
     },
     {
      "fs": "SMN",
      "iata": "SMN",
      "icao": "KSMN",
      "faa": "SMN",
      "name": "Lemhi County Airport",
      "city": "Salmon",
      "cityCode": "SMN",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 45.115059,
      "longitude": -113.885913,
      "elevationFeet": 4046,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMN?codeType=fs"
     },
     {
      "fs": "SMO",
      "iata": "SMO",
      "icao": "KSMO",
      "faa": "SMO",
      "name": "Santa Monica Municipal Airport",
      "city": "Santa Monica",
      "cityCode": "SMO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.017736,
      "longitude": -118.449646,
      "elevationFeet": 175,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMO?codeType=fs"
     },
     {
      "fs": "SMX",
      "iata": "SMX",
      "icao": "KSMX",
      "faa": "SMX",
      "name": "Santa Maria Public Airport",
      "street1": "3249 Terminal Drive",
      "city": "Santa Maria",
      "cityCode": "SMX",
      "stateCode": "CA",
      "postalCode": "93455",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ035",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.905,
      "longitude": -120.457778,
      "elevationFeet": 259,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMX?codeType=fs"
     },
     {
      "fs": "SNK",
      "iata": "SNK",
      "icao": "KSNK",
      "faa": "SNK",
      "name": "Winston Field",
      "city": "Snyder",
      "cityCode": "SNK",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.716667,
      "longitude": -100.9,
      "elevationFeet": 2430,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SNK?codeType=fs"
     },
     {
      "fs": "SNP",
      "iata": "SNP",
      "icao": "PASN",
      "faa": "PASN",
      "name": "Saint Paul Island Airport",
      "city": "Saint Paul Island",
      "cityCode": "SNP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ195",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 57.152222,
      "longitude": -170.217222,
      "elevationFeet": 63,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SNP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SNP?codeType=fs"
     },
     {
      "fs": "SNS",
      "iata": "SNS",
      "icao": "KSNS",
      "faa": "SNS",
      "name": "Salinas Municipal Airport",
      "city": "Salinas",
      "cityCode": "SNS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 36.664911,
      "longitude": -121.610426,
      "elevationFeet": 75,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SNS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SNS?codeType=fs"
     },
     {
      "fs": "SNY",
      "iata": "SNY",
      "icao": "KSNY",
      "faa": "SNY",
      "name": "Sidney Municipal Airport",
      "city": "Sidney",
      "cityCode": "SNY",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 41.099444,
      "longitude": -102.9825,
      "elevationFeet": 4313,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SNY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SNY?codeType=fs"
     },
     {
      "fs": "SOP",
      "iata": "SOP",
      "icao": "KSOP",
      "faa": "SOP",
      "name": "Moore County Airport",
      "city": "Southern Pines",
      "cityCode": "SOP",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 35.237611,
      "longitude": -79.388796,
      "elevationFeet": 438,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SOP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SOP?codeType=fs"
     },
     {
      "fs": "SOV",
      "iata": "SOV",
      "icao": "PASO",
      "faa": "PASO",
      "name": "Seldovia Airport",
      "city": "Seldovia",
      "cityCode": "SOV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 59.4425,
      "longitude": -151.704167,
      "elevationFeet": 29,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SOV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SOV?codeType=fs"
     },
     {
      "fs": "SOW",
      "iata": "SOW",
      "icao": "KSOW",
      "faa": "SOW",
      "name": "Show Low Airport",
      "city": "Show Low",
      "cityCode": "SOW",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 34.264444,
      "longitude": -110.004167,
      "elevationFeet": 6412,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SOW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SOW?codeType=fs"
     },
     {
      "fs": "SPG",
      "iata": "SPG",
      "icao": "KSPG",
      "faa": "SPG",
      "name": "St Pete-Albert Whitted Airport",
      "city": "Saint Petersburg",
      "cityCode": "PIE",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 27.766944,
      "longitude": -82.625278,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPG?codeType=fs"
     },
     {
      "fs": "SPI",
      "iata": "SPI",
      "icao": "KSPI",
      "faa": "SPI",
      "name": "Capital Airport",
      "street1": "1200 Capital Airport Drive",
      "street2": "",
      "city": "Springfield",
      "cityCode": "SPI",
      "stateCode": "IL",
      "postalCode": "62707",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ051",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.844167,
      "longitude": -89.678889,
      "elevationFeet": 597,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPI?codeType=fs"
     },
     {
      "fs": "SPS",
      "iata": "SPS",
      "icao": "KSPS",
      "faa": "SPS",
      "name": "Wichita Falls Municipal Airport/Sheppard Air Force Base",
      "city": "Wichita Falls",
      "cityCode": "SPS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.988333,
      "longitude": -98.491944,
      "elevationFeet": 1019,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPS?codeType=fs"
     },
     {
      "fs": "SPZ",
      "iata": "SPZ",
      "icao": "KASG",
      "faa": "ASG",
      "name": "Springdale Municipal Airport",
      "city": "Springdale",
      "cityCode": "SPZ",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.183333,
      "longitude": -94.166667,
      "elevationFeet": 1353,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPZ?codeType=fs"
     },
     {
      "fs": "SQA",
      "iata": "SQA",
      "icao": "KIZA",
      "faa": "IZA",
      "name": "Santa Ynez Airport",
      "city": "Santa Ynez",
      "cityCode": "SQA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.60694,
      "longitude": -120.07556,
      "elevationFeet": 664,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SQA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SQA?codeType=fs"
     },
     {
      "fs": "SQL",
      "iata": "SQL",
      "icao": "KSQL",
      "faa": "SQL",
      "name": "San Carlos Airport",
      "city": "San Carlos",
      "cityCode": "SQL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 37.511902,
      "longitude": -122.25,
      "elevationFeet": 5,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SQL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SQL?codeType=fs"
     },
     {
      "fs": "SRQ",
      "iata": "SRQ",
      "icao": "KSRQ",
      "faa": "SRQ",
      "name": "Sarasota Bradenton International Airport",
      "street1": "6000 Airport Circle",
      "city": "Sarasota",
      "cityCode": "SRQ",
      "stateCode": "FL",
      "postalCode": "34243",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "FLZ055",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 27.38748,
      "longitude": -82.553282,
      "elevationFeet": 27,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SRQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SRQ?codeType=fs"
     },
     {
      "fs": "SRV",
      "iata": "SRV",
      "icao": "",
      "faa": "SRV",
      "name": "Stony River Airport",
      "city": "Stony River",
      "cityCode": "SRV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.788762,
      "longitude": -156.58863,
      "elevationFeet": 250,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SRV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SRV?codeType=fs"
     },
     {
      "fs": "SSC",
      "iata": "SSC",
      "icao": "KSSC",
      "faa": "SSC",
      "name": "Shaw Air Force Base",
      "city": "Sumter",
      "cityCode": "SSC",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 33.972178,
      "longitude": -80.47071,
      "elevationFeet": 242,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SSC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SSC?codeType=fs"
     },
     {
      "fs": "SSI",
      "iata": "SSI",
      "icao": "KSSI",
      "faa": "SSI",
      "name": "McKinnon St. Simons Island Airport",
      "city": "Brunswick",
      "cityCode": "SSI",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 31.152237,
      "longitude": -81.390313,
      "elevationFeet": 14,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SSI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SSI?codeType=fs"
     },
     {
      "fs": "SSW",
      "iata": "SSW",
      "icao": "",
      "faa": "",
      "name": "Stuart Island Airport",
      "city": "Stuart Island",
      "cityCode": "SSW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 48.672878,
      "longitude": -123.175745,
      "elevationFeet": 10,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SSW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SSW?codeType=fs"
     },
     {
      "fs": "STC",
      "iata": "STC",
      "icao": "KSTC",
      "faa": "STC",
      "name": "St. Cloud Municipal Airport",
      "city": "Saint Cloud",
      "cityCode": "STC",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ049",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 45.545616,
      "longitude": -94.057826,
      "elevationFeet": 989,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STC?codeType=fs"
     },
     {
      "fs": "STE",
      "iata": "STE",
      "icao": "KSTE",
      "faa": "STE",
      "name": "Stevens Point Municipal Airport",
      "city": "Stevens Point",
      "cityCode": "STE",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 44.545278,
      "longitude": -89.530833,
      "elevationFeet": 1110,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STE?codeType=fs"
     },
     {
      "fs": "STG",
      "iata": "STG",
      "icao": "",
      "faa": "",
      "name": "St. George Island Airport",
      "city": "Saint George Island",
      "cityCode": "STG",
      "stateCode": "AK",
      "postalCode": "99591",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ195",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 56.6,
      "longitude": -169.5525,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STG?codeType=fs"
     },
     {
      "fs": "STK",
      "iata": "STK",
      "icao": "KSTK",
      "faa": "STK",
      "name": "Sterling Municipal Airport",
      "city": "Sterling",
      "cityCode": "STK",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 40.615312,
      "longitude": -103.264838,
      "elevationFeet": 4028,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STK?codeType=fs"
     },
     {
      "fs": "STS",
      "iata": "STS",
      "icao": "KSTS",
      "faa": "STS",
      "name": "Sonoma County Airport",
      "street1": "2200 Airport Boulevard",
      "city": "Santa Rosa",
      "cityCode": "STS",
      "stateCode": "CA",
      "postalCode": "95403",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.509962,
      "longitude": -122.806704,
      "elevationFeet": 125,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STS?codeType=fs"
     },
     {
      "fs": "SUA",
      "iata": "SUA",
      "icao": "KSUA",
      "faa": "SUA",
      "name": "Witham Field",
      "city": "Stuart",
      "cityCode": "SUA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 27.182892,
      "longitude": -80.221679,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUA?codeType=fs"
     },
     {
      "fs": "SUN",
      "iata": "SUN",
      "icao": "KSUN",
      "faa": "SUN",
      "name": "Friedman Memorial Airport",
      "city": "Sun Valley",
      "cityCode": "SUN",
      "stateCode": "ID",
      "postalCode": "83333",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "IDZ031",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 43.506471,
      "longitude": -114.300822,
      "elevationFeet": 5315,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUN?codeType=fs"
     },
     {
      "fs": "SUO",
      "iata": "SUO",
      "icao": "",
      "faa": "S21",
      "name": "Sunriver Airport",
      "city": "Sunriver",
      "cityCode": "SUO",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 43.876301,
      "longitude": -121.453003,
      "elevationFeet": 4164,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUO?codeType=fs"
     },
     {
      "fs": "SUU",
      "iata": "SUU",
      "icao": "KSUU",
      "faa": "SUU",
      "name": "Travis Air Force Base",
      "city": "Fairfield",
      "cityCode": "SUU",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.264321,
      "longitude": -121.936722,
      "elevationFeet": 47,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUU?codeType=fs"
     },
     {
      "fs": "SUX",
      "iata": "SUX",
      "icao": "KSUX",
      "faa": "SUX",
      "name": "Sioux Gateway Airport",
      "street1": "2403 Odgen Road",
      "street2": "",
      "city": "Sioux City",
      "cityCode": "SUX",
      "stateCode": "IA",
      "postalCode": "51111",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "IAZ031",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.401944,
      "longitude": -96.384167,
      "elevationFeet": 1098,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUX?codeType=fs"
     },
     {
      "fs": "SVA",
      "iata": "SVA",
      "icao": "PASA",
      "faa": "PASA",
      "name": "Savoonga Airport",
      "city": "Savoonga",
      "cityCode": "SVA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ210",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 63.690931,
      "longitude": -170.486792,
      "elevationFeet": 53,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVA?codeType=fs"
     },
     {
      "fs": "SVC",
      "iata": "SVC",
      "icao": "KSVC",
      "faa": "SVC",
      "name": "Grant County Airport",
      "city": "Silver City",
      "cityCode": "SVC",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ022",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 32.631944,
      "longitude": -108.153889,
      "elevationFeet": 5446,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVC?codeType=fs"
     },
     {
      "fs": "SVH",
      "iata": "SVH",
      "icao": "KSVH",
      "faa": "SVH",
      "name": "Statesville Municipal Airport",
      "city": "Statesville",
      "cityCode": "SVH",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 35.765122,
      "longitude": -80.951421,
      "elevationFeet": 963,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVH?codeType=fs"
     },
     {
      "fs": "SVN",
      "iata": "SVN",
      "icao": "KSVN",
      "faa": "SVN",
      "name": "Hunter Air Force Base",
      "city": "Savannah",
      "cityCode": "SAV",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 32.010124,
      "longitude": -81.146012,
      "elevationFeet": 38,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVN?codeType=fs"
     },
     {
      "fs": "SVS",
      "iata": "SVS",
      "icao": "",
      "faa": "SVS",
      "name": "Stevens Village Airport",
      "city": "Stevens Village",
      "cityCode": "SVS",
      "stateCode": "AK",
      "postalCode": "99774",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 66.009444,
      "longitude": -149.094167,
      "elevationFeet": 310,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVS?codeType=fs"
     },
     {
      "fs": "SVW",
      "iata": "SVW",
      "icao": "PASV",
      "faa": "PASV",
      "name": "Sparrevohn Air Force Station",
      "city": "Sparrevohn",
      "cityCode": "SVW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.0975,
      "longitude": -155.572222,
      "elevationFeet": 1585,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVW?codeType=fs"
     },
     {
      "fs": "SWF",
      "iata": "SWF",
      "icao": "KSWF",
      "faa": "SWF",
      "name": "Stewart International Airport",
      "street1": "1180 1st St",
      "city": "Newburgh",
      "cityCode": "SWF",
      "stateCode": "NY",
      "postalCode": "12553",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ067",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.49843,
      "longitude": -74.101045,
      "elevationFeet": 491,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SWF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SWF?codeType=fs"
     },
     {
      "fs": "SWO",
      "iata": "SWO",
      "icao": "KSWO",
      "faa": "SWO",
      "name": "Searcy Field",
      "city": "Stillwater",
      "cityCode": "SWO",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.158889,
      "longitude": -97.085556,
      "elevationFeet": 986,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SWO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SWO?codeType=fs"
     },
     {
      "fs": "SXP",
      "iata": "SXP",
      "icao": "",
      "faa": "SXP",
      "name": "Sheldon Sea Plane Base",
      "city": "Sheldon Point",
      "cityCode": "SXP",
      "stateCode": "AK",
      "postalCode": "99666",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ214",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 62.533333,
      "longitude": -164.833333,
      "elevationFeet": 12,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SXP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SXP?codeType=fs"
     },
     {
      "fs": "SYB",
      "iata": "SYB",
      "icao": "",
      "faa": "",
      "name": "Seal Bay Seaplane Base",
      "city": "Seal Bay",
      "cityCode": "SYB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 58.36872,
      "longitude": -152.214007,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYB?codeType=fs"
     },
     {
      "fs": "SZL",
      "iata": "SZL",
      "icao": "KSZL",
      "faa": "SZL",
      "name": "Whiteman Air Force Base",
      "city": "Warrensburg",
      "cityCode": "SZL",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 38.7303,
      "longitude": -93.547922,
      "elevationFeet": 836,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SZL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SZL?codeType=fs"
     },
     {
      "fs": "SZP",
      "iata": "SZP",
      "icao": "KSZP",
      "faa": "SZP",
      "name": "Santa Paula Airport",
      "city": "Santa Paula",
      "cityCode": "SZP",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.347198,
      "longitude": -119.060997,
      "elevationFeet": 243,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SZP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SZP?codeType=fs"
     },
     {
      "fs": "T82",
      "iata": "",
      "icao": "",
      "faa": "T82",
      "name": "Gillespie County Airport",
      "city": "Fredericksburg",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.24484,
      "longitude": -98.909264,
      "elevationFeet": 1687,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T82?codeType=fs"
     },
     {
      "fs": "TAD",
      "iata": "TAD",
      "icao": "KTAD",
      "faa": "TAD",
      "name": "Perry Stokes Municipal Airport",
      "city": "Trinidad",
      "cityCode": "TAD",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 37.262394,
      "longitude": -104.336957,
      "elevationFeet": 5753,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TAD?codeType=fs"
     },
     {
      "fs": "TAL",
      "iata": "TAL",
      "icao": "PATA",
      "faa": "PATA",
      "name": "Ralph M Calhoun Airport",
      "city": "Tanana",
      "cityCode": "TAL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ221",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 65.174422,
      "longitude": -152.109955,
      "elevationFeet": 227,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TAL?codeType=fs"
     },
     {
      "fs": "TBN",
      "iata": "TBN",
      "icao": "KTBN",
      "faa": "TBN",
      "name": "Waynesville-St. Robert Regional Airport",
      "city": "Fort Leonard Wood",
      "cityCode": "TBN",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 37.741389,
      "longitude": -92.140556,
      "elevationFeet": 1159,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TBN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TBN?codeType=fs"
     },
     {
      "fs": "TBR",
      "iata": "TBR",
      "icao": "KTBR",
      "faa": "TBR",
      "name": "Statesboro-Bulloch County Airport",
      "city": "Statesboro",
      "cityCode": "TBR",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 32.480883,
      "longitude": -81.741444,
      "elevationFeet": 176,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TBR?codeType=fs"
     },
     {
      "fs": "TCL",
      "iata": "TCL",
      "icao": "KTCL",
      "faa": "TCL",
      "name": "Tuscaloosa Regional Airport",
      "city": "Tuscaloosa",
      "cityCode": "TCL",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.221111,
      "longitude": -87.610833,
      "elevationFeet": 160,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TCL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TCL?codeType=fs"
     },
     {
      "fs": "TCM",
      "iata": "TCM",
      "icao": "KTCM",
      "faa": "TCM",
      "name": "McChord Field",
      "city": "Tacoma",
      "cityCode": "TIW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 47.138344,
      "longitude": -122.476581,
      "elevationFeet": 292,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TCM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TCM?codeType=fs"
     },
     {
      "fs": "TCT",
      "iata": "TCT",
      "icao": "",
      "faa": "TCT",
      "name": "Takotna Airport",
      "city": "Takotna",
      "cityCode": "TCT",
      "stateCode": "AK",
      "postalCode": "99675",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 62.992778,
      "longitude": -156.065556,
      "elevationFeet": 825,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TCT?codeType=fs"
     },
     {
      "fs": "TDZ",
      "iata": "TDZ",
      "icao": "KTDZ",
      "faa": "TDZ",
      "name": "Toledo Executive Airport",
      "city": "Toledo",
      "cityCode": "TOL",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.56515,
      "longitude": -83.476711,
      "elevationFeet": 620,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TDZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TDZ?codeType=fs"
     },
     {
      "fs": "TEK",
      "iata": "TEK",
      "icao": "",
      "faa": "7KA",
      "name": "Tatitlek Airport",
      "city": "Tatitlek",
      "cityCode": "TEK",
      "stateCode": "AK",
      "postalCode": "99677",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 60.871909,
      "longitude": -146.688227,
      "elevationFeet": 69,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TEK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TEK?codeType=fs"
     },
     {
      "fs": "TEX",
      "iata": "TEX",
      "icao": "KTEX",
      "faa": "TEX",
      "name": "Telluride Regional Airport",
      "street1": "1500 Last Dollar Road",
      "city": "Telluride",
      "cityCode": "TEX",
      "stateCode": "CO",
      "postalCode": "81435",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "COZ018",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 37.95354,
      "longitude": -107.901005,
      "elevationFeet": 9068,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TEX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TEX?codeType=fs"
     },
     {
      "fs": "THV",
      "iata": "THV",
      "icao": "KTHV",
      "faa": "THV",
      "name": "York Airport",
      "city": "York",
      "cityCode": "THV",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.918128,
      "longitude": -76.873739,
      "elevationFeet": 480,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/THV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/THV?codeType=fs"
     },
     {
      "fs": "TIK",
      "iata": "TIK",
      "icao": "KTIK",
      "faa": "TIK",
      "name": "Tinker Air Force Base",
      "city": "Oklahoma City",
      "cityCode": "OKC",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 35.416667,
      "longitude": -97.383333,
      "elevationFeet": 1291,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TIK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TIK?codeType=fs"
     },
     {
      "fs": "TIW",
      "iata": "TIW",
      "icao": "KTIW",
      "faa": "TIW",
      "name": "Tacoma Narrows Airport",
      "city": "Tacoma",
      "cityCode": "TIW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 47.267632,
      "longitude": -122.576477,
      "elevationFeet": 292,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TIW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TIW?codeType=fs"
     },
     {
      "fs": "TIX",
      "iata": "TIX",
      "icao": "KTIX",
      "faa": "TIX",
      "name": "Space Center Executive Airport",
      "city": "Titusville",
      "cityCode": "TIX",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 28.512222,
      "longitude": -80.799444,
      "elevationFeet": 34,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TIX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TIX?codeType=fs"
     },
     {
      "fs": "TKE",
      "iata": "TKE",
      "icao": "",
      "faa": "",
      "name": "Tenakee Springs Sea Plane Base",
      "city": "Tenakee Springs",
      "cityCode": "TKE",
      "stateCode": "AK",
      "postalCode": "99841",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ021",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 57.779639,
      "longitude": -135.217683,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TKE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TKE?codeType=fs"
     },
     {
      "fs": "TKF",
      "iata": "TKF",
      "icao": "KTRK",
      "faa": "TRK",
      "name": "Truckee Tahoe Airport",
      "city": "Truckee",
      "cityCode": "TKF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 39.317892,
      "longitude": -120.140502,
      "elevationFeet": 5896,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TKF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TKF?codeType=fs"
     },
     {
      "fs": "TKJ",
      "iata": "TKJ",
      "icao": "PATJ",
      "faa": "PATJ",
      "name": "Tok Airport",
      "city": "Tok",
      "cityCode": "TKJ",
      "stateCode": "AK",
      "postalCode": "99780",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ224",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 63.303333,
      "longitude": -143.001111,
      "elevationFeet": 1670,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TKJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TKJ?codeType=fs"
     },
     {
      "fs": "TLA",
      "iata": "TLA",
      "icao": "",
      "faa": "",
      "name": "Teller Airport",
      "city": "Teller",
      "cityCode": "TLA",
      "stateCode": "AK",
      "postalCode": "99778",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ213",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 65.271667,
      "longitude": -166.355,
      "elevationFeet": 293,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TLA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TLA?codeType=fs"
     },
     {
      "fs": "TLJ",
      "iata": "TLJ",
      "icao": "",
      "faa": "",
      "name": "Tatalina Air Force Station",
      "city": "Tatalina",
      "cityCode": "TLJ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 62.885278,
      "longitude": -155.968056,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TLJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TLJ?codeType=fs"
     },
     {
      "fs": "TLT",
      "iata": "TLT",
      "icao": "",
      "faa": "TLT",
      "name": "Tuluksak Airport",
      "city": "Tuluksak",
      "cityCode": "TLT",
      "stateCode": "AK",
      "postalCode": "99679",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.098889,
      "longitude": -160.964722,
      "elevationFeet": 30,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TLT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TLT?codeType=fs"
     },
     {
      "fs": "TMB",
      "iata": "TMB",
      "icao": "KTMB",
      "faa": "TMB",
      "name": "Kendall-Tamiami Executive Airport",
      "city": "Miami",
      "cityCode": "MIA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 25.65,
      "longitude": -80.433333,
      "elevationFeet": 8,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TMB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TMB?codeType=fs"
     },
     {
      "fs": "TNC",
      "iata": "TNC",
      "icao": "PATC",
      "faa": "PATC",
      "name": "Tin City Air Force Station",
      "city": "Tin City",
      "cityCode": "TNC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 65.563889,
      "longitude": -167.918889,
      "elevationFeet": 269,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TNC?codeType=fs"
     },
     {
      "fs": "TNK",
      "iata": "TNK",
      "icao": "",
      "faa": "4KA",
      "name": "Tununak Airport",
      "city": "Tununak",
      "cityCode": "TNK",
      "stateCode": "AK",
      "postalCode": "99681",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 60.570833,
      "longitude": -165.266667,
      "elevationFeet": 17,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TNK?codeType=fs"
     },
     {
      "fs": "TOA",
      "iata": "TOA",
      "icao": "KTOA",
      "faa": "TOA",
      "name": "Zamperini Field",
      "city": "Torrance",
      "cityCode": "TOA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 33.801676,
      "longitude": -118.341548,
      "elevationFeet": 116,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOA?codeType=fs"
     },
     {
      "fs": "TOG",
      "iata": "TOG",
      "icao": "PATG",
      "faa": "PATG",
      "name": "Togiak Village Airport",
      "city": "Togiak Village",
      "cityCode": "TOG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 59.05292,
      "longitude": -160.397728,
      "elevationFeet": 3,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOG?codeType=fs"
     },
     {
      "fs": "TOL",
      "iata": "TOL",
      "icao": "KTOL",
      "faa": "TOL",
      "name": "Toledo Express Airport",
      "street1": "11013 Airport Hwy",
      "city": "Toledo",
      "cityCode": "TOL",
      "stateCode": "OH",
      "postalCode": "43558",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ003",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.592497,
      "longitude": -83.806898,
      "elevationFeet": 684,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOL?codeType=fs"
     },
     {
      "fs": "TOP",
      "iata": "TOP",
      "icao": "KTOP",
      "faa": "TOP",
      "name": "Philip Billard Municipal Airport",
      "city": "Topeka",
      "cityCode": "TOP",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.069722,
      "longitude": -95.6225,
      "elevationFeet": 881,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOP?codeType=fs"
     },
     {
      "fs": "TPF",
      "iata": "TPF",
      "icao": "KTPF",
      "faa": "TPF",
      "name": "Peter O. Knight Airport",
      "city": "Tampa",
      "cityCode": "TPA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 27.915572,
      "longitude": -82.446688,
      "elevationFeet": 6,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TPF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TPF?codeType=fs"
     },
     {
      "fs": "TRI",
      "iata": "TRI",
      "icao": "KTRI",
      "faa": "TRI",
      "name": "Tri-Cities Regional Airport",
      "street1": "2525 Tennessee 75",
      "city": "Bristol, VA/Johnson City/Kingsport",
      "cityCode": "TRI",
      "stateCode": "TN",
      "postalCode": "37617",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "TNZ017",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 36.481109,
      "longitude": -82.407852,
      "elevationFeet": 1519,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TRI?codeType=fs"
     },
     {
      "fs": "TRL",
      "iata": "TRL",
      "icao": "KTRL",
      "faa": "TRL",
      "name": "Terrell Municipal Airport",
      "city": "Terrell",
      "cityCode": "TRL",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.709202,
      "longitude": -96.267403,
      "elevationFeet": 472,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TRL?codeType=fs"
     },
     {
      "fs": "TRM",
      "iata": "TRM",
      "icao": "KTRM",
      "faa": "TRM",
      "name": "Jacqueline Cochran Regional Airport",
      "city": "Thermal",
      "cityCode": "TRM",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 33.639217,
      "longitude": -116.15863,
      "elevationFeet": -112,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TRM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TRM?codeType=fs"
     },
     {
      "fs": "TTD",
      "iata": "TTD",
      "icao": "KTTD",
      "faa": "TTD",
      "name": "Troutdale Airport",
      "city": "Troutdale",
      "cityCode": "TTD",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 45.5494,
      "longitude": -122.401001,
      "elevationFeet": 39,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TTD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TTD?codeType=fs"
     },
     {
      "fs": "TTN",
      "iata": "TTN",
      "icao": "KTTN",
      "faa": "TTN",
      "name": "Trenton-Mercer Airport",
      "street1": "Scotch Road, Terminal Building",
      "city": "Trenton",
      "cityCode": "TTN",
      "stateCode": "NJ",
      "postalCode": "08628",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NJZ019",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.278056,
      "longitude": -74.8125,
      "elevationFeet": 213,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TTN?codeType=fs"
     },
     {
      "fs": "TUP",
      "iata": "TUP",
      "icao": "KTUP",
      "faa": "TUP",
      "name": "Tupelo Regional Airport",
      "street1": "Lemons Drive",
      "city": "Tupelo",
      "cityCode": "TUP",
      "stateCode": "MS",
      "postalCode": "38801-7024",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MSZ016",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.258889,
      "longitude": -88.767222,
      "elevationFeet": 346,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TUP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TUP?codeType=fs"
     },
     {
      "fs": "TVC",
      "iata": "TVC",
      "icao": "KTVC",
      "faa": "TVC",
      "name": "Cherry Capital Airport",
      "street1": "727 Fly Don't Dr",
      "city": "Traverse City",
      "cityCode": "TVC",
      "stateCode": "MI",
      "postalCode": "49686",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "MIZ026",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.737631,
      "longitude": -85.579631,
      "elevationFeet": 624,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TVC?codeType=fs"
     },
     {
      "fs": "TVF",
      "iata": "TVF",
      "icao": "KTVF",
      "faa": "TVF",
      "name": "Thief River Falls Regional Airport",
      "street1": "13722 Airport Dr",
      "city": "Thief River Falls",
      "cityCode": "TVF",
      "stateCode": "MN",
      "postalCode": "56701",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "MNZ013",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 48.066111,
      "longitude": -96.185,
      "elevationFeet": 1116,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TVF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TVF?codeType=fs"
     },
     {
      "fs": "TVI",
      "iata": "TVI",
      "icao": "KTVI",
      "faa": "TVI",
      "name": "Thomasville Regional Airport",
      "city": "Thomasville",
      "cityCode": "TVI",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 30.9025,
      "longitude": -83.880556,
      "elevationFeet": 264,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TVI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TVI?codeType=fs"
     },
     {
      "fs": "TVL",
      "iata": "TVL",
      "icao": "KTVL",
      "faa": "TVL",
      "name": "Lake Tahoe Airport",
      "street1": "1901 Airport Road, Suite 100",
      "city": "South Lake Tahoe",
      "cityCode": "TVL",
      "stateCode": "CA",
      "postalCode": "96150",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ072",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.894167,
      "longitude": -119.994444,
      "elevationFeet": 6264,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TVL?codeType=fs"
     },
     {
      "fs": "TWA",
      "iata": "TWA",
      "icao": "",
      "faa": "A63",
      "name": "Twin Hills Airport",
      "city": "Twin Hills",
      "cityCode": "TWA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 59.073842,
      "longitude": -160.276996,
      "elevationFeet": 53,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TWA?codeType=fs"
     },
     {
      "fs": "TWD",
      "iata": "TWD",
      "icao": "",
      "faa": "0S9",
      "name": "Jefferson County International Airport",
      "city": "Port Townsend",
      "cityCode": "TWD",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 48.0566,
      "longitude": -122.809493,
      "elevationFeet": 120,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TWD?codeType=fs"
     },
     {
      "fs": "TWF",
      "iata": "TWF",
      "icao": "KTWF",
      "faa": "TWF",
      "name": "Magic Valley Regional Airport",
      "street1": "492 Airport Loop",
      "city": "Twin Falls",
      "cityCode": "TWF",
      "stateCode": "ID",
      "postalCode": "83301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "IDZ016",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 42.481944,
      "longitude": -114.486667,
      "elevationFeet": 4151,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TWF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TWF?codeType=fs"
     },
     {
      "fs": "TXK",
      "iata": "TXK",
      "icao": "KTXK",
      "faa": "TXK",
      "name": "Texarkana Regional Airport - Webb Field",
      "street1": "201 Airport Drive",
      "city": "Texarkana",
      "cityCode": "TXK",
      "stateCode": "AR",
      "postalCode": "71854",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ARZ070",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.456389,
      "longitude": -93.989167,
      "elevationFeet": 389,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TXK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TXK?codeType=fs"
     },
     {
      "fs": "TYR",
      "iata": "TYR",
      "icao": "KTYR",
      "faa": "TYR",
      "name": "Tyler Pounds Regional Airport",
      "street1": "700 Skyway Blvd",
      "city": "Tyler",
      "cityCode": "TYR",
      "stateCode": "TX",
      "postalCode": "75704",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ136",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.351598,
      "longitude": -95.410117,
      "elevationFeet": 544,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TYR?codeType=fs"
     },
     {
      "fs": "UDD",
      "iata": "UDD",
      "icao": "KUDD",
      "faa": "UDD",
      "name": "Bermuda Dunes Airport",
      "city": "Palm Springs",
      "cityCode": "PSP",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 33.746019,
      "longitude": -116.270782,
      "elevationFeet": 54,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UDD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UDD?codeType=fs"
     },
     {
      "fs": "UES",
      "iata": "UES",
      "icao": "KUES",
      "faa": "UES",
      "name": "Waukesha County Airport",
      "city": "Waukesha",
      "cityCode": "UES",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 43.038912,
      "longitude": -88.237747,
      "elevationFeet": 906,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UES?codeType=fs"
     },
     {
      "fs": "UGB",
      "iata": "UGB",
      "icao": "",
      "faa": "UGB",
      "name": "Ugashik Bay Airport",
      "city": "Pilot Point",
      "cityCode": "PIP",
      "stateCode": "AK",
      "postalCode": "99649",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 57.425291,
      "longitude": -157.74422,
      "elevationFeet": 93,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UGB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UGB?codeType=fs"
     },
     {
      "fs": "UGI",
      "iata": "UGI",
      "icao": "",
      "faa": "WSJ",
      "name": "San Juan Sea Plane Base",
      "city": "Uganik",
      "cityCode": "UGI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 57.731348,
      "longitude": -153.320565,
      "elevationFeet": 7,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UGI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UGI?codeType=fs"
     },
     {
      "fs": "UGN",
      "iata": "UGN",
      "icao": "KUGN",
      "faa": "UGN",
      "name": "Waukegan National Airport",
      "city": "Waukegan",
      "cityCode": "UGN",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.420903,
      "longitude": -87.866024,
      "elevationFeet": 710,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UGN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UGN?codeType=fs"
     },
     {
      "fs": "UIN",
      "iata": "UIN",
      "icao": "KUIN",
      "faa": "UIN",
      "name": "Quincy Municipal Airport",
      "street1": "",
      "street2": "",
      "city": "Quincy",
      "cityCode": "UIN",
      "stateCode": "IL",
      "postalCode": "62301",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "ILZ095",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.944167,
      "longitude": -91.197222,
      "elevationFeet": 769,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UIN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UIN?codeType=fs"
     },
     {
      "fs": "UKI",
      "iata": "UKI",
      "icao": "KUKI",
      "faa": "UKI",
      "name": "Ukiah Municipal Airport",
      "city": "Ukiah",
      "cityCode": "UKI",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 39.125815,
      "longitude": -123.202162,
      "elevationFeet": 616,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UKI?codeType=fs"
     },
     {
      "fs": "UNK",
      "iata": "UNK",
      "icao": "PAUN",
      "faa": "PAUN",
      "name": "Unalakleet Airport",
      "street1": "",
      "street2": "",
      "city": "Unalakleet",
      "cityCode": "UNK",
      "stateCode": "AK",
      "postalCode": "99684",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 63.881928,
      "longitude": -160.799433,
      "elevationFeet": 21,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UNK?codeType=fs"
     },
     {
      "fs": "UOX",
      "iata": "UOX",
      "icao": "KUOX",
      "faa": "UOX",
      "name": "University-Oxford Airport",
      "city": "Oxford",
      "cityCode": "UOX",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.38,
      "longitude": -89.535296,
      "elevationFeet": 417,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UOX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UOX?codeType=fs"
     },
     {
      "fs": "UST",
      "iata": "UST",
      "icao": "KSGJ",
      "faa": "SGJ",
      "name": "St. Augustine Airport",
      "city": "Saint Augustine",
      "cityCode": "UST",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 29.959323,
      "longitude": -81.337849,
      "elevationFeet": 5,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UST?codeType=fs"
     },
     {
      "fs": "UTM",
      "iata": "UTM",
      "icao": "KUTA",
      "faa": "UTA",
      "name": "Tunica Municipal Airport",
      "city": "Tunica",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.683418,
      "longitude": -90.349798,
      "elevationFeet": 192,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UTM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UTM?codeType=fs"
     },
     {
      "fs": "UVA",
      "iata": "UVA",
      "icao": "KUVA",
      "faa": "UVA",
      "name": "Garner Field",
      "city": "Uvalde",
      "cityCode": "UVA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 29.201944,
      "longitude": -99.735,
      "elevationFeet": 941,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UVA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UVA?codeType=fs"
     },
     {
      "fs": "VAK",
      "iata": "VAK",
      "icao": "",
      "faa": "VAK",
      "name": "Chevak Airport",
      "city": "Chevak",
      "cityCode": "VAK",
      "stateCode": "AK",
      "postalCode": "99563",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.528611,
      "longitude": -165.590278,
      "elevationFeet": 75,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VAK?codeType=fs"
     },
     {
      "fs": "VBM",
      "iata": "VBM",
      "icao": "",
      "faa": "",
      "name": "Blue Mountain Airport",
      "city": "Blue Mountain",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 57.8575,
      "longitude": -157.08667,
      "elevationFeet": 177,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VBM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VBM?codeType=fs"
     },
     {
      "fs": "VCT",
      "iata": "VCT",
      "icao": "KVCT",
      "faa": "VCT",
      "name": "County-Foster Airport",
      "city": "Victoria",
      "cityCode": "VCT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ234",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 28.851111,
      "longitude": -96.914444,
      "elevationFeet": 115,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VCT?codeType=fs"
     },
     {
      "fs": "VCV",
      "iata": "VCV",
      "icao": "KVCV",
      "faa": "VCV",
      "name": "Southern California Logistics Airport",
      "city": "Victorville",
      "cityCode": "VCV",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.586573,
      "longitude": -117.378251,
      "elevationFeet": 2878,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VCV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VCV?codeType=fs"
     },
     {
      "fs": "VDF",
      "iata": "VDF",
      "icao": "KVDF",
      "faa": "X16",
      "name": "Tampa Executive Airport",
      "city": "Tampa",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 28.010858,
      "longitude": -82.342102,
      "elevationFeet": 17,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VDF?codeType=fs"
     },
     {
      "fs": "VDZ",
      "iata": "VDZ",
      "icao": "PAVD",
      "faa": "PAVD",
      "name": "Pioneer Field",
      "city": "Valdez",
      "cityCode": "VDZ",
      "stateCode": "AK",
      "postalCode": "99686",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ141",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 61.133913,
      "longitude": -146.248026,
      "elevationFeet": 81,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VDZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VDZ?codeType=fs"
     },
     {
      "fs": "VEE",
      "iata": "VEE",
      "icao": "",
      "faa": "",
      "name": "Venetie Airport",
      "city": "Venetie",
      "cityCode": "VEE",
      "stateCode": "AK",
      "postalCode": "99781",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 67.023056,
      "longitude": -146.411111,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VEE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VEE?codeType=fs"
     },
     {
      "fs": "VEL",
      "iata": "VEL",
      "icao": "KVEL",
      "faa": "VEL",
      "name": "Vernal Regional Airport",
      "street1": "825 South, 500 East",
      "city": "Vernal",
      "cityCode": "VEL",
      "stateCode": "UT",
      "postalCode": "84078",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "UTZ024",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 40.438889,
      "longitude": -109.510278,
      "elevationFeet": 5278,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VEL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VEL?codeType=fs"
     },
     {
      "fs": "VGT",
      "iata": "VGT",
      "icao": "KVGT",
      "faa": "VGT",
      "name": "North Las Vegas Airport",
      "city": "Las Vegas",
      "cityCode": "LAS",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "NVZ020",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 36.210172,
      "longitude": -115.190826,
      "elevationFeet": 2182,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VGT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VGT?codeType=fs"
     },
     {
      "fs": "VHN",
      "iata": "VHN",
      "icao": "KVHN",
      "faa": "VHN",
      "name": "Culberson County Airport",
      "city": "Van Horn",
      "cityCode": "VHN",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.0578,
      "longitude": -104.783997,
      "elevationFeet": 3941,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VHN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VHN?codeType=fs"
     },
     {
      "fs": "VIS",
      "iata": "VIS",
      "icao": "KVIS",
      "faa": "VIS",
      "name": "Visalia Municipal Airport",
      "street1": "9501 Airport Drive",
      "city": "Visalia",
      "cityCode": "VIS",
      "stateCode": "CA",
      "postalCode": "93277",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "CAZ092",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 36.319444,
      "longitude": -119.393889,
      "elevationFeet": 295,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VIS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VIS?codeType=fs"
     },
     {
      "fs": "VJI",
      "iata": "VJI",
      "icao": "KVJI",
      "faa": "VJI",
      "name": "Virginia Highlands Airport",
      "city": "Abingdon",
      "cityCode": "VJI",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 36.686111,
      "longitude": -82.033333,
      "elevationFeet": 2088,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VJI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VJI?codeType=fs"
     },
     {
      "fs": "VLD",
      "iata": "VLD",
      "icao": "KVLD",
      "faa": "VLD",
      "name": "Valdosta Regional Airport",
      "street1": "1750 Airport Rd",
      "city": "Valdosta",
      "cityCode": "VLD",
      "stateCode": "GA",
      "postalCode": "31601",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "GAZ160",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 30.784051,
      "longitude": -83.272354,
      "elevationFeet": 203,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VLD?codeType=fs"
     },
     {
      "fs": "VNC",
      "iata": "VNC",
      "icao": "KVNC",
      "faa": "VNC",
      "name": "Venice Municipal Airport",
      "city": "Venice",
      "cityCode": "VNC",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 27.077821,
      "longitude": -82.438754,
      "elevationFeet": 15,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VNC?codeType=fs"
     },
     {
      "fs": "VNY",
      "iata": "VNY",
      "icao": "KVNY",
      "faa": "VNY",
      "name": "Van Nuys Airport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.21016,
      "longitude": -118.490169,
      "elevationFeet": 780,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VNY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VNY?codeType=fs"
     },
     {
      "fs": "VOK",
      "iata": "VOK",
      "icao": "KVOK",
      "faa": "VOK",
      "name": "Volk Field",
      "city": "Camp Douglas",
      "cityCode": "VOK",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 43.937056,
      "longitude": -90.256884,
      "elevationFeet": 910,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VOK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VOK?codeType=fs"
     },
     {
      "fs": "VPS",
      "iata": "VPS",
      "icao": "KVPS",
      "faa": "VPS",
      "name": "Destin Fort Walton Beach Airport",
      "city": "Fort Walton Beach",
      "cityCode": "VPS",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "FLZ006",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.495913,
      "longitude": -86.549461,
      "elevationFeet": 85,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VPS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VPS?codeType=fs"
     },
     {
      "fs": "VPZ",
      "iata": "VPZ",
      "icao": "KVPZ",
      "faa": "VPZ",
      "name": "Porter County Regional Airport",
      "city": "Valparaiso",
      "cityCode": "VPZ",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.4525,
      "longitude": -87.005278,
      "elevationFeet": 771,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VPZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VPZ?codeType=fs"
     },
     {
      "fs": "VRB",
      "iata": "VRB",
      "icao": "KVRB",
      "faa": "VRB",
      "name": "Vero Beach Municipal Airport",
      "city": "Vero Beach",
      "cityCode": "VRB",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 27.6525,
      "longitude": -80.413611,
      "elevationFeet": 24,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VRB?codeType=fs"
     },
     {
      "fs": "VSF",
      "iata": "VSF",
      "icao": "KVSF",
      "faa": "VSF",
      "name": "Hartness State Airport",
      "city": "Springfield",
      "cityCode": "VSF",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.341625,
      "longitude": -72.524756,
      "elevationFeet": 576,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VSF?codeType=fs"
     },
     {
      "fs": "VTN",
      "iata": "VTN",
      "icao": "KVTN",
      "faa": "VTN",
      "name": "Miller Field",
      "city": "Valentine",
      "cityCode": "VTN",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.866667,
      "longitude": -100.55,
      "elevationFeet": 2590,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VTN?codeType=fs"
     },
     {
      "fs": "WAA",
      "iata": "WAA",
      "icao": "",
      "faa": "IWK",
      "name": "Wales Airport",
      "city": "Wales",
      "cityCode": "WAA",
      "stateCode": "AK",
      "postalCode": "99783",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ213",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 65.617222,
      "longitude": -168.090833,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WAA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WAA?codeType=fs"
     },
     {
      "fs": "WAL",
      "iata": "WAL",
      "icao": "KWAL",
      "faa": "WAL",
      "name": "Wallops Flight Facility",
      "city": "Chincoteague",
      "cityCode": "WAL",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 37.941166,
      "longitude": -75.468061,
      "elevationFeet": 37,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WAL?codeType=fs"
     },
     {
      "fs": "WBB",
      "iata": "WBB",
      "icao": "",
      "faa": "WBB",
      "name": "Stebbins Airport",
      "city": "Stebbins",
      "cityCode": "WBB",
      "stateCode": "AK",
      "postalCode": "99671",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ212",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 63.515411,
      "longitude": -162.284634,
      "elevationFeet": 16,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBB?codeType=fs"
     },
     {
      "fs": "WBQ",
      "iata": "WBQ",
      "icao": "",
      "faa": "WBQ",
      "name": "Beaver Airport",
      "city": "Beaver",
      "cityCode": "WBQ",
      "stateCode": "AK",
      "postalCode": "99724",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ220",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 66.362222,
      "longitude": -147.408333,
      "elevationFeet": 365,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBQ?codeType=fs"
     },
     {
      "fs": "WBU",
      "iata": "WBU",
      "icao": "",
      "faa": "1V5",
      "name": "Boulder Municipal Airport",
      "city": "Boulder",
      "cityCode": "WBU",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 40.039167,
      "longitude": -105.225556,
      "elevationFeet": 5288,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBU?codeType=fs"
     },
     {
      "fs": "WDG",
      "iata": "WDG",
      "icao": "KWDG",
      "faa": "WDG",
      "name": "Enid Woodring Municipal Airport",
      "city": "Enid",
      "cityCode": "WDG",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "OKZ012",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.383604,
      "longitude": -97.788232,
      "elevationFeet": 1166,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WDG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WDG?codeType=fs"
     },
     {
      "fs": "WGO",
      "iata": "WGO",
      "icao": "KOKV",
      "faa": "OKV",
      "name": "Winchester Regional Airport",
      "city": "Winchester",
      "cityCode": "WGO",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.143356,
      "longitude": -78.147094,
      "elevationFeet": 719,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WGO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WGO?codeType=fs"
     },
     {
      "fs": "WHD",
      "iata": "WHD",
      "icao": "",
      "faa": "",
      "name": "Hyder Sea Plane Base",
      "city": "Hyder",
      "cityCode": "WHD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 55.903881,
      "longitude": -130.011081,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WHD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WHD?codeType=fs"
     },
     {
      "fs": "WJF",
      "iata": "WJF",
      "icao": "KWJF",
      "faa": "WJF",
      "name": "General William J Fox Airfield",
      "city": "Lancaster",
      "cityCode": "WJF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 34.740316,
      "longitude": -118.218185,
      "elevationFeet": 2344,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WJF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WJF?codeType=fs"
     },
     {
      "fs": "WKK",
      "iata": "WKK",
      "icao": "",
      "faa": "5A8",
      "name": "Aleknagik Airport",
      "city": "Aleknagik",
      "cityCode": "WKK",
      "stateCode": "AK",
      "postalCode": "99555",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 59.282593,
      "longitude": -158.617987,
      "elevationFeet": 78,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WKK?codeType=fs"
     },
     {
      "fs": "WLK",
      "iata": "WLK",
      "icao": "PASK",
      "faa": "PASK",
      "name": "Selawik Airport",
      "city": "Selawik",
      "cityCode": "WLK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ209",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 66.602778,
      "longitude": -159.983333,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLK?codeType=fs"
     },
     {
      "fs": "WLW",
      "iata": "WLW",
      "icao": "KWLW",
      "faa": "WLW",
      "name": "Glenn County Airport",
      "city": "Willows",
      "cityCode": "WLW",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 39.516399,
      "longitude": -122.218002,
      "elevationFeet": 131,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLW?codeType=fs"
     },
     {
      "fs": "WMC",
      "iata": "WMC",
      "icao": "KWMC",
      "faa": "WMC",
      "name": "Winnemucca Municipal Airport",
      "city": "Winnemucca",
      "cityCode": "WMC",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 40.904331,
      "longitude": -117.806942,
      "elevationFeet": 4305,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WMC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WMC?codeType=fs"
     },
     {
      "fs": "WMK",
      "iata": "WMK",
      "icao": "",
      "faa": "",
      "name": "Meyers Chuck Sea Plane Base",
      "city": "Meyers Chuck",
      "cityCode": "WMK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 55.740381,
      "longitude": -132.257642,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WMK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WMK?codeType=fs"
     },
     {
      "fs": "WMO",
      "iata": "WMO",
      "icao": "",
      "faa": "WMO",
      "name": "White Mountain Airport",
      "city": "White Mountain",
      "cityCode": "WMO",
      "stateCode": "AK",
      "postalCode": "99784",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ210",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 64.686944,
      "longitude": -163.406667,
      "elevationFeet": 261,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WMO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WMO?codeType=fs"
     },
     {
      "fs": "WNA",
      "iata": "WNA",
      "icao": "",
      "faa": "WNA",
      "name": "Napakiak Sea Plane Base",
      "city": "Napakiak",
      "cityCode": "WNA",
      "stateCode": "AK",
      "postalCode": "99634",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 60.7,
      "longitude": -162.116667,
      "elevationFeet": 20,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WNA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WNA?codeType=fs"
     },
     {
      "fs": "WRB",
      "iata": "WRB",
      "icao": "KWRB",
      "faa": "WRB",
      "name": "Robins Air Force Base",
      "city": "Macon",
      "cityCode": "MCN",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 32.636712,
      "longitude": -83.58806,
      "elevationFeet": 269,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WRB?codeType=fs"
     },
     {
      "fs": "WRG",
      "iata": "WRG",
      "icao": "PAWG",
      "faa": "PAWG",
      "name": "Wrangell Airport",
      "city": "Wrangell",
      "cityCode": "WRG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ026",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 56.484444,
      "longitude": -132.366667,
      "elevationFeet": 44,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WRG?codeType=fs"
     },
     {
      "fs": "WRI",
      "iata": "WRI",
      "icao": "KWRI",
      "faa": "WRI",
      "name": "McGuire Air Force Base",
      "city": "Trenton",
      "cityCode": "WRI",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.014634,
      "longitude": -74.592989,
      "elevationFeet": 113,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WRI?codeType=fs"
     },
     {
      "fs": "WRL",
      "iata": "WRL",
      "icao": "KWRL",
      "faa": "WRL",
      "name": "Worland Airport",
      "street1": "",
      "street2": "",
      "city": "Worland",
      "cityCode": "WRL",
      "stateCode": "WY",
      "postalCode": "82401",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "WYZ009",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 43.9675,
      "longitude": -107.953056,
      "elevationFeet": 4227,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WRL?codeType=fs"
     },
     {
      "fs": "WSH",
      "iata": "WSH",
      "icao": "KHWV",
      "faa": "HWV",
      "name": "Brookhaven Airport",
      "city": "Shirley",
      "cityCode": "WSH",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.821899,
      "longitude": -72.8694,
      "elevationFeet": 65,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSH?codeType=fs"
     },
     {
      "fs": "WSN",
      "iata": "WSN",
      "icao": "",
      "faa": "WSN",
      "name": "South Naknek Airport",
      "city": "South Naknek",
      "cityCode": "WSN",
      "stateCode": "AK",
      "postalCode": "99670",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 58.702779,
      "longitude": -157.004018,
      "elevationFeet": 138,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSN?codeType=fs"
     },
     {
      "fs": "WST",
      "iata": "WST",
      "icao": "KWST",
      "faa": "WST",
      "name": "Westerly State Airport",
      "city": "Westerly",
      "cityCode": "WST",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "RIZ006",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.350194,
      "longitude": -71.806897,
      "elevationFeet": 81,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WST?codeType=fs"
     },
     {
      "fs": "WSX",
      "iata": "WSX",
      "icao": "",
      "faa": "",
      "name": "West Sound Sea Plane Base",
      "city": "West Sound",
      "cityCode": "WSX",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 48.63031,
      "longitude": -122.960389,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSX?codeType=fs"
     },
     {
      "fs": "WTK",
      "iata": "WTK",
      "icao": "PAWN",
      "faa": "PAWN",
      "name": "Noatak Airport",
      "city": "Noatak",
      "cityCode": "WTK",
      "stateCode": "AK",
      "postalCode": "99761",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ208",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 67.563056,
      "longitude": -162.984167,
      "elevationFeet": 88,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WTK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WTK?codeType=fs"
     },
     {
      "fs": "WTL",
      "iata": "WTL",
      "icao": "",
      "faa": "A61",
      "name": "Tuntutuliak Airport",
      "city": "Tuntutuliak",
      "cityCode": "WTL",
      "stateCode": "AK",
      "postalCode": "99680",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 60.35,
      "longitude": -162.633333,
      "elevationFeet": 16,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WTL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WTL?codeType=fs"
     },
     {
      "fs": "WVI",
      "iata": "WVI",
      "icao": "KWVI",
      "faa": "WVI",
      "name": "Watsonville Municipal Airport",
      "city": "Watsonville",
      "cityCode": "WVI",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 36.935699,
      "longitude": -121.790001,
      "elevationFeet": 150,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WVI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WVI?codeType=fs"
     },
     {
      "fs": "WVL",
      "iata": "WVL",
      "icao": "KWVL",
      "faa": "WVL",
      "name": "Waterville Robert LaFleur Airport",
      "city": "Waterville",
      "cityCode": "WVL",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.533186,
      "longitude": -69.679746,
      "elevationFeet": 304,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WVL?codeType=fs"
     },
     {
      "fs": "WWD",
      "iata": "WWD",
      "icao": "KWWD",
      "faa": "WWD",
      "name": "Cape May County Airport",
      "city": "Wildwood",
      "cityCode": "WWD",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.006389,
      "longitude": -74.908889,
      "elevationFeet": 23,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WWD?codeType=fs"
     },
     {
      "fs": "WWP",
      "iata": "WWP",
      "icao": "",
      "faa": "",
      "name": "North Whale Sea Plane Base",
      "city": "Whale Pass",
      "cityCode": "WWP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ027",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 56.114041,
      "longitude": -133.123301,
      "elevationFeet": 0,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WWP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WWP?codeType=fs"
     },
     {
      "fs": "WWR",
      "iata": "WWR",
      "icao": "KWWR",
      "faa": "WWR",
      "name": "West Woodward Airport",
      "city": "Woodward",
      "cityCode": "WWR",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.436111,
      "longitude": -99.526389,
      "elevationFeet": 2188,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WWR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WWR?codeType=fs"
     },
     {
      "fs": "WWT",
      "iata": "WWT",
      "icao": "PAEW",
      "faa": "PAEW",
      "name": "Newtok Airport",
      "city": "Newtok",
      "cityCode": "WWT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ155",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 60.922778,
      "longitude": -164.648611,
      "elevationFeet": 25,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WWT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WWT?codeType=fs"
     },
     {
      "fs": "WYS",
      "iata": "WYS",
      "icao": "KWYS",
      "faa": "WYS",
      "name": "Yellowstone Airport",
      "city": "West Yellowstone",
      "cityCode": "WYS",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.686667,
      "longitude": -111.104722,
      "elevationFeet": 6644,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WYS?codeType=fs"
     },
     {
      "fs": "X61",
      "iata": "",
      "icao": "",
      "faa": "X61",
      "name": "Bob White Field",
      "city": "Zellwood",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 28.735055,
      "longitude": -81.62694,
      "elevationFeet": 78,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X61?codeType=fs"
     },
     {
      "fs": "XSA",
      "icao": "KXSA",
      "faa": "XSA",
      "name": "Tappahannock-Essex County Airport",
      "city": "Tappahannock",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 37.859722,
      "longitude": -76.894167,
      "elevationFeet": 128,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XSA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XSA?codeType=fs"
     },
     {
      "fs": "XSD",
      "iata": "XSD",
      "icao": "KTNX",
      "faa": "",
      "name": "Tonopah Test Range Airport",
      "city": "Tonopah",
      "cityCode": "TPH",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 37.794722,
      "longitude": -116.778611,
      "elevationFeet": 5565,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XSD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XSD?codeType=fs"
     },
     {
      "fs": "XWA",
      "iata": "XWA",
      "name": "Basin International Airport",
      "street1": "",
      "street2": "",
      "city": "Williston",
      "cityCode": "ISN",
      "stateCode": "ND",
      "postalCode": "",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 48.259722,
      "longitude": -103.750556,
      "elevationFeet": 2332,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XWA?codeType=fs"
     },
     {
      "fs": "Y31",
      "iata": "",
      "icao": "",
      "faa": "Y31",
      "name": "West Branch Community Airport",
      "city": "West Branch",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.245799,
      "longitude": -84.187419,
      "elevationFeet": 880,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y31?codeType=fs"
     },
     {
      "fs": "YAK",
      "iata": "YAK",
      "icao": "PAYA",
      "faa": "PAYA",
      "name": "Yakutat Airport",
      "city": "Yakutat",
      "cityCode": "YAK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ022",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 59.509167,
      "longitude": -139.659722,
      "elevationFeet": 33,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/YAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/YAK?codeType=fs"
     },
     {
      "fs": "YKM",
      "iata": "YKM",
      "icao": "KYKM",
      "faa": "YKM",
      "name": "Yakima Air Terminal",
      "street1": "2400 West, Washington Avenue",
      "street2": "",
      "city": "Yakima",
      "cityCode": "YKM",
      "stateCode": "WA",
      "postalCode": "98903",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ027",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 46.566944,
      "longitude": -120.537778,
      "elevationFeet": 1095,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/YKM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/YKM?codeType=fs"
     },
     {
      "fs": "YNG",
      "iata": "YNG",
      "icao": "KYNG",
      "faa": "YNG",
      "name": "Youngstown-Warren Regional Airport",
      "street1": "1453 Youngstown-Kingsville Road N.E.",
      "city": "Youngstown",
      "cityCode": "YNG",
      "stateCode": "OH",
      "postalCode": "44473-9797",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "OHZ023",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.256111,
      "longitude": -80.669722,
      "elevationFeet": 1196,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/YNG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/YNG?codeType=fs"
     },
     {
      "fs": "ZZV",
      "iata": "ZZV",
      "icao": "KZZV",
      "faa": "ZZV",
      "name": "Zanesville Municipal Airport",
      "city": "Zanesville",
      "cityCode": "ZZV",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.947413,
      "longitude": -82.890474,
      "elevationFeet": 880,
      "classification": 4,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZZV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZZV?codeType=fs"
     },
     {
      "fs": "00M",
      "iata": "",
      "icao": "",
      "faa": "00M",
      "name": "Thigpen",
      "city": "Bay Springs",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.987639,
      "longitude": -89.245056,
      "elevationFeet": 351,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00M?codeType=fs"
     },
     {
      "fs": "00N",
      "iata": "",
      "icao": "",
      "faa": "00N",
      "name": "Bucks",
      "city": "Bridgeton",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.531694,
      "longitude": -75.201861,
      "elevationFeet": 105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00N?codeType=fs"
     },
     {
      "fs": "00R",
      "iata": "",
      "icao": "",
      "faa": "00R",
      "name": "Livingston Municipal",
      "city": "Livingston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.708611,
      "longitude": -95.029278,
      "elevationFeet": 151,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00R?codeType=fs"
     },
     {
      "fs": "00S",
      "iata": "",
      "icao": "",
      "faa": "00S",
      "name": "Mc Kenzie Bridge State",
      "city": "Mc Kenzie Bridge",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 44.331778,
      "longitude": -122.136667,
      "elevationFeet": 1620,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00S?codeType=fs"
     },
     {
      "fs": "00V",
      "iata": "",
      "icao": "",
      "faa": "00V",
      "name": "Meadow Lake",
      "city": "Colorado Springs",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 39.0575,
      "longitude": -104.598944,
      "elevationFeet": 6874,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00V?codeType=fs"
     },
     {
      "fs": "00W",
      "iata": "",
      "icao": "",
      "faa": "00W",
      "name": "Lower Granite State",
      "city": "Colfax",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 46.734917,
      "longitude": -117.526833,
      "elevationFeet": 719,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00W?codeType=fs"
     },
     {
      "fs": "00Y",
      "iata": "",
      "icao": "",
      "faa": "00Y",
      "name": "Kapaun-Wilson",
      "city": "Graceville",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 45.555194,
      "longitude": -96.4645,
      "elevationFeet": 1122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/00Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/00Y?codeType=fs"
     },
     {
      "fs": "01A",
      "iata": "",
      "icao": "",
      "faa": "01A",
      "name": "Purkeypile",
      "city": "Purkeypile",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 63.036111,
      "longitude": -152.300167,
      "elevationFeet": 1950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01A?codeType=fs"
     },
     {
      "fs": "01C",
      "iata": "",
      "icao": "",
      "faa": "01C",
      "name": "Grant",
      "city": "Grant",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.416889,
      "longitude": -85.850472,
      "elevationFeet": 815,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01C?codeType=fs"
     },
     {
      "fs": "01G",
      "iata": "",
      "icao": "",
      "faa": "01G",
      "name": "Perry-Warsaw",
      "city": "Perry",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.813472,
      "longitude": -78.070806,
      "elevationFeet": 1559,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01G?codeType=fs"
     },
     {
      "fs": "01J",
      "iata": "",
      "icao": "",
      "faa": "01J",
      "name": "Hilliard",
      "city": "Hilliard",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 30.730139,
      "longitude": -81.959444,
      "elevationFeet": 59,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01J?codeType=fs"
     },
     {
      "fs": "01K",
      "iata": "",
      "icao": "",
      "faa": "01K",
      "name": "Caldwell Municipal",
      "city": "Caldwell",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 37.061361,
      "longitude": -97.614389,
      "elevationFeet": 1157,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01K?codeType=fs"
     },
     {
      "fs": "01M",
      "iata": "",
      "icao": "",
      "faa": "01M",
      "name": "Tishomingo Co",
      "city": "Belmont",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.566667,
      "longitude": -88.211111,
      "elevationFeet": 578,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01M?codeType=fs"
     },
     {
      "fs": "01U",
      "iata": "",
      "icao": "",
      "faa": "01U",
      "name": "Duckwater",
      "city": "Duckwater",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.866,
      "longitude": -115.636472,
      "elevationFeet": 5124,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01U?codeType=fs"
     },
     {
      "fs": "01V",
      "iata": "",
      "icao": "",
      "faa": "01V",
      "name": "Aurora Airport",
      "city": "Aurora",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 39.733331,
      "longitude": -104.65248,
      "elevationFeet": 5669,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/01V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/01V?codeType=fs"
     },
     {
      "fs": "02A",
      "iata": "",
      "icao": "",
      "faa": "02A",
      "name": "Gragg-Wade",
      "city": "Clanton",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.854861,
      "longitude": -86.714528,
      "elevationFeet": 586,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/02A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/02A?codeType=fs"
     },
     {
      "fs": "02C",
      "iata": "",
      "icao": "",
      "faa": "02C",
      "name": "Capitol",
      "city": "Brookfield",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 43.125111,
      "longitude": -88.278694,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/02C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/02C?codeType=fs"
     },
     {
      "fs": "02G",
      "iata": "",
      "icao": "",
      "faa": "02G",
      "name": "Columbiana Co",
      "city": "East Liverpool",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.733139,
      "longitude": -80.714056,
      "elevationFeet": 1160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/02G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/02G?codeType=fs"
     },
     {
      "fs": "02T",
      "iata": "",
      "icao": "",
      "faa": "02T",
      "name": "Wise River",
      "city": "Wise River",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 45.790917,
      "longitude": -113.117056,
      "elevationFeet": 5830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/02T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/02T?codeType=fs"
     },
     {
      "fs": "02Y",
      "iata": "",
      "icao": "",
      "faa": "02Y",
      "name": "Greenbush Municipal",
      "city": "Greenbush",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 48.833111,
      "longitude": -96.269611,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/02Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/02Y?codeType=fs"
     },
     {
      "fs": "0353",
      "iata": "",
      "icao": "",
      "faa": "0353",
      "name": "Chenega Bay",
      "city": "Chenega",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.679",
      "utcOffsetHours": -10,
      "latitude": 60.173056,
      "longitude": -148.068889,
      "elevationFeet": 72,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0353?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0353?codeType=fs"
     },
     {
      "fs": "03B",
      "iata": "",
      "icao": "",
      "faa": "03B",
      "name": "Mansfield Municipal",
      "city": "Mansfield",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 37.228306,
      "longitude": -92.660028,
      "elevationFeet": 1500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/03B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/03B?codeType=fs"
     },
     {
      "fs": "03D",
      "iata": "",
      "icao": "",
      "faa": "03D",
      "name": "Memphis Memorial",
      "city": "Memphis",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.572583,
      "longitude": -92.319611,
      "elevationFeet": 813,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/03D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/03D?codeType=fs"
     },
     {
      "fs": "03I",
      "iata": "",
      "icao": "",
      "faa": "03I",
      "name": "Clarks Dream Strip",
      "city": "Circleville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.742278,
      "longitude": -83.032389,
      "elevationFeet": 680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/03I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/03I?codeType=fs"
     },
     {
      "fs": "03S",
      "iata": "",
      "icao": "",
      "faa": "03S",
      "name": "Sandy River Airport",
      "city": "Sandy",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 45.417861,
      "longitude": -122.336972,
      "elevationFeet": 704,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/03S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/03S?codeType=fs"
     },
     {
      "fs": "04A",
      "iata": "",
      "icao": "",
      "faa": "04A",
      "name": "Sikes",
      "city": "Luverne",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.762778,
      "longitude": -86.374722,
      "elevationFeet": 300,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/04A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/04A?codeType=fs"
     },
     {
      "fs": "04G",
      "iata": "",
      "icao": "",
      "faa": "04G",
      "name": "Lansdowne Airport",
      "city": "Youngstown",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.130105,
      "longitude": -80.616776,
      "elevationFeet": 1045,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/04G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/04G?codeType=fs"
     },
     {
      "fs": "04I",
      "iata": "",
      "icao": "",
      "faa": "04I",
      "name": "Columbus Southwest Airport",
      "city": "Columbus",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.912222,
      "longitude": -83.186709,
      "elevationFeet": 917,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/04I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/04I?codeType=fs"
     },
     {
      "fs": "04M",
      "iata": "",
      "icao": "",
      "faa": "04M",
      "name": "Calhoun Co",
      "city": "Pittsboro",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.051111,
      "longitude": -89.428528,
      "elevationFeet": 383,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/04M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/04M?codeType=fs"
     },
     {
      "fs": "04V",
      "iata": "",
      "icao": "",
      "faa": "04V",
      "name": "Saguache Municipal",
      "city": "Saguache",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 38.222222,
      "longitude": -106.186361,
      "elevationFeet": 7826,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/04V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/04V?codeType=fs"
     },
     {
      "fs": "04Y",
      "iata": "",
      "icao": "",
      "faa": "04Y",
      "name": "Hawley Municipal",
      "city": "Hawley",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 46.8885,
      "longitude": -96.359,
      "elevationFeet": 1208,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/04Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/04Y?codeType=fs"
     },
     {
      "fs": "05A",
      "iata": "",
      "icao": "",
      "faa": "05A",
      "name": "Cascabel",
      "city": "Tucson",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 32.300722,
      "longitude": -110.500778,
      "elevationFeet": 3374,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05A?codeType=fs"
     },
     {
      "fs": "05C",
      "iata": "",
      "icao": "",
      "faa": "05C",
      "name": "Griffith-Merrillville",
      "city": "Griffith",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.546194,
      "longitude": -87.410944,
      "elevationFeet": 634,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05C?codeType=fs"
     },
     {
      "fs": "05D",
      "iata": "",
      "icao": "",
      "faa": "05D",
      "name": "New Town Municipal",
      "city": "New Town",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 47.969583,
      "longitude": -102.579583,
      "elevationFeet": 1925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05D?codeType=fs"
     },
     {
      "fs": "05F",
      "iata": "",
      "icao": "",
      "faa": "05F",
      "name": "City-Co",
      "city": "Gatesville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.46275,
      "longitude": -97.919667,
      "elevationFeet": 905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05F?codeType=fs"
     },
     {
      "fs": "05S",
      "iata": "",
      "icao": "",
      "faa": "05S",
      "name": "Vernonia",
      "city": "Vernonia",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 45.865,
      "longitude": -123.315056,
      "elevationFeet": 647,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05S?codeType=fs"
     },
     {
      "fs": "05V",
      "iata": "",
      "icao": "",
      "faa": "05V",
      "name": "Blanca",
      "city": "Blanca",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 37.511194,
      "longitude": -105.566806,
      "elevationFeet": 7720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05V?codeType=fs"
     },
     {
      "fs": "05Y",
      "iata": "",
      "icao": "",
      "faa": "05Y",
      "name": "Henning Municipal",
      "city": "Henning",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 46.3385,
      "longitude": -95.494833,
      "elevationFeet": 1455,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/05Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/05Y?codeType=fs"
     },
     {
      "fs": "06A",
      "iata": "",
      "icao": "",
      "faa": "06A",
      "name": "Moton Municipal",
      "city": "Tuskegee",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.554722,
      "longitude": -85.800361,
      "elevationFeet": 264,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06A?codeType=fs"
     },
     {
      "fs": "06C",
      "iata": "",
      "icao": "",
      "faa": "06C",
      "name": "Schaumburg Regional",
      "city": "Chicago/Schaumburg",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.043417,
      "longitude": -88.112417,
      "elevationFeet": 801,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06C?codeType=fs"
     },
     {
      "fs": "06D",
      "iata": "",
      "icao": "",
      "faa": "06D",
      "name": "Rolla Municipal",
      "city": "Rolla",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 48.893417,
      "longitude": -99.658778,
      "elevationFeet": 1822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06D?codeType=fs"
     },
     {
      "fs": "06M",
      "iata": "",
      "icao": "",
      "faa": "06M",
      "name": "Eupora",
      "city": "Eupora",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.545667,
      "longitude": -89.425694,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06M?codeType=fs"
     },
     {
      "fs": "06N",
      "iata": "",
      "icao": "",
      "faa": "06N",
      "name": "Randall",
      "city": "Middletown",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.565667,
      "longitude": -74.469167,
      "elevationFeet": 523,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06N?codeType=fs"
     },
     {
      "fs": "06R",
      "iata": "",
      "icao": "",
      "faa": "06R",
      "name": "Grawunder",
      "city": "Bellville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.018917,
      "longitude": -96.36075,
      "elevationFeet": 289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06R?codeType=fs"
     },
     {
      "fs": "06Y",
      "iata": "",
      "icao": "",
      "faa": "06Y",
      "name": "Herman Municipal",
      "city": "Herman",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 45.949611,
      "longitude": -96.256139,
      "elevationFeet": 1068,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/06Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/06Y?codeType=fs"
     },
     {
      "fs": "07A",
      "iata": "",
      "icao": "",
      "faa": "07A",
      "name": "Franklin",
      "city": "Union Springs",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.195917,
      "longitude": -85.89675,
      "elevationFeet": 301,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07A?codeType=fs"
     },
     {
      "fs": "07B",
      "iata": "",
      "icao": "",
      "faa": "07B",
      "name": "Blue Hill",
      "city": "Blue Hill",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.503556,
      "longitude": -68.711333,
      "elevationFeet": 360,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07B?codeType=fs"
     },
     {
      "fs": "07C",
      "iata": "",
      "icao": "",
      "faa": "07C",
      "name": "De Kalb Co",
      "city": "Auburn",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.371667,
      "longitude": -85.193333,
      "elevationFeet": 881,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07C?codeType=fs"
     },
     {
      "fs": "07D",
      "iata": "",
      "icao": "",
      "faa": "07D",
      "name": "Tackaberry",
      "city": "Avoca",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.183611,
      "longitude": -82.799278,
      "elevationFeet": 764,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07D?codeType=fs"
     },
     {
      "fs": "07F",
      "iata": "",
      "icao": "",
      "faa": "07F",
      "name": "Gladewater Municipal",
      "city": "Gladewater",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.638389,
      "longitude": -95.017444,
      "elevationFeet": 297,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07F?codeType=fs"
     },
     {
      "fs": "07FA",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Ocean Reef Club",
      "city": "Key Largo",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 25.325393,
      "longitude": -80.274775,
      "elevationFeet": 8,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07FA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07FA?codeType=fs"
     },
     {
      "fs": "07G",
      "iata": "",
      "icao": "",
      "faa": "07G",
      "name": "Beach",
      "city": "Charlotte",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.645083,
      "longitude": -84.914306,
      "elevationFeet": 891,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07G?codeType=fs"
     },
     {
      "fs": "07K",
      "iata": "",
      "icao": "",
      "faa": "07K",
      "name": "Central City Municipal",
      "city": "Central City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.116806,
      "longitude": -98.053361,
      "elevationFeet": 1715,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07K?codeType=fs"
     },
     {
      "fs": "07N",
      "iata": "",
      "icao": "",
      "faa": "07N",
      "name": "Bermudian Valley",
      "city": "Kralltown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.017611,
      "longitude": -77.038667,
      "elevationFeet": 470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07N?codeType=fs"
     },
     {
      "fs": "07R",
      "iata": "",
      "icao": "",
      "faa": "07R",
      "name": "Bishop Municipal",
      "city": "Bishop",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 27.6103,
      "longitude": -97.751902,
      "elevationFeet": 55,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07R?codeType=fs"
     },
     {
      "fs": "07V",
      "iata": "",
      "icao": "",
      "faa": "07V",
      "name": "Cuchara Valley Apt At La Veta",
      "city": "La Veta",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 37.58825,
      "longitude": -105.092694,
      "elevationFeet": 7153,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07V?codeType=fs"
     },
     {
      "fs": "07Y",
      "iata": "",
      "icao": "",
      "faa": "07Y",
      "name": "Hill City-Quadna Mtn",
      "city": "Hill City",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 47.005083,
      "longitude": -93.718972,
      "elevationFeet": 1289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/07Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/07Y?codeType=fs"
     },
     {
      "fs": "08A",
      "iata": "",
      "icao": "",
      "faa": "08A",
      "name": "Wetumpka Municipal",
      "city": "Wetumpka",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.644444,
      "longitude": -86.432222,
      "elevationFeet": 197,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08A?codeType=fs"
     },
     {
      "fs": "08B",
      "iata": "",
      "icao": "",
      "faa": "08B",
      "name": "Merrymeeting",
      "city": "Bowdoinham",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.000778,
      "longitude": -69.919944,
      "elevationFeet": 65,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08B?codeType=fs"
     },
     {
      "fs": "08C",
      "iata": "",
      "icao": "",
      "faa": "08C",
      "name": "Riverview",
      "city": "Jenison",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.958583,
      "longitude": -85.850361,
      "elevationFeet": 603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08C?codeType=fs"
     },
     {
      "fs": "08D",
      "iata": "",
      "icao": "",
      "faa": "08D",
      "name": "Stanley Municipal",
      "city": "Stanley",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 48.308,
      "longitude": -102.463528,
      "elevationFeet": 2245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08D?codeType=fs"
     },
     {
      "fs": "08F",
      "iata": "",
      "icao": "",
      "faa": "08F",
      "name": "City Of Coalgate",
      "city": "Coalgate",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.667583,
      "longitude": -96.380528,
      "elevationFeet": 615,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08F?codeType=fs"
     },
     {
      "fs": "08K",
      "iata": "",
      "icao": "",
      "faa": "08K",
      "name": "Harvard State",
      "city": "Harvard",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.796667,
      "longitude": -98.224722,
      "elevationFeet": 1815,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08K?codeType=fs"
     },
     {
      "fs": "08M",
      "iata": "",
      "icao": "",
      "faa": "08M",
      "name": "Carthage-Leake Co",
      "city": "Carthage",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.862472,
      "longitude": -89.650722,
      "elevationFeet": 454,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08M?codeType=fs"
     },
     {
      "fs": "08N",
      "iata": "",
      "icao": "",
      "faa": "08N",
      "name": "Keller Brothers Airport",
      "city": "Lebanon",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.291877,
      "longitude": -76.329054,
      "elevationFeet": 545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08N?codeType=fs"
     },
     {
      "fs": "08R",
      "iata": "",
      "icao": "",
      "faa": "08R",
      "name": "Richmond",
      "city": "West Kingston",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.539889,
      "longitude": -71.653417,
      "elevationFeet": 130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08R?codeType=fs"
     },
     {
      "fs": "08U",
      "iata": "",
      "icao": "",
      "faa": "08U",
      "name": "Stevens Crosby",
      "city": "North Fork",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 41.657417,
      "longitude": -115.948056,
      "elevationFeet": 6397,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/08U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/08U?codeType=fs"
     },
     {
      "fs": "09A",
      "iata": "",
      "icao": "",
      "faa": "09A",
      "name": "Butler-Choctaw Co",
      "city": "Butler",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.143139,
      "longitude": -88.224639,
      "elevationFeet": 134,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09A?codeType=fs"
     },
     {
      "fs": "09C",
      "iata": "",
      "icao": "",
      "faa": "09C",
      "name": "Austin Lake",
      "city": "Kalamazoo",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.275444,
      "longitude": -85.658333,
      "elevationFeet": 871,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09C?codeType=fs"
     },
     {
      "fs": "09J",
      "iata": "",
      "icao": "",
      "faa": "09J",
      "name": "Jekyll Island",
      "city": "Jekyll Island",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 31.074499,
      "longitude": -81.427803,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09J?codeType=fs"
     },
     {
      "fs": "09K",
      "iata": "",
      "icao": "",
      "faa": "09K",
      "name": "Sargent Municipal",
      "city": "Sargent",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.6695,
      "longitude": -99.403806,
      "elevationFeet": 2313,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09K?codeType=fs"
     },
     {
      "fs": "09M",
      "iata": "",
      "icao": "",
      "faa": "09M",
      "name": "Charleston Municipal",
      "city": "Charleston",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.065028,
      "longitude": -90.181444,
      "elevationFeet": 175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09M?codeType=fs"
     },
     {
      "fs": "09N",
      "iata": "",
      "icao": "",
      "faa": "09N",
      "name": "Airhaven",
      "city": "Staatsburg",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.975944,
      "longitude": -73.959667,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09N?codeType=fs"
     },
     {
      "fs": "09R",
      "iata": "",
      "icao": "",
      "faa": "09R",
      "name": "Tyler Co",
      "city": "Woodville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.846972,
      "longitude": -94.538417,
      "elevationFeet": 388,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09R?codeType=fs"
     },
     {
      "fs": "09S",
      "iata": "",
      "icao": "",
      "faa": "09S",
      "name": "Sullivan Lake State",
      "city": "Metaline Falls",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 48.915889,
      "longitude": -117.294083,
      "elevationFeet": 2614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/09S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/09S?codeType=fs"
     },
     {
      "fs": "0A2",
      "iata": "",
      "icao": "",
      "faa": "0A2",
      "name": "Hester Memorial",
      "city": "Calhoun Falls",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 34.153944,
      "longitude": -82.579083,
      "elevationFeet": 517,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0A2?codeType=fs"
     },
     {
      "fs": "0A3",
      "iata": "",
      "icao": "",
      "faa": "0A3",
      "name": "Smithville Municipal Airport",
      "city": "Smithville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 35.987682,
      "longitude": -85.798359,
      "elevationFeet": 1084,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0A3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0A3?codeType=fs"
     },
     {
      "fs": "0A4",
      "iata": "",
      "icao": "",
      "faa": "0A4",
      "name": "Johnson City Stolport Airport",
      "city": "Johnson City",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 36.363247,
      "longitude": -82.308139,
      "elevationFeet": 1501,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0A4?codeType=fs"
     },
     {
      "fs": "0A7",
      "iata": "",
      "icao": "",
      "faa": "0A7",
      "name": "Hendersonville",
      "city": "Hendersonville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 35.376167,
      "longitude": -82.58175,
      "elevationFeet": 2084,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0A7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0A7?codeType=fs"
     },
     {
      "fs": "0A8",
      "iata": "",
      "icao": "",
      "faa": "0A8",
      "name": "Bibb Co",
      "city": "Centreville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.967917,
      "longitude": -87.138833,
      "elevationFeet": 251,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0A8?codeType=fs"
     },
     {
      "fs": "0A9",
      "iata": "",
      "icao": "",
      "faa": "0A9",
      "name": "Elizabethton Municipal",
      "city": "Elizabethton",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 36.409444,
      "longitude": -82.237417,
      "elevationFeet": 1585,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0A9?codeType=fs"
     },
     {
      "fs": "0B1",
      "iata": "",
      "icao": "",
      "faa": "0B1",
      "name": "Col Dyke",
      "city": "Bethel",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.500639,
      "longitude": -70.878472,
      "elevationFeet": 654,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0B1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0B1?codeType=fs"
     },
     {
      "fs": "0B2",
      "iata": "",
      "icao": "",
      "faa": "0B2",
      "name": "Brewer",
      "city": "Brewer",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.886833,
      "longitude": -68.778139,
      "elevationFeet": 124,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0B2?codeType=fs"
     },
     {
      "fs": "0B4",
      "iata": "",
      "icao": "",
      "faa": "0B4",
      "name": "Hartington Municipal",
      "city": "Hartington",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.635556,
      "longitude": -97.276389,
      "elevationFeet": 1387,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0B4?codeType=fs"
     },
     {
      "fs": "0B5",
      "iata": "",
      "icao": "",
      "faa": "0B5",
      "name": "Turners Falls",
      "city": "Montague",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.663639,
      "longitude": -72.577556,
      "elevationFeet": 356,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0B5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0B5?codeType=fs"
     },
     {
      "fs": "0B7",
      "iata": "",
      "icao": "",
      "faa": "0B7",
      "name": "Warren-Sugarbush",
      "city": "Warren",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 44.117278,
      "longitude": -72.920583,
      "elevationFeet": 1470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0B7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0B7?codeType=fs"
     },
     {
      "fs": "0C0",
      "iata": "",
      "icao": "",
      "faa": "0C0",
      "name": "Dacy",
      "city": "Harvard",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.441861,
      "longitude": -88.634333,
      "elevationFeet": 913,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C0?codeType=fs"
     },
     {
      "fs": "0C1",
      "iata": "",
      "icao": "",
      "faa": "0C1",
      "name": "Rainbow Air Village",
      "city": "Dearborn",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.52775,
      "longitude": -94.905167,
      "elevationFeet": 1000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C1?codeType=fs"
     },
     {
      "fs": "0C2",
      "iata": "",
      "icao": "",
      "faa": "0C2",
      "name": "Hinckley",
      "city": "Hinckley",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.808639,
      "longitude": -88.734139,
      "elevationFeet": 760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C2?codeType=fs"
     },
     {
      "fs": "0C3",
      "iata": "",
      "icao": "",
      "faa": "0C3",
      "name": "Wilhelmi",
      "city": "Joliet",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.483639,
      "longitude": -88.083917,
      "elevationFeet": 635,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C3?codeType=fs"
     },
     {
      "fs": "0C4",
      "iata": "",
      "icao": "",
      "faa": "0C4",
      "name": "Pender Municipal",
      "city": "Pender",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.238861,
      "longitude": -96.83925,
      "elevationFeet": 1355,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C4?codeType=fs"
     },
     {
      "fs": "0C5",
      "iata": "",
      "icao": "",
      "faa": "0C5",
      "name": "Canadian Lakes",
      "city": "Mecosta",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.664167,
      "longitude": -85.405917,
      "elevationFeet": 960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C5?codeType=fs"
     },
     {
      "fs": "0C7",
      "iata": "",
      "icao": "",
      "faa": "0C7",
      "name": "Grandpa'S Farm-Mendota",
      "city": "Mendota",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.569778,
      "longitude": -89.275833,
      "elevationFeet": 727,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C7?codeType=fs"
     },
     {
      "fs": "0C8",
      "iata": "",
      "icao": "",
      "faa": "0C8",
      "name": "Cushing",
      "city": "Newark",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.54475,
      "longitude": -88.656278,
      "elevationFeet": 640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0C8?codeType=fs"
     },
     {
      "fs": "0D1",
      "iata": "",
      "icao": "",
      "faa": "0D1",
      "name": "South Haven Area Regional",
      "city": "South Haven",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.358333,
      "longitude": -86.311389,
      "elevationFeet": 663,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0D1?codeType=fs"
     },
     {
      "fs": "0D4",
      "iata": "",
      "icao": "",
      "faa": "0D4",
      "name": "Camp Vernon",
      "city": "Westfield",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.411694,
      "longitude": -79.689361,
      "elevationFeet": 655,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0D4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0D4?codeType=fs"
     },
     {
      "fs": "0D6",
      "iata": "",
      "icao": "",
      "faa": "0D6",
      "name": "Wilber Municipal",
      "city": "Wilber",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.550028,
      "longitude": -97.028056,
      "elevationFeet": 1400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0D6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0D6?codeType=fs"
     },
     {
      "fs": "0D7",
      "iata": "",
      "icao": "",
      "faa": "0D7",
      "name": "Ada",
      "city": "Ada",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.856083,
      "longitude": -83.941028,
      "elevationFeet": 949,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0D7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0D7?codeType=fs"
     },
     {
      "fs": "0D8",
      "iata": "",
      "icao": "",
      "faa": "0D8",
      "name": "Gettysburg Municipal",
      "city": "Gettysburg",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 45.023056,
      "longitude": -99.985,
      "elevationFeet": 2061,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0D8?codeType=fs"
     },
     {
      "fs": "0E0",
      "iata": "",
      "icao": "",
      "faa": "0E0",
      "name": "Moriarty",
      "city": "Moriarty",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 35.006056,
      "longitude": -106.094667,
      "elevationFeet": 6199,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0E0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0E0?codeType=fs"
     },
     {
      "fs": "0E1",
      "iata": "",
      "icao": "",
      "faa": "0E1",
      "name": "Price Ranch",
      "city": "Mt Dora",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 36.70025,
      "longitude": -103.555083,
      "elevationFeet": 5631,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0E1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0E1?codeType=fs"
     },
     {
      "fs": "0E8",
      "iata": "",
      "icao": "",
      "faa": "0E8",
      "name": "Crownpoint",
      "city": "Crownpoint",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 35.726583,
      "longitude": -108.215972,
      "elevationFeet": 6696,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0E8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0E8?codeType=fs"
     },
     {
      "fs": "0E9",
      "iata": "",
      "icao": "",
      "faa": "0E9",
      "name": "Corydon",
      "city": "Corydon",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.7945,
      "longitude": -93.313222,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0E9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0E9?codeType=fs"
     },
     {
      "fs": "0F2",
      "iata": "",
      "icao": "",
      "faa": "0F2",
      "name": "Bowie Municipal",
      "city": "Bowie",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.616667,
      "longitude": -97.855611,
      "elevationFeet": 1101,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0F2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0F2?codeType=fs"
     },
     {
      "fs": "0F4",
      "iata": "",
      "icao": "",
      "faa": "0F4",
      "name": "Loup City Municipal",
      "city": "Loup City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.352861,
      "longitude": -99.056417,
      "elevationFeet": 2070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0F4?codeType=fs"
     },
     {
      "fs": "0F7",
      "iata": "",
      "icao": "",
      "faa": "0F7",
      "name": "Fountainhead Lodge",
      "city": "Eufaula",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 35.439889,
      "longitude": -95.6165,
      "elevationFeet": 670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0F7?codeType=fs"
     },
     {
      "fs": "0F8",
      "iata": "",
      "icao": "",
      "faa": "0F8",
      "name": "Pogue Municipal",
      "city": "Sand Springs",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.252806,
      "longitude": -96.168111,
      "elevationFeet": 891,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0F8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0F8?codeType=fs"
     },
     {
      "fs": "0F9",
      "iata": "",
      "icao": "",
      "faa": "0F9",
      "name": "Tishomingo",
      "city": "Tishomingo",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.309278,
      "longitude": -96.755556,
      "elevationFeet": 647,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0F9?codeType=fs"
     },
     {
      "fs": "0G0",
      "iata": "",
      "icao": "",
      "faa": "0G0",
      "name": "North Buffalo Suburban",
      "city": "Lockport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.131833,
      "longitude": -78.733472,
      "elevationFeet": 588,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0G0?codeType=fs"
     },
     {
      "fs": "0G3",
      "iata": "",
      "icao": "",
      "faa": "0G3",
      "name": "Tecumseh Municipal",
      "city": "Tecumseh",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.544444,
      "longitude": -96.213972,
      "elevationFeet": 1305,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0G3?codeType=fs"
     },
     {
      "fs": "0G6",
      "iata": "",
      "icao": "",
      "faa": "0G6",
      "name": "Williams Co",
      "city": "Bryan",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.473611,
      "longitude": -84.565556,
      "elevationFeet": 730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0G6?codeType=fs"
     },
     {
      "fs": "0G7",
      "iata": "",
      "icao": "",
      "faa": "0G7",
      "name": "Finger Lakes Regional",
      "city": "Seneca Falls",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 43.006222,
      "longitude": -76.916194,
      "elevationFeet": 491,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0G7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0G7?codeType=fs"
     },
     {
      "fs": "0H1",
      "iata": "",
      "icao": "",
      "faa": "0H1",
      "name": "Trego Wakeeney",
      "city": "Wakeeney",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.044528,
      "longitude": -99.979,
      "elevationFeet": 2435,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0H1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0H1?codeType=fs"
     },
     {
      "fs": "0H7",
      "iata": "",
      "icao": "",
      "faa": "0H7",
      "name": "Kahoka Municipal",
      "city": "Kahoka",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.500417,
      "longitude": -91.826639,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0H7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0H7?codeType=fs"
     },
     {
      "fs": "0I2",
      "iata": "",
      "icao": "",
      "faa": "0I2",
      "name": "Brazil Clay Co",
      "city": "Brazil",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.567361,
      "longitude": -87.247083,
      "elevationFeet": 645,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0I2?codeType=fs"
     },
     {
      "fs": "0I8",
      "iata": "",
      "icao": "",
      "faa": "0I8",
      "name": "Cynthiana-Harrison Co",
      "city": "Cynthiana",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 38.367417,
      "longitude": -84.291,
      "elevationFeet": 722,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0I8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0I8?codeType=fs"
     },
     {
      "fs": "0J0",
      "iata": "",
      "icao": "",
      "faa": "0J0",
      "name": "Abbeville Municipal",
      "city": "Abbeville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.601667,
      "longitude": -85.288222,
      "elevationFeet": 468,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0J0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0J0?codeType=fs"
     },
     {
      "fs": "0J4",
      "iata": "",
      "icao": "",
      "faa": "0J4",
      "name": "Florala Municipal",
      "city": "Florala",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.12475,
      "longitude": -86.415611,
      "elevationFeet": 314,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0J4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0J4?codeType=fs"
     },
     {
      "fs": "0J6",
      "iata": "",
      "icao": "",
      "faa": "0J6",
      "name": "Headland Municipal",
      "city": "Headland",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.498944,
      "longitude": -85.396556,
      "elevationFeet": 359,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0J6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0J6?codeType=fs"
     },
     {
      "fs": "0J8",
      "iata": "",
      "icao": "",
      "faa": "0J8",
      "name": "Flying Ten",
      "city": "Archer",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 29.630222,
      "longitude": -82.587194,
      "elevationFeet": 85,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0J8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0J8?codeType=fs"
     },
     {
      "fs": "0J9",
      "iata": "",
      "icao": "",
      "faa": "0J9",
      "name": "Flying V",
      "city": "Utica",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.894556,
      "longitude": -97.367139,
      "elevationFeet": 1585,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0J9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0J9?codeType=fs"
     },
     {
      "fs": "0K6",
      "iata": "",
      "icao": "",
      "faa": "0K6",
      "name": "Dobie'S",
      "city": "Inola",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.289861,
      "longitude": -95.710889,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0K6?codeType=fs"
     },
     {
      "fs": "0L4",
      "iata": "",
      "icao": "",
      "faa": "0L4",
      "name": "Lida Junction",
      "city": "Goldfield",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 37.507667,
      "longitude": -117.259083,
      "elevationFeet": 4684,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0L4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0L4?codeType=fs"
     },
     {
      "fs": "0L5",
      "iata": "",
      "icao": "",
      "faa": "0L5",
      "name": "Goldfield",
      "city": "Goldfield",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 37.729889,
      "longitude": -117.284111,
      "elevationFeet": 5680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0L5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0L5?codeType=fs"
     },
     {
      "fs": "0L7",
      "iata": "",
      "icao": "",
      "faa": "0L7",
      "name": "Jean",
      "city": "Jean",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 35.782722,
      "longitude": -115.446389,
      "elevationFeet": 2832,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0L7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0L7?codeType=fs"
     },
     {
      "fs": "0L8",
      "iata": "",
      "icao": "",
      "faa": "0L8",
      "name": "Heart Airport",
      "city": "Kansas City",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.073867,
      "longitude": -94.505946,
      "elevationFeet": 767,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0L8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0L8?codeType=fs"
     },
     {
      "fs": "0L9",
      "iata": "",
      "icao": "",
      "faa": "0L9",
      "name": "Echo Bay",
      "city": "Overton",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 36.410889,
      "longitude": -114.588667,
      "elevationFeet": 1535,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0L9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0L9?codeType=fs"
     },
     {
      "fs": "0M0",
      "iata": "",
      "icao": "",
      "faa": "0M0",
      "name": "Free Municipal",
      "city": "Dumas",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.895472,
      "longitude": -91.542917,
      "elevationFeet": 163,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M0?codeType=fs"
     },
     {
      "fs": "0M1",
      "iata": "",
      "icao": "",
      "faa": "0M1",
      "name": "Scott",
      "city": "Parsons",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 35.677806,
      "longitude": -88.229944,
      "elevationFeet": 520,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M1?codeType=fs"
     },
     {
      "fs": "0M2",
      "iata": "",
      "icao": "",
      "faa": "0M2",
      "name": "Reelfoot Lake",
      "city": "Tiptonville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.553417,
      "longitude": -89.461833,
      "elevationFeet": 289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M2?codeType=fs"
     },
     {
      "fs": "0M3",
      "iata": "",
      "icao": "",
      "faa": "0M3",
      "name": "Baker",
      "city": "Hohenwald",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 35.659722,
      "longitude": -87.72325,
      "elevationFeet": 972,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M3?codeType=fs"
     },
     {
      "fs": "0M4",
      "iata": "",
      "icao": "",
      "faa": "0M4",
      "name": "Benton Co",
      "city": "Camden",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.112278,
      "longitude": -88.182889,
      "elevationFeet": 468,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M4?codeType=fs"
     },
     {
      "fs": "0M5",
      "iata": "",
      "icao": "",
      "faa": "0M5",
      "name": "Humphreys Co",
      "city": "Waverly",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 36.265861,
      "longitude": -87.781611,
      "elevationFeet": 756,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M5?codeType=fs"
     },
     {
      "fs": "0M6",
      "iata": "",
      "icao": "",
      "faa": "0M6",
      "name": "Panola Co",
      "city": "Batesville",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.36775,
      "longitude": -89.900889,
      "elevationFeet": 219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M6?codeType=fs"
     },
     {
      "fs": "0M8",
      "iata": "",
      "icao": "",
      "faa": "0M8",
      "name": "Byerley",
      "city": "Lake Providence",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.908806,
      "longitude": -91.226639,
      "elevationFeet": 106,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0M8?codeType=fs"
     },
     {
      "fs": "0N0",
      "iata": "",
      "icao": "",
      "faa": "0N0",
      "name": "Roosterville Airport",
      "city": "Liberty",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.29202,
      "longitude": -94.441426,
      "elevationFeet": 998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0N0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0N0?codeType=fs"
     },
     {
      "fs": "0N6",
      "iata": "",
      "icao": "",
      "faa": "0N6",
      "name": "Henderson Aviation",
      "city": "Felton",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.126139,
      "longitude": -75.535361,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0N6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0N6?codeType=fs"
     },
     {
      "fs": "0O2",
      "iata": "",
      "icao": "",
      "faa": "0O2",
      "name": "Baker",
      "city": "Baker",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 35.305361,
      "longitude": -116.225139,
      "elevationFeet": 922,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0O2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0O2?codeType=fs"
     },
     {
      "fs": "0O4",
      "iata": "",
      "icao": "",
      "faa": "0O4",
      "name": "Corning Municipal",
      "city": "Corning",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 40.037694,
      "longitude": -122.213778,
      "elevationFeet": 292,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0O4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0O4?codeType=fs"
     },
     {
      "fs": "0O5",
      "iata": "",
      "icao": "",
      "faa": "0O5",
      "name": "University Airport",
      "city": "Davis",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.528964,
      "longitude": -121.7845,
      "elevationFeet": 64,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0O5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0O5?codeType=fs"
     },
     {
      "fs": "0O9",
      "iata": "",
      "icao": "",
      "faa": "0O9",
      "name": "Ward",
      "city": "Gasquet",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 41.956694,
      "longitude": -123.995194,
      "elevationFeet": 356,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0O9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0O9?codeType=fs"
     },
     {
      "fs": "0P1",
      "iata": "",
      "icao": "",
      "faa": "0P1",
      "name": "Van-Pak",
      "city": "Prairie View",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.972306,
      "longitude": -99.587194,
      "elevationFeet": 2213,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0P1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0P1?codeType=fs"
     },
     {
      "fs": "0Q3",
      "iata": "",
      "icao": "",
      "faa": "0Q3",
      "name": "Sonoma Valley Airport",
      "city": "Schellville-Sonoma",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.223804,
      "longitude": -122.450573,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Q3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Q3?codeType=fs"
     },
     {
      "fs": "0Q4",
      "iata": "",
      "icao": "",
      "faa": "0Q4",
      "name": "Selma",
      "city": "Selma",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 36.716167,
      "longitude": -119.734667,
      "elevationFeet": 305,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Q4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Q4?codeType=fs"
     },
     {
      "fs": "0Q5",
      "iata": "",
      "icao": "",
      "faa": "0Q5",
      "name": "Shelter Cove",
      "city": "Shelter Cove",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 40.126444,
      "longitude": -124.133639,
      "elevationFeet": 69,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Q5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Q5?codeType=fs"
     },
     {
      "fs": "0Q6",
      "iata": "",
      "icao": "",
      "faa": "0Q6",
      "name": "Shingletown",
      "city": "Shingletown",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 40.571,
      "longitude": -121.827667,
      "elevationFeet": 3880,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Q6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Q6?codeType=fs"
     },
     {
      "fs": "0Q9",
      "iata": "",
      "icao": "",
      "faa": "0Q9",
      "name": "Sonoma Skypark",
      "city": "Sonoma",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 38.25762,
      "longitude": -122.436842,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Q9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Q9?codeType=fs"
     },
     {
      "fs": "0R0",
      "iata": "",
      "icao": "",
      "faa": "0R0",
      "name": "Columbia-Marion Co",
      "city": "Columbia",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.420083,
      "longitude": -89.928278,
      "elevationFeet": 265,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R0?codeType=fs"
     },
     {
      "fs": "0R1",
      "iata": "",
      "icao": "",
      "faa": "0R1",
      "name": "Atmore Municipal",
      "city": "Atmore",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.162167,
      "longitude": -87.567611,
      "elevationFeet": 287,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R1?codeType=fs"
     },
     {
      "fs": "0R2",
      "iata": "",
      "icao": "",
      "faa": "0R2",
      "name": "Lincoln Municipal",
      "city": "Lincoln",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 38.439111,
      "longitude": -93.479833,
      "elevationFeet": 940,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R2?codeType=fs"
     },
     {
      "fs": "0R3",
      "iata": "",
      "icao": "",
      "faa": "0R3",
      "name": "Abbeville Crusta Memorial",
      "city": "Abbeville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.057611,
      "longitude": -92.091528,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R3?codeType=fs"
     },
     {
      "fs": "0R4",
      "iata": "",
      "icao": "",
      "faa": "0R4",
      "name": "Concordia Parish",
      "city": "Vidalia",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.568333,
      "longitude": -91.501194,
      "elevationFeet": 54,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R4?codeType=fs"
     },
     {
      "fs": "0R5",
      "iata": "",
      "icao": "",
      "faa": "0R5",
      "name": "Joyce",
      "city": "Winnfield",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.086611,
      "longitude": -92.752611,
      "elevationFeet": 146,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R5?codeType=fs"
     },
     {
      "fs": "0R6",
      "iata": "",
      "icao": "",
      "faa": "0R6",
      "name": "Hampton Municipal",
      "city": "Hampton",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.601139,
      "longitude": -92.534861,
      "elevationFeet": 173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R6?codeType=fs"
     },
     {
      "fs": "0R7",
      "iata": "",
      "icao": "",
      "faa": "0R7",
      "name": "The Red River",
      "city": "Coushatta",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.9907,
      "longitude": -93.307404,
      "elevationFeet": 177,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R7?codeType=fs"
     },
     {
      "fs": "0R9",
      "iata": "",
      "icao": "",
      "faa": "0R9",
      "name": "Plainville",
      "city": "Plainville",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.294556,
      "longitude": -99.334333,
      "elevationFeet": 2182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0R9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0R9?codeType=fs"
     },
     {
      "fs": "0S0",
      "iata": "",
      "icao": "",
      "faa": "0S0",
      "name": "Lind",
      "city": "Lind",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 47.076444,
      "longitude": -118.608194,
      "elevationFeet": 1491,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0S0?codeType=fs"
     },
     {
      "fs": "0S1",
      "iata": "",
      "icao": "",
      "faa": "0S1",
      "name": "Meadow Creek Usfs",
      "city": "Meadow Creek",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 47.957778,
      "longitude": -113.492472,
      "elevationFeet": 3984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0S1?codeType=fs"
     },
     {
      "fs": "0S2",
      "iata": "",
      "icao": "",
      "faa": "0S2",
      "name": "Stockton Municipal",
      "city": "Stockton",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 39.472333,
      "longitude": -99.400972,
      "elevationFeet": 1973,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0S2?codeType=fs"
     },
     {
      "fs": "0S5",
      "iata": "",
      "icao": "",
      "faa": "0S5",
      "name": "Nez Perce Municipal",
      "city": "Nez Perce",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 46.273917,
      "longitude": -116.326417,
      "elevationFeet": 3201,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0S5?codeType=fs"
     },
     {
      "fs": "0S7",
      "iata": "",
      "icao": "",
      "faa": "0S7",
      "name": "Scott",
      "city": "Oroville",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 49.039639,
      "longitude": -119.519611,
      "elevationFeet": 1064,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0S7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0S7?codeType=fs"
     },
     {
      "fs": "0T3",
      "iata": "",
      "icao": "",
      "faa": "0T3",
      "name": "Twin City",
      "city": "Marble Hill",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 37.439417,
      "longitude": -90.12325,
      "elevationFeet": 421,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0T3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0T3?codeType=fs"
     },
     {
      "fs": "0T7",
      "iata": "",
      "icao": "",
      "faa": "0T7",
      "name": "Kittyhawk",
      "city": "Allen",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.212306,
      "longitude": -96.686056,
      "elevationFeet": 725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0T7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0T7?codeType=fs"
     },
     {
      "fs": "0U0",
      "iata": "",
      "icao": "",
      "faa": "0U0",
      "name": "Landmark Usfs",
      "city": "Landmark",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.724028,
      "longitude": -115.534472,
      "elevationFeet": 6662,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U0?codeType=fs"
     },
     {
      "fs": "0U1",
      "iata": "",
      "icao": "",
      "faa": "0U1",
      "name": "Warm Springs Creek",
      "city": "Lowman",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.22125,
      "longitude": -115.442639,
      "elevationFeet": 4831,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U1?codeType=fs"
     },
     {
      "fs": "0U2",
      "iata": "",
      "icao": "",
      "faa": "0U2",
      "name": "Copper Basin",
      "city": "Mackay",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 43.8185,
      "longitude": -113.964222,
      "elevationFeet": 7920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U2?codeType=fs"
     },
     {
      "fs": "0U3",
      "iata": "",
      "icao": "",
      "faa": "0U3",
      "name": "Mahoney Creek Usfs",
      "city": "Mahoney Creek",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.846333,
      "longitude": -114.964833,
      "elevationFeet": 4618,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U3?codeType=fs"
     },
     {
      "fs": "0U7",
      "iata": "",
      "icao": "",
      "faa": "0U7",
      "name": "Hollow Top",
      "city": "Martin",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 43.399056,
      "longitude": -113.6335,
      "elevationFeet": 5359,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U7?codeType=fs"
     },
     {
      "fs": "0U8",
      "iata": "",
      "icao": "",
      "faa": "0U8",
      "name": "May",
      "city": "May",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.702028,
      "longitude": -114.008861,
      "elevationFeet": 5324,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U8?codeType=fs"
     },
     {
      "fs": "0U9",
      "iata": "",
      "icao": "",
      "faa": "0U9",
      "name": "Williams Memorial",
      "city": "Midvale",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 44.565528,
      "longitude": -116.826639,
      "elevationFeet": 2617,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0U9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0U9?codeType=fs"
     },
     {
      "fs": "0V3",
      "iata": "",
      "icao": "",
      "faa": "0V3",
      "name": "Pioneer Village",
      "city": "Minden",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.649139,
      "longitude": -99.0565,
      "elevationFeet": 2160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0V3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0V3?codeType=fs"
     },
     {
      "fs": "0V4",
      "iata": "",
      "icao": "",
      "faa": "0V4",
      "name": "Brookneal-Campbell Co",
      "city": "Brookneal",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 37.217222,
      "longitude": -79.163889,
      "elevationFeet": 596,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0V4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0V4?codeType=fs"
     },
     {
      "fs": "0V5",
      "iata": "",
      "icao": "",
      "faa": "0V5",
      "name": "Whitman",
      "city": "Manassas",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 38.656778,
      "longitude": -77.597111,
      "elevationFeet": 225,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0V5?codeType=fs"
     },
     {
      "fs": "0V6",
      "iata": "",
      "icao": "",
      "faa": "0V6",
      "name": "Mission Sioux",
      "city": "Mission",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 43.369472,
      "longitude": -100.731944,
      "elevationFeet": 2605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0V6?codeType=fs"
     },
     {
      "fs": "0W3",
      "iata": "",
      "icao": "",
      "faa": "0W3",
      "name": "Harford Co",
      "city": "Churchville",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 39.567083,
      "longitude": -76.222194,
      "elevationFeet": 409,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0W3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0W3?codeType=fs"
     },
     {
      "fs": "0Y4",
      "iata": "",
      "icao": "",
      "faa": "0Y4",
      "name": "Lambert Fechter Municipal",
      "city": "Hartley",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 43.274722,
      "longitude": -95.4695,
      "elevationFeet": 1452,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Y4?codeType=fs"
     },
     {
      "fs": "0Y6",
      "iata": "",
      "icao": "",
      "faa": "0Y6",
      "name": "Lake Mills Municipal",
      "city": "Lake Mills",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 43.566222,
      "longitude": -93.585444,
      "elevationFeet": 1260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/0Y6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/0Y6?codeType=fs"
     },
     {
      "fs": "10C",
      "iata": "",
      "icao": "",
      "faa": "10C",
      "name": "Galt",
      "city": "Greenwood/Wonder Lake",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 42.426639,
      "longitude": -88.458889,
      "elevationFeet": 875,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10C?codeType=fs"
     },
     {
      "fs": "10D",
      "iata": "",
      "icao": "",
      "faa": "10D",
      "name": "Winsted Municipal",
      "city": "Winsted",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 45.099639,
      "longitude": -94.069167,
      "elevationFeet": 1030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10D?codeType=fs"
     },
     {
      "fs": "10F",
      "iata": "",
      "icao": "",
      "faa": "10F",
      "name": "Rosser Ranch",
      "city": "Graham",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 33.153944,
      "longitude": -98.703361,
      "elevationFeet": 1112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10F?codeType=fs"
     },
     {
      "fs": "10G",
      "iata": "",
      "icao": "",
      "faa": "10G",
      "name": "Holmes Co",
      "city": "Millersburg",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.571667,
      "longitude": -81.993611,
      "elevationFeet": 1218,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10G?codeType=fs"
     },
     {
      "fs": "10I",
      "iata": "",
      "icao": "",
      "faa": "10I",
      "name": "Riverview",
      "city": "Dresden",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.164583,
      "longitude": -82.087472,
      "elevationFeet": 730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10I?codeType=fs"
     },
     {
      "fs": "10K",
      "iata": "",
      "icao": "",
      "faa": "10K",
      "name": "Scotia Municipal",
      "city": "Scotia",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.508444,
      "longitude": -98.861917,
      "elevationFeet": 1930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10K?codeType=fs"
     },
     {
      "fs": "10N",
      "iata": "",
      "icao": "",
      "faa": "10N",
      "name": "Kobelt",
      "city": "Wallkill",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.692167,
      "longitude": -74.214167,
      "elevationFeet": 420,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10N?codeType=fs"
     },
     {
      "fs": "10U",
      "iata": "",
      "icao": "",
      "faa": "10U",
      "name": "Owyhee",
      "city": "Owyhee",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 41.982333,
      "longitude": -116.226,
      "elevationFeet": 5374,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/10U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/10U?codeType=fs"
     },
     {
      "fs": "11A",
      "iata": "",
      "icao": "",
      "faa": "11A",
      "name": "Clayton Municipal",
      "city": "Clayton",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 32.033,
      "longitude": -85.499139,
      "elevationFeet": 435,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11A?codeType=fs"
     },
     {
      "fs": "11G",
      "iata": "",
      "icao": "",
      "faa": "11G",
      "name": "Johnson Field",
      "city": "Smiths Creek",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 42.961417,
      "longitude": -82.60475,
      "elevationFeet": 630,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11G?codeType=fs"
     },
     {
      "fs": "11J",
      "iata": "",
      "icao": "",
      "faa": "11J",
      "name": "Early Co",
      "city": "Blakely",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 31.506194,
      "longitude": -84.979861,
      "elevationFeet": 213,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11J?codeType=fs"
     },
     {
      "fs": "11K",
      "iata": "",
      "icao": "",
      "faa": "11K",
      "name": "Stromsburg Municipal",
      "city": "Stromsburg",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 41.241806,
      "longitude": -97.6755,
      "elevationFeet": 1675,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11K?codeType=fs"
     },
     {
      "fs": "11M",
      "iata": "",
      "icao": "",
      "faa": "11M",
      "name": "Fulton-Itawamba Co",
      "city": "Fulton",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 34.370472,
      "longitude": -88.472694,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11M?codeType=fs"
     },
     {
      "fs": "11N",
      "iata": "",
      "icao": "",
      "faa": "11N",
      "name": "Candlelight Farms",
      "city": "New Milford",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 41.567611,
      "longitude": -73.612333,
      "elevationFeet": 675,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11N?codeType=fs"
     },
     {
      "fs": "11R",
      "iata": "",
      "icao": "",
      "faa": "11R",
      "name": "Brenham Municipal",
      "city": "Brenham",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 30.24,
      "longitude": -96.442778,
      "elevationFeet": 308,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11R?codeType=fs"
     },
     {
      "fs": "11S",
      "iata": "",
      "icao": "",
      "faa": "11S",
      "name": "Sekiu",
      "city": "Sekiu",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.679",
      "utcOffsetHours": -8,
      "latitude": 48.414667,
      "longitude": -124.368861,
      "elevationFeet": 350,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11S?codeType=fs"
     },
     {
      "fs": "11V",
      "iata": "",
      "icao": "",
      "faa": "11V",
      "name": "Easton",
      "city": "Greeley",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.679",
      "utcOffsetHours": -7,
      "latitude": 40.455361,
      "longitude": -104.6885,
      "elevationFeet": 4820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11V?codeType=fs"
     },
     {
      "fs": "11Z",
      "iata": "",
      "icao": "",
      "faa": "11Z",
      "name": "Lignite",
      "city": "Lignite",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.679",
      "utcOffsetHours": -9,
      "latitude": 64.0065,
      "longitude": -149.089889,
      "elevationFeet": 1171,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/11Z?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/11Z?codeType=fs"
     },
     {
      "fs": "12D",
      "iata": "",
      "icao": "",
      "faa": "12D",
      "name": "Tower Municipal",
      "city": "Tower",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 47.833333,
      "longitude": -92.366667,
      "elevationFeet": 1369,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12D?codeType=fs"
     },
     {
      "fs": "12G",
      "iata": "",
      "icao": "",
      "faa": "12G",
      "name": "Shelby Community",
      "city": "Shelby",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.679",
      "utcOffsetHours": -5,
      "latitude": 40.921667,
      "longitude": -82.818056,
      "elevationFeet": 1120,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12G?codeType=fs"
     },
     {
      "fs": "12J",
      "iata": "",
      "icao": "",
      "faa": "12J",
      "name": "Brewton Municipal",
      "city": "Brewton",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 31.062639,
      "longitude": -87.079694,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12J?codeType=fs"
     },
     {
      "fs": "12K",
      "iata": "",
      "icao": "",
      "faa": "12K",
      "name": "Superior Municipal",
      "city": "Superior",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.679",
      "utcOffsetHours": -6,
      "latitude": 40.163611,
      "longitude": -98.151111,
      "elevationFeet": 1691,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12K?codeType=fs"
     },
     {
      "fs": "12N",
      "iata": "",
      "icao": "",
      "faa": "12N",
      "name": "Aeroflex-Andover",
      "city": "Andover",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.08625,
      "longitude": -74.78025,
      "elevationFeet": 583,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12N?codeType=fs"
     },
     {
      "fs": "12R",
      "iata": "",
      "icao": "",
      "faa": "12R",
      "name": "Mikeska",
      "city": "Brookshire",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.938389,
      "longitude": -96.044,
      "elevationFeet": 161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12R?codeType=fs"
     },
     {
      "fs": "12S",
      "iata": "",
      "icao": "",
      "faa": "12S",
      "name": "Monument Municipal",
      "city": "Monument",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 44.968139,
      "longitude": -119.552694,
      "elevationFeet": 2323,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12S?codeType=fs"
     },
     {
      "fs": "12V",
      "iata": "",
      "icao": "",
      "faa": "12V",
      "name": "Ona",
      "city": "Milton",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 38.508889,
      "longitude": -82.207778,
      "elevationFeet": 572,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12V?codeType=fs"
     },
     {
      "fs": "12Y",
      "iata": "",
      "icao": "",
      "faa": "12Y",
      "name": "Le Sueur Municipal",
      "city": "Le Sueur",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 44.474639,
      "longitude": -94.027417,
      "elevationFeet": 868,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/12Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/12Y?codeType=fs"
     },
     {
      "fs": "13C",
      "iata": "",
      "icao": "",
      "faa": "13C",
      "name": "Lakeview-Griffith",
      "city": "Lakeview",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.471361,
      "longitude": -85.398028,
      "elevationFeet": 969,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/13C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/13C?codeType=fs"
     },
     {
      "fs": "13K",
      "iata": "",
      "icao": "",
      "faa": "13K",
      "name": "Eureka Municipal",
      "city": "Eureka",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.865833,
      "longitude": -96.366972,
      "elevationFeet": 1206,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/13K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/13K?codeType=fs"
     },
     {
      "fs": "13N",
      "iata": "",
      "icao": "",
      "faa": "13N",
      "name": "Trinca",
      "city": "Andover",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.967639,
      "longitude": -74.901667,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/13N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/13N?codeType=fs"
     },
     {
      "fs": "13W",
      "iata": "",
      "icao": "",
      "faa": "13W",
      "name": "Camano I",
      "city": "Stanwood",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 48.320444,
      "longitude": -122.46825,
      "elevationFeet": 145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/13W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/13W?codeType=fs"
     },
     {
      "fs": "13Y",
      "iata": "",
      "icao": "",
      "faa": "13Y",
      "name": "Littlefork Municipal/Hanover",
      "city": "Littlefork",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 48.566111,
      "longitude": -93.612722,
      "elevationFeet": 1145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/13Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/13Y?codeType=fs"
     },
     {
      "fs": "14A",
      "iata": "",
      "icao": "",
      "faa": "14A",
      "name": "Lake Norman Airport",
      "city": "Mooresville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.612803,
      "longitude": -80.897745,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14A?codeType=fs"
     },
     {
      "fs": "14F",
      "iata": "",
      "icao": "",
      "faa": "14F",
      "name": "Hamlin Municipal",
      "city": "Hamlin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.851083,
      "longitude": -100.178806,
      "elevationFeet": 1753,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14F?codeType=fs"
     },
     {
      "fs": "14G",
      "iata": "",
      "icao": "",
      "faa": "14G",
      "name": "Fremont Airport",
      "city": "Fremont",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.345132,
      "longitude": -83.167389,
      "elevationFeet": 641,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14G?codeType=fs"
     },
     {
      "fs": "14I",
      "iata": "",
      "icao": "",
      "faa": "14I",
      "name": "Bloom",
      "city": "Jamestown",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.633944,
      "longitude": -83.89925,
      "elevationFeet": 1050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14I?codeType=fs"
     },
     {
      "fs": "14J",
      "iata": "",
      "icao": "",
      "faa": "14J",
      "name": "Folsom",
      "city": "Elba",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.498889,
      "longitude": -86.138361,
      "elevationFeet": 262,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14J?codeType=fs"
     },
     {
      "fs": "14M",
      "iata": "",
      "icao": "",
      "faa": "14M",
      "name": "Hollandale Municipal",
      "city": "Hollandale",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.326222,
      "longitude": -90.956556,
      "elevationFeet": 114,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14M?codeType=fs"
     },
     {
      "fs": "14N",
      "iata": "",
      "icao": "",
      "faa": "14N",
      "name": "Beltzville",
      "city": "Lehighton",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.942583,
      "longitude": -75.654667,
      "elevationFeet": 899,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14N?codeType=fs"
     },
     {
      "fs": "14R",
      "iata": "",
      "icao": "",
      "faa": "14R",
      "name": "Caldwell Municipal",
      "city": "Caldwell",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.654833,
      "longitude": -96.740861,
      "elevationFeet": 390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14R?codeType=fs"
     },
     {
      "fs": "14S",
      "iata": "",
      "icao": "",
      "faa": "14S",
      "name": "Westport",
      "city": "Westport",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.8969,
      "longitude": -124.100998,
      "elevationFeet": 14,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14S?codeType=fs"
     },
     {
      "fs": "14Y",
      "iata": "",
      "icao": "",
      "faa": "14Y",
      "name": "Todd",
      "city": "Long Prairie",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.03575,
      "longitude": -94.939111,
      "elevationFeet": 1333,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/14Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/14Y?codeType=fs"
     },
     {
      "fs": "15A",
      "iata": "",
      "icao": "",
      "faa": "15A",
      "name": "Reynolds/North Mobile Co",
      "city": "Creola",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.032389,
      "longitude": -88.105528,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/15A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/15A?codeType=fs"
     },
     {
      "fs": "15F",
      "iata": "",
      "icao": "",
      "faa": "15F",
      "name": "Haskell Municipal",
      "city": "Haskell",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.265556,
      "longitude": -99.729306,
      "elevationFeet": 1624,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/15F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/15F?codeType=fs"
     },
     {
      "fs": "15G",
      "iata": "",
      "icao": "",
      "faa": "15G",
      "name": "Weltzien Skypark Airport",
      "city": "Wadsworth",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.026848,
      "longitude": -81.791147,
      "elevationFeet": 1121,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/15G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/15G?codeType=fs"
     },
     {
      "fs": "15J",
      "iata": "",
      "icao": "",
      "faa": "15J",
      "name": "Cook Co",
      "city": "Adel",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 31.177778,
      "longitude": -83.480833,
      "elevationFeet": 235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/15J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/15J?codeType=fs"
     },
     {
      "fs": "15M",
      "iata": "",
      "icao": "",
      "faa": "15M",
      "name": "Iuka",
      "city": "Iuka",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.823139,
      "longitude": -88.30875,
      "elevationFeet": 630,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/15M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/15M?codeType=fs"
     },
     {
      "fs": "15N",
      "iata": "",
      "icao": "",
      "faa": "15N",
      "name": "Jenkins",
      "city": "Wyoming",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.145583,
      "longitude": -75.588139,
      "elevationFeet": 53,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/15N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/15N?codeType=fs"
     },
     {
      "fs": "16D",
      "iata": "",
      "icao": "",
      "faa": "16D",
      "name": "Perham Municipal",
      "city": "Perham",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.64125,
      "longitude": -95.644861,
      "elevationFeet": 1371,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/16D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/16D?codeType=fs"
     },
     {
      "fs": "16G",
      "iata": "",
      "icao": "",
      "faa": "16G",
      "name": "Seneca Co",
      "city": "Tiffin",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.190556,
      "longitude": -83.325,
      "elevationFeet": 786,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/16G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/16G?codeType=fs"
     },
     {
      "fs": "16J",
      "iata": "",
      "icao": "",
      "faa": "16J",
      "name": "Dawson Municipal",
      "city": "Dawson",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 31.832861,
      "longitude": -84.442861,
      "elevationFeet": 333,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/16J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/16J?codeType=fs"
     },
     {
      "fs": "16S",
      "iata": "",
      "icao": "",
      "faa": "16S",
      "name": "Myrtle Creek Municipal",
      "city": "Myrtle Creek",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 43.1345,
      "longitude": -123.395083,
      "elevationFeet": 619,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/16S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/16S?codeType=fs"
     },
     {
      "fs": "16U",
      "iata": "",
      "icao": "",
      "faa": "16U",
      "name": "Ft Ruby Ranch",
      "city": "Ruby Valley",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 40.129861,
      "longitude": -115.558778,
      "elevationFeet": 6006,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/16U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/16U?codeType=fs"
     },
     {
      "fs": "16W",
      "iata": "",
      "icao": "",
      "faa": "16W",
      "name": "Little Goose Lock & Dam",
      "city": "Starbuck",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.732028,
      "longitude": -118.010583,
      "elevationFeet": 681,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/16W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/16W?codeType=fs"
     },
     {
      "fs": "17G",
      "iata": "",
      "icao": "",
      "faa": "17G",
      "name": "Port Bucyrus-Crawford Co",
      "city": "Bucyrus",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.914167,
      "longitude": -83.046944,
      "elevationFeet": 1003,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17G?codeType=fs"
     },
     {
      "fs": "17J",
      "iata": "",
      "icao": "",
      "faa": "17J",
      "name": "Donalsonville Municipal",
      "city": "Donalsonville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 31.006901,
      "longitude": -84.877602,
      "elevationFeet": 148,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17J?codeType=fs"
     },
     {
      "fs": "17K",
      "iata": "",
      "icao": "",
      "faa": "17K",
      "name": "Boise City",
      "city": "Boise City",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.843,
      "longitude": -102.604361,
      "elevationFeet": 4178,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17K?codeType=fs"
     },
     {
      "fs": "17M",
      "iata": "",
      "icao": "",
      "faa": "17M",
      "name": "Magee Municipal",
      "city": "Magee",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.962722,
      "longitude": -89.828528,
      "elevationFeet": 555,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17M?codeType=fs"
     },
     {
      "fs": "17N",
      "iata": "",
      "icao": "",
      "faa": "17N",
      "name": "Cross Keys",
      "city": "Cross Keys",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.705502,
      "longitude": -75.032997,
      "elevationFeet": 162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17N?codeType=fs"
     },
     {
      "fs": "17S",
      "iata": "",
      "icao": "",
      "faa": "17S",
      "name": "Chehalem",
      "city": "Newberg",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.387278,
      "longitude": -123.092694,
      "elevationFeet": 190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17S?codeType=fs"
     },
     {
      "fs": "17U",
      "iata": "",
      "icao": "",
      "faa": "17U",
      "name": "Garn",
      "city": "Eagle Mountain",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.387444,
      "longitude": -112.05975,
      "elevationFeet": 4845,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17U?codeType=fs"
     },
     {
      "fs": "17V",
      "iata": "",
      "icao": "",
      "faa": "17V",
      "name": "Haxtun Municipal",
      "city": "Haxtun",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.699917,
      "longitude": -102.632472,
      "elevationFeet": 4035,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17V?codeType=fs"
     },
     {
      "fs": "17W",
      "iata": "",
      "icao": "",
      "faa": "17W",
      "name": "Wadena Municipal",
      "city": "Wadena",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.566667,
      "longitude": -95.316667,
      "elevationFeet": 1370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17W?codeType=fs"
     },
     {
      "fs": "17Y",
      "iata": "",
      "icao": "",
      "faa": "17Y",
      "name": "Iverson",
      "city": "Mc Gregor",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.657806,
      "longitude": -93.385639,
      "elevationFeet": 1227,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/17Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/17Y?codeType=fs"
     },
     {
      "fs": "18A",
      "iata": "",
      "icao": "",
      "faa": "18A",
      "name": "Franklin Co",
      "city": "Canon",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.401056,
      "longitude": -83.134833,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/18A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/18A?codeType=fs"
     },
     {
      "fs": "18I",
      "iata": "",
      "icao": "",
      "faa": "18I",
      "name": "Mc Creary Co",
      "city": "Pine Knot",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.809139,
      "longitude": -84.466028,
      "elevationFeet": 1370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/18I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/18I?codeType=fs"
     },
     {
      "fs": "18K",
      "iata": "",
      "icao": "",
      "faa": "18K",
      "name": "Fowler",
      "city": "Fowler",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.391917,
      "longitude": -100.212528,
      "elevationFeet": 2483,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/18K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/18K?codeType=fs"
     },
     {
      "fs": "18V",
      "iata": "",
      "icao": "",
      "faa": "18V",
      "name": "Platte Valley",
      "city": "Hudson",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.249833,
      "longitude": -104.710778,
      "elevationFeet": 4965,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/18V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/18V?codeType=fs"
     },
     {
      "fs": "18Y",
      "iata": "",
      "icao": "",
      "faa": "18Y",
      "name": "Milaca Municipal",
      "city": "Milaca",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.824639,
      "longitude": -93.771833,
      "elevationFeet": 1100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/18Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/18Y?codeType=fs"
     },
     {
      "fs": "19A",
      "iata": "",
      "icao": "",
      "faa": "19A",
      "name": "Jackson Co",
      "city": "Jefferson",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.24025,
      "longitude": -83.656639,
      "elevationFeet": 951,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/19A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/19A?codeType=fs"
     },
     {
      "fs": "19M",
      "iata": "",
      "icao": "",
      "faa": "19M",
      "name": "Moore",
      "city": "Lexington",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.204611,
      "longitude": -90.105583,
      "elevationFeet": 340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/19M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/19M?codeType=fs"
     },
     {
      "fs": "19N",
      "iata": "",
      "icao": "",
      "faa": "19N",
      "name": "Camden Co",
      "city": "Berlin",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.7784444,
      "longitude": -74.9478,
      "elevationFeet": 150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/19N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/19N?codeType=fs"
     },
     {
      "fs": "1A0",
      "iata": "",
      "icao": "",
      "faa": "1A0",
      "name": "Dallas Bay",
      "city": "Chattanooga",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.225694,
      "longitude": -85.277333,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A0?codeType=fs"
     },
     {
      "fs": "1A1",
      "iata": "",
      "icao": "",
      "faa": "1A1",
      "name": "Green Acres",
      "city": "Livingston",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.287,
      "longitude": -73.759583,
      "elevationFeet": 295,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A1?codeType=fs"
     },
     {
      "fs": "1A2",
      "iata": "",
      "icao": "",
      "faa": "1A2",
      "name": "Arthur",
      "city": "Arthur",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 47.210889,
      "longitude": -97.273083,
      "elevationFeet": 973,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A2?codeType=fs"
     },
     {
      "fs": "1A3",
      "iata": "",
      "icao": "",
      "faa": "1A3",
      "name": "Campbell",
      "city": "Copperhill",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.161917,
      "longitude": -84.463111,
      "elevationFeet": 1793,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A3?codeType=fs"
     },
     {
      "fs": "1A6",
      "iata": "",
      "icao": "",
      "faa": "1A6",
      "name": "Middlesboro-Bell Co",
      "city": "Middlesboro",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.706389,
      "longitude": -83.774167,
      "elevationFeet": 1154,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A6?codeType=fs"
     },
     {
      "fs": "1A7",
      "iata": "",
      "icao": "",
      "faa": "1A7",
      "name": "Jackson Co",
      "city": "Gainesboro",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.522806,
      "longitude": -85.716417,
      "elevationFeet": 515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A7?codeType=fs"
     },
     {
      "fs": "1A8",
      "iata": "",
      "icao": "",
      "faa": "1A8",
      "name": "Empire",
      "city": "Empire",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 40.679583,
      "longitude": -119.376861,
      "elevationFeet": 3990,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A8?codeType=fs"
     },
     {
      "fs": "1A9",
      "iata": "",
      "icao": "",
      "faa": "1A9",
      "name": "Autauga Co",
      "city": "Prattville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.487778,
      "longitude": -86.604444,
      "elevationFeet": 215,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1A9?codeType=fs"
     },
     {
      "fs": "1B0",
      "iata": "",
      "icao": "",
      "faa": "1B0",
      "name": "Dexter Regional",
      "city": "Dexter",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 45.083944,
      "longitude": -69.297667,
      "elevationFeet": 533,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B0?codeType=fs"
     },
     {
      "fs": "1B2",
      "iata": "",
      "icao": "",
      "faa": "1B2",
      "name": "Katama",
      "city": "Edgartown",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.358299,
      "longitude": -70.524399,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B2?codeType=fs"
     },
     {
      "fs": "1B3",
      "iata": "",
      "icao": "",
      "faa": "1B3",
      "name": "Fair Haven Municipal",
      "city": "Fair Haven",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.753444,
      "longitude": -73.345556,
      "elevationFeet": 370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B3?codeType=fs"
     },
     {
      "fs": "1B4",
      "iata": "",
      "icao": "",
      "faa": "1B4",
      "name": "Kamp",
      "city": "Durhamville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.147361,
      "longitude": -75.789056,
      "elevationFeet": 443,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B4?codeType=fs"
     },
     {
      "fs": "1B5",
      "iata": "",
      "icao": "",
      "faa": "1B5",
      "name": "Franconia",
      "city": "Franconia",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.308972,
      "longitude": -71.895306,
      "elevationFeet": 970,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B5?codeType=fs"
     },
     {
      "fs": "1B6",
      "iata": "",
      "icao": "",
      "faa": "1B6",
      "name": "Hopedale Industrial Park",
      "city": "Hopedale",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.106499,
      "longitude": -71.510101,
      "elevationFeet": 269,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B6?codeType=fs"
     },
     {
      "fs": "1B8",
      "iata": "",
      "icao": "",
      "faa": "1B8",
      "name": "Chaplin",
      "city": "Cambridge",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.050778,
      "longitude": -73.512222,
      "elevationFeet": 508,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B8?codeType=fs"
     },
     {
      "fs": "1B9",
      "iata": "",
      "icao": "",
      "faa": "1B9",
      "name": "Mansfield Municipal",
      "city": "Mansfield",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.000099,
      "longitude": -71.1968,
      "elevationFeet": 122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1B9?codeType=fs"
     },
     {
      "fs": "1C1",
      "iata": "",
      "icao": "",
      "faa": "1C1",
      "name": "Paxton",
      "city": "Paxton",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 40.589778,
      "longitude": -88.227389,
      "elevationFeet": 779,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1C1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1C1?codeType=fs"
     },
     {
      "fs": "1C2",
      "iata": "",
      "icao": "",
      "faa": "1C2",
      "name": "Howell-New Lenox",
      "city": "New Lenox",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 41.597556,
      "longitude": -87.964417,
      "elevationFeet": 753,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1C2?codeType=fs"
     },
     {
      "fs": "1C3",
      "iata": "",
      "icao": "",
      "faa": "1C3",
      "name": "Argyle",
      "city": "Argyle",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.292417,
      "longitude": -73.509444,
      "elevationFeet": 330,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1C3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1C3?codeType=fs"
     },
     {
      "fs": "1C5",
      "iata": "",
      "icao": "",
      "faa": "1C5",
      "name": "Clow International",
      "city": "Plainfield",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 41.80975,
      "longitude": -88.242306,
      "elevationFeet": 670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1C5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1C5?codeType=fs"
     },
     {
      "fs": "1C8",
      "iata": "",
      "icao": "",
      "faa": "1C8",
      "name": "Cottonwood",
      "city": "Rockford",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 42.366861,
      "longitude": -89.162194,
      "elevationFeet": 741,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1C8?codeType=fs"
     },
     {
      "fs": "1D1",
      "iata": "",
      "icao": "",
      "faa": "1D1",
      "name": "Milbank Municipal",
      "city": "Milbank",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.355389,
      "longitude": -96.709667,
      "elevationFeet": 1116,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D1?codeType=fs"
     },
     {
      "fs": "1D2",
      "iata": "",
      "icao": "",
      "faa": "1D2",
      "name": "Canton-Plymouth-Mettetal",
      "city": "Plymouth",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.350361,
      "longitude": -83.532694,
      "elevationFeet": 696,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D2?codeType=fs"
     },
     {
      "fs": "1D3",
      "iata": "",
      "icao": "",
      "faa": "1D3",
      "name": "Platte Municipal",
      "city": "Platte",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.433278,
      "longitude": -98.945306,
      "elevationFeet": 1618,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D3?codeType=fs"
     },
     {
      "fs": "1D4",
      "iata": "",
      "icao": "",
      "faa": "1D4",
      "name": "Mayfield Airport",
      "city": "Akron",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.992977,
      "longitude": -81.430397,
      "elevationFeet": 1075,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D4?codeType=fs"
     },
     {
      "fs": "1D5",
      "iata": "",
      "icao": "",
      "faa": "1D5",
      "name": "Luther",
      "city": "Chittenango",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.142333,
      "longitude": -75.954667,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D5?codeType=fs"
     },
     {
      "fs": "1D6",
      "iata": "",
      "icao": "",
      "faa": "1D6",
      "name": "Hector Municipal",
      "city": "Hector",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 44.860722,
      "longitude": -94.847139,
      "elevationFeet": 1077,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D6?codeType=fs"
     },
     {
      "fs": "1D7",
      "iata": "",
      "icao": "",
      "faa": "1D7",
      "name": "The Sigurd Anderson",
      "city": "Webster",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.382917,
      "longitude": -97.637,
      "elevationFeet": 1854,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D7?codeType=fs"
     },
     {
      "fs": "1D8",
      "iata": "",
      "icao": "",
      "faa": "1D8",
      "name": "Redfield Municipal",
      "city": "Redfield",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 44.97475,
      "longitude": -98.645389,
      "elevationFeet": 1307,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1D8?codeType=fs"
     },
     {
      "fs": "1E2",
      "iata": "",
      "icao": "",
      "faa": "1E2",
      "name": "Terlingua Ranch",
      "city": "Alpine",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.451944,
      "longitude": -103.535111,
      "elevationFeet": 3769,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1E2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1E2?codeType=fs"
     },
     {
      "fs": "1E4",
      "iata": "",
      "icao": "",
      "faa": "1E4",
      "name": "Palo Duro",
      "city": "Amarillo",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.219972,
      "longitude": -101.879639,
      "elevationFeet": 3639,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1E4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1E4?codeType=fs"
     },
     {
      "fs": "1E7",
      "iata": "",
      "icao": "",
      "faa": "1E7",
      "name": "Buffalo",
      "city": "Amarillo",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.2,
      "longitude": -101.991667,
      "elevationFeet": 3640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1E7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1E7?codeType=fs"
     },
     {
      "fs": "1E8",
      "iata": "",
      "icao": "",
      "faa": "1E8",
      "name": "Moores",
      "city": "Degrasse",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.425611,
      "longitude": -75.213111,
      "elevationFeet": 814,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1E8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1E8?codeType=fs"
     },
     {
      "fs": "1E9",
      "iata": "",
      "icao": "",
      "faa": "1E9",
      "name": "Maples",
      "city": "Canyon",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.203333,
      "longitude": -102.063028,
      "elevationFeet": 3677,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1E9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1E9?codeType=fs"
     },
     {
      "fs": "1F1",
      "iata": "",
      "icao": "",
      "faa": "1F1",
      "name": "Lake Murray State Park",
      "city": "Overbrook",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.150972,
      "longitude": -97.166806,
      "elevationFeet": 817,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F1?codeType=fs"
     },
     {
      "fs": "1F2",
      "iata": "",
      "icao": "",
      "faa": "1F2",
      "name": "Plateau Sky Ranch",
      "city": "Edinburg",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.300722,
      "longitude": -74.248528,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F2?codeType=fs"
     },
     {
      "fs": "1F4",
      "iata": "",
      "icao": "",
      "faa": "1F4",
      "name": "Madill Municipal",
      "city": "Madill",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.204028,
      "longitude": -96.920333,
      "elevationFeet": 890,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F4?codeType=fs"
     },
     {
      "fs": "1F5",
      "iata": "",
      "icao": "",
      "faa": "1F5",
      "name": "Hoxie-Sheridan Co",
      "city": "Hoxie",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 39.3945,
      "longitude": -100.451389,
      "elevationFeet": 2733,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F5?codeType=fs"
     },
     {
      "fs": "1F6",
      "iata": "",
      "icao": "",
      "faa": "1F6",
      "name": "Dolgeville",
      "city": "Dolgeville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.117361,
      "longitude": -74.895944,
      "elevationFeet": 945,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F6?codeType=fs"
     },
     {
      "fs": "1F7",
      "iata": "",
      "icao": "",
      "faa": "1F7",
      "name": "Airpark East",
      "city": "Dallas",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.940167,
      "longitude": -96.372056,
      "elevationFeet": 510,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F7?codeType=fs"
     },
     {
      "fs": "1F9",
      "iata": "",
      "icao": "",
      "faa": "1F9",
      "name": "Bridgeport Municipal",
      "city": "Bridgeport",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.253333,
      "longitude": -97.933889,
      "elevationFeet": 852,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1F9?codeType=fs"
     },
     {
      "fs": "1G1",
      "iata": "",
      "icao": "",
      "faa": "1G1",
      "name": "Elyria Airport",
      "city": "Elyria",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.332742,
      "longitude": -82.093924,
      "elevationFeet": 757,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G1?codeType=fs"
     },
     {
      "fs": "1G2",
      "iata": "",
      "icao": "",
      "faa": "1G2",
      "name": "Granite Falls Municipal/Lenzen-Roe *",
      "city": "Granite Falls",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 44.782833,
      "longitude": -95.610167,
      "elevationFeet": 1047,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G2?codeType=fs"
     },
     {
      "fs": "1G3",
      "iata": "",
      "icao": "",
      "faa": "1G3",
      "name": "Kent State University Airport",
      "city": "Kent",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.150614,
      "longitude": -81.413243,
      "elevationFeet": 1105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G3?codeType=fs"
     },
     {
      "fs": "1G5",
      "iata": "",
      "icao": "",
      "faa": "1G5",
      "name": "Medina Municipal Airport",
      "city": "Medina",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.131985,
      "longitude": -81.758968,
      "elevationFeet": 1167,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G5?codeType=fs"
     },
     {
      "fs": "1G6",
      "iata": "",
      "icao": "",
      "faa": "1G6",
      "name": "Michael",
      "city": "Cicero",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.316667,
      "longitude": -76.227778,
      "elevationFeet": 400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G6?codeType=fs"
     },
     {
      "fs": "1G8",
      "iata": "",
      "icao": "",
      "faa": "1G8",
      "name": "Dew Memorial",
      "city": "Toronto",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.559,
      "longitude": -80.731306,
      "elevationFeet": 1084,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1G8?codeType=fs"
     },
     {
      "fs": "1H0",
      "iata": "",
      "icao": "",
      "faa": "1H0",
      "name": "Creve Coeur Airport",
      "city": "St Louis",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 38.734246,
      "longitude": -90.487351,
      "elevationFeet": 453,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H0?codeType=fs"
     },
     {
      "fs": "1H1",
      "iata": "",
      "icao": "",
      "faa": "1H1",
      "name": "Airlane Enterprises",
      "city": "Clay",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.250694,
      "longitude": -76.288139,
      "elevationFeet": 385,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H1?codeType=fs"
     },
     {
      "fs": "1H2",
      "iata": "",
      "icao": "",
      "faa": "1H2",
      "name": "Effingham Co Memorial",
      "city": "Effingham",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 39.1045,
      "longitude": -88.535194,
      "elevationFeet": 587,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H2?codeType=fs"
     },
     {
      "fs": "1H3",
      "iata": "",
      "icao": "",
      "faa": "1H3",
      "name": "Linn State Tech College",
      "city": "Linn",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 38.514944,
      "longitude": -91.953167,
      "elevationFeet": 952,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H3?codeType=fs"
     },
     {
      "fs": "1H4",
      "iata": "",
      "icao": "",
      "faa": "1H4",
      "name": "Greenville-Rainbow",
      "city": "Greenville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.417472,
      "longitude": -74.162444,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H4?codeType=fs"
     },
     {
      "fs": "1H5",
      "iata": "",
      "icao": "",
      "faa": "1H5",
      "name": "Willow Springs Memorial",
      "city": "Willow Springs",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.108889,
      "longitude": -92.076528,
      "elevationFeet": 1252,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H5?codeType=fs"
     },
     {
      "fs": "1H6",
      "iata": "",
      "icao": "",
      "faa": "1H6",
      "name": "Harvey Young Airport",
      "city": "Tulsa",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.13894,
      "longitude": -95.824122,
      "elevationFeet": 748,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H6?codeType=fs"
     },
     {
      "fs": "1H8",
      "iata": "",
      "icao": "",
      "faa": "1H8",
      "name": "Casey Municipal",
      "city": "Casey",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 39.325083,
      "longitude": -88.040611,
      "elevationFeet": 654,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1H8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1H8?codeType=fs"
     },
     {
      "fs": "1I1",
      "iata": "",
      "icao": "",
      "faa": "1I1",
      "name": "Marcy",
      "city": "Keene",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.258806,
      "longitude": -73.8625,
      "elevationFeet": 985,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1I1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1I1?codeType=fs"
     },
     {
      "fs": "1I3",
      "iata": "",
      "icao": "",
      "faa": "1I3",
      "name": "Shawnee",
      "city": "Bloomfield",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.144889,
      "longitude": -87.055639,
      "elevationFeet": 501,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1I3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1I3?codeType=fs"
     },
     {
      "fs": "1I5",
      "iata": "",
      "icao": "",
      "faa": "1I5",
      "name": "Freehold",
      "city": "Freehold",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.4925,
      "longitude": -74.209694,
      "elevationFeet": 440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1I5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1I5?codeType=fs"
     },
     {
      "fs": "1I7",
      "iata": "",
      "icao": "",
      "faa": "1I7",
      "name": "Clinton",
      "city": "Clinton",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.825389,
      "longitude": -87.414056,
      "elevationFeet": 526,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1I7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1I7?codeType=fs"
     },
     {
      "fs": "1I8",
      "iata": "",
      "icao": "",
      "faa": "1I8",
      "name": "Converse",
      "city": "Converse",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.608722,
      "longitude": -85.966528,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1I8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1I8?codeType=fs"
     },
     {
      "fs": "1I9",
      "iata": "",
      "icao": "",
      "faa": "1I9",
      "name": "Delphi Municipal",
      "city": "Delphi",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.628139,
      "longitude": -86.816722,
      "elevationFeet": 675,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1I9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1I9?codeType=fs"
     },
     {
      "fs": "1J0",
      "iata": "",
      "icao": "",
      "faa": "1J0",
      "name": "Tri Co",
      "city": "Bonifay",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.957778,
      "longitude": -85.613889,
      "elevationFeet": 85,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1J0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1J0?codeType=fs"
     },
     {
      "fs": "1J6",
      "iata": "",
      "icao": "",
      "faa": "1J6",
      "name": "Lee",
      "city": "De Land",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 29.144167,
      "longitude": -81.436667,
      "elevationFeet": 94,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1J6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1J6?codeType=fs"
     },
     {
      "fs": "1J9",
      "iata": "",
      "icao": "",
      "faa": "1J9",
      "name": "Ft Walton Beach",
      "city": "Navarre",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.463111,
      "longitude": -86.94125,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1J9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1J9?codeType=fs"
     },
     {
      "fs": "1K0",
      "iata": "",
      "icao": "",
      "faa": "1K0",
      "name": "Hendricks",
      "city": "Gouverneur",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.381167,
      "longitude": -75.424361,
      "elevationFeet": 480,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K0?codeType=fs"
     },
     {
      "fs": "1K1",
      "iata": "",
      "icao": "",
      "faa": "1K1",
      "name": "Benton",
      "city": "Benton",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.87875,
      "longitude": -97.235111,
      "elevationFeet": 1364,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K1?codeType=fs"
     },
     {
      "fs": "1K2",
      "iata": "",
      "icao": "",
      "faa": "1K2",
      "name": "Lindsay Municipal",
      "city": "Lindsay",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.850722,
      "longitude": -97.614194,
      "elevationFeet": 968,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K2?codeType=fs"
     },
     {
      "fs": "1K3",
      "iata": "",
      "icao": "",
      "faa": "1K3",
      "name": "Hamilton",
      "city": "Derby",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.655722,
      "longitude": -97.236556,
      "elevationFeet": 1320,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K3?codeType=fs"
     },
     {
      "fs": "1K4",
      "iata": "",
      "icao": "",
      "faa": "1K4",
      "name": "Perry",
      "city": "Goldsby",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.200667,
      "longitude": -97.503944,
      "elevationFeet": 1168,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K4?codeType=fs"
     },
     {
      "fs": "1K5",
      "iata": "",
      "icao": "",
      "faa": "1K5",
      "name": "Waynoka Municipal",
      "city": "Waynoka",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.567,
      "longitude": -98.873139,
      "elevationFeet": 1543,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K5?codeType=fs"
     },
     {
      "fs": "1K6",
      "iata": "",
      "icao": "",
      "faa": "1K6",
      "name": "Ellinwood Municipal",
      "city": "Ellinwood",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 38.433444,
      "longitude": -98.700778,
      "elevationFeet": 1797,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K6?codeType=fs"
     },
     {
      "fs": "1K7",
      "iata": "",
      "icao": "",
      "faa": "1K7",
      "name": "Fredonia",
      "city": "Fredonia",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.692139,
      "longitude": -95.877611,
      "elevationFeet": 880,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K7?codeType=fs"
     },
     {
      "fs": "1K8",
      "iata": "",
      "icao": "",
      "faa": "1K8",
      "name": "Craig Co South Grand Lake",
      "city": "Ketchum",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.617472,
      "longitude": -95.060722,
      "elevationFeet": 775,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K8?codeType=fs"
     },
     {
      "fs": "1K9",
      "iata": "",
      "icao": "",
      "faa": "1K9",
      "name": "Satanta Municipal",
      "city": "Satanta",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.491917,
      "longitude": -101.071111,
      "elevationFeet": 2976,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1K9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1K9?codeType=fs"
     },
     {
      "fs": "1L0",
      "iata": "",
      "icao": "",
      "faa": "1L0",
      "name": "St John The Baptist Parish",
      "city": "Reserve",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.12,
      "longitude": -90.725806,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L0?codeType=fs"
     },
     {
      "fs": "1L1",
      "iata": "",
      "icao": "",
      "faa": "1L1",
      "name": "Lincoln Co",
      "city": "Panaca",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 37.824639,
      "longitude": -114.466583,
      "elevationFeet": 4828,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L1?codeType=fs"
     },
     {
      "fs": "1L3",
      "iata": "",
      "icao": "",
      "faa": "1L3",
      "name": "Searchlight",
      "city": "Searchlight",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 35.544361,
      "longitude": -114.994222,
      "elevationFeet": 3410,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L3?codeType=fs"
     },
     {
      "fs": "1L4",
      "iata": "",
      "icao": "",
      "faa": "1L4",
      "name": "Kidwell",
      "city": "Cal Nev Ari",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 35.3555,
      "longitude": -115.027528,
      "elevationFeet": 2605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L4?codeType=fs"
     },
     {
      "fs": "1L7",
      "iata": "",
      "icao": "",
      "faa": "1L7",
      "name": "Escalante Municipal",
      "city": "Escalante",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 37.853278,
      "longitude": -111.601667,
      "elevationFeet": 5740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L7?codeType=fs"
     },
     {
      "fs": "1L8",
      "iata": "",
      "icao": "",
      "faa": "1L8",
      "name": "Hurricane",
      "city": "Hurricane",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 37.188722,
      "longitude": -113.363389,
      "elevationFeet": 3347,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L8?codeType=fs"
     },
     {
      "fs": "1L9",
      "iata": "",
      "icao": "",
      "faa": "1L9",
      "name": "Parowan",
      "city": "Parowan",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 37.946972,
      "longitude": -112.960556,
      "elevationFeet": 5930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1L9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1L9?codeType=fs"
     },
     {
      "fs": "1M1",
      "iata": "",
      "icao": "",
      "faa": "1M1",
      "name": "North Little Rock Municipal",
      "city": "Little Rock",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.839389,
      "longitude": -92.328611,
      "elevationFeet": 545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M1?codeType=fs"
     },
     {
      "fs": "1M2",
      "iata": "",
      "icao": "",
      "faa": "1M2",
      "name": "Belzoni Municipal",
      "city": "Belzoni",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.251806,
      "longitude": -90.652861,
      "elevationFeet": 110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M2?codeType=fs"
     },
     {
      "fs": "1M3",
      "iata": "",
      "icao": "",
      "faa": "1M3",
      "name": "Ardmore",
      "city": "Ardmore",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.078639,
      "longitude": -86.89725,
      "elevationFeet": 920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M3?codeType=fs"
     },
     {
      "fs": "1M4",
      "iata": "",
      "icao": "",
      "faa": "1M4",
      "name": "Posey",
      "city": "Haleyville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.403472,
      "longitude": -87.604417,
      "elevationFeet": 930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M4?codeType=fs"
     },
     {
      "fs": "1M5",
      "iata": "",
      "icao": "",
      "faa": "1M5",
      "name": "Portland Municipal",
      "city": "Portland",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.67875,
      "longitude": -86.569111,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M5?codeType=fs"
     },
     {
      "fs": "1M6",
      "iata": "",
      "icao": "",
      "faa": "1M6",
      "name": "Standard",
      "city": "Elkton",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.828194,
      "longitude": -87.263917,
      "elevationFeet": 665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M6?codeType=fs"
     },
     {
      "fs": "1M7",
      "iata": "",
      "icao": "",
      "faa": "1M7",
      "name": "Fulton",
      "city": "Fulton",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.608944,
      "longitude": -89.056167,
      "elevationFeet": 400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M7?codeType=fs"
     },
     {
      "fs": "1M8",
      "iata": "",
      "icao": "",
      "faa": "1M8",
      "name": "Myricks",
      "city": "Berkley",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.889917,
      "longitude": -71.10875,
      "elevationFeet": 71,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M8?codeType=fs"
     },
     {
      "fs": "1M9",
      "iata": "",
      "icao": "",
      "faa": "1M9",
      "name": "Lake Barkley State Park",
      "city": "Cadiz",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.839389,
      "longitude": -87.989111,
      "elevationFeet": 570,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1M9?codeType=fs"
     },
     {
      "fs": "1MO",
      "iata": "",
      "icao": "",
      "faa": "1MO",
      "name": "Mountain Grove Memorial",
      "city": "Mountain Grove",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.157194,
      "longitude": -92.412444,
      "elevationFeet": 1476,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1MO?codeType=fs"
     },
     {
      "fs": "1N0",
      "iata": "",
      "icao": "",
      "faa": "1N0",
      "name": "Ridgely",
      "city": "Ridgely",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.001139,
      "longitude": -76.01325,
      "elevationFeet": 63,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N0?codeType=fs"
     },
     {
      "fs": "1N1",
      "iata": "",
      "icao": "",
      "faa": "1N1",
      "name": "Sandia Airpark Estates East",
      "city": "Edgewood",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 35.194917,
      "longitude": -106.172472,
      "elevationFeet": 6550,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N1?codeType=fs"
     },
     {
      "fs": "1N2",
      "iata": "",
      "icao": "",
      "faa": "1N2",
      "name": "Spadaro",
      "city": "East Moriches",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.928778,
      "longitude": -72.887111,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N2?codeType=fs"
     },
     {
      "fs": "1N3",
      "iata": "",
      "icao": "",
      "faa": "1N3",
      "name": "Albert",
      "city": "Philipsburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.050556,
      "longitude": -78.397361,
      "elevationFeet": 1784,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N3?codeType=fs"
     },
     {
      "fs": "1N4",
      "iata": "",
      "icao": "",
      "faa": "1N4",
      "name": "Woodbine Municipal",
      "city": "Woodbine",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.2415,
      "longitude": -74.897639,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N4?codeType=fs"
     },
     {
      "fs": "1N5",
      "iata": "",
      "icao": "",
      "faa": "1N5",
      "name": "Bennett",
      "city": "Salisbury",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 38.526167,
      "longitude": -75.702028,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N5?codeType=fs"
     },
     {
      "fs": "1N7",
      "iata": "",
      "icao": "",
      "faa": "1N7",
      "name": "Blairstown",
      "city": "Blairstown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.011528,
      "longitude": -75.124806,
      "elevationFeet": 372,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N7?codeType=fs"
     },
     {
      "fs": "1N9",
      "iata": "",
      "icao": "",
      "faa": "1N9",
      "name": "Allentown-Queen City Municipal",
      "city": "Allentown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.602778,
      "longitude": -75.533056,
      "elevationFeet": 399,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1N9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1N9?codeType=fs"
     },
     {
      "fs": "1O1",
      "iata": "",
      "icao": "",
      "faa": "1O1",
      "name": "Grandfield Municipal",
      "city": "Grandfield",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.275889,
      "longitude": -98.820083,
      "elevationFeet": 1128,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O1?codeType=fs"
     },
     {
      "fs": "1O2",
      "iata": "",
      "icao": "",
      "faa": "1O2",
      "name": "Lampson",
      "city": "Lakeport",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 39.051667,
      "longitude": -123.047222,
      "elevationFeet": 1378,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O2?codeType=fs"
     },
     {
      "fs": "1O3",
      "iata": "",
      "icao": "",
      "faa": "1O3",
      "name": "Lodi",
      "city": "Lodi",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 38.223389,
      "longitude": -121.283833,
      "elevationFeet": 58,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O3?codeType=fs"
     },
     {
      "fs": "1O4",
      "iata": "",
      "icao": "",
      "faa": "1O4",
      "name": "Thomas Municipal",
      "city": "Thomas",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.733833,
      "longitude": -98.856389,
      "elevationFeet": 1731,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O4?codeType=fs"
     },
     {
      "fs": "1O6",
      "iata": "",
      "icao": "",
      "faa": "1O6",
      "name": "Dunsmuir Mun-Mott",
      "city": "Dunsmuir",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 41.382083,
      "longitude": -122.319528,
      "elevationFeet": 3258,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O6?codeType=fs"
     },
     {
      "fs": "1O7",
      "iata": "",
      "icao": "",
      "faa": "1O7",
      "name": "Claremore Regional",
      "city": "Claremore",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.393611,
      "longitude": -95.594167,
      "elevationFeet": 725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O7?codeType=fs"
     },
     {
      "fs": "1O8",
      "iata": "",
      "icao": "",
      "faa": "1O8",
      "name": "Tipton Municipal",
      "city": "Tipton",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.53625,
      "longitude": -99.213333,
      "elevationFeet": 1248,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1O8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1O8?codeType=fs"
     },
     {
      "fs": "1P1",
      "iata": "",
      "icao": "",
      "faa": "1P1",
      "name": "Plymouth Municipal",
      "city": "Plymouth",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.892389,
      "longitude": -71.786917,
      "elevationFeet": 505,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1P1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1P1?codeType=fs"
     },
     {
      "fs": "1Q1",
      "iata": "",
      "icao": "",
      "faa": "1Q1",
      "name": "Eckert",
      "city": "Strathmore",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 36.2745,
      "longitude": -119.051028,
      "elevationFeet": 426,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Q1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Q1?codeType=fs"
     },
     {
      "fs": "1Q2",
      "iata": "",
      "icao": "",
      "faa": "1Q2",
      "name": "Spaulding",
      "city": "Susanville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 40.653056,
      "longitude": -120.785083,
      "elevationFeet": 5116,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Q2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Q2?codeType=fs"
     },
     {
      "fs": "1Q4",
      "iata": "",
      "icao": "",
      "faa": "1Q4",
      "name": "New Jerusalem",
      "city": "Tracy",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 37.790972,
      "longitude": -121.446639,
      "elevationFeet": 62,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Q4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Q4?codeType=fs"
     },
     {
      "fs": "1Q5",
      "iata": "",
      "icao": "",
      "faa": "1Q5",
      "name": "Gravelly Valley",
      "city": "Upper Lake",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 39.598806,
      "longitude": -123.002778,
      "elevationFeet": 1900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Q5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Q5?codeType=fs"
     },
     {
      "fs": "1R1",
      "iata": "",
      "icao": "",
      "faa": "1R1",
      "name": "Jena",
      "city": "Jena",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.710056,
      "longitude": -92.234667,
      "elevationFeet": 212,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1R1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1R1?codeType=fs"
     },
     {
      "fs": "1R4",
      "iata": "",
      "icao": "",
      "faa": "1R4",
      "name": "Woodworth",
      "city": "Woodworth",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.243528,
      "longitude": -92.501389,
      "elevationFeet": 140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1R4?codeType=fs"
     },
     {
      "fs": "1R7",
      "iata": "",
      "icao": "",
      "faa": "1R7",
      "name": "Brookhaven-Lincoln Co",
      "city": "Brookhaven",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.66225,
      "longitude": -90.488444,
      "elevationFeet": 489,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1R7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1R7?codeType=fs"
     },
     {
      "fs": "1R8",
      "iata": "",
      "icao": "",
      "faa": "1R8",
      "name": "Bay Minette Municipal",
      "city": "Bay Minette",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.904639,
      "longitude": -87.823806,
      "elevationFeet": 248,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1R8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1R8?codeType=fs"
     },
     {
      "fs": "1S0",
      "iata": "",
      "icao": "",
      "faa": "1S0",
      "name": "Pierce Co-Thun",
      "city": "Puyallup",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.139167,
      "longitude": -122.321944,
      "elevationFeet": 538,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S0?codeType=fs"
     },
     {
      "fs": "1S1",
      "iata": "",
      "icao": "",
      "faa": "1S1",
      "name": "Porthill Eckhart International",
      "city": "Porthill",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 49.107861,
      "longitude": -116.510444,
      "elevationFeet": 1756,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S1?codeType=fs"
     },
     {
      "fs": "1S2",
      "iata": "",
      "icao": "",
      "faa": "1S2",
      "name": "Darrington Municipal",
      "city": "Darrington",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 48.331639,
      "longitude": -121.695694,
      "elevationFeet": 543,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S2?codeType=fs"
     },
     {
      "fs": "1S3",
      "iata": "",
      "icao": "",
      "faa": "1S3",
      "name": "Tillitt",
      "city": "Forsyth",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 46.311611,
      "longitude": -106.688944,
      "elevationFeet": 2727,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S3?codeType=fs"
     },
     {
      "fs": "1S4",
      "iata": "",
      "icao": "",
      "faa": "1S4",
      "name": "Seiling",
      "city": "Seiling",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.200389,
      "longitude": -98.937056,
      "elevationFeet": 1746,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S4?codeType=fs"
     },
     {
      "fs": "1S5",
      "iata": "",
      "icao": "",
      "faa": "1S5",
      "name": "Sunnyside Municipal",
      "city": "Sunnyside",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.426306,
      "longitude": -120.005972,
      "elevationFeet": 764,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S5?codeType=fs"
     },
     {
      "fs": "1S6",
      "iata": "",
      "icao": "",
      "faa": "1S6",
      "name": "Priest River Municipal",
      "city": "Priest River",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 48.251861,
      "longitude": -116.993639,
      "elevationFeet": 2187,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S6?codeType=fs"
     },
     {
      "fs": "1S7",
      "iata": "",
      "icao": "",
      "faa": "1S7",
      "name": "Slate Creek",
      "city": "Slate Creek",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.748861,
      "longitude": -116.393056,
      "elevationFeet": 1660,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S7?codeType=fs"
     },
     {
      "fs": "1S8",
      "iata": "",
      "icao": "",
      "faa": "1S8",
      "name": "Arlington Municipal",
      "city": "Arlington",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.865194,
      "longitude": -120.178194,
      "elevationFeet": 890,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S8?codeType=fs"
     },
     {
      "fs": "1S9",
      "iata": "",
      "icao": "",
      "faa": "1S9",
      "name": "Sand Canyon",
      "city": "Chewelah",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 48.437889,
      "longitude": -117.835806,
      "elevationFeet": 2075,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1S9?codeType=fs"
     },
     {
      "fs": "1T7",
      "iata": "",
      "icao": "",
      "faa": "1T7",
      "name": "Kestrel",
      "city": "San Antonio",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.927194,
      "longitude": -98.502944,
      "elevationFeet": 1250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1T7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1T7?codeType=fs"
     },
     {
      "fs": "1T8",
      "iata": "",
      "icao": "",
      "faa": "1T8",
      "name": "Bulverde",
      "city": "Bulverde",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.791111,
      "longitude": -98.461278,
      "elevationFeet": 1087,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1T8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1T8?codeType=fs"
     },
     {
      "fs": "1U0",
      "iata": "",
      "icao": "",
      "faa": "1U0",
      "name": "Bear Trap",
      "city": "Minidoka",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.049083,
      "longitude": -113.355611,
      "elevationFeet": 4716,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U0?codeType=fs"
     },
     {
      "fs": "1U1",
      "iata": "",
      "icao": "",
      "faa": "1U1",
      "name": "Moose Creek Usfs",
      "city": "Moose Creek Ranger Stn",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.1575,
      "longitude": -115.023333,
      "elevationFeet": 2454,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U1?codeType=fs"
     },
     {
      "fs": "1U2",
      "iata": "",
      "icao": "",
      "faa": "1U2",
      "name": "Mud Lake",
      "city": "Mud Lake",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.982417,
      "longitude": -112.6415,
      "elevationFeet": 4787,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U2?codeType=fs"
     },
     {
      "fs": "1U3",
      "iata": "",
      "icao": "",
      "faa": "1U3",
      "name": "Murphy",
      "city": "Murphy",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.359972,
      "longitude": -116.690083,
      "elevationFeet": 2855,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U3?codeType=fs"
     },
     {
      "fs": "1U4",
      "iata": "",
      "icao": "",
      "faa": "1U4",
      "name": "New Meadows",
      "city": "New Meadows",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 45.090583,
      "longitude": -116.292944,
      "elevationFeet": 3908,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U4?codeType=fs"
     },
     {
      "fs": "1U6",
      "iata": "",
      "icao": "",
      "faa": "1U6",
      "name": "Oakley Municipal",
      "city": "Oakley",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 42.240778,
      "longitude": -113.976528,
      "elevationFeet": 4650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U6?codeType=fs"
     },
     {
      "fs": "1U7",
      "iata": "",
      "icao": "",
      "faa": "1U7",
      "name": "Bear Lake Co",
      "city": "Paris",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 42.3715,
      "longitude": -111.382611,
      "elevationFeet": 5928,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U7?codeType=fs"
     },
     {
      "fs": "1U8",
      "iata": "",
      "icao": "",
      "faa": "1U8",
      "name": "Picabo",
      "city": "Picabo",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.382389,
      "longitude": -114.183667,
      "elevationFeet": 4828,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U8?codeType=fs"
     },
     {
      "fs": "1U9",
      "iata": "",
      "icao": "",
      "faa": "1U9",
      "name": "Pine",
      "city": "Pine",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.573944,
      "longitude": -115.392472,
      "elevationFeet": 4232,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1U9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1U9?codeType=fs"
     },
     {
      "fs": "1V0",
      "iata": "",
      "icao": "",
      "faa": "1V0",
      "name": "Navajo State Park",
      "city": "Navajo Dam",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 36.883389,
      "longitude": -107.664444,
      "elevationFeet": 6475,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1V0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1V0?codeType=fs"
     },
     {
      "fs": "1V2",
      "iata": "",
      "icao": "",
      "faa": "1V2",
      "name": "Grant Co Municipal",
      "city": "Hyannis",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 42.094306,
      "longitude": -101.793444,
      "elevationFeet": 3710,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1V2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1V2?codeType=fs"
     },
     {
      "fs": "1V8",
      "iata": "",
      "icao": "",
      "faa": "1V8",
      "name": "Leach",
      "city": "Center",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 37.797222,
      "longitude": -106.083583,
      "elevationFeet": 7598,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1V8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1V8?codeType=fs"
     },
     {
      "fs": "1V9",
      "iata": "",
      "icao": "",
      "faa": "1V9",
      "name": "Blake",
      "city": "Delta",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 38.803444,
      "longitude": -108.186444,
      "elevationFeet": 5193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1V9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1V9?codeType=fs"
     },
     {
      "fs": "1VA1",
      "iata": "",
      "icao": "",
      "faa": "1VA1",
      "name": "Micro",
      "city": "Stuart",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.752389,
      "longitude": -80.587611,
      "elevationFeet": 2923,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1VA1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1VA1?codeType=fs"
     },
     {
      "fs": "1W0",
      "iata": "",
      "icao": "",
      "faa": "1W0",
      "name": "J-Z",
      "city": "Almira",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.770944,
      "longitude": -119.027917,
      "elevationFeet": 1950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1W0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1W0?codeType=fs"
     },
     {
      "fs": "1W1",
      "iata": "",
      "icao": "",
      "faa": "1W1",
      "name": "Grove",
      "city": "Camas",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.727778,
      "longitude": -122.441667,
      "elevationFeet": 430,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1W1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1W1?codeType=fs"
     },
     {
      "fs": "1W2",
      "iata": "",
      "icao": "",
      "faa": "1W2",
      "name": "Baltimore Airpark",
      "city": "Baltimore",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.445528,
      "longitude": -76.510722,
      "elevationFeet": 230,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1W2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1W2?codeType=fs"
     },
     {
      "fs": "1W3",
      "iata": "",
      "icao": "",
      "faa": "1W3",
      "name": "Mexico Farms",
      "city": "Cumberland",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.648111,
      "longitude": -78.85575,
      "elevationFeet": 607,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1W3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1W3?codeType=fs"
     },
     {
      "fs": "1W5",
      "iata": "",
      "icao": "",
      "faa": "1W5",
      "name": "Hoby Wolf Airport",
      "city": "Eldersburg",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.406631,
      "longitude": -76.923019,
      "elevationFeet": 603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1W5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1W5?codeType=fs"
     },
     {
      "fs": "1X1",
      "iata": "",
      "icao": "",
      "faa": "1X1",
      "name": "Higgins-Lipscomb Co",
      "city": "Higgins",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.159028,
      "longitude": -100.107056,
      "elevationFeet": 2566,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1X1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1X1?codeType=fs"
     },
     {
      "fs": "1Y3",
      "iata": "",
      "icao": "",
      "faa": "1Y3",
      "name": "Judge Lewis-Mt Ayr Municipal",
      "city": "Mt Ayr",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 40.755472,
      "longitude": -94.288417,
      "elevationFeet": 1265,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Y3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Y3?codeType=fs"
     },
     {
      "fs": "1Y5",
      "iata": "",
      "icao": "",
      "faa": "1Y5",
      "name": "New Hampton Municipal",
      "city": "New Hampton",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.121972,
      "longitude": -92.432333,
      "elevationFeet": 1173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Y5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Y5?codeType=fs"
     },
     {
      "fs": "1Y9",
      "iata": "",
      "icao": "",
      "faa": "1Y9",
      "name": "Paullina Municipal",
      "city": "Paullina",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.033139,
      "longitude": -95.794528,
      "elevationFeet": 1385,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/1Y9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/1Y9?codeType=fs"
     },
     {
      "fs": "2001",
      "iata": "",
      "icao": "",
      "faa": "2001",
      "name": "Kure",
      "city": "Kure I",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.680",
      "utcOffsetHours": -10,
      "latitude": 28.383333,
      "longitude": -178.3,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2001?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2001?codeType=fs"
     },
     {
      "fs": "20A",
      "iata": "",
      "icao": "",
      "faa": "20A",
      "name": "Robbins",
      "city": "Oneonta",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.023194,
      "longitude": -86.494278,
      "elevationFeet": 1140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20A?codeType=fs"
     },
     {
      "fs": "20GA",
      "iata": "",
      "icao": "",
      "faa": "20GA",
      "name": "Stockmar",
      "city": "Villa Rica",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 33.814972,
      "longitude": -84.896639,
      "elevationFeet": 1110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20GA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20GA?codeType=fs"
     },
     {
      "fs": "20K",
      "iata": "",
      "icao": "",
      "faa": "20K",
      "name": "Quail Creek",
      "city": "Quail Creek",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.680",
      "utcOffsetHours": -9,
      "latitude": 65.389806,
      "longitude": -149.87225,
      "elevationFeet": 1550,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20K?codeType=fs"
     },
     {
      "fs": "20M",
      "iata": "",
      "icao": "",
      "faa": "20M",
      "name": "Macon Municipal",
      "city": "Macon",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.134583,
      "longitude": -88.555972,
      "elevationFeet": 238,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20M?codeType=fs"
     },
     {
      "fs": "20N",
      "iata": "",
      "icao": "",
      "faa": "20N",
      "name": "Kingston-Ulster",
      "city": "Kingston",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.002528,
      "longitude": -74.090972,
      "elevationFeet": 149,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20N?codeType=fs"
     },
     {
      "fs": "20R",
      "iata": "",
      "icao": "",
      "faa": "20R",
      "name": "Crystal City Municipal",
      "city": "Crystal City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 28.827556,
      "longitude": -99.828333,
      "elevationFeet": 608,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20R?codeType=fs"
     },
     {
      "fs": "20U",
      "iata": "",
      "icao": "",
      "faa": "20U",
      "name": "Beach",
      "city": "Beach",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 46.98625,
      "longitude": -104.085389,
      "elevationFeet": 2752,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20U?codeType=fs"
     },
     {
      "fs": "20V",
      "iata": "",
      "icao": "",
      "faa": "20V",
      "name": "Mc Elroy",
      "city": "Kremmling",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.086806,
      "longitude": -106.389472,
      "elevationFeet": 7411,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/20V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/20V?codeType=fs"
     },
     {
      "fs": "21D",
      "iata": "",
      "icao": "",
      "faa": "21D",
      "name": "Lake Elmo",
      "city": "St Paul",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.124944,
      "longitude": -92.906806,
      "elevationFeet": 932,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/21D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/21D?codeType=fs"
     },
     {
      "fs": "21F",
      "iata": "",
      "icao": "",
      "faa": "21F",
      "name": "Jacksboro Municipal",
      "city": "Jacksboro",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.33725,
      "longitude": -98.267111,
      "elevationFeet": 1055,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/21F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/21F?codeType=fs"
     },
     {
      "fs": "21N",
      "iata": "",
      "icao": "",
      "faa": "21N",
      "name": "Mattituck",
      "city": "Mattituck",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.026,
      "longitude": -72.53975,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/21N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/21N?codeType=fs"
     },
     {
      "fs": "21W",
      "iata": "",
      "icao": "",
      "faa": "21W",
      "name": "Ranger Creek",
      "city": "Greenwater",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.13,
      "longitude": -121.545,
      "elevationFeet": 2650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/21W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/21W?codeType=fs"
     },
     {
      "fs": "22B",
      "iata": "",
      "icao": "",
      "faa": "22B",
      "name": "Mountain Meadow Airstrip",
      "city": "Burlington",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.82875,
      "longitude": -73.112167,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22B?codeType=fs"
     },
     {
      "fs": "22D",
      "iata": "",
      "icao": "",
      "faa": "22D",
      "name": "Bandel",
      "city": "Eighty Four",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.256278,
      "longitude": -80.211667,
      "elevationFeet": 1210,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22D?codeType=fs"
     },
     {
      "fs": "22F",
      "iata": "",
      "icao": "",
      "faa": "22F",
      "name": "Kent Co",
      "city": "Jayton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.342611,
      "longitude": -100.58725,
      "elevationFeet": 2006,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22F?codeType=fs"
     },
     {
      "fs": "22I",
      "iata": "",
      "icao": "",
      "faa": "22I",
      "name": "Vinton Co",
      "city": "Mc Arthur",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.43125,
      "longitude": -82.518222,
      "elevationFeet": 958,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22I?codeType=fs"
     },
     {
      "fs": "22M",
      "iata": "",
      "icao": "",
      "faa": "22M",
      "name": "Pontotoc Co",
      "city": "Pontotoc",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.359389,
      "longitude": -89.083972,
      "elevationFeet": 440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22M?codeType=fs"
     },
     {
      "fs": "22N",
      "iata": "",
      "icao": "",
      "faa": "22N",
      "name": "Arner Memorial",
      "city": "Lehighton",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.895083,
      "longitude": -75.864972,
      "elevationFeet": 534,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22N?codeType=fs"
     },
     {
      "fs": "22S",
      "iata": "",
      "icao": "",
      "faa": "22S",
      "name": "Paisley State",
      "city": "Paisley",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 42.729306,
      "longitude": -120.6775,
      "elevationFeet": 4395,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22S?codeType=fs"
     },
     {
      "fs": "22Y",
      "iata": "",
      "icao": "",
      "faa": "22Y",
      "name": "Morey'S",
      "city": "Motley",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.38575,
      "longitude": -94.68625,
      "elevationFeet": 1225,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/22Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/22Y?codeType=fs"
     },
     {
      "fs": "23A",
      "iata": "",
      "icao": "",
      "faa": "23A",
      "name": "Mallard",
      "city": "York",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.601389,
      "longitude": -88.280833,
      "elevationFeet": 185,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23A?codeType=fs"
     },
     {
      "fs": "23D",
      "iata": "",
      "icao": "",
      "faa": "23D",
      "name": "Karlstad Municipal",
      "city": "Karlstad",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 48.691444,
      "longitude": -96.619861,
      "elevationFeet": 1025,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23D?codeType=fs"
     },
     {
      "fs": "23M",
      "iata": "",
      "icao": "",
      "faa": "23M",
      "name": "Clarke Co",
      "city": "Quitman",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.098722,
      "longitude": -88.789333,
      "elevationFeet": 320,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23M?codeType=fs"
     },
     {
      "fs": "23N",
      "iata": "",
      "icao": "",
      "faa": "23N",
      "name": "Bayport",
      "city": "Bayport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.834306,
      "longitude": -73.087222,
      "elevationFeet": 41,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23N?codeType=fs"
     },
     {
      "fs": "23R",
      "iata": "",
      "icao": "",
      "faa": "23R",
      "name": "Devine Municipal",
      "city": "Devine",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.184083,
      "longitude": -99.018917,
      "elevationFeet": 703,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23R?codeType=fs"
     },
     {
      "fs": "23S",
      "iata": "",
      "icao": "",
      "faa": "23S",
      "name": "Seeley Lake",
      "city": "Seeley Lake",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 47.291028,
      "longitude": -113.553528,
      "elevationFeet": 4235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23S?codeType=fs"
     },
     {
      "fs": "23Y",
      "iata": "",
      "icao": "",
      "faa": "23Y",
      "name": "Murdock Municipal",
      "city": "Murdock",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.271833,
      "longitude": -95.411361,
      "elevationFeet": 1082,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/23Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/23Y?codeType=fs"
     },
     {
      "fs": "24A",
      "iata": "",
      "icao": "",
      "faa": "24A",
      "name": "Jackson Co",
      "city": "Sylva",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.318639,
      "longitude": -83.293694,
      "elevationFeet": 2844,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24A?codeType=fs"
     },
     {
      "fs": "24C",
      "iata": "",
      "icao": "",
      "faa": "24C",
      "name": "Lowell City",
      "city": "Lowell",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.989194,
      "longitude": -85.439056,
      "elevationFeet": 681,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24C?codeType=fs"
     },
     {
      "fs": "24F",
      "iata": "",
      "icao": "",
      "faa": "24F",
      "name": "Cypress River",
      "city": "Jefferson",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.85975,
      "longitude": -94.343583,
      "elevationFeet": 221,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24F?codeType=fs"
     },
     {
      "fs": "24J",
      "iata": "",
      "icao": "",
      "faa": "24J",
      "name": "Suwannee Co",
      "city": "Live Oak",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 30.310556,
      "longitude": -83.081889,
      "elevationFeet": 104,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24J?codeType=fs"
     },
     {
      "fs": "24K",
      "iata": "",
      "icao": "",
      "faa": "24K",
      "name": "Krassel Usfs",
      "city": "Mc Call",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 45.043444,
      "longitude": -115.848417,
      "elevationFeet": 3982,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24K?codeType=fs"
     },
     {
      "fs": "24M",
      "iata": "",
      "icao": "",
      "faa": "24M",
      "name": "Wilderness Airpark",
      "city": "Kent City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.347472,
      "longitude": -85.817083,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24M?codeType=fs"
     },
     {
      "fs": "24N",
      "iata": "",
      "icao": "",
      "faa": "24N",
      "name": "Jicarilla Apache Nation",
      "city": "Dulce",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 36.935361,
      "longitude": -106.891917,
      "elevationFeet": 7618,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24N?codeType=fs"
     },
     {
      "fs": "24R",
      "iata": "",
      "icao": "",
      "faa": "24R",
      "name": "Dilley",
      "city": "Dilley",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 28.705361,
      "longitude": -99.242,
      "elevationFeet": 542,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24R?codeType=fs"
     },
     {
      "fs": "24S",
      "iata": "",
      "icao": "",
      "faa": "24S",
      "name": "Pinehurst State",
      "city": "Pinehurst",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 42.181944,
      "longitude": -122.394667,
      "elevationFeet": 3650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/24S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/24S?codeType=fs"
     },
     {
      "fs": "25A",
      "iata": "",
      "icao": "",
      "faa": "25A",
      "name": "Mc Minn",
      "city": "Weaver",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.79825,
      "longitude": -85.905222,
      "elevationFeet": 680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25A?codeType=fs"
     },
     {
      "fs": "25D",
      "iata": "",
      "icao": "",
      "faa": "25D",
      "name": "Forest Lake",
      "city": "Forest Lake",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.377444,
      "longitude": -93.093861,
      "elevationFeet": 925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25D?codeType=fs"
     },
     {
      "fs": "25J",
      "iata": "",
      "icao": "",
      "faa": "25J",
      "name": "Cuthbert-Randolph",
      "city": "Cuthbert",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 31.701667,
      "longitude": -84.899222,
      "elevationFeet": 457,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25J?codeType=fs"
     },
     {
      "fs": "25M",
      "iata": "",
      "icao": "",
      "faa": "25M",
      "name": "Ripley",
      "city": "Ripley",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.772667,
      "longitude": -89.1505,
      "elevationFeet": 465,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25M?codeType=fs"
     },
     {
      "fs": "25N",
      "iata": "",
      "icao": "",
      "faa": "25N",
      "name": "Rudys",
      "city": "Vineland",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.606722,
      "longitude": -75.212861,
      "elevationFeet": 88,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25N?codeType=fs"
     },
     {
      "fs": "25R",
      "iata": "",
      "icao": "",
      "faa": "25R",
      "name": "Edinburg International",
      "city": "Edinburg",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 26.520111,
      "longitude": -98.244528,
      "elevationFeet": 80,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25R?codeType=fs"
     },
     {
      "fs": "25U",
      "iata": "",
      "icao": "",
      "faa": "25U",
      "name": "Memaloose",
      "city": "Imnaha",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.526583,
      "longitude": -116.787583,
      "elevationFeet": 6708,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25U?codeType=fs"
     },
     {
      "fs": "25Y",
      "iata": "",
      "icao": "",
      "faa": "25Y",
      "name": "New York Mills Municipal",
      "city": "New York Mills",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.521833,
      "longitude": -95.375333,
      "elevationFeet": 1401,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/25Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/25Y?codeType=fs"
     },
     {
      "fs": "26A",
      "iata": "",
      "icao": "",
      "faa": "26A",
      "name": "Ashland-Lineville",
      "city": "Ashland-Lineville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.326139,
      "longitude": -85.841278,
      "elevationFeet": 1065,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/26A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/26A?codeType=fs"
     },
     {
      "fs": "26N",
      "iata": "",
      "icao": "",
      "faa": "26N",
      "name": "Ocean City Municipal",
      "city": "Ocean City",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.2635,
      "longitude": -74.607498,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/26N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/26N?codeType=fs"
     },
     {
      "fs": "26R",
      "iata": "",
      "icao": "",
      "faa": "26R",
      "name": "Jackson Co",
      "city": "Edna",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.010111,
      "longitude": -96.719472,
      "elevationFeet": 61,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/26R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/26R?codeType=fs"
     },
     {
      "fs": "26U",
      "iata": "",
      "icao": "",
      "faa": "26U",
      "name": "Mc Dermitt State",
      "city": "Mc Dermitt",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 42.021111,
      "longitude": -117.781972,
      "elevationFeet": 4478,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/26U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/26U?codeType=fs"
     },
     {
      "fs": "27A",
      "iata": "",
      "icao": "",
      "faa": "27A",
      "name": "Elbert Co-Patz",
      "city": "Elberton",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.201972,
      "longitude": -82.958639,
      "elevationFeet": 603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27A?codeType=fs"
     },
     {
      "fs": "27C",
      "iata": "",
      "icao": "",
      "faa": "27C",
      "name": "Mecosta Morton",
      "city": "Mecosta",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.741944,
      "longitude": -85.375361,
      "elevationFeet": 1022,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27C?codeType=fs"
     },
     {
      "fs": "27D",
      "iata": "",
      "icao": "",
      "faa": "27D",
      "name": "Myers",
      "city": "Canby",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 44.830194,
      "longitude": -96.381,
      "elevationFeet": 1190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27D?codeType=fs"
     },
     {
      "fs": "27J",
      "iata": "",
      "icao": "",
      "faa": "27J",
      "name": "Newberry Municipal",
      "city": "Newberry",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.392778,
      "longitude": -81.697222,
      "elevationFeet": 568,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27J?codeType=fs"
     },
     {
      "fs": "27R",
      "iata": "",
      "icao": "",
      "faa": "27R",
      "name": "Eldorado",
      "city": "Eldorado",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.960083,
      "longitude": -100.700972,
      "elevationFeet": 2441,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27R?codeType=fs"
     },
     {
      "fs": "27W",
      "iata": "",
      "icao": "",
      "faa": "27W",
      "name": "Lake Wenatchee State",
      "city": "Leavenworth",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.842889,
      "longitude": -120.748167,
      "elevationFeet": 1936,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/27W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/27W?codeType=fs"
     },
     {
      "fs": "28A",
      "iata": "",
      "icao": "",
      "faa": "28A",
      "name": "Goose Creek",
      "city": "Indian Trail",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.159806,
      "longitude": -80.622889,
      "elevationFeet": 565,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/28A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/28A?codeType=fs"
     },
     {
      "fs": "28J",
      "iata": "",
      "icao": "",
      "faa": "28J",
      "name": "Larkin",
      "city": "Palatka",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 29.658325,
      "longitude": -81.689352,
      "elevationFeet": 49,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/28J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/28J?codeType=fs"
     },
     {
      "fs": "28M",
      "iata": "",
      "icao": "",
      "faa": "28M",
      "name": "Cranland",
      "city": "Hanson",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.098333,
      "longitude": -70.881667,
      "elevationFeet": 71,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/28M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/28M?codeType=fs"
     },
     {
      "fs": "28N",
      "iata": "",
      "icao": "",
      "faa": "28N",
      "name": "Vineland Downstown",
      "city": "Vineland",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.576167,
      "longitude": -75.112833,
      "elevationFeet": 120,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/28N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/28N?codeType=fs"
     },
     {
      "fs": "28U",
      "iata": "",
      "icao": "",
      "faa": "28U",
      "name": "Owyhee Reservoir State",
      "city": "Owyhee",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.498806,
      "longitude": -117.454417,
      "elevationFeet": 2680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/28U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/28U?codeType=fs"
     },
     {
      "fs": "29D",
      "iata": "",
      "icao": "",
      "faa": "29D",
      "name": "Grove City",
      "city": "Grove City",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.25975,
      "longitude": -80.309222,
      "elevationFeet": 1371,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/29D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/29D?codeType=fs"
     },
     {
      "fs": "29F",
      "iata": "",
      "icao": "",
      "faa": "29F",
      "name": "Vaughn Spraying",
      "city": "Kress",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.508972,
      "longitude": -101.77125,
      "elevationFeet": 3500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/29F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/29F?codeType=fs"
     },
     {
      "fs": "29G",
      "iata": "",
      "icao": "",
      "faa": "29G",
      "name": "Portage Co",
      "city": "Ravenna",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.301944,
      "longitude": -81.266306,
      "elevationFeet": 1197,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/29G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/29G?codeType=fs"
     },
     {
      "fs": "29N",
      "iata": "",
      "icao": "",
      "faa": "29N",
      "name": "Kroelinger",
      "city": "Vineland",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.590056,
      "longitude": -75.163417,
      "elevationFeet": 93,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/29N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/29N?codeType=fs"
     },
     {
      "fs": "29S",
      "iata": "",
      "icao": "",
      "faa": "29S",
      "name": "Gardiner",
      "city": "Gardiner",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 45.199361,
      "longitude": -110.866,
      "elevationFeet": 5286,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/29S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/29S?codeType=fs"
     },
     {
      "fs": "2A0",
      "iata": "",
      "icao": "",
      "faa": "2A0",
      "name": "Anton",
      "city": "Dayton",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.512472,
      "longitude": -85.060972,
      "elevationFeet": 719,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A0?codeType=fs"
     },
     {
      "fs": "2A1",
      "iata": "",
      "icao": "",
      "faa": "2A1",
      "name": "Jamestown Municipal",
      "city": "Jamestown",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.497083,
      "longitude": -85.066444,
      "elevationFeet": 1694,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A1?codeType=fs"
     },
     {
      "fs": "2A2",
      "iata": "",
      "icao": "",
      "faa": "2A2",
      "name": "Holley Mountain",
      "city": "Clinton",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.663889,
      "longitude": -92.466667,
      "elevationFeet": 1270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A2?codeType=fs"
     },
     {
      "fs": "2A5",
      "iata": "",
      "icao": "",
      "faa": "2A5",
      "name": "Causey",
      "city": "Liberty",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.028306,
      "longitude": -79.62275,
      "elevationFeet": 723,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A5?codeType=fs"
     },
     {
      "fs": "2A6",
      "iata": "",
      "icao": "",
      "faa": "2A6",
      "name": "Holly Grove Municipal",
      "city": "Holly Grove",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.584306,
      "longitude": -91.309556,
      "elevationFeet": 176,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A6?codeType=fs"
     },
     {
      "fs": "2A8",
      "iata": "",
      "icao": "",
      "faa": "2A8",
      "name": "Addison Municipal",
      "city": "Addison",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.292694,
      "longitude": -87.230667,
      "elevationFeet": 786,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A8?codeType=fs"
     },
     {
      "fs": "2A9",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Kotlik/New",
      "city": "Kotlik",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.680",
      "utcOffsetHours": -9,
      "latitude": 63.161611,
      "longitude": -163.649278,
      "elevationFeet": 15,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2A9?codeType=fs"
     },
     {
      "fs": "2AK4",
      "iata": "",
      "icao": "",
      "faa": "2AK4",
      "name": "Oyster Cove",
      "city": "Homer",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.680",
      "utcOffsetHours": -9,
      "latitude": 59.499389,
      "longitude": -151.60975,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2AK4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2AK4?codeType=fs"
     },
     {
      "fs": "2B1",
      "iata": "",
      "icao": "",
      "faa": "2B1",
      "name": "Cape Cod",
      "city": "Marstons Mills",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.726083,
      "longitude": -70.436361,
      "elevationFeet": 100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2B1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2B1?codeType=fs"
     },
     {
      "fs": "2B2",
      "iata": "",
      "icao": "",
      "faa": "2B2",
      "name": "Plum Island",
      "city": "Newburyport",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.90925,
      "longitude": -70.911639,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2B2?codeType=fs"
     },
     {
      "fs": "2B6",
      "iata": "",
      "icao": "",
      "faa": "2B6",
      "name": "Hollister",
      "city": "Wilmington",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.475611,
      "longitude": -83.782556,
      "elevationFeet": 1090,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2B6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2B6?codeType=fs"
     },
     {
      "fs": "2B7",
      "iata": "",
      "icao": "",
      "faa": "2B7",
      "name": "Pittsfield Municipal",
      "city": "Pittsfield",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.785278,
      "longitude": -69.444167,
      "elevationFeet": 198,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2B7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2B7?codeType=fs"
     },
     {
      "fs": "2B9",
      "iata": "",
      "icao": "",
      "faa": "2B9",
      "name": "Post Mills",
      "city": "Post Mills",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.892361,
      "longitude": -72.287028,
      "elevationFeet": 693,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2B9?codeType=fs"
     },
     {
      "fs": "2C3",
      "iata": "",
      "icao": "",
      "faa": "2C3",
      "name": "Saline",
      "city": "Saline",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.263889,
      "longitude": -83.869444,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2C3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2C3?codeType=fs"
     },
     {
      "fs": "2C4",
      "iata": "",
      "icao": "",
      "faa": "2C4",
      "name": "Flying A",
      "city": "Chatfield",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.846861,
      "longitude": -92.335,
      "elevationFeet": 1300,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2C4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2C4?codeType=fs"
     },
     {
      "fs": "2C5",
      "iata": "",
      "icao": "",
      "faa": "2C5",
      "name": "Almena",
      "city": "Paw Paw",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.275389,
      "longitude": -85.852917,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2C5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2C5?codeType=fs"
     },
     {
      "fs": "2C6",
      "iata": "",
      "icao": "",
      "faa": "2C6",
      "name": "Tri County",
      "city": "Yates",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 40.839278,
      "longitude": -90.142833,
      "elevationFeet": 661,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2C6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2C6?codeType=fs"
     },
     {
      "fs": "2C8",
      "iata": "",
      "icao": "",
      "faa": "2C8",
      "name": "Cavalier Municipal",
      "city": "Cavalier",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 48.788806,
      "longitude": -97.748111,
      "elevationFeet": 892,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2C8?codeType=fs"
     },
     {
      "fs": "2CB",
      "iata": "",
      "icao": "",
      "faa": "2CB",
      "name": "Camp Blanding Aaf",
      "city": "Camp Blanding",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 29.952417,
      "longitude": -82.131583,
      "elevationFeet": 196,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2CB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2CB?codeType=fs"
     },
     {
      "fs": "2D1",
      "iata": "",
      "icao": "",
      "faa": "2D1",
      "name": "Barber",
      "city": "Alliance",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.008917,
      "longitude": -81.248194,
      "elevationFeet": 1062,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2D1?codeType=fs"
     },
     {
      "fs": "2D5",
      "iata": "",
      "icao": "",
      "faa": "2D5",
      "name": "Oakes Municipal",
      "city": "Oakes",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.230194,
      "longitude": -98.19875,
      "elevationFeet": 1335,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2D5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2D5?codeType=fs"
     },
     {
      "fs": "2D7",
      "iata": "",
      "icao": "",
      "faa": "2D7",
      "name": "Beach City",
      "city": "Beach City",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.766111,
      "longitude": -81.608889,
      "elevationFeet": 984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2D7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2D7?codeType=fs"
     },
     {
      "fs": "2E1",
      "iata": "",
      "icao": "",
      "faa": "2E1",
      "name": "Miller",
      "city": "Dalhart",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.167,
      "longitude": -102.557444,
      "elevationFeet": 3961,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2E1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2E1?codeType=fs"
     },
     {
      "fs": "2E3",
      "iata": "",
      "icao": "",
      "faa": "2E3",
      "name": "Cluck Ranch",
      "city": "Gruver",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.273056,
      "longitude": -101.794167,
      "elevationFeet": 3423,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2E3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2E3?codeType=fs"
     },
     {
      "fs": "2E5",
      "iata": "",
      "icao": "",
      "faa": "2E5",
      "name": "Dell City Municipal",
      "city": "Dell City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 32.067806,
      "longitude": -105.316222,
      "elevationFeet": 3701,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2E5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2E5?codeType=fs"
     },
     {
      "fs": "2E6",
      "iata": "",
      "icao": "",
      "faa": "2E6",
      "name": "Groton Municipal",
      "city": "Groton",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.544028,
      "longitude": -98.201,
      "elevationFeet": 1305,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2E6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2E6?codeType=fs"
     },
     {
      "fs": "2E7",
      "iata": "",
      "icao": "",
      "faa": "2E7",
      "name": "Mc Lean-Gray Co",
      "city": "Mc Lean",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.369944,
      "longitude": -100.640194,
      "elevationFeet": 2835,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2E7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2E7?codeType=fs"
     },
     {
      "fs": "2E8",
      "iata": "",
      "icao": "",
      "faa": "2E8",
      "name": "Cackleberry",
      "city": "Dexter",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.500361,
      "longitude": -83.893889,
      "elevationFeet": 890,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2E8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2E8?codeType=fs"
     },
     {
      "fs": "2F1",
      "iata": "",
      "icao": "",
      "faa": "2F1",
      "name": "Shamrock Municipal",
      "city": "Shamrock",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.261611,
      "longitude": -100.198389,
      "elevationFeet": 2369,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F1?codeType=fs"
     },
     {
      "fs": "2F4",
      "iata": "",
      "icao": "",
      "faa": "2F4",
      "name": "T-Bar",
      "city": "Tahoka",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.270361,
      "longitude": -101.848806,
      "elevationFeet": 3126,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F4?codeType=fs"
     },
     {
      "fs": "2F5",
      "iata": "",
      "icao": "",
      "faa": "2F5",
      "name": "Lamesa Municipal",
      "city": "Lamesa",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.812778,
      "longitude": -101.944722,
      "elevationFeet": 2998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F5?codeType=fs"
     },
     {
      "fs": "2F6",
      "iata": "",
      "icao": "",
      "faa": "2F6",
      "name": "Skiatook Municipal",
      "city": "Skiatook",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.420361,
      "longitude": -96.113861,
      "elevationFeet": 670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F6?codeType=fs"
     },
     {
      "fs": "2F7",
      "iata": "",
      "icao": "",
      "faa": "2F7",
      "name": "Commerce Municipal",
      "city": "Commerce",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.378889,
      "longitude": -96.014194,
      "elevationFeet": 515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F7?codeType=fs"
     },
     {
      "fs": "2F8",
      "iata": "",
      "icao": "",
      "faa": "2F8",
      "name": "Morehouse Memorial",
      "city": "Bastrop",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.810806,
      "longitude": -92.005722,
      "elevationFeet": 167,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F8?codeType=fs"
     },
     {
      "fs": "2F9",
      "iata": "",
      "icao": "",
      "faa": "2F9",
      "name": "Danaher",
      "city": "Wichita Falls",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.931833,
      "longitude": -98.6275,
      "elevationFeet": 986,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2F9?codeType=fs"
     },
     {
      "fs": "2G1",
      "iata": "",
      "icao": "",
      "faa": "2G1",
      "name": "Concord",
      "city": "Painesville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.670472,
      "longitude": -81.321833,
      "elevationFeet": 995,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2G1?codeType=fs"
     },
     {
      "fs": "2G2",
      "iata": "",
      "icao": "",
      "faa": "2G2",
      "name": "Jefferson Co",
      "city": "Steubenville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.444444,
      "longitude": -80.700778,
      "elevationFeet": 1194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2G2?codeType=fs"
     },
     {
      "fs": "2G8",
      "iata": "",
      "icao": "",
      "faa": "2G8",
      "name": "Gorham",
      "city": "Gorham",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.481167,
      "longitude": -71.317417,
      "elevationFeet": 835,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2G8?codeType=fs"
     },
     {
      "fs": "2G9",
      "iata": "",
      "icao": "",
      "faa": "2G9",
      "name": "Somerset Co",
      "city": "Somerset",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.091111,
      "longitude": -79.145556,
      "elevationFeet": 2272,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2G9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2G9?codeType=fs"
     },
     {
      "fs": "2GC",
      "iata": "",
      "icao": "",
      "faa": "2GC",
      "name": "Grays Creek Airport",
      "city": "Fayetteville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.892725,
      "longitude": -78.843731,
      "elevationFeet": 155,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2GC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2GC?codeType=fs"
     },
     {
      "fs": "2H0",
      "iata": "",
      "icao": "",
      "faa": "2H0",
      "name": "Shelby Co",
      "city": "Shelbyville",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 39.504278,
      "longitude": -88.954333,
      "elevationFeet": 618,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2H0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2H0?codeType=fs"
     },
     {
      "fs": "2H2",
      "iata": "",
      "icao": "",
      "faa": "2H2",
      "name": "Aurora Memorial Municipal",
      "city": "Aurora",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.073083,
      "longitude": -93.803111,
      "elevationFeet": 1434,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2H2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2H2?codeType=fs"
     },
     {
      "fs": "2H3",
      "iata": "",
      "icao": "",
      "faa": "2H3",
      "name": "Hebron Municipal",
      "city": "Hebron",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 46.96675,
      "longitude": -102.132167,
      "elevationFeet": 2150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2H3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2H3?codeType=fs"
     },
     {
      "fs": "2H4",
      "iata": "",
      "icao": "",
      "faa": "2H4",
      "name": "Triple H",
      "city": "Parchment",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.503167,
      "longitude": -85.608417,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2H4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2H4?codeType=fs"
     },
     {
      "fs": "2H9",
      "iata": "",
      "icao": "",
      "faa": "2H9",
      "name": "Rolette",
      "city": "Rolette",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 48.802778,
      "longitude": -99.882,
      "elevationFeet": 1620,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2H9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2H9?codeType=fs"
     },
     {
      "fs": "2I0",
      "iata": "",
      "icao": "",
      "faa": "2I0",
      "name": "Madisonville Municipal",
      "city": "Madisonville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.400278,
      "longitude": -87.546389,
      "elevationFeet": 439,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2I0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2I0?codeType=fs"
     },
     {
      "fs": "2I2",
      "iata": "",
      "icao": "",
      "faa": "2I2",
      "name": "Olive Hill-Seller'S",
      "city": "Olive Hill",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 38.286917,
      "longitude": -83.229528,
      "elevationFeet": 1016,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2I2?codeType=fs"
     },
     {
      "fs": "2I3",
      "iata": "",
      "icao": "",
      "faa": "2I3",
      "name": "Rough River State Park",
      "city": "Falls Of Rough",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.697778,
      "longitude": -86.56925,
      "elevationFeet": 577,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2I3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2I3?codeType=fs"
     },
     {
      "fs": "2I5",
      "iata": "",
      "icao": "",
      "faa": "2I5",
      "name": "Rantoul Natl Aviation Ctr-Liot",
      "city": "Rantoul",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 40.385583,
      "longitude": -88.223778,
      "elevationFeet": 737,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2I5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2I5?codeType=fs"
     },
     {
      "fs": "2IS",
      "iata": "",
      "icao": "",
      "faa": "2IS",
      "name": "Airglades",
      "city": "Clewiston",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 26.820111,
      "longitude": -81.197889,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2IS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2IS?codeType=fs"
     },
     {
      "fs": "2J0",
      "iata": "",
      "icao": "",
      "faa": "2J0",
      "name": "Wakulla Co",
      "city": "Panacea",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 30.040944,
      "longitude": -84.504556,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2J0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2J0?codeType=fs"
     },
     {
      "fs": "2J2",
      "iata": "",
      "icao": "",
      "faa": "2J2",
      "name": "Liberty Co",
      "city": "Hinesville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 31.796111,
      "longitude": -81.711667,
      "elevationFeet": 98,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2J2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2J2?codeType=fs"
     },
     {
      "fs": "2J3",
      "iata": "",
      "icao": "",
      "faa": "2J3",
      "name": "Louisville Municipal",
      "city": "Louisville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 33.015417,
      "longitude": -82.406806,
      "elevationFeet": 328,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2J3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2J3?codeType=fs"
     },
     {
      "fs": "2J5",
      "iata": "",
      "icao": "",
      "faa": "2J5",
      "name": "Millen",
      "city": "Millen",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 32.987694,
      "longitude": -82.101167,
      "elevationFeet": 229,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2J5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2J5?codeType=fs"
     },
     {
      "fs": "2J8",
      "iata": "",
      "icao": "",
      "faa": "2J8",
      "name": "Pierson Municipal",
      "city": "Pierson",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 29.399778,
      "longitude": -81.542361,
      "elevationFeet": 63,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2J8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2J8?codeType=fs"
     },
     {
      "fs": "2J9",
      "iata": "",
      "icao": "",
      "faa": "2J9",
      "name": "Quincy Municipal",
      "city": "Quincy",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 30.728611,
      "longitude": -84.624167,
      "elevationFeet": 221,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2J9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2J9?codeType=fs"
     },
     {
      "fs": "2K0",
      "iata": "",
      "icao": "",
      "faa": "2K0",
      "name": "Piatt Co",
      "city": "Monticello",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 40.055889,
      "longitude": -88.633972,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K0?codeType=fs"
     },
     {
      "fs": "2K1",
      "iata": "",
      "icao": "",
      "faa": "2K1",
      "name": "Pond Creek Municipal",
      "city": "Pond Creek",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.775306,
      "longitude": -97.886667,
      "elevationFeet": 1061,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K1?codeType=fs"
     },
     {
      "fs": "2K2",
      "iata": "",
      "icao": "",
      "faa": "2K2",
      "name": "Air Park South",
      "city": "Ozark",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.144694,
      "longitude": -93.242667,
      "elevationFeet": 1336,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K2?codeType=fs"
     },
     {
      "fs": "2K3",
      "iata": "",
      "icao": "",
      "faa": "2K3",
      "name": "Stanton Co Municipal",
      "city": "Johnson",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.727111,
      "longitude": -101.878111,
      "elevationFeet": 3324,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K3?codeType=fs"
     },
     {
      "fs": "2K4",
      "iata": "",
      "icao": "",
      "faa": "2K4",
      "name": "Scott Field",
      "city": "Mangum",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.96725,
      "longitude": -99.617556,
      "elevationFeet": 1643,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K4?codeType=fs"
     },
     {
      "fs": "2K6",
      "iata": "",
      "icao": "",
      "faa": "2K6",
      "name": "Elk Co",
      "city": "Moline",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.505944,
      "longitude": -96.308306,
      "elevationFeet": 1063,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K6?codeType=fs"
     },
     {
      "fs": "2K7",
      "iata": "",
      "icao": "",
      "faa": "2K7",
      "name": "Neodesha Municipal",
      "city": "Neodesha",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.453639,
      "longitude": -95.761194,
      "elevationFeet": 841,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K7?codeType=fs"
     },
     {
      "fs": "2K8",
      "iata": "",
      "icao": "",
      "faa": "2K8",
      "name": "Argonia Municipal",
      "city": "Argonia",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.350194,
      "longitude": -97.850528,
      "elevationFeet": 1275,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K8?codeType=fs"
     },
     {
      "fs": "2K9",
      "iata": "",
      "icao": "",
      "faa": "2K9",
      "name": "Haskell",
      "city": "Haskell",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.956556,
      "longitude": -95.669278,
      "elevationFeet": 588,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2K9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2K9?codeType=fs"
     },
     {
      "fs": "2KL",
      "iata": "",
      "icao": "",
      "faa": "2KL",
      "name": "Sunrise Beach",
      "city": "Sunrise Beach Village",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.738,
      "longitude": -98.486389,
      "elevationFeet": 854,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2KL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2KL?codeType=fs"
     },
     {
      "fs": "2L0",
      "iata": "",
      "icao": "",
      "faa": "2L0",
      "name": "Pineville Municipal",
      "city": "Pineville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.418472,
      "longitude": -92.531917,
      "elevationFeet": 100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2L0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2L0?codeType=fs"
     },
     {
      "fs": "2L1",
      "iata": "",
      "icao": "",
      "faa": "2L1",
      "name": "Larimore Municipal",
      "city": "Larimore",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 47.969361,
      "longitude": -97.706417,
      "elevationFeet": 1130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2L1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2L1?codeType=fs"
     },
     {
      "fs": "2M0",
      "iata": "",
      "icao": "",
      "faa": "2M0",
      "name": "Princeton-Caldwell Co",
      "city": "Princeton",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.256056,
      "longitude": -87.905694,
      "elevationFeet": 582,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2M0?codeType=fs"
     },
     {
      "fs": "2M1",
      "iata": "",
      "icao": "",
      "faa": "2M1",
      "name": "Harry S. Truman Regional Airport",
      "city": "Bates City",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 39.018422,
      "longitude": -94.087907,
      "elevationFeet": 864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2M1?codeType=fs"
     },
     {
      "fs": "2M2",
      "iata": "",
      "icao": "",
      "faa": "2M2",
      "name": "Lawrenceburg-Lawrence Co",
      "city": "Lawrenceburg",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.243028,
      "longitude": -87.329333,
      "elevationFeet": 936,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2M2?codeType=fs"
     },
     {
      "fs": "2M4",
      "iata": "",
      "icao": "",
      "faa": "2M4",
      "name": "Montgomery",
      "city": "Forest",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.384778,
      "longitude": -89.536806,
      "elevationFeet": 517,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2M4?codeType=fs"
     },
     {
      "fs": "2M7",
      "iata": "",
      "icao": "",
      "faa": "2M7",
      "name": "Black Mountain",
      "city": "Cheboygan",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 45.669444,
      "longitude": -84.380556,
      "elevationFeet": 677,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2M7?codeType=fs"
     },
     {
      "fs": "2M8",
      "iata": "",
      "icao": "",
      "faa": "2M8",
      "name": "Baker",
      "city": "Millington",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.390306,
      "longitude": -90.064194,
      "elevationFeet": 247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2M8?codeType=fs"
     },
     {
      "fs": "2MO",
      "iata": "",
      "icao": "",
      "faa": "2MO",
      "name": "Mt Vernon Municipal",
      "city": "Mt Vernon",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.083917,
      "longitude": -93.899306,
      "elevationFeet": 1244,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2MO?codeType=fs"
     },
     {
      "fs": "2N2",
      "iata": "",
      "icao": "",
      "faa": "2N2",
      "name": "Newfound Valley",
      "city": "Bristol",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.670194,
      "longitude": -71.764694,
      "elevationFeet": 510,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2N2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2N2?codeType=fs"
     },
     {
      "fs": "2N5",
      "iata": "",
      "icao": "",
      "faa": "2N5",
      "name": "Kampel",
      "city": "Wellsville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.184278,
      "longitude": -77.080333,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2N5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2N5?codeType=fs"
     },
     {
      "fs": "2N6",
      "iata": "",
      "icao": "",
      "faa": "2N6",
      "name": "Redwing Airport",
      "city": "Jobstown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.028611,
      "longitude": -74.693896,
      "elevationFeet": 69,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2N6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2N6?codeType=fs"
     },
     {
      "fs": "2N8",
      "iata": "",
      "icao": "",
      "faa": "2N8",
      "name": "Marlboro",
      "city": "Matawan",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.512472,
      "longitude": -74.293389,
      "elevationFeet": 122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2N8?codeType=fs"
     },
     {
      "fs": "2O1",
      "iata": "GNF",
      "icao": "",
      "faa": "2O1",
      "name": "Gansner Field",
      "city": "Quincy",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 39.943996,
      "longitude": -121.945361,
      "elevationFeet": 3409,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2O1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2O1?codeType=fs"
     },
     {
      "fs": "2O2",
      "iata": "",
      "icao": "",
      "faa": "2O2",
      "name": "Enix Boys",
      "city": "Hennessey",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.142056,
      "longitude": -97.970028,
      "elevationFeet": 1100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2O2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2O2?codeType=fs"
     },
     {
      "fs": "2O3",
      "iata": "",
      "icao": "",
      "faa": "2O3",
      "name": "Angwin-Parrett",
      "city": "Angwin",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 38.685167,
      "longitude": -122.452583,
      "elevationFeet": 1848,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2O3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2O3?codeType=fs"
     },
     {
      "fs": "2O6",
      "iata": "",
      "icao": "",
      "faa": "2O6",
      "name": "Chowchilla",
      "city": "Chowchilla",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 37.224444,
      "longitude": -120.368417,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2O6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2O6?codeType=fs"
     },
     {
      "fs": "2O7",
      "iata": "",
      "icao": "",
      "faa": "2O7",
      "name": "Independence",
      "city": "Independence",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 36.938222,
      "longitude": -118.250944,
      "elevationFeet": 3900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2O7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2O7?codeType=fs"
     },
     {
      "fs": "2O8",
      "iata": "",
      "icao": "",
      "faa": "2O8",
      "name": "Hinton Municipal",
      "city": "Hinton",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.55925,
      "longitude": -98.423611,
      "elevationFeet": 1583,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2O8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2O8?codeType=fs"
     },
     {
      "fs": "2P2",
      "iata": "",
      "icao": "",
      "faa": "2P2",
      "name": "Washington I",
      "city": "Washington I",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.412083,
      "longitude": -86.994806,
      "elevationFeet": 652,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2P2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2P2?codeType=fs"
     },
     {
      "fs": "2P7",
      "iata": "",
      "icao": "",
      "faa": "2P7",
      "name": "Alderman",
      "city": "St Clairsville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.11875,
      "longitude": -81.082056,
      "elevationFeet": 1187,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2P7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2P7?codeType=fs"
     },
     {
      "fs": "2PS6",
      "iata": "",
      "icao": "",
      "faa": "2PS6",
      "name": "Brandywine Hospital Heliport",
      "city": "Coatesville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.00955,
      "longitude": -75.784389,
      "elevationFeet": 565,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2PS6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2PS6?codeType=fs"
     },
     {
      "fs": "2Q3",
      "iata": "",
      "icao": "",
      "faa": "2Q3",
      "name": "Yolo County Davis Woodland Winters Airport",
      "city": "Davis Woodland Winters",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 38.579757,
      "longitude": -121.855568,
      "elevationFeet": 90,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Q3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Q3?codeType=fs"
     },
     {
      "fs": "2Q5",
      "iata": "",
      "icao": "",
      "faa": "2Q5",
      "name": "Parker Carson",
      "city": "Carson City",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 39.221333,
      "longitude": -119.699,
      "elevationFeet": 4900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Q5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Q5?codeType=fs"
     },
     {
      "fs": "2Q9",
      "iata": "",
      "icao": "",
      "faa": "2Q9",
      "name": "Dyer",
      "city": "Dyer",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 37.696528,
      "longitude": -118.064889,
      "elevationFeet": 4899,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Q9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Q9?codeType=fs"
     },
     {
      "fs": "2R0",
      "iata": "",
      "icao": "",
      "faa": "2R0",
      "name": "Waynesboro Municipal",
      "city": "Waynesboro",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.759944,
      "longitude": -88.647556,
      "elevationFeet": 164,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R0?codeType=fs"
     },
     {
      "fs": "2R1",
      "iata": "",
      "icao": "",
      "faa": "2R1",
      "name": "Le Maire Memorial",
      "city": "Jeanerette",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.040694,
      "longitude": -91.81,
      "elevationFeet": 14,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R1?codeType=fs"
     },
     {
      "fs": "2R4",
      "iata": "",
      "icao": "",
      "faa": "2R4",
      "name": "Prince",
      "city": "Milton",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.676222,
      "longitude": -87.086528,
      "elevationFeet": 82,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R4?codeType=fs"
     },
     {
      "fs": "2R5",
      "iata": "",
      "icao": "",
      "faa": "2R5",
      "name": "St Elmo",
      "city": "St Elmo",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.519083,
      "longitude": -88.351167,
      "elevationFeet": 133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R5?codeType=fs"
     },
     {
      "fs": "2R6",
      "iata": "",
      "icao": "",
      "faa": "2R6",
      "name": "Bunkie Municipal",
      "city": "Bunkie",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.017472,
      "longitude": -92.241,
      "elevationFeet": 62,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R6?codeType=fs"
     },
     {
      "fs": "2R7",
      "iata": "",
      "icao": "",
      "faa": "2R7",
      "name": "Franklinton",
      "city": "Franklinton",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 30.846306,
      "longitude": -90.2175,
      "elevationFeet": 175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R7?codeType=fs"
     },
     {
      "fs": "2R8",
      "iata": "",
      "icao": "",
      "faa": "2R8",
      "name": "Mustang Beach",
      "city": "Port Aransas",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 27.914167,
      "longitude": -97.141556,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R8?codeType=fs"
     },
     {
      "fs": "2R9",
      "iata": "",
      "icao": "",
      "faa": "2R9",
      "name": "Karnes Co",
      "city": "Kenedy",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 28.900083,
      "longitude": -98.005833,
      "elevationFeet": 289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2R9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2R9?codeType=fs"
     },
     {
      "fs": "2RR",
      "iata": "",
      "icao": "",
      "faa": "2RR",
      "name": "River Ranch Resort",
      "city": "River Ranch",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 27.9225,
      "longitude": -81.253472,
      "elevationFeet": 55,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2RR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2RR?codeType=fs"
     },
     {
      "fs": "2S0",
      "iata": "",
      "icao": "",
      "faa": "2S0",
      "name": "Twisp Municipal",
      "city": "Twisp",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 48.354222,
      "longitude": -120.189694,
      "elevationFeet": 1597,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S0?codeType=fs"
     },
     {
      "fs": "2S1",
      "iata": "",
      "icao": "",
      "faa": "2S1",
      "name": "Vashon Municipal",
      "city": "Vashon",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.458599,
      "longitude": -122.473999,
      "elevationFeet": 316,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S1?codeType=fs"
     },
     {
      "fs": "2S2",
      "iata": "",
      "icao": "",
      "faa": "2S2",
      "name": "Beaver Marsh State",
      "city": "Beaver Marsh",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 43.240194,
      "longitude": -121.828,
      "elevationFeet": 4638,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S2?codeType=fs"
     },
     {
      "fs": "2S4",
      "iata": "",
      "icao": "",
      "faa": "2S4",
      "name": "New Warden",
      "city": "Warden",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.115306,
      "longitude": -119.077861,
      "elevationFeet": 1265,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S4?codeType=fs"
     },
     {
      "fs": "2S5",
      "iata": "",
      "icao": "",
      "faa": "2S5",
      "name": "Waterville",
      "city": "Waterville",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.690278,
      "longitude": -120.103333,
      "elevationFeet": 2640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S5?codeType=fs"
     },
     {
      "fs": "2S6",
      "iata": "",
      "icao": "",
      "faa": "2S6",
      "name": "Sportsman",
      "city": "Newberg",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.406722,
      "longitude": -123.003778,
      "elevationFeet": 178,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S6?codeType=fs"
     },
     {
      "fs": "2S8",
      "iata": "",
      "icao": "",
      "faa": "2S8",
      "name": "Wilbur",
      "city": "Wilbur",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.782056,
      "longitude": -118.838944,
      "elevationFeet": 2178,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S8?codeType=fs"
     },
     {
      "fs": "2S9",
      "iata": "",
      "icao": "",
      "faa": "2S9",
      "name": "Willapa Harbor",
      "city": "South Bend-Raymond",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.806556,
      "longitude": -123.871083,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2S9?codeType=fs"
     },
     {
      "fs": "2T1",
      "iata": "",
      "icao": "",
      "faa": "2T1",
      "name": "Muleshoe Municipal",
      "city": "Muleshoe",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.201361,
      "longitude": -102.710972,
      "elevationFeet": 3779,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2T1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2T1?codeType=fs"
     },
     {
      "fs": "2T4",
      "iata": "",
      "icao": "",
      "faa": "2T4",
      "name": "Hayesport",
      "city": "Collinsville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.634444,
      "longitude": -97.052833,
      "elevationFeet": 733,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2T4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2T4?codeType=fs"
     },
     {
      "fs": "2T5",
      "iata": "",
      "icao": "",
      "faa": "2T5",
      "name": "Hahn Sky Ranch",
      "city": "West Bend",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.613861,
      "longitude": -88.359306,
      "elevationFeet": 1090,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2T5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2T5?codeType=fs"
     },
     {
      "fs": "2TA8",
      "iata": "",
      "icao": "",
      "faa": "2TA8",
      "name": "El Coyote Ranch",
      "city": "Encino",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 26.942417,
      "longitude": -98.27175,
      "elevationFeet": 196,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2TA8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2TA8?codeType=fs"
     },
     {
      "fs": "2U0",
      "iata": "",
      "icao": "",
      "faa": "2U0",
      "name": "Smith Prairie",
      "city": "Prairie",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.635056,
      "longitude": -115.681472,
      "elevationFeet": 4958,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2U0?codeType=fs"
     },
     {
      "fs": "2U4",
      "iata": "",
      "icao": "",
      "faa": "2U4",
      "name": "Rockford Municipal",
      "city": "Rockford",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 43.251917,
      "longitude": -112.669278,
      "elevationFeet": 4465,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2U4?codeType=fs"
     },
     {
      "fs": "2U5",
      "iata": "",
      "icao": "",
      "faa": "2U5",
      "name": "Shearer Usfs",
      "city": "Shearer",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.065833,
      "longitude": -114.909389,
      "elevationFeet": 2634,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2U5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2U5?codeType=fs"
     },
     {
      "fs": "2U7",
      "iata": "",
      "icao": "",
      "faa": "2U7",
      "name": "Stanley",
      "city": "Stanley",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 44.285194,
      "longitude": -114.945278,
      "elevationFeet": 6403,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2U7?codeType=fs"
     },
     {
      "fs": "2U8",
      "iata": "",
      "icao": "",
      "faa": "2U8",
      "name": "Thomas Creek",
      "city": "Stanley",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 44.812972,
      "longitude": -115.034306,
      "elevationFeet": 4400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2U8?codeType=fs"
     },
     {
      "fs": "2V2",
      "iata": "",
      "icao": "",
      "faa": "2V2",
      "name": "Brand",
      "city": "Longmont",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.286722,
      "longitude": -105.280361,
      "elevationFeet": 5052,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2V2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2V2?codeType=fs"
     },
     {
      "fs": "2V3",
      "iata": "",
      "icao": "",
      "faa": "2V3",
      "name": "Hartenbower Hectares",
      "city": "Lostant",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 41.294806,
      "longitude": -89.278611,
      "elevationFeet": 733,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2V3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2V3?codeType=fs"
     },
     {
      "fs": "2V5",
      "iata": "",
      "icao": "",
      "faa": "2V5",
      "name": "Wray Municipal",
      "city": "Wray",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.103222,
      "longitude": -102.309611,
      "elevationFeet": 3667,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2V5?codeType=fs"
     },
     {
      "fs": "2V6",
      "iata": "",
      "icao": "",
      "faa": "2V6",
      "name": "Yuma Municipal",
      "city": "Yuma",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.141528,
      "longitude": -102.829861,
      "elevationFeet": 4136,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2V6?codeType=fs"
     },
     {
      "fs": "2V8",
      "iata": "",
      "icao": "",
      "faa": "2V8",
      "name": "Melon",
      "city": "Rocky Ford",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 38.152861,
      "longitude": -103.841167,
      "elevationFeet": 4260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2V8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2V8?codeType=fs"
     },
     {
      "fs": "2W1",
      "iata": "",
      "icao": "",
      "faa": "2W1",
      "name": "De Vere Field",
      "city": "Cle Elum",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.178106,
      "longitude": -120.851849,
      "elevationFeet": 1840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2W1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2W1?codeType=fs"
     },
     {
      "fs": "2W2",
      "iata": "",
      "icao": "",
      "faa": "2W2",
      "name": "Clearview Airpark",
      "city": "Westminster",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.46693,
      "longitude": -77.017115,
      "elevationFeet": 782,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2W2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2W2?codeType=fs"
     },
     {
      "fs": "2W3",
      "iata": "",
      "icao": "",
      "faa": "2W3",
      "name": "Swanson",
      "city": "Eatonville",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.917694,
      "longitude": -122.323361,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2W3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2W3?codeType=fs"
     },
     {
      "fs": "2W5",
      "iata": "",
      "icao": "",
      "faa": "2W5",
      "name": "Maryland",
      "city": "Indian Head",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 38.605361,
      "longitude": -77.129694,
      "elevationFeet": 170,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2W5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2W5?codeType=fs"
     },
     {
      "fs": "2W8",
      "iata": "",
      "icao": "",
      "faa": "2W8",
      "name": "Atwood Lodge",
      "city": "Dellroy",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.672861,
      "longitude": -81.281611,
      "elevationFeet": 1108,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2W8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2W8?codeType=fs"
     },
     {
      "fs": "2Y0",
      "iata": "",
      "icao": "",
      "faa": "2Y0",
      "name": "Primghar",
      "city": "Primghar",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.233111,
      "longitude": -95.727861,
      "elevationFeet": 1481,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Y0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Y0?codeType=fs"
     },
     {
      "fs": "2Y1",
      "iata": "",
      "icao": "",
      "faa": "2Y1",
      "name": "Drake",
      "city": "Radcliffe",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 42.4665,
      "longitude": -93.41875,
      "elevationFeet": 1179,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Y1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Y1?codeType=fs"
     },
     {
      "fs": "2Y2",
      "iata": "",
      "icao": "",
      "faa": "2Y2",
      "name": "Hawarden Municipal",
      "city": "Hawarden",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 43.069306,
      "longitude": -96.580889,
      "elevationFeet": 1190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Y2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Y2?codeType=fs"
     },
     {
      "fs": "2Y4",
      "iata": "",
      "icao": "",
      "faa": "2Y4",
      "name": "Rockwell City Municipal",
      "city": "Rockwell City",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 42.424806,
      "longitude": -94.630333,
      "elevationFeet": 1217,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Y4?codeType=fs"
     },
     {
      "fs": "2Z2",
      "iata": "",
      "icao": "",
      "faa": "2Z2",
      "name": "Eureka Creek",
      "city": "Eureka Creek",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.680",
      "utcOffsetHours": -9,
      "latitude": 65.259111,
      "longitude": -150.255389,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/2Z2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/2Z2?codeType=fs"
     },
     {
      "fs": "30A",
      "iata": "",
      "icao": "",
      "faa": "30A",
      "name": "Meadow Lake",
      "city": "Kingston",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.886861,
      "longitude": -84.588222,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/30A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/30A?codeType=fs"
     },
     {
      "fs": "30F",
      "iata": "",
      "icao": "",
      "faa": "30F",
      "name": "Lakeview",
      "city": "Lake Dallas",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.270639,
      "longitude": -97.14175,
      "elevationFeet": 535,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/30F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/30F?codeType=fs"
     },
     {
      "fs": "30K",
      "iata": "",
      "icao": "",
      "faa": "30K",
      "name": "Ingalls Municipal",
      "city": "Ingalls",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.969667,
      "longitude": -100.662611,
      "elevationFeet": 2814,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/30K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/30K?codeType=fs"
     },
     {
      "fs": "30M",
      "iata": "",
      "icao": "",
      "faa": "30M",
      "name": "Tunica",
      "city": "Tunica",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.667694,
      "longitude": -90.367667,
      "elevationFeet": 195,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/30M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/30M?codeType=fs"
     },
     {
      "fs": "31A",
      "iata": "",
      "icao": "",
      "faa": "31A",
      "name": "Sugar Valley",
      "city": "Mocksville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.004139,
      "longitude": -80.611694,
      "elevationFeet": 731,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/31A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/31A?codeType=fs"
     },
     {
      "fs": "31D",
      "iata": "",
      "icao": "",
      "faa": "31D",
      "name": "Inter Co",
      "city": "Irwin",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.334028,
      "longitude": -79.892111,
      "elevationFeet": 1250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/31D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/31D?codeType=fs"
     },
     {
      "fs": "31E",
      "iata": "",
      "icao": "",
      "faa": "31E",
      "name": "Eagles Nest",
      "city": "West Creek",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.665401,
      "longitude": -74.307899,
      "elevationFeet": 35,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/31E?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/31E?codeType=fs"
     },
     {
      "fs": "31F",
      "iata": "",
      "icao": "",
      "faa": "31F",
      "name": "Gaines Co",
      "city": "Seminole",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.753528,
      "longitude": -102.676861,
      "elevationFeet": 3315,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/31F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/31F?codeType=fs"
     },
     {
      "fs": "31M",
      "iata": "",
      "icao": "",
      "faa": "31M",
      "name": "Union Municipal",
      "city": "Union",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.706944,
      "longitude": -89.161694,
      "elevationFeet": 512,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/31M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/31M?codeType=fs"
     },
     {
      "fs": "32A",
      "iata": "",
      "icao": "",
      "faa": "32A",
      "name": "Danville Municipal",
      "city": "Danville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 35.123111,
      "longitude": -93.537972,
      "elevationFeet": 389,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/32A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/32A?codeType=fs"
     },
     {
      "fs": "32M",
      "iata": "",
      "icao": "",
      "faa": "32M",
      "name": "Norfolk Airport",
      "city": "Norfolk",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.12788,
      "longitude": -71.37034,
      "elevationFeet": 137,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/32M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/32M?codeType=fs"
     },
     {
      "fs": "32S",
      "iata": "",
      "icao": "",
      "faa": "32S",
      "name": "Stevensville",
      "city": "Stevensville",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 46.601111,
      "longitude": -114.078056,
      "elevationFeet": 3610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/32S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/32S?codeType=fs"
     },
     {
      "fs": "33A",
      "iata": "",
      "icao": "",
      "faa": "33A",
      "name": "Fairview",
      "city": "Landrum",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 35.223389,
      "longitude": -82.173333,
      "elevationFeet": 1047,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33A?codeType=fs"
     },
     {
      "fs": "33C",
      "iata": "",
      "icao": "",
      "faa": "33C",
      "name": "Jablonski Airport",
      "city": "Nunica",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.082548,
      "longitude": -86.094619,
      "elevationFeet": 628,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33C?codeType=fs"
     },
     {
      "fs": "33J",
      "iata": "",
      "icao": "",
      "faa": "33J",
      "name": "Geneva Municipal",
      "city": "Geneva",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.102778,
      "longitude": -86.003111,
      "elevationFeet": 101,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33J?codeType=fs"
     },
     {
      "fs": "33K",
      "iata": "",
      "icao": "",
      "faa": "33K",
      "name": "Kinsley Municipal",
      "city": "Kinsley",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.99,
      "longitude": -99.431111,
      "elevationFeet": 2171,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33K?codeType=fs"
     },
     {
      "fs": "33M",
      "iata": "",
      "icao": "",
      "faa": "33M",
      "name": "Water Valley Municipal",
      "city": "Water Valley",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.167778,
      "longitude": -89.711972,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33M?codeType=fs"
     },
     {
      "fs": "33R",
      "iata": "",
      "icao": "",
      "faa": "33R",
      "name": "Trinity Co",
      "city": "Groveton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.099056,
      "longitude": -95.291028,
      "elevationFeet": 340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33R?codeType=fs"
     },
     {
      "fs": "33S",
      "iata": "",
      "icao": "",
      "faa": "33S",
      "name": "Pru",
      "city": "Ritzville",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.198722,
      "longitude": -118.477528,
      "elevationFeet": 1796,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33S?codeType=fs"
     },
     {
      "fs": "33U",
      "iata": "",
      "icao": "",
      "faa": "33U",
      "name": "Dutch John",
      "city": "Dutch John",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.927361,
      "longitude": -109.456917,
      "elevationFeet": 6561,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33U?codeType=fs"
     },
     {
      "fs": "33V",
      "iata": "",
      "icao": "",
      "faa": "33V",
      "name": "Walden-Jackson Co",
      "city": "Walden",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 40.899778,
      "longitude": -106.314139,
      "elevationFeet": 8149,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/33V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/33V?codeType=fs"
     },
     {
      "fs": "34A",
      "iata": "",
      "icao": "",
      "faa": "34A",
      "name": "Laurens Co",
      "city": "Laurens",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.570556,
      "longitude": -82.071944,
      "elevationFeet": 697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/34A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/34A?codeType=fs"
     },
     {
      "fs": "34G",
      "iata": "",
      "icao": "",
      "faa": "34G",
      "name": "Merillat",
      "city": "Tecumseh",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.050444,
      "longitude": -84.002194,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/34G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/34G?codeType=fs"
     },
     {
      "fs": "34I",
      "iata": "",
      "icao": "",
      "faa": "34I",
      "name": "Somerville",
      "city": "Ada",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.016972,
      "longitude": -85.514111,
      "elevationFeet": 660,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/34I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/34I?codeType=fs"
     },
     {
      "fs": "34M",
      "iata": "",
      "icao": "",
      "faa": "34M",
      "name": "Campbell Municipal",
      "city": "Campbell",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.511722,
      "longitude": -90.08425,
      "elevationFeet": 284,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/34M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/34M?codeType=fs"
     },
     {
      "fs": "34R",
      "iata": "",
      "icao": "",
      "faa": "34R",
      "name": "Hallettsville Municipal",
      "city": "Hallettsville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.453972,
      "longitude": -97.008167,
      "elevationFeet": 276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/34R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/34R?codeType=fs"
     },
     {
      "fs": "34U",
      "iata": "",
      "icao": "",
      "faa": "34U",
      "name": "Yuba",
      "city": "Elk Rapids",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.888917,
      "longitude": -85.561806,
      "elevationFeet": 645,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/34U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/34U?codeType=fs"
     },
     {
      "fs": "35A",
      "iata": "",
      "icao": "",
      "faa": "35A",
      "name": "Union Co-Shelton",
      "city": "Union",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 34.718,
      "longitude": -81.712111,
      "elevationFeet": 608,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/35A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/35A?codeType=fs"
     },
     {
      "fs": "35C",
      "iata": "",
      "icao": "",
      "faa": "35C",
      "name": "Wells",
      "city": "Rockford",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.233611,
      "longitude": -85.553083,
      "elevationFeet": 890,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/35C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/35C?codeType=fs"
     },
     {
      "fs": "35D",
      "iata": "",
      "icao": "",
      "faa": "35D",
      "name": "Padgham",
      "city": "Allegan",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.659833,
      "longitude": -85.901361,
      "elevationFeet": 708,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/35D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/35D?codeType=fs"
     },
     {
      "fs": "35G",
      "iata": "",
      "icao": "",
      "faa": "35G",
      "name": "Midway",
      "city": "Albion",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.353194,
      "longitude": -84.869194,
      "elevationFeet": 963,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/35G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/35G?codeType=fs"
     },
     {
      "fs": "35L",
      "iata": "",
      "icao": "",
      "faa": "35L",
      "name": "Carriage Lane",
      "city": "Gregory",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.594806,
      "longitude": -84.0495,
      "elevationFeet": 920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/35L?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/35L?codeType=fs"
     },
     {
      "fs": "35S",
      "iata": "",
      "icao": "",
      "faa": "35S",
      "name": "Wasco State",
      "city": "Wasco",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 45.645,
      "longitude": -120.741667,
      "elevationFeet": 1503,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/35S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/35S?codeType=fs"
     },
     {
      "fs": "36K",
      "iata": "",
      "icao": "",
      "faa": "36K",
      "name": "Lakin",
      "city": "Lakin",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 37.994639,
      "longitude": -101.304472,
      "elevationFeet": 3077,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/36K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/36K?codeType=fs"
     },
     {
      "fs": "36S",
      "iata": "",
      "icao": "",
      "faa": "36S",
      "name": "Happy Camp",
      "city": "Happy Camp",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 41.856806,
      "longitude": -123.439444,
      "elevationFeet": 1209,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/36S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/36S?codeType=fs"
     },
     {
      "fs": "37F",
      "iata": "",
      "icao": "",
      "faa": "37F",
      "name": "Munday Mun",
      "city": "Munday",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.498167,
      "longitude": -99.611972,
      "elevationFeet": 1473,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/37F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/37F?codeType=fs"
     },
     {
      "fs": "37I",
      "iata": "",
      "icao": "",
      "faa": "37I",
      "name": "Troy",
      "city": "Troy",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.058861,
      "longitude": -84.305,
      "elevationFeet": 930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/37I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/37I?codeType=fs"
     },
     {
      "fs": "37K",
      "iata": "",
      "icao": "",
      "faa": "37K",
      "name": "Falconhead",
      "city": "Burneyville",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 34.001,
      "longitude": -97.425167,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/37K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/37K?codeType=fs"
     },
     {
      "fs": "37M",
      "iata": "",
      "icao": "",
      "faa": "37M",
      "name": "Hornersville Memorial",
      "city": "Hornersville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.117361,
      "longitude": -90.150944,
      "elevationFeet": 248,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/37M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/37M?codeType=fs"
     },
     {
      "fs": "37N",
      "iata": "",
      "icao": "",
      "faa": "37N",
      "name": "Garrison Dam Recreational",
      "city": "Riverdale",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 47.630556,
      "longitude": -101.487722,
      "elevationFeet": 1723,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/37N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/37N?codeType=fs"
     },
     {
      "fs": "37T",
      "iata": "",
      "icao": "",
      "faa": "37T",
      "name": "Calico Rock-Izard Co",
      "city": "Calico Rock",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 36.306528,
      "longitude": -92.252361,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/37T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/37T?codeType=fs"
     },
     {
      "fs": "38B",
      "iata": "",
      "icao": "",
      "faa": "38B",
      "name": "Ring Hill",
      "city": "Carmel",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.875694,
      "longitude": -69.103222,
      "elevationFeet": 340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38B?codeType=fs"
     },
     {
      "fs": "38C",
      "iata": "",
      "icao": "",
      "faa": "38C",
      "name": "Cain",
      "city": "Stanwood",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.60025,
      "longitude": -85.581,
      "elevationFeet": 889,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38C?codeType=fs"
     },
     {
      "fs": "38D",
      "iata": "",
      "icao": "",
      "faa": "38D",
      "name": "Salem",
      "city": "Salem",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.082222,
      "longitude": -80.976944,
      "elevationFeet": 1162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38D?codeType=fs"
     },
     {
      "fs": "38I",
      "iata": "",
      "icao": "",
      "faa": "38I",
      "name": "Weller",
      "city": "Urbana",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.161694,
      "longitude": -83.743722,
      "elevationFeet": 1150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38I?codeType=fs"
     },
     {
      "fs": "38J",
      "iata": "",
      "icao": "",
      "faa": "38J",
      "name": "Hemingway Stuckey",
      "city": "Hemingway",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 33.836389,
      "longitude": -79.659778,
      "elevationFeet": 54,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38J?codeType=fs"
     },
     {
      "fs": "38K",
      "iata": "",
      "icao": "",
      "faa": "38K",
      "name": "Lucas",
      "city": "Lucas",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 39.169556,
      "longitude": -98.603444,
      "elevationFeet": 1485,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38K?codeType=fs"
     },
     {
      "fs": "38N",
      "iata": "",
      "icao": "",
      "faa": "38N",
      "name": "Smyrna",
      "city": "Smyrna",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 39.301111,
      "longitude": -75.6215,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38N?codeType=fs"
     },
     {
      "fs": "38U",
      "iata": "",
      "icao": "",
      "faa": "38U",
      "name": "Wayne Wonderland",
      "city": "Loa",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 38.474806,
      "longitude": -111.710167,
      "elevationFeet": 7023,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38U?codeType=fs"
     },
     {
      "fs": "38V",
      "iata": "",
      "icao": "",
      "faa": "38V",
      "name": "Arthur Municipal",
      "city": "Arthur",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.680",
      "utcOffsetHours": -7,
      "latitude": 41.666667,
      "longitude": -101.813889,
      "elevationFeet": 3646,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38V?codeType=fs"
     },
     {
      "fs": "38W",
      "iata": "",
      "icao": "",
      "faa": "38W",
      "name": "Lynden",
      "city": "Lynden",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 48.955898,
      "longitude": -122.458,
      "elevationFeet": 106,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/38W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/38W?codeType=fs"
     },
     {
      "fs": "39G",
      "iata": "",
      "icao": "",
      "faa": "39G",
      "name": "Rasor",
      "city": "Avoca",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.150278,
      "longitude": -82.693694,
      "elevationFeet": 726,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/39G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/39G?codeType=fs"
     },
     {
      "fs": "39K",
      "iata": "",
      "icao": "",
      "faa": "39K",
      "name": "Pomona Lake",
      "city": "Lyndon",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 38.769528,
      "longitude": -95.749833,
      "elevationFeet": 1050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/39K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/39K?codeType=fs"
     },
     {
      "fs": "39P",
      "iata": "",
      "icao": "",
      "faa": "39P",
      "name": "Strom",
      "city": "Morton",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 46.553861,
      "longitude": -122.414917,
      "elevationFeet": 950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/39P?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/39P?codeType=fs"
     },
     {
      "fs": "39R",
      "iata": "",
      "icao": "",
      "faa": "39R",
      "name": "Flyin' B Airport",
      "city": "Houston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 29.537303,
      "longitude": -95.42335,
      "elevationFeet": 66,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/39R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/39R?codeType=fs"
     },
     {
      "fs": "39T",
      "iata": "",
      "icao": "",
      "faa": "39T",
      "name": "Tripp Creek",
      "city": "St Johns",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.197528,
      "longitude": -84.541528,
      "elevationFeet": 717,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/39T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/39T?codeType=fs"
     },
     {
      "fs": "39Z",
      "iata": "",
      "icao": "",
      "faa": "39Z",
      "name": "Flying-A-Ranch",
      "city": "Fruitport",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.150194,
      "longitude": -86.186639,
      "elevationFeet": 630,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/39Z?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/39Z?codeType=fs"
     },
     {
      "fs": "3A0",
      "iata": "",
      "icao": "",
      "faa": "3A0",
      "name": "Grove Hill Municipal",
      "city": "Grove Hill",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 31.74325,
      "longitude": -87.863889,
      "elevationFeet": 478,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A0?codeType=fs"
     },
     {
      "fs": "3A2",
      "iata": "",
      "icao": "",
      "faa": "3A2",
      "name": "New Tazewell Municipal",
      "city": "Tazewell",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.500833,
      "longitude": -83.604611,
      "elevationFeet": 1179,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A2?codeType=fs"
     },
     {
      "fs": "3A4",
      "iata": "",
      "icao": "",
      "faa": "3A4",
      "name": "Southeast Greensboro",
      "city": "Greensboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 36.019806,
      "longitude": -79.705222,
      "elevationFeet": 737,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A4?codeType=fs"
     },
     {
      "fs": "3A7",
      "iata": "",
      "icao": "",
      "faa": "3A7",
      "name": "Eutaw Municipal",
      "city": "Eutaw",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 32.859639,
      "longitude": -87.975139,
      "elevationFeet": 170,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A7?codeType=fs"
     },
     {
      "fs": "3A8",
      "iata": "",
      "icao": "",
      "faa": "3A8",
      "name": "Stinson",
      "city": "Aberdeen",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 33.86225,
      "longitude": -88.625444,
      "elevationFeet": 265,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A8?codeType=fs"
     },
     {
      "fs": "3A9",
      "iata": "",
      "icao": "",
      "faa": "3A9",
      "name": "Arlington Municipal",
      "city": "Arlington",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 44.494139,
      "longitude": -97.181222,
      "elevationFeet": 1818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3A9?codeType=fs"
     },
     {
      "fs": "3AE",
      "iata": "",
      "icao": "",
      "faa": "3AE",
      "name": "Ace",
      "city": "Anderson",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 40.15875,
      "longitude": -85.816417,
      "elevationFeet": 910,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3AE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3AE?codeType=fs"
     },
     {
      "fs": "3AK",
      "iata": "",
      "icao": "",
      "faa": "3AK",
      "name": "Paf Cannery",
      "city": "South Naknek",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.680",
      "utcOffsetHours": -9,
      "latitude": 58.82325,
      "longitude": -157.007528,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3AK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3AK?codeType=fs"
     },
     {
      "fs": "3AU",
      "iata": "",
      "icao": "",
      "faa": "3AU",
      "name": "Augusta Municipal",
      "city": "Augusta",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 37.716278,
      "longitude": -97.178722,
      "elevationFeet": 1328,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3AU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3AU?codeType=fs"
     },
     {
      "fs": "3B0",
      "iata": "",
      "icao": "",
      "faa": "3B0",
      "name": "Southbridge Municipal",
      "city": "Southbridge",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.109278,
      "longitude": -72.084083,
      "elevationFeet": 697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B0?codeType=fs"
     },
     {
      "fs": "3B1",
      "iata": "",
      "icao": "",
      "faa": "3B1",
      "name": "Greenville Municipal",
      "city": "Greenville",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 45.580278,
      "longitude": -69.566111,
      "elevationFeet": 1401,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B1?codeType=fs"
     },
     {
      "fs": "3B2",
      "iata": "",
      "icao": "",
      "faa": "3B2",
      "name": "Marshfield",
      "city": "Marshfield",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.232417,
      "longitude": -70.721222,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B2?codeType=fs"
     },
     {
      "fs": "3B3",
      "iata": "",
      "icao": "",
      "faa": "3B3",
      "name": "Sterling",
      "city": "Sterling",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 42.500917,
      "longitude": -71.861833,
      "elevationFeet": 459,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B3?codeType=fs"
     },
     {
      "fs": "3B4",
      "iata": "",
      "icao": "",
      "faa": "3B4",
      "name": "Littlebrook",
      "city": "Eliot",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.231944,
      "longitude": -70.836111,
      "elevationFeet": 130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B4?codeType=fs"
     },
     {
      "fs": "3B5",
      "iata": "",
      "icao": "",
      "faa": "3B5",
      "name": "Twitchell",
      "city": "Turner",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.225722,
      "longitude": -70.378333,
      "elevationFeet": 356,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B5?codeType=fs"
     },
     {
      "fs": "3B8",
      "iata": "",
      "icao": "",
      "faa": "3B8",
      "name": "Shady Acres",
      "city": "Spanaway",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.680",
      "utcOffsetHours": -8,
      "latitude": 47.103889,
      "longitude": -122.410833,
      "elevationFeet": 445,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B8?codeType=fs"
     },
     {
      "fs": "3B9",
      "iata": "",
      "icao": "",
      "faa": "3B9",
      "name": "Chester",
      "city": "Chester",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.389056,
      "longitude": -72.558944,
      "elevationFeet": 416,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3B9?codeType=fs"
     },
     {
      "fs": "3BS",
      "iata": "",
      "icao": "",
      "faa": "3BS",
      "name": "Barstow",
      "city": "Midland",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.779167,
      "longitude": -84.36325,
      "elevationFeet": 636,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3BS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3BS?codeType=fs"
     },
     {
      "fs": "3C1",
      "iata": "",
      "icao": "",
      "faa": "3C1",
      "name": "Mishawaka Pilots Club",
      "city": "Elkhart",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.719944,
      "longitude": -86.04725,
      "elevationFeet": 755,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3C1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3C1?codeType=fs"
     },
     {
      "fs": "3C2",
      "iata": "",
      "icao": "",
      "faa": "3C2",
      "name": "Shenk",
      "city": "Garrett",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.369944,
      "longitude": -85.291389,
      "elevationFeet": 864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3C2?codeType=fs"
     },
     {
      "fs": "3C5",
      "iata": "",
      "icao": "",
      "faa": "3C5",
      "name": "Wheeler",
      "city": "Knox",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 41.247639,
      "longitude": -86.669556,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3C5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3C5?codeType=fs"
     },
     {
      "fs": "3CK",
      "iata": "",
      "icao": "",
      "faa": "3CK",
      "name": "Lake In The Hills",
      "city": "Lake In The Hills",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 42.268028,
      "longitude": -88.380417,
      "elevationFeet": 888,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3CK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3CK?codeType=fs"
     },
     {
      "fs": "3CM",
      "iata": "",
      "icao": "",
      "faa": "3CM",
      "name": "Clements Municipal",
      "city": "Bay City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 43.669167,
      "longitude": -84.005028,
      "elevationFeet": 586,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3CM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3CM?codeType=fs"
     },
     {
      "fs": "3CU",
      "iata": "",
      "icao": "",
      "faa": "3CU",
      "name": "Cable Union",
      "city": "Cable",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 46.2925,
      "longitude": -91.364111,
      "elevationFeet": 1360,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3CU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3CU?codeType=fs"
     },
     {
      "fs": "3D1",
      "iata": "",
      "icao": "",
      "faa": "3D1",
      "name": "Crivitz Municipal",
      "city": "Crivitz",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.344194,
      "longitude": -88.126056,
      "elevationFeet": 731,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3D1?codeType=fs"
     },
     {
      "fs": "3D2",
      "iata": "",
      "icao": "",
      "faa": "3D2",
      "name": "Ephraim Fish Creek",
      "city": "Ephraim",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.680",
      "utcOffsetHours": -6,
      "latitude": 45.153583,
      "longitude": -87.208667,
      "elevationFeet": 773,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3D2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3D2?codeType=fs"
     },
     {
      "fs": "3D4",
      "iata": "",
      "icao": "",
      "faa": "3D4",
      "name": "Frankfort Dow Memorial",
      "city": "Frankfort",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 44.700444,
      "longitude": -86.206667,
      "elevationFeet": 632,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3D4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3D4?codeType=fs"
     },
     {
      "fs": "3D8",
      "iata": "",
      "icao": "",
      "faa": "3D8",
      "name": "Bordner",
      "city": "Bowling Green",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.680",
      "utcOffsetHours": -5,
      "latitude": 41.361639,
      "longitude": -83.774361,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3D8?codeType=fs"
     },
     {
      "fs": "3DA",
      "iata": "",
      "icao": "",
      "faa": "3DA",
      "name": "Dalton",
      "city": "Flushing",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.119722,
      "longitude": -83.869056,
      "elevationFeet": 733,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3DA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3DA?codeType=fs"
     },
     {
      "fs": "3DW",
      "iata": "",
      "icao": "",
      "faa": "3DW",
      "name": "Downtown",
      "city": "Springfield",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 37.267139,
      "longitude": -93.376861,
      "elevationFeet": 1374,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3DW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3DW?codeType=fs"
     },
     {
      "fs": "3E0",
      "iata": "",
      "icao": "",
      "faa": "3E0",
      "name": "Miami-Roberts Co",
      "city": "Miami",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.839333,
      "longitude": -100.631917,
      "elevationFeet": 2720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3E0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3E0?codeType=fs"
     },
     {
      "fs": "3E7",
      "iata": "",
      "icao": "",
      "faa": "3E7",
      "name": "Pronger Bros Ranch",
      "city": "Stratford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.24475,
      "longitude": -102.140667,
      "elevationFeet": 3722,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3E7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3E7?codeType=fs"
     },
     {
      "fs": "3EV",
      "iata": "",
      "icao": "",
      "faa": "3EV",
      "name": "Skylane",
      "city": "Evansville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.017083,
      "longitude": -87.666833,
      "elevationFeet": 380,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3EV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3EV?codeType=fs"
     },
     {
      "fs": "3EX",
      "iata": "",
      "icao": "",
      "faa": "3EX",
      "name": "Excelsior Springs Memorial Airport",
      "city": "Excelsior Springs",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.337006,
      "longitude": -94.197826,
      "elevationFeet": 998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3EX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3EX?codeType=fs"
     },
     {
      "fs": "3F2",
      "iata": "",
      "icao": "",
      "faa": "3F2",
      "name": "Cisco Municipal",
      "city": "Cisco",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.417972,
      "longitude": -99.003444,
      "elevationFeet": 1612,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F2?codeType=fs"
     },
     {
      "fs": "3F3",
      "iata": "",
      "icao": "",
      "faa": "3F3",
      "name": "De Soto Parish",
      "city": "Mansfield",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.134694,
      "longitude": -93.905167,
      "elevationFeet": 324,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F3?codeType=fs"
     },
     {
      "fs": "3F4",
      "iata": "",
      "icao": "",
      "faa": "3F4",
      "name": "Vivian",
      "city": "Vivian",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.963333,
      "longitude": -94.101528,
      "elevationFeet": 260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F4?codeType=fs"
     },
     {
      "fs": "3F5",
      "iata": "",
      "icao": "",
      "faa": "3F5",
      "name": "Forest Hill",
      "city": "Westphalia",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.022556,
      "longitude": -84.755444,
      "elevationFeet": 775,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F5?codeType=fs"
     },
     {
      "fs": "3F6",
      "iata": "",
      "icao": "",
      "faa": "3F6",
      "name": "Richards Municipal",
      "city": "Paducah",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.126333,
      "longitude": -100.420028,
      "elevationFeet": 1860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F6?codeType=fs"
     },
     {
      "fs": "3F7",
      "iata": "",
      "icao": "",
      "faa": "3F7",
      "name": "Jones Memorial",
      "city": "Bristow",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.868528,
      "longitude": -96.468556,
      "elevationFeet": 851,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F7?codeType=fs"
     },
     {
      "fs": "3F9",
      "iata": "",
      "icao": "",
      "faa": "3F9",
      "name": "Mineola Wisener",
      "city": "Mineola",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.766944,
      "longitude": -95.608056,
      "elevationFeet": 429,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3F9?codeType=fs"
     },
     {
      "fs": "3FD1",
      "iata": "",
      "icao": "",
      "faa": "3FD1",
      "name": "Tampa Bay Executive Airport",
      "city": "New Port Richey",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 28.189112,
      "longitude": -82.620828,
      "elevationFeet": 39,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3FD1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3FD1?codeType=fs"
     },
     {
      "fs": "3FK",
      "iata": "",
      "icao": "",
      "faa": "3FK",
      "name": "Franklin Flying Field",
      "city": "Franklin",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.514389,
      "longitude": -86.133222,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3FK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3FK?codeType=fs"
     },
     {
      "fs": "3FM",
      "iata": "",
      "icao": "",
      "faa": "3FM",
      "name": "Fremont Municipal",
      "city": "Fremont",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.489056,
      "longitude": -86.097806,
      "elevationFeet": 772,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3FM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3FM?codeType=fs"
     },
     {
      "fs": "3FU",
      "iata": "",
      "icao": "",
      "faa": "3FU",
      "name": "Faulkton Municipal",
      "city": "Faulkton",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.169194,
      "longitude": -99.256639,
      "elevationFeet": 1569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3FU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3FU?codeType=fs"
     },
     {
      "fs": "3G1",
      "iata": "",
      "icao": "",
      "faa": "3G1",
      "name": "Erie Co",
      "city": "Wattsburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.145,
      "longitude": -79.889389,
      "elevationFeet": 1450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G1?codeType=fs"
     },
     {
      "fs": "3G2",
      "iata": "",
      "icao": "",
      "faa": "3G2",
      "name": "Grygla Mun-Wilkens",
      "city": "Grygla",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 48.416667,
      "longitude": -95.722222,
      "elevationFeet": 1177,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G2?codeType=fs"
     },
     {
      "fs": "3G3",
      "iata": "",
      "icao": "",
      "faa": "3G3",
      "name": "Wadsworth Municipal Airport",
      "city": "Wadsworth",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.003325,
      "longitude": -81.75017,
      "elevationFeet": 993,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G3?codeType=fs"
     },
     {
      "fs": "3G4",
      "iata": "",
      "icao": "",
      "faa": "3G4",
      "name": "Ashland Co",
      "city": "Ashland",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.929722,
      "longitude": -82.306389,
      "elevationFeet": 1206,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G4?codeType=fs"
     },
     {
      "fs": "3G5",
      "iata": "",
      "icao": "",
      "faa": "3G5",
      "name": "Dawson Aaf",
      "city": "Camp Dawson",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.539806,
      "longitude": -79.745,
      "elevationFeet": 1265,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G5?codeType=fs"
     },
     {
      "fs": "3G6",
      "iata": "",
      "icao": "",
      "faa": "3G6",
      "name": "Tri-City",
      "city": "Sebring",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.96,
      "longitude": -81.000278,
      "elevationFeet": 1188,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G6?codeType=fs"
     },
     {
      "fs": "3G7",
      "iata": "",
      "icao": "",
      "faa": "3G7",
      "name": "Williamson-Sodus",
      "city": "Williamson-Sodus",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.247861,
      "longitude": -77.159167,
      "elevationFeet": 425,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G7?codeType=fs"
     },
     {
      "fs": "3G8",
      "iata": "",
      "icao": "",
      "faa": "3G8",
      "name": "Gen-Air Park",
      "city": "Geneseo",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.497556,
      "longitude": -90.201167,
      "elevationFeet": 645,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G8?codeType=fs"
     },
     {
      "fs": "3G9",
      "iata": "",
      "icao": "",
      "faa": "3G9",
      "name": "Butler Farm Show",
      "city": "Butler",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.875639,
      "longitude": -80.047806,
      "elevationFeet": 1333,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3G9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3G9?codeType=fs"
     },
     {
      "fs": "3GM",
      "iata": "",
      "icao": "",
      "faa": "3GM",
      "name": "Grand Haven Memorial",
      "city": "Grand Haven",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.040472,
      "longitude": -86.331639,
      "elevationFeet": 604,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3GM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3GM?codeType=fs"
     },
     {
      "fs": "3GN",
      "iata": "",
      "icao": "",
      "faa": "3GN",
      "name": "Grundman",
      "city": "Nebraska City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.741694,
      "longitude": -95.977806,
      "elevationFeet": 1085,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3GN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3GN?codeType=fs"
     },
     {
      "fs": "3GV",
      "iata": "",
      "icao": "",
      "faa": "3GV",
      "name": "East Kansas City",
      "city": "Grain Valley",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.155611,
      "longitude": -94.332806,
      "elevationFeet": 835,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3GV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3GV?codeType=fs"
     },
     {
      "fs": "3H4",
      "iata": "",
      "icao": "",
      "faa": "3H4",
      "name": "Hillsboro Municipal",
      "city": "Hillsboro",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.443972,
      "longitude": -97.154194,
      "elevationFeet": 905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3H4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3H4?codeType=fs"
     },
     {
      "fs": "3H5",
      "iata": "",
      "icao": "",
      "faa": "3H5",
      "name": "Erie",
      "city": "Erie",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.791972,
      "longitude": -90.187306,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3H5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3H5?codeType=fs"
     },
     {
      "fs": "3HO",
      "iata": "",
      "icao": "",
      "faa": "3HO",
      "name": "Hobart-Sky Ranch",
      "city": "Hobart",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.592028,
      "longitude": -87.375361,
      "elevationFeet": 644,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3HO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3HO?codeType=fs"
     },
     {
      "fs": "3I1",
      "iata": "",
      "icao": "",
      "faa": "3I1",
      "name": "Elwood",
      "city": "Elwood",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.278167,
      "longitude": -85.983139,
      "elevationFeet": 866,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3I1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3I1?codeType=fs"
     },
     {
      "fs": "3I2",
      "iata": "",
      "icao": "",
      "faa": "3I2",
      "name": "Mason Co",
      "city": "Point Pleasant",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.046389,
      "longitude": -82.235833,
      "elevationFeet": 643,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3I2?codeType=fs"
     },
     {
      "fs": "3I3",
      "iata": "",
      "icao": "",
      "faa": "3I3",
      "name": "Sky King",
      "city": "Terre Haute",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.677861,
      "longitude": -87.473528,
      "elevationFeet": 496,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3I3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3I3?codeType=fs"
     },
     {
      "fs": "3I4",
      "iata": "",
      "icao": "",
      "faa": "3I4",
      "name": "Richwood Municipal",
      "city": "Richwood",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 38.334472,
      "longitude": -80.656472,
      "elevationFeet": 2486,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3I4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3I4?codeType=fs"
     },
     {
      "fs": "3I6",
      "iata": "",
      "icao": "",
      "faa": "3I6",
      "name": "Paintsville-Prestonsburg-Combs",
      "city": "Paintsville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 37.859306,
      "longitude": -82.8905,
      "elevationFeet": 624,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3I6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3I6?codeType=fs"
     },
     {
      "fs": "3I7",
      "iata": "",
      "icao": "",
      "faa": "3I7",
      "name": "Phillipsburg",
      "city": "Phillipsburg",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.034417,
      "longitude": -84.403083,
      "elevationFeet": 1031,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3I7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3I7?codeType=fs"
     },
     {
      "fs": "3IP",
      "iata": "",
      "icao": "",
      "faa": "3IP",
      "name": "Independence Memorial Airport",
      "city": "Independence",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.065168,
      "longitude": -94.341541,
      "elevationFeet": 756,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3IP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3IP?codeType=fs"
     },
     {
      "fs": "3J0",
      "iata": "",
      "icao": "",
      "faa": "3J0",
      "name": "Hampton-Varnville",
      "city": "Hampton",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.876667,
      "longitude": -81.231611,
      "elevationFeet": 113,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3J0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3J0?codeType=fs"
     },
     {
      "fs": "3J1",
      "iata": "",
      "icao": "",
      "faa": "3J1",
      "name": "Ridgeland",
      "city": "Ridgeland",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.576861,
      "longitude": -81.073306,
      "elevationFeet": 79,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3J1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3J1?codeType=fs"
     },
     {
      "fs": "3J6",
      "iata": "",
      "icao": "",
      "faa": "3J6",
      "name": "Davis",
      "city": "Folkston",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 30.924556,
      "longitude": -82.126167,
      "elevationFeet": 68,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3J6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3J6?codeType=fs"
     },
     {
      "fs": "3JC",
      "iata": "",
      "icao": "",
      "faa": "3JC",
      "name": "Freeman",
      "city": "Junction City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.13275,
      "longitude": -96.932861,
      "elevationFeet": 1101,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3JC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3JC?codeType=fs"
     },
     {
      "fs": "3K1",
      "iata": "",
      "icao": "",
      "faa": "3K1",
      "name": "Alva Regional",
      "city": "Alva",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.831694,
      "longitude": -98.699472,
      "elevationFeet": 1474,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3K1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3K1?codeType=fs"
     },
     {
      "fs": "3K3",
      "iata": "",
      "icao": "",
      "faa": "3K3",
      "name": "Syracuse-Hamilton Co Municipal",
      "city": "Syracuse",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 38.066806,
      "longitude": -101.862833,
      "elevationFeet": 3322,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3K3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3K3?codeType=fs"
     },
     {
      "fs": "3K4",
      "iata": "",
      "icao": "",
      "faa": "3K4",
      "name": "Hillsboro Municipal",
      "city": "Hillsboro",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.244917,
      "longitude": -89.520306,
      "elevationFeet": 637,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3K4?codeType=fs"
     },
     {
      "fs": "3K6",
      "iata": "",
      "icao": "",
      "faa": "3K6",
      "name": "St Louis Metro East Shafer Field",
      "city": "St Jacob",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.732828,
      "longitude": -89.802761,
      "elevationFeet": 476,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3K6?codeType=fs"
     },
     {
      "fs": "3K7",
      "iata": "",
      "icao": "",
      "faa": "3K7",
      "name": "Hoard Memorial",
      "city": "Leoti",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.519639,
      "longitude": -101.382167,
      "elevationFeet": 3303,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3K7?codeType=fs"
     },
     {
      "fs": "3K8",
      "iata": "",
      "icao": "",
      "faa": "3K8",
      "name": "Comanche Co",
      "city": "Coldwater",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 37.330806,
      "longitude": -99.459472,
      "elevationFeet": 2000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3K8?codeType=fs"
     },
     {
      "fs": "3KK",
      "iata": "",
      "icao": "",
      "faa": "3KK",
      "name": "Kankakee",
      "city": "Kankakee",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.100333,
      "longitude": -87.917111,
      "elevationFeet": 625,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3KK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3KK?codeType=fs"
     },
     {
      "fs": "3L0",
      "iata": "",
      "icao": "",
      "faa": "3L0",
      "name": "Lyon",
      "city": "Thornwell",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.110417,
      "longitude": -92.901472,
      "elevationFeet": 6,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3L0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3L0?codeType=fs"
     },
     {
      "fs": "3L2",
      "iata": "",
      "icao": "",
      "faa": "3L2",
      "name": "Sky Ranch",
      "city": "Sandy Valley",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 35.902528,
      "longitude": -115.722278,
      "elevationFeet": 2599,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3L2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3L2?codeType=fs"
     },
     {
      "fs": "3LC",
      "iata": "",
      "icao": "",
      "faa": "3LC",
      "name": "Logan Co",
      "city": "Lincoln",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.234722,
      "longitude": -89.349722,
      "elevationFeet": 597,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3LC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3LC?codeType=fs"
     },
     {
      "fs": "3LF",
      "iata": "",
      "icao": "",
      "faa": "3LF",
      "name": "Litchfield Municipal",
      "city": "Litchfield",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.313528,
      "longitude": -89.748972,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3LF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3LF?codeType=fs"
     },
     {
      "fs": "3M0",
      "iata": "",
      "icao": "",
      "faa": "3M0",
      "name": "Gaston",
      "city": "Lakeview",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.486778,
      "longitude": -92.621083,
      "elevationFeet": 479,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M0?codeType=fs"
     },
     {
      "fs": "3M2",
      "iata": "",
      "icao": "",
      "faa": "3M2",
      "name": "Double Springs-Winston Co",
      "city": "Double Springs",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.245472,
      "longitude": -87.427917,
      "elevationFeet": 753,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M2?codeType=fs"
     },
     {
      "fs": "3M3",
      "iata": "",
      "icao": "",
      "faa": "3M3",
      "name": "Collegedale Municipal",
      "city": "Collegedale",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 35.131306,
      "longitude": -85.068944,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M3?codeType=fs"
     },
     {
      "fs": "3M5",
      "iata": "",
      "icao": "",
      "faa": "3M5",
      "name": "Moontown",
      "city": "Huntsville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.873139,
      "longitude": -86.563778,
      "elevationFeet": 650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M5?codeType=fs"
     },
     {
      "fs": "3M7",
      "iata": "",
      "icao": "",
      "faa": "3M7",
      "name": "Lafayette Municipal",
      "city": "Lafayette",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.53375,
      "longitude": -86.132806,
      "elevationFeet": 970,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M7?codeType=fs"
     },
     {
      "fs": "3M8",
      "iata": "",
      "icao": "",
      "faa": "3M8",
      "name": "North Pickens",
      "city": "Reform",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.440056,
      "longitude": -88.055778,
      "elevationFeet": 237,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M8?codeType=fs"
     },
     {
      "fs": "3M9",
      "iata": "",
      "icao": "",
      "faa": "3M9",
      "name": "Warren Municipal",
      "city": "Warren",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.654444,
      "longitude": -92.103889,
      "elevationFeet": 235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3M9?codeType=fs"
     },
     {
      "fs": "3MO",
      "iata": "",
      "icao": "",
      "faa": "3MO",
      "name": "Osceola Municipal",
      "city": "Osceola",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.036139,
      "longitude": -93.780611,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3MO?codeType=fs"
     },
     {
      "fs": "3MY",
      "iata": "",
      "icao": "",
      "faa": "3MY",
      "name": "Mt Hawley Aux",
      "city": "Peoria",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.902583,
      "longitude": -89.734028,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3MY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3MY?codeType=fs"
     },
     {
      "fs": "3N3",
      "iata": "",
      "icao": "",
      "faa": "3N3",
      "name": "North Windham",
      "city": "Londonderry",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.264639,
      "longitude": -72.828722,
      "elevationFeet": 1750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3N3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3N3?codeType=fs"
     },
     {
      "fs": "3N5",
      "iata": "",
      "icao": "",
      "faa": "3N5",
      "name": "Newton",
      "city": "Newton",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.123194,
      "longitude": -74.834972,
      "elevationFeet": 620,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3N5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3N5?codeType=fs"
     },
     {
      "fs": "3N6",
      "iata": "",
      "icao": "",
      "faa": "3N6",
      "name": "Old Bridge",
      "city": "Old Bridge",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.448861,
      "longitude": -74.467861,
      "elevationFeet": 87,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3N6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3N6?codeType=fs"
     },
     {
      "fs": "3N7",
      "iata": "",
      "icao": "",
      "faa": "3N7",
      "name": "Pemberton Airport",
      "city": "Pemberton",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.983985,
      "longitude": -74.689391,
      "elevationFeet": 62,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3N7?codeType=fs"
     },
     {
      "fs": "3N8",
      "iata": "",
      "icao": "",
      "faa": "3N8",
      "name": "Mahnomen Co",
      "city": "Mahnomen",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.349611,
      "longitude": -96.030972,
      "elevationFeet": 1244,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3N8?codeType=fs"
     },
     {
      "fs": "3N9",
      "iata": "",
      "icao": "",
      "faa": "3N9",
      "name": "Alamo-Navajo",
      "city": "Alamo",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 34.478361,
      "longitude": -107.605972,
      "elevationFeet": 6460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3N9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3N9?codeType=fs"
     },
     {
      "fs": "3NO",
      "iata": "",
      "icao": "",
      "faa": "3NO",
      "name": "North Omaha Airport",
      "city": "Omaha",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.367463,
      "longitude": -96.021119,
      "elevationFeet": 1293,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3NO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3NO?codeType=fs"
     },
     {
      "fs": "3NP",
      "iata": "",
      "icao": "",
      "faa": "3NP",
      "name": "Napoleon Airport",
      "city": "Napoleon",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.168209,
      "longitude": -84.257239,
      "elevationFeet": 964,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3NP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3NP?codeType=fs"
     },
     {
      "fs": "3O1",
      "iata": "",
      "icao": "",
      "faa": "3O1",
      "name": "Gustine Airport",
      "city": "Gustine",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 37.262345,
      "longitude": -120.963322,
      "elevationFeet": 73,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O1?codeType=fs"
     },
     {
      "fs": "3O3",
      "iata": "",
      "icao": "",
      "faa": "3O3",
      "name": "Purcell Municipal",
      "city": "Purcell",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.097944,
      "longitude": -97.408611,
      "elevationFeet": 1140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O3?codeType=fs"
     },
     {
      "fs": "3O4",
      "iata": "",
      "icao": "",
      "faa": "3O4",
      "name": "Sayre Municipal",
      "city": "Sayre",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.175528,
      "longitude": -99.72875,
      "elevationFeet": 1937,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O4?codeType=fs"
     },
     {
      "fs": "3O5",
      "iata": "",
      "icao": "",
      "faa": "3O5",
      "name": "Walters Municipal",
      "city": "Walters",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.425833,
      "longitude": -98.458861,
      "elevationFeet": 1058,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O5?codeType=fs"
     },
     {
      "fs": "3O7",
      "iata": "",
      "icao": "",
      "faa": "3O7",
      "name": "Hollister Municipal",
      "city": "Hollister",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 36.983444,
      "longitude": -121.502694,
      "elevationFeet": 230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O7?codeType=fs"
     },
     {
      "fs": "3O8",
      "iata": "",
      "icao": "",
      "faa": "3O8",
      "name": "Harris Ranch",
      "city": "Coalinga",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 36.380083,
      "longitude": -120.276444,
      "elevationFeet": 470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O8?codeType=fs"
     },
     {
      "fs": "3O9",
      "iata": "",
      "icao": "",
      "faa": "3O9",
      "name": "Grand Lake Regional",
      "city": "Afton",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.675778,
      "longitude": -94.969,
      "elevationFeet": 792,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3O9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3O9?codeType=fs"
     },
     {
      "fs": "3P3",
      "iata": "",
      "icao": "",
      "faa": "3P3",
      "name": "Mott Municipal",
      "city": "Mott",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 46.44725,
      "longitude": -102.379389,
      "elevationFeet": 2411,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3P3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3P3?codeType=fs"
     },
     {
      "fs": "3Q0",
      "iata": "",
      "icao": "",
      "faa": "3Q0",
      "name": "Mina",
      "city": "Mina",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 38.532583,
      "longitude": -118.109528,
      "elevationFeet": 4552,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Q0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Q0?codeType=fs"
     },
     {
      "fs": "3R0",
      "iata": "",
      "icao": "",
      "faa": "3R0",
      "name": "Beeville Municipal",
      "city": "Beeville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 28.495556,
      "longitude": -97.870833,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3R0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3R0?codeType=fs"
     },
     {
      "fs": "3R2",
      "iata": "",
      "icao": "",
      "faa": "3R2",
      "name": "Le Gros Memorial",
      "city": "Crowley",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.267361,
      "longitude": -92.489611,
      "elevationFeet": 17,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3R2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3R2?codeType=fs"
     },
     {
      "fs": "3R4",
      "iata": "",
      "icao": "",
      "faa": "3R4",
      "name": "Hart",
      "city": "Many",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.648972,
      "longitude": -93.514528,
      "elevationFeet": 324,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3R4?codeType=fs"
     },
     {
      "fs": "3R7",
      "iata": "",
      "icao": "",
      "faa": "3R7",
      "name": "Jennings",
      "city": "Jennings",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.326944,
      "longitude": -92.734472,
      "elevationFeet": 23,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3R7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3R7?codeType=fs"
     },
     {
      "fs": "3R8",
      "iata": "",
      "icao": "",
      "faa": "3R8",
      "name": "Scottsburg",
      "city": "Scottsburg",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 38.722806,
      "longitude": -85.852444,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3R8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3R8?codeType=fs"
     },
     {
      "fs": "3R9",
      "iata": "",
      "icao": "",
      "faa": "3R9",
      "name": "Lakeway",
      "city": "Austin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.3575,
      "longitude": -97.994499,
      "elevationFeet": 909,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3R9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3R9?codeType=fs"
     },
     {
      "fs": "3RC",
      "iata": "",
      "icao": "",
      "faa": "3RC",
      "name": "Roscommon Conservation",
      "city": "Roscommon",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.550167,
      "longitude": -84.566889,
      "elevationFeet": 1156,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3RC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3RC?codeType=fs"
     },
     {
      "fs": "3RU",
      "iata": "",
      "icao": "",
      "faa": "3RU",
      "name": "Rust",
      "city": "Woolsey",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.476167,
      "longitude": -84.418694,
      "elevationFeet": 810,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3RU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3RU?codeType=fs"
     },
     {
      "fs": "3S2",
      "iata": "",
      "icao": "",
      "faa": "3S2",
      "name": "Swans",
      "city": "Dixfield",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.639528,
      "longitude": -70.464528,
      "elevationFeet": 400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S2?codeType=fs"
     },
     {
      "fs": "3S4",
      "iata": "",
      "icao": "",
      "faa": "3S4",
      "name": "Illinois Valley",
      "city": "Cave Junction",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 42.13725,
      "longitude": -123.822917,
      "elevationFeet": 1394,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S4?codeType=fs"
     },
     {
      "fs": "3S5",
      "iata": "",
      "icao": "",
      "faa": "3S5",
      "name": "Schiffer Acres",
      "city": "St Johns",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.058639,
      "longitude": -84.438694,
      "elevationFeet": 735,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S5?codeType=fs"
     },
     {
      "fs": "3S6",
      "iata": "",
      "icao": "",
      "faa": "3S6",
      "name": "Toketee State",
      "city": "Clearwater",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.284556,
      "longitude": -122.45875,
      "elevationFeet": 3361,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S6?codeType=fs"
     },
     {
      "fs": "3S7",
      "iata": "",
      "icao": "",
      "faa": "3S7",
      "name": "Nehalem Bay State",
      "city": "Manzanita",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.831611,
      "longitude": -124.048583,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S7?codeType=fs"
     },
     {
      "fs": "3S9",
      "iata": "",
      "icao": "",
      "faa": "3S9",
      "name": "Condon State Pauling",
      "city": "Condon",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.365194,
      "longitude": -120.314222,
      "elevationFeet": 2902,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3S9?codeType=fs"
     },
     {
      "fs": "3SQ",
      "iata": "",
      "icao": "",
      "faa": "3SQ",
      "name": "St Charles Airport",
      "city": "St Charles",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.846786,
      "longitude": -90.497886,
      "elevationFeet": 444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3SQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3SQ?codeType=fs"
     },
     {
      "fs": "3SY",
      "iata": "",
      "icao": "",
      "faa": "3SY",
      "name": "Speedway Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.797897,
      "longitude": -86.356729,
      "elevationFeet": 866,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3SY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3SY?codeType=fs"
     },
     {
      "fs": "3T0",
      "iata": "",
      "icao": "",
      "faa": "3T0",
      "name": "Cedar Mills",
      "city": "Gordonville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.9,
      "longitude": -96.916667,
      "elevationFeet": 640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3T0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3T0?codeType=fs"
     },
     {
      "fs": "3T1",
      "iata": "",
      "icao": "",
      "faa": "3T1",
      "name": "Wood Co",
      "city": "Mineola/Quitman",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.813778,
      "longitude": -95.615111,
      "elevationFeet": 434,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3T1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3T1?codeType=fs"
     },
     {
      "fs": "3T2",
      "iata": "",
      "icao": "",
      "faa": "3T2",
      "name": "Wolfe Air Park",
      "city": "Manvel",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.478313,
      "longitude": -95.323263,
      "elevationFeet": 49,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3T2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3T2?codeType=fs"
     },
     {
      "fs": "3T3",
      "iata": "",
      "icao": "",
      "faa": "3T3",
      "name": "Boyceville Municipal",
      "city": "Boyceville",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.121861,
      "longitude": -92.143472,
      "elevationFeet": 960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3T3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3T3?codeType=fs"
     },
     {
      "fs": "3T5",
      "iata": "",
      "icao": "",
      "faa": "3T5",
      "name": "Fayette Regional Air Center",
      "city": "La Grange",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.993056,
      "longitude": -96.955,
      "elevationFeet": 322,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3T5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3T5?codeType=fs"
     },
     {
      "fs": "3TA",
      "iata": "",
      "icao": "",
      "faa": "3TA",
      "name": "Stafford Municipal",
      "city": "Stafford",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.033472,
      "longitude": -98.653611,
      "elevationFeet": 1886,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3TA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3TA?codeType=fs"
     },
     {
      "fs": "3TE",
      "iata": "",
      "icao": "",
      "faa": "3TE",
      "name": "Meyers-Diver'S",
      "city": "Tecumseh",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.100722,
      "longitude": -83.991639,
      "elevationFeet": 815,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3TE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3TE?codeType=fs"
     },
     {
      "fs": "3U0",
      "iata": "",
      "icao": "",
      "faa": "3U0",
      "name": "Murphy Hot Springs",
      "city": "Three Creek",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 42.057389,
      "longitude": -115.384,
      "elevationFeet": 5829,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U0?codeType=fs"
     },
     {
      "fs": "3U1",
      "iata": "",
      "icao": "",
      "faa": "3U1",
      "name": "Warren Usfs",
      "city": "Warren",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.282389,
      "longitude": -115.684556,
      "elevationFeet": 5896,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U1?codeType=fs"
     },
     {
      "fs": "3U2",
      "iata": "",
      "icao": "",
      "faa": "3U2",
      "name": "Johnson Creek",
      "city": "Yellow Pine",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.021278,
      "longitude": -115.506694,
      "elevationFeet": 4933,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U2?codeType=fs"
     },
     {
      "fs": "3U3",
      "iata": "",
      "icao": "",
      "faa": "3U3",
      "name": "Bowman",
      "city": "Anaconda",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 46.181333,
      "longitude": -112.878389,
      "elevationFeet": 5030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U3?codeType=fs"
     },
     {
      "fs": "3U4",
      "iata": "",
      "icao": "",
      "faa": "3U4",
      "name": "St Labre Mission",
      "city": "Ashland",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.6,
      "longitude": -106.272361,
      "elevationFeet": 2909,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U4?codeType=fs"
     },
     {
      "fs": "3U5",
      "iata": "",
      "icao": "",
      "faa": "3U5",
      "name": "Augusta",
      "city": "Augusta",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.582806,
      "longitude": -112.500222,
      "elevationFeet": 4145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U5?codeType=fs"
     },
     {
      "fs": "3U7",
      "iata": "",
      "icao": "",
      "faa": "3U7",
      "name": "Benchmark",
      "city": "Benchmark",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.613333,
      "longitude": -112.897667,
      "elevationFeet": 5434,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U7?codeType=fs"
     },
     {
      "fs": "3U8",
      "iata": "",
      "icao": "",
      "faa": "3U8",
      "name": "Big Sandy",
      "city": "Big Sandy",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.274806,
      "longitude": -110.232639,
      "elevationFeet": 2700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U8?codeType=fs"
     },
     {
      "fs": "3U9",
      "iata": "",
      "icao": "",
      "faa": "3U9",
      "name": "Boulder",
      "city": "Boulder",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 46.315944,
      "longitude": -112.158333,
      "elevationFeet": 4968,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3U9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3U9?codeType=fs"
     },
     {
      "fs": "3V0",
      "iata": "",
      "icao": "",
      "faa": "3V0",
      "name": "Custer State Park",
      "city": "Fairburn",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.799889,
      "longitude": -103.354722,
      "elevationFeet": 3980,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3V0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3V0?codeType=fs"
     },
     {
      "fs": "3V4",
      "iata": "",
      "icao": "",
      "faa": "3V4",
      "name": "Ft Morgan Municipal",
      "city": "Ft Morgan",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 40.342333,
      "longitude": -103.8395,
      "elevationFeet": 4567,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3V4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3V4?codeType=fs"
     },
     {
      "fs": "3V5",
      "iata": "",
      "icao": "",
      "faa": "3V5",
      "name": "Ft Collins Downtown",
      "city": "Ft Collins",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 40.633361,
      "longitude": -105.11675,
      "elevationFeet": 4939,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3V5?codeType=fs"
     },
     {
      "fs": "3V7",
      "iata": "",
      "icao": "",
      "faa": "3V7",
      "name": "Belle Creek",
      "city": "Belle Creek",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.199861,
      "longitude": -105.172056,
      "elevationFeet": 3678,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3V7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3V7?codeType=fs"
     },
     {
      "fs": "3W2",
      "iata": "",
      "icao": "",
      "faa": "3W2",
      "name": "Put-In-Bay Airport",
      "city": "Put-In-Bay",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.649473,
      "longitude": -82.815065,
      "elevationFeet": 588,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W2?codeType=fs"
     },
     {
      "fs": "3W3",
      "iata": "",
      "icao": "",
      "faa": "3W3",
      "name": "Kentmorr",
      "city": "Stevensville",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 38.931694,
      "longitude": -76.430111,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W3?codeType=fs"
     },
     {
      "fs": "3W5",
      "iata": "",
      "icao": "",
      "faa": "3W5",
      "name": "Concrete Municipal",
      "city": "Concrete",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 48.619194,
      "longitude": -121.831972,
      "elevationFeet": 264,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W5?codeType=fs"
     },
     {
      "fs": "3W6",
      "iata": "",
      "icao": "",
      "faa": "3W6",
      "name": "Bladenboro",
      "city": "Bladenboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.551694,
      "longitude": -78.93075,
      "elevationFeet": 115,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W6?codeType=fs"
     },
     {
      "fs": "3W7",
      "iata": "",
      "icao": "",
      "faa": "3W7",
      "name": "Grand Coulee Dam",
      "city": "Electric City",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 47.984833,
      "longitude": -119.205806,
      "elevationFeet": 1590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W7?codeType=fs"
     },
     {
      "fs": "3W8",
      "iata": "",
      "icao": "",
      "faa": "3W8",
      "name": "Eureka Municipal",
      "city": "Eureka",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.949806,
      "longitude": -99.720639,
      "elevationFeet": 1935,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W8?codeType=fs"
     },
     {
      "fs": "3W9",
      "iata": "",
      "icao": "",
      "faa": "3W9",
      "name": "Middle Bass-East Point Airport",
      "city": "Middle Bass I",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.698067,
      "longitude": -82.775108,
      "elevationFeet": 570,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3W9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3W9?codeType=fs"
     },
     {
      "fs": "3WO",
      "iata": "",
      "icao": "",
      "faa": "3WO",
      "name": "Shawano Municipal",
      "city": "Shawano",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 44.827778,
      "longitude": -88.66525,
      "elevationFeet": 811,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3WO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3WO?codeType=fs"
     },
     {
      "fs": "3X5",
      "iata": "",
      "icao": "",
      "faa": "3X5",
      "name": "North Bass Island Airport",
      "city": "North Bass Island",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.711458,
      "longitude": -82.799962,
      "elevationFeet": 563,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3X5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3X5?codeType=fs"
     },
     {
      "fs": "3XS7",
      "iata": "",
      "icao": "",
      "faa": "3XS7",
      "name": "Skydive Houston",
      "city": "Waller",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.681",
      "utcOffsetHours": -10,
      "latitude": 30.083333,
      "longitude": -96.053333,
      "elevationFeet": 235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3XS7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3XS7?codeType=fs"
     },
     {
      "fs": "3Y0",
      "iata": "",
      "icao": "",
      "faa": "3Y0",
      "name": "Wall Lake Municipal",
      "city": "Wall Lake",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.399833,
      "longitude": -95.102694,
      "elevationFeet": 1224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Y0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Y0?codeType=fs"
     },
     {
      "fs": "3Y2",
      "iata": "",
      "icao": "",
      "faa": "3Y2",
      "name": "Scott Municipal",
      "city": "West Union",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.000889,
      "longitude": -91.856056,
      "elevationFeet": 1232,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Y2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Y2?codeType=fs"
     },
     {
      "fs": "3Y3",
      "iata": "",
      "icao": "",
      "faa": "3Y3",
      "name": "Winterset-Madison Co",
      "city": "Winterset",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.477667,
      "longitude": -94.060611,
      "elevationFeet": 1110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Y3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Y3?codeType=fs"
     },
     {
      "fs": "3Y4",
      "iata": "",
      "icao": "",
      "faa": "3Y4",
      "name": "Woodbine Municipal",
      "city": "Woodbine",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.761,
      "longitude": -95.686167,
      "elevationFeet": 1068,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Y4?codeType=fs"
     },
     {
      "fs": "3Y7",
      "iata": "",
      "icao": "",
      "faa": "3Y7",
      "name": "Isabel Municipal",
      "city": "Isabel",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.424806,
      "longitude": -101.520944,
      "elevationFeet": 2398,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Y7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Y7?codeType=fs"
     },
     {
      "fs": "3Z1",
      "iata": "",
      "icao": "",
      "faa": "3Z1",
      "name": "Feather River",
      "city": "Feather River",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 64.966667,
      "longitude": -166.265,
      "elevationFeet": 325,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/3Z1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/3Z1?codeType=fs"
     },
     {
      "fs": "40C",
      "iata": "",
      "icao": "",
      "faa": "40C",
      "name": "Watervliet",
      "city": "Watervliet",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.2,
      "longitude": -86.25,
      "elevationFeet": 656,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/40C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/40C?codeType=fs"
     },
     {
      "fs": "40D",
      "iata": "",
      "icao": "",
      "faa": "40D",
      "name": "Three Lakes Municipal",
      "city": "Three Lakes",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.852361,
      "longitude": -89.159583,
      "elevationFeet": 1636,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/40D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/40D?codeType=fs"
     },
     {
      "fs": "40G",
      "iata": "",
      "icao": "",
      "faa": "40G",
      "name": "Valle",
      "city": "Grand Canyon",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 35.656472,
      "longitude": -112.280444,
      "elevationFeet": 5999,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/40G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/40G?codeType=fs"
     },
     {
      "fs": "40I",
      "iata": "",
      "icao": "",
      "faa": "40I",
      "name": "Stewart",
      "city": "Waynesville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.553389,
      "longitude": -84.168806,
      "elevationFeet": 955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/40I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/40I?codeType=fs"
     },
     {
      "fs": "40U",
      "iata": "",
      "icao": "",
      "faa": "40U",
      "name": "Manila",
      "city": "Manila",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 41.010694,
      "longitude": -109.784806,
      "elevationFeet": 6175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/40U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/40U?codeType=fs"
     },
     {
      "fs": "41A",
      "iata": "",
      "icao": "",
      "faa": "41A",
      "name": "Reeves",
      "city": "Tallassee",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.644444,
      "longitude": -85.958333,
      "elevationFeet": 326,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/41A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/41A?codeType=fs"
     },
     {
      "fs": "41C",
      "iata": "",
      "icao": "",
      "faa": "41C",
      "name": "Calkins",
      "city": "Wayland",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.766972,
      "longitude": -85.758556,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/41C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/41C?codeType=fs"
     },
     {
      "fs": "41G",
      "iata": "",
      "icao": "",
      "faa": "41G",
      "name": "University",
      "city": "Bath",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.903111,
      "longitude": -84.591444,
      "elevationFeet": 856,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/41G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/41G?codeType=fs"
     },
     {
      "fs": "42A",
      "iata": "",
      "icao": "",
      "faa": "42A",
      "name": "Melbourne Mun - Miller",
      "city": "Melbourne",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.107917,
      "longitude": -91.941472,
      "elevationFeet": 730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42A?codeType=fs"
     },
     {
      "fs": "42B",
      "iata": "",
      "icao": "",
      "faa": "42B",
      "name": "Goodspeed",
      "city": "East Haddam",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.556556,
      "longitude": -72.506417,
      "elevationFeet": 9,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42B?codeType=fs"
     },
     {
      "fs": "42C",
      "iata": "",
      "icao": "",
      "faa": "42C",
      "name": "White Cloud",
      "city": "White Cloud",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.647417,
      "longitude": -85.842194,
      "elevationFeet": 914,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42C?codeType=fs"
     },
     {
      "fs": "42F",
      "iata": "",
      "icao": "",
      "faa": "42F",
      "name": "Palmer",
      "city": "Ponder",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.337306,
      "longitude": -97.319639,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42F?codeType=fs"
     },
     {
      "fs": "42I",
      "iata": "",
      "icao": "",
      "faa": "42I",
      "name": "Parr",
      "city": "Zanesville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.070111,
      "longitude": -82.123583,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42I?codeType=fs"
     },
     {
      "fs": "42J",
      "iata": "",
      "icao": "",
      "faa": "42J",
      "name": "Keystone",
      "city": "Keystone Heights",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 29.9475,
      "longitude": -82.175278,
      "elevationFeet": 196,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42J?codeType=fs"
     },
     {
      "fs": "42M",
      "iata": "",
      "icao": "",
      "faa": "42M",
      "name": "Thayer Memorial",
      "city": "Thayer",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.517278,
      "longitude": -91.568083,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42M?codeType=fs"
     },
     {
      "fs": "42N",
      "iata": "",
      "icao": "",
      "faa": "42N",
      "name": "Double Jj Resort Ranch",
      "city": "Rothbury",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.519444,
      "longitude": -86.433333,
      "elevationFeet": 689,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42N?codeType=fs"
     },
     {
      "fs": "42S",
      "iata": "",
      "icao": "",
      "faa": "42S",
      "name": "Poplar",
      "city": "Poplar",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.259583,
      "longitude": -105.321917,
      "elevationFeet": 2005,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42S?codeType=fs"
     },
     {
      "fs": "42U",
      "iata": "",
      "icao": "",
      "faa": "42U",
      "name": "Morgan Co",
      "city": "Morgan",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 41.288306,
      "longitude": -111.916028,
      "elevationFeet": 5020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42U?codeType=fs"
     },
     {
      "fs": "42V",
      "iata": "",
      "icao": "",
      "faa": "42V",
      "name": "Jones",
      "city": "Benkelman",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 40.1305,
      "longitude": -101.668333,
      "elevationFeet": 3126,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/42V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/42V?codeType=fs"
     },
     {
      "fs": "43A",
      "iata": "",
      "icao": "",
      "faa": "43A",
      "name": "Montgomery Co",
      "city": "Star",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 35.431944,
      "longitude": -79.878167,
      "elevationFeet": 628,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43A?codeType=fs"
     },
     {
      "fs": "43B",
      "iata": "",
      "icao": "",
      "faa": "43B",
      "name": "Deblois",
      "city": "Deblois",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.80075,
      "longitude": -68.061194,
      "elevationFeet": 217,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43B?codeType=fs"
     },
     {
      "fs": "43D",
      "iata": "",
      "icao": "",
      "faa": "43D",
      "name": "Odessa Municipal",
      "city": "Odessa",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 47.432028,
      "longitude": -118.733278,
      "elevationFeet": 1725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43D?codeType=fs"
     },
     {
      "fs": "43G",
      "iata": "",
      "icao": "",
      "faa": "43G",
      "name": "Larsen",
      "city": "Belleville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.267083,
      "longitude": -83.657694,
      "elevationFeet": 696,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43G?codeType=fs"
     },
     {
      "fs": "43K",
      "iata": "",
      "icao": "",
      "faa": "43K",
      "name": "Marion Municipal",
      "city": "Marion",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.375167,
      "longitude": -97.066889,
      "elevationFeet": 1390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43K?codeType=fs"
     },
     {
      "fs": "43M",
      "iata": "",
      "icao": "",
      "faa": "43M",
      "name": "Oxford",
      "city": "Oxford",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.170389,
      "longitude": -71.850722,
      "elevationFeet": 763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43M?codeType=fs"
     },
     {
      "fs": "43N",
      "iata": "",
      "icao": "",
      "faa": "43N",
      "name": "Stanton",
      "city": "New Paltz",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.750944,
      "longitude": -74.262556,
      "elevationFeet": 303,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43N?codeType=fs"
     },
     {
      "fs": "43Y",
      "iata": "",
      "icao": "",
      "faa": "43Y",
      "name": "Northome Municipal",
      "city": "Northome",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.966222,
      "longitude": -94.252222,
      "elevationFeet": 1427,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/43Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/43Y?codeType=fs"
     },
     {
      "fs": "44A",
      "iata": "",
      "icao": "",
      "faa": "44A",
      "name": "Rolle",
      "city": "Somerton",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 32.533861,
      "longitude": -114.830111,
      "elevationFeet": 163,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44A?codeType=fs"
     },
     {
      "fs": "44B",
      "iata": "",
      "icao": "",
      "faa": "44B",
      "name": "Chase Jr Memorial",
      "city": "Dover Foxcroft",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.183889,
      "longitude": -69.378222,
      "elevationFeet": 520,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44B?codeType=fs"
     },
     {
      "fs": "44C",
      "iata": "",
      "icao": "",
      "faa": "44C",
      "name": "Beloit",
      "city": "Beloit",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.627778,
      "longitude": -88.976111,
      "elevationFeet": 817,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44C?codeType=fs"
     },
     {
      "fs": "44G",
      "iata": "",
      "icao": "",
      "faa": "44G",
      "name": "Betz",
      "city": "Blissfield",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.906028,
      "longitude": -83.90775,
      "elevationFeet": 691,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44G?codeType=fs"
     },
     {
      "fs": "44I",
      "iata": "",
      "icao": "",
      "faa": "44I",
      "name": "Hollow Regional",
      "city": "Albany",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.678444,
      "longitude": -85.288444,
      "elevationFeet": 980,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44I?codeType=fs"
     },
     {
      "fs": "44M",
      "iata": "",
      "icao": "",
      "faa": "44M",
      "name": "Tenkiller Lake Airpark",
      "city": "Cookson",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.700917,
      "longitude": -94.935639,
      "elevationFeet": 877,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44M?codeType=fs"
     },
     {
      "fs": "44N",
      "iata": "",
      "icao": "",
      "faa": "44N",
      "name": "Sky Acres",
      "city": "Millbrook",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.774278,
      "longitude": -73.780278,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44N?codeType=fs"
     },
     {
      "fs": "44S",
      "iata": "",
      "icao": "",
      "faa": "44S",
      "name": "Sheridan",
      "city": "Sheridan",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.126139,
      "longitude": -123.44275,
      "elevationFeet": 215,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44S?codeType=fs"
     },
     {
      "fs": "44T",
      "iata": "",
      "icao": "",
      "faa": "44T",
      "name": "Hoskins",
      "city": "Olympia",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 47.076667,
      "longitude": -122.926667,
      "elevationFeet": 213,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/44T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/44T?codeType=fs"
     },
     {
      "fs": "45G",
      "iata": "",
      "icao": "",
      "faa": "45G",
      "name": "Brighton",
      "city": "Brighton",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.603111,
      "longitude": -83.88,
      "elevationFeet": 973,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/45G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/45G?codeType=fs"
     },
     {
      "fs": "45IS",
      "iata": "",
      "icao": "",
      "faa": "45IS",
      "name": "Bolingbrook Med Center Heliport",
      "city": "Bolingbrook",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.681697,
      "longitude": -88.095618,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/45IS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/45IS?codeType=fs"
     },
     {
      "fs": "45J",
      "iata": "",
      "icao": "",
      "faa": "45J",
      "name": "Rockingham-Hamlet",
      "city": "Rockingham",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.960722,
      "longitude": -79.840583,
      "elevationFeet": 358,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/45J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/45J?codeType=fs"
     },
     {
      "fs": "45K",
      "iata": "",
      "icao": "",
      "faa": "45K",
      "name": "Minneapolis City Co",
      "city": "Minneapolis",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.197222,
      "longitude": -97.755917,
      "elevationFeet": 1245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/45K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/45K?codeType=fs"
     },
     {
      "fs": "45R",
      "iata": "",
      "icao": "",
      "faa": "45R",
      "name": "Hawthorne",
      "city": "Kountze/Silsbee",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.363333,
      "longitude": -94.325556,
      "elevationFeet": 71,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/45R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/45R?codeType=fs"
     },
     {
      "fs": "45S",
      "iata": "",
      "icao": "",
      "faa": "45S",
      "name": "Silver Lake F S Strip",
      "city": "Silver Lake",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.209722,
      "longitude": -121.191667,
      "elevationFeet": 4492,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/45S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/45S?codeType=fs"
     },
     {
      "fs": "46A",
      "iata": "",
      "icao": "",
      "faa": "46A",
      "name": "Blairsville",
      "city": "Blairsville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.900861,
      "longitude": -84.118556,
      "elevationFeet": 1911,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/46A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/46A?codeType=fs"
     },
     {
      "fs": "46D",
      "iata": "",
      "icao": "",
      "faa": "46D",
      "name": "Carrington Municipal",
      "city": "Carrington",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.461111,
      "longitude": -99.161111,
      "elevationFeet": 1604,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/46D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/46D?codeType=fs"
     },
     {
      "fs": "46IA",
      "iata": "",
      "icao": "",
      "faa": "46IA",
      "name": "Todd Field",
      "city": "Ankeny",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.75586,
      "longitude": -93.56668,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/46IA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/46IA?codeType=fs"
     },
     {
      "fs": "46N",
      "iata": "",
      "icao": "",
      "faa": "46N",
      "name": "Sky Park",
      "city": "Red Hook",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.995833,
      "longitude": -73.859722,
      "elevationFeet": 323,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/46N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/46N?codeType=fs"
     },
     {
      "fs": "46U",
      "iata": "",
      "icao": "",
      "faa": "46U",
      "name": "Alpine",
      "city": "Alpine",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.196444,
      "longitude": -111.124333,
      "elevationFeet": 5634,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/46U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/46U?codeType=fs"
     },
     {
      "fs": "47A",
      "iata": "",
      "icao": "",
      "faa": "47A",
      "name": "Cherokee Co",
      "city": "Canton",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.405833,
      "longitude": -84.489167,
      "elevationFeet": 1219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47A?codeType=fs"
     },
     {
      "fs": "47G",
      "iata": "",
      "icao": "",
      "faa": "47G",
      "name": "Mayes",
      "city": "Carson City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.308667,
      "longitude": -85.000083,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47G?codeType=fs"
     },
     {
      "fs": "47I",
      "iata": "",
      "icao": "",
      "faa": "47I",
      "name": "Scott",
      "city": "Mineral Wells",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.281333,
      "longitude": -81.587333,
      "elevationFeet": 662,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47I?codeType=fs"
     },
     {
      "fs": "47K",
      "iata": "",
      "icao": "",
      "faa": "47K",
      "name": "Moundridge Municipal",
      "city": "Moundridge",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.269528,
      "longitude": -97.530944,
      "elevationFeet": 1490,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47K?codeType=fs"
     },
     {
      "fs": "47M",
      "iata": "",
      "icao": "",
      "faa": "47M",
      "name": "Thornton",
      "city": "Brownsville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.703528,
      "longitude": -89.245111,
      "elevationFeet": 351,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47M?codeType=fs"
     },
     {
      "fs": "47V",
      "iata": "",
      "icao": "",
      "faa": "47V",
      "name": "Curtis Municipal",
      "city": "Curtis",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.675083,
      "longitude": -100.512556,
      "elevationFeet": 2676,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47V?codeType=fs"
     },
     {
      "fs": "47Y",
      "iata": "",
      "icao": "",
      "faa": "47Y",
      "name": "Pelican Rapids Mun-Lyon'S",
      "city": "Pelican Rapids",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.71625,
      "longitude": -96.145028,
      "elevationFeet": 1389,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/47Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/47Y?codeType=fs"
     },
     {
      "fs": "48A",
      "iata": "",
      "icao": "",
      "faa": "48A",
      "name": "Cochran",
      "city": "Cochran",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.543611,
      "longitude": -83.359167,
      "elevationFeet": 336,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48A?codeType=fs"
     },
     {
      "fs": "48D",
      "iata": "",
      "icao": "",
      "faa": "48D",
      "name": "Clare Municipal",
      "city": "Clare",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.966639,
      "longitude": -84.820722,
      "elevationFeet": 857,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48D?codeType=fs"
     },
     {
      "fs": "48G",
      "iata": "",
      "icao": "",
      "faa": "48G",
      "name": "Gavagan",
      "city": "Yale",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.141944,
      "longitude": -82.952111,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48G?codeType=fs"
     },
     {
      "fs": "48I",
      "iata": "",
      "icao": "",
      "faa": "48I",
      "name": "Braxton Co",
      "city": "Sutton",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 38.720444,
      "longitude": -80.667611,
      "elevationFeet": 1270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48I?codeType=fs"
     },
     {
      "fs": "48K",
      "iata": "",
      "icao": "",
      "faa": "48K",
      "name": "Ness City Municipal",
      "city": "Ness City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.511111,
      "longitude": -99.980556,
      "elevationFeet": 2308,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48K?codeType=fs"
     },
     {
      "fs": "48S",
      "iata": "",
      "icao": "",
      "faa": "48S",
      "name": "Harlem",
      "city": "Harlem",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.716639,
      "longitude": -108.829333,
      "elevationFeet": 2623,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48S?codeType=fs"
     },
     {
      "fs": "48U",
      "iata": "",
      "icao": "",
      "faa": "48U",
      "name": "Gtr Green River Intergalactic*",
      "city": "Green River",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 41.530194,
      "longitude": -109.554139,
      "elevationFeet": 7182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48U?codeType=fs"
     },
     {
      "fs": "48V",
      "iata": "",
      "icao": "",
      "faa": "48V",
      "name": "Tri-County",
      "city": "Erie",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 40.10225,
      "longitude": -105.17975,
      "elevationFeet": 5130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48V?codeType=fs"
     },
     {
      "fs": "48X",
      "iata": "",
      "icao": "",
      "faa": "48X",
      "name": "Airport Manatee",
      "city": "Palmetto",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 27.725333,
      "longitude": -82.559306,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48X?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48X?codeType=fs"
     },
     {
      "fs": "48Y",
      "iata": "",
      "icao": "",
      "faa": "48Y",
      "name": "Piney Pinecreek Border Airport",
      "city": "Pinecreek",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 48.998453,
      "longitude": -95.978308,
      "elevationFeet": 1072,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/48Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/48Y?codeType=fs"
     },
     {
      "fs": "49A",
      "iata": "",
      "icao": "",
      "faa": "49A",
      "name": "Gilmer Co",
      "city": "Ellijay",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.728639,
      "longitude": -84.599278,
      "elevationFeet": 1486,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49A?codeType=fs"
     },
     {
      "fs": "49B",
      "iata": "",
      "icao": "",
      "faa": "49B",
      "name": "Sturgis Municipal",
      "city": "Sturgis",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 44.426111,
      "longitude": -103.447778,
      "elevationFeet": 3239,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49B?codeType=fs"
     },
     {
      "fs": "49C",
      "iata": "",
      "icao": "",
      "faa": "49C",
      "name": "Camp Lake",
      "city": "Camp Lake",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.533528,
      "longitude": -88.234194,
      "elevationFeet": 755,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49C?codeType=fs"
     },
     {
      "fs": "49F",
      "iata": "",
      "icao": "",
      "faa": "49F",
      "name": "Rankin",
      "city": "Rankin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.323694,
      "longitude": -101.981861,
      "elevationFeet": 2543,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49F?codeType=fs"
     },
     {
      "fs": "49G",
      "iata": "",
      "icao": "",
      "faa": "49G",
      "name": "Wend Valley",
      "city": "Charlotte",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.692028,
      "longitude": -84.98325,
      "elevationFeet": 859,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49G?codeType=fs"
     },
     {
      "fs": "49I",
      "iata": "",
      "icao": "",
      "faa": "49I",
      "name": "Bennett",
      "city": "Weston",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.164806,
      "longitude": -80.495361,
      "elevationFeet": 1014,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49I?codeType=fs"
     },
     {
      "fs": "49K",
      "iata": "",
      "icao": "",
      "faa": "49K",
      "name": "Norwich",
      "city": "Norwich",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 37.50575,
      "longitude": -97.836639,
      "elevationFeet": 1494,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49K?codeType=fs"
     },
     {
      "fs": "49R",
      "iata": "",
      "icao": "",
      "faa": "49R",
      "name": "Real Co",
      "city": "Leakey",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.855,
      "longitude": -99.858917,
      "elevationFeet": 1640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49R?codeType=fs"
     },
     {
      "fs": "49S",
      "iata": "",
      "icao": "",
      "faa": "49S",
      "name": "Babb",
      "city": "Babb",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.949833,
      "longitude": -113.523194,
      "elevationFeet": 4518,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49S?codeType=fs"
     },
     {
      "fs": "49U",
      "iata": "",
      "icao": "",
      "faa": "49U",
      "name": "Shoshoni Municipal",
      "city": "Shoshoni",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.263472,
      "longitude": -108.164833,
      "elevationFeet": 4817,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49U?codeType=fs"
     },
     {
      "fs": "49X",
      "iata": "",
      "icao": "",
      "faa": "49X",
      "name": "Chemehuevi Valley",
      "city": "Chemehuevi Valley",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 34.625111,
      "longitude": -114.560694,
      "elevationFeet": 631,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49X?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49X?codeType=fs"
     },
     {
      "fs": "49Y",
      "iata": "",
      "icao": "",
      "faa": "49Y",
      "name": "Fillmore Co",
      "city": "Preston",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.767611,
      "longitude": -92.297333,
      "elevationFeet": 1276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/49Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/49Y?codeType=fs"
     },
     {
      "fs": "4A0",
      "iata": "",
      "icao": "",
      "faa": "4A0",
      "name": "Berry Hill",
      "city": "Stockbridge",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.556667,
      "longitude": -84.290861,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A0?codeType=fs"
     },
     {
      "fs": "4A4",
      "iata": "",
      "icao": "",
      "faa": "4A4",
      "name": "Cornelius-Moore",
      "city": "Cedartown",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.037111,
      "longitude": -85.264778,
      "elevationFeet": 974,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A4?codeType=fs"
     },
     {
      "fs": "4A5",
      "iata": "",
      "icao": "",
      "faa": "4A5",
      "name": "Searcy Co",
      "city": "Marshall",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.039361,
      "longitude": -92.708861,
      "elevationFeet": 916,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A5?codeType=fs"
     },
     {
      "fs": "4A6",
      "iata": "",
      "icao": "",
      "faa": "4A6",
      "name": "Scottsboro Mun-Word",
      "city": "Scottsboro",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.739722,
      "longitude": -86.058139,
      "elevationFeet": 640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A6?codeType=fs"
     },
     {
      "fs": "4A8",
      "iata": "",
      "icao": "",
      "faa": "4A8",
      "name": "Lost Bridge Village",
      "city": "Garfield",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.438889,
      "longitude": -93.997222,
      "elevationFeet": 1440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A8?codeType=fs"
     },
     {
      "fs": "4A9",
      "iata": "",
      "icao": "",
      "faa": "4A9",
      "name": "Isbell",
      "city": "Ft Payne",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.528917,
      "longitude": -85.772444,
      "elevationFeet": 877,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4A9?codeType=fs"
     },
     {
      "fs": "4AC",
      "iata": "",
      "icao": "",
      "faa": "4AC",
      "name": "Coronado",
      "city": "Albuquerque",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 35.308778,
      "longitude": -106.633583,
      "elevationFeet": 5280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4AC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4AC?codeType=fs"
     },
     {
      "fs": "4B0",
      "iata": "",
      "icao": "",
      "faa": "4B0",
      "name": "South Albany",
      "city": "South Bethlehem",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.65725,
      "longitude": -73.839556,
      "elevationFeet": 196,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4B0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4B0?codeType=fs"
     },
     {
      "fs": "4B1",
      "iata": "",
      "icao": "",
      "faa": "4B1",
      "name": "Duanesburg Airport",
      "city": "Duanesburg",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.758936,
      "longitude": -74.132451,
      "elevationFeet": 704,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4B1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4B1?codeType=fs"
     },
     {
      "fs": "4B6",
      "iata": "",
      "icao": "",
      "faa": "4B6",
      "name": "Ticonderoga Municipal",
      "city": "Ticonderoga",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.970028,
      "longitude": -73.531778,
      "elevationFeet": 274,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4B6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4B6?codeType=fs"
     },
     {
      "fs": "4B7",
      "iata": "",
      "icao": "",
      "faa": "4B7",
      "name": "Schroon Lake",
      "city": "Schroon Lake",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.975611,
      "longitude": -73.826306,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4B7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4B7?codeType=fs"
     },
     {
      "fs": "4B8",
      "iata": "",
      "icao": "",
      "faa": "4B8",
      "name": "Robertson",
      "city": "Plainville",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.690399,
      "longitude": -72.864799,
      "elevationFeet": 200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4B8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4B8?codeType=fs"
     },
     {
      "fs": "4B9",
      "iata": "",
      "icao": "",
      "faa": "4B9",
      "name": "Simsbury",
      "city": "Simsbury",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.917639,
      "longitude": -72.873167,
      "elevationFeet": 195,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4B9?codeType=fs"
     },
     {
      "fs": "4C1",
      "iata": "",
      "icao": "",
      "faa": "4C1",
      "name": "Flying U Ranch",
      "city": "Union Mills",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.489306,
      "longitude": -86.872444,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4C1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4C1?codeType=fs"
     },
     {
      "fs": "4C2",
      "iata": "",
      "icao": "",
      "faa": "4C2",
      "name": "Walker-Waterloo",
      "city": "Waterloo",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.561611,
      "longitude": -85.116306,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4C2?codeType=fs"
     },
     {
      "fs": "4C4",
      "iata": "",
      "icao": "",
      "faa": "4C4",
      "name": "Colebrook",
      "city": "Colebrook",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.883806,
      "longitude": -71.645278,
      "elevationFeet": 1010,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4C4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4C4?codeType=fs"
     },
     {
      "fs": "4C7",
      "iata": "",
      "icao": "",
      "faa": "4C7",
      "name": "Ackley Municipal",
      "city": "Ackley",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.658111,
      "longitude": -93.040889,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4C7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4C7?codeType=fs"
     },
     {
      "fs": "4C8",
      "iata": "",
      "icao": "",
      "faa": "4C8",
      "name": "Albia Municipal",
      "city": "Albia",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 41.094528,
      "longitude": -92.879722,
      "elevationFeet": 963,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4C8?codeType=fs"
     },
     {
      "fs": "4D0",
      "iata": "",
      "icao": "",
      "faa": "4D0",
      "name": "Abrams Municipal",
      "city": "Grand Ledge",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.842028,
      "longitude": -84.880972,
      "elevationFeet": 842,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4D0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4D0?codeType=fs"
     },
     {
      "fs": "4D1",
      "iata": "",
      "icao": "",
      "faa": "4D1",
      "name": "Three Castles",
      "city": "Wonewoc",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.69975,
      "longitude": -90.376278,
      "elevationFeet": 921,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4D1?codeType=fs"
     },
     {
      "fs": "4D8",
      "iata": "",
      "icao": "",
      "faa": "4D8",
      "name": "Fuller",
      "city": "Milford",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.481861,
      "longitude": -95.240528,
      "elevationFeet": 1439,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4D8?codeType=fs"
     },
     {
      "fs": "4D9",
      "iata": "",
      "icao": "",
      "faa": "4D9",
      "name": "Alma Municipal",
      "city": "Alma",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.239,
      "longitude": -99.456528,
      "elevationFeet": 2070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4D9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4D9?codeType=fs"
     },
     {
      "fs": "4E7",
      "iata": "",
      "icao": "",
      "faa": "4E7",
      "name": "Ellendale Municipal",
      "city": "Ellendale",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.124722,
      "longitude": -98.628778,
      "elevationFeet": 1455,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4E7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4E7?codeType=fs"
     },
     {
      "fs": "4E8",
      "iata": "",
      "icao": "",
      "faa": "4E8",
      "name": "Richardton",
      "city": "Richardton",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.008389,
      "longitude": -102.398972,
      "elevationFeet": 2492,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4E8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4E8?codeType=fs"
     },
     {
      "fs": "4F0",
      "iata": "",
      "icao": "",
      "faa": "4F0",
      "name": "Lone Star Steel Company",
      "city": "Lone Star",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.934639,
      "longitude": -94.735417,
      "elevationFeet": 285,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F0?codeType=fs"
     },
     {
      "fs": "4F1",
      "iata": "",
      "icao": "",
      "faa": "4F1",
      "name": "Keystone",
      "city": "Westport",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.273,
      "longitude": -96.46125,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F1?codeType=fs"
     },
     {
      "fs": "4F2",
      "iata": "",
      "icao": "",
      "faa": "4F2",
      "name": "Panola Co-Sharpe",
      "city": "Carthage",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.260833,
      "longitude": -94.438056,
      "elevationFeet": 248,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F2?codeType=fs"
     },
     {
      "fs": "4F4",
      "iata": "",
      "icao": "",
      "faa": "4F4",
      "name": "Stephens-Gilmer Municipal",
      "city": "Gilmer",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.84,
      "longitude": -95.088611,
      "elevationFeet": 415,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F4?codeType=fs"
     },
     {
      "fs": "4F6",
      "iata": "",
      "icao": "",
      "faa": "4F6",
      "name": "Williams Ranch",
      "city": "Caddo Gap",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.492667,
      "longitude": -93.676889,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F6?codeType=fs"
     },
     {
      "fs": "4F7",
      "iata": "",
      "icao": "",
      "faa": "4F7",
      "name": "Kizer",
      "city": "Prescott",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.838333,
      "longitude": -93.482278,
      "elevationFeet": 311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F7?codeType=fs"
     },
     {
      "fs": "4F8",
      "iata": "",
      "icao": "",
      "faa": "4F8",
      "name": "Wilson",
      "city": "Stephens",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.503972,
      "longitude": -93.107222,
      "elevationFeet": 230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F8?codeType=fs"
     },
     {
      "fs": "4F9",
      "iata": "",
      "icao": "",
      "faa": "4F9",
      "name": "La Moure Rott Municipal",
      "city": "La Moure",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.466361,
      "longitude": -98.287111,
      "elevationFeet": 1310,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4F9?codeType=fs"
     },
     {
      "fs": "4G0",
      "iata": "",
      "icao": "",
      "faa": "4G0",
      "name": "Pittsburgh-Monroeville",
      "city": "Monroeville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.472917,
      "longitude": -79.847694,
      "elevationFeet": 1187,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G0?codeType=fs"
     },
     {
      "fs": "4G1",
      "iata": "",
      "icao": "",
      "faa": "4G1",
      "name": "Greenville Municipal",
      "city": "Greenville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.568306,
      "longitude": -80.462611,
      "elevationFeet": 1202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G1?codeType=fs"
     },
     {
      "fs": "4G2",
      "iata": "",
      "icao": "",
      "faa": "4G2",
      "name": "Hamburg Inc Airport",
      "city": "Hamburg",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.700183,
      "longitude": -79.914867,
      "elevationFeet": 745,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G2?codeType=fs"
     },
     {
      "fs": "4G3",
      "iata": "",
      "icao": "",
      "faa": "4G3",
      "name": "Miller",
      "city": "Alliance",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.117528,
      "longitude": -81.1215,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G3?codeType=fs"
     },
     {
      "fs": "4G4",
      "iata": "",
      "icao": "",
      "faa": "4G4",
      "name": "Youngstown Elser Metro",
      "city": "Youngstown",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.067944,
      "longitude": -80.773278,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G4?codeType=fs"
     },
     {
      "fs": "4G5",
      "iata": "",
      "icao": "",
      "faa": "4G5",
      "name": "Monroe Co",
      "city": "Woodsfield",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.890444,
      "longitude": -81.127722,
      "elevationFeet": 1195,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G5?codeType=fs"
     },
     {
      "fs": "4G6",
      "iata": "",
      "icao": "",
      "faa": "4G6",
      "name": "Hornell Municipal",
      "city": "Hornell",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.521444,
      "longitude": -77.821111,
      "elevationFeet": 1220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G6?codeType=fs"
     },
     {
      "fs": "4G7",
      "iata": "",
      "icao": "",
      "faa": "4G7",
      "name": "Fairmont Mun-Frankman",
      "city": "Fairmont",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.581667,
      "longitude": -80.170278,
      "elevationFeet": 1029,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G7?codeType=fs"
     },
     {
      "fs": "4G8",
      "iata": "",
      "icao": "",
      "faa": "4G8",
      "name": "Columbia Airport",
      "city": "Columbia Station",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.319312,
      "longitude": -81.956146,
      "elevationFeet": 809,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4G8?codeType=fs"
     },
     {
      "fs": "4I0",
      "iata": "",
      "icao": "",
      "faa": "4I0",
      "name": "Mingo Co",
      "city": "Williamson",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 37.726028,
      "longitude": -82.359722,
      "elevationFeet": 1575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4I0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4I0?codeType=fs"
     },
     {
      "fs": "4I1",
      "iata": "",
      "icao": "",
      "faa": "4I1",
      "name": "Williamsburg-Cumberland Falls",
      "city": "Williamsburg",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 36.945278,
      "longitude": -84.229889,
      "elevationFeet": 1215,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4I1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4I1?codeType=fs"
     },
     {
      "fs": "4I7",
      "iata": "",
      "icao": "",
      "faa": "4I7",
      "name": "Putnam Co",
      "city": "Greencastle",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.635944,
      "longitude": -86.938333,
      "elevationFeet": 835,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4I7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4I7?codeType=fs"
     },
     {
      "fs": "4I9",
      "iata": "",
      "icao": "",
      "faa": "4I9",
      "name": "Morrow Co",
      "city": "Mt Gilead",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.595278,
      "longitude": -82.850556,
      "elevationFeet": 1085,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4I9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4I9?codeType=fs"
     },
     {
      "fs": "4J1",
      "iata": "",
      "icao": "",
      "faa": "4J1",
      "name": "Brantley Co",
      "city": "Nahunta",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 31.32725,
      "longitude": -81.953917,
      "elevationFeet": 83,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4J1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4J1?codeType=fs"
     },
     {
      "fs": "4J2",
      "iata": "",
      "icao": "",
      "faa": "4J2",
      "name": "Berrien Co",
      "city": "Nashville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 31.326972,
      "longitude": -83.326528,
      "elevationFeet": 239,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4J2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4J2?codeType=fs"
     },
     {
      "fs": "4J5",
      "iata": "",
      "icao": "",
      "faa": "4J5",
      "name": "Quitman-Brooks Co",
      "city": "Quitman",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 30.857528,
      "longitude": -83.6155,
      "elevationFeet": 185,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4J5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4J5?codeType=fs"
     },
     {
      "fs": "4J6",
      "iata": "",
      "icao": "",
      "faa": "4J6",
      "name": "St Marys",
      "city": "St Marys",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 30.796667,
      "longitude": -81.623056,
      "elevationFeet": 24,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4J6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4J6?codeType=fs"
     },
     {
      "fs": "4J8",
      "iata": "",
      "icao": "",
      "faa": "4J8",
      "name": "Treutlen Co",
      "city": "Soperton",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.42675,
      "longitude": -82.687444,
      "elevationFeet": 345,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4J8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4J8?codeType=fs"
     },
     {
      "fs": "4K3",
      "iata": "",
      "icao": "",
      "faa": "4K3",
      "name": "Lexington Municipal Airport",
      "city": "Lexington",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.209743,
      "longitude": -94.923781,
      "elevationFeet": 689,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4K3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4K3?codeType=fs"
     },
     {
      "fs": "4K6",
      "iata": "",
      "icao": "",
      "faa": "4K6",
      "name": "Bloomfield Municipal",
      "city": "Bloomfield",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.871056,
      "longitude": -92.532694,
      "elevationFeet": 888,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4K6?codeType=fs"
     },
     {
      "fs": "4K8",
      "iata": "",
      "icao": "",
      "faa": "4K8",
      "name": "Sky Park",
      "city": "Newkirk",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.867,
      "longitude": -97.0615,
      "elevationFeet": 1155,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4K8?codeType=fs"
     },
     {
      "fs": "4M1",
      "iata": "",
      "icao": "",
      "faa": "4M1",
      "name": "Carroll Co",
      "city": "Berryville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.384028,
      "longitude": -93.618556,
      "elevationFeet": 1207,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M1?codeType=fs"
     },
     {
      "fs": "4M2",
      "iata": "",
      "icao": "",
      "faa": "4M2",
      "name": "Booneville Municipal",
      "city": "Booneville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.287028,
      "longitude": -94.004778,
      "elevationFeet": 460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M2?codeType=fs"
     },
     {
      "fs": "4M3",
      "iata": "",
      "icao": "",
      "faa": "4M3",
      "name": "Carlisle Municipal",
      "city": "Carlisle",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.882306,
      "longitude": -91.8205,
      "elevationFeet": 240,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M3?codeType=fs"
     },
     {
      "fs": "4M4",
      "iata": "",
      "icao": "",
      "faa": "4M4",
      "name": "Clinton Municipal",
      "city": "Clinton",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.728556,
      "longitude": -92.46825,
      "elevationFeet": 513,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M4?codeType=fs"
     },
     {
      "fs": "4M5",
      "iata": "",
      "icao": "",
      "faa": "4M5",
      "name": "Dermott Municipal",
      "city": "Dermott",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.540028,
      "longitude": -91.517861,
      "elevationFeet": 135,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M5?codeType=fs"
     },
     {
      "fs": "4M7",
      "iata": "",
      "icao": "",
      "faa": "4M7",
      "name": "Russellville-Logan Co",
      "city": "Russellville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.949167,
      "longitude": -86.901667,
      "elevationFeet": 689,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M7?codeType=fs"
     },
     {
      "fs": "4M8",
      "iata": "",
      "icao": "",
      "faa": "4M8",
      "name": "Clarendon Municipal",
      "city": "Clarendon",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.647999,
      "longitude": -91.394402,
      "elevationFeet": 217,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M8?codeType=fs"
     },
     {
      "fs": "4M9",
      "iata": "",
      "icao": "",
      "faa": "4M9",
      "name": "Corning Municipal",
      "city": "Corning",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.442278,
      "longitude": -90.779194,
      "elevationFeet": 293,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4M9?codeType=fs"
     },
     {
      "fs": "4MO",
      "iata": "",
      "icao": "",
      "faa": "4MO",
      "name": "Montgomery-Wehrman",
      "city": "Montgomery City",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.125417,
      "longitude": -91.44325,
      "elevationFeet": 778,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4MO?codeType=fs"
     },
     {
      "fs": "4N0",
      "iata": "",
      "icao": "",
      "faa": "4N0",
      "name": "Newman'S",
      "city": "Kalamazoo",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.339278,
      "longitude": -85.750111,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4N0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4N0?codeType=fs"
     },
     {
      "fs": "4N1",
      "iata": "",
      "icao": "",
      "faa": "4N1",
      "name": "Greenwood Lake",
      "city": "West Milford",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.235472,
      "longitude": -74.458472,
      "elevationFeet": 791,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4N1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4N1?codeType=fs"
     },
     {
      "fs": "4N2",
      "iata": "",
      "icao": "",
      "faa": "4N2",
      "name": "Middlesex Valley",
      "city": "Middlesex",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.795083,
      "longitude": -77.355361,
      "elevationFeet": 735,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4N2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4N2?codeType=fs"
     },
     {
      "fs": "4N4",
      "iata": "",
      "icao": "",
      "faa": "4N4",
      "name": "Lidgerwood Municipal",
      "city": "Lidgerwood",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.141278,
      "longitude": -97.314778,
      "elevationFeet": 1081,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4N4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4N4?codeType=fs"
     },
     {
      "fs": "4N7",
      "iata": "",
      "icao": "",
      "faa": "4N7",
      "name": "Greene",
      "city": "Greene",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.342417,
      "longitude": -75.821361,
      "elevationFeet": 935,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4N7?codeType=fs"
     },
     {
      "fs": "4N8",
      "iata": "",
      "icao": "",
      "faa": "4N8",
      "name": "White Birch",
      "city": "Hancock",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.050861,
      "longitude": -75.310056,
      "elevationFeet": 1860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4N8?codeType=fs"
     },
     {
      "fs": "4O1",
      "iata": "",
      "icao": "",
      "faa": "4O1",
      "name": "Snyder",
      "city": "Snyder",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.725833,
      "longitude": -99.140278,
      "elevationFeet": 1325,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4O1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4O1?codeType=fs"
     },
     {
      "fs": "4O2",
      "iata": "",
      "icao": "",
      "faa": "4O2",
      "name": "Love Co",
      "city": "Marietta",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.964889,
      "longitude": -97.26125,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4O2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4O2?codeType=fs"
     },
     {
      "fs": "4O4",
      "iata": "",
      "icao": "",
      "faa": "4O4",
      "name": "Mc Curtain Co Regional",
      "city": "Idabel",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.99325,
      "longitude": -94.933528,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4O4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4O4?codeType=fs"
     },
     {
      "fs": "4O5",
      "iata": "",
      "icao": "",
      "faa": "4O5",
      "name": "Cherokee Municipal",
      "city": "Cherokee",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.783639,
      "longitude": -98.3535,
      "elevationFeet": 1177,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4O5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4O5?codeType=fs"
     },
     {
      "fs": "4O7",
      "iata": "",
      "icao": "",
      "faa": "4O7",
      "name": "Decker",
      "city": "Meno",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.405889,
      "longitude": -98.286778,
      "elevationFeet": 1330,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4O7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4O7?codeType=fs"
     },
     {
      "fs": "4P3",
      "iata": "",
      "icao": "",
      "faa": "4P3",
      "name": "Flandreau Municipal",
      "city": "Flandreau",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 44.038611,
      "longitude": -96.681028,
      "elevationFeet": 1645,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4P3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4P3?codeType=fs"
     },
     {
      "fs": "4R1",
      "iata": "",
      "icao": "",
      "faa": "4R1",
      "name": "Bass Memorial",
      "city": "Lumberton",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.154611,
      "longitude": -89.625667,
      "elevationFeet": 310,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R1?codeType=fs"
     },
     {
      "fs": "4R3",
      "iata": "",
      "icao": "",
      "faa": "4R3",
      "name": "Jackson Municipal",
      "city": "Jackson",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.521083,
      "longitude": -87.997222,
      "elevationFeet": 39,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R3?codeType=fs"
     },
     {
      "fs": "4R5",
      "iata": "",
      "icao": "",
      "faa": "4R5",
      "name": "Madeline I",
      "city": "La Pointe",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.836556,
      "longitude": -90.836694,
      "elevationFeet": 648,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R5?codeType=fs"
     },
     {
      "fs": "4R6",
      "iata": "",
      "icao": "",
      "faa": "4R6",
      "name": "Milnor Municipal",
      "city": "Milnor",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.332944,
      "longitude": -97.478694,
      "elevationFeet": 1091,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R6?codeType=fs"
     },
     {
      "fs": "4R8",
      "iata": "",
      "icao": "",
      "faa": "4R8",
      "name": "Jackson",
      "city": "Jackson",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.885167,
      "longitude": -91.21775,
      "elevationFeet": 204,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R8?codeType=fs"
     },
     {
      "fs": "4R9",
      "iata": "",
      "icao": "",
      "faa": "4R9",
      "name": "Dauphin I",
      "city": "Dauphin I",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.354806,
      "longitude": -88.225,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4R9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4R9?codeType=fs"
     },
     {
      "fs": "4S2",
      "iata": "",
      "icao": "",
      "faa": "4S2",
      "name": "Hood River",
      "city": "Hood River",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.6726,
      "longitude": -121.536003,
      "elevationFeet": 631,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S2?codeType=fs"
     },
     {
      "fs": "4S3",
      "iata": "",
      "icao": "",
      "faa": "4S3",
      "name": "Joseph State",
      "city": "Joseph",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.420972,
      "longitude": -117.28225,
      "elevationFeet": 4122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S3?codeType=fs"
     },
     {
      "fs": "4S4",
      "iata": "",
      "icao": "",
      "faa": "4S4",
      "name": "Skyport",
      "city": "Cornelius",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.726139,
      "longitude": -123.078861,
      "elevationFeet": 174,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S4?codeType=fs"
     },
     {
      "fs": "4S5",
      "iata": "",
      "icao": "",
      "faa": "4S5",
      "name": "St Thomas Municipal",
      "city": "St Thomas",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 48.713778,
      "longitude": -97.492472,
      "elevationFeet": 837,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S5?codeType=fs"
     },
     {
      "fs": "4S6",
      "iata": "",
      "icao": "",
      "faa": "4S6",
      "name": "Tieton State",
      "city": "Rimrock",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 46.677556,
      "longitude": -121.186889,
      "elevationFeet": 2961,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S6?codeType=fs"
     },
     {
      "fs": "4S7",
      "iata": "",
      "icao": "",
      "faa": "4S7",
      "name": "Malin",
      "city": "Malin",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 42.009889,
      "longitude": -121.513806,
      "elevationFeet": 4052,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S7?codeType=fs"
     },
     {
      "fs": "4S9",
      "iata": "",
      "icao": "",
      "faa": "4S9",
      "name": "Portland-Mulino",
      "city": "Portland",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.36325,
      "longitude": -122.650833,
      "elevationFeet": 257,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4S9?codeType=fs"
     },
     {
      "fs": "4SD",
      "iata": "",
      "icao": "",
      "faa": "4SD",
      "name": "Reno/Stead",
      "city": "Reno",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 39.673806,
      "longitude": -119.954167,
      "elevationFeet": 5046,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4SD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4SD?codeType=fs"
     },
     {
      "fs": "4T5",
      "iata": "",
      "icao": "",
      "faa": "4T5",
      "name": "Cornell Municipal",
      "city": "Cornell",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.305222,
      "longitude": -91.156972,
      "elevationFeet": 1154,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4T5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4T5?codeType=fs"
     },
     {
      "fs": "4TA2",
      "iata": "",
      "icao": "",
      "faa": "4TA2",
      "name": "Copeland",
      "city": "Ft Worth",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.073472,
      "longitude": -97.533556,
      "elevationFeet": 693,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4TA2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4TA2?codeType=fs"
     },
     {
      "fs": "4U3",
      "iata": "",
      "icao": "",
      "faa": "4U3",
      "name": "Liberty Co",
      "city": "Chester",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.607222,
      "longitude": -111.058639,
      "elevationFeet": 3160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4U3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4U3?codeType=fs"
     },
     {
      "fs": "4U4",
      "iata": "",
      "icao": "",
      "faa": "4U4",
      "name": "Hebbelman",
      "city": "Chinook",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.638861,
      "longitude": -109.173889,
      "elevationFeet": 2576,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4U4?codeType=fs"
     },
     {
      "fs": "4U6",
      "iata": "",
      "icao": "",
      "faa": "4U6",
      "name": "Circle Town Co",
      "city": "Circle",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.436194,
      "longitude": -105.669444,
      "elevationFeet": 2426,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4U6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4U6?codeType=fs"
     },
     {
      "fs": "4U7",
      "iata": "",
      "icao": "",
      "faa": "4U7",
      "name": "West Fork Lodge",
      "city": "Conner",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.974194,
      "longitude": -114.348083,
      "elevationFeet": 4247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4U7?codeType=fs"
     },
     {
      "fs": "4U9",
      "iata": "",
      "icao": "",
      "faa": "4U9",
      "name": "Dell",
      "city": "Dell",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 44.757472,
      "longitude": -112.750139,
      "elevationFeet": 6007,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4U9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4U9?codeType=fs"
     },
     {
      "fs": "4V1",
      "iata": "",
      "icao": "",
      "faa": "4V1",
      "name": "Spanish Peaks",
      "city": "Walsenburg",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 37.814,
      "longitude": -104.78875,
      "elevationFeet": 6050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4V1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4V1?codeType=fs"
     },
     {
      "fs": "4V4",
      "iata": "",
      "icao": "",
      "faa": "4V4",
      "name": "Northwood Mun-Vince",
      "city": "Northwood",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.792333,
      "longitude": -97.654222,
      "elevationFeet": 1117,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4V4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4V4?codeType=fs"
     },
     {
      "fs": "4V6",
      "iata": "",
      "icao": "",
      "faa": "4V6",
      "name": "Hay Springs Municipal",
      "city": "Hay Springs",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 42.791389,
      "longitude": -102.746222,
      "elevationFeet": 3831,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4V6?codeType=fs"
     },
     {
      "fs": "4V8",
      "iata": "",
      "icao": "",
      "faa": "4V8",
      "name": "Mount Snow",
      "city": "West Dover",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.021361,
      "longitude": -73.006528,
      "elevationFeet": 1953,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4V8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4V8?codeType=fs"
     },
     {
      "fs": "4V9",
      "iata": "",
      "icao": "",
      "faa": "4V9",
      "name": "Antelope Co",
      "city": "Neligh",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.222278,
      "longitude": -98.086778,
      "elevationFeet": 1738,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4V9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4V9?codeType=fs"
     },
     {
      "fs": "4W0",
      "iata": "",
      "icao": "",
      "faa": "4W0",
      "name": "Bandera State",
      "city": "Bandera",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 47.506667,
      "longitude": -121.567639,
      "elevationFeet": 1632,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4W0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4W0?codeType=fs"
     },
     {
      "fs": "4W4",
      "iata": "",
      "icao": "",
      "faa": "4W4",
      "name": "Whitfield Farms",
      "city": "Hurdle Mills",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 36.284722,
      "longitude": -79.189028,
      "elevationFeet": 653,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4W4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4W4?codeType=fs"
     },
     {
      "fs": "4W7",
      "iata": "",
      "icao": "",
      "faa": "4W7",
      "name": "Hurdle",
      "city": "Mebane",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 36.068056,
      "longitude": -79.430722,
      "elevationFeet": 680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4W7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4W7?codeType=fs"
     },
     {
      "fs": "4W8",
      "iata": "",
      "icao": "",
      "faa": "4W8",
      "name": "Elma Municipal",
      "city": "Elma",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 47.05375,
      "longitude": -123.557139,
      "elevationFeet": 28,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4W8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4W8?codeType=fs"
     },
     {
      "fs": "4W9",
      "iata": "",
      "icao": "",
      "faa": "4W9",
      "name": "Pink Hill",
      "city": "Pink Hill",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 35.057194,
      "longitude": -77.760861,
      "elevationFeet": 144,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4W9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4W9?codeType=fs"
     },
     {
      "fs": "4XS7",
      "iata": "",
      "icao": "",
      "faa": "4XS7",
      "name": "Horseshoe Bay",
      "city": "Marble Falls",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.620528,
      "longitude": -98.437472,
      "elevationFeet": 1117,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4XS7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4XS7?codeType=fs"
     },
     {
      "fs": "4Y1",
      "iata": "",
      "icao": "",
      "faa": "4Y1",
      "name": "Raether",
      "city": "Howell",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.703333,
      "longitude": -83.915,
      "elevationFeet": 982,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4Y1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4Y1?codeType=fs"
     },
     {
      "fs": "4Y4",
      "iata": "",
      "icao": "",
      "faa": "4Y4",
      "name": "Lakes Of The North",
      "city": "Gaylord",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.025111,
      "longitude": -84.964306,
      "elevationFeet": 1286,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4Y4?codeType=fs"
     },
     {
      "fs": "4Y9",
      "iata": "",
      "icao": "",
      "faa": "4Y9",
      "name": "Bunch'S Half Acre",
      "city": "Harrietta",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.383389,
      "longitude": -85.822889,
      "elevationFeet": 1010,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4Y9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4Y9?codeType=fs"
     },
     {
      "fs": "4Z9",
      "iata": "",
      "icao": "",
      "faa": "4Z9",
      "name": "Jakolof Bay",
      "city": "Jakolof Bay",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 59.471611,
      "longitude": -151.573806,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/4Z9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/4Z9?codeType=fs"
     },
     {
      "fs": "50D",
      "iata": "",
      "icao": "",
      "faa": "50D",
      "name": "Iron Co",
      "city": "Crystal Falls",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.166194,
      "longitude": -88.309694,
      "elevationFeet": 1340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50D?codeType=fs"
     },
     {
      "fs": "50F",
      "iata": "",
      "icao": "",
      "faa": "50F",
      "name": "Bourland",
      "city": "Ft Worth",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.717806,
      "longitude": -97.657694,
      "elevationFeet": 873,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50F?codeType=fs"
     },
     {
      "fs": "50G",
      "iata": "",
      "icao": "",
      "faa": "50G",
      "name": "Nixon Memorial",
      "city": "Chesaning",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.183583,
      "longitude": -84.283083,
      "elevationFeet": 644,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50G?codeType=fs"
     },
     {
      "fs": "50J",
      "iata": "",
      "icao": "",
      "faa": "50J",
      "name": "Berkeley Co",
      "city": "Moncks Corner",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.210556,
      "longitude": -80.056389,
      "elevationFeet": 73,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50J?codeType=fs"
     },
     {
      "fs": "50K",
      "iata": "",
      "icao": "",
      "faa": "50K",
      "name": "Pawnee City Municipal",
      "city": "Pawnee City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.261111,
      "longitude": -96.294528,
      "elevationFeet": 1260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50K?codeType=fs"
     },
     {
      "fs": "50M",
      "iata": "",
      "icao": "",
      "faa": "50M",
      "name": "Puckett",
      "city": "Eagleville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.744444,
      "longitude": -86.75,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50M?codeType=fs"
     },
     {
      "fs": "50R",
      "iata": "",
      "icao": "",
      "faa": "50R",
      "name": "Lockhart Municipal",
      "city": "Lockhart",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.853333,
      "longitude": -97.724167,
      "elevationFeet": 532,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50R?codeType=fs"
     },
     {
      "fs": "50S",
      "iata": "",
      "icao": "",
      "faa": "50S",
      "name": "Parma",
      "city": "Parma",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.887722,
      "longitude": -116.984861,
      "elevationFeet": 2228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/50S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/50S?codeType=fs"
     },
     {
      "fs": "51A",
      "iata": "",
      "icao": "",
      "faa": "51A",
      "name": "Hawkinsville-Pulaski Co",
      "city": "Hawkinsville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.284972,
      "longitude": -83.485028,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51A?codeType=fs"
     },
     {
      "fs": "51D",
      "iata": "",
      "icao": "",
      "faa": "51D",
      "name": "Edgeley Municipal",
      "city": "Edgeley",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.3825,
      "longitude": -98.788889,
      "elevationFeet": 1602,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51D?codeType=fs"
     },
     {
      "fs": "51G",
      "iata": "",
      "icao": "",
      "faa": "51G",
      "name": "Cagney",
      "city": "Clio",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.230833,
      "longitude": -83.907944,
      "elevationFeet": 722,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51G?codeType=fs"
     },
     {
      "fs": "51J",
      "iata": "",
      "icao": "",
      "faa": "51J",
      "name": "Lake City Mun Evans",
      "city": "Lake City",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.885833,
      "longitude": -79.781111,
      "elevationFeet": 80,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51J?codeType=fs"
     },
     {
      "fs": "51K",
      "iata": "",
      "icao": "",
      "faa": "51K",
      "name": "Cedar Air Park",
      "city": "Olathe",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.930317,
      "longitude": -94.883899,
      "elevationFeet": 1007,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51K?codeType=fs"
     },
     {
      "fs": "51M",
      "iata": "",
      "icao": "",
      "faa": "51M",
      "name": "Oscoda Co",
      "city": "Mio",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.805694,
      "longitude": -84.200056,
      "elevationFeet": 1050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51M?codeType=fs"
     },
     {
      "fs": "51R",
      "iata": "",
      "icao": "",
      "faa": "51R",
      "name": "Madisonville Municipal",
      "city": "Madisonville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.028333,
      "longitude": -95.97,
      "elevationFeet": 287,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/51R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/51R?codeType=fs"
     },
     {
      "fs": "52A",
      "iata": "",
      "icao": "",
      "faa": "52A",
      "name": "Madison Municipal",
      "city": "Madison",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.72125,
      "longitude": -83.554444,
      "elevationFeet": 694,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52A?codeType=fs"
     },
     {
      "fs": "52B",
      "iata": "",
      "icao": "",
      "faa": "52B",
      "name": "Greenville Seaplane Base",
      "city": "Greenville",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.561583,
      "longitude": -69.728333,
      "elevationFeet": 1028,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52B?codeType=fs"
     },
     {
      "fs": "52F",
      "iata": "",
      "icao": "",
      "faa": "52F",
      "name": "Northwest Regional",
      "city": "Roanoke",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.198444,
      "longitude": -97.372389,
      "elevationFeet": 643,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52F?codeType=fs"
     },
     {
      "fs": "52I",
      "iata": "",
      "icao": "",
      "faa": "52I",
      "name": "Gross",
      "city": "Pinconning",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.966889,
      "longitude": -84.163778,
      "elevationFeet": 615,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52I?codeType=fs"
     },
     {
      "fs": "52J",
      "iata": "",
      "icao": "",
      "faa": "52J",
      "name": "Lee Co",
      "city": "Bishopville",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.346,
      "longitude": -80.272944,
      "elevationFeet": 216,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52J?codeType=fs"
     },
     {
      "fs": "52K",
      "iata": "",
      "icao": "",
      "faa": "52K",
      "name": "Grutzmacher Municipal",
      "city": "Onaga",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.622167,
      "longitude": -96.252778,
      "elevationFeet": 1183,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52K?codeType=fs"
     },
     {
      "fs": "52OK",
      "iata": "",
      "icao": "",
      "faa": "52OK",
      "name": "Tulsa Security",
      "city": "Tulsa",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.14235,
      "longitude": -95.95869,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52OK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52OK?codeType=fs"
     },
     {
      "fs": "52S",
      "iata": "",
      "icao": "",
      "faa": "52S",
      "name": "St Ignatius",
      "city": "St Ignatius",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.399306,
      "longitude": -114.206639,
      "elevationFeet": 3006,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52S?codeType=fs"
     },
     {
      "fs": "52U",
      "iata": "",
      "icao": "",
      "faa": "52U",
      "name": "Weatherby Usfs",
      "city": "Atlanta",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.898972,
      "longitude": -115.467583,
      "elevationFeet": 4494,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52U?codeType=fs"
     },
     {
      "fs": "52Y",
      "iata": "",
      "icao": "",
      "faa": "52Y",
      "name": "Remer Municipal",
      "city": "Remer",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.080083,
      "longitude": -94.04125,
      "elevationFeet": 1350,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/52Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/52Y?codeType=fs"
     },
     {
      "fs": "53A",
      "iata": "",
      "icao": "",
      "faa": "53A",
      "name": "Savage",
      "city": "Montezuma",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.32,
      "longitude": -84.074722,
      "elevationFeet": 337,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/53A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/53A?codeType=fs"
     },
     {
      "fs": "53K",
      "iata": "",
      "icao": "",
      "faa": "53K",
      "name": "Osage City Municipal",
      "city": "Osage City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.633417,
      "longitude": -95.885972,
      "elevationFeet": 1105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/53K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/53K?codeType=fs"
     },
     {
      "fs": "53M",
      "iata": "",
      "icao": "",
      "faa": "53M",
      "name": "Silver City",
      "city": "Alpena",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.273472,
      "longitude": -83.580278,
      "elevationFeet": 680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/53M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/53M?codeType=fs"
     },
     {
      "fs": "53U",
      "iata": "",
      "icao": "",
      "faa": "53U",
      "name": "Ferndale",
      "city": "Big Fork",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.149528,
      "longitude": -114.009417,
      "elevationFeet": 3060,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/53U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/53U?codeType=fs"
     },
     {
      "fs": "53W",
      "iata": "",
      "icao": "",
      "faa": "53W",
      "name": "Woodruff Lake",
      "city": "Winn",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.59475,
      "longitude": -85.089111,
      "elevationFeet": 940,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/53W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/53W?codeType=fs"
     },
     {
      "fs": "54F",
      "iata": "",
      "icao": "",
      "faa": "54F",
      "name": "Robert Lee",
      "city": "Robert Lee",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.018111,
      "longitude": -100.603778,
      "elevationFeet": 1922,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/54F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/54F?codeType=fs"
     },
     {
      "fs": "54J",
      "iata": "",
      "icao": "",
      "faa": "54J",
      "name": "De Funiak Springs",
      "city": "De Funiak Springs",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.863,
      "longitude": -86.166083,
      "elevationFeet": 289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/54J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/54J?codeType=fs"
     },
     {
      "fs": "54M",
      "iata": "",
      "icao": "",
      "faa": "54M",
      "name": "Wolf River",
      "city": "Rossville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 35.073139,
      "longitude": -89.709139,
      "elevationFeet": 310,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/54M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/54M?codeType=fs"
     },
     {
      "fs": "54T",
      "iata": "",
      "icao": "",
      "faa": "54T",
      "name": "RWJ Airpark",
      "city": "Baytown",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.76304,
      "longitude": -94.846652,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/54T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/54T?codeType=fs"
     },
     {
      "fs": "55D",
      "iata": "",
      "icao": "",
      "faa": "55D",
      "name": "Grayling Aaf",
      "city": "Grayling",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.803194,
      "longitude": -84.838639,
      "elevationFeet": 1158,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55D?codeType=fs"
     },
     {
      "fs": "55G",
      "iata": "",
      "icao": "",
      "faa": "55G",
      "name": "Arnold",
      "city": "Croswell",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.428028,
      "longitude": -82.665944,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55G?codeType=fs"
     },
     {
      "fs": "55H",
      "iata": "",
      "icao": "",
      "faa": "55H",
      "name": "Atlanta",
      "city": "Atlanta",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.935111,
      "longitude": -115.150806,
      "elevationFeet": 5500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55H?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55H?codeType=fs"
     },
     {
      "fs": "55J",
      "iata": "",
      "icao": "",
      "faa": "55J",
      "name": "Fernandina Beach Municipal",
      "city": "Fernandina Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 30.711972,
      "longitude": -81.576028,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55J?codeType=fs"
     },
     {
      "fs": "55K",
      "iata": "",
      "icao": "",
      "faa": "55K",
      "name": "Oxford Municipal",
      "city": "Oxford",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 37.297472,
      "longitude": -97.164278,
      "elevationFeet": 1189,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55K?codeType=fs"
     },
     {
      "fs": "55M",
      "iata": "",
      "icao": "",
      "faa": "55M",
      "name": "Star City Municipal",
      "city": "Star City",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.917694,
      "longitude": -91.868,
      "elevationFeet": 398,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55M?codeType=fs"
     },
     {
      "fs": "55S",
      "iata": "",
      "icao": "",
      "faa": "55S",
      "name": "Packwood",
      "city": "Packwood",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 46.64,
      "longitude": -121.778667,
      "elevationFeet": 1053,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55S?codeType=fs"
     },
     {
      "fs": "55Y",
      "iata": "",
      "icao": "",
      "faa": "55Y",
      "name": "Rushford Municipal",
      "city": "Rushford",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.95825,
      "longitude": -91.950944,
      "elevationFeet": 1211,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/55Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/55Y?codeType=fs"
     },
     {
      "fs": "56D",
      "iata": "",
      "icao": "",
      "faa": "56D",
      "name": "Wyandot Co",
      "city": "Upper Sandusky",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.883611,
      "longitude": -83.445333,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/56D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/56D?codeType=fs"
     },
     {
      "fs": "56F",
      "iata": "",
      "icao": "",
      "faa": "56F",
      "name": "Fisher Co",
      "city": "Rotan/Roby",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.906611,
      "longitude": -100.553861,
      "elevationFeet": 1941,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/56F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/56F?codeType=fs"
     },
     {
      "fs": "56G",
      "iata": "",
      "icao": "",
      "faa": "56G",
      "name": "Indian Creek Ranch",
      "city": "Deckerville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.664083,
      "longitude": -82.7715,
      "elevationFeet": 745,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/56G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/56G?codeType=fs"
     },
     {
      "fs": "56M",
      "iata": "",
      "icao": "",
      "faa": "56M",
      "name": "Warsaw Municipal",
      "city": "Warsaw",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.468889,
      "longitude": -93.45425,
      "elevationFeet": 936,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/56M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/56M?codeType=fs"
     },
     {
      "fs": "56S",
      "iata": "",
      "icao": "",
      "faa": "56S",
      "name": "Seaside Municipal",
      "city": "Seaside",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 46.016499,
      "longitude": -123.904999,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/56S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/56S?codeType=fs"
     },
     {
      "fs": "57B",
      "iata": "",
      "icao": "",
      "faa": "57B",
      "name": "Islesboro",
      "city": "Islesboro",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.302502,
      "longitude": -68.910599,
      "elevationFeet": 92,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/57B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/57B?codeType=fs"
     },
     {
      "fs": "57C",
      "iata": "",
      "icao": "",
      "faa": "57C",
      "name": "East Troy Municipal",
      "city": "East Troy",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.921639,
      "longitude": -88.426167,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/57C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/57C?codeType=fs"
     },
     {
      "fs": "57D",
      "iata": "",
      "icao": "",
      "faa": "57D",
      "name": "Macomb",
      "city": "New Haven",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.775306,
      "longitude": -82.952028,
      "elevationFeet": 632,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/57D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/57D?codeType=fs"
     },
     {
      "fs": "57K",
      "iata": "",
      "icao": "",
      "faa": "57K",
      "name": "Gilmore",
      "city": "Pleasanton",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 38.233639,
      "longitude": -94.880139,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/57K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/57K?codeType=fs"
     },
     {
      "fs": "57S",
      "iata": "",
      "icao": "",
      "faa": "57S",
      "name": "Troy",
      "city": "Troy",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.602194,
      "longitude": -115.935056,
      "elevationFeet": 2017,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/57S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/57S?codeType=fs"
     },
     {
      "fs": "57Y",
      "iata": "",
      "icao": "",
      "faa": "57Y",
      "name": "Sandstone Municipal",
      "city": "Sandstone",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.266167,
      "longitude": -92.885361,
      "elevationFeet": 1089,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/57Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/57Y?codeType=fs"
     },
     {
      "fs": "58C",
      "iata": "",
      "icao": "",
      "faa": "58C",
      "name": "Jana",
      "city": "Edgerton",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.927833,
      "longitude": -89.156694,
      "elevationFeet": 842,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/58C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/58C?codeType=fs"
     },
     {
      "fs": "58F",
      "iata": "",
      "icao": "",
      "faa": "58F",
      "name": "Lane",
      "city": "Sanger",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.503917,
      "longitude": -97.26125,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/58F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/58F?codeType=fs"
     },
     {
      "fs": "58J",
      "iata": "",
      "icao": "",
      "faa": "58J",
      "name": "Huggins Memorial",
      "city": "Timmonsville",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.176556,
      "longitude": -79.956222,
      "elevationFeet": 143,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/58J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/58J?codeType=fs"
     },
     {
      "fs": "58M",
      "iata": "",
      "icao": "",
      "faa": "58M",
      "name": "Cecil Co",
      "city": "Elkton",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.648361,
      "longitude": -75.888278,
      "elevationFeet": 106,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/58M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/58M?codeType=fs"
     },
     {
      "fs": "58N",
      "iata": "",
      "icao": "",
      "faa": "58N",
      "name": "Reigle",
      "city": "Palmyra",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.325917,
      "longitude": -76.674694,
      "elevationFeet": 489,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/58N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/58N?codeType=fs"
     },
     {
      "fs": "58S",
      "iata": "",
      "icao": "",
      "faa": "58S",
      "name": "Whitefish",
      "city": "Whitefish",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 48.480194,
      "longitude": -114.44575,
      "elevationFeet": 3066,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/58S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/58S?codeType=fs"
     },
     {
      "fs": "59B",
      "iata": "",
      "icao": "",
      "faa": "59B",
      "name": "Newton",
      "city": "Jackman",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.769917,
      "longitude": -70.372889,
      "elevationFeet": 1176,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/59B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/59B?codeType=fs"
     },
     {
      "fs": "59M",
      "iata": "",
      "icao": "",
      "faa": "59M",
      "name": "Torchport",
      "city": "Eastport",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.108361,
      "longitude": -85.409056,
      "elevationFeet": 640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/59M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/59M?codeType=fs"
     },
     {
      "fs": "59S",
      "iata": "",
      "icao": "",
      "faa": "59S",
      "name": "Evergreen Field",
      "city": "Vancouver",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.62,
      "longitude": -122.5275,
      "elevationFeet": 311,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/59S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/59S?codeType=fs"
     },
     {
      "fs": "5A1",
      "iata": "",
      "icao": "",
      "faa": "5A1",
      "name": "Norwalk Huron County Airport",
      "city": "Norwalk",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.246906,
      "longitude": -82.549598,
      "elevationFeet": 841,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5A1?codeType=fs"
     },
     {
      "fs": "5A2",
      "iata": "",
      "icao": "",
      "faa": "5A2",
      "name": "Warner Robins",
      "city": "Warner Robins",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.643139,
      "longitude": -83.749056,
      "elevationFeet": 409,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5A2?codeType=fs"
     },
     {
      "fs": "5A4",
      "iata": "",
      "icao": "",
      "faa": "5A4",
      "name": "Okolona Mun-Stovall",
      "city": "Okolona",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.158056,
      "longitude": -88.811889,
      "elevationFeet": 335,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5A4?codeType=fs"
     },
     {
      "fs": "5A6",
      "iata": "",
      "icao": "",
      "faa": "5A6",
      "name": "Winona-Montgomery Co",
      "city": "Winona",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.604,
      "longitude": -89.842472,
      "elevationFeet": 363,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5A6?codeType=fs"
     },
     {
      "fs": "5A9",
      "iata": "",
      "icao": "",
      "faa": "5A9",
      "name": "Roosevelt Memorial",
      "city": "Warm Springs",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 32.934611,
      "longitude": -84.738167,
      "elevationFeet": 880,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5A9?codeType=fs"
     },
     {
      "fs": "5B1",
      "iata": "",
      "icao": "",
      "faa": "5B1",
      "name": "Boylan State",
      "city": "Island Pond",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.864389,
      "longitude": -71.867611,
      "elevationFeet": 1194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B1?codeType=fs"
     },
     {
      "fs": "5B2",
      "iata": "",
      "icao": "",
      "faa": "5B2",
      "name": "Saratoga Co",
      "city": "Saratoga Springs",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.0625,
      "longitude": -73.961944,
      "elevationFeet": 433,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B2?codeType=fs"
     },
     {
      "fs": "5B3",
      "iata": "",
      "icao": "",
      "faa": "5B3",
      "name": "Danielson",
      "city": "Danielson",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.847361,
      "longitude": -71.909611,
      "elevationFeet": 238,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B3?codeType=fs"
     },
     {
      "fs": "5B4",
      "iata": "",
      "icao": "",
      "faa": "5B4",
      "name": "Bowbells Municipal",
      "city": "Bowbells",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 48.8975,
      "longitude": -102.354444,
      "elevationFeet": 1955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B4?codeType=fs"
     },
     {
      "fs": "5B5",
      "iata": "",
      "icao": "",
      "faa": "5B5",
      "name": "Napoleon Municipal",
      "city": "Napoleon",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.59425,
      "longitude": -99.851083,
      "elevationFeet": 1983,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B5?codeType=fs"
     },
     {
      "fs": "5B6",
      "iata": "",
      "icao": "",
      "faa": "5B6",
      "name": "Falmouth",
      "city": "Falmouth",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.598306,
      "longitude": -70.611389,
      "elevationFeet": 43,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B6?codeType=fs"
     },
     {
      "fs": "5B7",
      "iata": "",
      "icao": "",
      "faa": "5B7",
      "name": "Rensselaer Co",
      "city": "Troy",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.759111,
      "longitude": -73.695611,
      "elevationFeet": 440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B7?codeType=fs"
     },
     {
      "fs": "5B9",
      "iata": "",
      "icao": "",
      "faa": "5B9",
      "name": "Dean Memorial",
      "city": "Haverhill",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.206194,
      "longitude": -72.078667,
      "elevationFeet": 580,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5B9?codeType=fs"
     },
     {
      "fs": "5BK",
      "iata": "",
      "icao": "",
      "faa": "5BK",
      "name": "Black Rapids",
      "city": "Black Rapids",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 63.551472,
      "longitude": -145.958861,
      "elevationFeet": 2125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5BK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5BK?codeType=fs"
     },
     {
      "fs": "5C1",
      "iata": "",
      "icao": "",
      "faa": "5C1",
      "name": "Boerne Stage",
      "city": "San Antonio",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.785556,
      "longitude": -98.797472,
      "elevationFeet": 1380,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5C1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5C1?codeType=fs"
     },
     {
      "fs": "5C3",
      "iata": "",
      "icao": "",
      "faa": "5C3",
      "name": "Nary Natl-Shefland",
      "city": "Nary",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.460639,
      "longitude": -94.930528,
      "elevationFeet": 1389,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5C3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5C3?codeType=fs"
     },
     {
      "fs": "5C8",
      "iata": "",
      "icao": "",
      "faa": "5C8",
      "name": "Washburn Municipal",
      "city": "Washburn",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.3805,
      "longitude": -101.123694,
      "elevationFeet": 1905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5C8?codeType=fs"
     },
     {
      "fs": "5CD",
      "iata": "",
      "icao": "",
      "faa": "5CD",
      "name": "Chandalar Shelf",
      "city": "Chandalar Camp",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 68.204389,
      "longitude": -149.697389,
      "elevationFeet": 3222,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5CD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5CD?codeType=fs"
     },
     {
      "fs": "5D2",
      "iata": "",
      "icao": "",
      "faa": "5D2",
      "name": "Northwood Municipal",
      "city": "Northwood",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.463472,
      "longitude": -93.254806,
      "elevationFeet": 1224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5D2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5D2?codeType=fs"
     },
     {
      "fs": "5D3",
      "iata": "",
      "icao": "",
      "faa": "5D3",
      "name": "Owosso Community",
      "city": "Owosso",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.079722,
      "longitude": -84.189139,
      "elevationFeet": 736,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5D3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5D3?codeType=fs"
     },
     {
      "fs": "5D4",
      "iata": "",
      "icao": "",
      "faa": "5D4",
      "name": "Country Club",
      "city": "Goffstown",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.073056,
      "longitude": -71.711833,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5D4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5D4?codeType=fs"
     },
     {
      "fs": "5D5",
      "iata": "",
      "icao": "",
      "faa": "5D5",
      "name": "Woolsey Memorial",
      "city": "Northport",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 45.3,
      "longitude": -85.6175,
      "elevationFeet": 628,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5D5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5D5?codeType=fs"
     },
     {
      "fs": "5D6",
      "iata": "",
      "icao": "",
      "faa": "5D6",
      "name": "Parsons",
      "city": "Carrollton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.781167,
      "longitude": -81.087083,
      "elevationFeet": 1290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5D6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5D6?codeType=fs"
     },
     {
      "fs": "5D9",
      "iata": "",
      "icao": "",
      "faa": "5D9",
      "name": "Bandit Field Airdrome",
      "city": "Clyde",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.224859,
      "longitude": -82.947444,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5D9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5D9?codeType=fs"
     },
     {
      "fs": "5E6",
      "iata": "",
      "icao": "",
      "faa": "5E6",
      "name": "Blair",
      "city": "Blair",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 44.310694,
      "longitude": -91.3155,
      "elevationFeet": 864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5E6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5E6?codeType=fs"
     },
     {
      "fs": "5E9",
      "iata": "",
      "icao": "",
      "faa": "5E9",
      "name": "Packer",
      "city": "Radnor",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.47975,
      "longitude": -83.243611,
      "elevationFeet": 918,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5E9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5E9?codeType=fs"
     },
     {
      "fs": "5F0",
      "iata": "",
      "icao": "",
      "faa": "5F0",
      "name": "Arcadia-Bienville Parish",
      "city": "Arcadia",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.657083,
      "longitude": -92.990472,
      "elevationFeet": 440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5F0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5F0?codeType=fs"
     },
     {
      "fs": "5F1",
      "iata": "",
      "icao": "",
      "faa": "5F1",
      "name": "Post-Garza Co Municipal",
      "city": "Post",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.237056,
      "longitude": -101.404139,
      "elevationFeet": 2545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5F1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5F1?codeType=fs"
     },
     {
      "fs": "5F3",
      "iata": "",
      "icao": "",
      "faa": "5F3",
      "name": "Haynesville",
      "city": "Haynesville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.0125,
      "longitude": -93.184972,
      "elevationFeet": 348,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5F3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5F3?codeType=fs"
     },
     {
      "fs": "5F4",
      "iata": "",
      "icao": "",
      "faa": "5F4",
      "name": "Homer Municipal",
      "city": "Homer",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.835083,
      "longitude": -93.036611,
      "elevationFeet": 244,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5F4?codeType=fs"
     },
     {
      "fs": "5F5",
      "iata": "",
      "icao": "",
      "faa": "5F5",
      "name": "Bluebird Hill",
      "city": "Keithville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.446,
      "longitude": -93.949028,
      "elevationFeet": 180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5F5?codeType=fs"
     },
     {
      "fs": "5F8",
      "iata": "",
      "icao": "",
      "faa": "5F8",
      "name": "Thackers",
      "city": "Oil City",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.868083,
      "longitude": -94.02125,
      "elevationFeet": 202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5F8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5F8?codeType=fs"
     },
     {
      "fs": "5G0",
      "iata": "",
      "icao": "",
      "faa": "5G0",
      "name": "Le Roy",
      "city": "Le Roy",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.113667,
      "longitude": -77.975139,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5G0?codeType=fs"
     },
     {
      "fs": "5G3",
      "iata": "",
      "icao": "",
      "faa": "5G3",
      "name": "Harrold Municipal",
      "city": "Harrold",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 44.663722,
      "longitude": -99.876167,
      "elevationFeet": 1787,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5G3?codeType=fs"
     },
     {
      "fs": "5G4",
      "iata": "",
      "icao": "",
      "faa": "5G4",
      "name": "Eau Claire Lakes",
      "city": "Drummond",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.488333,
      "longitude": -91.632444,
      "elevationFeet": 1214,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5G4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5G4?codeType=fs"
     },
     {
      "fs": "5G6",
      "iata": "",
      "icao": "",
      "faa": "5G6",
      "name": "Cherry Springs",
      "city": "Galeton",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.797222,
      "longitude": -77.833333,
      "elevationFeet": 2330,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5G6?codeType=fs"
     },
     {
      "fs": "5G7",
      "iata": "",
      "icao": "",
      "faa": "5G7",
      "name": "Bluffton",
      "city": "Bluffton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.904444,
      "longitude": -83.886389,
      "elevationFeet": 851,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5G7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5G7?codeType=fs"
     },
     {
      "fs": "5G8",
      "iata": "",
      "icao": "",
      "faa": "5G8",
      "name": "Greensburg Jeannette Regional",
      "city": "Jeannette",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.464583,
      "longitude": -79.68375,
      "elevationFeet": 1188,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5G8?codeType=fs"
     },
     {
      "fs": "5H3",
      "iata": "",
      "icao": "",
      "faa": "5H3",
      "name": "Clear Lake Municipal",
      "city": "Clear Lake",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 44.813528,
      "longitude": -96.731139,
      "elevationFeet": 1801,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5H3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5H3?codeType=fs"
     },
     {
      "fs": "5H4",
      "iata": "",
      "icao": "",
      "faa": "5H4",
      "name": "Harvey Municipal",
      "city": "Harvey",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 47.862222,
      "longitude": -100.067389,
      "elevationFeet": 1605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5H4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5H4?codeType=fs"
     },
     {
      "fs": "5HO",
      "iata": "",
      "icao": "",
      "faa": "5HO",
      "name": "Hope",
      "city": "Hope",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 60.9415,
      "longitude": -149.688389,
      "elevationFeet": 200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5HO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5HO?codeType=fs"
     },
     {
      "fs": "5I2",
      "iata": "",
      "icao": "",
      "faa": "5I2",
      "name": "Flora Municipal",
      "city": "Flora",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.597583,
      "longitude": -86.683333,
      "elevationFeet": 710,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5I2?codeType=fs"
     },
     {
      "fs": "5I4",
      "iata": "",
      "icao": "",
      "faa": "5I4",
      "name": "Sheridan Airport",
      "city": "Sheridan",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.182339,
      "longitude": -86.217056,
      "elevationFeet": 934,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5I4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5I4?codeType=fs"
     },
     {
      "fs": "5I6",
      "iata": "",
      "icao": "",
      "faa": "5I6",
      "name": "Galveston",
      "city": "Galveston",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.592056,
      "longitude": -86.319417,
      "elevationFeet": 786,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5I6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5I6?codeType=fs"
     },
     {
      "fs": "5J5",
      "iata": "",
      "icao": "",
      "faa": "5J5",
      "name": "Holly Hill",
      "city": "Holly Hill",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.309944,
      "longitude": -80.489833,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5J5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5J5?codeType=fs"
     },
     {
      "fs": "5J9",
      "iata": "",
      "icao": "",
      "faa": "5J9",
      "name": "Twin City",
      "city": "Loris",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 34.135667,
      "longitude": -78.996194,
      "elevationFeet": 99,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5J9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5J9?codeType=fs"
     },
     {
      "fs": "5K0",
      "iata": "",
      "icao": "",
      "faa": "5K0",
      "name": "Bressler",
      "city": "Bird City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.824944,
      "longitude": -101.607222,
      "elevationFeet": 3489,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5K0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5K0?codeType=fs"
     },
     {
      "fs": "5K1",
      "iata": "",
      "icao": "",
      "faa": "5K1",
      "name": "Zelmer Memorial",
      "city": "Palmyra",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.450472,
      "longitude": -90.062167,
      "elevationFeet": 663,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5K1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5K1?codeType=fs"
     },
     {
      "fs": "5K2",
      "iata": "",
      "icao": "",
      "faa": "5K2",
      "name": "Tribune Municipal",
      "city": "Tribune",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 38.491833,
      "longitude": -101.862833,
      "elevationFeet": 3620,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5K2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5K2?codeType=fs"
     },
     {
      "fs": "5K4",
      "iata": "",
      "icao": "",
      "faa": "5K4",
      "name": "Schuy-Rush",
      "city": "Rushville",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 40.125472,
      "longitude": -90.654056,
      "elevationFeet": 665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5K4?codeType=fs"
     },
     {
      "fs": "5K6",
      "iata": "",
      "icao": "",
      "faa": "5K6",
      "name": "Westosha",
      "city": "Wilmot",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.639083,
      "longitude": -88.284222,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5K6?codeType=fs"
     },
     {
      "fs": "5K9",
      "iata": "",
      "icao": "",
      "faa": "5K9",
      "name": "Pruetz Municipal",
      "city": "Kulm",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.338583,
      "longitude": -99.0205,
      "elevationFeet": 1982,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5K9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5K9?codeType=fs"
     },
     {
      "fs": "5KS",
      "iata": "",
      "icao": "",
      "faa": "5KS",
      "name": "Kasilof",
      "city": "Kasilof",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 60.383083,
      "longitude": -151.377722,
      "elevationFeet": 125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5KS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5KS?codeType=fs"
     },
     {
      "fs": "5L0",
      "iata": "",
      "icao": "",
      "faa": "5L0",
      "name": "Lakota Municipal",
      "city": "Lakota",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 48.163889,
      "longitude": -98.428806,
      "elevationFeet": 1515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5L0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5L0?codeType=fs"
     },
     {
      "fs": "5L7",
      "iata": "",
      "icao": "",
      "faa": "5L7",
      "name": "Larsh",
      "city": "Colfax",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.233722,
      "longitude": -86.711167,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5L7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5L7?codeType=fs"
     },
     {
      "fs": "5M0",
      "iata": "",
      "icao": "",
      "faa": "5M0",
      "name": "Rountree",
      "city": "Hartselle",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.482333,
      "longitude": -87.0795,
      "elevationFeet": 628,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M0?codeType=fs"
     },
     {
      "fs": "5M1",
      "iata": "",
      "icao": "",
      "faa": "5M1",
      "name": "De Witt Municipal",
      "city": "De Witt",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.376,
      "longitude": -91.398417,
      "elevationFeet": 190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M1?codeType=fs"
     },
     {
      "fs": "5M2",
      "iata": "",
      "icao": "",
      "faa": "5M2",
      "name": "Bredlow Farm",
      "city": "England",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.534278,
      "longitude": -92.101444,
      "elevationFeet": 233,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M2?codeType=fs"
     },
     {
      "fs": "5M3",
      "iata": "",
      "icao": "",
      "faa": "5M3",
      "name": "Moultonboro",
      "city": "Moultonboro",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.784083,
      "longitude": -71.417389,
      "elevationFeet": 571,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M3?codeType=fs"
     },
     {
      "fs": "5M4",
      "iata": "",
      "icao": "",
      "faa": "5M4",
      "name": "Hopkins-Fordyce Municipal",
      "city": "Fordyce",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.959361,
      "longitude": -92.504278,
      "elevationFeet": 193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M4?codeType=fs"
     },
     {
      "fs": "5M5",
      "iata": "",
      "icao": "",
      "faa": "5M5",
      "name": "Crystal Lake",
      "city": "Decatur",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.436389,
      "longitude": -94.548333,
      "elevationFeet": 1180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M5?codeType=fs"
     },
     {
      "fs": "5M7",
      "iata": "",
      "icao": "",
      "faa": "5M7",
      "name": "Mountain Lakes",
      "city": "Helena",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 46.757694,
      "longitude": -111.8665,
      "elevationFeet": 4250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M7?codeType=fs"
     },
     {
      "fs": "5M8",
      "iata": "",
      "icao": "",
      "faa": "5M8",
      "name": "Gurdon Lowe",
      "city": "Gurdon",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 34.001028,
      "longitude": -93.276694,
      "elevationFeet": 229,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M8?codeType=fs"
     },
     {
      "fs": "5M9",
      "iata": "",
      "icao": "",
      "faa": "5M9",
      "name": "Marion-Crittenden Co",
      "city": "Marion",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 37.361611,
      "longitude": -88.211361,
      "elevationFeet": 650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5M9?codeType=fs"
     },
     {
      "fs": "5MD1",
      "iata": "",
      "icao": "",
      "faa": "5MD1",
      "name": "Brooklandville Heliport",
      "city": "Brooklandville",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 39.426861,
      "longitude": -76.789972,
      "elevationFeet": 291,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5MD1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5MD1?codeType=fs"
     },
     {
      "fs": "5MO",
      "iata": "",
      "icao": "",
      "faa": "5MO",
      "name": "Plattsburg",
      "city": "Plattsburg",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.694444,
      "longitude": -94.577278,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5MO?codeType=fs"
     },
     {
      "fs": "5N3",
      "iata": "",
      "icao": "",
      "faa": "5N3",
      "name": "Grund",
      "city": "Ithaca",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.572944,
      "longitude": -76.718889,
      "elevationFeet": 1453,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5N3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5N3?codeType=fs"
     },
     {
      "fs": "5N4",
      "iata": "",
      "icao": "",
      "faa": "5N4",
      "name": "Sky Haven",
      "city": "Enderlin",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.721944,
      "longitude": -97.65375,
      "elevationFeet": 1147,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5N4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5N4?codeType=fs"
     },
     {
      "fs": "5N5",
      "iata": "",
      "icao": "",
      "faa": "5N5",
      "name": "Kirkwood",
      "city": "Kirkwood",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.003556,
      "longitude": -75.851861,
      "elevationFeet": 870,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5N5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5N5?codeType=fs"
     },
     {
      "fs": "5N6",
      "iata": "",
      "icao": "",
      "faa": "5N6",
      "name": "Ridgefield Park",
      "city": "Ridgefield Park",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 40.959333,
      "longitude": -74.137499,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5N6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5N6?codeType=fs"
     },
     {
      "fs": "5N7",
      "iata": "",
      "icao": "",
      "faa": "5N7",
      "name": "Hat Field",
      "city": "Nunica",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.09767,
      "longitude": -86.093084,
      "elevationFeet": 622,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5N7?codeType=fs"
     },
     {
      "fs": "5N8",
      "iata": "",
      "icao": "",
      "faa": "5N8",
      "name": "Casselton Regional",
      "city": "Casselton",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 46.896944,
      "longitude": -97.287,
      "elevationFeet": 932,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5N8?codeType=fs"
     },
     {
      "fs": "5O1",
      "iata": "",
      "icao": "",
      "faa": "5O1",
      "name": "Vici Municipal",
      "city": "Vici",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 36.217083,
      "longitude": -99.331611,
      "elevationFeet": 2268,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5O1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5O1?codeType=fs"
     },
     {
      "fs": "5P2",
      "iata": "",
      "icao": "",
      "faa": "5P2",
      "name": "Mc Laughlin Municipal",
      "city": "Mc Laughlin",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.918056,
      "longitude": -100.792444,
      "elevationFeet": 2006,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5P2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5P2?codeType=fs"
     },
     {
      "fs": "5P3",
      "iata": "",
      "icao": "",
      "faa": "5P3",
      "name": "Bowdle Municipal",
      "city": "Bowdle",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.494278,
      "longitude": -99.751167,
      "elevationFeet": 1967,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5P3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5P3?codeType=fs"
     },
     {
      "fs": "5P5",
      "iata": "",
      "icao": "",
      "faa": "5P5",
      "name": "Presho Municipal",
      "city": "Presho",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.963778,
      "longitude": -100.070667,
      "elevationFeet": 1760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5P5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5P5?codeType=fs"
     },
     {
      "fs": "5QC",
      "iata": "",
      "icao": "",
      "faa": "5QC",
      "name": "Quartz Creek Kougarok",
      "city": "Quartz Creek",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 65.459333,
      "longitude": -164.70725,
      "elevationFeet": 416,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5QC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5QC?codeType=fs"
     },
     {
      "fs": "5R1",
      "iata": "",
      "icao": "",
      "faa": "5R1",
      "name": "Wilcox",
      "city": "Chatom",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.468333,
      "longitude": -88.294528,
      "elevationFeet": 165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5R1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5R1?codeType=fs"
     },
     {
      "fs": "5R2",
      "iata": "",
      "icao": "",
      "faa": "5R2",
      "name": "Ocean Springs",
      "city": "Ocean Springs",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.444444,
      "longitude": -88.784444,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5R2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5R2?codeType=fs"
     },
     {
      "fs": "5R3",
      "iata": "",
      "icao": "",
      "faa": "5R3",
      "name": "Lago Vista-Allen",
      "city": "Lago Vista",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.635861,
      "longitude": -97.994722,
      "elevationFeet": 1231,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5R3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5R3?codeType=fs"
     },
     {
      "fs": "5R4",
      "iata": "",
      "icao": "",
      "faa": "5R4",
      "name": "Foley Municipal",
      "city": "Foley",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.526972,
      "longitude": -87.708194,
      "elevationFeet": 74,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5R4?codeType=fs"
     },
     {
      "fs": "5R7",
      "iata": "",
      "icao": "",
      "faa": "5R7",
      "name": "Ray",
      "city": "Bayou La Batre",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.496417,
      "longitude": -88.305583,
      "elevationFeet": 80,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5R7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5R7?codeType=fs"
     },
     {
      "fs": "5R8",
      "iata": "",
      "icao": "",
      "faa": "5R8",
      "name": "De Quincy Industrial",
      "city": "De Quincy",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.511722,
      "longitude": -93.534972,
      "elevationFeet": 81,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5R8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5R8?codeType=fs"
     },
     {
      "fs": "5S0",
      "iata": "",
      "icao": "",
      "faa": "5S0",
      "name": "Oakridge State",
      "city": "Oakridge",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.776222,
      "longitude": -122.5255,
      "elevationFeet": 1393,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S0?codeType=fs"
     },
     {
      "fs": "5S1",
      "iata": "",
      "icao": "",
      "faa": "5S1",
      "name": "Felt",
      "city": "Roseburg",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.298389,
      "longitude": -123.520194,
      "elevationFeet": 428,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S1?codeType=fs"
     },
     {
      "fs": "5S2",
      "iata": "",
      "icao": "",
      "faa": "5S2",
      "name": "Crescent Lake State",
      "city": "Crescent Lake",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.67625,
      "longitude": -121.950306,
      "elevationFeet": 4810,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S2?codeType=fs"
     },
     {
      "fs": "5S4",
      "iata": "",
      "icao": "",
      "faa": "5S4",
      "name": "Toledo State",
      "city": "Toledo",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 44.609528,
      "longitude": -123.995583,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S4?codeType=fs"
     },
     {
      "fs": "5S5",
      "iata": "",
      "icao": "",
      "faa": "5S5",
      "name": "Lake Billy Chinook State",
      "city": "Culver",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 44.542861,
      "longitude": -121.356,
      "elevationFeet": 2695,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S5?codeType=fs"
     },
     {
      "fs": "5S6",
      "iata": "",
      "icao": "",
      "faa": "5S6",
      "name": "Cape Blanco State",
      "city": "Denmark",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 42.928861,
      "longitude": -124.526083,
      "elevationFeet": 214,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S6?codeType=fs"
     },
     {
      "fs": "5S9",
      "iata": "",
      "icao": "",
      "faa": "5S9",
      "name": "Valley View",
      "city": "Estacada",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 45.381778,
      "longitude": -122.336972,
      "elevationFeet": 735,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5S9?codeType=fs"
     },
     {
      "fs": "5T0",
      "iata": "",
      "icao": "",
      "faa": "5T0",
      "name": "Ward",
      "city": "Beasley",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 29.530556,
      "longitude": -95.95,
      "elevationFeet": 105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5T0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5T0?codeType=fs"
     },
     {
      "fs": "5T4",
      "iata": "",
      "icao": "",
      "faa": "5T4",
      "name": "Herreid Municipal",
      "city": "Herreid",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 45.891583,
      "longitude": -100.153944,
      "elevationFeet": 1725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5T4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5T4?codeType=fs"
     },
     {
      "fs": "5T5",
      "iata": "",
      "icao": "",
      "faa": "5T5",
      "name": "Hillsboro Municipal",
      "city": "Hillsboro",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.085,
      "longitude": -97.221667,
      "elevationFeet": 685,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5T5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5T5?codeType=fs"
     },
     {
      "fs": "5U0",
      "iata": "",
      "icao": "",
      "faa": "5U0",
      "name": "Denton",
      "city": "Denton",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.358056,
      "longitude": -110.018639,
      "elevationFeet": 3592,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U0?codeType=fs"
     },
     {
      "fs": "5U1",
      "iata": "",
      "icao": "",
      "faa": "5U1",
      "name": "Dutton",
      "city": "Dutton",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.971806,
      "longitude": -111.833222,
      "elevationFeet": 3699,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U1?codeType=fs"
     },
     {
      "fs": "5U3",
      "iata": "",
      "icao": "",
      "faa": "5U3",
      "name": "Ennis-Big Sky",
      "city": "Ennis",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.289806,
      "longitude": -111.786389,
      "elevationFeet": 5383,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U3?codeType=fs"
     },
     {
      "fs": "5U5",
      "iata": "",
      "icao": "",
      "faa": "5U5",
      "name": "Fairfield",
      "city": "Fairfield",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.741167,
      "longitude": -112.1,
      "elevationFeet": 3989,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U5?codeType=fs"
     },
     {
      "fs": "5U6",
      "iata": "",
      "icao": "",
      "faa": "5U6",
      "name": "Fairview",
      "city": "Fairview",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.961306,
      "longitude": -104.127111,
      "elevationFeet": 2152,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U6?codeType=fs"
     },
     {
      "fs": "5U7",
      "iata": "",
      "icao": "",
      "faa": "5U7",
      "name": "Ft Smith",
      "city": "Ft Smith",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 45.357917,
      "longitude": -108.062222,
      "elevationFeet": 3242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U7?codeType=fs"
     },
     {
      "fs": "5U8",
      "iata": "",
      "icao": "",
      "faa": "5U8",
      "name": "Geraldine",
      "city": "Geraldine",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 47.716389,
      "longitude": -110.410361,
      "elevationFeet": 3173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5U8?codeType=fs"
     },
     {
      "fs": "5V4",
      "iata": "",
      "icao": "",
      "faa": "5V4",
      "name": "Calhan",
      "city": "Calhan",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 39.177667,
      "longitude": -104.371861,
      "elevationFeet": 6450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5V4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5V4?codeType=fs"
     },
     {
      "fs": "5V5",
      "iata": "",
      "icao": "",
      "faa": "5V5",
      "name": "Shiprock Airstrip",
      "city": "Shiprock",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 36.827778,
      "longitude": -108.711972,
      "elevationFeet": 5270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5V5?codeType=fs"
     },
     {
      "fs": "5V6",
      "iata": "",
      "icao": "",
      "faa": "5V6",
      "name": "Gebauer",
      "city": "Akron",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 40.34425,
      "longitude": -103.1855,
      "elevationFeet": 4509,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5V6?codeType=fs"
     },
     {
      "fs": "5V8",
      "iata": "",
      "icao": "",
      "faa": "5V8",
      "name": "Kadoka Municipal",
      "city": "Kadoka",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 43.983278,
      "longitude": -101.620889,
      "elevationFeet": 2460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5V8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5V8?codeType=fs"
     },
     {
      "fs": "5V9",
      "iata": "",
      "icao": "",
      "faa": "5V9",
      "name": "Navajo",
      "city": "Arboles",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.681",
      "utcOffsetHours": -7,
      "latitude": 37.013944,
      "longitude": -107.47825,
      "elevationFeet": 6110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5V9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5V9?codeType=fs"
     },
     {
      "fs": "5W1",
      "iata": "",
      "icao": "",
      "faa": "5W1",
      "name": "Wilson Creek",
      "city": "Wilson Creek",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 47.498667,
      "longitude": -119.250167,
      "elevationFeet": 1440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5W1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5W1?codeType=fs"
     },
     {
      "fs": "5W4",
      "iata": "",
      "icao": "",
      "faa": "5W4",
      "name": "P K Airpark",
      "city": "Raeford",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 35.048611,
      "longitude": -79.260028,
      "elevationFeet": 304,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5W4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5W4?codeType=fs"
     },
     {
      "fs": "5W5",
      "iata": "",
      "icao": "",
      "faa": "5W5",
      "name": "Triple W Airport",
      "city": "Raleigh",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 35.620073,
      "longitude": -78.70076,
      "elevationFeet": 243,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5W5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5W5?codeType=fs"
     },
     {
      "fs": "5W8",
      "iata": "",
      "icao": "",
      "faa": "5W8",
      "name": "Siler City Municipal",
      "city": "Siler City",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 35.729167,
      "longitude": -79.553,
      "elevationFeet": 614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5W8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5W8?codeType=fs"
     },
     {
      "fs": "5Y0",
      "iata": "",
      "icao": "",
      "faa": "5Y0",
      "name": "Harrisville",
      "city": "Harrisville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.708472,
      "longitude": -83.341333,
      "elevationFeet": 675,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Y0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Y0?codeType=fs"
     },
     {
      "fs": "5Y1",
      "iata": "",
      "icao": "",
      "faa": "5Y1",
      "name": "Lindberg",
      "city": "Hessel",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 46.0585,
      "longitude": -84.447583,
      "elevationFeet": 760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Y1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Y1?codeType=fs"
     },
     {
      "fs": "5Y2",
      "iata": "",
      "icao": "",
      "faa": "5Y2",
      "name": "Houghton Lake Heights",
      "city": "Houghton Heights",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.441833,
      "longitude": -84.866944,
      "elevationFeet": 1165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Y2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Y2?codeType=fs"
     },
     {
      "fs": "5Y3",
      "iata": "",
      "icao": "",
      "faa": "5Y3",
      "name": "Gutzmer'S Twin Oaks",
      "city": "Whitewater",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.89175,
      "longitude": -88.862167,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Y3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Y3?codeType=fs"
     },
     {
      "fs": "5Y4",
      "iata": "",
      "icao": "",
      "faa": "5Y4",
      "name": "Lost Creek",
      "city": "Luzerne",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 44.750139,
      "longitude": -84.275111,
      "elevationFeet": 1051,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Y4?codeType=fs"
     },
     {
      "fs": "5Y7",
      "iata": "",
      "icao": "",
      "faa": "5Y7",
      "name": "Hanley",
      "city": "Munising",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 46.391167,
      "longitude": -86.659917,
      "elevationFeet": 984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Y7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Y7?codeType=fs"
     },
     {
      "fs": "5Z5",
      "iata": "",
      "icao": "",
      "faa": "5Z5",
      "name": "Kantishna",
      "city": "Kantishna",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.681",
      "utcOffsetHours": -9,
      "latitude": 63.617139,
      "longitude": -151.089556,
      "elevationFeet": 1575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/5Z5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/5Z5?codeType=fs"
     },
     {
      "fs": "60A",
      "iata": "",
      "icao": "",
      "faa": "60A",
      "name": "Brundidge Municipal",
      "city": "Brundidge",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 31.734944,
      "longitude": -85.846667,
      "elevationFeet": 476,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60A?codeType=fs"
     },
     {
      "fs": "60C",
      "iata": "",
      "icao": "",
      "faa": "60C",
      "name": "Elroy Municipal",
      "city": "Elroy",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.763611,
      "longitude": -90.326278,
      "elevationFeet": 944,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60C?codeType=fs"
     },
     {
      "fs": "60F",
      "iata": "",
      "icao": "",
      "faa": "60F",
      "name": "Seymour Municipal",
      "city": "Seymour",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 33.787056,
      "longitude": -99.356306,
      "elevationFeet": 1344,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60F?codeType=fs"
     },
     {
      "fs": "60G",
      "iata": "",
      "icao": "",
      "faa": "60G",
      "name": "Skyway Estates",
      "city": "Eaton Rapids",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.586472,
      "longitude": -84.663694,
      "elevationFeet": 931,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60G?codeType=fs"
     },
     {
      "fs": "60J",
      "iata": "",
      "icao": "",
      "faa": "60J",
      "name": "Ocean Isle",
      "city": "Ocean Isle Beach",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 33.985056,
      "longitude": -78.466722,
      "elevationFeet": 32,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60J?codeType=fs"
     },
     {
      "fs": "60M",
      "iata": "",
      "icao": "",
      "faa": "60M",
      "name": "Spencer",
      "city": "Spencer",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.367583,
      "longitude": -72.070194,
      "elevationFeet": 1040,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60M?codeType=fs"
     },
     {
      "fs": "60R",
      "iata": "",
      "icao": "",
      "faa": "60R",
      "name": "Navasota Municipal",
      "city": "Navasota",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.418889,
      "longitude": -96.232778,
      "elevationFeet": 228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60R?codeType=fs"
     },
     {
      "fs": "60Y",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Slayton Municipal",
      "city": "Slayton",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 44.017917,
      "longitude": -95.926111,
      "elevationFeet": 1623,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/60Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/60Y?codeType=fs"
     },
     {
      "fs": "61A",
      "iata": "",
      "icao": "",
      "faa": "61A",
      "name": "Camden Municipal",
      "city": "Camden",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 32.098694,
      "longitude": -87.388806,
      "elevationFeet": 143,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61A?codeType=fs"
     },
     {
      "fs": "61C",
      "iata": "",
      "icao": "",
      "faa": "61C",
      "name": "Ft Atkinson Municipal",
      "city": "Ft Atkinson",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 43.082,
      "longitude": -88.826333,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61C?codeType=fs"
     },
     {
      "fs": "61D",
      "iata": "",
      "icao": "",
      "faa": "61D",
      "name": "Plainwell Municipal",
      "city": "Plainwell",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 42.480917,
      "longitude": -85.772389,
      "elevationFeet": 722,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61D?codeType=fs"
     },
     {
      "fs": "61G",
      "iata": "",
      "icao": "",
      "faa": "61G",
      "name": "Randolph'S Landing Area",
      "city": "St Johns",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 43.225306,
      "longitude": -84.558222,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61G?codeType=fs"
     },
     {
      "fs": "61K",
      "iata": "",
      "icao": "",
      "faa": "61K",
      "name": "Sedan City",
      "city": "Sedan",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 37.283861,
      "longitude": -96.202694,
      "elevationFeet": 1005,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61K?codeType=fs"
     },
     {
      "fs": "61R",
      "iata": "",
      "icao": "",
      "faa": "61R",
      "name": "Newton Municipal",
      "city": "Newton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.893667,
      "longitude": -93.818444,
      "elevationFeet": 320,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61R?codeType=fs"
     },
     {
      "fs": "61S",
      "iata": "",
      "icao": "",
      "faa": "61S",
      "name": "Cottage Grove State",
      "city": "Cottage Grove",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.948444,
      "longitude": -123.139667,
      "elevationFeet": 640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61S?codeType=fs"
     },
     {
      "fs": "61Y",
      "iata": "",
      "icao": "",
      "faa": "61Y",
      "name": "Koch",
      "city": "Poseyville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 38.275833,
      "longitude": -87.843278,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/61Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/61Y?codeType=fs"
     },
     {
      "fs": "62C",
      "iata": "",
      "icao": "",
      "faa": "62C",
      "name": "Cindy Guntly Memorial",
      "city": "Franksville",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 42.913889,
      "longitude": -88.193056,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/62C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/62C?codeType=fs"
     },
     {
      "fs": "62D",
      "iata": "",
      "icao": "",
      "faa": "62D",
      "name": "Warren",
      "city": "Warren",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.681",
      "utcOffsetHours": -5,
      "latitude": 41.267222,
      "longitude": -81.039778,
      "elevationFeet": 905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/62D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/62D?codeType=fs"
     },
     {
      "fs": "62H",
      "iata": "",
      "icao": "",
      "faa": "62H",
      "name": "Giddings-Lee Co",
      "city": "Giddings",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 30.192667,
      "longitude": -97.100167,
      "elevationFeet": 486,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/62H?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/62H?codeType=fs"
     },
     {
      "fs": "62K",
      "iata": "",
      "icao": "",
      "faa": "62K",
      "name": "Seneca Municipal",
      "city": "Seneca",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.681",
      "utcOffsetHours": -6,
      "latitude": 39.972222,
      "longitude": -96.227806,
      "elevationFeet": 1270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/62K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/62K?codeType=fs"
     },
     {
      "fs": "62S",
      "iata": "",
      "icao": "",
      "faa": "62S",
      "name": "Christmas Valley",
      "city": "Christmas Valley",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.681",
      "utcOffsetHours": -8,
      "latitude": 43.265306,
      "longitude": -120.810972,
      "elevationFeet": 4317,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/62S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/62S?codeType=fs"
     },
     {
      "fs": "63B",
      "iata": "",
      "icao": "",
      "faa": "63B",
      "name": "Limington-Harmon",
      "city": "Limington",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.892444,
      "longitude": -70.731139,
      "elevationFeet": 291,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63B?codeType=fs"
     },
     {
      "fs": "63C",
      "iata": "",
      "icao": "",
      "faa": "63C",
      "name": "Adams Co Legion",
      "city": "Friendship",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.061722,
      "longitude": -89.8305,
      "elevationFeet": 976,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63C?codeType=fs"
     },
     {
      "fs": "63F",
      "iata": "",
      "icao": "",
      "faa": "63F",
      "name": "Stanton Municipal",
      "city": "Stanton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.235833,
      "longitude": -101.874722,
      "elevationFeet": 2731,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63F?codeType=fs"
     },
     {
      "fs": "63K",
      "iata": "",
      "icao": "",
      "faa": "63K",
      "name": "Hillside",
      "city": "Stilwell",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.861194,
      "longitude": -94.696778,
      "elevationFeet": 1025,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63K?codeType=fs"
     },
     {
      "fs": "63M",
      "iata": "",
      "icao": "",
      "faa": "63M",
      "name": "Hermann Municipal",
      "city": "Hermann",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.753222,
      "longitude": -91.551639,
      "elevationFeet": 510,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63M?codeType=fs"
     },
     {
      "fs": "63S",
      "iata": "",
      "icao": "",
      "faa": "63S",
      "name": "Colville Municipal",
      "city": "Colville",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 48.615694,
      "longitude": -117.89425,
      "elevationFeet": 1878,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63S?codeType=fs"
     },
     {
      "fs": "63Y",
      "iata": "",
      "icao": "",
      "faa": "63Y",
      "name": "Tyler Municipal",
      "city": "Tyler",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.366333,
      "longitude": -96.153111,
      "elevationFeet": 1742,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/63Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/63Y?codeType=fs"
     },
     {
      "fs": "64C",
      "iata": "",
      "icao": "",
      "faa": "64C",
      "name": "Vincent",
      "city": "Genoa City",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.533528,
      "longitude": -88.303694,
      "elevationFeet": 880,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/64C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/64C?codeType=fs"
     },
     {
      "fs": "64F",
      "iata": "",
      "icao": "",
      "faa": "64F",
      "name": "Cole Ranch",
      "city": "Sterling City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.737583,
      "longitude": -100.995528,
      "elevationFeet": 2444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/64F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/64F?codeType=fs"
     },
     {
      "fs": "64I",
      "iata": "",
      "icao": "",
      "faa": "64I",
      "name": "Lee Bottom",
      "city": "Hanover",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.761722,
      "longitude": -85.535694,
      "elevationFeet": 470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/64I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/64I?codeType=fs"
     },
     {
      "fs": "64S",
      "iata": "",
      "icao": "",
      "faa": "64S",
      "name": "Prospect State",
      "city": "Prospect",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 42.831833,
      "longitude": -122.530917,
      "elevationFeet": 2578,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/64S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/64S?codeType=fs"
     },
     {
      "fs": "64V",
      "iata": "",
      "icao": "",
      "faa": "64V",
      "name": "Wallace Municipal",
      "city": "Wallace",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.97225,
      "longitude": -101.290444,
      "elevationFeet": 3101,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/64V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/64V?codeType=fs"
     },
     {
      "fs": "65B",
      "iata": "",
      "icao": "",
      "faa": "65B",
      "name": "Lubec Municipal",
      "city": "Lubec",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.875806,
      "longitude": -67.177583,
      "elevationFeet": 85,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/65B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/65B?codeType=fs"
     },
     {
      "fs": "65G",
      "iata": "",
      "icao": "",
      "faa": "65G",
      "name": "Maple Grove",
      "city": "Fowlerville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.722556,
      "longitude": -84.174611,
      "elevationFeet": 908,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/65G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/65G?codeType=fs"
     },
     {
      "fs": "65J",
      "iata": "",
      "icao": "",
      "faa": "65J",
      "name": "Wrens Memorial",
      "city": "Wrens",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.276444,
      "longitude": -82.387361,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/65J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/65J?codeType=fs"
     },
     {
      "fs": "65S",
      "iata": "",
      "icao": "",
      "faa": "65S",
      "name": "Boundary Co",
      "city": "Bonners Ferry",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 48.813278,
      "longitude": -116.404778,
      "elevationFeet": 2331,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/65S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/65S?codeType=fs"
     },
     {
      "fs": "66B",
      "iata": "",
      "icao": "",
      "faa": "66B",
      "name": "Gillespie",
      "city": "Meddybemps",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 45.034111,
      "longitude": -67.494361,
      "elevationFeet": 200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/66B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/66B?codeType=fs"
     },
     {
      "fs": "66G",
      "iata": "",
      "icao": "",
      "faa": "66G",
      "name": "Zehnder",
      "city": "Frankenmuth",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.439139,
      "longitude": -83.796833,
      "elevationFeet": 645,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/66G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/66G?codeType=fs"
     },
     {
      "fs": "66R",
      "iata": "",
      "icao": "",
      "faa": "66R",
      "name": "Wells Jr",
      "city": "Columbus",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.710694,
      "longitude": -96.658028,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/66R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/66R?codeType=fs"
     },
     {
      "fs": "66S",
      "iata": "",
      "icao": "",
      "faa": "66S",
      "name": "Cavanaugh Bay",
      "city": "Coolin",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 48.557556,
      "longitude": -116.952056,
      "elevationFeet": 2484,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/66S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/66S?codeType=fs"
     },
     {
      "fs": "66V",
      "iata": "",
      "icao": "",
      "faa": "66V",
      "name": "Bluff",
      "city": "Bluff",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 37.25,
      "longitude": -109.640111,
      "elevationFeet": 4476,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/66V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/66V?codeType=fs"
     },
     {
      "fs": "66Y",
      "iata": "",
      "icao": "",
      "faa": "66Y",
      "name": "Diamondhead",
      "city": "Diamondhead",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.48,
      "longitude": -89.42,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/66Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/66Y?codeType=fs"
     },
     {
      "fs": "67A",
      "iata": "",
      "icao": "",
      "faa": "67A",
      "name": "Ft Deposit-Lowndes Co",
      "city": "Ft Deposit",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.023722,
      "longitude": -86.666417,
      "elevationFeet": 490,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/67A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/67A?codeType=fs"
     },
     {
      "fs": "67D",
      "iata": "",
      "icao": "",
      "faa": "67D",
      "name": "Botsford",
      "city": "Wellington",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.275528,
      "longitude": -82.226556,
      "elevationFeet": 864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/67D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/67D?codeType=fs"
     },
     {
      "fs": "67L",
      "iata": "",
      "icao": "",
      "faa": "67L",
      "name": "Mesquite",
      "city": "Mesquite",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 36.84975,
      "longitude": -114.102472,
      "elevationFeet": 1975,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/67L?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/67L?codeType=fs"
     },
     {
      "fs": "67R",
      "iata": "",
      "icao": "",
      "faa": "67R",
      "name": "Starr Co",
      "city": "Rio Grande City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 26.492778,
      "longitude": -98.960833,
      "elevationFeet": 290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/67R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/67R?codeType=fs"
     },
     {
      "fs": "67S",
      "iata": "",
      "icao": "",
      "faa": "67S",
      "name": "Priest Lake Usfs",
      "city": "Nordman",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 48.649194,
      "longitude": -117.085472,
      "elevationFeet": 2611,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/67S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/67S?codeType=fs"
     },
     {
      "fs": "67TX",
      "iata": "",
      "icao": "",
      "faa": "67TX",
      "name": "Old Hoppe Place",
      "city": "Agua Dulce",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 27.802444,
      "longitude": -97.860222,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/67TX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/67TX?codeType=fs"
     },
     {
      "fs": "68C",
      "iata": "",
      "icao": "",
      "faa": "68C",
      "name": "Central Co",
      "city": "Iola",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.555361,
      "longitude": -89.101083,
      "elevationFeet": 876,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68C?codeType=fs"
     },
     {
      "fs": "68F",
      "iata": "",
      "icao": "",
      "faa": "68F",
      "name": "Teague Municipal",
      "city": "Teague",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.762806,
      "longitude": -96.39975,
      "elevationFeet": 525,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68F?codeType=fs"
     },
     {
      "fs": "68G",
      "iata": "",
      "icao": "",
      "faa": "68G",
      "name": "Duford",
      "city": "Genesee",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.20025,
      "longitude": -83.713444,
      "elevationFeet": 773,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68G?codeType=fs"
     },
     {
      "fs": "68J",
      "iata": "",
      "icao": "",
      "faa": "68J",
      "name": "Tallahassee Commercial",
      "city": "Tallahassee/Havana",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 30.673056,
      "longitude": -84.438333,
      "elevationFeet": 155,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68J?codeType=fs"
     },
     {
      "fs": "68R",
      "iata": "",
      "icao": "",
      "faa": "68R",
      "name": "Hamp",
      "city": "Elwell",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.54475,
      "longitude": -84.808444,
      "elevationFeet": 825,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68R?codeType=fs"
     },
     {
      "fs": "68S",
      "iata": "",
      "icao": "",
      "faa": "68S",
      "name": "Davenport",
      "city": "Davenport",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.690444,
      "longitude": -118.177528,
      "elevationFeet": 2416,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68S?codeType=fs"
     },
     {
      "fs": "68Y",
      "iata": "",
      "icao": "",
      "faa": "68Y",
      "name": "Wells Municipal",
      "city": "Wells",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.882889,
      "longitude": -93.785611,
      "elevationFeet": 1119,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/68Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/68Y?codeType=fs"
     },
     {
      "fs": "69G",
      "iata": "",
      "icao": "",
      "faa": "69G",
      "name": "Richmond",
      "city": "Gregory",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.517028,
      "longitude": -84.216194,
      "elevationFeet": 921,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69G?codeType=fs"
     },
     {
      "fs": "69K",
      "iata": "",
      "icao": "",
      "faa": "69K",
      "name": "Wamego Municipal",
      "city": "Wamego",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 39.322194,
      "longitude": -96.338861,
      "elevationFeet": 966,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69K?codeType=fs"
     },
     {
      "fs": "69M",
      "iata": "",
      "icao": "",
      "faa": "69M",
      "name": "Nolan",
      "city": "Jonesboro",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.861861,
      "longitude": -90.767778,
      "elevationFeet": 238,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69M?codeType=fs"
     },
     {
      "fs": "69N",
      "iata": "",
      "icao": "",
      "faa": "69N",
      "name": "Slatington Airport",
      "city": "Slatington",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.762342,
      "longitude": -75.603504,
      "elevationFeet": 353,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69N?codeType=fs"
     },
     {
      "fs": "69R",
      "iata": "",
      "icao": "",
      "faa": "69R",
      "name": "Edwards Co",
      "city": "Rocksprings",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.069361,
      "longitude": -100.238556,
      "elevationFeet": 2371,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69R?codeType=fs"
     },
     {
      "fs": "69S",
      "iata": "",
      "icao": "",
      "faa": "69S",
      "name": "Avey Field State",
      "city": "Laurier",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 49.149056,
      "longitude": -118.302889,
      "elevationFeet": 1655,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69S?codeType=fs"
     },
     {
      "fs": "69V",
      "iata": "",
      "icao": "",
      "faa": "69V",
      "name": "Huntington Municipal",
      "city": "Huntington",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 39.463583,
      "longitude": -110.918306,
      "elevationFeet": 5909,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/69V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/69V?codeType=fs"
     },
     {
      "fs": "6A1",
      "iata": "",
      "icao": "",
      "faa": "6A1",
      "name": "Butler Municipal",
      "city": "Butler",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 32.573333,
      "longitude": -84.256667,
      "elevationFeet": 667,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A1?codeType=fs"
     },
     {
      "fs": "6A2",
      "iata": "",
      "icao": "",
      "faa": "6A2",
      "name": "Griffin-Spalding Co",
      "city": "Griffin",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.319722,
      "longitude": -84.349444,
      "elevationFeet": 958,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A2?codeType=fs"
     },
     {
      "fs": "6A3",
      "iata": "",
      "icao": "",
      "faa": "6A3",
      "name": "Andrews-Murphy",
      "city": "Andrews",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 35.295306,
      "longitude": -83.999028,
      "elevationFeet": 1700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A3?codeType=fs"
     },
     {
      "fs": "6A4",
      "iata": "",
      "icao": "",
      "faa": "6A4",
      "name": "Johnson Co",
      "city": "Mountain City",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.428972,
      "longitude": -81.901167,
      "elevationFeet": 2240,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A4?codeType=fs"
     },
     {
      "fs": "6A5",
      "iata": "",
      "icao": "",
      "faa": "6A5",
      "name": "Warf",
      "city": "Reidsville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.318028,
      "longitude": -79.780861,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A5?codeType=fs"
     },
     {
      "fs": "6A6",
      "iata": "",
      "icao": "",
      "faa": "6A6",
      "name": "Kimball Municipal",
      "city": "Kimball",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.833306,
      "longitude": -99.081472,
      "elevationFeet": 1755,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A6?codeType=fs"
     },
     {
      "fs": "6A8",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "New Allakaket",
      "city": "Allakaket",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 66.569444,
      "longitude": -152.672222,
      "elevationFeet": 504,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6A8?codeType=fs"
     },
     {
      "fs": "6AK",
      "iata": "",
      "icao": "",
      "faa": "6AK",
      "name": "Rainy Pass",
      "city": "Rainy Pass",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 62.091417,
      "longitude": -152.72525,
      "elevationFeet": 1900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6AK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6AK?codeType=fs"
     },
     {
      "fs": "6B0",
      "iata": "",
      "icao": "",
      "faa": "6B0",
      "name": "Middlebury State",
      "city": "Middlebury",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.997833,
      "longitude": -73.2095,
      "elevationFeet": 490,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6B0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6B0?codeType=fs"
     },
     {
      "fs": "6B2",
      "iata": "",
      "icao": "",
      "faa": "6B2",
      "name": "Yoder",
      "city": "Louisville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.91725,
      "longitude": -81.314944,
      "elevationFeet": 1149,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6B2?codeType=fs"
     },
     {
      "fs": "6B3",
      "iata": "",
      "icao": "",
      "faa": "6B3",
      "name": "Bean Blossom",
      "city": "New Lathrop",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.102778,
      "longitude": -84.094444,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6B3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6B3?codeType=fs"
     },
     {
      "fs": "6B4",
      "iata": "",
      "icao": "",
      "faa": "6B4",
      "name": "Frankfort-Highland",
      "city": "Utica/Frankfort",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.059028,
      "longitude": -75.204389,
      "elevationFeet": 1325,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6B4?codeType=fs"
     },
     {
      "fs": "6B9",
      "iata": "",
      "icao": "",
      "faa": "6B9",
      "name": "Skaneateles",
      "city": "Skaneateles",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.039556,
      "longitude": -76.507694,
      "elevationFeet": 1038,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6B9?codeType=fs"
     },
     {
      "fs": "6C0",
      "iata": "",
      "icao": "",
      "faa": "6C0",
      "name": "Eldora Municipal",
      "city": "Eldora",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.449833,
      "longitude": -93.265917,
      "elevationFeet": 979,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6C0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6C0?codeType=fs"
     },
     {
      "fs": "6C2",
      "iata": "",
      "icao": "",
      "faa": "6C2",
      "name": "Ohio Dusting Co Inc",
      "city": "Pandora",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.975528,
      "longitude": -84.121667,
      "elevationFeet": 765,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6C2?codeType=fs"
     },
     {
      "fs": "6C8",
      "iata": "",
      "icao": "",
      "faa": "6C8",
      "name": "Nichols",
      "city": "La Porte City",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.466583,
      "longitude": -92.285194,
      "elevationFeet": 950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6C8?codeType=fs"
     },
     {
      "fs": "6D1",
      "iata": "",
      "icao": "",
      "faa": "6D1",
      "name": "Brooten Municipal",
      "city": "Brooten",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.649639,
      "longitude": -95.228,
      "elevationFeet": 1305,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6D1?codeType=fs"
     },
     {
      "fs": "6D3",
      "iata": "",
      "icao": "",
      "faa": "6D3",
      "name": "Maddock Municipal",
      "city": "Maddock",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 48.077861,
      "longitude": -99.620778,
      "elevationFeet": 1600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6D3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6D3?codeType=fs"
     },
     {
      "fs": "6D6",
      "iata": "",
      "icao": "",
      "faa": "6D6",
      "name": "Greenville Municipal",
      "city": "Greenville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.222806,
      "longitude": -85.288056,
      "elevationFeet": 855,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6D6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6D6?codeType=fs"
     },
     {
      "fs": "6D7",
      "iata": "",
      "icao": "",
      "faa": "6D7",
      "name": "Deshler Municipal",
      "city": "Deshler",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.358833,
      "longitude": -83.943833,
      "elevationFeet": 706,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6D7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6D7?codeType=fs"
     },
     {
      "fs": "6D8",
      "iata": "",
      "icao": "",
      "faa": "6D8",
      "name": "Barnes Co Municipal",
      "city": "Valley City",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.010083,
      "longitude": -98.02625,
      "elevationFeet": 1400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6D8?codeType=fs"
     },
     {
      "fs": "6E5",
      "iata": "",
      "icao": "",
      "faa": "6E5",
      "name": "Wilder",
      "city": "De Smet",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.558028,
      "longitude": -97.661889,
      "elevationFeet": 1729,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6E5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6E5?codeType=fs"
     },
     {
      "fs": "6F1",
      "iata": "",
      "icao": "",
      "faa": "6F1",
      "name": "Talihina Municipal",
      "city": "Talihina",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.777722,
      "longitude": -95.137861,
      "elevationFeet": 687,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6F1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6F1?codeType=fs"
     },
     {
      "fs": "6F4",
      "iata": "",
      "icao": "",
      "faa": "6F4",
      "name": "Elmdale",
      "city": "Abilene",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.45125,
      "longitude": -99.653639,
      "elevationFeet": 1775,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6F4?codeType=fs"
     },
     {
      "fs": "6F5",
      "iata": "",
      "icao": "",
      "faa": "6F5",
      "name": "Taylor",
      "city": "Albany",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.826194,
      "longitude": -99.428556,
      "elevationFeet": 1473,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6F5?codeType=fs"
     },
     {
      "fs": "6F7",
      "iata": "",
      "icao": "",
      "faa": "6F7",
      "name": "Manning",
      "city": "Jefferson",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.915278,
      "longitude": -94.393583,
      "elevationFeet": 320,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6F7?codeType=fs"
     },
     {
      "fs": "6F9",
      "iata": "",
      "icao": "",
      "faa": "6F9",
      "name": "Mc Kenzie",
      "city": "Avinger",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.818028,
      "longitude": -94.618694,
      "elevationFeet": 360,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6F9?codeType=fs"
     },
     {
      "fs": "6G0",
      "iata": "",
      "icao": "",
      "faa": "6G0",
      "name": "Williams Memorial",
      "city": "Davison",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.141389,
      "longitude": -83.646722,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6G0?codeType=fs"
     },
     {
      "fs": "6G1",
      "iata": "",
      "icao": "",
      "faa": "6G1",
      "name": "Titusville",
      "city": "Titusville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.688083,
      "longitude": -79.813306,
      "elevationFeet": 1600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6G1?codeType=fs"
     },
     {
      "fs": "6G4",
      "iata": "",
      "icao": "",
      "faa": "6G4",
      "name": "Wynkoop",
      "city": "Mt Vernon",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.500611,
      "longitude": -82.607194,
      "elevationFeet": 1041,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6G4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6G4?codeType=fs"
     },
     {
      "fs": "6G5",
      "iata": "",
      "icao": "",
      "faa": "6G5",
      "name": "Barnesville-Bradfield",
      "city": "Barnesville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.024306,
      "longitude": -81.268306,
      "elevationFeet": 1313,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6G5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6G5?codeType=fs"
     },
     {
      "fs": "6G6",
      "iata": "",
      "icao": "",
      "faa": "6G6",
      "name": "Cove Valley",
      "city": "Williamsburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.495167,
      "longitude": -78.280667,
      "elevationFeet": 1156,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6G6?codeType=fs"
     },
     {
      "fs": "6G8",
      "iata": "",
      "icao": "",
      "faa": "6G8",
      "name": "Shamrock",
      "city": "Brooklyn",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.200417,
      "longitude": -84.307806,
      "elevationFeet": 995,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6G8?codeType=fs"
     },
     {
      "fs": "6H4",
      "iata": "",
      "icao": "",
      "faa": "6H4",
      "name": "Van Wagnen Airport",
      "city": "Napoleon",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.15569,
      "longitude": -84.33266,
      "elevationFeet": 983,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6H4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6H4?codeType=fs"
     },
     {
      "fs": "6H8",
      "iata": "",
      "icao": "",
      "faa": "6H8",
      "name": "Hazelton Municipal",
      "city": "Hazelton",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.619333,
      "longitude": -100.298361,
      "elevationFeet": 2003,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6H8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6H8?codeType=fs"
     },
     {
      "fs": "6I2",
      "iata": "",
      "icao": "",
      "faa": "6I2",
      "name": "Lebanon-Springfield Airport",
      "city": "Springfield",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 37.643685,
      "longitude": -85.235348,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6I2?codeType=fs"
     },
     {
      "fs": "6I4",
      "iata": "",
      "icao": "",
      "faa": "6I4",
      "name": "Boone County Airport",
      "city": "Lebanon",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.009014,
      "longitude": -86.437609,
      "elevationFeet": 952,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6I4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6I4?codeType=fs"
     },
     {
      "fs": "6I6",
      "iata": "",
      "icao": "",
      "faa": "6I6",
      "name": "Darby Dan Airport",
      "city": "Columbus",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.941934,
      "longitude": -83.202591,
      "elevationFeet": 928,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6I6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6I6?codeType=fs"
     },
     {
      "fs": "6J0",
      "iata": "",
      "icao": "",
      "faa": "6J0",
      "name": "Corporate",
      "city": "Pelion",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.896389,
      "longitude": -81.358611,
      "elevationFeet": 452,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J0?codeType=fs"
     },
     {
      "fs": "6J2",
      "iata": "",
      "icao": "",
      "faa": "6J2",
      "name": "St George",
      "city": "St George",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.305,
      "longitude": -80.584722,
      "elevationFeet": 84,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J2?codeType=fs"
     },
     {
      "fs": "6J4",
      "iata": "",
      "icao": "",
      "faa": "6J4",
      "name": "Saluda Co",
      "city": "Saluda",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.018,
      "longitude": -81.895528,
      "elevationFeet": 555,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J4?codeType=fs"
     },
     {
      "fs": "6J5",
      "iata": "",
      "icao": "",
      "faa": "6J5",
      "name": "Dabbs",
      "city": "Sumter",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.012694,
      "longitude": -80.214639,
      "elevationFeet": 125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J5?codeType=fs"
     },
     {
      "fs": "6J6",
      "iata": "",
      "icao": "",
      "faa": "6J6",
      "name": "Edgefield Co",
      "city": "Trenton",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.768028,
      "longitude": -81.845556,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J6?codeType=fs"
     },
     {
      "fs": "6J7",
      "iata": "",
      "icao": "",
      "faa": "6J7",
      "name": "Branhams",
      "city": "Darlington",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.420972,
      "longitude": -80.03675,
      "elevationFeet": 165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J7?codeType=fs"
     },
     {
      "fs": "6J8",
      "iata": "",
      "icao": "",
      "faa": "6J8",
      "name": "Rudy'S Gliderport",
      "city": "High Springs",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 29.774611,
      "longitude": -82.742833,
      "elevationFeet": 90,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6J8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6J8?codeType=fs"
     },
     {
      "fs": "6K1",
      "iata": "",
      "icao": "",
      "faa": "6K1",
      "name": "Marceline Municipal",
      "city": "Marceline",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 39.733583,
      "longitude": -93.060306,
      "elevationFeet": 874,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K1?codeType=fs"
     },
     {
      "fs": "6K2",
      "iata": "",
      "icao": "",
      "faa": "6K2",
      "name": "Shelby Co",
      "city": "Shelbyville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 39.817056,
      "longitude": -92.05175,
      "elevationFeet": 766,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K2?codeType=fs"
     },
     {
      "fs": "6K3",
      "iata": "",
      "icao": "",
      "faa": "6K3",
      "name": "Creighton Municipal",
      "city": "Creighton",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.508361,
      "longitude": -97.886778,
      "elevationFeet": 1653,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K3?codeType=fs"
     },
     {
      "fs": "6K4",
      "iata": "",
      "icao": "",
      "faa": "6K4",
      "name": "Fairview Municipal",
      "city": "Fairview",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.351472,
      "longitude": -98.558278,
      "elevationFeet": 1272,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K4?codeType=fs"
     },
     {
      "fs": "6K5",
      "iata": "",
      "icao": "",
      "faa": "6K5",
      "name": "Sisters Eagle Air",
      "city": "Sisters",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 44.345611,
      "longitude": -121.592111,
      "elevationFeet": 3168,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K5?codeType=fs"
     },
     {
      "fs": "6K7",
      "iata": "",
      "icao": "",
      "faa": "6K7",
      "name": "Grundy Center Municipal",
      "city": "Grundy Center",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.358167,
      "longitude": -92.935333,
      "elevationFeet": 1075,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K7?codeType=fs"
     },
     {
      "fs": "6K8",
      "iata": "",
      "icao": "",
      "faa": "6K8",
      "name": "Tok Junction",
      "city": "Tok",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 63.446528,
      "longitude": -142.988972,
      "elevationFeet": 1630,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K8?codeType=fs"
     },
     {
      "fs": "6K9",
      "iata": "",
      "icao": "",
      "faa": "6K9",
      "name": "Keosauqua Municipal",
      "city": "Keosauqua",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.7475,
      "longitude": -92.087833,
      "elevationFeet": 580,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6K9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6K9?codeType=fs"
     },
     {
      "fs": "6L3",
      "iata": "",
      "icao": "",
      "faa": "6L3",
      "name": "Lisbon Municipal",
      "city": "Lisbon",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.566361,
      "longitude": -97.823222,
      "elevationFeet": 1240,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6L3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6L3?codeType=fs"
     },
     {
      "fs": "6L4",
      "iata": "",
      "icao": "",
      "faa": "6L4",
      "name": "Logan Co",
      "city": "Logan",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 37.906778,
      "longitude": -82.058972,
      "elevationFeet": 1667,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6L4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6L4?codeType=fs"
     },
     {
      "fs": "6L5",
      "iata": "",
      "icao": "",
      "faa": "6L5",
      "name": "Wishek Municipal",
      "city": "Wishek",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.363611,
      "longitude": -99.578889,
      "elevationFeet": 2035,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6L5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6L5?codeType=fs"
     },
     {
      "fs": "6M0",
      "iata": "",
      "icao": "",
      "faa": "6M0",
      "name": "Hazen Municipal",
      "city": "Hazen",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.767583,
      "longitude": -91.634667,
      "elevationFeet": 230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6M0?codeType=fs"
     },
     {
      "fs": "6M2",
      "iata": "",
      "icao": "",
      "faa": "6M2",
      "name": "Horseshoe Bend",
      "city": "Horseshoe Bend",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.217333,
      "longitude": -91.751444,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6M2?codeType=fs"
     },
     {
      "fs": "6M5",
      "iata": "",
      "icao": "",
      "faa": "6M5",
      "name": "Lakewood Country Club",
      "city": "Lakewood",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.394139,
      "longitude": -88.5955,
      "elevationFeet": 1229,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6M5?codeType=fs"
     },
     {
      "fs": "6M6",
      "iata": "",
      "icao": "",
      "faa": "6M6",
      "name": "Lewis Co Regional",
      "city": "Monticello",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.241667,
      "longitude": -91.783611,
      "elevationFeet": 674,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6M6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6M6?codeType=fs"
     },
     {
      "fs": "6M7",
      "iata": "",
      "icao": "",
      "faa": "6M7",
      "name": "Lee Co-Marianna",
      "city": "Marianna",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.902778,
      "longitude": -90.905556,
      "elevationFeet": 217,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6M7?codeType=fs"
     },
     {
      "fs": "6M8",
      "iata": "",
      "icao": "",
      "faa": "6M8",
      "name": "Marked Tree Municipal",
      "city": "Marked Tree",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.534139,
      "longitude": -90.414917,
      "elevationFeet": 219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6M8?codeType=fs"
     },
     {
      "fs": "6MO",
      "iata": "",
      "icao": "",
      "faa": "6MO",
      "name": "Washington Co",
      "city": "Potosi",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.036611,
      "longitude": -90.867972,
      "elevationFeet": 955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6MO?codeType=fs"
     },
     {
      "fs": "6N8",
      "iata": "",
      "icao": "",
      "faa": "6N8",
      "name": "Thomas Co",
      "city": "Thedford",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.071694,
      "longitude": -100.590139,
      "elevationFeet": 2926,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6N8?codeType=fs"
     },
     {
      "fs": "6N9",
      "iata": "",
      "icao": "",
      "faa": "6N9",
      "name": "Flying W",
      "city": "Potters Hill",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 35.121083,
      "longitude": -77.833333,
      "elevationFeet": 115,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6N9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6N9?codeType=fs"
     },
     {
      "fs": "6P3",
      "iata": "",
      "icao": "",
      "faa": "6P3",
      "name": "Waunakee",
      "city": "Waunakee",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.333278,
      "longitude": -89.451194,
      "elevationFeet": 950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6P3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6P3?codeType=fs"
     },
     {
      "fs": "6R1",
      "iata": "",
      "icao": "",
      "faa": "6R1",
      "name": "Welsh",
      "city": "Welsh",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.31875,
      "longitude": -92.943111,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6R1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6R1?codeType=fs"
     },
     {
      "fs": "6R3",
      "iata": "",
      "icao": "",
      "faa": "6R3",
      "name": "Cleveland Municipal",
      "city": "Cleveland",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.414306,
      "longitude": -95.080139,
      "elevationFeet": 151,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6R3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6R3?codeType=fs"
     },
     {
      "fs": "6R4",
      "iata": "",
      "icao": "",
      "faa": "6R4",
      "name": "Bird'S Nest",
      "city": "Austin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.516111,
      "longitude": -97.5725,
      "elevationFeet": 615,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6R4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6R4?codeType=fs"
     },
     {
      "fs": "6R5",
      "iata": "",
      "icao": "",
      "faa": "6R5",
      "name": "Alvin Airpark",
      "city": "Alvin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.414784,
      "longitude": -95.291184,
      "elevationFeet": 37,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6R5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6R5?codeType=fs"
     },
     {
      "fs": "6R6",
      "iata": "",
      "icao": "",
      "faa": "6R6",
      "name": "Terrell Co",
      "city": "Dryden",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.16025,
      "longitude": -102.329139,
      "elevationFeet": 2322,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6R6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6R6?codeType=fs"
     },
     {
      "fs": "6R9",
      "iata": "",
      "icao": "",
      "faa": "6R9",
      "name": "Llano Municipal",
      "city": "Llano",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.795028,
      "longitude": -98.7525,
      "elevationFeet": 1102,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6R9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6R9?codeType=fs"
     },
     {
      "fs": "6S0",
      "iata": "",
      "icao": "",
      "faa": "6S0",
      "name": "Big Timber",
      "city": "Big Timber",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.863889,
      "longitude": -110.111111,
      "elevationFeet": 4492,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S0?codeType=fs"
     },
     {
      "fs": "6S1",
      "iata": "",
      "icao": "",
      "faa": "6S1",
      "name": "Bridger Municipal",
      "city": "Bridger",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.35225,
      "longitude": -109.007,
      "elevationFeet": 3720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S1?codeType=fs"
     },
     {
      "fs": "6S2",
      "iata": "FMU",
      "icao": "",
      "faa": "6S2",
      "name": "Florence Municipal",
      "city": "Florence",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 43.9828,
      "longitude": -124.111,
      "elevationFeet": 51,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S2?codeType=fs"
     },
     {
      "fs": "6S3",
      "iata": "",
      "icao": "",
      "faa": "6S3",
      "name": "Columbus",
      "city": "Columbus",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.741083,
      "longitude": -109.257167,
      "elevationFeet": 3575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S3?codeType=fs"
     },
     {
      "fs": "6S4",
      "iata": "",
      "icao": "",
      "faa": "6S4",
      "name": "Davis",
      "city": "Gates",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 44.856778,
      "longitude": -122.464694,
      "elevationFeet": 1026,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S4?codeType=fs"
     },
     {
      "fs": "6S6",
      "iata": "",
      "icao": "",
      "faa": "6S6",
      "name": "Powers State",
      "city": "Powers",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 42.895556,
      "longitude": -124.142611,
      "elevationFeet": 326,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S6?codeType=fs"
     },
     {
      "fs": "6S8",
      "iata": "",
      "icao": "",
      "faa": "6S8",
      "name": "Laurel Municipal",
      "city": "Laurel",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.730889,
      "longitude": -108.860889,
      "elevationFeet": 3515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S8?codeType=fs"
     },
     {
      "fs": "6S9",
      "iata": "",
      "icao": "",
      "faa": "6S9",
      "name": "Stehekin State",
      "city": "Stehekin",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 48.456944,
      "longitude": -120.756667,
      "elevationFeet": 1230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6S9?codeType=fs"
     },
     {
      "fs": "6U5",
      "iata": "",
      "icao": "",
      "faa": "6U5",
      "name": "Hinsdale",
      "city": "Hinsdale",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.425083,
      "longitude": -107.086806,
      "elevationFeet": 2220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6U5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6U5?codeType=fs"
     },
     {
      "fs": "6U6",
      "iata": "",
      "icao": "",
      "faa": "6U6",
      "name": "Hogeland",
      "city": "Hogeland",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.938944,
      "longitude": -108.743139,
      "elevationFeet": 3138,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6U6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6U6?codeType=fs"
     },
     {
      "fs": "6U7",
      "iata": "",
      "icao": "",
      "faa": "6U7",
      "name": "Hysham",
      "city": "Hysham",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.344333,
      "longitude": -107.308944,
      "elevationFeet": 2624,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6U7?codeType=fs"
     },
     {
      "fs": "6V0",
      "iata": "",
      "icao": "",
      "faa": "6V0",
      "name": "Edgemont Municipal",
      "city": "Edgemont",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 43.4025,
      "longitude": -103.935333,
      "elevationFeet": 3605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6V0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6V0?codeType=fs"
     },
     {
      "fs": "6V3",
      "iata": "",
      "icao": "",
      "faa": "6V3",
      "name": "Tazewell Co",
      "city": "Richlands",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 37.187528,
      "longitude": -81.932833,
      "elevationFeet": 2652,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6V3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6V3?codeType=fs"
     },
     {
      "fs": "6V4",
      "iata": "",
      "icao": "",
      "faa": "6V4",
      "name": "Wall Municipal",
      "city": "Wall",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 44.099889,
      "longitude": -102.254361,
      "elevationFeet": 2810,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6V4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6V4?codeType=fs"
     },
     {
      "fs": "6V5",
      "iata": "",
      "icao": "",
      "faa": "6V5",
      "name": "Bison Municipal",
      "city": "Bison",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.535972,
      "longitude": -102.471028,
      "elevationFeet": 2785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6V5?codeType=fs"
     },
     {
      "fs": "6V6",
      "iata": "",
      "icao": "",
      "faa": "6V6",
      "name": "Hopkins",
      "city": "Nucla",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 38.287972,
      "longitude": -108.682611,
      "elevationFeet": 5936,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6V6?codeType=fs"
     },
     {
      "fs": "6W0",
      "iata": "",
      "icao": "",
      "faa": "6W0",
      "name": "Maley",
      "city": "Shinnston",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.470306,
      "longitude": -80.367528,
      "elevationFeet": 962,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6W0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6W0?codeType=fs"
     },
     {
      "fs": "6W4",
      "iata": "",
      "icao": "",
      "faa": "6W4",
      "name": "Caswell",
      "city": "Yanceyville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.546528,
      "longitude": -79.477944,
      "elevationFeet": 648,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6W4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6W4?codeType=fs"
     },
     {
      "fs": "6W6",
      "iata": "",
      "icao": "",
      "faa": "6W6",
      "name": "Hanover",
      "city": "Hanover",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.876,
      "longitude": -77.097028,
      "elevationFeet": 560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6W6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6W6?codeType=fs"
     },
     {
      "fs": "6X0",
      "iata": "",
      "icao": "",
      "faa": "6X0",
      "name": "Tarrant",
      "city": "Mt Selman",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.223833,
      "longitude": -95.396722,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6X0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6X0?codeType=fs"
     },
     {
      "fs": "6Y0",
      "iata": "",
      "icao": "",
      "faa": "6Y0",
      "name": "Moorestown",
      "city": "Moorestown",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.575111,
      "longitude": -85.10875,
      "elevationFeet": 1213,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Y0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Y0?codeType=fs"
     },
     {
      "fs": "6Y1",
      "iata": "",
      "icao": "",
      "faa": "6Y1",
      "name": "Bois Blanc",
      "city": "Pointe Aux Pins",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 45.766806,
      "longitude": -84.500389,
      "elevationFeet": 653,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Y1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Y1?codeType=fs"
     },
     {
      "fs": "6Y4",
      "iata": "",
      "icao": "",
      "faa": "6Y4",
      "name": "Bonnie",
      "city": "Rock",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 46.071778,
      "longitude": -87.331944,
      "elevationFeet": 970,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Y4?codeType=fs"
     },
     {
      "fs": "6Y6",
      "iata": "",
      "icao": "",
      "faa": "6Y6",
      "name": "St Helen",
      "city": "St Helen",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.366861,
      "longitude": -84.400139,
      "elevationFeet": 1198,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Y6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Y6?codeType=fs"
     },
     {
      "fs": "6Y8",
      "iata": "",
      "icao": "",
      "faa": "6Y8",
      "name": "Welke",
      "city": "Beaver I",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 45.758333,
      "longitude": -85.559194,
      "elevationFeet": 664,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Y8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Y8?codeType=fs"
     },
     {
      "fs": "6Y9",
      "iata": "",
      "icao": "",
      "faa": "6Y9",
      "name": "Prickett-Grooms",
      "city": "Sidnaw",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 46.666083,
      "longitude": -88.701389,
      "elevationFeet": 1372,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Y9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Y9?codeType=fs"
     },
     {
      "fs": "6Z1",
      "iata": "",
      "icao": "",
      "faa": "6Z1",
      "name": "Arness Lake",
      "city": "Kenai",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 60.738778,
      "longitude": -151.350111,
      "elevationFeet": 125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/6Z1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/6Z1?codeType=fs"
     },
     {
      "fs": "70A",
      "iata": "",
      "icao": "",
      "faa": "70A",
      "name": "Jones",
      "city": "Linden",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.268111,
      "longitude": -87.730639,
      "elevationFeet": 161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/70A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/70A?codeType=fs"
     },
     {
      "fs": "70D",
      "iata": "",
      "icao": "",
      "faa": "70D",
      "name": "Titus",
      "city": "Arthurdale",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.636972,
      "longitude": -79.875611,
      "elevationFeet": 1860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/70D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/70D?codeType=fs"
     },
     {
      "fs": "70J",
      "iata": "",
      "icao": "",
      "faa": "70J",
      "name": "Cairo-Grady Co",
      "city": "Cairo",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 30.929778,
      "longitude": -84.197361,
      "elevationFeet": 265,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/70J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/70J?codeType=fs"
     },
     {
      "fs": "70K",
      "iata": "",
      "icao": "",
      "faa": "70K",
      "name": "Maize",
      "city": "Wichita",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.905667,
      "longitude": -97.458778,
      "elevationFeet": 1336,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/70K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/70K?codeType=fs"
     },
     {
      "fs": "70N",
      "iata": "",
      "icao": "",
      "faa": "70N",
      "name": "Spring Hill",
      "city": "Sterling",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.473583,
      "longitude": -75.558972,
      "elevationFeet": 1729,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/70N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/70N?codeType=fs"
     },
     {
      "fs": "70S",
      "iata": "",
      "icao": "",
      "faa": "70S",
      "name": "Mead Flying Service",
      "city": "Mead",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.865583,
      "longitude": -117.3605,
      "elevationFeet": 1900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/70S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/70S?codeType=fs"
     },
     {
      "fs": "71A",
      "iata": "",
      "icao": "",
      "faa": "71A",
      "name": "Pine Hill Municipal",
      "city": "Pine Hill",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.968167,
      "longitude": -87.583333,
      "elevationFeet": 123,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/71A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/71A?codeType=fs"
     },
     {
      "fs": "71D",
      "iata": "",
      "icao": "",
      "faa": "71D",
      "name": "Roy",
      "city": "Grafton",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.353722,
      "longitude": -79.964639,
      "elevationFeet": 1560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/71D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/71D?codeType=fs"
     },
     {
      "fs": "71J",
      "iata": "",
      "icao": "",
      "faa": "71J",
      "name": "Blackwell",
      "city": "Ozark",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.561389,
      "longitude": -85.642222,
      "elevationFeet": 356,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/71J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/71J?codeType=fs"
     },
     {
      "fs": "71K",
      "iata": "",
      "icao": "",
      "faa": "71K",
      "name": "Westport",
      "city": "Wichita",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.775139,
      "longitude": -97.394889,
      "elevationFeet": 1290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/71K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/71K?codeType=fs"
     },
     {
      "fs": "71N",
      "iata": "",
      "icao": "",
      "faa": "71N",
      "name": "Sunbury",
      "city": "Sunbury",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.967528,
      "longitude": -76.888528,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/71N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/71N?codeType=fs"
     },
     {
      "fs": "72A",
      "iata": "",
      "icao": "",
      "faa": "72A",
      "name": "Johnson",
      "city": "Archdale",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 35.870806,
      "longitude": -80.058694,
      "elevationFeet": 732,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/72A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/72A?codeType=fs"
     },
     {
      "fs": "72F",
      "iata": "",
      "icao": "",
      "faa": "72F",
      "name": "Throckmorton Municipal",
      "city": "Throckmorton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.292722,
      "longitude": -99.297972,
      "elevationFeet": 1273,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/72F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/72F?codeType=fs"
     },
     {
      "fs": "72S",
      "iata": "",
      "icao": "",
      "faa": "72S",
      "name": "Rosalia Municipal",
      "city": "Rosalia",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.268389,
      "longitude": -117.46025,
      "elevationFeet": 2170,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/72S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/72S?codeType=fs"
     },
     {
      "fs": "73C",
      "iata": "",
      "icao": "",
      "faa": "73C",
      "name": "Lancaster Municipal",
      "city": "Lancaster",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.905472,
      "longitude": -90.809611,
      "elevationFeet": 1008,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/73C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/73C?codeType=fs"
     },
     {
      "fs": "73F",
      "iata": "",
      "icao": "",
      "faa": "73F",
      "name": "Wings For Christ International Fl Acad*",
      "city": "Waco",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.687778,
      "longitude": -97.074972,
      "elevationFeet": 455,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/73F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/73F?codeType=fs"
     },
     {
      "fs": "73J",
      "iata": "",
      "icao": "",
      "faa": "73J",
      "name": "Beaufort Co",
      "city": "Beaufort",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 32.521389,
      "longitude": -80.6455,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/73J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/73J?codeType=fs"
     },
     {
      "fs": "73S",
      "iata": "",
      "icao": "",
      "faa": "73S",
      "name": "Willard",
      "city": "Tekoa",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.257333,
      "longitude": -117.132306,
      "elevationFeet": 2513,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/73S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/73S?codeType=fs"
     },
     {
      "fs": "74A",
      "iata": "",
      "icao": "",
      "faa": "74A",
      "name": "Lyons",
      "city": "Rainsville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.542528,
      "longitude": -85.891361,
      "elevationFeet": 1220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/74A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/74A?codeType=fs"
     },
     {
      "fs": "74D",
      "iata": "",
      "icao": "",
      "faa": "74D",
      "name": "Marshall Co",
      "city": "Moundsville",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.008333,
      "longitude": -80.757778,
      "elevationFeet": 1214,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/74D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/74D?codeType=fs"
     },
     {
      "fs": "74F",
      "iata": "",
      "icao": "",
      "faa": "74F",
      "name": "Flat Top Ranch",
      "city": "Walnut Springs",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.15,
      "longitude": -97.9,
      "elevationFeet": 967,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/74F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/74F?codeType=fs"
     },
     {
      "fs": "74N",
      "iata": "",
      "icao": "",
      "faa": "74N",
      "name": "Bendigo",
      "city": "Tower City",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.634222,
      "longitude": -76.669083,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/74N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/74N?codeType=fs"
     },
     {
      "fs": "74R",
      "iata": "",
      "icao": "",
      "faa": "74R",
      "name": "Horizon",
      "city": "San Antonio",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.285722,
      "longitude": -98.502944,
      "elevationFeet": 550,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/74R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/74R?codeType=fs"
     },
     {
      "fs": "75C",
      "iata": "",
      "icao": "",
      "faa": "75C",
      "name": "Orogrande",
      "city": "Orogrande",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.851833,
      "longitude": -115.629056,
      "elevationFeet": 4405,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/75C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/75C?codeType=fs"
     },
     {
      "fs": "75D",
      "iata": "",
      "icao": "",
      "faa": "75D",
      "name": "Johnson Memorial",
      "city": "New Martinsville",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.689667,
      "longitude": -80.973194,
      "elevationFeet": 632,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/75D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/75D?codeType=fs"
     },
     {
      "fs": "75G",
      "iata": "",
      "icao": "",
      "faa": "75G",
      "name": "Rossettie",
      "city": "Manchester",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.300361,
      "longitude": -84.157917,
      "elevationFeet": 1005,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/75G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/75G?codeType=fs"
     },
     {
      "fs": "75J",
      "iata": "",
      "icao": "",
      "faa": "75J",
      "name": "Turner Co",
      "city": "Ashburn",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 31.704583,
      "longitude": -83.771111,
      "elevationFeet": 389,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/75J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/75J?codeType=fs"
     },
     {
      "fs": "75K",
      "iata": "",
      "icao": "",
      "faa": "75K",
      "name": "Bethany Memorial",
      "city": "Bethany",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.369472,
      "longitude": -94.077306,
      "elevationFeet": 1027,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/75K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/75K?codeType=fs"
     },
     {
      "fs": "76C",
      "iata": "",
      "icao": "",
      "faa": "76C",
      "name": "Aero Park",
      "city": "Menomonee Falls",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.183417,
      "longitude": -88.248139,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/76C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/76C?codeType=fs"
     },
     {
      "fs": "76F",
      "iata": "",
      "icao": "",
      "faa": "76F",
      "name": "Wills Point Municipal",
      "city": "Wills Point",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.815194,
      "longitude": -95.991333,
      "elevationFeet": 518,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/76F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/76F?codeType=fs"
     },
     {
      "fs": "76G",
      "iata": "",
      "icao": "",
      "faa": "76G",
      "name": "Marine City",
      "city": "Marine City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.758667,
      "longitude": -82.707472,
      "elevationFeet": 613,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/76G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/76G?codeType=fs"
     },
     {
      "fs": "76N",
      "iata": "",
      "icao": "",
      "faa": "76N",
      "name": "Skyhaven",
      "city": "Tunkhannock",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.642444,
      "longitude": -76.068667,
      "elevationFeet": 639,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/76N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/76N?codeType=fs"
     },
     {
      "fs": "76V",
      "iata": "",
      "icao": "",
      "faa": "76V",
      "name": "Thomas Memorial",
      "city": "Glendo",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 42.538583,
      "longitude": -105.041389,
      "elevationFeet": 4665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/76V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/76V?codeType=fs"
     },
     {
      "fs": "76Z",
      "iata": "",
      "icao": "",
      "faa": "76Z",
      "name": "Nakeen",
      "city": "Nakeen",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 59.026056,
      "longitude": -157.171528,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/76Z?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/76Z?codeType=fs"
     },
     {
      "fs": "77F",
      "iata": "",
      "icao": "",
      "faa": "77F",
      "name": "Winters Municipal",
      "city": "Winters",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.072,
      "longitude": -100.008417,
      "elevationFeet": 1870,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/77F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/77F?codeType=fs"
     },
     {
      "fs": "77G",
      "iata": "",
      "icao": "",
      "faa": "77G",
      "name": "Marlette",
      "city": "Marlette",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.418306,
      "longitude": -83.159139,
      "elevationFeet": 895,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/77G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/77G?codeType=fs"
     },
     {
      "fs": "77S",
      "iata": "",
      "icao": "",
      "faa": "77S",
      "name": "Hobby",
      "city": "Creswell",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 44.070694,
      "longitude": -123.067472,
      "elevationFeet": 535,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/77S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/77S?codeType=fs"
     },
     {
      "fs": "77T",
      "iata": "",
      "icao": "",
      "faa": "77T",
      "name": "Kittie Hill",
      "city": "Leander",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.621389,
      "longitude": -97.839028,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/77T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/77T?codeType=fs"
     },
     {
      "fs": "78A",
      "iata": "",
      "icao": "",
      "faa": "78A",
      "name": "Swan Creek",
      "city": "Jonesville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.223556,
      "longitude": -80.881278,
      "elevationFeet": 1135,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/78A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/78A?codeType=fs"
     },
     {
      "fs": "78D",
      "iata": "",
      "icao": "",
      "faa": "78D",
      "name": "Caro Municipal",
      "city": "Caro",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.540833,
      "longitude": -83.552222,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/78D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/78D?codeType=fs"
     },
     {
      "fs": "78I",
      "iata": "",
      "icao": "",
      "faa": "78I",
      "name": "Pam'S Place",
      "city": "Eminence",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.508333,
      "longitude": -86.769444,
      "elevationFeet": 795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/78I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/78I?codeType=fs"
     },
     {
      "fs": "78N",
      "iata": "",
      "icao": "",
      "faa": "78N",
      "name": "Rockingham Co-Shiloh",
      "city": "Reidsville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.472222,
      "longitude": -79.860111,
      "elevationFeet": 693,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/78N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/78N?codeType=fs"
     },
     {
      "fs": "78R",
      "iata": "",
      "icao": "",
      "faa": "78R",
      "name": "San Augustine Co",
      "city": "San Augustine",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.59625,
      "longitude": -94.20475,
      "elevationFeet": 443,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/78R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/78R?codeType=fs"
     },
     {
      "fs": "78Y",
      "iata": "",
      "icao": "",
      "faa": "78Y",
      "name": "Rankin",
      "city": "Maryville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.48325,
      "longitude": -94.835806,
      "elevationFeet": 976,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/78Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/78Y?codeType=fs"
     },
     {
      "fs": "79C",
      "iata": "",
      "icao": "",
      "faa": "79C",
      "name": "Brennand",
      "city": "Neenah",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.249833,
      "longitude": -88.645556,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/79C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/79C?codeType=fs"
     },
     {
      "fs": "79D",
      "iata": "",
      "icao": "",
      "faa": "79D",
      "name": "Philippi/Barbour Co Regional",
      "city": "Philippi",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.311944,
      "longitude": -80.175833,
      "elevationFeet": 1780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/79D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/79D?codeType=fs"
     },
     {
      "fs": "79F",
      "iata": "",
      "icao": "",
      "faa": "79F",
      "name": "Teramiranda",
      "city": "Afton",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.684111,
      "longitude": -94.924556,
      "elevationFeet": 793,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/79F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/79F?codeType=fs"
     },
     {
      "fs": "79J",
      "iata": "",
      "icao": "",
      "faa": "79J",
      "name": "Andalusia-Opp Municipal",
      "city": "Andalusia/Opp",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.387528,
      "longitude": -86.487611,
      "elevationFeet": 309,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/79J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/79J?codeType=fs"
     },
     {
      "fs": "79N",
      "iata": "",
      "icao": "",
      "faa": "79N",
      "name": "Keystone",
      "city": "Unionville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.9,
      "longitude": -78.016667,
      "elevationFeet": 815,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/79N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/79N?codeType=fs"
     },
     {
      "fs": "79S",
      "iata": "",
      "icao": "",
      "faa": "79S",
      "name": "Ft Benton",
      "city": "Ft Benton",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 47.958333,
      "longitude": -110.636111,
      "elevationFeet": 2869,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/79S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/79S?codeType=fs"
     },
     {
      "fs": "7A0",
      "iata": "",
      "icao": "",
      "faa": "7A0",
      "name": "Greensboro Municipal",
      "city": "Greensboro",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.814389,
      "longitude": -87.770278,
      "elevationFeet": 180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A0?codeType=fs"
     },
     {
      "fs": "7A2",
      "iata": "",
      "icao": "",
      "faa": "7A2",
      "name": "Demopolis Municipal",
      "city": "Demopolis",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.588333,
      "longitude": -87.990444,
      "elevationFeet": 112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A2?codeType=fs"
     },
     {
      "fs": "7A3",
      "iata": "",
      "icao": "",
      "faa": "7A3",
      "name": "Chambers Municipal",
      "city": "Lanett",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.920472,
      "longitude": -85.345806,
      "elevationFeet": 624,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A3?codeType=fs"
     },
     {
      "fs": "7A4",
      "iata": "",
      "icao": "",
      "faa": "7A4",
      "name": "Foster",
      "city": "Apple River",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.450083,
      "longitude": -90.192917,
      "elevationFeet": 990,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A4?codeType=fs"
     },
     {
      "fs": "7A5",
      "iata": "",
      "icao": "",
      "faa": "7A5",
      "name": "Roanoke Municipal",
      "city": "Roanoke",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.242861,
      "longitude": -85.516139,
      "elevationFeet": 907,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A5?codeType=fs"
     },
     {
      "fs": "7A6",
      "iata": "",
      "icao": "",
      "faa": "7A6",
      "name": "Stevenson",
      "city": "Stevenson",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.911917,
      "longitude": -85.830306,
      "elevationFeet": 641,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A6?codeType=fs"
     },
     {
      "fs": "7A8",
      "iata": "",
      "icao": "",
      "faa": "7A8",
      "name": "Avery Co",
      "city": "Spruce Pine",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.045694,
      "longitude": -82.106694,
      "elevationFeet": 2750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A8?codeType=fs"
     },
     {
      "fs": "7A9",
      "iata": "",
      "icao": "",
      "faa": "7A9",
      "name": "Peterson",
      "city": "Plains",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 32.154389,
      "longitude": -84.421361,
      "elevationFeet": 526,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7A9?codeType=fs"
     },
     {
      "fs": "7B2",
      "iata": "",
      "icao": "",
      "faa": "7B2",
      "name": "Northampton",
      "city": "Northampton",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.431722,
      "longitude": -72.715056,
      "elevationFeet": 122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7B2?codeType=fs"
     },
     {
      "fs": "7B3",
      "iata": "",
      "icao": "",
      "faa": "7B3",
      "name": "Hampton",
      "city": "Hampton",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.075889,
      "longitude": -70.936639,
      "elevationFeet": 93,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7B3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7B3?codeType=fs"
     },
     {
      "fs": "7B4",
      "iata": "",
      "icao": "",
      "faa": "7B4",
      "name": "Miller Farm",
      "city": "Baltimore",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.895083,
      "longitude": -82.6405,
      "elevationFeet": 930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7B4?codeType=fs"
     },
     {
      "fs": "7B6",
      "iata": "",
      "icao": "",
      "faa": "7B6",
      "name": "Skylark Airpark",
      "city": "Warehouse Point",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.929448,
      "longitude": -72.573249,
      "elevationFeet": 116,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7B6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7B6?codeType=fs"
     },
     {
      "fs": "7B9",
      "iata": "",
      "icao": "",
      "faa": "7B9",
      "name": "Ellington Airport",
      "city": "Ellington",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.92479,
      "longitude": -72.455191,
      "elevationFeet": 291,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7B9?codeType=fs"
     },
     {
      "fs": "7C3",
      "iata": "",
      "icao": "",
      "faa": "7C3",
      "name": "Monona Municipal",
      "city": "Monona",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.155389,
      "longitude": -91.459694,
      "elevationFeet": 1147,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7C3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7C3?codeType=fs"
     },
     {
      "fs": "7C5",
      "iata": "",
      "icao": "",
      "faa": "7C5",
      "name": "Sig Field",
      "city": "Montezuma",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.682",
      "utcOffsetHours": -10,
      "latitude": 41.658333,
      "longitude": -92.533333,
      "elevationFeet": 929,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7C5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7C5?codeType=fs"
     },
     {
      "fs": "7D2",
      "iata": "",
      "icao": "",
      "faa": "7D2",
      "name": "Oakland/Troy",
      "city": "Troy",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.629444,
      "longitude": -83.279083,
      "elevationFeet": 729,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7D2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7D2?codeType=fs"
     },
     {
      "fs": "7D3",
      "iata": "",
      "icao": "",
      "faa": "7D3",
      "name": "Baldwin Municipal",
      "city": "Baldwin",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.954889,
      "longitude": -85.92125,
      "elevationFeet": 828,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7D3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7D3?codeType=fs"
     },
     {
      "fs": "7D5",
      "iata": "",
      "icao": "",
      "faa": "7D5",
      "name": "Priebe",
      "city": "Findlay",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.239417,
      "longitude": -83.693778,
      "elevationFeet": 795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7D5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7D5?codeType=fs"
     },
     {
      "fs": "7D6",
      "iata": "",
      "icao": "",
      "faa": "7D6",
      "name": "Freedom",
      "city": "Freedom",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.239444,
      "longitude": -81.203778,
      "elevationFeet": 1220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7D6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7D6?codeType=fs"
     },
     {
      "fs": "7D8",
      "iata": "",
      "icao": "",
      "faa": "7D8",
      "name": "Gates",
      "city": "Garrettsville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.361667,
      "longitude": -81.245417,
      "elevationFeet": 1110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7D8?codeType=fs"
     },
     {
      "fs": "7D9",
      "iata": "",
      "icao": "",
      "faa": "7D9",
      "name": "Germack",
      "city": "Geneva",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.878333,
      "longitude": -80.939806,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7D9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7D9?codeType=fs"
     },
     {
      "fs": "7E3",
      "iata": "",
      "icao": "",
      "faa": "7E3",
      "name": "Mills",
      "city": "Mantua",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.289444,
      "longitude": -81.289917,
      "elevationFeet": 1140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7E3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7E3?codeType=fs"
     },
     {
      "fs": "7F2",
      "iata": "",
      "icao": "",
      "faa": "7F2",
      "name": "Dupree Municipal",
      "city": "Dupree",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.199806,
      "longitude": -101.690444,
      "elevationFeet": 2341,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7F2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7F2?codeType=fs"
     },
     {
      "fs": "7F3",
      "iata": "",
      "icao": "",
      "faa": "7F3",
      "name": "Caddo Mills Municipal",
      "city": "Caddo Mills",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.062222,
      "longitude": -96.331389,
      "elevationFeet": 542,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7F3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7F3?codeType=fs"
     },
     {
      "fs": "7F5",
      "iata": "",
      "icao": "",
      "faa": "7F5",
      "name": "Canton-Hackney",
      "city": "Canton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.612444,
      "longitude": -95.977444,
      "elevationFeet": 500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7F5?codeType=fs"
     },
     {
      "fs": "7F6",
      "iata": "",
      "icao": "",
      "faa": "7F6",
      "name": "Clarksville-Red River Co",
      "city": "Clarksville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.681639,
      "longitude": -95.185556,
      "elevationFeet": 440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7F6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7F6?codeType=fs"
     },
     {
      "fs": "7F7",
      "iata": "",
      "icao": "",
      "faa": "7F7",
      "name": "Clifton Municipal/Isenhower",
      "city": "Clifton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.818222,
      "longitude": -97.569639,
      "elevationFeet": 760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7F7?codeType=fs"
     },
     {
      "fs": "7F9",
      "iata": "",
      "icao": "",
      "faa": "7F9",
      "name": "Comanche Co-City",
      "city": "Comanche",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.918139,
      "longitude": -98.60325,
      "elevationFeet": 1388,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7F9?codeType=fs"
     },
     {
      "fs": "7FL6",
      "iata": "",
      "icao": "",
      "faa": "7FL6",
      "name": "Spruce Creek",
      "city": "Daytona Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 29.201667,
      "longitude": -81.166667,
      "elevationFeet": 24,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7FL6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7FL6?codeType=fs"
     },
     {
      "fs": "7G0",
      "iata": "",
      "icao": "",
      "faa": "7G0",
      "name": "Ledgedale",
      "city": "Brockport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.311722,
      "longitude": -78.036222,
      "elevationFeet": 666,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7G0?codeType=fs"
     },
     {
      "fs": "7G1",
      "iata": "",
      "icao": "",
      "faa": "7G1",
      "name": "Herron",
      "city": "New Cumberland",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.534,
      "longitude": -80.600694,
      "elevationFeet": 1226,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7G1?codeType=fs"
     },
     {
      "fs": "7G2",
      "iata": "",
      "icao": "",
      "faa": "7G2",
      "name": "Mc Clusky Municipal",
      "city": "Mc Clusky",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.572194,
      "longitude": -100.5235,
      "elevationFeet": 1900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7G2?codeType=fs"
     },
     {
      "fs": "7G4",
      "iata": "",
      "icao": "",
      "faa": "7G4",
      "name": "Blue Knob Valley",
      "city": "Newry",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.509056,
      "longitude": -78.489028,
      "elevationFeet": 1270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7G4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7G4?codeType=fs"
     },
     {
      "fs": "7G8",
      "iata": "",
      "icao": "",
      "faa": "7G8",
      "name": "Geauga Co",
      "city": "Middlefield",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.596111,
      "longitude": -81.179306,
      "elevationFeet": 1175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7G8?codeType=fs"
     },
     {
      "fs": "7I2",
      "iata": "",
      "icao": "",
      "faa": "7I2",
      "name": "Reese",
      "city": "Muncie",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.192111,
      "longitude": -85.466361,
      "elevationFeet": 991,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7I2?codeType=fs"
     },
     {
      "fs": "7I4",
      "iata": "",
      "icao": "",
      "faa": "7I4",
      "name": "Orleans",
      "city": "Orleans",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.733861,
      "longitude": -86.530444,
      "elevationFeet": 655,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7I4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7I4?codeType=fs"
     },
     {
      "fs": "7I7",
      "iata": "",
      "icao": "",
      "faa": "7I7",
      "name": "Bellefontaine Municipal",
      "city": "Bellefontaine",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.520833,
      "longitude": -83.768611,
      "elevationFeet": 1345,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7I7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7I7?codeType=fs"
     },
     {
      "fs": "7J1",
      "iata": "",
      "icao": "",
      "faa": "7J1",
      "name": "Lexington Co",
      "city": "Gaston",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.818194,
      "longitude": -81.198167,
      "elevationFeet": 460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7J1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7J1?codeType=fs"
     },
     {
      "fs": "7K4",
      "iata": "",
      "icao": "",
      "faa": "7K4",
      "name": "Ohio Co",
      "city": "Hartford",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.533333,
      "longitude": -86.999444,
      "elevationFeet": 535,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7K4?codeType=fs"
     },
     {
      "fs": "7K5",
      "iata": "",
      "icao": "",
      "faa": "7K5",
      "name": "Kenmare Municipal",
      "city": "Kenmare",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 48.675833,
      "longitude": -102.175944,
      "elevationFeet": 1962,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7K5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7K5?codeType=fs"
     },
     {
      "fs": "7K6",
      "iata": "",
      "icao": "",
      "faa": "7K6",
      "name": "Wilcox",
      "city": "Anthony",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.083556,
      "longitude": -98.092278,
      "elevationFeet": 1263,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7K6?codeType=fs"
     },
     {
      "fs": "7K7",
      "iata": "",
      "icao": "",
      "faa": "7K7",
      "name": "Graham",
      "city": "North Sioux City",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.602722,
      "longitude": -96.500306,
      "elevationFeet": 1106,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7K7?codeType=fs"
     },
     {
      "fs": "7K8",
      "iata": "",
      "icao": "",
      "faa": "7K8",
      "name": "Martin",
      "city": "South Sioux City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.491611,
      "longitude": -96.525306,
      "elevationFeet": 1100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7K8?codeType=fs"
     },
     {
      "fs": "7L2",
      "iata": "",
      "icao": "",
      "faa": "7L2",
      "name": "Linton Municipal",
      "city": "Linton",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.233056,
      "longitude": -100.350028,
      "elevationFeet": 1778,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7L2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7L2?codeType=fs"
     },
     {
      "fs": "7L7",
      "iata": "",
      "icao": "",
      "faa": "7L7",
      "name": "Harbour",
      "city": "Gravois Mills",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.266972,
      "longitude": -92.818583,
      "elevationFeet": 823,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7L7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7L7?codeType=fs"
     },
     {
      "fs": "7L8",
      "iata": "",
      "icao": "",
      "faa": "7L8",
      "name": "Post Air Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.747859,
      "longitude": -86.012583,
      "elevationFeet": 864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7L8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7L8?codeType=fs"
     },
     {
      "fs": "7M0",
      "iata": "",
      "icao": "",
      "faa": "7M0",
      "name": "Mc Crory-Morton",
      "city": "Mc Crory",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.328667,
      "longitude": -91.181778,
      "elevationFeet": 222,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M0?codeType=fs"
     },
     {
      "fs": "7M1",
      "iata": "",
      "icao": "",
      "faa": "7M1",
      "name": "Mc Gehee Municipal",
      "city": "Mc Gehee",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.652222,
      "longitude": -91.498417,
      "elevationFeet": 141,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M1?codeType=fs"
     },
     {
      "fs": "7M2",
      "iata": "",
      "icao": "",
      "faa": "7M2",
      "name": "Mountain View Wilcox Memorial",
      "city": "Mountain View",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.003528,
      "longitude": -92.170972,
      "elevationFeet": 802,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M2?codeType=fs"
     },
     {
      "fs": "7M3",
      "iata": "",
      "icao": "",
      "faa": "7M3",
      "name": "Bearce",
      "city": "Mount Ida",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.642611,
      "longitude": -93.621361,
      "elevationFeet": 643,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M3?codeType=fs"
     },
     {
      "fs": "7M4",
      "iata": "",
      "icao": "",
      "faa": "7M4",
      "name": "Osceola Municipal",
      "city": "Osceola",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.761333,
      "longitude": -90.101167,
      "elevationFeet": 234,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M4?codeType=fs"
     },
     {
      "fs": "7M5",
      "iata": "",
      "icao": "",
      "faa": "7M5",
      "name": "Ozark-Franklin Co",
      "city": "Ozark",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.606944,
      "longitude": -93.893083,
      "elevationFeet": 648,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M5?codeType=fs"
     },
     {
      "fs": "7M6",
      "iata": "",
      "icao": "",
      "faa": "7M6",
      "name": "Paris Municipal",
      "city": "Paris/Subiaco",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.300889,
      "longitude": -93.685278,
      "elevationFeet": 430,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M6?codeType=fs"
     },
     {
      "fs": "7M7",
      "iata": "",
      "icao": "",
      "faa": "7M7",
      "name": "Piggott Municipal",
      "city": "Piggott",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.482056,
      "longitude": -90.312417,
      "elevationFeet": 272,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M7?codeType=fs"
     },
     {
      "fs": "7M8",
      "iata": "",
      "icao": "",
      "faa": "7M8",
      "name": "Rector",
      "city": "Rector",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.250639,
      "longitude": -90.345472,
      "elevationFeet": 281,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M8?codeType=fs"
     },
     {
      "fs": "7M9",
      "iata": "",
      "icao": "",
      "faa": "7M9",
      "name": "Salem",
      "city": "Salem",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.409083,
      "longitude": -91.959556,
      "elevationFeet": 787,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7M9?codeType=fs"
     },
     {
      "fs": "7MO",
      "iata": "",
      "icao": "",
      "faa": "7MO",
      "name": "Princeton-Kauffman Memorial",
      "city": "Princeton",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.458417,
      "longitude": -93.738333,
      "elevationFeet": 858,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7MO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7MO?codeType=fs"
     },
     {
      "fs": "7N1",
      "iata": "",
      "icao": "",
      "faa": "7N1",
      "name": "Corning-Painted Post",
      "city": "Corning",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.259083,
      "longitude": -77.221917,
      "elevationFeet": 951,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7N1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7N1?codeType=fs"
     },
     {
      "fs": "7N6",
      "iata": "",
      "icao": "",
      "faa": "7N6",
      "name": "Grenora Centennial",
      "city": "Grenora",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 48.705833,
      "longitude": -104.049306,
      "elevationFeet": 2145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7N6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7N6?codeType=fs"
     },
     {
      "fs": "7N7",
      "iata": "",
      "icao": "",
      "faa": "7N7",
      "name": "Old Mans",
      "city": "Pedrictown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 39.755583,
      "longitude": -75.527194,
      "elevationFeet": 40,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7N7?codeType=fs"
     },
     {
      "fs": "7N8",
      "iata": "",
      "icao": "",
      "faa": "7N8",
      "name": "Butter Valley Golf Port",
      "city": "Bally",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.531528,
      "longitude": -75.6935,
      "elevationFeet": 500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7N8?codeType=fs"
     },
     {
      "fs": "7P5",
      "iata": "",
      "icao": "",
      "faa": "7P5",
      "name": "Piso",
      "city": "Suring",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.202611,
      "longitude": -88.514917,
      "elevationFeet": 891,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7P5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7P5?codeType=fs"
     },
     {
      "fs": "7Q7",
      "iata": "",
      "icao": "",
      "faa": "7Q7",
      "name": "White River Municipal",
      "city": "White River",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 43.666639,
      "longitude": -100.818056,
      "elevationFeet": 2151,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7Q7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7Q7?codeType=fs"
     },
     {
      "fs": "7R9",
      "iata": "",
      "icao": "",
      "faa": "7R9",
      "name": "Bailes",
      "city": "Angleton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.305222,
      "longitude": -95.402167,
      "elevationFeet": 21,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7R9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7R9?codeType=fs"
     },
     {
      "fs": "7S1",
      "iata": "",
      "icao": "",
      "faa": "7S1",
      "name": "Twin Bridges",
      "city": "Twin Bridges",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.682583,
      "longitude": -112.391667,
      "elevationFeet": 4772,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S1?codeType=fs"
     },
     {
      "fs": "7S3",
      "iata": "",
      "icao": "",
      "faa": "7S3",
      "name": "Stark'S Twin Oaks",
      "city": "Hillsboro",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 45.5345,
      "longitude": -123.021583,
      "elevationFeet": 170,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S3?codeType=fs"
     },
     {
      "fs": "7S4",
      "iata": "",
      "icao": "",
      "faa": "7S4",
      "name": "Wisdom",
      "city": "Wisdom",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.665889,
      "longitude": -113.54225,
      "elevationFeet": 6133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S4?codeType=fs"
     },
     {
      "fs": "7S5",
      "iata": "",
      "icao": "",
      "faa": "7S5",
      "name": "Independence State",
      "city": "Independence",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 44.867639,
      "longitude": -123.332472,
      "elevationFeet": 176,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S5?codeType=fs"
     },
     {
      "fs": "7S6",
      "iata": "",
      "icao": "",
      "faa": "7S6",
      "name": "White Sulphur Springs",
      "city": "White Sulphur Springs",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.541083,
      "longitude": -111.032667,
      "elevationFeet": 5061,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S6?codeType=fs"
     },
     {
      "fs": "7S7",
      "iata": "",
      "icao": "",
      "faa": "7S7",
      "name": "Valier",
      "city": "Valier",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.44975,
      "longitude": -112.258722,
      "elevationFeet": 3820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S7?codeType=fs"
     },
     {
      "fs": "7S8",
      "iata": "",
      "icao": "",
      "faa": "7S8",
      "name": "Ross International Airport",
      "city": "Sweetgrass",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.996835,
      "longitude": -111.971627,
      "elevationFeet": 3569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S8?codeType=fs"
     },
     {
      "fs": "7S9",
      "iata": "",
      "icao": "",
      "faa": "7S9",
      "name": "Lenhardt",
      "city": "Hubbard",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 45.303972,
      "longitude": -122.83425,
      "elevationFeet": 165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7S9?codeType=fs"
     },
     {
      "fs": "7SP",
      "iata": "",
      "icao": "",
      "faa": "7SP",
      "name": "Seven Springs",
      "city": "Seven Springs Borough",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.100472,
      "longitude": -79.368944,
      "elevationFeet": 2907,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7SP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7SP?codeType=fs"
     },
     {
      "fs": "7T7",
      "iata": "",
      "icao": "",
      "faa": "7T7",
      "name": "Skywest Inc",
      "city": "Midland",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.934611,
      "longitude": -102.14025,
      "elevationFeet": 2800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7T7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7T7?codeType=fs"
     },
     {
      "fs": "7U4",
      "iata": "",
      "icao": "",
      "faa": "7U4",
      "name": "Morgan",
      "city": "Morgan",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 49.000194,
      "longitude": -107.9065,
      "elevationFeet": 2813,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7U4?codeType=fs"
     },
     {
      "fs": "7U8",
      "iata": "",
      "icao": "",
      "faa": "7U8",
      "name": "Richey",
      "city": "Richey",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 47.716806,
      "longitude": -105.163639,
      "elevationFeet": 2493,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7U8?codeType=fs"
     },
     {
      "fs": "7V1",
      "iata": "",
      "icao": "",
      "faa": "7V1",
      "name": "Central Colorado Regional",
      "city": "Buena Vista",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 38.941611,
      "longitude": -106.156944,
      "elevationFeet": 7946,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V1?codeType=fs"
     },
     {
      "fs": "7V3",
      "iata": "",
      "icao": "",
      "faa": "7V3",
      "name": "Big Foot",
      "city": "Walworth",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.627944,
      "longitude": -88.689917,
      "elevationFeet": 951,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V3?codeType=fs"
     },
     {
      "fs": "7V5",
      "iata": "",
      "icao": "",
      "faa": "7V5",
      "name": "Brush Municipal",
      "city": "Brush",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 40.388694,
      "longitude": -103.710583,
      "elevationFeet": 4280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V5?codeType=fs"
     },
     {
      "fs": "7V6",
      "iata": "",
      "icao": "",
      "faa": "7V6",
      "name": "Camp Guernsey",
      "city": "Guernsey",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 42.346111,
      "longitude": -104.832889,
      "elevationFeet": 4400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V6?codeType=fs"
     },
     {
      "fs": "7V7",
      "iata": "",
      "icao": "",
      "faa": "7V7",
      "name": "Red Cloud Municipal",
      "city": "Red Cloud",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.097361,
      "longitude": -98.606167,
      "elevationFeet": 1742,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V7?codeType=fs"
     },
     {
      "fs": "7V8",
      "iata": "",
      "icao": "",
      "faa": "7V8",
      "name": "Julesburg Municipal",
      "city": "Julesburg",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 41.00825,
      "longitude": -102.454639,
      "elevationFeet": 3520,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V8?codeType=fs"
     },
     {
      "fs": "7V9",
      "iata": "",
      "icao": "",
      "faa": "7V9",
      "name": "City And Co",
      "city": "Las Animas",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 38.077833,
      "longitude": -103.271528,
      "elevationFeet": 3915,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7V9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7V9?codeType=fs"
     },
     {
      "fs": "7W1",
      "iata": "",
      "icao": "",
      "faa": "7W1",
      "name": "Port Of Ilwaco",
      "city": "Ilwaco",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 46.464889,
      "longitude": -124.012639,
      "elevationFeet": 8,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7W1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7W1?codeType=fs"
     },
     {
      "fs": "7W4",
      "iata": "",
      "icao": "",
      "faa": "7W4",
      "name": "Lake Anna",
      "city": "Bumpass",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.106944,
      "longitude": -77.85825,
      "elevationFeet": 355,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7W4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7W4?codeType=fs"
     },
     {
      "fs": "7W5",
      "iata": "",
      "icao": "",
      "faa": "7W5",
      "name": "Henry Co",
      "city": "Napoleon",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.442778,
      "longitude": -84.079167,
      "elevationFeet": 683,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7W5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7W5?codeType=fs"
     },
     {
      "fs": "7W6",
      "iata": "",
      "icao": "",
      "faa": "7W6",
      "name": "Hyde Co",
      "city": "Engelhard",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 35.673917,
      "longitude": -76.001833,
      "elevationFeet": 8,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7W6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7W6?codeType=fs"
     },
     {
      "fs": "7Y2",
      "iata": "",
      "icao": "",
      "faa": "7Y2",
      "name": "Thompsonville",
      "city": "Thompsonville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.516694,
      "longitude": -86.050833,
      "elevationFeet": 793,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7Y2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7Y2?codeType=fs"
     },
     {
      "fs": "7Y3",
      "iata": "",
      "icao": "",
      "faa": "7Y3",
      "name": "Backus Municipal",
      "city": "Backus",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.919028,
      "longitude": -94.572194,
      "elevationFeet": 1355,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7Y3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7Y3?codeType=fs"
     },
     {
      "fs": "7Y4",
      "iata": "",
      "icao": "",
      "faa": "7Y4",
      "name": "Bagley Municipal",
      "city": "Bagley",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.599556,
      "longitude": -95.458472,
      "elevationFeet": 1500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7Y4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7Y4?codeType=fs"
     },
     {
      "fs": "7Y7",
      "iata": "",
      "icao": "",
      "faa": "7Y7",
      "name": "A R S Sport Strip",
      "city": "Belle Plaine",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.816306,
      "longitude": -93.78575,
      "elevationFeet": 955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7Y7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7Y7?codeType=fs"
     },
     {
      "fs": "7Y9",
      "iata": "",
      "icao": "",
      "faa": "7Y9",
      "name": "Big Falls Municipal",
      "city": "Big Falls",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 48.307833,
      "longitude": -93.768444,
      "elevationFeet": 1232,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/7Y9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/7Y9?codeType=fs"
     },
     {
      "fs": "80C",
      "iata": "",
      "icao": "",
      "faa": "80C",
      "name": "Lone Hickory",
      "city": "Yadkinville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.063889,
      "longitude": -80.744444,
      "elevationFeet": 1000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/80C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/80C?codeType=fs"
     },
     {
      "fs": "80D",
      "iata": "",
      "icao": "",
      "faa": "80D",
      "name": "Clare Co",
      "city": "Harrison",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.077972,
      "longitude": -84.92525,
      "elevationFeet": 1142,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/80D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/80D?codeType=fs"
     },
     {
      "fs": "80G",
      "iata": "",
      "icao": "",
      "faa": "80G",
      "name": "Tri-City",
      "city": "West Lafayette",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.3785,
      "longitude": -81.759583,
      "elevationFeet": 844,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/80G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/80G?codeType=fs"
     },
     {
      "fs": "80S",
      "iata": "",
      "icao": "",
      "faa": "80S",
      "name": "Lavina",
      "city": "Lavina",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.371806,
      "longitude": -109.007139,
      "elevationFeet": 3490,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/80S?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/80S?codeType=fs"
     },
     {
      "fs": "80T",
      "iata": "",
      "icao": "",
      "faa": "80T",
      "name": "Quincy Municipal",
      "city": "Quincy",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.316111,
      "longitude": -119.898333,
      "elevationFeet": 120,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/80T?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/80T?codeType=fs"
     },
     {
      "fs": "80V",
      "iata": "",
      "icao": "",
      "faa": "80V",
      "name": "Medicine Bow",
      "city": "Medicine Bow",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 42.033,
      "longitude": -106.308472,
      "elevationFeet": 6646,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/80V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/80V?codeType=fs"
     },
     {
      "fs": "81B",
      "iata": "",
      "icao": "",
      "faa": "81B",
      "name": "Oxford Co Regional",
      "city": "Oxford",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.22425,
      "longitude": -70.612972,
      "elevationFeet": 346,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/81B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/81B?codeType=fs"
     },
     {
      "fs": "81D",
      "iata": "",
      "icao": "",
      "faa": "81D",
      "name": "Flyin Tiger Airport",
      "city": "Angleton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.265191,
      "longitude": -95.410792,
      "elevationFeet": 33,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/81D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/81D?codeType=fs"
     },
     {
      "fs": "81R",
      "iata": "",
      "icao": "",
      "faa": "81R",
      "name": "San Saba Co Municipal",
      "city": "San Saba",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.251667,
      "longitude": -98.719861,
      "elevationFeet": 1249,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/81R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/81R?codeType=fs"
     },
     {
      "fs": "82A",
      "iata": "",
      "icao": "",
      "faa": "82A",
      "name": "Marion Co",
      "city": "Buena Vista",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 32.42375,
      "longitude": -84.535278,
      "elevationFeet": 682,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/82A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/82A?codeType=fs"
     },
     {
      "fs": "82C",
      "iata": "",
      "icao": "",
      "faa": "82C",
      "name": "Mauston-New Lisbon Union",
      "city": "New Lisbon",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.887222,
      "longitude": -90.176833,
      "elevationFeet": 905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/82C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/82C?codeType=fs"
     },
     {
      "fs": "82D",
      "iata": "",
      "icao": "",
      "faa": "82D",
      "name": "Weiker Airport",
      "city": "Green Springs",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.233607,
      "longitude": -83.03262,
      "elevationFeet": 746,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/82D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/82D?codeType=fs"
     },
     {
      "fs": "82IS",
      "iata": "",
      "icao": "",
      "faa": "82IS",
      "name": "Landings Condominium",
      "city": "Huntley",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.143081,
      "longitude": -88.402861,
      "elevationFeet": 880,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/82IS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/82IS?codeType=fs"
     },
     {
      "fs": "82J",
      "iata": "",
      "icao": "",
      "faa": "82J",
      "name": "Ferguson",
      "city": "Pensacola",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.538083,
      "longitude": -87.485861,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/82J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/82J?codeType=fs"
     },
     {
      "fs": "82V",
      "iata": "",
      "icao": "",
      "faa": "82V",
      "name": "Pine Bluffs Municipal",
      "city": "Pine Bluffs",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 41.183167,
      "longitude": -104.252306,
      "elevationFeet": 5152,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/82V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/82V?codeType=fs"
     },
     {
      "fs": "83D",
      "iata": "",
      "icao": "",
      "faa": "83D",
      "name": "Mackinac Co",
      "city": "St Ignace",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 45.952917,
      "longitude": -84.7755,
      "elevationFeet": 623,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/83D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/83D?codeType=fs"
     },
     {
      "fs": "83G",
      "iata": "",
      "icao": "",
      "faa": "83G",
      "name": "Loars Field Inc",
      "city": "Onsted",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.000444,
      "longitude": -84.332778,
      "elevationFeet": 990,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/83G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/83G?codeType=fs"
     },
     {
      "fs": "83J",
      "iata": "",
      "icao": "",
      "faa": "83J",
      "name": "Coastal",
      "city": "Pensacola",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.668889,
      "longitude": -87.403083,
      "elevationFeet": 110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/83J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/83J?codeType=fs"
     },
     {
      "fs": "83R",
      "iata": "",
      "icao": "",
      "faa": "83R",
      "name": "Beicker Ranch",
      "city": "Seguin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.644,
      "longitude": -97.833333,
      "elevationFeet": 465,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/83R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/83R?codeType=fs"
     },
     {
      "fs": "83V",
      "iata": "",
      "icao": "",
      "faa": "83V",
      "name": "Upton Municipal",
      "city": "Upton",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 44.155361,
      "longitude": -104.707944,
      "elevationFeet": 4290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/83V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/83V?codeType=fs"
     },
     {
      "fs": "84A",
      "iata": "",
      "icao": "",
      "faa": "84A",
      "name": "Mathis",
      "city": "Cumming",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.112111,
      "longitude": -84.260278,
      "elevationFeet": 1170,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/84A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/84A?codeType=fs"
     },
     {
      "fs": "84C",
      "iata": "",
      "icao": "",
      "faa": "84C",
      "name": "Valhalla",
      "city": "North Cape",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.875167,
      "longitude": -88.125833,
      "elevationFeet": 805,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/84C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/84C?codeType=fs"
     },
     {
      "fs": "84D",
      "iata": "",
      "icao": "",
      "faa": "84D",
      "name": "Cheyenne Eagle Butte",
      "city": "Eagle Butte",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 44.99375,
      "longitude": -101.260417,
      "elevationFeet": 2447,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/84D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/84D?codeType=fs"
     },
     {
      "fs": "84R",
      "iata": "",
      "icao": "",
      "faa": "84R",
      "name": "Smithville Municipal",
      "city": "Smithville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.154806,
      "longitude": -97.168722,
      "elevationFeet": 323,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/84R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/84R?codeType=fs"
     },
     {
      "fs": "84Y",
      "iata": "",
      "icao": "",
      "faa": "84Y",
      "name": "Bloomfield Municipal",
      "city": "Bloomfield",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.69725,
      "longitude": -97.73675,
      "elevationFeet": 1673,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/84Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/84Y?codeType=fs"
     },
     {
      "fs": "85N",
      "iata": "",
      "icao": "",
      "faa": "85N",
      "name": "Hollands International",
      "city": "Newfane",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.267222,
      "longitude": -78.778139,
      "elevationFeet": 360,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/85N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/85N?codeType=fs"
     },
     {
      "fs": "85U",
      "iata": "",
      "icao": "",
      "faa": "85U",
      "name": "Soldier Bar Usfs",
      "city": "Soldier Bar",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.265806,
      "longitude": -114.809306,
      "elevationFeet": 4190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/85U?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/85U?codeType=fs"
     },
     {
      "fs": "85V",
      "iata": "",
      "icao": "",
      "faa": "85V",
      "name": "Ganado",
      "city": "Ganado",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 35.714028,
      "longitude": -109.603806,
      "elevationFeet": 6662,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/85V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/85V?codeType=fs"
     },
     {
      "fs": "86D",
      "iata": "",
      "icao": "",
      "faa": "86D",
      "name": "Far View",
      "city": "Hiram",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.408889,
      "longitude": -81.231556,
      "elevationFeet": 1300,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/86D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/86D?codeType=fs"
     },
     {
      "fs": "86F",
      "iata": "",
      "icao": "",
      "faa": "86F",
      "name": "Carnegie Municipal",
      "city": "Carnegie",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.156139,
      "longitude": -98.706167,
      "elevationFeet": 1354,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/86F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/86F?codeType=fs"
     },
     {
      "fs": "87I",
      "iata": "",
      "icao": "",
      "faa": "87I",
      "name": "Yazoo Co",
      "city": "Yazoo City",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.032139,
      "longitude": -90.586472,
      "elevationFeet": 104,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/87I?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/87I?codeType=fs"
     },
     {
      "fs": "87K",
      "iata": "",
      "icao": "",
      "faa": "87K",
      "name": "El Dorado Springs Memorial",
      "city": "El Dorado Springs",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.916722,
      "longitude": -94.141139,
      "elevationFeet": 931,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/87K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/87K?codeType=fs"
     },
     {
      "fs": "87Y",
      "iata": "",
      "icao": "",
      "faa": "87Y",
      "name": "Blackhawk",
      "city": "Madison",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.149139,
      "longitude": -89.205389,
      "elevationFeet": 920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/87Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/87Y?codeType=fs"
     },
     {
      "fs": "88C",
      "iata": "",
      "icao": "",
      "faa": "88C",
      "name": "Palmyra Municipal",
      "city": "Palmyra",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.885556,
      "longitude": -88.724306,
      "elevationFeet": 851,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88C?codeType=fs"
     },
     {
      "fs": "88D",
      "iata": "",
      "icao": "",
      "faa": "88D",
      "name": "Hinde Airport",
      "city": "Huron",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.404529,
      "longitude": -82.600086,
      "elevationFeet": 603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88D?codeType=fs"
     },
     {
      "fs": "88G",
      "iata": "",
      "icao": "",
      "faa": "88G",
      "name": "Gradolph",
      "city": "Petersburg",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.947694,
      "longitude": -83.749389,
      "elevationFeet": 673,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88G?codeType=fs"
     },
     {
      "fs": "88J",
      "iata": "",
      "icao": "",
      "faa": "88J",
      "name": "Allendale Co",
      "city": "Allendale",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.101306,
      "longitude": -81.302472,
      "elevationFeet": 161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88J?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88J?codeType=fs"
     },
     {
      "fs": "88M",
      "iata": "",
      "icao": "",
      "faa": "88M",
      "name": "Eureka",
      "city": "Eureka",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.988556,
      "longitude": -115.104472,
      "elevationFeet": 2668,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88M?codeType=fs"
     },
     {
      "fs": "88R",
      "iata": "",
      "icao": "",
      "faa": "88R",
      "name": "Spicewood",
      "city": "Spicewood",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 30.579722,
      "longitude": -98.161278,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88R?codeType=fs"
     },
     {
      "fs": "88Y",
      "iata": "",
      "icao": "",
      "faa": "88Y",
      "name": "Perkins Memorial",
      "city": "Chambers",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.202833,
      "longitude": -98.745333,
      "elevationFeet": 2129,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/88Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/88Y?codeType=fs"
     },
     {
      "fs": "89D",
      "iata": "",
      "icao": "",
      "faa": "89D",
      "name": "Kelleys Island Land Field",
      "city": "Kelleys Island",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.605618,
      "longitude": -82.692797,
      "elevationFeet": 592,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/89D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/89D?codeType=fs"
     },
     {
      "fs": "89N",
      "iata": "",
      "icao": "",
      "faa": "89N",
      "name": "Maxson Airfield",
      "city": "Alexandria Bay",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.317167,
      "longitude": -76.046722,
      "elevationFeet": 340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/89N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/89N?codeType=fs"
     },
     {
      "fs": "89Y",
      "iata": "",
      "icao": "",
      "faa": "89Y",
      "name": "Maidens",
      "city": "Williamston",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.733333,
      "longitude": -84.386667,
      "elevationFeet": 920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/89Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/89Y?codeType=fs"
     },
     {
      "fs": "8A1",
      "iata": "",
      "icao": "",
      "faa": "8A1",
      "name": "Guntersville Municipal",
      "city": "Guntersville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.544389,
      "longitude": -86.301611,
      "elevationFeet": 613,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8A1?codeType=fs"
     },
     {
      "fs": "8A3",
      "iata": "",
      "icao": "",
      "faa": "8A3",
      "name": "Livingston Municipal",
      "city": "Livingston",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.52175,
      "longitude": -85.4155,
      "elevationFeet": 1372,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8A3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8A3?codeType=fs"
     },
     {
      "fs": "8A7",
      "iata": "",
      "icao": "",
      "faa": "8A7",
      "name": "Twin Lakes",
      "city": "Mocksville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.049139,
      "longitude": -80.518056,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8A7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8A7?codeType=fs"
     },
     {
      "fs": "8A9",
      "iata": "",
      "icao": "",
      "faa": "8A9",
      "name": "South Fulton",
      "city": "Palmetto",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.576111,
      "longitude": -84.688194,
      "elevationFeet": 1025,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8A9?codeType=fs"
     },
     {
      "fs": "8B0",
      "iata": "",
      "icao": "",
      "faa": "8B0",
      "name": "Rangeley Municipal",
      "city": "Rangeley",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 45.068944,
      "longitude": -70.79625,
      "elevationFeet": 1825,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8B0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8B0?codeType=fs"
     },
     {
      "fs": "8B1",
      "iata": "",
      "icao": "",
      "faa": "8B1",
      "name": "Hawthorne-Feather",
      "city": "Hillsboro",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.067472,
      "longitude": -72.04525,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8B1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8B1?codeType=fs"
     },
     {
      "fs": "8B2",
      "iata": "",
      "icao": "",
      "faa": "8B2",
      "name": "Twin Mountain",
      "city": "Twin Mountain",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.389528,
      "longitude": -71.675806,
      "elevationFeet": 1459,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8B2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8B2?codeType=fs"
     },
     {
      "fs": "8B4",
      "iata": "",
      "icao": "",
      "faa": "8B4",
      "name": "Farnsworths",
      "city": "North Rose",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.267333,
      "longitude": -76.894056,
      "elevationFeet": 420,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8B4?codeType=fs"
     },
     {
      "fs": "8B5",
      "iata": "",
      "icao": "",
      "faa": "8B5",
      "name": "Tanner-Hiller",
      "city": "Barre",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.392583,
      "longitude": -72.236889,
      "elevationFeet": 584,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8B5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8B5?codeType=fs"
     },
     {
      "fs": "8B8",
      "iata": "",
      "icao": "",
      "faa": "8B8",
      "name": "Lakes Region",
      "city": "Wolfeboro",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.625778,
      "longitude": -71.411806,
      "elevationFeet": 580,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8B8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8B8?codeType=fs"
     },
     {
      "fs": "8C2",
      "iata": "",
      "icao": "",
      "faa": "8C2",
      "name": "Sully Municipal",
      "city": "Sully",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 41.622167,
      "longitude": -92.974167,
      "elevationFeet": 922,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8C2?codeType=fs"
     },
     {
      "fs": "8C4",
      "iata": "",
      "icao": "",
      "faa": "8C4",
      "name": "Mathews Memorial",
      "city": "Tipton",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 41.883556,
      "longitude": -91.179361,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8C4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8C4?codeType=fs"
     },
     {
      "fs": "8C5",
      "iata": "",
      "icao": "",
      "faa": "8C5",
      "name": "Toledo Municipal",
      "city": "Toledo",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.066583,
      "longitude": -92.668583,
      "elevationFeet": 960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8C5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8C5?codeType=fs"
     },
     {
      "fs": "8C6",
      "iata": "",
      "icao": "",
      "faa": "8C6",
      "name": "Traer Municipal",
      "city": "Traer",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.341556,
      "longitude": -92.529694,
      "elevationFeet": 892,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8C6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8C6?codeType=fs"
     },
     {
      "fs": "8D1",
      "iata": "",
      "icao": "",
      "faa": "8D1",
      "name": "New Holstein Municipal",
      "city": "New Holstein",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.042417,
      "longitude": -88.234778,
      "elevationFeet": 992,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D1?codeType=fs"
     },
     {
      "fs": "8D3",
      "iata": "",
      "icao": "",
      "faa": "8D3",
      "name": "Sisseton Municipal",
      "city": "Sisseton",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.707917,
      "longitude": -97.111917,
      "elevationFeet": 1161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D3?codeType=fs"
     },
     {
      "fs": "8D4",
      "iata": "",
      "icao": "",
      "faa": "8D4",
      "name": "Sparta",
      "city": "Sparta",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.236083,
      "longitude": -85.768972,
      "elevationFeet": 761,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D4?codeType=fs"
     },
     {
      "fs": "8D6",
      "iata": "",
      "icao": "",
      "faa": "8D6",
      "name": "Mc Intosh Municipal",
      "city": "Mc Intosh",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.983333,
      "longitude": -101.462444,
      "elevationFeet": 2251,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D6?codeType=fs"
     },
     {
      "fs": "8D7",
      "iata": "",
      "icao": "",
      "faa": "8D7",
      "name": "Clark Co",
      "city": "Clark",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.007028,
      "longitude": -97.819139,
      "elevationFeet": 1793,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D7?codeType=fs"
     },
     {
      "fs": "8D8",
      "iata": "",
      "icao": "",
      "faa": "8D8",
      "name": "Lake Andes Municipal",
      "city": "Lake Andes",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.2805,
      "longitude": -98.603583,
      "elevationFeet": 1475,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D8?codeType=fs"
     },
     {
      "fs": "8D9",
      "iata": "",
      "icao": "",
      "faa": "8D9",
      "name": "Howard Municipal",
      "city": "Howard",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.141417,
      "longitude": -97.578472,
      "elevationFeet": 1582,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8D9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8D9?codeType=fs"
     },
     {
      "fs": "8F3",
      "iata": "",
      "icao": "",
      "faa": "8F3",
      "name": "Crosbyton Municipal",
      "city": "Crosbyton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.688361,
      "longitude": -101.308444,
      "elevationFeet": 3017,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8F3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8F3?codeType=fs"
     },
     {
      "fs": "8F4",
      "iata": "",
      "icao": "",
      "faa": "8F4",
      "name": "Foard Co",
      "city": "Crowell",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.0925,
      "longitude": -99.828722,
      "elevationFeet": 1479,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8F4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8F4?codeType=fs"
     },
     {
      "fs": "8F5",
      "iata": "",
      "icao": "",
      "faa": "8F5",
      "name": "Greater Morris Co",
      "city": "Daingerfield",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.217917,
      "longitude": -94.838167,
      "elevationFeet": 402,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8F5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8F5?codeType=fs"
     },
     {
      "fs": "8F6",
      "iata": "",
      "icao": "",
      "faa": "8F6",
      "name": "Murdo Municipal",
      "city": "Murdo",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 43.866556,
      "longitude": -100.820806,
      "elevationFeet": 2263,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8F6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8F6?codeType=fs"
     },
     {
      "fs": "8F7",
      "iata": "",
      "icao": "",
      "faa": "8F7",
      "name": "Decatur Municipal",
      "city": "Decatur",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.296389,
      "longitude": -97.705556,
      "elevationFeet": 1047,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8F7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8F7?codeType=fs"
     },
     {
      "fs": "8F8",
      "iata": "",
      "icao": "",
      "faa": "8F8",
      "name": "Mckeon Aviation",
      "city": "Denison",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.742722,
      "longitude": -96.716611,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8F8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8F8?codeType=fs"
     },
     {
      "fs": "8G1",
      "iata": "",
      "icao": "",
      "faa": "8G1",
      "name": "Willard",
      "city": "Willard",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.0875,
      "longitude": -82.795417,
      "elevationFeet": 967,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8G1?codeType=fs"
     },
     {
      "fs": "8G2",
      "iata": "",
      "icao": "",
      "faa": "8G2",
      "name": "Corry-Lawrence",
      "city": "Corry",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.975556,
      "longitude": -79.7105,
      "elevationFeet": 1766,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8G2?codeType=fs"
     },
     {
      "fs": "8G3",
      "iata": "",
      "icao": "",
      "faa": "8G3",
      "name": "Giermek Executive",
      "city": "Olean",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.08675,
      "longitude": -78.444639,
      "elevationFeet": 1420,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8G3?codeType=fs"
     },
     {
      "fs": "8G6",
      "iata": "",
      "icao": "",
      "faa": "8G6",
      "name": "Harrison Co",
      "city": "Cadiz",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.282056,
      "longitude": -81.125694,
      "elevationFeet": 1174,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8G6?codeType=fs"
     },
     {
      "fs": "8G7",
      "iata": "",
      "icao": "",
      "faa": "8G7",
      "name": "Zelienople Municipal",
      "city": "Zelienople",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.816194,
      "longitude": -80.257278,
      "elevationFeet": 901,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8G7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8G7?codeType=fs"
     },
     {
      "fs": "8G8",
      "iata": "",
      "icao": "",
      "faa": "8G8",
      "name": "Koons",
      "city": "Salem",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.883917,
      "longitude": -81.031417,
      "elevationFeet": 1327,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8G8?codeType=fs"
     },
     {
      "fs": "8GA9",
      "iata": "",
      "icao": "",
      "faa": "8GA9",
      "name": "Brookbridge",
      "city": "Vaughn",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.333333,
      "longitude": -84.516667,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8GA9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8GA9?codeType=fs"
     },
     {
      "fs": "8I1",
      "iata": "",
      "icao": "",
      "faa": "8I1",
      "name": "Robinson",
      "city": "Vevay",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.795056,
      "longitude": -85.332861,
      "elevationFeet": 484,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8I1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8I1?codeType=fs"
     },
     {
      "fs": "8I2",
      "iata": "",
      "icao": "",
      "faa": "8I2",
      "name": "Shades State Park",
      "city": "Waveland",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.061556,
      "longitude": -87.200111,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8I2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8I2?codeType=fs"
     },
     {
      "fs": "8I3",
      "iata": "",
      "icao": "",
      "faa": "8I3",
      "name": "Glenndale",
      "city": "Kokomo",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.433722,
      "longitude": -86.233278,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8I3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8I3?codeType=fs"
     },
     {
      "fs": "8J2",
      "iata": "",
      "icao": "",
      "faa": "8J2",
      "name": "Ames",
      "city": "Trenton",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 29.624611,
      "longitude": -82.912333,
      "elevationFeet": 64,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8J2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8J2?codeType=fs"
     },
     {
      "fs": "8J7",
      "iata": "",
      "icao": "",
      "faa": "8J7",
      "name": "Tomlinson",
      "city": "New Rockford",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.813861,
      "longitude": -99.262278,
      "elevationFeet": 1533,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8J7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8J7?codeType=fs"
     },
     {
      "fs": "8K0",
      "iata": "",
      "icao": "",
      "faa": "8K0",
      "name": "Bucklin",
      "city": "Bucklin",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.564083,
      "longitude": -99.748472,
      "elevationFeet": 2418,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8K0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8K0?codeType=fs"
     },
     {
      "fs": "8K2",
      "iata": "",
      "icao": "",
      "faa": "8K2",
      "name": "Harper Municipal",
      "city": "Harper",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.381861,
      "longitude": -98.134778,
      "elevationFeet": 1427,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8K2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8K2?codeType=fs"
     },
     {
      "fs": "8K5",
      "iata": "",
      "icao": "",
      "faa": "8K5",
      "name": "Yates Center",
      "city": "Yates Center",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.98925,
      "longitude": -95.8915,
      "elevationFeet": 1140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8K5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8K5?codeType=fs"
     },
     {
      "fs": "8K6",
      "iata": "",
      "icao": "",
      "faa": "8K6",
      "name": "Cawker City",
      "city": "Cawker City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 39.525111,
      "longitude": -98.550611,
      "elevationFeet": 1482,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8K6?codeType=fs"
     },
     {
      "fs": "8K7",
      "iata": "",
      "icao": "",
      "faa": "8K7",
      "name": "Windle Municipal",
      "city": "Greensburg",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.600018,
      "longitude": -99.275113,
      "elevationFeet": 2230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8K7?codeType=fs"
     },
     {
      "fs": "8K8",
      "iata": "",
      "icao": "",
      "faa": "8K8",
      "name": "Cimarron Municipal",
      "city": "Cimarron",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.955778,
      "longitude": -100.354222,
      "elevationFeet": 2752,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8K8?codeType=fs"
     },
     {
      "fs": "8M0",
      "iata": "",
      "icao": "",
      "faa": "8M0",
      "name": "Hargrove",
      "city": "Stuttgart",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.625972,
      "longitude": -91.690167,
      "elevationFeet": 211,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M0?codeType=fs"
     },
     {
      "fs": "8M1",
      "iata": "",
      "icao": "",
      "faa": "8M1",
      "name": "Booneville/Baldwyn",
      "city": "Booneville/Baldwyn",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.648194,
      "longitude": -88.77,
      "elevationFeet": 384,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M1?codeType=fs"
     },
     {
      "fs": "8M2",
      "iata": "",
      "icao": "",
      "faa": "8M2",
      "name": "Wofford",
      "city": "Weiner",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.625806,
      "longitude": -90.9845,
      "elevationFeet": 245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M2?codeType=fs"
     },
     {
      "fs": "8M3",
      "iata": "",
      "icao": "",
      "faa": "8M3",
      "name": "Barnesville Municipal",
      "city": "Barnesville",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.802389,
      "longitude": -96.511806,
      "elevationFeet": 980,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M3?codeType=fs"
     },
     {
      "fs": "8M6",
      "iata": "",
      "icao": "",
      "faa": "8M6",
      "name": "Mc Ville Municipal",
      "city": "Mc Ville",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.9305,
      "longitude": -98.214889,
      "elevationFeet": 1473,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M6?codeType=fs"
     },
     {
      "fs": "8M7",
      "iata": "",
      "icao": "",
      "faa": "8M7",
      "name": "Tradewater",
      "city": "Dawson Springs",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.239361,
      "longitude": -87.750056,
      "elevationFeet": 405,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M7?codeType=fs"
     },
     {
      "fs": "8M8",
      "iata": "",
      "icao": "",
      "faa": "8M8",
      "name": "Garland",
      "city": "Lewiston",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.841806,
      "longitude": -84.33625,
      "elevationFeet": 1218,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M8?codeType=fs"
     },
     {
      "fs": "8M9",
      "iata": "",
      "icao": "",
      "faa": "8M9",
      "name": "Providence-Webster Co",
      "city": "Providence",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.497667,
      "longitude": -87.761222,
      "elevationFeet": 393,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8M9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8M9?codeType=fs"
     },
     {
      "fs": "8N1",
      "iata": "",
      "icao": "",
      "faa": "8N1",
      "name": "Grimes",
      "city": "Bethel",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.498139,
      "longitude": -76.385611,
      "elevationFeet": 582,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8N1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8N1?codeType=fs"
     },
     {
      "fs": "8N2",
      "iata": "",
      "icao": "",
      "faa": "8N2",
      "name": "Skydive Chicago",
      "city": "Ottawa",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 41.544444,
      "longitude": -88.886111,
      "elevationFeet": 615,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8N2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8N2?codeType=fs"
     },
     {
      "fs": "8N4",
      "iata": "",
      "icao": "",
      "faa": "8N4",
      "name": "Flying Dollar",
      "city": "Canadensis",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.217583,
      "longitude": -75.39625,
      "elevationFeet": 1400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8N4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8N4?codeType=fs"
     },
     {
      "fs": "8N7",
      "iata": "",
      "icao": "",
      "faa": "8N7",
      "name": "Mc Ginness",
      "city": "Columbia",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.100972,
      "longitude": -76.521861,
      "elevationFeet": 334,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8N7?codeType=fs"
     },
     {
      "fs": "8N8",
      "iata": "",
      "icao": "",
      "faa": "8N8",
      "name": "Danville",
      "city": "Danville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.96475,
      "longitude": -76.727361,
      "elevationFeet": 559,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8N8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8N8?codeType=fs"
     },
     {
      "fs": "8S0",
      "iata": "",
      "icao": "",
      "faa": "8S0",
      "name": "Starr-Browning",
      "city": "Browning",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.613611,
      "longitude": -113.248139,
      "elevationFeet": 4655,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8S0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8S0?codeType=fs"
     },
     {
      "fs": "8S1",
      "iata": "",
      "icao": "",
      "faa": "8S1",
      "name": "Polson",
      "city": "Polson",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 47.804389,
      "longitude": -114.201167,
      "elevationFeet": 2938,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8S1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8S1?codeType=fs"
     },
     {
      "fs": "8S2",
      "iata": "",
      "icao": "",
      "faa": "8S2",
      "name": "Cashmere-Dryden",
      "city": "Cashmere",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.648472,
      "longitude": -120.498028,
      "elevationFeet": 853,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8S2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8S2?codeType=fs"
     },
     {
      "fs": "8S3",
      "iata": "",
      "icao": "",
      "faa": "8S3",
      "name": "Santiam Junction State",
      "city": "Santiam Junction",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 44.445556,
      "longitude": -122.022778,
      "elevationFeet": 3780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8S3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8S3?codeType=fs"
     },
     {
      "fs": "8S4",
      "iata": "",
      "icao": "",
      "faa": "8S4",
      "name": "Enterprise Municipal",
      "city": "Enterprise",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 45.498722,
      "longitude": -117.398917,
      "elevationFeet": 3957,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8S4?codeType=fs"
     },
     {
      "fs": "8S5",
      "iata": "",
      "icao": "",
      "faa": "8S5",
      "name": "East Cooper",
      "city": "Mt Pleasant",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.028333,
      "longitude": -79.928611,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8S5?codeType=fs"
     },
     {
      "fs": "8T6",
      "iata": "",
      "icao": "",
      "faa": "8T6",
      "name": "Live Oak Co",
      "city": "George West",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 28.477778,
      "longitude": -98.263944,
      "elevationFeet": 129,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8T6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8T6?codeType=fs"
     },
     {
      "fs": "8T8",
      "iata": "",
      "icao": "",
      "faa": "8T8",
      "name": "San Geronimo",
      "city": "San Antonio",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.605083,
      "longitude": -98.933583,
      "elevationFeet": 1040,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8T8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8T8?codeType=fs"
     },
     {
      "fs": "8U0",
      "iata": "",
      "icao": "",
      "faa": "8U0",
      "name": "Ryegate",
      "city": "Ryegate",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.354111,
      "longitude": -109.376,
      "elevationFeet": 3689,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U0?codeType=fs"
     },
     {
      "fs": "8U1",
      "iata": "",
      "icao": "",
      "faa": "8U1",
      "name": "Sand Springs",
      "city": "Sand Springs",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 47.141639,
      "longitude": -107.534278,
      "elevationFeet": 3180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U1?codeType=fs"
     },
     {
      "fs": "8U2",
      "iata": "",
      "icao": "",
      "faa": "8U2",
      "name": "Schafer Usfs",
      "city": "Schafer",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.124528,
      "longitude": -113.259139,
      "elevationFeet": 4855,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U2?codeType=fs"
     },
     {
      "fs": "8U3",
      "iata": "",
      "icao": "",
      "faa": "8U3",
      "name": "Scobey Border Stn/East Poplar*",
      "city": "Scobey",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 49.00025,
      "longitude": -105.4055,
      "elevationFeet": 2501,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U3?codeType=fs"
     },
     {
      "fs": "8U4",
      "iata": "",
      "icao": "",
      "faa": "8U4",
      "name": "Spotted Bear Usfs",
      "city": "Spotted Bear",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.032806,
      "longitude": -113.642556,
      "elevationFeet": 3670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U4?codeType=fs"
     },
     {
      "fs": "8U5",
      "iata": "",
      "icao": "",
      "faa": "8U5",
      "name": "Sunburst",
      "city": "Sunburst",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 48.916639,
      "longitude": -111.967028,
      "elevationFeet": 3401,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U5?codeType=fs"
     },
     {
      "fs": "8U6",
      "iata": "",
      "icao": "",
      "faa": "8U6",
      "name": "Terry",
      "city": "Terry",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.891722,
      "longitude": -105.347083,
      "elevationFeet": 2260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U6?codeType=fs"
     },
     {
      "fs": "8U8",
      "iata": "",
      "icao": "",
      "faa": "8U8",
      "name": "Townsend",
      "city": "Townsend",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.386111,
      "longitude": -111.613889,
      "elevationFeet": 3885,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U8?codeType=fs"
     },
     {
      "fs": "8U9",
      "iata": "",
      "icao": "",
      "faa": "8U9",
      "name": "Canyon Ferry",
      "city": "Townsend",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 46.438222,
      "longitude": -111.671944,
      "elevationFeet": 3840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8U9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8U9?codeType=fs"
     },
     {
      "fs": "8V1",
      "iata": "",
      "icao": "",
      "faa": "8V1",
      "name": "Del Norte Mun-Co",
      "city": "Del Norte",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 37.836139,
      "longitude": -106.394806,
      "elevationFeet": 7949,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8V1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8V1?codeType=fs"
     },
     {
      "fs": "8V2",
      "iata": "",
      "icao": "",
      "faa": "8V2",
      "name": "Stuart-Atkinson Municipal",
      "city": "Atkinson",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.638917,
      "longitude": -99.070417,
      "elevationFeet": 2130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8V2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8V2?codeType=fs"
     },
     {
      "fs": "8V3",
      "iata": "",
      "icao": "",
      "faa": "8V3",
      "name": "Parkston Municipal",
      "city": "Parkston",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.491528,
      "longitude": -98.011833,
      "elevationFeet": 1415,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8V3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8V3?codeType=fs"
     },
     {
      "fs": "8V6",
      "iata": "",
      "icao": "",
      "faa": "8V6",
      "name": "Dove Creek",
      "city": "Dove Creek",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 37.888778,
      "longitude": -108.937167,
      "elevationFeet": 6975,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8V6?codeType=fs"
     },
     {
      "fs": "8V7",
      "iata": "",
      "icao": "",
      "faa": "8V7",
      "name": "Springfield Municipal",
      "city": "Springfield",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 37.580694,
      "longitude": -102.638056,
      "elevationFeet": 4387,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8V7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8V7?codeType=fs"
     },
     {
      "fs": "8W1",
      "iata": "",
      "icao": "",
      "faa": "8W1",
      "name": "Antonneau Memorial",
      "city": "Green Bay",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.699917,
      "longitude": -88.114917,
      "elevationFeet": 587,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8W1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8W1?codeType=fs"
     },
     {
      "fs": "8W2",
      "iata": "",
      "icao": "",
      "faa": "8W2",
      "name": "New Market",
      "city": "New Market",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.706722,
      "longitude": -78.78075,
      "elevationFeet": 975,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8W2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8W2?codeType=fs"
     },
     {
      "fs": "8W3",
      "iata": "",
      "icao": "",
      "faa": "8W3",
      "name": "Mansfield",
      "city": "Mansfield",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.895889,
      "longitude": -119.672694,
      "elevationFeet": 2276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8W3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8W3?codeType=fs"
     },
     {
      "fs": "8W8",
      "iata": "",
      "icao": "",
      "faa": "8W8",
      "name": "Hartwood",
      "city": "Sommerville",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.495694,
      "longitude": -77.727667,
      "elevationFeet": 390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8W8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8W8?codeType=fs"
     },
     {
      "fs": "8W9",
      "iata": "",
      "icao": "",
      "faa": "8W9",
      "name": "R & K Skyranch",
      "city": "Rochester",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 46.976944,
      "longitude": -123.164167,
      "elevationFeet": 149,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8W9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8W9?codeType=fs"
     },
     {
      "fs": "8Y2",
      "iata": "",
      "icao": "",
      "faa": "8Y2",
      "name": "Buffalo Municipal",
      "city": "Buffalo",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.240472,
      "longitude": -93.933028,
      "elevationFeet": 967,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8Y2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8Y2?codeType=fs"
     },
     {
      "fs": "8Y5",
      "iata": "",
      "icao": "",
      "faa": "8Y5",
      "name": "Clarissa Municipal",
      "city": "Clarissa",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.230194,
      "longitude": -94.966889,
      "elevationFeet": 1308,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8Y5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8Y5?codeType=fs"
     },
     {
      "fs": "8Y6",
      "iata": "",
      "icao": "",
      "faa": "8Y6",
      "name": "Leaders/Clear Lake Airport",
      "city": "Clear Lake",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.445094,
      "longitude": -93.965879,
      "elevationFeet": 992,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/8Y6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/8Y6?codeType=fs"
     },
     {
      "fs": "90D",
      "iata": "",
      "icao": "",
      "faa": "90D",
      "name": "Pine City Municipal",
      "city": "Pine City",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.960667,
      "longitude": -93.032639,
      "elevationFeet": 971,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/90D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/90D?codeType=fs"
     },
     {
      "fs": "90F",
      "iata": "",
      "icao": "",
      "faa": "90F",
      "name": "Broken Bow",
      "city": "Broken Bow",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.14,
      "longitude": -94.8355,
      "elevationFeet": 404,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/90F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/90F?codeType=fs"
     },
     {
      "fs": "90Y",
      "iata": "",
      "icao": "",
      "faa": "90Y",
      "name": "Leonard Municipal",
      "city": "Leonard",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.691361,
      "longitude": -97.253694,
      "elevationFeet": 1050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/90Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/90Y?codeType=fs"
     },
     {
      "fs": "91C",
      "iata": "",
      "icao": "",
      "faa": "91C",
      "name": "Sauk-Prairie",
      "city": "Prairie Du Sac",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.419333,
      "longitude": -89.809556,
      "elevationFeet": 832,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/91C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/91C?codeType=fs"
     },
     {
      "fs": "91F",
      "iata": "",
      "icao": "",
      "faa": "91F",
      "name": "Arrowhead",
      "city": "Canadian",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.192639,
      "longitude": -95.652639,
      "elevationFeet": 851,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/91F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/91F?codeType=fs"
     },
     {
      "fs": "91N",
      "iata": "",
      "icao": "",
      "faa": "91N",
      "name": "Turtle Lake Municipal",
      "city": "Turtle Lake",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.594417,
      "longitude": -101.059778,
      "elevationFeet": 1910,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/91N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/91N?codeType=fs"
     },
     {
      "fs": "92A",
      "iata": "",
      "icao": "",
      "faa": "92A",
      "name": "Chilhowee",
      "city": "Benton",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 35.370167,
      "longitude": -84.599333,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/92A?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/92A?codeType=fs"
     },
     {
      "fs": "92C",
      "iata": "",
      "icao": "",
      "faa": "92C",
      "name": "Carter",
      "city": "Pulaski",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.712194,
      "longitude": -88.352194,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/92C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/92C?codeType=fs"
     },
     {
      "fs": "92D",
      "iata": "",
      "icao": "",
      "faa": "92D",
      "name": "Harlan",
      "city": "Lagrange",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.228306,
      "longitude": -82.2515,
      "elevationFeet": 843,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/92D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/92D?codeType=fs"
     },
     {
      "fs": "92F",
      "iata": "",
      "icao": "",
      "faa": "92F",
      "name": "Chattanooga Sky Harbor",
      "city": "Chattanooga",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.450833,
      "longitude": -98.728417,
      "elevationFeet": 1135,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/92F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/92F?codeType=fs"
     },
     {
      "fs": "92G",
      "iata": "",
      "icao": "",
      "faa": "92G",
      "name": "Midlakes",
      "city": "Gorham",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.925667,
      "longitude": -77.238667,
      "elevationFeet": 1080,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/92G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/92G?codeType=fs"
     },
     {
      "fs": "92W",
      "iata": "",
      "icao": "",
      "faa": "92W",
      "name": "Western",
      "city": "Yelm",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 47.001,
      "longitude": -122.590111,
      "elevationFeet": 390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/92W?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/92W?codeType=fs"
     },
     {
      "fs": "93B",
      "iata": "",
      "icao": "",
      "faa": "93B",
      "name": "Stonington Municipal",
      "city": "Stonington",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.173199,
      "longitude": -68.680298,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/93B?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/93B?codeType=fs"
     },
     {
      "fs": "93C",
      "iata": "",
      "icao": "",
      "faa": "93C",
      "name": "Richland",
      "city": "Richland Center",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.283333,
      "longitude": -90.432778,
      "elevationFeet": 742,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/93C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/93C?codeType=fs"
     },
     {
      "fs": "93F",
      "iata": "",
      "icao": "",
      "faa": "93F",
      "name": "Mignon Laird Municipal",
      "city": "Cheyenne",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.639361,
      "longitude": -99.734389,
      "elevationFeet": 2084,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/93F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/93F?codeType=fs"
     },
     {
      "fs": "93Y",
      "iata": "",
      "icao": "",
      "faa": "93Y",
      "name": "David City Municipal",
      "city": "David City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 41.233472,
      "longitude": -97.119806,
      "elevationFeet": 1614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/93Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/93Y?codeType=fs"
     },
     {
      "fs": "94C",
      "iata": "",
      "icao": "",
      "faa": "94C",
      "name": "Cowgill",
      "city": "Rio",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.599861,
      "longitude": -89.251167,
      "elevationFeet": 925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/94C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/94C?codeType=fs"
     },
     {
      "fs": "94D",
      "iata": "",
      "icao": "",
      "faa": "94D",
      "name": "Wells Seaplane Base",
      "city": "Schenectady",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.998,
      "longitude": -73.948444,
      "elevationFeet": 210,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/94D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/94D?codeType=fs"
     },
     {
      "fs": "94E",
      "iata": "",
      "icao": "",
      "faa": "94E",
      "name": "Whiskey Creek",
      "city": "Silver City",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 32.870194,
      "longitude": -108.283806,
      "elevationFeet": 6126,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/94E?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/94E?codeType=fs"
     },
     {
      "fs": "94K",
      "iata": "",
      "icao": "",
      "faa": "94K",
      "name": "Cassville Municipal",
      "city": "Cassville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.824167,
      "longitude": -93.905278,
      "elevationFeet": 1482,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/94K?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/94K?codeType=fs"
     },
     {
      "fs": "94R",
      "iata": "",
      "icao": "",
      "faa": "94R",
      "name": "Lackey Aviation",
      "city": "Wharton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 29.410833,
      "longitude": -96.077333,
      "elevationFeet": 90,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/94R?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/94R?codeType=fs"
     },
     {
      "fs": "94Z",
      "iata": "",
      "icao": "",
      "faa": "94Z",
      "name": "Nome City",
      "city": "Nome",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 64.631222,
      "longitude": -165.509278,
      "elevationFeet": 59,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/94Z?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/94Z?codeType=fs"
     },
     {
      "fs": "95D",
      "iata": "",
      "icao": "",
      "faa": "95D",
      "name": "Beulah",
      "city": "Beulah",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/North_Dakota/Beulah",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 47.258417,
      "longitude": -101.940583,
      "elevationFeet": 1791,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/95D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/95D?codeType=fs"
     },
     {
      "fs": "95F",
      "iata": "",
      "icao": "",
      "faa": "95F",
      "name": "Cleveland Municipal",
      "city": "Cleveland",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 36.284028,
      "longitude": -96.591889,
      "elevationFeet": 980,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/95F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/95F?codeType=fs"
     },
     {
      "fs": "95Z",
      "iata": "",
      "icao": "",
      "faa": "95Z",
      "name": "Bradley Sky Ranch",
      "city": "North Pole",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 64.841667,
      "longitude": -147.426667,
      "elevationFeet": 483,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/95Z?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/95Z?codeType=fs"
     },
     {
      "fs": "96C",
      "iata": "",
      "icao": "",
      "faa": "96C",
      "name": "Fox River",
      "city": "Rochester",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 42.750167,
      "longitude": -88.25925,
      "elevationFeet": 822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/96C?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/96C?codeType=fs"
     },
     {
      "fs": "96D",
      "iata": "",
      "icao": "",
      "faa": "96D",
      "name": "Walhalla Municipal",
      "city": "Walhalla",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 49.005722,
      "longitude": -97.92775,
      "elevationFeet": 953,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/96D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/96D?codeType=fs"
     },
     {
      "fs": "96G",
      "iata": "",
      "icao": "",
      "faa": "96G",
      "name": "Cowley",
      "city": "Sandusky",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.464111,
      "longitude": -82.952111,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/96G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/96G?codeType=fs"
     },
     {
      "fs": "97F",
      "iata": "",
      "icao": "",
      "faa": "97F",
      "name": "Crazy Horse Municipal",
      "city": "Davis",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.66475,
      "longitude": -97.183528,
      "elevationFeet": 940,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/97F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/97F?codeType=fs"
     },
     {
      "fs": "97G",
      "iata": "",
      "icao": "",
      "faa": "97G",
      "name": "Glowacki",
      "city": "St Johns",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.000333,
      "longitude": -84.708194,
      "elevationFeet": 775,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/97G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/97G?codeType=fs"
     },
     {
      "fs": "97M",
      "iata": "",
      "icao": "",
      "faa": "97M",
      "name": "Ekalaka",
      "city": "Ekalaka",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.979139,
      "longitude": -104.575083,
      "elevationFeet": 3503,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/97M?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/97M?codeType=fs"
     },
     {
      "fs": "97Y",
      "iata": "",
      "icao": "",
      "faa": "97Y",
      "name": "Genoa Municipal",
      "city": "Genoa",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 41.441806,
      "longitude": -97.786639,
      "elevationFeet": 1570,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/97Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/97Y?codeType=fs"
     },
     {
      "fs": "98D",
      "iata": "",
      "icao": "",
      "faa": "98D",
      "name": "Onida Municipal",
      "city": "Onida",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.7415,
      "longitude": -100.187361,
      "elevationFeet": 1871,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/98D?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/98D?codeType=fs"
     },
     {
      "fs": "98G",
      "iata": "",
      "icao": "",
      "faa": "98G",
      "name": "Sebewaing",
      "city": "Sebewaing",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.841833,
      "longitude": -83.574611,
      "elevationFeet": 584,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/98G?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/98G?codeType=fs"
     },
     {
      "fs": "99F",
      "iata": "",
      "icao": "",
      "faa": "99F",
      "name": "El Reno",
      "city": "El Reno",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 35.517194,
      "longitude": -98.094944,
      "elevationFeet": 1395,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/99F?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/99F?codeType=fs"
     },
     {
      "fs": "99N",
      "iata": "",
      "icao": "",
      "faa": "99N",
      "name": "Bamberg Co",
      "city": "Bamberg",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.351556,
      "longitude": -81.189889,
      "elevationFeet": 199,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/99N?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/99N?codeType=fs"
     },
     {
      "fs": "99V",
      "iata": "",
      "icao": "",
      "faa": "99V",
      "name": "Crawford",
      "city": "Crawford",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 38.741528,
      "longitude": -107.736694,
      "elevationFeet": 6470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/99V?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/99V?codeType=fs"
     },
     {
      "fs": "99Y",
      "iata": "",
      "icao": "",
      "faa": "99Y",
      "name": "Greeley Municipal",
      "city": "Greeley",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 41.633444,
      "longitude": -98.661861,
      "elevationFeet": 2035,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/99Y?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/99Y?codeType=fs"
     },
     {
      "fs": "9A0",
      "iata": "",
      "icao": "",
      "faa": "9A0",
      "name": "Lumpkin Co-Wimpy'S",
      "city": "Dahlonega",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.692583,
      "longitude": -84.057444,
      "elevationFeet": 1311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A0?codeType=fs"
     },
     {
      "fs": "9A1",
      "iata": "",
      "icao": "",
      "faa": "9A1",
      "name": "Covington Municipal",
      "city": "Covington",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 33.774833,
      "longitude": -83.995583,
      "elevationFeet": 795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A1?codeType=fs"
     },
     {
      "fs": "9A2",
      "iata": "",
      "icao": "",
      "faa": "9A2",
      "name": "Powell",
      "city": "Knoxville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 36.14525,
      "longitude": -84.043556,
      "elevationFeet": 992,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A2?codeType=fs"
     },
     {
      "fs": "9A4",
      "iata": "",
      "icao": "",
      "faa": "9A4",
      "name": "Industrial",
      "city": "Courtland",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.743889,
      "longitude": -87.488333,
      "elevationFeet": 588,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A4?codeType=fs"
     },
     {
      "fs": "9A5",
      "iata": "",
      "icao": "",
      "faa": "9A5",
      "name": "Barwick-Lafayette",
      "city": "Lafayette",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.739694,
      "longitude": -85.352333,
      "elevationFeet": 777,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A5?codeType=fs"
     },
     {
      "fs": "9A6",
      "iata": "",
      "icao": "",
      "faa": "9A6",
      "name": "Chester Municipal",
      "city": "Chester",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 34.843333,
      "longitude": -81.307778,
      "elevationFeet": 656,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A6?codeType=fs"
     },
     {
      "fs": "9A9",
      "iata": "",
      "icao": "",
      "faa": "9A9",
      "name": "Shiflet",
      "city": "Marion",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 35.756806,
      "longitude": -82.098306,
      "elevationFeet": 1212,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9A9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9A9?codeType=fs"
     },
     {
      "fs": "9B4",
      "iata": "",
      "icao": "",
      "faa": "9B4",
      "name": "Shirley",
      "city": "Shirley",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.623139,
      "longitude": -71.795139,
      "elevationFeet": 400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9B4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9B4?codeType=fs"
     },
     {
      "fs": "9B8",
      "iata": "",
      "icao": "",
      "faa": "9B8",
      "name": "Salmon River",
      "city": "Marlborough",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.645444,
      "longitude": -72.523083,
      "elevationFeet": 540,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9B8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9B8?codeType=fs"
     },
     {
      "fs": "9B9",
      "iata": "",
      "icao": "",
      "faa": "9B9",
      "name": "Champion Executive",
      "city": "Orwell",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.572778,
      "longitude": -80.931444,
      "elevationFeet": 940,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9B9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9B9?codeType=fs"
     },
     {
      "fs": "9C2",
      "iata": "",
      "icao": "",
      "faa": "9C2",
      "name": "David'S",
      "city": "Athens",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.20325,
      "longitude": -85.3165,
      "elevationFeet": 887,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9C2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9C2?codeType=fs"
     },
     {
      "fs": "9C8",
      "iata": "",
      "icao": "",
      "faa": "9C8",
      "name": "Evart Municipal",
      "city": "Evart",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 44.008528,
      "longitude": -85.392083,
      "elevationFeet": 1018,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9C8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9C8?codeType=fs"
     },
     {
      "fs": "9C9",
      "iata": "",
      "icao": "",
      "faa": "9C9",
      "name": "Gladstone",
      "city": "Gladstone",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 45.941306,
      "longitude": -87.118028,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9C9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9C9?codeType=fs"
     },
     {
      "fs": "9D0",
      "iata": "",
      "icao": "",
      "faa": "9D0",
      "name": "Highmore Municipal",
      "city": "Highmore",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 44.6165,
      "longitude": -99.562222,
      "elevationFeet": 1851,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D0?codeType=fs"
     },
     {
      "fs": "9D1",
      "iata": "",
      "icao": "",
      "faa": "9D1",
      "name": "Gregory Municipal",
      "city": "Gregory",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 43.267472,
      "longitude": -99.433,
      "elevationFeet": 2168,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D1?codeType=fs"
     },
     {
      "fs": "9D2",
      "iata": "",
      "icao": "",
      "faa": "9D2",
      "name": "Harding Co",
      "city": "Buffalo",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.705528,
      "longitude": -103.646361,
      "elevationFeet": 2889,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D2?codeType=fs"
     },
     {
      "fs": "9D4",
      "iata": "",
      "icao": "",
      "faa": "9D4",
      "name": "Deck Airport",
      "city": "Myerstown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.351311,
      "longitude": -76.330116,
      "elevationFeet": 515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D4?codeType=fs"
     },
     {
      "fs": "9D5",
      "iata": "",
      "icao": "",
      "faa": "9D5",
      "name": "Gwin",
      "city": "Bessemer",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.0145,
      "longitude": -80.503444,
      "elevationFeet": 1225,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D5?codeType=fs"
     },
     {
      "fs": "9D7",
      "iata": "",
      "icao": "",
      "faa": "9D7",
      "name": "Cando Municipal",
      "city": "Cando",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 48.491667,
      "longitude": -99.268028,
      "elevationFeet": 1485,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D7?codeType=fs"
     },
     {
      "fs": "9D9",
      "iata": "",
      "icao": "",
      "faa": "9D9",
      "name": "Hastings",
      "city": "Hastings",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.786167,
      "longitude": -85.462583,
      "elevationFeet": 801,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9D9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9D9?codeType=fs"
     },
     {
      "fs": "9F0",
      "iata": "",
      "icao": "",
      "faa": "9F0",
      "name": "Dublin Municipal",
      "city": "Dublin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.082,
      "longitude": -98.403222,
      "elevationFeet": 1495,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9F0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9F0?codeType=fs"
     },
     {
      "fs": "9F1",
      "iata": "",
      "icao": "",
      "faa": "9F1",
      "name": "Valley Mills Municipal",
      "city": "Valley Mills",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 31.659972,
      "longitude": -97.544583,
      "elevationFeet": 751,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9F1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9F1?codeType=fs"
     },
     {
      "fs": "9F8",
      "iata": "",
      "icao": "",
      "faa": "9F8",
      "name": "Hoven Municipal",
      "city": "Hoven",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 45.325667,
      "longitude": -99.928389,
      "elevationFeet": 1884,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9F8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9F8?codeType=fs"
     },
     {
      "fs": "9F9",
      "iata": "",
      "icao": "",
      "faa": "9F9",
      "name": "Sycamore Strip",
      "city": "Ft Worth",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.627664,
      "longitude": -97.352376,
      "elevationFeet": 754,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9F9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9F9?codeType=fs"
     },
     {
      "fs": "9G0",
      "iata": "",
      "icao": "",
      "faa": "9G0",
      "name": "Buffalo Airfield",
      "city": "Buffalo",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.862914,
      "longitude": -78.71617,
      "elevationFeet": 665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G0?codeType=fs"
     },
     {
      "fs": "9G1",
      "iata": "",
      "icao": "",
      "faa": "9G1",
      "name": "Rock",
      "city": "Tarentum",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.642333,
      "longitude": -79.856056,
      "elevationFeet": 1125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G1?codeType=fs"
     },
     {
      "fs": "9G2",
      "iata": "",
      "icao": "",
      "faa": "9G2",
      "name": "Prices",
      "city": "Linden",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 42.875833,
      "longitude": -83.84675,
      "elevationFeet": 920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G2?codeType=fs"
     },
     {
      "fs": "9G3",
      "iata": "",
      "icao": "",
      "faa": "9G3",
      "name": "Akron",
      "city": "Akron",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.060861,
      "longitude": -78.629667,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G3?codeType=fs"
     },
     {
      "fs": "9G5",
      "iata": "",
      "icao": "",
      "faa": "9G5",
      "name": "Royalton",
      "city": "Gasport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.320028,
      "longitude": -78.628056,
      "elevationFeet": 628,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G5?codeType=fs"
     },
     {
      "fs": "9G6",
      "iata": "",
      "icao": "",
      "faa": "9G6",
      "name": "Pine Hill",
      "city": "Albion",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 43.235306,
      "longitude": -78.346333,
      "elevationFeet": 669,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G6?codeType=fs"
     },
     {
      "fs": "9G8",
      "iata": "",
      "icao": "",
      "faa": "9G8",
      "name": "Ebensburg",
      "city": "Ebensburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.562111,
      "longitude": -78.852444,
      "elevationFeet": 2099,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G8?codeType=fs"
     },
     {
      "fs": "9G9",
      "iata": "",
      "icao": "",
      "faa": "9G9",
      "name": "Gackle Municipal",
      "city": "Gackle",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 46.766444,
      "longitude": -99.170556,
      "elevationFeet": 1904,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9G9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9G9?codeType=fs"
     },
     {
      "fs": "9I0",
      "iata": "",
      "icao": "",
      "faa": "9I0",
      "name": "Havana Regional",
      "city": "Havana",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 40.261556,
      "longitude": -90.078944,
      "elevationFeet": 499,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9I0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9I0?codeType=fs"
     },
     {
      "fs": "9I3",
      "iata": "",
      "icao": "",
      "faa": "9I3",
      "name": "West Liberty",
      "city": "West Liberty",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 38.045306,
      "longitude": -83.271222,
      "elevationFeet": 934,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9I3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9I3?codeType=fs"
     },
     {
      "fs": "9K0",
      "iata": "",
      "icao": "",
      "faa": "9K0",
      "name": "Chase Co",
      "city": "Cottonwood Falls",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.43625,
      "longitude": -96.594528,
      "elevationFeet": 1273,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K0?codeType=fs"
     },
     {
      "fs": "9K1",
      "iata": "",
      "icao": "",
      "faa": "9K1",
      "name": "Wilroads Gardens",
      "city": "Dodge City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.777972,
      "longitude": -100.012417,
      "elevationFeet": 2440,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K1?codeType=fs"
     },
     {
      "fs": "9K2",
      "iata": "",
      "icao": "",
      "faa": "9K2",
      "name": "Kokhanok",
      "city": "Kokhanok",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.682",
      "utcOffsetHours": -9,
      "latitude": 59.576444,
      "longitude": -154.827056,
      "elevationFeet": 150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K2?codeType=fs"
     },
     {
      "fs": "9K3",
      "iata": "",
      "icao": "",
      "faa": "9K3",
      "name": "Thielen",
      "city": "Dorrance",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.852889,
      "longitude": -98.584028,
      "elevationFeet": 1755,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K3?codeType=fs"
     },
     {
      "fs": "9K4",
      "iata": "",
      "icao": "",
      "faa": "9K4",
      "name": "Skyhaven",
      "city": "Warrensburg",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.792417,
      "longitude": -93.828556,
      "elevationFeet": 795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K4?codeType=fs"
     },
     {
      "fs": "9K5",
      "iata": "",
      "icao": "",
      "faa": "9K5",
      "name": "Slater Memorial",
      "city": "Slater",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 39.341917,
      "longitude": -93.124194,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K5?codeType=fs"
     },
     {
      "fs": "9K6",
      "iata": "",
      "icao": "",
      "faa": "9K6",
      "name": "Patty",
      "city": "El Dorado",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.800194,
      "longitude": -96.786389,
      "elevationFeet": 1385,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K6?codeType=fs"
     },
     {
      "fs": "9K7",
      "iata": "",
      "icao": "",
      "faa": "9K7",
      "name": "Ellsworth Municipal",
      "city": "Ellsworth",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.875083,
      "longitude": -98.356111,
      "elevationFeet": 1615,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K7?codeType=fs"
     },
     {
      "fs": "9K8",
      "iata": "",
      "icao": "",
      "faa": "9K8",
      "name": "Kingman Municipal",
      "city": "Kingman",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 37.816111,
      "longitude": -98.176389,
      "elevationFeet": 1605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K8?codeType=fs"
     },
     {
      "fs": "9K9",
      "iata": "",
      "icao": "",
      "faa": "9K9",
      "name": "Prichard",
      "city": "Enterprise",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 38.9,
      "longitude": -97.119611,
      "elevationFeet": 1164,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9K9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9K9?codeType=fs"
     },
     {
      "fs": "9L2",
      "iata": "",
      "icao": "",
      "faa": "9L2",
      "name": "Edwards Af Aux North Base",
      "city": "Edwards",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 34.983333,
      "longitude": -117.866667,
      "elevationFeet": 2300,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9L2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9L2?codeType=fs"
     },
     {
      "fs": "9M2",
      "iata": "",
      "icao": "",
      "faa": "9M2",
      "name": "Newellton",
      "city": "Newellton",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.176556,
      "longitude": -91.292806,
      "elevationFeet": 77,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9M2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9M2?codeType=fs"
     },
     {
      "fs": "9M4",
      "iata": "",
      "icao": "",
      "faa": "9M4",
      "name": "Ackerman-Choctaw Co",
      "city": "Ackerman",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 33.334583,
      "longitude": -89.334,
      "elevationFeet": 552,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9M4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9M4?codeType=fs"
     },
     {
      "fs": "9M6",
      "iata": "",
      "icao": "",
      "faa": "9M6",
      "name": "Kelly",
      "city": "Oak Grove",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 32.992139,
      "longitude": -91.439056,
      "elevationFeet": 112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9M6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9M6?codeType=fs"
     },
     {
      "fs": "9M8",
      "iata": "",
      "icao": "",
      "faa": "9M8",
      "name": "Sheridan Municipal",
      "city": "Sheridan",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 34.434306,
      "longitude": -92.359861,
      "elevationFeet": 232,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9M8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9M8?codeType=fs"
     },
     {
      "fs": "9N1",
      "iata": "",
      "icao": "",
      "faa": "9N1",
      "name": "Vansant",
      "city": "Erwinna",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.492694,
      "longitude": -75.246167,
      "elevationFeet": 390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9N1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9N1?codeType=fs"
     },
     {
      "fs": "9N3",
      "iata": "",
      "icao": "",
      "faa": "9N3",
      "name": "Seamans",
      "city": "Factoryville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 41.643556,
      "longitude": -75.810806,
      "elevationFeet": 1209,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9N3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9N3?codeType=fs"
     },
     {
      "fs": "9N7",
      "iata": "",
      "icao": "",
      "faa": "9N7",
      "name": "Farmers Pride",
      "city": "Fredericksburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.682",
      "utcOffsetHours": -5,
      "latitude": 40.528694,
      "longitude": -76.516278,
      "elevationFeet": 495,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9N7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9N7?codeType=fs"
     },
     {
      "fs": "9P7",
      "iata": "",
      "icao": "",
      "faa": "9P7",
      "name": "Hillcrest",
      "city": "Goldendale",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 45.95125,
      "longitude": -120.708944,
      "elevationFeet": 2405,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9P7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9P7?codeType=fs"
     },
     {
      "fs": "9R5",
      "iata": "",
      "icao": "",
      "faa": "9R5",
      "name": "Hunt",
      "city": "Portland",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.682",
      "utcOffsetHours": -6,
      "latitude": 27.928,
      "longitude": -97.394361,
      "elevationFeet": 40,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9R5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9R5?codeType=fs"
     },
     {
      "fs": "9S3",
      "iata": "",
      "icao": "",
      "faa": "9S3",
      "name": "Lakeside State",
      "city": "Lakeside",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 43.731694,
      "longitude": -124.303917,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9S3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9S3?codeType=fs"
     },
     {
      "fs": "9S4",
      "iata": "",
      "icao": "",
      "faa": "9S4",
      "name": "Mineral Co",
      "city": "Superior",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 47.182583,
      "longitude": -114.887417,
      "elevationFeet": 2787,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9S4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9S4?codeType=fs"
     },
     {
      "fs": "9S5",
      "iata": "",
      "icao": "",
      "faa": "9S5",
      "name": "Three Forks",
      "city": "Three Forks",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 45.985278,
      "longitude": -111.591389,
      "elevationFeet": 4086,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9S5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9S5?codeType=fs"
     },
     {
      "fs": "9S7",
      "iata": "",
      "icao": "",
      "faa": "9S7",
      "name": "Winifred",
      "city": "Winifred",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.682",
      "utcOffsetHours": -7,
      "latitude": 47.566472,
      "longitude": -109.476806,
      "elevationFeet": 3311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9S7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9S7?codeType=fs"
     },
     {
      "fs": "9S9",
      "iata": "",
      "icao": "",
      "faa": "9S9",
      "name": "Lexington",
      "city": "Lexington",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.682",
      "utcOffsetHours": -8,
      "latitude": 45.476306,
      "longitude": -119.736361,
      "elevationFeet": 1634,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9S9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9S9?codeType=fs"
     },
     {
      "fs": "9U0",
      "iata": "",
      "icao": "",
      "faa": "9U0",
      "name": "Turner",
      "city": "Turner",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 48.891722,
      "longitude": -108.490222,
      "elevationFeet": 3049,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9U0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9U0?codeType=fs"
     },
     {
      "fs": "9U1",
      "iata": "",
      "icao": "",
      "faa": "9U1",
      "name": "Wilsall",
      "city": "Wilsall",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 46.196556,
      "longitude": -110.704861,
      "elevationFeet": 5134,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9U1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9U1?codeType=fs"
     },
     {
      "fs": "9U4",
      "iata": "",
      "icao": "",
      "faa": "9U4",
      "name": "Dixon",
      "city": "Dixon",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 41.082972,
      "longitude": -107.622861,
      "elevationFeet": 6520,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9U4?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9U4?codeType=fs"
     },
     {
      "fs": "9U7",
      "iata": "",
      "icao": "",
      "faa": "9U7",
      "name": "Currant Ranch",
      "city": "Currant",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 38.760472,
      "longitude": -115.603056,
      "elevationFeet": 5181,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9U7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9U7?codeType=fs"
     },
     {
      "fs": "9V1",
      "iata": "",
      "icao": "",
      "faa": "9V1",
      "name": "Springview Municipal",
      "city": "Springview",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.941667,
      "longitude": -99.798389,
      "elevationFeet": 2446,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V1?codeType=fs"
     },
     {
      "fs": "9V2",
      "iata": "",
      "icao": "",
      "faa": "9V2",
      "name": "Trenton Municipal",
      "city": "Trenton",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.224972,
      "longitude": -101.104389,
      "elevationFeet": 2796,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V2?codeType=fs"
     },
     {
      "fs": "9V3",
      "iata": "",
      "icao": "",
      "faa": "9V3",
      "name": "Harrison Skyranch",
      "city": "Harrison",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 42.808,
      "longitude": -103.954889,
      "elevationFeet": 4863,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V3?codeType=fs"
     },
     {
      "fs": "9V5",
      "iata": "",
      "icao": "",
      "faa": "9V5",
      "name": "Modisett",
      "city": "Rushville",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 42.774861,
      "longitude": -102.548944,
      "elevationFeet": 3761,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V5?codeType=fs"
     },
     {
      "fs": "9V6",
      "iata": "",
      "icao": "",
      "faa": "9V6",
      "name": "Martin Municipal",
      "city": "Martin",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 43.306361,
      "longitude": -101.827028,
      "elevationFeet": 3293,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V6?codeType=fs"
     },
     {
      "fs": "9V7",
      "iata": "",
      "icao": "",
      "faa": "9V7",
      "name": "Eads Municipal",
      "city": "Eads",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 38.550056,
      "longitude": -102.888083,
      "elevationFeet": 4245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V7?codeType=fs"
     },
     {
      "fs": "9V9",
      "iata": "",
      "icao": "",
      "faa": "9V9",
      "name": "Chamberlain Municipal",
      "city": "Chamberlain",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.90825,
      "longitude": -99.35975,
      "elevationFeet": 1695,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9V9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9V9?codeType=fs"
     },
     {
      "fs": "9W3",
      "iata": "",
      "icao": "",
      "faa": "9W3",
      "name": "Simpson",
      "city": "Philippi",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.184333,
      "longitude": -80.109111,
      "elevationFeet": 1960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9W3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9W3?codeType=fs"
     },
     {
      "fs": "9W7",
      "iata": "",
      "icao": "",
      "faa": "9W7",
      "name": "Currituck Co",
      "city": "Currituck",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 36.539333,
      "longitude": -76.163111,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9W7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9W7?codeType=fs"
     },
     {
      "fs": "9W8",
      "iata": "",
      "icao": "",
      "faa": "9W8",
      "name": "Baublitz Commercial",
      "city": "Brogue",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.87325,
      "longitude": -76.513528,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9W8?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9W8?codeType=fs"
     },
     {
      "fs": "9W9",
      "iata": "",
      "icao": "",
      "faa": "9W9",
      "name": "Clio Crop Care",
      "city": "Clio",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 34.637722,
      "longitude": -79.603306,
      "elevationFeet": 130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9W9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9W9?codeType=fs"
     },
     {
      "fs": "9X1",
      "iata": "",
      "icao": "",
      "faa": "9X1",
      "name": "Williams",
      "city": "Porter",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 30.188278,
      "longitude": -95.368806,
      "elevationFeet": 122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9X1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9X1?codeType=fs"
     },
     {
      "fs": "9Y0",
      "iata": "",
      "icao": "",
      "faa": "9Y0",
      "name": "Bowstring",
      "city": "Deer River",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.699472,
      "longitude": -93.868778,
      "elevationFeet": 1372,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9Y0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9Y0?codeType=fs"
     },
     {
      "fs": "9Y1",
      "iata": "",
      "icao": "",
      "faa": "9Y1",
      "name": "Weydahl",
      "city": "Killdeer",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 47.477917,
      "longitude": -102.807417,
      "elevationFeet": 2256,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9Y1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9Y1?codeType=fs"
     },
     {
      "fs": "9Y2",
      "iata": "",
      "icao": "",
      "faa": "9Y2",
      "name": "East Gull Lake",
      "city": "East Gull Lake",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 46.533,
      "longitude": -94.469472,
      "elevationFeet": 1236,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9Y2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9Y2?codeType=fs"
     },
     {
      "fs": "9Y7",
      "iata": "",
      "icao": "",
      "faa": "9Y7",
      "name": "Barron Municipal",
      "city": "Barron",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 45.474583,
      "longitude": -91.843389,
      "elevationFeet": 1113,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9Y7?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9Y7?codeType=fs"
     },
     {
      "fs": "9Z9",
      "iata": "",
      "icao": "",
      "faa": "9Z9",
      "name": "Lawing",
      "city": "Lawing",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 60.510972,
      "longitude": -149.401944,
      "elevationFeet": 475,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/9Z9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/9Z9?codeType=fs"
     },
     {
      "fs": "A05",
      "iata": "",
      "icao": "",
      "faa": "A05",
      "name": "Dixie Usfs",
      "city": "Dixie",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 45.557417,
      "longitude": -115.526278,
      "elevationFeet": 5148,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A05?codeType=fs"
     },
     {
      "fs": "A08",
      "iata": "",
      "icao": "",
      "faa": "A08",
      "name": "Vaiden",
      "city": "Marion",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.623556,
      "longitude": -87.405556,
      "elevationFeet": 225,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A08?codeType=fs"
     },
     {
      "fs": "A09",
      "iata": "",
      "icao": "",
      "faa": "A09",
      "name": "Eagle Airpark",
      "city": "Bullhead City",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 34.925,
      "longitude": -114.763333,
      "elevationFeet": 485,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A09?codeType=fs"
     },
     {
      "fs": "A20",
      "iata": "",
      "icao": "",
      "faa": "A20",
      "name": "Sun Valley",
      "city": "Bullhead City",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 35.125028,
      "longitude": -114.682972,
      "elevationFeet": 725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A20?codeType=fs"
     },
     {
      "fs": "A22",
      "iata": "",
      "icao": "",
      "faa": "A22",
      "name": "Eagleville",
      "city": "Eagleville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 41.37675,
      "longitude": -120.121611,
      "elevationFeet": 4497,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A22?codeType=fs"
     },
     {
      "fs": "A24",
      "iata": "",
      "icao": "",
      "faa": "A24",
      "name": "California Pines",
      "city": "Alturas",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 41.523917,
      "longitude": -120.694056,
      "elevationFeet": 4398,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A24?codeType=fs"
     },
     {
      "fs": "A26",
      "iata": "",
      "icao": "",
      "faa": "A26",
      "name": "Adin",
      "city": "Adin",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 41.210028,
      "longitude": -120.971889,
      "elevationFeet": 4229,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A26?codeType=fs"
     },
     {
      "fs": "A28",
      "iata": "",
      "icao": "",
      "faa": "A28",
      "name": "Ft Bidwell",
      "city": "Ft Bidwell",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 41.962806,
      "longitude": -120.268944,
      "elevationFeet": 4602,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A28?codeType=fs"
     },
     {
      "fs": "A30",
      "iata": "",
      "icao": "",
      "faa": "A30",
      "name": "Scott Valley",
      "city": "Ft Jones",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 41.631944,
      "longitude": -122.903111,
      "elevationFeet": 2728,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A30?codeType=fs"
     },
     {
      "fs": "A32",
      "iata": "",
      "icao": "",
      "faa": "A32",
      "name": "Butte Valley",
      "city": "Dorris",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 41.920917,
      "longitude": -122.055611,
      "elevationFeet": 4239,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A32?codeType=fs"
     },
     {
      "fs": "A34",
      "iata": "",
      "icao": "",
      "faa": "A34",
      "name": "Dayton Valley",
      "city": "Dayton/Carson City",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 39.276917,
      "longitude": -119.623944,
      "elevationFeet": 4412,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A34?codeType=fs"
     },
     {
      "fs": "A36",
      "iata": "",
      "icao": "",
      "faa": "A36",
      "name": "Hadley",
      "city": "Round Mountain",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 38.790972,
      "longitude": -117.267528,
      "elevationFeet": 5744,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A36?codeType=fs"
     },
     {
      "fs": "A39",
      "iata": "",
      "icao": "",
      "faa": "A39",
      "name": "Grande Valley",
      "city": "Maricopa",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 33.066667,
      "longitude": -111.955556,
      "elevationFeet": 1290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A39?codeType=fs"
     },
     {
      "fs": "A50",
      "iata": "",
      "icao": "",
      "faa": "A50",
      "name": "Colorado Springs East",
      "city": "Ellicott",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 38.944389,
      "longitude": -104.499667,
      "elevationFeet": 6145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A50?codeType=fs"
     },
     {
      "fs": "A51",
      "iata": "",
      "icao": "",
      "faa": "A51",
      "name": "Costin",
      "city": "Port St Joe",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 29.835,
      "longitude": -85.341667,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A51?codeType=fs"
     },
     {
      "fs": "A79",
      "iata": "",
      "icao": "",
      "faa": "A79",
      "name": "Chignik Lake",
      "city": "Chignik Lake",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 56.308806,
      "longitude": -158.853611,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/A79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/A79?codeType=fs"
     },
     {
      "fs": "AAF",
      "iata": "AAF",
      "icao": "KAAF",
      "faa": "AAF",
      "name": "Apalachicola Municipal Airport",
      "city": "Apalachicola",
      "cityCode": "AAF",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 29.733333,
      "longitude": -84.983333,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AAF?codeType=fs"
     },
     {
      "fs": "ADG",
      "iata": "ADG",
      "icao": "KADG",
      "faa": "ADG",
      "name": "Lenawee County Airport",
      "city": "Adrian",
      "cityCode": "ADG",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.9,
      "longitude": -84.033333,
      "elevationFeet": 798,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADG?codeType=fs"
     },
     {
      "fs": "ADR",
      "iata": "ADR",
      "icao": "KPHH",
      "faa": "PHH",
      "name": "Andrews Airport",
      "city": "Andrews",
      "cityCode": "ADR",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 33.45,
      "longitude": -79.566667,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADR?codeType=fs"
     },
     {
      "fs": "ADT",
      "iata": "ADT",
      "icao": "KADH",
      "faa": "ADH",
      "name": "Ada Airport",
      "city": "Ada",
      "cityCode": "ADT",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.8,
      "longitude": -96.666667,
      "elevationFeet": 1016,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ADT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ADT?codeType=fs"
     },
     {
      "fs": "AED",
      "iata": "AED",
      "icao": "",
      "faa": "",
      "name": "Aleneva Airport",
      "city": "Aleneva",
      "cityCode": "AED",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 58.033333,
      "longitude": -152.9,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AED?codeType=fs"
     },
     {
      "fs": "AEL",
      "iata": "AEL",
      "icao": "KAEL",
      "faa": "AEL",
      "name": "Albert Lea Airport",
      "city": "Albert Lea",
      "cityCode": "AEL",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.65,
      "longitude": -93.366667,
      "elevationFeet": 1259,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AEL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AEL?codeType=fs"
     },
     {
      "fs": "AFF",
      "iata": "AFF",
      "icao": "KAFF",
      "faa": "AFF",
      "name": "United States Air Force Academy Airport",
      "city": "Colorado Springs",
      "cityCode": "COS",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 38.972,
      "longitude": -104.822,
      "elevationFeet": 6572,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AFF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AFF?codeType=fs"
     },
     {
      "fs": "AFN",
      "iata": "AFN",
      "icao": "KAFN",
      "faa": "AFN",
      "name": "Jaffrey Municipal Airport",
      "city": "Jaffrey",
      "cityCode": "AFN",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.833333,
      "longitude": -72.066667,
      "elevationFeet": 1040,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AFN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AFN?codeType=fs"
     },
     {
      "fs": "AFO",
      "iata": "AFO",
      "icao": "KAFO",
      "faa": "AFO",
      "name": "Afton Municipal Airport",
      "city": "Afton",
      "cityCode": "AFO",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 42.733333,
      "longitude": -110.933333,
      "elevationFeet": 6201,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AFO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AFO?codeType=fs"
     },
     {
      "fs": "AGO",
      "iata": "AGO",
      "icao": "KAGO",
      "faa": "AGO",
      "name": "Magnolia Municipal Airport",
      "city": "Magnolia",
      "cityCode": "AGO",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.266667,
      "longitude": -93.233333,
      "elevationFeet": 317,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AGO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AGO?codeType=fs"
     },
     {
      "fs": "AHC",
      "iata": "AHC",
      "icao": "KAHC",
      "faa": "AHC",
      "name": "Amedee Army Air Field",
      "city": "Herlong",
      "cityCode": "AHC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 40.15,
      "longitude": -120.133333,
      "elevationFeet": 4008,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AHC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AHC?codeType=fs"
     },
     {
      "fs": "AHD",
      "iata": "AHD",
      "icao": "",
      "faa": "1F0",
      "name": "Ardmore Downtown Executive Airport",
      "city": "Ardmore",
      "cityCode": "ADM",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.146941,
      "longitude": -97.122714,
      "elevationFeet": 823,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AHD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AHD?codeType=fs"
     },
     {
      "fs": "AHF",
      "iata": "AHF",
      "icao": "",
      "faa": "37V",
      "name": "Arapahoe Municipal Airport",
      "city": "Arapahoe",
      "cityCode": "AHF",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.3,
      "longitude": -99.9,
      "elevationFeet": 2270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AHF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AHF?codeType=fs"
     },
     {
      "fs": "AHH",
      "iata": "AHH",
      "icao": "KAHH",
      "faa": "AHH",
      "name": "Amery Municipal Airport",
      "city": "Amery",
      "cityCode": "AHH",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 45.3,
      "longitude": -92.35,
      "elevationFeet": 1088,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AHH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AHH?codeType=fs"
     },
     {
      "fs": "AHT",
      "iata": "AHT",
      "icao": "",
      "faa": "",
      "name": "Amchitka Airport",
      "city": "Amchitka",
      "cityCode": "AHT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Adak",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.683",
      "utcOffsetHours": -10,
      "latitude": 51.5,
      "longitude": 179,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AHT?codeType=fs"
     },
     {
      "fs": "AIB",
      "iata": "AIB",
      "icao": "",
      "faa": "",
      "name": "Anita Bay Airport",
      "city": "Anita Bay",
      "cityCode": "AIB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 56.233333,
      "longitude": -132.383333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIB?codeType=fs"
     },
     {
      "fs": "AID",
      "iata": "AID",
      "icao": "KAID",
      "faa": "AID",
      "name": "Anderson Municipal Airport",
      "city": "Anderson",
      "cityCode": "AID",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.166667,
      "longitude": -85.683333,
      "elevationFeet": 919,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AID?codeType=fs"
     },
     {
      "fs": "AIO",
      "iata": "AIO",
      "icao": "KAIO",
      "faa": "AIO",
      "name": "Atlantic Municipal Airport",
      "city": "Atlantic",
      "cityCode": "AIO",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.4,
      "longitude": -95.016667,
      "elevationFeet": 1182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIO?codeType=fs"
     },
     {
      "fs": "AIV",
      "iata": "AIV",
      "icao": "KAIV",
      "faa": "AIV",
      "name": "George Downer Airport",
      "city": "Aliceville",
      "cityCode": "AIV",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.133333,
      "longitude": -88.15,
      "elevationFeet": 150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIV?codeType=fs"
     },
     {
      "fs": "AIY",
      "iata": "AIY",
      "icao": "KAIY",
      "faa": "AIY",
      "name": "Bader Field",
      "city": "Atlantic City",
      "cityCode": "AIY",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.36,
      "longitude": -74.457222,
      "elevationFeet": 8,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AIY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AIY?codeType=fs"
     },
     {
      "fs": "AK0",
      "iata": "",
      "icao": "",
      "faa": "AK0",
      "name": "Jakes Bar",
      "city": "Mc Carthy",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.237222,
      "longitude": -142.94825,
      "elevationFeet": 1052,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AK0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AK0?codeType=fs"
     },
     {
      "fs": "AK1",
      "iata": "",
      "icao": "",
      "faa": "AK1",
      "name": "Butte Municipal",
      "city": "Palmer",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.647417,
      "longitude": -149.047083,
      "elevationFeet": 64,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AK1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AK1?codeType=fs"
     },
     {
      "fs": "AK11",
      "iata": "",
      "icao": "",
      "faa": "AK11",
      "name": "Point Mc Intyre",
      "city": "Point Mc Intyre",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 70.416778,
      "longitude": -148.822361,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AK11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AK11?codeType=fs"
     },
     {
      "fs": "AKO",
      "iata": "AKO",
      "icao": "KAKO",
      "faa": "AKO",
      "name": "Washington County Airport",
      "city": "Akron",
      "cityCode": "AKO",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 40.166667,
      "longitude": -103.216667,
      "elevationFeet": 4714,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AKO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AKO?codeType=fs"
     },
     {
      "fs": "ALX",
      "iata": "ALX",
      "icao": "KALX",
      "faa": "ALX",
      "name": "Thomas C Russell Field",
      "city": "Alexander City",
      "cityCode": "ALX",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.933333,
      "longitude": -85.95,
      "elevationFeet": 686,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ALX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ALX?codeType=fs"
     },
     {
      "fs": "AMN",
      "iata": "AMN",
      "icao": "KAMN",
      "faa": "AMN",
      "name": "Gratiot Community Airport",
      "city": "Alma",
      "cityCode": "AMN",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.383333,
      "longitude": -84.65,
      "elevationFeet": 754,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AMN?codeType=fs"
     },
     {
      "fs": "AMW",
      "iata": "AMW",
      "icao": "KAMW",
      "faa": "AMW",
      "name": "Ames Airport",
      "city": "Ames",
      "cityCode": "AMW",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.994167,
      "longitude": -93.618333,
      "elevationFeet": 955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AMW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AMW?codeType=fs"
     },
     {
      "fs": "ANN",
      "iata": "ANN",
      "icao": "",
      "faa": "",
      "name": "Annette Island Airport",
      "city": "Annette Island",
      "cityCode": "ANN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 55.036944,
      "longitude": -131.570556,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANN?codeType=fs"
     },
     {
      "fs": "ANP",
      "iata": "ANP",
      "icao": "KANP",
      "faa": "ANP",
      "name": "Lee Airport",
      "city": "Annapolis",
      "cityCode": "ANP",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.983333,
      "longitude": -76.5,
      "elevationFeet": 34,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANP?codeType=fs"
     },
     {
      "fs": "ANQ",
      "iata": "ANQ",
      "icao": "KANQ",
      "faa": "ANQ",
      "name": "Tri-State Steuben County Airport",
      "city": "Angola",
      "cityCode": "ANQ",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.633333,
      "longitude": -85,
      "elevationFeet": 995,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANQ?codeType=fs"
     },
     {
      "fs": "ANW",
      "iata": "ANW",
      "icao": "KANW",
      "faa": "ANW",
      "name": "Ainsworth Airport",
      "city": "Ainsworth",
      "cityCode": "ANW",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.55,
      "longitude": -99.866667,
      "elevationFeet": 2589,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANW?codeType=fs"
     },
     {
      "fs": "ANY",
      "iata": "ANY",
      "icao": "KANY",
      "faa": "ANY",
      "name": "Anthony Airport",
      "city": "Anthony",
      "cityCode": "ANY",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 37.15,
      "longitude": -98.033333,
      "elevationFeet": 1340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ANY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ANY?codeType=fs"
     },
     {
      "fs": "AOH",
      "iata": "AOH",
      "icao": "KAOH",
      "faa": "AOH",
      "name": "Allen County Airport",
      "city": "Lima",
      "cityCode": "AOH",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.766667,
      "longitude": -84.1,
      "elevationFeet": 975,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AOH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AOH?codeType=fs"
     },
     {
      "fs": "APG",
      "iata": "APG",
      "icao": "KAPG",
      "faa": "APG",
      "name": "Phillips Army Air Field",
      "city": "Aberdeen",
      "cityCode": "APG",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.5,
      "longitude": -76.166667,
      "elevationFeet": 58,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APG?codeType=fs"
     },
     {
      "fs": "APH",
      "iata": "APH",
      "icao": "",
      "faa": "",
      "name": "Camp A P Hill Airport",
      "city": "Bowling Green",
      "cityCode": "APH",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.05,
      "longitude": -77.35,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APH?codeType=fs"
     },
     {
      "fs": "APT",
      "iata": "APT",
      "icao": "KAPT",
      "faa": "APT",
      "name": "Marion County Airport",
      "city": "Jasper",
      "cityCode": "APT",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.066667,
      "longitude": -85.5,
      "elevationFeet": 641,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APT?codeType=fs"
     },
     {
      "fs": "APV",
      "iata": "APV",
      "icao": "KAPV",
      "faa": "APV",
      "name": "Apple Valley Airport",
      "city": "Apple Valley",
      "cityCode": "APV",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 34.579105,
      "longitude": -117.185485,
      "elevationFeet": 3059,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/APV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/APV?codeType=fs"
     },
     {
      "fs": "AQY",
      "iata": "AQY",
      "icao": "",
      "faa": "",
      "name": "Alyeska Airport",
      "city": "Alyeska",
      "cityCode": "AQY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 60.966667,
      "longitude": -149.116667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AQY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AQY?codeType=fs"
     },
     {
      "fs": "AQY0",
      "iata": "",
      "icao": "",
      "faa": "AQY",
      "name": "Girdwood",
      "city": "Girdwood",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.110972,
      "longitude": -149.207889,
      "elevationFeet": 150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AQY0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AQY0?codeType=fs"
     },
     {
      "fs": "ARG",
      "iata": "ARG",
      "icao": "KARG",
      "faa": "ARG",
      "name": "Walnut Ridge Airport",
      "city": "Walnut Ridge",
      "cityCode": "ARG",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.066667,
      "longitude": -90.95,
      "elevationFeet": 273,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ARG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ARG?codeType=fs"
     },
     {
      "fs": "ARX",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Asbury Park Airport",
      "city": "Asbury Park",
      "cityCode": "ARX",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.216667,
      "longitude": -74.1,
      "elevationFeet": 87,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ARX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ARX?codeType=fs"
     },
     {
      "fs": "ASL",
      "iata": "ASL",
      "icao": "KASL",
      "faa": "ASL",
      "name": "Harrison County Airport",
      "city": "Marshall",
      "cityCode": "ASL",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.55,
      "longitude": -94.383333,
      "elevationFeet": 357,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASL?codeType=fs"
     },
     {
      "fs": "ASQ",
      "iata": "ASQ",
      "icao": "",
      "faa": "9U3",
      "name": "Austin Airport",
      "city": "Austin",
      "cityCode": "ASQ",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 39.466667,
      "longitude": -117.166667,
      "elevationFeet": 5730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASQ?codeType=fs"
     },
     {
      "fs": "ASX",
      "iata": "ASX",
      "icao": "KASX",
      "faa": "ASX",
      "name": "Ashland Airport",
      "city": "Ashland",
      "cityCode": "ASX",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 46.55,
      "longitude": -90.916667,
      "elevationFeet": 826,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASX?codeType=fs"
     },
     {
      "fs": "ASY",
      "iata": "ASY",
      "icao": "KASY",
      "faa": "ASY",
      "name": "Ashley Airport",
      "city": "Ashley",
      "cityCode": "ASY",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 46.033333,
      "longitude": -99.366667,
      "elevationFeet": 2032,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ASY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ASY?codeType=fs"
     },
     {
      "fs": "ATE",
      "iata": "ATE",
      "icao": "",
      "faa": "80F",
      "name": "Antlers Airport",
      "city": "Antlers",
      "cityCode": "ATE",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.233333,
      "longitude": -95.616667,
      "elevationFeet": 575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATE?codeType=fs"
     },
     {
      "fs": "ATO",
      "iata": "ATO",
      "icao": "KUNI",
      "faa": "UNI",
      "name": "Ohio University Airport",
      "city": "Athens",
      "cityCode": "ATO",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.333333,
      "longitude": -82.1,
      "elevationFeet": 766,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATO?codeType=fs"
     },
     {
      "fs": "ATS",
      "iata": "ATS",
      "icao": "KATS",
      "faa": "ATS",
      "name": "Artesia Airport",
      "city": "Artesia",
      "cityCode": "ATS",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.848333,
      "longitude": -104.466944,
      "elevationFeet": 3541,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATS?codeType=fs"
     },
     {
      "fs": "ATU",
      "iata": "ATU",
      "icao": "",
      "faa": "",
      "name": "Casco Cove Airport",
      "city": "Attu Island",
      "cityCode": "ATU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Adak",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.683",
      "utcOffsetHours": -10,
      "latitude": 52.825833,
      "longitude": 173.172778,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ATU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ATU?codeType=fs"
     },
     {
      "fs": "AUM",
      "iata": "AUM",
      "icao": "KAUM",
      "faa": "AUM",
      "name": "Austin Airport",
      "city": "Austin",
      "cityCode": "AUM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.666667,
      "longitude": -92.983333,
      "elevationFeet": 1233,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUM?codeType=fs"
     },
     {
      "fs": "AUN",
      "iata": "AUN",
      "icao": "KAUN",
      "faa": "AUN",
      "name": "Auburn Airport",
      "city": "Auburn",
      "cityCode": "AUN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 38.9,
      "longitude": -121.066667,
      "elevationFeet": 1531,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUN?codeType=fs"
     },
     {
      "fs": "AUW",
      "iata": "AUW",
      "icao": "KAUW",
      "faa": "AUW",
      "name": "Wausau Downtown Airport",
      "city": "Wausau",
      "cityCode": "AUW",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 44.926188,
      "longitude": -89.626599,
      "elevationFeet": 1192,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AUW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AUW?codeType=fs"
     },
     {
      "fs": "AVO",
      "iata": "AVO",
      "icao": "KAVO",
      "faa": "AVO",
      "name": "Avon Park Municipal Airport",
      "city": "Avon Park",
      "cityCode": "AVO",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 27.6,
      "longitude": -81.516667,
      "elevationFeet": 156,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AVO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AVO?codeType=fs"
     },
     {
      "fs": "AXB",
      "iata": "AXB",
      "icao": "",
      "faa": "",
      "name": "Alexandria Bay Airport",
      "city": "Alexandria Bay",
      "cityCode": "AXB",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 44.2525,
      "longitude": -75.901389,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AXB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AXB?codeType=fs"
     },
     {
      "fs": "AXG",
      "iata": "AXG",
      "icao": "KAXA",
      "faa": "AXA",
      "name": "Algona Airport",
      "city": "Algona",
      "cityCode": "AXG",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.066667,
      "longitude": -94.233333,
      "elevationFeet": 1219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AXG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AXG?codeType=fs"
     },
     {
      "fs": "AXS",
      "iata": "AXS",
      "icao": "KAXS",
      "faa": "AXS",
      "name": "Altus Municipal Airport",
      "city": "Altus",
      "cityCode": "LTS",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.696667,
      "longitude": -99.338056,
      "elevationFeet": 1433,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AXS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AXS?codeType=fs"
     },
     {
      "fs": "AXV",
      "iata": "AXV",
      "icao": "KAXV",
      "faa": "AXV",
      "name": "Neil Armstrong Airport",
      "city": "Wapakoneta",
      "cityCode": "AXV",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.566667,
      "longitude": -84.2,
      "elevationFeet": 912,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AXV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AXV?codeType=fs"
     },
     {
      "fs": "AYE",
      "iata": "AYE",
      "icao": "",
      "faa": "",
      "name": "Army Air Field Heliport",
      "city": "Fort Devens",
      "cityCode": "AYE",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.55,
      "longitude": -71.6,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AYE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AYE?codeType=fs"
     },
     {
      "fs": "AYS",
      "iata": "AYS",
      "icao": "KAYS",
      "faa": "AYS",
      "name": "Ware County Airport",
      "city": "Waycross",
      "cityCode": "AYS",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 31.248611,
      "longitude": -82.396667,
      "elevationFeet": 142,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AYS?codeType=fs"
     },
     {
      "fs": "AYZ",
      "iata": "AYZ",
      "icao": "",
      "faa": "",
      "name": "Zahns Airport",
      "city": "Amityville",
      "cityCode": "AYZ",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.666667,
      "longitude": -73.416667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/AYZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/AYZ?codeType=fs"
     },
     {
      "fs": "B01",
      "iata": "",
      "icao": "",
      "faa": "B01",
      "name": "Granville",
      "city": "Granville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.500722,
      "longitude": -73.370528,
      "elevationFeet": 420,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B01?codeType=fs"
     },
     {
      "fs": "B04",
      "iata": "",
      "icao": "",
      "faa": "B04",
      "name": "Garnsey'S",
      "city": "Schuylerville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.15075,
      "longitude": -73.728944,
      "elevationFeet": 100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B04?codeType=fs"
     },
     {
      "fs": "B06",
      "iata": "",
      "icao": "",
      "faa": "B06",
      "name": "Basin Harbor",
      "city": "Vergennes",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 44.308861,
      "longitude": -73.512361,
      "elevationFeet": 132,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B06?codeType=fs"
     },
     {
      "fs": "B08",
      "iata": "",
      "icao": "",
      "faa": "B08",
      "name": "Silver Springs",
      "city": "Silver Springs",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 39.4325,
      "longitude": -119.268306,
      "elevationFeet": 4269,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B08?codeType=fs"
     },
     {
      "fs": "B10",
      "iata": "",
      "icao": "",
      "faa": "B10",
      "name": "Bowman",
      "city": "Livermore Falls",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 44.511778,
      "longitude": -70.253333,
      "elevationFeet": 327,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B10?codeType=fs"
     },
     {
      "fs": "B16",
      "iata": "",
      "icao": "",
      "faa": "B16",
      "name": "Whitford'S",
      "city": "Weedsport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.20275,
      "longitude": -76.58375,
      "elevationFeet": 400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B16?codeType=fs"
     },
     {
      "fs": "B19",
      "iata": "",
      "icao": "",
      "faa": "B19",
      "name": "Biddeford Municipal",
      "city": "Biddeford",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.591111,
      "longitude": -70.523889,
      "elevationFeet": 157,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B19?codeType=fs"
     },
     {
      "fs": "B21",
      "iata": "",
      "icao": "",
      "faa": "B21",
      "name": "Sugarloaf Regional",
      "city": "Carrabassett",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 45.111667,
      "longitude": -70.361778,
      "elevationFeet": 885,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B21?codeType=fs"
     },
     {
      "fs": "B25",
      "iata": "",
      "icao": "",
      "faa": "B25",
      "name": "Harrold",
      "city": "Butler",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.561611,
      "longitude": -84.960722,
      "elevationFeet": 925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B25?codeType=fs"
     },
     {
      "fs": "B70",
      "iata": "",
      "icao": "",
      "faa": "B70",
      "name": "Tiber Dam",
      "city": "Tiber Dam",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 48.438722,
      "longitude": -111.191417,
      "elevationFeet": 3023,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/B70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/B70?codeType=fs"
     },
     {
      "fs": "BAB",
      "iata": "BAB",
      "icao": "KBAB",
      "faa": "BAB",
      "name": "Beale Air Force Base",
      "city": "Marysville",
      "cityCode": "MYV",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 39.136103,
      "longitude": -121.436957,
      "elevationFeet": 106,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BAB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BAB?codeType=fs"
     },
     {
      "fs": "BAM",
      "iata": "BAM",
      "icao": "KBAM",
      "faa": "BAM",
      "name": "Lander County Airport",
      "city": "Battle Mountain",
      "cityCode": "BAM",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 40.633333,
      "longitude": -116.933333,
      "elevationFeet": 4532,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BAM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BAM?codeType=fs"
     },
     {
      "fs": "BBB",
      "iata": "BBB",
      "icao": "KBBB",
      "faa": "BBB",
      "name": "Benson Municipal Airport",
      "city": "Benson",
      "cityCode": "BBB",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 45.316667,
      "longitude": -95.6,
      "elevationFeet": 1039,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BBB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BBB?codeType=fs"
     },
     {
      "fs": "BBC",
      "iata": "BBC",
      "icao": "KBYY",
      "faa": "BYY",
      "name": "Bay City Airport",
      "city": "Bay City",
      "cityCode": "BBC",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 28.983333,
      "longitude": -95.966667,
      "elevationFeet": 45,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BBC?codeType=fs"
     },
     {
      "fs": "BBD",
      "iata": "BBD",
      "icao": "KBBD",
      "faa": "BBD",
      "name": "Curtis Field",
      "city": "Brady",
      "cityCode": "BBD",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.133333,
      "longitude": -99.333333,
      "elevationFeet": 1827,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BBD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BBD?codeType=fs"
     },
     {
      "fs": "BBF",
      "iata": "BBF",
      "icao": "",
      "faa": "",
      "name": "Burlington Airport",
      "city": "Burlington",
      "cityCode": "BBF",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.5,
      "longitude": -71.183333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BBF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BBF?codeType=fs"
     },
     {
      "fs": "BCB",
      "iata": "BCB",
      "icao": "KBCB",
      "faa": "BCB",
      "name": "Virginia Tech Airport",
      "city": "Blacksburg",
      "cityCode": "BCB",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 37.233333,
      "longitude": -80.416667,
      "elevationFeet": 2132,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BCB?codeType=fs"
     },
     {
      "fs": "BCC",
      "iata": "BCC",
      "icao": "",
      "faa": "",
      "name": "Bear Creek Airport",
      "city": "Bear Creek",
      "cityCode": "BCC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 45.183333,
      "longitude": -109.1,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BCC?codeType=fs"
     },
     {
      "fs": "BCE",
      "iata": "BCE",
      "icao": "KBCE",
      "faa": "BCE",
      "name": "Bryce Airport",
      "city": "Bryce",
      "cityCode": "BCE",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 37.701111,
      "longitude": -112.135278,
      "elevationFeet": 7586,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BCE?codeType=fs"
     },
     {
      "fs": "BCJ",
      "iata": "BCJ",
      "icao": "",
      "faa": "",
      "name": "Baca Grande Airport",
      "city": "Baca Grande",
      "cityCode": "BCJ",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 39,
      "longitude": -106,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BCJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BCJ?codeType=fs"
     },
     {
      "fs": "BCS",
      "iata": "BCS",
      "icao": "",
      "faa": "",
      "name": "Southern Sea Plane Base",
      "city": "Belle Chasse",
      "cityCode": "BCS",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 29.86594,
      "longitude": -90.020305,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BCS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BCS?codeType=fs"
     },
     {
      "fs": "BDE",
      "iata": "BDE",
      "icao": "KBDE",
      "faa": "BDE",
      "name": "Baudette Airport",
      "city": "Baudette",
      "cityCode": "BDE",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.722778,
      "longitude": -94.606944,
      "elevationFeet": 1084,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDE?codeType=fs"
     },
     {
      "fs": "BDF",
      "iata": "BDF",
      "icao": "",
      "faa": "",
      "name": "Rinkenberger Airport",
      "city": "Bradford",
      "cityCode": "BDF",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.183333,
      "longitude": -89.65,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDF?codeType=fs"
     },
     {
      "fs": "BDG",
      "iata": "BDG",
      "icao": "KBDG",
      "faa": "BDG",
      "name": "Blanding Airport",
      "city": "Blanding",
      "cityCode": "BDG",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 37.616667,
      "longitude": -109.483333,
      "elevationFeet": 5865,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDG?codeType=fs"
     },
     {
      "fs": "BDX",
      "iata": "BDX",
      "icao": "KBDX",
      "faa": "BDX",
      "name": "Broadus Airport",
      "city": "Broadus",
      "cityCode": "BDX",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 45.466667,
      "longitude": -105.366667,
      "elevationFeet": 3034,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDX?codeType=fs"
     },
     {
      "fs": "BDY",
      "iata": "BDY",
      "icao": "",
      "faa": "S05",
      "name": "Bandon State Airport",
      "city": "Bandon",
      "cityCode": "BDY",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 43.086467,
      "longitude": -124.407957,
      "elevationFeet": 114,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BDY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BDY?codeType=fs"
     },
     {
      "fs": "BEC",
      "iata": "BEC",
      "icao": "KBEC",
      "faa": "BEC",
      "name": "Beech Airport",
      "city": "Wichita",
      "cityCode": "ICT",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 37.683333,
      "longitude": -97.333333,
      "elevationFeet": 1408,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BEC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BEC?codeType=fs"
     },
     {
      "fs": "BFB",
      "iata": "BFB",
      "icao": "",
      "faa": "",
      "name": "Blue Fox Bay Airport",
      "city": "Blue Fox Bay",
      "cityCode": "BFB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 58.183333,
      "longitude": -152.133333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFB?codeType=fs"
     },
     {
      "fs": "BFG",
      "iata": "BFG",
      "icao": "",
      "faa": "",
      "name": "Bullfrog Basin Airport",
      "city": "Bullfrog Basin",
      "cityCode": "BFG",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 37.545833,
      "longitude": -110.713333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFG?codeType=fs"
     },
     {
      "fs": "BFK",
      "iata": "BFK",
      "icao": "KBKF",
      "faa": "BKF",
      "name": "Buckley Air National Guard Base",
      "city": "Denver",
      "cityCode": "DEN",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 39.707224,
      "longitude": -104.765732,
      "elevationFeet": 5565,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFK?codeType=fs"
     },
     {
      "fs": "BFP",
      "iata": "BFP",
      "icao": "KBVI",
      "faa": "BVI",
      "name": "Beaver Falls Airport",
      "city": "Beaver Falls",
      "cityCode": "BFP",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.766667,
      "longitude": -80.4,
      "elevationFeet": 1253,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFP?codeType=fs"
     },
     {
      "fs": "BFR",
      "iata": "BFR",
      "icao": "KBFR",
      "faa": "BFR",
      "name": "Virgil I Grissom Municipal Airport",
      "city": "Bedford",
      "cityCode": "BFR",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.866667,
      "longitude": -86.483333,
      "elevationFeet": 728,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BFR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BFR?codeType=fs"
     },
     {
      "fs": "BGD",
      "iata": "BGD",
      "icao": "KBGD",
      "faa": "BGD",
      "name": "Borger Airport",
      "city": "Borger",
      "cityCode": "BGD",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.65,
      "longitude": -101.4,
      "elevationFeet": 3054,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGD?codeType=fs"
     },
     {
      "fs": "BGE",
      "iata": "BGE",
      "icao": "KBGE",
      "faa": "BGE",
      "name": "Decatur County Airport",
      "city": "Bainbridge",
      "cityCode": "BGE",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 30.916667,
      "longitude": -84.583333,
      "elevationFeet": 141,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGE?codeType=fs"
     },
     {
      "fs": "BGQ",
      "iata": "BGQ",
      "icao": "",
      "faa": "BGQ",
      "name": "Big Lake Airport",
      "city": "Big Lake",
      "cityCode": "BGQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.536098,
      "longitude": -149.813995,
      "elevationFeet": 158,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGQ?codeType=fs"
     },
     {
      "fs": "BGS",
      "iata": "BGS",
      "icao": "",
      "faa": "",
      "name": "Webb Air Force Base",
      "city": "Big Spring",
      "cityCode": "HCA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.385556,
      "longitude": -101.483333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BGS?codeType=fs"
     },
     {
      "fs": "BIG",
      "iata": "BIG",
      "icao": "",
      "faa": "",
      "name": "Allen Army  Airfield",
      "city": "Delta Junction",
      "cityCode": "BIG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 63.994581,
      "longitude": -145.718989,
      "elevationFeet": 1254,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIG?codeType=fs"
     },
     {
      "fs": "BIX",
      "iata": "BIX",
      "icao": "KBIX",
      "faa": "BIX",
      "name": "Keesler Air Force Base",
      "city": "Biloxi",
      "cityCode": "BIX",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 30.41129,
      "longitude": -88.923622,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BIX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BIX?codeType=fs"
     },
     {
      "fs": "BJJ",
      "iata": "BJJ",
      "icao": "KBJJ",
      "faa": "BJJ",
      "name": "Wayne County Airport",
      "city": "Wooster",
      "cityCode": "BJJ",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.8,
      "longitude": -81.933333,
      "elevationFeet": 1135,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BJJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BJJ?codeType=fs"
     },
     {
      "fs": "BKD",
      "iata": "BKD",
      "icao": "KBKD",
      "faa": "BKD",
      "name": "Stephens County Airport",
      "city": "Breckenridge",
      "cityCode": "BKD",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.75,
      "longitude": -98.9,
      "elevationFeet": 1284,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKD?codeType=fs"
     },
     {
      "fs": "BKF",
      "iata": "BKF",
      "icao": "",
      "faa": "",
      "name": "Lake Brooks Sea Plane Base",
      "city": "Katmai National Park",
      "cityCode": "BKF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 58.554798,
      "longitude": -155.776993,
      "elevationFeet": 46,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKF?codeType=fs"
     },
     {
      "fs": "BKH",
      "iata": "BKH",
      "icao": "PHBK",
      "faa": "PHBK",
      "name": "Barking Sands Airport",
      "city": "Kekaha",
      "cityCode": "BKH",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.683",
      "utcOffsetHours": -10,
      "latitude": 22.017555,
      "longitude": -159.765001,
      "elevationFeet": 8,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKH?codeType=fs"
     },
     {
      "fs": "BKT",
      "iata": "BKT",
      "icao": "KBKT",
      "faa": "BKT",
      "name": "Blackstone Army Air Field",
      "city": "Blackstone",
      "cityCode": "BKT",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 37.066667,
      "longitude": -78,
      "elevationFeet": 439,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKT?codeType=fs"
     },
     {
      "fs": "BKX",
      "iata": "BKX",
      "icao": "KBKX",
      "faa": "BKX",
      "name": "Brookings Airport",
      "street1": "307 2nd Street Southwest",
      "street2": "",
      "city": "Brookings",
      "cityCode": "BKX",
      "stateCode": "SD",
      "postalCode": "57006",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "SDZ040",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 44.303333,
      "longitude": -96.811111,
      "elevationFeet": 1648,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BKX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BKX?codeType=fs"
     },
     {
      "fs": "BLF",
      "iata": "BLF",
      "icao": "KBLF",
      "faa": "BLF",
      "name": "Mercer County Airport",
      "city": "Bluefield",
      "cityCode": "BLF",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "WVZ042",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 37.295833,
      "longitude": -81.208056,
      "elevationFeet": 2857,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLF?codeType=fs"
     },
     {
      "fs": "BLU",
      "iata": "BLU",
      "icao": "KBLU",
      "faa": "BLU",
      "name": "Blue Canyon Airport",
      "city": "Blue Canyon",
      "cityCode": "BLU",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 39.25,
      "longitude": -120.716667,
      "elevationFeet": 5284,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BLU?codeType=fs"
     },
     {
      "fs": "BMC",
      "iata": "BMC",
      "icao": "KBMC",
      "faa": "BMC",
      "name": "Brigham City Airport",
      "city": "Brigham City",
      "cityCode": "BMC",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 41.549167,
      "longitude": -112.062222,
      "elevationFeet": 4226,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BMC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BMC?codeType=fs"
     },
     {
      "fs": "BML",
      "iata": "BML",
      "icao": "KBML",
      "faa": "BML",
      "name": "Berlin Airport",
      "city": "Berlin",
      "cityCode": "BML",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 44.574722,
      "longitude": -71.176389,
      "elevationFeet": 1161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BML?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BML?codeType=fs"
     },
     {
      "fs": "BMX",
      "iata": "BMX",
      "icao": "",
      "faa": "",
      "name": "Big Mountain Airport",
      "city": "Big Mountain",
      "cityCode": "BMX",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 59.361944,
      "longitude": -155.256667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BMX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BMX?codeType=fs"
     },
     {
      "fs": "BNF",
      "iata": "BNF",
      "icao": "",
      "faa": "",
      "name": "Warm Spring Bay Sea Plane Base",
      "city": "Baranof",
      "cityCode": "BNF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 57.088798,
      "longitude": -135.833112,
      "elevationFeet": 26,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNF?codeType=fs"
     },
     {
      "fs": "BNG",
      "iata": "BNG",
      "icao": "KBNG",
      "faa": "BNG",
      "name": "Banning Airport",
      "city": "Banning",
      "cityCode": "BNG",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 33.933333,
      "longitude": -116.866667,
      "elevationFeet": 2219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNG?codeType=fs"
     },
     {
      "fs": "BNH",
      "iata": "BNH",
      "icao": "",
      "faa": "",
      "name": "Boston Harbor Seaplane Base",
      "city": "Boston",
      "cityCode": "HFD",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.352497,
      "longitude": -71.02584,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNH?codeType=fs"
     },
     {
      "fs": "BNL",
      "iata": "BNL",
      "icao": "KBNL",
      "faa": "BNL",
      "name": "Barnwell County Airport",
      "city": "Barnwell",
      "cityCode": "BNL",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 33.25,
      "longitude": -81.383333,
      "elevationFeet": 246,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNL?codeType=fs"
     },
     {
      "fs": "BNW",
      "iata": "BNW",
      "icao": "KBNW",
      "faa": "BNW",
      "name": "Boone Airport",
      "city": "Boone",
      "cityCode": "BNW",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.066667,
      "longitude": -93.883333,
      "elevationFeet": 1160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BNW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BNW?codeType=fs"
     },
     {
      "fs": "BOF",
      "iata": "BOF",
      "icao": "",
      "faa": "",
      "name": "Bolling Air Force Base",
      "city": "Washington",
      "cityCode": "WAS",
      "stateCode": "DC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.851693,
      "longitude": -77.012501,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BOF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BOF?codeType=fs"
     },
     {
      "fs": "BOK",
      "iata": "BOK",
      "icao": "KBOK",
      "faa": "BOK",
      "name": "Brookings State Airport",
      "city": "Brookings",
      "cityCode": "BOK",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 42.05,
      "longitude": -124.283333,
      "elevationFeet": 459,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BOK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BOK?codeType=fs"
     },
     {
      "fs": "BOW",
      "iata": "BOW",
      "icao": "KBOW",
      "faa": "BOW",
      "name": "Bartow Airport",
      "city": "Bartow",
      "cityCode": "BOW",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 27.9,
      "longitude": -81.833333,
      "elevationFeet": 125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BOW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BOW?codeType=fs"
     },
     {
      "fs": "BPA",
      "iata": "BPA",
      "icao": "",
      "faa": "",
      "name": "Grumman Airport",
      "city": "Bethpage",
      "cityCode": "BPA",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.733333,
      "longitude": -73.483333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BPA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BPA?codeType=fs"
     },
     {
      "fs": "BPE0",
      "iata": "",
      "icao": "",
      "faa": "BPE",
      "name": "Badami Airstrip",
      "city": "Badami",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 70.177083,
      "longitude": -147.124917,
      "elevationFeet": 26,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BPE0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BPE0?codeType=fs"
     },
     {
      "fs": "BPI",
      "iata": "BPI",
      "icao": "KBPI",
      "faa": "BPI",
      "name": "Miley Memorial Field",
      "city": "Big Piney",
      "cityCode": "BPI",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 42.585029,
      "longitude": -110.111064,
      "elevationFeet": 6974,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BPI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BPI?codeType=fs"
     },
     {
      "fs": "BQV",
      "iata": "BQV",
      "icao": "",
      "faa": "",
      "name": "Bartlett Sea Plane Base",
      "city": "Gustavus",
      "cityCode": "GST",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 58.416667,
      "longitude": -135.733333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BQV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BQV?codeType=fs"
     },
     {
      "fs": "BRG",
      "iata": "BRG",
      "icao": "",
      "faa": "",
      "name": "Whitesburg Municipal Airport",
      "city": "Whitesburg",
      "cityCode": "BRG",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 37.116667,
      "longitude": -82.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BRG?codeType=fs"
     },
     {
      "fs": "BRY",
      "iata": "BRY",
      "icao": "KBRY",
      "faa": "BRY",
      "name": "Samuels Field",
      "city": "Bardstown",
      "cityCode": "BRY",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 37.822034,
      "longitude": -85.484178,
      "elevationFeet": 650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BRY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BRY?codeType=fs"
     },
     {
      "fs": "BSF",
      "iata": "BSF",
      "icao": "PHSF",
      "faa": "PHSF",
      "name": "Bradshaw Army Air Field",
      "city": "Pohakuloa",
      "cityCode": "BSF",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.683",
      "utcOffsetHours": -10,
      "latitude": 19.758207,
      "longitude": -155.549427,
      "elevationFeet": 6185,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BSF?codeType=fs"
     },
     {
      "fs": "BSQ",
      "iata": "BSQ",
      "icao": "",
      "faa": "P04",
      "name": "Bisbee Municipal Airport",
      "city": "Bisbee",
      "cityCode": "BSQ",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 31.363889,
      "longitude": -109.881111,
      "elevationFeet": 4780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BSQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BSQ?codeType=fs"
     },
     {
      "fs": "BSW",
      "iata": "BSW",
      "icao": "",
      "faa": "",
      "name": "Boswell Bay Airport",
      "city": "Boswell Bay",
      "cityCode": "BSW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 60.4,
      "longitude": -146.133333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BSW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BSW?codeType=fs"
     },
     {
      "fs": "BTF",
      "iata": "BTF",
      "icao": "KBTF",
      "faa": "BTF",
      "name": "Bountiful Skypark",
      "city": "Bountiful",
      "cityCode": "BTF",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 40.869432,
      "longitude": -111.927485,
      "elevationFeet": 4242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTF?codeType=fs"
     },
     {
      "fs": "BTN",
      "iata": "BTN",
      "icao": "KBBP",
      "faa": "BBP",
      "name": "Bennettsville Airport",
      "city": "Bennettsville",
      "cityCode": "BTN",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 34.616667,
      "longitude": -79.683333,
      "elevationFeet": 1318,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTN?codeType=fs"
     },
     {
      "fs": "BTP",
      "iata": "BTP",
      "icao": "KBTP",
      "faa": "BTP",
      "name": "Graham Field",
      "city": "Butler",
      "cityCode": "BTP",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.85,
      "longitude": -79.916667,
      "elevationFeet": 1248,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTP?codeType=fs"
     },
     {
      "fs": "BTY",
      "iata": "BTY",
      "icao": "KBTY",
      "faa": "BTY",
      "name": "Beatty Airport",
      "city": "Beatty",
      "cityCode": "BTY",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 36.9,
      "longitude": -116.766667,
      "elevationFeet": 3170,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BTY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BTY?codeType=fs"
     },
     {
      "fs": "BUM",
      "iata": "BUM",
      "icao": "KBUM",
      "faa": "BUM",
      "name": "Butler Airport",
      "city": "Butler",
      "cityCode": "BUM",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 38.266667,
      "longitude": -94.333333,
      "elevationFeet": 892,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BUM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BUM?codeType=fs"
     },
     {
      "fs": "BVD",
      "iata": "BVD",
      "icao": "",
      "faa": "",
      "name": "Beaver Inlet Sea Port",
      "city": "Beaver Inlet",
      "cityCode": "BVD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 53.733333,
      "longitude": -166.316667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BVD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BVD?codeType=fs"
     },
     {
      "fs": "BVU",
      "iata": "BVU",
      "icao": "PABG",
      "faa": "PABG",
      "name": "Beluga Airport",
      "city": "Beluga",
      "cityCode": "BVU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.169444,
      "longitude": -151.036111,
      "elevationFeet": 87,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BVU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BVU?codeType=fs"
     },
     {
      "fs": "BVX",
      "iata": "BVX",
      "icao": "KBVX",
      "faa": "BVX",
      "name": "Batesville Regional Airport",
      "city": "Batesville",
      "cityCode": "BVX",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.766667,
      "longitude": -91.65,
      "elevationFeet": 464,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BVX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BVX?codeType=fs"
     },
     {
      "fs": "BWC",
      "iata": "BWC",
      "icao": "KBWC",
      "faa": "BWC",
      "name": "Brawley Municipal Airport",
      "city": "Brawley",
      "cityCode": "BWC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 32.992865,
      "longitude": -115.516875,
      "elevationFeet": -131,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWC?codeType=fs"
     },
     {
      "fs": "BWL",
      "iata": "BWL",
      "icao": "",
      "faa": "4O3",
      "name": "Blackwell Airport",
      "city": "Blackwell",
      "cityCode": "BWL",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.8,
      "longitude": -97.283333,
      "elevationFeet": 1029,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWL?codeType=fs"
     },
     {
      "fs": "BWM",
      "iata": "BWM",
      "icao": "KBPP",
      "faa": "BPP",
      "name": "Bowman Airport",
      "city": "Bowman",
      "cityCode": "BWM",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 46.183333,
      "longitude": -103.4,
      "elevationFeet": 2958,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWM?codeType=fs"
     },
     {
      "fs": "BWS",
      "iata": "BWS",
      "icao": "",
      "faa": "4W6",
      "name": "Blaine Airport",
      "city": "Blaine",
      "cityCode": "BWS",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 48.966667,
      "longitude": -122.833333,
      "elevationFeet": 70,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BWS?codeType=fs"
     },
     {
      "fs": "BXA",
      "iata": "BXA",
      "icao": "KBXA",
      "faa": "BXA",
      "name": "George R. Carr Airport",
      "city": "Bogalusa",
      "cityCode": "BXA",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 30.933333,
      "longitude": -89.883333,
      "elevationFeet": 119,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BXA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BXA?codeType=fs"
     },
     {
      "fs": "BXC",
      "iata": "BXC",
      "icao": "",
      "faa": "",
      "name": "Boxborough Airport",
      "city": "Boxborough",
      "cityCode": "BXC",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.483333,
      "longitude": -71.533333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BXC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BXC?codeType=fs"
     },
     {
      "fs": "BXK",
      "iata": "BXK",
      "icao": "KBXK",
      "faa": "BXK",
      "name": "Buckeye Airport",
      "city": "Buckeye",
      "cityCode": "BXK",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 33.366667,
      "longitude": -112.583333,
      "elevationFeet": 1021,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BXK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BXK?codeType=fs"
     },
     {
      "fs": "BXS",
      "iata": "BXS",
      "icao": "",
      "faa": "L08",
      "name": "Borrego Springs Airport",
      "city": "Borrego Springs",
      "cityCode": "BXS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 33.343333,
      "longitude": -116.327778,
      "elevationFeet": 520,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BXS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BXS?codeType=fs"
     },
     {
      "fs": "BYA",
      "iata": "BYA",
      "icao": "",
      "faa": "BYA",
      "name": "Boundary Airport",
      "city": "Boundary",
      "cityCode": "BYA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 64.076389,
      "longitude": -141.114444,
      "elevationFeet": 2940,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BYA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BYA?codeType=fs"
     },
     {
      "fs": "BYG",
      "iata": "BYG",
      "icao": "KBYG",
      "faa": "BYG",
      "name": "Buffalo Municipal Airport",
      "city": "Buffalo",
      "cityCode": "BYG",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 44.35,
      "longitude": -106.7,
      "elevationFeet": 4968,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BYG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BYG?codeType=fs"
     },
     {
      "fs": "BYH",
      "iata": "BYH",
      "icao": "KBYH",
      "faa": "BYH",
      "name": "Arkansas International Airport",
      "city": "Blytheville",
      "cityCode": "BYH",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.960897,
      "longitude": -89.945216,
      "elevationFeet": 252,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BYH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BYH?codeType=fs"
     },
     {
      "fs": "BYS",
      "iata": "BYS",
      "icao": "",
      "faa": "",
      "name": "Bicycle Lake Army Air Field",
      "city": "Fort Irwin",
      "cityCode": "BYS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 35.266667,
      "longitude": -116.566667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BYS?codeType=fs"
     },
     {
      "fs": "BYW",
      "iata": "BYW",
      "icao": "",
      "faa": "",
      "name": "Blakely Island Airport",
      "city": "Blakely Island",
      "cityCode": "BYW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "WAZ001",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 48.5,
      "longitude": -123,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BYW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BYW?codeType=fs"
     },
     {
      "fs": "BZS",
      "iata": "BZS",
      "icao": "",
      "faa": "",
      "name": "Buzzards Point S Airport",
      "city": "Washington",
      "cityCode": "WAS",
      "stateCode": "DC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.868675,
      "longitude": -77.007637,
      "elevationFeet": 1,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BZS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BZS?codeType=fs"
     },
     {
      "fs": "BZT",
      "iata": "BZT",
      "icao": "",
      "faa": "",
      "name": "Hinkles Ferry",
      "city": "Brazoria",
      "cityCode": "BZT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 29.05,
      "longitude": -95.566667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/BZT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/BZT?codeType=fs"
     },
     {
      "fs": "C00",
      "iata": "",
      "icao": "",
      "faa": "C00",
      "name": "Mercer Co",
      "city": "Aledo",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.386444,
      "longitude": -90.770833,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C00?codeType=fs"
     },
     {
      "fs": "C01",
      "iata": "",
      "icao": "",
      "faa": "C01",
      "name": "Southern Cross",
      "city": "Williamstown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.705,
      "longitude": -75.145,
      "elevationFeet": 145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C01?codeType=fs"
     },
     {
      "fs": "C02",
      "iata": "",
      "icao": "",
      "faa": "C02",
      "name": "Grand Geneva Resort",
      "city": "Lake Geneva",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.746861,
      "longitude": -88.449889,
      "elevationFeet": 835,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C02?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C02?codeType=fs"
     },
     {
      "fs": "C03",
      "iata": "",
      "icao": "",
      "faa": "C03",
      "name": "Nappanee Municipal",
      "city": "Nappanee",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.561583,
      "longitude": -85.948306,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C03?codeType=fs"
     },
     {
      "fs": "C04",
      "iata": "",
      "icao": "",
      "faa": "C04",
      "name": "Oceana Co",
      "city": "Hart/Shelby",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.71675,
      "longitude": -86.442417,
      "elevationFeet": 910,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C04?codeType=fs"
     },
     {
      "fs": "C07",
      "iata": "",
      "icao": "",
      "faa": "C07",
      "name": "Mack Mesa",
      "city": "Mack",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 39.272028,
      "longitude": -108.987167,
      "elevationFeet": 4724,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C07?codeType=fs"
     },
     {
      "fs": "C08",
      "iata": "",
      "icao": "",
      "faa": "C08",
      "name": "Silver West",
      "city": "Westcliffe",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 38.111139,
      "longitude": -105.427806,
      "elevationFeet": 8290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C08?codeType=fs"
     },
     {
      "fs": "C09",
      "iata": "",
      "icao": "",
      "faa": "C09",
      "name": "Morris Mun-Washburn",
      "city": "Morris",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.504167,
      "longitude": -88.436944,
      "elevationFeet": 584,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C09?codeType=fs"
     },
     {
      "fs": "C10",
      "iata": "",
      "icao": "",
      "faa": "C10",
      "name": "Smith",
      "city": "Macomb",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.492083,
      "longitude": -90.685,
      "elevationFeet": 702,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C10?codeType=fs"
     },
     {
      "fs": "C11",
      "iata": "",
      "icao": "",
      "faa": "C11",
      "name": "Amana",
      "city": "Amana",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.908417,
      "longitude": -91.910111,
      "elevationFeet": 712,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C11?codeType=fs"
     },
     {
      "fs": "C14",
      "iata": "",
      "icao": "",
      "faa": "C14",
      "name": "Borges-Clarksburg Airport",
      "city": "Clarksburg",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 38.444144,
      "longitude": -121.505054,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C14?codeType=fs"
     },
     {
      "fs": "C15",
      "iata": "",
      "icao": "",
      "faa": "C15",
      "name": "Pekin Municipal",
      "city": "Pekin",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.532056,
      "longitude": -89.759111,
      "elevationFeet": 530,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C15?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C15?codeType=fs"
     },
     {
      "fs": "C16",
      "iata": "",
      "icao": "",
      "faa": "C16",
      "name": "Frasca",
      "city": "Urbana",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.252528,
      "longitude": -88.336028,
      "elevationFeet": 735,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C16?codeType=fs"
     },
     {
      "fs": "C17",
      "iata": "",
      "icao": "",
      "faa": "C17",
      "name": "Marion",
      "city": "Marion",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.161111,
      "longitude": -91.643417,
      "elevationFeet": 862,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C17?codeType=fs"
     },
     {
      "fs": "C18",
      "iata": "",
      "icao": "",
      "faa": "C18",
      "name": "Frankfort",
      "city": "Frankfort",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.575,
      "longitude": -87.904722,
      "elevationFeet": 778,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C18?codeType=fs"
     },
     {
      "fs": "C20",
      "iata": "",
      "icao": "",
      "faa": "C20",
      "name": "Andrews University",
      "city": "Berrien Springs",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.967194,
      "longitude": -86.376583,
      "elevationFeet": 668,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C20?codeType=fs"
     },
     {
      "fs": "C22",
      "iata": "",
      "icao": "",
      "faa": "C22",
      "name": "Centre Municipal",
      "city": "Centre",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.24875,
      "longitude": -85.651306,
      "elevationFeet": 619,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C22?codeType=fs"
     },
     {
      "fs": "C24",
      "iata": "",
      "icao": "",
      "faa": "C24",
      "name": "Brookeridge",
      "city": "Downers Grove",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.877444,
      "longitude": -88.142722,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C24?codeType=fs"
     },
     {
      "fs": "C25",
      "iata": "",
      "icao": "",
      "faa": "C25",
      "name": "Waverly Municipal",
      "city": "Waverly",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.819528,
      "longitude": -92.579361,
      "elevationFeet": 992,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C25?codeType=fs"
     },
     {
      "fs": "C27",
      "iata": "",
      "icao": "",
      "faa": "C27",
      "name": "Manchester Municipal",
      "city": "Manchester",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.583194,
      "longitude": -91.634806,
      "elevationFeet": 987,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C27?codeType=fs"
     },
     {
      "fs": "C34",
      "iata": "",
      "icao": "",
      "faa": "C34",
      "name": "Schertz",
      "city": "Gibson City",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.507833,
      "longitude": -88.272722,
      "elevationFeet": 758,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C34?codeType=fs"
     },
     {
      "fs": "C35",
      "iata": "",
      "icao": "",
      "faa": "C35",
      "name": "Reedsburg Municipal",
      "city": "Reedsburg",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.609,
      "longitude": -90.132222,
      "elevationFeet": 907,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C35?codeType=fs"
     },
     {
      "fs": "C37",
      "iata": "",
      "icao": "",
      "faa": "C37",
      "name": "Brodhead",
      "city": "Brodhead",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.666778,
      "longitude": -89.451167,
      "elevationFeet": 793,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C37?codeType=fs"
     },
     {
      "fs": "C38",
      "iata": "",
      "icao": "",
      "faa": "C38",
      "name": "Casa De Aero Park",
      "city": "Hampshire",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.286361,
      "longitude": -88.648111,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C38?codeType=fs"
     },
     {
      "fs": "C40",
      "iata": "",
      "icao": "",
      "faa": "C40",
      "name": "Miller",
      "city": "Bluffton",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.717139,
      "longitude": -85.399722,
      "elevationFeet": 845,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C40?codeType=fs"
     },
     {
      "fs": "C43",
      "iata": "",
      "icao": "",
      "faa": "C43",
      "name": "Cure",
      "city": "Sunfield",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.800333,
      "longitude": -85.099583,
      "elevationFeet": 853,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C43?codeType=fs"
     },
     {
      "fs": "C44",
      "iata": "",
      "icao": "",
      "faa": "C44",
      "name": "Toutant",
      "city": "Putnam",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.000972,
      "longitude": -72.095194,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C44?codeType=fs"
     },
     {
      "fs": "C45",
      "iata": "",
      "icao": "",
      "faa": "C45",
      "name": "Manito Mitchell",
      "city": "Manito",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 40.543444,
      "longitude": -89.880806,
      "elevationFeet": 501,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C45?codeType=fs"
     },
     {
      "fs": "C47",
      "iata": "",
      "icao": "",
      "faa": "C47",
      "name": "Portage Municipal",
      "city": "Portage",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.650917,
      "longitude": -89.630917,
      "elevationFeet": 825,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C47?codeType=fs"
     },
     {
      "fs": "C55",
      "iata": "",
      "icao": "",
      "faa": "C55",
      "name": "Barnett Memorial",
      "city": "Mt Morris",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.0725,
      "longitude": -89.478861,
      "elevationFeet": 929,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C55?codeType=fs"
     },
     {
      "fs": "C56",
      "iata": "",
      "icao": "",
      "faa": "C56",
      "name": "Sanger",
      "city": "Monee",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.475611,
      "longitude": -87.81375,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C56?codeType=fs"
     },
     {
      "fs": "C59",
      "iata": "",
      "icao": "",
      "faa": "C59",
      "name": "Lake Lawn",
      "city": "Delavan",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.64125,
      "longitude": -88.611306,
      "elevationFeet": 981,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C59?codeType=fs"
     },
     {
      "fs": "C62",
      "iata": "",
      "icao": "",
      "faa": "C62",
      "name": "Kendallville Municipal",
      "city": "Kendallville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.527167,
      "longitude": -85.358083,
      "elevationFeet": 1005,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C62?codeType=fs"
     },
     {
      "fs": "C66",
      "iata": "",
      "icao": "",
      "faa": "C66",
      "name": "Monmouth Municipal",
      "city": "Monmouth",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.047056,
      "longitude": -90.761083,
      "elevationFeet": 753,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C66?codeType=fs"
     },
     {
      "fs": "C71",
      "iata": "",
      "icao": "",
      "faa": "C71",
      "name": "Crosby Municipal",
      "city": "Crosby",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.410056,
      "longitude": -91.078806,
      "elevationFeet": 336,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C71?codeType=fs"
     },
     {
      "fs": "C72",
      "iata": "",
      "icao": "",
      "faa": "C72",
      "name": "Cross Winds",
      "city": "Clayton",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 48.13225,
      "longitude": -117.627278,
      "elevationFeet": 2150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C72?codeType=fs"
     },
     {
      "fs": "C73",
      "iata": "",
      "icao": "",
      "faa": "C73",
      "name": "Dixon Mun-Walgreen",
      "city": "Dixon",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.837,
      "longitude": -89.562139,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C73?codeType=fs"
     },
     {
      "fs": "C74",
      "iata": "",
      "icao": "",
      "faa": "C74",
      "name": "Cassville Municipal",
      "city": "Cassville",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.741611,
      "longitude": -91.095722,
      "elevationFeet": 627,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C74?codeType=fs"
     },
     {
      "fs": "C75",
      "iata": "",
      "icao": "",
      "faa": "C75",
      "name": "Marshall Co",
      "city": "Lacon",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.042861,
      "longitude": -89.414222,
      "elevationFeet": 568,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C75?codeType=fs"
     },
     {
      "fs": "C77",
      "iata": "",
      "icao": "",
      "faa": "C77",
      "name": "Poplar Grove",
      "city": "Poplar Grove",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.376861,
      "longitude": -88.865194,
      "elevationFeet": 856,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C77?codeType=fs"
     },
     {
      "fs": "C80",
      "iata": "",
      "icao": "",
      "faa": "C80",
      "name": "New Coalinga Municipal",
      "city": "Coalinga",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 36.281389,
      "longitude": -120.388139,
      "elevationFeet": 622,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C80?codeType=fs"
     },
     {
      "fs": "C81",
      "iata": "",
      "icao": "",
      "faa": "C81",
      "name": "Campbell",
      "city": "Grayslake",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.396111,
      "longitude": -88.140889,
      "elevationFeet": 788,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C81?codeType=fs"
     },
     {
      "fs": "C82",
      "iata": "",
      "icao": "",
      "faa": "C82",
      "name": "Bresson",
      "city": "Compton",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.875306,
      "longitude": -89.114806,
      "elevationFeet": 769,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C82?codeType=fs"
     },
     {
      "fs": "C83",
      "iata": "",
      "icao": "",
      "faa": "C83",
      "name": "Byron",
      "city": "Byron",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 37.8284,
      "longitude": -121.625999,
      "elevationFeet": 79,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C83?codeType=fs"
     },
     {
      "fs": "C86",
      "iata": "",
      "icao": "",
      "faa": "C86",
      "name": "Freeport/Dornink",
      "city": "Freeport",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.477944,
      "longitude": -89.690056,
      "elevationFeet": 949,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C86?codeType=fs"
     },
     {
      "fs": "C89",
      "iata": "",
      "icao": "",
      "faa": "C89",
      "name": "Sylvania",
      "city": "Sturtevant",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.73075,
      "longitude": -88.034139,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C89?codeType=fs"
     },
     {
      "fs": "C91",
      "iata": "",
      "icao": "",
      "faa": "C91",
      "name": "Dowagiac Municipal",
      "city": "Dowagiac",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.079333,
      "longitude": -86.230139,
      "elevationFeet": 748,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C91?codeType=fs"
     },
     {
      "fs": "C92",
      "iata": "",
      "icao": "",
      "faa": "C92",
      "name": "Mentone",
      "city": "Mentone",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.150444,
      "longitude": -86.174972,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C92?codeType=fs"
     },
     {
      "fs": "C94",
      "iata": "",
      "icao": "",
      "faa": "C94",
      "name": "Earlville",
      "city": "Earlville",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.56975,
      "longitude": -89.078611,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C94?codeType=fs"
     },
     {
      "fs": "C95",
      "iata": "",
      "icao": "",
      "faa": "C95",
      "name": "Mc Neal'S",
      "city": "East Moline",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.658667,
      "longitude": -90.495722,
      "elevationFeet": 575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C95?codeType=fs"
     },
     {
      "fs": "C97",
      "iata": "",
      "icao": "",
      "faa": "C97",
      "name": "Lowell",
      "city": "Lowell",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.350361,
      "longitude": -87.578139,
      "elevationFeet": 675,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C97?codeType=fs"
     },
     {
      "fs": "C98",
      "iata": "",
      "icao": "",
      "faa": "C98",
      "name": "Lake Village",
      "city": "Lake Village",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.150333,
      "longitude": -87.575333,
      "elevationFeet": 644,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/C98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/C98?codeType=fs"
     },
     {
      "fs": "CAR",
      "iata": "CAR",
      "icao": "KCAR",
      "faa": "CAR",
      "name": "Caribou Municipal Airport",
      "city": "Caribou",
      "cityCode": "CAR",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 46.866667,
      "longitude": -68.016667,
      "elevationFeet": 626,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CAR?codeType=fs"
     },
     {
      "fs": "CBA",
      "iata": "CBA",
      "icao": "",
      "faa": "",
      "name": "Corner Bay Airport",
      "city": "Corner Bay",
      "cityCode": "CBA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 57.716667,
      "longitude": -135.2,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CBA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CBA?codeType=fs"
     },
     {
      "fs": "CBF",
      "iata": "CBF",
      "icao": "KCBF",
      "faa": "CBF",
      "name": "Council Bluffs Municipal Airport",
      "city": "Council Bluffs",
      "cityCode": "CBF",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.259926,
      "longitude": -95.757689,
      "elevationFeet": 1242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CBF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CBF?codeType=fs"
     },
     {
      "fs": "CBM",
      "iata": "CBM",
      "icao": "KCBM",
      "faa": "CBM",
      "name": "Columbus Air Force Base",
      "city": "Columbus",
      "cityCode": "UBS",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.64384,
      "longitude": -88.444666,
      "elevationFeet": 201,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CBM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CBM?codeType=fs"
     },
     {
      "fs": "CCD",
      "iata": "CCD",
      "icao": "",
      "faa": "",
      "name": "Century City Airport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 34.066667,
      "longitude": -118.266667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CCD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CCD?codeType=fs"
     },
     {
      "fs": "CCG",
      "iata": "CCG",
      "icao": "",
      "faa": "E13",
      "name": "Crane County Airport",
      "city": "Crane",
      "cityCode": "CCG",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.4,
      "longitude": -102.35,
      "elevationFeet": 2552,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CCG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CCG?codeType=fs"
     },
     {
      "fs": "CCY",
      "iata": "CCY",
      "icao": "KCCY",
      "faa": "CCY",
      "name": "Charles City Municipal Airport",
      "city": "Charles City",
      "cityCode": "CCY",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.066667,
      "longitude": -92.683333,
      "elevationFeet": 1125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CCY?codeType=fs"
     },
     {
      "fs": "CDH",
      "iata": "CDH",
      "icao": "KCDH",
      "faa": "CDH",
      "name": "Harrell Field",
      "city": "Camden",
      "cityCode": "CDH",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.583333,
      "longitude": -92.833333,
      "elevationFeet": 130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDH?codeType=fs"
     },
     {
      "fs": "CDK",
      "iata": "CDK",
      "icao": "KCDK",
      "faa": "CDK",
      "name": "Lewis Airport",
      "city": "Cedar Key",
      "cityCode": "CDK",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 29.133333,
      "longitude": -83.033333,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDK?codeType=fs"
     },
     {
      "fs": "CDL",
      "iata": "CDL",
      "icao": "",
      "faa": "CDL",
      "name": "Candle Airport",
      "city": "Candle",
      "cityCode": "CDL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 65.908056,
      "longitude": -161.938333,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDL?codeType=fs"
     },
     {
      "fs": "CDN",
      "iata": "CDN",
      "icao": "KCDN",
      "faa": "CDN",
      "name": "Woodward Field",
      "city": "Camden",
      "cityCode": "CDN",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 34.266667,
      "longitude": -80.6,
      "elevationFeet": 302,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDN?codeType=fs"
     },
     {
      "fs": "CDS",
      "iata": "CDS",
      "icao": "KCDS",
      "faa": "CDS",
      "name": "Childress Airport",
      "city": "Childress",
      "cityCode": "CDS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 37.416667,
      "longitude": -100.216667,
      "elevationFeet": 1953,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CDS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CDS?codeType=fs"
     },
     {
      "fs": "CEA",
      "iata": "CEA",
      "icao": "KCEA",
      "faa": "CEA",
      "name": "Cessna Aircraft Field",
      "city": "Wichita",
      "cityCode": "ICT",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 37.7,
      "longitude": -97.333333,
      "elevationFeet": 1378,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEA?codeType=fs"
     },
     {
      "fs": "CEV",
      "iata": "CEV",
      "icao": "KCEV",
      "faa": "CEV",
      "name": "Mettle Field",
      "city": "Connersville",
      "cityCode": "CEV",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.65,
      "longitude": -85.133333,
      "elevationFeet": 867,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEV?codeType=fs"
     },
     {
      "fs": "CEX",
      "iata": "CEX",
      "icao": "",
      "faa": "",
      "name": "Chena Hot Springs Airport",
      "city": "Chena Hot Springs",
      "cityCode": "CEX",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 65.05,
      "longitude": -146.166667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEX?codeType=fs"
     },
     {
      "fs": "CEY",
      "iata": "CEY",
      "icao": "KCEY",
      "faa": "CEY",
      "name": "Calloway County Airport",
      "city": "Murray",
      "cityCode": "CEY",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.616667,
      "longitude": -88.316667,
      "elevationFeet": 576,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CEY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CEY?codeType=fs"
     },
     {
      "fs": "CFD",
      "iata": "CFD",
      "icao": "KCFD",
      "faa": "CFD",
      "name": "Coulter Field",
      "city": "Bryan",
      "cityCode": "CFD",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 30.666667,
      "longitude": -96.366667,
      "elevationFeet": 367,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CFD?codeType=fs"
     },
     {
      "fs": "CFT",
      "iata": "CFT",
      "icao": "KCFT",
      "faa": "CFT",
      "name": "Morenci Airport",
      "city": "Clifton",
      "cityCode": "CFT",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.952801,
      "longitude": -109.209999,
      "elevationFeet": 3798,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CFT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CFT?codeType=fs"
     },
     {
      "fs": "CFV",
      "iata": "CFV",
      "icao": "KCFV",
      "faa": "CFV",
      "name": "Coffeyville Municipal Airport",
      "city": "Coffeyville",
      "cityCode": "CFV",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 37.033333,
      "longitude": -95.616667,
      "elevationFeet": 754,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CFV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CFV?codeType=fs"
     },
     {
      "fs": "CGE",
      "iata": "CGE",
      "icao": "KCGE",
      "faa": "CGE",
      "name": "Cambridge Airport",
      "city": "Cambridge",
      "cityCode": "CGE",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.566667,
      "longitude": -76.083333,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGE?codeType=fs"
     },
     {
      "fs": "CGS",
      "iata": "CGS",
      "icao": "KCGS",
      "faa": "CGS",
      "name": "College Park Airport",
      "city": "College Park",
      "cityCode": "CGS",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.980346,
      "longitude": -76.922132,
      "elevationFeet": 44,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGS?codeType=fs"
     },
     {
      "fs": "CGX",
      "iata": "CGX",
      "icao": "KCGX",
      "faa": "CGX",
      "name": "Merrill C Meigs Field",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.858889,
      "longitude": -87.608333,
      "elevationFeet": 593,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGX?codeType=fs"
     },
     {
      "fs": "CGZ",
      "iata": "CGZ",
      "icao": "KCGZ",
      "faa": "CGZ",
      "name": "Casa Grande Municipal Airport",
      "city": "Casa Grande",
      "cityCode": "CGZ",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.954899,
      "longitude": -111.766998,
      "elevationFeet": 1464,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CGZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CGZ?codeType=fs"
     },
     {
      "fs": "CHD",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Phoenix-Mesa Gateway Airport",
      "city": "Chandler",
      "cityCode": "CHD",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 33.307778,
      "longitude": -111.655556,
      "elevationFeet": 1382,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHD?codeType=fs"
     },
     {
      "fs": "CHK",
      "iata": "CHK",
      "icao": "KCHK",
      "faa": "CHK",
      "name": "Chickasha Municipal Airport",
      "city": "Chickasha",
      "cityCode": "CHK",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.05,
      "longitude": -97.966667,
      "elevationFeet": 1150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHK?codeType=fs"
     },
     {
      "fs": "CHL",
      "iata": "CHL",
      "icao": "KLLJ",
      "faa": "LLJ",
      "name": "Challis Airport",
      "city": "Challis",
      "cityCode": "CHL",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 44.5,
      "longitude": -114.25,
      "elevationFeet": 5072,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHL?codeType=fs"
     },
     {
      "fs": "CHP",
      "iata": "CHP",
      "icao": "",
      "faa": "CHP",
      "name": "Circle Hot Springs Airport",
      "city": "Circle Hot Springs",
      "cityCode": "CHP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 65.466667,
      "longitude": -144.583333,
      "elevationFeet": 956,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHP?codeType=fs"
     },
     {
      "fs": "CHZ",
      "iata": "CHZ",
      "icao": "",
      "faa": "2S7",
      "name": "Chiloquin State Airport",
      "city": "Chiloquin",
      "cityCode": "CHZ",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 42.579404,
      "longitude": -121.879001,
      "elevationFeet": 4207,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CHZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CHZ?codeType=fs"
     },
     {
      "fs": "CIB",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Ap In The Sky Airport",
      "city": "Catalina Island",
      "cityCode": "AVX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 33.406111,
      "longitude": -118.413889,
      "elevationFeet": 1577,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIB?codeType=fs"
     },
     {
      "fs": "CIG",
      "iata": "CIG",
      "icao": "KCAG",
      "faa": "CAG",
      "name": "Craig-Moffat Airport",
      "city": "Craig",
      "cityCode": "CIG",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 40.495556,
      "longitude": -107.525,
      "elevationFeet": 6193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIG?codeType=fs"
     },
     {
      "fs": "CIL",
      "iata": "CIL",
      "icao": "",
      "faa": "",
      "name": "Melsing Creek Airport",
      "city": "Council",
      "cityCode": "CIL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 64.908333,
      "longitude": -163.733333,
      "elevationFeet": 85,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIL?codeType=fs"
     },
     {
      "fs": "CIN",
      "iata": "CIN",
      "icao": "KCIN",
      "faa": "CIN",
      "name": "Carroll Airport",
      "city": "Carroll",
      "cityCode": "CIN",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.066667,
      "longitude": -94.866667,
      "elevationFeet": 1204,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIN?codeType=fs"
     },
     {
      "fs": "CIV",
      "iata": "CIV",
      "icao": "",
      "faa": "",
      "name": "Chomley Airport",
      "city": "Chomley",
      "cityCode": "CIV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 55.216667,
      "longitude": -132.216667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CIV?codeType=fs"
     },
     {
      "fs": "CKA",
      "iata": "CKA",
      "icao": "KCKA",
      "faa": "CKA",
      "name": "Kegelman Air Field",
      "city": "Cherokee",
      "cityCode": "CKA",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.75,
      "longitude": -98.35,
      "elevationFeet": 1202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKA?codeType=fs"
     },
     {
      "fs": "CKE",
      "iata": "CKE",
      "icao": "",
      "faa": "",
      "name": "Lampson Field",
      "city": "Lakeport",
      "cityCode": "CKE",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 38.990591,
      "longitude": -122.900723,
      "elevationFeet": 1370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKE?codeType=fs"
     },
     {
      "fs": "CKK",
      "iata": "CKK",
      "icao": "",
      "faa": "",
      "name": "Cherokee Village Airport",
      "city": "Cherokee Village",
      "cityCode": "CKK",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.5,
      "longitude": -91.866667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKK?codeType=fs"
     },
     {
      "fs": "CKM",
      "iata": "CKM",
      "icao": "KCKM",
      "faa": "CKM",
      "name": "Fletcher Field",
      "city": "Clarksdale",
      "cityCode": "CKM",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.2,
      "longitude": -90.583333,
      "elevationFeet": 173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKM?codeType=fs"
     },
     {
      "fs": "CKN",
      "iata": "CKN",
      "icao": "KCKN",
      "faa": "CKN",
      "name": "Crookston Municipal Airport",
      "city": "Crookston",
      "cityCode": "CKN",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.783333,
      "longitude": -96.616667,
      "elevationFeet": 899,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKN?codeType=fs"
     },
     {
      "fs": "CKR",
      "iata": "CKR",
      "icao": "",
      "faa": "",
      "name": "Crane Island Airport",
      "city": "Crane Island",
      "cityCode": "CKR",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 48.6,
      "longitude": -123,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKR?codeType=fs"
     },
     {
      "fs": "CKU",
      "iata": "CKU",
      "icao": "",
      "faa": "CKU",
      "name": "Cordova Municipal Airport",
      "city": "Cordova",
      "cityCode": "CDV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 60.543819,
      "longitude": -145.726976,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKU?codeType=fs"
     },
     {
      "fs": "CKV",
      "iata": "CKV",
      "icao": "KCKV",
      "faa": "CKV",
      "name": "Outlaw Field",
      "city": "Clarksville",
      "cityCode": "CKV",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.620833,
      "longitude": -87.414444,
      "elevationFeet": 550,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CKV?codeType=fs"
     },
     {
      "fs": "CLC",
      "iata": "CLC",
      "icao": "",
      "faa": "",
      "name": "Metroport Airport",
      "city": "Clear Lake City",
      "cityCode": "CLC",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 29.556944,
      "longitude": -95.1375,
      "elevationFeet": 30,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLC?codeType=fs"
     },
     {
      "fs": "CLF",
      "iata": "",
      "icao": "",
      "faa": "CLF",
      "name": "Clear Sky Lodge",
      "city": "Clear",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 64.320333,
      "longitude": -149.2125,
      "elevationFeet": 650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLF?codeType=fs"
     },
     {
      "fs": "CLG",
      "iata": "CLG",
      "icao": "",
      "faa": "",
      "name": "Coalinga Airport",
      "city": "Coalinga",
      "cityCode": "CLG",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 36.15,
      "longitude": -120.35,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLG?codeType=fs"
     },
     {
      "fs": "CLI",
      "iata": "CLI",
      "icao": "KCLI",
      "faa": "CLI",
      "name": "Clintonville Airport",
      "city": "Clintonville",
      "cityCode": "CLI",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.566667,
      "longitude": -88.866667,
      "elevationFeet": 822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLI?codeType=fs"
     },
     {
      "fs": "CLR",
      "iata": "CLR",
      "icao": "KCLR",
      "faa": "CLR",
      "name": "Cliff Hatfield Memorial Airport",
      "city": "Calipatria",
      "cityCode": "CLR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 33.1315,
      "longitude": -115.521004,
      "elevationFeet": -186,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLR?codeType=fs"
     },
     {
      "fs": "CLS",
      "iata": "CLS",
      "icao": "KCLS",
      "faa": "CLS",
      "name": "Centralia Airport",
      "city": "Chehalis",
      "cityCode": "CLS",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 46.673889,
      "longitude": -122.981111,
      "elevationFeet": 174,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLS?codeType=fs"
     },
     {
      "fs": "CLW",
      "iata": "CLW",
      "icao": "KCLW",
      "faa": "CLW",
      "name": "Clearwater Air Park",
      "city": "Tampa",
      "cityCode": "CLW",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 27.976667,
      "longitude": -82.758611,
      "elevationFeet": 71,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CLW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CLW?codeType=fs"
     },
     {
      "fs": "CMY",
      "iata": "CMY",
      "icao": "KCMY",
      "faa": "CMY",
      "name": "Fort McCoy Army Air Field",
      "city": "Sparta",
      "cityCode": "CMY",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 44.033472,
      "longitude": -90.778972,
      "elevationFeet": 837,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CMY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CMY?codeType=fs"
     },
     {
      "fs": "CNH",
      "iata": "CNH",
      "icao": "KCNH",
      "faa": "CNH",
      "name": "Claremont Municipal Airport",
      "city": "Claremont",
      "cityCode": "CNH",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.383333,
      "longitude": -72.333333,
      "elevationFeet": 545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNH?codeType=fs"
     },
     {
      "fs": "CNK",
      "iata": "CNK",
      "icao": "KCNK",
      "faa": "CNK",
      "name": "Blosser Municipal Airport",
      "city": "Concordia",
      "cityCode": "CNK",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 39.566667,
      "longitude": -97.666667,
      "elevationFeet": 1486,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNK?codeType=fs"
     },
     {
      "fs": "CNU",
      "iata": "CNU",
      "icao": "KCNU",
      "faa": "CNU",
      "name": "Martin Johnson Airport",
      "city": "Chanute",
      "cityCode": "CNU",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 37.683333,
      "longitude": -95.45,
      "elevationFeet": 1002,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CNU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CNU?codeType=fs"
     },
     {
      "fs": "COA",
      "iata": "COA",
      "icao": "",
      "faa": "O22",
      "name": "Columbia Airport",
      "city": "Columbia",
      "cityCode": "COA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 38.028889,
      "longitude": -120.412778,
      "elevationFeet": 2118,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COA?codeType=fs"
     },
     {
      "fs": "COI",
      "iata": "COI",
      "icao": "KCOI",
      "faa": "COI",
      "name": "Merritt Island Airport",
      "city": "Cocoa",
      "cityCode": "COI",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 28.342023,
      "longitude": -80.68677,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COI?codeType=fs"
     },
     {
      "fs": "COM",
      "iata": "COM",
      "icao": "KCOM",
      "faa": "COM",
      "name": "Coleman Airport",
      "city": "Coleman",
      "cityCode": "COM",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.833333,
      "longitude": -99.433333,
      "elevationFeet": 1697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COM?codeType=fs"
     },
     {
      "fs": "COP",
      "iata": "COP",
      "icao": "",
      "faa": "",
      "name": "Cooperstown Airport",
      "city": "Cooperstown",
      "cityCode": "COP",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.7,
      "longitude": -74.933333,
      "elevationFeet": 1260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COP?codeType=fs"
     },
     {
      "fs": "COT",
      "iata": "COT",
      "icao": "KCOT",
      "faa": "COT",
      "name": "Cotulla Airport",
      "city": "Cotulla",
      "cityCode": "COT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 28.433333,
      "longitude": -99.233333,
      "elevationFeet": 476,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/COT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/COT?codeType=fs"
     },
     {
      "fs": "CPM",
      "iata": "CPM",
      "icao": "KCPM",
      "faa": "CPM",
      "name": "Compton Airport",
      "city": "Compton",
      "cityCode": "CPM",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 33.894444,
      "longitude": -118.247778,
      "elevationFeet": 97,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CPM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CPM?codeType=fs"
     },
     {
      "fs": "CRO",
      "iata": "CRO",
      "icao": "KCRO",
      "faa": "CRO",
      "name": "Corcoran Airport",
      "city": "Corcoran",
      "cityCode": "CRO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 36.1,
      "longitude": -119.55,
      "elevationFeet": 197,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRO?codeType=fs"
     },
     {
      "fs": "CRS",
      "iata": "CRS",
      "icao": "KCRS",
      "faa": "CRS",
      "name": "C. David Campbell Field",
      "city": "Corsicana",
      "cityCode": "CRS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.028086,
      "longitude": -96.400582,
      "elevationFeet": 444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRS?codeType=fs"
     },
     {
      "fs": "CRT",
      "iata": "CRT",
      "icao": "KCRT",
      "faa": "CRT",
      "name": "Z.M. Jack Stell Field",
      "city": "Crossett",
      "cityCode": "CRT",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.178296,
      "longitude": -91.880205,
      "elevationFeet": 166,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CRT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CRT?codeType=fs"
     },
     {
      "fs": "CSE",
      "iata": "CSE",
      "icao": "",
      "faa": "",
      "name": "Crested Butte Airport",
      "city": "Crested Butte",
      "cityCode": "CSE",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 38.866667,
      "longitude": -106.983333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSE?codeType=fs"
     },
     {
      "fs": "CSM",
      "iata": "CSM",
      "icao": "KCSM",
      "faa": "CSM",
      "name": "Sherman Airport",
      "city": "Clinton",
      "cityCode": "CSM",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.539167,
      "longitude": -96.933333,
      "elevationFeet": 1922,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSM?codeType=fs"
     },
     {
      "fs": "CSN",
      "iata": "CSN",
      "icao": "KCXP",
      "faa": "CXP",
      "name": "Carson City Airport",
      "city": "Carson City",
      "cityCode": "CSN",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 39.191667,
      "longitude": -119.734722,
      "elevationFeet": 4697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSN?codeType=fs"
     },
     {
      "fs": "CSP",
      "iata": "CSP",
      "icao": "",
      "faa": "",
      "name": "Cape Spencer Coast Guard Heliport",
      "city": "Cape Spencer",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 58.199253,
      "longitude": -136.639934,
      "elevationFeet": 36,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSP?codeType=fs"
     },
     {
      "fs": "CSQ",
      "iata": "CSQ",
      "icao": "KCSQ",
      "faa": "CSQ",
      "name": "Creston Municipal Airport",
      "city": "Creston",
      "cityCode": "CSQ",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.066667,
      "longitude": -94.366667,
      "elevationFeet": 1294,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSQ?codeType=fs"
     },
     {
      "fs": "CSR0",
      "iata": "",
      "icao": "",
      "faa": "CSR",
      "name": "Campbell Airport",
      "city": "Anchorage",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.160058,
      "longitude": -149.781178,
      "elevationFeet": 271,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CSR0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CSR0?codeType=fs"
     },
     {
      "fs": "CTK",
      "iata": "CTK",
      "icao": "",
      "faa": "7G9",
      "name": "Canton Airport",
      "city": "Canton",
      "cityCode": "CTK",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.3,
      "longitude": -96.583333,
      "elevationFeet": 684,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTK?codeType=fs"
     },
     {
      "fs": "CTO",
      "iata": "CTO",
      "icao": "",
      "faa": "",
      "name": "Peconic River Airport",
      "city": "Calverton",
      "cityCode": "CTO",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.633333,
      "longitude": -77.683333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTO?codeType=fs"
     },
     {
      "fs": "CTY",
      "iata": "CTY",
      "icao": "KCTY",
      "faa": "CTY",
      "name": "Cross City Airport",
      "city": "Cross City",
      "cityCode": "CTY",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 29.633333,
      "longitude": -83.116667,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTY?codeType=fs"
     },
     {
      "fs": "CTZ",
      "iata": "CTZ",
      "icao": "KCTZ",
      "faa": "CTZ",
      "name": "Sampson County Airport",
      "city": "Clinton",
      "cityCode": "CTZ",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 35,
      "longitude": -78.366667,
      "elevationFeet": 148,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CTZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CTZ?codeType=fs"
     },
     {
      "fs": "CUB",
      "iata": "CUB",
      "icao": "KCUB",
      "faa": "CUB",
      "name": "J. Hamilton-L.B. Owens Airport",
      "city": "Columbia",
      "cityCode": "CAE",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 33.970556,
      "longitude": -80.995278,
      "elevationFeet": 174,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CUB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CUB?codeType=fs"
     },
     {
      "fs": "CUH",
      "iata": "CUH",
      "icao": "KCUH",
      "faa": "CUH",
      "name": "Cushing Municipal Airport",
      "city": "Cushing",
      "cityCode": "CUH",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.983333,
      "longitude": -96.766667,
      "elevationFeet": 914,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CUH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CUH?codeType=fs"
     },
     {
      "fs": "CUS",
      "iata": "CUS",
      "icao": "",
      "faa": "",
      "name": "Columbus Municipal Airport",
      "city": "Columbus",
      "cityCode": "CUS",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 31.833333,
      "longitude": -107.633333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CUS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CUS?codeType=fs"
     },
     {
      "fs": "CUW",
      "iata": "CUW",
      "icao": "",
      "faa": "",
      "name": "Cube Cove Airport",
      "city": "Cube Cove",
      "cityCode": "CUW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 57.941667,
      "longitude": -134.75,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CUW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CUW?codeType=fs"
     },
     {
      "fs": "CUX",
      "iata": "CUX",
      "icao": "",
      "faa": "",
      "name": "Cuddihy Field",
      "city": "Corpus Christi",
      "cityCode": "CRP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 27.75,
      "longitude": -97.336111,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CUX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CUX?codeType=fs"
     },
     {
      "fs": "CVA",
      "iata": "CVA",
      "icao": "",
      "faa": "",
      "name": "Civic Ar Heliport",
      "city": "Pittsburgh",
      "cityCode": "PIT",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.439747,
      "longitude": -79.988941,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CVA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CVA?codeType=fs"
     },
     {
      "fs": "CWG",
      "iata": "CWG",
      "icao": "",
      "faa": "",
      "name": "Callaway Gardens Airport",
      "city": "Callaway Gardens",
      "cityCode": "CWG",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 32.840278,
      "longitude": -84.8825,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CWG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CWG?codeType=fs"
     },
     {
      "fs": "CWI",
      "iata": "CWI",
      "icao": "KCWI",
      "faa": "CWI",
      "name": "Clinton Airport",
      "city": "Clinton",
      "cityCode": "CWI",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.829444,
      "longitude": -90.331944,
      "elevationFeet": 708,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CWI?codeType=fs"
     },
     {
      "fs": "CWO",
      "iata": "CWO",
      "icao": "",
      "faa": "",
      "name": "Ft. Wolter Air Force Base",
      "city": "Mineral Wells",
      "cityCode": "MWL",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.8,
      "longitude": -98.116667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CWO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CWO?codeType=fs"
     },
     {
      "fs": "CWS",
      "iata": "CWS",
      "icao": "",
      "faa": "",
      "name": "Center Island Airport",
      "city": "Center Island",
      "cityCode": "CWS",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 47.485,
      "longitude": -122.831389,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CWS?codeType=fs"
     },
     {
      "fs": "CXC",
      "iata": "CXC",
      "icao": "",
      "faa": "CXC",
      "name": "Chitina Airport",
      "city": "Chitina",
      "cityCode": "CXC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.583333,
      "longitude": -144.427778,
      "elevationFeet": 556,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CXC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CXC?codeType=fs"
     },
     {
      "fs": "CYM",
      "iata": "CYM",
      "icao": "",
      "faa": "",
      "name": "Chatham Sea Plane Base",
      "city": "Chatham",
      "cityCode": "CYM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 57.515115,
      "longitude": -134.944698,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CYM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CYM?codeType=fs"
     },
     {
      "fs": "CYT",
      "iata": "CYT",
      "icao": "PACY",
      "faa": "PACY",
      "name": "Yakataga Intermediate Airport",
      "city": "Yakataga",
      "cityCode": "CYT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 60.08,
      "longitude": -142.494444,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CYT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CYT?codeType=fs"
     },
     {
      "fs": "CZC",
      "iata": "CZC",
      "icao": "",
      "faa": "Z93",
      "name": "Copper Centre Airport",
      "city": "Copper Centre",
      "cityCode": "CZC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.966667,
      "longitude": -145.3,
      "elevationFeet": 1150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZC?codeType=fs"
     },
     {
      "fs": "CZF",
      "iata": "CZF",
      "icao": "PACZ",
      "faa": "PACZ",
      "name": "Cape Romanzof Airport",
      "city": "Cape Romanzof",
      "cityCode": "CZF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 61.781111,
      "longitude": -166.036389,
      "elevationFeet": 457,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZF?codeType=fs"
     },
     {
      "fs": "CZK",
      "iata": "CZK",
      "icao": "KCZK",
      "faa": "CZK",
      "name": "Cascade Locks State Airport",
      "city": "Cascade Locks",
      "cityCode": "CZK",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 45.676873,
      "longitude": -121.879011,
      "elevationFeet": 153,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZK?codeType=fs"
     },
     {
      "fs": "CZN",
      "iata": "CZN",
      "icao": "",
      "faa": "CZN",
      "name": "Chisana Field",
      "city": "Chisana",
      "cityCode": "CZN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ141",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 62.070833,
      "longitude": -142.05,
      "elevationFeet": 3318,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZN?codeType=fs"
     },
     {
      "fs": "CZO",
      "iata": "CZO",
      "icao": "",
      "faa": "CZO",
      "name": "Chistochina Airport",
      "city": "Chistochina",
      "cityCode": "CZO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 62.566667,
      "longitude": -144.666667,
      "elevationFeet": 1850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZO?codeType=fs"
     },
     {
      "fs": "CZP",
      "iata": "CZP",
      "icao": "",
      "faa": "",
      "name": "Cape Pole Sea Plane Base",
      "city": "Cape Pole",
      "cityCode": "CZP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 55.966218,
      "longitude": -133.796757,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZP?codeType=fs"
     },
     {
      "fs": "CZT",
      "iata": "CZT",
      "icao": "KCZT",
      "faa": "CZT",
      "name": "Carrizo Springs Airport",
      "city": "Carrizo Springs",
      "cityCode": "CZT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 28.516667,
      "longitude": -99.866667,
      "elevationFeet": 599,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZT?codeType=fs"
     },
     {
      "fs": "CZZ",
      "iata": "CZZ",
      "icao": "",
      "faa": "",
      "name": "Campo Airport",
      "city": "Campo",
      "cityCode": "CZZ",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 37.1,
      "longitude": -102.583333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/CZZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/CZZ?codeType=fs"
     },
     {
      "fs": "D00",
      "iata": "",
      "icao": "",
      "faa": "D00",
      "name": "Norman Co Ada/Twin Valley",
      "city": "Ada/Twin Valley",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.354667,
      "longitude": -96.402639,
      "elevationFeet": 954,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D00?codeType=fs"
     },
     {
      "fs": "D02",
      "iata": "",
      "icao": "",
      "faa": "D02",
      "name": "Osage Municipal",
      "city": "Osage",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.374722,
      "longitude": -92.910278,
      "elevationFeet": 1168,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D02?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D02?codeType=fs"
     },
     {
      "fs": "D05",
      "iata": "",
      "icao": "",
      "faa": "D05",
      "name": "Garrison Municipal",
      "city": "Garrison",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.709444,
      "longitude": -101.472222,
      "elevationFeet": 1935,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D05?codeType=fs"
     },
     {
      "fs": "D06",
      "iata": "",
      "icao": "",
      "faa": "D06",
      "name": "Minto Municipal",
      "city": "Minto",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.433222,
      "longitude": -97.470222,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D06?codeType=fs"
     },
     {
      "fs": "D07",
      "iata": "",
      "icao": "",
      "faa": "D07",
      "name": "Faith Municipal",
      "city": "Faith",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 45.060944,
      "longitude": -102.048806,
      "elevationFeet": 2582,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D07?codeType=fs"
     },
     {
      "fs": "D09",
      "iata": "",
      "icao": "",
      "faa": "D09",
      "name": "Bottineau Municipal",
      "city": "Bottineau",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.953917,
      "longitude": -100.421361,
      "elevationFeet": 1679,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D09?codeType=fs"
     },
     {
      "fs": "D11",
      "iata": "",
      "icao": "",
      "faa": "D11",
      "name": "Ojibwa",
      "city": "Weidman",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.750278,
      "longitude": -85.028056,
      "elevationFeet": 950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D11?codeType=fs"
     },
     {
      "fs": "D14",
      "iata": "",
      "icao": "",
      "faa": "D14",
      "name": "Fertile Municipal",
      "city": "Fertile",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.674667,
      "longitude": -96.325556,
      "elevationFeet": 1136,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D14?codeType=fs"
     },
     {
      "fs": "D15",
      "iata": "",
      "icao": "",
      "faa": "D15",
      "name": "Lake Isabella",
      "city": "Village Of Lake Isabella",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.744722,
      "longitude": -85.119694,
      "elevationFeet": 886,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D15?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D15?codeType=fs"
     },
     {
      "fs": "D17",
      "iata": "",
      "icao": "",
      "faa": "D17",
      "name": "Hawkins",
      "city": "Delta",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 38.824833,
      "longitude": -108.2785,
      "elevationFeet": 5000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D17?codeType=fs"
     },
     {
      "fs": "D19",
      "iata": "",
      "icao": "",
      "faa": "D19",
      "name": "Aanenson",
      "city": "Luverne",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.658028,
      "longitude": -96.236417,
      "elevationFeet": 1431,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D19?codeType=fs"
     },
     {
      "fs": "D20",
      "iata": "",
      "icao": "",
      "faa": "D20",
      "name": "Yale",
      "city": "Yale",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.22525,
      "longitude": -82.824306,
      "elevationFeet": 814,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D20?codeType=fs"
     },
     {
      "fs": "D22",
      "iata": "",
      "icao": "",
      "faa": "D22",
      "name": "Angola Airport",
      "city": "Angola",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.656156,
      "longitude": -78.988893,
      "elevationFeet": 712,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D22?codeType=fs"
     },
     {
      "fs": "D24",
      "iata": "",
      "icao": "",
      "faa": "D24",
      "name": "Fessenden Municipal",
      "city": "Fessenden",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.74725,
      "longitude": -99.759556,
      "elevationFeet": 1619,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D24?codeType=fs"
     },
     {
      "fs": "D25",
      "iata": "",
      "icao": "",
      "faa": "D25",
      "name": "Manitowish Waters",
      "city": "Manitowish Waters",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 46.169722,
      "longitude": -90.023333,
      "elevationFeet": 1610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D25?codeType=fs"
     },
     {
      "fs": "D29",
      "iata": "",
      "icao": "",
      "faa": "D29",
      "name": "Drayton Municipal",
      "city": "Drayton",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.635972,
      "longitude": -97.259028,
      "elevationFeet": 798,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D29?codeType=fs"
     },
     {
      "fs": "D31",
      "iata": "",
      "icao": "",
      "faa": "D31",
      "name": "Leeds Municipal",
      "city": "Leeds",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.3,
      "longitude": -99.434694,
      "elevationFeet": 1508,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D31?codeType=fs"
     },
     {
      "fs": "D32",
      "iata": "",
      "icao": "",
      "faa": "D32",
      "name": "Starbuck Municipal",
      "city": "Starbuck",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 45.749611,
      "longitude": -95.5365,
      "elevationFeet": 1141,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D32?codeType=fs"
     },
     {
      "fs": "D37",
      "iata": "",
      "icao": "",
      "faa": "D37",
      "name": "Warren Municipal",
      "city": "Warren",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.261111,
      "longitude": -96.811389,
      "elevationFeet": 886,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D37?codeType=fs"
     },
     {
      "fs": "D38",
      "iata": "",
      "icao": "",
      "faa": "D38",
      "name": "Canandaigua",
      "city": "Canandaigua",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.971861,
      "longitude": -77.366278,
      "elevationFeet": 814,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D38?codeType=fs"
     },
     {
      "fs": "D39",
      "iata": "",
      "icao": "",
      "faa": "D39",
      "name": "Sauk Centre Municipal",
      "city": "Sauk Centre",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 45.765611,
      "longitude": -94.933972,
      "elevationFeet": 1244,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D39?codeType=fs"
     },
     {
      "fs": "D41",
      "iata": "",
      "icao": "",
      "faa": "D41",
      "name": "Stephen Municipal",
      "city": "Stephen",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.533111,
      "longitude": -96.978389,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D41?codeType=fs"
     },
     {
      "fs": "D42",
      "iata": "",
      "icao": "",
      "faa": "D42",
      "name": "Springfield Municipal",
      "city": "Springfield",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 44.360694,
      "longitude": -95.139333,
      "elevationFeet": 1072,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D42?codeType=fs"
     },
     {
      "fs": "D43",
      "iata": "",
      "icao": "",
      "faa": "D43",
      "name": "Hopewell",
      "city": "Canandaigua",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.945083,
      "longitude": -77.327778,
      "elevationFeet": 730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D43?codeType=fs"
     },
     {
      "fs": "D46",
      "iata": "",
      "icao": "",
      "faa": "D46",
      "name": "Potoczak",
      "city": "Clarence Center",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.161694,
      "longitude": -78.764194,
      "elevationFeet": 582,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D46?codeType=fs"
     },
     {
      "fs": "D48",
      "iata": "",
      "icao": "",
      "faa": "D48",
      "name": "Dundee Flying Club",
      "city": "Dundee",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.642389,
      "longitude": -77.071861,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D48?codeType=fs"
     },
     {
      "fs": "D49",
      "iata": "",
      "icao": "",
      "faa": "D49",
      "name": "Columbus Municipal",
      "city": "Columbus",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 49.036444,
      "longitude": -102.871194,
      "elevationFeet": 1930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D49?codeType=fs"
     },
     {
      "fs": "D50",
      "iata": "",
      "icao": "",
      "faa": "D50",
      "name": "Crosby Municipal",
      "city": "Crosby",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 49.035167,
      "longitude": -103.422528,
      "elevationFeet": 1950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D50?codeType=fs"
     },
     {
      "fs": "D51",
      "iata": "",
      "icao": "",
      "faa": "D51",
      "name": "Clarence",
      "city": "Buffalo",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.06725,
      "longitude": -78.830861,
      "elevationFeet": 589,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D51?codeType=fs"
     },
     {
      "fs": "D52",
      "iata": "",
      "icao": "",
      "faa": "D52",
      "name": "Geneseo",
      "city": "Geneseo",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.93675,
      "longitude": -77.925028,
      "elevationFeet": 560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D52?codeType=fs"
     },
     {
      "fs": "D54",
      "iata": "",
      "icao": "",
      "faa": "D54",
      "name": "West Fargo Utility",
      "city": "Fargo",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 46.908,
      "longitude": -96.936944,
      "elevationFeet": 896,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D54?codeType=fs"
     },
     {
      "fs": "D55",
      "iata": "",
      "icao": "",
      "faa": "D55",
      "name": "Robertson",
      "city": "Langdon",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.780167,
      "longitude": -98.483361,
      "elevationFeet": 1608,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D55?codeType=fs"
     },
     {
      "fs": "D56",
      "iata": "",
      "icao": "",
      "faa": "D56",
      "name": "Mayville Municipal",
      "city": "Mayville",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.549861,
      "longitude": -97.337028,
      "elevationFeet": 975,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D56?codeType=fs"
     },
     {
      "fs": "D57",
      "iata": "",
      "icao": "",
      "faa": "D57",
      "name": "Glen Ullin Municipal",
      "city": "Glen Ullin",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 46.927833,
      "longitude": -101.951556,
      "elevationFeet": 2089,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D57?codeType=fs"
     },
     {
      "fs": "D58",
      "iata": "",
      "icao": "",
      "faa": "D58",
      "name": "Timber Lake Municipal",
      "city": "Timber Lake",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 45.549889,
      "longitude": -101.232,
      "elevationFeet": 2193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D58?codeType=fs"
     },
     {
      "fs": "D59",
      "iata": "",
      "icao": "",
      "faa": "D59",
      "name": "Gowanda",
      "city": "Gowanda",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.5395,
      "longitude": -78.955889,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D59?codeType=fs"
     },
     {
      "fs": "D61",
      "iata": "",
      "icao": "",
      "faa": "D61",
      "name": "Towner Municipal",
      "city": "Towner",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 48.433333,
      "longitude": -100.470778,
      "elevationFeet": 1484,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D61?codeType=fs"
     },
     {
      "fs": "D64",
      "iata": "",
      "icao": "",
      "faa": "D64",
      "name": "Westhope Municipal",
      "city": "Westhope",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 49.033528,
      "longitude": -101.034889,
      "elevationFeet": 1494,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D64?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D64?codeType=fs"
     },
     {
      "fs": "D65",
      "iata": "",
      "icao": "",
      "faa": "D65",
      "name": "Corsica Municipal",
      "city": "Corsica",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.444333,
      "longitude": -98.525806,
      "elevationFeet": 1579,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D65?codeType=fs"
     },
     {
      "fs": "D67",
      "iata": "",
      "icao": "",
      "faa": "D67",
      "name": "Creekside",
      "city": "Holcomb",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.06175,
      "longitude": -77.499889,
      "elevationFeet": 820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D67?codeType=fs"
     },
     {
      "fs": "D70",
      "iata": "",
      "icao": "",
      "faa": "D70",
      "name": "Honeoye Falls",
      "city": "Honeoye Falls",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.072861,
      "longitude": -77.747194,
      "elevationFeet": 683,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D70?codeType=fs"
     },
     {
      "fs": "D73",
      "iata": "",
      "icao": "",
      "faa": "D73",
      "name": "Monroe-Walton Co",
      "city": "Monroe",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 33.915,
      "longitude": -83.785528,
      "elevationFeet": 867,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D73?codeType=fs"
     },
     {
      "fs": "D74",
      "iata": "",
      "icao": "",
      "faa": "D74",
      "name": "Chorman",
      "city": "Farmington",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.984472,
      "longitude": -75.724278,
      "elevationFeet": 66,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D74?codeType=fs"
     },
     {
      "fs": "D77",
      "iata": "",
      "icao": "",
      "faa": "BQR",
      "name": "Buffalo-Lancaster Regional Airport",
      "city": "Lancaster",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.925068,
      "longitude": -78.600662,
      "elevationFeet": 753,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D77?codeType=fs"
     },
     {
      "fs": "D79",
      "iata": "",
      "icao": "",
      "faa": "D79",
      "name": "Dart",
      "city": "Mayville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.281139,
      "longitude": -79.617139,
      "elevationFeet": 1330,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D79?codeType=fs"
     },
     {
      "fs": "D80",
      "iata": "",
      "icao": "",
      "faa": "D80",
      "name": "Olcott-Newfane",
      "city": "Olcott",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.358889,
      "longitude": -78.83925,
      "elevationFeet": 315,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D80?codeType=fs"
     },
     {
      "fs": "D81",
      "iata": "",
      "icao": "",
      "faa": "D81",
      "name": "Red Lake Falls Municipal",
      "city": "Red Lake Falls",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 47.899667,
      "longitude": -96.32825,
      "elevationFeet": 1061,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D81?codeType=fs"
     },
     {
      "fs": "D82",
      "iata": "",
      "icao": "",
      "faa": "D82",
      "name": "Ovid",
      "city": "Ovid",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.697917,
      "longitude": -76.913417,
      "elevationFeet": 1062,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D82?codeType=fs"
     },
     {
      "fs": "D85",
      "iata": "",
      "icao": "",
      "faa": "D85",
      "name": "Randolph",
      "city": "Randolph",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.192278,
      "longitude": -79.164306,
      "elevationFeet": 1665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D85?codeType=fs"
     },
     {
      "fs": "D87",
      "iata": "",
      "icao": "",
      "faa": "D87",
      "name": "Harbor Springs",
      "city": "Harbor Springs",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 45.505667,
      "longitude": -85.033833,
      "elevationFeet": 686,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D87?codeType=fs"
     },
     {
      "fs": "D88",
      "iata": "",
      "icao": "",
      "faa": "D88",
      "name": "Pratt'S Eastern Divide",
      "city": "Sherman",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.150556,
      "longitude": -79.708806,
      "elevationFeet": 1640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D88?codeType=fs"
     },
     {
      "fs": "D90",
      "iata": "",
      "icao": "",
      "faa": "D90",
      "name": "Mancelona Municipal",
      "city": "Mancelona",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 45.000056,
      "longitude": -85.067194,
      "elevationFeet": 1133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D90?codeType=fs"
     },
     {
      "fs": "D91",
      "iata": "",
      "icao": "",
      "faa": "D91",
      "name": "Spencerport",
      "city": "Spencerport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.195056,
      "longitude": -77.833417,
      "elevationFeet": 614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D91?codeType=fs"
     },
     {
      "fs": "D93",
      "iata": "",
      "icao": "",
      "faa": "D93",
      "name": "Airtrek",
      "city": "Waterloo",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.850667,
      "longitude": -76.996806,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D93?codeType=fs"
     },
     {
      "fs": "D95",
      "iata": "",
      "icao": "",
      "faa": "D95",
      "name": "Dupont-Lapeer",
      "city": "Lapeer",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 43.070333,
      "longitude": -83.324444,
      "elevationFeet": 844,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/D95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/D95?codeType=fs"
     },
     {
      "fs": "DAA",
      "iata": "DAA",
      "icao": "KDAA",
      "faa": "DAA",
      "name": "Davison Army Air Field",
      "city": "Fort Belvoir",
      "cityCode": "DAA",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.715,
      "longitude": -77.181,
      "elevationFeet": 73,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DAA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DAA?codeType=fs"
     },
     {
      "fs": "DAG",
      "iata": "DAG",
      "icao": "KDAG",
      "faa": "DAG",
      "name": "Barstow-Daggett Airport",
      "city": "Daggett",
      "cityCode": "DAG",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 34.853699,
      "longitude": -116.787003,
      "elevationFeet": 1930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DAG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DAG?codeType=fs"
     },
     {
      "fs": "DBN",
      "iata": "DBN",
      "icao": "KDBN",
      "faa": "DBN",
      "name": "Dublin Municipal Airport",
      "city": "Dublin",
      "cityCode": "DBN",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 32.561944,
      "longitude": -82.986111,
      "elevationFeet": 310,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DBN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DBN?codeType=fs"
     },
     {
      "fs": "DBS",
      "iata": "DBS",
      "icao": "",
      "faa": "U41",
      "name": "Dubois Airport",
      "city": "Dubois",
      "cityCode": "DBS",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 44.166667,
      "longitude": -112.233333,
      "elevationFeet": 5123,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DBS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DBS?codeType=fs"
     },
     {
      "fs": "DCK",
      "iata": "DCK",
      "icao": "",
      "faa": "DCK",
      "name": "Dahl Creek Airport",
      "city": "Dahl Creek",
      "cityCode": "DCK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 66.95,
      "longitude": -156.9,
      "elevationFeet": 260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DCK?codeType=fs"
     },
     {
      "fs": "DCR",
      "iata": "DCR",
      "icao": "KDCR",
      "faa": "DCR",
      "name": "Decatur Hi-Way Airport",
      "city": "Decatur",
      "cityCode": "DCR",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.833333,
      "longitude": -84.933333,
      "elevationFeet": 842,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DCR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DCR?codeType=fs"
     },
     {
      "fs": "DCU",
      "iata": "DCU",
      "icao": "KDCU",
      "faa": "DCU",
      "name": "Pyor Airport",
      "city": "Decatur",
      "cityCode": "DCU",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.6,
      "longitude": -86.983333,
      "elevationFeet": 592,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DCU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DCU?codeType=fs"
     },
     {
      "fs": "DEH",
      "iata": "DEH",
      "icao": "KDEH",
      "faa": "DEH",
      "name": "Decorah Municipal Airport",
      "city": "Decorah",
      "cityCode": "DEH",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 43.3,
      "longitude": -91.8,
      "elevationFeet": 1157,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DEH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DEH?codeType=fs"
     },
     {
      "fs": "DEO",
      "iata": "DEO",
      "icao": "",
      "faa": "",
      "name": "Hyatt Regency Heliport",
      "city": "Dearborn",
      "cityCode": "DEO",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.3,
      "longitude": -83.166667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DEO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DEO?codeType=fs"
     },
     {
      "fs": "DFI",
      "iata": "DFI",
      "icao": "KDFI",
      "faa": "DFI",
      "name": "Defiance Memorial Airport",
      "city": "Defiance",
      "cityCode": "DFI",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41.283333,
      "longitude": -84.366667,
      "elevationFeet": 707,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DFI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DFI?codeType=fs"
     },
     {
      "fs": "DGB",
      "iata": "DGB",
      "icao": "",
      "faa": "",
      "name": "Danger Bay Airport",
      "city": "Danger Bay",
      "cityCode": "DGB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 58.083333,
      "longitude": -152.75,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DGB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DGB?codeType=fs"
     },
     {
      "fs": "DGL",
      "iata": "DGL",
      "icao": "KDGL",
      "faa": "DGL",
      "name": "Douglas Municipal Airport",
      "city": "Douglas",
      "cityCode": "DUG",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 31.35,
      "longitude": -109.566667,
      "elevationFeet": 4173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DGL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DGL?codeType=fs"
     },
     {
      "fs": "DGN",
      "iata": "DGN",
      "icao": "KNDY",
      "faa": "NDY",
      "name": "Naval Air Field",
      "city": "Dahlgren",
      "cityCode": "DGN",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 38.2,
      "longitude": -88.683333,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DGN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DGN?codeType=fs"
     },
     {
      "fs": "DGW",
      "iata": "DGW",
      "icao": "KDGW",
      "faa": "DGW",
      "name": "Converse County Airport",
      "city": "Douglas",
      "cityCode": "DGW",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 42.75,
      "longitude": -105.4,
      "elevationFeet": 4929,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DGW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DGW?codeType=fs"
     },
     {
      "fs": "DHT",
      "iata": "DHT",
      "icao": "KDHT",
      "faa": "DHT",
      "name": "Dalhart Airport",
      "city": "Dalhart",
      "cityCode": "DHT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.066667,
      "longitude": -102.516667,
      "elevationFeet": 3991,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DHT?codeType=fs"
     },
     {
      "fs": "DKK",
      "iata": "DKK",
      "icao": "KDKK",
      "faa": "DKK",
      "name": "Dunkirk Airport",
      "city": "Dunkirk",
      "cityCode": "DKK",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.483333,
      "longitude": -79.333333,
      "elevationFeet": 693,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DKK?codeType=fs"
     },
     {
      "fs": "DLL",
      "iata": "DLL",
      "icao": "KDLC",
      "faa": "DLC",
      "name": "Dillon Airport",
      "city": "Dillon",
      "cityCode": "DLL",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 34.416667,
      "longitude": -79.366667,
      "elevationFeet": 976,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLL?codeType=fs"
     },
     {
      "fs": "DLO",
      "iata": "DLO",
      "icao": "",
      "faa": "",
      "name": "Dolomi Airport",
      "city": "Dolomi",
      "cityCode": "DLO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 55.122222,
      "longitude": -132.05,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLO?codeType=fs"
     },
     {
      "fs": "DLS",
      "iata": "DLS",
      "icao": "KDLS",
      "faa": "DLS",
      "name": "The Dalles Airport",
      "city": "The Dalles",
      "cityCode": "DLS",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 45.6,
      "longitude": -121.166667,
      "elevationFeet": 247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DLS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DLS?codeType=fs"
     },
     {
      "fs": "DMN",
      "iata": "DMN",
      "icao": "KDMN",
      "faa": "DMN",
      "name": "Deming Airport",
      "city": "Deming",
      "cityCode": "DMN",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.266667,
      "longitude": -107.75,
      "elevationFeet": 4314,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DMN?codeType=fs"
     },
     {
      "fs": "DMO",
      "iata": "DMO",
      "icao": "KDMO",
      "faa": "DMO",
      "name": "Sedalia Airport",
      "city": "Sedalia",
      "cityCode": "DMO",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 38.704167,
      "longitude": -93.180556,
      "elevationFeet": 909,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DMO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DMO?codeType=fs"
     },
     {
      "fs": "DNE",
      "iata": "DNE",
      "icao": "",
      "faa": "",
      "name": "Dallas North Airport",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.75,
      "longitude": -97.383333,
      "elevationFeet": 685,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DNE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DNE?codeType=fs"
     },
     {
      "fs": "DNN",
      "iata": "DNN",
      "icao": "KDNN",
      "faa": "DNN",
      "name": "Dalton Municipal Airport",
      "city": "Dalton",
      "cityCode": "DNN",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 34.766667,
      "longitude": -84.966667,
      "elevationFeet": 710,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DNN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DNN?codeType=fs"
     },
     {
      "fs": "DNS",
      "iata": "DNS",
      "icao": "KDNS",
      "faa": "DNS",
      "name": "Denison Municipal Airport",
      "city": "Denison",
      "cityCode": "DNS",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 42.016667,
      "longitude": -95.35,
      "elevationFeet": 1276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DNS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DNS?codeType=fs"
     },
     {
      "fs": "DNT",
      "iata": "DNT",
      "icao": "",
      "faa": "",
      "name": "Santa Ana Downtown Heliport",
      "city": "Santa Ana",
      "cityCode": "SNA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 33.753853,
      "longitude": -117.868003,
      "elevationFeet": 132,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DNT?codeType=fs"
     },
     {
      "fs": "DOF",
      "iata": "DOF",
      "icao": "",
      "faa": "",
      "name": "Dora Bay Airport",
      "city": "Dora Bay",
      "cityCode": "DOF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 55.2125,
      "longitude": -132.266667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DOF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DOF?codeType=fs"
     },
     {
      "fs": "DPG",
      "iata": "DPG",
      "icao": "KDPG",
      "faa": "DPG",
      "name": "Michael Army Air Field",
      "city": "Dugway",
      "cityCode": "DPG",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 40.233333,
      "longitude": -112.75,
      "elevationFeet": 4348,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DPG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DPG?codeType=fs"
     },
     {
      "fs": "DPK",
      "iata": "DPK",
      "icao": "",
      "faa": "",
      "name": "Deer Park Airport",
      "city": "Deer Park",
      "cityCode": "DPK",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 41,
      "longitude": -73.533333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DPK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DPK?codeType=fs"
     },
     {
      "fs": "DRA",
      "iata": "DRA",
      "icao": "",
      "faa": "",
      "name": "Desert Rock Airport",
      "city": "Mercury",
      "cityCode": "DRA",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 36.666667,
      "longitude": -115.966667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRA?codeType=fs"
     },
     {
      "fs": "DRE",
      "iata": "DRE",
      "icao": "",
      "faa": "Y66",
      "name": "Drummond Island Airport",
      "city": "Drummond Island",
      "cityCode": "DRE",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 46.016667,
      "longitude": -83.75,
      "elevationFeet": 668,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRE?codeType=fs"
     },
     {
      "fs": "DRF",
      "iata": "DRF",
      "icao": "",
      "faa": "",
      "name": "Drift River Airport",
      "city": "Drift River",
      "cityCode": "DRF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.683",
      "utcOffsetHours": -9,
      "latitude": 60.583333,
      "longitude": -152.15,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRF?codeType=fs"
     },
     {
      "fs": "DRI",
      "iata": "DRI",
      "icao": "KDRI",
      "faa": "DRI",
      "name": "Beauregard Parish Airport",
      "city": "De Ridder",
      "cityCode": "DRI",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 30.85,
      "longitude": -93.283333,
      "elevationFeet": 205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRI?codeType=fs"
     },
     {
      "fs": "DRU",
      "iata": "DRU",
      "icao": "KDRU",
      "faa": "DRU",
      "name": "Drummond Airport",
      "city": "Drummond",
      "cityCode": "DRU",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 46.666667,
      "longitude": -113.15,
      "elevationFeet": 4245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DRU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DRU?codeType=fs"
     },
     {
      "fs": "DSV",
      "iata": "DSV",
      "icao": "KDSV",
      "faa": "DSV",
      "name": "Dansville Airport",
      "city": "Dansville",
      "cityCode": "DSV",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 42.566667,
      "longitude": -77.7,
      "elevationFeet": 662,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DSV?codeType=fs"
     },
     {
      "fs": "DTA",
      "iata": "DTA",
      "icao": "KDTA",
      "faa": "DTA",
      "name": "Delta Airport",
      "city": "Delta",
      "cityCode": "DTA",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 39.383333,
      "longitude": -112.5,
      "elevationFeet": 4755,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DTA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DTA?codeType=fs"
     },
     {
      "fs": "DTH",
      "iata": "DTH",
      "icao": "",
      "faa": "",
      "name": "Death Valley Airport",
      "city": "Death Valley",
      "cityCode": "DTH",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 36.5,
      "longitude": -117,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DTH?codeType=fs"
     },
     {
      "fs": "DTN",
      "iata": "DTN",
      "icao": "KDTN",
      "faa": "DTN",
      "name": "Shreveport Downtown Airport",
      "city": "Shreveport",
      "cityCode": "SHV",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.539722,
      "longitude": -93.744444,
      "elevationFeet": 179,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DTN?codeType=fs"
     },
     {
      "fs": "DTR",
      "iata": "DTR",
      "icao": "",
      "faa": "",
      "name": "Decatur Island Airport",
      "city": "Decatur Island",
      "cityCode": "DTR",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.683",
      "utcOffsetHours": -8,
      "latitude": 48.516667,
      "longitude": -122.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DTR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DTR?codeType=fs"
     },
     {
      "fs": "DUA",
      "iata": "DUA",
      "icao": "KDUA",
      "faa": "DUA",
      "name": "Durant Regional Airport - Eaker Field",
      "city": "Durant",
      "cityCode": "DUA",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.94231,
      "longitude": -96.394494,
      "elevationFeet": 682,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DUA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DUA?codeType=fs"
     },
     {
      "fs": "DUC",
      "iata": "DUC",
      "icao": "KDUC",
      "faa": "DUC",
      "name": "Halliburton Field",
      "city": "Duncan",
      "cityCode": "DUC",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 34.472222,
      "longitude": -97.959722,
      "elevationFeet": 1113,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DUC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DUC?codeType=fs"
     },
     {
      "fs": "DUF",
      "iata": "DUF",
      "icao": "",
      "faa": "",
      "name": "Pine Island Airport",
      "city": "Duck",
      "cityCode": "DUF",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 36.258333,
      "longitude": -75.788889,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DUF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DUF?codeType=fs"
     },
     {
      "fs": "DUG",
      "iata": "DUG",
      "icao": "KDUG",
      "faa": "DUG",
      "name": "Bisbee-Douglas International Airport",
      "city": "Douglas",
      "cityCode": "DUG",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 31.468611,
      "longitude": -109.603611,
      "elevationFeet": 4154,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DUG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DUG?codeType=fs"
     },
     {
      "fs": "DWF",
      "iata": "DWF",
      "icao": "",
      "faa": "",
      "name": "Wright Air Force Base",
      "city": "Dayton",
      "cityCode": "DAY",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 39.666667,
      "longitude": -84.183333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DWF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DWF?codeType=fs"
     },
     {
      "fs": "DWN",
      "iata": "DWN",
      "icao": "",
      "faa": "2DT",
      "name": "Oklahoma City Downtown Airpark",
      "city": "Oklahoma City",
      "cityCode": "OKC",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.45,
      "longitude": -97.533333,
      "elevationFeet": 1180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DWN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DWN?codeType=fs"
     },
     {
      "fs": "DWS",
      "iata": "DWS",
      "icao": "",
      "faa": "",
      "name": "Walt Disney World Airport",
      "city": "Orlando",
      "cityCode": "ORL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 28.383611,
      "longitude": -81.55,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DWS?codeType=fs"
     },
     {
      "fs": "DYL",
      "iata": "DYL",
      "icao": "KDYL",
      "faa": "DYL",
      "name": "Doylestown Airport",
      "city": "Doylestown",
      "cityCode": "DYL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 40.316667,
      "longitude": -75.133333,
      "elevationFeet": 394,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/DYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/DYL?codeType=fs"
     },
     {
      "fs": "E04",
      "iata": "",
      "icao": "",
      "faa": "E04",
      "name": "Eunice",
      "city": "Eunice",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.517917,
      "longitude": -103.304722,
      "elevationFeet": 3569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E04?codeType=fs"
     },
     {
      "fs": "E05",
      "iata": "",
      "icao": "",
      "faa": "E05",
      "name": "Hatch Municipal",
      "city": "Hatch",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.760611,
      "longitude": -107.329333,
      "elevationFeet": 4080,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E05?codeType=fs"
     },
     {
      "fs": "E06",
      "iata": "",
      "icao": "",
      "faa": "E06",
      "name": "Lea Co-Franklin Memorial",
      "city": "Lovington",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.989444,
      "longitude": -103.487778,
      "elevationFeet": 3979,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E06?codeType=fs"
     },
     {
      "fs": "E07",
      "iata": "",
      "icao": "",
      "faa": "E07",
      "name": "Lea Co",
      "city": "Tatum",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 33.362222,
      "longitude": -103.368944,
      "elevationFeet": 3986,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E07?codeType=fs"
     },
     {
      "fs": "E11",
      "iata": "",
      "icao": "",
      "faa": "E11",
      "name": "Andrews Co",
      "city": "Andrews",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 32.461111,
      "longitude": -102.645278,
      "elevationFeet": 3174,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E11?codeType=fs"
     },
     {
      "fs": "E16",
      "iata": "",
      "icao": "",
      "faa": "E16",
      "name": "Leland",
      "city": "Leland",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 41.600306,
      "longitude": -88.895222,
      "elevationFeet": 680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E16?codeType=fs"
     },
     {
      "fs": "E19",
      "iata": "",
      "icao": "",
      "faa": "E19",
      "name": "Gruver Municipal",
      "city": "Gruver",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.23725,
      "longitude": -101.571889,
      "elevationFeet": 3205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E19?codeType=fs"
     },
     {
      "fs": "E26",
      "iata": "",
      "icao": "",
      "faa": "E26",
      "name": "Lea Co",
      "city": "Jal",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.260778,
      "longitude": -103.1985,
      "elevationFeet": 3118,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E26?codeType=fs"
     },
     {
      "fs": "E29",
      "iata": "",
      "icao": "",
      "faa": "E29",
      "name": "Sonora Municipal",
      "city": "Sonora",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 30.607083,
      "longitude": -100.785667,
      "elevationFeet": 2139,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E29?codeType=fs"
     },
     {
      "fs": "E30",
      "iata": "",
      "icao": "",
      "faa": "E30",
      "name": "Bruce",
      "city": "Ballinger",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.740417,
      "longitude": -100.075278,
      "elevationFeet": 1737,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E30?codeType=fs"
     },
     {
      "fs": "E32",
      "iata": "",
      "icao": "",
      "faa": "E32",
      "name": "Lindrith",
      "city": "Lindrith",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 36.364056,
      "longitude": -107.111528,
      "elevationFeet": 7202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E32?codeType=fs"
     },
     {
      "fs": "E34",
      "iata": "",
      "icao": "",
      "faa": "E34",
      "name": "Clarendon Municipal",
      "city": "Clarendon",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.004694,
      "longitude": -100.897806,
      "elevationFeet": 2832,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E34?codeType=fs"
     },
     {
      "fs": "E35",
      "iata": "",
      "icao": "",
      "faa": "E35",
      "name": "Fabens",
      "city": "Fabens",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 31.656722,
      "longitude": -106.271972,
      "elevationFeet": 3679,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E35?codeType=fs"
     },
     {
      "fs": "E37",
      "iata": "",
      "icao": "",
      "faa": "E37",
      "name": "Flying J Ranch",
      "city": "Pima",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.978444,
      "longitude": -110.017472,
      "elevationFeet": 3100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E37?codeType=fs"
     },
     {
      "fs": "E40",
      "iata": "",
      "icao": "",
      "faa": "E40",
      "name": "Wilson'S",
      "city": "Hickory",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.683",
      "utcOffsetHours": -5,
      "latitude": 35.670778,
      "longitude": -81.428639,
      "elevationFeet": 985,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E40?codeType=fs"
     },
     {
      "fs": "E41",
      "iata": "",
      "icao": "",
      "faa": "E41",
      "name": "Reagan Co",
      "city": "Big Lake",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.324889,
      "longitude": -101.532833,
      "elevationFeet": 2704,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E41?codeType=fs"
     },
     {
      "fs": "E42",
      "iata": "",
      "icao": "",
      "faa": "E42",
      "name": "Spearman Municipal",
      "city": "Spearman",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 36.26,
      "longitude": -101.295,
      "elevationFeet": 3090,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E42?codeType=fs"
     },
     {
      "fs": "E48",
      "iata": "",
      "icao": "",
      "faa": "E48",
      "name": "Upton Co",
      "city": "Mc Camey",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 31.201472,
      "longitude": -102.304139,
      "elevationFeet": 2433,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E48?codeType=fs"
     },
     {
      "fs": "E52",
      "iata": "",
      "icao": "",
      "faa": "E52",
      "name": "Oldham Co",
      "city": "Vega",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 35.369972,
      "longitude": -102.540944,
      "elevationFeet": 3995,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E52?codeType=fs"
     },
     {
      "fs": "E54",
      "iata": "",
      "icao": "",
      "faa": "E54",
      "name": "Bowie",
      "city": "Bowie",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.359083,
      "longitude": -109.531194,
      "elevationFeet": 3737,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E54?codeType=fs"
     },
     {
      "fs": "E57",
      "iata": "",
      "icao": "",
      "faa": "E57",
      "name": "Denver City",
      "city": "Denver City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.683",
      "utcOffsetHours": -6,
      "latitude": 33.051028,
      "longitude": -102.921528,
      "elevationFeet": 3575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E57?codeType=fs"
     },
     {
      "fs": "E60",
      "iata": "",
      "icao": "",
      "faa": "E60",
      "name": "Eloy Municipal",
      "city": "Eloy",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 32.870056,
      "longitude": -111.617889,
      "elevationFeet": 1513,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E60?codeType=fs"
     },
     {
      "fs": "E63",
      "iata": "",
      "icao": "",
      "faa": "E63",
      "name": "Gila Bend Municipal",
      "city": "Gila Bend",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 33.031,
      "longitude": -112.782194,
      "elevationFeet": 778,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E63?codeType=fs"
     },
     {
      "fs": "E67",
      "iata": "",
      "icao": "",
      "faa": "E67",
      "name": "Kearny",
      "city": "Kearny",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.683",
      "utcOffsetHours": -7,
      "latitude": 33.175639,
      "longitude": -110.990167,
      "elevationFeet": 1833,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E67?codeType=fs"
     },
     {
      "fs": "E68",
      "iata": "",
      "icao": "",
      "faa": "E68",
      "name": "Estrella Sailport",
      "city": "Maricopa",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 33.103278,
      "longitude": -112.259806,
      "elevationFeet": 1273,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E68?codeType=fs"
     },
     {
      "fs": "E77",
      "iata": "",
      "icao": "",
      "faa": "E77",
      "name": "San Manuel",
      "city": "San Manuel",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 32.664583,
      "longitude": -110.773194,
      "elevationFeet": 3275,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E77?codeType=fs"
     },
     {
      "fs": "E78",
      "iata": "",
      "icao": "",
      "faa": "E78",
      "name": "Sells",
      "city": "Sells",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 32.078528,
      "longitude": -111.992889,
      "elevationFeet": 2409,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E78?codeType=fs"
     },
     {
      "fs": "E80",
      "iata": "",
      "icao": "",
      "faa": "E80",
      "name": "Alexander Municipal",
      "city": "Belen",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 34.751972,
      "longitude": -106.836944,
      "elevationFeet": 5194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E80?codeType=fs"
     },
     {
      "fs": "E81",
      "iata": "",
      "icao": "",
      "faa": "E81",
      "name": "Superior Municipal",
      "city": "Superior",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 33.378333,
      "longitude": -111.220639,
      "elevationFeet": 2646,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E81?codeType=fs"
     },
     {
      "fs": "E85",
      "iata": "",
      "icao": "",
      "faa": "E85",
      "name": "Denio Junction",
      "city": "Denio",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.684",
      "utcOffsetHours": -10,
      "latitude": 41.990639,
      "longitude": -118.760056,
      "elevationFeet": 4202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E85?codeType=fs"
     },
     {
      "fs": "E89",
      "iata": "",
      "icao": "",
      "faa": "E89",
      "name": "Conchas State Park",
      "city": "Conchas Dam",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 35.367167,
      "longitude": -104.230306,
      "elevationFeet": 4230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E89?codeType=fs"
     },
     {
      "fs": "E90",
      "iata": "",
      "icao": "",
      "faa": "E90",
      "name": "Pueblo Pintado",
      "city": "Pueblo Pintado",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 35.980722,
      "longitude": -107.767194,
      "elevationFeet": 6488,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E90?codeType=fs"
     },
     {
      "fs": "E91",
      "iata": "",
      "icao": "",
      "faa": "E91",
      "name": "Chinle Municipal",
      "city": "Chinle",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 36.208806,
      "longitude": -109.654222,
      "elevationFeet": 5547,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E91?codeType=fs"
     },
     {
      "fs": "E92",
      "iata": "",
      "icao": "",
      "faa": "E92",
      "name": "Estancia Municipal",
      "city": "Estancia",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 34.883944,
      "longitude": -106.114056,
      "elevationFeet": 6100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E92?codeType=fs"
     },
     {
      "fs": "E94",
      "iata": "",
      "icao": "",
      "faa": "E94",
      "name": "Glenwood-Catron Co",
      "city": "Glenwood",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 33.378389,
      "longitude": -108.872861,
      "elevationFeet": 5428,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E94?codeType=fs"
     },
     {
      "fs": "E95",
      "iata": "",
      "icao": "",
      "faa": "E95",
      "name": "Benson Municipal",
      "city": "Benson",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 32.147222,
      "longitude": -110.422222,
      "elevationFeet": 3829,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E95?codeType=fs"
     },
     {
      "fs": "E97",
      "iata": "",
      "icao": "",
      "faa": "E97",
      "name": "Ute Dam",
      "city": "Logan",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 35.414389,
      "longitude": -103.474583,
      "elevationFeet": 3812,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E97?codeType=fs"
     },
     {
      "fs": "E98",
      "iata": "",
      "icao": "",
      "faa": "E98",
      "name": "Mid Valley",
      "city": "Los Lunas",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 34.847778,
      "longitude": -106.853056,
      "elevationFeet": 4830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/E98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/E98?codeType=fs"
     },
     {
      "fs": "EAN",
      "iata": "EAN",
      "icao": "KEAN",
      "faa": "EAN",
      "name": "Phifer Field",
      "city": "Wheatland",
      "cityCode": "EAN",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 42.05,
      "longitude": -104.966667,
      "elevationFeet": 4775,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EAN?codeType=fs"
     },
     {
      "fs": "EBR",
      "iata": "EBR",
      "icao": "",
      "faa": "",
      "name": "Baton Rouge Downtown Airport",
      "city": "Baton Rouge",
      "cityCode": "BTR",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.45,
      "longitude": -91.183333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EBR?codeType=fs"
     },
     {
      "fs": "EBS",
      "iata": "EBS",
      "icao": "KEBS",
      "faa": "EBS",
      "name": "Webster City Municipal Airport",
      "city": "Webster City",
      "cityCode": "EBS",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.466667,
      "longitude": -93.816667,
      "elevationFeet": 1121,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EBS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EBS?codeType=fs"
     },
     {
      "fs": "ECA",
      "iata": "ECA",
      "icao": "",
      "faa": "6D9",
      "name": "Iosco County Airport",
      "city": "East Tawas",
      "cityCode": "ECA",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 44.311548,
      "longitude": -83.421867,
      "elevationFeet": 606,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ECA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ECA?codeType=fs"
     },
     {
      "fs": "ECS",
      "iata": "ECS",
      "icao": "KECS",
      "faa": "ECS",
      "name": "Mondell Field",
      "city": "Newcastle",
      "cityCode": "ECS",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 43.885385,
      "longitude": -104.318011,
      "elevationFeet": 4150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ECS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ECS?codeType=fs"
     },
     {
      "fs": "EDG",
      "iata": "EDG",
      "icao": "KEDG",
      "faa": "EDG",
      "name": "Weide Army Air Field",
      "city": "Edgewood Arsenal",
      "cityCode": "EDG",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.465667,
      "longitude": -76.360917,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDG?codeType=fs"
     },
     {
      "fs": "EDJ",
      "iata": "",
      "icao": "",
      "faa": "EDJ",
      "name": "Bellefontaine Regional Airport",
      "city": "Bellefontaine",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.372314,
      "longitude": -83.819016,
      "elevationFeet": 1345,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDJ?codeType=fs"
     },
     {
      "fs": "EDK",
      "iata": "EDK",
      "icao": "KEQA",
      "faa": "EQA",
      "name": "El Dorado Airport",
      "city": "El Dorado",
      "cityCode": "EDK",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.816667,
      "longitude": -96.866667,
      "elevationFeet": 1378,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EDK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EDK?codeType=fs"
     },
     {
      "fs": "EED",
      "iata": "EED",
      "icao": "KEED",
      "faa": "EED",
      "name": "Needles Airport",
      "city": "Needles",
      "cityCode": "EED",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.85,
      "longitude": -114.616667,
      "elevationFeet": 983,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EED?codeType=fs"
     },
     {
      "fs": "EEN",
      "iata": "EEN",
      "icao": "KEEN",
      "faa": "EEN",
      "name": "Dillant-Hopkins Airport",
      "city": "Keene",
      "cityCode": "EEN",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.900833,
      "longitude": -72.270833,
      "elevationFeet": 488,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EEN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EEN?codeType=fs"
     },
     {
      "fs": "EFB",
      "iata": "EFB",
      "icao": "",
      "faa": "",
      "name": "Eight Fathom Bight Airport",
      "city": "Eight Fathom Bight",
      "cityCode": "EFB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 58,
      "longitude": -135.733333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EFB?codeType=fs"
     },
     {
      "fs": "EFW",
      "iata": "EFW",
      "icao": "KEFW",
      "faa": "EFW",
      "name": "Jefferson Municipal Airport",
      "city": "Jefferson",
      "cityCode": "EFW",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.016667,
      "longitude": -94.383333,
      "elevationFeet": 1048,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EFW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EFW?codeType=fs"
     },
     {
      "fs": "EGI",
      "iata": "EGI",
      "icao": "KEGI",
      "faa": "EGI",
      "name": "Duke Field",
      "city": "Crestview",
      "cityCode": "VPS",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.650388,
      "longitude": -86.522905,
      "elevationFeet": 192,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EGI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EGI?codeType=fs"
     },
     {
      "fs": "EGP",
      "iata": "EGP",
      "icao": "",
      "faa": "",
      "name": "Maverick County Airport",
      "city": "Eagle Pass",
      "cityCode": "EGP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 28.702222,
      "longitude": -100.480556,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EGP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EGP?codeType=fs"
     },
     {
      "fs": "EHM",
      "iata": "EHM",
      "icao": "PAEH",
      "faa": "PAEH",
      "name": "Cape Newenham Airport",
      "city": "Cape Newenham",
      "cityCode": "EHM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 58.647222,
      "longitude": -162.060556,
      "elevationFeet": 541,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EHM?codeType=fs"
     },
     {
      "fs": "EHT",
      "iata": "EHT",
      "icao": "",
      "faa": "",
      "name": "Rentschler Airport",
      "city": "East Hartford",
      "cityCode": "EHT",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.752632,
      "longitude": -72.620662,
      "elevationFeet": 27,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EHT?codeType=fs"
     },
     {
      "fs": "EKI",
      "iata": "EKI",
      "icao": "KEKM",
      "faa": "EKM",
      "name": "Elkhart Municipal Airport",
      "city": "Elkhart",
      "cityCode": "EKI",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.722222,
      "longitude": -85.992222,
      "elevationFeet": 778,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EKI?codeType=fs"
     },
     {
      "fs": "EKX",
      "iata": "EKX",
      "icao": "KEKX",
      "faa": "EKX",
      "name": "Elizabethtown Regional Airport - Addington Field",
      "city": "Elizabethtown",
      "cityCode": "EKX",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.686001,
      "longitude": -85.925014,
      "elevationFeet": 766,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EKX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EKX?codeType=fs"
     },
     {
      "fs": "ELA",
      "iata": "ELA",
      "icao": "KELA",
      "faa": "ELA",
      "name": "Eagle Lake Airport",
      "city": "Eagle Lake",
      "cityCode": "ELA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.583333,
      "longitude": -96.333333,
      "elevationFeet": 184,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELA?codeType=fs"
     },
     {
      "fs": "ELK",
      "iata": "ELK",
      "icao": "KELK",
      "faa": "ELK",
      "name": "Elk City Regional Business Airport",
      "city": "Elk City",
      "cityCode": "ELK",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.432404,
      "longitude": -99.394289,
      "elevationFeet": 1986,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELK?codeType=fs"
     },
     {
      "fs": "ELN",
      "iata": "ELN",
      "icao": "KELN",
      "faa": "ELN",
      "name": "Bowers Field",
      "city": "Ellensburg",
      "cityCode": "ELN",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 47.033774,
      "longitude": -120.531969,
      "elevationFeet": 1763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELN?codeType=fs"
     },
     {
      "fs": "ELW",
      "iata": "ELW",
      "icao": "",
      "faa": "",
      "name": "Ellamar Sea Plane Base",
      "city": "Ellamar",
      "cityCode": "ELW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 60.893908,
      "longitude": -146.703692,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELW?codeType=fs"
     },
     {
      "fs": "ELZ",
      "iata": "ELZ",
      "icao": "KELZ",
      "faa": "ELZ",
      "name": "Wellsville Municipal Airport",
      "city": "Wellsville",
      "cityCode": "ELZ",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.116667,
      "longitude": -77.95,
      "elevationFeet": 2123,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ELZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ELZ?codeType=fs"
     },
     {
      "fs": "EMB",
      "iata": "EMB",
      "icao": "",
      "faa": "",
      "name": "Embarcadero",
      "city": "San Francisco",
      "cityCode": "SFO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.810117,
      "longitude": -122.409555,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EMB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EMB?codeType=fs"
     },
     {
      "fs": "EMM",
      "iata": "EMM",
      "icao": "KEMM",
      "faa": "EMM",
      "name": "Kemmerer Airport",
      "city": "Kemmerer",
      "cityCode": "EMM",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 41.783333,
      "longitude": -110.55,
      "elevationFeet": 7282,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EMM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EMM?codeType=fs"
     },
     {
      "fs": "EMP",
      "iata": "EMP",
      "icao": "KEMP",
      "faa": "EMP",
      "name": "Emporia Airport",
      "city": "Emporia",
      "cityCode": "EMP",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.3325,
      "longitude": -96.190833,
      "elevationFeet": 1208,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EMP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EMP?codeType=fs"
     },
     {
      "fs": "END",
      "iata": "END",
      "icao": "KEND",
      "faa": "END",
      "name": "Vance Air Force Base",
      "city": "Enid",
      "cityCode": "WDG",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.340058,
      "longitude": -97.914614,
      "elevationFeet": 1282,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/END?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/END?codeType=fs"
     },
     {
      "fs": "ENL",
      "iata": "ENL",
      "icao": "KENL",
      "faa": "ENL",
      "name": "Centralia Municipal Airport",
      "city": "Centralia",
      "cityCode": "ENL",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.516667,
      "longitude": -89.133333,
      "elevationFeet": 534,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ENL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ENL?codeType=fs"
     },
     {
      "fs": "ENN",
      "iata": "ENN",
      "icao": "PANN",
      "faa": "PANN",
      "name": "Nenana Municipal Airport",
      "city": "Nenana",
      "cityCode": "ENN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 64.566667,
      "longitude": -149.116667,
      "elevationFeet": 362,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ENN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ENN?codeType=fs"
     },
     {
      "fs": "EOK",
      "iata": "EOK",
      "icao": "KEOK",
      "faa": "EOK",
      "name": "Keokuk Airport",
      "city": "Keokuk",
      "cityCode": "EOK",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.458333,
      "longitude": -91.43,
      "elevationFeet": 671,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EOK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EOK?codeType=fs"
     },
     {
      "fs": "EOS",
      "iata": "EOS",
      "icao": "KEOS",
      "faa": "EOS",
      "name": "Neosho Airport",
      "city": "Neosho",
      "cityCode": "EOS",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.866667,
      "longitude": -94.366667,
      "elevationFeet": 1255,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EOS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EOS?codeType=fs"
     },
     {
      "fs": "EPG",
      "iata": "EPG",
      "icao": "KEPG",
      "faa": "EPG",
      "name": "Browns Airport",
      "city": "Weeping Water",
      "cityCode": "EPG",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.866667,
      "longitude": -96.133333,
      "elevationFeet": 1183,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EPG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EPG?codeType=fs"
     },
     {
      "fs": "EPH",
      "iata": "EPH",
      "icao": "KEPH",
      "faa": "EPH",
      "name": "Ephrata Airport",
      "city": "Ephrata",
      "cityCode": "EPH",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 47.304167,
      "longitude": -119.5125,
      "elevationFeet": 1276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EPH?codeType=fs"
     },
     {
      "fs": "ERO",
      "iata": "ERO",
      "icao": "",
      "faa": "",
      "name": "Eldred Rock Coast Guard Heliport",
      "city": "Eldred Rock",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 58.971568,
      "longitude": -135.224572,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ERO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ERO?codeType=fs"
     },
     {
      "fs": "ERR",
      "iata": "ERR",
      "icao": "KERR",
      "faa": "ERR",
      "name": "Errol Airport",
      "city": "Errol",
      "cityCode": "ERR",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 44.783333,
      "longitude": -71.133333,
      "elevationFeet": 1245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ERR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ERR?codeType=fs"
     },
     {
      "fs": "ESF",
      "iata": "ESF",
      "icao": "KESF",
      "faa": "ESF",
      "name": "Esler Field",
      "city": "Alexandria",
      "cityCode": "AEX",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.395,
      "longitude": -92.296944,
      "elevationFeet": 112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESF?codeType=fs"
     },
     {
      "fs": "ESO",
      "iata": "ESO",
      "icao": "",
      "faa": "Q14",
      "name": "Espanola Airport",
      "city": "Espanola",
      "cityCode": "ESO",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 36.1,
      "longitude": -106.033333,
      "elevationFeet": 5790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESO?codeType=fs"
     },
     {
      "fs": "ESP",
      "iata": "ESP",
      "icao": "",
      "faa": "N53",
      "name": "Birchwood-Pocono Airport",
      "city": "East Stroudsburg",
      "cityCode": "ESP",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.983333,
      "longitude": -75.2,
      "elevationFeet": 480,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESP?codeType=fs"
     },
     {
      "fs": "EST",
      "iata": "EST",
      "icao": "KEST",
      "faa": "EST",
      "name": "Estherville Municipal Airport",
      "city": "Estherville",
      "cityCode": "EST",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 43.4,
      "longitude": -94.833333,
      "elevationFeet": 1317,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EST?codeType=fs"
     },
     {
      "fs": "ESW",
      "iata": "ESW",
      "icao": "KESW",
      "faa": "ESW",
      "name": "Easton State Airport",
      "city": "Easton",
      "cityCode": "ESW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 47.254211,
      "longitude": -121.185989,
      "elevationFeet": 2226,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ESW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ESW?codeType=fs"
     },
     {
      "fs": "ETB",
      "iata": "ETB",
      "icao": "KETB",
      "faa": "ETB",
      "name": "West Bend Airport",
      "city": "West Bend",
      "cityCode": "ETB",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 43.416667,
      "longitude": -88.183333,
      "elevationFeet": 886,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ETB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ETB?codeType=fs"
     },
     {
      "fs": "ETN",
      "iata": "ETN",
      "icao": "KETN",
      "faa": "ETN",
      "name": "Eastland Municipal Airport",
      "city": "Eastland",
      "cityCode": "ETN",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.383333,
      "longitude": -98.833333,
      "elevationFeet": 1464,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ETN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ETN?codeType=fs"
     },
     {
      "fs": "ETS",
      "iata": "ETS",
      "icao": "KEDN",
      "faa": "EDN",
      "name": "Enterprise Municipal Airport",
      "city": "Enterprise",
      "cityCode": "ETS",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.316667,
      "longitude": -85.85,
      "elevationFeet": 364,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ETS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ETS?codeType=fs"
     },
     {
      "fs": "EUE",
      "iata": "EUE",
      "icao": "",
      "faa": "05U",
      "name": "Eureka Airport",
      "city": "Eureka",
      "cityCode": "EUE",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 39.5,
      "longitude": -115.916667,
      "elevationFeet": 5954,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EUE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EUE?codeType=fs"
     },
     {
      "fs": "EUF",
      "iata": "EUF",
      "icao": "KEUF",
      "faa": "EUF",
      "name": "Weedon Field",
      "city": "Eufaula",
      "cityCode": "EUF",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.9,
      "longitude": -85.15,
      "elevationFeet": 285,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EUF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EUF?codeType=fs"
     },
     {
      "fs": "EVA",
      "iata": "EVA",
      "icao": "",
      "faa": "",
      "name": "Evadale Landing Strip",
      "city": "Evadale",
      "cityCode": "EVA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.35,
      "longitude": -94.066667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EVA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EVA?codeType=fs"
     },
     {
      "fs": "EVW",
      "iata": "EVW",
      "icao": "KEVW",
      "faa": "EVW",
      "name": "Evanston Airport",
      "city": "Evanston",
      "cityCode": "EVW",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 41.266667,
      "longitude": -110.966667,
      "elevationFeet": 7163,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EVW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EVW?codeType=fs"
     },
     {
      "fs": "EWK",
      "iata": "EWK",
      "icao": "KEWK",
      "faa": "EWK",
      "name": "Newton City-County Airport",
      "city": "Newton",
      "cityCode": "EWK",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.058201,
      "longitude": -97.274498,
      "elevationFeet": 1533,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EWK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EWK?codeType=fs"
     },
     {
      "fs": "EYR",
      "iata": "EYR",
      "icao": "",
      "faa": "O43",
      "name": "Yerington Airport",
      "city": "Yerington",
      "cityCode": "EYR",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 39,
      "longitude": -119.25,
      "elevationFeet": 4378,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/EYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/EYR?codeType=fs"
     },
     {
      "fs": "F00",
      "iata": "",
      "icao": "",
      "faa": "F00",
      "name": "Jones",
      "city": "Bonham",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.717222,
      "longitude": -96.293889,
      "elevationFeet": 618,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F00?codeType=fs"
     },
     {
      "fs": "F01",
      "iata": "",
      "icao": "",
      "faa": "F01",
      "name": "Quanah Municipal",
      "city": "Quanah",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.370833,
      "longitude": -99.842722,
      "elevationFeet": 1602,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F01?codeType=fs"
     },
     {
      "fs": "F02",
      "iata": "",
      "icao": "",
      "faa": "F02",
      "name": "Fairgrounds",
      "city": "Hardin",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 45.799778,
      "longitude": -107.606417,
      "elevationFeet": 2911,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F02?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F02?codeType=fs"
     },
     {
      "fs": "F04",
      "iata": "",
      "icao": "",
      "faa": "F04",
      "name": "Saginaw",
      "city": "Ft Worth",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.976278,
      "longitude": -97.48075,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F04?codeType=fs"
     },
     {
      "fs": "F06",
      "iata": "",
      "icao": "",
      "faa": "F06",
      "name": "Marian",
      "city": "Wellington",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.956111,
      "longitude": -100.309472,
      "elevationFeet": 2008,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F06?codeType=fs"
     },
     {
      "fs": "F08",
      "iata": "",
      "icao": "",
      "faa": "F08",
      "name": "Eufaula Municipal",
      "city": "Eufaula",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.409333,
      "longitude": -95.702639,
      "elevationFeet": 635,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F08?codeType=fs"
     },
     {
      "fs": "F09",
      "iata": "",
      "icao": "",
      "faa": "F09",
      "name": "Olustee Municipal",
      "city": "Olustee",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.62575,
      "longitude": -99.545333,
      "elevationFeet": 1346,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F09?codeType=fs"
     },
     {
      "fs": "F10",
      "iata": "",
      "icao": "",
      "faa": "F10",
      "name": "Henryetta Municipal",
      "city": "Henryetta",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.468806,
      "longitude": -96.158333,
      "elevationFeet": 849,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F10?codeType=fs"
     },
     {
      "fs": "F12",
      "iata": "",
      "icao": "",
      "faa": "F12",
      "name": "Rusk Co",
      "city": "Henderson",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.217222,
      "longitude": -94.867222,
      "elevationFeet": 442,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F12?codeType=fs"
     },
     {
      "fs": "F13",
      "iata": "",
      "icao": "",
      "faa": "F13",
      "name": "Shell Creek Airpark",
      "city": "Punta Gorda",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 26.989472,
      "longitude": -82.056417,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F13?codeType=fs"
     },
     {
      "fs": "F14",
      "iata": "",
      "icao": "",
      "faa": "F14",
      "name": "Wichita Valley",
      "city": "Wichita Falls",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.077222,
      "longitude": -98.616944,
      "elevationFeet": 1005,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F14?codeType=fs"
     },
     {
      "fs": "F17",
      "iata": "",
      "icao": "",
      "faa": "F17",
      "name": "Center Municipal",
      "city": "Center",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.965833,
      "longitude": -94.214167,
      "elevationFeet": 319,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F17?codeType=fs"
     },
     {
      "fs": "F18",
      "iata": "",
      "icao": "",
      "faa": "F18",
      "name": "Cleburne Municipal",
      "city": "Cleburne",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.387639,
      "longitude": -97.4375,
      "elevationFeet": 854,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F18?codeType=fs"
     },
     {
      "fs": "F21",
      "iata": "",
      "icao": "",
      "faa": "F21",
      "name": "Memphis Municipal",
      "city": "Memphis",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.795889,
      "longitude": -100.647,
      "elevationFeet": 2102,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F21?codeType=fs"
     },
     {
      "fs": "F22",
      "iata": "",
      "icao": "",
      "faa": "F22",
      "name": "Perry Municipal",
      "city": "Perry",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.405972,
      "longitude": -97.372111,
      "elevationFeet": 1002,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F22?codeType=fs"
     },
     {
      "fs": "F24",
      "iata": "",
      "icao": "",
      "faa": "F24",
      "name": "Minden-Webster",
      "city": "Minden",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.760111,
      "longitude": -93.430861,
      "elevationFeet": 278,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F24?codeType=fs"
     },
     {
      "fs": "F29",
      "iata": "",
      "icao": "",
      "faa": "F29",
      "name": "Page Municipal",
      "city": "Oklahoma City",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.530833,
      "longitude": -97.885444,
      "elevationFeet": 1353,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F29?codeType=fs"
     },
     {
      "fs": "F30",
      "iata": "",
      "icao": "",
      "faa": "F30",
      "name": "Sulphur Municipal",
      "city": "Sulphur",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.595333,
      "longitude": -97.047389,
      "elevationFeet": 1051,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F30?codeType=fs"
     },
     {
      "fs": "F31",
      "iata": "",
      "icao": "",
      "faa": "F31",
      "name": "Lake Texoma State Park",
      "city": "Kingston",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.078778,
      "longitude": -96.724972,
      "elevationFeet": 693,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F31?codeType=fs"
     },
     {
      "fs": "F32",
      "iata": "",
      "icao": "",
      "faa": "F32",
      "name": "Healdton Municipal",
      "city": "Healdton",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.392583,
      "longitude": -97.539139,
      "elevationFeet": 956,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F32?codeType=fs"
     },
     {
      "fs": "F35",
      "iata": "",
      "icao": "",
      "faa": "F35",
      "name": "Possum Kingdom",
      "city": "Graford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.979722,
      "longitude": -98.471111,
      "elevationFeet": 1008,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F35?codeType=fs"
     },
     {
      "fs": "F36",
      "iata": "",
      "icao": "",
      "faa": "F36",
      "name": "Cordell Municipal",
      "city": "Cordell",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.342194,
      "longitude": -98.970222,
      "elevationFeet": 1589,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F36?codeType=fs"
     },
     {
      "fs": "F37",
      "iata": "",
      "icao": "",
      "faa": "F37",
      "name": "Wauchula Municipal Airport",
      "city": "Wauchula",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 27.515964,
      "longitude": -82.882258,
      "elevationFeet": 102,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F37?codeType=fs"
     },
     {
      "fs": "F41",
      "iata": "",
      "icao": "",
      "faa": "F41",
      "name": "Ennis Municipal",
      "city": "Ennis",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.446944,
      "longitude": -96.788889,
      "elevationFeet": 500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F41?codeType=fs"
     },
     {
      "fs": "F43",
      "iata": "",
      "icao": "",
      "faa": "F43",
      "name": "Downtown",
      "city": "El Dorado",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.292972,
      "longitude": -92.782111,
      "elevationFeet": 256,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F43?codeType=fs"
     },
     {
      "fs": "F44",
      "iata": "",
      "icao": "",
      "faa": "F44",
      "name": "Athens Municipal",
      "city": "Athens",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.288472,
      "longitude": -95.933528,
      "elevationFeet": 444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F44?codeType=fs"
     },
     {
      "fs": "F45",
      "iata": "",
      "icao": "",
      "faa": "F45",
      "name": "North Palm Beach Co Gen Avn",
      "city": "West Palm Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 26.8444,
      "longitude": -80.221298,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F45?codeType=fs"
     },
     {
      "fs": "F46",
      "iata": "",
      "icao": "",
      "faa": "F46",
      "name": "Rockwall Municipal",
      "city": "Rockwall",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.055944,
      "longitude": -96.454861,
      "elevationFeet": 574,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F46?codeType=fs"
     },
     {
      "fs": "F47",
      "iata": "",
      "icao": "",
      "faa": "F47",
      "name": "St George Island",
      "city": "Apalachicola",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 29.760472,
      "longitude": -85.06575,
      "elevationFeet": 3,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F47?codeType=fs"
     },
     {
      "fs": "F48",
      "iata": "",
      "icao": "",
      "faa": "F48",
      "name": "Nocona",
      "city": "Nocona",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.839917,
      "longitude": -97.780861,
      "elevationFeet": 905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F48?codeType=fs"
     },
     {
      "fs": "F49",
      "iata": "",
      "icao": "",
      "faa": "F49",
      "name": "Slaton Municipal",
      "city": "Slaton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.498111,
      "longitude": -101.757167,
      "elevationFeet": 3123,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F49?codeType=fs"
     },
     {
      "fs": "F50",
      "iata": "",
      "icao": "",
      "faa": "F50",
      "name": "Lake Whitney State Park",
      "city": "Whitney",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.001556,
      "longitude": -97.497361,
      "elevationFeet": 564,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F50?codeType=fs"
     },
     {
      "fs": "F51",
      "iata": "",
      "icao": "",
      "faa": "F51",
      "name": "Winnsboro Municipal",
      "city": "Winnsboro",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.988472,
      "longitude": -95.388611,
      "elevationFeet": 513,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F51?codeType=fs"
     },
     {
      "fs": "F53",
      "iata": "",
      "icao": "",
      "faa": "F53",
      "name": "Franklin Co",
      "city": "Mt Vernon",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.353056,
      "longitude": -95.274917,
      "elevationFeet": 412,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F53?codeType=fs"
     },
     {
      "fs": "F55",
      "iata": "",
      "icao": "",
      "faa": "F55",
      "name": "Granbury Municipal",
      "city": "Granbury",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.544167,
      "longitude": -97.819472,
      "elevationFeet": 777,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F55?codeType=fs"
     },
     {
      "fs": "F56",
      "iata": "",
      "icao": "",
      "faa": "F56",
      "name": "Arledge",
      "city": "Stamford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.001944,
      "longitude": -99.742306,
      "elevationFeet": 1560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F56?codeType=fs"
     },
     {
      "fs": "F62",
      "iata": "",
      "icao": "",
      "faa": "F62",
      "name": "Idabel",
      "city": "Idabel",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.9485,
      "longitude": -94.952583,
      "elevationFeet": 510,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F62?codeType=fs"
     },
     {
      "fs": "F66",
      "iata": "",
      "icao": "",
      "faa": "F66",
      "name": "Carroll",
      "city": "De Soto",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.620806,
      "longitude": -97.005556,
      "elevationFeet": 715,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F66?codeType=fs"
     },
     {
      "fs": "F68",
      "iata": "",
      "icao": "",
      "faa": "F68",
      "name": "Anadarko Municipal",
      "city": "Anadarko",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.092278,
      "longitude": -98.378306,
      "elevationFeet": 1286,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F68?codeType=fs"
     },
     {
      "fs": "F69",
      "iata": "",
      "icao": "",
      "faa": "F69",
      "name": "Airpark-Dallas",
      "city": "Dallas",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.084556,
      "longitude": -96.869472,
      "elevationFeet": 695,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F69?codeType=fs"
     },
     {
      "fs": "F75",
      "iata": "",
      "icao": "",
      "faa": "F75",
      "name": "Harrison",
      "city": "Knox City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.4815,
      "longitude": -99.928694,
      "elevationFeet": 1500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F75?codeType=fs"
     },
     {
      "fs": "F78",
      "iata": "",
      "icao": "",
      "faa": "F78",
      "name": "Horseshoe Bend",
      "city": "Weatherford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.629111,
      "longitude": -97.925333,
      "elevationFeet": 715,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F78?codeType=fs"
     },
     {
      "fs": "F80",
      "iata": "",
      "icao": "",
      "faa": "F80",
      "name": "Atoka Municipal",
      "city": "Atoka",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.533389,
      "longitude": -96.280611,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F80?codeType=fs"
     },
     {
      "fs": "F81",
      "iata": "",
      "icao": "",
      "faa": "F81",
      "name": "Okemah",
      "city": "Okemah",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.542528,
      "longitude": -96.327833,
      "elevationFeet": 867,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F81?codeType=fs"
     },
     {
      "fs": "F82",
      "iata": "",
      "icao": "",
      "faa": "F82",
      "name": "Town And Country",
      "city": "Lubbock",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.506417,
      "longitude": -101.926639,
      "elevationFeet": 3200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F82?codeType=fs"
     },
     {
      "fs": "F83",
      "iata": "",
      "icao": "",
      "faa": "F83",
      "name": "Abernathy Municipal",
      "city": "Abernathy",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.959139,
      "longitude": -101.879472,
      "elevationFeet": 3327,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F83?codeType=fs"
     },
     {
      "fs": "F84",
      "iata": "",
      "icao": "",
      "faa": "F84",
      "name": "Stigler Municipal",
      "city": "Stigler",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.341056,
      "longitude": -95.188972,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F84?codeType=fs"
     },
     {
      "fs": "F85",
      "iata": "",
      "icao": "",
      "faa": "F85",
      "name": "Cochran",
      "city": "Morton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.842639,
      "longitude": -102.738194,
      "elevationFeet": 3746,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F85?codeType=fs"
     },
     {
      "fs": "F86",
      "iata": "",
      "icao": "",
      "faa": "F86",
      "name": "Columbia",
      "city": "Columbia",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.173778,
      "longitude": -92.079111,
      "elevationFeet": 66,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F86?codeType=fs"
     },
     {
      "fs": "F87",
      "iata": "",
      "icao": "",
      "faa": "F87",
      "name": "Farmerville",
      "city": "Farmerville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.799556,
      "longitude": -92.371667,
      "elevationFeet": 121,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F87?codeType=fs"
     },
     {
      "fs": "F88",
      "iata": "",
      "icao": "",
      "faa": "F88",
      "name": "Jonesboro Municipal",
      "city": "Jonesboro",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.219889,
      "longitude": -92.879306,
      "elevationFeet": 256,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F88?codeType=fs"
     },
     {
      "fs": "F89",
      "iata": "",
      "icao": "",
      "faa": "F89",
      "name": "Winnsboro Municipal",
      "city": "Winnsboro",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.193194,
      "longitude": -91.70125,
      "elevationFeet": 76,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F89?codeType=fs"
     },
     {
      "fs": "F91",
      "iata": "",
      "icao": "",
      "faa": "F91",
      "name": "Stafford",
      "city": "Weatherford",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.648306,
      "longitude": -98.684917,
      "elevationFeet": 1605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F91?codeType=fs"
     },
     {
      "fs": "F92",
      "iata": "",
      "icao": "",
      "faa": "F92",
      "name": "Kingfisher",
      "city": "Kingfisher",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.950417,
      "longitude": -97.953333,
      "elevationFeet": 1067,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F92?codeType=fs"
     },
     {
      "fs": "F95",
      "iata": "",
      "icao": "",
      "faa": "F95",
      "name": "Calhoun Co",
      "city": "Blountstown",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.522222,
      "longitude": -85.236111,
      "elevationFeet": 120,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F95?codeType=fs"
     },
     {
      "fs": "F97",
      "iata": "",
      "icao": "",
      "faa": "F97",
      "name": "Seagraves",
      "city": "Seagraves",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.950972,
      "longitude": -102.538028,
      "elevationFeet": 3366,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F97?codeType=fs"
     },
     {
      "fs": "F98",
      "iata": "",
      "icao": "",
      "faa": "F98",
      "name": "Yoakum Co",
      "city": "Plains",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.34825,
      "longitude": -102.841,
      "elevationFeet": 3678,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F98?codeType=fs"
     },
     {
      "fs": "F99",
      "iata": "",
      "icao": "",
      "faa": "F99",
      "name": "Holdenville Municipal",
      "city": "Holdenville",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.10875,
      "longitude": -96.416667,
      "elevationFeet": 860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/F99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/F99?codeType=fs"
     },
     {
      "fs": "FA40",
      "iata": "",
      "icao": "",
      "faa": "FA40",
      "name": "Hidden Lake Airport",
      "city": "New Port Richey",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 28.283664,
      "longitude": -82.639466,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FA40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FA40?codeType=fs"
     },
     {
      "fs": "FAF",
      "iata": "FAF",
      "icao": "KFAF",
      "faa": "FAF",
      "name": "Felker Army Air Field",
      "city": "Fort Eustis",
      "cityCode": "FAF",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.132548,
      "longitude": -76.608832,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAF?codeType=fs"
     },
     {
      "fs": "FAK",
      "iata": "FAK",
      "icao": "",
      "faa": "",
      "name": "False Island Sea Plane Base",
      "city": "False Island",
      "cityCode": "FAK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 57.53213,
      "longitude": -135.213364,
      "elevationFeet": 4,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAK?codeType=fs"
     },
     {
      "fs": "FAL",
      "iata": "FAL",
      "icao": "",
      "faa": "",
      "name": "Roma Falcon State Airport",
      "city": "Roma Falcon",
      "cityCode": "FAL",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 26.583333,
      "longitude": -99.133333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAL?codeType=fs"
     },
     {
      "fs": "FAM",
      "iata": "FAM",
      "icao": "KFAM",
      "faa": "FAM",
      "name": "Farmington Regional Airport",
      "city": "Farmington",
      "cityCode": "FAM",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.780833,
      "longitude": -90.421667,
      "elevationFeet": 947,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FAM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FAM?codeType=fs"
     },
     {
      "fs": "FBG",
      "iata": "FBG",
      "icao": "KFBG",
      "faa": "FBG",
      "name": "Simmons Army Airfield",
      "city": "Fort Bragg",
      "cityCode": "FBG",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.131944,
      "longitude": -78.936389,
      "elevationFeet": 238,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FBG?codeType=fs"
     },
     {
      "fs": "FBK",
      "iata": "FBK",
      "icao": "",
      "faa": "",
      "name": "Fort Wainwright Airport",
      "city": "Fairbanks",
      "cityCode": "FAI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 64.83364,
      "longitude": -147.611924,
      "elevationFeet": 447,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FBK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FBK?codeType=fs"
     },
     {
      "fs": "FBL",
      "iata": "FBL",
      "icao": "KFBL",
      "faa": "FBL",
      "name": "Faribault Municipal Airport",
      "city": "Faribault",
      "cityCode": "FBL",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 44.3,
      "longitude": -93.266667,
      "elevationFeet": 1060,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FBL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FBL?codeType=fs"
     },
     {
      "fs": "FBR",
      "iata": "FBR",
      "icao": "KFBR",
      "faa": "FBR",
      "name": "Fort Bridger Airport",
      "city": "Fort Bridger",
      "cityCode": "FBR",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 41.316667,
      "longitude": -110.383333,
      "elevationFeet": 7034,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FBR?codeType=fs"
     },
     {
      "fs": "FBY",
      "iata": "FBY",
      "icao": "KFBY",
      "faa": "FBY",
      "name": "Fairbury Municipal Airport",
      "city": "Fairbury",
      "cityCode": "FBY",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.133333,
      "longitude": -97.183333,
      "elevationFeet": 1479,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FBY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FBY?codeType=fs"
     },
     {
      "fs": "FCH",
      "iata": "FCH",
      "icao": "KFCH",
      "faa": "FCH",
      "name": "Fresno-Chandler Airport",
      "city": "Fresno",
      "cityCode": "FAT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 36.733333,
      "longitude": -119.783333,
      "elevationFeet": 278,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FCH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FCH?codeType=fs"
     },
     {
      "fs": "FCS",
      "iata": "FCS",
      "icao": "KFCS",
      "faa": "FCS",
      "name": "Butts Army Air Field",
      "city": "Colorado Springs",
      "cityCode": "COS",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 38.833333,
      "longitude": -104.816667,
      "elevationFeet": 5872,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FCS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FCS?codeType=fs"
     },
     {
      "fs": "FCY",
      "iata": "FCY",
      "icao": "KFCY",
      "faa": "FCY",
      "name": "Forrest City Municipal Airport",
      "city": "Forrest City",
      "cityCode": "FCY",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.95,
      "longitude": -90.766667,
      "elevationFeet": 249,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FCY?codeType=fs"
     },
     {
      "fs": "FDR",
      "iata": "FDR",
      "icao": "KFDR",
      "faa": "FDR",
      "name": "Frederick Municipal Airport",
      "city": "Frederick",
      "cityCode": "FDR",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.383333,
      "longitude": -99.016667,
      "elevationFeet": 1255,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FDR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FDR?codeType=fs"
     },
     {
      "fs": "FDY",
      "iata": "FDY",
      "icao": "KFDY",
      "faa": "FDY",
      "name": "Findlay Airport",
      "city": "Findlay",
      "cityCode": "FDY",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.0135,
      "longitude": -83.668701,
      "elevationFeet": 813,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FDY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FDY?codeType=fs"
     },
     {
      "fs": "FEP",
      "iata": "FEP",
      "icao": "KFEP",
      "faa": "FEP",
      "name": "Albertus Airport",
      "city": "Freeport",
      "cityCode": "FEP",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.283333,
      "longitude": -89.6,
      "elevationFeet": 859,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FEP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FEP?codeType=fs"
     },
     {
      "fs": "FET",
      "iata": "FET",
      "icao": "KFET",
      "faa": "FET",
      "name": "Fremont Municipal Airport",
      "city": "Fremont",
      "cityCode": "FET",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.449989,
      "longitude": -96.519759,
      "elevationFeet": 1203,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FET?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FET?codeType=fs"
     },
     {
      "fs": "FEW",
      "iata": "FEW",
      "icao": "",
      "faa": "",
      "name": "Warren Air Force Base",
      "city": "Cheyenne",
      "cityCode": "CYS",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 41.133333,
      "longitude": -104.816667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FEW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FEW?codeType=fs"
     },
     {
      "fs": "FFA",
      "iata": "FFA",
      "icao": "KFFA",
      "faa": "FFA",
      "name": "First Flight Airport",
      "city": "Kill Devil Hills",
      "cityCode": "FFA",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 36.016667,
      "longitude": -75.666667,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FFA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FFA?codeType=fs"
     },
     {
      "fs": "FFL",
      "iata": "FFL",
      "icao": "KFFL",
      "faa": "FFL",
      "name": "Fairfield Municipal Airport",
      "city": "Fairfield",
      "cityCode": "FFL",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.933333,
      "longitude": -91.95,
      "elevationFeet": 799,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FFL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FFL?codeType=fs"
     },
     {
      "fs": "FFO",
      "iata": "FFO",
      "icao": "KFFO",
      "faa": "FFO",
      "name": "Wright-Patterson Air Force Base",
      "city": "Dayton",
      "cityCode": "DAY",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.826093,
      "longitude": -84.048289,
      "elevationFeet": 812,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FFO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FFO?codeType=fs"
     },
     {
      "fs": "FFT",
      "iata": "FFT",
      "icao": "KFFT",
      "faa": "FFT",
      "name": "Frankfort Capital City Airport",
      "city": "Frankfort",
      "cityCode": "FFT",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.182222,
      "longitude": -84.905,
      "elevationFeet": 804,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FFT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FFT?codeType=fs"
     },
     {
      "fs": "FIC",
      "iata": "FIC",
      "icao": "",
      "faa": "",
      "name": "Fire Cove Airport",
      "city": "Fire Cove",
      "cityCode": "FIC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 55.777778,
      "longitude": -131.5375,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FIC?codeType=fs"
     },
     {
      "fs": "FIL",
      "iata": "FIL",
      "icao": "",
      "faa": "U19",
      "name": "Fillmore Municipal Airport",
      "city": "Fillmore",
      "cityCode": "FIL",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 38.958333,
      "longitude": -112.3625,
      "elevationFeet": 4988,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FIL?codeType=fs"
     },
     {
      "fs": "FIV",
      "iata": "FIV",
      "icao": "",
      "faa": "",
      "name": "Five Fingers Coast Guard Heliport",
      "city": "Five Fingers",
      "cityCode": "FIV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 57.269972,
      "longitude": -133.630974,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FIV?codeType=fs"
     },
     {
      "fs": "FKN",
      "iata": "FKN",
      "icao": "KFKN",
      "faa": "FKN",
      "name": "Franklin Municipal Airport",
      "city": "Franklin",
      "cityCode": "FKN",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 36.683333,
      "longitude": -76.933333,
      "elevationFeet": 41,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FKN?codeType=fs"
     },
     {
      "fs": "FLE",
      "iata": "FLE",
      "icao": "",
      "faa": "",
      "name": "Fort Lee Army Air Field",
      "city": "Petersburg",
      "cityCode": "PTB",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.283384,
      "longitude": -77.344322,
      "elevationFeet": 93,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLE?codeType=fs"
     },
     {
      "fs": "FLJ",
      "iata": "FLJ",
      "icao": "",
      "faa": "",
      "name": "Falls Bay Airport",
      "city": "Falls Bay",
      "cityCode": "FLJ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 60.0325,
      "longitude": -148.008333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLJ?codeType=fs"
     },
     {
      "fs": "FLP",
      "iata": "FLP",
      "icao": "KFLP",
      "faa": "FLP",
      "name": "Flippin Airport",
      "city": "Flippin",
      "cityCode": "FLP",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.3,
      "longitude": -92.583333,
      "elevationFeet": 719,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLP?codeType=fs"
     },
     {
      "fs": "FLT",
      "iata": "FLT",
      "icao": "",
      "faa": "FLT",
      "name": "Flat Airport",
      "city": "Flat",
      "cityCode": "FLT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 62.454167,
      "longitude": -157.986667,
      "elevationFeet": 309,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLT?codeType=fs"
     },
     {
      "fs": "FLU",
      "iata": "FLU",
      "icao": "",
      "faa": "",
      "name": "Flushing Airport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.775556,
      "longitude": -73.834444,
      "elevationFeet": 15,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLU?codeType=fs"
     },
     {
      "fs": "FLV",
      "iata": "FLV",
      "icao": "KFLV",
      "faa": "FLV",
      "name": "Sherman Army Air Field",
      "city": "Fort Leavenworth",
      "cityCode": "FLV",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.368307,
      "longitude": -94.914695,
      "elevationFeet": 770,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLV?codeType=fs"
     },
     {
      "fs": "FLX",
      "iata": "FLX",
      "icao": "KFLX",
      "faa": "FLX",
      "name": "Fallon Municipal Airport",
      "city": "Fallon",
      "cityCode": "NFL",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 39.500678,
      "longitude": -118.746038,
      "elevationFeet": 3958,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FLX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FLX?codeType=fs"
     },
     {
      "fs": "FMC",
      "iata": "FMC",
      "icao": "",
      "faa": "",
      "name": "Five Mile Airport",
      "city": "Five Mile",
      "cityCode": "FMC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 66.916667,
      "longitude": -149.841667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FMC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FMC?codeType=fs"
     },
     {
      "fs": "FMS",
      "iata": "FMS",
      "icao": "KFSW",
      "faa": "FSW",
      "name": "Fort Madison Municipal Airport",
      "city": "Fort Madison",
      "cityCode": "FMS",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.658889,
      "longitude": -91.3275,
      "elevationFeet": 724,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FMS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FMS?codeType=fs"
     },
     {
      "fs": "FNK",
      "iata": "FNK",
      "icao": "",
      "faa": "",
      "name": "Fin Creek Airport",
      "city": "Fin Creek",
      "cityCode": "FNK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 69.5,
      "longitude": -147.583333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FNK?codeType=fs"
     },
     {
      "fs": "FNR",
      "iata": "FNR",
      "icao": "",
      "faa": "",
      "name": "Funter Bay Sea Plane Base",
      "city": "Funter Bay",
      "cityCode": "FNR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 58.255311,
      "longitude": -134.89602,
      "elevationFeet": 4,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FNR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FNR?codeType=fs"
     },
     {
      "fs": "FOB",
      "iata": "FOB",
      "icao": "",
      "faa": "",
      "name": "Fort Bragg Airport",
      "city": "Fort Bragg",
      "cityCode": "FOB",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 39.474444,
      "longitude": -123.794444,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FOB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FOB?codeType=fs"
     },
     {
      "fs": "FOP",
      "iata": "FOP",
      "icao": "",
      "faa": "",
      "name": "Morris Army Air Field",
      "city": "Forest Park",
      "cityCode": "FOP",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 33.616667,
      "longitude": -84.366667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FOP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FOP?codeType=fs"
     },
     {
      "fs": "FOX",
      "iata": "FOX",
      "icao": "",
      "faa": "",
      "name": "Fox Airport",
      "city": "Fox",
      "cityCode": "FOX",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 64,
      "longitude": -147,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FOX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FOX?codeType=fs"
     },
     {
      "fs": "FPY",
      "iata": "FPY",
      "icao": "",
      "faa": "40J",
      "name": "Perry-Foley Airport",
      "city": "Perry",
      "cityCode": "FPY",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 30.116667,
      "longitude": -83.583333,
      "elevationFeet": 45,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FPY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FPY?codeType=fs"
     },
     {
      "fs": "FRH",
      "iata": "FRH",
      "icao": "KFRH",
      "faa": "FRH",
      "name": "French Lick Municipal Airport",
      "city": "French Lick",
      "cityCode": "FRH",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.55,
      "longitude": -86.616667,
      "elevationFeet": 792,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRH?codeType=fs"
     },
     {
      "fs": "FRI",
      "iata": "FRI",
      "icao": "KFRI",
      "faa": "FRI",
      "name": "Marshall Army Air Field",
      "city": "Fort Riley",
      "cityCode": "FRI",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.053192,
      "longitude": -96.764195,
      "elevationFeet": 1064,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRI?codeType=fs"
     },
     {
      "fs": "FRM",
      "iata": "FRM",
      "icao": "KFRM",
      "faa": "FRM",
      "name": "Fairmont Airport",
      "city": "Fairmont",
      "cityCode": "FRM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 43.647222,
      "longitude": -94.423611,
      "elevationFeet": 1162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRM?codeType=fs"
     },
     {
      "fs": "FRN",
      "iata": "FRN",
      "icao": "",
      "faa": "",
      "name": "Bryant Army Air Field",
      "city": "Fort Richardson",
      "cityCode": "FRN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 61.270108,
      "longitude": -149.649116,
      "elevationFeet": 381,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRN?codeType=fs"
     },
     {
      "fs": "FRP",
      "iata": "FRP",
      "icao": "",
      "faa": "",
      "name": "Fresh Water Bay Airport",
      "city": "Fresh Water Bay",
      "cityCode": "FRP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 57.845833,
      "longitude": -135.025,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FRP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FRP?codeType=fs"
     },
     {
      "fs": "FSI",
      "iata": "FSI",
      "icao": "KFSI",
      "faa": "FSI",
      "name": "Post Aaf",
      "city": "Ft Sill",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.650722,
      "longitude": -98.419972,
      "elevationFeet": 1188,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FSI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FSI?codeType=fs"
     },
     {
      "fs": "FSK",
      "iata": "FSK",
      "icao": "KFSK",
      "faa": "FSK",
      "name": "Fort Scott Municipal Airport",
      "city": "Fort Scott",
      "cityCode": "FSK",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.833333,
      "longitude": -94.7,
      "elevationFeet": 918,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FSK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FSK?codeType=fs"
     },
     {
      "fs": "FSN",
      "iata": "FSN",
      "icao": "",
      "faa": "",
      "name": "Haley AAF",
      "city": "Fort Sheridan",
      "cityCode": "FSN",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.15,
      "longitude": -87.966667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FSN?codeType=fs"
     },
     {
      "fs": "FST",
      "iata": "FST",
      "icao": "KFST",
      "faa": "FST",
      "name": "Pecos County Airport",
      "city": "Fort Stockton",
      "cityCode": "FST",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.893889,
      "longitude": -102.878889,
      "elevationFeet": 3011,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FST?codeType=fs"
     },
     {
      "fs": "FSU",
      "iata": "FSU",
      "icao": "KFSU",
      "faa": "FSU",
      "name": "Fort Sumner Airport",
      "city": "Fort Sumner",
      "cityCode": "FSU",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 34.466667,
      "longitude": -104.25,
      "elevationFeet": 4165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FSU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FSU?codeType=fs"
     },
     {
      "fs": "FTK",
      "iata": "FTK",
      "icao": "KFTK",
      "faa": "FTK",
      "name": "Godman Army Air Field",
      "city": "Fort Knox",
      "cityCode": "FTK",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.927708,
      "longitude": -85.949045,
      "elevationFeet": 766,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FTK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FTK?codeType=fs"
     },
     {
      "fs": "FTL",
      "iata": "FTL",
      "icao": "",
      "faa": "",
      "name": "Fortuna Ledge Airport",
      "city": "Fortuna Ledge",
      "cityCode": "FTL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 61.883333,
      "longitude": -162.083333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FTL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FTL?codeType=fs"
     },
     {
      "fs": "FWL",
      "iata": "FWL",
      "icao": "PAFW",
      "faa": "PAFW",
      "name": "Farewell Airport",
      "city": "Farewell",
      "cityCode": "FWL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 62.509722,
      "longitude": -153.889444,
      "elevationFeet": 1535,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FWL?codeType=fs"
     },
     {
      "fs": "FXM",
      "iata": "FXM",
      "icao": "",
      "faa": "",
      "name": "Flaxman Island Airport",
      "city": "Flaxman Island",
      "cityCode": "FXM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 70.2,
      "longitude": -146,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FXM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FXM?codeType=fs"
     },
     {
      "fs": "FXY",
      "iata": "FXY",
      "icao": "KFXY",
      "faa": "FXY",
      "name": "Forest City Municipal Airport",
      "city": "Forest City",
      "cityCode": "FXY",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 43.266667,
      "longitude": -93.65,
      "elevationFeet": 1230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FXY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FXY?codeType=fs"
     },
     {
      "fs": "FYM",
      "iata": "FYM",
      "icao": "KFYM",
      "faa": "FYM",
      "name": "Fayetteville Municipal Airport",
      "city": "Fayetteville",
      "cityCode": "FYM",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.15,
      "longitude": -86.566667,
      "elevationFeet": 984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/FYM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/FYM?codeType=fs"
     },
     {
      "fs": "G04",
      "iata": "",
      "icao": "",
      "faa": "G04",
      "name": "Culmerville",
      "city": "Culmerville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.775667,
      "longitude": -79.956083,
      "elevationFeet": 1220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/G04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/G04?codeType=fs"
     },
     {
      "fs": "G05",
      "iata": "",
      "icao": "",
      "faa": "G05",
      "name": "Finleyville",
      "city": "Finleyville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.359028,
      "longitude": -80.12275,
      "elevationFeet": 1240,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/G05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/G05?codeType=fs"
     },
     {
      "fs": "GA2",
      "iata": "",
      "icao": "",
      "faa": "GA2",
      "name": "Peach State",
      "city": "Williamson",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 33.184528,
      "longitude": -84.415917,
      "elevationFeet": 926,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GA2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GA2?codeType=fs"
     },
     {
      "fs": "GAB",
      "iata": "GAB",
      "icao": "KGAB",
      "faa": "GAB",
      "name": "Gabbs Airport",
      "city": "Gabbs",
      "cityCode": "GAB",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 38.866667,
      "longitude": -117.916667,
      "elevationFeet": 4700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAB?codeType=fs"
     },
     {
      "fs": "GAD",
      "iata": "GAD",
      "icao": "KGAD",
      "faa": "GAD",
      "name": "Gadsden Municipal Airport",
      "city": "Gadsden",
      "cityCode": "GAD",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.973611,
      "longitude": -86.087222,
      "elevationFeet": 569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAD?codeType=fs"
     },
     {
      "fs": "GAG",
      "iata": "GAG",
      "icao": "KGAG",
      "faa": "GAG",
      "name": "Gage Airport",
      "city": "Gage",
      "cityCode": "GAG",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.35,
      "longitude": -99.883333,
      "elevationFeet": 2223,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAG?codeType=fs"
     },
     {
      "fs": "GAK",
      "iata": "GAK",
      "icao": "",
      "faa": "",
      "name": "Gakona Airport",
      "city": "Gakona",
      "cityCode": "GAK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 62.333333,
      "longitude": -145.316667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GAK?codeType=fs"
     },
     {
      "fs": "GBG",
      "iata": "GBG",
      "icao": "KGBG",
      "faa": "GBG",
      "name": "Galesburg Airport",
      "city": "Galesburg",
      "cityCode": "GBG",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.938611,
      "longitude": -90.428889,
      "elevationFeet": 764,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GBG?codeType=fs"
     },
     {
      "fs": "GBH",
      "iata": "GBH",
      "icao": "PAGB",
      "faa": "PAGB",
      "name": "Galbraith Lake Airport",
      "city": "Galbraith Lake",
      "cityCode": "GBH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 68.466667,
      "longitude": -149.483333,
      "elevationFeet": 2670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GBH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GBH?codeType=fs"
     },
     {
      "fs": "GBO",
      "iata": "GBO",
      "icao": "",
      "faa": "",
      "name": "Baltimore Greenbelt T Station",
      "city": "Baltimore",
      "cityCode": "BWI",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.010586,
      "longitude": -76.910159,
      "elevationFeet": 76,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GBO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GBO?codeType=fs"
     },
     {
      "fs": "GBR",
      "iata": "GBR",
      "icao": "KGBR",
      "faa": "GBR",
      "name": "Great Barrington Airport",
      "city": "Great Barrington",
      "cityCode": "GBR",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.2,
      "longitude": -73.366667,
      "elevationFeet": 739,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GBR?codeType=fs"
     },
     {
      "fs": "GCY",
      "iata": "GCY",
      "icao": "KGCY",
      "faa": "GCY",
      "name": "Greene County Municipal Airport",
      "city": "Greeneville",
      "cityCode": "GCY",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.192986,
      "longitude": -82.815047,
      "elevationFeet": 1605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GCY?codeType=fs"
     },
     {
      "fs": "GDH",
      "iata": "GDH",
      "icao": "",
      "faa": "",
      "name": "Gold Horn SPB",
      "city": "Golden Horn",
      "cityCode": "GDH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 59.716667,
      "longitude": -158.166667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GDH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GDH?codeType=fs"
     },
     {
      "fs": "GDM",
      "iata": "GDM",
      "icao": "KGDM",
      "faa": "GDM",
      "name": "Gardner Municipal Airport",
      "city": "Gardner",
      "cityCode": "GDM",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.566667,
      "longitude": -71.983333,
      "elevationFeet": 955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GDM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GDM?codeType=fs"
     },
     {
      "fs": "GDW",
      "iata": "GDW",
      "icao": "KGDW",
      "faa": "GDW",
      "name": "Gladwin Airport",
      "city": "Gladwin",
      "cityCode": "GDW",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 43.983333,
      "longitude": -84.483333,
      "elevationFeet": 776,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GDW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GDW?codeType=fs"
     },
     {
      "fs": "GEK",
      "iata": "GEK",
      "icao": "",
      "faa": "",
      "name": "Ganes Creek Airport",
      "city": "Ganes Creek",
      "cityCode": "GEK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 63.1,
      "longitude": -156.433333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GEK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GEK?codeType=fs"
     },
     {
      "fs": "GEY",
      "iata": "GEY",
      "icao": "KGEY",
      "faa": "GEY",
      "name": "South Big Horn County Airport",
      "city": "Greybull",
      "cityCode": "GEY",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 44.5,
      "longitude": -108.05,
      "elevationFeet": 3933,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GEY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GEY?codeType=fs"
     },
     {
      "fs": "GFA",
      "iata": "GFA",
      "icao": "",
      "faa": "",
      "name": "Malmstrom Air Force Base",
      "city": "Great Falls",
      "cityCode": "GTF",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 47.5,
      "longitude": -111.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GFA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GFA?codeType=fs"
     },
     {
      "fs": "GFB",
      "iata": "GFB",
      "icao": "",
      "faa": "",
      "name": "Togiak Fishery Airport",
      "city": "Togiak Fishery",
      "cityCode": "GFB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 59.016667,
      "longitude": -160.05,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GFB?codeType=fs"
     },
     {
      "fs": "GFD",
      "iata": "GFD",
      "icao": "KGFD",
      "faa": "GFD",
      "name": "Pope Field",
      "city": "Greenfield",
      "cityCode": "GFD",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.783333,
      "longitude": -85.766667,
      "elevationFeet": 895,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GFD?codeType=fs"
     },
     {
      "fs": "GHM",
      "iata": "GHM",
      "icao": "KGHM",
      "faa": "GHM",
      "name": "Centerville Municipal Airport",
      "city": "Centerville",
      "cityCode": "GHM",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.836367,
      "longitude": -87.444471,
      "elevationFeet": 768,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GHM?codeType=fs"
     },
     {
      "fs": "GIF",
      "iata": "GIF",
      "icao": "KGIF",
      "faa": "GIF",
      "name": "Gilbert Field Airport",
      "city": "Winter Haven",
      "cityCode": "GIF",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 28.066667,
      "longitude": -81.75,
      "elevationFeet": 145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GIF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GIF?codeType=fs"
     },
     {
      "fs": "GKN",
      "iata": "GKN",
      "icao": "PAGK",
      "faa": "PAGK",
      "name": "Gulkana Airport",
      "city": "Gulkana",
      "cityCode": "GKN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 62.155278,
      "longitude": -145.452222,
      "elevationFeet": 1579,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GKN?codeType=fs"
     },
     {
      "fs": "GKT",
      "iata": "GKT",
      "icao": "KGKT",
      "faa": "GKT",
      "name": "Gatlinburg Airport",
      "city": "Gatlinburg",
      "cityCode": "GKT",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.851389,
      "longitude": -83.518611,
      "elevationFeet": 1014,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GKT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GKT?codeType=fs"
     },
     {
      "fs": "GLE",
      "iata": "GLE",
      "icao": "KGLE",
      "faa": "GLE",
      "name": "Gainesville Municipal Airport",
      "city": "Gainesville",
      "cityCode": "GLE",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.633333,
      "longitude": -97.133333,
      "elevationFeet": 839,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLE?codeType=fs"
     },
     {
      "fs": "GLQ",
      "iata": "GLQ",
      "icao": "",
      "faa": "",
      "name": "Glennallen Airport",
      "city": "Glennallen",
      "cityCode": "GLQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 62.116667,
      "longitude": -145.55,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLQ?codeType=fs"
     },
     {
      "fs": "GLS",
      "iata": "GLS",
      "icao": "KGLS",
      "faa": "GLS",
      "name": "Scholes Field",
      "city": "Galveston",
      "cityCode": "GLS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.2675,
      "longitude": -94.860278,
      "elevationFeet": 6,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLS?codeType=fs"
     },
     {
      "fs": "GLW",
      "iata": "GLW",
      "icao": "KGLW",
      "faa": "GLW",
      "name": "Glasgow Municipal Airport",
      "city": "Glasgow",
      "cityCode": "GLW",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37,
      "longitude": -85.916667,
      "elevationFeet": 715,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GLW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GLW?codeType=fs"
     },
     {
      "fs": "GMT",
      "iata": "GMT",
      "icao": "",
      "faa": "",
      "name": "Granite Mountain Airport",
      "city": "Granite Mountain",
      "cityCode": "GMT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 65.405556,
      "longitude": -161.2775,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GMT?codeType=fs"
     },
     {
      "fs": "GMV",
      "iata": "GMV",
      "icao": "",
      "faa": "",
      "name": "Monument Valley Airport",
      "city": "Monument Valley Gouldings",
      "cityCode": "GMV",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 37.001944,
      "longitude": -110.202778,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GMV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GMV?codeType=fs"
     },
     {
      "fs": "GNG",
      "iata": "GNG",
      "icao": "KGNG",
      "faa": "GNG",
      "name": "Gooding Airport",
      "city": "Gooding",
      "cityCode": "GNG",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 42.933333,
      "longitude": -114.716667,
      "elevationFeet": 3728,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GNG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GNG?codeType=fs"
     },
     {
      "fs": "GNT",
      "iata": "GNT",
      "icao": "KGNT",
      "faa": "GNT",
      "name": "Milan Airport",
      "city": "Grants",
      "cityCode": "GNT",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 35.15,
      "longitude": -107.866667,
      "elevationFeet": 6521,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GNT?codeType=fs"
     },
     {
      "fs": "GOF",
      "iata": "GOF",
      "icao": "",
      "faa": "",
      "name": "Goodfellow Air Force Base",
      "city": "San Angelo",
      "cityCode": "SJT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.466667,
      "longitude": -100.433333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GOF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GOF?codeType=fs"
     },
     {
      "fs": "GOK",
      "iata": "GOK",
      "icao": "KGOK",
      "faa": "GOK",
      "name": "Guthrie Airport",
      "city": "Guthrie",
      "cityCode": "GOK",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.883333,
      "longitude": -97.416667,
      "elevationFeet": 1068,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GOK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GOK?codeType=fs"
     },
     {
      "fs": "GOL",
      "iata": "GOL",
      "icao": "",
      "faa": "4S1",
      "name": "State Airport",
      "city": "Gold Beach",
      "cityCode": "GOL",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 42.416667,
      "longitude": -124.416667,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GOL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GOL?codeType=fs"
     },
     {
      "fs": "GQQ",
      "iata": "GQQ",
      "icao": "KGQQ",
      "faa": "GQQ",
      "name": "Galion Airport",
      "city": "Galion",
      "cityCode": "GQQ",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.736667,
      "longitude": -82.757222,
      "elevationFeet": 1224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GQQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GQQ?codeType=fs"
     },
     {
      "fs": "GRD",
      "iata": "GRD",
      "icao": "KGRD",
      "faa": "GRD",
      "name": "Greenwood County Airport",
      "city": "Greenwood",
      "cityCode": "GRD",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 34.248713,
      "longitude": -82.159153,
      "elevationFeet": 628,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRD?codeType=fs"
     },
     {
      "fs": "GRE",
      "iata": "GRE",
      "icao": "KGRE",
      "faa": "GRE",
      "name": "Greenville Municipal Airport",
      "city": "Greenville",
      "cityCode": "GRE",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.842235,
      "longitude": -89.364941,
      "elevationFeet": 533,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRE?codeType=fs"
     },
     {
      "fs": "GRM",
      "iata": "GRM",
      "icao": "KCKC",
      "faa": "CKC",
      "name": "Devils Track Airport",
      "city": "Grand Marais",
      "cityCode": "GRM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 47.838387,
      "longitude": -90.38329,
      "elevationFeet": 1795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GRM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GRM?codeType=fs"
     },
     {
      "fs": "GSB",
      "iata": "GSB",
      "icao": "KGSB",
      "faa": "GSB",
      "name": "Seymour Johnson Air Force Base",
      "city": "Goldsboro",
      "cityCode": "GSB",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.339393,
      "longitude": -77.960579,
      "elevationFeet": 80,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GSB?codeType=fs"
     },
     {
      "fs": "GTG",
      "iata": "GTG",
      "icao": "KGTG",
      "faa": "GTG",
      "name": "Grantsburg Municipal Airport",
      "city": "Grantsburg",
      "cityCode": "GTG",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 45.783333,
      "longitude": -92.683333,
      "elevationFeet": 927,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GTG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GTG?codeType=fs"
     },
     {
      "fs": "GTY",
      "iata": "GTY",
      "icao": "",
      "faa": "W05",
      "name": "Gettysburg Airport",
      "city": "Gettysburg",
      "cityCode": "GTY",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.833333,
      "longitude": -77.233333,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GTY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GTY?codeType=fs"
     },
     {
      "fs": "GUN",
      "iata": "GUN",
      "icao": "",
      "faa": "",
      "name": "Gunter Annex",
      "city": "Montgomery",
      "cityCode": "MGM",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.394464,
      "longitude": -86.262546,
      "elevationFeet": 292,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GUN?codeType=fs"
     },
     {
      "fs": "GUS",
      "iata": "GUS",
      "icao": "KGUS",
      "faa": "GUS",
      "name": "Grissom Air Force Base",
      "city": "Peru",
      "cityCode": "GUS",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.75,
      "longitude": -86.066667,
      "elevationFeet": 811,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GUS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GUS?codeType=fs"
     },
     {
      "fs": "GVE",
      "iata": "GVE",
      "icao": "KGVE",
      "faa": "GVE",
      "name": "Gordonsville Municipal Airport",
      "city": "Gordonsville",
      "cityCode": "GVE",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.133333,
      "longitude": -78.2,
      "elevationFeet": 454,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GVE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GVE?codeType=fs"
     },
     {
      "fs": "GVL",
      "iata": "GVL",
      "icao": "KGVL",
      "faa": "GVL",
      "name": "Lee Gilmer Memorial Airport",
      "city": "Gainesville",
      "cityCode": "GVL",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 34.3,
      "longitude": -83.833333,
      "elevationFeet": 1275,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GVL?codeType=fs"
     },
     {
      "fs": "GVW",
      "iata": "GVW",
      "icao": "",
      "faa": "",
      "name": "Richards-Gebaur Airport",
      "city": "Grandview",
      "cityCode": "GVW",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.883333,
      "longitude": -94.533333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GVW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GVW?codeType=fs"
     },
     {
      "fs": "GWO",
      "iata": "GWO",
      "icao": "KGWO",
      "faa": "GWO",
      "name": "Leflore Airport",
      "city": "Greenwood",
      "cityCode": "GWO",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 33.495,
      "longitude": -90.088889,
      "elevationFeet": 162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GWO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GWO?codeType=fs"
     },
     {
      "fs": "GWS",
      "iata": "GWS",
      "icao": "KGWS",
      "faa": "GWS",
      "name": "Glenwood Springs Municipal",
      "city": "Glenwood Springs",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 39.583167,
      "longitude": -107.414417,
      "elevationFeet": 5916,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GWS?codeType=fs"
     },
     {
      "fs": "GWV",
      "iata": "GWV",
      "icao": "",
      "faa": "",
      "name": "Fokker Field",
      "city": "Glendale",
      "cityCode": "GWV",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.949003,
      "longitude": -80.759405,
      "elevationFeet": 643,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/GWV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/GWV?codeType=fs"
     },
     {
      "fs": "H04",
      "iata": "",
      "icao": "",
      "faa": "H04",
      "name": "Vinita Municipal",
      "city": "Vinita",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.631389,
      "longitude": -95.277444,
      "elevationFeet": 696,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H04?codeType=fs"
     },
     {
      "fs": "H05",
      "iata": "",
      "icao": "",
      "faa": "H05",
      "name": "Wilburton Municipal",
      "city": "Wilburton",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.945417,
      "longitude": -95.496972,
      "elevationFeet": 670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H05?codeType=fs"
     },
     {
      "fs": "H07",
      "iata": "",
      "icao": "",
      "faa": "H07",
      "name": "Highland-Winet Airport",
      "city": "Highland",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.777182,
      "longitude": -89.638796,
      "elevationFeet": 534,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H07?codeType=fs"
     },
     {
      "fs": "H17",
      "iata": "",
      "icao": "",
      "faa": "H17",
      "name": "Buffalo Municipal",
      "city": "Buffalo",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.692056,
      "longitude": -93.126861,
      "elevationFeet": 1154,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H17?codeType=fs"
     },
     {
      "fs": "H19",
      "iata": "",
      "icao": "",
      "faa": "H19",
      "name": "Bowling Green Municipal",
      "city": "Bowling Green",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.399333,
      "longitude": -91.242556,
      "elevationFeet": 886,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H19?codeType=fs"
     },
     {
      "fs": "H21",
      "iata": "",
      "icao": "",
      "faa": "H21",
      "name": "Camdenton Memorial",
      "city": "Camdenton",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.046861,
      "longitude": -92.766167,
      "elevationFeet": 1062,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H21?codeType=fs"
     },
     {
      "fs": "H27",
      "iata": "",
      "icao": "",
      "faa": "H27",
      "name": "Gainesville Memorial",
      "city": "Gainesville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.725639,
      "longitude": -92.548833,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H27?codeType=fs"
     },
     {
      "fs": "H28",
      "iata": "",
      "icao": "",
      "faa": "H28",
      "name": "Whetstone International",
      "city": "Port Of Del Bonita",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 49.149889,
      "longitude": -112.875806,
      "elevationFeet": 4336,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H28?codeType=fs"
     },
     {
      "fs": "H30",
      "iata": "",
      "icao": "",
      "faa": "H30",
      "name": "Hamilton Municipal",
      "city": "Hamilton",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.938194,
      "longitude": -75.664028,
      "elevationFeet": 1134,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H30?codeType=fs"
     },
     {
      "fs": "H34",
      "iata": "",
      "icao": "",
      "faa": "H34",
      "name": "Huntsville-Madison Co Regional",
      "city": "Huntsville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.182139,
      "longitude": -93.798306,
      "elevationFeet": 1749,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H34?codeType=fs"
     },
     {
      "fs": "H35",
      "iata": "",
      "icao": "",
      "faa": "H35",
      "name": "Clarksville Municipal",
      "city": "Clarksville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.506944,
      "longitude": -93.521556,
      "elevationFeet": 481,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H35?codeType=fs"
     },
     {
      "fs": "H41",
      "iata": "",
      "icao": "",
      "faa": "H41",
      "name": "Mexico Memorial",
      "city": "Mexico",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.225278,
      "longitude": -91.832778,
      "elevationFeet": 823,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H41?codeType=fs"
     },
     {
      "fs": "H45",
      "iata": "",
      "icao": "",
      "faa": "H45",
      "name": "Seminole Municipal",
      "city": "Seminole",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.346778,
      "longitude": -96.751611,
      "elevationFeet": 1021,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H45?codeType=fs"
     },
     {
      "fs": "H49",
      "iata": "",
      "icao": "",
      "faa": "H49",
      "name": "Sackman Field",
      "city": "Columbia",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.451274,
      "longitude": -90.233441,
      "elevationFeet": 412,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H49?codeType=fs"
     },
     {
      "fs": "H57",
      "iata": "",
      "icao": "",
      "faa": "H57",
      "name": "Bismarck Memorial",
      "city": "Bismarck",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.792167,
      "longitude": -90.617917,
      "elevationFeet": 1038,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H57?codeType=fs"
     },
     {
      "fs": "H58",
      "iata": "",
      "icao": "",
      "faa": "H58",
      "name": "Owen",
      "city": "Seymour",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.183833,
      "longitude": -92.735028,
      "elevationFeet": 1600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H58?codeType=fs"
     },
     {
      "fs": "H66",
      "iata": "",
      "icao": "",
      "faa": "H66",
      "name": "Nowata Municipal",
      "city": "Nowata",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.759222,
      "longitude": -95.702556,
      "elevationFeet": 679,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H66?codeType=fs"
     },
     {
      "fs": "H68",
      "iata": "",
      "icao": "",
      "faa": "H68",
      "name": "Wagoner Municipal",
      "city": "Wagoner",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.076667,
      "longitude": -95.418333,
      "elevationFeet": 609,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H68?codeType=fs"
     },
     {
      "fs": "H71",
      "iata": "",
      "icao": "",
      "faa": "H71",
      "name": "Mid-America Industrial",
      "city": "Pryor",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.303944,
      "longitude": -95.450639,
      "elevationFeet": 622,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H71?codeType=fs"
     },
     {
      "fs": "H73",
      "iata": "",
      "icao": "",
      "faa": "H73",
      "name": "Tahlequah Municipal",
      "city": "Tahlequah",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.039167,
      "longitude": -95.045278,
      "elevationFeet": 873,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H73?codeType=fs"
     },
     {
      "fs": "H75",
      "iata": "",
      "icao": "",
      "faa": "H75",
      "name": "Hernando Village Airpark Inc",
      "city": "Hernando",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.931556,
      "longitude": -90.070361,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H75?codeType=fs"
     },
     {
      "fs": "H76",
      "iata": "",
      "icao": "",
      "faa": "H76",
      "name": "Pawhuska Municipal",
      "city": "Pawhuska",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.71725,
      "longitude": -96.455694,
      "elevationFeet": 1000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H76?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H76?codeType=fs"
     },
     {
      "fs": "H79",
      "iata": "",
      "icao": "",
      "faa": "H79",
      "name": "Eldon Model",
      "city": "Eldon",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.45625,
      "longitude": -92.615722,
      "elevationFeet": 909,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H79?codeType=fs"
     },
     {
      "fs": "H80",
      "iata": "",
      "icao": "",
      "faa": "H80",
      "name": "Field Of Dreams",
      "city": "Hale",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 44.5,
      "longitude": -83.875,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H80?codeType=fs"
     },
     {
      "fs": "H88",
      "iata": "",
      "icao": "",
      "faa": "H88",
      "name": "Fredericktown Regional",
      "city": "Fredericktown",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.65825,
      "longitude": -90.323139,
      "elevationFeet": 880,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H88?codeType=fs"
     },
     {
      "fs": "H92",
      "iata": "",
      "icao": "",
      "faa": "H92",
      "name": "Hominy Municipal",
      "city": "Hominy",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.434028,
      "longitude": -96.386278,
      "elevationFeet": 825,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H92?codeType=fs"
     },
     {
      "fs": "H96",
      "iata": "",
      "icao": "",
      "faa": "H96",
      "name": "Benton Municipal",
      "city": "Benton",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.0675,
      "longitude": -88.944167,
      "elevationFeet": 444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H96?codeType=fs"
     },
     {
      "fs": "H97",
      "iata": "",
      "icao": "",
      "faa": "H97",
      "name": "Pawnee Municipal",
      "city": "Pawnee",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 36.383861,
      "longitude": -96.903139,
      "elevationFeet": 875,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/H97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/H97?codeType=fs"
     },
     {
      "fs": "HAB",
      "iata": "HAB",
      "icao": "KHAB",
      "faa": "HAB",
      "name": "Marion County Airport",
      "city": "Hamilton",
      "cityCode": "HAB",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.15,
      "longitude": -88.1,
      "elevationFeet": 442,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAB?codeType=fs"
     },
     {
      "fs": "HAF",
      "iata": "HAF",
      "icao": "KHAF",
      "faa": "HAF",
      "name": "Half Moon Airport",
      "city": "Half Moon",
      "cityCode": "HAF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.513401,
      "longitude": -122.500999,
      "elevationFeet": 66,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAF?codeType=fs"
     },
     {
      "fs": "HAI",
      "iata": "HAI",
      "icao": "KHAI",
      "faa": "HAI",
      "name": "Dr. Haines Airport",
      "city": "Three Rivers",
      "cityCode": "HAI",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.95,
      "longitude": -85.633333,
      "elevationFeet": 824,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAI?codeType=fs"
     },
     {
      "fs": "HAX",
      "iata": "HAX",
      "icao": "KHAX",
      "faa": "HAX",
      "name": "Hatbox Field",
      "city": "Muskogee",
      "cityCode": "MKO",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.75,
      "longitude": -95.416667,
      "elevationFeet": 627,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HAX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HAX?codeType=fs"
     },
     {
      "fs": "HBB",
      "iata": "HBB",
      "icao": "",
      "faa": "",
      "name": "Industrial Airpark",
      "city": "Hobbs",
      "cityCode": "HOB",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 32.7,
      "longitude": -103.133333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HBB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HBB?codeType=fs"
     },
     {
      "fs": "HBC",
      "iata": "HBC",
      "icao": "",
      "faa": "",
      "name": "Hanus Bay Airport",
      "city": "Hanus Bay",
      "cityCode": "HBC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 57.5,
      "longitude": -135.916667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HBC?codeType=fs"
     },
     {
      "fs": "HBH",
      "iata": "HBH",
      "icao": "",
      "faa": "",
      "name": "Entrance Island Sea Plane Base",
      "city": "Entrance Island",
      "cityCode": "HBH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 57.412259,
      "longitude": -133.439502,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HBH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HBH?codeType=fs"
     },
     {
      "fs": "HBO",
      "iata": "HBO",
      "icao": "",
      "faa": "",
      "name": "Humboldt Municipal Airport",
      "city": "Humboldt",
      "cityCode": "HBO",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.166667,
      "longitude": -95.95,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HBO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HBO?codeType=fs"
     },
     {
      "fs": "HBR",
      "iata": "HBR",
      "icao": "KHBR",
      "faa": "HBR",
      "name": "Hobart Airport",
      "city": "Hobart",
      "cityCode": "HBR",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.016667,
      "longitude": -99.1,
      "elevationFeet": 1564,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HBR?codeType=fs"
     },
     {
      "fs": "HCB",
      "iata": "HCB",
      "icao": "",
      "faa": "",
      "name": "Shoal Cove Airport",
      "city": "Shoal Cove",
      "cityCode": "HCB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 55.45,
      "longitude": -131.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HCB?codeType=fs"
     },
     {
      "fs": "HCW",
      "iata": "HCW",
      "icao": "",
      "faa": "47J",
      "name": "Cheraw Airport",
      "city": "Cheraw",
      "cityCode": "HCW",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 34.7,
      "longitude": -79.883333,
      "elevationFeet": 239,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HCW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HCW?codeType=fs"
     },
     {
      "fs": "HDA",
      "iata": "HDA",
      "icao": "",
      "faa": "",
      "name": "Hidden Falls Airport",
      "city": "Hidden Falls",
      "cityCode": "HDA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 57.2,
      "longitude": -134.85,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HDA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HDA?codeType=fs"
     },
     {
      "fs": "HDE",
      "iata": "HDE",
      "icao": "KHDE",
      "faa": "HDE",
      "name": "Brewster Field",
      "city": "Holdrege",
      "cityCode": "HDE",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.433333,
      "longitude": -99.383333,
      "elevationFeet": 2309,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HDE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HDE?codeType=fs"
     },
     {
      "fs": "HDH",
      "iata": "HDH",
      "icao": "PHDH",
      "faa": "PHDH",
      "name": "Dillingham Airfield",
      "city": "Oahu",
      "cityCode": "HDH",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.684",
      "utcOffsetHours": -10,
      "latitude": 21.577203,
      "longitude": -158.191203,
      "elevationFeet": 3,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HDH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HDH?codeType=fs"
     },
     {
      "fs": "HED",
      "iata": "HED",
      "icao": "",
      "faa": "HED",
      "name": "Herendeen Airport",
      "city": "Herendeen",
      "cityCode": "HED",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 55.833333,
      "longitude": -160.833333,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HED?codeType=fs"
     },
     {
      "fs": "HEE",
      "iata": "HEE",
      "icao": "KHEE",
      "faa": "HEE",
      "name": "Thompson-Robbins Airport",
      "city": "Helena",
      "cityCode": "HEE",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.533333,
      "longitude": -90.6,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HEE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HEE?codeType=fs"
     },
     {
      "fs": "HEY",
      "iata": "HEY",
      "icao": "",
      "faa": "",
      "name": "Hanchey Army Heliport",
      "city": "Ozark",
      "cityCode": "OZR",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.416667,
      "longitude": -84.533333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HEY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HEY?codeType=fs"
     },
     {
      "fs": "HEZ",
      "iata": "HEZ",
      "icao": "KHEZ",
      "faa": "HEZ",
      "name": "Hardy-Anders Airport",
      "city": "Natchez",
      "cityCode": "HEZ",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.614722,
      "longitude": -91.296389,
      "elevationFeet": 272,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HEZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HEZ?codeType=fs"
     },
     {
      "fs": "HFF",
      "iata": "HFF",
      "icao": "KHFF",
      "faa": "HFF",
      "name": "Mackall Army Air Field",
      "city": "Hoffman",
      "cityCode": "HFF",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.03628,
      "longitude": -79.497712,
      "elevationFeet": 341,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HFF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HFF?codeType=fs"
     },
     {
      "fs": "HGT",
      "iata": "HGT",
      "icao": "",
      "faa": "",
      "name": "Hunter Army Air Field",
      "city": "Jolon",
      "cityCode": "HGT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 35.966667,
      "longitude": -121.15,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HGT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HGT?codeType=fs"
     },
     {
      "fs": "HGZ",
      "iata": "HGZ",
      "icao": "",
      "faa": "",
      "name": "Hogatza Airport",
      "city": "Hogatza",
      "cityCode": "HGZ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 66.191667,
      "longitude": -155.668889,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HGZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HGZ?codeType=fs"
     },
     {
      "fs": "HHI",
      "iata": "HHI",
      "icao": "PHHI",
      "faa": "PHHI",
      "name": "Wheeler Air Force Base",
      "city": "Wahiawa",
      "cityCode": "HHI",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.684",
      "utcOffsetHours": -10,
      "latitude": 21.480308,
      "longitude": -158.036409,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HHI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HHI?codeType=fs"
     },
     {
      "fs": "HIF",
      "iata": "HIF",
      "icao": "KHIF",
      "faa": "HIF",
      "name": "Hill Air Force Base",
      "city": "Ogden",
      "cityCode": "OGD",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 41.123902,
      "longitude": -111.973041,
      "elevationFeet": 4791,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HIF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HIF?codeType=fs"
     },
     {
      "fs": "HIK",
      "iata": "HIK",
      "icao": "",
      "faa": "",
      "name": "Hickam Air Force Base",
      "city": "Honolulu",
      "cityCode": "HNL",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.684",
      "utcOffsetHours": -10,
      "latitude": 21.328994,
      "longitude": -157.937601,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HIK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HIK?codeType=fs"
     },
     {
      "fs": "HKA",
      "iata": "HKA",
      "icao": "KHKA",
      "faa": "HKA",
      "name": "Blytheville Municipal Airport",
      "city": "Blytheville",
      "cityCode": "BYH",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 35.933333,
      "longitude": -89.916667,
      "elevationFeet": 255,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HKA?codeType=fs"
     },
     {
      "fs": "HKY",
      "iata": "HKY",
      "icao": "KHKY",
      "faa": "HKY",
      "name": "Hickory Airport",
      "city": "Hickory",
      "cityCode": "HKY",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.738611,
      "longitude": -81.391667,
      "elevationFeet": 1189,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HKY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HKY?codeType=fs"
     },
     {
      "fs": "HLB",
      "iata": "HLB",
      "icao": "KHLB",
      "faa": "HLB",
      "name": "Hillenbrand Airport",
      "city": "Batesville",
      "cityCode": "HLB",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.3,
      "longitude": -85.216667,
      "elevationFeet": 973,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLB?codeType=fs"
     },
     {
      "fs": "HLC",
      "iata": "HLC",
      "icao": "KHLC",
      "faa": "HLC",
      "name": "Hill City Airport",
      "city": "Hill City",
      "cityCode": "HLC",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.366667,
      "longitude": -99.85,
      "elevationFeet": 2230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLC?codeType=fs"
     },
     {
      "fs": "HLG",
      "iata": "HLG",
      "icao": "KHLG",
      "faa": "HLG",
      "name": "Ohio County Airport",
      "city": "Wheeling",
      "cityCode": "HLG",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.183333,
      "longitude": -80.65,
      "elevationFeet": 1194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLG?codeType=fs"
     },
     {
      "fs": "HLI",
      "iata": "HLI",
      "icao": "",
      "faa": "1C9",
      "name": "Hollister Airport",
      "city": "Hollister",
      "cityCode": "HLI",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 36.85,
      "longitude": -121.4,
      "elevationFeet": 151,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLI?codeType=fs"
     },
     {
      "fs": "HLM",
      "iata": "HLM",
      "icao": "KHLM",
      "faa": "HLM",
      "name": "Park Township Airport",
      "city": "Holland",
      "cityCode": "HLM",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.783333,
      "longitude": -86.116667,
      "elevationFeet": 603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLM?codeType=fs"
     },
     {
      "fs": "HLR",
      "iata": "HLR",
      "icao": "KHLR",
      "faa": "HLR",
      "name": "Hood Army Air Field",
      "city": "Killeen",
      "cityCode": "ILE",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.138698,
      "longitude": -97.714511,
      "elevationFeet": 899,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HLR?codeType=fs"
     },
     {
      "fs": "HMN",
      "iata": "HMN",
      "icao": "KHMN",
      "faa": "HMN",
      "name": "Holloman Air Force Base",
      "city": "Alamogordo",
      "cityCode": "ALM",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 32.852489,
      "longitude": -106.107011,
      "elevationFeet": 4068,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HMN?codeType=fs"
     },
     {
      "fs": "HMT",
      "iata": "HMT",
      "icao": "KHMT",
      "faa": "HMT",
      "name": "Ryan Field",
      "city": "Hemet",
      "cityCode": "HMT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.733333,
      "longitude": -117.025,
      "elevationFeet": 1512,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HMT?codeType=fs"
     },
     {
      "fs": "HNB",
      "iata": "HNB",
      "icao": "KHNB",
      "faa": "HNB",
      "name": "Huntingburg Municipal Airport",
      "city": "Huntingburg",
      "cityCode": "HNB",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.3,
      "longitude": -86.95,
      "elevationFeet": 529,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNB?codeType=fs"
     },
     {
      "fs": "HNE",
      "iata": "HNE",
      "icao": "",
      "faa": "HNE",
      "name": "Tabneta Pass Airport",
      "city": "Tabneta Pass Lodge",
      "cityCode": "HNE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 61.883333,
      "longitude": -147.333333,
      "elevationFeet": 2960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNE?codeType=fs"
     },
     {
      "fs": "HNX",
      "iata": "HNX",
      "icao": "",
      "faa": "",
      "name": "Hanna Airport",
      "city": "Hanna",
      "cityCode": "HNX",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 41.833333,
      "longitude": -106.5,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HNX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HNX?codeType=fs"
     },
     {
      "fs": "HOL",
      "iata": "HOL",
      "icao": "",
      "faa": "",
      "name": "Holikachu Airport",
      "city": "Holikachu",
      "cityCode": "HOL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 62.866667,
      "longitude": -159.65,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HOL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HOL?codeType=fs"
     },
     {
      "fs": "HPT",
      "iata": "HPT",
      "icao": "KHPT",
      "faa": "HPT",
      "name": "Hampton Municipal Airport",
      "city": "Hampton",
      "cityCode": "HPT",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.75,
      "longitude": -93.2,
      "elevationFeet": 1176,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HPT?codeType=fs"
     },
     {
      "fs": "HPV",
      "iata": "HPV",
      "icao": "HI01",
      "faa": "HI01",
      "name": "Princeville Airport",
      "city": "Kauai Island",
      "cityCode": "LIH",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.684",
      "utcOffsetHours": -10,
      "latitude": 22.210378,
      "longitude": -159.444808,
      "elevationFeet": 297,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HPV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HPV?codeType=fs"
     },
     {
      "fs": "HPY",
      "iata": "HPY",
      "icao": "KHPY",
      "faa": "HPY",
      "name": "Baytown Airport",
      "city": "Baytown",
      "cityCode": "HPY",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.774058,
      "longitude": -94.958621,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HPY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HPY?codeType=fs"
     },
     {
      "fs": "HRR0",
      "iata": "",
      "icao": "",
      "faa": "HRR",
      "name": "Healy River",
      "city": "Healy",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 64.012083,
      "longitude": -148.989833,
      "elevationFeet": 1294,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HRR0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HRR0?codeType=fs"
     },
     {
      "fs": "HSB",
      "iata": "HSB",
      "icao": "KHSB",
      "faa": "HSB",
      "name": "Raleigh Airport",
      "city": "Harrisburg",
      "cityCode": "HSB",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.733333,
      "longitude": -88.533333,
      "elevationFeet": 396,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HSB?codeType=fs"
     },
     {
      "fs": "HST",
      "iata": "HST",
      "icao": "KHST",
      "faa": "HST",
      "name": "Homestead Air Force Base",
      "city": "Homestead",
      "cityCode": "HST",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 25.4886,
      "longitude": -80.383598,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HST?codeType=fs"
     },
     {
      "fs": "HTH",
      "iata": "HTH",
      "icao": "KHTH",
      "faa": "HTH",
      "name": "Hawthorne Airport",
      "city": "Hawthorne",
      "cityCode": "HTH",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 38.533333,
      "longitude": -118.633333,
      "elevationFeet": 4215,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HTH?codeType=fs"
     },
     {
      "fs": "HTL",
      "iata": "HTL",
      "icao": "KHTL",
      "faa": "HTL",
      "name": "Roscommon County Airport",
      "city": "Houghton Lake",
      "cityCode": "HTL",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 44.448056,
      "longitude": -84.711111,
      "elevationFeet": 1150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HTL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HTL?codeType=fs"
     },
     {
      "fs": "HTV",
      "iata": "HTV",
      "icao": "KUTS",
      "faa": "UTS",
      "name": "Huntsville Airport",
      "city": "Huntsville",
      "cityCode": "HTV",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.716667,
      "longitude": -95.55,
      "elevationFeet": 363,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HTV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HTV?codeType=fs"
     },
     {
      "fs": "HTW",
      "iata": "HTW",
      "icao": "KHTW",
      "faa": "HTW",
      "name": "Huntington County Airport",
      "city": "Chesapeake",
      "cityCode": "HTW",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 36.833333,
      "longitude": -76.283333,
      "elevationFeet": 568,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HTW?codeType=fs"
     },
     {
      "fs": "HUA",
      "iata": "HUA",
      "icao": "KHUA",
      "faa": "HUA",
      "name": "Redstone Army Air Field",
      "city": "Huntsville",
      "cityCode": "HSV",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 34.678679,
      "longitude": -86.684783,
      "elevationFeet": 665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUA?codeType=fs"
     },
     {
      "fs": "HUD",
      "iata": "HUD",
      "icao": "",
      "faa": "0K7",
      "name": "Humboldt Airport",
      "city": "Humboldt",
      "cityCode": "HUD",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.733333,
      "longitude": -94.216667,
      "elevationFeet": 1110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUD?codeType=fs"
     },
     {
      "fs": "HUF",
      "iata": "HUF",
      "icao": "KHUF",
      "faa": "HUF",
      "name": "Hulman Field",
      "street1": "581 South Airport Street",
      "street2": "",
      "city": "Terre Haute",
      "cityCode": "HUF",
      "stateCode": "IN",
      "postalCode": "47803",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "INZ051",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.454444,
      "longitude": -87.3075,
      "elevationFeet": 589,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUF?codeType=fs"
     },
     {
      "fs": "HUL",
      "iata": "HUL",
      "icao": "KHUL",
      "faa": "HUL",
      "name": "Houlton International Airport",
      "city": "Houlton",
      "cityCode": "HUL",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 46.133333,
      "longitude": -67.8,
      "elevationFeet": 489,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUL?codeType=fs"
     },
     {
      "fs": "HUT",
      "iata": "HUT",
      "icao": "KHUT",
      "faa": "HUT",
      "name": "Hutchinson Airport",
      "city": "Hutchinson",
      "cityCode": "HUT",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.068056,
      "longitude": -97.861111,
      "elevationFeet": 1542,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HUT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HUT?codeType=fs"
     },
     {
      "fs": "HVE",
      "iata": "HVE",
      "icao": "KHVE",
      "faa": "HVE",
      "name": "Hanksville Intermediate Airport",
      "city": "Hanksville",
      "cityCode": "HVE",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 38.366667,
      "longitude": -110.716667,
      "elevationFeet": 4444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HVE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HVE?codeType=fs"
     },
     {
      "fs": "HVS",
      "iata": "HVS",
      "icao": "KHVS",
      "faa": "HVS",
      "name": "Hartsville Municipal Airport",
      "city": "Hartsville",
      "cityCode": "HVS",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 34.383333,
      "longitude": -80.066667,
      "elevationFeet": 364,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HVS?codeType=fs"
     },
     {
      "fs": "HWI",
      "iata": "HWI",
      "icao": "",
      "faa": "",
      "name": "Hawk Inlet Sea Plane Base",
      "city": "Hawk Inlet",
      "cityCode": "HWI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 58.126224,
      "longitude": -134.757813,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HWI?codeType=fs"
     },
     {
      "fs": "HWO",
      "iata": "HWO",
      "icao": "KHWO",
      "faa": "HWO",
      "name": "North Perry Airport",
      "city": "Hollywood",
      "cityCode": "HWO",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 26.002428,
      "longitude": -80.238918,
      "elevationFeet": 6,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HWO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HWO?codeType=fs"
     },
     {
      "fs": "HZL",
      "iata": "HZL",
      "icao": "KHZL",
      "faa": "HZL",
      "name": "Hazleton Airport",
      "city": "Hazleton",
      "cityCode": "HZL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.986389,
      "longitude": -75.991111,
      "elevationFeet": 1603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/HZL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/HZL?codeType=fs"
     },
     {
      "fs": "I05",
      "iata": "",
      "icao": "",
      "faa": "I05",
      "name": "Sturgis Municipal",
      "city": "Sturgis",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.608333,
      "longitude": -87.968333,
      "elevationFeet": 372,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I05?codeType=fs"
     },
     {
      "fs": "I08",
      "iata": "",
      "icao": "",
      "faa": "I08",
      "name": "Cabin Creek Usfs",
      "city": "Big Creek Ranger Station",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 45.23525,
      "longitude": -115.039889,
      "elevationFeet": 4289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I08?codeType=fs"
     },
     {
      "fs": "I10",
      "iata": "",
      "icao": "",
      "faa": "I10",
      "name": "Noble Co",
      "city": "Caldwell",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.809611,
      "longitude": -81.563194,
      "elevationFeet": 879,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I10?codeType=fs"
     },
     {
      "fs": "I12",
      "iata": "",
      "icao": "",
      "faa": "I12",
      "name": "Sidney Municipal",
      "city": "Sidney",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.312806,
      "longitude": -84.160111,
      "elevationFeet": 1044,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I12?codeType=fs"
     },
     {
      "fs": "I16",
      "iata": "",
      "icao": "",
      "faa": "I16",
      "name": "Kee",
      "city": "Pineville",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.604444,
      "longitude": -81.642778,
      "elevationFeet": 1783,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I16?codeType=fs"
     },
     {
      "fs": "I17",
      "iata": "",
      "icao": "",
      "faa": "I17",
      "name": "Piqua",
      "city": "Piqua",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.296944,
      "longitude": -84.384444,
      "elevationFeet": 994,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I17?codeType=fs"
     },
     {
      "fs": "I18",
      "iata": "",
      "icao": "",
      "faa": "I18",
      "name": "Jackson Co",
      "city": "Ravenswood",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.047778,
      "longitude": -81.844722,
      "elevationFeet": 758,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I18?codeType=fs"
     },
     {
      "fs": "I19",
      "iata": "",
      "icao": "",
      "faa": "I19",
      "name": "Greene Co-Jackson Regional",
      "city": "Dayton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.767278,
      "longitude": -84.052389,
      "elevationFeet": 949,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I19?codeType=fs"
     },
     {
      "fs": "I21",
      "iata": "",
      "icao": "",
      "faa": "I21",
      "name": "Indianapolis Brookside Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.903258,
      "longitude": -85.922117,
      "elevationFeet": 852,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I21?codeType=fs"
     },
     {
      "fs": "I22",
      "iata": "",
      "icao": "",
      "faa": "I22",
      "name": "Randolph Co",
      "city": "Winchester",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.1885,
      "longitude": -85.008528,
      "elevationFeet": 1117,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I22?codeType=fs"
     },
     {
      "fs": "I23",
      "iata": "",
      "icao": "",
      "faa": "I23",
      "name": "Fayette Co",
      "city": "Washington Court House",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.604028,
      "longitude": -83.45525,
      "elevationFeet": 982,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I23?codeType=fs"
     },
     {
      "fs": "I25",
      "iata": "",
      "icao": "",
      "faa": "I25",
      "name": "Welch Municipal",
      "city": "Welch",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.417806,
      "longitude": -81.639944,
      "elevationFeet": 2118,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I25?codeType=fs"
     },
     {
      "fs": "I27",
      "iata": "",
      "icao": "",
      "faa": "I27",
      "name": "Elkader",
      "city": "Elkader",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.969306,
      "longitude": -91.506917,
      "elevationFeet": 932,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I27?codeType=fs"
     },
     {
      "fs": "I32",
      "iata": "",
      "icao": "",
      "faa": "I32",
      "name": "Morehead-Rowan Co",
      "city": "Morehead",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.134139,
      "longitude": -83.579639,
      "elevationFeet": 845,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I32?codeType=fs"
     },
     {
      "fs": "I34",
      "iata": "",
      "icao": "",
      "faa": "I34",
      "name": "Greensburg-Decatur Co",
      "city": "Greensburg",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.419111,
      "longitude": -85.575278,
      "elevationFeet": 912,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I34?codeType=fs"
     },
     {
      "fs": "I35",
      "iata": "",
      "icao": "",
      "faa": "I35",
      "name": "Tucker-Guthrie Memorial",
      "city": "Harlan",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 36.948111,
      "longitude": -83.460167,
      "elevationFeet": 1551,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I35?codeType=fs"
     },
     {
      "fs": "I40",
      "iata": "",
      "icao": "",
      "faa": "I40",
      "name": "Downing",
      "city": "Coshocton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.391806,
      "longitude": -81.883833,
      "elevationFeet": 979,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I40?codeType=fs"
     },
     {
      "fs": "I41",
      "iata": "",
      "icao": "",
      "faa": "I41",
      "name": "Newlon",
      "city": "Huntington",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.520278,
      "longitude": -82.437611,
      "elevationFeet": 550,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I41?codeType=fs"
     },
     {
      "fs": "I42",
      "iata": "",
      "icao": "",
      "faa": "I42",
      "name": "Paoli Municipal",
      "city": "Paoli",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.583889,
      "longitude": -86.574889,
      "elevationFeet": 817,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I42?codeType=fs"
     },
     {
      "fs": "I43",
      "iata": "",
      "icao": "",
      "faa": "I43",
      "name": "Rhodes",
      "city": "Jackson",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.113528,
      "longitude": -82.678556,
      "elevationFeet": 726,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I43?codeType=fs"
     },
     {
      "fs": "I44",
      "iata": "",
      "icao": "",
      "faa": "I44",
      "name": "Dayton-New Lebanon",
      "city": "Dayton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.908889,
      "longitude": -84.432778,
      "elevationFeet": 925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I44?codeType=fs"
     },
     {
      "fs": "I48",
      "iata": "",
      "icao": "",
      "faa": "I48",
      "name": "Carthage",
      "city": "Carthage",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.425444,
      "longitude": -91.301444,
      "elevationFeet": 695,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I48?codeType=fs"
     },
     {
      "fs": "I50",
      "iata": "",
      "icao": "",
      "faa": "I50",
      "name": "Stanton",
      "city": "Stanton",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.850806,
      "longitude": -83.957528,
      "elevationFeet": 651,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I50?codeType=fs"
     },
     {
      "fs": "I53",
      "iata": "",
      "icao": "",
      "faa": "I53",
      "name": "Liberty-Casey Co",
      "city": "Liberty",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.395139,
      "longitude": -85.138444,
      "elevationFeet": 1040,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I53?codeType=fs"
     },
     {
      "fs": "I54",
      "iata": "",
      "icao": "",
      "faa": "I54",
      "name": "Mad River",
      "city": "Tremont City",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.050583,
      "longitude": -83.935417,
      "elevationFeet": 958,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I54?codeType=fs"
     },
     {
      "fs": "I61",
      "iata": "",
      "icao": "",
      "faa": "I61",
      "name": "Hagerstown",
      "city": "Hagerstown",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.941667,
      "longitude": -85.283333,
      "elevationFeet": 1000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I61?codeType=fs"
     },
     {
      "fs": "I62",
      "iata": "",
      "icao": "",
      "faa": "I62",
      "name": "Brookville",
      "city": "Brookville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.975528,
      "longitude": -84.582806,
      "elevationFeet": 1037,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I62?codeType=fs"
     },
     {
      "fs": "I63",
      "iata": "",
      "icao": "",
      "faa": "I63",
      "name": "Mt Sterling Municipal",
      "city": "Mt Sterling",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.025,
      "longitude": -90.841667,
      "elevationFeet": 732,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I63?codeType=fs"
     },
     {
      "fs": "I64",
      "iata": "",
      "icao": "",
      "faa": "I64",
      "name": "Wakeman Airport",
      "city": "Wakeman",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.293742,
      "longitude": -82.371286,
      "elevationFeet": 839,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I64?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I64?codeType=fs"
     },
     {
      "fs": "I66",
      "iata": "",
      "icao": "",
      "faa": "I66",
      "name": "Clinton",
      "city": "Wilmington",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.528611,
      "longitude": -83.980556,
      "elevationFeet": 1033,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I66?codeType=fs"
     },
     {
      "fs": "I67",
      "iata": "",
      "icao": "",
      "faa": "I67",
      "name": "Cincinnati West Airport",
      "city": "Harrison",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.257844,
      "longitude": -84.771005,
      "elevationFeet": 581,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I67?codeType=fs"
     },
     {
      "fs": "I68",
      "iata": "",
      "icao": "",
      "faa": "I68",
      "name": "Lebanon-Warren Co",
      "city": "Lebanon",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.571722,
      "longitude": -84.268472,
      "elevationFeet": 898,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I68?codeType=fs"
     },
     {
      "fs": "I69",
      "iata": "",
      "icao": "",
      "faa": "I69",
      "name": "Clermont County Airport",
      "city": "Batavia",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.078659,
      "longitude": -84.207477,
      "elevationFeet": 831,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I69?codeType=fs"
     },
     {
      "fs": "I71",
      "iata": "",
      "icao": "",
      "faa": "I71",
      "name": "Morgan Co",
      "city": "Mc Connelsville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.692389,
      "longitude": -81.831889,
      "elevationFeet": 1000,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I71?codeType=fs"
     },
     {
      "fs": "I72",
      "iata": "",
      "icao": "",
      "faa": "I72",
      "name": "Westfield Airport",
      "city": "Westfield",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.05533,
      "longitude": -86.152902,
      "elevationFeet": 919,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I72?codeType=fs"
     },
     {
      "fs": "I73",
      "iata": "",
      "icao": "",
      "faa": "I73",
      "name": "Moraine Air Park",
      "city": "Dayton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.825583,
      "longitude": -84.30775,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I73?codeType=fs"
     },
     {
      "fs": "I74",
      "iata": "",
      "icao": "",
      "faa": "I74",
      "name": "Grimes",
      "city": "Urbana",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.242833,
      "longitude": -83.798778,
      "elevationFeet": 1060,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I74?codeType=fs"
     },
     {
      "fs": "I75",
      "iata": "",
      "icao": "",
      "faa": "I75",
      "name": "Osceola Municipal",
      "city": "Osceola",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.072194,
      "longitude": -93.746611,
      "elevationFeet": 1110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I75?codeType=fs"
     },
     {
      "fs": "I76",
      "iata": "",
      "icao": "",
      "faa": "I76",
      "name": "Peru Municipal",
      "city": "Peru",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.813194,
      "longitude": -86.263833,
      "elevationFeet": 779,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I76?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I76?codeType=fs"
     },
     {
      "fs": "I78",
      "iata": "",
      "icao": "",
      "faa": "I78",
      "name": "Union Co",
      "city": "Columbus",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.296944,
      "longitude": -83.366111,
      "elevationFeet": 1021,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I78?codeType=fs"
     },
     {
      "fs": "I80",
      "iata": "",
      "icao": "",
      "faa": "I80",
      "name": "Noblesville Airport",
      "city": "Noblesville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.005449,
      "longitude": -85.959246,
      "elevationFeet": 821,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I80?codeType=fs"
     },
     {
      "fs": "I83",
      "iata": "",
      "icao": "",
      "faa": "I83",
      "name": "Salem Municipal",
      "city": "Salem",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.620028,
      "longitude": -86.199778,
      "elevationFeet": 822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I83?codeType=fs"
     },
     {
      "fs": "I84",
      "iata": "",
      "icao": "",
      "faa": "I84",
      "name": "Crooksville",
      "city": "Crooksville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.770139,
      "longitude": -82.23475,
      "elevationFeet": 777,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I84?codeType=fs"
     },
     {
      "fs": "I86",
      "iata": "",
      "icao": "",
      "faa": "I86",
      "name": "Perry Co",
      "city": "New Lexington",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.765972,
      "longitude": -82.327861,
      "elevationFeet": 1051,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I86?codeType=fs"
     },
     {
      "fs": "I89",
      "iata": "",
      "icao": "",
      "faa": "I89",
      "name": "Fayette",
      "city": "Fayetteville",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.117778,
      "longitude": -81.14825,
      "elevationFeet": 1960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I89?codeType=fs"
     },
     {
      "fs": "I91",
      "iata": "",
      "icao": "",
      "faa": "I91",
      "name": "Boonville",
      "city": "Boonville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.125444,
      "longitude": -87.327861,
      "elevationFeet": 380,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I91?codeType=fs"
     },
     {
      "fs": "I93",
      "iata": "",
      "icao": "",
      "faa": "I93",
      "name": "Breckinridge Co",
      "city": "Hardinsburg",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.800583,
      "longitude": -86.519222,
      "elevationFeet": 735,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I93?codeType=fs"
     },
     {
      "fs": "I94",
      "iata": "",
      "icao": "",
      "faa": "I94",
      "name": "Mc Donald",
      "city": "Taplin",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.876056,
      "longitude": -81.98175,
      "elevationFeet": 730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I94?codeType=fs"
     },
     {
      "fs": "I95",
      "iata": "",
      "icao": "",
      "faa": "I95",
      "name": "Hardin Co",
      "city": "Kenton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.707194,
      "longitude": -83.735972,
      "elevationFeet": 1024,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I95?codeType=fs"
     },
     {
      "fs": "I96",
      "iata": "",
      "icao": "",
      "faa": "I96",
      "name": "Columbia-Adair Co",
      "city": "Columbia",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.103389,
      "longitude": -85.471833,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I96?codeType=fs"
     },
     {
      "fs": "I99",
      "iata": "",
      "icao": "",
      "faa": "I99",
      "name": "Alexandria",
      "city": "Alexandria",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.375139,
      "longitude": -85.675306,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/I99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/I99?codeType=fs"
     },
     {
      "fs": "ICL",
      "iata": "ICL",
      "icao": "KICL",
      "faa": "ICL",
      "name": "Schenk Field",
      "city": "Clarinda",
      "cityCode": "ICL",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.721862,
      "longitude": -95.026542,
      "elevationFeet": 987,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ICL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ICL?codeType=fs"
     },
     {
      "fs": "ICY",
      "iata": "ICY",
      "icao": "",
      "faa": "",
      "name": "Icy Bay Airport",
      "city": "Icy Bay",
      "cityCode": "ICY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 60,
      "longitude": -141.25,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ICY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ICY?codeType=fs"
     },
     {
      "fs": "IDG",
      "iata": "IDG",
      "icao": "KIDG",
      "faa": "IDG",
      "name": "Ida Grove Municipal Airport",
      "city": "Ida Grove",
      "cityCode": "IDG",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.35,
      "longitude": -95.466667,
      "elevationFeet": 1245,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IDG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IDG?codeType=fs"
     },
     {
      "fs": "IDP",
      "iata": "IDP",
      "icao": "KIDP",
      "faa": "IDP",
      "name": "Independence Airport",
      "city": "Independence",
      "cityCode": "IDP",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 37.233333,
      "longitude": -95.7,
      "elevationFeet": 100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IDP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IDP?codeType=fs"
     },
     {
      "fs": "IFA",
      "iata": "IFA",
      "icao": "KIFA",
      "faa": "IFA",
      "name": "Iowa Falls Airport",
      "city": "Iowa Falls",
      "cityCode": "IFA",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.516667,
      "longitude": -93.266667,
      "elevationFeet": 1137,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IFA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IFA?codeType=fs"
     },
     {
      "fs": "IJX",
      "iata": "IJX",
      "icao": "KIJX",
      "faa": "IJX",
      "name": "Jacksonville Municipal Airport",
      "city": "Jacksonville",
      "cityCode": "IJX",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.774167,
      "longitude": -90.237222,
      "elevationFeet": 624,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IJX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IJX?codeType=fs"
     },
     {
      "fs": "IKB",
      "iata": "IKB",
      "icao": "KUKF",
      "faa": "UKF",
      "name": "Wilkes County Airport",
      "city": "Wilkesboro",
      "cityCode": "IKB",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 36.222801,
      "longitude": -81.098297,
      "elevationFeet": 1301,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IKB?codeType=fs"
     },
     {
      "fs": "IKK",
      "iata": "IKK",
      "icao": "KIKK",
      "faa": "IKK",
      "name": "Greater Kankakee Airport",
      "city": "Kankakee",
      "cityCode": "IKK",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.383333,
      "longitude": -88.25,
      "elevationFeet": 629,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IKK?codeType=fs"
     },
     {
      "fs": "ILE",
      "iata": "ILE",
      "icao": "KILE",
      "faa": "ILE",
      "name": "Skylark Field",
      "street1": "1525 Airport Drive",
      "city": "Killeen",
      "cityCode": "ILE",
      "stateCode": "TX",
      "postalCode": "76543",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "TXZ158",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.086389,
      "longitude": -97.686667,
      "elevationFeet": 848,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ILE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ILE?codeType=fs"
     },
     {
      "fs": "ILL",
      "iata": "ILL",
      "icao": "KILL",
      "faa": "ILL",
      "name": "Willmar Airport",
      "city": "Willmar",
      "cityCode": "ILL",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 45.115278,
      "longitude": -95.085278,
      "elevationFeet": 1127,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ILL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ILL?codeType=fs"
     },
     {
      "fs": "IML",
      "iata": "IML",
      "icao": "KIML",
      "faa": "IML",
      "name": "Imperial Airport",
      "city": "Imperial",
      "cityCode": "IML",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 40.516667,
      "longitude": -101.65,
      "elevationFeet": 3272,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IML?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IML?codeType=fs"
     },
     {
      "fs": "IMM",
      "iata": "IMM",
      "icao": "KIMM",
      "faa": "IMM",
      "name": "Immokalee Airport",
      "city": "Immokalee",
      "cityCode": "IMM",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 26.416667,
      "longitude": -81.416667,
      "elevationFeet": 36,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IMM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IMM?codeType=fs"
     },
     {
      "fs": "INK",
      "iata": "INK",
      "icao": "KINK",
      "faa": "INK",
      "name": "Wink Airport",
      "city": "Wink",
      "cityCode": "INK",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.75,
      "longitude": -103.15,
      "elevationFeet": 2820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/INK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/INK?codeType=fs"
     },
     {
      "fs": "INR",
      "iata": "INR",
      "icao": "",
      "faa": "",
      "name": "Kincheloe Air Force Base",
      "city": "Sault Ste. Marie",
      "cityCode": "SSM",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 46.250933,
      "longitude": -84.457941,
      "elevationFeet": 797,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/INR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/INR?codeType=fs"
     },
     {
      "fs": "INS",
      "iata": "INS",
      "icao": "KINS",
      "faa": "INS",
      "name": "Af Aux Airport",
      "city": "Indian Springs",
      "cityCode": "INS",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 36.583333,
      "longitude": -115.666667,
      "elevationFeet": 3133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/INS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/INS?codeType=fs"
     },
     {
      "fs": "INW",
      "iata": "INW",
      "icao": "KINW",
      "faa": "INW",
      "name": "Winslow Airport",
      "city": "Winslow",
      "cityCode": "INW",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 35.024167,
      "longitude": -110.725,
      "elevationFeet": 4941,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/INW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/INW?codeType=fs"
     },
     {
      "fs": "IOW",
      "iata": "IOW",
      "icao": "KIOW",
      "faa": "IOW",
      "name": "Iowa City Airport",
      "city": "Iowa City",
      "cityCode": "IOW",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.666667,
      "longitude": -91.533333,
      "elevationFeet": 668,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IOW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IOW?codeType=fs"
     },
     {
      "fs": "IRB",
      "iata": "IRB",
      "icao": "",
      "faa": "2F0",
      "name": "Iraan Municipal Airport",
      "city": "Iraan",
      "cityCode": "IRB",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.7,
      "longitude": -101.933333,
      "elevationFeet": 2200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IRB?codeType=fs"
     },
     {
      "fs": "IRS",
      "iata": "IRS",
      "icao": "KIRS",
      "faa": "IRS",
      "name": "Kirsch Municipal",
      "city": "Sturgis",
      "cityCode": "IRS",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.816667,
      "longitude": -85.435278,
      "elevationFeet": 925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IRS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IRS?codeType=fs"
     },
     {
      "fs": "ISQ",
      "iata": "ISQ",
      "icao": "KISQ",
      "faa": "ISQ",
      "name": "Schoolcraft County Airport",
      "city": "Manistique",
      "cityCode": "ISQ",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 45.95,
      "longitude": -86.25,
      "elevationFeet": 685,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ISQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ISQ?codeType=fs"
     },
     {
      "fs": "IVH",
      "iata": "IVH",
      "icao": "",
      "faa": "",
      "name": "Ivishak Airport",
      "city": "Ivishak",
      "cityCode": "IVH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 69.4,
      "longitude": -148.25,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IVH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IVH?codeType=fs"
     },
     {
      "fs": "IWS",
      "iata": "IWS",
      "icao": "KIWS",
      "faa": "IWS",
      "name": "West Houston Airport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.816667,
      "longitude": -95.666667,
      "elevationFeet": 111,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/IWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/IWS?codeType=fs"
     },
     {
      "fs": "JAJ",
      "iata": "JAJ",
      "icao": "",
      "faa": "",
      "name": "Perimeter Mall Heliport",
      "city": "Atlanta",
      "cityCode": "ATL",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 33.924538,
      "longitude": -84.341837,
      "elevationFeet": 976,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JAJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JAJ?codeType=fs"
     },
     {
      "fs": "JAO",
      "iata": "JAO",
      "icao": "",
      "faa": "",
      "name": "Beaver Ruin Heliport",
      "city": "Atlanta",
      "cityCode": "ATL",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 33.954932,
      "longitude": -84.136721,
      "elevationFeet": 953,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JAO?codeType=fs"
     },
     {
      "fs": "JAS",
      "iata": "JAS",
      "icao": "KJAS",
      "faa": "JAS",
      "name": "Jasper County-Bell Field",
      "city": "Jasper",
      "cityCode": "JAS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.885701,
      "longitude": -94.034907,
      "elevationFeet": 193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JAS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JAS?codeType=fs"
     },
     {
      "fs": "JBC",
      "iata": "JBC",
      "icao": "",
      "faa": "",
      "name": "Boston City Heliport",
      "city": "Boston",
      "cityCode": "BOS",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.343889,
      "longitude": -71.049444,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JBC?codeType=fs"
     },
     {
      "fs": "JBK",
      "iata": "JBK",
      "icao": "",
      "faa": "",
      "name": "Berkeley",
      "city": "Berkeley",
      "cityCode": "JBK",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.866667,
      "longitude": -122.3,
      "elevationFeet": 18,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JBK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JBK?codeType=fs"
     },
     {
      "fs": "JBP",
      "iata": "JBP",
      "icao": "",
      "faa": "",
      "name": "Commerce Bus. Plaza Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.986667,
      "longitude": -118.159722,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JBP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JBP?codeType=fs"
     },
     {
      "fs": "JBT",
      "iata": "JBT",
      "icao": "",
      "faa": "",
      "name": "Bethel Sea Plane Base",
      "city": "Bethel",
      "cityCode": "BET",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 60.790714,
      "longitude": -161.756696,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JBT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JBT?codeType=fs"
     },
     {
      "fs": "JCC",
      "iata": "JCC",
      "icao": "",
      "faa": "",
      "name": "China Basin Heliport",
      "city": "San Francisco",
      "cityCode": "SFO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.775351,
      "longitude": -122.404401,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JCC?codeType=fs"
     },
     {
      "fs": "JCE",
      "iata": "JCE",
      "icao": "",
      "faa": "",
      "name": "Convention Center Heliport",
      "city": "Oakland",
      "cityCode": "OAK",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.802159,
      "longitude": -122.273706,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JCE?codeType=fs"
     },
     {
      "fs": "JCI",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Johnson Industrial Airport",
      "city": "Kansas City",
      "cityCode": "MKC",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.833333,
      "longitude": -94.9,
      "elevationFeet": 1074,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JCI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JCI?codeType=fs"
     },
     {
      "fs": "JCT",
      "iata": "JCT",
      "icao": "KJCT",
      "faa": "JCT",
      "name": "Kimble County Airport",
      "city": "Junction",
      "cityCode": "JCT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.483333,
      "longitude": -99.766667,
      "elevationFeet": 1749,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JCT?codeType=fs"
     },
     {
      "fs": "JCX",
      "iata": "JCX",
      "icao": "",
      "faa": "",
      "name": "Citicorp Plaza Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.050553,
      "longitude": -118.25952,
      "elevationFeet": 297,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JCX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JCX?codeType=fs"
     },
     {
      "fs": "JCY",
      "iata": "JCY",
      "icao": "KJCY",
      "faa": "JCY",
      "name": "Johnson Airport",
      "city": "Johnson",
      "cityCode": "JCY",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.283333,
      "longitude": -98.416667,
      "elevationFeet": 1515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JCY?codeType=fs"
     },
     {
      "fs": "JDA",
      "iata": "JDA",
      "icao": "",
      "faa": "5J0",
      "name": "John Day Airport",
      "city": "John Day",
      "cityCode": "JDA",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 44.416667,
      "longitude": -118.95,
      "elevationFeet": 3697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDA?codeType=fs"
     },
     {
      "fs": "JDB",
      "iata": "JDB",
      "icao": "",
      "faa": "",
      "name": "Dallas Downtown Heliport",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.77238,
      "longitude": -97.801097,
      "elevationFeet": 417,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDB?codeType=fs"
     },
     {
      "fs": "JDM",
      "iata": "JDM",
      "icao": "",
      "faa": "",
      "name": "Miami Downtown Heliport",
      "city": "Miami",
      "cityCode": "MIA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 25.78552,
      "longitude": -80.177217,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDM?codeType=fs"
     },
     {
      "fs": "JDN",
      "iata": "JDN",
      "icao": "KJDN",
      "faa": "JDN",
      "name": "Jordan Airport",
      "city": "Jordan",
      "cityCode": "JDN",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 47.316667,
      "longitude": -106.883333,
      "elevationFeet": 2662,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDN?codeType=fs"
     },
     {
      "fs": "JDT",
      "iata": "JDT",
      "icao": "",
      "faa": "",
      "name": "Minneapolis Downtown Heliport",
      "city": "Minneapolis",
      "cityCode": "MSP",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 44.983333,
      "longitude": -93.266667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDT?codeType=fs"
     },
     {
      "fs": "JDX",
      "iata": "JDX",
      "icao": "",
      "faa": "",
      "name": "Central Business District Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.766667,
      "longitude": -95.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDX?codeType=fs"
     },
     {
      "fs": "JDY",
      "iata": "JDY",
      "icao": "",
      "faa": "",
      "name": "Downey Heliport",
      "city": "Downey",
      "cityCode": "JDY",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.933333,
      "longitude": -118.116667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JDY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JDY?codeType=fs"
     },
     {
      "fs": "JEM",
      "iata": "JEM",
      "icao": "",
      "faa": "",
      "name": "Emeryville Heliport",
      "city": "Emeryville",
      "cityCode": "JEM",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.836226,
      "longitude": -122.266614,
      "elevationFeet": 103,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JEM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JEM?codeType=fs"
     },
     {
      "fs": "JFN",
      "iata": "JFN",
      "icao": "",
      "faa": "",
      "name": "Ashtabula Airport",
      "city": "Jefferson",
      "cityCode": "JFN",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.733333,
      "longitude": -80.766667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JFN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JFN?codeType=fs"
     },
     {
      "fs": "JGL",
      "iata": "JGL",
      "icao": "",
      "faa": "",
      "name": "Galleria Heliport",
      "city": "Atlanta",
      "cityCode": "ATL",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 33.886111,
      "longitude": -84.466944,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JGL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JGL?codeType=fs"
     },
     {
      "fs": "JGP",
      "iata": "JGP",
      "icao": "",
      "faa": "",
      "name": "Greenway Plaza Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.731623,
      "longitude": -95.431405,
      "elevationFeet": 67,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JGP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JGP?codeType=fs"
     },
     {
      "fs": "JGQ",
      "iata": "JGQ",
      "icao": "",
      "faa": "",
      "name": "Transco Tower Galleria Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.766667,
      "longitude": -95.466667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JGQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JGQ?codeType=fs"
     },
     {
      "fs": "JGX",
      "iata": "JGX",
      "icao": "",
      "faa": "",
      "name": "Glendale Heliport",
      "city": "Glendale",
      "cityCode": "JGX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.166667,
      "longitude": -118.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JGX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JGX?codeType=fs"
     },
     {
      "fs": "JHC",
      "iata": "JHC",
      "icao": "",
      "faa": "",
      "name": "Island Heliport",
      "city": "Garden City",
      "cityCode": "JHC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.783333,
      "longitude": -74.1,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JHC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JHC?codeType=fs"
     },
     {
      "fs": "JHY",
      "iata": "JHY",
      "icao": "",
      "faa": "",
      "name": "Hyatt Regency Heliport",
      "city": "Cambridge",
      "cityCode": "JHY",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 42.354044,
      "longitude": -71.105341,
      "elevationFeet": 9,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JHY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JHY?codeType=fs"
     },
     {
      "fs": "JID",
      "iata": "JID",
      "icao": "",
      "faa": "",
      "name": "City of Industry Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34,
      "longitude": -118,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JID?codeType=fs"
     },
     {
      "fs": "JKV",
      "iata": "JKV",
      "icao": "",
      "faa": "",
      "name": "Jacksonville Airport",
      "city": "Jacksonville",
      "cityCode": "JKV",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 31.966667,
      "longitude": -95.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JKV?codeType=fs"
     },
     {
      "fs": "JLA",
      "iata": "JLA",
      "icao": "",
      "faa": "JLA",
      "name": "Quart Creek Airport",
      "city": "Cooper Lodge",
      "cityCode": "JLA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 60.483333,
      "longitude": -149.85,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JLA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JLA?codeType=fs"
     },
     {
      "fs": "JLB",
      "iata": "JLB",
      "icao": "",
      "faa": "",
      "name": "Long Beach Heliport",
      "city": "Long Beach",
      "cityCode": "LGB",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.807831,
      "longitude": -118.147331,
      "elevationFeet": 33,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JLB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JLB?codeType=fs"
     },
     {
      "fs": "JLH",
      "iata": "JLH",
      "icao": "",
      "faa": "",
      "name": "United States Army Heliport",
      "city": "Arlington Heights",
      "cityCode": "JLH",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.083333,
      "longitude": -87.983333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JLH?codeType=fs"
     },
     {
      "fs": "JLX",
      "iata": "JLX",
      "icao": "",
      "faa": "",
      "name": "Union Station Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.166667,
      "longitude": -118.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JLX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JLX?codeType=fs"
     },
     {
      "fs": "JMA",
      "iata": "JMA",
      "icao": "",
      "faa": "",
      "name": "Marriot Astrodome Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.699588,
      "longitude": -95.405494,
      "elevationFeet": 46,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JMA?codeType=fs"
     },
     {
      "fs": "JMC",
      "iata": "JMC",
      "icao": "",
      "faa": "",
      "name": "Marin County Airport",
      "city": "Sausalito",
      "cityCode": "JMC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.878611,
      "longitude": -122.509722,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JMC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JMC?codeType=fs"
     },
     {
      "fs": "JMD",
      "iata": "JMD",
      "icao": "",
      "faa": "",
      "name": "Market Centre Heliport",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.8,
      "longitude": -97.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JMD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JMD?codeType=fs"
     },
     {
      "fs": "JMH",
      "iata": "JMH",
      "icao": "",
      "faa": "",
      "name": "Schaumburg Marriott Heliport",
      "city": "Schaumburg",
      "cityCode": "JMH",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.033333,
      "longitude": -88.083333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JMH?codeType=fs"
     },
     {
      "fs": "JMN",
      "iata": "JMN",
      "icao": "",
      "faa": "",
      "name": "Mankato Municipal Heliport",
      "city": "Mankato",
      "cityCode": "MKT",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 44.166667,
      "longitude": -94.016667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JMN?codeType=fs"
     },
     {
      "fs": "JNH",
      "iata": "JNH",
      "icao": "",
      "faa": "",
      "name": "North Park Inn Heliport",
      "city": "Dallas",
      "cityCode": "DFW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 32.816667,
      "longitude": -97.35,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JNH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JNH?codeType=fs"
     },
     {
      "fs": "JNP",
      "iata": "JNP",
      "icao": "",
      "faa": "",
      "name": "Newport Beach Heliport",
      "city": "Newport Beach",
      "cityCode": "JNP",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.616667,
      "longitude": -117.933333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JNP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JNP?codeType=fs"
     },
     {
      "fs": "JOC",
      "iata": "JOC",
      "icao": "",
      "faa": "",
      "name": "Centerport Heliport",
      "city": "Santa Ana",
      "cityCode": "SNA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.670417,
      "longitude": -117.857693,
      "elevationFeet": 46,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JOC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JOC?codeType=fs"
     },
     {
      "fs": "JOR",
      "iata": "JOR",
      "icao": "",
      "faa": "",
      "name": "The City Heliport",
      "city": "Orange",
      "cityCode": "JOR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.730729,
      "longitude": -117.847277,
      "elevationFeet": 98,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JOR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JOR?codeType=fs"
     },
     {
      "fs": "JOT",
      "iata": "JOT",
      "icao": "KJOT",
      "faa": "JOT",
      "name": "Joliet Municipal Airport",
      "city": "Joliet",
      "cityCode": "JOT",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.533333,
      "longitude": -88.083333,
      "elevationFeet": 581,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JOT?codeType=fs"
     },
     {
      "fs": "JPD",
      "iata": "JPD",
      "icao": "",
      "faa": "",
      "name": "Pasadena Heliport",
      "city": "Pasadena",
      "cityCode": "JPD",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.15,
      "longitude": -118.15,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JPD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JPD?codeType=fs"
     },
     {
      "fs": "JPN",
      "iata": "JPN",
      "icao": "",
      "faa": "",
      "name": "Pentagon Army Airport",
      "city": "Washington",
      "cityCode": "WAS",
      "stateCode": "DC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 38.874736,
      "longitude": -77.056079,
      "elevationFeet": 28,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JPN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JPN?codeType=fs"
     },
     {
      "fs": "JPT",
      "iata": "JPT",
      "icao": "",
      "faa": "",
      "name": "Texas Park Ten Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.786389,
      "longitude": -95.811667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JPT?codeType=fs"
     },
     {
      "fs": "JRA",
      "iata": "JRA",
      "icao": "",
      "faa": "",
      "name": "West 30th Street Heliport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.75,
      "longitude": -74.0075,
      "elevationFeet": 10,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JRA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JRA?codeType=fs"
     },
     {
      "fs": "JRB",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "New York Downtown Manhattan Heliport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.704167,
      "longitude": -74.008333,
      "elevationFeet": 7,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JRB?codeType=fs"
     },
     {
      "fs": "JRC",
      "iata": "JRC",
      "icao": "",
      "faa": "",
      "name": "Rochester Municipal Heliport",
      "city": "Rochester",
      "cityCode": "RST",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 44.016667,
      "longitude": -92.466667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JRC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JRC?codeType=fs"
     },
     {
      "fs": "JRD",
      "iata": "JRD",
      "icao": "",
      "faa": "",
      "name": "Riverside Metro Center Heliport",
      "city": "Riverside",
      "cityCode": "RAL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 33.983008,
      "longitude": -117.376141,
      "elevationFeet": 847,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JRD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JRD?codeType=fs"
     },
     {
      "fs": "JRE",
      "iata": "JRE",
      "icao": "",
      "faa": "",
      "name": "East 60th Street Heliport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 40.754167,
      "longitude": -73.970833,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JRE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JRE?codeType=fs"
     },
     {
      "fs": "JSD",
      "iata": "JSD",
      "icao": "",
      "faa": "",
      "name": "Sikorsky Heliport",
      "city": "Stratford",
      "cityCode": "JSD",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.2,
      "longitude": -73.133333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JSD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JSD?codeType=fs"
     },
     {
      "fs": "JSG",
      "iata": "JSG",
      "icao": "",
      "faa": "",
      "name": "San Rafael Heliport",
      "city": "San Rafael",
      "cityCode": "SRF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 37.966667,
      "longitude": -122.533333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JSG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JSG?codeType=fs"
     },
     {
      "fs": "JSL",
      "iata": "JSL",
      "icao": "",
      "faa": "",
      "name": "Steel Pier Heliport",
      "city": "Atlantic City",
      "cityCode": "AIY",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 39.333333,
      "longitude": -74.45,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JSL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JSL?codeType=fs"
     },
     {
      "fs": "JSN",
      "iata": "JSN",
      "icao": "",
      "faa": "",
      "name": "Sherman Oaks Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.16001,
      "longitude": -118.44953,
      "elevationFeet": 663,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JSN?codeType=fs"
     },
     {
      "fs": "JTO",
      "iata": "JTO",
      "icao": "",
      "faa": "",
      "name": "Thousand Oaks Heliport",
      "city": "Thousand Oaks",
      "cityCode": "JTO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.166667,
      "longitude": -118.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JTO?codeType=fs"
     },
     {
      "fs": "JUC",
      "iata": "JUC",
      "icao": "",
      "faa": "",
      "name": "Universal City Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.083333,
      "longitude": -118.266667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JUC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JUC?codeType=fs"
     },
     {
      "fs": "JUP",
      "iata": "JUP",
      "icao": "",
      "faa": "",
      "name": "Cable Heliport",
      "city": "Upland",
      "cityCode": "CCB",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.1,
      "longitude": -117.633333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JUP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JUP?codeType=fs"
     },
     {
      "fs": "JVL",
      "iata": "JVL",
      "icao": "KJVL",
      "faa": "JVL",
      "name": "Rock County Airport",
      "city": "Janesville",
      "cityCode": "JVL",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 42.683333,
      "longitude": -89.016667,
      "elevationFeet": 808,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JVL?codeType=fs"
     },
     {
      "fs": "JWC",
      "iata": "JWC",
      "icao": "",
      "faa": "",
      "name": "Warner Center Business Plaza Heliport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.180088,
      "longitude": -118.599013,
      "elevationFeet": 841,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JWC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JWC?codeType=fs"
     },
     {
      "fs": "JWH",
      "iata": "JWH",
      "icao": "",
      "faa": "",
      "name": "West Chase Hilton Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 29.736111,
      "longitude": -95.417778,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JWH?codeType=fs"
     },
     {
      "fs": "JWL",
      "iata": "JWL",
      "icao": "",
      "faa": "",
      "name": "Woodlawns Heliport",
      "city": "Houston",
      "cityCode": "HOU",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 30.150556,
      "longitude": -95.471389,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JWL?codeType=fs"
     },
     {
      "fs": "JZZ",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Koliganek",
      "city": "Koliganek",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.684",
      "utcOffsetHours": -9,
      "latitude": 59.816417,
      "longitude": -157.344722,
      "elevationFeet": 269,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/JZZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/JZZ?codeType=fs"
     },
     {
      "fs": "KAAS",
      "iata": "",
      "icao": "KAAS",
      "faa": "AAS",
      "name": "Taylor Co",
      "city": "Campbellsville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.432778,
      "longitude": -85.394167,
      "elevationFeet": 921,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAAS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAAS?codeType=fs"
     },
     {
      "fs": "KAAT",
      "iata": "",
      "icao": "KAAT",
      "faa": "AAT",
      "name": "Alturas Municipal",
      "city": "Alturas",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 41.63,
      "longitude": -120.703611,
      "elevationFeet": 4374,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAAT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAAT?codeType=fs"
     },
     {
      "fs": "KACJ",
      "iata": "",
      "icao": "KACJ",
      "faa": "ACJ",
      "name": "Souther",
      "city": "Americus",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 32.214139,
      "longitude": -84.232139,
      "elevationFeet": 466,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KACJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KACJ?codeType=fs"
     },
     {
      "fs": "KACQ",
      "iata": "",
      "icao": "KACQ",
      "faa": "ACQ",
      "name": "Waseca Municipal",
      "city": "Waseca",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 44.134639,
      "longitude": -93.579444,
      "elevationFeet": 1126,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KACQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KACQ?codeType=fs"
     },
     {
      "fs": "KACZ",
      "iata": "",
      "icao": "KACZ",
      "faa": "ACZ",
      "name": "Henderson",
      "city": "Wallace",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 34.728917,
      "longitude": -78.03625,
      "elevationFeet": 39,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KACZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KACZ?codeType=fs"
     },
     {
      "fs": "KADT",
      "iata": "",
      "icao": "KADT",
      "faa": "ADT",
      "name": "Atwood-Rawlins Co City-Co",
      "city": "Atwood",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 39.901389,
      "longitude": -101.120278,
      "elevationFeet": 2991,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KADT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KADT?codeType=fs"
     },
     {
      "fs": "KADU",
      "iata": "",
      "icao": "KADU",
      "faa": "ADU",
      "name": "Audubon Co",
      "city": "Audubon",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.71375,
      "longitude": -94.955417,
      "elevationFeet": 1287,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KADU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KADU?codeType=fs"
     },
     {
      "fs": "KAEG",
      "iata": "",
      "icao": "KAEG",
      "faa": "AEG",
      "name": "Double Eagle Ii",
      "city": "Albuquerque",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.684",
      "utcOffsetHours": -7,
      "latitude": 35.251556,
      "longitude": -106.901694,
      "elevationFeet": 5837,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAEG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAEG?codeType=fs"
     },
     {
      "fs": "KAFK",
      "iata": "",
      "icao": "KAFK",
      "faa": "AFK",
      "name": "Nebraska City Municipal",
      "city": "Nebraska City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 40.668889,
      "longitude": -96.006944,
      "elevationFeet": 1162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAFK?codeType=fs"
     },
     {
      "fs": "KAFP",
      "iata": "",
      "icao": "KAFP",
      "faa": "AFP",
      "name": "Anson Co",
      "city": "Wadesboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.08975,
      "longitude": -80.212722,
      "elevationFeet": 301,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAFP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAFP?codeType=fs"
     },
     {
      "fs": "KAGZ",
      "iata": "",
      "icao": "KAGZ",
      "faa": "AGZ",
      "name": "Wagner Municipal",
      "city": "Wagner",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 43.183278,
      "longitude": -98.411889,
      "elevationFeet": 1475,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAGZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAGZ?codeType=fs"
     },
     {
      "fs": "KAHQ",
      "iata": "",
      "icao": "KAHQ",
      "faa": "AHQ",
      "name": "Wahoo Municipal Airport",
      "city": "Wahoo",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 41.240459,
      "longitude": -96.590763,
      "elevationFeet": 1221,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAHQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAHQ?codeType=fs"
     },
     {
      "fs": "KAIG",
      "iata": "",
      "icao": "KAIG",
      "faa": "AIG",
      "name": "Langlade Co",
      "city": "Antigo",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 45.191944,
      "longitude": -89.207222,
      "elevationFeet": 1522,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAIG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAIG?codeType=fs"
     },
     {
      "fs": "KAIT",
      "iata": "",
      "icao": "KAIT",
      "faa": "AIT",
      "name": "Aitkin Mun - Kurtz",
      "city": "Aitkin",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 46.684222,
      "longitude": -93.768,
      "elevationFeet": 1205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAIT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAIT?codeType=fs"
     },
     {
      "fs": "KAJG",
      "iata": "",
      "icao": "KAJG",
      "faa": "AJG",
      "name": "Mt Carmel Municipal",
      "city": "Mt Carmel",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.684",
      "utcOffsetHours": -6,
      "latitude": 38.665472,
      "longitude": -87.816944,
      "elevationFeet": 429,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAJG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAJG?codeType=fs"
     },
     {
      "fs": "KAJO",
      "iata": "",
      "icao": "KAJO",
      "faa": "AJO",
      "name": "Corona Municipal",
      "city": "Corona",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.684",
      "utcOffsetHours": -8,
      "latitude": 34.026528,
      "longitude": -117.624389,
      "elevationFeet": 533,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAJO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAJO?codeType=fs"
     },
     {
      "fs": "KAJR",
      "iata": "",
      "icao": "KAJR",
      "faa": "AJR",
      "name": "Habersham Co",
      "city": "Cornelia",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 34.508194,
      "longitude": -83.598694,
      "elevationFeet": 1447,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAJR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAJR?codeType=fs"
     },
     {
      "fs": "KAKH",
      "iata": "",
      "icao": "KAKH",
      "faa": "AKH",
      "name": "Gastonia Municipal",
      "city": "Gastonia",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 35.202598,
      "longitude": -81.149902,
      "elevationFeet": 798,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAKH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAKH?codeType=fs"
     },
     {
      "fs": "KAKQ",
      "iata": "",
      "icao": "KAKQ",
      "faa": "AKQ",
      "name": "Wakefield Municipal",
      "city": "Wakefield",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 37.022056,
      "longitude": -77.011278,
      "elevationFeet": 113,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAKQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAKQ?codeType=fs"
     },
     {
      "fs": "KAKR",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Akron Fulton International",
      "city": "Akron",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.684",
      "utcOffsetHours": -5,
      "latitude": 41.075,
      "longitude": -81.469389,
      "elevationFeet": 1067,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAKR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAKR?codeType=fs"
     },
     {
      "fs": "KAMG",
      "iata": "",
      "icao": "KAMG",
      "faa": "AMG",
      "name": "Bacon Co",
      "city": "Alma",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.560556,
      "longitude": -82.565556,
      "elevationFeet": 200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAMG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAMG?codeType=fs"
     },
     {
      "fs": "KAMT",
      "iata": "",
      "icao": "KAMT",
      "faa": "AMT",
      "name": "Salamon",
      "city": "West Union",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.864889,
      "longitude": -83.712778,
      "elevationFeet": 896,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAMT?codeType=fs"
     },
     {
      "fs": "KANJ",
      "iata": "SSM",
      "icao": "KANJ",
      "faa": "ANJ",
      "name": "Sault Ste Marie Municipal Airport",
      "city": "Sault Ste Marie",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 46.479166,
      "longitude": -84.368275,
      "elevationFeet": 709,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KANJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KANJ?codeType=fs"
     },
     {
      "fs": "KAOC",
      "iata": "",
      "icao": "KAOC",
      "faa": "AOC",
      "name": "Arco-Butte Co",
      "city": "Arco",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 43.634306,
      "longitude": -113.340972,
      "elevationFeet": 5328,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAOC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAOC?codeType=fs"
     },
     {
      "fs": "KAOV",
      "iata": "",
      "icao": "KAOV",
      "faa": "AOV",
      "name": "Ava Martin Memorial",
      "city": "Ava",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.018861,
      "longitude": -92.819472,
      "elevationFeet": 1311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAOV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAOV?codeType=fs"
     },
     {
      "fs": "KAQP",
      "iata": "",
      "icao": "KAQP",
      "faa": "AQP",
      "name": "Appleton Municipal",
      "city": "Appleton",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.325278,
      "longitude": -96.043333,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAQP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAQP?codeType=fs"
     },
     {
      "fs": "KAQW",
      "iata": "",
      "icao": "KAQW",
      "faa": "AQW",
      "name": "Harriman And West",
      "city": "North Adams",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.809139,
      "longitude": -73.203833,
      "elevationFeet": 654,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAQW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAQW?codeType=fs"
     },
     {
      "fs": "KASD",
      "iata": "",
      "icao": "KASD",
      "faa": "ASD",
      "name": "Slidell",
      "city": "Slidell",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.450556,
      "longitude": -89.857889,
      "elevationFeet": 28,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KASD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KASD?codeType=fs"
     },
     {
      "fs": "KASJ",
      "iata": "",
      "icao": "KASJ",
      "faa": "ASJ",
      "name": "Tri Co",
      "city": "Ahoskie",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.42525,
      "longitude": -77.208556,
      "elevationFeet": 68,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KASJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KASJ?codeType=fs"
     },
     {
      "fs": "KATA",
      "iata": "",
      "icao": "KATA",
      "faa": "ATA",
      "name": "Hall-Miller Municipal",
      "city": "Atlanta",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.118056,
      "longitude": -94.303278,
      "elevationFeet": 280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KATA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KATA?codeType=fs"
     },
     {
      "fs": "KAUH",
      "iata": "",
      "icao": "KAUH",
      "faa": "AUH",
      "name": "Aurora Municipal",
      "city": "Aurora",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.991389,
      "longitude": -98.095556,
      "elevationFeet": 1804,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAUH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAUH?codeType=fs"
     },
     {
      "fs": "KAVC",
      "iata": "",
      "icao": "KAVC",
      "faa": "AVC",
      "name": "Mecklenburg-Brunswick Regional",
      "city": "South Hill",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.732778,
      "longitude": -78.094722,
      "elevationFeet": 442,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAVC?codeType=fs"
     },
     {
      "fs": "KAWG",
      "iata": "",
      "icao": "KAWG",
      "faa": "AWG",
      "name": "Washington Municipal",
      "city": "Washington",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.361,
      "longitude": -91.734444,
      "elevationFeet": 754,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAWG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAWG?codeType=fs"
     },
     {
      "fs": "KAWO",
      "iata": "",
      "icao": "KAWO",
      "faa": "AWO",
      "name": "Arlington Municipal",
      "city": "Arlington",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 48.162514,
      "longitude": -122.156417,
      "elevationFeet": 137,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAWO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAWO?codeType=fs"
     },
     {
      "fs": "KAXH",
      "iata": "",
      "icao": "KAXH",
      "faa": "AXH",
      "name": "Houston Southwest Airport",
      "city": "Houston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 29.511775,
      "longitude": -95.469948,
      "elevationFeet": 66,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAXH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAXH?codeType=fs"
     },
     {
      "fs": "KAXQ",
      "iata": "",
      "icao": "KAXQ",
      "faa": "AXQ",
      "name": "Clarion Co",
      "city": "Clarion",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.308111,
      "longitude": -79.509889,
      "elevationFeet": 1458,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAXQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAXQ?codeType=fs"
     },
     {
      "fs": "KAZC",
      "iata": "",
      "icao": "KAZC",
      "faa": "AZC",
      "name": "Colorado City Municipal",
      "city": "Colorado City",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 37.049444,
      "longitude": -113.138889,
      "elevationFeet": 4874,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAZC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAZC?codeType=fs"
     },
     {
      "fs": "KAZE",
      "iata": "",
      "icao": "KAZE",
      "faa": "AZE",
      "name": "Hazlehurst",
      "city": "Hazlehurst",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.896556,
      "longitude": -82.773889,
      "elevationFeet": 255,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KAZE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KAZE?codeType=fs"
     },
     {
      "fs": "KBAX",
      "iata": "",
      "icao": "KBAX",
      "faa": "BAX",
      "name": "Huron Co Memorial",
      "city": "Bad Axe",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 43.909167,
      "longitude": -83.006667,
      "elevationFeet": 766,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBAX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBAX?codeType=fs"
     },
     {
      "fs": "KBAZ",
      "iata": "",
      "icao": "KBAZ",
      "faa": "BAZ",
      "name": "New Braunfels Municipal",
      "city": "New Braunfels",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 29.707118,
      "longitude": -98.040987,
      "elevationFeet": 651,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBAZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBAZ?codeType=fs"
     },
     {
      "fs": "KBCK",
      "iata": "",
      "icao": "KBCK",
      "faa": "BCK",
      "name": "Black River Falls Area",
      "city": "Black River Falls",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.257389,
      "longitude": -90.902806,
      "elevationFeet": 836,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBCK?codeType=fs"
     },
     {
      "fs": "KBDJ",
      "iata": "",
      "icao": "KBDJ",
      "faa": "BDJ",
      "name": "Boulder Junction",
      "city": "Boulder Junction",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.1745,
      "longitude": -89.759833,
      "elevationFeet": 1665,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBDJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBDJ?codeType=fs"
     },
     {
      "fs": "KBDN",
      "iata": "",
      "icao": "KBDN",
      "faa": "S07",
      "name": "Bend Municipal",
      "city": "Bend",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 44.094799,
      "longitude": -121.200996,
      "elevationFeet": 3460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBDN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBDN?codeType=fs"
     },
     {
      "fs": "KBDQ",
      "iata": "",
      "icao": "KBDQ",
      "faa": "BDQ",
      "name": "Morrilton Municipal",
      "city": "Morrilton",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.161944,
      "longitude": -92.834972,
      "elevationFeet": 321,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBDQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBDQ?codeType=fs"
     },
     {
      "fs": "KBE",
      "iata": "KBE",
      "icao": "",
      "faa": "",
      "name": "Hot Springs Sea Plane Base",
      "city": "Bell Island",
      "cityCode": "KBE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 55.929014,
      "longitude": -131.57226,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBE?codeType=fs"
     },
     {
      "fs": "KBFA",
      "iata": "",
      "icao": "KBFA",
      "faa": "BFA",
      "name": "Boyne Mtn",
      "city": "Boyne Falls",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.308333,
      "longitude": -84.990556,
      "elevationFeet": 719,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBFA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBFA?codeType=fs"
     },
     {
      "fs": "KBFK",
      "iata": "",
      "icao": "KBFK",
      "faa": "BFK",
      "name": "Buffalo Municipal",
      "city": "Buffalo",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.983028,
      "longitude": -99.637306,
      "elevationFeet": 1822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBFK?codeType=fs"
     },
     {
      "fs": "KBFW",
      "iata": "",
      "icao": "KBFW",
      "faa": "BFW",
      "name": "Silver Bay Municipal",
      "city": "Silver Bay",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 47.390278,
      "longitude": -91.555833,
      "elevationFeet": 1089,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBFW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBFW?codeType=fs"
     },
     {
      "fs": "KBGF",
      "iata": "",
      "icao": "KBGF",
      "faa": "BGF",
      "name": "Winchester Municipal",
      "city": "Winchester",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.275278,
      "longitude": -86.211778,
      "elevationFeet": 979,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBGF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBGF?codeType=fs"
     },
     {
      "fs": "KBHC",
      "iata": "",
      "icao": "KBHC",
      "faa": "BHC",
      "name": "Baxley Municipal",
      "city": "Baxley",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.838333,
      "longitude": -82.487778,
      "elevationFeet": 201,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBHC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBHC?codeType=fs"
     },
     {
      "fs": "KBHK",
      "iata": "",
      "icao": "KBHK",
      "faa": "BHK",
      "name": "Baker Municipal",
      "city": "Baker",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 46.476361,
      "longitude": -104.344472,
      "elevationFeet": 2973,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBHK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBHK?codeType=fs"
     },
     {
      "fs": "KBMQ",
      "iata": "",
      "icao": "KBMQ",
      "faa": "BMQ",
      "name": "Burnet Mun-Craddock",
      "city": "Burnet",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.789444,
      "longitude": -98.285833,
      "elevationFeet": 1283,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBMQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBMQ?codeType=fs"
     },
     {
      "fs": "KBST",
      "iata": "",
      "icao": "KBST",
      "faa": "BST",
      "name": "Belfast Municipal",
      "city": "Belfast",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 44.496667,
      "longitude": -69.1225,
      "elevationFeet": 195,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBST?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBST?codeType=fs"
     },
     {
      "fs": "KBUU",
      "iata": "",
      "icao": "KBUU",
      "faa": "BUU",
      "name": "Burlington Municipal",
      "city": "Burlington",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.755639,
      "longitude": -88.346389,
      "elevationFeet": 779,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBUU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBUU?codeType=fs"
     },
     {
      "fs": "KBVN",
      "iata": "",
      "icao": "KBVN",
      "faa": "BVN",
      "name": "Albion Municipal",
      "city": "Albion",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.835778,
      "longitude": -98.107611,
      "elevationFeet": 1806,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBVN?codeType=fs"
     },
     {
      "fs": "KBW",
      "iata": "KBW",
      "icao": "",
      "faa": "",
      "name": "Chignik Bay Airport",
      "city": "Chignik",
      "cityCode": "KCQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 56.283333,
      "longitude": -158.383333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBW?codeType=fs"
     },
     {
      "fs": "KBXG",
      "iata": "",
      "icao": "KBXG",
      "faa": "BXG",
      "name": "Burke Co",
      "city": "Waynesboro",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.109306,
      "longitude": -82.039806,
      "elevationFeet": 302,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBXG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBXG?codeType=fs"
     },
     {
      "fs": "KBZK",
      "iata": "",
      "icao": "KBZK",
      "faa": "BZK",
      "name": "Gen Pershing Memorial",
      "city": "Brookfield",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.87525,
      "longitude": -93.153417,
      "elevationFeet": 807,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KBZK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KBZK?codeType=fs"
     },
     {
      "fs": "KCAV",
      "iata": "",
      "icao": "KCAV",
      "faa": "CAV",
      "name": "Clarion Municipal",
      "city": "Clarion",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.819444,
      "longitude": -93.839083,
      "elevationFeet": 1162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCAV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCAV?codeType=fs"
     },
     {
      "fs": "KCBG",
      "iata": "",
      "icao": "KCBG",
      "faa": "CBG",
      "name": "Cambridge Municipal",
      "city": "Cambridge",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.635472,
      "longitude": -93.396444,
      "elevationFeet": 945,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCBG?codeType=fs"
     },
     {
      "fs": "KCDI",
      "iata": "",
      "icao": "KCDI",
      "faa": "CDI",
      "name": "Cambridge Municipal",
      "city": "Cambridge",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.050444,
      "longitude": -81.675944,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCDI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCDI?codeType=fs"
     },
     {
      "fs": "KCEK",
      "iata": "",
      "icao": "KCEK",
      "faa": "CEK",
      "name": "Crete Municipal",
      "city": "Crete",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.629167,
      "longitude": -96.998889,
      "elevationFeet": 1499,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCEK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCEK?codeType=fs"
     },
     {
      "fs": "KCFJ",
      "iata": "",
      "icao": "KCFJ",
      "faa": "CFJ",
      "name": "Crawfordsville Municipal Airport",
      "city": "Crawfordsville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.987763,
      "longitude": -86.911421,
      "elevationFeet": 763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCFJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCFJ?codeType=fs"
     },
     {
      "fs": "KCGC",
      "iata": "",
      "icao": "KCGC",
      "faa": "CGC",
      "name": "Crystal River",
      "city": "Crystal River",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 28.872278,
      "longitude": -82.613056,
      "elevationFeet": 9,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCGC?codeType=fs"
     },
     {
      "fs": "KCHD",
      "iata": "",
      "icao": "KCHD",
      "faa": "CHD",
      "name": "Chandler Municipal",
      "city": "Chandler",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 33.269167,
      "longitude": -111.811111,
      "elevationFeet": 1243,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCHD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCHD?codeType=fs"
     },
     {
      "fs": "KCHQ",
      "iata": "",
      "icao": "KCHQ",
      "faa": "CHQ",
      "name": "Mississippi Co",
      "city": "Charleston",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.921361,
      "longitude": -89.446583,
      "elevationFeet": 313,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCHQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCHQ?codeType=fs"
     },
     {
      "fs": "KCHT",
      "iata": "",
      "icao": "KCHT",
      "faa": "CHT",
      "name": "Chillicothe Municipal",
      "city": "Chillicothe",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.921667,
      "longitude": -93.606944,
      "elevationFeet": 783,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCHT?codeType=fs"
     },
     {
      "fs": "KCHU",
      "iata": "",
      "icao": "KCHU",
      "faa": "CHU",
      "name": "Houston Co",
      "city": "Caledonia",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.713583,
      "longitude": -91.539472,
      "elevationFeet": 1179,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCHU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCHU?codeType=fs"
     },
     {
      "fs": "KCII",
      "iata": "",
      "icao": "KCII",
      "faa": "CII",
      "name": "Choteau",
      "city": "Choteau",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 47.902778,
      "longitude": -112.312222,
      "elevationFeet": 3949,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCII?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCII?codeType=fs"
     },
     {
      "fs": "KCJJ",
      "iata": "",
      "icao": "KCJJ",
      "faa": "CJJ",
      "name": "Church",
      "city": "Cresco",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.503028,
      "longitude": -92.280833,
      "elevationFeet": 1279,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCJJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCJJ?codeType=fs"
     },
     {
      "fs": "KCKF",
      "iata": "",
      "icao": "KCKF",
      "faa": "CKF",
      "name": "Crisp Co-Cordele",
      "city": "Cordele",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.038333,
      "longitude": -83.839167,
      "elevationFeet": 309,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCKF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCKF?codeType=fs"
     },
     {
      "fs": "KCKP",
      "iata": "",
      "icao": "KCKP",
      "faa": "CKP",
      "name": "Cherokee Municipal",
      "city": "Cherokee",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.864722,
      "longitude": -95.611389,
      "elevationFeet": 1219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCKP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCKP?codeType=fs"
     },
     {
      "fs": "KCN",
      "iata": "KCN",
      "icao": "",
      "faa": "",
      "name": "Chernofski Sea Plane Base",
      "city": "Chernofski",
      "cityCode": "KCN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 53.40287,
      "longitude": -167.520633,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCN?codeType=fs"
     },
     {
      "fs": "KCNC",
      "iata": "",
      "icao": "KCNC",
      "faa": "CNC",
      "name": "Chariton Municipal",
      "city": "Chariton",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.046111,
      "longitude": -93.446833,
      "elevationFeet": 1050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCNC?codeType=fs"
     },
     {
      "fs": "KCNP",
      "iata": "",
      "icao": "KCNP",
      "faa": "CNP",
      "name": "Ray",
      "city": "Chappell",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 41.174722,
      "longitude": -102.590556,
      "elevationFeet": 3682,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCNP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCNP?codeType=fs"
     },
     {
      "fs": "KCOQ",
      "iata": "",
      "icao": "KCOQ",
      "faa": "COQ",
      "name": "Cloquet Carlton Co",
      "city": "Cloquet",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.701694,
      "longitude": -92.555278,
      "elevationFeet": 1279,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCOQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCOQ?codeType=fs"
     },
     {
      "fs": "KCPC",
      "iata": "",
      "icao": "KCPC",
      "faa": "CPC",
      "name": "Columbus Co Municipal",
      "city": "Whiteville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.328722,
      "longitude": -78.849917,
      "elevationFeet": 98,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCPC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCPC?codeType=fs"
     },
     {
      "fs": "KCPU",
      "iata": "",
      "icao": "KCPU",
      "faa": "CPU",
      "name": "Calaveras Co-Rasmussen",
      "city": "San Andreas",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 38.261167,
      "longitude": -120.781722,
      "elevationFeet": 1325,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCPU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCPU?codeType=fs"
     },
     {
      "fs": "KCQA",
      "iata": "",
      "icao": "KCQA",
      "faa": "CQA",
      "name": "Lakefield",
      "city": "Celina",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.490833,
      "longitude": -84.651111,
      "elevationFeet": 894,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCQA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCQA?codeType=fs"
     },
     {
      "fs": "KCQB",
      "iata": "",
      "icao": "KCQB",
      "faa": "CQB",
      "name": "Chandler Municipal",
      "city": "Chandler",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.788167,
      "longitude": -96.852722,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCQB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCQB?codeType=fs"
     },
     {
      "fs": "KCQM",
      "iata": "",
      "icao": "KCQM",
      "faa": "CQM",
      "name": "Cook Municipal",
      "city": "Cook",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 47.869194,
      "longitude": -92.74425,
      "elevationFeet": 1327,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCQM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCQM?codeType=fs"
     },
     {
      "fs": "KCQX",
      "iata": "",
      "icao": "KCQX",
      "faa": "CQX",
      "name": "Chatham Municipal",
      "city": "Chatham",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.733889,
      "longitude": -70.045167,
      "elevationFeet": 68,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCQX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCQX?codeType=fs"
     },
     {
      "fs": "KCRZ",
      "iata": "",
      "icao": "KCRZ",
      "faa": "CRZ",
      "name": "Corning Municipal",
      "city": "Corning",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.09125,
      "longitude": -94.800306,
      "elevationFeet": 1274,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCRZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCRZ?codeType=fs"
     },
     {
      "fs": "KCSB",
      "iata": "",
      "icao": "KCSB",
      "faa": "CSB",
      "name": "Cambridge Municipal",
      "city": "Cambridge",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.365833,
      "longitude": -100.270833,
      "elevationFeet": 2414,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCSB?codeType=fs"
     },
     {
      "fs": "KCTJ",
      "iata": "",
      "icao": "KCTJ",
      "faa": "CTJ",
      "name": "West Georgia Regional-Gray",
      "city": "Carrollton",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.76025,
      "longitude": -85.170306,
      "elevationFeet": 1161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCTJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCTJ?codeType=fs"
     },
     {
      "fs": "KCTK",
      "iata": "",
      "icao": "KCTK",
      "faa": "CTK",
      "name": "Ingersoll",
      "city": "Canton",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.590944,
      "longitude": -90.148389,
      "elevationFeet": 684,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCTK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCTK?codeType=fs"
     },
     {
      "fs": "KCUL",
      "iata": "",
      "icao": "KCUL",
      "faa": "CUL",
      "name": "Carmi Municipal",
      "city": "Carmi",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.144806,
      "longitude": -88.180611,
      "elevationFeet": 388,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCUL?codeType=fs"
     },
     {
      "fs": "KCUT",
      "iata": "",
      "icao": "KCUT",
      "faa": "CUT",
      "name": "Custer Co",
      "city": "Custer",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 43.883167,
      "longitude": -103.626944,
      "elevationFeet": 5602,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCUT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCUT?codeType=fs"
     },
     {
      "fs": "KCVK",
      "iata": "",
      "icao": "KCVK",
      "faa": "CVK",
      "name": "Sharp Co Regional",
      "city": "Ash Flat",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.398722,
      "longitude": -91.676417,
      "elevationFeet": 716,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCVK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCVK?codeType=fs"
     },
     {
      "fs": "KCWV",
      "iata": "",
      "icao": "KCWV",
      "faa": "CWV",
      "name": "Claxton-Evans Co",
      "city": "Claxton",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.300556,
      "longitude": -81.895556,
      "elevationFeet": 112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCWV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCWV?codeType=fs"
     },
     {
      "fs": "KCXE",
      "iata": "",
      "icao": "KCXE",
      "faa": "CXE",
      "name": "Chase City Municipal",
      "city": "Chase City",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.833361,
      "longitude": -78.515528,
      "elevationFeet": 503,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCXE?codeType=fs"
     },
     {
      "fs": "KCXU",
      "iata": "",
      "icao": "KCXU",
      "faa": "CXU",
      "name": "Camilla-Mitchell Co",
      "city": "Camilla",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.329056,
      "longitude": -84.267944,
      "elevationFeet": 175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCXU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCXU?codeType=fs"
     },
     {
      "fs": "KCXY",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Capital City",
      "city": "Harrisburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.221389,
      "longitude": -76.864722,
      "elevationFeet": 347,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCXY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCXY?codeType=fs"
     },
     {
      "fs": "KCYO",
      "iata": "",
      "icao": "KCYO",
      "faa": "CYO",
      "name": "Pickaway Co Memorial",
      "city": "Circleville",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.660056,
      "longitude": -83.121528,
      "elevationFeet": 685,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCYO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCYO?codeType=fs"
     },
     {
      "fs": "KCYW",
      "iata": "",
      "icao": "KCYW",
      "faa": "KCYW",
      "name": "Clay Center Municipal",
      "city": "Clay Center",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.421361,
      "longitude": -97.222167,
      "elevationFeet": 1208,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCYW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCYW?codeType=fs"
     },
     {
      "fs": "KCZD",
      "iata": "",
      "icao": "KCZD",
      "faa": "CZD",
      "name": "Cozad Municipal",
      "city": "Cozad",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.891111,
      "longitude": -100.042222,
      "elevationFeet": 2502,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCZD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCZD?codeType=fs"
     },
     {
      "fs": "KCZG",
      "iata": "",
      "icao": "KCZG",
      "faa": "CZG",
      "name": "Tri-Cities",
      "city": "Endicott",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.185361,
      "longitude": -76.213333,
      "elevationFeet": 833,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCZG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCZG?codeType=fs"
     },
     {
      "fs": "KCZL",
      "iata": "",
      "icao": "KCZL",
      "faa": "CZL",
      "name": "David",
      "city": "Calhoun",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.536639,
      "longitude": -84.999778,
      "elevationFeet": 642,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KCZL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KCZL?codeType=fs"
     },
     {
      "fs": "KDAF",
      "iata": "",
      "icao": "KDAF",
      "faa": "DAF",
      "name": "Necedah",
      "city": "Necedah",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.034389,
      "longitude": -90.101306,
      "elevationFeet": 919,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDAF?codeType=fs"
     },
     {
      "fs": "KDAW",
      "iata": "",
      "icao": "KDAW",
      "faa": "DAW",
      "name": "Skyhaven",
      "city": "Rochester",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 43.290556,
      "longitude": -71.042556,
      "elevationFeet": 322,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDAW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDAW?codeType=fs"
     },
     {
      "fs": "KDCY",
      "iata": "",
      "icao": "KDCY",
      "faa": "DCY",
      "name": "Daviess Co",
      "city": "Washington",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.704361,
      "longitude": -87.247333,
      "elevationFeet": 473,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDCY?codeType=fs"
     },
     {
      "fs": "KDDH",
      "iata": "",
      "icao": "KDDH",
      "faa": "DDH",
      "name": "Morse State",
      "city": "Bennington",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.963278,
      "longitude": -73.364139,
      "elevationFeet": 826,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDDH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDDH?codeType=fs"
     },
     {
      "fs": "KDDJ",
      "iata": "",
      "icao": "KDDJ",
      "faa": "DDJ",
      "name": "Frisco",
      "city": "Frisco",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.248556,
      "longitude": -96.877806,
      "elevationFeet": 611,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDDJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDDJ?codeType=fs"
     },
     {
      "fs": "KDED",
      "iata": "",
      "icao": "KDED",
      "faa": "DED",
      "name": "De Land Mun-Taylor",
      "city": "De Land",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 29.067389,
      "longitude": -81.291167,
      "elevationFeet": 79,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDED?codeType=fs"
     },
     {
      "fs": "KDEQ",
      "iata": "",
      "icao": "KDEQ",
      "faa": "DEQ",
      "name": "Helms Sevier Co",
      "city": "De Queen",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 34.169944,
      "longitude": -94.543667,
      "elevationFeet": 355,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDEQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDEQ?codeType=fs"
     },
     {
      "fs": "KDEW",
      "iata": "",
      "icao": "KDEW",
      "faa": "DEW",
      "name": "Deer Park",
      "city": "Deer Park",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 48.116389,
      "longitude": -117.516667,
      "elevationFeet": 2210,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDEW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDEW?codeType=fs"
     },
     {
      "fs": "KDK",
      "iata": "KDK",
      "icao": "",
      "faa": "",
      "name": "Kodiak Municipal Airport",
      "city": "Kodiak",
      "cityCode": "ADQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 57.807222,
      "longitude": -152.37,
      "elevationFeet": 139,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDK?codeType=fs"
     },
     {
      "fs": "KDKB",
      "iata": "",
      "icao": "KDKB",
      "faa": "DKB",
      "name": "De Kalb Taylor Municipal",
      "city": "De Kalb",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.068806,
      "longitude": -88.783,
      "elevationFeet": 915,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDKB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDKB?codeType=fs"
     },
     {
      "fs": "KDKX",
      "iata": "",
      "icao": "KDKX",
      "faa": "DKX",
      "name": "Knoxville-Downtown I",
      "city": "Knoxville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.088333,
      "longitude": -83.936528,
      "elevationFeet": 833,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDKX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDKX?codeType=fs"
     },
     {
      "fs": "KDLO",
      "iata": "",
      "icao": "KDLO",
      "faa": "DLO",
      "name": "Delano Municipal",
      "city": "Delano",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 35.855806,
      "longitude": -119.265028,
      "elevationFeet": 314,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDLO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDLO?codeType=fs"
     },
     {
      "fs": "KDMW",
      "iata": "",
      "icao": "KDMW",
      "faa": "DMW",
      "name": "Carroll Co Regional/Poage",
      "city": "Westminster",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.682778,
      "longitude": -77.076667,
      "elevationFeet": 789,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDMW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDMW?codeType=fs"
     },
     {
      "fs": "KDPL",
      "iata": "",
      "icao": "KDPL",
      "faa": "DPL",
      "name": "Duplin Co",
      "city": "Kenansville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.000639,
      "longitude": -78.116944,
      "elevationFeet": 137,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDPL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDPL?codeType=fs"
     },
     {
      "fs": "KDQH",
      "iata": "",
      "icao": "KDQH",
      "faa": "DQH",
      "name": "Douglas Municipal",
      "city": "Douglas",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.578083,
      "longitude": -82.946167,
      "elevationFeet": 257,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDQH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDQH?codeType=fs"
     },
     {
      "fs": "KDTG",
      "iata": "",
      "icao": "KDTG",
      "faa": "DTG",
      "name": "Dwight",
      "city": "Dwight",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.283111,
      "longitude": -88.507556,
      "elevationFeet": 632,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDTG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDTG?codeType=fs"
     },
     {
      "fs": "KDTO",
      "iata": "",
      "icao": "KDTO",
      "faa": "DTO",
      "name": "Denton Municipal",
      "city": "Denton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.207222,
      "longitude": -97.329778,
      "elevationFeet": 642,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDTO?codeType=fs"
     },
     {
      "fs": "KDUH",
      "iata": "",
      "icao": "KDUH",
      "faa": "DUH",
      "name": "Toledo Suburban",
      "city": "Lambertville",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.758778,
      "longitude": -83.704111,
      "elevationFeet": 669,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDUH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDUH?codeType=fs"
     },
     {
      "fs": "KDUX",
      "iata": "",
      "icao": "KDUX",
      "faa": "DUX",
      "name": "Moore Co",
      "city": "Dumas",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.929278,
      "longitude": -102.130972,
      "elevationFeet": 3705,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDUX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDUX?codeType=fs"
     },
     {
      "fs": "KDVK",
      "iata": "",
      "icao": "KDVK",
      "faa": "DVK",
      "name": "Powell",
      "city": "Danville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.679167,
      "longitude": -84.796944,
      "elevationFeet": 1022,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDVK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDVK?codeType=fs"
     },
     {
      "fs": "KDWU",
      "iata": "",
      "icao": "KDWU",
      "faa": "DWU",
      "name": "Ashland-Boyd Co",
      "city": "Ashland",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.595,
      "longitude": -82.78,
      "elevationFeet": 546,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDWU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDWU?codeType=fs"
     },
     {
      "fs": "KDXE",
      "iata": "",
      "icao": "KDXE",
      "faa": "DXE",
      "name": "Dexter Municipal",
      "city": "Dexter",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.874694,
      "longitude": -90.011722,
      "elevationFeet": 305,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDXE?codeType=fs"
     },
     {
      "fs": "KDXX",
      "iata": "",
      "icao": "KDXX",
      "faa": "DXX",
      "name": "Madison-Lac Qui Parle Co",
      "city": "Madison",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.012389,
      "longitude": -96.277361,
      "elevationFeet": 1082,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDXX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDXX?codeType=fs"
     },
     {
      "fs": "KDYB",
      "iata": "",
      "icao": "KDYB",
      "faa": "DYB",
      "name": "Summerville",
      "city": "Summerville",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.184444,
      "longitude": -80.393333,
      "elevationFeet": 56,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDYB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDYB?codeType=fs"
     },
     {
      "fs": "KDYR",
      "iata": "",
      "icao": "KDYR",
      "faa": "DYR",
      "name": "Dyersburg Municipal",
      "city": "Dyersburg",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.135167,
      "longitude": -89.460722,
      "elevationFeet": 338,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDYR?codeType=fs"
     },
     {
      "fs": "KDYT",
      "iata": "",
      "icao": "KDYT",
      "faa": "DYT",
      "name": "Sky Harbor",
      "city": "Duluth",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.768556,
      "longitude": -92.134389,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KDYT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KDYT?codeType=fs"
     },
     {
      "fs": "KEAG",
      "iata": "",
      "icao": "KEAG",
      "faa": "EAG",
      "name": "Eagle Grove Municipal",
      "city": "Eagle Grove",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.798056,
      "longitude": -94.061139,
      "elevationFeet": 1133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEAG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEAG?codeType=fs"
     },
     {
      "fs": "KEEO",
      "iata": "",
      "icao": "KEEO",
      "faa": "EEO",
      "name": "Meeker",
      "city": "Meeker",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 40.188611,
      "longitude": -107.909056,
      "elevationFeet": 6421,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEEO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEEO?codeType=fs"
     },
     {
      "fs": "KEET",
      "iata": "",
      "icao": "KEET",
      "faa": "EET",
      "name": "Shelby Co",
      "city": "Alabaster",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.278111,
      "longitude": -86.932361,
      "elevationFeet": 584,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEET?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEET?codeType=fs"
     },
     {
      "fs": "KEFC",
      "iata": "",
      "icao": "KEFC",
      "faa": "EFC",
      "name": "Belle Fourche Municipal",
      "city": "Belle Fourche",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 44.742083,
      "longitude": -103.969917,
      "elevationFeet": 3190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEFC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEFC?codeType=fs"
     },
     {
      "fs": "KEGQ",
      "iata": "",
      "icao": "KEGQ",
      "faa": "EGQ",
      "name": "Emmetsburg Municipal",
      "city": "Emmetsburg",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.120194,
      "longitude": -94.74675,
      "elevationFeet": 1205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEGQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEGQ?codeType=fs"
     },
     {
      "fs": "KEGT",
      "iata": "",
      "icao": "KEGT",
      "faa": "EGT",
      "name": "Wellington Municipal",
      "city": "Wellington",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.394111,
      "longitude": -97.423222,
      "elevationFeet": 1273,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEGT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEGT?codeType=fs"
     },
     {
      "fs": "KEHA",
      "iata": "",
      "icao": "KEHA",
      "faa": "EHA",
      "name": "Elkhart-Morton Co",
      "city": "Elkhart",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.018806,
      "longitude": -102.02125,
      "elevationFeet": 3625,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEHA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEHA?codeType=fs"
     },
     {
      "fs": "KEHO",
      "iata": "",
      "icao": "KEHO",
      "faa": "EHO",
      "name": "Shelby Municipal",
      "city": "Shelby",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.305556,
      "longitude": -81.609972,
      "elevationFeet": 847,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEHO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEHO?codeType=fs"
     },
     {
      "fs": "KEHR",
      "iata": "",
      "icao": "KEHR",
      "faa": "EHR",
      "name": "Henderson City-Co",
      "city": "Henderson",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.878611,
      "longitude": -87.694722,
      "elevationFeet": 386,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEHR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEHR?codeType=fs"
     },
     {
      "fs": "KEIW",
      "iata": "",
      "icao": "KEIW",
      "faa": "EIW",
      "name": "County Memorial",
      "city": "New Madrid",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.553111,
      "longitude": -89.747167,
      "elevationFeet": 295,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEIW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEIW?codeType=fs"
     },
     {
      "fs": "KEKQ",
      "iata": "",
      "icao": "KEKQ",
      "faa": "EKQ",
      "name": "Wayne Co",
      "city": "Monticello",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.902778,
      "longitude": -84.911389,
      "elevationFeet": 963,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEKQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEKQ?codeType=fs"
     },
     {
      "fs": "KEKY",
      "iata": "",
      "icao": "KEKY",
      "faa": "EKY",
      "name": "Bessemer",
      "city": "Bessemer",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.428917,
      "longitude": -87.009083,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEKY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEKY?codeType=fs"
     },
     {
      "fs": "KEMV",
      "iata": "",
      "icao": "KEMV",
      "faa": "EMV",
      "name": "Emporia-Greensville Regional",
      "city": "Emporia",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.719167,
      "longitude": -77.628056,
      "elevationFeet": 127,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEMV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEMV?codeType=fs"
     },
     {
      "fs": "KEOP",
      "iata": "",
      "icao": "KEOP",
      "faa": "EOP",
      "name": "Pike Co",
      "city": "Waverly",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.169333,
      "longitude": -83.03175,
      "elevationFeet": 660,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEOP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEOP?codeType=fs"
     },
     {
      "fs": "KEPM",
      "iata": "",
      "icao": "KEPM",
      "faa": "EPM",
      "name": "Eastport Municipal",
      "city": "Eastport",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.001111,
      "longitude": -67.126944,
      "elevationFeet": 45,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEPM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEPM?codeType=fs"
     },
     {
      "fs": "KEQY",
      "iata": "",
      "icao": "KEQY",
      "faa": "EQY",
      "name": "Monroe",
      "city": "Monroe",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.038444,
      "longitude": -80.652333,
      "elevationFeet": 679,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEQY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEQY?codeType=fs"
     },
     {
      "fs": "KERY",
      "iata": "",
      "icao": "KERY",
      "faa": "ERY",
      "name": "Luce Co",
      "city": "Newberry",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 46.411861,
      "longitude": -85.523167,
      "elevationFeet": 869,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KERY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KERY?codeType=fs"
     },
     {
      "fs": "KETC",
      "iata": "",
      "icao": "KETC",
      "faa": "ETC",
      "name": "Tarboro-Edgecombe",
      "city": "Tarboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.971,
      "longitude": -77.666389,
      "elevationFeet": 53,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KETC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KETC?codeType=fs"
     },
     {
      "fs": "KETH",
      "iata": "",
      "icao": "KETH",
      "faa": "ETH",
      "name": "Wheaton Municipal",
      "city": "Wheaton",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.904611,
      "longitude": -96.635389,
      "elevationFeet": 1025,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KETH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KETH?codeType=fs"
     },
     {
      "fs": "KEUL",
      "iata": "",
      "icao": "KEUL",
      "faa": "EUL",
      "name": "Caldwell Industrial",
      "city": "Caldwell",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 43.718611,
      "longitude": -116.657778,
      "elevationFeet": 2432,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEUL?codeType=fs"
     },
     {
      "fs": "KEVU",
      "iata": "",
      "icao": "KEVU",
      "faa": "EVU",
      "name": "Maryville Memorial",
      "city": "Maryville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.376028,
      "longitude": -95.055278,
      "elevationFeet": 1150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEVU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEVU?codeType=fs"
     },
     {
      "fs": "KEVY",
      "iata": "",
      "icao": "KEVY",
      "faa": "EVY",
      "name": "Summit",
      "city": "Middletown",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.553889,
      "longitude": -75.754444,
      "elevationFeet": 71,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEVY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEVY?codeType=fs"
     },
     {
      "fs": "KEXX",
      "iata": "",
      "icao": "KEXX",
      "faa": "EXX",
      "name": "Davidson Co",
      "city": "Lexington",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.911444,
      "longitude": -80.337833,
      "elevationFeet": 733,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEXX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEXX?codeType=fs"
     },
     {
      "fs": "KEYE",
      "iata": "",
      "icao": "KEYE",
      "faa": "EYE",
      "name": "Eagle Creek Airpark",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.832948,
      "longitude": -86.291999,
      "elevationFeet": 816,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEYE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEYE?codeType=fs"
     },
     {
      "fs": "KEYF",
      "iata": "",
      "icao": "KEYF",
      "faa": "EYF",
      "name": "Elizabethtown",
      "city": "Elizabethtown",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.618361,
      "longitude": -78.697333,
      "elevationFeet": 133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEYF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEYF?codeType=fs"
     },
     {
      "fs": "KEYQ",
      "iata": "",
      "icao": "KEYQ",
      "faa": "EYQ",
      "name": "Weiser",
      "city": "Houston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 29.955028,
      "longitude": -95.699444,
      "elevationFeet": 140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEYQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEYQ?codeType=fs"
     },
     {
      "fs": "KEZF",
      "iata": "",
      "icao": "KEZF",
      "faa": "EZF",
      "name": "Shannon",
      "city": "Fredericksburg",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.2668,
      "longitude": -77.449203,
      "elevationFeet": 85,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEZF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEZF?codeType=fs"
     },
     {
      "fs": "KEZI",
      "iata": "",
      "icao": "KEZI",
      "faa": "EZI",
      "name": "Kewanee Municipal",
      "city": "Kewanee",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.252028,
      "longitude": -90.088611,
      "elevationFeet": 858,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEZI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEZI?codeType=fs"
     },
     {
      "fs": "KEZM",
      "iata": "",
      "icao": "KEZM",
      "faa": "EZM",
      "name": "Heart Of Georgia Regional",
      "city": "Eastman",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.214199,
      "longitude": -83.127998,
      "elevationFeet": 304,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEZM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEZM?codeType=fs"
     },
     {
      "fs": "KEZZ",
      "iata": "",
      "icao": "KEZZ",
      "faa": "EZZ",
      "name": "Cameron Memorial",
      "city": "Cameron",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.825611,
      "longitude": -94.36375,
      "elevationFeet": 1036,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KEZZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KEZZ?codeType=fs"
     },
     {
      "fs": "KFCI",
      "iata": "",
      "icao": "KFCI",
      "faa": "FCI",
      "name": "Chesterfield Co",
      "city": "Richmond",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.465389,
      "longitude": -77.599861,
      "elevationFeet": 237,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFCI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFCI?codeType=fs"
     },
     {
      "fs": "KFDW",
      "iata": "",
      "icao": "KFDW",
      "faa": "FDW",
      "name": "Fairfield Co",
      "city": "Winnsboro",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.454722,
      "longitude": -81.188056,
      "elevationFeet": 577,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFDW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFDW?codeType=fs"
     },
     {
      "fs": "KFES",
      "iata": "",
      "icao": "KFES",
      "faa": "FES",
      "name": "Festus Memorial Airport",
      "city": "Festus",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.194164,
      "longitude": -90.381666,
      "elevationFeet": 431,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFES?codeType=fs"
     },
     {
      "fs": "KFFC",
      "iata": "",
      "icao": "KFFC",
      "faa": "FFC",
      "name": "Peachtree City-Falcon",
      "city": "Atlanta",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.419444,
      "longitude": -84.616667,
      "elevationFeet": 808,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFFC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFFC?codeType=fs"
     },
     {
      "fs": "KFGX",
      "iata": "",
      "icao": "KFGX",
      "faa": "FGX",
      "name": "Fleming-Mason",
      "city": "Flemingsburg",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.618056,
      "longitude": -83.833889,
      "elevationFeet": 913,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFGX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFGX?codeType=fs"
     },
     {
      "fs": "KFIG",
      "iata": "",
      "icao": "KFIG",
      "faa": "FIG",
      "name": "Clearfield-Lawrence",
      "city": "Clearfield",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.186139,
      "longitude": -78.531028,
      "elevationFeet": 1516,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFIG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFIG?codeType=fs"
     },
     {
      "fs": "KFIO",
      "iata": "",
      "icao": "KFIO",
      "faa": "FIO",
      "name": "West Kentucky",
      "city": "Paducah",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.975306,
      "longitude": -88.702694,
      "elevationFeet": 338,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFIO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFIO?codeType=fs"
     },
     {
      "fs": "KFIT",
      "iata": "",
      "icao": "KFIT",
      "faa": "FIT",
      "name": "Fitchburg Municipal",
      "city": "Fitchburg",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.591167,
      "longitude": -71.839611,
      "elevationFeet": 348,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFIT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFIT?codeType=fs"
     },
     {
      "fs": "KFKR",
      "iata": "",
      "icao": "KFKR",
      "faa": "FKR",
      "name": "Frankfort Municipal",
      "city": "Frankfort",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.334306,
      "longitude": -86.671694,
      "elevationFeet": 861,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFKR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFKR?codeType=fs"
     },
     {
      "fs": "KFMZ",
      "iata": "",
      "icao": "KFMZ",
      "faa": "FMZ",
      "name": "Fairmont State",
      "city": "Fairmont",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.606944,
      "longitude": -97.630556,
      "elevationFeet": 1636,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFMZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFMZ?codeType=fs"
     },
     {
      "fs": "KFNB",
      "iata": "",
      "icao": "KFNB",
      "faa": "FNB",
      "name": "Brenner",
      "city": "Falls City",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.187861,
      "longitude": -95.669917,
      "elevationFeet": 984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFNB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFNB?codeType=fs"
     },
     {
      "fs": "KFOA",
      "iata": "",
      "icao": "KFOA",
      "faa": "FOA",
      "name": "Flora Municipal",
      "city": "Flora",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.799444,
      "longitude": -88.479944,
      "elevationFeet": 472,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFOA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFOA?codeType=fs"
     },
     {
      "fs": "KFOT",
      "iata": "",
      "icao": "KFOT",
      "faa": "FOT",
      "name": "Rohnerville",
      "city": "Fortuna",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 40.589361,
      "longitude": -124.276583,
      "elevationFeet": 392,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFOT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFOT?codeType=fs"
     },
     {
      "fs": "KFOZ",
      "iata": "",
      "icao": "KFOZ",
      "faa": "FOZ",
      "name": "Bigfork Municipal",
      "city": "Bigfork",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 47.928333,
      "longitude": -93.651944,
      "elevationFeet": 1348,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFOZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFOZ?codeType=fs"
     },
     {
      "fs": "KFQD",
      "iata": "",
      "icao": "KFQD",
      "faa": "FQD",
      "name": "Rutherford Co-Marchman",
      "city": "Rutherfordton",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.532222,
      "longitude": -81.950778,
      "elevationFeet": 1078,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFQD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFQD?codeType=fs"
     },
     {
      "fs": "KFSE",
      "iata": "",
      "icao": "KFSE",
      "faa": "FSE",
      "name": "Fosston Municipal",
      "city": "Fosston",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 47.678194,
      "longitude": -95.835,
      "elevationFeet": 1277,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFSE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFSE?codeType=fs"
     },
     {
      "fs": "KFSO",
      "iata": "",
      "icao": "KFSO",
      "faa": "FSO",
      "name": "Franklin Co State",
      "city": "Highgate",
      "stateCode": "VT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.002917,
      "longitude": -73.224639,
      "elevationFeet": 228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFSO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFSO?codeType=fs"
     },
     {
      "fs": "KFTG",
      "iata": "",
      "icao": "KFTG",
      "faa": "FTG",
      "name": "Front Range Airport",
      "city": "Denver",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 39.779653,
      "longitude": -104.532695,
      "elevationFeet": 5510,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFTG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFTG?codeType=fs"
     },
     {
      "fs": "KFTT",
      "iata": "",
      "icao": "KFTT",
      "faa": "FTT",
      "name": "Hensley Memorial",
      "city": "Fulton",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.89875,
      "longitude": -92.042111,
      "elevationFeet": 886,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFTT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFTT?codeType=fs"
     },
     {
      "fs": "KFVX",
      "iata": "",
      "icao": "KFVX",
      "faa": "FVX",
      "name": "Farmville Regional",
      "city": "Farmville",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.425278,
      "longitude": -78.477972,
      "elevationFeet": 417,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFVX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFVX?codeType=fs"
     },
     {
      "fs": "KFWC",
      "iata": "",
      "icao": "KFWC",
      "faa": "FWC",
      "name": "Fairfield Municipal",
      "city": "Fairfield",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.486333,
      "longitude": -88.526528,
      "elevationFeet": 436,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFWC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFWC?codeType=fs"
     },
     {
      "fs": "KFWN",
      "iata": "",
      "icao": "KFWN",
      "faa": "FWN",
      "name": "Sussex",
      "city": "Sussex",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.202056,
      "longitude": -74.6805,
      "elevationFeet": 421,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFWN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFWN?codeType=fs"
     },
     {
      "fs": "KFWS",
      "iata": "",
      "icao": "KFWS",
      "faa": "FWS",
      "name": "Ft Worth Spinks",
      "city": "Ft Worth",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.701333,
      "longitude": -97.380722,
      "elevationFeet": 700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFWS?codeType=fs"
     },
     {
      "fs": "KFYE",
      "iata": "",
      "icao": "KFYE",
      "faa": "FYE",
      "name": "Fayette Co",
      "city": "Somerville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.259194,
      "longitude": -89.494167,
      "elevationFeet": 436,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFYE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFYE?codeType=fs"
     },
     {
      "fs": "KFYJ",
      "iata": "",
      "icao": "KFYJ",
      "faa": "FYJ",
      "name": "Middle Peninsula Regional",
      "city": "West Point",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.521198,
      "longitude": -76.764702,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFYJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFYJ?codeType=fs"
     },
     {
      "fs": "KFZG",
      "iata": "",
      "icao": "KFZG",
      "faa": "FZG",
      "name": "Fitzgerald Municipal",
      "city": "Fitzgerald",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.686861,
      "longitude": -83.304611,
      "elevationFeet": 365,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFZG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFZG?codeType=fs"
     },
     {
      "fs": "KFZI",
      "iata": "",
      "icao": "KFZI",
      "faa": "FZI",
      "name": "Fostoria Metropolitan",
      "city": "Fostoria",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.258306,
      "longitude": -83.495361,
      "elevationFeet": 752,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFZI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFZI?codeType=fs"
     },
     {
      "fs": "KFZY",
      "iata": "",
      "icao": "KFZY",
      "faa": "FZY",
      "name": "Oswego Co",
      "city": "Fulton",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 43.357639,
      "longitude": -76.430472,
      "elevationFeet": 475,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KFZY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KFZY?codeType=fs"
     },
     {
      "fs": "KGAF",
      "iata": "",
      "icao": "KGAF",
      "faa": "GAF",
      "name": "Grafton Municipal",
      "city": "Grafton",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 48.445944,
      "longitude": -97.409,
      "elevationFeet": 824,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGAF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGAF?codeType=fs"
     },
     {
      "fs": "KGAS",
      "iata": "",
      "icao": "KGAS",
      "faa": "GAS",
      "name": "Gallia-Meigs Regional",
      "city": "Gallipolis",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.841083,
      "longitude": -82.284222,
      "elevationFeet": 567,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGAS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGAS?codeType=fs"
     },
     {
      "fs": "KGCT",
      "iata": "",
      "icao": "KGCT",
      "faa": "GCT",
      "name": "Guthrie Co Regional",
      "city": "Guthrie Center",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.707361,
      "longitude": -94.434639,
      "elevationFeet": 1230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGCT?codeType=fs"
     },
     {
      "fs": "KGDY",
      "iata": "",
      "icao": "KGDY",
      "faa": "GDY",
      "name": "Grundy Municipal",
      "city": "Grundy",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.374,
      "longitude": -82.199917,
      "elevationFeet": 2304,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGDY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGDY?codeType=fs"
     },
     {
      "fs": "KGEO",
      "iata": "",
      "icao": "KGEO",
      "faa": "GEO",
      "name": "Brown County Airport",
      "city": "Georgetown",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.882121,
      "longitude": -83.881789,
      "elevationFeet": 955,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGEO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGEO?codeType=fs"
     },
     {
      "fs": "KGEU",
      "iata": "",
      "icao": "KGEU",
      "faa": "GEU",
      "name": "Glendale Municipal Airport",
      "city": "Glendale",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 33.530634,
      "longitude": -112.292874,
      "elevationFeet": 1053,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGEU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGEU?codeType=fs"
     },
     {
      "fs": "KGEV",
      "iata": "",
      "icao": "KGEV",
      "faa": "GEV",
      "name": "Ashe Co",
      "city": "Jefferson",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.574583,
      "longitude": -81.447139,
      "elevationFeet": 3180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGEV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGEV?codeType=fs"
     },
     {
      "fs": "KGEZ",
      "iata": "",
      "icao": "KGEZ",
      "faa": "GEZ",
      "name": "Shelbyville Municipal Airport",
      "city": "Shelbyville",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.590419,
      "longitude": -85.807634,
      "elevationFeet": 792,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGEZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGEZ?codeType=fs"
     },
     {
      "fs": "KGFZ",
      "iata": "",
      "icao": "KGFZ",
      "faa": "GFZ",
      "name": "Greenfield Municipal",
      "city": "Greenfield",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.420278,
      "longitude": -94.557222,
      "elevationFeet": 1361,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGFZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGFZ?codeType=fs"
     },
     {
      "fs": "KGGF",
      "iata": "",
      "icao": "KGGF",
      "faa": "GGF",
      "name": "Grant Municipal",
      "city": "Grant",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 40.895278,
      "longitude": -101.878611,
      "elevationFeet": 3424,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGGF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGGF?codeType=fs"
     },
     {
      "fs": "KGGI",
      "iata": "",
      "icao": "KGGI",
      "faa": "GGI",
      "name": "Grinnell Regional",
      "city": "Grinnell",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.791611,
      "longitude": -92.749139,
      "elevationFeet": 1008,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGGI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGGI?codeType=fs"
     },
     {
      "fs": "KGGP",
      "iata": "",
      "icao": "KGGP",
      "faa": "GGP",
      "name": "Logansport Municipal",
      "city": "Logansport",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.812611,
      "longitude": -86.445,
      "elevationFeet": 738,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGGP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGGP?codeType=fs"
     },
     {
      "fs": "KGHW",
      "iata": "",
      "icao": "KGHW",
      "faa": "GHW",
      "name": "Glenwood Municipal",
      "city": "Glenwood",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.738917,
      "longitude": -95.354306,
      "elevationFeet": 1393,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGHW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGHW?codeType=fs"
     },
     {
      "fs": "KGLY",
      "iata": "",
      "icao": "KGLY",
      "faa": "GLY",
      "name": "Clinton Memorial",
      "city": "Clinton",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.415778,
      "longitude": -93.691833,
      "elevationFeet": 822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGLY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGLY?codeType=fs"
     },
     {
      "fs": "KGNF",
      "iata": "",
      "icao": "KGNF",
      "faa": "GNF",
      "name": "Grenada Municipal",
      "city": "Grenada",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.975306,
      "longitude": -89.932278,
      "elevationFeet": 208,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGNF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGNF?codeType=fs"
     },
     {
      "fs": "KGNI",
      "iata": "",
      "icao": "KGNI",
      "faa": "GNI",
      "name": "Grand Isle Seaplane Base",
      "city": "Grand Isle",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.685",
      "utcOffsetHours": -10,
      "latitude": 29.377278,
      "longitude": -90.061833,
      "elevationFeet": 1,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGNI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGNI?codeType=fs"
     },
     {
      "fs": "KGPH",
      "iata": "",
      "icao": "KGPH",
      "faa": "GPH",
      "name": "Midwest National Air Center Airport",
      "city": "Mosby",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.33017,
      "longitude": -94.306033,
      "elevationFeet": 773,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGPH?codeType=fs"
     },
     {
      "fs": "KGPM",
      "iata": "",
      "icao": "KGPM",
      "faa": "GPM",
      "name": "Grand Prairie Municipal Airport",
      "city": "Grand Prairie",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.699097,
      "longitude": -97.0418,
      "elevationFeet": 580,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGPM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGPM?codeType=fs"
     },
     {
      "fs": "KGTE",
      "iata": "",
      "icao": "KGTE",
      "faa": "GTE",
      "name": "Quinn",
      "city": "Gothenburg",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.012778,
      "longitude": -100.283056,
      "elevationFeet": 2559,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGTE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGTE?codeType=fs"
     },
     {
      "fs": "KGVQ",
      "iata": "",
      "icao": "KGVQ",
      "faa": "GVQ",
      "name": "Genesee Co",
      "city": "Batavia",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 43.167278,
      "longitude": -78.176,
      "elevationFeet": 913,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGVQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGVQ?codeType=fs"
     },
     {
      "fs": "KGWR",
      "iata": "",
      "icao": "KGWR",
      "faa": "GWR",
      "name": "Gwinner-Melroe",
      "city": "Gwinner",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.237222,
      "longitude": -97.7325,
      "elevationFeet": 1266,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGWR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGWR?codeType=fs"
     },
     {
      "fs": "KGWW",
      "iata": "",
      "icao": "KGWW",
      "faa": "GWW",
      "name": "Goldsboro-Wayne Municipal Airport",
      "city": "Goldsboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.460701,
      "longitude": -77.963413,
      "elevationFeet": 130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGWW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGWW?codeType=fs"
     },
     {
      "fs": "KGYL",
      "iata": "",
      "icao": "KGYL",
      "faa": "GYL",
      "name": "Glencoe Municipal",
      "city": "Glencoe",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.810444,
      "longitude": -94.212111,
      "elevationFeet": 992,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGYL?codeType=fs"
     },
     {
      "fs": "KGZ",
      "iata": "KGZ",
      "icao": "",
      "faa": "",
      "name": "Glacier Creek Airport",
      "city": "Glacier Creek",
      "cityCode": "KGZ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 61.45,
      "longitude": -142.383333,
      "elevationFeet": 2380,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGZ?codeType=fs"
     },
     {
      "fs": "KGZH",
      "iata": "",
      "icao": "KGZH",
      "faa": "GZH",
      "name": "Middleton",
      "city": "Evergreen",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.558056,
      "longitude": -87.140444,
      "elevationFeet": 260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KGZH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KGZH?codeType=fs"
     },
     {
      "fs": "KHAD",
      "iata": "",
      "icao": "KHAD",
      "faa": "HAD",
      "name": "Harford",
      "city": "Casper",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 42.994111,
      "longitude": -106.394694,
      "elevationFeet": 5370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHAD?codeType=fs"
     },
     {
      "fs": "KHAE",
      "iata": "",
      "icao": "KHAE",
      "faa": "HAE",
      "name": "Hannibal Municipal",
      "city": "Hannibal",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.794889,
      "longitude": -91.536806,
      "elevationFeet": 772,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHAE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHAE?codeType=fs"
     },
     {
      "fs": "KHBC",
      "iata": "",
      "icao": "KHBC",
      "faa": "HBC",
      "name": "Mohall Municipal",
      "city": "Mohall",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 48.783833,
      "longitude": -101.569944,
      "elevationFeet": 1649,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHBC?codeType=fs"
     },
     {
      "fs": "KHBI",
      "iata": "",
      "icao": "KHBI",
      "faa": "HBI",
      "name": "Asheboro Municipal",
      "city": "Asheboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.688833,
      "longitude": -80.000417,
      "elevationFeet": 673,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHBI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHBI?codeType=fs"
     },
     {
      "fs": "KHBV",
      "iata": "",
      "icao": "KHBV",
      "faa": "HBV",
      "name": "Hogg Co",
      "city": "Hebbronville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 27.495556,
      "longitude": -98.769722,
      "elevationFeet": 663,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHBV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHBV?codeType=fs"
     },
     {
      "fs": "KHCD",
      "iata": "",
      "icao": "KHCD",
      "faa": "HCD",
      "name": "Hutchinson Mun-Butler",
      "city": "Hutchinson",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.939056,
      "longitude": -94.517889,
      "elevationFeet": 1060,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHCD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHCD?codeType=fs"
     },
     {
      "fs": "KHCO",
      "iata": "",
      "icao": "KHCO",
      "faa": "HCO",
      "name": "Hallock Municipal",
      "city": "Hallock",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 48.777306,
      "longitude": -97.030028,
      "elevationFeet": 819,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHCO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHCO?codeType=fs"
     },
     {
      "fs": "KHDI",
      "iata": "",
      "icao": "KHDI",
      "faa": "HDI",
      "name": "Hardwick",
      "city": "Cleveland",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.250722,
      "longitude": -84.974444,
      "elevationFeet": 874,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHDI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHDI?codeType=fs"
     },
     {
      "fs": "KHEI",
      "iata": "",
      "icao": "KHEI",
      "faa": "HEI",
      "name": "Hettinger Municipal",
      "city": "Hettinger",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 46.148556,
      "longitude": -102.709167,
      "elevationFeet": 2705,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHEI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHEI?codeType=fs"
     },
     {
      "fs": "KHEQ",
      "iata": "",
      "icao": "KHEQ",
      "faa": "HEQ",
      "name": "Holyoke Municipal",
      "city": "Holyoke",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 40.66825,
      "longitude": -102.383,
      "elevationFeet": 3730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHEQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHEQ?codeType=fs"
     },
     {
      "fs": "KHFY",
      "iata": "",
      "icao": "KHFY",
      "faa": "HFY",
      "name": "Greenwood Municipal Airport",
      "city": "Indianapolis",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.629079,
      "longitude": -86.090403,
      "elevationFeet": 824,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHFY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHFY?codeType=fs"
     },
     {
      "fs": "KHHF",
      "iata": "",
      "icao": "KHHF",
      "faa": "HHF",
      "name": "Hemphill Co",
      "city": "Canadian",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.003194,
      "longitude": -100.436333,
      "elevationFeet": 2394,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHHF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHHF?codeType=fs"
     },
     {
      "fs": "KHHG",
      "iata": "",
      "icao": "KHHG",
      "faa": "HHG",
      "name": "Huntington Municipal",
      "city": "Huntington",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.879889,
      "longitude": -85.544194,
      "elevationFeet": 806,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHHG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHHG?codeType=fs"
     },
     {
      "fs": "KHIG",
      "iata": "",
      "icao": "KHIG",
      "faa": "HIG",
      "name": "Higginsville Industrial Municipal Airport",
      "city": "Higginsville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.074006,
      "longitude": -93.672783,
      "elevationFeet": 763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHIG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHIG?codeType=fs"
     },
     {
      "fs": "KHJH",
      "iata": "",
      "icao": "KHJH",
      "faa": "HJH",
      "name": "Hebron Municipal",
      "city": "Hebron",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.1725,
      "longitude": -97.619722,
      "elevationFeet": 1466,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHJH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHJH?codeType=fs"
     },
     {
      "fs": "KHJO",
      "iata": "",
      "icao": "KHJO",
      "faa": "HJO",
      "name": "Hanford Municipal",
      "city": "Hanford",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 36.335222,
      "longitude": -119.738667,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHJO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHJO?codeType=fs"
     },
     {
      "fs": "KHMZ",
      "iata": "",
      "icao": "KHMZ",
      "faa": "HMZ",
      "name": "Bedford Co",
      "city": "Bedford",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.103694,
      "longitude": -78.622167,
      "elevationFeet": 1161,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHMZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHMZ?codeType=fs"
     },
     {
      "fs": "KHNR",
      "iata": "",
      "icao": "KHNR",
      "faa": "HNR",
      "name": "Harlan Municipal",
      "city": "Harlan",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.593889,
      "longitude": -95.396389,
      "elevationFeet": 1231,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHNR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHNR?codeType=fs"
     },
     {
      "fs": "KHNZ",
      "iata": "",
      "icao": "KHNZ",
      "faa": "HNZ",
      "name": "Henderson Oxford Airport",
      "city": "Oxford",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.363765,
      "longitude": -78.528521,
      "elevationFeet": 511,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHNZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHNZ?codeType=fs"
     },
     {
      "fs": "KHOC",
      "iata": "",
      "icao": "KHOC",
      "faa": "HOC",
      "name": "Highland Co",
      "city": "Hillsboro",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.237611,
      "longitude": -83.588083,
      "elevationFeet": 978,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHOC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHOC?codeType=fs"
     },
     {
      "fs": "KHOE",
      "iata": "",
      "icao": "KHOE",
      "faa": "HOE",
      "name": "Homerville",
      "city": "Homerville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 31.109167,
      "longitude": -82.841389,
      "elevationFeet": 186,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHOE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHOE?codeType=fs"
     },
     {
      "fs": "KHQG",
      "iata": "",
      "icao": "KHQG",
      "faa": "HQG",
      "name": "Hugoton Municipal",
      "city": "Hugoton",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.280806,
      "longitude": -101.405278,
      "elevationFeet": 3133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHQG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHQG?codeType=fs"
     },
     {
      "fs": "KHQU",
      "iata": "",
      "icao": "KHQU",
      "faa": "HQU",
      "name": "Thomson-Mc Duffie Co",
      "city": "Thomson",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.647278,
      "longitude": -82.517861,
      "elevationFeet": 498,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHQU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHQU?codeType=fs"
     },
     {
      "fs": "KHQZ",
      "iata": "",
      "icao": "KHQZ",
      "faa": "HQZ",
      "name": "Mesquite Metro",
      "city": "Mesquite",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.869639,
      "longitude": -96.654167,
      "elevationFeet": 447,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHQZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHQZ?codeType=fs"
     },
     {
      "fs": "KHRT",
      "iata": "",
      "icao": "KHRT",
      "faa": "HRT",
      "name": "Hurlburt",
      "city": "Mary Esther",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.539139,
      "longitude": -86.742778,
      "elevationFeet": 38,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHRT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHRT?codeType=fs"
     },
     {
      "fs": "KHRU",
      "iata": "",
      "icao": "KHRU",
      "faa": "HRU",
      "name": "Herington Regional",
      "city": "Herington",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.83225,
      "longitude": -96.880056,
      "elevationFeet": 1480,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHRU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHRU?codeType=fs"
     },
     {
      "fs": "KHRX",
      "iata": "",
      "icao": "KHRX",
      "faa": "HRX",
      "name": "Hereford Municipal",
      "city": "Hereford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 34.926167,
      "longitude": -102.422,
      "elevationFeet": 3783,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHRX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHRX?codeType=fs"
     },
     {
      "fs": "KHSD",
      "iata": "",
      "icao": "KHSD",
      "faa": "HSD",
      "name": "Sundance",
      "city": "Oklahoma City",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.618306,
      "longitude": -97.761556,
      "elevationFeet": 1193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHSD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHSD?codeType=fs"
     },
     {
      "fs": "KHSR",
      "iata": "",
      "icao": "KHSR",
      "faa": "HSR",
      "name": "Hot Springs Municipal",
      "city": "Hot Springs",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 43.382444,
      "longitude": -103.431389,
      "elevationFeet": 3148,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHSR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHSR?codeType=fs"
     },
     {
      "fs": "KHVC",
      "iata": "",
      "icao": "KHVC",
      "faa": "HVC",
      "name": "Hopkinsville-Christian Co",
      "city": "Hopkinsville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.915833,
      "longitude": -87.5225,
      "elevationFeet": 553,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHVC?codeType=fs"
     },
     {
      "fs": "KHWQ",
      "iata": "",
      "icao": "KHWQ",
      "faa": "HWQ",
      "name": "Wheatland Co",
      "city": "Harlowton",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 46.491222,
      "longitude": -109.899056,
      "elevationFeet": 4309,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHWQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHWQ?codeType=fs"
     },
     {
      "fs": "KHXF",
      "iata": "",
      "icao": "KHXF",
      "faa": "HXF",
      "name": "Hartford Municipal",
      "city": "Hartford",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.492778,
      "longitude": -88.46125,
      "elevationFeet": 1070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHXF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHXF?codeType=fs"
     },
     {
      "fs": "KHYI",
      "iata": "",
      "icao": "KHYI",
      "faa": "HYI",
      "name": "San Marcos Municipal",
      "city": "San Marcos",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 29.8927,
      "longitude": -97.862999,
      "elevationFeet": 597,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHYI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHYI?codeType=fs"
     },
     {
      "fs": "KHYW",
      "iata": "",
      "icao": "KHYW",
      "faa": "HYW",
      "name": "Conway-Horry Co",
      "city": "Conway",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.935,
      "longitude": -79.171667,
      "elevationFeet": 34,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHYW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHYW?codeType=fs"
     },
     {
      "fs": "KHYX",
      "iata": "",
      "icao": "KHYX",
      "faa": "HYX",
      "name": "Saginaw Co-Browne",
      "city": "Saginaw",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 43.434111,
      "longitude": -83.974583,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHYX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHYX?codeType=fs"
     },
     {
      "fs": "KHZD",
      "iata": "",
      "icao": "KHZD",
      "faa": "HZD",
      "name": "Carroll Co",
      "city": "Huntingdon",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.143083,
      "longitude": -88.582972,
      "elevationFeet": 496,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHZD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHZD?codeType=fs"
     },
     {
      "fs": "KHZE",
      "iata": "",
      "icao": "KHZE",
      "faa": "HZE",
      "name": "Mercer Co Regional",
      "city": "Hazen",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/North_Dakota/Beulah",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 47.348611,
      "longitude": -101.709444,
      "elevationFeet": 1813,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHZE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHZE?codeType=fs"
     },
     {
      "fs": "KHZR",
      "iata": "",
      "icao": "KHZR",
      "faa": "HZR",
      "name": "False River",
      "city": "New Roads",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.733222,
      "longitude": -91.586694,
      "elevationFeet": 39,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHZR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHZR?codeType=fs"
     },
     {
      "fs": "KHZY",
      "iata": "",
      "icao": "KHZY",
      "faa": "HZY",
      "name": "Ashtabula Co",
      "city": "Ashtabula",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.879722,
      "longitude": -80.80525,
      "elevationFeet": 924,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KHZY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KHZY?codeType=fs"
     },
     {
      "fs": "KIB",
      "iata": "KIB",
      "icao": "",
      "faa": "",
      "name": "Ivanof Bay Sea Plane Base",
      "city": "Ivanof Bay",
      "cityCode": "KIB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 55.89778,
      "longitude": -159.487224,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIB?codeType=fs"
     },
     {
      "fs": "KIBM",
      "iata": "",
      "icao": "KIBM",
      "faa": "IBM",
      "name": "Kimball Municipal/Arraj",
      "city": "Kimball",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 41.230556,
      "longitude": -103.773889,
      "elevationFeet": 4926,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIBM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIBM?codeType=fs"
     },
     {
      "fs": "KIDL",
      "iata": "",
      "icao": "KIDL",
      "faa": "IDL",
      "name": "Indianola Municipal",
      "city": "Indianola",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.507556,
      "longitude": -90.788694,
      "elevationFeet": 126,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIDL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIDL?codeType=fs"
     },
     {
      "fs": "KIER",
      "iata": "",
      "icao": "KIER",
      "faa": "IER",
      "name": "Natchitoches Regional",
      "city": "Natchitoches",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.735701,
      "longitude": -93.099098,
      "elevationFeet": 121,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIER?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIER?codeType=fs"
     },
     {
      "fs": "KIGQ",
      "iata": "",
      "icao": "KIGQ",
      "faa": "IGQ",
      "name": "Lansing Municipal",
      "city": "Chicago",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.534901,
      "longitude": -87.529503,
      "elevationFeet": 620,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIGQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIGQ?codeType=fs"
     },
     {
      "fs": "KIGX",
      "iata": "",
      "icao": "KIGX",
      "faa": "IGX",
      "name": "Horace Williams Airport",
      "city": "Chapel Hill",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.934599,
      "longitude": -79.060805,
      "elevationFeet": 487,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIGX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIGX?codeType=fs"
     },
     {
      "fs": "KIIB",
      "iata": "",
      "icao": "KIIB",
      "faa": "IIB",
      "name": "Independence Municipal",
      "city": "Independence",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.485972,
      "longitude": -92.076194,
      "elevationFeet": 978,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIIB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIIB?codeType=fs"
     },
     {
      "fs": "KIIY",
      "iata": "",
      "icao": "KIIY",
      "faa": "IIY",
      "name": "Washington-Wilkes Co",
      "city": "Washington",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.89875,
      "longitude": -82.966167,
      "elevationFeet": 645,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIIY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIIY?codeType=fs"
     },
     {
      "fs": "KIJD",
      "iata": "",
      "icao": "KIJD",
      "faa": "IJD",
      "name": "Windham",
      "city": "Willimantic",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.840417,
      "longitude": -72.302361,
      "elevationFeet": 247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIJD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIJD?codeType=fs"
     },
     {
      "fs": "KIKG",
      "iata": "",
      "icao": "KIKG",
      "faa": "IKG",
      "name": "Kleberg Co",
      "city": "Kingsville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 27.558611,
      "longitude": -98.159194,
      "elevationFeet": 131,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIKG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIKG?codeType=fs"
     },
     {
      "fs": "KIKV",
      "iata": "",
      "icao": "KIKV",
      "faa": "IKV",
      "name": "Ankeny Regional",
      "city": "Ankeny",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.691399,
      "longitude": -93.566399,
      "elevationFeet": 910,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIKV?codeType=fs"
     },
     {
      "fs": "KIMS",
      "iata": "",
      "icao": "KIMS",
      "faa": "IMS",
      "name": "Madison Municipal Airport",
      "city": "Madison",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.763291,
      "longitude": -85.457388,
      "elevationFeet": 819,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIMS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIMS?codeType=fs"
     },
     {
      "fs": "KIOB",
      "iata": "",
      "icao": "KIOB",
      "faa": "IOB",
      "name": "Mt Sterling-Montgomery Co",
      "city": "Mount Sterling",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.131389,
      "longitude": -84.095833,
      "elevationFeet": 1019,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIOB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIOB?codeType=fs"
     },
     {
      "fs": "KIP",
      "iata": "KIP",
      "icao": "",
      "faa": "T47",
      "name": "Kickapoo Airport",
      "city": "Wichita Falls",
      "cityCode": "SPS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.9,
      "longitude": -98.5,
      "elevationFeet": 998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIP?codeType=fs"
     },
     {
      "fs": "KIPJ",
      "iata": "",
      "icao": "KIPJ",
      "faa": "IPJ",
      "name": "Lincolnton-Lincoln Co",
      "city": "Lincolnton",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.633278,
      "longitude": -81.262583,
      "elevationFeet": 875,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIPJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIPJ?codeType=fs"
     },
     {
      "fs": "KISB",
      "iata": "",
      "icao": "KISB",
      "faa": "ISB",
      "name": "Sibley Municipal",
      "city": "Sibley",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.398333,
      "longitude": -95.841389,
      "elevationFeet": 1537,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KISB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KISB?codeType=fs"
     },
     {
      "fs": "KISZ",
      "iata": "",
      "icao": "KISZ",
      "faa": "ISZ",
      "name": "Cincinnati Blue Ash Airport",
      "city": "Cincinnati",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.245765,
      "longitude": -84.39033,
      "elevationFeet": 843,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KISZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KISZ?codeType=fs"
     },
     {
      "fs": "KITR",
      "iata": "",
      "icao": "KITR",
      "faa": "ITR",
      "name": "Kit Carson Co",
      "city": "Burlington",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 39.325083,
      "longitude": -102.303778,
      "elevationFeet": 4219,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KITR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KITR?codeType=fs"
     },
     {
      "fs": "KIWH",
      "iata": "",
      "icao": "KIWH",
      "faa": "IWH",
      "name": "Wabash Municipal",
      "city": "Wabash",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.869611,
      "longitude": -85.937333,
      "elevationFeet": 796,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KIWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KIWH?codeType=fs"
     },
     {
      "fs": "KJAU",
      "iata": "",
      "icao": "KJAU",
      "faa": "JAU",
      "name": "Campbell Co",
      "city": "Jacksboro",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.345806,
      "longitude": -84.273417,
      "elevationFeet": 1180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJAU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJAU?codeType=fs"
     },
     {
      "fs": "KJER",
      "iata": "",
      "icao": "KJER",
      "faa": "JER",
      "name": "Jerome Co",
      "city": "Jerome",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 42.816389,
      "longitude": -114.521389,
      "elevationFeet": 4048,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJER?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJER?codeType=fs"
     },
     {
      "fs": "KJFX",
      "iata": "",
      "icao": "KJFX",
      "faa": "JFX",
      "name": "Walker Co-Bevill",
      "city": "Jasper",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.919944,
      "longitude": -87.441667,
      "elevationFeet": 482,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJFX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJFX?codeType=fs"
     },
     {
      "fs": "KJGG",
      "iata": "",
      "icao": "KJGG",
      "faa": "JGG",
      "name": "Williamsburg-Jamestown",
      "city": "Williamsburg",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.239201,
      "longitude": -76.716103,
      "elevationFeet": 49,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJGG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJGG?codeType=fs"
     },
     {
      "fs": "KJKJ",
      "iata": "",
      "icao": "KJKJ",
      "faa": "JKJ",
      "name": "Moorhead Municipal",
      "city": "Moorhead",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.891917,
      "longitude": -96.782722,
      "elevationFeet": 917,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJKJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJKJ?codeType=fs"
     },
     {
      "fs": "KJKL",
      "iata": "",
      "icao": "KJKL",
      "faa": "JKL",
      "name": "Carroll",
      "city": "Jackson",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.688611,
      "longitude": -83.3225,
      "elevationFeet": 1381,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJKL?codeType=fs"
     },
     {
      "fs": "KJMR",
      "iata": "",
      "icao": "KJMR",
      "faa": "JMR",
      "name": "Mora Municipal",
      "city": "Mora",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.910972,
      "longitude": -93.317778,
      "elevationFeet": 1012,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJMR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJMR?codeType=fs"
     },
     {
      "fs": "KJNX",
      "iata": "",
      "icao": "KJNX",
      "faa": "JNX",
      "name": "Johnston County Airport",
      "city": "Smithfield",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.543253,
      "longitude": -78.393744,
      "elevationFeet": 134,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJNX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJNX?codeType=fs"
     },
     {
      "fs": "KJRA",
      "iata": "",
      "icao": "KJRA",
      "faa": "JRA",
      "name": "Port Authority-West 30Th St. Midtown. (Hel",
      "city": "New York",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.75458,
      "longitude": -74.00715,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJRA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJRA?codeType=fs"
     },
     {
      "fs": "KJRB",
      "iata": "",
      "icao": "KJRB",
      "faa": "JRB",
      "name": "Wall St (Heliport)",
      "city": "New York",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.70125,
      "longitude": -74.00909,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJRB?codeType=fs"
     },
     {
      "fs": "KJSO",
      "iata": "",
      "icao": "KJSO",
      "faa": "JSO",
      "name": "Cherokee Co",
      "city": "Jacksonville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.893361,
      "longitude": -95.223917,
      "elevationFeet": 677,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJSO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJSO?codeType=fs"
     },
     {
      "fs": "KJSV",
      "iata": "",
      "icao": "KJSV",
      "faa": "JSV",
      "name": "Sallisaw Municipal",
      "city": "Sallisaw",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.481667,
      "longitude": -94.827778,
      "elevationFeet": 528,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJSV?codeType=fs"
     },
     {
      "fs": "KJWG",
      "iata": "",
      "icao": "KJWG",
      "faa": "JWG",
      "name": "Watonga",
      "city": "Watonga",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.997083,
      "longitude": -98.4575,
      "elevationFeet": 1548,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJWG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJWG?codeType=fs"
     },
     {
      "fs": "KJWY",
      "iata": "",
      "icao": "KJWY",
      "faa": "JWY",
      "name": "Mid-Way",
      "city": "Midlothian/Waxahachie",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.510972,
      "longitude": -97.024111,
      "elevationFeet": 713,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJWY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJWY?codeType=fs"
     },
     {
      "fs": "KJYG",
      "iata": "",
      "icao": "KJYG",
      "faa": "JYG",
      "name": "St James Municipal",
      "city": "St James",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.013194,
      "longitude": -94.629361,
      "elevationFeet": 1067,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJYG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJYG?codeType=fs"
     },
     {
      "fs": "KJYL",
      "iata": "",
      "icao": "KJYL",
      "faa": "JYL",
      "name": "Plantation",
      "city": "Sylvania",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.7545,
      "longitude": -81.714972,
      "elevationFeet": 188,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJYL?codeType=fs"
     },
     {
      "fs": "KJYM",
      "iata": "",
      "icao": "KJYM",
      "faa": "JYM",
      "name": "Hillsdale Municipal",
      "city": "Hillsdale",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.962611,
      "longitude": -84.607639,
      "elevationFeet": 1182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJYM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJYM?codeType=fs"
     },
     {
      "fs": "KJYR",
      "iata": "",
      "icao": "KJYR",
      "faa": "JYR",
      "name": "York Municipal",
      "city": "York",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.0175,
      "longitude": -97.677778,
      "elevationFeet": 1670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJYR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJYR?codeType=fs"
     },
     {
      "fs": "KJZP",
      "iata": "",
      "icao": "KJZP",
      "faa": "JZP",
      "name": "Pickens Co",
      "city": "Jasper",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.464806,
      "longitude": -84.515917,
      "elevationFeet": 1535,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KJZP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KJZP?codeType=fs"
     },
     {
      "fs": "KKF",
      "iata": "KKF",
      "icao": "",
      "faa": "",
      "name": "Kagvik Creek Airport",
      "city": "Kagvik Creek",
      "cityCode": "KKF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 67.6,
      "longitude": -163.5,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKF?codeType=fs"
     },
     {
      "fs": "KKK",
      "iata": "KKK",
      "icao": "",
      "faa": "",
      "name": "Kalakaket Creek Air Station",
      "city": "Kalakaket",
      "cityCode": "KKK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 64.41664,
      "longitude": -156.820385,
      "elevationFeet": 1542,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKK?codeType=fs"
     },
     {
      "fs": "KKT",
      "iata": "KKT",
      "icao": "",
      "faa": "50I",
      "name": "Kentland Airport",
      "city": "Kentland",
      "cityCode": "KKT",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.766667,
      "longitude": -87.45,
      "elevationFeet": 698,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KKT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KKT?codeType=fs"
     },
     {
      "fs": "KLBO",
      "iata": "",
      "icao": "KLBO",
      "faa": "LBO",
      "name": "Jones Lebanon",
      "city": "Lebanon",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.771806,
      "longitude": -92.687583,
      "elevationFeet": 1319,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLBO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLBO?codeType=fs"
     },
     {
      "fs": "KLCG",
      "iata": "",
      "icao": "KLCG",
      "faa": "LCG",
      "name": "Wayne Municipal",
      "city": "Wayne",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.318889,
      "longitude": -97.114167,
      "elevationFeet": 1431,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLCG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLCG?codeType=fs"
     },
     {
      "fs": "KLHM",
      "iata": "",
      "icao": "KLHM",
      "faa": "LHM",
      "name": "Lincoln Regional/Harder",
      "city": "Lincoln",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 38.909199,
      "longitude": -121.350998,
      "elevationFeet": 121,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLHM?codeType=fs"
     },
     {
      "fs": "KLHQ",
      "iata": "",
      "icao": "KLHQ",
      "faa": "LHQ",
      "name": "Fairfield Co",
      "city": "Lancaster",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.806472,
      "longitude": -82.721111,
      "elevationFeet": 869,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLHQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLHQ?codeType=fs"
     },
     {
      "fs": "KLHX",
      "iata": "",
      "icao": "KLHX",
      "faa": "LHX",
      "name": "La Junta Municipal",
      "city": "La Junta",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 38.063417,
      "longitude": -103.606917,
      "elevationFeet": 4238,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLHX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLHX?codeType=fs"
     },
     {
      "fs": "KLJF",
      "iata": "",
      "icao": "KLJF",
      "faa": "LJF",
      "name": "Litchfield Municipal",
      "city": "Litchfield",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.221278,
      "longitude": -94.572694,
      "elevationFeet": 1140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLJF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLJF?codeType=fs"
     },
     {
      "fs": "KLKR",
      "iata": "",
      "icao": "KLKR",
      "faa": "LKR",
      "name": "Lancaster Co-Mc Whirter",
      "city": "Lancaster",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.779167,
      "longitude": -80.895833,
      "elevationFeet": 486,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLKR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLKR?codeType=fs"
     },
     {
      "fs": "KLLQ",
      "iata": "",
      "icao": "KLLQ",
      "faa": "LLQ",
      "name": "Monticello Municipal/Ellis",
      "city": "Monticello",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.685528,
      "longitude": -91.760194,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLLQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLLQ?codeType=fs"
     },
     {
      "fs": "KLLU",
      "iata": "",
      "icao": "KLLU",
      "faa": "LLU",
      "name": "Lamar Municipal",
      "city": "Lamar",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.544917,
      "longitude": -94.415056,
      "elevationFeet": 1009,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLLU?codeType=fs"
     },
     {
      "fs": "KLNC",
      "iata": "",
      "icao": "KLNC",
      "faa": "LNC",
      "name": "Lancaster",
      "city": "Lancaster",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.691917,
      "longitude": -96.7405,
      "elevationFeet": 501,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLNC?codeType=fs"
     },
     {
      "fs": "KLNL",
      "iata": "",
      "icao": "KLNL",
      "faa": "LNL",
      "name": "Kings Land O'Lakes",
      "city": "Land O'Lakes",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.188778,
      "longitude": -89.319444,
      "elevationFeet": 1705,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLNL?codeType=fs"
     },
     {
      "fs": "KLP",
      "iata": "KLP",
      "icao": "",
      "faa": "",
      "name": "Kelp Bay Airport",
      "city": "Kelp Bay",
      "cityCode": "KLP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 57.55,
      "longitude": -134.866667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLP?codeType=fs"
     },
     {
      "fs": "KLPR",
      "iata": "",
      "icao": "KLPR",
      "faa": "LPR",
      "name": "Lorain County Regional Airport",
      "city": "Lorain/Elyria",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.345455,
      "longitude": -82.170487,
      "elevationFeet": 786,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLPR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLPR?codeType=fs"
     },
     {
      "fs": "KLQR",
      "iata": "",
      "icao": "KLQR",
      "faa": "LQR",
      "name": "Larned-Pawnee Co",
      "city": "Larned",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.280972,
      "longitude": -99.110722,
      "elevationFeet": 2011,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLQR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLQR?codeType=fs"
     },
     {
      "fs": "KLRG",
      "iata": "",
      "icao": "KLRG",
      "faa": "LRG",
      "name": "Lincoln Regional",
      "city": "Lincoln",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.471611,
      "longitude": -68.547472,
      "elevationFeet": 208,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLRG?codeType=fs"
     },
     {
      "fs": "KLRY",
      "iata": "",
      "icao": "KLRY",
      "faa": "LRY",
      "name": "Smith Memorial",
      "city": "Harrisonville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.710222,
      "longitude": -94.421306,
      "elevationFeet": 915,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLRY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLRY?codeType=fs"
     },
     {
      "fs": "KLS",
      "iata": "KLS",
      "icao": "KKLS",
      "faa": "KLS",
      "name": "Longview Airport",
      "city": "Kelso",
      "cityCode": "KLS",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 46.15,
      "longitude": -122.9,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLS?codeType=fs"
     },
     {
      "fs": "KLUG",
      "iata": "",
      "icao": "KLUG",
      "faa": "LUG",
      "name": "Ellington Airport",
      "city": "Lewisburg",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.50608,
      "longitude": -86.796945,
      "elevationFeet": 701,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLUG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLUG?codeType=fs"
     },
     {
      "fs": "KLVJ",
      "iata": "",
      "icao": "KLVJ",
      "faa": "LVJ",
      "name": "Pearland Regional Airport",
      "city": "Houston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 29.521949,
      "longitude": -95.239491,
      "elevationFeet": 39,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLVJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLVJ?codeType=fs"
     },
     {
      "fs": "KLVN",
      "iata": "",
      "icao": "KLVN",
      "faa": "LVN",
      "name": "Airlake",
      "city": "Minneapolis",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.728528,
      "longitude": -93.331083,
      "elevationFeet": 960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLVN?codeType=fs"
     },
     {
      "fs": "KLWD",
      "iata": "",
      "icao": "KLWD",
      "faa": "LWD",
      "name": "Lamoni Municipal",
      "city": "Lamoni",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.633333,
      "longitude": -93.921694,
      "elevationFeet": 1131,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLWD?codeType=fs"
     },
     {
      "fs": "KLXL",
      "iata": "",
      "icao": "KLXL",
      "faa": "LXL",
      "name": "Little Falls-Morrison Co",
      "city": "Little Falls",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.094389,
      "longitude": -94.470861,
      "elevationFeet": 1122,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLXL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLXL?codeType=fs"
     },
     {
      "fs": "KLXY",
      "iata": "",
      "icao": "KLXY",
      "faa": "LXY",
      "name": "Mexia-Limestone Co",
      "city": "Mexia",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.698361,
      "longitude": -96.647222,
      "elevationFeet": 544,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KLXY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KLXY?codeType=fs"
     },
     {
      "fs": "KMAI",
      "iata": "",
      "icao": "KMAI",
      "faa": "MAI",
      "name": "Marianna Municipal",
      "city": "Marianna",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.878056,
      "longitude": -85.318889,
      "elevationFeet": 110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMAI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMAI?codeType=fs"
     },
     {
      "fs": "KMAL",
      "iata": "",
      "icao": "KMAL",
      "faa": "MAL",
      "name": "Malone-Dufort",
      "city": "Malone",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 44.886583,
      "longitude": -74.4395,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMAL?codeType=fs"
     },
     {
      "fs": "KMAO",
      "iata": "",
      "icao": "KMAO",
      "faa": "MAO",
      "name": "Marion Co",
      "city": "Marion",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.311667,
      "longitude": -79.347222,
      "elevationFeet": 92,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMAO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMAO?codeType=fs"
     },
     {
      "fs": "KMBO",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Campbell",
      "city": "Madison",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.486694,
      "longitude": -90.130861,
      "elevationFeet": 326,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMBO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMBO?codeType=fs"
     },
     {
      "fs": "KMBT",
      "iata": "",
      "icao": "KMBT",
      "faa": "MBT",
      "name": "Murfreesboro Municipal Airport",
      "city": "Murfreesboro",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.877442,
      "longitude": -86.376427,
      "elevationFeet": 613,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMBT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMBT?codeType=fs"
     },
     {
      "fs": "KMCX",
      "iata": "",
      "icao": "KMCX",
      "faa": "MCX",
      "name": "White Co",
      "city": "Monticello",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.788167,
      "longitude": -86.767611,
      "elevationFeet": 676,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMCX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMCX?codeType=fs"
     },
     {
      "fs": "KMCZ",
      "iata": "",
      "icao": "KMCZ",
      "faa": "MCZ",
      "name": "Martin Co",
      "city": "Williamston",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.971944,
      "longitude": -77.282028,
      "elevationFeet": 76,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMCZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMCZ?codeType=fs"
     },
     {
      "fs": "KMDF",
      "iata": "MDF",
      "icao": "KMDF",
      "faa": "MDF",
      "name": "Mooreland Municipal",
      "city": "Mooreland",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.497583,
      "longitude": -99.291583,
      "elevationFeet": 1970,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMDF?codeType=fs"
     },
     {
      "fs": "KMEJ",
      "iata": "",
      "icao": "KMEJ",
      "faa": "MEJ",
      "name": "Meade Municipal",
      "city": "Meade",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.368611,
      "longitude": -100.415,
      "elevationFeet": 2529,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMEJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMEJ?codeType=fs"
     },
     {
      "fs": "KMEY",
      "iata": "",
      "icao": "KMEY",
      "faa": "MEY",
      "name": "Whiting Memorial",
      "city": "Mapleton",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.282944,
      "longitude": -95.886444,
      "elevationFeet": 1116,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMEY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMEY?codeType=fs"
     },
     {
      "fs": "KMGG",
      "iata": "",
      "icao": "KMGG",
      "faa": "MGG",
      "name": "Maple Lake Municipal",
      "city": "Maple Lake",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.259944,
      "longitude": -94.005889,
      "elevationFeet": 1028,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMGG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMGG?codeType=fs"
     },
     {
      "fs": "KMGY",
      "iata": "",
      "icao": "KMGY",
      "faa": "MGY",
      "name": "Dayton-Wright Brothers",
      "city": "Dayton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.639722,
      "longitude": -84.298611,
      "elevationFeet": 957,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMGY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMGY?codeType=fs"
     },
     {
      "fs": "KMHP",
      "iata": "",
      "icao": "KMHP",
      "faa": "MHP",
      "name": "Metter Municipal",
      "city": "Metter",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.438889,
      "longitude": -82.191944,
      "elevationFeet": 197,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMHP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMHP?codeType=fs"
     },
     {
      "fs": "KMKA",
      "iata": "",
      "icao": "KMKA",
      "faa": "MKA",
      "name": "Miller Municipal",
      "city": "Miller",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.602444,
      "longitude": -99.031139,
      "elevationFeet": 1569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMKA?codeType=fs"
     },
     {
      "fs": "KMKJ",
      "iata": "",
      "icao": "KMKJ",
      "faa": "MKJ",
      "name": "Mountain Empire",
      "city": "Marion-Wytheville",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.998389,
      "longitude": -81.499667,
      "elevationFeet": 2559,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMKJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMKJ?codeType=fs"
     },
     {
      "fs": "KMKV",
      "iata": "",
      "icao": "KMKV",
      "faa": "MKV",
      "name": "Marksville Municipal",
      "city": "Marksville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.196611,
      "longitude": -92.090694,
      "elevationFeet": 79,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMKV?codeType=fs"
     },
     {
      "fs": "KMMK",
      "iata": "",
      "icao": "KMMK",
      "faa": "MMK",
      "name": "Meriden Markham Municipal",
      "city": "Meriden",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.587083,
      "longitude": -72.944889,
      "elevationFeet": 103,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMMK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMMK?codeType=fs"
     },
     {
      "fs": "KMNF",
      "iata": "",
      "icao": "KMNF",
      "faa": "MNF",
      "name": "Mountain View",
      "city": "Mountain View",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.078278,
      "longitude": -91.844556,
      "elevationFeet": 1181,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMNF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMNF?codeType=fs"
     },
     {
      "fs": "KMNI",
      "iata": "",
      "icao": "KMNI",
      "faa": "MNI",
      "name": "Santee Cooper Regional",
      "city": "Manning",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.621111,
      "longitude": -80.286667,
      "elevationFeet": 103,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMNI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMNI?codeType=fs"
     },
     {
      "fs": "KMNV",
      "iata": "",
      "icao": "KMNV",
      "faa": "MNV",
      "name": "Monroe Co",
      "city": "Madisonville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.653806,
      "longitude": -84.502306,
      "elevationFeet": 1031,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMNV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMNV?codeType=fs"
     },
     {
      "fs": "KMNZ",
      "iata": "",
      "icao": "KMNZ",
      "faa": "MNZ",
      "name": "Hamilton Municipal",
      "city": "Hamilton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.809278,
      "longitude": -98.286389,
      "elevationFeet": 1299,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMNZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMNZ?codeType=fs"
     },
     {
      "fs": "KMPE",
      "iata": "",
      "icao": "KMPE",
      "faa": "MPE",
      "name": "Philadelphia Municipal",
      "city": "Philadelphia",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.945778,
      "longitude": -89.208944,
      "elevationFeet": 456,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMPE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMPE?codeType=fs"
     },
     {
      "fs": "KMRH",
      "iata": "",
      "icao": "KMRH",
      "faa": "MRH",
      "name": "Smith",
      "city": "Beaufort",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.7355,
      "longitude": -76.755972,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMRH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMRH?codeType=fs"
     },
     {
      "fs": "KMVI",
      "iata": "",
      "icao": "KMVI",
      "faa": "MVI",
      "name": "Monte Vista Municipal",
      "city": "Monte Vista",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 37.635583,
      "longitude": -106.160528,
      "elevationFeet": 7608,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMVI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMVI?codeType=fs"
     },
     {
      "fs": "KMVM",
      "iata": "",
      "icao": "KMVM",
      "faa": "MVM",
      "name": "Machias-Valley",
      "city": "Machias",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 44.731111,
      "longitude": -67.586111,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMVM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMVM?codeType=fs"
     },
     {
      "fs": "KMWK",
      "iata": "",
      "icao": "KMWK",
      "faa": "MWK",
      "name": "Mt Airy-Surry Co",
      "city": "Mt Airy",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.547361,
      "longitude": -80.579583,
      "elevationFeet": 1247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMWK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMWK?codeType=fs"
     },
     {
      "fs": "KMYZ",
      "iata": "",
      "icao": "KMYZ",
      "faa": "MYZ",
      "name": "Marysville Municipal",
      "city": "Marysville",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.891694,
      "longitude": -96.752139,
      "elevationFeet": 1283,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMYZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMYZ?codeType=fs"
     },
     {
      "fs": "KMZH",
      "iata": "",
      "icao": "KMZH",
      "faa": "MZH",
      "name": "Moose Lake/Carlton Co",
      "city": "Moose Lake",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.4375,
      "longitude": -92.846667,
      "elevationFeet": 1076,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KMZH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KMZH?codeType=fs"
     },
     {
      "fs": "KNB",
      "iata": "KNB",
      "icao": "KKNB",
      "faa": "KNB",
      "name": "Kanab Airport",
      "city": "Kanab",
      "cityCode": "KNB",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 37.05,
      "longitude": -112.533333,
      "elevationFeet": 4864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNB?codeType=fs"
     },
     {
      "fs": "KNCA",
      "iata": "",
      "icao": "KNCA",
      "faa": "NCA",
      "name": "New River Mcas",
      "city": "Jacksonville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.784972,
      "longitude": -77.530194,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNCA?codeType=fs"
     },
     {
      "fs": "KNEN",
      "iata": "",
      "icao": "KNEN",
      "faa": "NEN",
      "name": "Whitehouse Nolf",
      "city": "Jacksonville",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 30.35,
      "longitude": -81.866667,
      "elevationFeet": 99,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNEN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNEN?codeType=fs"
     },
     {
      "fs": "KNFE",
      "iata": "",
      "icao": "KNFE",
      "faa": "NFE",
      "name": "Fentress Nalf",
      "city": "Fentress",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.7015,
      "longitude": -76.279889,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNFE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNFE?codeType=fs"
     },
     {
      "fs": "KNFG",
      "iata": "",
      "icao": "KNFG",
      "faa": "NFG",
      "name": "Camp Pendleton MCAS Airport",
      "city": "Oceanside",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 33.299221,
      "longitude": -117.340616,
      "elevationFeet": 229,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNFG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNFG?codeType=fs"
     },
     {
      "fs": "KNID",
      "iata": "",
      "icao": "KNID",
      "faa": "NID",
      "name": "China Lake Naws",
      "city": "Ridgecrest",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 35.685398,
      "longitude": -117.692001,
      "elevationFeet": 2283,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNID?codeType=fs"
     },
     {
      "fs": "KNJM",
      "iata": "",
      "icao": "KNJM",
      "faa": "NJM",
      "name": "Bogue Mcalf",
      "city": "Swansboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.690399,
      "longitude": -77.029701,
      "elevationFeet": 21,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNJM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNJM?codeType=fs"
     },
     {
      "fs": "KNJP",
      "iata": "",
      "icao": "KNJP",
      "faa": "NJP",
      "name": "Warminster Nawc",
      "city": "Warminster",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.201083,
      "longitude": -75.212806,
      "elevationFeet": 375,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNJP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNJP?codeType=fs"
     },
     {
      "fs": "KNMM",
      "iata": "",
      "icao": "KNMM",
      "faa": "NMM",
      "name": "Meridian Nas",
      "city": "Meridian",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.568056,
      "longitude": -88.600389,
      "elevationFeet": 317,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNMM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNMM?codeType=fs"
     },
     {
      "fs": "KNOG",
      "iata": "",
      "icao": "KNOG",
      "faa": "NOG",
      "name": "Orange Grove Nalf",
      "city": "Orange Grove",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 27.902972,
      "longitude": -98.052806,
      "elevationFeet": 257,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNOG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNOG?codeType=fs"
     },
     {
      "fs": "KNOW",
      "iata": "",
      "icao": "KNOW",
      "faa": "NOW",
      "name": "Port Angeles Cgas",
      "city": "Port Angeles",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 48.212861,
      "longitude": -123.539639,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNOW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNOW?codeType=fs"
     },
     {
      "fs": "KNRA",
      "iata": "",
      "icao": "KNRA",
      "faa": "NRA",
      "name": "NOLF Coupeville",
      "city": "Coupeville",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 48.18947,
      "longitude": -122.632401,
      "elevationFeet": 191,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNRA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNRA?codeType=fs"
     },
     {
      "fs": "KNRN",
      "iata": "",
      "icao": "KNRN",
      "faa": "NRN",
      "name": "Norton Municipal",
      "city": "Norton",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.991444,
      "longitude": -99.982056,
      "elevationFeet": 2361,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNRN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNRN?codeType=fs"
     },
     {
      "fs": "KNSE",
      "iata": "",
      "icao": "KNSE",
      "faa": "NSE",
      "name": "Whiting Fld Nas (North)",
      "city": "Milton",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.785222,
      "longitude": -87.066333,
      "elevationFeet": 200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNSE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNSE?codeType=fs"
     },
     {
      "fs": "KNSI",
      "iata": "",
      "icao": "KNSI",
      "faa": "NSI",
      "name": "San Nicolas I Nolf",
      "city": "San Nicolas I",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 33.29775,
      "longitude": -119.531806,
      "elevationFeet": 504,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNSI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNSI?codeType=fs"
     },
     {
      "fs": "KNT",
      "iata": "KNT",
      "icao": "KTKX",
      "faa": "TKX",
      "name": "Kennett Municipal Airport",
      "city": "Kennett",
      "cityCode": "KNT",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.230556,
      "longitude": -90.034722,
      "elevationFeet": 262,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNT?codeType=fs"
     },
     {
      "fs": "KNUC",
      "iata": "",
      "icao": "KNUC",
      "faa": "NUC",
      "name": "San Clemente I Nalf",
      "city": "San Clemente I",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 33.077389,
      "longitude": -118.63475,
      "elevationFeet": 182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNUC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNUC?codeType=fs"
     },
     {
      "fs": "KNUQ",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Moffett Federal Afld",
      "city": "Mountain View",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 37.548389,
      "longitude": -122.195722,
      "elevationFeet": 34,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNUQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNUQ?codeType=fs"
     },
     {
      "fs": "KNZJ",
      "iata": "",
      "icao": "KNZJ",
      "faa": "NZJ",
      "name": "El Toro Marine Corps Air Station",
      "city": "Santa Ana",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 33.674962,
      "longitude": -117.729185,
      "elevationFeet": 346,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KNZJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KNZJ?codeType=fs"
     },
     {
      "fs": "KOAR",
      "iata": "",
      "icao": "KOAR",
      "faa": "OAR",
      "name": "Marina",
      "city": "Marina",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 36.819028,
      "longitude": -121.8745,
      "elevationFeet": 134,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOAR?codeType=fs"
     },
     {
      "fs": "KOCQ",
      "iata": "",
      "icao": "KOCQ",
      "faa": "OCQ",
      "name": "Oconto Municipal",
      "city": "Oconto",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.935833,
      "longitude": -87.990528,
      "elevationFeet": 604,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOCQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOCQ?codeType=fs"
     },
     {
      "fs": "KODX",
      "iata": "",
      "icao": "KODX",
      "faa": "ODX",
      "name": "Sharp",
      "city": "Ord",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.6925,
      "longitude": -98.973611,
      "elevationFeet": 2070,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KODX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KODX?codeType=fs"
     },
     {
      "fs": "KOEB",
      "iata": "",
      "icao": "KOEB",
      "faa": "OEB",
      "name": "Branch Co Memorial",
      "city": "Coldwater",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.934389,
      "longitude": -85.075806,
      "elevationFeet": 959,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOEB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOEB?codeType=fs"
     },
     {
      "fs": "KOEL",
      "iata": "",
      "icao": "KOEL",
      "faa": "OEL",
      "name": "Oakley Municipal",
      "city": "Oakley",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.199444,
      "longitude": -100.964444,
      "elevationFeet": 3045,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOEL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOEL?codeType=fs"
     },
     {
      "fs": "KOFP",
      "iata": "",
      "icao": "KOFP",
      "faa": "OFP",
      "name": "Hanover Co Municipal",
      "city": "Richmond/Ashland",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.709,
      "longitude": -77.436699,
      "elevationFeet": 207,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOFP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOFP?codeType=fs"
     },
     {
      "fs": "KOGM",
      "iata": "",
      "icao": "KOGM",
      "faa": "OGM",
      "name": "Ontonagon Co",
      "city": "Ontonagon",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 46.954694,
      "longitude": -89.354222,
      "elevationFeet": 669,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOGM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOGM?codeType=fs"
     },
     {
      "fs": "KOIN",
      "iata": "",
      "icao": "KOIN",
      "faa": "OIN",
      "name": "Oberlin Municipal",
      "city": "Oberlin",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.837833,
      "longitude": -100.59425,
      "elevationFeet": 2703,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOIN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOIN?codeType=fs"
     },
     {
      "fs": "KOKZ",
      "iata": "",
      "icao": "KOKZ",
      "faa": "OKZ",
      "name": "Kaolin",
      "city": "Sandersville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.967222,
      "longitude": -82.881667,
      "elevationFeet": 438,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOKZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOKZ?codeType=fs"
     },
     {
      "fs": "KOLG",
      "iata": "",
      "icao": "KOLG",
      "faa": "OLG",
      "name": "Solon Springs Municipal",
      "city": "Solon Springs",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.4475,
      "longitude": -91.96375,
      "elevationFeet": 1102,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOLG?codeType=fs"
     },
     {
      "fs": "KOLZ",
      "iata": "",
      "icao": "KOLZ",
      "faa": "OLZ",
      "name": "Oelwein Municipal",
      "city": "Oelwein",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.808444,
      "longitude": -92.044778,
      "elevationFeet": 1076,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOLZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOLZ?codeType=fs"
     },
     {
      "fs": "KOMH",
      "iata": "",
      "icao": "KOMH",
      "faa": "OMH",
      "name": "Orange Co",
      "city": "Orange",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.2472,
      "longitude": -78.045601,
      "elevationFeet": 465,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOMH?codeType=fs"
     },
     {
      "fs": "KOMN",
      "iata": "",
      "icao": "KOMN",
      "faa": "OMN",
      "name": "Ormond Beach Municipal",
      "city": "Ormond Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 29.3006,
      "longitude": -81.113602,
      "elevationFeet": 29,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOMN?codeType=fs"
     },
     {
      "fs": "KONZ",
      "iata": "",
      "icao": "KONZ",
      "faa": "ONZ",
      "name": "Grosse Ile Municipal Airport",
      "city": "Detroit",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.100357,
      "longitude": -83.165098,
      "elevationFeet": 582,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KONZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KONZ?codeType=fs"
     },
     {
      "fs": "KOPN",
      "iata": "",
      "icao": "KOPN",
      "faa": "OPN",
      "name": "Thomaston-Upson Co",
      "city": "Thomaston",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 33.000278,
      "longitude": -84.391667,
      "elevationFeet": 796,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOPN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOPN?codeType=fs"
     },
     {
      "fs": "KOQW",
      "iata": "",
      "icao": "KOQW",
      "faa": "OQW",
      "name": "Maquoketa Municipal",
      "city": "Maquoketa",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.05075,
      "longitude": -90.788056,
      "elevationFeet": 769,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOQW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOQW?codeType=fs"
     },
     {
      "fs": "KORB",
      "iata": "",
      "icao": "KORB",
      "faa": "ORB",
      "name": "Orr Regional",
      "city": "Orr",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 48.159222,
      "longitude": -92.910528,
      "elevationFeet": 1311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KORB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KORB?codeType=fs"
     },
     {
      "fs": "KORC",
      "iata": "",
      "icao": "KORC",
      "faa": "ORC",
      "name": "Orange City Municipal",
      "city": "Orange City",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.052639,
      "longitude": -96.177972,
      "elevationFeet": 1414,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KORC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KORC?codeType=fs"
     },
     {
      "fs": "KORE",
      "iata": "",
      "icao": "KORE",
      "faa": "ORE",
      "name": "Orange Municipal",
      "city": "Orange",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.601139,
      "longitude": -72.336111,
      "elevationFeet": 555,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KORE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KORE?codeType=fs"
     },
     {
      "fs": "KORG",
      "iata": "",
      "icao": "KORG",
      "faa": "ORG",
      "name": "Orange Co",
      "city": "Orange",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.091667,
      "longitude": -93.809167,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KORG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KORG?codeType=fs"
     },
     {
      "fs": "KOVL",
      "iata": "",
      "icao": "KOVL",
      "faa": "OVL",
      "name": "Olivia Regional",
      "city": "Olivia",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.885722,
      "longitude": -95.177778,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOVL?codeType=fs"
     },
     {
      "fs": "KOVO",
      "iata": "",
      "icao": "KOVO",
      "faa": "OVO",
      "name": "North Vernon Airport",
      "city": "North Vernon",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.045762,
      "longitude": -85.607379,
      "elevationFeet": 756,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOVO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOVO?codeType=fs"
     },
     {
      "fs": "KOVS",
      "iata": "",
      "icao": "KOVS",
      "faa": "OVS",
      "name": "Boscobel",
      "city": "Boscobel",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.256306,
      "longitude": -90.742194,
      "elevationFeet": 672,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOVS?codeType=fs"
     },
     {
      "fs": "KOWI",
      "iata": "",
      "icao": "KOWI",
      "faa": "OWI",
      "name": "Ottawa Municipal",
      "city": "Ottawa",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.586667,
      "longitude": -95.279722,
      "elevationFeet": 966,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOWI?codeType=fs"
     },
     {
      "fs": "KOWX",
      "iata": "",
      "icao": "KOWX",
      "faa": "OWX",
      "name": "Putnam Co",
      "city": "Ottawa",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.055833,
      "longitude": -84.12025,
      "elevationFeet": 763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOWX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOWX?codeType=fs"
     },
     {
      "fs": "KOXI",
      "iata": "",
      "icao": "KOXI",
      "faa": "OXI",
      "name": "Starke Co",
      "city": "Knox",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.451889,
      "longitude": -86.797333,
      "elevationFeet": 684,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOXI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOXI?codeType=fs"
     },
     {
      "fs": "KOXV",
      "iata": "",
      "icao": "KOXV",
      "faa": "OXV",
      "name": "Knoxville Municipal",
      "city": "Knoxville",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.438861,
      "longitude": -93.238167,
      "elevationFeet": 928,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KOXV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KOXV?codeType=fs"
     },
     {
      "fs": "KPBH",
      "iata": "",
      "icao": "KPBH",
      "faa": "PBH",
      "name": "Price Co",
      "city": "Phillips",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.7895,
      "longitude": -90.424861,
      "elevationFeet": 1497,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPBH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPBH?codeType=fs"
     },
     {
      "fs": "KPCM",
      "iata": "",
      "icao": "KPCM",
      "faa": "PCM",
      "name": "Plant City Municipal Airport",
      "city": "Plant City",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 27.995309,
      "longitude": -82.164345,
      "elevationFeet": 144,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPCM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPCM?codeType=fs"
     },
     {
      "fs": "KPCW",
      "iata": "",
      "icao": "KPCW",
      "faa": "PCW",
      "name": "Carl R. Keller Field",
      "city": "Port Clinton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.523672,
      "longitude": -82.855166,
      "elevationFeet": 587,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPCW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPCW?codeType=fs"
     },
     {
      "fs": "KPCZ",
      "iata": "",
      "icao": "KPCZ",
      "faa": "PCZ",
      "name": "Waupaca Municipal",
      "city": "Waupaca",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.336889,
      "longitude": -89.155,
      "elevationFeet": 826,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPCZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPCZ?codeType=fs"
     },
     {
      "fs": "KPEA",
      "iata": "",
      "icao": "KPEA",
      "faa": "PEA",
      "name": "Pella Municipal",
      "city": "Pella",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.400667,
      "longitude": -93.058833,
      "elevationFeet": 885,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPEA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPEA?codeType=fs"
     },
     {
      "fs": "KPEO",
      "iata": "",
      "icao": "KPEO",
      "faa": "PEO",
      "name": "Penn Yan",
      "city": "Penn Yan",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.681361,
      "longitude": -77.080611,
      "elevationFeet": 977,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPEO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPEO?codeType=fs"
     },
     {
      "fs": "KPEZ",
      "iata": "",
      "icao": "KPEZ",
      "faa": "PEZ",
      "name": "Pleasanton Municipal",
      "city": "Pleasanton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 28.991944,
      "longitude": -98.549889,
      "elevationFeet": 429,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPEZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPEZ?codeType=fs"
     },
     {
      "fs": "KPH",
      "iata": "KPH",
      "icao": "",
      "faa": "",
      "name": "Pauloff Harbor Sea Plane Base",
      "city": "Pauloff Harbor",
      "cityCode": "KPH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 54.45,
      "longitude": -162.683333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPH?codeType=fs"
     },
     {
      "fs": "KPHG",
      "iata": "",
      "icao": "KPHG",
      "faa": "PHG",
      "name": "Phillipsburg Municipal",
      "city": "Phillipsburg",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.765361,
      "longitude": -99.328194,
      "elevationFeet": 1907,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPHG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPHG?codeType=fs"
     },
     {
      "fs": "KPIL",
      "iata": "",
      "icao": "KPIL",
      "faa": "PIL",
      "name": "Port Isabel-Cameron Co",
      "city": "Port Isabel",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 26.166201,
      "longitude": -97.345901,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPIL?codeType=fs"
     },
     {
      "fs": "KPJY",
      "iata": "",
      "icao": "KPJY",
      "faa": "PJY",
      "name": "Pinckneyville-Du Quoin",
      "city": "Pinckneyville",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.078833,
      "longitude": -89.4545,
      "elevationFeet": 400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPJY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPJY?codeType=fs"
     },
     {
      "fs": "KPK",
      "iata": "KPK",
      "icao": "",
      "faa": "",
      "name": "Parks Sea Plane Base",
      "city": "Parks",
      "cityCode": "KPK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 57.433611,
      "longitude": -153.9,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPK?codeType=fs"
     },
     {
      "fs": "KPLD",
      "iata": "",
      "icao": "KPLD",
      "faa": "PLD",
      "name": "Portland Municipal",
      "city": "Portland",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.457667,
      "longitude": -85.050806,
      "elevationFeet": 926,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPLD?codeType=fs"
     },
     {
      "fs": "KPMV",
      "iata": "",
      "icao": "KPMV",
      "faa": "PMV",
      "name": "Plattsmouth Municipal",
      "city": "Plattsmouth",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.9525,
      "longitude": -95.928889,
      "elevationFeet": 1202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPMV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPMV?codeType=fs"
     },
     {
      "fs": "KPMZ",
      "iata": "",
      "icao": "KPMZ",
      "faa": "PMZ",
      "name": "Plymouth Municipal",
      "city": "Plymouth",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 35.884389,
      "longitude": -76.842778,
      "elevationFeet": 39,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPMZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPMZ?codeType=fs"
     },
     {
      "fs": "KPNM",
      "iata": "",
      "icao": "KPNM",
      "faa": "PNM",
      "name": "Princeton Municipal",
      "city": "Princeton",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.648667,
      "longitude": -93.682167,
      "elevationFeet": 979,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPNM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPNM?codeType=fs"
     },
     {
      "fs": "KPNT",
      "iata": "",
      "icao": "KPNT",
      "faa": "PNT",
      "name": "Pontiac Municipal",
      "city": "Pontiac",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.987222,
      "longitude": -88.705,
      "elevationFeet": 659,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPNT?codeType=fs"
     },
     {
      "fs": "KPPQ",
      "iata": "",
      "icao": "KPPQ",
      "faa": "PPQ",
      "name": "Pittsfield Penstone Municipal",
      "city": "Pittsfield",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.688556,
      "longitude": -90.884306,
      "elevationFeet": 710,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPPQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPPQ?codeType=fs"
     },
     {
      "fs": "KPQL",
      "iata": "",
      "icao": "KPQL",
      "faa": "PQL",
      "name": "Lott International",
      "city": "Pascagoula",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 30.577806,
      "longitude": -88.642278,
      "elevationFeet": 17,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPQL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPQL?codeType=fs"
     },
     {
      "fs": "KPQN",
      "iata": "",
      "icao": "KPQN",
      "faa": "PQN",
      "name": "Pipestone Municipal",
      "city": "Pipestone",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.133028,
      "longitude": -96.303111,
      "elevationFeet": 1736,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPQN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPQN?codeType=fs"
     },
     {
      "fs": "KPRG",
      "iata": "",
      "icao": "KPRG",
      "faa": "PRG",
      "name": "Edgar Co",
      "city": "Paris",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.701472,
      "longitude": -87.706917,
      "elevationFeet": 654,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPRG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPRG?codeType=fs"
     },
     {
      "fs": "KPRN",
      "iata": "",
      "icao": "KPRN",
      "faa": "PRN",
      "name": "Greenville Municipal",
      "city": "Greenville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.954028,
      "longitude": -86.704472,
      "elevationFeet": 449,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPRN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPRN?codeType=fs"
     },
     {
      "fs": "KPT",
      "iata": "KPT",
      "icao": "",
      "faa": "06U",
      "name": "Hayden Field",
      "city": "Jackpot",
      "cityCode": "KPT",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 41.975987,
      "longitude": -114.658024,
      "elevationFeet": 5191,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPT?codeType=fs"
     },
     {
      "fs": "KPTG",
      "iata": "",
      "icao": "KPTG",
      "faa": "PTG",
      "name": "Lee Co",
      "city": "Pennington Gap",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.861722,
      "longitude": -83.070278,
      "elevationFeet": 1864,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPTG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPTG?codeType=fs"
     },
     {
      "fs": "KPVB",
      "iata": "",
      "icao": "KPVB",
      "faa": "PVB",
      "name": "Platteville Municipal",
      "city": "Platteville",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.743556,
      "longitude": -90.543917,
      "elevationFeet": 1024,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPVB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPVB?codeType=fs"
     },
     {
      "fs": "KPVG",
      "iata": "",
      "icao": "KPVG",
      "faa": "PVG",
      "name": "Hampton Roads",
      "city": "Chesapeake",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.779298,
      "longitude": -76.448881,
      "elevationFeet": 23,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPVG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPVG?codeType=fs"
     },
     {
      "fs": "KPVJ",
      "iata": "",
      "icao": "KPVJ",
      "faa": "PVJ",
      "name": "Pauls Valley Municipal",
      "city": "Pauls Valley",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 34.825806,
      "longitude": -97.303,
      "elevationFeet": 968,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPVJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPVJ?codeType=fs"
     },
     {
      "fs": "KPWG",
      "iata": "",
      "icao": "KPWG",
      "faa": "PWG",
      "name": "Mc Gregor Executive",
      "city": "Waco",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 31.499167,
      "longitude": -97.465278,
      "elevationFeet": 592,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPWG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPWG?codeType=fs"
     },
     {
      "fs": "KPXE",
      "iata": "",
      "icao": "KPXE",
      "faa": "PXE",
      "name": "Perry-Houston Co",
      "city": "Perry",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.605833,
      "longitude": -83.773333,
      "elevationFeet": 418,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPXE?codeType=fs"
     },
     {
      "fs": "KPYG",
      "iata": "",
      "icao": "KPYG",
      "faa": "PYG",
      "name": "Pageland",
      "city": "Pageland",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.821389,
      "longitude": -80.451944,
      "elevationFeet": 575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPYG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPYG?codeType=fs"
     },
     {
      "fs": "KPYX",
      "iata": "",
      "icao": "KPYX",
      "faa": "PYX",
      "name": "Perryton Ochiltree Co",
      "city": "Perryton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.520028,
      "longitude": -100.767889,
      "elevationFeet": 2915,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPYX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPYX?codeType=fs"
     },
     {
      "fs": "KPZQ",
      "iata": "",
      "icao": "KPZQ",
      "faa": "PZQ",
      "name": "Presque Isle Co",
      "city": "Rogers City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.470972,
      "longitude": -83.928861,
      "elevationFeet": 670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KPZQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KPZQ?codeType=fs"
     },
     {
      "fs": "KRBE",
      "iata": "",
      "icao": "KRBE",
      "faa": "RBE",
      "name": "Rock Co",
      "city": "Bassett",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.596667,
      "longitude": -99.583611,
      "elevationFeet": 2349,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRBE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRBE?codeType=fs"
     },
     {
      "fs": "KRBM",
      "iata": "",
      "icao": "KRBM",
      "faa": "RBM",
      "name": "Robinson Aaf",
      "city": "Camp Robinson",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 34.850889,
      "longitude": -92.301528,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRBM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRBM?codeType=fs"
     },
     {
      "fs": "KRCX",
      "iata": "",
      "icao": "KRCX",
      "faa": "RCX",
      "name": "Rusk Co",
      "city": "Ladysmith",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.620722,
      "longitude": -91.011,
      "elevationFeet": 1238,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRCX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRCX?codeType=fs"
     },
     {
      "fs": "KRDK",
      "iata": "",
      "icao": "KRDK",
      "faa": "RDK",
      "name": "Red Oak Municipal",
      "city": "Red Oak",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.105278,
      "longitude": -95.348611,
      "elevationFeet": 1044,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRDK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRDK?codeType=fs"
     },
     {
      "fs": "KRED",
      "iata": "",
      "icao": "KRED",
      "faa": "RED",
      "name": "Red Lodge",
      "city": "Red Lodge",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 45.224444,
      "longitude": -109.273778,
      "elevationFeet": 5763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRED?codeType=fs"
     },
     {
      "fs": "KRGK",
      "iata": "",
      "icao": "KRGK",
      "faa": "RGK",
      "name": "Red Wing Municipal",
      "city": "Red Wing",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.643556,
      "longitude": -92.499694,
      "elevationFeet": 780,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRGK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRGK?codeType=fs"
     },
     {
      "fs": "KRIU",
      "iata": "",
      "icao": "KRIU",
      "faa": "RIU",
      "name": "Rancho Murieta Airport",
      "city": "Sacramento",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 38.488362,
      "longitude": -121.100674,
      "elevationFeet": 143,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRIU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRIU?codeType=fs"
     },
     {
      "fs": "KRMN",
      "iata": "",
      "icao": "",
      "faa": "KRMN",
      "name": "Stafford Regional Airport",
      "city": "Stafford",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.398111,
      "longitude": -77.455472,
      "elevationFeet": 211,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRMN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRMN?codeType=fs"
     },
     {
      "fs": "KRMY",
      "iata": "",
      "icao": "KRMY",
      "faa": "RMY",
      "name": "Brooks",
      "city": "Marshall",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.261806,
      "longitude": -85.004528,
      "elevationFeet": 941,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRMY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRMY?codeType=fs"
     },
     {
      "fs": "KRNV",
      "iata": "",
      "icao": "KRNV",
      "faa": "RNV",
      "name": "Cleveland Municipal",
      "city": "Cleveland",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.760848,
      "longitude": -90.757914,
      "elevationFeet": 140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRNV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRNV?codeType=fs"
     },
     {
      "fs": "KROS",
      "iata": "",
      "icao": "KROS",
      "faa": "ROS",
      "name": "Rush City Regional",
      "city": "Rush City",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.703333,
      "longitude": -92.973889,
      "elevationFeet": 925,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KROS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KROS?codeType=fs"
     },
     {
      "fs": "KRPB",
      "iata": "",
      "icao": "KRPB",
      "faa": "RPB",
      "name": "Belleville Municipal",
      "city": "Belleville",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.829222,
      "longitude": -97.74625,
      "elevationFeet": 1537,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRPB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRPB?codeType=fs"
     },
     {
      "fs": "KRPH",
      "iata": "",
      "icao": "KRPH",
      "faa": "RPH",
      "name": "Graham Municipal",
      "city": "Graham",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.202222,
      "longitude": -98.602778,
      "elevationFeet": 1123,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRPH?codeType=fs"
     },
     {
      "fs": "KRPJ",
      "iata": "",
      "icao": "KRPJ",
      "faa": "RPJ",
      "name": "Rochelle Mun-Koritz",
      "city": "Rochelle",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.980028,
      "longitude": -89.182889,
      "elevationFeet": 781,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRPJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRPJ?codeType=fs"
     },
     {
      "fs": "KRQE",
      "iata": "",
      "icao": "KRQE",
      "faa": "RQE",
      "name": "Window Rock",
      "city": "Window Rock",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 35.670556,
      "longitude": -109.073889,
      "elevationFeet": 6742,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRQE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRQE?codeType=fs"
     },
     {
      "fs": "KRRQ",
      "iata": "",
      "icao": "KRRQ",
      "faa": "RRQ",
      "name": "Rock Rapids Municipal",
      "city": "Rock Rapids",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.472222,
      "longitude": -96.297778,
      "elevationFeet": 1363,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRRQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRRQ?codeType=fs"
     },
     {
      "fs": "KRSV",
      "iata": "",
      "icao": "KRSV",
      "faa": "RSV",
      "name": "Robinson Municipal",
      "city": "Robinson",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.160417,
      "longitude": -87.79775,
      "elevationFeet": 462,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRSV?codeType=fs"
     },
     {
      "fs": "KRUG",
      "iata": "",
      "icao": "KRUG",
      "faa": "RUG",
      "name": "Rugby Municipal",
      "city": "Rugby",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 48.453583,
      "longitude": -100.09275,
      "elevationFeet": 1548,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRUG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRUG?codeType=fs"
     },
     {
      "fs": "KRVJ",
      "iata": "",
      "icao": "KRVJ",
      "faa": "RVJ",
      "name": "Reidsville",
      "city": "Reidsville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 32.139722,
      "longitude": -82.167222,
      "elevationFeet": 195,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRVJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRVJ?codeType=fs"
     },
     {
      "fs": "KRVN",
      "iata": "",
      "icao": "KRVN",
      "faa": "RVN",
      "name": "Hawkins Co",
      "city": "Rogersville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.525694,
      "longitude": -82.90025,
      "elevationFeet": 1255,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRVN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRVN?codeType=fs"
     },
     {
      "fs": "KRWN",
      "iata": "",
      "icao": "KRWN",
      "faa": "RWN",
      "name": "Arens",
      "city": "Winamac",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.172639,
      "longitude": -86.728722,
      "elevationFeet": 711,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRWN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRWN?codeType=fs"
     },
     {
      "fs": "KRYM",
      "iata": "",
      "icao": "KRYM",
      "faa": "RYM",
      "name": "Miller Aaf",
      "city": "Camp Ripley",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.149111,
      "longitude": -94.437,
      "elevationFeet": 1149,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRYM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRYM?codeType=fs"
     },
     {
      "fs": "KRYN",
      "iata": "",
      "icao": "KRYN",
      "faa": "RYN",
      "name": "Ryan",
      "city": "Tucson",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 32.230833,
      "longitude": -111.228611,
      "elevationFeet": 2403,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRYN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRYN?codeType=fs"
     },
     {
      "fs": "KRYV",
      "iata": "",
      "icao": "KRYV",
      "faa": "RYV",
      "name": "Watertown Municipal",
      "city": "Watertown",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.196333,
      "longitude": -88.782111,
      "elevationFeet": 833,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRYV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRYV?codeType=fs"
     },
     {
      "fs": "KRYY",
      "iata": "",
      "icao": "KRYY",
      "faa": "RYY",
      "name": "Cobb Co-Mc Collum",
      "city": "Marietta",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.013199,
      "longitude": -84.598602,
      "elevationFeet": 1040,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRYY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRYY?codeType=fs"
     },
     {
      "fs": "KRZN",
      "iata": "",
      "icao": "KRZN",
      "faa": "RZN",
      "name": "Burnett Co",
      "city": "Siren",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.877278,
      "longitude": -92.425,
      "elevationFeet": 989,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRZN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRZN?codeType=fs"
     },
     {
      "fs": "KRZT",
      "iata": "",
      "icao": "KRZT",
      "faa": "RZT",
      "name": "Ross Co",
      "city": "Chillicothe",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.513694,
      "longitude": -83.075167,
      "elevationFeet": 725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KRZT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KRZT?codeType=fs"
     },
     {
      "fs": "KS03",
      "iata": "",
      "icao": "KS03",
      "faa": "KS03",
      "name": "Lenora Municipal",
      "city": "Lenora",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.7445,
      "longitude": -100.154056,
      "elevationFeet": 2373,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KS03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KS03?codeType=fs"
     },
     {
      "fs": "KSAW",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Old Sawyer International",
      "city": "Marquette",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 46.53417,
      "longitude": -87.558334,
      "elevationFeet": 1221,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSAW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSAW?codeType=fs"
     },
     {
      "fs": "KSAZ",
      "iata": "",
      "icao": "KSAZ",
      "faa": "SAZ",
      "name": "Staples Municipal",
      "city": "Staples",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 46.508806,
      "longitude": -94.866028,
      "elevationFeet": 1287,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSAZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSAZ?codeType=fs"
     },
     {
      "fs": "KSBU",
      "iata": "",
      "icao": "KSBU",
      "faa": "SBU",
      "name": "Blue Earth Municipal",
      "city": "Blue Earth",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.703444,
      "longitude": -94.178472,
      "elevationFeet": 1107,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSBU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSBU?codeType=fs"
     },
     {
      "fs": "KSCD",
      "iata": "",
      "icao": "KSCD",
      "faa": "SCD",
      "name": "Merkel Sylacauga Municipal",
      "city": "Sylacauga",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.218333,
      "longitude": -86.355278,
      "elevationFeet": 569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSCD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSCD?codeType=fs"
     },
     {
      "fs": "KSDA",
      "iata": "",
      "icao": "KSDA",
      "faa": "SDA",
      "name": "Shenandoah Municipal",
      "city": "Shenandoah",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.764806,
      "longitude": -95.534222,
      "elevationFeet": 971,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSDA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSDA?codeType=fs"
     },
     {
      "fs": "KSFD",
      "iata": "",
      "icao": "KSFD",
      "faa": "SFD",
      "name": "Wiley",
      "city": "Winner",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.455833,
      "longitude": -99.925611,
      "elevationFeet": 2032,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSFD?codeType=fs"
     },
     {
      "fs": "KSFQ",
      "iata": "",
      "icao": "KSFQ",
      "faa": "SFQ",
      "name": "Suffolk Municipal",
      "city": "Suffolk",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.6824,
      "longitude": -76.601898,
      "elevationFeet": 72,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSFQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSFQ?codeType=fs"
     },
     {
      "fs": "KSFY",
      "iata": "",
      "icao": "KSFY",
      "faa": "SFY",
      "name": "Tri-Township",
      "city": "Savanna",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.158194,
      "longitude": -90.176,
      "elevationFeet": 616,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSFY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSFY?codeType=fs"
     },
     {
      "fs": "KSGS",
      "iata": "",
      "icao": "KSGS",
      "faa": "SGS",
      "name": "South St Paul Municipal Airport",
      "city": "South St Paul",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.859673,
      "longitude": -93.039694,
      "elevationFeet": 823,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSGS?codeType=fs"
     },
     {
      "fs": "KSHL",
      "iata": "",
      "icao": "KSHL",
      "faa": "SHL",
      "name": "Sheldon Municipal",
      "city": "Sheldon",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.283944,
      "longitude": -95.834333,
      "elevationFeet": 1419,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSHL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSHL?codeType=fs"
     },
     {
      "fs": "KSJX",
      "iata": "",
      "icao": "KSJX",
      "faa": "SJX",
      "name": "Beaver I",
      "city": "Beaver I",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.772778,
      "longitude": -85.713056,
      "elevationFeet": 669,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSJX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSJX?codeType=fs"
     },
     {
      "fs": "KSKI",
      "iata": "",
      "icao": "KSKI",
      "faa": "SKI",
      "name": "Sac City Municipal",
      "city": "Sac City",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 42.490833,
      "longitude": -95.095833,
      "elevationFeet": 1250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSKI?codeType=fs"
     },
     {
      "fs": "KSLH",
      "iata": "",
      "icao": "KSLH",
      "faa": "SLH",
      "name": "Cheboygan Co",
      "city": "Cheboygan",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 45.6865,
      "longitude": -84.535667,
      "elevationFeet": 639,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSLH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSLH?codeType=fs"
     },
     {
      "fs": "KSLI",
      "iata": "",
      "icao": "KSLI",
      "faa": "SLI",
      "name": "Los Alamitos Aaf",
      "city": "Los Alamitos",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 33.850167,
      "longitude": -118.058972,
      "elevationFeet": 35,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSLI?codeType=fs"
     },
     {
      "fs": "KSMQ",
      "iata": "",
      "icao": "KSMQ",
      "faa": "SMQ",
      "name": "Somerset",
      "city": "Somerville",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.625999,
      "longitude": -74.670197,
      "elevationFeet": 105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSMQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSMQ?codeType=fs"
     },
     {
      "fs": "KSOY",
      "iata": "",
      "icao": "KSOY",
      "faa": "SOY",
      "name": "Sioux Center Municipal",
      "city": "Sioux Center",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 43.133444,
      "longitude": -96.224944,
      "elevationFeet": 1448,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSOY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSOY?codeType=fs"
     },
     {
      "fs": "KSPB",
      "iata": "",
      "icao": "KSPB",
      "faa": "SPB",
      "name": "Scappoose Industrial",
      "city": "Scappoose",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ005",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 45.770736,
      "longitude": -122.861884,
      "elevationFeet": 58,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSPB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSPB?codeType=fs"
     },
     {
      "fs": "KSPH",
      "iata": "",
      "icao": "KSPH",
      "faa": "SPH",
      "name": "Springhill",
      "city": "Springhill",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.131639,
      "longitude": -93.508111,
      "elevationFeet": 218,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSPH?codeType=fs"
     },
     {
      "fs": "KSRB",
      "iata": "",
      "icao": "KSRB",
      "faa": "SRB",
      "name": "Upper Cumberland Regional Airport",
      "city": "Sparta",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.055824,
      "longitude": -85.524104,
      "elevationFeet": 1022,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSRB?codeType=fs"
     },
     {
      "fs": "KSSN",
      "iata": "",
      "icao": "KSSN",
      "faa": "SSN",
      "name": "Seneca Aaf",
      "city": "Romulus",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.862972,
      "longitude": -77.032778,
      "elevationFeet": 647,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSSN?codeType=fs"
     },
     {
      "fs": "KSSQ",
      "iata": "",
      "icao": "KSSQ",
      "faa": "SSQ",
      "name": "Shell Lake Municipal",
      "city": "Shell Lake",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.863806,
      "longitude": -91.956611,
      "elevationFeet": 1232,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSSQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSSQ?codeType=fs"
     },
     {
      "fs": "KSTF",
      "iata": "",
      "icao": "KSTF",
      "faa": "STF",
      "name": "Bryan",
      "city": "Starkville",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.438167,
      "longitude": -88.986389,
      "elevationFeet": 333,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSTF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSTF?codeType=fs"
     },
     {
      "fs": "KSUT",
      "iata": "",
      "icao": "KSUT",
      "faa": "SUT",
      "name": "Brunswick Co",
      "city": "Oak Island",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 34.042583,
      "longitude": -78.149917,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSUT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSUT?codeType=fs"
     },
     {
      "fs": "KSWI",
      "iata": "",
      "icao": "KSWI",
      "faa": "SWI",
      "name": "Sherman Municipal",
      "city": "Sherman",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 33.691611,
      "longitude": -96.611306,
      "elevationFeet": 745,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSWI?codeType=fs"
     },
     {
      "fs": "KSWT",
      "iata": "",
      "icao": "KSWT",
      "faa": "SWT",
      "name": "Seward Municipal",
      "city": "Seward",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.002583,
      "longitude": -97.193139,
      "elevationFeet": 1505,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSWT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSWT?codeType=fs"
     },
     {
      "fs": "KSXL",
      "iata": "",
      "icao": "KSXL",
      "faa": "SXL",
      "name": "Summersville",
      "city": "Summersville",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.366389,
      "longitude": -80.908194,
      "elevationFeet": 1820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSXL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSXL?codeType=fs"
     },
     {
      "fs": "KSYF",
      "iata": "",
      "icao": "KSYF",
      "faa": "SYF",
      "name": "Cheyenne Co Municipal",
      "city": "St Francis",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.860472,
      "longitude": -101.908417,
      "elevationFeet": 3411,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSYF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSYF?codeType=fs"
     },
     {
      "fs": "KSZT",
      "iata": "",
      "icao": "KSZT",
      "faa": "SZT",
      "name": "Sandpoint",
      "city": "Sandpoint",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 48.446528,
      "longitude": -116.647694,
      "elevationFeet": 2127,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSZT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSZT?codeType=fs"
     },
     {
      "fs": "KSZY",
      "iata": "",
      "icao": "KSZY",
      "faa": "SZY",
      "name": "Sibley",
      "city": "Selmer",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 35.2295,
      "longitude": -88.633611,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KSZY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KSZY?codeType=fs"
     },
     {
      "fs": "KTAN",
      "iata": "",
      "icao": "KTAN",
      "faa": "TAN",
      "name": "Taunton Municipal",
      "city": "Taunton",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.874401,
      "longitude": -71.016602,
      "elevationFeet": 43,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTAN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTAN?codeType=fs"
     },
     {
      "fs": "KTAZ",
      "iata": "",
      "icao": "KTAZ",
      "faa": "TAZ",
      "name": "Taylorville Municipal",
      "city": "Taylorville",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.541861,
      "longitude": -89.428111,
      "elevationFeet": 622,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTAZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTAZ?codeType=fs"
     },
     {
      "fs": "KTCY",
      "iata": "",
      "icao": "KTCY",
      "faa": "TCY",
      "name": "Tracy Municipal",
      "city": "Tracy",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.685",
      "utcOffsetHours": -8,
      "latitude": 37.741083,
      "longitude": -121.518167,
      "elevationFeet": 193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTCY?codeType=fs"
     },
     {
      "fs": "KTDF",
      "iata": "",
      "icao": "KTDF",
      "faa": "TDF",
      "name": "Person County Airport",
      "city": "Roxboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 36.2885,
      "longitude": -78.983136,
      "elevationFeet": 612,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTDF?codeType=fs"
     },
     {
      "fs": "KTEL",
      "iata": "",
      "icao": "KTEL",
      "faa": "TEL",
      "name": "Perry Co Municipal",
      "city": "Tell City",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 38.026972,
      "longitude": -86.759306,
      "elevationFeet": 659,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTEL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTEL?codeType=fs"
     },
     {
      "fs": "KTEW",
      "iata": "",
      "icao": "KTEW",
      "faa": "TEW",
      "name": "Mason Jewett",
      "city": "Mason",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 42.707722,
      "longitude": -84.482194,
      "elevationFeet": 919,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTEW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTEW?codeType=fs"
     },
     {
      "fs": "KTGC",
      "iata": "",
      "icao": "KTGC",
      "faa": "TGC",
      "name": "Gibson Co",
      "city": "Trenton",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.074556,
      "longitude": -88.989417,
      "elevationFeet": 359,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTGC?codeType=fs"
     },
     {
      "fs": "KTGI",
      "iata": "",
      "icao": "KTGI",
      "faa": "TGI",
      "name": "Tangier I",
      "city": "Tangier",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 37.901389,
      "longitude": -76.127778,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTGI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTGI?codeType=fs"
     },
     {
      "fs": "KTH",
      "iata": "KTH",
      "icao": "",
      "faa": "",
      "name": "Tikchik Sea Plane Base",
      "city": "Tikchik",
      "cityCode": "KTH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.685",
      "utcOffsetHours": -9,
      "latitude": 59.966667,
      "longitude": -158.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTH?codeType=fs"
     },
     {
      "fs": "KTHM",
      "iata": "",
      "icao": "KTHM",
      "faa": "THM",
      "name": "Thompson Falls",
      "city": "Thompson Falls",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 47.649361,
      "longitude": -115.293167,
      "elevationFeet": 2460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTHM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTHM?codeType=fs"
     },
     {
      "fs": "KTKO",
      "iata": "",
      "icao": "KTKO",
      "faa": "TKO",
      "name": "Mankato",
      "city": "Mankato",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 39.827889,
      "longitude": -98.261611,
      "elevationFeet": 1859,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTKO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTKO?codeType=fs"
     },
     {
      "fs": "KTOB",
      "iata": "",
      "icao": "KTOB",
      "faa": "TOB",
      "name": "Dodge Center",
      "city": "Dodge Center",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 44.032194,
      "longitude": -92.970417,
      "elevationFeet": 1305,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTOB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTOB?codeType=fs"
     },
     {
      "fs": "KTQE",
      "iata": "",
      "icao": "KTQE",
      "faa": "TQE",
      "name": "Tekamah",
      "city": "Tekamah",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.885278,
      "longitude": -96.279444,
      "elevationFeet": 1027,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTQE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTQE?codeType=fs"
     },
     {
      "fs": "KTQK",
      "iata": "",
      "icao": "KTQK",
      "faa": "TQK",
      "name": "Scott City Municipal",
      "city": "Scott City",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 38.542778,
      "longitude": -100.899444,
      "elevationFeet": 2963,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTQK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTQK?codeType=fs"
     },
     {
      "fs": "KTSO",
      "iata": "",
      "icao": "KTSO",
      "faa": "TSO",
      "name": "Carroll Co-Tolson",
      "city": "Carrollton",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 40.668694,
      "longitude": -81.174861,
      "elevationFeet": 1163,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTSO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTSO?codeType=fs"
     },
     {
      "fs": "KTTF",
      "iata": "",
      "icao": "KTTF",
      "faa": "TTF",
      "name": "Custer",
      "city": "Monroe",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 41.999056,
      "longitude": -83.446833,
      "elevationFeet": 616,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTTF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTTF?codeType=fs"
     },
     {
      "fs": "KTVB",
      "iata": "",
      "icao": "KTVB",
      "faa": "TVB",
      "name": "Cabool Memorial",
      "city": "Cabool",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 37.274417,
      "longitude": -92.089611,
      "elevationFeet": 1220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTVB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTVB?codeType=fs"
     },
     {
      "fs": "KTVK",
      "iata": "",
      "icao": "KTVK",
      "faa": "TVK",
      "name": "Centerville Municipal",
      "city": "Centerville",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 40.689028,
      "longitude": -92.910333,
      "elevationFeet": 1028,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTVK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTVK?codeType=fs"
     },
     {
      "fs": "KTVR",
      "iata": "",
      "icao": "KTVR",
      "faa": "TVR",
      "name": "Vicksburg Tallulah Regional",
      "city": "Tallulah/Vicksburg",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 32.366056,
      "longitude": -91.126889,
      "elevationFeet": 86,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTVR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTVR?codeType=fs"
     },
     {
      "fs": "KTVY",
      "iata": "",
      "icao": "KTVY",
      "faa": "TVY",
      "name": "Bolinder-Tooele Valley",
      "city": "Tooele",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.685",
      "utcOffsetHours": -7,
      "latitude": 40.722722,
      "longitude": -112.357722,
      "elevationFeet": 4316,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTVY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTVY?codeType=fs"
     },
     {
      "fs": "KTWM",
      "iata": "",
      "icao": "KTWM",
      "faa": "TWM",
      "name": "Helgeson",
      "city": "Two Harbors",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 47.192417,
      "longitude": -91.852,
      "elevationFeet": 1080,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTWM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTWM?codeType=fs"
     },
     {
      "fs": "KTZR",
      "iata": "",
      "icao": "KTZR",
      "faa": "TZR",
      "name": "Bolton Field",
      "city": "Columbus",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.685",
      "utcOffsetHours": -5,
      "latitude": 39.902571,
      "longitude": -83.137984,
      "elevationFeet": 905,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTZR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTZR?codeType=fs"
     },
     {
      "fs": "KTZT",
      "iata": "",
      "icao": "KTZT",
      "faa": "TZT",
      "name": "Belle Plaine Municipal",
      "city": "Belle Plaine",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 41.987778,
      "longitude": -92.295694,
      "elevationFeet": 771,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTZT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTZT?codeType=fs"
     },
     {
      "fs": "KTZV",
      "iata": "",
      "icao": "KTZV",
      "faa": "TZV",
      "name": "Tompkinsville-Monroe Co",
      "city": "Tompkinsville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 36.847806,
      "longitude": -85.669167,
      "elevationFeet": 1036,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KTZV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KTZV?codeType=fs"
     },
     {
      "fs": "KUBE",
      "iata": "",
      "icao": "KUBE",
      "faa": "UBE",
      "name": "Cumberland Municipal",
      "city": "Cumberland",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.685",
      "utcOffsetHours": -6,
      "latitude": 45.559694,
      "longitude": -92.110861,
      "elevationFeet": 1241,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUBE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUBE?codeType=fs"
     },
     {
      "fs": "KUBX",
      "iata": "",
      "icao": "KUBX",
      "faa": "UBX",
      "name": "Cuba Municipal",
      "city": "Cuba",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.087778,
      "longitude": -91.538583,
      "elevationFeet": 1023,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUBX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUBX?codeType=fs"
     },
     {
      "fs": "KUCP",
      "iata": "",
      "icao": "KUCP",
      "faa": "UCP",
      "name": "New Castle Municipal",
      "city": "New Castle",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.103389,
      "longitude": -80.533722,
      "elevationFeet": 1072,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUCP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUCP?codeType=fs"
     },
     {
      "fs": "KUDG",
      "iata": "",
      "icao": "KUDG",
      "faa": "UDG",
      "name": "Darlington Co Jetport",
      "city": "Darlington",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.591944,
      "longitude": -79.953611,
      "elevationFeet": 192,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUDG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUDG?codeType=fs"
     },
     {
      "fs": "KUKL",
      "iata": "",
      "icao": "KUKL",
      "faa": "UKL",
      "name": "Coffey Co",
      "city": "Burlington",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.324861,
      "longitude": -95.801528,
      "elevationFeet": 1173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUKL?codeType=fs"
     },
     {
      "fs": "KULS",
      "iata": "",
      "icao": "KULS",
      "faa": "ULS",
      "name": "Ulysses",
      "city": "Ulysses",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.637528,
      "longitude": -101.433889,
      "elevationFeet": 3067,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KULS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KULS?codeType=fs"
     },
     {
      "fs": "KUNO",
      "iata": "",
      "icao": "KUNO",
      "faa": "UNO",
      "name": "West Plains Municipal",
      "city": "West Plains",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.981389,
      "longitude": -91.926944,
      "elevationFeet": 1228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUNO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUNO?codeType=fs"
     },
     {
      "fs": "KUSE",
      "iata": "",
      "icao": "KUSE",
      "faa": "USE",
      "name": "Fulton Co",
      "city": "Wauseon",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.703333,
      "longitude": -84.205278,
      "elevationFeet": 779,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUSE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUSE?codeType=fs"
     },
     {
      "fs": "KUUV",
      "iata": "",
      "icao": "KUUV",
      "faa": "UUV",
      "name": "Sullivan Regional",
      "city": "Sullivan",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.234833,
      "longitude": -91.292861,
      "elevationFeet": 933,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUUV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUUV?codeType=fs"
     },
     {
      "fs": "KUW",
      "iata": "KUW",
      "icao": "",
      "faa": "",
      "name": "Kugururok River Airport",
      "city": "Kugururok River",
      "cityCode": "KUW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 67.966667,
      "longitude": -161.983333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUW?codeType=fs"
     },
     {
      "fs": "KUWL",
      "iata": "",
      "icao": "KUWL",
      "faa": "UWL",
      "name": "New Castle-Henry Co Municipal",
      "city": "New Castle",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.958528,
      "longitude": -85.414694,
      "elevationFeet": 1088,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUWL?codeType=fs"
     },
     {
      "fs": "KUYF",
      "iata": "",
      "icao": "KUYF",
      "faa": "UYF",
      "name": "Madison Co",
      "city": "London",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.077278,
      "longitude": -83.570028,
      "elevationFeet": 1081,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KUYF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KUYF?codeType=fs"
     },
     {
      "fs": "KVBT",
      "iata": "",
      "icao": "KVBT",
      "faa": "VBT",
      "name": "Bentonville Municipal/Thaden",
      "city": "Bentonville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.457167,
      "longitude": -94.243444,
      "elevationFeet": 1296,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVBT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVBT?codeType=fs"
     },
     {
      "fs": "KVBW",
      "iata": "",
      "icao": "KVBW",
      "faa": "VBW",
      "name": "Bridgewater",
      "city": "Bridgewater",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.367389,
      "longitude": -79.053333,
      "elevationFeet": 1165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVBW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVBW?codeType=fs"
     },
     {
      "fs": "KVER",
      "iata": "",
      "icao": "KVER",
      "faa": "VER",
      "name": "Viertel Memorial",
      "city": "Boonville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 39.05775,
      "longitude": -92.827722,
      "elevationFeet": 715,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVER?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVER?codeType=fs"
     },
     {
      "fs": "KVES",
      "iata": "",
      "icao": "KVES",
      "faa": "VES",
      "name": "Darke Co",
      "city": "Versailles",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.244167,
      "longitude": -84.669167,
      "elevationFeet": 1007,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVES?codeType=fs"
     },
     {
      "fs": "KVIQ",
      "iata": "",
      "icao": "KVIQ",
      "faa": "VIQ",
      "name": "Neillsville Municipal",
      "city": "Neillsville",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 44.631278,
      "longitude": -90.622472,
      "elevationFeet": 1237,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVIQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVIQ?codeType=fs"
     },
     {
      "fs": "KVKX",
      "iata": "",
      "icao": "KVKX",
      "faa": "VKX",
      "name": "Potomac Airfield",
      "city": "Friendly",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.748841,
      "longitude": -76.955579,
      "elevationFeet": 110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVKX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVKX?codeType=fs"
     },
     {
      "fs": "KVMR",
      "iata": "",
      "icao": "KVMR",
      "faa": "VMR",
      "name": "Davidson",
      "city": "Vermillion",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.902889,
      "longitude": -96.942556,
      "elevationFeet": 1147,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVMR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVMR?codeType=fs"
     },
     {
      "fs": "KVNW",
      "iata": "",
      "icao": "KVNW",
      "faa": "VNW",
      "name": "Van Wert Co",
      "city": "Van Wert",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.8647,
      "longitude": -84.609398,
      "elevationFeet": 785,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVNW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVNW?codeType=fs"
     },
     {
      "fs": "KVPC",
      "iata": "",
      "icao": "KVPC",
      "faa": "VPC",
      "name": "Cartersville",
      "city": "Cartersville",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.181389,
      "longitude": -84.986944,
      "elevationFeet": 759,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVPC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVPC?codeType=fs"
     },
     {
      "fs": "KVTI",
      "iata": "",
      "icao": "KVTI",
      "faa": "VTI",
      "name": "Vinton-Veterans Memorial",
      "city": "Vinton",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.23625,
      "longitude": -92.109278,
      "elevationFeet": 845,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVTI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVTI?codeType=fs"
     },
     {
      "fs": "KVUJ",
      "iata": "",
      "icao": "KVUJ",
      "faa": "VUJ",
      "name": "Stanly Co",
      "city": "Albemarle",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.416944,
      "longitude": -80.157944,
      "elevationFeet": 609,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVUJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVUJ?codeType=fs"
     },
     {
      "fs": "KVUO",
      "iata": "",
      "icao": "KVUO",
      "faa": "VUO",
      "name": "Pearson Field",
      "city": "Vancouver",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 45.621446,
      "longitude": -122.654983,
      "elevationFeet": 23,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVUO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVUO?codeType=fs"
     },
     {
      "fs": "KVVS",
      "iata": "",
      "icao": "KVVS",
      "faa": "VVS",
      "name": "Connellsville",
      "city": "Connellsville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.039361,
      "longitude": -79.72125,
      "elevationFeet": 1267,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVVS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVVS?codeType=fs"
     },
     {
      "fs": "KVVV",
      "iata": "",
      "icao": "KVVV",
      "faa": "VVV",
      "name": "Ortonville Mun-Martinson",
      "city": "Ortonville",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 45.356639,
      "longitude": -96.494222,
      "elevationFeet": 1100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVVV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVVV?codeType=fs"
     },
     {
      "fs": "KVWU",
      "iata": "",
      "icao": "KVWU",
      "faa": "VWU",
      "name": "Waskish Municipal",
      "city": "Waskish",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 48.191306,
      "longitude": -94.519,
      "elevationFeet": 1181,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KVWU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KVWU?codeType=fs"
     },
     {
      "fs": "KXMR",
      "iata": "",
      "icao": "KXMR",
      "faa": "XMR",
      "name": "Cape Canaveral As Skid Strip",
      "city": "Cocoa Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 28.4676,
      "longitude": -80.566597,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KXMR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KXMR?codeType=fs"
     },
     {
      "fs": "KXVG",
      "iata": "",
      "icao": "KXVG",
      "faa": "XVG",
      "name": "Longville Municipal",
      "city": "Longville",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 47.051639,
      "longitude": -94.24,
      "elevationFeet": 1334,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KXVG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KXVG?codeType=fs"
     },
     {
      "fs": "KYL",
      "iata": "KYL",
      "icao": "",
      "faa": "",
      "name": "Port Largo Airport",
      "city": "Key Largo",
      "cityCode": "KYL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 25.066667,
      "longitude": -80.466667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KYL?codeType=fs"
     },
     {
      "fs": "KYO",
      "iata": "KYO",
      "icao": "",
      "faa": "X39",
      "name": "Topp of Tampa Airport",
      "city": "Tampa",
      "cityCode": "TPA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 28.216667,
      "longitude": -82.366667,
      "elevationFeet": 68,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KYO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KYO?codeType=fs"
     },
     {
      "fs": "KZEF",
      "iata": "",
      "icao": "KZEF",
      "faa": "ZEF",
      "name": "Elkin Municipal",
      "city": "Elkin",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.40025,
      "longitude": -80.810694,
      "elevationFeet": 1068,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KZEF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KZEF?codeType=fs"
     },
     {
      "fs": "KZER",
      "iata": "",
      "icao": "KZER",
      "faa": "ZER",
      "name": "Schuylkill Co",
      "city": "Pottsville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.7645,
      "longitude": -76.431472,
      "elevationFeet": 1734,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KZER?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KZER?codeType=fs"
     },
     {
      "fs": "KZH",
      "iata": "KZH",
      "icao": "",
      "faa": "",
      "name": "Kizhuyak Airport",
      "city": "Kizhuyak",
      "cityCode": "KZH",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 57.583333,
      "longitude": -153.15,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KZH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KZH?codeType=fs"
     },
     {
      "fs": "KZUN",
      "iata": "",
      "icao": "KZUN",
      "faa": "ZUN",
      "name": "Black Rock",
      "city": "Zuni Pueblo",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 35.232278,
      "longitude": -108.867778,
      "elevationFeet": 6454,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/KZUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/KZUN?codeType=fs"
     },
     {
      "fs": "L00",
      "iata": "",
      "icao": "",
      "faa": "L00",
      "name": "Rosamond",
      "city": "Rosamond",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.908111,
      "longitude": -118.292417,
      "elevationFeet": 2415,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L00?codeType=fs"
     },
     {
      "fs": "L04",
      "iata": "",
      "icao": "",
      "faa": "L04",
      "name": "Holtville Airport",
      "city": "Holtville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 32.840499,
      "longitude": -115.269745,
      "elevationFeet": 52,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L04?codeType=fs"
     },
     {
      "fs": "L05",
      "iata": "",
      "icao": "",
      "faa": "L05",
      "name": "Kern Valley",
      "city": "Kernville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.832861,
      "longitude": -118.448056,
      "elevationFeet": 2614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L05?codeType=fs"
     },
     {
      "fs": "L06",
      "iata": "",
      "icao": "",
      "faa": "L06",
      "name": "Furnace Creek",
      "city": "Death Valley Natl Park",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 36.588361,
      "longitude": -117.014417,
      "elevationFeet": -210,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L06?codeType=fs"
     },
     {
      "fs": "L09",
      "iata": "",
      "icao": "",
      "faa": "L09",
      "name": "Stove Pipe Wells",
      "city": "Death Valley Natl Park",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 36.641139,
      "longitude": -117.242306,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L09?codeType=fs"
     },
     {
      "fs": "L12",
      "iata": "",
      "icao": "",
      "faa": "L12",
      "name": "Redlands Municipal",
      "city": "Redlands",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.102611,
      "longitude": -117.263778,
      "elevationFeet": 1571,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L12?codeType=fs"
     },
     {
      "fs": "L17",
      "iata": "",
      "icao": "",
      "faa": "L17",
      "name": "Taft-Kern Co",
      "city": "Taft",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.210778,
      "longitude": -119.512306,
      "elevationFeet": 875,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L17?codeType=fs"
     },
     {
      "fs": "L18",
      "iata": "",
      "icao": "",
      "faa": "L18",
      "name": "Fallbrook Community",
      "city": "Fallbrook",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 33.391972,
      "longitude": -117.258694,
      "elevationFeet": 708,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L18?codeType=fs"
     },
     {
      "fs": "L19",
      "iata": "",
      "icao": "",
      "faa": "L19",
      "name": "Wasco-Kern Co",
      "city": "Wasco",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.646778,
      "longitude": -119.38725,
      "elevationFeet": 313,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L19?codeType=fs"
     },
     {
      "fs": "L20",
      "iata": "",
      "icao": "",
      "faa": "L20",
      "name": "Coal Creek",
      "city": "Yukon Charley Rivers",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 65.413361,
      "longitude": -143.154528,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L20?codeType=fs"
     },
     {
      "fs": "L22",
      "iata": "",
      "icao": "",
      "faa": "L22",
      "name": "Yucca Valley",
      "city": "Yucca Valley",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.227861,
      "longitude": -116.477917,
      "elevationFeet": 3224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L22?codeType=fs"
     },
     {
      "fs": "L25",
      "iata": "",
      "icao": "",
      "faa": "L25",
      "name": "Pearce Ferry",
      "city": "Meadview",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 36.185972,
      "longitude": -114.1635,
      "elevationFeet": 2941,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L25?codeType=fs"
     },
     {
      "fs": "L26",
      "iata": "",
      "icao": "",
      "faa": "L26",
      "name": "Hesperia",
      "city": "Hesperia",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.472222,
      "longitude": -117.458778,
      "elevationFeet": 3390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L26?codeType=fs"
     },
     {
      "fs": "L28",
      "iata": "",
      "icao": "",
      "faa": "L28",
      "name": "Bordelon",
      "city": "Breaux Bridge",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.366972,
      "longitude": -91.963944,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L28?codeType=fs"
     },
     {
      "fs": "L31",
      "iata": "",
      "icao": "",
      "faa": "L31",
      "name": "Greater St Tammany",
      "city": "Covington",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.550556,
      "longitude": -90.038806,
      "elevationFeet": 39,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L31?codeType=fs"
     },
     {
      "fs": "L32",
      "iata": "",
      "icao": "",
      "faa": "L32",
      "name": "Jonesville",
      "city": "Jonesville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.701694,
      "longitude": -91.942944,
      "elevationFeet": 56,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L32?codeType=fs"
     },
     {
      "fs": "L33",
      "iata": "",
      "icao": "",
      "faa": "L33",
      "name": "Tensas Parish",
      "city": "St Joseph",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.106667,
      "longitude": -91.356667,
      "elevationFeet": 73,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L33?codeType=fs"
     },
     {
      "fs": "L36",
      "iata": "",
      "icao": "",
      "faa": "L36",
      "name": "Hanks",
      "city": "Kaplan",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.018722,
      "longitude": -92.34575,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L36?codeType=fs"
     },
     {
      "fs": "L38",
      "iata": "",
      "icao": "",
      "faa": "L38",
      "name": "Louisiana Regional",
      "city": "Gonzales",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.213528,
      "longitude": -91.003972,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L38?codeType=fs"
     },
     {
      "fs": "L39",
      "iata": "",
      "icao": "",
      "faa": "L39",
      "name": "Leesville",
      "city": "Leesville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.181944,
      "longitude": -93.424583,
      "elevationFeet": 280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L39?codeType=fs"
     },
     {
      "fs": "L40",
      "iata": "",
      "icao": "",
      "faa": "L40",
      "name": "Colfax",
      "city": "Colfax",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.659861,
      "longitude": -92.761889,
      "elevationFeet": 95,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L40?codeType=fs"
     },
     {
      "fs": "L42",
      "iata": "",
      "icao": "",
      "faa": "L42",
      "name": "Allen Parish",
      "city": "Oakdale",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.751667,
      "longitude": -92.734722,
      "elevationFeet": 107,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L42?codeType=fs"
     },
     {
      "fs": "L44",
      "iata": "",
      "icao": "",
      "faa": "L44",
      "name": "Moundville",
      "city": "Moundville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.981806,
      "longitude": -87.705639,
      "elevationFeet": 162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L44?codeType=fs"
     },
     {
      "fs": "L45",
      "iata": "",
      "icao": "",
      "faa": "L45",
      "name": "Bakersfield Municipal",
      "city": "Bakersfield",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.398333,
      "longitude": -119.108333,
      "elevationFeet": 376,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L45?codeType=fs"
     },
     {
      "fs": "L47",
      "iata": "",
      "icao": "",
      "faa": "L47",
      "name": "Olla",
      "city": "Olla",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.004417,
      "longitude": -92.229167,
      "elevationFeet": 130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L47?codeType=fs"
     },
     {
      "fs": "L49",
      "iata": "",
      "icao": "",
      "faa": "L49",
      "name": "South Lafourche",
      "city": "Galliano",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 29.548333,
      "longitude": -90.361111,
      "elevationFeet": 1,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L49?codeType=fs"
     },
     {
      "fs": "L50",
      "iata": "",
      "icao": "",
      "faa": "L50",
      "name": "Tuweep",
      "city": "Tuweep",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 36.308139,
      "longitude": -113.090944,
      "elevationFeet": 4682,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L50?codeType=fs"
     },
     {
      "fs": "L52",
      "iata": "",
      "icao": "",
      "faa": "L52",
      "name": "Oceano Co",
      "city": "Oceano",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.113639,
      "longitude": -120.671167,
      "elevationFeet": 14,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L52?codeType=fs"
     },
     {
      "fs": "L53",
      "iata": "",
      "icao": "",
      "faa": "L53",
      "name": "Sun Hill Ranch",
      "city": "Helendale",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.830417,
      "longitude": -117.617194,
      "elevationFeet": 2984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L53?codeType=fs"
     },
     {
      "fs": "L54",
      "iata": "",
      "icao": "",
      "faa": "L54",
      "name": "Agua Caliente Springs",
      "city": "Agua Caliente Springs",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 32.9505,
      "longitude": -116.383472,
      "elevationFeet": 1220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L54?codeType=fs"
     },
     {
      "fs": "L57",
      "iata": "",
      "icao": "",
      "faa": "L57",
      "name": "Hidden Hills",
      "city": "Pahrump",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 36.063556,
      "longitude": -115.980722,
      "elevationFeet": 2808,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L57?codeType=fs"
     },
     {
      "fs": "L61",
      "iata": "",
      "icao": "",
      "faa": "L61",
      "name": "Shoshone",
      "city": "Shoshone",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.985722,
      "longitude": -116.294722,
      "elevationFeet": 1568,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L61?codeType=fs"
     },
     {
      "fs": "L62",
      "iata": "",
      "icao": "",
      "faa": "L62",
      "name": "Elk Hills-Buttonwillow",
      "city": "Buttonwillow",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.377389,
      "longitude": -119.587306,
      "elevationFeet": 326,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L62?codeType=fs"
     },
     {
      "fs": "L64",
      "iata": "",
      "icao": "",
      "faa": "L64",
      "name": "Desert Center",
      "city": "Desert Center",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 33.886306,
      "longitude": -115.380361,
      "elevationFeet": 559,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L64?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L64?codeType=fs"
     },
     {
      "fs": "L65",
      "iata": "",
      "icao": "",
      "faa": "L65",
      "name": "Perris Valley Airport",
      "city": "Perris",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 33.762172,
      "longitude": -117.214715,
      "elevationFeet": 1416,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L65?codeType=fs"
     },
     {
      "fs": "L66",
      "iata": "",
      "icao": "",
      "faa": "L66",
      "name": "Pollock Municipal",
      "city": "Pollock",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.551778,
      "longitude": -92.534722,
      "elevationFeet": 213,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L66?codeType=fs"
     },
     {
      "fs": "L67",
      "iata": "",
      "icao": "",
      "faa": "L67",
      "name": "Rialto Municipal/Miro",
      "city": "Rialto",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.243444,
      "longitude": -117.416306,
      "elevationFeet": 1455,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L67?codeType=fs"
     },
     {
      "fs": "L70",
      "iata": "",
      "icao": "",
      "faa": "L70",
      "name": "Agua Dulce",
      "city": "Agua Dulce",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.541583,
      "longitude": -118.428556,
      "elevationFeet": 2660,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L70?codeType=fs"
     },
     {
      "fs": "L71",
      "iata": "",
      "icao": "",
      "faa": "L71",
      "name": "California City Municipal",
      "city": "California City",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.162528,
      "longitude": -118.016667,
      "elevationFeet": 2450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L71?codeType=fs"
     },
     {
      "fs": "L73",
      "iata": "",
      "icao": "",
      "faa": "L73",
      "name": "Poso-Kern Co",
      "city": "Famoso",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.716222,
      "longitude": -119.226028,
      "elevationFeet": 635,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L73?codeType=fs"
     },
     {
      "fs": "L75",
      "iata": "",
      "icao": "",
      "faa": "L75",
      "name": "Southland",
      "city": "Sulphur",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.174083,
      "longitude": -93.500833,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L75?codeType=fs"
     },
     {
      "fs": "L77",
      "iata": "",
      "icao": "",
      "faa": "L77",
      "name": "Chiriaco Summit",
      "city": "Chiriaco",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 33.802972,
      "longitude": -115.805472,
      "elevationFeet": 1713,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L77?codeType=fs"
     },
     {
      "fs": "L78",
      "iata": "",
      "icao": "",
      "faa": "L78",
      "name": "Jacumba",
      "city": "Jacumba",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 32.617306,
      "longitude": -116.297389,
      "elevationFeet": 2820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L78?codeType=fs"
     },
     {
      "fs": "L80",
      "iata": "",
      "icao": "",
      "faa": "L80",
      "name": "Hi Desert",
      "city": "Joshua Tree",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.191722,
      "longitude": -116.272306,
      "elevationFeet": 2464,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L80?codeType=fs"
     },
     {
      "fs": "L81",
      "iata": "",
      "icao": "",
      "faa": "L81",
      "name": "Hains",
      "city": "Rayne",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.293694,
      "longitude": -92.312389,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L81?codeType=fs"
     },
     {
      "fs": "L83",
      "iata": "",
      "icao": "",
      "faa": "L83",
      "name": "Thibodaux Municipal",
      "city": "Thibodaux",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 29.877917,
      "longitude": -90.979,
      "elevationFeet": 9,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L83?codeType=fs"
     },
     {
      "fs": "L84",
      "iata": "",
      "icao": "",
      "faa": "L84",
      "name": "Lost Hills-Kern Co",
      "city": "Lost Hills",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.685722,
      "longitude": -119.712389,
      "elevationFeet": 274,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L84?codeType=fs"
     },
     {
      "fs": "L88",
      "iata": "",
      "icao": "",
      "faa": "L88",
      "name": "New Cuyama",
      "city": "New Cuyama",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.974778,
      "longitude": -119.734639,
      "elevationFeet": 2203,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L88?codeType=fs"
     },
     {
      "fs": "L89",
      "iata": "",
      "icao": "",
      "faa": "L89",
      "name": "Kibs",
      "city": "Bristol",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.513111,
      "longitude": -92.259556,
      "elevationFeet": 51,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L89?codeType=fs"
     },
     {
      "fs": "L90",
      "iata": "",
      "icao": "",
      "faa": "L90",
      "name": "Ocotillo",
      "city": "Ocotillo Wells",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 33.150444,
      "longitude": -116.277833,
      "elevationFeet": 160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L90?codeType=fs"
     },
     {
      "fs": "L91",
      "iata": "",
      "icao": "",
      "faa": "L91",
      "name": "Rio Bravo",
      "city": "Bakersfield",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.46625,
      "longitude": -118.878722,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L91?codeType=fs"
     },
     {
      "fs": "L92",
      "iata": "",
      "icao": "",
      "faa": "L92",
      "name": "Alamo Landing",
      "city": "Alamo",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 37.474611,
      "longitude": -115.294639,
      "elevationFeet": 3719,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L92?codeType=fs"
     },
     {
      "fs": "L94",
      "iata": "",
      "icao": "",
      "faa": "L94",
      "name": "Mountain Valley",
      "city": "Tehachapi",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.110778,
      "longitude": -118.481389,
      "elevationFeet": 4220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/L94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/L94?codeType=fs"
     },
     {
      "fs": "LEM",
      "iata": "LEM",
      "icao": "KLEM",
      "faa": "LEM",
      "name": "Lemmon Airport",
      "city": "Lemmon",
      "cityCode": "LEM",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 45.940833,
      "longitude": -102.158889,
      "elevationFeet": 2571,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LEM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LEM?codeType=fs"
     },
     {
      "fs": "LFK",
      "iata": "LFK",
      "icao": "KLFK",
      "faa": "LFK",
      "name": "Lufkin Angelina County Airport",
      "city": "Nacogdoches",
      "cityCode": "OCH",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.234167,
      "longitude": -94.750278,
      "elevationFeet": 296,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LFK?codeType=fs"
     },
     {
      "fs": "LFN",
      "iata": "LFN",
      "icao": "KLHZ",
      "faa": "LHZ",
      "name": "Triangle North Executive Airport",
      "city": "Louisburg",
      "cityCode": "LFN",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.024947,
      "longitude": -78.325418,
      "elevationFeet": 338,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LFN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LFN?codeType=fs"
     },
     {
      "fs": "LGC",
      "iata": "LGC",
      "icao": "KLGC",
      "faa": "LGC",
      "name": "Calloway Airport",
      "city": "La Grange",
      "cityCode": "LGC",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 33.0075,
      "longitude": -85.070833,
      "elevationFeet": 693,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LGC?codeType=fs"
     },
     {
      "fs": "LGF",
      "iata": "LGF",
      "icao": "KLGF",
      "faa": "LGF",
      "name": "Laguna Army Air Field",
      "city": "Yuma",
      "cityCode": "YUM",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 32.861859,
      "longitude": -114.398003,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LGF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LGF?codeType=fs"
     },
     {
      "fs": "LHB",
      "iata": "LHB",
      "icao": "",
      "faa": "",
      "name": "Lost Harbor Sea Port",
      "city": "Lost Harbor",
      "cityCode": "LHB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 54.233333,
      "longitude": -165.6,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LHB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LHB?codeType=fs"
     },
     {
      "fs": "LHV",
      "iata": "LHV",
      "icao": "KLHV",
      "faa": "LHV",
      "name": "W T Piper Memorial Airport",
      "city": "Lock Haven",
      "cityCode": "LHV",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.133333,
      "longitude": -77.45,
      "elevationFeet": 555,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LHV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LHV?codeType=fs"
     },
     {
      "fs": "LIC",
      "iata": "LIC",
      "icao": "KLIC",
      "faa": "LIC",
      "name": "Limon Municipal Airport",
      "city": "Limon",
      "cityCode": "LIC",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 39.266667,
      "longitude": -103.683333,
      "elevationFeet": 5365,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIC?codeType=fs"
     },
     {
      "fs": "LIJ",
      "iata": "LIJ",
      "icao": "",
      "faa": "",
      "name": "Long Island Airport",
      "city": "Long Island",
      "cityCode": "LIJ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 54.929167,
      "longitude": -132.808333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIJ?codeType=fs"
     },
     {
      "fs": "LIV",
      "iata": "LIV",
      "icao": "",
      "faa": "4AK",
      "name": "Livengood Airport",
      "city": "Livengood",
      "cityCode": "LIV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 65.516667,
      "longitude": -148.666667,
      "elevationFeet": 425,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIV?codeType=fs"
     },
     {
      "fs": "LIY",
      "iata": "LIY",
      "icao": "KLHW",
      "faa": "LHW",
      "name": "Wright Army Air Field",
      "city": "Hinesville",
      "cityCode": "LIY",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 31.85,
      "longitude": -81.6,
      "elevationFeet": 48,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIY?codeType=fs"
     },
     {
      "fs": "LIZ",
      "iata": "LIZ",
      "icao": "",
      "faa": "",
      "name": "Loring Air Force Base",
      "city": "Limestone",
      "cityCode": "LIZ",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.033333,
      "longitude": -78.633333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LIZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LIZ?codeType=fs"
     },
     {
      "fs": "LJC",
      "iata": "LJC",
      "icao": "",
      "faa": "",
      "name": "Intercontinental Airport",
      "city": "Louisville",
      "cityCode": "SDF",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.266667,
      "longitude": -85.75,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LJC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LJC?codeType=fs"
     },
     {
      "fs": "LJN",
      "iata": "LJN",
      "icao": "KLBX",
      "faa": "LBX",
      "name": "Brazoria County Airport",
      "city": "Lake Jackson",
      "cityCode": "LJN",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 29.108601,
      "longitude": -95.462097,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LJN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LJN?codeType=fs"
     },
     {
      "fs": "LKI",
      "iata": "LKI",
      "icao": "",
      "faa": "",
      "name": "Lakeside United States Air Force",
      "city": "Duluth",
      "cityCode": "DLH",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 46.783333,
      "longitude": -92.1,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LKI?codeType=fs"
     },
     {
      "fs": "LKK",
      "iata": "LKK",
      "icao": "",
      "faa": "",
      "name": "Kulik Lake Airport",
      "city": "Kulik Lake",
      "cityCode": "LKK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 59.816667,
      "longitude": -158.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LKK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LKK?codeType=fs"
     },
     {
      "fs": "LKS",
      "iata": "LKS",
      "icao": "",
      "faa": "",
      "name": "Lakeside Airport",
      "city": "Lakeside",
      "cityCode": "LKS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.500833,
      "longitude": -98.146944,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LKS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LKS?codeType=fs"
     },
     {
      "fs": "LL10",
      "iata": "",
      "icao": "LL10",
      "faa": "LL10",
      "name": "Naper Aero Club",
      "city": "Naperville",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 41.758667,
      "longitude": -88.228,
      "elevationFeet": 708,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LL10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LL10?codeType=fs"
     },
     {
      "fs": "LLY",
      "iata": "LLY",
      "icao": "KVAY",
      "faa": "VAY",
      "name": "Burlington County Airport",
      "city": "Mount Holly",
      "cityCode": "LLY",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.916667,
      "longitude": -74.75,
      "elevationFeet": 53,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LLY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LLY?codeType=fs"
     },
     {
      "fs": "LMS",
      "iata": "LMS",
      "icao": "KLMS",
      "faa": "LMS",
      "name": "Winston County Airport",
      "city": "Louisville",
      "cityCode": "LMS",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.116667,
      "longitude": -89.05,
      "elevationFeet": 575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LMS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LMS?codeType=fs"
     },
     {
      "fs": "LNA",
      "iata": "LNA",
      "icao": "KLNA",
      "faa": "LNA",
      "name": "Palm Beach County Airport",
      "city": "West Palm Beach",
      "cityCode": "PBI",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 26.592477,
      "longitude": -80.084477,
      "elevationFeet": 14,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNA?codeType=fs"
     },
     {
      "fs": "LND",
      "iata": "LND",
      "icao": "KLND",
      "faa": "LND",
      "name": "Hunt Field",
      "city": "Lander",
      "cityCode": "LND",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 42.833333,
      "longitude": -108.733333,
      "elevationFeet": 5586,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LND?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LND?codeType=fs"
     },
     {
      "fs": "LNI",
      "iata": "LNI",
      "icao": "",
      "faa": "",
      "name": "Lonely Air Station",
      "city": "Lonely",
      "cityCode": "LNI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 70.911275,
      "longitude": -153.242451,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNI?codeType=fs"
     },
     {
      "fs": "LNN",
      "iata": "LNN",
      "icao": "KLNN",
      "faa": "LNN",
      "name": "Lost Nation Airport",
      "city": "Willoughby",
      "cityCode": "LNN",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.683646,
      "longitude": -81.391396,
      "elevationFeet": 622,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNN?codeType=fs"
     },
     {
      "fs": "LNP",
      "iata": "LNP",
      "icao": "KLNP",
      "faa": "LNP",
      "name": "Wise Airport",
      "city": "Wise",
      "cityCode": "LNP",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.983333,
      "longitude": -82.566667,
      "elevationFeet": 2685,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LNP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LNP?codeType=fs"
     },
     {
      "fs": "LOG",
      "iata": "LOG",
      "icao": "",
      "faa": "",
      "name": "Longview Airport",
      "city": "Longview",
      "cityCode": "LOG",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 46.116667,
      "longitude": -122.883333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOG?codeType=fs"
     },
     {
      "fs": "LOR",
      "iata": "LOR",
      "icao": "",
      "faa": "",
      "name": "Lowe Army Heliport",
      "city": "Ozark",
      "cityCode": "OZR",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.5,
      "longitude": -85.433333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOR?codeType=fs"
     },
     {
      "fs": "LOW",
      "iata": "LOW",
      "icao": "KLKU",
      "faa": "LKU",
      "name": "Louisa Airport",
      "city": "Louisa",
      "cityCode": "LOW",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38,
      "longitude": -77.966667,
      "elevationFeet": 493,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOW?codeType=fs"
     },
     {
      "fs": "LOZ",
      "iata": "LOZ",
      "icao": "KLOZ",
      "faa": "LOZ",
      "name": "Magee Field",
      "city": "London",
      "cityCode": "LOZ",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 37.087222,
      "longitude": -84.076944,
      "elevationFeet": 1212,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LOZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LOZ?codeType=fs"
     },
     {
      "fs": "LPC",
      "iata": "LPC",
      "icao": "KLPC",
      "faa": "LPC",
      "name": "Lompoc Airport",
      "city": "Lompoc",
      "cityCode": "LPC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 34.664642,
      "longitude": -120.466196,
      "elevationFeet": 86,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LPC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LPC?codeType=fs"
     },
     {
      "fs": "LPO",
      "iata": "LPO",
      "icao": "KPPO",
      "faa": "PPO",
      "name": "Laporte Municipal Airport",
      "city": "Laporte",
      "cityCode": "LPO",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 41.6,
      "longitude": -86.716667,
      "elevationFeet": 812,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LPO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LPO?codeType=fs"
     },
     {
      "fs": "LPW",
      "iata": "LPW",
      "icao": "",
      "faa": "",
      "name": "Little Port Walter Airport",
      "city": "Little Port Walter",
      "cityCode": "LPW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 56.383333,
      "longitude": -134.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LPW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LPW?codeType=fs"
     },
     {
      "fs": "LQK",
      "iata": "LQK",
      "icao": "KLQK",
      "faa": "LQK",
      "name": "Pickens Airport",
      "city": "Pickens",
      "cityCode": "LQK",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.883333,
      "longitude": -82.7,
      "elevationFeet": 1013,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LQK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LQK?codeType=fs"
     },
     {
      "fs": "LRF",
      "iata": "LRF",
      "icao": "KLRF",
      "faa": "LRF",
      "name": "Little Rock Air Force Base",
      "city": "Jacksonville",
      "cityCode": "LRF",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.916667,
      "longitude": -92.15,
      "elevationFeet": 311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LRF?codeType=fs"
     },
     {
      "fs": "LRJ",
      "iata": "LRJ",
      "icao": "KLRJ",
      "faa": "LRJ",
      "name": "Lemars Municipal Airport",
      "city": "Lemars",
      "cityCode": "LRJ",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.8,
      "longitude": -96.166667,
      "elevationFeet": 1196,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LRJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LRJ?codeType=fs"
     },
     {
      "fs": "LRN",
      "iata": "LRN",
      "icao": "",
      "faa": "",
      "name": "Larson Air Force Base",
      "city": "Moses Lake",
      "cityCode": "MWH",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 47.133333,
      "longitude": -119.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LRN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LRN?codeType=fs"
     },
     {
      "fs": "LRO",
      "iata": "LRO",
      "icao": "",
      "faa": "",
      "name": "Sharpe Army Air Field",
      "city": "Lathrop",
      "cityCode": "LRO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 39.55,
      "longitude": -94.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LRO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LRO?codeType=fs"
     },
     {
      "fs": "LSB",
      "iata": "LSB",
      "icao": "KLSB",
      "faa": "LSB",
      "name": "Lordsburg Airport",
      "city": "Lordsburg",
      "cityCode": "LSB",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 32.416667,
      "longitude": -108.666667,
      "elevationFeet": 4278,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LSB?codeType=fs"
     },
     {
      "fs": "LSK",
      "iata": "LSK",
      "icao": "KLSK",
      "faa": "LSK",
      "name": "Lusk Municipal",
      "city": "Lusk",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 42.788083,
      "longitude": -104.445528,
      "elevationFeet": 4964,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LSK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LSK?codeType=fs"
     },
     {
      "fs": "LSN",
      "iata": "LSN",
      "icao": "KLSN",
      "faa": "LSN",
      "name": "Los Banos Airport",
      "city": "Los Banos",
      "cityCode": "LSN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 37.066667,
      "longitude": -120.85,
      "elevationFeet": 119,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LSN?codeType=fs"
     },
     {
      "fs": "LTH",
      "iata": "LTH",
      "icao": "",
      "faa": "",
      "name": "Lathrop Wells Airport",
      "city": "Lathrop Wells",
      "cityCode": "LTH",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 36.633333,
      "longitude": -116.383333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LTH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LTH?codeType=fs"
     },
     {
      "fs": "LTS",
      "iata": "LTS",
      "icao": "KLTS",
      "faa": "LTS",
      "name": "Altus Air Force Base",
      "city": "Altus",
      "cityCode": "LTS",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.658354,
      "longitude": -99.269343,
      "elevationFeet": 1358,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LTS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LTS?codeType=fs"
     },
     {
      "fs": "LTW",
      "iata": "LTW",
      "icao": "",
      "faa": "2W6",
      "name": "Saint Marys County Airport",
      "city": "Leonardtown",
      "cityCode": "LTW",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.315399,
      "longitude": -76.550102,
      "elevationFeet": 142,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LTW?codeType=fs"
     },
     {
      "fs": "LUL",
      "iata": "LUL",
      "icao": "KLUL",
      "faa": "LUL",
      "name": "Hesler-Noble Field",
      "city": "Laurel",
      "cityCode": "LUL",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.672604,
      "longitude": -89.172207,
      "elevationFeet": 235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LUL?codeType=fs"
     },
     {
      "fs": "LVD",
      "iata": "LVD",
      "icao": "",
      "faa": "2AK",
      "name": "Lime Village Airport",
      "city": "Lime Village",
      "cityCode": "LVD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ151",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 61.35,
      "longitude": -155.466667,
      "elevationFeet": 552,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LVD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LVD?codeType=fs"
     },
     {
      "fs": "LVL",
      "iata": "LVL",
      "icao": "KLVL",
      "faa": "LVL",
      "name": "Lawrenceville Airport",
      "city": "Lawrenceville",
      "cityCode": "LVL",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.75,
      "longitude": -77.833333,
      "elevationFeet": 329,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LVL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LVL?codeType=fs"
     },
     {
      "fs": "LWC",
      "iata": "LWC",
      "icao": "KLWC",
      "faa": "LWC",
      "name": "Lawrence Airport",
      "city": "Lawrence",
      "cityCode": "LWC",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 39.009167,
      "longitude": -95.2175,
      "elevationFeet": 832,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWC?codeType=fs"
     },
     {
      "fs": "LWL",
      "iata": "LWL",
      "icao": "KLWL",
      "faa": "LWL",
      "name": "Wells Municipal Airport-Harriet Field",
      "city": "Wells",
      "cityCode": "LWL",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 41.117098,
      "longitude": -114.922214,
      "elevationFeet": 5734,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWL?codeType=fs"
     },
     {
      "fs": "LWV",
      "iata": "LWV",
      "icao": "KLWV",
      "faa": "LWV",
      "name": "Lawrenceville Municipal Airport",
      "city": "Lawrenceville",
      "cityCode": "LWV",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.733333,
      "longitude": -87.683333,
      "elevationFeet": 430,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LWV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LWV?codeType=fs"
     },
     {
      "fs": "LXN",
      "iata": "LXN",
      "icao": "KLXN",
      "faa": "LXN",
      "name": "Jim Kelly Field",
      "city": "Lexington",
      "cityCode": "LXN",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 40.791002,
      "longitude": -99.777288,
      "elevationFeet": 2410,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LXN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LXN?codeType=fs"
     },
     {
      "fs": "LXV",
      "iata": "LXV",
      "icao": "KLXV",
      "faa": "LXV",
      "name": "Leadville Airport",
      "city": "Leadville",
      "cityCode": "LXV",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 39.220278,
      "longitude": -106.316111,
      "elevationFeet": 9927,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LXV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LXV?codeType=fs"
     },
     {
      "fs": "LYO",
      "iata": "LYO",
      "icao": "KLYO",
      "faa": "LYO",
      "name": "Rice County Municipal Airport",
      "city": "Lyons",
      "cityCode": "LYO",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.35,
      "longitude": -98.2,
      "elevationFeet": 1691,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LYO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LYO?codeType=fs"
     },
     {
      "fs": "LYU",
      "iata": "LYU",
      "icao": "KELO",
      "faa": "ELO",
      "name": "Ely Airport",
      "city": "Ely",
      "cityCode": "LYU",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 47.823889,
      "longitude": -91.829167,
      "elevationFeet": 1455,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/LYU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/LYU?codeType=fs"
     },
     {
      "fs": "M01",
      "iata": "",
      "icao": "",
      "faa": "M01",
      "name": "Gen Spain",
      "city": "Memphis",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.206917,
      "longitude": -90.089778,
      "elevationFeet": 224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M01?codeType=fs"
     },
     {
      "fs": "M02",
      "iata": "",
      "icao": "",
      "faa": "M02",
      "name": "Dickson Municipal Airport",
      "city": "Dickson",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.128114,
      "longitude": -87.429512,
      "elevationFeet": 865,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M02?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M02?codeType=fs"
     },
     {
      "fs": "M03",
      "iata": "",
      "icao": "",
      "faa": "M03",
      "name": "Cantrell",
      "city": "Conway",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.208083,
      "longitude": -92.499611,
      "elevationFeet": 315,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M03?codeType=fs"
     },
     {
      "fs": "M04",
      "iata": "",
      "icao": "",
      "faa": "M04",
      "name": "Covington Municipal",
      "city": "Covington",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.583639,
      "longitude": -89.622222,
      "elevationFeet": 280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M04?codeType=fs"
     },
     {
      "fs": "M05",
      "iata": "",
      "icao": "",
      "faa": "M05",
      "name": "Caruthersville Memorial",
      "city": "Caruthersville",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.250694,
      "longitude": -89.750806,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M05?codeType=fs"
     },
     {
      "fs": "M08",
      "iata": "",
      "icao": "",
      "faa": "M08",
      "name": "Whitehurst",
      "city": "Bolivar",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.344583,
      "longitude": -89.133611,
      "elevationFeet": 499,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M08?codeType=fs"
     },
     {
      "fs": "M11",
      "iata": "",
      "icao": "",
      "faa": "M11",
      "name": "Copiah Co",
      "city": "Crystal Springs",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.929361,
      "longitude": -90.387028,
      "elevationFeet": 443,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M11?codeType=fs"
     },
     {
      "fs": "M12",
      "iata": "",
      "icao": "",
      "faa": "M12",
      "name": "Steele Municipal",
      "city": "Steele",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.209028,
      "longitude": -89.984194,
      "elevationFeet": 259,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M12?codeType=fs"
     },
     {
      "fs": "M13",
      "iata": "",
      "icao": "",
      "faa": "M13",
      "name": "Poplarville-Pearl River Co",
      "city": "Poplarville",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.810194,
      "longitude": -89.545083,
      "elevationFeet": 320,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M13?codeType=fs"
     },
     {
      "fs": "M15",
      "iata": "",
      "icao": "",
      "faa": "M15",
      "name": "Perry Co",
      "city": "Linden",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.709028,
      "longitude": -87.966944,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M15?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M15?codeType=fs"
     },
     {
      "fs": "M16",
      "iata": "",
      "icao": "",
      "faa": "M16",
      "name": "Williams",
      "city": "Raymond",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.333417,
      "longitude": -90.484833,
      "elevationFeet": 246,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M16?codeType=fs"
     },
     {
      "fs": "M17",
      "iata": "",
      "icao": "",
      "faa": "M17",
      "name": "Bolivar Municipal",
      "city": "Bolivar",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.719333,
      "longitude": -93.4765,
      "elevationFeet": 1092,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M17?codeType=fs"
     },
     {
      "fs": "M18",
      "iata": "",
      "icao": "",
      "faa": "M18",
      "name": "Hope Municipal",
      "city": "Hope",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.750889,
      "longitude": -93.738444,
      "elevationFeet": 359,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M18?codeType=fs"
     },
     {
      "fs": "M19",
      "iata": "",
      "icao": "",
      "faa": "M19",
      "name": "Newport Municipal",
      "city": "Newport",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.677167,
      "longitude": -91.26375,
      "elevationFeet": 239,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M19?codeType=fs"
     },
     {
      "fs": "M20",
      "iata": "",
      "icao": "",
      "faa": "M20",
      "name": "Grayson Co",
      "city": "Leitchfield",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.544972,
      "longitude": -86.3525,
      "elevationFeet": 760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M20?codeType=fs"
     },
     {
      "fs": "M21",
      "iata": "",
      "icao": "",
      "faa": "M21",
      "name": "Muhlenberg Co",
      "city": "Greenville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.306111,
      "longitude": -87.225278,
      "elevationFeet": 422,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M21?codeType=fs"
     },
     {
      "fs": "M22",
      "iata": "",
      "icao": "",
      "faa": "M22",
      "name": "Russellville Municipal",
      "city": "Russellville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.595389,
      "longitude": -87.803083,
      "elevationFeet": 724,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M22?codeType=fs"
     },
     {
      "fs": "M23",
      "iata": "",
      "icao": "",
      "faa": "M23",
      "name": "Easom",
      "city": "Newton",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.418111,
      "longitude": -89.158917,
      "elevationFeet": 369,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M23?codeType=fs"
     },
     {
      "fs": "M24",
      "iata": "",
      "icao": "",
      "faa": "M24",
      "name": "Griffin Memorial",
      "city": "Wiggins",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.932444,
      "longitude": -89.247722,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M24?codeType=fs"
     },
     {
      "fs": "M25",
      "iata": "",
      "icao": "",
      "faa": "M25",
      "name": "Mayfield-Graves Co",
      "city": "Mayfield",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.791111,
      "longitude": -88.597222,
      "elevationFeet": 522,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M25?codeType=fs"
     },
     {
      "fs": "M27",
      "iata": "",
      "icao": "",
      "faa": "M27",
      "name": "Waldron Municipal",
      "city": "Waldron",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.951,
      "longitude": -94.199306,
      "elevationFeet": 695,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M27?codeType=fs"
     },
     {
      "fs": "M28",
      "iata": "",
      "icao": "",
      "faa": "M28",
      "name": "Mid Continent",
      "city": "Hayti",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.300694,
      "longitude": -89.828611,
      "elevationFeet": 268,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M28?codeType=fs"
     },
     {
      "fs": "M29",
      "iata": "",
      "icao": "",
      "faa": "M29",
      "name": "Hassell",
      "city": "Clifton",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.40075,
      "longitude": -87.975278,
      "elevationFeet": 401,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M29?codeType=fs"
     },
     {
      "fs": "M30",
      "iata": "",
      "icao": "",
      "faa": "M30",
      "name": "Metropolis Municipal",
      "city": "Metropolis",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.208861,
      "longitude": -88.756111,
      "elevationFeet": 384,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M30?codeType=fs"
     },
     {
      "fs": "M31",
      "iata": "",
      "icao": "",
      "faa": "M31",
      "name": "Arnold",
      "city": "Halls",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.934083,
      "longitude": -89.522944,
      "elevationFeet": 292,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M31?codeType=fs"
     },
     {
      "fs": "M32",
      "iata": "",
      "icao": "",
      "faa": "M32",
      "name": "Lake Village Municipal",
      "city": "Lake Village",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.459778,
      "longitude": -91.456972,
      "elevationFeet": 125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M32?codeType=fs"
     },
     {
      "fs": "M33",
      "iata": "",
      "icao": "",
      "faa": "M33",
      "name": "Sumner County Regional Airport",
      "city": "Gallatin",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.3737,
      "longitude": -86.409357,
      "elevationFeet": 559,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M33?codeType=fs"
     },
     {
      "fs": "M34",
      "iata": "",
      "icao": "",
      "faa": "M34",
      "name": "Kentucky Dam State Park",
      "city": "Gilbertsville",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.095,
      "longitude": -88.408667,
      "elevationFeet": 349,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M34?codeType=fs"
     },
     {
      "fs": "M36",
      "iata": "",
      "icao": "",
      "faa": "M36",
      "name": "Federer Memorial",
      "city": "Brinkley",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.000028,
      "longitude": -91.264389,
      "elevationFeet": 194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M36?codeType=fs"
     },
     {
      "fs": "M37",
      "iata": "",
      "icao": "",
      "faa": "M37",
      "name": "Ruleville-Drew",
      "city": "Drew",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.776402,
      "longitude": -90.525002,
      "elevationFeet": 137,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M37?codeType=fs"
     },
     {
      "fs": "M38",
      "iata": "",
      "icao": "",
      "faa": "M38",
      "name": "Hazel Green",
      "city": "Hazel Green",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.062,
      "longitude": -86.769417,
      "elevationFeet": 814,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M38?codeType=fs"
     },
     {
      "fs": "M39",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Mena Intermountain Municipal",
      "city": "Mena",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.653944,
      "longitude": -94.226528,
      "elevationFeet": 1079,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M39?codeType=fs"
     },
     {
      "fs": "M40",
      "iata": "",
      "icao": "",
      "faa": "M40",
      "name": "Monroe Co",
      "city": "Aberdeen-Amory",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.9375,
      "longitude": -88.546778,
      "elevationFeet": 226,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M40?codeType=fs"
     },
     {
      "fs": "M41",
      "iata": "",
      "icao": "",
      "faa": "M41",
      "name": "Marshall Co",
      "city": "Holly Springs",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.843472,
      "longitude": -89.561083,
      "elevationFeet": 553,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M41?codeType=fs"
     },
     {
      "fs": "M42",
      "iata": "",
      "icao": "",
      "faa": "M42",
      "name": "Abide",
      "city": "Greenville",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.35675,
      "longitude": -91.053833,
      "elevationFeet": 115,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M42?codeType=fs"
     },
     {
      "fs": "M43",
      "iata": "",
      "icao": "",
      "faa": "M43",
      "name": "Prentiss-Jefferson Davis Co",
      "city": "Prentiss",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.704472,
      "longitude": -89.961917,
      "elevationFeet": 454,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M43?codeType=fs"
     },
     {
      "fs": "M44",
      "iata": "",
      "icao": "",
      "faa": "M44",
      "name": "Houston Municipal",
      "city": "Houston",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.967806,
      "longitude": -89.086722,
      "elevationFeet": 337,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M44?codeType=fs"
     },
     {
      "fs": "M46",
      "iata": "",
      "icao": "",
      "faa": "M46",
      "name": "Colstrip",
      "city": "Colstrip",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 45.8785,
      "longitude": -106.792722,
      "elevationFeet": 3426,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M46?codeType=fs"
     },
     {
      "fs": "M48",
      "iata": "",
      "icao": "",
      "faa": "M48",
      "name": "Houston Memorial",
      "city": "Houston",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.450917,
      "longitude": -92.031694,
      "elevationFeet": 1196,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M48?codeType=fs"
     },
     {
      "fs": "M50",
      "iata": "",
      "icao": "",
      "faa": "M50",
      "name": "Boardman",
      "city": "Boardman",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 45.94825,
      "longitude": -119.855,
      "elevationFeet": 396,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M50?codeType=fs"
     },
     {
      "fs": "M51",
      "iata": "",
      "icao": "",
      "faa": "M51",
      "name": "Oktibbeha",
      "city": "Starkville",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.625417,
      "longitude": -88.813333,
      "elevationFeet": 250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M51?codeType=fs"
     },
     {
      "fs": "M52",
      "iata": "",
      "icao": "",
      "faa": "M52",
      "name": "Franklin-Wilkins",
      "city": "Lexington",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.663194,
      "longitude": -88.489333,
      "elevationFeet": 514,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M52?codeType=fs"
     },
     {
      "fs": "M53",
      "iata": "",
      "icao": "",
      "faa": "M53",
      "name": "Humboldt Municipal",
      "city": "Humboldt",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.821806,
      "longitude": -88.9495,
      "elevationFeet": 421,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M53?codeType=fs"
     },
     {
      "fs": "M54",
      "iata": "",
      "icao": "",
      "faa": "M54",
      "name": "Lebanon Municipal Airport",
      "city": "Lebanon",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.189643,
      "longitude": -86.313894,
      "elevationFeet": 566,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M54?codeType=fs"
     },
     {
      "fs": "M55",
      "iata": "",
      "icao": "",
      "faa": "M55",
      "name": "Lamar Co",
      "city": "Vernon",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.967194,
      "longitude": -88.25475,
      "elevationFeet": 463,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M55?codeType=fs"
     },
     {
      "fs": "M58",
      "iata": "",
      "icao": "",
      "faa": "M58",
      "name": "Monett Municipal",
      "city": "Monett",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.962167,
      "longitude": -94.127583,
      "elevationFeet": 1315,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M58?codeType=fs"
     },
     {
      "fs": "M59",
      "iata": "",
      "icao": "",
      "faa": "M59",
      "name": "Richton-Perry Co",
      "city": "Richton",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.324,
      "longitude": -88.950472,
      "elevationFeet": 167,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M59?codeType=fs"
     },
     {
      "fs": "M60",
      "iata": "",
      "icao": "",
      "faa": "M60",
      "name": "Woodruff Co",
      "city": "Augusta",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.317528,
      "longitude": -91.304056,
      "elevationFeet": 200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M60?codeType=fs"
     },
     {
      "fs": "M65",
      "iata": "",
      "icao": "",
      "faa": "M65",
      "name": "Wynne Municipal",
      "city": "Wynne",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.365889,
      "longitude": -90.865556,
      "elevationFeet": 370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M65?codeType=fs"
     },
     {
      "fs": "M66",
      "iata": "",
      "icao": "",
      "faa": "M66",
      "name": "Schroeder Field",
      "city": "Hillsboro",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.430667,
      "longitude": -97.341944,
      "elevationFeet": 1434,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M66?codeType=fs"
     },
     {
      "fs": "M70",
      "iata": "",
      "icao": "",
      "faa": "M70",
      "name": "Wilson",
      "city": "Pocahontas",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.355111,
      "longitude": -91.002056,
      "elevationFeet": 271,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M70?codeType=fs"
     },
     {
      "fs": "M71",
      "iata": "",
      "icao": "",
      "faa": "M71",
      "name": "Greensfield Airport",
      "city": "Moscow Mills",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.902832,
      "longitude": -90.956021,
      "elevationFeet": 553,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M71?codeType=fs"
     },
     {
      "fs": "M72",
      "iata": "",
      "icao": "",
      "faa": "M72",
      "name": "New Albany-Union Co",
      "city": "New Albany",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.672222,
      "longitude": -89.091667,
      "elevationFeet": 413,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M72?codeType=fs"
     },
     {
      "fs": "M73",
      "iata": "",
      "icao": "",
      "faa": "M73",
      "name": "Almyra Municipal",
      "city": "Almyra",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.523278,
      "longitude": -91.613472,
      "elevationFeet": 208,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M73?codeType=fs"
     },
     {
      "fs": "M74",
      "iata": "",
      "icao": "",
      "faa": "M74",
      "name": "Bald Knob Municipal",
      "city": "Bald Knob",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.304278,
      "longitude": -91.625778,
      "elevationFeet": 212,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M74?codeType=fs"
     },
     {
      "fs": "M75",
      "iata": "",
      "icao": "",
      "faa": "M75",
      "name": "Malta",
      "city": "Malta",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 48.369417,
      "longitude": -107.943444,
      "elevationFeet": 2254,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M75?codeType=fs"
     },
     {
      "fs": "M76",
      "iata": "",
      "icao": "",
      "faa": "M76",
      "name": "Picayune Municipal",
      "city": "Picayune",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.524861,
      "longitude": -89.661944,
      "elevationFeet": 56,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M76?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M76?codeType=fs"
     },
     {
      "fs": "M77",
      "iata": "",
      "icao": "",
      "faa": "M77",
      "name": "Howard Co",
      "city": "Nashville",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.1175,
      "longitude": -93.881389,
      "elevationFeet": 553,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M77?codeType=fs"
     },
     {
      "fs": "M78",
      "iata": "",
      "icao": "",
      "faa": "M78",
      "name": "Malvern Municipal",
      "city": "Malvern",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.483167,
      "longitude": -92.865,
      "elevationFeet": 538,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M78?codeType=fs"
     },
     {
      "fs": "M79",
      "iata": "",
      "icao": "",
      "faa": "M79",
      "name": "Hooks Memorial",
      "city": "Rayville",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.513389,
      "longitude": -91.80875,
      "elevationFeet": 83,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M79?codeType=fs"
     },
     {
      "fs": "M80",
      "iata": "",
      "icao": "",
      "faa": "M80",
      "name": "Scott",
      "city": "Tallulah",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.418083,
      "longitude": -91.151083,
      "elevationFeet": 84,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M80?codeType=fs"
     },
     {
      "fs": "M82",
      "iata": "",
      "icao": "",
      "faa": "M82",
      "name": "Madison Co Executive",
      "city": "Huntsville",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.9145,
      "longitude": -86.612139,
      "elevationFeet": 758,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M82?codeType=fs"
     },
     {
      "fs": "M83",
      "iata": "",
      "icao": "",
      "faa": "M83",
      "name": "Mc Charen",
      "city": "West Point",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.590361,
      "longitude": -88.666861,
      "elevationFeet": 205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M83?codeType=fs"
     },
     {
      "fs": "M84",
      "iata": "",
      "icao": "",
      "faa": "M84",
      "name": "Erie",
      "city": "Erie",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.931028,
      "longitude": -83.518778,
      "elevationFeet": 605,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M84?codeType=fs"
     },
     {
      "fs": "M85",
      "iata": "",
      "icao": "",
      "faa": "M85",
      "name": "Gideon Memorial",
      "city": "Gideon",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.537556,
      "longitude": -89.938389,
      "elevationFeet": 268,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M85?codeType=fs"
     },
     {
      "fs": "M86",
      "iata": "",
      "icao": "",
      "faa": "M86",
      "name": "Walle",
      "city": "Pullman",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.508639,
      "longitude": -86.222528,
      "elevationFeet": 635,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M86?codeType=fs"
     },
     {
      "fs": "M88",
      "iata": "",
      "icao": "",
      "faa": "M88",
      "name": "Cornelia Fort Airpark",
      "city": "Nashville",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.190239,
      "longitude": -86.699583,
      "elevationFeet": 419,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M88?codeType=fs"
     },
     {
      "fs": "M89",
      "iata": "",
      "icao": "",
      "faa": "M89",
      "name": "Florence Memorial",
      "city": "Arkadelphia",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.248472,
      "longitude": -93.211167,
      "elevationFeet": 182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M89?codeType=fs"
     },
     {
      "fs": "M91",
      "iata": "",
      "icao": "",
      "faa": "M91",
      "name": "Springfield Robertson Co",
      "city": "Springfield",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.572667,
      "longitude": -86.956944,
      "elevationFeet": 706,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M91?codeType=fs"
     },
     {
      "fs": "M93",
      "iata": "",
      "icao": "",
      "faa": "M93",
      "name": "Houston Co",
      "city": "Mc Kinnon",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.317222,
      "longitude": -87.916944,
      "elevationFeet": 370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M93?codeType=fs"
     },
     {
      "fs": "M94",
      "iata": "",
      "icao": "",
      "faa": "M94",
      "name": "Desert Aire",
      "city": "Mattawa",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 46.723556,
      "longitude": -119.956,
      "elevationFeet": 570,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M94?codeType=fs"
     },
     {
      "fs": "M95",
      "iata": "",
      "icao": "",
      "faa": "M95",
      "name": "Arthur",
      "city": "Fayette",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.822194,
      "longitude": -87.950472,
      "elevationFeet": 364,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M95?codeType=fs"
     },
     {
      "fs": "M99",
      "iata": "",
      "icao": "",
      "faa": "M99",
      "name": "Saline Co/Watts",
      "city": "Benton",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.615639,
      "longitude": -92.669389,
      "elevationFeet": 318,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/M99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/M99?codeType=fs"
     },
     {
      "fs": "MAC",
      "iata": "MAC",
      "icao": "KMAC",
      "faa": "MAC",
      "name": "Macon Downtown Airport",
      "city": "Macon",
      "cityCode": "MCN",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 32.822158,
      "longitude": -83.562019,
      "elevationFeet": 430,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MAC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MAC?codeType=fs"
     },
     {
      "fs": "MAW",
      "iata": "MAW",
      "icao": "KMAW",
      "faa": "MAW",
      "name": "Malden Airport",
      "city": "Malden",
      "cityCode": "MAW",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.605556,
      "longitude": -89.988889,
      "elevationFeet": 295,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MAW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MAW?codeType=fs"
     },
     {
      "fs": "MBY",
      "iata": "MBY",
      "icao": "KMBY",
      "faa": "MBY",
      "name": "Moberly Airport",
      "city": "Moberly",
      "cityCode": "MBY",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 39.463889,
      "longitude": -92.426667,
      "elevationFeet": 867,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MBY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MBY?codeType=fs"
     },
     {
      "fs": "MCL",
      "iata": "MCL",
      "icao": "PAIN",
      "faa": "PAIN",
      "name": "Mount Mckinley Airport",
      "city": "Mount McKinley",
      "cityCode": "MCL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 63.875972,
      "longitude": -149.006389,
      "elevationFeet": 1720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MCL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MCL?codeType=fs"
     },
     {
      "fs": "MDA",
      "iata": "MDA",
      "icao": "KMDA",
      "faa": "MDA",
      "name": "Martindale Army Air Field",
      "city": "San Antonio",
      "cityCode": "SAT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 29.43279,
      "longitude": -98.376758,
      "elevationFeet": 677,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDA?codeType=fs"
     },
     {
      "fs": "MDF",
      "iata": "",
      "icao": "KMDZ",
      "faa": "MDZ",
      "name": "Medford Airport",
      "city": "Medford",
      "cityCode": "MDF",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 45.15,
      "longitude": -90.333333,
      "elevationFeet": 1470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDF?codeType=fs"
     },
     {
      "fs": "MDH",
      "iata": "MDH",
      "icao": "KMDH",
      "faa": "MDH",
      "name": "Southern Illinois Airport",
      "city": "Carbondale",
      "cityCode": "MDH",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.781389,
      "longitude": -89.246944,
      "elevationFeet": 411,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDH?codeType=fs"
     },
     {
      "fs": "MDJ",
      "iata": "MDJ",
      "icao": "",
      "faa": "S33",
      "name": "Madras City-County Airport",
      "city": "Madras",
      "cityCode": "MDJ",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 44.6702,
      "longitude": -121.154999,
      "elevationFeet": 2437,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDJ?codeType=fs"
     },
     {
      "fs": "MDN",
      "iata": "MDN",
      "icao": "",
      "faa": "",
      "name": "Jefferson Proving Ground",
      "city": "Madison",
      "cityCode": "MDN",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.733333,
      "longitude": -85.383333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDN?codeType=fs"
     },
     {
      "fs": "MDO",
      "iata": "MDO",
      "icao": "PAMD",
      "faa": "PAMD",
      "name": "Middleton Island Intermediate Airport",
      "city": "Middleton Island",
      "cityCode": "MDO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 59.453056,
      "longitude": -146.3,
      "elevationFeet": 87,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MDO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MDO?codeType=fs"
     },
     {
      "fs": "ME6",
      "iata": "",
      "icao": "",
      "faa": "ME6",
      "name": "Wales",
      "city": "Wales",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 44.245278,
      "longitude": -70.039444,
      "elevationFeet": 210,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ME6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ME6?codeType=fs"
     },
     {
      "fs": "MEJ",
      "iata": "MEJ",
      "icao": "KGKJ",
      "faa": "GKJ",
      "name": "Meadville Airport",
      "city": "Meadville",
      "cityCode": "MEJ",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.633333,
      "longitude": -80.166667,
      "elevationFeet": 1400,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MEJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MEJ?codeType=fs"
     },
     {
      "fs": "MER",
      "iata": "MER",
      "icao": "KMER",
      "faa": "MER",
      "name": "Castle Air Force Base",
      "city": "Merced",
      "cityCode": "MCE",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 37.380501,
      "longitude": -120.568001,
      "elevationFeet": 191,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MER?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MER?codeType=fs"
     },
     {
      "fs": "MEV",
      "iata": "MEV",
      "icao": "KMEV",
      "faa": "MEV",
      "name": "Douglas County Airport",
      "city": "Minden",
      "cityCode": "MEV",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 39,
      "longitude": -119.75,
      "elevationFeet": 4717,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MEV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MEV?codeType=fs"
     },
     {
      "fs": "MFH",
      "iata": "MFH",
      "icao": "",
      "faa": "",
      "name": "Mesquite Airport",
      "city": "Mesquite",
      "cityCode": "MFH",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 36.836111,
      "longitude": -114.058611,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MFH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MFH?codeType=fs"
     },
     {
      "fs": "MFI",
      "iata": "MFI",
      "icao": "KMFI",
      "faa": "MFI",
      "name": "Marshfield Municipal Airport",
      "city": "Marshfield",
      "cityCode": "MFI",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 44.633889,
      "longitude": -90.186667,
      "elevationFeet": 1277,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MFI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MFI?codeType=fs"
     },
     {
      "fs": "MFV",
      "iata": "MFV",
      "icao": "KMFV",
      "faa": "MFV",
      "name": "Accomack County Airport",
      "city": "Melfa",
      "cityCode": "MFV",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 37.633333,
      "longitude": -75.783333,
      "elevationFeet": 47,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MFV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MFV?codeType=fs"
     },
     {
      "fs": "MGC",
      "iata": "MGC",
      "icao": "KMGC",
      "faa": "MGC",
      "name": "Michigan City Airport",
      "city": "Michigan City",
      "cityCode": "MGC",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 41.7,
      "longitude": -86.816667,
      "elevationFeet": 655,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGC?codeType=fs"
     },
     {
      "fs": "MGI",
      "iata": "MGI",
      "icao": "",
      "faa": "",
      "name": "Matagorda Island National Wildlife Refuge Airport",
      "city": "Matagorda Island",
      "cityCode": "MGI",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 28.325536,
      "longitude": -96.463667,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGI?codeType=fs"
     },
     {
      "fs": "MGJ",
      "iata": "MGJ",
      "icao": "KMGJ",
      "faa": "MGJ",
      "name": "Orange County Airport",
      "city": "Montgomery",
      "cityCode": "MGJ",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.516667,
      "longitude": -74.266667,
      "elevationFeet": 365,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGJ?codeType=fs"
     },
     {
      "fs": "MGR",
      "iata": "MGR",
      "icao": "KMGR",
      "faa": "MGR",
      "name": "Thomasville Airport",
      "city": "Moultrie",
      "cityCode": "MGR",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 31.069444,
      "longitude": -83.802778,
      "elevationFeet": 294,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGR?codeType=fs"
     },
     {
      "fs": "MGY",
      "iata": "MGY",
      "icao": "",
      "faa": "",
      "name": "Montgomery County Airport",
      "city": "Dayton",
      "cityCode": "DAY",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.933333,
      "longitude": -84.254444,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MGY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MGY?codeType=fs"
     },
     {
      "fs": "MHL",
      "iata": "MHL",
      "icao": "KMHL",
      "faa": "MHL",
      "name": "Memorial Municipal Airport",
      "city": "Marshall",
      "cityCode": "MHL",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 39.116667,
      "longitude": -93.2,
      "elevationFeet": 779,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHL?codeType=fs"
     },
     {
      "fs": "MHN",
      "iata": "MHN",
      "icao": "KMHN",
      "faa": "MHN",
      "name": "Mullen Airport",
      "city": "Mullen",
      "cityCode": "MHN",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 42.05,
      "longitude": -101.016667,
      "elevationFeet": 3260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHN?codeType=fs"
     },
     {
      "fs": "MHS",
      "iata": "MHS",
      "icao": "",
      "faa": "",
      "name": "Rep Airport",
      "city": "Mount Shasta",
      "cityCode": "MHS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 41.316667,
      "longitude": -122.316667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MHS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MHS?codeType=fs"
     },
     {
      "fs": "MI54",
      "iata": "",
      "icao": "MI54",
      "faa": "MI54",
      "name": "David'S Landing",
      "city": "St Clair",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.783333,
      "longitude": -82.575,
      "elevationFeet": 615,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MI54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MI54?codeType=fs"
     },
     {
      "fs": "MIC",
      "iata": "MIC",
      "icao": "KMIC",
      "faa": "MIC",
      "name": "Crystal Airport",
      "city": "Minneapolis",
      "cityCode": "MSP",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 45.061944,
      "longitude": -93.353889,
      "elevationFeet": 869,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIC?codeType=fs"
     },
     {
      "fs": "MIF",
      "iata": "MIF",
      "icao": "",
      "faa": "E01",
      "name": "Roy Hurd Memorial Airport",
      "city": "Monahans",
      "cityCode": "MIF",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.6,
      "longitude": -102.9,
      "elevationFeet": 2614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIF?codeType=fs"
     },
     {
      "fs": "MIO",
      "iata": "MIO",
      "icao": "KMIO",
      "faa": "MIO",
      "name": "Miami Airport",
      "city": "Miami",
      "cityCode": "MIO",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 36.883333,
      "longitude": -94.9,
      "elevationFeet": 808,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIO?codeType=fs"
     },
     {
      "fs": "MIT",
      "iata": "MIT",
      "icao": "KMIT",
      "faa": "MIT",
      "name": "Minter Field",
      "city": "Shafter",
      "cityCode": "MIT",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 35.507387,
      "longitude": -119.192002,
      "elevationFeet": 417,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIT?codeType=fs"
     },
     {
      "fs": "MIW",
      "iata": "MIW",
      "icao": "KMIW",
      "faa": "MIW",
      "name": "Marshalltown Municipal Airport",
      "city": "Marshalltown",
      "cityCode": "MIW",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.166667,
      "longitude": -92.916667,
      "elevationFeet": 974,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MIW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MIW?codeType=fs"
     },
     {
      "fs": "MJQ",
      "iata": "MJQ",
      "icao": "KMJQ",
      "faa": "MJQ",
      "name": "Jackson Airport",
      "city": "Jackson",
      "cityCode": "MJQ",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 43.616667,
      "longitude": -95.016667,
      "elevationFeet": 1446,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MJQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MJQ?codeType=fs"
     },
     {
      "fs": "MKO",
      "iata": "MKO",
      "icao": "KMKO",
      "faa": "MKO",
      "name": "Davis Field",
      "city": "Muskogee",
      "cityCode": "MKO",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.660556,
      "longitude": -95.366667,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKO?codeType=fs"
     },
     {
      "fs": "MKT",
      "iata": "MKT",
      "icao": "KMKT",
      "faa": "MKT",
      "name": "Mankato Municipal Airport",
      "city": "Mankato",
      "cityCode": "MKT",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 44.223611,
      "longitude": -93.918333,
      "elevationFeet": 1020,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MKT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MKT?codeType=fs"
     },
     {
      "fs": "MLD",
      "iata": "MLD",
      "icao": "KMLD",
      "faa": "MLD",
      "name": "Malad City Airport",
      "city": "Malad City",
      "cityCode": "MLD",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 42.2,
      "longitude": -112.45,
      "elevationFeet": 4503,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLD?codeType=fs"
     },
     {
      "fs": "MLF",
      "iata": "MLF",
      "icao": "KMLF",
      "faa": "MLF",
      "name": "Milford Airport",
      "city": "Milford",
      "cityCode": "MLF",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 38.433333,
      "longitude": -113.016667,
      "elevationFeet": 5039,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLF?codeType=fs"
     },
     {
      "fs": "MLJ",
      "iata": "MLJ",
      "icao": "KMLJ",
      "faa": "MLJ",
      "name": "Baldwin County Airport",
      "city": "Milledgeville",
      "cityCode": "MLJ",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 33.083333,
      "longitude": -83.233333,
      "elevationFeet": 384,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLJ?codeType=fs"
     },
     {
      "fs": "MLK",
      "iata": "MLK",
      "icao": "KMLK",
      "faa": "MLK",
      "name": "Malta",
      "city": "Malta",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 48.494417,
      "longitude": -107.9095,
      "elevationFeet": 2280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MLK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MLK?codeType=fs"
     },
     {
      "fs": "MMI",
      "iata": "MMI",
      "icao": "KMMI",
      "faa": "MMI",
      "name": "McMinn County Airport",
      "city": "Athens",
      "cityCode": "MMI",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.523028,
      "longitude": -84.675694,
      "elevationFeet": 858,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMI?codeType=fs"
     },
     {
      "fs": "MMR",
      "iata": "MMR",
      "icao": "",
      "faa": "",
      "name": "Camp Maybry Army Heliport",
      "city": "Austin",
      "cityCode": "AUS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.324601,
      "longitude": -97.761108,
      "elevationFeet": 698,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMR?codeType=fs"
     },
     {
      "fs": "MMS",
      "iata": "MMS",
      "icao": "KMMS",
      "faa": "MMS",
      "name": "Selfs Airport",
      "city": "Marks",
      "cityCode": "MMS",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 34.266667,
      "longitude": -90.266667,
      "elevationFeet": 162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMS?codeType=fs"
     },
     {
      "fs": "MMT",
      "iata": "MMT",
      "icao": "KMMT",
      "faa": "MMT",
      "name": "McEntire Joint National Guard Base",
      "city": "Columbia",
      "cityCode": "CAE",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 33.92465,
      "longitude": -80.806428,
      "elevationFeet": 239,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MMT?codeType=fs"
     },
     {
      "fs": "MNN",
      "iata": "MNN",
      "icao": "KMNN",
      "faa": "MNN",
      "name": "Marion Municipal Airport",
      "city": "Marion",
      "cityCode": "MNN",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.583333,
      "longitude": -83.133333,
      "elevationFeet": 993,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MNN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MNN?codeType=fs"
     },
     {
      "fs": "MO1",
      "iata": "",
      "icao": "",
      "faa": "MO1",
      "name": "Richland Municipal",
      "city": "Richland",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.950389,
      "longitude": -92.485056,
      "elevationFeet": 1110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MO1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MO1?codeType=fs"
     },
     {
      "fs": "MO2",
      "iata": "",
      "icao": "",
      "faa": "MO2",
      "name": "Flying Bar H Ranch",
      "city": "Springfield",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.183833,
      "longitude": -93.135139,
      "elevationFeet": 1375,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MO2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MO2?codeType=fs"
     },
     {
      "fs": "MO3",
      "iata": "",
      "icao": "",
      "faa": "MO3",
      "name": "Stockton Municipal",
      "city": "Stockton",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.752611,
      "longitude": -93.818222,
      "elevationFeet": 1042,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MO3?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MO3?codeType=fs"
     },
     {
      "fs": "MO5",
      "iata": "",
      "icao": "",
      "faa": "MO5",
      "name": "Bollinger-Crass Memorial",
      "city": "Van Buren",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.069944,
      "longitude": -91.070722,
      "elevationFeet": 647,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MO5?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MO5?codeType=fs"
     },
     {
      "fs": "MO6",
      "iata": "",
      "icao": "",
      "faa": "MO6",
      "name": "Washington Memorial Airport",
      "city": "Washington",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.594633,
      "longitude": -90.976904,
      "elevationFeet": 577,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MO6?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MO6?codeType=fs"
     },
     {
      "fs": "MO9",
      "iata": "",
      "icao": "",
      "faa": "MO9",
      "name": "Piedmont Municipal",
      "city": "Piedmont",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.217167,
      "longitude": -90.828972,
      "elevationFeet": 467,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MO9?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MO9?codeType=fs"
     },
     {
      "fs": "MOS",
      "iata": "MOS",
      "icao": "",
      "faa": "",
      "name": "Moses Point Intermediate Airport",
      "city": "Moses Point",
      "cityCode": "MOS",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 64.695556,
      "longitude": -162.043333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOS?codeType=fs"
     },
     {
      "fs": "MOX",
      "iata": "MOX",
      "icao": "KMOX",
      "faa": "MOX",
      "name": "Morris Municipal Airport",
      "city": "Morris",
      "cityCode": "MOX",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 45.583333,
      "longitude": -95.916667,
      "elevationFeet": 1130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MOX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MOX?codeType=fs"
     },
     {
      "fs": "MPE",
      "iata": "MPE",
      "icao": "",
      "faa": "N04",
      "name": "Madison Airport",
      "city": "Madison",
      "cityCode": "MPE",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.283333,
      "longitude": -72.6,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPE?codeType=fs"
     },
     {
      "fs": "MPJ",
      "icao": "KMPJ",
      "faa": "MPJ",
      "name": "Petit Jean Park Airport",
      "city": "Morrilton",
      "cityCode": "MPJ",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.15,
      "longitude": -92.733333,
      "elevationFeet": 923,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPJ?codeType=fs"
     },
     {
      "fs": "MPO",
      "iata": "MPO",
      "icao": "KMPO",
      "faa": "MPO",
      "name": "Mount Pocono Airport",
      "city": "Mount Pocono",
      "cityCode": "MPO",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.133333,
      "longitude": -75.366667,
      "elevationFeet": 1916,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPO?codeType=fs"
     },
     {
      "fs": "MPR",
      "iata": "MPR",
      "icao": "KMPR",
      "faa": "MPR",
      "name": "McPherson Airport",
      "city": "McPherson",
      "cityCode": "MPR",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 38.374361,
      "longitude": -97.763306,
      "elevationFeet": 1497,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPR?codeType=fs"
     },
     {
      "fs": "MPS",
      "iata": "MPS",
      "icao": "KMSA",
      "faa": "MSA",
      "name": "Mount Pleasant Airport",
      "city": "Mount Pleasant",
      "cityCode": "MPS",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 33.166667,
      "longitude": -94.983333,
      "elevationFeet": 404,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPS?codeType=fs"
     },
     {
      "fs": "MPZ",
      "iata": "MPZ",
      "icao": "KMPZ",
      "faa": "MPZ",
      "name": "Mount Pleasant Municipal Airport",
      "city": "Mount Pleasant",
      "cityCode": "MPZ",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 40.966667,
      "longitude": -91.55,
      "elevationFeet": 734,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MPZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MPZ?codeType=fs"
     },
     {
      "fs": "MQB",
      "iata": "MQB",
      "icao": "KMQB",
      "faa": "MQB",
      "name": "Macomb Municipal Airport",
      "city": "Macomb",
      "cityCode": "MQB",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 40.4525,
      "longitude": -90.621389,
      "elevationFeet": 705,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MQB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MQB?codeType=fs"
     },
     {
      "fs": "MQI",
      "iata": "MQI",
      "icao": "",
      "faa": "",
      "name": "Quincy Airport",
      "city": "Quincy",
      "cityCode": "MQI",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.25,
      "longitude": -71,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MQI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MQI?codeType=fs"
     },
     {
      "fs": "MQW",
      "iata": "MQW",
      "icao": "KMQW",
      "faa": "MQW",
      "name": "Telfair-Wheeler Airport",
      "city": "McRae",
      "cityCode": "MQW",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 32.207778,
      "longitude": -83.000278,
      "elevationFeet": 202,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MQW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MQW?codeType=fs"
     },
     {
      "fs": "MRC",
      "iata": "MRC",
      "icao": "KMRC",
      "faa": "MRC",
      "name": "Maury County Airport",
      "city": "Columbia",
      "cityCode": "MRC",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.553375,
      "longitude": -87.177436,
      "elevationFeet": 676,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRC?codeType=fs"
     },
     {
      "fs": "MRI",
      "iata": "MRI",
      "icao": "PAMR",
      "faa": "PAMR",
      "name": "Merrill Field",
      "city": "Anchorage",
      "cityCode": "ANC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 61.221681,
      "longitude": -149.855652,
      "elevationFeet": 63,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRI?codeType=fs"
     },
     {
      "fs": "MRN",
      "iata": "MRN",
      "icao": "KMRN",
      "faa": "MRN",
      "name": "Lenoir Airport",
      "city": "Morganton",
      "cityCode": "MRN",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.75,
      "longitude": -81.683333,
      "elevationFeet": 1270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MRN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MRN?codeType=fs"
     },
     {
      "fs": "MSD",
      "iata": "MSD",
      "icao": "",
      "faa": "43U",
      "name": "Mt. Pleasant Airport",
      "city": "Mount Pleasant",
      "cityCode": "MSD",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 39.524722,
      "longitude": -111.474444,
      "elevationFeet": 5829,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSD?codeType=fs"
     },
     {
      "fs": "MSV",
      "iata": "MSV",
      "icao": "KMSV",
      "faa": "MSV",
      "name": "Sullivan County International Airport",
      "city": "Monticello",
      "cityCode": "MSV",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.701389,
      "longitude": -74.795,
      "elevationFeet": 1403,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MSV?codeType=fs"
     },
     {
      "fs": "MTO",
      "iata": "MTO",
      "icao": "KMTO",
      "faa": "MTO",
      "name": "Coles County Memorial Airport",
      "city": "Mattoon",
      "cityCode": "MTO",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 39.478611,
      "longitude": -88.278333,
      "elevationFeet": 722,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTO?codeType=fs"
     },
     {
      "fs": "MTW",
      "iata": "MTW",
      "icao": "KMTW",
      "faa": "MTW",
      "name": "Manitowoc Municipal Airport",
      "city": "Manitowoc",
      "cityCode": "MTW",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 44.129722,
      "longitude": -87.682222,
      "elevationFeet": 651,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTW?codeType=fs"
     },
     {
      "fs": "MTX",
      "iata": "MTX",
      "icao": "",
      "faa": "",
      "name": "Metro Field",
      "city": "Fairbanks",
      "cityCode": "FAI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 64.807197,
      "longitude": -147.760097,
      "elevationFeet": 439,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MTX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MTX?codeType=fs"
     },
     {
      "fs": "MUI",
      "iata": "MUI",
      "icao": "KMUI",
      "faa": "MUI",
      "name": "Muir Aaf",
      "city": "Ft Indiantown Gap",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.447583,
      "longitude": -76.596611,
      "elevationFeet": 489,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUI?codeType=fs"
     },
     {
      "fs": "MUL",
      "iata": "MUL",
      "icao": "KMUL",
      "faa": "MUL",
      "name": "Spence Airport",
      "city": "Moultrie",
      "cityCode": "MGR",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 31.183333,
      "longitude": -83.783333,
      "elevationFeet": 292,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUL?codeType=fs"
     },
     {
      "fs": "MUT",
      "iata": "MUT",
      "icao": "KMUT",
      "faa": "MUT",
      "name": "Muscatine Airport",
      "city": "Muscatine",
      "cityCode": "MUT",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 41.366667,
      "longitude": -91.145,
      "elevationFeet": 548,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUT?codeType=fs"
     },
     {
      "fs": "MUU",
      "iata": "MUU",
      "icao": "KMUU",
      "faa": "MUU",
      "name": "Mount Union Airport",
      "city": "Mount Union",
      "cityCode": "MUU",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.383333,
      "longitude": -77.883333,
      "elevationFeet": 560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUU?codeType=fs"
     },
     {
      "fs": "MUV",
      "iata": "MUV",
      "icao": "",
      "faa": "",
      "name": "Mustin Airfield",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.891349,
      "longitude": -75.162238,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MUV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MUV?codeType=fs"
     },
     {
      "fs": "MVC",
      "iata": "MVC",
      "icao": "KMVC",
      "faa": "MVC",
      "name": "Monroe County Airport",
      "city": "Monroeville",
      "cityCode": "MVC",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 31.516667,
      "longitude": -87.333333,
      "elevationFeet": 419,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVC?codeType=fs"
     },
     {
      "fs": "MVE",
      "iata": "MVE",
      "icao": "KMVE",
      "faa": "MVE",
      "name": "Montevideo Municipal Airport",
      "city": "Montevideo",
      "cityCode": "MVE",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 44.95,
      "longitude": -95.716667,
      "elevationFeet": 1034,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVE?codeType=fs"
     },
     {
      "fs": "MVM",
      "iata": "MVM",
      "icao": "",
      "faa": "0V7",
      "name": "Monument Valley Airport",
      "city": "Kayenta",
      "cityCode": "MVM",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 36.702778,
      "longitude": -110.233333,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MVM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MVM?codeType=fs"
     },
     {
      "fs": "MWC",
      "iata": "MWC",
      "icao": "KMWC",
      "faa": "MWC",
      "name": "Lawrence J. Timmerman Airport",
      "city": "Milwaukee",
      "cityCode": "MKE",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 43.110636,
      "longitude": -88.033293,
      "elevationFeet": 736,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MWC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MWC?codeType=fs"
     },
     {
      "fs": "MWL",
      "iata": "MWL",
      "icao": "KMWL",
      "faa": "MWL",
      "name": "Mineral Wells Airport",
      "city": "Mineral Wells",
      "cityCode": "MWL",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.783333,
      "longitude": -98.066667,
      "elevationFeet": 973,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MWL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MWL?codeType=fs"
     },
     {
      "fs": "MWM",
      "iata": "MWM",
      "icao": "KMWM",
      "faa": "MWM",
      "name": "Windom Municipal Airport",
      "city": "Windom",
      "cityCode": "MWM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 43.916667,
      "longitude": -95.1,
      "elevationFeet": 1410,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MWM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MWM?codeType=fs"
     },
     {
      "fs": "MXA",
      "iata": "MXA",
      "icao": "KMXA",
      "faa": "MXA",
      "name": "Manila Municipal Airport",
      "city": "Manila",
      "cityCode": "MXA",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.883333,
      "longitude": -90.183333,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXA?codeType=fs"
     },
     {
      "fs": "MXC",
      "iata": "MXC",
      "icao": "",
      "faa": "U43",
      "name": "San Juan County Airport",
      "city": "Monticello",
      "cityCode": "MXC",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 37.883333,
      "longitude": -109.366667,
      "elevationFeet": 6998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXC?codeType=fs"
     },
     {
      "fs": "MXE",
      "iata": "MXE",
      "icao": "KMEB",
      "faa": "MEB",
      "name": "Maxton Airport",
      "city": "Maxton",
      "cityCode": "MXE",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.716667,
      "longitude": -79.333333,
      "elevationFeet": 220,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXE?codeType=fs"
     },
     {
      "fs": "MXF",
      "iata": "MXF",
      "icao": "KMXF",
      "faa": "MXF",
      "name": "Maxwell Air Force Base",
      "city": "Montgomery",
      "cityCode": "MGM",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 32.382266,
      "longitude": -86.365684,
      "elevationFeet": 164,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXF?codeType=fs"
     },
     {
      "fs": "MXG",
      "iata": "MXG",
      "icao": "",
      "faa": "9B1",
      "name": "Marlborough Airport",
      "city": "Marlborough",
      "cityCode": "MXG",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.333333,
      "longitude": -71.55,
      "elevationFeet": 285,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXG?codeType=fs"
     },
     {
      "fs": "MXO",
      "iata": "MXO",
      "icao": "KMXO",
      "faa": "MXO",
      "name": "Monticello Municipal Airport",
      "city": "Monticello",
      "cityCode": "MXO",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.25,
      "longitude": -91.2,
      "elevationFeet": 849,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXO?codeType=fs"
     },
     {
      "fs": "MXY",
      "iata": "MXY",
      "icao": "",
      "faa": "15Z",
      "name": "Mc Carthy Airport",
      "city": "McCarthy",
      "cityCode": "MXY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 61.470611,
      "longitude": -142.937361,
      "elevationFeet": 1531,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MXY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MXY?codeType=fs"
     },
     {
      "fs": "MYH",
      "iata": "MYH",
      "icao": "",
      "faa": "L41",
      "name": "Marble Canyon Airport",
      "city": "Marble Canyon",
      "cityCode": "MYH",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 36.8125,
      "longitude": -111.645833,
      "elevationFeet": 3603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYH?codeType=fs"
     },
     {
      "fs": "MYK",
      "iata": "MYK",
      "icao": "",
      "faa": "MYK",
      "name": "May Creek Airport",
      "city": "May Creek",
      "cityCode": "MYK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 61.416667,
      "longitude": -142.916667,
      "elevationFeet": 1650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYK?codeType=fs"
     },
     {
      "fs": "MYL",
      "iata": "MYL",
      "icao": "KMYL",
      "faa": "MYL",
      "name": "Mc Call Airport",
      "city": "Mc Call",
      "cityCode": "MYL",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 44.916667,
      "longitude": -116.1,
      "elevationFeet": 5021,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MYL?codeType=fs"
     },
     {
      "fs": "MZZ",
      "iata": "MZZ",
      "icao": "KMZZ",
      "faa": "MZZ",
      "name": "Marion Airport",
      "city": "Marion",
      "cityCode": "MZZ",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.490833,
      "longitude": -85.679444,
      "elevationFeet": 859,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/MZZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/MZZ?codeType=fs"
     },
     {
      "fs": "N00",
      "iata": "",
      "icao": "",
      "faa": "N00",
      "name": "Maben",
      "city": "Lexington & Prattsville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.323083,
      "longitude": -74.490361,
      "elevationFeet": 1800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N00?codeType=fs"
     },
     {
      "fs": "N05",
      "iata": "",
      "icao": "",
      "faa": "N05",
      "name": "Hackettstown",
      "city": "Hackettstown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.851,
      "longitude": -74.901667,
      "elevationFeet": 670,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N05?codeType=fs"
     },
     {
      "fs": "N06",
      "iata": "",
      "icao": "",
      "faa": "N06",
      "name": "Laurel",
      "city": "Laurel",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.542198,
      "longitude": -75.594398,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N06?codeType=fs"
     },
     {
      "fs": "N07",
      "iata": "",
      "icao": "",
      "faa": "N07",
      "name": "Lincoln Park",
      "city": "Lincoln Park",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.07525,
      "longitude": -74.445028,
      "elevationFeet": 182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N07?codeType=fs"
     },
     {
      "fs": "N08",
      "iata": "",
      "icao": "",
      "faa": "N08",
      "name": "Flanagan",
      "city": "Farmville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.616667,
      "longitude": -77.655556,
      "elevationFeet": 75,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N08?codeType=fs"
     },
     {
      "fs": "N10",
      "iata": "",
      "icao": "",
      "faa": "N10",
      "name": "Perkiomen Valley",
      "city": "Collegeville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.240472,
      "longitude": -75.552639,
      "elevationFeet": 277,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N10?codeType=fs"
     },
     {
      "fs": "N12",
      "iata": "",
      "icao": "",
      "faa": "N12",
      "name": "Lakewood",
      "city": "Lakewood",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.067833,
      "longitude": -74.276417,
      "elevationFeet": 32,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N12?codeType=fs"
     },
     {
      "fs": "N13",
      "iata": "",
      "icao": "",
      "faa": "N13",
      "name": "Bloomsburg Municipal",
      "city": "Bloomsburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.127806,
      "longitude": -76.460556,
      "elevationFeet": 481,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N13?codeType=fs"
     },
     {
      "fs": "N16",
      "iata": "",
      "icao": "",
      "faa": "N16",
      "name": "Centre Airpark",
      "city": "Centre Hall",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.917306,
      "longitude": -77.722194,
      "elevationFeet": 1307,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N16?codeType=fs"
     },
     {
      "fs": "N21",
      "iata": "",
      "icao": "",
      "faa": "N21",
      "name": "Holly Ridge/Topsail I",
      "city": "Holly Ridge",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.56,
      "longitude": -77.660806,
      "elevationFeet": 40,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N21?codeType=fs"
     },
     {
      "fs": "N22",
      "iata": "",
      "icao": "",
      "faa": "N22",
      "name": "Sky Manor",
      "city": "Jacksonville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.718333,
      "longitude": -77.671944,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N22?codeType=fs"
     },
     {
      "fs": "N24",
      "iata": "",
      "icao": "",
      "faa": "N24",
      "name": "Questa Mun Nr 2",
      "city": "Questa",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 36.803056,
      "longitude": -105.725,
      "elevationFeet": 7690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N24?codeType=fs"
     },
     {
      "fs": "N25",
      "iata": "",
      "icao": "",
      "faa": "N25",
      "name": "Westport",
      "city": "Westport",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 44.233861,
      "longitude": -73.579056,
      "elevationFeet": 276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N25?codeType=fs"
     },
     {
      "fs": "N27",
      "iata": "",
      "icao": "",
      "faa": "N27",
      "name": "Bradford Co",
      "city": "Towanda",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.832417,
      "longitude": -76.545722,
      "elevationFeet": 733,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N27?codeType=fs"
     },
     {
      "fs": "N29",
      "iata": "",
      "icao": "",
      "faa": "N29",
      "name": "Magdalena Municipal",
      "city": "Magdalena",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 34.195083,
      "longitude": -107.428139,
      "elevationFeet": 6727,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N29?codeType=fs"
     },
     {
      "fs": "N30",
      "iata": "",
      "icao": "",
      "faa": "N30",
      "name": "Cherry Ridge",
      "city": "Honesdale",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.653389,
      "longitude": -75.264806,
      "elevationFeet": 1357,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N30?codeType=fs"
     },
     {
      "fs": "N31",
      "iata": "",
      "icao": "",
      "faa": "N31",
      "name": "Kutztown",
      "city": "Kutztown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.534278,
      "longitude": -75.821417,
      "elevationFeet": 512,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N31?codeType=fs"
     },
     {
      "fs": "N32",
      "iata": "",
      "icao": "",
      "faa": "N32",
      "name": "Blue Swan",
      "city": "Sayre",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.011861,
      "longitude": -76.699444,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N32?codeType=fs"
     },
     {
      "fs": "N34",
      "iata": "",
      "icao": "",
      "faa": "N34",
      "name": "Orchard Park Airport",
      "city": "Orchard Park",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.796201,
      "longitude": -78.740401,
      "elevationFeet": 787,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N34?codeType=fs"
     },
     {
      "fs": "N35",
      "iata": "",
      "icao": "",
      "faa": "N35",
      "name": "Punxsutawney Municipal",
      "city": "Punxsutawney",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.96675,
      "longitude": -79.050056,
      "elevationFeet": 1439,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N35?codeType=fs"
     },
     {
      "fs": "N37",
      "iata": "",
      "icao": "",
      "faa": "N37",
      "name": "Monticello",
      "city": "Monticello",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.674917,
      "longitude": -74.714111,
      "elevationFeet": 1545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N37?codeType=fs"
     },
     {
      "fs": "N38",
      "iata": "",
      "icao": "",
      "faa": "N38",
      "name": "Grand Canyon State",
      "city": "Wellsboro",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.829,
      "longitude": -77.515111,
      "elevationFeet": 1899,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N38?codeType=fs"
     },
     {
      "fs": "N40",
      "iata": "",
      "icao": "",
      "faa": "N40",
      "name": "Sky Manor",
      "city": "Pittstown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.712694,
      "longitude": -75.086417,
      "elevationFeet": 560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N40?codeType=fs"
     },
     {
      "fs": "N41",
      "iata": "",
      "icao": "",
      "faa": "N41",
      "name": "Waterbury",
      "city": "Waterbury",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.634306,
      "longitude": -73.16775,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N41?codeType=fs"
     },
     {
      "fs": "N42",
      "iata": "",
      "icao": "",
      "faa": "N42",
      "name": "Shippensburg",
      "city": "Shippensburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.134222,
      "longitude": -77.572083,
      "elevationFeet": 760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N42?codeType=fs"
     },
     {
      "fs": "N43",
      "iata": "",
      "icao": "",
      "faa": "N43",
      "name": "Easton",
      "city": "Easton",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.81375,
      "longitude": -75.329556,
      "elevationFeet": 399,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N43?codeType=fs"
     },
     {
      "fs": "N44",
      "iata": "",
      "icao": "",
      "faa": "N44",
      "name": "Bear Creek",
      "city": "Mt Pleasant",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.470861,
      "longitude": -80.425611,
      "elevationFeet": 795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N44?codeType=fs"
     },
     {
      "fs": "N46",
      "iata": "",
      "icao": "",
      "faa": "N46",
      "name": "Us Heliport",
      "city": "Wingate",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.99339,
      "longitude": -80.4414,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N46?codeType=fs"
     },
     {
      "fs": "N47",
      "iata": "",
      "icao": "",
      "faa": "N47",
      "name": "Pottstown Municipal",
      "city": "Pottstown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.354,
      "longitude": -75.708528,
      "elevationFeet": 256,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N47?codeType=fs"
     },
     {
      "fs": "N49",
      "iata": "",
      "icao": "",
      "faa": "N49",
      "name": "Chim Commercial",
      "city": "Minersville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.75,
      "longitude": -76.263889,
      "elevationFeet": 930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N49?codeType=fs"
     },
     {
      "fs": "N50",
      "iata": "",
      "icao": "",
      "faa": "N50",
      "name": "Li Calzi",
      "city": "Bridgeton",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.484472,
      "longitude": -75.271333,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N50?codeType=fs"
     },
     {
      "fs": "N51",
      "iata": "",
      "icao": "",
      "faa": "N51",
      "name": "Solberg-Hunterdon",
      "city": "Readington",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.728639,
      "longitude": -74.765611,
      "elevationFeet": 195,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N51?codeType=fs"
     },
     {
      "fs": "N52",
      "iata": "",
      "icao": "",
      "faa": "N52",
      "name": "Jaars-Townsend",
      "city": "Waxhaw",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 34.988167,
      "longitude": -80.879833,
      "elevationFeet": 602,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N52?codeType=fs"
     },
     {
      "fs": "N56",
      "iata": "",
      "icao": "",
      "faa": "N56",
      "name": "Great Valley",
      "city": "Great Valley",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.250639,
      "longitude": -78.7725,
      "elevationFeet": 1450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N56?codeType=fs"
     },
     {
      "fs": "N57",
      "iata": "",
      "icao": "",
      "faa": "N57",
      "name": "New Garden",
      "city": "Toughkenamon",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.95525,
      "longitude": -75.797444,
      "elevationFeet": 436,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N57?codeType=fs"
     },
     {
      "fs": "N58",
      "iata": "",
      "icao": "",
      "faa": "N58",
      "name": "Tiger",
      "city": "Fernley",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 39.636111,
      "longitude": -119.3,
      "elevationFeet": 4346,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N58?codeType=fs"
     },
     {
      "fs": "N59",
      "iata": "",
      "icao": "",
      "faa": "N59",
      "name": "Rosaschi",
      "city": "Smith",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 38.893583,
      "longitude": -119.382139,
      "elevationFeet": 4809,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N59?codeType=fs"
     },
     {
      "fs": "N61",
      "iata": "",
      "icao": "",
      "faa": "N61",
      "name": "Hinshaw",
      "city": "Liberty",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.937472,
      "longitude": -79.625222,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N61?codeType=fs"
     },
     {
      "fs": "N62",
      "iata": "",
      "icao": "",
      "faa": "N62",
      "name": "New Hanover",
      "city": "New Hanover",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.300972,
      "longitude": -75.649056,
      "elevationFeet": 280,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N62?codeType=fs"
     },
     {
      "fs": "N63",
      "iata": "",
      "icao": "",
      "faa": "N63",
      "name": "Meadow Brook",
      "city": "Walnut Cove",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.31525,
      "longitude": -80.283806,
      "elevationFeet": 631,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N63?codeType=fs"
     },
     {
      "fs": "N65",
      "iata": "",
      "icao": "",
      "faa": "N65",
      "name": "Knox Airport",
      "city": "Quaker Street",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.729508,
      "longitude": -74.164411,
      "elevationFeet": 1105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N65?codeType=fs"
     },
     {
      "fs": "N67",
      "iata": "",
      "icao": "",
      "faa": "N67",
      "name": "Wings",
      "city": "Philadelphia",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.164694,
      "longitude": -75.270389,
      "elevationFeet": 302,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N67?codeType=fs"
     },
     {
      "fs": "N68",
      "iata": "",
      "icao": "",
      "faa": "N68",
      "name": "Chambersburg Municipal",
      "city": "Chambersburg",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.029528,
      "longitude": -77.732667,
      "elevationFeet": 697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N68?codeType=fs"
     },
     {
      "fs": "N69",
      "iata": "",
      "icao": "",
      "faa": "N69",
      "name": "Stormville",
      "city": "Stormville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.669833,
      "longitude": -73.873528,
      "elevationFeet": 358,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N69?codeType=fs"
     },
     {
      "fs": "N70",
      "iata": "",
      "icao": "",
      "faa": "CKZ",
      "name": "Pennridge Airport",
      "city": "Perkasie",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.39069,
      "longitude": -75.290331,
      "elevationFeet": 517,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N70?codeType=fs"
     },
     {
      "fs": "N71",
      "iata": "",
      "icao": "",
      "faa": "N71",
      "name": "Donegal Springs",
      "city": "Mt Joy/Marietta",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.172056,
      "longitude": -76.643556,
      "elevationFeet": 458,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N71?codeType=fs"
     },
     {
      "fs": "N72",
      "iata": "",
      "icao": "",
      "faa": "N72",
      "name": "Warwick Municipal",
      "city": "Warwick",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.325944,
      "longitude": -74.320944,
      "elevationFeet": 540,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N72?codeType=fs"
     },
     {
      "fs": "N73",
      "iata": "",
      "icao": "",
      "faa": "N73",
      "name": "Red Lion",
      "city": "Vincentown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.941528,
      "longitude": -74.8955,
      "elevationFeet": 54,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N73?codeType=fs"
     },
     {
      "fs": "N74",
      "iata": "",
      "icao": "",
      "faa": "N74",
      "name": "Penns Cave",
      "city": "Centre Hall",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.953417,
      "longitude": -77.624972,
      "elevationFeet": 1260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N74?codeType=fs"
     },
     {
      "fs": "N75",
      "iata": "",
      "icao": "",
      "faa": "N75",
      "name": "Twin Pine",
      "city": "Pennington",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.384417,
      "longitude": -74.829389,
      "elevationFeet": 230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N75?codeType=fs"
     },
     {
      "fs": "N76",
      "iata": "",
      "icao": "",
      "faa": "N76",
      "name": "Millard",
      "city": "Annville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.321944,
      "longitude": -76.563889,
      "elevationFeet": 485,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N76?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N76?codeType=fs"
     },
     {
      "fs": "N79",
      "iata": "",
      "icao": "",
      "faa": "N79",
      "name": "Northumberland Co",
      "city": "Shamokin",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.869194,
      "longitude": -76.574556,
      "elevationFeet": 881,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N79?codeType=fs"
     },
     {
      "fs": "N81",
      "iata": "",
      "icao": "",
      "faa": "N81",
      "name": "Hammonton Municipal",
      "city": "Hammonton",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 39.674694,
      "longitude": -74.827333,
      "elevationFeet": 69,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N81?codeType=fs"
     },
     {
      "fs": "N82",
      "iata": "",
      "icao": "",
      "faa": "N82",
      "name": "Wurtsboro-Sullivan Co",
      "city": "Wurtsboro",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.722056,
      "longitude": -74.534083,
      "elevationFeet": 560,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N82?codeType=fs"
     },
     {
      "fs": "N83",
      "iata": "",
      "icao": "",
      "faa": "N83",
      "name": "Ds Butler Farm And Airfield",
      "city": "Oak Ridge",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.301361,
      "longitude": -80.053167,
      "elevationFeet": 950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N83?codeType=fs"
     },
     {
      "fs": "N85",
      "iata": "",
      "icao": "",
      "faa": "N85",
      "name": "Alexandria",
      "city": "Pittstown",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.62575,
      "longitude": -75.044194,
      "elevationFeet": 480,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N85?codeType=fs"
     },
     {
      "fs": "N86",
      "iata": "",
      "icao": "",
      "faa": "N86",
      "name": "Spanish Springs",
      "city": "Reno",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 39.815778,
      "longitude": -119.782444,
      "elevationFeet": 4600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N86?codeType=fs"
     },
     {
      "fs": "N87",
      "iata": "",
      "icao": "",
      "faa": "N87",
      "name": "Trenton-Robbinsville",
      "city": "Robbinsville",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.213902,
      "longitude": -74.601799,
      "elevationFeet": 118,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N87?codeType=fs"
     },
     {
      "fs": "N88",
      "iata": "",
      "icao": "",
      "faa": "N88",
      "name": "Keck'S",
      "city": "Julian",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.01525,
      "longitude": -79.72525,
      "elevationFeet": 724,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N88?codeType=fs"
     },
     {
      "fs": "N89",
      "iata": "",
      "icao": "",
      "faa": "N89",
      "name": "Resnick",
      "city": "Ellenville",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.838861,
      "longitude": -74.46825,
      "elevationFeet": 290,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N89?codeType=fs"
     },
     {
      "fs": "N92",
      "iata": "",
      "icao": "",
      "faa": "N92",
      "name": "Laneys",
      "city": "Maiden",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.643,
      "longitude": -81.123,
      "elevationFeet": 1025,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N92?codeType=fs"
     },
     {
      "fs": "N94",
      "iata": "",
      "icao": "",
      "faa": "N94",
      "name": "Carlisle",
      "city": "Carlisle",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.229139,
      "longitude": -77.24275,
      "elevationFeet": 510,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N94?codeType=fs"
     },
     {
      "fs": "N96",
      "iata": "",
      "icao": "",
      "faa": "N96",
      "name": "Bellefonte",
      "city": "Bellefonte",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.904722,
      "longitude": -77.963056,
      "elevationFeet": 1071,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N96?codeType=fs"
     },
     {
      "fs": "N97",
      "iata": "",
      "icao": "",
      "faa": "N97",
      "name": "Hiatt",
      "city": "Thomasville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 35.951361,
      "longitude": -80.175444,
      "elevationFeet": 855,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N97?codeType=fs"
     },
     {
      "fs": "N98",
      "iata": "",
      "icao": "",
      "faa": "N98",
      "name": "Boyne City Municipal",
      "city": "Boyne City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 45.283417,
      "longitude": -85.053306,
      "elevationFeet": 657,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N98?codeType=fs"
     },
     {
      "fs": "N99",
      "iata": "",
      "icao": "",
      "faa": "N99",
      "name": "Brandywine",
      "city": "West Chester",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.097222,
      "longitude": -75.583333,
      "elevationFeet": 466,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/N99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/N99?codeType=fs"
     },
     {
      "fs": "NAB",
      "iata": "NAB",
      "icao": "",
      "faa": "",
      "name": "Albany Naval Air Station",
      "city": "Albany",
      "cityCode": "ABY",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 31.583333,
      "longitude": -84.166667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NAB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NAB?codeType=fs"
     },
     {
      "fs": "NAX",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Barbers Point Naval Station",
      "city": "Barbers Point",
      "cityCode": "NAX",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.686",
      "utcOffsetHours": -10,
      "latitude": 21.3,
      "longitude": -158.116667,
      "elevationFeet": 30,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NAX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NAX?codeType=fs"
     },
     {
      "fs": "NBG",
      "iata": "NBG",
      "icao": "KNBG",
      "faa": "NBG",
      "name": "Naval Air Station/Alvin Callendar",
      "city": "New Orleans",
      "cityCode": "MSY",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 29.830831,
      "longitude": -90.02336,
      "elevationFeet": 1,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NBG?codeType=fs"
     },
     {
      "fs": "NBP",
      "iata": "NBP",
      "icao": "",
      "faa": "",
      "name": "Battery Park City/North Cove Sea Plane Base",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.712793,
      "longitude": -74.017529,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NBP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NBP?codeType=fs"
     },
     {
      "fs": "NBU",
      "iata": "NBU",
      "icao": "",
      "faa": "",
      "name": "Glenview Naval Air Station",
      "city": "Glenview",
      "cityCode": "NBU",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.0889,
      "longitude": -87.82447,
      "elevationFeet": 646,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NBU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NBU?codeType=fs"
     },
     {
      "fs": "NCQ",
      "iata": "NCQ",
      "icao": "",
      "faa": "",
      "name": "General Lucius D. Clay National Guard Center",
      "city": "Marietta",
      "cityCode": "MGE",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 33.918152,
      "longitude": -84.520862,
      "elevationFeet": 1010,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NCQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NCQ?codeType=fs"
     },
     {
      "fs": "NDP",
      "iata": "NDP",
      "icao": "",
      "faa": "",
      "name": "Ellyson Naval Air Station",
      "city": "Pensacola",
      "cityCode": "PNS",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.5277,
      "longitude": -87.19753,
      "elevationFeet": 110,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NDP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NDP?codeType=fs"
     },
     {
      "fs": "NDV",
      "iata": "NDV",
      "icao": "",
      "faa": "",
      "name": "United States Naval Heliport",
      "city": "Anacostia",
      "cityCode": "NDV",
      "stateCode": "DC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.855714,
      "longitude": -77.010493,
      "elevationFeet": 3,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NDV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NDV?codeType=fs"
     },
     {
      "fs": "NEA",
      "iata": "NEA",
      "icao": "",
      "faa": "",
      "name": "Naval Air Station",
      "city": "Glynco",
      "cityCode": "NEA",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 31.25,
      "longitude": -81.466667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NEA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NEA?codeType=fs"
     },
     {
      "fs": "NEL",
      "iata": "NEL",
      "icao": "KNEL",
      "faa": "NEL",
      "name": "Naec Airport",
      "city": "Lakehurst",
      "cityCode": "NEL",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.016667,
      "longitude": -74.316667,
      "elevationFeet": 103,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NEL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NEL?codeType=fs"
     },
     {
      "fs": "NEN",
      "iata": "NEN",
      "icao": "",
      "faa": "",
      "name": "Olf Usn Airport",
      "city": "Whitehouse",
      "cityCode": "NEN",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 30.316667,
      "longitude": -81.85,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NEN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NEN?codeType=fs"
     },
     {
      "fs": "NES",
      "iata": "NES",
      "icao": "",
      "faa": "",
      "name": "East 34th Street - Sea Plane Base",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.743333,
      "longitude": -73.975,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NES?codeType=fs"
     },
     {
      "fs": "NFB",
      "iata": "NFB",
      "icao": "",
      "faa": "",
      "name": "Detroit Naval Air Field",
      "city": "Mount Clemens",
      "cityCode": "MTC",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.966667,
      "longitude": -82.966667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NFB?codeType=fs"
     },
     {
      "fs": "NFL",
      "iata": "NFL",
      "icao": "KNFL",
      "faa": "NFL",
      "name": "Naval Air Station",
      "city": "Fallon",
      "cityCode": "NFL",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 39.416599,
      "longitude": -118.700996,
      "elevationFeet": 3934,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NFL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NFL?codeType=fs"
     },
     {
      "fs": "NGC",
      "iata": "NGC",
      "icao": "",
      "faa": "",
      "name": "North Rim Airport",
      "city": "Grand Canyon",
      "cityCode": "GCN",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 36.389722,
      "longitude": -112.129167,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NGC?codeType=fs"
     },
     {
      "fs": "NGP",
      "iata": "NGP",
      "icao": "KNGP",
      "faa": "NGP",
      "name": "Corpus Christi Naval Air Station (Truax Field)",
      "city": "Corpus Christi",
      "cityCode": "CRP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 27.7,
      "longitude": -97.283333,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NGP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NGP?codeType=fs"
     },
     {
      "fs": "NGW",
      "iata": "NGW",
      "icao": "",
      "faa": "",
      "name": "Cabaniss Field",
      "city": "Corpus Christi",
      "cityCode": "CRP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 27.783333,
      "longitude": -97.4,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NGW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NGW?codeType=fs"
     },
     {
      "fs": "NGZ",
      "iata": "NGZ",
      "icao": "",
      "faa": "",
      "name": "Alameda Naval Air Station",
      "city": "Alameda",
      "cityCode": "NGZ",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 37.782127,
      "longitude": -122.30862,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NGZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NGZ?codeType=fs"
     },
     {
      "fs": "NHK",
      "iata": "NHK",
      "icao": "KNHK",
      "faa": "NHK",
      "name": "Naval Air Station",
      "city": "Patuxent River",
      "cityCode": "NHK",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.3,
      "longitude": -76.433333,
      "elevationFeet": 40,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NHK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NHK?codeType=fs"
     },
     {
      "fs": "NHX",
      "iata": "NHX",
      "icao": "",
      "faa": "",
      "name": "Barin Olf Osn Airport",
      "city": "Foley",
      "cityCode": "NHX",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.4,
      "longitude": -87.683333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NHX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NHX?codeType=fs"
     },
     {
      "fs": "NIE",
      "iata": "NIE",
      "icao": "",
      "faa": "",
      "name": "Niblack Airport",
      "city": "Niblack",
      "cityCode": "NIE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 55.066667,
      "longitude": -132.15,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NIE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NIE?codeType=fs"
     },
     {
      "fs": "NIN",
      "iata": "NIN",
      "icao": "",
      "faa": "NIN",
      "name": "Ninilchik Airport",
      "city": "Ninilchik",
      "cityCode": "NIN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 60.066667,
      "longitude": -151.733333,
      "elevationFeet": 276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NIN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NIN?codeType=fs"
     },
     {
      "fs": "NIR",
      "iata": "NIR",
      "icao": "",
      "faa": "",
      "name": "Chase Field Naval Air Station",
      "city": "Beeville",
      "cityCode": "NIR",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 28.4,
      "longitude": -97.75,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NIR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NIR?codeType=fs"
     },
     {
      "fs": "NJK",
      "iata": "NJK",
      "icao": "KNJK",
      "faa": "NJK",
      "name": "Navy Air Facility El Centro",
      "city": "El Centro",
      "cityCode": "NJK",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 32.822125,
      "longitude": -115.661315,
      "elevationFeet": -43,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NJK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NJK?codeType=fs"
     },
     {
      "fs": "NKV",
      "iata": "NKV",
      "icao": "",
      "faa": "",
      "name": "Nichen Cove Airport",
      "city": "Nichen Cove",
      "cityCode": "NKV",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 55.85,
      "longitude": -133.216667,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NKV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NKV?codeType=fs"
     },
     {
      "fs": "NLC",
      "iata": "NLC",
      "icao": "KNLC",
      "faa": "NLC",
      "name": "Naval Air Station/Reeves Field",
      "city": "Lemoore",
      "cityCode": "NLC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 36.3,
      "longitude": -119.766667,
      "elevationFeet": 234,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NLC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NLC?codeType=fs"
     },
     {
      "fs": "NLE",
      "iata": "NLE",
      "icao": "",
      "faa": "3TR",
      "name": "Jerry Tyler Memorial Airport",
      "city": "Niles",
      "cityCode": "NLE",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 41.841667,
      "longitude": -86.225,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NLE?codeType=fs"
     },
     {
      "fs": "NNK",
      "iata": "NNK",
      "icao": "",
      "faa": "5NK",
      "name": "Naknek Airport",
      "city": "Naknek",
      "cityCode": "NNK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 58.733333,
      "longitude": -157.016944,
      "elevationFeet": 70,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NNK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NNK?codeType=fs"
     },
     {
      "fs": "NOH",
      "iata": "NOH",
      "icao": "",
      "faa": "",
      "name": "Naval Air Station Great Lakes",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 42.311512,
      "longitude": -87.849268,
      "elevationFeet": 656,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NOH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NOH?codeType=fs"
     },
     {
      "fs": "NOL",
      "iata": "NOL",
      "icao": "",
      "faa": "",
      "name": "Nakolik River Airport",
      "city": "Nakolik River",
      "cityCode": "NOL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.686",
      "utcOffsetHours": -9,
      "latitude": 67.9,
      "longitude": -160.716667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NOL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NOL?codeType=fs"
     },
     {
      "fs": "NPH",
      "iata": "NPH",
      "icao": "",
      "faa": "U14",
      "name": "Nephi Airport",
      "city": "Nephi",
      "cityCode": "NPH",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 39.738889,
      "longitude": -111.870833,
      "elevationFeet": 5009,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NPH?codeType=fs"
     },
     {
      "fs": "NQA",
      "iata": "NQA",
      "icao": "KNQA",
      "faa": "NQA",
      "name": "Naval Air Station",
      "city": "Memphis",
      "cityCode": "MEM",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.133333,
      "longitude": -90.05,
      "elevationFeet": 320,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NQA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NQA?codeType=fs"
     },
     {
      "fs": "NQI",
      "iata": "NQI",
      "icao": "KNQI",
      "faa": "NQI",
      "name": "Naval Air Station",
      "city": "Kingsville",
      "cityCode": "NQI",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 27.516667,
      "longitude": -97.866667,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NQI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NQI?codeType=fs"
     },
     {
      "fs": "NRB",
      "iata": "NRB",
      "icao": "KNRB",
      "faa": "NRB",
      "name": "Mayport Naval Station",
      "city": "Mayport",
      "cityCode": "NRB",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 30.39151,
      "longitude": -81.418771,
      "elevationFeet": 9,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NRB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NRB?codeType=fs"
     },
     {
      "fs": "NRC",
      "iata": "NRC",
      "icao": "",
      "faa": "",
      "name": "NASA Crows Landing Airport",
      "city": "Crows Landing",
      "cityCode": "NRC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 37.410968,
      "longitude": -121.10196,
      "elevationFeet": 133,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NRC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NRC?codeType=fs"
     },
     {
      "fs": "NRI",
      "iata": "NRI",
      "icao": "",
      "faa": "",
      "name": "Shangri-la Airport",
      "city": "Shangri-la",
      "cityCode": "NRI",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 35.166667,
      "longitude": -99.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NRI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NRI?codeType=fs"
     },
     {
      "fs": "NRS",
      "iata": "NRS",
      "icao": "KNRS",
      "faa": "NRS",
      "name": "NOLF Imperial Beach",
      "city": "Imperial Beach",
      "cityCode": "NRS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 32.564201,
      "longitude": -117.113811,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NRS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NRS?codeType=fs"
     },
     {
      "fs": "NSE",
      "iata": "NSE",
      "icao": "KNDZ",
      "faa": "NDZ",
      "name": "Whiting Field Naval Air Station",
      "city": "Milton",
      "cityCode": "NSE",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 30.633333,
      "longitude": -87.05,
      "elevationFeet": 178,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NSE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NSE?codeType=fs"
     },
     {
      "fs": "NSF",
      "iata": "NSF",
      "icao": "",
      "faa": "",
      "name": "Andrews Navy Air Field",
      "city": "Camp Springs",
      "cityCode": "ADW",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.816667,
      "longitude": -76.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NSF?codeType=fs"
     },
     {
      "fs": "NSL",
      "iata": "NSL",
      "icao": "",
      "faa": "",
      "name": "Slayton Municipal Airport",
      "city": "Slayton",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 43.988795,
      "longitude": -95.78259,
      "elevationFeet": 1623,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NSL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NSL?codeType=fs"
     },
     {
      "fs": "NTJ",
      "iata": "NTJ",
      "icao": "",
      "faa": "41U",
      "name": "Manti-Ephraim Airport",
      "city": "Manti",
      "cityCode": "NTJ",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.686",
      "utcOffsetHours": -7,
      "latitude": 39.266667,
      "longitude": -111.633333,
      "elevationFeet": 5500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NTJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NTJ?codeType=fs"
     },
     {
      "fs": "NTU",
      "iata": "NTU",
      "icao": "KNTU",
      "faa": "NTU",
      "name": "Naval Air Station",
      "city": "Oceana",
      "cityCode": "NTU",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 36.816667,
      "longitude": -76.033333,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NTU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NTU?codeType=fs"
     },
     {
      "fs": "NUN",
      "iata": "NUN",
      "icao": "KNUN",
      "faa": "NUN",
      "name": "Saufley Naval Air Station",
      "city": "Pensacola",
      "cityCode": "PNS",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 30.468549,
      "longitude": -87.334118,
      "elevationFeet": 81,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NUN?codeType=fs"
     },
     {
      "fs": "NUW",
      "iata": "NUW",
      "icao": "KNUW",
      "faa": "NUW",
      "name": "Ault Field",
      "city": "Whidbey Island",
      "cityCode": "NUW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.686",
      "utcOffsetHours": -8,
      "latitude": 48.351944,
      "longitude": -122.655833,
      "elevationFeet": 47,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NUW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NUW?codeType=fs"
     },
     {
      "fs": "NVD",
      "iata": "NVD",
      "icao": "KNVD",
      "faa": "NVD",
      "name": "Nevada Airport",
      "city": "Nevada",
      "cityCode": "NVD",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.686",
      "utcOffsetHours": -6,
      "latitude": 37.851389,
      "longitude": -94.303889,
      "elevationFeet": 892,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NVD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NVD?codeType=fs"
     },
     {
      "fs": "NWH",
      "iata": "NWH",
      "icao": "",
      "faa": "2B3",
      "name": "Parlin Field",
      "city": "Newport",
      "cityCode": "NWH",
      "stateCode": "NH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 43.388357,
      "longitude": -72.186437,
      "elevationFeet": 777,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NWH?codeType=fs"
     },
     {
      "fs": "NWS",
      "iata": "NWS",
      "icao": "",
      "faa": "",
      "name": "Pier 11-Wall St Sea Plane Base",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.703321,
      "longitude": -74.005318,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NWS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NWS?codeType=fs"
     },
     {
      "fs": "NXX",
      "iata": "NXX",
      "icao": "KNXX",
      "faa": "NXX",
      "name": "Willow Grove Naval Air Station",
      "city": "Willow Grove",
      "cityCode": "NXX",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.2,
      "longitude": -75.133333,
      "elevationFeet": 362,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NXX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NXX?codeType=fs"
     },
     {
      "fs": "NY0",
      "iata": "",
      "icao": "",
      "faa": "NY0",
      "name": "Fulton Co",
      "city": "Johnstown",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 43.132111,
      "longitude": -74.4455,
      "elevationFeet": 881,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NY0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NY0?codeType=fs"
     },
     {
      "fs": "NY1",
      "iata": "",
      "icao": "",
      "faa": "NY1",
      "name": "Kline Kill",
      "city": "Ghent",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.350861,
      "longitude": -73.670639,
      "elevationFeet": 380,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NY1?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NY1?codeType=fs"
     },
     {
      "fs": "NY2",
      "iata": "",
      "icao": "",
      "faa": "NY2",
      "name": "Camillus",
      "city": "Camillus",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 43.084,
      "longitude": -76.429833,
      "elevationFeet": 405,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NY2?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NY2?codeType=fs"
     },
     {
      "fs": "NY28",
      "iata": "",
      "icao": "NY28",
      "faa": "NY28",
      "name": "Anthonson",
      "city": "Jordan",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 43.109,
      "longitude": -76.479889,
      "elevationFeet": 430,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NY28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NY28?codeType=fs"
     },
     {
      "fs": "NYG",
      "iata": "NYG",
      "icao": "KNYG",
      "faa": "NYG",
      "name": "Quantico Naval Air Station",
      "city": "Quantico",
      "cityCode": "NYG",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 38.516667,
      "longitude": -77.283333,
      "elevationFeet": 11,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NYG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NYG?codeType=fs"
     },
     {
      "fs": "NYS",
      "iata": "NYS",
      "icao": "",
      "faa": "",
      "name": "New York Skyports Seaplane Base",
      "city": "New York",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 40.733889,
      "longitude": -73.972778,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NYS?codeType=fs"
     },
     {
      "fs": "NZW",
      "iata": "NZW",
      "icao": "",
      "faa": "",
      "name": "South Weymouth Airport",
      "city": "South Weymouth",
      "cityCode": "NZW",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.686",
      "utcOffsetHours": -5,
      "latitude": 42.166667,
      "longitude": -70.933333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/NZW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/NZW?codeType=fs"
     },
     {
      "fs": "O00",
      "iata": "",
      "icao": "",
      "faa": "O00",
      "name": "Lufker",
      "city": "East Moriches",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.898222,
      "longitude": -72.759333,
      "elevationFeet": 57,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O00?codeType=fs"
     },
     {
      "fs": "O02",
      "iata": "",
      "icao": "",
      "faa": "O02",
      "name": "Nervino",
      "city": "Beckwourth",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.857361,
      "longitude": -120.393778,
      "elevationFeet": 4894,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O02?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O02?codeType=fs"
     },
     {
      "fs": "O03",
      "iata": "",
      "icao": "",
      "faa": "O03",
      "name": "Morgantown",
      "city": "Morgantown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.220417,
      "longitude": -75.904889,
      "elevationFeet": 600,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O03?codeType=fs"
     },
     {
      "fs": "O05",
      "iata": "",
      "icao": "",
      "faa": "O05",
      "name": "Rogers",
      "city": "Chester",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.423528,
      "longitude": -121.311694,
      "elevationFeet": 4528,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O05?codeType=fs"
     },
     {
      "fs": "O07",
      "iata": "",
      "icao": "",
      "faa": "O07",
      "name": "Westheimer",
      "city": "Houston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.796778,
      "longitude": -95.896722,
      "elevationFeet": 117,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O07?codeType=fs"
     },
     {
      "fs": "O08",
      "iata": "",
      "icao": "",
      "faa": "O08",
      "name": "Colusa Co",
      "city": "Colusa",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.179001,
      "longitude": -121.992996,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O08?codeType=fs"
     },
     {
      "fs": "O09",
      "iata": "",
      "icao": "",
      "faa": "O09",
      "name": "Round Valley",
      "city": "Covelo",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.851556,
      "longitude": -123.414028,
      "elevationFeet": 1434,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O09?codeType=fs"
     },
     {
      "fs": "O10",
      "iata": "",
      "icao": "",
      "faa": "O10",
      "name": "Alta",
      "city": "Dinuba",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.602278,
      "longitude": -119.462278,
      "elevationFeet": 364,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O10?codeType=fs"
     },
     {
      "fs": "O11",
      "iata": "",
      "icao": "",
      "faa": "O11",
      "name": "Stilwell/Cherokee Nation",
      "city": "Stilwell",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.820306,
      "longitude": -94.799444,
      "elevationFeet": 1084,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O11?codeType=fs"
     },
     {
      "fs": "O13",
      "iata": "",
      "icao": "",
      "faa": "O13",
      "name": "Haddock",
      "city": "Erick",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.200528,
      "longitude": -99.887139,
      "elevationFeet": 2097,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O13?codeType=fs"
     },
     {
      "fs": "O15",
      "iata": "",
      "icao": "",
      "faa": "O15",
      "name": "Turlock Municipal",
      "city": "Turlock",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.524361,
      "longitude": -120.818667,
      "elevationFeet": 159,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O15?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O15?codeType=fs"
     },
     {
      "fs": "O16",
      "iata": "",
      "icao": "",
      "faa": "O16",
      "name": "Garberville",
      "city": "Garberville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.109778,
      "longitude": -123.936389,
      "elevationFeet": 546,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O16?codeType=fs"
     },
     {
      "fs": "O17",
      "iata": "",
      "icao": "",
      "faa": "O17",
      "name": "Nevada Co",
      "city": "Grass Valley",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.289722,
      "longitude": -121.030722,
      "elevationFeet": 3152,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O17?codeType=fs"
     },
     {
      "fs": "O18",
      "iata": "",
      "icao": "",
      "faa": "O18",
      "name": "Buzzards Roost",
      "city": "Inola",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.239861,
      "longitude": -95.4275,
      "elevationFeet": 661,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O18?codeType=fs"
     },
     {
      "fs": "O19",
      "iata": "",
      "icao": "",
      "faa": "O19",
      "name": "Kneeland",
      "city": "Eureka",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.743,
      "longitude": -124.025528,
      "elevationFeet": 2737,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O19?codeType=fs"
     },
     {
      "fs": "O20",
      "iata": "",
      "icao": "",
      "faa": "O20",
      "name": "Kingdon",
      "city": "Lodi",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.091599,
      "longitude": -121.359001,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O20?codeType=fs"
     },
     {
      "fs": "O21",
      "iata": "",
      "icao": "",
      "faa": "O21",
      "name": "Hoopa",
      "city": "Hoopa",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.129083,
      "longitude": -123.683889,
      "elevationFeet": 356,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O21?codeType=fs"
     },
     {
      "fs": "O23",
      "iata": "",
      "icao": "",
      "faa": "O23",
      "name": "Ranchaero",
      "city": "Chico",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.757167,
      "longitude": -121.877556,
      "elevationFeet": 173,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O23?codeType=fs"
     },
     {
      "fs": "O24",
      "iata": "",
      "icao": "",
      "faa": "O24",
      "name": "Lee Vining",
      "city": "Lee Vining",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.032583,
      "longitude": -119.165361,
      "elevationFeet": 6802,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O24?codeType=fs"
     },
     {
      "fs": "O26",
      "iata": "",
      "icao": "",
      "faa": "O26",
      "name": "Lone Pine",
      "city": "Lone Pine",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.632667,
      "longitude": -118.070306,
      "elevationFeet": 3680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O26?codeType=fs"
     },
     {
      "fs": "O27",
      "iata": "",
      "icao": "",
      "faa": "O27",
      "name": "Oakdale",
      "city": "Oakdale",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.813444,
      "longitude": -120.802083,
      "elevationFeet": 234,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O27?codeType=fs"
     },
     {
      "fs": "O28",
      "iata": "",
      "icao": "",
      "faa": "O28",
      "name": "Ells-Willits Municipal",
      "city": "Willits",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.462972,
      "longitude": -123.422833,
      "elevationFeet": 2063,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O28?codeType=fs"
     },
     {
      "fs": "O31",
      "iata": "",
      "icao": "",
      "faa": "O31",
      "name": "Healdsburg Municipal",
      "city": "Healdsburg",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.685222,
      "longitude": -123.044389,
      "elevationFeet": 278,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O31?codeType=fs"
     },
     {
      "fs": "O32",
      "iata": "",
      "icao": "",
      "faa": "O32",
      "name": "Reedley Municipal",
      "city": "Reedley",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.813389,
      "longitude": -119.456806,
      "elevationFeet": 383,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O32?codeType=fs"
     },
     {
      "fs": "O33",
      "iata": "",
      "icao": "",
      "faa": "O33",
      "name": "Eureka Municipal",
      "city": "Eureka",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.909583,
      "longitude": -124.322833,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O33?codeType=fs"
     },
     {
      "fs": "O35",
      "iata": "",
      "icao": "",
      "faa": "O35",
      "name": "Hollis Municipal",
      "city": "Hollis",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.783944,
      "longitude": -99.987111,
      "elevationFeet": 1658,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O35?codeType=fs"
     },
     {
      "fs": "O36",
      "iata": "",
      "icao": "",
      "faa": "O36",
      "name": "Ashley",
      "city": "Morris",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.651028,
      "longitude": -95.924917,
      "elevationFeet": 731,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O36?codeType=fs"
     },
     {
      "fs": "O37",
      "iata": "",
      "icao": "",
      "faa": "O37",
      "name": "Haigh",
      "city": "Orland",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.762417,
      "longitude": -122.2665,
      "elevationFeet": 215,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O37?codeType=fs"
     },
     {
      "fs": "O38",
      "iata": "",
      "icao": "",
      "faa": "O38",
      "name": "Gundys",
      "city": "Owasso",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.267639,
      "longitude": -95.785972,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O38?codeType=fs"
     },
     {
      "fs": "O39",
      "iata": "",
      "icao": "",
      "faa": "O39",
      "name": "Ravendale",
      "city": "Ravendale",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.832306,
      "longitude": -120.513889,
      "elevationFeet": 5299,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O39?codeType=fs"
     },
     {
      "fs": "O41",
      "iata": "",
      "icao": "",
      "faa": "O41",
      "name": "Watts Woodland Airport",
      "city": "Woodland",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.673404,
      "longitude": -121.870539,
      "elevationFeet": 115,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O41?codeType=fs"
     },
     {
      "fs": "O42",
      "iata": "",
      "icao": "",
      "faa": "O42",
      "name": "Woodlake",
      "city": "Woodlake",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.538389,
      "longitude": -119.173278,
      "elevationFeet": 425,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O42?codeType=fs"
     },
     {
      "fs": "O44",
      "iata": "",
      "icao": "",
      "faa": "O44",
      "name": "Mc Caslin",
      "city": "Lexington",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.687",
      "utcOffsetHours": -10,
      "latitude": 35.172917,
      "longitude": -97.364167,
      "elevationFeet": 1135,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O44?codeType=fs"
     },
     {
      "fs": "O45",
      "iata": "",
      "icao": "",
      "faa": "O45",
      "name": "Hooker Municipal",
      "city": "Hooker",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.920833,
      "longitude": -101.320917,
      "elevationFeet": 2998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O45?codeType=fs"
     },
     {
      "fs": "O46",
      "iata": "",
      "icao": "",
      "faa": "O46",
      "name": "Weed",
      "city": "Weed",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.548694,
      "longitude": -122.48075,
      "elevationFeet": 2938,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O46?codeType=fs"
     },
     {
      "fs": "O47",
      "iata": "",
      "icao": "",
      "faa": "O47",
      "name": "Prague Municipal",
      "city": "Prague",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.620139,
      "longitude": -96.736306,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O47?codeType=fs"
     },
     {
      "fs": "O48",
      "iata": "",
      "icao": "",
      "faa": "O48",
      "name": "Little River",
      "city": "Little River",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.370389,
      "longitude": -123.787361,
      "elevationFeet": 572,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O48?codeType=fs"
     },
     {
      "fs": "O51",
      "iata": "",
      "icao": "",
      "faa": "O51",
      "name": "Laverne Municipal",
      "city": "Laverne",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.844778,
      "longitude": -99.987389,
      "elevationFeet": 2112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O51?codeType=fs"
     },
     {
      "fs": "O52",
      "iata": "",
      "icao": "",
      "faa": "O52",
      "name": "Sutter Co",
      "city": "Yuba City",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.215583,
      "longitude": -121.691333,
      "elevationFeet": 58,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O52?codeType=fs"
     },
     {
      "fs": "O53",
      "iata": "",
      "icao": "",
      "faa": "O53",
      "name": "Medford Municipal",
      "city": "Medford",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.855833,
      "longitude": -97.889972,
      "elevationFeet": 1092,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O53?codeType=fs"
     },
     {
      "fs": "O54",
      "iata": "",
      "icao": "",
      "faa": "O54",
      "name": "Pool/Weaverville",
      "city": "Weaverville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.857,
      "longitude": -122.969694,
      "elevationFeet": 2350,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O54?codeType=fs"
     },
     {
      "fs": "O55",
      "iata": "",
      "icao": "",
      "faa": "O55",
      "name": "Southard",
      "city": "Bieber",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.196111,
      "longitude": -121.188611,
      "elevationFeet": 4158,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O55?codeType=fs"
     },
     {
      "fs": "O57",
      "iata": "",
      "icao": "",
      "faa": "O57",
      "name": "Bryant",
      "city": "Bridgeport",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.374194,
      "longitude": -119.307083,
      "elevationFeet": 6468,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O57?codeType=fs"
     },
     {
      "fs": "O59",
      "iata": "",
      "icao": "",
      "faa": "O59",
      "name": "Cedarville",
      "city": "Cedarville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.576722,
      "longitude": -120.313333,
      "elevationFeet": 4623,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O59?codeType=fs"
     },
     {
      "fs": "O60",
      "iata": "",
      "icao": "",
      "faa": "O60",
      "name": "Cloverdale Municipal",
      "city": "Cloverdale",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.843611,
      "longitude": -123.072222,
      "elevationFeet": 272,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O60?codeType=fs"
     },
     {
      "fs": "O61",
      "iata": "",
      "icao": "",
      "faa": "O61",
      "name": "Cameron",
      "city": "Cameron Park",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.690694,
      "longitude": -121.021639,
      "elevationFeet": 1286,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O61?codeType=fs"
     },
     {
      "fs": "O62",
      "iata": "",
      "icao": "",
      "faa": "O62",
      "name": "Carmel Valley Vintage",
      "city": "Carmel Valley",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.619056,
      "longitude": -121.85225,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O62?codeType=fs"
     },
     {
      "fs": "O63",
      "iata": "",
      "icao": "",
      "faa": "O63",
      "name": "Exeter",
      "city": "Exeter",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.330056,
      "longitude": -119.295528,
      "elevationFeet": 340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O63?codeType=fs"
     },
     {
      "fs": "O65",
      "iata": "",
      "icao": "",
      "faa": "O65",
      "name": "Okeene Municipal",
      "city": "Okeene",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.225361,
      "longitude": -98.386833,
      "elevationFeet": 1205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O65?codeType=fs"
     },
     {
      "fs": "O66",
      "iata": "",
      "icao": "",
      "faa": "O66",
      "name": "Homestead Farms",
      "city": "Pond Creek",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.766972,
      "longitude": -97.817194,
      "elevationFeet": 1030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O66?codeType=fs"
     },
     {
      "fs": "O68",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Mariposa-Yosemite",
      "city": "Mariposa",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.607694,
      "longitude": -120.118444,
      "elevationFeet": 2250,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O68?codeType=fs"
     },
     {
      "fs": "O70",
      "iata": "",
      "icao": "",
      "faa": "O70",
      "name": "Westover-Amador Co",
      "city": "Jackson",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.468,
      "longitude": -120.889083,
      "elevationFeet": 1690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O70?codeType=fs"
     },
     {
      "fs": "O74",
      "iata": "",
      "icao": "",
      "faa": "O74",
      "name": "Elliotts Landing",
      "city": "Mt Victory",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.597222,
      "longitude": -83.616667,
      "elevationFeet": 1045,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O74?codeType=fs"
     },
     {
      "fs": "O79",
      "iata": "",
      "icao": "",
      "faa": "O79",
      "name": "Sierraville Dearwater",
      "city": "Sierraville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.710139,
      "longitude": -120.39375,
      "elevationFeet": 4984,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O79?codeType=fs"
     },
     {
      "fs": "O81",
      "iata": "",
      "icao": "",
      "faa": "O81",
      "name": "Tulelake Municipal",
      "city": "Tulelake",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.923806,
      "longitude": -121.444333,
      "elevationFeet": 4044,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O81?codeType=fs"
     },
     {
      "fs": "O85",
      "iata": "BZF",
      "icao": "",
      "faa": "O85",
      "name": "Benton Field",
      "city": "Redding",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.574169,
      "longitude": -122.407437,
      "elevationFeet": 717,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O85?codeType=fs"
     },
     {
      "fs": "O86",
      "iata": "",
      "icao": "",
      "faa": "O86",
      "name": "Trinity Center",
      "city": "Trinity Center",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.132,
      "longitude": -122.791889,
      "elevationFeet": 2390,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O86?codeType=fs"
     },
     {
      "fs": "O88",
      "iata": "",
      "icao": "",
      "faa": "O88",
      "name": "Rio Vista Municipal",
      "city": "Rio Vista",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.193747,
      "longitude": -121.704528,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O88?codeType=fs"
     },
     {
      "fs": "O89",
      "iata": "",
      "icao": "",
      "faa": "O89",
      "name": "Fall River Mills",
      "city": "Fall River Mills",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.03775,
      "longitude": -121.583139,
      "elevationFeet": 3323,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/O89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/O89?codeType=fs"
     },
     {
      "fs": "OAR",
      "iata": "OAR",
      "icao": "",
      "faa": "",
      "name": "Marina Municipal Airport",
      "city": "Monterey",
      "cityCode": "MRY",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.681019,
      "longitude": -121.763032,
      "elevationFeet": 136,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OAR?codeType=fs"
     },
     {
      "fs": "OBE",
      "iata": "OBE",
      "icao": "KOBE",
      "faa": "OBE",
      "name": "Okeechobee County Airport",
      "city": "Okeechobee",
      "cityCode": "OBE",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 27.25,
      "longitude": -80.833333,
      "elevationFeet": 34,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OBE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OBE?codeType=fs"
     },
     {
      "fs": "OBK",
      "iata": "OBK",
      "icao": "",
      "faa": "",
      "name": "Sky Harbor Airport",
      "city": "Northbrook",
      "cityCode": "OBK",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 42.116667,
      "longitude": -87.816667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OBK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OBK?codeType=fs"
     },
     {
      "fs": "OBT",
      "iata": "OBT",
      "icao": "",
      "faa": "",
      "name": "Oakland Coliseum Station",
      "city": "Oakland",
      "cityCode": "ODM",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.7525,
      "longitude": -122.198333,
      "elevationFeet": 12,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OBT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OBT?codeType=fs"
     },
     {
      "fs": "OCI",
      "iata": "OCI",
      "icao": "",
      "faa": "",
      "name": "Oceanic Airport",
      "city": "Oceanic",
      "cityCode": "OCI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.25,
      "longitude": -147.866667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCI?codeType=fs"
     },
     {
      "fs": "OCN",
      "iata": "OCN",
      "icao": "KOKB",
      "faa": "OKB",
      "name": "Oceanside Municipal Airport",
      "city": "Oceanside",
      "cityCode": "OCN",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 33.218611,
      "longitude": -117.353333,
      "elevationFeet": 28,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCN?codeType=fs"
     },
     {
      "fs": "OCW",
      "iata": "OCW",
      "icao": "KOCW",
      "faa": "OCW",
      "name": "Warren Field",
      "city": "Washington",
      "cityCode": "OCW",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 35.55,
      "longitude": -77.05,
      "elevationFeet": 38,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OCW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OCW?codeType=fs"
     },
     {
      "fs": "ODM",
      "iata": "ODM",
      "icao": "",
      "faa": "2G4",
      "name": "Metropolitan Area Airport",
      "city": "Oakland",
      "cityCode": "ODM",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39.0625,
      "longitude": -79.43,
      "elevationFeet": 2933,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ODM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ODM?codeType=fs"
     },
     {
      "fs": "ODW",
      "iata": "ODW",
      "icao": "",
      "faa": "76S",
      "name": "Oak Harbor Airport",
      "city": "Oak Harbor",
      "cityCode": "ODW",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.251389,
      "longitude": -122.686111,
      "elevationFeet": 189,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ODW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ODW?codeType=fs"
     },
     {
      "fs": "OEA",
      "iata": "OEA",
      "icao": "KOEA",
      "faa": "OEA",
      "name": "Oneal Airport",
      "city": "Vincennes",
      "cityCode": "OEA",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 38.683333,
      "longitude": -87.533333,
      "elevationFeet": 414,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OEA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OEA?codeType=fs"
     },
     {
      "fs": "OEO",
      "iata": "OEO",
      "icao": "KOEO",
      "faa": "OEO",
      "name": "Osceola Municipal Airport",
      "city": "Osceola",
      "cityCode": "OEO",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 45.3,
      "longitude": -92.7,
      "elevationFeet": 903,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OEO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OEO?codeType=fs"
     },
     {
      "fs": "OGA",
      "iata": "OGA",
      "icao": "KOGA",
      "faa": "OGA",
      "name": "Searle Field",
      "city": "Ogallala",
      "cityCode": "OGA",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 41.133333,
      "longitude": -101.716667,
      "elevationFeet": 3278,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OGA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OGA?codeType=fs"
     },
     {
      "fs": "OGB",
      "iata": "OGB",
      "icao": "KOGB",
      "faa": "OGB",
      "name": "Orangeburg Municipal Airport",
      "city": "Orangeburg",
      "cityCode": "OGB",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 33.5,
      "longitude": -80.866667,
      "elevationFeet": 195,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OGB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OGB?codeType=fs"
     },
     {
      "fs": "OH22",
      "iata": "",
      "icao": "OH22",
      "faa": "OH22",
      "name": "Stoltzfus Airfield",
      "city": "Kidron",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.852,
      "longitude": -81.898667,
      "elevationFeet": 1130,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OH22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OH22?codeType=fs"
     },
     {
      "fs": "OHC",
      "iata": "OHC",
      "icao": "",
      "faa": "",
      "name": "Northeast Cape Air Force Station",
      "city": "Northeast Cape",
      "cityCode": "OHC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 63.326389,
      "longitude": -168.968889,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OHC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OHC?codeType=fs"
     },
     {
      "fs": "OIC",
      "iata": "OIC",
      "icao": "KOIC",
      "faa": "OIC",
      "name": "Eaton Airport",
      "city": "Norwich",
      "cityCode": "OIC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.533333,
      "longitude": -75.533333,
      "elevationFeet": 1025,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OIC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OIC?codeType=fs"
     },
     {
      "fs": "OIL",
      "iata": "OIL",
      "icao": "",
      "faa": "",
      "name": "Splane Memorial Airport",
      "city": "Oil City",
      "cityCode": "OIL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.433333,
      "longitude": -79.7,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OIL?codeType=fs"
     },
     {
      "fs": "OK12",
      "iata": "",
      "icao": "",
      "faa": "OK12",
      "name": "Allied",
      "city": "Tulsa",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.26667,
      "longitude": -96.0583,
      "elevationFeet": 746,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OK12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OK12?codeType=fs"
     },
     {
      "fs": "OKM",
      "iata": "OKM",
      "icao": "KOKM",
      "faa": "OKM",
      "name": "Okmulgee Airport",
      "city": "Okmulgee",
      "cityCode": "OKM",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.616667,
      "longitude": -95.966667,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OKM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OKM?codeType=fs"
     },
     {
      "fs": "OKS",
      "iata": "OKS",
      "icao": "KOKS",
      "faa": "OKS",
      "name": "Oshkosh Airport",
      "city": "Oshkosh",
      "cityCode": "OKS",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.4,
      "longitude": -102.35,
      "elevationFeet": 3388,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OKS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OKS?codeType=fs"
     },
     {
      "fs": "OLD",
      "iata": "OLD",
      "icao": "KOLD",
      "faa": "OLD",
      "name": "Old Town Airport",
      "city": "Old Town",
      "cityCode": "OLD",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 44.933333,
      "longitude": -68.65,
      "elevationFeet": 126,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLD?codeType=fs"
     },
     {
      "fs": "OLU",
      "iata": "OLU",
      "icao": "KOLU",
      "faa": "OLU",
      "name": "Columbus Airport",
      "city": "Columbus",
      "cityCode": "OLU",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.447222,
      "longitude": -97.341667,
      "elevationFeet": 1444,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLU?codeType=fs"
     },
     {
      "fs": "OLY",
      "iata": "OLY",
      "icao": "KOLY",
      "faa": "OLY",
      "name": "Olney Airport",
      "city": "Olney",
      "cityCode": "OLY",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 38.716667,
      "longitude": -88.083333,
      "elevationFeet": 482,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OLY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OLY?codeType=fs"
     },
     {
      "fs": "ONA",
      "iata": "ONA",
      "icao": "KONA",
      "faa": "ONA",
      "name": "Winona Municipal Airport",
      "city": "Winona",
      "cityCode": "ONA",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 44.076667,
      "longitude": -91.706111,
      "elevationFeet": 656,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONA?codeType=fs"
     },
     {
      "fs": "ONH",
      "iata": "ONH",
      "icao": "",
      "faa": "N66",
      "name": "Oneonta Municipal Airport",
      "city": "Oneonta",
      "cityCode": "ONH",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.482778,
      "longitude": -75.000556,
      "elevationFeet": 1764,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONH?codeType=fs"
     },
     {
      "fs": "ONM",
      "iata": "ONM",
      "icao": "KONM",
      "faa": "ONM",
      "name": "Socorro Airport",
      "city": "Socorro",
      "cityCode": "ONM",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.066667,
      "longitude": -106.9,
      "elevationFeet": 4875,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONM?codeType=fs"
     },
     {
      "fs": "ONN",
      "iata": "ONN",
      "icao": "",
      "faa": "",
      "name": "Onion Bay Airport",
      "city": "Onion Bay",
      "cityCode": "ONN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 58.233333,
      "longitude": -152.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONN?codeType=fs"
     },
     {
      "fs": "ONY",
      "iata": "ONY",
      "icao": "KONY",
      "faa": "ONY",
      "name": "Olney Airport",
      "city": "Olney",
      "cityCode": "ONY",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.366667,
      "longitude": -98.75,
      "elevationFeet": 1275,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ONY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ONY?codeType=fs"
     },
     {
      "fs": "OOA",
      "iata": "OOA",
      "icao": "KOOA",
      "faa": "OOA",
      "name": "Oskaloosa Municipal Airport",
      "city": "Oskaloosa",
      "cityCode": "OOA",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.3,
      "longitude": -92.65,
      "elevationFeet": 840,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OOA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OOA?codeType=fs"
     },
     {
      "fs": "OPL",
      "iata": "OPL",
      "icao": "KOPL",
      "faa": "OPL",
      "name": "St Landry Parish Airport",
      "city": "Opelousas",
      "cityCode": "OPL",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.533333,
      "longitude": -92.083333,
      "elevationFeet": 75,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OPL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OPL?codeType=fs"
     },
     {
      "fs": "ORQ",
      "iata": "ORQ",
      "icao": "",
      "faa": "",
      "name": "Norwalk Heliport",
      "city": "Norwalk",
      "cityCode": "ORQ",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.116667,
      "longitude": -73.366667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORQ?codeType=fs"
     },
     {
      "fs": "ORT",
      "iata": "ORT",
      "icao": "PAOR",
      "faa": "PAOR",
      "name": "Northway Airport",
      "city": "Northway",
      "cityCode": "ORT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ224",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 62.961944,
      "longitude": -141.923889,
      "elevationFeet": 1716,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORT?codeType=fs"
     },
     {
      "fs": "ORV0",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Curtis Memorial",
      "city": "Noorvik",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 66.935278,
      "longitude": -161.127917,
      "elevationFeet": 63,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ORV0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ORV0?codeType=fs"
     },
     {
      "fs": "OSX",
      "iata": "OSX",
      "icao": "KOSX",
      "faa": "OSX",
      "name": "Attala County Airport",
      "city": "Kosciusko",
      "cityCode": "OSX",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.066667,
      "longitude": -89.583333,
      "elevationFeet": 480,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OSX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OSX?codeType=fs"
     },
     {
      "fs": "OTG",
      "iata": "OTG",
      "icao": "KOTG",
      "faa": "OTG",
      "name": "Worthington Airport",
      "city": "Worthington",
      "cityCode": "OTG",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 43.652222,
      "longitude": -95.583611,
      "elevationFeet": 1574,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTG?codeType=fs"
     },
     {
      "fs": "OTM",
      "iata": "OTM",
      "icao": "KOTM",
      "faa": "OTM",
      "name": "Industrial Airport",
      "city": "Ottumwa",
      "cityCode": "OTM",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.106389,
      "longitude": -92.449167,
      "elevationFeet": 845,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTM?codeType=fs"
     },
     {
      "fs": "OTN",
      "iata": "OTN",
      "icao": "",
      "faa": "",
      "name": "Green Airport",
      "city": "Oaktown",
      "cityCode": "OTN",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 38.866667,
      "longitude": -87.45,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTN?codeType=fs"
     },
     {
      "fs": "OTO",
      "iata": "OTO",
      "icao": "",
      "faa": "",
      "name": "Vor Airport",
      "city": "Otto",
      "cityCode": "OTO",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 35.066667,
      "longitude": -105.933333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTO?codeType=fs"
     },
     {
      "fs": "OTS",
      "iata": "OTS",
      "icao": "",
      "faa": "74S",
      "name": "Anacortes Airport",
      "city": "Anacortes",
      "cityCode": "OTS",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.499167,
      "longitude": -122.661111,
      "elevationFeet": 241,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OTS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OTS?codeType=fs"
     },
     {
      "fs": "OUN",
      "iata": "OUN",
      "icao": "KOUN",
      "faa": "OUN",
      "name": "Max Westheimer Airport",
      "city": "Norman",
      "cityCode": "OUN",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.24507,
      "longitude": -97.471223,
      "elevationFeet": 1182,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OUN?codeType=fs"
     },
     {
      "fs": "OVE",
      "iata": "OVE",
      "icao": "KOVE",
      "faa": "OVE",
      "name": "Oroville Airport",
      "city": "Oroville",
      "cityCode": "OVE",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.5,
      "longitude": -121.616667,
      "elevationFeet": 192,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OVE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OVE?codeType=fs"
     },
     {
      "fs": "OWA",
      "iata": "OWA",
      "icao": "KOWA",
      "faa": "OWA",
      "name": "Owatonna Airport",
      "city": "Owatonna",
      "cityCode": "OWA",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 44.1,
      "longitude": -93.166667,
      "elevationFeet": 1145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OWA?codeType=fs"
     },
     {
      "fs": "OWK",
      "iata": "OWK",
      "icao": "KOWK",
      "faa": "OWK",
      "name": "Central Maine Airport",
      "city": "Norridgewock",
      "cityCode": "OWK",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 44.716667,
      "longitude": -69.8,
      "elevationFeet": 270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OWK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OWK?codeType=fs"
     },
     {
      "fs": "OXD",
      "iata": "OXD",
      "icao": "KOXD",
      "faa": "OXD",
      "name": "Miami University Airport",
      "city": "Oxford",
      "cityCode": "OXD",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39.860278,
      "longitude": -84.761111,
      "elevationFeet": 1045,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OXD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OXD?codeType=fs"
     },
     {
      "fs": "OYS",
      "iata": "OYS",
      "icao": "",
      "faa": "",
      "name": "Yosemite National Park Airport",
      "city": "Yosemite National Park",
      "cityCode": "OYS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.85,
      "longitude": -119.55,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OYS?codeType=fs"
     },
     {
      "fs": "OZA",
      "iata": "OZA",
      "icao": "KOZA",
      "faa": "OZA",
      "name": "Ozona Airport",
      "city": "Ozona",
      "cityCode": "OZA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.716667,
      "longitude": -101.216667,
      "elevationFeet": 2381,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OZA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OZA?codeType=fs"
     },
     {
      "fs": "OZR",
      "iata": "OZR",
      "icao": "KOZR",
      "faa": "OZR",
      "name": "Cairns Army Air Field",
      "city": "Ozark",
      "cityCode": "OZR",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.276799,
      "longitude": -85.710038,
      "elevationFeet": 293,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/OZR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/OZR?codeType=fs"
     },
     {
      "fs": "P01",
      "iata": "",
      "icao": "",
      "faa": "P01",
      "name": "Ajo Municipal",
      "city": "Ajo",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 32.450583,
      "longitude": -112.873778,
      "elevationFeet": 1458,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P01?codeType=fs"
     },
     {
      "fs": "P03",
      "iata": "",
      "icao": "",
      "faa": "P03",
      "name": "Cochise College",
      "city": "Douglas",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 31.411111,
      "longitude": -109.747222,
      "elevationFeet": 4124,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P03?codeType=fs"
     },
     {
      "fs": "P06",
      "iata": "",
      "icao": "",
      "faa": "P06",
      "name": "Moorhead",
      "city": "North East",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.19225,
      "longitude": -80.025528,
      "elevationFeet": 805,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P06?codeType=fs"
     },
     {
      "fs": "P08",
      "iata": "",
      "icao": "",
      "faa": "P08",
      "name": "Coolidge Municipal",
      "city": "Coolidge",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 32.959,
      "longitude": -111.514722,
      "elevationFeet": 1574,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P08?codeType=fs"
     },
     {
      "fs": "P09",
      "iata": "",
      "icao": "",
      "faa": "P09",
      "name": "Lakehill",
      "city": "Mars",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.770111,
      "longitude": -80.153361,
      "elevationFeet": 1030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P09?codeType=fs"
     },
     {
      "fs": "P10",
      "iata": "",
      "icao": "",
      "faa": "P10",
      "name": "Scandia",
      "city": "Russell",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.056139,
      "longitude": -79.042083,
      "elevationFeet": 2050,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P10?codeType=fs"
     },
     {
      "fs": "P13",
      "iata": "",
      "icao": "",
      "faa": "P13",
      "name": "San Carlos Apache",
      "city": "Globe",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.378917,
      "longitude": -110.792444,
      "elevationFeet": 3235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P13?codeType=fs"
     },
     {
      "fs": "P14",
      "iata": "HBK",
      "icao": "",
      "faa": "P14",
      "name": "Holbrook Municipal Airport",
      "city": "Holbrook",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.940676,
      "longitude": -110.137982,
      "elevationFeet": 5242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P14?codeType=fs"
     },
     {
      "fs": "P15",
      "iata": "",
      "icao": "",
      "faa": "P15",
      "name": "Brokenstraw",
      "city": "Pittsfield",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.975583,
      "longitude": -79.461611,
      "elevationFeet": 1230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P15?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P15?codeType=fs"
     },
     {
      "fs": "P18",
      "iata": "",
      "icao": "",
      "faa": "P18",
      "name": "Papago Air Force Base",
      "city": "Phoenix",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.46936,
      "longitude": -111.962091,
      "elevationFeet": 1269,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P18?codeType=fs"
     },
     {
      "fs": "P19",
      "iata": "",
      "icao": "",
      "faa": "P19",
      "name": "Stellar Airpark",
      "city": "Chandler",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.298889,
      "longitude": -111.915556,
      "elevationFeet": 1180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P19?codeType=fs"
     },
     {
      "fs": "P20",
      "iata": "",
      "icao": "",
      "faa": "P20",
      "name": "Avi Suquilla",
      "city": "Parker",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.156389,
      "longitude": -114.312222,
      "elevationFeet": 452,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P20?codeType=fs"
     },
     {
      "fs": "P23",
      "iata": "",
      "icao": "",
      "faa": "P23",
      "name": "Seligman",
      "city": "Seligman",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 35.35,
      "longitude": -112.922222,
      "elevationFeet": 5235,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P23?codeType=fs"
     },
     {
      "fs": "P29",
      "iata": "",
      "icao": "",
      "faa": "P29",
      "name": "Tombstone Municipal",
      "city": "Tombstone",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 31.70925,
      "longitude": -110.078528,
      "elevationFeet": 4743,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P29?codeType=fs"
     },
     {
      "fs": "P32",
      "iata": "",
      "icao": "",
      "faa": "P32",
      "name": "Clark Memorial",
      "city": "Williams",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 35.322333,
      "longitude": -112.290583,
      "elevationFeet": 6680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P32?codeType=fs"
     },
     {
      "fs": "P33",
      "iata": "",
      "icao": "",
      "faa": "P33",
      "name": "Cochise Co",
      "city": "Willcox",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 32.354028,
      "longitude": -109.996333,
      "elevationFeet": 4181,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P33?codeType=fs"
     },
     {
      "fs": "P34",
      "iata": "",
      "icao": "",
      "faa": "P34",
      "name": "Mifflintown",
      "city": "Mifflintown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.611861,
      "longitude": -77.449889,
      "elevationFeet": 545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P34?codeType=fs"
     },
     {
      "fs": "P37",
      "iata": "",
      "icao": "",
      "faa": "P37",
      "name": "Mc Ville",
      "city": "Freeport",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.733972,
      "longitude": -79.747694,
      "elevationFeet": 1090,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P37?codeType=fs"
     },
     {
      "fs": "P45",
      "iata": "",
      "icao": "",
      "faa": "P45",
      "name": "Mt Pleasant-Scottdale",
      "city": "Mt Pleasant",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.184056,
      "longitude": -79.614278,
      "elevationFeet": 1160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P45?codeType=fs"
     },
     {
      "fs": "P53",
      "iata": "",
      "icao": "",
      "faa": "P53",
      "name": "Rostraver",
      "city": "Monongahela",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.297222,
      "longitude": -79.964444,
      "elevationFeet": 1228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P53?codeType=fs"
     },
     {
      "fs": "P64",
      "iata": "",
      "icao": "",
      "faa": "P64",
      "name": "Miller",
      "city": "Burgettstown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.514556,
      "longitude": -80.464556,
      "elevationFeet": 1230,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P64?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P64?codeType=fs"
     },
     {
      "fs": "P91",
      "iata": "",
      "icao": "",
      "faa": "P91",
      "name": "Flying M Aerodrome",
      "city": "Germansville",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.737797,
      "longitude": -75.704233,
      "elevationFeet": 732,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P91?codeType=fs"
     },
     {
      "fs": "P96",
      "iata": "",
      "icao": "",
      "faa": "P96",
      "name": "Jersey Shore",
      "city": "Jersey Shore",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.270167,
      "longitude": -77.310806,
      "elevationFeet": 547,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P96?codeType=fs"
     },
     {
      "fs": "P97",
      "iata": "",
      "icao": "",
      "faa": "P97",
      "name": "Prairie Ronde",
      "city": "Schoolcraft",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.1875,
      "longitude": -85.802778,
      "elevationFeet": 890,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/P97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/P97?codeType=fs"
     },
     {
      "fs": "PABV",
      "iata": "",
      "icao": "PABV",
      "faa": "PABV",
      "name": "Birchwood Airport",
      "city": "Birchwood",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 61.427607,
      "longitude": -149.524557,
      "elevationFeet": -1,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PABV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PABV?codeType=fs"
     },
     {
      "fs": "PACS",
      "iata": "",
      "icao": "PACS",
      "faa": "PACS",
      "name": "Cape Sarichef",
      "city": "Cape Sarichef",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 54.724306,
      "longitude": -165.044806,
      "elevationFeet": 291,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PACS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PACS?codeType=fs"
     },
     {
      "fs": "PAFB",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Wainwright Aaf",
      "city": "Ft Wainwright",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 64.865167,
      "longitude": -147.618667,
      "elevationFeet": 452,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAFB?codeType=fs"
     },
     {
      "fs": "PAK",
      "iata": "PAK",
      "icao": "",
      "faa": "",
      "name": "Port Allen Airport",
      "city": "Hanapepe",
      "cityCode": "PAK",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.687",
      "utcOffsetHours": -10,
      "latitude": 21.900305,
      "longitude": -159.598297,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAK?codeType=fs"
     },
     {
      "fs": "PALH",
      "iata": "",
      "icao": "PALH",
      "faa": "PALH",
      "name": "Lake Hood Seaplane Base",
      "city": "Anchorage",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 61.182847,
      "longitude": -149.964113,
      "elevationFeet": 75,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PALH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PALH?codeType=fs"
     },
     {
      "fs": "PALP",
      "iata": "",
      "icao": "PALP",
      "faa": "PALP",
      "name": "Alpine Airstrip",
      "city": "Nuiqsut",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 70.442806,
      "longitude": -151.047361,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PALP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PALP?codeType=fs"
     },
     {
      "fs": "PATW",
      "iata": "",
      "icao": "PATW",
      "faa": "PATW",
      "name": "Cantwell",
      "city": "Cantwell",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 63.462056,
      "longitude": -149.006167,
      "elevationFeet": 2190,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PATW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PATW?codeType=fs"
     },
     {
      "fs": "PAWR",
      "iata": "",
      "icao": "PAWR",
      "faa": "PAWR",
      "name": "Whittier",
      "city": "Whittier",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.872139,
      "longitude": -148.765778,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAWR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAWR?codeType=fs"
     },
     {
      "fs": "PAZK",
      "iata": "",
      "icao": "PAZK",
      "faa": "PAZK",
      "name": "Skelton",
      "city": "Eureka",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 61.969972,
      "longitude": -147.188639,
      "elevationFeet": 3289,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PAZK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PAZK?codeType=fs"
     },
     {
      "fs": "PBA",
      "iata": "PBA",
      "icao": "",
      "faa": "",
      "name": "Point Barrow Airport",
      "city": "Barrow",
      "cityCode": "BRW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 71.340678,
      "longitude": -156.63737,
      "elevationFeet": 2,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PBA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PBA?codeType=fs"
     },
     {
      "fs": "PBF",
      "iata": "PBF",
      "icao": "KPBF",
      "faa": "PBF",
      "name": "Grider Field",
      "city": "Pine Bluff",
      "cityCode": "PBF",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.175556,
      "longitude": -91.935556,
      "elevationFeet": 206,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PBF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PBF?codeType=fs"
     },
     {
      "fs": "PBK",
      "iata": "PBK",
      "icao": "",
      "faa": "",
      "name": "Pack Creek Airport",
      "city": "Pack Creek",
      "cityCode": "PBK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 57.8,
      "longitude": -134.7,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PBK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PBK?codeType=fs"
     },
     {
      "fs": "PCA",
      "iata": "PCA",
      "icao": "PAOC",
      "faa": "A14",
      "name": "Portage Creek Airport",
      "city": "Portage Creek",
      "cityCode": "PCA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ161",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 58.901389,
      "longitude": -157.701944,
      "elevationFeet": 137,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PCA?codeType=fs"
     },
     {
      "fs": "PCD",
      "iata": "PCD",
      "icao": "KPDC",
      "faa": "PDC",
      "name": "Prairie Du Chien Municipal Airport",
      "city": "Prairie Du Chien",
      "cityCode": "PCD",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 43.016667,
      "longitude": -91.116667,
      "elevationFeet": 661,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PCD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PCD?codeType=fs"
     },
     {
      "fs": "PCK",
      "iata": "PCK",
      "icao": "",
      "faa": "",
      "name": "Porcupine Creek Airport",
      "city": "Porcupine Creek",
      "cityCode": "PCK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 67.228889,
      "longitude": -150.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PCK?codeType=fs"
     },
     {
      "fs": "PCU",
      "iata": "PCU",
      "icao": "KPCU",
      "faa": "PCU",
      "name": "Pearl River County Airport",
      "city": "Picayune",
      "cityCode": "PCU",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.433333,
      "longitude": -89.683333,
      "elevationFeet": 62,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PCU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PCU?codeType=fs"
     },
     {
      "fs": "PFC",
      "iata": "PFC",
      "icao": "KPFC",
      "faa": "PFC",
      "name": "Pacific City State Airport",
      "city": "Pacific City",
      "cityCode": "PFC",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 45.199796,
      "longitude": -123.962047,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PFC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PFC?codeType=fs"
     },
     {
      "fs": "PFD",
      "iata": "PFD",
      "icao": "",
      "faa": "",
      "name": "Port Frederick Airport",
      "city": "Port Frederick",
      "cityCode": "PFD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 57.95,
      "longitude": -135.65,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PFD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PFD?codeType=fs"
     },
     {
      "fs": "PFN",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Bay County Airport",
      "street1": "3173 Airport Road",
      "city": "Panama City",
      "cityCode": "PFN",
      "stateCode": "FL",
      "postalCode": "32405",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "FLZ012",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.207084,
      "longitude": -85.683088,
      "elevationFeet": 20,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PFN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PFN?codeType=fs"
     },
     {
      "fs": "PGC",
      "iata": "PGC",
      "icao": "",
      "faa": "W99",
      "name": "Grant County Airport",
      "city": "Petersburg",
      "cityCode": "PGC",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39,
      "longitude": -79.116667,
      "elevationFeet": 960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGC?codeType=fs"
     },
     {
      "fs": "PGL",
      "iata": "PGL",
      "icao": "",
      "faa": "",
      "name": "Jackson County Airport",
      "city": "Pascagoula",
      "cityCode": "PGL",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.383333,
      "longitude": -88.516667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGL?codeType=fs"
     },
     {
      "fs": "PGO",
      "iata": "PGO",
      "icao": "",
      "faa": "2V1",
      "name": "Stevens Field",
      "city": "Pagosa Springs",
      "cityCode": "PGO",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 37.268611,
      "longitude": -107.050833,
      "elevationFeet": 7700,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGO?codeType=fs"
     },
     {
      "fs": "PGR",
      "iata": "PGR",
      "icao": "KPGR",
      "faa": "PGR",
      "name": "Kirk Field",
      "city": "Paragould",
      "cityCode": "PGR",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.062905,
      "longitude": -90.507802,
      "elevationFeet": 276,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGR?codeType=fs"
     },
     {
      "fs": "PGS",
      "iata": "PGS",
      "icao": "",
      "faa": "L37",
      "name": "Peach Springs Airport",
      "city": "Peach Springs",
      "cityCode": "PGS",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 35.533333,
      "longitude": -113.416667,
      "elevationFeet": 5386,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PGS?codeType=fs"
     },
     {
      "fs": "PHD",
      "iata": "PHD",
      "icao": "KPHD",
      "faa": "PHD",
      "name": "Harry Clever Field",
      "city": "New Philadelphia",
      "cityCode": "PHD",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.470892,
      "longitude": -81.419694,
      "elevationFeet": 891,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHD?codeType=fs"
     },
     {
      "fs": "PHFS",
      "iata": "",
      "icao": "PHFS",
      "faa": "PHFS",
      "name": "Tern I.",
      "city": "Tern I.",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.687",
      "utcOffsetHours": -10,
      "latitude": 23.872222,
      "longitude": -166.325,
      "elevationFeet": 6,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHFS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHFS?codeType=fs"
     },
     {
      "fs": "PHK",
      "iata": "PHK",
      "icao": "KPHK",
      "faa": "PHK",
      "name": "Palm Beach County Glades Airport",
      "city": "Pahokee",
      "cityCode": "PHK",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 26.816667,
      "longitude": -80.666667,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHK?codeType=fs"
     },
     {
      "fs": "PHLU",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Kalaupapa Apt.",
      "city": "Molokai  Hawaii",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.687",
      "utcOffsetHours": -10,
      "latitude": 21.31,
      "longitude": -157.036667,
      "elevationFeet": 24,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHLU?codeType=fs"
     },
     {
      "fs": "PHN",
      "iata": "PHN",
      "icao": "KPHN",
      "faa": "PHN",
      "name": "St Clair County International Airport",
      "city": "Port Huron",
      "cityCode": "PHN",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.913056,
      "longitude": -82.526111,
      "elevationFeet": 650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHN?codeType=fs"
     },
     {
      "fs": "PHP",
      "iata": "PHP",
      "icao": "KPHP",
      "faa": "PHP",
      "name": "Phillip Airport",
      "city": "Philip",
      "cityCode": "PHP",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 44.333333,
      "longitude": -101.666667,
      "elevationFeet": 2207,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHP?codeType=fs"
     },
     {
      "fs": "PHT",
      "iata": "PHT",
      "icao": "KPHT",
      "faa": "PHT",
      "name": "Henry County Airport",
      "city": "Paris",
      "cityCode": "PHT",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.333611,
      "longitude": -88.383333,
      "elevationFeet": 580,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PHT?codeType=fs"
     },
     {
      "fs": "PII",
      "iata": "PII",
      "icao": "",
      "faa": "",
      "name": "Phillips Field",
      "city": "Fairbanks",
      "cityCode": "FAI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 64.850874,
      "longitude": -147.783215,
      "elevationFeet": 447,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PII?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PII?codeType=fs"
     },
     {
      "fs": "PIM",
      "iata": "PIM",
      "icao": "KPIM",
      "faa": "PIM",
      "name": "Garden Harris County Airport",
      "city": "Pine Mountain",
      "cityCode": "PIM",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 32.866667,
      "longitude": -84.833333,
      "elevationFeet": 902,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PIM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PIM?codeType=fs"
     },
     {
      "fs": "PJS",
      "iata": "PJS",
      "icao": "",
      "faa": "",
      "name": "Port San Juan Airport",
      "city": "Port San Juan",
      "cityCode": "PJS",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.048611,
      "longitude": -148.063889,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PJS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PJS?codeType=fs"
     },
     {
      "fs": "PKD",
      "iata": "PKD",
      "icao": "KPKD",
      "faa": "PKD",
      "name": "Park Rapids Municipal Airport-Konshok Field",
      "city": "Park Rapids",
      "cityCode": "PKD",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 46.898333,
      "longitude": -95.071667,
      "elevationFeet": 1443,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PKD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PKD?codeType=fs"
     },
     {
      "fs": "PKF",
      "iata": "PKF",
      "icao": "KPKF",
      "faa": "PKF",
      "name": "Park Falls Airport",
      "city": "Park Falls",
      "cityCode": "PKF",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 45.933333,
      "longitude": -90.533333,
      "elevationFeet": 1500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PKF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PKF?codeType=fs"
     },
     {
      "fs": "PLB",
      "iata": "PLB",
      "icao": "KPLB",
      "faa": "PLB",
      "name": "Clinton County Airport",
      "street1": "11 Airport Road, Suite 101",
      "street2": "",
      "city": "Plattsburgh",
      "cityCode": "PLB",
      "stateCode": "NY",
      "postalCode": "12901",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ031",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 44.688333,
      "longitude": -73.521111,
      "elevationFeet": 371,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PLB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PLB?codeType=fs"
     },
     {
      "fs": "PLK",
      "iata": "PLK",
      "icao": "KPLK",
      "faa": "PLK",
      "name": "M Graham Clark Airport",
      "city": "Branson/Point Lookout",
      "cityCode": "PLK",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.65,
      "longitude": -93.216667,
      "elevationFeet": 938,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PLK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PLK?codeType=fs"
     },
     {
      "fs": "PLR",
      "iata": "PLR",
      "icao": "KPLR",
      "faa": "PLR",
      "name": "St. Clair County Airport",
      "city": "Pell City",
      "cityCode": "PLR",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.583333,
      "longitude": -86.283333,
      "elevationFeet": 485,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PLR?codeType=fs"
     },
     {
      "fs": "PLY",
      "iata": "PLY",
      "icao": "",
      "faa": "C65",
      "name": "Plymouth Airport",
      "city": "Plymouth",
      "cityCode": "PLY",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "INZ014",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.365278,
      "longitude": -86.301667,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PLY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PLY?codeType=fs"
     },
     {
      "fs": "PMB",
      "iata": "PMB",
      "icao": "KPMB",
      "faa": "PMB",
      "name": "Pembina Intermediate Airport",
      "city": "Pembina",
      "cityCode": "PMB",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 49,
      "longitude": -98.083333,
      "elevationFeet": 795,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PMB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PMB?codeType=fs"
     },
     {
      "fs": "PMH",
      "iata": "PMH",
      "icao": "KPMH",
      "faa": "PMH",
      "name": "Portsmouth Regional Airport",
      "city": "Portsmouth",
      "cityCode": "PMH",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 38.75,
      "longitude": -82.983333,
      "elevationFeet": 663,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PMH?codeType=fs"
     },
     {
      "fs": "PMU",
      "iata": "PMU",
      "icao": "",
      "faa": "",
      "name": "Paimiut Sea Plane Base",
      "city": "Paimiut",
      "cityCode": "PMU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 61.983333,
      "longitude": -160.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PMU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PMU?codeType=fs"
     },
     {
      "fs": "PMX",
      "iata": "PMX",
      "icao": "KPMX",
      "faa": "PMX",
      "name": "Palmer Metropolitan Airport",
      "city": "Palmer",
      "cityCode": "PMX",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.15,
      "longitude": -72.316667,
      "elevationFeet": 418,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PMX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PMX?codeType=fs"
     },
     {
      "fs": "PN0",
      "iata": "",
      "icao": "",
      "faa": "PN0",
      "name": "Echo",
      "city": "Morris",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.603333,
      "longitude": -77.363333,
      "elevationFeet": 1800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PN0?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PN0?codeType=fs"
     },
     {
      "fs": "PNF",
      "iata": "PNF",
      "icao": "",
      "faa": "",
      "name": "Peterson's Point Airport",
      "city": "Peterson's Point",
      "cityCode": "PNF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 58.683333,
      "longitude": -156.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNF?codeType=fs"
     },
     {
      "fs": "PNN",
      "iata": "PNN",
      "icao": "KPNN",
      "faa": "PNN",
      "name": "Princeton Airport",
      "city": "Princeton",
      "cityCode": "PNN",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 45.233333,
      "longitude": -67.566667,
      "elevationFeet": 266,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNN?codeType=fs"
     },
     {
      "fs": "PNU",
      "iata": "PNU",
      "icao": "",
      "faa": "U55",
      "name": "Panguitch Airport",
      "city": "Panguitch",
      "cityCode": "PNU",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 37.833333,
      "longitude": -112.383333,
      "elevationFeet": 6759,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNU?codeType=fs"
     },
     {
      "fs": "PNX",
      "iata": "PNX",
      "icao": "",
      "faa": "GYI",
      "name": "Grayson County Airport",
      "city": "Sherman-Denison",
      "cityCode": "PNX",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.638889,
      "longitude": -96.611111,
      "elevationFeet": 749,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PNX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PNX?codeType=fs"
     },
     {
      "fs": "POC",
      "iata": "POC",
      "icao": "KPOC",
      "faa": "POC",
      "name": "Brackett Field",
      "city": "La Verne",
      "cityCode": "POC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 34.091599,
      "longitude": -117.781998,
      "elevationFeet": 1011,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POC?codeType=fs"
     },
     {
      "fs": "POE",
      "iata": "POE",
      "icao": "KPOE",
      "faa": "POE",
      "name": "Polk Army Air Field",
      "city": "Fort Polk",
      "cityCode": "POE",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.045833,
      "longitude": -93.192222,
      "elevationFeet": 330,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POE?codeType=fs"
     },
     {
      "fs": "POF",
      "iata": "POF",
      "icao": "KPOF",
      "faa": "POF",
      "name": "Earl Fields Memorial Airport",
      "city": "Poplar Bluff",
      "cityCode": "POF",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.711111,
      "longitude": -90.313889,
      "elevationFeet": 331,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POF?codeType=fs"
     },
     {
      "fs": "POH",
      "iata": "POH",
      "icao": "KPOH",
      "faa": "POH",
      "name": "Pocahontas Municipal Airport",
      "city": "Pocahontas",
      "cityCode": "POH",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 42.742222,
      "longitude": -94.644167,
      "elevationFeet": 1224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POH?codeType=fs"
     },
     {
      "fs": "POLI",
      "iata": "",
      "icao": "POLI",
      "faa": "POLI",
      "name": "Oliktok Lrrs",
      "city": "Oliktok Point",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 70.647111,
      "longitude": -149.995333,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POLI?codeType=fs"
     },
     {
      "fs": "POY",
      "iata": "POY",
      "icao": "KPOY",
      "faa": "POY",
      "name": "Powell/Lovell Airport",
      "city": "Powell/Lovell",
      "cityCode": "POY",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.75,
      "longitude": -108.766667,
      "elevationFeet": 5092,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/POY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/POY?codeType=fs"
     },
     {
      "fs": "PPF",
      "iata": "PPF",
      "icao": "KPPF",
      "faa": "PPF",
      "name": "Tri-City Airport",
      "city": "Parsons",
      "cityCode": "PPF",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 37.332222,
      "longitude": -95.508611,
      "elevationFeet": 899,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PPF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PPF?codeType=fs"
     },
     {
      "fs": "PPM",
      "iata": "PPM",
      "icao": "KPMP",
      "faa": "PMP",
      "name": "Pompano Beach Airport",
      "city": "Pompano Beach",
      "cityCode": "PPM",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 26.25,
      "longitude": -80.116667,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PPM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PPM?codeType=fs"
     },
     {
      "fs": "PRF",
      "iata": "PRF",
      "icao": "",
      "faa": "",
      "name": "Port Johnson Airport",
      "city": "Port Johnson",
      "cityCode": "PRF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 55.133333,
      "longitude": -132,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRF?codeType=fs"
     },
     {
      "fs": "PRL",
      "iata": "PRL",
      "icao": "",
      "faa": "",
      "name": "Port Oceanic Airport",
      "city": "Port Oceanic",
      "cityCode": "PRL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.208333,
      "longitude": -147.819444,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRL?codeType=fs"
     },
     {
      "fs": "PRO",
      "iata": "PRO",
      "icao": "KPRO",
      "faa": "PRO",
      "name": "Perry Municipal Airport",
      "city": "Perry",
      "cityCode": "PRO",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.85,
      "longitude": -94.1,
      "elevationFeet": 1014,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRO?codeType=fs"
     },
     {
      "fs": "PRW",
      "iata": "PRW",
      "icao": "",
      "faa": "5N2",
      "name": "Prentice Airport",
      "city": "Prentice",
      "cityCode": "PRW",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 45.55,
      "longitude": -90.283333,
      "elevationFeet": 1578,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRW?codeType=fs"
     },
     {
      "fs": "PRX",
      "iata": "PRX",
      "icao": "KPRX",
      "faa": "PRX",
      "name": "Cox Field",
      "city": "Paris",
      "cityCode": "PRX",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.636667,
      "longitude": -95.450278,
      "elevationFeet": 547,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRX?codeType=fs"
     },
     {
      "fs": "PRZ",
      "iata": "PRZ",
      "icao": "",
      "faa": "S39",
      "name": "Prineville Airport",
      "city": "Prineville",
      "cityCode": "PRZ",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 44.3,
      "longitude": -120.85,
      "elevationFeet": 3250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PRZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PRZ?codeType=fs"
     },
     {
      "fs": "PSB",
      "iata": "PSB",
      "icao": "KPSB",
      "faa": "PSB",
      "name": "Mid-State Airport",
      "city": "Philipsburg",
      "cityCode": "PSB",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.883333,
      "longitude": -78.085833,
      "elevationFeet": 1948,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSB?codeType=fs"
     },
     {
      "fs": "PSQ",
      "iata": "PSQ",
      "icao": "",
      "faa": "",
      "name": "Essington Sea Plane Base",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39.859081,
      "longitude": -75.299458,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSQ?codeType=fs"
     },
     {
      "fs": "PSX",
      "iata": "PSX",
      "icao": "KPSX",
      "faa": "PSX",
      "name": "Palacios Airport",
      "city": "Palacios",
      "cityCode": "PSX",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.7,
      "longitude": -96.25,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PSX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PSX?codeType=fs"
     },
     {
      "fs": "PTB",
      "iata": "PTB",
      "icao": "KPTB",
      "faa": "PTB",
      "name": "Dinwiddie County Airport",
      "city": "Petersburg",
      "cityCode": "PTB",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 37.183941,
      "longitude": -77.50569,
      "elevationFeet": 181,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTB?codeType=fs"
     },
     {
      "fs": "PTC",
      "iata": "PTC",
      "icao": "",
      "faa": "",
      "name": "Port Alice Sea Plane Base",
      "city": "Port Alice",
      "cityCode": "PTC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 55.79878,
      "longitude": -133.594564,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTC?codeType=fs"
     },
     {
      "fs": "PTD",
      "iata": "PTD",
      "icao": "",
      "faa": "",
      "name": "Port Alexander Sea Plane Base",
      "city": "Port Alexander",
      "cityCode": "PTD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 56.24772,
      "longitude": -134.648782,
      "elevationFeet": 8,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTD?codeType=fs"
     },
     {
      "fs": "PTN",
      "iata": "PTN",
      "icao": "KPTN",
      "faa": "PTN",
      "name": "Patterson Municipal Heliport",
      "city": "Patterson",
      "cityCode": "PTN",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.708333,
      "longitude": -91.3375,
      "elevationFeet": 9,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTN?codeType=fs"
     },
     {
      "fs": "PTR",
      "iata": "PTR",
      "icao": "",
      "faa": "",
      "name": "Pleasant Harbor Airport",
      "city": "Pleasant Harbor",
      "cityCode": "PTR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 57.75,
      "longitude": -152.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTR?codeType=fs"
     },
     {
      "fs": "PTS",
      "iata": "PTS",
      "icao": "KPTS",
      "faa": "PTS",
      "name": "Pittsburg Municipal Airport",
      "city": "Pittsburg",
      "cityCode": "PTS",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 37.446667,
      "longitude": -94.730556,
      "elevationFeet": 950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTS?codeType=fs"
     },
     {
      "fs": "PTT",
      "iata": "PTT",
      "icao": "KPTT",
      "faa": "PTT",
      "name": "Pratt Airport",
      "city": "Pratt",
      "cityCode": "PTT",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 37.716667,
      "longitude": -98.75,
      "elevationFeet": 1952,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTT?codeType=fs"
     },
     {
      "fs": "PTV",
      "iata": "PTV",
      "icao": "KPTV",
      "faa": "PTV",
      "name": "Porterville Airport",
      "city": "Porterville",
      "cityCode": "PTV",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.066667,
      "longitude": -119.016667,
      "elevationFeet": 442,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PTV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PTV?codeType=fs"
     },
     {
      "fs": "PUL",
      "iata": "PUL",
      "icao": "",
      "faa": "",
      "name": "Poulsbo Airport",
      "city": "Poulsbo",
      "cityCode": "PUL",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.733333,
      "longitude": -122.65,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PUL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PUL?codeType=fs"
     },
     {
      "fs": "PUO",
      "iata": "PUO",
      "icao": "PAUD",
      "faa": "PAUD",
      "name": "Prudhoe Bay Airport",
      "city": "Prudhoe Bay",
      "cityCode": "PUO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 70.251389,
      "longitude": -148.336944,
      "elevationFeet": 45,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PUO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PUO?codeType=fs"
     },
     {
      "fs": "PVW",
      "iata": "PVW",
      "icao": "KPVW",
      "faa": "PVW",
      "name": "Hale County Airport",
      "city": "Plainview",
      "cityCode": "PVW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.183333,
      "longitude": -101.716667,
      "elevationFeet": 3374,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVW?codeType=fs"
     },
     {
      "fs": "PVY",
      "iata": "PVY",
      "icao": "",
      "faa": "",
      "name": "Pope Vanoy Airport",
      "city": "Pope Vanoy",
      "cityCode": "PVY",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 59.316667,
      "longitude": -154.916667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVY?codeType=fs"
     },
     {
      "fs": "PVZ",
      "iata": "PVZ",
      "icao": "KPVZ",
      "faa": "PVZ",
      "name": "Casement Airport",
      "city": "Painesville",
      "cityCode": "PVZ",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.716667,
      "longitude": -81.25,
      "elevationFeet": 697,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PVZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PVZ?codeType=fs"
     },
     {
      "fs": "PWD",
      "iata": "PWD",
      "icao": "KPWD",
      "faa": "PWD",
      "name": "Sherwood Airport",
      "city": "Plentywood",
      "cityCode": "PWD",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.783333,
      "longitude": -104.566667,
      "elevationFeet": 2250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PWD?codeType=fs"
     },
     {
      "fs": "PWR",
      "iata": "PWR",
      "icao": "",
      "faa": "",
      "name": "Port Walter Sea Plane Base",
      "city": "Port Walter",
      "cityCode": "PWR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 56.382663,
      "longitude": -134.648359,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PWR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PWR?codeType=fs"
     },
     {
      "fs": "PXK",
      "iata": "",
      "icao": "",
      "faa": "PXK",
      "name": "Paxson",
      "city": "Paxson",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 63.095806,
      "longitude": -145.5055,
      "elevationFeet": 2653,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PXK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PXK?codeType=fs"
     },
     {
      "fs": "PXL",
      "iata": "PXL",
      "icao": "",
      "faa": "",
      "name": "Polacca Airport",
      "city": "Polacca",
      "cityCode": "PXL",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 35.8,
      "longitude": -110.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PXL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PXL?codeType=fs"
     },
     {
      "fs": "PYL",
      "iata": "PYL",
      "icao": "",
      "faa": "",
      "name": "Perry Island Sea Plane Base",
      "city": "Perry Island",
      "cityCode": "PYL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.685287,
      "longitude": -147.918736,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PYL?codeType=fs"
     },
     {
      "fs": "PYS",
      "iata": "PYS",
      "icao": "",
      "faa": "",
      "name": "Paradise Skypark",
      "city": "Paradise",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.710556,
      "longitude": -121.616389,
      "elevationFeet": 1313,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/PYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/PYS?codeType=fs"
     },
     {
      "fs": "Q00",
      "iata": "",
      "icao": "",
      "faa": "Q00",
      "name": "Littlefield Municipal",
      "city": "Littlefield",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.989528,
      "longitude": -102.416833,
      "elevationFeet": 3614,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q00?codeType=fs"
     },
     {
      "fs": "Q01",
      "iata": "",
      "icao": "",
      "faa": "Q01",
      "name": "Schneiders",
      "city": "Revere",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.653806,
      "longitude": -75.196194,
      "elevationFeet": 540,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q01?codeType=fs"
     },
     {
      "fs": "Q04",
      "iata": "",
      "icao": "",
      "faa": "Q04",
      "name": "Mountainair Municipal",
      "city": "Mountainair",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.533333,
      "longitude": -106.288889,
      "elevationFeet": 6492,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q04?codeType=fs"
     },
     {
      "fs": "Q05",
      "iata": "",
      "icao": "",
      "faa": "Q05",
      "name": "Salyer Farms",
      "city": "Corcoran",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.136722,
      "longitude": -119.616278,
      "elevationFeet": 205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q05?codeType=fs"
     },
     {
      "fs": "Q06",
      "iata": "",
      "icao": "",
      "faa": "Q06",
      "name": "City Of-Swisher Co Municipal",
      "city": "Tulia",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.56825,
      "longitude": -101.914611,
      "elevationFeet": 3503,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q06?codeType=fs"
     },
     {
      "fs": "Q07",
      "iata": "",
      "icao": "",
      "faa": "Q07",
      "name": "Stahl'S Mountain",
      "city": "Union Dale",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.878611,
      "longitude": -75.624056,
      "elevationFeet": 1950,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q07?codeType=fs"
     },
     {
      "fs": "Q08",
      "iata": "",
      "icao": "",
      "faa": "Q08",
      "name": "Smoketown",
      "city": "Smoketown",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.112083,
      "longitude": -76.213444,
      "elevationFeet": 370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q08?codeType=fs"
     },
     {
      "fs": "Q13",
      "iata": "",
      "icao": "",
      "faa": "Q13",
      "name": "Jewett Mesa",
      "city": "Apache Creek",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.033861,
      "longitude": -108.781222,
      "elevationFeet": 7681,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q13?codeType=fs"
     },
     {
      "fs": "Q16",
      "iata": "",
      "icao": "",
      "faa": "Q16",
      "name": "Reserve",
      "city": "Reserve",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.700556,
      "longitude": -108.856222,
      "elevationFeet": 6360,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q16?codeType=fs"
     },
     {
      "fs": "Q17",
      "iata": "",
      "icao": "",
      "faa": "Q17",
      "name": "Boonville",
      "city": "Boonville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.126778,
      "longitude": -123.527861,
      "elevationFeet": 371,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q17?codeType=fs"
     },
     {
      "fs": "Q19",
      "iata": "",
      "icao": "",
      "faa": "Q19",
      "name": "Aztec Municipal",
      "city": "Aztec",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 36.84725,
      "longitude": -108.134028,
      "elevationFeet": 5877,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q19?codeType=fs"
     },
     {
      "fs": "Q21",
      "iata": "",
      "icao": "",
      "faa": "Q21",
      "name": "Brownsville",
      "city": "Brownsville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.504444,
      "longitude": -121.363611,
      "elevationFeet": 2120,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q21?codeType=fs"
     },
     {
      "fs": "Q24",
      "iata": "",
      "icao": "",
      "faa": "Q24",
      "name": "Levelland Municipal",
      "city": "Levelland",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.577889,
      "longitude": -102.426028,
      "elevationFeet": 3514,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q24?codeType=fs"
     },
     {
      "fs": "Q25",
      "iata": "",
      "icao": "",
      "faa": "Q25",
      "name": "Dinsmore",
      "city": "Dinsmore",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.579194,
      "longitude": -123.747583,
      "elevationFeet": 2375,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q25?codeType=fs"
     },
     {
      "fs": "Q26",
      "iata": "",
      "icao": "",
      "faa": "Q26",
      "name": "Terry Co",
      "city": "Brownfield",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.23675,
      "longitude": -102.276222,
      "elevationFeet": 3263,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q26?codeType=fs"
     },
     {
      "fs": "Q31",
      "iata": "",
      "icao": "",
      "faa": "Q31",
      "name": "Sequoia",
      "city": "Visalia",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.585611,
      "longitude": -119.340056,
      "elevationFeet": 313,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q31?codeType=fs"
     },
     {
      "fs": "Q34",
      "iata": "",
      "icao": "",
      "faa": "Q34",
      "name": "Portales Municipal",
      "city": "Portales",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.254722,
      "longitude": -103.503333,
      "elevationFeet": 4078,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q34?codeType=fs"
     },
     {
      "fs": "Q35",
      "iata": "",
      "icao": "",
      "faa": "Q35",
      "name": "Springerville Babbitt",
      "city": "Springerville",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.154444,
      "longitude": -109.40025,
      "elevationFeet": 7051,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q35?codeType=fs"
     },
     {
      "fs": "Q37",
      "iata": "",
      "icao": "",
      "faa": "Q37",
      "name": "Carrizozo Municipal",
      "city": "Carrizozo",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.788611,
      "longitude": -106.006861,
      "elevationFeet": 5371,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q37?codeType=fs"
     },
     {
      "fs": "Q39",
      "iata": "",
      "icao": "",
      "faa": "Q39",
      "name": "Mineral Co Memorial",
      "city": "Creede",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 37.858333,
      "longitude": -107.061556,
      "elevationFeet": 8680,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q39?codeType=fs"
     },
     {
      "fs": "Q40",
      "iata": "",
      "icao": "",
      "faa": "Q40",
      "name": "Sunset Skyranch",
      "city": "Elk Grove",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.488,
      "longitude": -121.471722,
      "elevationFeet": 54,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q40?codeType=fs"
     },
     {
      "fs": "Q41",
      "iata": "",
      "icao": "",
      "faa": "Q41",
      "name": "Floydada Municipal",
      "city": "Floydada",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.023,
      "longitude": -101.454361,
      "elevationFeet": 3183,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q41?codeType=fs"
     },
     {
      "fs": "Q42",
      "iata": "",
      "icao": "",
      "faa": "Q42",
      "name": "Springer Municipal",
      "city": "Springer",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 36.419778,
      "longitude": -104.647111,
      "elevationFeet": 5891,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q42?codeType=fs"
     },
     {
      "fs": "Q43",
      "iata": "",
      "icao": "",
      "faa": "Q43",
      "name": "Sunray",
      "city": "Sunray",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.142028,
      "longitude": -101.937833,
      "elevationFeet": 3507,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q43?codeType=fs"
     },
     {
      "fs": "Q44",
      "iata": "",
      "icao": "",
      "faa": "Q44",
      "name": "Beaver Municipal",
      "city": "Beaver",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.939139,
      "longitude": -100.648722,
      "elevationFeet": 2491,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q44?codeType=fs"
     },
     {
      "fs": "Q49",
      "iata": "",
      "icao": "",
      "faa": "Q49",
      "name": "Firebaugh",
      "city": "Firebaugh",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.949889,
      "longitude": -120.594667,
      "elevationFeet": 157,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q49?codeType=fs"
     },
     {
      "fs": "Q53",
      "iata": "",
      "icao": "",
      "faa": "Q53",
      "name": "Franklin",
      "city": "Franklin",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.349139,
      "longitude": -121.54675,
      "elevationFeet": 21,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q53?codeType=fs"
     },
     {
      "fs": "Q54",
      "iata": "",
      "icao": "",
      "faa": "Q54",
      "name": "Benger",
      "city": "Friona",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.692333,
      "longitude": -102.768806,
      "elevationFeet": 4003,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q54?codeType=fs"
     },
     {
      "fs": "Q55",
      "iata": "",
      "icao": "",
      "faa": "Q55",
      "name": "Dimmitt Municipal",
      "city": "Dimmitt",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.567361,
      "longitude": -102.376944,
      "elevationFeet": 3883,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q55?codeType=fs"
     },
     {
      "fs": "Q58",
      "iata": "",
      "icao": "",
      "faa": "Q58",
      "name": "Santa Rosa Municipal",
      "city": "Santa Rosa",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.94425,
      "longitude": -104.730639,
      "elevationFeet": 4790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q58?codeType=fs"
     },
     {
      "fs": "Q60",
      "iata": "",
      "icao": "",
      "faa": "Q60",
      "name": "Sierra Sky Park",
      "city": "Fresno",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.90225,
      "longitude": -119.904278,
      "elevationFeet": 321,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q60?codeType=fs"
     },
     {
      "fs": "Q61",
      "iata": "",
      "icao": "",
      "faa": "Q61",
      "name": "Georgetown",
      "city": "Georgetown",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.961139,
      "longitude": -120.997944,
      "elevationFeet": 2623,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q61?codeType=fs"
     },
     {
      "fs": "Q68",
      "iata": "",
      "icao": "",
      "faa": "Q68",
      "name": "Pine Mountain Lake",
      "city": "Groveland",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.966667,
      "longitude": -120.278889,
      "elevationFeet": 2930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q68?codeType=fs"
     },
     {
      "fs": "Q69",
      "iata": "",
      "icao": "",
      "faa": "Q69",
      "name": "Ocean Ridge",
      "city": "Gualala",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.813056,
      "longitude": -123.652778,
      "elevationFeet": 940,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q69?codeType=fs"
     },
     {
      "fs": "Q70",
      "iata": "",
      "icao": "",
      "faa": "Q70",
      "name": "Stratford",
      "city": "Stratford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.456389,
      "longitude": -102.1925,
      "elevationFeet": 3668,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q70?codeType=fs"
     },
     {
      "fs": "Q72",
      "iata": "",
      "icao": "",
      "faa": "Q72",
      "name": "Hayfork",
      "city": "Hayfork",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.670889,
      "longitude": -123.316944,
      "elevationFeet": 2321,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q72?codeType=fs"
     },
     {
      "fs": "Q73",
      "iata": "",
      "icao": "",
      "faa": "Q73",
      "name": "Herlong",
      "city": "Herlong",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.187917,
      "longitude": -120.288194,
      "elevationFeet": 4055,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q73?codeType=fs"
     },
     {
      "fs": "Q75",
      "iata": "",
      "icao": "",
      "faa": "Q75",
      "name": "Hyampom",
      "city": "Hyampom",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.726417,
      "longitude": -123.505917,
      "elevationFeet": 1250,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q75?codeType=fs"
     },
     {
      "fs": "Q82",
      "iata": "",
      "icao": "",
      "faa": "Q82",
      "name": "Alpine Co",
      "city": "Markleeville",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.760167,
      "longitude": -119.912861,
      "elevationFeet": 5867,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q82?codeType=fs"
     },
     {
      "fs": "Q84",
      "iata": "",
      "icao": "",
      "faa": "Q84",
      "name": "Mendota",
      "city": "Mendota",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.830056,
      "longitude": -120.412806,
      "elevationFeet": 162,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q84?codeType=fs"
     },
     {
      "fs": "Q88",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Paradise Skypark",
      "city": "Paradise",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 39.796056,
      "longitude": -121.763611,
      "elevationFeet": 1300,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q88?codeType=fs"
     },
     {
      "fs": "Q94",
      "iata": "",
      "icao": "",
      "faa": "Q94",
      "name": "Rio Linda Airport",
      "city": "Rio Linda",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.673699,
      "longitude": -121.443453,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q94?codeType=fs"
     },
     {
      "fs": "Q95",
      "iata": "",
      "icao": "",
      "faa": "Q95",
      "name": "Ruth",
      "city": "Ruth",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.3125,
      "longitude": -123.425278,
      "elevationFeet": 2781,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q95?codeType=fs"
     },
     {
      "fs": "Q96",
      "iata": "",
      "icao": "",
      "faa": "Q96",
      "name": "Natomas Airport",
      "city": "Sacramento",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.638388,
      "longitude": -121.516581,
      "elevationFeet": 21,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q96?codeType=fs"
     },
     {
      "fs": "Q98",
      "iata": "",
      "icao": "",
      "faa": "Q98",
      "name": "San Ardo",
      "city": "San Ardo",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 36.11075,
      "longitude": -120.976833,
      "elevationFeet": 441,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q98?codeType=fs"
     },
     {
      "fs": "Q99",
      "iata": "",
      "icao": "",
      "faa": "Q99",
      "name": "South Co Of Santa Clara Co",
      "city": "San Martin",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 37.215861,
      "longitude": -121.720833,
      "elevationFeet": 281,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Q99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Q99?codeType=fs"
     },
     {
      "fs": "QMV",
      "iata": "QMV",
      "icao": "",
      "faa": "",
      "name": "Montvale Airport",
      "city": "Montvale",
      "cityCode": "QMV",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.033333,
      "longitude": -74.016667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/QMV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/QMV?codeType=fs"
     },
     {
      "fs": "QNY",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Skyports Seaplane Base",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.740053,
      "longitude": -73.968161,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/QNY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/QNY?codeType=fs"
     },
     {
      "fs": "QWG",
      "iata": "QWG",
      "icao": "",
      "faa": "8A6",
      "name": "Wilgrove Air Park",
      "city": "Charlotte",
      "cityCode": "CLT",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 35.213799,
      "longitude": -80.670097,
      "elevationFeet": 799,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/QWG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/QWG?codeType=fs"
     },
     {
      "fs": "R03",
      "iata": "",
      "icao": "",
      "faa": "R03",
      "name": "Alkali Lake State",
      "city": "Alkali Lake",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 43.123722,
      "longitude": -120.060722,
      "elevationFeet": 4312,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/R03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/R03?codeType=fs"
     },
     {
      "fs": "R33",
      "iata": "",
      "icao": "",
      "faa": "R33",
      "name": "Wakonda Beach State",
      "city": "Waldport",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 44.395639,
      "longitude": -124.101194,
      "elevationFeet": 41,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/R33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/R33?codeType=fs"
     },
     {
      "fs": "R47",
      "iata": "",
      "icao": "",
      "faa": "R47",
      "name": "Ruhe'S",
      "city": "Leipsic",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.131111,
      "longitude": -84.068889,
      "elevationFeet": 801,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/R47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/R47?codeType=fs"
     },
     {
      "fs": "R49",
      "iata": "",
      "icao": "",
      "faa": "R49",
      "name": "Ferry Co",
      "city": "Republic",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.732222,
      "longitude": -118.711361,
      "elevationFeet": 2519,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/R49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/R49?codeType=fs"
     },
     {
      "fs": "RAC",
      "iata": "RAC",
      "icao": "KRAC",
      "faa": "RAC",
      "name": "Horlick Airport",
      "city": "Racine",
      "cityCode": "RAC",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 42.683333,
      "longitude": -87.85,
      "elevationFeet": 674,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RAC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RAC?codeType=fs"
     },
     {
      "fs": "RAL",
      "iata": "RAL",
      "icao": "KRAL",
      "faa": "RAL",
      "name": "Riverside Municipal Airport",
      "city": "Riverside",
      "cityCode": "RAL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 33.951667,
      "longitude": -117.442222,
      "elevationFeet": 818,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RAL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RAL?codeType=fs"
     },
     {
      "fs": "RBF",
      "iata": "RBF",
      "icao": "",
      "faa": "L35",
      "name": "Big Bear City Airport",
      "city": "Big Bear",
      "cityCode": "RBF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 34.266667,
      "longitude": -116.85,
      "elevationFeet": 6748,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBF?codeType=fs"
     },
     {
      "fs": "RBN",
      "iata": "RBN",
      "icao": "",
      "faa": "",
      "name": "Fort Jefferson Airport",
      "city": "Fort Jefferson",
      "cityCode": "RBN",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 24.616667,
      "longitude": -82.866667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RBN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RBN?codeType=fs"
     },
     {
      "fs": "RCK",
      "iata": "RCK",
      "icao": "KRCK",
      "faa": "RCK",
      "name": "Coffield Airport",
      "city": "Rockdale",
      "cityCode": "RCK",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.65,
      "longitude": -97,
      "elevationFeet": 474,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RCK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RCK?codeType=fs"
     },
     {
      "fs": "RCR",
      "iata": "RCR",
      "icao": "KRCR",
      "faa": "RCR",
      "name": "Fulton County Airport",
      "city": "Rochester",
      "cityCode": "RCR",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.066667,
      "longitude": -86.216667,
      "elevationFeet": 790,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RCR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RCR?codeType=fs"
     },
     {
      "fs": "RCT",
      "iata": "RCT",
      "icao": "KRCT",
      "faa": "RCT",
      "name": "Nartron Field",
      "city": "Reed City",
      "cityCode": "RCT",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 43.899998,
      "longitude": -85.51579,
      "elevationFeet": 1039,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RCT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RCT?codeType=fs"
     },
     {
      "fs": "RDR",
      "iata": "RDR",
      "icao": "KRDR",
      "faa": "RDR",
      "name": "Grand Forks Air Force Base",
      "city": "Red River",
      "cityCode": "RDR",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 47.961307,
      "longitude": -97.400751,
      "elevationFeet": 907,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RDR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RDR?codeType=fs"
     },
     {
      "fs": "RED",
      "iata": "RED",
      "icao": "KRVL",
      "faa": "RVL",
      "name": "Mifflin County Airport",
      "city": "Reedsville",
      "cityCode": "RED",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.683333,
      "longitude": -77.616667,
      "elevationFeet": 819,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RED?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RED?codeType=fs"
     },
     {
      "fs": "REE",
      "iata": "REE",
      "icao": "",
      "faa": "",
      "name": "Reese Air Force Base",
      "city": "Lubbock",
      "cityCode": "LBB",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.583333,
      "longitude": -101.85,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/REE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/REE?codeType=fs"
     },
     {
      "fs": "REH",
      "iata": "REH",
      "icao": "",
      "faa": "",
      "name": "Rehoboth Beach Airport",
      "city": "Rehoboth Beach",
      "cityCode": "REH",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 38.7,
      "longitude": -75.1,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/REH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/REH?codeType=fs"
     },
     {
      "fs": "REO",
      "iata": "REO",
      "icao": "KREO",
      "faa": "REO",
      "name": "Rome State Airport",
      "city": "Rome",
      "cityCode": "REO",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 42.577778,
      "longitude": -117.885556,
      "elevationFeet": 4054,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/REO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/REO?codeType=fs"
     },
     {
      "fs": "RFG",
      "iata": "RFG",
      "icao": "KRFG",
      "faa": "RFG",
      "name": "Rooke Field",
      "city": "Refugio",
      "cityCode": "RFG",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.2934,
      "longitude": -97.324458,
      "elevationFeet": 57,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RFG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RFG?codeType=fs"
     },
     {
      "fs": "RFK",
      "iata": "RFK",
      "icao": "",
      "faa": "",
      "name": "Rollang Field",
      "city": "Rolling Fork",
      "cityCode": "RFK",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.95433,
      "longitude": -90.845098,
      "elevationFeet": 103,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RFK?codeType=fs"
     },
     {
      "fs": "RGR",
      "iata": "RGR",
      "icao": "",
      "faa": "F23",
      "name": "Ranger Municipal Airport",
      "city": "Ranger",
      "cityCode": "RGR",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.466667,
      "longitude": -98.683333,
      "elevationFeet": 1470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RGR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RGR?codeType=fs"
     },
     {
      "fs": "RID",
      "iata": "RID",
      "icao": "KRID",
      "faa": "RID",
      "name": "Richmond Airport",
      "city": "Richmond",
      "cityCode": "RID",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39.833333,
      "longitude": -84.9,
      "elevationFeet": 1140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RID?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RID?codeType=fs"
     },
     {
      "fs": "RIF",
      "iata": "RIF",
      "icao": "KRIF",
      "faa": "RIF",
      "name": "Reynolds Airport",
      "city": "Richfield",
      "cityCode": "RIF",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 38.741111,
      "longitude": -112.094444,
      "elevationFeet": 5301,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIF?codeType=fs"
     },
     {
      "fs": "RIR",
      "iata": "RIR",
      "icao": "KRIR",
      "faa": "RIR",
      "name": "Riverside Flabob Airport",
      "city": "Riverside",
      "cityCode": "RAL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 33.988828,
      "longitude": -117.409042,
      "elevationFeet": 759,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RIR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RIR?codeType=fs"
     },
     {
      "fs": "RKC",
      "iata": "RKC",
      "icao": "",
      "faa": "",
      "name": "Yreka Airport",
      "city": "Yreka",
      "cityCode": "RKC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.733333,
      "longitude": -122.633333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKC?codeType=fs"
     },
     {
      "fs": "RKP",
      "iata": "RKP",
      "icao": "KRKP",
      "faa": "RKP",
      "name": "Aransas County Airport",
      "city": "Rockport",
      "cityCode": "RKP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.033333,
      "longitude": -97.05,
      "elevationFeet": 24,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKP?codeType=fs"
     },
     {
      "fs": "RKR",
      "iata": "RKR",
      "icao": "KRKR",
      "faa": "RKR",
      "name": "Robert S. Kerr Airport",
      "city": "Poteau",
      "cityCode": "RKR",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.05,
      "longitude": -94.616667,
      "elevationFeet": 451,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKR?codeType=fs"
     },
     {
      "fs": "RKW",
      "iata": "RKW",
      "icao": "KRKW",
      "faa": "RKW",
      "name": "Rockwood Municipal Airport",
      "city": "Rockwood",
      "cityCode": "RKW",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 35.866667,
      "longitude": -84.683333,
      "elevationFeet": 1664,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RKW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RKW?codeType=fs"
     },
     {
      "fs": "RLI",
      "iata": "RLI",
      "icao": "",
      "faa": "",
      "name": "Reilly Army Heliport",
      "city": "Anniston",
      "cityCode": "ANB",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.666667,
      "longitude": -85.85,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RLI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RLI?codeType=fs"
     },
     {
      "fs": "RLU",
      "iata": "RLU",
      "icao": "",
      "faa": "",
      "name": "Bornite Upper Airport",
      "city": "Bornite",
      "cityCode": "RLU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 67.75,
      "longitude": -156,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RLU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RLU?codeType=fs"
     },
     {
      "fs": "RMC",
      "iata": "RMC",
      "icao": "",
      "faa": "",
      "name": "Machesney Airport",
      "city": "Rockford",
      "cityCode": "RFD",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 42.266667,
      "longitude": -89.1,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RMC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RMC?codeType=fs"
     },
     {
      "fs": "RNC",
      "iata": "RNC",
      "icao": "KRNC",
      "faa": "RNC",
      "name": "Warren County Memorial Airport",
      "city": "McMinnville",
      "cityCode": "RNC",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.698566,
      "longitude": -85.843808,
      "elevationFeet": 1016,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RNC?codeType=fs"
     },
     {
      "fs": "RNH",
      "iata": "RNH",
      "icao": "KRNH",
      "faa": "RNH",
      "name": "New Richmond Municipal Airport",
      "city": "New Richmond",
      "cityCode": "RNH",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 45.133333,
      "longitude": -92.55,
      "elevationFeet": 996,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RNH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RNH?codeType=fs"
     },
     {
      "fs": "RNZ",
      "iata": "RNZ",
      "icao": "KRZL",
      "faa": "RZL",
      "name": "Rensselaer Airport",
      "city": "Rensselaer",
      "cityCode": "RNZ",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 40.95,
      "longitude": -87.15,
      "elevationFeet": 698,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RNZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RNZ?codeType=fs"
     },
     {
      "fs": "ROL",
      "iata": "ROL",
      "icao": "",
      "faa": "74V",
      "name": "Roosevelt Airport",
      "city": "Roosevelt",
      "cityCode": "ROL",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 40.3,
      "longitude": -109.983333,
      "elevationFeet": 5172,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ROL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ROL?codeType=fs"
     },
     {
      "fs": "RPX",
      "iata": "RPX",
      "icao": "KRPX",
      "faa": "RPX",
      "name": "Roundup Airport",
      "city": "Roundup",
      "cityCode": "RPX",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 46.433333,
      "longitude": -108.533333,
      "elevationFeet": 3485,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RPX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RPX?codeType=fs"
     },
     {
      "fs": "RRL",
      "iata": "RRL",
      "icao": "KRRL",
      "faa": "RRL",
      "name": "Merrill Municipal Airport",
      "city": "Merrill",
      "cityCode": "RRL",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 45.183333,
      "longitude": -89.683333,
      "elevationFeet": 1317,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RRL?codeType=fs"
     },
     {
      "fs": "RRT",
      "iata": "RRT",
      "icao": "KRRT",
      "faa": "RRT",
      "name": "Warroad Airport",
      "city": "Warroad",
      "cityCode": "RRT",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 48.9,
      "longitude": -95.3,
      "elevationFeet": 1074,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RRT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RRT?codeType=fs"
     },
     {
      "fs": "RSL",
      "iata": "RSL",
      "icao": "KRSL",
      "faa": "RSL",
      "name": "Russell Airport",
      "city": "Russell",
      "cityCode": "RSL",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 38.883333,
      "longitude": -98.85,
      "elevationFeet": 1862,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSL?codeType=fs"
     },
     {
      "fs": "RSN",
      "iata": "RSN",
      "icao": "KRSN",
      "faa": "RSN",
      "name": "Ruston Airport",
      "city": "Ruston",
      "cityCode": "RSN",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.516667,
      "longitude": -92.633333,
      "elevationFeet": 311,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSN?codeType=fs"
     },
     {
      "fs": "RSP",
      "iata": "RSP",
      "icao": "",
      "faa": "",
      "name": "Raspberry Strait Airport",
      "city": "Raspberry Strait",
      "cityCode": "RSP",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 58.166667,
      "longitude": -154.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSP?codeType=fs"
     },
     {
      "fs": "RSX",
      "iata": "RSX",
      "icao": "",
      "faa": "",
      "name": "Rouses Point Sea Plane Base",
      "city": "Rouses Point",
      "cityCode": "RSX",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 44.991934,
      "longitude": -73.362757,
      "elevationFeet": 92,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RSX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RSX?codeType=fs"
     },
     {
      "fs": "RTD",
      "iata": "RTD",
      "icao": "",
      "faa": "",
      "name": "Rotunda Airport",
      "city": "Rotunda",
      "cityCode": "RTD",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 26.866667,
      "longitude": -82.266667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RTD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RTD?codeType=fs"
     },
     {
      "fs": "RTE",
      "icao": "",
      "faa": "",
      "name": "Marguerite Bay Airport",
      "city": "Marguerite Bay",
      "cityCode": "",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 55.7,
      "longitude": -131.633333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RTE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RTE?codeType=fs"
     },
     {
      "fs": "RTL",
      "iata": "RTL",
      "icao": "",
      "faa": "0F3",
      "name": "Spirit Lake Airport",
      "city": "Spirit Lake",
      "cityCode": "RTL",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 47.95,
      "longitude": -116.866667,
      "elevationFeet": 1434,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RTL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RTL?codeType=fs"
     },
     {
      "fs": "RTN",
      "iata": "RTN",
      "icao": "KRTN",
      "faa": "RTN",
      "name": "Crews Field",
      "city": "Raton",
      "cityCode": "RTN",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 36.741389,
      "longitude": -104.501111,
      "elevationFeet": 6352,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RTN?codeType=fs"
     },
     {
      "fs": "RUI",
      "iata": "RUI",
      "icao": "KSRR",
      "faa": "SRR",
      "name": "Ruidoso Municipal Airport",
      "city": "Ruidoso",
      "cityCode": "RUI",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.360833,
      "longitude": -105.6625,
      "elevationFeet": 6814,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RUI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RUI?codeType=fs"
     },
     {
      "fs": "RVR",
      "iata": "RVR",
      "icao": "",
      "faa": "U34",
      "name": "Green River Airport",
      "city": "Green River",
      "cityCode": "RVR",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 38.966667,
      "longitude": -110.25,
      "elevationFeet": 4225,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RVR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RVR?codeType=fs"
     },
     {
      "fs": "RWB",
      "iata": "RWB",
      "icao": "",
      "faa": "",
      "name": "Rowan Bay Airport",
      "city": "Rowan Bay",
      "cityCode": "RWB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 56.75,
      "longitude": -134.133333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RWB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RWB?codeType=fs"
     },
     {
      "fs": "RWF",
      "iata": "RWF",
      "icao": "KRWF",
      "faa": "RWF",
      "name": "Redwood Falls Municipal Airport",
      "city": "Redwood Falls",
      "cityCode": "RWF",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 44.5,
      "longitude": -95.1,
      "elevationFeet": 1023,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RWF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RWF?codeType=fs"
     },
     {
      "fs": "RZZ",
      "iata": "RZZ",
      "icao": "KRZZ",
      "faa": "RZZ",
      "name": "Halifax County Airport",
      "city": "Roanoke Rapids",
      "cityCode": "RZZ",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 36.466667,
      "longitude": -77.666667,
      "elevationFeet": 256,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/RZZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/RZZ?codeType=fs"
     },
     {
      "fs": "S00",
      "iata": "",
      "icao": "",
      "faa": "S00",
      "name": "Opheim",
      "city": "Opheim",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.866917,
      "longitude": -106.422528,
      "elevationFeet": 3264,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S00?codeType=fs"
     },
     {
      "fs": "S01",
      "iata": "",
      "icao": "",
      "faa": "S01",
      "name": "Conrad",
      "city": "Conrad",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.186389,
      "longitude": -112.064722,
      "elevationFeet": 3545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S01?codeType=fs"
     },
     {
      "fs": "S03",
      "iata": "",
      "icao": "",
      "faa": "S03",
      "name": "Ashland Mun-Parker",
      "city": "Ashland",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 42.252833,
      "longitude": -122.756278,
      "elevationFeet": 1885,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S03?codeType=fs"
     },
     {
      "fs": "S04",
      "iata": "",
      "icao": "",
      "faa": "S04",
      "name": "Condon Usfs",
      "city": "Condon",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 47.58825,
      "longitude": -113.753694,
      "elevationFeet": 3686,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S04?codeType=fs"
     },
     {
      "fs": "S09",
      "iata": "",
      "icao": "",
      "faa": "S09",
      "name": "Hot Springs",
      "city": "Hot Springs",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 47.724361,
      "longitude": -114.734639,
      "elevationFeet": 2763,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S09?codeType=fs"
     },
     {
      "fs": "S10",
      "iata": "",
      "icao": "",
      "faa": "S10",
      "name": "Chelan Municipal",
      "city": "Chelan",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.009722,
      "longitude": -120.027056,
      "elevationFeet": 1263,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S10?codeType=fs"
     },
     {
      "fs": "S12",
      "iata": "",
      "icao": "",
      "faa": "S12",
      "name": "Albany Municipal",
      "city": "Albany",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 44.678167,
      "longitude": -123.1445,
      "elevationFeet": 226,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S12?codeType=fs"
     },
     {
      "fs": "S13",
      "iata": "",
      "icao": "",
      "faa": "S13",
      "name": "Martha Lake",
      "city": "Alderwood Manor",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.973194,
      "longitude": -122.279083,
      "elevationFeet": 500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S13?codeType=fs"
     },
     {
      "fs": "S16",
      "iata": "",
      "icao": "",
      "faa": "S16",
      "name": "Copalis State",
      "city": "Copalis",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.198083,
      "longitude": -124.196222,
      "elevationFeet": 1,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S16?codeType=fs"
     },
     {
      "fs": "S17",
      "iata": "",
      "icao": "",
      "faa": "S17",
      "name": "Twin Lakes",
      "city": "Graniteville",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 33.756917,
      "longitude": -81.870556,
      "elevationFeet": 540,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S17?codeType=fs"
     },
     {
      "fs": "S18",
      "iata": "",
      "icao": "",
      "faa": "S18",
      "name": "Forks",
      "city": "Forks",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.014667,
      "longitude": -124.479861,
      "elevationFeet": 296,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S18?codeType=fs"
     },
     {
      "fs": "S19",
      "iata": "",
      "icao": "",
      "faa": "S19",
      "name": "Mc Cormick Co",
      "city": "Mc Cormick",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 33.980972,
      "longitude": -82.269306,
      "elevationFeet": 459,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S19?codeType=fs"
     },
     {
      "fs": "S20",
      "iata": "",
      "icao": "",
      "faa": "S20",
      "name": "Goldendale",
      "city": "Goldendale",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 45.956806,
      "longitude": -120.875639,
      "elevationFeet": 1660,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S20?codeType=fs"
     },
     {
      "fs": "S23",
      "iata": "",
      "icao": "",
      "faa": "S23",
      "name": "Ione Municipal",
      "city": "Ione",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.77275,
      "longitude": -117.526028,
      "elevationFeet": 2107,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S23?codeType=fs"
     },
     {
      "fs": "S24",
      "iata": "",
      "icao": "",
      "faa": "S24",
      "name": "Sandusky County Regional Airport",
      "city": "Fremont",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.306565,
      "longitude": -83.01603,
      "elevationFeet": 651,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S24?codeType=fs"
     },
     {
      "fs": "S25",
      "iata": "",
      "icao": "",
      "faa": "S25",
      "name": "Watford City Municipal",
      "city": "Watford City",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 47.907,
      "longitude": -103.287,
      "elevationFeet": 2109,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S25?codeType=fs"
     },
     {
      "fs": "S26",
      "iata": "",
      "icao": "",
      "faa": "S26",
      "name": "Skywest Airpark",
      "city": "Mobile",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.68525,
      "longitude": -88.419556,
      "elevationFeet": 150,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S26?codeType=fs"
     },
     {
      "fs": "S27",
      "iata": "",
      "icao": "",
      "faa": "S27",
      "name": "Kalispell City",
      "city": "Kalispell",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.285694,
      "longitude": -114.337417,
      "elevationFeet": 2932,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S27?codeType=fs"
     },
     {
      "fs": "S28",
      "iata": "",
      "icao": "",
      "faa": "S28",
      "name": "International Peace Garden",
      "city": "Dunseith",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 49.127833,
      "longitude": -100.134583,
      "elevationFeet": 2314,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S28?codeType=fs"
     },
     {
      "fs": "S30",
      "iata": "",
      "icao": "",
      "faa": "S30",
      "name": "Lebanon State",
      "city": "Lebanon",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 44.648444,
      "longitude": -123.045333,
      "elevationFeet": 344,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S30?codeType=fs"
     },
     {
      "fs": "S32",
      "iata": "",
      "icao": "",
      "faa": "S32",
      "name": "Cooperstown Municipal",
      "city": "Cooperstown",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 47.477722,
      "longitude": -98.158722,
      "elevationFeet": 1424,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S32?codeType=fs"
     },
     {
      "fs": "S34",
      "iata": "",
      "icao": "",
      "faa": "S34",
      "name": "Plains",
      "city": "Plains",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 47.524361,
      "longitude": -114.901361,
      "elevationFeet": 2462,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S34?codeType=fs"
     },
     {
      "fs": "S35",
      "iata": "",
      "icao": "",
      "faa": "S35",
      "name": "Okanogan Legion",
      "city": "Okanogan",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.473722,
      "longitude": -119.578306,
      "elevationFeet": 1043,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S35?codeType=fs"
     },
     {
      "fs": "S36",
      "iata": "",
      "icao": "",
      "faa": "S36",
      "name": "Crest",
      "city": "Kent",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.373222,
      "longitude": -122.1345,
      "elevationFeet": 466,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S36?codeType=fs"
     },
     {
      "fs": "S40",
      "iata": "",
      "icao": "",
      "faa": "S40",
      "name": "Prosser",
      "city": "Prosser",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.323556,
      "longitude": -119.878111,
      "elevationFeet": 694,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S40?codeType=fs"
     },
     {
      "fs": "S43",
      "iata": "",
      "icao": "",
      "faa": "S43",
      "name": "Harvey",
      "city": "Snohomish",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.905,
      "longitude": -122.1022,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S43?codeType=fs"
     },
     {
      "fs": "S44",
      "iata": "",
      "icao": "",
      "faa": "S44",
      "name": "Spanaway",
      "city": "Spanaway",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.118778,
      "longitude": -122.564,
      "elevationFeet": 373,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S44?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S44?codeType=fs"
     },
     {
      "fs": "S45",
      "iata": "",
      "icao": "",
      "faa": "S45",
      "name": "Siletz Bay State",
      "city": "Gleneden Beach",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 44.976111,
      "longitude": -124.134472,
      "elevationFeet": 62,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S45?codeType=fs"
     },
     {
      "fs": "S48",
      "iata": "",
      "icao": "",
      "faa": "S48",
      "name": "Country Squire",
      "city": "Sandy",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 45.394444,
      "longitude": -122.280556,
      "elevationFeet": 1175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S48?codeType=fs"
     },
     {
      "fs": "S49",
      "iata": "",
      "icao": "",
      "faa": "S49",
      "name": "Miller Memorial",
      "city": "Vale",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.087722,
      "longitude": -117.343417,
      "elevationFeet": 2249,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S49?codeType=fs"
     },
     {
      "fs": "S50",
      "iata": "",
      "icao": "",
      "faa": "S50",
      "name": "Auburn Municipal Airport",
      "city": "Auburn",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.326861,
      "longitude": -122.224745,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S50?codeType=fs"
     },
     {
      "fs": "S51",
      "iata": "",
      "icao": "",
      "faa": "S51",
      "name": "Mc Beth",
      "city": "Klamath Glen",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.620667,
      "longitude": -124.106278,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S51?codeType=fs"
     },
     {
      "fs": "S52",
      "iata": "",
      "icao": "",
      "faa": "S52",
      "name": "Methow Valley State",
      "city": "Winthrop",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.456944,
      "longitude": -120.270278,
      "elevationFeet": 1694,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S52?codeType=fs"
     },
     {
      "fs": "S59",
      "iata": "",
      "icao": "",
      "faa": "S59",
      "name": "Libby",
      "city": "Libby",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.288444,
      "longitude": -115.552444,
      "elevationFeet": 2601,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S59?codeType=fs"
     },
     {
      "fs": "S62",
      "iata": "",
      "icao": "",
      "faa": "S62",
      "name": "Silverwood",
      "city": "Athol",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.982389,
      "longitude": -116.793611,
      "elevationFeet": 2350,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S62?codeType=fs"
     },
     {
      "fs": "S63",
      "iata": "",
      "icao": "",
      "faa": "S63",
      "name": "Skyharbor",
      "city": "Selma",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.368056,
      "longitude": -87.141583,
      "elevationFeet": 125,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S63?codeType=fs"
     },
     {
      "fs": "S64",
      "iata": "",
      "icao": "",
      "faa": "S64",
      "name": "Stanford",
      "city": "Stanford",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 47.271889,
      "longitude": -110.349278,
      "elevationFeet": 4329,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S64?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S64?codeType=fs"
     },
     {
      "fs": "S66",
      "iata": "",
      "icao": "",
      "faa": "S66",
      "name": "Homedale Municipal",
      "city": "Homedale",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 43.748806,
      "longitude": -116.965361,
      "elevationFeet": 2210,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S66?codeType=fs"
     },
     {
      "fs": "S67",
      "iata": "",
      "icao": "",
      "faa": "S67",
      "name": "Nampa Municipal",
      "city": "Nampa",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 43.713333,
      "longitude": -116.580556,
      "elevationFeet": 2537,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S67?codeType=fs"
     },
     {
      "fs": "S68",
      "iata": "",
      "icao": "",
      "faa": "S68",
      "name": "Orofino Municipal",
      "city": "Orofino",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.562917,
      "longitude": -116.368056,
      "elevationFeet": 1005,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S68?codeType=fs"
     },
     {
      "fs": "S69",
      "iata": "",
      "icao": "",
      "faa": "S69",
      "name": "Lincoln",
      "city": "Lincoln",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 46.991667,
      "longitude": -112.702778,
      "elevationFeet": 4597,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S69?codeType=fs"
     },
     {
      "fs": "S70",
      "iata": "",
      "icao": "",
      "faa": "S70",
      "name": "Othello Municipal",
      "city": "Othello",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.898639,
      "longitude": -119.202861,
      "elevationFeet": 1145,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S70?codeType=fs"
     },
     {
      "fs": "S71",
      "iata": "",
      "icao": "",
      "faa": "S71",
      "name": "Obie",
      "city": "Chinook",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.669444,
      "longitude": -109.388889,
      "elevationFeet": 2413,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S71?codeType=fs"
     },
     {
      "fs": "S72",
      "iata": "",
      "icao": "",
      "faa": "S72",
      "name": "St Maries Municipal",
      "city": "St Maries",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.426861,
      "longitude": -116.673917,
      "elevationFeet": 2127,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S72?codeType=fs"
     },
     {
      "fs": "S73",
      "iata": "",
      "icao": "",
      "faa": "S73",
      "name": "Kamiah Municipal",
      "city": "Kamiah",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.243417,
      "longitude": -116.13475,
      "elevationFeet": 1194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S73?codeType=fs"
     },
     {
      "fs": "S75",
      "iata": "",
      "icao": "",
      "faa": "S75",
      "name": "Payette Municipal",
      "city": "Payette",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.165528,
      "longitude": -116.909917,
      "elevationFeet": 2228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S75?codeType=fs"
     },
     {
      "fs": "S77",
      "iata": "",
      "icao": "",
      "faa": "S77",
      "name": "Magee",
      "city": "Coeur D'Alene",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.874167,
      "longitude": -116.385139,
      "elevationFeet": 3002,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S77?codeType=fs"
     },
     {
      "fs": "S78",
      "iata": "",
      "icao": "",
      "faa": "S78",
      "name": "Emmett Municipal",
      "city": "Emmett",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 43.998861,
      "longitude": -116.626361,
      "elevationFeet": 2350,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S78?codeType=fs"
     },
     {
      "fs": "S79",
      "iata": "",
      "icao": "",
      "faa": "S79",
      "name": "Green Sea",
      "city": "Green Sea",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 34.205556,
      "longitude": -79.055889,
      "elevationFeet": 95,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S79?codeType=fs"
     },
     {
      "fs": "S80",
      "iata": "",
      "icao": "",
      "faa": "S80",
      "name": "Idaho Co",
      "city": "Grangeville",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.025583,
      "longitude": -116.184167,
      "elevationFeet": 3310,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S80?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S80?codeType=fs"
     },
     {
      "fs": "S81",
      "iata": "",
      "icao": "",
      "faa": "S81",
      "name": "Indian Creek Usfs",
      "city": "Indian Creek",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.862972,
      "longitude": -115.173222,
      "elevationFeet": 4701,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S81?codeType=fs"
     },
     {
      "fs": "S82",
      "iata": "",
      "icao": "",
      "faa": "S82",
      "name": "Kooskia Municipal",
      "city": "Kooskia",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.276722,
      "longitude": -116.087528,
      "elevationFeet": 1263,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S82?codeType=fs"
     },
     {
      "fs": "S83",
      "iata": "",
      "icao": "",
      "faa": "S83",
      "name": "Shoshone Co",
      "city": "Kellogg",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.677,
      "longitude": -116.235,
      "elevationFeet": 2223,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S83?codeType=fs"
     },
     {
      "fs": "S84",
      "iata": "",
      "icao": "",
      "faa": "S84",
      "name": "Cottonwood Municipal",
      "city": "Cottonwood",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.087694,
      "longitude": -116.465333,
      "elevationFeet": 3474,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S84?codeType=fs"
     },
     {
      "fs": "S85",
      "iata": "",
      "icao": "",
      "faa": "S85",
      "name": "Big Sky",
      "city": "Culbertson",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.183333,
      "longitude": -104.538889,
      "elevationFeet": 1954,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S85?codeType=fs"
     },
     {
      "fs": "S86",
      "iata": "",
      "icao": "",
      "faa": "S86",
      "name": "Sky Harbor",
      "city": "Sultan",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.906583,
      "longitude": -121.873417,
      "elevationFeet": 282,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S86?codeType=fs"
     },
     {
      "fs": "S87",
      "iata": "",
      "icao": "",
      "faa": "S87",
      "name": "Weiser Municipal",
      "city": "Weiser",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.268306,
      "longitude": -117.073861,
      "elevationFeet": 2112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S87?codeType=fs"
     },
     {
      "fs": "S88",
      "iata": "",
      "icao": "",
      "faa": "S88",
      "name": "Skykomish State",
      "city": "Skykomish",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.811111,
      "longitude": -121.386111,
      "elevationFeet": 998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S88?codeType=fs"
     },
     {
      "fs": "S89",
      "iata": "",
      "icao": "",
      "faa": "S89",
      "name": "Craigmont Municipal",
      "city": "Craigmont",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.371083,
      "longitude": -116.601444,
      "elevationFeet": 3805,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S89?codeType=fs"
     },
     {
      "fs": "S90",
      "iata": "",
      "icao": "",
      "faa": "S90",
      "name": "Elk City",
      "city": "Elk City",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 45.876861,
      "longitude": -115.4985,
      "elevationFeet": 4097,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S90?codeType=fs"
     },
     {
      "fs": "S92",
      "iata": "",
      "icao": "",
      "faa": "S92",
      "name": "Fish Lake Usfs",
      "city": "Fish Lake",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.451944,
      "longitude": -115.18175,
      "elevationFeet": 5646,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S92?codeType=fs"
     },
     {
      "fs": "S93",
      "iata": "",
      "icao": "",
      "faa": "S93",
      "name": "Cle Elum Municipal Airport",
      "city": "Cle Elum",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.195069,
      "longitude": -120.883515,
      "elevationFeet": 1956,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S93?codeType=fs"
     },
     {
      "fs": "S94",
      "iata": "",
      "icao": "",
      "faa": "S94",
      "name": "Whitman Co Memorial",
      "city": "Colfax",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.934972,
      "longitude": -117.537972,
      "elevationFeet": 2171,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S94?codeType=fs"
     },
     {
      "fs": "S95",
      "iata": "",
      "icao": "",
      "faa": "S95",
      "name": "Martin",
      "city": "College Place",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.156917,
      "longitude": -118.427472,
      "elevationFeet": 750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S95?codeType=fs"
     },
     {
      "fs": "S97",
      "iata": "",
      "icao": "",
      "faa": "S97",
      "name": "Anderson",
      "city": "Brewster",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.148694,
      "longitude": -119.756139,
      "elevationFeet": 914,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S97?codeType=fs"
     },
     {
      "fs": "S98",
      "iata": "",
      "icao": "",
      "faa": "S98",
      "name": "Vista",
      "city": "Kennewick",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.256917,
      "longitude": -119.252917,
      "elevationFeet": 531,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/S98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/S98?codeType=fs"
     },
     {
      "fs": "SAR",
      "iata": "SAR",
      "icao": "KSAR",
      "faa": "SAR",
      "name": "Sparta Community Airport",
      "city": "Sparta",
      "cityCode": "SAR",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 38.133333,
      "longitude": -89.7,
      "elevationFeet": 538,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAR?codeType=fs"
     },
     {
      "fs": "SAS",
      "iata": "SAS",
      "icao": "KSAS",
      "faa": "SAS",
      "name": "Salton City Airport",
      "city": "Salton City",
      "cityCode": "SAS",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 33.316667,
      "longitude": -115.983333,
      "elevationFeet": -85,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SAS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SAS?codeType=fs"
     },
     {
      "fs": "SBO",
      "iata": "SBO",
      "icao": "",
      "faa": "44U",
      "name": "Salina Airport",
      "city": "Salina",
      "cityCode": "SBO",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 39.029167,
      "longitude": -111.8375,
      "elevationFeet": 327,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBO?codeType=fs"
     },
     {
      "fs": "SBX",
      "iata": "SBX",
      "icao": "KSBX",
      "faa": "SBX",
      "name": "Shelby Airport",
      "city": "Shelby",
      "cityCode": "SBX",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 48.5,
      "longitude": -111.85,
      "elevationFeet": 3437,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SBX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SBX?codeType=fs"
     },
     {
      "fs": "SCB",
      "iata": "SCB",
      "icao": "KSCB",
      "faa": "SCB",
      "name": "Scribner State Airport",
      "city": "Scribner",
      "cityCode": "SCB",
      "stateCode": "NE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.610328,
      "longitude": -96.629823,
      "elevationFeet": 1323,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCB?codeType=fs"
     },
     {
      "fs": "SCJ",
      "iata": "SCJ",
      "icao": "",
      "faa": "",
      "name": "Smith Cove Airport",
      "city": "Smith Cove",
      "cityCode": "SCJ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 55.416667,
      "longitude": -132.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCJ?codeType=fs"
     },
     {
      "fs": "SCR",
      "icao": "",
      "faa": "",
      "name": "Scranton Municipal Airport",
      "city": "Scranton",
      "cityCode": "SCR",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.416667,
      "longitude": -75.666667,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SCR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SCR?codeType=fs"
     },
     {
      "fs": "SEF",
      "iata": "SEF",
      "icao": "KSEF",
      "faa": "SEF",
      "name": "Sebring Air Terminal",
      "city": "Sebring",
      "cityCode": "SEF",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 27.457846,
      "longitude": -81.342519,
      "elevationFeet": 63,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SEF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SEF?codeType=fs"
     },
     {
      "fs": "SEM",
      "iata": "SEM",
      "icao": "KSEM",
      "faa": "SEM",
      "name": "Craig Field",
      "city": "Selma",
      "cityCode": "SES",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.343889,
      "longitude": -87.987778,
      "elevationFeet": 159,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SEM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SEM?codeType=fs"
     },
     {
      "fs": "SEP",
      "iata": "SEP",
      "icao": "KSEP",
      "faa": "SEP",
      "name": "Clark Field",
      "city": "Stephenville",
      "cityCode": "SEP",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.216667,
      "longitude": -98.2,
      "elevationFeet": 1321,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SEP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SEP?codeType=fs"
     },
     {
      "fs": "SER",
      "iata": "SER",
      "icao": "KSER",
      "faa": "SER",
      "name": "Freeman Municipal Airport",
      "city": "Seymour",
      "cityCode": "SER",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 38.966667,
      "longitude": -85.883333,
      "elevationFeet": 583,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SER?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SER?codeType=fs"
     },
     {
      "fs": "SES",
      "iata": "SES",
      "icao": "",
      "faa": "",
      "name": "Selfield Airport",
      "city": "Selma",
      "cityCode": "SES",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.726111,
      "longitude": -87.087222,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SES?codeType=fs"
     },
     {
      "fs": "SET",
      "iata": "",
      "icao": "KSET",
      "faa": "SET",
      "name": "St. Charles County Smartt Airport",
      "city": "St. Charles",
      "cityCode": "SET",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 38.929699,
      "longitude": -90.43,
      "elevationFeet": 438,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SET?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SET?codeType=fs"
     },
     {
      "fs": "SFR",
      "iata": "SFR",
      "icao": "",
      "faa": "",
      "name": "San Fernando Airport",
      "city": "San Fernando",
      "cityCode": "SFR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 34.266667,
      "longitude": -118.433333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SFR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SFR?codeType=fs"
     },
     {
      "fs": "SGH",
      "iata": "SGH",
      "icao": "KSGH",
      "faa": "SGH",
      "name": "Springfield Airport",
      "city": "Springfield",
      "cityCode": "SGH",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39.916667,
      "longitude": -83.8,
      "elevationFeet": 1052,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGH?codeType=fs"
     },
     {
      "fs": "SGT",
      "iata": "SGT",
      "icao": "KSGT",
      "faa": "SGT",
      "name": "Stuttgart Airport",
      "city": "Stuttgart",
      "cityCode": "SGT",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 34.599499,
      "longitude": -91.574997,
      "elevationFeet": 224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGT?codeType=fs"
     },
     {
      "fs": "SGW",
      "iata": "SGW",
      "icao": "",
      "faa": "",
      "name": "Saginaw Bay Airport",
      "city": "Saginaw Bay",
      "cityCode": "SGW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 58.4776,
      "longitude": -134.1578,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SGW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SGW?codeType=fs"
     },
     {
      "fs": "SHN",
      "iata": "SHN",
      "icao": "KSHN",
      "faa": "SHN",
      "name": "Sanderson Field",
      "city": "Shelton",
      "cityCode": "SHN",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 47.233889,
      "longitude": -123.138889,
      "elevationFeet": 273,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SHN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SHN?codeType=fs"
     },
     {
      "fs": "SIK",
      "iata": "SIK",
      "icao": "KSIK",
      "faa": "SIK",
      "name": "Sikeston Memorial Airport",
      "city": "Sikeston",
      "cityCode": "SIK",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.866667,
      "longitude": -89.55,
      "elevationFeet": 315,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SIK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SIK?codeType=fs"
     },
     {
      "fs": "SIV",
      "iata": "SIV",
      "icao": "KSIV",
      "faa": "SIV",
      "name": "Sullivan County Airport",
      "city": "Sullivan",
      "cityCode": "SIV",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 39.1,
      "longitude": -87.4,
      "elevationFeet": 540,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SIV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SIV?codeType=fs"
     },
     {
      "fs": "SIY",
      "iata": "SIY",
      "icao": "KSIY",
      "faa": "SIY",
      "name": "Siskiyou County Airport",
      "city": "Montague",
      "cityCode": "SIY",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 41.733333,
      "longitude": -122.533333,
      "elevationFeet": 2648,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SIY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SIY?codeType=fs"
     },
     {
      "fs": "SJN",
      "iata": "SJN",
      "icao": "KSJN",
      "faa": "SJN",
      "name": "Saint Johns Municipal Airport",
      "city": "Saint Johns",
      "cityCode": "SJN",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 34.5,
      "longitude": -109.35,
      "elevationFeet": 5736,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SJN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SJN?codeType=fs"
     },
     {
      "fs": "SKJ",
      "iata": "SKJ",
      "icao": "",
      "faa": "",
      "name": "Sitkinak Island Coast Guard Station",
      "city": "Sitkinak Island",
      "cityCode": "SKJ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 56.532778,
      "longitude": -154.113889,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SKJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SKJ?codeType=fs"
     },
     {
      "fs": "SKW",
      "iata": "SKW",
      "icao": "PASW",
      "faa": "PASW",
      "name": "Skwentna Intermediate Airport",
      "city": "Skwentna",
      "cityCode": "SKW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 61.965833,
      "longitude": -151.188611,
      "elevationFeet": 148,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SKW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SKW?codeType=fs"
     },
     {
      "fs": "SKY",
      "iata": "SKY",
      "icao": "KSKY",
      "faa": "SKY",
      "name": "Griffin Sandusky Airport",
      "city": "Sandusky",
      "cityCode": "SKY",
      "stateCode": "OH",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.434295,
      "longitude": -83.652619,
      "elevationFeet": 575,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SKY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SKY?codeType=fs"
     },
     {
      "fs": "SLB",
      "iata": "SLB",
      "icao": "KSLB",
      "faa": "SLB",
      "name": "Storm Lake Municipal Airport",
      "city": "Storm Lake",
      "cityCode": "SLB",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 42.633333,
      "longitude": -95.2,
      "elevationFeet": 1488,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLB?codeType=fs"
     },
     {
      "fs": "SLG",
      "iata": "SLG",
      "icao": "KSLG",
      "faa": "SLG",
      "name": "Smith Field",
      "city": "Siloam Springs",
      "cityCode": "SLG",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.183333,
      "longitude": -94.533333,
      "elevationFeet": 1193,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLG?codeType=fs"
     },
     {
      "fs": "SLO",
      "iata": "SLO",
      "icao": "KSLO",
      "faa": "SLO",
      "name": "Leckrone Airport",
      "city": "Salem",
      "cityCode": "SLO",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 38.633333,
      "longitude": -88.95,
      "elevationFeet": 573,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLO?codeType=fs"
     },
     {
      "fs": "SLT",
      "iata": "SLT",
      "icao": "",
      "faa": "0V2",
      "name": "Harriet Alexander Field",
      "city": "Salida",
      "cityCode": "SLT",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 38.538248,
      "longitude": -106.048666,
      "elevationFeet": 7461,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SLT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SLT?codeType=fs"
     },
     {
      "fs": "SMD",
      "iata": "SMD",
      "icao": "KSMD",
      "faa": "SMD",
      "name": "Smith Field",
      "city": "Fort Wayne",
      "cityCode": "FWA",
      "stateCode": "IN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.143344,
      "longitude": -85.152789,
      "elevationFeet": 834,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMD?codeType=fs"
     },
     {
      "fs": "SME",
      "iata": "SME",
      "icao": "KSME",
      "faa": "SME",
      "name": "Lake Cumberland Regional Airport",
      "city": "Somerset",
      "cityCode": "SME",
      "stateCode": "KY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 37.053398,
      "longitude": -84.615898,
      "elevationFeet": 928,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SME?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SME?codeType=fs"
     },
     {
      "fs": "SMU",
      "iata": "SMU",
      "icao": "PASP",
      "faa": "PASP",
      "name": "Sheep Mountain Airport",
      "city": "Sheep Mountain",
      "cityCode": "SMU",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 61.8,
      "longitude": -147.666667,
      "elevationFeet": 2750,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SMU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SMU?codeType=fs"
     },
     {
      "fs": "SNL",
      "iata": "SNL",
      "icao": "KSNL",
      "faa": "SNL",
      "name": "Shawnee Municipal Airport",
      "city": "Shawnee",
      "cityCode": "SNL",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.333333,
      "longitude": -96.916667,
      "elevationFeet": 1073,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SNL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SNL?codeType=fs"
     },
     {
      "fs": "SOL",
      "iata": "SOL",
      "icao": "",
      "faa": "",
      "name": "Solomon State Field",
      "city": "Solomon",
      "cityCode": "SOL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 64.560512,
      "longitude": -164.445681,
      "elevationFeet": 40,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SOL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SOL?codeType=fs"
     },
     {
      "fs": "SPA",
      "iata": "SPA",
      "icao": "KSPA",
      "faa": "SPA",
      "name": "Spartanburg Downtown Memorial Airport",
      "city": "Spartanburg",
      "cityCode": "SPA",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 34.95,
      "longitude": -81.916667,
      "elevationFeet": 801,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPA?codeType=fs"
     },
     {
      "fs": "SPF",
      "iata": "SPF",
      "icao": "KSPF",
      "faa": "SPF",
      "name": "Black Hills Airport",
      "city": "Spearfish",
      "cityCode": "SPF",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.5,
      "longitude": -103.866667,
      "elevationFeet": 3931,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPF?codeType=fs"
     },
     {
      "fs": "SPQ",
      "iata": "SPQ",
      "icao": "",
      "faa": "",
      "name": "Catalina Sea Plane Base",
      "city": "San Pedro",
      "cityCode": "SPQ",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 33.750556,
      "longitude": -118.272778,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPQ?codeType=fs"
     },
     {
      "fs": "SPW",
      "iata": "SPW",
      "icao": "KSPW",
      "faa": "SPW",
      "name": "Spencer Municipal Airport",
      "city": "Spencer",
      "cityCode": "SPW",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 43.163889,
      "longitude": -95.200833,
      "elevationFeet": 1339,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SPW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SPW?codeType=fs"
     },
     {
      "fs": "SQI",
      "iata": "SQI",
      "icao": "KSQI",
      "faa": "SQI",
      "name": "Whiteside County Airport",
      "city": "Sterling",
      "cityCode": "SQI",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 41.74,
      "longitude": -89.680833,
      "elevationFeet": 647,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SQI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SQI?codeType=fs"
     },
     {
      "fs": "SQV",
      "iata": "SQV",
      "icao": "",
      "faa": "W28",
      "name": "Sequim Valley Airport",
      "city": "Sequim",
      "cityCode": "SQV",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 48.097778,
      "longitude": -123.185278,
      "elevationFeet": 144,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SQV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SQV?codeType=fs"
     },
     {
      "fs": "SRC",
      "iata": "SRC",
      "icao": "KSRC",
      "faa": "SRC",
      "name": "Searcy Airport",
      "city": "Searcy",
      "cityCode": "SRC",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.25,
      "longitude": -91.733333,
      "elevationFeet": 264,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SRC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SRC?codeType=fs"
     },
     {
      "fs": "SRF",
      "iata": "SRF",
      "icao": "",
      "faa": "",
      "name": "Hamilton Field",
      "city": "San Rafael",
      "cityCode": "SRF",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 38.015278,
      "longitude": -122.522222,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SRF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SRF?codeType=fs"
     },
     {
      "fs": "SRW",
      "iata": "SRW",
      "icao": "KRUQ",
      "faa": "RUQ",
      "name": "Rowan County Airport",
      "city": "Salisbury",
      "cityCode": "SRW",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 35.666667,
      "longitude": -80.483333,
      "elevationFeet": 773,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SRW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SRW?codeType=fs"
     },
     {
      "fs": "SSF",
      "iata": "SSF",
      "icao": "KSSF",
      "faa": "SSF",
      "name": "Stinson Municipal Airport",
      "city": "San Antonio",
      "cityCode": "SAT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.337084,
      "longitude": -98.469359,
      "elevationFeet": 569,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SSF?codeType=fs"
     },
     {
      "fs": "SSU",
      "iata": "SSU",
      "icao": "",
      "faa": "",
      "name": "Greenbrier Airport",
      "city": "White Sulphur Springs",
      "cityCode": "SSU",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 37.8,
      "longitude": -80.3,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SSU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SSU?codeType=fs"
     },
     {
      "fs": "STJ",
      "iata": "STJ",
      "icao": "KSTJ",
      "faa": "STJ",
      "name": "Rosecrans Memorial Airport",
      "city": "Saint Joseph",
      "cityCode": "STJ",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 39.960556,
      "longitude": -94.925,
      "elevationFeet": 826,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STJ?codeType=fs"
     },
     {
      "fs": "STQ",
      "iata": "STQ",
      "icao": "KOYM",
      "faa": "OYM",
      "name": "St. Marys Airport",
      "city": "Sainte Marys",
      "cityCode": "STQ",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 41.433333,
      "longitude": -78.566667,
      "elevationFeet": 1934,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/STQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/STQ?codeType=fs"
     },
     {
      "fs": "SUC",
      "iata": "SUC",
      "icao": "",
      "faa": "",
      "name": "Schloredt Airport",
      "city": "Sundance",
      "cityCode": "SUC",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 44.4,
      "longitude": -104.383333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUC?codeType=fs"
     },
     {
      "fs": "SUD",
      "iata": "SUD",
      "icao": "KSUD",
      "faa": "SUD",
      "name": "Stroud Airport",
      "city": "Stroud",
      "cityCode": "SUD",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.75,
      "longitude": -96.683333,
      "elevationFeet": 900,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUD?codeType=fs"
     },
     {
      "fs": "SUE",
      "iata": "SUE",
      "icao": "KSUE",
      "faa": "SUE",
      "name": "Door County Airport",
      "city": "Sturgeon Bay",
      "cityCode": "SUE",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 44.843889,
      "longitude": -87.421389,
      "elevationFeet": 724,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUE?codeType=fs"
     },
     {
      "fs": "SUM",
      "iata": "SUM",
      "icao": "KSMS",
      "faa": "SMS",
      "name": "Sumter Municipal Airport",
      "city": "Sumter",
      "cityCode": "SSC",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 33.993316,
      "longitude": -80.361994,
      "elevationFeet": 179,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUM?codeType=fs"
     },
     {
      "fs": "SUW",
      "iata": "SUW",
      "icao": "KSUW",
      "faa": "SUW",
      "name": "Richard I Bong Airport",
      "city": "Superior",
      "cityCode": "SUW",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 46.691111,
      "longitude": -92.103333,
      "elevationFeet": 674,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SUW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SUW?codeType=fs"
     },
     {
      "fs": "SVE",
      "iata": "SVE",
      "icao": "KSVE",
      "faa": "SVE",
      "name": "Susanville Airport",
      "city": "Susanville",
      "cityCode": "SVE",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 40.375702,
      "longitude": -120.572998,
      "elevationFeet": 4149,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SVE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SVE?codeType=fs"
     },
     {
      "fs": "SWD",
      "iata": "SWD",
      "icao": "PAWD",
      "faa": "PAWD",
      "name": "Seward Airport",
      "city": "Seward",
      "cityCode": "SWD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.133333,
      "longitude": -149.418056,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SWD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SWD?codeType=fs"
     },
     {
      "fs": "SWW",
      "iata": "SWW",
      "icao": "KSWW",
      "faa": "SWW",
      "name": "Avenger Field",
      "city": "Sweetwater",
      "cityCode": "SWW",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.467378,
      "longitude": -100.466991,
      "elevationFeet": 2361,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SWW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SWW?codeType=fs"
     },
     {
      "fs": "SXC",
      "iata": "SXC",
      "icao": "",
      "faa": "",
      "name": "Avalon Vor/WP Airport",
      "city": "Catalina Island",
      "cityCode": "AVX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 33.5,
      "longitude": -118.416667,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SXC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SXC?codeType=fs"
     },
     {
      "fs": "SXQ",
      "iata": "SXQ",
      "icao": "PASX",
      "faa": "PASX",
      "name": "Soldotna Airport",
      "city": "Soldotna",
      "cityCode": "SXQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ121",
      "localTime": "2022-11-09T03:41:39.687",
      "utcOffsetHours": -9,
      "latitude": 60.475556,
      "longitude": -151.036389,
      "elevationFeet": 108,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SXQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SXQ?codeType=fs"
     },
     {
      "fs": "SXY",
      "iata": "SXY",
      "icao": "",
      "faa": "N23",
      "name": "Sidney Airport",
      "city": "Sidney",
      "cityCode": "SXY",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 42.316667,
      "longitude": -75.4,
      "elevationFeet": 1027,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SXY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SXY?codeType=fs"
     },
     {
      "fs": "SYA",
      "iata": "SYA",
      "icao": "PASY",
      "faa": "PASY",
      "name": "Shemya Air Force Base",
      "city": "Shemya",
      "cityCode": "SYA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Adak",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.687",
      "utcOffsetHours": -10,
      "latitude": 52.7175,
      "longitude": 174.089444,
      "elevationFeet": 97,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYA?codeType=fs"
     },
     {
      "fs": "SYI",
      "iata": "SYI",
      "icao": "KSYI",
      "faa": "SYI",
      "name": "Shelbyville Municipal Airport-Bomar Field",
      "city": "Shelbyville",
      "cityCode": "SYI",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.560833,
      "longitude": -86.4425,
      "elevationFeet": 800,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYI?codeType=fs"
     },
     {
      "fs": "SYL",
      "iata": "SYL",
      "icao": "",
      "faa": "",
      "name": "Roberts Air Force Base",
      "city": "San Miguel",
      "cityCode": "SYL",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 35.75,
      "longitude": -120.7,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYL?codeType=fs"
     },
     {
      "fs": "SYN",
      "iata": "SYN",
      "icao": "KSYN",
      "faa": "SYN",
      "name": "Carleton Airport",
      "city": "Stanton",
      "cityCode": "SYN",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.133333,
      "longitude": -101.8,
      "elevationFeet": 920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYN?codeType=fs"
     },
     {
      "fs": "SYV",
      "iata": "SYV",
      "icao": "KSYV",
      "faa": "SYV",
      "name": "Sylvester Airport",
      "city": "Sylvester",
      "cityCode": "SYV",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 31.516667,
      "longitude": -83.833333,
      "elevationFeet": 403,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SYV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SYV?codeType=fs"
     },
     {
      "fs": "SZN",
      "iata": "SZN",
      "icao": "",
      "faa": "",
      "name": "Santa Cruz Island Airport",
      "city": "Santa Barbara",
      "cityCode": "SBA",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 34.060556,
      "longitude": -119.915,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/SZN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/SZN?codeType=fs"
     },
     {
      "fs": "T00",
      "iata": "",
      "icao": "",
      "faa": "T00",
      "name": "Chambers County Airport",
      "city": "Anahuac",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.763946,
      "longitude": -94.661906,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T00?codeType=fs"
     },
     {
      "fs": "T05",
      "iata": "",
      "icao": "",
      "faa": "T05",
      "name": "Johnson",
      "city": "Port Mansfield",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 26.678444,
      "longitude": -97.477583,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T05?codeType=fs"
     },
     {
      "fs": "T08",
      "iata": "",
      "icao": "",
      "faa": "T08",
      "name": "Tomahawk Regional",
      "city": "Tomahawk",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 45.491389,
      "longitude": -89.856944,
      "elevationFeet": 1486,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T08?codeType=fs"
     },
     {
      "fs": "T12",
      "iata": "",
      "icao": "",
      "faa": "T12",
      "name": "Kirbyville",
      "city": "Kirbyville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.765639,
      "longitude": -94.049028,
      "elevationFeet": 121,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T12?codeType=fs"
     },
     {
      "fs": "T13",
      "iata": "",
      "icao": "",
      "faa": "T13",
      "name": "Lewis Ranch",
      "city": "Leakey",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.818861,
      "longitude": -99.828389,
      "elevationFeet": 1730,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T13?codeType=fs"
     },
     {
      "fs": "T14",
      "iata": "",
      "icao": "",
      "faa": "T14",
      "name": "Taylor",
      "city": "Quinlan",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.972222,
      "longitude": -96.208333,
      "elevationFeet": 487,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T14?codeType=fs"
     },
     {
      "fs": "T15",
      "iata": "",
      "icao": "",
      "faa": "T15",
      "name": "Marlin",
      "city": "Marlin",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.406667,
      "longitude": -96.870278,
      "elevationFeet": 411,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T15?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T15?codeType=fs"
     },
     {
      "fs": "T18",
      "iata": "",
      "icao": "",
      "faa": "T18",
      "name": "Brooks Co",
      "city": "Falfurrias",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 27.268333,
      "longitude": -98.161722,
      "elevationFeet": 112,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T18?codeType=fs"
     },
     {
      "fs": "T19",
      "iata": "",
      "icao": "",
      "faa": "T19",
      "name": "Duval-Freer",
      "city": "Freer",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 27.886306,
      "longitude": -98.602917,
      "elevationFeet": 564,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T19?codeType=fs"
     },
     {
      "fs": "T20",
      "iata": "",
      "icao": "",
      "faa": "T20",
      "name": "Gonzales Municipal",
      "city": "Gonzales",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.630139,
      "longitude": -97.563806,
      "elevationFeet": 354,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T20?codeType=fs"
     },
     {
      "fs": "T23",
      "iata": "",
      "icao": "",
      "faa": "T23",
      "name": "Albany Municipal",
      "city": "Albany",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.740083,
      "longitude": -99.275778,
      "elevationFeet": 1425,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T23?codeType=fs"
     },
     {
      "fs": "T24",
      "iata": "",
      "icao": "",
      "faa": "T24",
      "name": "Pineland Municipal",
      "city": "Pineland",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.235222,
      "longitude": -94.118556,
      "elevationFeet": 260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T24?codeType=fs"
     },
     {
      "fs": "T26",
      "iata": "",
      "icao": "",
      "faa": "T26",
      "name": "Flying V Ranch",
      "city": "Louise",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.182778,
      "longitude": -96.537778,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T26?codeType=fs"
     },
     {
      "fs": "T27",
      "iata": "",
      "icao": "",
      "faa": "T27",
      "name": "West Texas",
      "city": "El Paso",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 31.746944,
      "longitude": -106.292861,
      "elevationFeet": 4007,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T27?codeType=fs"
     },
     {
      "fs": "T28",
      "iata": "",
      "icao": "",
      "faa": "T28",
      "name": "Lampasas",
      "city": "Lampasas",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.167278,
      "longitude": -98.310028,
      "elevationFeet": 1215,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T28?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T28?codeType=fs"
     },
     {
      "fs": "T30",
      "iata": "",
      "icao": "",
      "faa": "T30",
      "name": "Mc Kinley",
      "city": "Pearsall",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.8725,
      "longitude": -99.190278,
      "elevationFeet": 586,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T30?codeType=fs"
     },
     {
      "fs": "T31",
      "iata": "",
      "icao": "",
      "faa": "T31",
      "name": "Aero Country",
      "city": "Mc Kinney",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.2845,
      "longitude": -96.819417,
      "elevationFeet": 792,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T31?codeType=fs"
     },
     {
      "fs": "T32",
      "iata": "",
      "icao": "",
      "faa": "T32",
      "name": "Sudden Stop",
      "city": "Collinsville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.615,
      "longitude": -96.98,
      "elevationFeet": 720,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T32?codeType=fs"
     },
     {
      "fs": "T33",
      "iata": "",
      "icao": "",
      "faa": "T33",
      "name": "Rives Air Park",
      "city": "Royse City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.687",
      "utcOffsetHours": -10,
      "latitude": 32.920694,
      "longitude": -96.383139,
      "elevationFeet": 555,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T33?codeType=fs"
     },
     {
      "fs": "T34",
      "iata": "",
      "icao": "",
      "faa": "T34",
      "name": "Cameron",
      "city": "Angleton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.246889,
      "longitude": -95.454972,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T34?codeType=fs"
     },
     {
      "fs": "T35",
      "iata": "",
      "icao": "",
      "faa": "T35",
      "name": "Cameron Municipal",
      "city": "Cameron",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.993556,
      "longitude": -97.010972,
      "elevationFeet": 402,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T35?codeType=fs"
     },
     {
      "fs": "T36",
      "iata": "",
      "icao": "",
      "faa": "T36",
      "name": "Pittman Memorial",
      "city": "Tylertown",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.260111,
      "longitude": -90.181444,
      "elevationFeet": 384,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T36?codeType=fs"
     },
     {
      "fs": "T39",
      "iata": "",
      "icao": "",
      "faa": "T39",
      "name": "Archer City Municipal",
      "city": "Archer City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.72325,
      "longitude": -98.636694,
      "elevationFeet": 1065,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T39?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T39?codeType=fs"
     },
     {
      "fs": "T40",
      "iata": "",
      "icao": "",
      "faa": "T40",
      "name": "Mc Gehee Catfish Restaurant",
      "city": "Marietta",
      "stateCode": "OK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.901028,
      "longitude": -97.169583,
      "elevationFeet": 760,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T40?codeType=fs"
     },
     {
      "fs": "T41",
      "iata": "",
      "icao": "",
      "faa": "T41",
      "name": "La Porte Municipal Airport",
      "city": "La Porte",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.666706,
      "longitude": -95.057868,
      "elevationFeet": 22,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T41?codeType=fs"
     },
     {
      "fs": "T43",
      "iata": "",
      "icao": "",
      "faa": "T43",
      "name": "Mc Campbell",
      "city": "Ingleside",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.011333,
      "longitude": -97.244361,
      "elevationFeet": 17,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T43?codeType=fs"
     },
     {
      "fs": "T45",
      "iata": "",
      "icao": "",
      "faa": "T45",
      "name": "Panhandle-Carson Co",
      "city": "Panhandle",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.466944,
      "longitude": -101.500833,
      "elevationFeet": 3454,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T45?codeType=fs"
     },
     {
      "fs": "T48",
      "iata": "",
      "icao": "",
      "faa": "T48",
      "name": "Phillips Flying Ranch",
      "city": "Rockwall",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.867917,
      "longitude": -96.302556,
      "elevationFeet": 500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T48?codeType=fs"
     },
     {
      "fs": "T49",
      "iata": "",
      "icao": "",
      "faa": "T49",
      "name": "Big Spring Mc Mahon-Wrinkle",
      "city": "Big Spring",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.326111,
      "longitude": -101.566389,
      "elevationFeet": 2573,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T49?codeType=fs"
     },
     {
      "fs": "T50",
      "iata": "",
      "icao": "",
      "faa": "T50",
      "name": "Menard Co",
      "city": "Menard",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.935056,
      "longitude": -99.820139,
      "elevationFeet": 1930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T50?codeType=fs"
     },
     {
      "fs": "T51",
      "iata": "",
      "icao": "",
      "faa": "T51",
      "name": "May",
      "city": "Houston",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.12775,
      "longitude": -95.672222,
      "elevationFeet": 166,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T51?codeType=fs"
     },
     {
      "fs": "T53",
      "iata": "",
      "icao": "",
      "faa": "T53",
      "name": "Nueces Co",
      "city": "Robstown",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 27.885444,
      "longitude": -97.75525,
      "elevationFeet": 79,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T53?codeType=fs"
     },
     {
      "fs": "T56",
      "iata": "",
      "icao": "",
      "faa": "T56",
      "name": "Houston Co",
      "city": "Crockett",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 31.369611,
      "longitude": -95.438306,
      "elevationFeet": 348,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T56?codeType=fs"
     },
     {
      "fs": "T58",
      "iata": "",
      "icao": "",
      "faa": "T58",
      "name": "Ironhead",
      "city": "Sanger",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.467833,
      "longitude": -97.352944,
      "elevationFeet": 715,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T58?codeType=fs"
     },
     {
      "fs": "T59",
      "iata": "",
      "icao": "",
      "faa": "T59",
      "name": "Wheeler Municipal",
      "city": "Wheeler",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.460833,
      "longitude": -100.349167,
      "elevationFeet": 2470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T59?codeType=fs"
     },
     {
      "fs": "T60",
      "iata": "",
      "icao": "",
      "faa": "T60",
      "name": "Stonewall Co",
      "city": "Aspermont",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.223194,
      "longitude": -100.326056,
      "elevationFeet": 1744,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T60?codeType=fs"
     },
     {
      "fs": "T65",
      "iata": "",
      "icao": "",
      "faa": "T65",
      "name": "Mid Valley",
      "city": "Weslaco",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 26.276389,
      "longitude": -98.030556,
      "elevationFeet": 70,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T65?codeType=fs"
     },
     {
      "fs": "T67",
      "iata": "",
      "icao": "",
      "faa": "T67",
      "name": "Hicks",
      "city": "Ft Worth",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 33.062361,
      "longitude": -97.516861,
      "elevationFeet": 855,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T67?codeType=fs"
     },
     {
      "fs": "T69",
      "iata": "",
      "icao": "",
      "faa": "T69",
      "name": "San Patricio Co",
      "city": "Sinton",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.0925,
      "longitude": -97.624444,
      "elevationFeet": 48,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T69?codeType=fs"
     },
     {
      "fs": "T70",
      "iata": "",
      "icao": "",
      "faa": "T70",
      "name": "Laughlin Afb Aux No 1",
      "city": "Spofford",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.244056,
      "longitude": -100.522167,
      "elevationFeet": 975,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T70?codeType=fs"
     },
     {
      "fs": "T71",
      "iata": "",
      "icao": "",
      "faa": "T71",
      "name": "Cuero Municipal",
      "city": "Cuero",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.085889,
      "longitude": -97.269333,
      "elevationFeet": 214,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T71?codeType=fs"
     },
     {
      "fs": "T72",
      "iata": "",
      "icao": "",
      "faa": "T72",
      "name": "Hearne Municipal",
      "city": "Hearne",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.918306,
      "longitude": -96.672278,
      "elevationFeet": 285,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T72?codeType=fs"
     },
     {
      "fs": "T73",
      "iata": "",
      "icao": "",
      "faa": "T73",
      "name": "Kirk Air Base",
      "city": "Lancaster",
      "stateCode": "SC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.687",
      "utcOffsetHours": -5,
      "latitude": 34.743167,
      "longitude": -80.822917,
      "elevationFeet": 578,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T73?codeType=fs"
     },
     {
      "fs": "T74",
      "iata": "",
      "icao": "",
      "faa": "T74",
      "name": "Taylor Municipal",
      "city": "Taylor",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.619444,
      "longitude": -97.531667,
      "elevationFeet": 590,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T74?codeType=fs"
     },
     {
      "fs": "T77",
      "iata": "",
      "icao": "",
      "faa": "T77",
      "name": "Presidio Lely International",
      "city": "Presidio",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.751806,
      "longitude": -104.438139,
      "elevationFeet": 2932,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T77?codeType=fs"
     },
     {
      "fs": "T78",
      "iata": "",
      "icao": "",
      "faa": "T78",
      "name": "Liberty Municipal Airport",
      "city": "Liberty",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.075709,
      "longitude": -94.69739,
      "elevationFeet": 66,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T78?codeType=fs"
     },
     {
      "fs": "T79",
      "iata": "",
      "icao": "",
      "faa": "T79",
      "name": "Skyway Manor Airport",
      "city": "Pearland",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.556387,
      "longitude": -95.326265,
      "elevationFeet": 53,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T79?codeType=fs"
     },
     {
      "fs": "T84",
      "iata": "",
      "icao": "",
      "faa": "T84",
      "name": "Fehmel Dusting Service",
      "city": "Bay City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.974806,
      "longitude": -96.035694,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T84?codeType=fs"
     },
     {
      "fs": "T85",
      "iata": "",
      "icao": "",
      "faa": "T85",
      "name": "Yoakum Municipal",
      "city": "Yoakum",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.431639,
      "longitude": -97.184028,
      "elevationFeet": 365,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T85?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T85?codeType=fs"
     },
     {
      "fs": "T86",
      "iata": "",
      "icao": "",
      "faa": "T86",
      "name": "Zapata Co",
      "city": "Zapata",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 26.987778,
      "longitude": -99.389167,
      "elevationFeet": 422,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T86?codeType=fs"
     },
     {
      "fs": "T88",
      "iata": "",
      "icao": "",
      "faa": "T88",
      "name": "Colorado City",
      "city": "Colorado City",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 32.484278,
      "longitude": -100.961222,
      "elevationFeet": 2214,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T88?codeType=fs"
     },
     {
      "fs": "T89",
      "iata": "",
      "icao": "",
      "faa": "T89",
      "name": "Castroville Municipal",
      "city": "Castroville",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.419222,
      "longitude": -98.859,
      "elevationFeet": 771,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T89?codeType=fs"
     },
     {
      "fs": "T90",
      "iata": "",
      "icao": "",
      "faa": "T90",
      "name": "Chambers Co-Winnie Stowell Airport",
      "city": "Winnie/Stowell",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.818755,
      "longitude": -94.431714,
      "elevationFeet": 23,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T90?codeType=fs"
     },
     {
      "fs": "T91",
      "iata": "",
      "icao": "",
      "faa": "T91",
      "name": "Carter Memorial",
      "city": "Luling",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.832833,
      "longitude": -97.744417,
      "elevationFeet": 475,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T91?codeType=fs"
     },
     {
      "fs": "T92",
      "iata": "",
      "icao": "",
      "faa": "T92",
      "name": "Mason Co",
      "city": "Mason",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 30.872333,
      "longitude": -99.19,
      "elevationFeet": 1502,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T92?codeType=fs"
     },
     {
      "fs": "T93",
      "iata": "",
      "icao": "",
      "faa": "T93",
      "name": "Follett-Lipscomb Co",
      "city": "Follett",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 36.508056,
      "longitude": -100.188056,
      "elevationFeet": 2601,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T93?codeType=fs"
     },
     {
      "fs": "T94",
      "iata": "",
      "icao": "",
      "faa": "T94",
      "name": "Twin Oaks",
      "city": "San Antonio",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 29.630056,
      "longitude": -98.580722,
      "elevationFeet": 878,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T94?codeType=fs"
     },
     {
      "fs": "T97",
      "iata": "",
      "icao": "",
      "faa": "T97",
      "name": "Calhoun Co",
      "city": "Port Lavaca",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 28.6905,
      "longitude": -96.813139,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/T97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/T97?codeType=fs"
     },
     {
      "fs": "TBC",
      "iata": "TBC",
      "icao": "",
      "faa": "T03",
      "name": "Tuba City Airport",
      "city": "Tuba City",
      "cityCode": "TBC",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 36.133333,
      "longitude": -111.233333,
      "elevationFeet": 4513,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TBC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TBC?codeType=fs"
     },
     {
      "fs": "TCC",
      "iata": "TCC",
      "icao": "KTCC",
      "faa": "TCC",
      "name": "Tucumcari Airport",
      "city": "Tucumcari",
      "cityCode": "TCC",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 35.166667,
      "longitude": -103.733333,
      "elevationFeet": 4065,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TCC?codeType=fs"
     },
     {
      "fs": "TCS",
      "iata": "TCS",
      "icao": "KTCS",
      "faa": "TCS",
      "name": "Truth Or Consequences Municipal Airport",
      "city": "Truth Or Consequences",
      "cityCode": "TCS",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.687",
      "utcOffsetHours": -7,
      "latitude": 33.133333,
      "longitude": -107.25,
      "elevationFeet": 4853,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TCS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TCS?codeType=fs"
     },
     {
      "fs": "TDO",
      "iata": "TDO",
      "icao": "KTDO",
      "faa": "TDO",
      "name": "Winlock Airport",
      "city": "Toledo",
      "cityCode": "TDO",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.687",
      "utcOffsetHours": -8,
      "latitude": 46.433333,
      "longitude": -122.85,
      "elevationFeet": 375,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TDO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TDO?codeType=fs"
     },
     {
      "fs": "TDW",
      "iata": "TDW",
      "icao": "KTDW",
      "faa": "TDW",
      "name": "Tradewind Airport",
      "city": "Amarillo",
      "cityCode": "AMA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.687",
      "utcOffsetHours": -6,
      "latitude": 35.216667,
      "longitude": -101.833333,
      "elevationFeet": 3648,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TDW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TDW?codeType=fs"
     },
     {
      "fs": "TEH",
      "iata": "TEH",
      "icao": "",
      "faa": "5TE",
      "name": "Tetlin Airport",
      "city": "Tetlin",
      "cityCode": "TEH",
      "stateCode": "AK",
      "postalCode": "99779",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ224",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 63.133333,
      "longitude": -142.516667,
      "elevationFeet": 1625,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TEH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TEH?codeType=fs"
     },
     {
      "fs": "TGE",
      "iata": "TGE",
      "icao": "",
      "faa": "",
      "name": "Sharpe Field",
      "city": "Tuskegee",
      "cityCode": "TGE",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 32.466667,
      "longitude": -85.683333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TGE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TGE?codeType=fs"
     },
     {
      "fs": "THA",
      "iata": "THA",
      "icao": "KTHA",
      "faa": "THA",
      "name": "Northern Airport",
      "city": "Tullahoma",
      "cityCode": "THA",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 35.366667,
      "longitude": -86.183333,
      "elevationFeet": 1082,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/THA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/THA?codeType=fs"
     },
     {
      "fs": "THM",
      "iata": "THM",
      "icao": "",
      "faa": "",
      "name": "Thompsonfield Airport",
      "city": "Thompsonfield",
      "cityCode": "THM",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 39.183333,
      "longitude": -91.983333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/THM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/THM?codeType=fs"
     },
     {
      "fs": "THP",
      "iata": "THP",
      "icao": "KTHP",
      "faa": "THP",
      "name": "Hot Springs Airport",
      "city": "Thermopolis",
      "cityCode": "THP",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.65,
      "longitude": -108.216667,
      "elevationFeet": 4580,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/THP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/THP?codeType=fs"
     },
     {
      "fs": "TKA",
      "iata": "TKA",
      "icao": "PATK",
      "faa": "PATK",
      "name": "Talkeetna Airport",
      "city": "Talkeetna",
      "cityCode": "TKA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "AKZ145",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 62.322222,
      "longitude": -150.09,
      "elevationFeet": 358,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TKA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TKA?codeType=fs"
     },
     {
      "fs": "TKI",
      "iata": "TKI",
      "icao": "",
      "faa": "",
      "name": "Tokeen Sea Plane Base",
      "city": "Tokeen",
      "cityCode": "TKI",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.93671,
      "longitude": -133.327325,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TKI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TKI?codeType=fs"
     },
     {
      "fs": "TKL",
      "iata": "TKL",
      "icao": "",
      "faa": "",
      "name": "Taku Sea Plane Base",
      "city": "Taku Lodge",
      "cityCode": "TKL",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 58.069099,
      "longitude": -134.015433,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TKL?codeType=fs"
     },
     {
      "fs": "TLF",
      "iata": "TLF",
      "icao": "",
      "faa": "2K5",
      "name": "Telida Airport",
      "city": "Telida",
      "cityCode": "TLF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 63.666667,
      "longitude": -152.5,
      "elevationFeet": 650,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TLF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TLF?codeType=fs"
     },
     {
      "fs": "TLR",
      "iata": "TLR",
      "icao": "KTLR",
      "faa": "TLR",
      "name": "Mefford Field",
      "city": "Tulare",
      "cityCode": "TLR",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 36.156302,
      "longitude": -119.326001,
      "elevationFeet": 255,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TLR?codeType=fs"
     },
     {
      "fs": "TMA",
      "iata": "TMA",
      "icao": "KTMA",
      "faa": "TMA",
      "name": "Henry Tift Myers Airport",
      "city": "Tifton",
      "cityCode": "TMA",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 31.433333,
      "longitude": -83.483333,
      "elevationFeet": 355,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TMA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TMA?codeType=fs"
     },
     {
      "fs": "TNP",
      "iata": "TNP",
      "icao": "KNXP",
      "faa": "NXP",
      "name": "Twentynine Palms Airport",
      "city": "Twentynine Palms",
      "cityCode": "TNP",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 34.118889,
      "longitude": -115.935,
      "elevationFeet": 2055,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TNP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TNP?codeType=fs"
     },
     {
      "fs": "TNT",
      "iata": "TNT",
      "icao": "KTNT",
      "faa": "TNT",
      "name": "Dade Collier Training and Transition Airport",
      "city": "Miami",
      "cityCode": "MIA",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 25.86081,
      "longitude": -80.895721,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TNT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TNT?codeType=fs"
     },
     {
      "fs": "TNU",
      "iata": "TNU",
      "icao": "KTNU",
      "faa": "TNU",
      "name": "Newton Municipal Airport",
      "city": "Newton",
      "cityCode": "TNU",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 41.7,
      "longitude": -93.05,
      "elevationFeet": 953,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TNU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TNU?codeType=fs"
     },
     {
      "fs": "TNW",
      "iata": "",
      "icao": "",
      "faa": "TNW",
      "name": "Tin Creek",
      "city": "Farewell Lake",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 62.666194,
      "longitude": -153.711194,
      "elevationFeet": 1151,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TNW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TNW?codeType=fs"
     },
     {
      "fs": "TOC",
      "iata": "TOC",
      "icao": "KTOC",
      "faa": "TOC",
      "name": "R.G. LeTourneau Field",
      "city": "Toccoa",
      "cityCode": "TOC",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 34.5938,
      "longitude": -83.295799,
      "elevationFeet": 967,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOC?codeType=fs"
     },
     {
      "fs": "TOI",
      "iata": "TOI",
      "icao": "KTOI",
      "faa": "TOI",
      "name": "Troy Municipal Airport",
      "city": "Troy",
      "cityCode": "TOI",
      "stateCode": "AL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 31.8,
      "longitude": -85.966667,
      "elevationFeet": 397,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOI?codeType=fs"
     },
     {
      "fs": "TOR",
      "iata": "TOR",
      "icao": "KTOR",
      "faa": "TOR",
      "name": "Torrington Municipal Airport",
      "city": "Torrington",
      "cityCode": "TOR",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.066667,
      "longitude": -104.183333,
      "elevationFeet": 4205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TOR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TOR?codeType=fs"
     },
     {
      "fs": "TPH",
      "iata": "TPH",
      "icao": "KTPH",
      "faa": "TPH",
      "name": "Tonopah Airport",
      "city": "Tonopah",
      "cityCode": "TPH",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 38.066667,
      "longitude": -117.233333,
      "elevationFeet": 5426,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TPH?codeType=fs"
     },
     {
      "fs": "TPL",
      "iata": "TPL",
      "icao": "KTPL",
      "faa": "TPL",
      "name": "Draughon-Miller Airport",
      "city": "Temple",
      "cityCode": "TPL",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 31.150278,
      "longitude": -97.409167,
      "elevationFeet": 682,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TPL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TPL?codeType=fs"
     },
     {
      "fs": "TPO",
      "iata": "TPO",
      "icao": "",
      "faa": "",
      "name": "Tanalian Point Airport",
      "city": "Tanalian Point",
      "cityCode": "TPO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 60.166667,
      "longitude": -154.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TPO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TPO?codeType=fs"
     },
     {
      "fs": "TRH",
      "iata": "TRH",
      "icao": "",
      "faa": "L72",
      "name": "Trona Airport",
      "city": "Trona",
      "cityCode": "TRH",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 35.812778,
      "longitude": -117.325833,
      "elevationFeet": 1716,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TRH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TRH?codeType=fs"
     },
     {
      "fs": "TRX",
      "iata": "TRX",
      "icao": "KTRX",
      "faa": "TRX",
      "name": "Trenton Memorial Airport",
      "city": "Trenton",
      "cityCode": "TRX",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 40.083333,
      "longitude": -93.616667,
      "elevationFeet": 757,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TRX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TRX?codeType=fs"
     },
     {
      "fs": "TSG",
      "iata": "TSG",
      "icao": "",
      "faa": "TSG",
      "name": "Tanacross Intermediate Airport",
      "city": "Tanacross",
      "cityCode": "TSG",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 63.35,
      "longitude": -143.5,
      "elevationFeet": 1549,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TSG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TSG?codeType=fs"
     },
     {
      "fs": "TSM",
      "iata": "TSM",
      "icao": "KSKX",
      "faa": "SKX",
      "name": "Taos Airport",
      "city": "Taos",
      "cityCode": "TSM",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "NMZ516",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 36.459167,
      "longitude": -105.675278,
      "elevationFeet": 7091,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TSM?codeType=fs"
     },
     {
      "fs": "TSP",
      "iata": "TSP",
      "icao": "KTSP",
      "faa": "TSP",
      "name": "Kern County Airport",
      "city": "Tehachapi",
      "cityCode": "TSP",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 35.1375,
      "longitude": -118.441667,
      "elevationFeet": 3998,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TSP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TSP?codeType=fs"
     },
     {
      "fs": "TSS",
      "iata": "TSS",
      "icao": "",
      "faa": "",
      "name": "East 34th Street Heliport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.7425,
      "longitude": -73.971944,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TSS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TSS?codeType=fs"
     },
     {
      "fs": "TTO",
      "iata": "TTO",
      "icao": "KBTN",
      "faa": "BTN",
      "name": "Britton Municipal Airport",
      "city": "Britton",
      "cityCode": "TTO",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 45.8,
      "longitude": -97.75,
      "elevationFeet": 1318,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TTO?codeType=fs"
     },
     {
      "fs": "TUH",
      "iata": "TUH",
      "icao": "",
      "faa": "",
      "name": "Arnold Air Force Base",
      "city": "Tullahoma",
      "cityCode": "THA",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 35.366667,
      "longitude": -86.216667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TUH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TUH?codeType=fs"
     },
     {
      "fs": "TWE",
      "iata": "TWE",
      "icao": "",
      "faa": "",
      "name": "Taylor Airport",
      "city": "Taylor",
      "cityCode": "TWE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 65.733333,
      "longitude": -164.85,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TWE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TWE?codeType=fs"
     },
     {
      "fs": "TWH",
      "iata": "TWH",
      "icao": "",
      "faa": "",
      "name": "Two Harbors Airport",
      "city": "Catalina Island",
      "cityCode": "AVX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 33.425,
      "longitude": -118.508333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TWH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TWH?codeType=fs"
     },
     {
      "fs": "TX25",
      "iata": "",
      "icao": "TX25",
      "faa": "TX25",
      "name": "Lochridge Ranch",
      "city": "Athens",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 32.043278,
      "longitude": -95.96075,
      "elevationFeet": 391,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TX25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TX25?codeType=fs"
     },
     {
      "fs": "TYE",
      "iata": "TYE",
      "icao": "",
      "faa": "",
      "name": "Tyonek Airport",
      "city": "Tyonek",
      "cityCode": "TYE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 61.076698,
      "longitude": -151.138,
      "elevationFeet": 110,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TYE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TYE?codeType=fs"
     },
     {
      "fs": "TYZ",
      "iata": "TYZ",
      "icao": "KTYL",
      "faa": "TYL",
      "name": "Taylor Airport",
      "city": "Taylor",
      "cityCode": "TYZ",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 34.466667,
      "longitude": -110.083333,
      "elevationFeet": 5820,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/TYZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/TYZ?codeType=fs"
     },
     {
      "fs": "U00",
      "iata": "",
      "icao": "",
      "faa": "U00",
      "name": "Leadore",
      "city": "Leadore",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.738111,
      "longitude": -113.380917,
      "elevationFeet": 6018,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U00?codeType=fs"
     },
     {
      "fs": "U01",
      "iata": "",
      "icao": "",
      "faa": "U01",
      "name": "American Falls",
      "city": "American Falls",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.923278,
      "longitude": -112.901861,
      "elevationFeet": 4419,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U01?codeType=fs"
     },
     {
      "fs": "U02",
      "iata": "",
      "icao": "",
      "faa": "U02",
      "name": "Mc Carley",
      "city": "Blackfoot",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.324139,
      "longitude": -112.466444,
      "elevationFeet": 4488,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U02?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U02?codeType=fs"
     },
     {
      "fs": "U03",
      "iata": "",
      "icao": "",
      "faa": "U03",
      "name": "Buhl Municipal",
      "city": "Buhl",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.665722,
      "longitude": -114.917194,
      "elevationFeet": 3660,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U03?codeType=fs"
     },
     {
      "fs": "U05",
      "iata": "",
      "icao": "",
      "faa": "U05",
      "name": "Riddick",
      "city": "Philipsburg",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 46.343694,
      "longitude": -113.350639,
      "elevationFeet": 5212,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U05?codeType=fs"
     },
     {
      "fs": "U06",
      "iata": "",
      "icao": "",
      "faa": "U06",
      "name": "Cokeville Municipal",
      "city": "Cokeville",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.157722,
      "longitude": -111.110194,
      "elevationFeet": 6270,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U06?codeType=fs"
     },
     {
      "fs": "U07",
      "iata": "",
      "icao": "",
      "faa": "U07",
      "name": "Bullfrog Basin",
      "city": "Glen Canyon Natl Rec",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 37.65825,
      "longitude": -110.832,
      "elevationFeet": 4167,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U07?codeType=fs"
     },
     {
      "fs": "U08",
      "iata": "",
      "icao": "",
      "faa": "U08",
      "name": "Perkins",
      "city": "Overton",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 36.580306,
      "longitude": -114.533139,
      "elevationFeet": 1358,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U08?codeType=fs"
     },
     {
      "fs": "U09",
      "iata": "",
      "icao": "",
      "faa": "U09",
      "name": "Ft Belknap Agency",
      "city": "Harlem",
      "stateCode": "MT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 48.611083,
      "longitude": -108.790472,
      "elevationFeet": 2374,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U09?codeType=fs"
     },
     {
      "fs": "U10",
      "iata": "",
      "icao": "",
      "faa": "U10",
      "name": "Preston",
      "city": "Preston",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.169083,
      "longitude": -112.025389,
      "elevationFeet": 4728,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U10?codeType=fs"
     },
     {
      "fs": "U12",
      "iata": "",
      "icao": "",
      "faa": "U12",
      "name": "Stanford",
      "city": "St Anthony",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.057444,
      "longitude": -111.691278,
      "elevationFeet": 4966,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U12?codeType=fs"
     },
     {
      "fs": "U13",
      "iata": "",
      "icao": "",
      "faa": "U13",
      "name": "Junction",
      "city": "Junction",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 38.399778,
      "longitude": -112.304806,
      "elevationFeet": 6069,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U13?codeType=fs"
     },
     {
      "fs": "U25",
      "iata": "",
      "icao": "",
      "faa": "U25",
      "name": "Dubois Municipal",
      "city": "Dubois",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.683472,
      "longitude": -109.752611,
      "elevationFeet": 7291,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U25?codeType=fs"
     },
     {
      "fs": "U30",
      "iata": "",
      "icao": "",
      "faa": "U30",
      "name": "Temple Bar",
      "city": "Temple Bar",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 36.055417,
      "longitude": -114.352472,
      "elevationFeet": 1549,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U30?codeType=fs"
     },
     {
      "fs": "U36",
      "iata": "",
      "icao": "",
      "faa": "U36",
      "name": "Aberdeen Municipal",
      "city": "Aberdeen",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.960222,
      "longitude": -113.011056,
      "elevationFeet": 4470,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U36?codeType=fs"
     },
     {
      "fs": "U37",
      "iata": "",
      "icao": "",
      "faa": "U37",
      "name": "Midway",
      "city": "Atomic City",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.532417,
      "longitude": -112.891583,
      "elevationFeet": 5017,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U37?codeType=fs"
     },
     {
      "fs": "U40",
      "iata": "",
      "icao": "",
      "faa": "U40",
      "name": "Albion Municipal",
      "city": "Albion",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.526889,
      "longitude": -113.625056,
      "elevationFeet": 4777,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U40?codeType=fs"
     },
     {
      "fs": "U42",
      "iata": "",
      "icao": "",
      "faa": "U42",
      "name": "Salt Lake City Mun No 2",
      "city": "Salt Lake City",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 40.645389,
      "longitude": -112.078861,
      "elevationFeet": 4603,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U42?codeType=fs"
     },
     {
      "fs": "U45",
      "iata": "",
      "icao": "",
      "faa": "U45",
      "name": "Graham Usfs",
      "city": "Atlanta",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.001778,
      "longitude": -115.325917,
      "elevationFeet": 5726,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U45?codeType=fs"
     },
     {
      "fs": "U46",
      "iata": "",
      "icao": "",
      "faa": "U46",
      "name": "Big Southern Butte",
      "city": "Atomic City",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.54075,
      "longitude": -113.141667,
      "elevationFeet": 5073,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U46?codeType=fs"
     },
     {
      "fs": "U48",
      "iata": "",
      "icao": "",
      "faa": "U48",
      "name": "Cox'S Well",
      "city": "Atomic City",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.229639,
      "longitude": -113.32225,
      "elevationFeet": 5034,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U48?codeType=fs"
     },
     {
      "fs": "U51",
      "iata": "",
      "icao": "",
      "faa": "U51",
      "name": "Bancroft Municipal",
      "city": "Bancroft",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.757528,
      "longitude": -111.874556,
      "elevationFeet": 5435,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U51?codeType=fs"
     },
     {
      "fs": "U52",
      "iata": "",
      "icao": "",
      "faa": "U52",
      "name": "Beaver Municipal",
      "city": "Beaver",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 38.357111,
      "longitude": -112.7535,
      "elevationFeet": 5860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U52?codeType=fs"
     },
     {
      "fs": "U53",
      "iata": "",
      "icao": "",
      "faa": "U53",
      "name": "Henry'S Lake",
      "city": "Lake",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.740889,
      "longitude": -111.357861,
      "elevationFeet": 6596,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U53?codeType=fs"
     },
     {
      "fs": "U54",
      "iata": "",
      "icao": "",
      "faa": "U54",
      "name": "Bernard Usfs",
      "city": "Bernard",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 45.096361,
      "longitude": -114.748139,
      "elevationFeet": 3626,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U54?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U54?codeType=fs"
     },
     {
      "fs": "U56",
      "iata": "",
      "icao": "",
      "faa": "U56",
      "name": "Rigby-Jefferson Co",
      "city": "Rigby",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.743556,
      "longitude": -112.035806,
      "elevationFeet": 4845,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U56?codeType=fs"
     },
     {
      "fs": "U58",
      "iata": "",
      "icao": "",
      "faa": "U58",
      "name": "Downey",
      "city": "Downey",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.513083,
      "longitude": -112.191278,
      "elevationFeet": 4906,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U58?codeType=fs"
     },
     {
      "fs": "U59",
      "iata": "",
      "icao": "",
      "faa": "U59",
      "name": "Driggs-Reed Memorial Airport",
      "city": "Driggs",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.819306,
      "longitude": -111.228611,
      "elevationFeet": 6228,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U59?codeType=fs"
     },
     {
      "fs": "U60",
      "iata": "",
      "icao": "",
      "faa": "U60",
      "name": "Big Creek",
      "city": "Big Creek",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 45.282444,
      "longitude": -115.367806,
      "elevationFeet": 5743,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U60?codeType=fs"
     },
     {
      "fs": "U61",
      "iata": "",
      "icao": "",
      "faa": "U61",
      "name": "Twin Bridges Emergency",
      "city": "Ketchum",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.065806,
      "longitude": -114.197694,
      "elevationFeet": 6893,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U61?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U61?codeType=fs"
     },
     {
      "fs": "U62",
      "iata": "",
      "icao": "",
      "faa": "U62",
      "name": "Mackay",
      "city": "Mackay",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.94075,
      "longitude": -113.608556,
      "elevationFeet": 5891,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U62?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U62?codeType=fs"
     },
     {
      "fs": "U63",
      "iata": "",
      "icao": "",
      "faa": "U63",
      "name": "Bruce Meadows",
      "city": "Stanley",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.554583,
      "longitude": -115.317722,
      "elevationFeet": 6370,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U63?codeType=fs"
     },
     {
      "fs": "U65",
      "iata": "",
      "icao": "",
      "faa": "U65",
      "name": "Carey",
      "city": "Carey",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.382389,
      "longitude": -113.941972,
      "elevationFeet": 4783,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U65?codeType=fs"
     },
     {
      "fs": "U68",
      "iata": "",
      "icao": "",
      "faa": "U68",
      "name": "North Big Horn Co",
      "city": "Cowley-Lovell-Byron",
      "stateCode": "WY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 45.016694,
      "longitude": -108.555083,
      "elevationFeet": 4090,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U68?codeType=fs"
     },
     {
      "fs": "U69",
      "iata": "",
      "icao": "",
      "faa": "U69",
      "name": "Duchesne Municipal",
      "city": "Duchesne",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 40.269028,
      "longitude": -110.509889,
      "elevationFeet": 5826,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U69?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U69?codeType=fs"
     },
     {
      "fs": "U70",
      "iata": "",
      "icao": "",
      "faa": "U70",
      "name": "Cascade",
      "city": "Cascade",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.587833,
      "longitude": -116.162417,
      "elevationFeet": 4742,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U70?codeType=fs"
     },
     {
      "fs": "U72",
      "iata": "",
      "icao": "",
      "faa": "U72",
      "name": "Upper Loon Creek Usfs",
      "city": "Challis",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.665778,
      "longitude": -114.881444,
      "elevationFeet": 5500,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U72?codeType=fs"
     },
     {
      "fs": "U74",
      "iata": "",
      "icao": "",
      "faa": "U74",
      "name": "Crescent Valley",
      "city": "Crescent Valley",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 40.5325,
      "longitude": -116.670306,
      "elevationFeet": 4787,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U74?codeType=fs"
     },
     {
      "fs": "U75",
      "iata": "",
      "icao": "",
      "faa": "U75",
      "name": "Jackass",
      "city": "Amargosa Valley",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 36.64675,
      "longitude": -116.533806,
      "elevationFeet": 2640,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U75?codeType=fs"
     },
     {
      "fs": "U76",
      "iata": "",
      "icao": "",
      "faa": "U76",
      "name": "Mountain Home Municipal",
      "city": "Mountain Home",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.262528,
      "longitude": -115.845944,
      "elevationFeet": 3164,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U76?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U76?codeType=fs"
     },
     {
      "fs": "U77",
      "iata": "",
      "icao": "",
      "faa": "U77",
      "name": "Spanish Fork-Springville",
      "city": "Spanish Fork",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 40.216222,
      "longitude": -111.763111,
      "elevationFeet": 4529,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U77?codeType=fs"
     },
     {
      "fs": "U78",
      "iata": "",
      "icao": "",
      "faa": "U78",
      "name": "Tigert",
      "city": "Soda Springs",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.715889,
      "longitude": -111.699444,
      "elevationFeet": 5839,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U78?codeType=fs"
     },
     {
      "fs": "U79",
      "iata": "",
      "icao": "",
      "faa": "U79",
      "name": "Chamberlain Usfs",
      "city": "Chamberlain Guard Station",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 45.490778,
      "longitude": -115.317806,
      "elevationFeet": 5765,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U79?codeType=fs"
     },
     {
      "fs": "U81",
      "iata": "",
      "icao": "",
      "faa": "U81",
      "name": "Cold Meadows Usfs",
      "city": "Cold Meadows Guard Station",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 45.365806,
      "longitude": -115.095472,
      "elevationFeet": 7030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U81?codeType=fs"
     },
     {
      "fs": "U82",
      "iata": "",
      "icao": "",
      "faa": "U82",
      "name": "Council Municipal",
      "city": "Council",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.898889,
      "longitude": -116.568083,
      "elevationFeet": 2963,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U82?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U82?codeType=fs"
     },
     {
      "fs": "U84",
      "iata": "",
      "icao": "",
      "faa": "U84",
      "name": "Donnelly",
      "city": "Donnelly",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.840611,
      "longitude": -116.176278,
      "elevationFeet": 4860,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U84?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U84?codeType=fs"
     },
     {
      "fs": "U86",
      "iata": "",
      "icao": "",
      "faa": "U86",
      "name": "Camas Co",
      "city": "Fairfield",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.374,
      "longitude": -114.917278,
      "elevationFeet": 5058,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U86?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U86?codeType=fs"
     },
     {
      "fs": "U87",
      "iata": "",
      "icao": "",
      "faa": "U87",
      "name": "Smiley Creek",
      "city": "Galena",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.051833,
      "longitude": -114.922917,
      "elevationFeet": 7160,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U87?codeType=fs"
     },
     {
      "fs": "U88",
      "iata": "",
      "icao": "",
      "faa": "U88",
      "name": "Garden Valley",
      "city": "Garden Valley",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 44.0795,
      "longitude": -116.065083,
      "elevationFeet": 3177,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U88?codeType=fs"
     },
     {
      "fs": "U89",
      "iata": "",
      "icao": "",
      "faa": "U89",
      "name": "Glenns Ferry Municipal",
      "city": "Glenns Ferry",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.057333,
      "longitude": -115.450722,
      "elevationFeet": 2536,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U89?codeType=fs"
     },
     {
      "fs": "U91",
      "iata": "",
      "icao": "",
      "faa": "U91",
      "name": "Grasmere",
      "city": "Grasmere",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.515667,
      "longitude": -115.892611,
      "elevationFeet": 5134,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U91?codeType=fs"
     },
     {
      "fs": "U92",
      "iata": "",
      "icao": "",
      "faa": "U92",
      "name": "Antelope Valley",
      "city": "Grouse",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.760139,
      "longitude": -113.616889,
      "elevationFeet": 6180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U92?codeType=fs"
     },
     {
      "fs": "U93",
      "iata": "",
      "icao": "",
      "faa": "U93",
      "name": "Magic Reservoir",
      "city": "Hailey",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.424028,
      "longitude": -114.50325,
      "elevationFeet": 4844,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U93?codeType=fs"
     },
     {
      "fs": "U94",
      "iata": "",
      "icao": "",
      "faa": "U94",
      "name": "Hazelton Municipal",
      "city": "Hazelton",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 42.690778,
      "longitude": -114.183611,
      "elevationFeet": 4172,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U94?codeType=fs"
     },
     {
      "fs": "U96",
      "iata": "",
      "icao": "",
      "faa": "U96",
      "name": "Black Memorial",
      "city": "Halls Crossing",
      "stateCode": "UT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 37.522139,
      "longitude": -110.595833,
      "elevationFeet": 4388,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U96?codeType=fs"
     },
     {
      "fs": "U97",
      "iata": "",
      "icao": "",
      "faa": "U97",
      "name": "Howe",
      "city": "Howe",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.890694,
      "longitude": -113.166694,
      "elevationFeet": 4930,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U97?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U97?codeType=fs"
     },
     {
      "fs": "U98",
      "iata": "",
      "icao": "",
      "faa": "U98",
      "name": "Idaho City Usfs",
      "city": "Idaho City",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.857278,
      "longitude": -115.859417,
      "elevationFeet": 3920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U98?codeType=fs"
     },
     {
      "fs": "U99",
      "iata": "",
      "icao": "",
      "faa": "U99",
      "name": "Laidlaw Corrals",
      "city": "Kimama",
      "stateCode": "ID",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.074056,
      "longitude": -113.741861,
      "elevationFeet": 4427,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/U99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/U99?codeType=fs"
     },
     {
      "fs": "UBS",
      "iata": "UBS",
      "icao": "KUBS",
      "faa": "UBS",
      "name": "Lowndes County Airport",
      "city": "Columbus",
      "cityCode": "UBS",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 33.466667,
      "longitude": -88.383333,
      "elevationFeet": 188,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UBS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UBS?codeType=fs"
     },
     {
      "fs": "UCA",
      "iata": "UCA",
      "icao": "KUCA",
      "faa": "UCA",
      "name": "Oneida County Airport",
      "street1": "5900 Airport Road, Suite 207",
      "street2": "",
      "city": "Utica",
      "cityCode": "UCA",
      "stateCode": "NY",
      "postalCode": "13424",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "NYZ037",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 43.141389,
      "longitude": -75.380278,
      "elevationFeet": 743,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UCA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UCA?codeType=fs"
     },
     {
      "fs": "UCC",
      "iata": "UCC",
      "icao": "",
      "faa": "",
      "name": "Yucca Flat Airport",
      "city": "Yucca Flat",
      "cityCode": "UCC",
      "stateCode": "NV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 37,
      "longitude": -116.05,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UCC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UCC?codeType=fs"
     },
     {
      "fs": "UCE",
      "iata": "UCE",
      "icao": "",
      "faa": "4R7",
      "name": "Eunice Airport",
      "city": "Eunice",
      "cityCode": "UCE",
      "stateCode": "LA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 30.5,
      "longitude": -92.416667,
      "elevationFeet": 42,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UCE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UCE?codeType=fs"
     },
     {
      "fs": "UCY",
      "iata": "UCY",
      "icao": "KUCY",
      "faa": "UCY",
      "name": "Everett-Stewart Airport",
      "city": "Union City",
      "cityCode": "UCY",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 36.433333,
      "longitude": -89.05,
      "elevationFeet": 341,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UCY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UCY?codeType=fs"
     },
     {
      "fs": "UGS",
      "iata": "UGS",
      "icao": "",
      "faa": "9A8",
      "name": "Ugashik Airport",
      "city": "Ugashik",
      "cityCode": "UGS",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 57.533333,
      "longitude": -157.416667,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UGS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UGS?codeType=fs"
     },
     {
      "fs": "UIL",
      "iata": "UIL",
      "icao": "KUIL",
      "faa": "UIL",
      "name": "Quillayute State Airport",
      "city": "Quillayute",
      "cityCode": "UIL",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 47.9,
      "longitude": -124.633333,
      "elevationFeet": 194,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UIL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UIL?codeType=fs"
     },
     {
      "fs": "UIZ",
      "iata": "UIZ",
      "icao": "KUIZ",
      "faa": "UIZ",
      "name": "Berz-Macomb Airport",
      "city": "Utica",
      "cityCode": "UIZ",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.616667,
      "longitude": -83.05,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UIZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UIZ?codeType=fs"
     },
     {
      "fs": "UKN",
      "iata": "UKN",
      "icao": "",
      "faa": "Y01",
      "name": "Waukon Municipal Airport",
      "city": "Waukon",
      "cityCode": "UKN",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.266667,
      "longitude": -91.483333,
      "elevationFeet": 1281,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UKN?codeType=fs"
     },
     {
      "fs": "UKT",
      "iata": "UKT",
      "icao": "KUKT",
      "faa": "UKT",
      "name": "Upper Bucks Airport",
      "city": "Quakertown",
      "cityCode": "UKT",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.434173,
      "longitude": -75.381102,
      "elevationFeet": 504,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UKT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UKT?codeType=fs"
     },
     {
      "fs": "ULM",
      "iata": "ULM",
      "icao": "KULM",
      "faa": "ULM",
      "name": "New Ulm Airport",
      "city": "New Ulm",
      "cityCode": "ULM",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.321389,
      "longitude": -94.500556,
      "elevationFeet": 1011,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ULM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ULM?codeType=fs"
     },
     {
      "fs": "UMB",
      "iata": "UMB",
      "icao": "",
      "faa": "",
      "name": "North Shore Airport",
      "city": "Umnak Island",
      "cityCode": "UMB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 53.376667,
      "longitude": -167.8875,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UMB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UMB?codeType=fs"
     },
     {
      "fs": "UMM",
      "iata": "UMM",
      "icao": "",
      "faa": "UMM",
      "name": "Summit Airport",
      "city": "Summit",
      "cityCode": "UMM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 63.316667,
      "longitude": -149.316667,
      "elevationFeet": 2409,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UMM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UMM?codeType=fs"
     },
     {
      "fs": "UMT",
      "iata": "UMT",
      "icao": "PAUM",
      "faa": "PAUM",
      "name": "Umiat Airport",
      "city": "Umiat",
      "cityCode": "UMT",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 69.416667,
      "longitude": -152.333333,
      "elevationFeet": 266,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UMT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UMT?codeType=fs"
     },
     {
      "fs": "UMZ",
      "iata": "UMZ",
      "icao": "",
      "faa": "",
      "name": "Intermountain Municipal Airport",
      "city": "Mena",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 34.545278,
      "longitude": -94.202778,
      "elevationFeet": 1074,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UMZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UMZ?codeType=fs"
     },
     {
      "fs": "UNS",
      "iata": "UNS",
      "icao": "",
      "faa": "",
      "name": "Umnak Island Airport",
      "city": "Umnak Island",
      "cityCode": "UMB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 53.25,
      "longitude": -168.333333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UNS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UNS?codeType=fs"
     },
     {
      "fs": "UNU",
      "iata": "UNU",
      "icao": "KUNU",
      "faa": "UNU",
      "name": "Dodge County Airport",
      "city": "Juneau",
      "cityCode": "UNU",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 58.3,
      "longitude": -134.416667,
      "elevationFeet": 936,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UNU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UNU?codeType=fs"
     },
     {
      "fs": "UNV",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "University Park",
      "city": "State College",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.853721,
      "longitude": -77.848228,
      "elevationFeet": 1239,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UNV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UNV?codeType=fs"
     },
     {
      "fs": "UOS",
      "iata": "UOS",
      "icao": "KUOS",
      "faa": "UOS",
      "name": "Franklin County Airport",
      "city": "Sewanee",
      "cityCode": "UOS",
      "stateCode": "TN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 35.183333,
      "longitude": -85.9,
      "elevationFeet": 1953,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UOS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UOS?codeType=fs"
     },
     {
      "fs": "UPP",
      "iata": "UPP",
      "icao": "PHUP",
      "faa": "PHUP",
      "name": "Upolu Point Airport",
      "city": "Upolu Point",
      "cityCode": "UPP",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.688",
      "utcOffsetHours": -10,
      "latitude": 20.268056,
      "longitude": -155.8625,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UPP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UPP?codeType=fs"
     },
     {
      "fs": "UQE",
      "iata": "UQE",
      "icao": "",
      "faa": "",
      "name": "Queen Airport",
      "city": "Queen",
      "cityCode": "UQE",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 58.876667,
      "longitude": -158.431667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UQE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UQE?codeType=fs"
     },
     {
      "fs": "UTO",
      "iata": "UTO",
      "icao": "",
      "faa": "",
      "name": "Indian Mountain Air Force Station",
      "city": "Utopia Creek",
      "cityCode": "UTO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 65.993333,
      "longitude": -153.701667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UTO?codeType=fs"
     },
     {
      "fs": "UUK",
      "icao": "",
      "faa": "",
      "name": "Kuparuk Airport",
      "city": "Kuparuk",
      "cityCode": "UUK",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 70.416667,
      "longitude": -148.916667,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UUK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UUK?codeType=fs"
     },
     {
      "fs": "UWA",
      "iata": "UWA",
      "icao": "",
      "faa": "",
      "name": "Ware Airport",
      "city": "Ware",
      "cityCode": "UWA",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.266667,
      "longitude": -72.233333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/UWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/UWA?codeType=fs"
     },
     {
      "fs": "VAD",
      "iata": "VAD",
      "icao": "KVAD",
      "faa": "VAD",
      "name": "Moody Air Force Base",
      "city": "Valdosta",
      "cityCode": "VLD",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 30.968364,
      "longitude": -83.193053,
      "elevationFeet": 224,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VAD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VAD?codeType=fs"
     },
     {
      "fs": "VBG",
      "iata": "VBG",
      "icao": "KVBG",
      "faa": "VBG",
      "name": "Vandenburg Air Force Base",
      "city": "Lompoc",
      "cityCode": "LPC",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 34.733805,
      "longitude": -120.575367,
      "elevationFeet": 331,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VBG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VBG?codeType=fs"
     },
     {
      "fs": "VCB",
      "iata": "VCB",
      "icao": "",
      "faa": "",
      "name": "View Cove Airport",
      "city": "View Cove",
      "cityCode": "VCB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.083333,
      "longitude": -133.016667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VCB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VCB?codeType=fs"
     },
     {
      "fs": "VDI",
      "iata": "VDI",
      "icao": "KVDI",
      "faa": "VDI",
      "name": "Vidalia Municipal Airport",
      "city": "Vidalia",
      "cityCode": "VDI",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 32.216667,
      "longitude": -82.416667,
      "elevationFeet": 274,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VDI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VDI?codeType=fs"
     },
     {
      "fs": "VDU",
      "iata": "VDU",
      "icao": "",
      "faa": "",
      "name": "Tom O'Connor Oil Field Airport",
      "city": "Refugio",
      "cityCode": "RFG",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 28.3,
      "longitude": -97.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VDU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VDU?codeType=fs"
     },
     {
      "fs": "VEX",
      "iata": "VEX",
      "icao": "",
      "faa": "D60",
      "name": "Tioga Municipal Airport",
      "city": "Tioga",
      "cityCode": "VEX",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 41.916667,
      "longitude": -77.133333,
      "elevationFeet": 2266,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VEX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VEX?codeType=fs"
     },
     {
      "fs": "VIH",
      "iata": "VIH",
      "icao": "",
      "faa": "",
      "name": "Rolla National Airport",
      "city": "Vichy",
      "cityCode": "VIH",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 38.133333,
      "longitude": -91.766667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VIH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VIH?codeType=fs"
     },
     {
      "fs": "VKS",
      "iata": "VKS",
      "icao": "KVKS",
      "faa": "VKS",
      "name": "Vicksburg Airport",
      "city": "Vicksburg",
      "cityCode": "VKS",
      "stateCode": "MS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 32.35,
      "longitude": -90.85,
      "elevationFeet": 106,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VKS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VKS?codeType=fs"
     },
     {
      "fs": "VKW",
      "iata": "VKW",
      "icao": "",
      "faa": "",
      "name": "West Kavik Airport",
      "city": "West Kavik",
      "cityCode": "VKW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 69.766667,
      "longitude": -146.916667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VKW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VKW?codeType=fs"
     },
     {
      "fs": "VLA",
      "iata": "VLA",
      "icao": "KVLA",
      "faa": "VLA",
      "name": "Vandalia Airport",
      "city": "Vandalia",
      "cityCode": "VLA",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 38.966667,
      "longitude": -89.1,
      "elevationFeet": 537,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VLA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VLA?codeType=fs"
     },
     {
      "fs": "VLE",
      "iata": "VLE",
      "icao": "",
      "faa": "",
      "name": "J. T. Robidoux Airport",
      "city": "Valle",
      "cityCode": "VLE",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 35.65,
      "longitude": -112.183333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VLE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VLE?codeType=fs"
     },
     {
      "fs": "VLO",
      "iata": "VLO",
      "icao": "",
      "faa": "",
      "name": "Stolport Airport",
      "city": "Vallejo",
      "cityCode": "VLO",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 38.116667,
      "longitude": -122.233333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VLO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VLO?codeType=fs"
     },
     {
      "fs": "VRS",
      "iata": "VRS",
      "icao": "",
      "faa": "3VS",
      "name": "Versailles Airport",
      "city": "Versailles",
      "cityCode": "VRS",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 38.433333,
      "longitude": -92.85,
      "elevationFeet": 1030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VRS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VRS?codeType=fs"
     },
     {
      "fs": "VYS",
      "iata": "VYS",
      "icao": "KVYS",
      "faa": "VYS",
      "name": "Illinois Valley Regional Airport",
      "city": "Peru",
      "cityCode": "VYS",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 41.333333,
      "longitude": -89.133333,
      "elevationFeet": 654,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/VYS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/VYS?codeType=fs"
     },
     {
      "fs": "W00",
      "iata": "",
      "icao": "",
      "faa": "W00",
      "name": "Freeway",
      "city": "Mitchellville",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.013667,
      "longitude": -76.823861,
      "elevationFeet": 168,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W00?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W00?codeType=fs"
     },
     {
      "fs": "W01",
      "iata": "",
      "icao": "",
      "faa": "W01",
      "name": "Tonasket Municipal",
      "city": "Tonasket",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 48.793056,
      "longitude": -119.603333,
      "elevationFeet": 1340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W01?codeType=fs"
     },
     {
      "fs": "W03",
      "iata": "",
      "icao": "",
      "faa": "W03",
      "name": "Wilson Industrial Air Center",
      "city": "Wilson",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 35.78104,
      "longitude": -77.972037,
      "elevationFeet": 156,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W03?codeType=fs"
     },
     {
      "fs": "W04",
      "iata": "",
      "icao": "",
      "faa": "W04",
      "name": "Ocean Shores Municipal",
      "city": "Ocean Shores",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 47.036972,
      "longitude": -124.237861,
      "elevationFeet": 13,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W04?codeType=fs"
     },
     {
      "fs": "W07",
      "iata": "",
      "icao": "",
      "faa": "W07",
      "name": "Leon",
      "city": "Leon",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.800861,
      "longitude": -81.998583,
      "elevationFeet": 563,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W07?codeType=fs"
     },
     {
      "fs": "W08",
      "iata": "",
      "icao": "",
      "faa": "W08",
      "name": "Kellam",
      "city": "Weirwood",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.534694,
      "longitude": -75.988194,
      "elevationFeet": 40,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W08?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W08?codeType=fs"
     },
     {
      "fs": "W09",
      "iata": "",
      "icao": "",
      "faa": "W09",
      "name": "Lower Monumental State",
      "city": "Kahlotus",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 46.554194,
      "longitude": -118.56375,
      "elevationFeet": 813,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W09?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W09?codeType=fs"
     },
     {
      "fs": "W11",
      "iata": "",
      "icao": "",
      "faa": "W11",
      "name": "Menomonie Mun-Score",
      "city": "Menomonie",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.973472,
      "longitude": -91.877806,
      "elevationFeet": 895,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W11?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W11?codeType=fs"
     },
     {
      "fs": "W12",
      "iata": "",
      "icao": "",
      "faa": "W12",
      "name": "Lost River Resort",
      "city": "Mazama",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 48.795833,
      "longitude": -120.520444,
      "elevationFeet": 2415,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W12?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W12?codeType=fs"
     },
     {
      "fs": "W13",
      "iata": "",
      "icao": "",
      "faa": "W13",
      "name": "Eagle'S Nest",
      "city": "Waynesboro",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.170806,
      "longitude": -79.041917,
      "elevationFeet": 1437,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W13?codeType=fs"
     },
     {
      "fs": "W16",
      "iata": "",
      "icao": "",
      "faa": "W16",
      "name": "Firstair",
      "city": "Monroe",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 47.871399,
      "longitude": -121.995003,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W16?codeType=fs"
     },
     {
      "fs": "W17",
      "iata": "",
      "icao": "",
      "faa": "W17",
      "name": "Raleigh East Airport",
      "city": "Knightdale",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Indiana/Indianapolis",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 35.797524,
      "longitude": -78.43579,
      "elevationFeet": 278,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W17?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W17?codeType=fs"
     },
     {
      "fs": "W18",
      "iata": "",
      "icao": "",
      "faa": "W18",
      "name": "Suburban",
      "city": "Laurel",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.169444,
      "longitude": -76.929778,
      "elevationFeet": 148,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W18?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W18?codeType=fs"
     },
     {
      "fs": "W19",
      "iata": "",
      "icao": "",
      "faa": "W19",
      "name": "Verona",
      "city": "Verona",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.133306,
      "longitude": -89.517889,
      "elevationFeet": 960,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W19?codeType=fs"
     },
     {
      "fs": "W20",
      "iata": "",
      "icao": "",
      "faa": "W20",
      "name": "Moses Lake Municipal",
      "city": "Moses Lake",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 47.229194,
      "longitude": -119.314083,
      "elevationFeet": 1205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W20?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W20?codeType=fs"
     },
     {
      "fs": "W22",
      "iata": "",
      "icao": "",
      "faa": "W22",
      "name": "Upshur Co",
      "city": "Buckhannon",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.003583,
      "longitude": -80.339278,
      "elevationFeet": 1636,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W22?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W22?codeType=fs"
     },
     {
      "fs": "W23",
      "iata": "",
      "icao": "",
      "faa": "W23",
      "name": "Wild Rose Idlewild",
      "city": "Wild Rose",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.327556,
      "longitude": -89.228944,
      "elevationFeet": 908,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W23?codeType=fs"
     },
     {
      "fs": "W24",
      "iata": "",
      "icao": "",
      "faa": "W24",
      "name": "Falwell",
      "city": "Lynchburg",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.479222,
      "longitude": -79.172444,
      "elevationFeet": 939,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W24?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W24?codeType=fs"
     },
     {
      "fs": "W27",
      "iata": "",
      "icao": "",
      "faa": "W27",
      "name": "Woodland State",
      "city": "Woodland",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 46.034472,
      "longitude": -122.77325,
      "elevationFeet": 24,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W27?codeType=fs"
     },
     {
      "fs": "W29",
      "iata": "",
      "icao": "",
      "faa": "W29",
      "name": "Bay Bridge",
      "city": "Stevensville",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.976398,
      "longitude": -76.329597,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W29?codeType=fs"
     },
     {
      "fs": "W31",
      "iata": "",
      "icao": "",
      "faa": "W31",
      "name": "Lunenburg Co",
      "city": "Kenbridge",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.0515,
      "longitude": -78.2,
      "elevationFeet": 526,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W31?codeType=fs"
     },
     {
      "fs": "W32",
      "iata": "",
      "icao": "",
      "faa": "W32",
      "name": "Washington Executive/Hyde",
      "city": "Clinton",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.750295,
      "longitude": -76.925084,
      "elevationFeet": 233,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W32?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W32?codeType=fs"
     },
     {
      "fs": "W34",
      "iata": "",
      "icao": "",
      "faa": "W34",
      "name": "Shiocton",
      "city": "Shiocton",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.497056,
      "longitude": -88.667667,
      "elevationFeet": 769,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W34?codeType=fs"
     },
     {
      "fs": "W35",
      "iata": "",
      "icao": "",
      "faa": "W35",
      "name": "Potomac",
      "city": "Berkeley Springs",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.776111,
      "longitude": -78.310833,
      "elevationFeet": 412,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W35?codeType=fs"
     },
     {
      "fs": "W38",
      "iata": "",
      "icao": "",
      "faa": "W38",
      "name": "Craft Air",
      "city": "Farmville",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 35.602556,
      "longitude": -77.701667,
      "elevationFeet": 84,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W38?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W38?codeType=fs"
     },
     {
      "fs": "W40",
      "iata": "",
      "icao": "",
      "faa": "W40",
      "name": "Mount Olive Municipal Airport",
      "city": "Mt Olive",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 35.221834,
      "longitude": -78.038868,
      "elevationFeet": 165,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W40?codeType=fs"
     },
     {
      "fs": "W41",
      "iata": "",
      "icao": "",
      "faa": "W41",
      "name": "Crisfield Municipal",
      "city": "Crisfield",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.017917,
      "longitude": -75.938194,
      "elevationFeet": 4,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W41?codeType=fs"
     },
     {
      "fs": "W42",
      "iata": "",
      "icao": "",
      "faa": "W42",
      "name": "Fallston",
      "city": "Fallston",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.514972,
      "longitude": -76.510722,
      "elevationFeet": 460,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W42?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W42?codeType=fs"
     },
     {
      "fs": "W45",
      "iata": "",
      "icao": "",
      "faa": "W45",
      "name": "Luray Caverns",
      "city": "Luray",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.670556,
      "longitude": -78.505833,
      "elevationFeet": 902,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W45?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W45?codeType=fs"
     },
     {
      "fs": "W48",
      "iata": "",
      "icao": "",
      "faa": "W48",
      "name": "Essex Skypark",
      "city": "Baltimore",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.376083,
      "longitude": -76.580167,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W48?codeType=fs"
     },
     {
      "fs": "W50",
      "iata": "",
      "icao": "",
      "faa": "W50",
      "name": "Davis",
      "city": "Laytonsville",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.3455,
      "longitude": -77.285917,
      "elevationFeet": 630,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W50?codeType=fs"
     },
     {
      "fs": "W52",
      "iata": "",
      "icao": "",
      "faa": "W52",
      "name": "Goheen",
      "city": "Battle Ground",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 45.926139,
      "longitude": -122.662111,
      "elevationFeet": 285,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W52?codeType=fs"
     },
     {
      "fs": "W56",
      "iata": "",
      "icao": "",
      "faa": "W56",
      "name": "Fly For Fun",
      "city": "Vancouver",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 45.723389,
      "longitude": -122.570389,
      "elevationFeet": 275,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W56?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W56?codeType=fs"
     },
     {
      "fs": "W57",
      "iata": "",
      "icao": "",
      "faa": "W57",
      "name": "Round Lake",
      "city": "Round Lake",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 43.041667,
      "longitude": -73.803333,
      "elevationFeet": 175,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W57?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W57?codeType=fs"
     },
     {
      "fs": "W58",
      "iata": "",
      "icao": "",
      "faa": "W58",
      "name": "Cedars North",
      "city": "Battle Ground",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 45.895556,
      "longitude": -122.650833,
      "elevationFeet": 275,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W58?codeType=fs"
     },
     {
      "fs": "W59",
      "iata": "",
      "icao": "",
      "faa": "W59",
      "name": "Hinton-Alderson",
      "city": "Pence Springs",
      "stateCode": "WV",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.795639,
      "longitude": -80.803583,
      "elevationFeet": 1520,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W59?codeType=fs"
     },
     {
      "fs": "W63",
      "iata": "",
      "icao": "",
      "faa": "W63",
      "name": "Lake County Regional Airport",
      "city": "Clarksville",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 36.593987,
      "longitude": -78.556822,
      "elevationFeet": 347,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W63?codeType=fs"
     },
     {
      "fs": "W66",
      "iata": "",
      "icao": "",
      "faa": "W66",
      "name": "Warrenton-Fauquier",
      "city": "Warrenton",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.620472,
      "longitude": -77.813833,
      "elevationFeet": 329,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W66?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W66?codeType=fs"
     },
     {
      "fs": "W73",
      "iata": "",
      "icao": "",
      "faa": "W73",
      "name": "Mid-Atlantic Soaring Center",
      "city": "Fairfield",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.820417,
      "longitude": -77.36375,
      "elevationFeet": 573,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W73?codeType=fs"
     },
     {
      "fs": "W75",
      "iata": "",
      "icao": "",
      "faa": "W75",
      "name": "Hummel",
      "city": "Saluda",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.624333,
      "longitude": -76.566667,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W75?codeType=fs"
     },
     {
      "fs": "W77",
      "iata": "",
      "icao": "",
      "faa": "W77",
      "name": "Sanford-Lee Co Brick",
      "city": "Sanford",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 35.437667,
      "longitude": -79.325222,
      "elevationFeet": 430,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W77?codeType=fs"
     },
     {
      "fs": "W78",
      "iata": "",
      "icao": "",
      "faa": "W78",
      "name": "Tuck",
      "city": "South Boston",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 36.800444,
      "longitude": -78.980194,
      "elevationFeet": 420,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W78?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W78?codeType=fs"
     },
     {
      "fs": "W79",
      "iata": "",
      "icao": "",
      "faa": "W79",
      "name": "Tappahannock Municipal",
      "city": "Tappahannock",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.001361,
      "longitude": -76.916306,
      "elevationFeet": 31,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W79?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W79?codeType=fs"
     },
     {
      "fs": "W81",
      "iata": "",
      "icao": "",
      "faa": "W81",
      "name": "Crewe Municipal",
      "city": "Crewe",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.309861,
      "longitude": -78.233333,
      "elevationFeet": 420,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W81?codeType=fs"
     },
     {
      "fs": "W87",
      "iata": "",
      "icao": "",
      "faa": "W87",
      "name": "Wickenheiser",
      "city": "Carleton",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.031,
      "longitude": -83.471556,
      "elevationFeet": 610,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W87?codeType=fs"
     },
     {
      "fs": "W88",
      "iata": "",
      "icao": "",
      "faa": "W88",
      "name": "Air Harbor",
      "city": "Greensboro",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 36.173599,
      "longitude": -79.803101,
      "elevationFeet": 822,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W88?codeType=fs"
     },
     {
      "fs": "W90",
      "iata": "",
      "icao": "",
      "faa": "W90",
      "name": "New London",
      "city": "Forest",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.318111,
      "longitude": -79.358583,
      "elevationFeet": 849,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W90?codeType=fs"
     },
     {
      "fs": "W91",
      "iata": "",
      "icao": "",
      "faa": "W91",
      "name": "Smith Mountain Lake",
      "city": "Moneta",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.177222,
      "longitude": -79.674722,
      "elevationFeet": 892,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W91?codeType=fs"
     },
     {
      "fs": "W95",
      "iata": "",
      "icao": "",
      "faa": "W95",
      "name": "Ocracoke I",
      "city": "Ocracoke",
      "stateCode": "NC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 35.111722,
      "longitude": -76.109528,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W95?codeType=fs"
     },
     {
      "fs": "W96",
      "iata": "",
      "icao": "",
      "faa": "W96",
      "name": "New Kent Co",
      "city": "Quinton",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.532028,
      "longitude": -77.205278,
      "elevationFeet": 123,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/W96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/W96?codeType=fs"
     },
     {
      "fs": "WA31",
      "iata": "",
      "icao": "WA31",
      "faa": "WA31",
      "name": "Whidbey",
      "city": "Langley",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 48.0315,
      "longitude": -122.484806,
      "elevationFeet": 260,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WA31?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WA31?codeType=fs"
     },
     {
      "fs": "WAH",
      "iata": "WAH",
      "icao": "KBWP",
      "faa": "BWP",
      "name": "Wahpeton Airport",
      "city": "Wahpeton",
      "cityCode": "WAH",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 46.266667,
      "longitude": -96.6,
      "elevationFeet": 967,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WAH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WAH?codeType=fs"
     },
     {
      "fs": "WAY",
      "iata": "WAY",
      "icao": "KWAY",
      "faa": "WAY",
      "name": "Green County Airport",
      "city": "Waynesburg",
      "cityCode": "WAY",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.75,
      "longitude": -77.583333,
      "elevationFeet": 1065,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WAY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WAY?codeType=fs"
     },
     {
      "fs": "WBI",
      "iata": "WBI",
      "icao": "",
      "faa": "",
      "name": "Broker Inn Airport",
      "city": "Boulder",
      "cityCode": "WBU",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 40.016667,
      "longitude": -105.283333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBI?codeType=fs"
     },
     {
      "fs": "WBN",
      "iata": "WBN",
      "icao": "",
      "faa": "",
      "name": "Cummings Park Airport",
      "city": "Woburn",
      "cityCode": "WBN",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.466667,
      "longitude": -71.15,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBN?codeType=fs"
     },
     {
      "fs": "WBR",
      "iata": "WBR",
      "icao": "KRQB",
      "faa": "RQB",
      "name": "Big Rapids Airport",
      "city": "Big Rapids",
      "cityCode": "WBR",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 43.7,
      "longitude": -85.483333,
      "elevationFeet": 990,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBR?codeType=fs"
     },
     {
      "fs": "WBW",
      "iata": "WBW",
      "icao": "KWBW",
      "faa": "WBW",
      "name": "Wyoming Valle Airport",
      "city": "Wilkes-Barre",
      "cityCode": "AVP",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 41.233333,
      "longitude": -75.883333,
      "elevationFeet": 545,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WBW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WBW?codeType=fs"
     },
     {
      "fs": "WCR",
      "iata": "WCR",
      "icao": "PALR",
      "faa": "PALR",
      "name": "Chandalar Airport",
      "city": "Chandalar",
      "cityCode": "WCR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 67.505556,
      "longitude": -148.5,
      "elevationFeet": 1920,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WCR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WCR?codeType=fs"
     },
     {
      "fs": "WDB",
      "iata": "WDB",
      "icao": "",
      "faa": "",
      "name": "Deep Bay Airport",
      "city": "Deep Bay",
      "cityCode": "WDB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.583333,
      "longitude": -131.75,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WDB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WDB?codeType=fs"
     },
     {
      "fs": "WDN",
      "iata": "WDN",
      "icao": "",
      "faa": "",
      "name": "Waldron Island Airport",
      "city": "Waldron Island",
      "cityCode": "WDN",
      "stateCode": "WA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 48.716667,
      "longitude": -123.033333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WDN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WDN?codeType=fs"
     },
     {
      "fs": "WDR",
      "iata": "WDR",
      "icao": "KWDR",
      "faa": "WDR",
      "name": "Winder Airport",
      "city": "Winder",
      "cityCode": "WDR",
      "stateCode": "GA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 33.983333,
      "longitude": -83.716667,
      "elevationFeet": 943,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WDR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WDR?codeType=fs"
     },
     {
      "fs": "WDY",
      "iata": "WDY",
      "icao": "",
      "faa": "",
      "name": "Kodiak FSS Airport",
      "city": "Kodiak",
      "cityCode": "ADQ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 57.783333,
      "longitude": -152.4,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WDY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WDY?codeType=fs"
     },
     {
      "fs": "WEA",
      "iata": "WEA",
      "icao": "KWEA",
      "faa": "WEA",
      "name": "Parker County Airport",
      "city": "Weatherford",
      "cityCode": "WEA",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 32.766667,
      "longitude": -97.8,
      "elevationFeet": 990,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WEA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WEA?codeType=fs"
     },
     {
      "fs": "WFB",
      "iata": "WFB",
      "icao": "",
      "faa": "",
      "name": "Ketchikan Harbor Sea Plane Base",
      "city": "Ketchikan",
      "cityCode": "KTN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.347459,
      "longitude": -131.670048,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WFB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WFB?codeType=fs"
     },
     {
      "fs": "WFK",
      "iata": "WFK",
      "icao": "KFVE",
      "faa": "FVE",
      "name": "Frenchville Airport",
      "city": "Frenchville",
      "cityCode": "WFK",
      "stateCode": "ME",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 47.35,
      "longitude": -68.333333,
      "elevationFeet": 988,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WFK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WFK?codeType=fs"
     },
     {
      "fs": "WHH",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Hiltons Har H Airport",
      "city": "Boulder",
      "cityCode": "WBU",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 40.030556,
      "longitude": -105.234722,
      "elevationFeet": 5255,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WHH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WHH?codeType=fs"
     },
     {
      "fs": "WHP",
      "iata": "WHP",
      "icao": "KWHP",
      "faa": "WHP",
      "name": "Whiteman Airport",
      "city": "Los Angeles",
      "cityCode": "LAX",
      "stateCode": "CA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 34.05,
      "longitude": -118.25,
      "elevationFeet": 1003,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WHP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WHP?codeType=fs"
     },
     {
      "fs": "WHT",
      "iata": "WHT",
      "icao": "",
      "faa": "5R5",
      "name": "Wharton Airport",
      "city": "Wharton",
      "cityCode": "WHT",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 29.316667,
      "longitude": -96.1,
      "elevationFeet": 100,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WHT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WHT?codeType=fs"
     },
     {
      "fs": "WKL",
      "iata": "WKL",
      "icao": "",
      "faa": "",
      "name": "Waikoloa Heliport",
      "city": "Waikoloa",
      "cityCode": "WKL",
      "stateCode": "HI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "Pacific/Honolulu",
      "weatherZone": "",
      "localTime": "2022-11-09T02:41:39.688",
      "utcOffsetHours": -10,
      "latitude": 19.920416,
      "longitude": -155.860879,
      "elevationFeet": 118,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WKL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WKL?codeType=fs"
     },
     {
      "fs": "WLB",
      "iata": "WLB",
      "icao": "",
      "faa": "",
      "name": "Labouchere Bay Airport",
      "city": "Labouchere Bay",
      "cityCode": "WLB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 56.291667,
      "longitude": -133.658333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLB?codeType=fs"
     },
     {
      "fs": "WLD",
      "iata": "WLD",
      "icao": "KWLD",
      "faa": "WLD",
      "name": "Strother Field",
      "city": "Winfield",
      "cityCode": "WLD",
      "stateCode": "KS",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 37.168594,
      "longitude": -97.037597,
      "elevationFeet": 1151,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLD?codeType=fs"
     },
     {
      "fs": "WLM",
      "iata": "WLM",
      "icao": "",
      "faa": "",
      "name": "Waltham Airport",
      "city": "Waltham",
      "cityCode": "WLM",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.385278,
      "longitude": -71.251389,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLM?codeType=fs"
     },
     {
      "fs": "WLN",
      "iata": "WLN",
      "icao": "",
      "faa": "",
      "name": "Little Naukati Airport",
      "city": "Little Naukati",
      "cityCode": "WLN",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.873259,
      "longitude": -133.216211,
      "elevationFeet": 44,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLN?codeType=fs"
     },
     {
      "fs": "WLR",
      "iata": "WLR",
      "icao": "",
      "faa": "",
      "name": "Loring Sea Plane Base",
      "city": "Loring",
      "cityCode": "WLR",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.601333,
      "longitude": -131.63504,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WLR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WLR?codeType=fs"
     },
     {
      "fs": "WMH",
      "iata": "WMH",
      "icao": "KBPK",
      "faa": "BPK",
      "name": "Mountain Home Airport",
      "city": "Mountain Home",
      "cityCode": "WMH",
      "stateCode": "AR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 36.333333,
      "longitude": -92.383333,
      "elevationFeet": 928,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WMH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WMH?codeType=fs"
     },
     {
      "fs": "WOD",
      "iata": "WOD",
      "icao": "",
      "faa": "",
      "name": "Wood River Airport",
      "city": "Wood River",
      "cityCode": "WOD",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 59.063988,
      "longitude": -157.424927,
      "elevationFeet": 246,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WOD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WOD?codeType=fs"
     },
     {
      "fs": "WOO",
      "iata": "WOO",
      "icao": "",
      "faa": "",
      "name": "Woodchopper Airport",
      "city": "Woodchopper",
      "cityCode": "WOO",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 65.333333,
      "longitude": -143.533333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WOO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WOO?codeType=fs"
     },
     {
      "fs": "WOW",
      "iata": "WOW",
      "icao": "PAUO",
      "faa": "UUO",
      "name": "Willow Airport",
      "city": "Willow",
      "cityCode": "WOW",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 61.833333,
      "longitude": -150.166667,
      "elevationFeet": 221,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WOW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WOW?codeType=fs"
     },
     {
      "fs": "WPO",
      "iata": "WPO",
      "icao": "",
      "faa": "7V2",
      "name": "North Fork Valley Airport",
      "city": "Paonia",
      "cityCode": "WPO",
      "stateCode": "CO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 38.866667,
      "longitude": -107.6,
      "elevationFeet": 5798,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WPO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WPO?codeType=fs"
     },
     {
      "fs": "WS51",
      "iata": "",
      "icao": "WS51",
      "faa": "WS51",
      "name": "Leeward Farm",
      "city": "Soldiers Grove",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.376472,
      "longitude": -90.810222,
      "elevationFeet": 1068,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WS51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WS51?codeType=fs"
     },
     {
      "fs": "WSB",
      "iata": "WSB",
      "icao": "",
      "faa": "",
      "name": "Steamboat Sea Plane Base",
      "city": "Steamboat Bay",
      "cityCode": "WSB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.532617,
      "longitude": -133.636384,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSB?codeType=fs"
     },
     {
      "fs": "WSD",
      "iata": "WSD",
      "icao": "",
      "faa": "",
      "name": "Condron Army Air Field",
      "city": "White Sands",
      "cityCode": "WSD",
      "stateCode": "NM",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 32.33806,
      "longitude": -106.406997,
      "elevationFeet": 3941,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSD?codeType=fs"
     },
     {
      "fs": "WSF",
      "iata": "WSF",
      "icao": "",
      "faa": "",
      "name": "Saricheff Airport",
      "city": "Saricheff",
      "cityCode": "WSF",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 54.583333,
      "longitude": -164.916667,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSF?codeType=fs"
     },
     {
      "fs": "WSG",
      "iata": "WSG",
      "icao": "KAFJ",
      "faa": "AFJ",
      "name": "County Airport",
      "city": "Washington",
      "cityCode": "WSG",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.166667,
      "longitude": -80.25,
      "elevationFeet": 1184,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSG?codeType=fs"
     },
     {
      "fs": "WSJ",
      "iata": "WSJ",
      "icao": "",
      "faa": "",
      "name": "San Juan Sea Plane Base",
      "city": "San Juan",
      "cityCode": "WSJ",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 57.731348,
      "longitude": -153.320565,
      "elevationFeet": 7,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSJ?codeType=fs"
     },
     {
      "fs": "WSM",
      "iata": "WSM",
      "icao": "",
      "faa": "WSM",
      "name": "Wiseman Airport",
      "city": "Wiseman",
      "cityCode": "WSM",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 67.401667,
      "longitude": -150.116667,
      "elevationFeet": 1180,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WSM?codeType=fs"
     },
     {
      "fs": "WTC",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "World Trade Center Airport",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.710787,
      "longitude": -74.010993,
      "elevationFeet": 19,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WTC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WTC?codeType=fs"
     },
     {
      "fs": "WTR",
      "iata": "WTR",
      "icao": "",
      "faa": "E24",
      "name": "White River Airport",
      "city": "White River",
      "cityCode": "WTR",
      "stateCode": "AZ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Phoenix",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 33.85,
      "longitude": -109.966667,
      "elevationFeet": 5152,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WTR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WTR?codeType=fs"
     },
     {
      "fs": "WWA",
      "iata": "WWA",
      "icao": "PAWS",
      "faa": "PAWS",
      "name": "Wasilla Airport",
      "city": "Wasilla",
      "cityCode": "WWA",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 61.57291,
      "longitude": -149.504176,
      "elevationFeet": 324,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WWA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WWA?codeType=fs"
     },
     {
      "fs": "WYB",
      "iata": "WYB",
      "icao": "",
      "faa": "",
      "name": "Yes Bay Sea Plane Base",
      "city": "Yes Bay",
      "cityCode": "WYB",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 55.916667,
      "longitude": -131.833333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/WYB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/WYB?codeType=fs"
     },
     {
      "fs": "X01",
      "iata": "",
      "icao": "",
      "faa": "X01",
      "name": "Everglades Airpark",
      "city": "Everglades",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 25.987111,
      "longitude": -81.450806,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X01?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X01?codeType=fs"
     },
     {
      "fs": "X04",
      "iata": "",
      "icao": "",
      "faa": "X04",
      "name": "Orlando Country",
      "city": "Plymouth",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.772167,
      "longitude": -81.717389,
      "elevationFeet": 143,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X04?codeType=fs"
     },
     {
      "fs": "X05",
      "iata": "",
      "icao": "",
      "faa": "X05",
      "name": "Pilot Country Airport",
      "city": "Brooksville",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.326063,
      "longitude": -82.49423,
      "elevationFeet": 74,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X05?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X05?codeType=fs"
     },
     {
      "fs": "X06",
      "iata": "",
      "icao": "",
      "faa": "X06",
      "name": "Arcadia Municipal",
      "city": "Arcadia",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.269944,
      "longitude": -81.873056,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X06?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X06?codeType=fs"
     },
     {
      "fs": "X07",
      "iata": "",
      "icao": "",
      "faa": "X07",
      "name": "Lake Wales Municipal",
      "city": "Lake Wales",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.988056,
      "longitude": -81.653889,
      "elevationFeet": 127,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X07?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X07?codeType=fs"
     },
     {
      "fs": "X10",
      "iata": "",
      "icao": "",
      "faa": "X10",
      "name": "Belle Glade State",
      "city": "Belle Glade",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 26.700899,
      "longitude": -80.6623,
      "elevationFeet": 14,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X10?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X10?codeType=fs"
     },
     {
      "fs": "X13",
      "iata": "",
      "icao": "",
      "faa": "X13",
      "name": "Carrabelle-Thompson",
      "city": "Carrabelle",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 29.921944,
      "longitude": -84.710389,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X13?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X13?codeType=fs"
     },
     {
      "fs": "X14",
      "iata": "",
      "icao": "",
      "faa": "X14",
      "name": "La Belle Municipal",
      "city": "La Belle",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 26.842333,
      "longitude": -81.57575,
      "elevationFeet": 18,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X14?codeType=fs"
     },
     {
      "fs": "X21",
      "iata": "",
      "icao": "",
      "faa": "X21",
      "name": "Dunn",
      "city": "Titusville",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.673444,
      "longitude": -80.856944,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X21?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X21?codeType=fs"
     },
     {
      "fs": "X23",
      "iata": "",
      "icao": "",
      "faa": "X23",
      "name": "Umatilla Municipal",
      "city": "Umatilla",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.977639,
      "longitude": -81.667417,
      "elevationFeet": 107,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X23?codeType=fs"
     },
     {
      "fs": "X25",
      "iata": "",
      "icao": "",
      "faa": "X25",
      "name": "Chalet Suzanne",
      "city": "Lake Wales",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.953,
      "longitude": -81.748,
      "elevationFeet": 140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X25?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X25?codeType=fs"
     },
     {
      "fs": "X26",
      "iata": "",
      "icao": "",
      "faa": "X26",
      "name": "Sebastian Municipal",
      "city": "Sebastian",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.812599,
      "longitude": -80.495903,
      "elevationFeet": 21,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X26?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X26?codeType=fs"
     },
     {
      "fs": "X29",
      "iata": "",
      "icao": "",
      "faa": "X29",
      "name": "Carrabelle",
      "city": "Pehrson",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 29.885444,
      "longitude": -84.707361,
      "elevationFeet": 4,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X29?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X29?codeType=fs"
     },
     {
      "fs": "X33",
      "iata": "",
      "icao": "",
      "faa": "X33",
      "name": "Doniphan Municipal",
      "city": "Doniphan",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 36.786667,
      "longitude": -90.798444,
      "elevationFeet": 635,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X33?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X33?codeType=fs"
     },
     {
      "fs": "X35",
      "iata": "",
      "icao": "",
      "faa": "X35",
      "name": "Dunnellon",
      "city": "Dunnellon/Marion Co & Park Of*",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 29.167778,
      "longitude": -82.465833,
      "elevationFeet": 65,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X35?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X35?codeType=fs"
     },
     {
      "fs": "X36",
      "iata": "",
      "icao": "",
      "faa": "X36",
      "name": "Buchan",
      "city": "Englewood",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.047806,
      "longitude": -82.4315,
      "elevationFeet": 15,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X36?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X36?codeType=fs"
     },
     {
      "fs": "X40",
      "iata": "",
      "icao": "KINF",
      "faa": "INF",
      "name": "Inverness",
      "city": "Inverness",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.805021,
      "longitude": -82.318185,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X40?codeType=fs"
     },
     {
      "fs": "X46",
      "iata": "",
      "icao": "",
      "faa": "X46",
      "name": "Opa Locka West Airport",
      "city": "Miami",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 25.951309,
      "longitude": -80.419695,
      "elevationFeet": 3,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X46?codeType=fs"
     },
     {
      "fs": "X47",
      "iata": "",
      "icao": "",
      "faa": "X47",
      "name": "Flagler Co",
      "city": "Bunnell",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 29.473889,
      "longitude": -81.263333,
      "elevationFeet": 33,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X47?codeType=fs"
     },
     {
      "fs": "X49",
      "iata": "",
      "icao": "",
      "faa": "X49",
      "name": "South Lakeland Airport",
      "city": "Mulberry",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.9328,
      "longitude": -82.042821,
      "elevationFeet": 113,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X49?codeType=fs"
     },
     {
      "fs": "X50",
      "iata": "",
      "icao": "",
      "faa": "X50",
      "name": "Massey Ranch",
      "city": "New Smyrna Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.978901,
      "longitude": -80.925102,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X50?codeType=fs"
     },
     {
      "fs": "X51",
      "iata": "",
      "icao": "",
      "faa": "X51",
      "name": "Homestead Gen Aviation",
      "city": "Homestead",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 25.636667,
      "longitude": -80.591667,
      "elevationFeet": 7,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X51?codeType=fs"
     },
     {
      "fs": "X52",
      "iata": "",
      "icao": "",
      "faa": "X52",
      "name": "New Hibiscus",
      "city": "Vero Beach",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.772556,
      "longitude": -80.625556,
      "elevationFeet": 25,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X52?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X52?codeType=fs"
     },
     {
      "fs": "X55",
      "iata": "",
      "icao": "",
      "faa": "X55",
      "name": "Mid Florida Air Svc",
      "city": "Eustis",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.961028,
      "longitude": -81.753528,
      "elevationFeet": 167,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X55?codeType=fs"
     },
     {
      "fs": "X58",
      "iata": "",
      "icao": "",
      "faa": "X58",
      "name": "Indiantown",
      "city": "Indiantown",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.0364,
      "longitude": -80.440102,
      "elevationFeet": 30,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X58?codeType=fs"
     },
     {
      "fs": "X59",
      "iata": "",
      "icao": "",
      "faa": "X59",
      "name": "Valkaria",
      "city": "Valkaria",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 27.962,
      "longitude": -80.559833,
      "elevationFeet": 26,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X59?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X59?codeType=fs"
     },
     {
      "fs": "X60",
      "iata": "",
      "icao": "",
      "faa": "X60",
      "name": "Williston Municipal",
      "city": "Williston",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 29.392194,
      "longitude": -82.528833,
      "elevationFeet": 76,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X60?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X60?codeType=fs"
     },
     {
      "fs": "X68",
      "iata": "",
      "icao": "",
      "faa": "X68",
      "name": "Nasa Shuttle Landing Facility",
      "city": "Titusville",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.748944,
      "longitude": -80.793694,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/X68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/X68?codeType=fs"
     },
     {
      "fs": "XES",
      "iata": "XES",
      "icao": "",
      "faa": "",
      "name": "Lake Geneva Municipal Airport",
      "city": "Lake Geneva",
      "cityCode": "XES",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.627778,
      "longitude": -88.428056,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XES?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XES?codeType=fs"
     },
     {
      "fs": "XMD",
      "iata": "XMD",
      "icao": "KMDS",
      "faa": "MDS",
      "name": "Madison Airport",
      "city": "Madison",
      "cityCode": "XMD",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44,
      "longitude": -97.116667,
      "elevationFeet": 1717,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XMD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XMD?codeType=fs"
     },
     {
      "fs": "XNY",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "New York 39th St Ferry",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.76,
      "longitude": -74.003,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XNY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XNY?codeType=fs"
     },
     {
      "fs": "XPR",
      "iata": "XPR",
      "icao": "KIEN",
      "faa": "IEN",
      "name": "Pine Ridge Airport",
      "city": "Pine Ridge",
      "cityCode": "XPR",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 43.016667,
      "longitude": -102.516667,
      "elevationFeet": 3331,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XPR?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XPR?codeType=fs"
     },
     {
      "fs": "XS67",
      "iata": "",
      "icao": "XS67",
      "faa": "XS67",
      "name": "San Jose I",
      "city": "Rockport",
      "stateCode": "TX",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 28.05,
      "longitude": -97,
      "elevationFeet": 10,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XS67?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XS67?codeType=fs"
     },
     {
      "fs": "XSM",
      "iata": "XSM",
      "icao": "",
      "faa": "",
      "name": "St Marys Airport",
      "city": "Saint Marys",
      "cityCode": "XSM",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.283333,
      "longitude": -76.633333,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XSM?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XSM?codeType=fs"
     },
     {
      "fs": "XXXX",
      "iata": "",
      "icao": "",
      "faa": "",
      "name": "Airport",
      "city": "City",
      "stateCode": "OR",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Los_Angeles",
      "weatherZone": "ORZ006",
      "localTime": "2022-11-09T04:41:39.688",
      "utcOffsetHours": -8,
      "latitude": 45.589167,
      "longitude": -122.595,
      "elevationFeet": 0,
      "classification": 5,
      "active": false,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/XXXX?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/XXXX?codeType=fs"
     },
     {
      "fs": "Y03",
      "iata": "",
      "icao": "",
      "faa": "Y03",
      "name": "Springfield Municipal",
      "city": "Springfield",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.999972,
      "longitude": -97.911806,
      "elevationFeet": 1324,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y03?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y03?codeType=fs"
     },
     {
      "fs": "Y04",
      "iata": "",
      "icao": "",
      "faa": "Y04",
      "name": "Sugar Loaf Resort",
      "city": "Traverse City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.024972,
      "longitude": -85.93975,
      "elevationFeet": 825,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y04?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y04?codeType=fs"
     },
     {
      "fs": "Y14",
      "iata": "",
      "icao": "",
      "faa": "Y14",
      "name": "Skie-Lincoln Co",
      "city": "Tea",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.524778,
      "longitude": -96.819944,
      "elevationFeet": 1515,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y14?codeType=fs"
     },
     {
      "fs": "Y16",
      "iata": "",
      "icao": "",
      "faa": "Y16",
      "name": "Dale Delight",
      "city": "Postville",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.188667,
      "longitude": -91.751472,
      "elevationFeet": 1200,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y16?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y16?codeType=fs"
     },
     {
      "fs": "Y19",
      "iata": "",
      "icao": "",
      "faa": "Y19",
      "name": "Mandan Municipal",
      "city": "Mandan",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 46.782361,
      "longitude": -100.993444,
      "elevationFeet": 1944,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y19?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y19?codeType=fs"
     },
     {
      "fs": "Y23",
      "iata": "",
      "icao": "",
      "faa": "Y23",
      "name": "Chetek Mun-Southworth",
      "city": "Chetek",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 45.365278,
      "longitude": -91.666,
      "elevationFeet": 1055,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y23?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y23?codeType=fs"
     },
     {
      "fs": "Y27",
      "iata": "",
      "icao": "",
      "faa": "Y27",
      "name": "Standing Rock",
      "city": "Ft Yates",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 46.213861,
      "longitude": -100.6485,
      "elevationFeet": 1633,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y27?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y27?codeType=fs"
     },
     {
      "fs": "Y30",
      "iata": "",
      "icao": "",
      "faa": "Y30",
      "name": "Pbeaaye",
      "city": "Topinabee",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.661222,
      "longitude": -84.619833,
      "elevationFeet": 690,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y30?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y30?codeType=fs"
     },
     {
      "fs": "Y34",
      "iata": "",
      "icao": "",
      "faa": "Y34",
      "name": "Lake Preston Municipal",
      "city": "Lake Preston",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.516361,
      "longitude": -97.386833,
      "elevationFeet": 1725,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y34?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y34?codeType=fs"
     },
     {
      "fs": "Y37",
      "iata": "",
      "icao": "",
      "faa": "Y37",
      "name": "Park River-Skjerven",
      "city": "Park River",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 48.494389,
      "longitude": -97.914778,
      "elevationFeet": 1103,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y37?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y37?codeType=fs"
     },
     {
      "fs": "Y40",
      "iata": "",
      "icao": "",
      "faa": "Y40",
      "name": "Akron Municipal",
      "city": "Akron",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.838806,
      "longitude": -96.683639,
      "elevationFeet": 1143,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y40?codeType=fs"
     },
     {
      "fs": "Y43",
      "iata": "",
      "icao": "",
      "faa": "Y43",
      "name": "Anita Mun-Burke Memorial",
      "city": "Anita",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 41.502639,
      "longitude": -94.797028,
      "elevationFeet": 1251,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y43?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y43?codeType=fs"
     },
     {
      "fs": "Y46",
      "iata": "",
      "icao": "",
      "faa": "Y46",
      "name": "Bedford Municipal",
      "city": "Bedford",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 40.677667,
      "longitude": -94.844139,
      "elevationFeet": 1201,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y46?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y46?codeType=fs"
     },
     {
      "fs": "Y47",
      "iata": "",
      "icao": "",
      "faa": "Y47",
      "name": "New Hudson",
      "city": "New Hudson",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.531167,
      "longitude": -83.687167,
      "elevationFeet": 926,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y47?codeType=fs"
     },
     {
      "fs": "Y48",
      "iata": "",
      "icao": "",
      "faa": "Y48",
      "name": "Belmond Municipal",
      "city": "Belmond",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.877472,
      "longitude": -93.696528,
      "elevationFeet": 1201,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y48?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y48?codeType=fs"
     },
     {
      "fs": "Y49",
      "iata": "",
      "icao": "",
      "faa": "Y49",
      "name": "Walker Municipal",
      "city": "Walker",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 47.232889,
      "longitude": -94.761056,
      "elevationFeet": 1364,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y49?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y49?codeType=fs"
     },
     {
      "fs": "Y50",
      "iata": "",
      "icao": "",
      "faa": "Y50",
      "name": "Wautoma Municipal",
      "city": "Wautoma",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.116389,
      "longitude": -89.345,
      "elevationFeet": 859,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y50?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y50?codeType=fs"
     },
     {
      "fs": "Y51",
      "iata": "",
      "icao": "",
      "faa": "Y51",
      "name": "Viroqua Municipal",
      "city": "Viroqua",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.691389,
      "longitude": -90.909639,
      "elevationFeet": 1284,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y51?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y51?codeType=fs"
     },
     {
      "fs": "Y55",
      "iata": "",
      "icao": "",
      "faa": "Y55",
      "name": "Crandon Municipal",
      "city": "Crandon",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 45.666306,
      "longitude": -88.934472,
      "elevationFeet": 1646,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y55?codeType=fs"
     },
     {
      "fs": "Y58",
      "iata": "",
      "icao": "",
      "faa": "Y58",
      "name": "Sleepy Eye Municipal",
      "city": "Sleepy Eye",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.399611,
      "longitude": -94.71925,
      "elevationFeet": 1004,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y58?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y58?codeType=fs"
     },
     {
      "fs": "Y63",
      "iata": "",
      "icao": "",
      "faa": "Y63",
      "name": "Elbow Lake Municipal",
      "city": "Elbow Lake",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 46.010722,
      "longitude": -96.07,
      "elevationFeet": 1205,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y63?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y63?codeType=fs"
     },
     {
      "fs": "Y65",
      "iata": "",
      "icao": "",
      "faa": "Y65",
      "name": "Campbell Municipal",
      "city": "Indian River",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.483444,
      "longitude": -84.600361,
      "elevationFeet": 602,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y65?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y65?codeType=fs"
     },
     {
      "fs": "Y68",
      "iata": "",
      "icao": "",
      "faa": "Y68",
      "name": "Tracy Municipal",
      "city": "Tracy",
      "stateCode": "MN",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.399583,
      "longitude": -95.644528,
      "elevationFeet": 1340,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y68?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y68?codeType=fs"
     },
     {
      "fs": "Y70",
      "iata": "",
      "icao": "",
      "faa": "Y70",
      "name": "Ionia Co",
      "city": "Ionia",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.976944,
      "longitude": -85.159417,
      "elevationFeet": 813,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y70?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y70?codeType=fs"
     },
     {
      "fs": "Y71",
      "iata": "",
      "icao": "",
      "faa": "Y71",
      "name": "Elgin Municipal",
      "city": "Elgin",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Denver",
      "weatherZone": "",
      "localTime": "2022-11-09T05:41:39.688",
      "utcOffsetHours": -7,
      "latitude": 46.527833,
      "longitude": -101.951444,
      "elevationFeet": 2355,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y71?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y71?codeType=fs"
     },
     {
      "fs": "Y72",
      "iata": "",
      "icao": "",
      "faa": "Y72",
      "name": "Bloyer",
      "city": "Tomah",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 44.049639,
      "longitude": -90.484667,
      "elevationFeet": 963,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y72?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y72?codeType=fs"
     },
     {
      "fs": "Y73",
      "iata": "",
      "icao": "",
      "faa": "Y73",
      "name": "Stambaugh",
      "city": "Stambaugh",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 46.149556,
      "longitude": -88.743,
      "elevationFeet": 1622,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y73?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y73?codeType=fs"
     },
     {
      "fs": "Y74",
      "iata": "",
      "icao": "",
      "faa": "Y74",
      "name": "Parshall-Hankins",
      "city": "Parshall",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 47.964,
      "longitude": -102.221139,
      "elevationFeet": 2031,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y74?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y74?codeType=fs"
     },
     {
      "fs": "Y75",
      "iata": "",
      "icao": "",
      "faa": "Y75",
      "name": "Standish Industrial",
      "city": "Standish",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 44.098806,
      "longitude": -84.04325,
      "elevationFeet": 630,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y75?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y75?codeType=fs"
     },
     {
      "fs": "Y76",
      "iata": "",
      "icao": "",
      "faa": "Y76",
      "name": "Morningstar",
      "city": "Des Moines",
      "stateCode": "IA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 41.705444,
      "longitude": -93.741083,
      "elevationFeet": 805,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y76?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y76?codeType=fs"
     },
     {
      "fs": "Y77",
      "iata": "",
      "icao": "",
      "faa": "Y77",
      "name": "Bayfield Co",
      "city": "Iron River",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 46.663306,
      "longitude": -91.535222,
      "elevationFeet": 1143,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y77?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y77?codeType=fs"
     },
     {
      "fs": "Y83",
      "iata": "",
      "icao": "",
      "faa": "Y83",
      "name": "Sandusky City",
      "city": "Sandusky",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 43.491861,
      "longitude": -82.993806,
      "elevationFeet": 776,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y83?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y83?codeType=fs"
     },
     {
      "fs": "Y87",
      "iata": "",
      "icao": "",
      "faa": "Y87",
      "name": "Empire",
      "city": "Empire",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 44.824972,
      "longitude": -86.042583,
      "elevationFeet": 944,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y87?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y87?codeType=fs"
     },
     {
      "fs": "Y88",
      "iata": "",
      "icao": "",
      "faa": "Y88",
      "name": "Green Lake",
      "city": "Interlochen",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 44.661139,
      "longitude": -85.834111,
      "elevationFeet": 866,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y88?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y88?codeType=fs"
     },
     {
      "fs": "Y89",
      "iata": "",
      "icao": "",
      "faa": "Y89",
      "name": "Kalkaska City",
      "city": "Kalkaska",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 44.813944,
      "longitude": -85.295,
      "elevationFeet": 1030,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y89?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y89?codeType=fs"
     },
     {
      "fs": "Y91",
      "iata": "",
      "icao": "",
      "faa": "Y91",
      "name": "Home Acres Sky Ranch",
      "city": "Lake City",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 44.352889,
      "longitude": -85.211556,
      "elevationFeet": 1247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y91?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y91?codeType=fs"
     },
     {
      "fs": "Y93",
      "iata": "",
      "icao": "",
      "faa": "Y93",
      "name": "Atlanta Municipal",
      "city": "Atlanta",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.000083,
      "longitude": -84.133361,
      "elevationFeet": 875,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y93?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y93?codeType=fs"
     },
     {
      "fs": "Y94",
      "iata": "",
      "icao": "",
      "faa": "Y94",
      "name": "East Jordan City",
      "city": "East Jordan",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.250917,
      "longitude": -85.165889,
      "elevationFeet": 642,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y94?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y94?codeType=fs"
     },
     {
      "fs": "Y95",
      "iata": "",
      "icao": "",
      "faa": "Y95",
      "name": "Hillman",
      "city": "Hillman",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.083444,
      "longitude": -84.00275,
      "elevationFeet": 850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y95?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y95?codeType=fs"
     },
     {
      "fs": "Y96",
      "iata": "",
      "icao": "",
      "faa": "Y96",
      "name": "Goetz Co",
      "city": "Onaway",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 45.408444,
      "longitude": -84.300139,
      "elevationFeet": 830,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y96?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y96?codeType=fs"
     },
     {
      "fs": "Y98",
      "iata": "",
      "icao": "",
      "faa": "Y98",
      "name": "Grand Marais",
      "city": "Grand Marais",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 46.658167,
      "longitude": -85.91825,
      "elevationFeet": 838,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y98?codeType=fs"
     },
     {
      "fs": "Y99",
      "iata": "",
      "icao": "",
      "faa": "Y99",
      "name": "Trulson",
      "city": "Plaza",
      "stateCode": "ND",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 48.155694,
      "longitude": -101.982222,
      "elevationFeet": 2105,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Y99?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Y99?codeType=fs"
     },
     {
      "fs": "YKN",
      "iata": "YKN",
      "icao": "KYKN",
      "faa": "YKN",
      "name": "Chan Gurney Airport",
      "city": "Yankton",
      "cityCode": "YKN",
      "stateCode": "SD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "weatherZone": "",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.916944,
      "longitude": -97.386389,
      "elevationFeet": 1306,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/YKN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/YKN?codeType=fs"
     },
     {
      "fs": "Z14",
      "iata": "",
      "icao": "",
      "faa": "Z14",
      "name": "Tazlina",
      "city": "Tazlina",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 62.197889,
      "longitude": -146.555222,
      "elevationFeet": 2450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z14?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z14?codeType=fs"
     },
     {
      "fs": "Z40",
      "iata": "",
      "icao": "",
      "faa": "Z40",
      "name": "Goose Bay",
      "city": "Goose Bay",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 61.394501,
      "longitude": -149.845993,
      "elevationFeet": 78,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z40?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z40?codeType=fs"
     },
     {
      "fs": "Z41",
      "iata": "",
      "icao": "",
      "faa": "Z41",
      "name": "Lake Hood Strip",
      "city": "Anchorage",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 61.184861,
      "longitude": -149.959773,
      "elevationFeet": 71,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z41?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z41?codeType=fs"
     },
     {
      "fs": "Z47",
      "iata": "",
      "icao": "",
      "faa": "Z47",
      "name": "Basin Creek",
      "city": "Basin Creek",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 64.797944,
      "longitude": -165.448361,
      "elevationFeet": 140,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z47?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z47?codeType=fs"
     },
     {
      "fs": "Z53",
      "iata": "",
      "icao": "",
      "faa": "Z53",
      "name": "Cape Sabine",
      "city": "Cape Beaufort",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 69.093472,
      "longitude": -163.922639,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z53?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z53?codeType=fs"
     },
     {
      "fs": "Z55",
      "iata": "",
      "icao": "",
      "faa": "Z55",
      "name": "Lake Louise",
      "city": "Lake Louise",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 62.386889,
      "longitude": -146.694222,
      "elevationFeet": 2450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z55?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z55?codeType=fs"
     },
     {
      "fs": "Z81",
      "iata": "",
      "icao": "",
      "faa": "Z81",
      "name": "Salmon Lake",
      "city": "Salmon Lake",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 64.992472,
      "longitude": -165.126278,
      "elevationFeet": 450,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z81?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z81?codeType=fs"
     },
     {
      "fs": "Z90",
      "iata": "",
      "icao": "",
      "faa": "Z90",
      "name": "Stampede",
      "city": "Kantishna",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 63.886778,
      "longitude": -150.445194,
      "elevationFeet": 1850,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z90?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z90?codeType=fs"
     },
     {
      "fs": "Z92",
      "iata": "",
      "icao": "",
      "faa": "Z92",
      "name": "Harsens I",
      "city": "Harsens I",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.647222,
      "longitude": -82.663889,
      "elevationFeet": 578,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z92?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z92?codeType=fs"
     },
     {
      "fs": "Z98",
      "iata": "",
      "icao": "",
      "faa": "Z98",
      "name": "Ottawa Executive",
      "city": "Zeeland",
      "stateCode": "MI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.823333,
      "longitude": -86.031667,
      "elevationFeet": 740,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/Z98?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/Z98?codeType=fs"
     },
     {
      "fs": "ZBP",
      "iata": "ZBP",
      "name": "Penn Railway Station",
      "city": "Baltimore",
      "cityCode": "BWI",
      "stateCode": "MD",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.1667,
      "longitude": -76.6667,
      "elevationFeet": 120,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZBP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZBP?codeType=fs"
     },
     {
      "fs": "ZFT",
      "iata": "ZFT",
      "name": "Fort Lauderdale Tri-Railway Station",
      "city": "Fort Lauderdale",
      "cityCode": "FLL",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 26.1167,
      "longitude": -80.1667,
      "elevationFeet": 5,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZFT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZFT?codeType=fs"
     },
     {
      "fs": "ZFV",
      "iata": "ZFV",
      "icao": "",
      "faa": "",
      "name": "30th Street Railway Station",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.955822,
      "longitude": -75.1824,
      "elevationFeet": 19,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZFV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZFV?codeType=fs"
     },
     {
      "fs": "ZFZ",
      "iata": "ZFZ",
      "name": "Depew Railway Station",
      "city": "Buffalo",
      "cityCode": "BUF",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.9128,
      "longitude": -78.7328,
      "elevationFeet": 658,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZFZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZFZ?codeType=fs"
     },
     {
      "fs": "ZGD",
      "iata": "ZGD",
      "name": "New London Railway Station",
      "city": "Groton/New London",
      "cityCode": "GON",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 41.4042,
      "longitude": -72.0928,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZGD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZGD?codeType=fs"
     },
     {
      "fs": "ZHC",
      "iata": "ZHC",
      "name": "Philadelphia North Railway Station",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40,
      "longitude": -75.1667,
      "elevationFeet": 117,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZHC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZHC?codeType=fs"
     },
     {
      "fs": "ZLY",
      "iata": "ZLY",
      "name": "Rensselaer Railway Station",
      "city": "Albany",
      "cityCode": "ALB",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.6964,
      "longitude": -73.7258,
      "elevationFeet": 60,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZLY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZLY?codeType=fs"
     },
     {
      "fs": "ZME",
      "iata": "ZME",
      "name": "Metropark Railway Station",
      "city": "Iselin",
      "cityCode": "ZME",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.5672,
      "longitude": -74.3306,
      "elevationFeet": 50,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZME?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZME?codeType=fs"
     },
     {
      "fs": "ZML",
      "iata": "ZML",
      "name": "Intermodal Station",
      "city": "Milwaukee",
      "cityCode": "MKE",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 43.0389,
      "longitude": -87.9064,
      "elevationFeet": 616,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZML?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZML?codeType=fs"
     },
     {
      "fs": "ZNC",
      "iata": "ZNC",
      "icao": "",
      "faa": "",
      "name": "Nyac Airport",
      "city": "Nyac",
      "cityCode": "ZNC",
      "stateCode": "AK",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Anchorage",
      "weatherZone": "",
      "localTime": "2022-11-09T03:41:39.688",
      "utcOffsetHours": -9,
      "latitude": 61,
      "longitude": -160,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZNC?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZNC?codeType=fs"
     },
     {
      "fs": "ZPH",
      "iata": "ZPH",
      "icao": "KZPH",
      "faa": "ZPH",
      "name": "Zephyrhills Airport",
      "city": "Zephyrhills",
      "cityCode": "ZPH",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "weatherZone": "",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 28.233333,
      "longitude": -82.183333,
      "elevationFeet": 90,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZPH?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZPH?codeType=fs"
     },
     {
      "fs": "ZRA",
      "iata": "ZRA",
      "name": "Atlantic City Railway Station",
      "city": "Atlantic City",
      "cityCode": "ACY",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.3694,
      "longitude": -74.45,
      "elevationFeet": 0,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRA?codeType=fs"
     },
     {
      "fs": "ZRD",
      "iata": "ZRD",
      "name": "Staples Mill Road Railway Station",
      "city": "Richmond",
      "cityCode": "RIC",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.4614,
      "longitude": -76.9861,
      "elevationFeet": 96,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRD?codeType=fs"
     },
     {
      "fs": "ZRL",
      "iata": "ZRL",
      "name": "Lancaster Railway Station",
      "city": "Lancaster",
      "cityCode": "LNS",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.1581,
      "longitude": -76.3075,
      "elevationFeet": 372,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRL?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRL?codeType=fs"
     },
     {
      "fs": "ZRP",
      "iata": "ZRP",
      "name": "Newark NJ Penn Railway Station",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.7344,
      "longitude": -74.1619,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRP?codeType=fs"
     },
     {
      "fs": "ZRT",
      "iata": "ZRT",
      "name": "Hartford Railway Station",
      "city": "Hartford",
      "cityCode": "HFD",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 41.6583,
      "longitude": -72.4694,
      "elevationFeet": 531,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRT?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRT?codeType=fs"
     },
     {
      "fs": "ZRU",
      "iata": "ZRU",
      "name": "Boston Route 128 Railway Station",
      "city": "Boston",
      "cityCode": "BOS",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.2103,
      "longitude": -71.1472,
      "elevationFeet": 48,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRU?codeType=fs"
     },
     {
      "fs": "ZRV",
      "iata": "ZRV",
      "name": "Providence Railway Station",
      "city": "Providence",
      "cityCode": "PVD",
      "stateCode": "RI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 41.8294,
      "longitude": -71.4133,
      "elevationFeet": 36,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRV?codeType=fs"
     },
     {
      "fs": "ZRZ",
      "iata": "ZRZ",
      "name": "New Carrolton Railway Station",
      "city": "Washington",
      "cityCode": "WAS",
      "stateCode": "DC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.9478,
      "longitude": -76.8717,
      "elevationFeet": 92,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZRZ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZRZ?codeType=fs"
     },
     {
      "fs": "ZSF",
      "iata": "ZSF",
      "name": "Springfield Railway Station",
      "city": "Springfield",
      "cityCode": "SFY",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.0544,
      "longitude": -72.7656,
      "elevationFeet": 267,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZSF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZSF?codeType=fs"
     },
     {
      "fs": "ZSV",
      "iata": "ZSV",
      "name": "Gateway Railway Station",
      "city": "Saint Louis",
      "cityCode": "STL",
      "stateCode": "MO",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 38.6167,
      "longitude": -90.2,
      "elevationFeet": 474,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZSV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZSV?codeType=fs"
     },
     {
      "fs": "ZTD",
      "iata": "ZTD",
      "name": "Schenectady Railway Station",
      "city": "Schenectady",
      "cityCode": "SCH",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.8142,
      "longitude": -73.9394,
      "elevationFeet": 242,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTD?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTD?codeType=fs"
     },
     {
      "fs": "ZTE",
      "iata": "ZTE",
      "name": "Rochester Railway Station",
      "city": "Rochester",
      "cityCode": "ROC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 43.2233,
      "longitude": -77.4492,
      "elevationFeet": 385,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTE?codeType=fs"
     },
     {
      "fs": "ZTF",
      "iata": "ZTF",
      "name": "Stamford Railway Station",
      "city": "Stamford",
      "cityCode": "ZTF",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 41.0475,
      "longitude": -73.5414,
      "elevationFeet": 27,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTF?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTF?codeType=fs"
     },
     {
      "fs": "ZTJ",
      "iata": "ZTJ",
      "name": "Princeton Junction Railway Station",
      "city": "Princeton/Rocky Hill",
      "cityCode": "PCT",
      "stateCode": "NJ",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.3572,
      "longitude": -74.6694,
      "elevationFeet": 136,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTJ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTJ?codeType=fs"
     },
     {
      "fs": "ZTN",
      "iata": "ZTN",
      "name": "Trenton Railway Station",
      "city": "Philadelphia",
      "cityCode": "PHL",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.2183,
      "longitude": -74.755,
      "elevationFeet": 48,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTN?codeType=fs"
     },
     {
      "fs": "ZTO",
      "iata": "ZTO",
      "name": "Boston South Railway Station",
      "city": "Boston",
      "cityCode": "BOS",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.3519,
      "longitude": -71.0553,
      "elevationFeet": 16,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTO?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTO?codeType=fs"
     },
     {
      "fs": "ZTV",
      "iata": "ZTV",
      "name": "Sturtevant Railway Station",
      "city": "Sturtevant",
      "cityCode": "ZTV",
      "stateCode": "WI",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.9997,
      "longitude": -88.9978,
      "elevationFeet": 835,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTV?codeType=fs"
     },
     {
      "fs": "ZTY",
      "iata": "ZTY",
      "name": "Back Bay Railway Station",
      "city": "Boston",
      "cityCode": "BOS",
      "stateCode": "MA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.3472,
      "longitude": -71.0756,
      "elevationFeet": 20,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZTY?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZTY?codeType=fs"
     },
     {
      "fs": "ZUA",
      "iata": "ZUA",
      "name": "Utica Railway Station",
      "city": "Utica",
      "cityCode": "ZUA",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 43.1083,
      "longitude": -75.2325,
      "elevationFeet": 413,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZUA?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZUA?codeType=fs"
     },
     {
      "fs": "ZUG",
      "iata": "ZUG",
      "name": "Harrisburg Railway Station",
      "city": "Harrisburg",
      "cityCode": "HAR",
      "stateCode": "PA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.2547,
      "longitude": -76.8736,
      "elevationFeet": 309,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZUG?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZUG?codeType=fs"
     },
     {
      "fs": "ZUK",
      "iata": "ZUK",
      "name": "Lake Cook Road Railway Station",
      "city": "Lake Cook Road",
      "cityCode": "ZUK",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.2578,
      "longitude": -88.9881,
      "elevationFeet": 868,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZUK?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZUK?codeType=fs"
     },
     {
      "fs": "ZUN",
      "iata": "ZUN",
      "name": "Chicago Union Railway Station",
      "city": "Chicago",
      "cityCode": "CHI",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 41.8833,
      "longitude": -87.6333,
      "elevationFeet": 597,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZUN?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZUN?codeType=fs"
     },
     {
      "fs": "ZVE",
      "iata": "ZVE",
      "name": "New Haven Railway Station",
      "city": "New Haven",
      "cityCode": "HVN",
      "stateCode": "CT",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 41.3139,
      "longitude": -72.9267,
      "elevationFeet": 43,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZVE?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZVE?codeType=fs"
     },
     {
      "fs": "ZWB",
      "iata": "ZWB",
      "name": "Williamsburg Railway Station",
      "city": "Newport News/Williamsburg",
      "cityCode": "PHF",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.2756,
      "longitude": -76.7078,
      "elevationFeet": 82,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZWB?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZWB?codeType=fs"
     },
     {
      "fs": "ZWI",
      "iata": "ZWI",
      "name": "Wilmington Railway Station",
      "city": "Wilmington",
      "cityCode": "ILG",
      "stateCode": "DE",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 39.7367,
      "longitude": -75.5517,
      "elevationFeet": 6,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZWI?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZWI?codeType=fs"
     },
     {
      "fs": "ZWP",
      "iata": "ZWP",
      "name": "West Palm Beach Tri-Railway Station",
      "city": "West Palm Beach",
      "cityCode": "PBI",
      "stateCode": "FL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 26.7153,
      "longitude": -80.0533,
      "elevationFeet": 12,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZWP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZWP?codeType=fs"
     },
     {
      "fs": "ZWU",
      "iata": "ZWU",
      "name": "Washington Union Railway Station",
      "city": "Washington",
      "cityCode": "WAS",
      "stateCode": "DC",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 38.8706,
      "longitude": -76.9331,
      "elevationFeet": 247,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZWU?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZWU?codeType=fs"
     },
     {
      "fs": "ZWV",
      "iata": "ZWV",
      "name": "Glenview Railway Station",
      "city": "Glenview",
      "cityCode": "ZWV",
      "stateCode": "IL",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/Chicago",
      "localTime": "2022-11-09T06:41:39.688",
      "utcOffsetHours": -6,
      "latitude": 42.1283,
      "longitude": -87.9981,
      "elevationFeet": 732,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZWV?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZWV?codeType=fs"
     },
     {
      "fs": "ZWW",
      "iata": "ZWW",
      "name": "Newport News Railway Station",
      "city": "Newport News/Williamsburg",
      "cityCode": "PHF",
      "stateCode": "VA",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 37.1322,
      "longitude": -76.5214,
      "elevationFeet": 28,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZWW?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZWW?codeType=fs"
     },
     {
      "fs": "ZXS",
      "iata": "ZXS",
      "name": "Exchange Street Railway Station",
      "city": "Buffalo",
      "cityCode": "BUF",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.8833,
      "longitude": -78.8833,
      "elevationFeet": 579,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZXS?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZXS?codeType=fs"
     },
     {
      "fs": "ZYP",
      "iata": "ZYP",
      "name": "Penn Railway Station",
      "city": "New York",
      "cityCode": "NYC",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 40.7506,
      "longitude": -73.9933,
      "elevationFeet": 36,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZYP?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZYP?codeType=fs"
     },
     {
      "fs": "ZYQ",
      "iata": "ZYQ",
      "name": "Syracuse Railway Station",
      "city": "Syracuse",
      "cityCode": "SYR",
      "stateCode": "NY",
      "countryCode": "US",
      "countryName": "United States",
      "regionName": "North America",
      "timeZoneRegionName": "America/New_York",
      "localTime": "2022-11-09T07:41:39.688",
      "utcOffsetHours": -5,
      "latitude": 42.98,
      "longitude": -75.5786,
      "elevationFeet": 861,
      "classification": 5,
      "active": true,
      "weatherUrl": "https://api.flightstats.com/flex/weather/rest/v1/json/all/ZYQ?codeType=fs",
      "delayIndexUrl": "https://api.flightstats.com/flex/delayindex/rest/v1/json/airports/ZYQ?codeType=fs"
     }
    ]
   